(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
* Panzoom for panning and zooming elements using CSS transforms
* Copyright Timmy Willison and other contributors
* https://github.com/timmywil/panzoom/blob/master/MIT-License.txt
*/
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Panzoom = factory());
})(void 0, function () {
  'use strict';
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign.apply(this, arguments);
  };
  /* eslint-disable no-var */


  if (typeof window !== 'undefined') {
    // Support: IE11 only
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    } // Support: IE11 only
    // CustomEvent is an object instead of a constructor


    if (typeof window.CustomEvent !== 'function') {
      window.CustomEvent = function CustomEvent(event, params) {
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      };
    }
  }
  /**
   * Utilites for working with multiple pointer events
   */


  function findEventIndex(pointers, event) {
    var i = pointers.length;

    while (i--) {
      if (pointers[i].pointerId === event.pointerId) {
        return i;
      }
    }

    return -1;
  }

  function addPointer(pointers, event) {
    var i; // Add touches if applicable

    if (event.touches) {
      i = 0;

      for (var _i = 0, _a = event.touches; _i < _a.length; _i++) {
        var touch = _a[_i];
        touch.pointerId = i++;
        addPointer(pointers, touch);
      }

      return;
    }

    i = findEventIndex(pointers, event); // Update if already present

    if (i > -1) {
      pointers.splice(i, 1);
    }

    pointers.push(event);
  }

  function removePointer(pointers, event) {
    // Add touches if applicable
    if (event.touches) {
      // Remove all touches
      while (pointers.length) {
        pointers.pop();
      }

      return;
    }

    var i = findEventIndex(pointers, event);

    if (i > -1) {
      pointers.splice(i, 1);
    }
  }
  /**
   * Calculates a center point between
   * the given pointer events, for panning
   * with multiple pointers.
   */


  function getMiddle(pointers) {
    // Copy to avoid changing by reference
    pointers = pointers.slice(0);
    var event1 = pointers.pop();
    var event2;

    while (event2 = pointers.pop()) {
      event1 = {
        clientX: (event2.clientX - event1.clientX) / 2 + event1.clientX,
        clientY: (event2.clientY - event1.clientY) / 2 + event1.clientY
      };
    }

    return event1;
  }
  /**
   * Calculates the distance between two points
   * for pinch zooming.
   * Limits to the first 2
   */


  function getDistance(pointers) {
    if (pointers.length < 2) {
      return 0;
    }

    var event1 = pointers[0];
    var event2 = pointers[1];
    return Math.sqrt(Math.pow(Math.abs(event2.clientX - event1.clientX), 2) + Math.pow(Math.abs(event2.clientY - event1.clientY), 2));
  }

  var events = {
    down: 'mousedown',
    move: 'mousemove',
    up: 'mouseup mouseleave'
  };

  if (typeof window !== 'undefined') {
    if (typeof window.PointerEvent === 'function') {
      events = {
        down: 'pointerdown',
        move: 'pointermove',
        up: 'pointerup pointerleave pointercancel'
      };
    } else if (typeof window.TouchEvent === 'function') {
      events = {
        down: 'touchstart',
        move: 'touchmove',
        up: 'touchend touchcancel'
      };
    }
  }

  function onPointer(event, elem, handler, eventOpts) {
    events[event].split(' ').forEach(function (name) {
      elem.addEventListener(name, handler, eventOpts);
    });
  }

  function destroyPointer(event, elem, handler) {
    events[event].split(' ').forEach(function (name) {
      elem.removeEventListener(name, handler);
    });
  }

  var isIE = typeof document !== 'undefined' && !!document.documentMode;
  /**
   * Lazy creation of a CSS style declaration
   */

  var divStyle;

  function createStyle() {
    if (divStyle) {
      return divStyle;
    }

    return divStyle = document.createElement('div').style;
  }
  /**
   * Proper prefixing for cross-browser compatibility
   */


  var prefixes = ['webkit', 'moz', 'ms'];
  var prefixCache = {};

  function getPrefixedName(name) {
    if (prefixCache[name]) {
      return prefixCache[name];
    }

    var divStyle = createStyle();

    if (name in divStyle) {
      return prefixCache[name] = name;
    }

    var capName = name[0].toUpperCase() + name.slice(1);
    var i = prefixes.length;

    while (i--) {
      var prefixedName = "" + prefixes[i] + capName;

      if (prefixedName in divStyle) {
        return prefixCache[name] = prefixedName;
      }
    }
  }
  /**
   * Gets a style value expected to be a number
   */


  function getCSSNum(name, style) {
    return parseFloat(style[getPrefixedName(name)]) || 0;
  }

  function getBoxStyle(elem, name, style) {
    if (style === void 0) {
      style = window.getComputedStyle(elem);
    } // Support: FF 68+
    // Firefox requires specificity for border


    var suffix = name === 'border' ? 'Width' : '';
    return {
      left: getCSSNum(name + "Left" + suffix, style),
      right: getCSSNum(name + "Right" + suffix, style),
      top: getCSSNum(name + "Top" + suffix, style),
      bottom: getCSSNum(name + "Bottom" + suffix, style)
    };
  }
  /**
   * Set a style using the properly prefixed name
   */


  function _setStyle(elem, name, value) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    elem.style[getPrefixedName(name)] = value;
  }
  /**
   * Constructs the transition from panzoom options
   * and takes care of prefixing the transition and transform
   */


  function setTransition(elem, options) {
    var transform = getPrefixedName('transform');

    _setStyle(elem, 'transition', transform + " " + options.duration + "ms " + options.easing);
  }
  /**
   * Set the transform using the proper prefix
   */


  function setTransform(elem, _a, _options) {
    var x = _a.x,
        y = _a.y,
        scale = _a.scale,
        isSVG = _a.isSVG;

    _setStyle(elem, 'transform', "scale(" + scale + ") translate(" + x + "px, " + y + "px)");

    if (isSVG && isIE) {
      var matrixValue = window.getComputedStyle(elem).getPropertyValue('transform');
      elem.setAttribute('transform', matrixValue);
    }
  }
  /**
   * Dimensions used in containment and focal point zooming
   */


  function getDimensions(elem) {
    var parent = elem.parentNode;
    var style = window.getComputedStyle(elem);
    var parentStyle = window.getComputedStyle(parent);
    var rectElem = elem.getBoundingClientRect();
    var rectParent = parent.getBoundingClientRect();
    return {
      elem: {
        style: style,
        width: rectElem.width,
        height: rectElem.height,
        top: rectElem.top,
        bottom: rectElem.bottom,
        left: rectElem.left,
        right: rectElem.right,
        margin: getBoxStyle(elem, 'margin', style),
        border: getBoxStyle(elem, 'border', style)
      },
      parent: {
        style: parentStyle,
        width: rectParent.width,
        height: rectParent.height,
        top: rectParent.top,
        bottom: rectParent.bottom,
        left: rectParent.left,
        right: rectParent.right,
        padding: getBoxStyle(parent, 'padding', parentStyle),
        border: getBoxStyle(parent, 'border', parentStyle)
      }
    };
  }
  /**
   * Determine if an element is attached to the DOM
   * Panzoom requires this so events work properly
   */


  function isAttached(elem) {
    var doc = elem.ownerDocument;
    var parent = elem.parentNode;
    return doc && parent && doc.nodeType === 9 && parent.nodeType === 1 && doc.documentElement.contains(parent);
  }

  function getClass(elem) {
    return (elem.getAttribute('class') || '').trim();
  }

  function hasClass(elem, className) {
    return elem.nodeType === 1 && (" " + getClass(elem) + " ").indexOf(" " + className + " ") > -1;
  }

  function isExcluded(elem, options) {
    for (var cur = elem; cur != null; cur = cur.parentNode) {
      if (hasClass(cur, options.excludeClass) || options.exclude.indexOf(cur) > -1) {
        return true;
      }
    }

    return false;
  }
  /**
   * Determine if an element is SVG by checking the namespace
   * Exception: the <svg> element itself should be treated like HTML
   */


  var rsvg = /^http:[\w\.\/]+svg$/;

  function isSVGElement(elem) {
    return rsvg.test(elem.namespaceURI) && elem.nodeName.toLowerCase() !== 'svg';
  }

  function shallowClone(obj) {
    var clone = {};

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = obj[key];
      }
    }

    return clone;
  }

  var defaultOptions = {
    animate: false,
    canvas: false,
    cursor: 'move',
    disablePan: false,
    disableZoom: false,
    disableXAxis: false,
    disableYAxis: false,
    duration: 200,
    easing: 'ease-in-out',
    exclude: [],
    excludeClass: 'panzoom-exclude',
    handleStartEvent: function handleStartEvent(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    maxScale: 4,
    minScale: 0.125,
    overflow: 'hidden',
    panOnlyWhenZoomed: false,
    relative: false,
    setTransform: setTransform,
    startX: 0,
    startY: 0,
    startScale: 1,
    step: 0.3,
    touchAction: 'none'
  };

  function Panzoom(elem, options) {
    if (!elem) {
      throw new Error('Panzoom requires an element as an argument');
    }

    if (elem.nodeType !== 1) {
      throw new Error('Panzoom requires an element with a nodeType of 1');
    }

    if (!isAttached(elem)) {
      throw new Error('Panzoom should be called on elements that have been attached to the DOM');
    }

    options = _assign(_assign({}, defaultOptions), options);
    var isSVG = isSVGElement(elem);
    var parent = elem.parentNode; // Set parent styles

    parent.style.overflow = options.overflow;
    parent.style.userSelect = 'none'; // This is important for mobile to
    // prevent scrolling while panning

    parent.style.touchAction = options.touchAction;
    (options.canvas ? parent : elem).style.cursor = options.cursor; // Set element styles

    elem.style.userSelect = 'none';
    elem.style.touchAction = options.touchAction; // The default for SVG is '0 0'
    // SVG can't be changed in IE

    _setStyle(elem, 'transformOrigin', typeof options.origin === 'string' ? options.origin : isSVG ? '0 0' : '50% 50%');

    function setOptions(opts) {
      if (opts === void 0) {
        opts = {};
      }

      for (var key in opts) {
        if (opts.hasOwnProperty(key)) {
          options[key] = opts[key];
        }
      } // Handle option side-effects


      if (opts.hasOwnProperty('cursor')) {
        elem.style.cursor = opts.cursor;
      }

      if (opts.hasOwnProperty('overflow')) {
        parent.style.overflow = opts.overflow;
      }

      if (opts.hasOwnProperty('touchAction')) {
        parent.style.touchAction = opts.touchAction;
        elem.style.touchAction = opts.touchAction;
      }

      if (opts.hasOwnProperty('minScale') || opts.hasOwnProperty('maxScale') || opts.hasOwnProperty('contain')) {
        setMinMax();
      }
    }

    var x = 0;
    var y = 0;
    var scale = 1;
    var isPanning = false;
    zoom(options.startScale, {
      animate: false
    }); // Wait for scale to update
    // for accurate dimensions
    // to constrain initial values

    setTimeout(function () {
      setMinMax();
      pan(options.startX, options.startY, {
        animate: false
      });
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    function trigger(eventName, detail, opts) {
      if (opts.silent) {
        return;
      }

      var event = new CustomEvent(eventName, {
        detail: detail
      });
      elem.dispatchEvent(event);
    }

    function setTransformWithEvent(eventName, opts) {
      var value = {
        x: x,
        y: y,
        scale: scale,
        isSVG: isSVG
      };
      requestAnimationFrame(function () {
        if (typeof opts.animate === 'boolean') {
          if (opts.animate) {
            setTransition(elem, opts);
          } else {
            _setStyle(elem, 'transition', 'none');
          }
        }

        opts.setTransform(elem, value, opts);
      });
      trigger(eventName, value, opts);
      trigger('panzoomchange', value, opts);
      return value;
    }

    function setMinMax() {
      if (options.contain) {
        var dims = getDimensions(elem);
        var parentWidth = dims.parent.width - dims.parent.border.left - dims.parent.border.right;
        var parentHeight = dims.parent.height - dims.parent.border.top - dims.parent.border.bottom;
        var elemWidth = dims.elem.width / scale;
        var elemHeight = dims.elem.height / scale;
        var elemScaledWidth = parentWidth / elemWidth;
        var elemScaledHeight = parentHeight / elemHeight;

        if (options.contain === 'inside') {
          options.maxScale = Math.min(elemScaledWidth, elemScaledHeight);
        } else if (options.contain === 'outside') {
          options.minScale = Math.max(elemScaledWidth, elemScaledHeight);
        }
      }
    }

    function constrainXY(toX, toY, toScale, panOptions) {
      var opts = _assign(_assign({}, options), panOptions);

      var result = {
        x: x,
        y: y,
        opts: opts
      };

      if (!opts.force && (opts.disablePan || opts.panOnlyWhenZoomed && scale === opts.startScale)) {
        return result;
      }

      toX = parseFloat(toX);
      toY = parseFloat(toY);

      if (!opts.disableXAxis) {
        result.x = (opts.relative ? x : 0) + toX;
      }

      if (!opts.disableYAxis) {
        result.y = (opts.relative ? y : 0) + toY;
      }

      if (opts.contain === 'inside') {
        var dims = getDimensions(elem);
        result.x = Math.max(-dims.elem.margin.left - dims.parent.padding.left, Math.min(dims.parent.width - dims.elem.width / toScale - dims.parent.padding.left - dims.elem.margin.left - dims.parent.border.left - dims.parent.border.right, result.x));
        result.y = Math.max(-dims.elem.margin.top - dims.parent.padding.top, Math.min(dims.parent.height - dims.elem.height / toScale - dims.parent.padding.top - dims.elem.margin.top - dims.parent.border.top - dims.parent.border.bottom, result.y));
      } else if (opts.contain === 'outside') {
        var dims = getDimensions(elem);
        var realWidth = dims.elem.width / scale;
        var realHeight = dims.elem.height / scale;
        var scaledWidth = realWidth * toScale;
        var scaledHeight = realHeight * toScale;
        var diffHorizontal = (scaledWidth - realWidth) / 2;
        var diffVertical = (scaledHeight - realHeight) / 2;
        var minX = (-(scaledWidth - dims.parent.width) - dims.parent.padding.left - dims.parent.border.left - dims.parent.border.right + diffHorizontal) / toScale;
        var maxX = (diffHorizontal - dims.parent.padding.left) / toScale;
        result.x = Math.max(Math.min(result.x, maxX), minX);
        var minY = (-(scaledHeight - dims.parent.height) - dims.parent.padding.top - dims.parent.border.top - dims.parent.border.bottom + diffVertical) / toScale;
        var maxY = (diffVertical - dims.parent.padding.top) / toScale;
        result.y = Math.max(Math.min(result.y, maxY), minY);
      }

      return result;
    }

    function constrainScale(toScale, zoomOptions) {
      var opts = _assign(_assign({}, options), zoomOptions);

      var result = {
        scale: scale,
        opts: opts
      };

      if (!opts.force && opts.disableZoom) {
        return result;
      }

      result.scale = Math.min(Math.max(toScale, opts.minScale), opts.maxScale);
      return result;
    }

    function pan(toX, toY, panOptions) {
      var result = constrainXY(toX, toY, scale, panOptions);
      var opts = result.opts;
      x = result.x;
      y = result.y;
      return setTransformWithEvent('panzoompan', opts);
    }

    function zoom(toScale, zoomOptions) {
      var result = constrainScale(toScale, zoomOptions);
      var opts = result.opts;

      if (!opts.force && opts.disableZoom) {
        return;
      }

      toScale = result.scale;
      var toX = x;
      var toY = y;

      if (opts.focal) {
        // The difference between the point after the scale and the point before the scale
        // plus the current translation after the scale
        // neutralized to no scale (as the transform scale will apply to the translation)
        var focal = opts.focal;
        toX = (focal.x / toScale - focal.x / scale + x * toScale) / toScale;
        toY = (focal.y / toScale - focal.y / scale + y * toScale) / toScale;
      }

      var panResult = constrainXY(toX, toY, toScale, {
        relative: false,
        force: true
      });
      x = panResult.x;
      y = panResult.y;
      scale = toScale;
      return setTransformWithEvent('panzoomzoom', opts);
    }

    function zoomInOut(isIn, zoomOptions) {
      var opts = _assign(_assign(_assign({}, options), {
        animate: true
      }), zoomOptions);

      return zoom(scale * Math.exp((isIn ? 1 : -1) * opts.step), opts);
    }

    function zoomIn(zoomOptions) {
      return zoomInOut(true, zoomOptions);
    }

    function zoomOut(zoomOptions) {
      return zoomInOut(false, zoomOptions);
    }

    function zoomToPoint(toScale, point, zoomOptions) {
      var dims = getDimensions(elem); // Instead of thinking of operating on the panzoom element,
      // think of operating on the area inside the panzoom
      // element's parent
      // Subtract padding and border

      var effectiveArea = {
        width: dims.parent.width - dims.parent.padding.left - dims.parent.padding.right - dims.parent.border.left - dims.parent.border.right,
        height: dims.parent.height - dims.parent.padding.top - dims.parent.padding.bottom - dims.parent.border.top - dims.parent.border.bottom
      }; // Adjust the clientX/clientY to ignore the area
      // outside the effective area

      var clientX = point.clientX - dims.parent.left - dims.parent.padding.left - dims.parent.border.left - dims.elem.margin.left;
      var clientY = point.clientY - dims.parent.top - dims.parent.padding.top - dims.parent.border.top - dims.elem.margin.top; // Adjust the clientX/clientY for HTML elements,
      // because they have a transform-origin of 50% 50%

      if (!isSVG) {
        clientX -= dims.elem.width / scale / 2;
        clientY -= dims.elem.height / scale / 2;
      } // Convert the mouse point from it's position over the
      // effective area before the scale to the position
      // over the effective area after the scale.


      var focal = {
        x: clientX / effectiveArea.width * (effectiveArea.width * toScale),
        y: clientY / effectiveArea.height * (effectiveArea.height * toScale)
      };
      return zoom(toScale, _assign(_assign({
        animate: false
      }, zoomOptions), {
        focal: focal
      }));
    }

    function zoomWithWheel(event, zoomOptions) {
      // Need to prevent the default here
      // or it conflicts with regular page scroll
      event.preventDefault();

      var opts = _assign(_assign({}, options), zoomOptions); // Normalize to deltaX in case shift modifier is used on Mac


      var delta = event.deltaY === 0 && event.deltaX ? event.deltaX : event.deltaY;
      var wheel = delta < 0 ? 1 : -1;
      var toScale = constrainScale(scale * Math.exp(wheel * opts.step / 3), opts).scale;
      return zoomToPoint(toScale, event, opts);
    }

    function reset(resetOptions) {
      var opts = _assign(_assign(_assign({}, options), {
        animate: true,
        force: true
      }), resetOptions);

      scale = constrainScale(opts.startScale, opts).scale;
      var panResult = constrainXY(opts.startX, opts.startY, scale, opts);
      x = panResult.x;
      y = panResult.y;
      return setTransformWithEvent('panzoomreset', opts);
    }

    var origX;
    var origY;
    var startClientX;
    var startClientY;
    var startScale;
    var startDistance;
    var pointers = [];

    function handleDown(event) {
      // Don't handle this event if the target is excluded
      if (isExcluded(event.target, options)) {
        return;
      }

      addPointer(pointers, event);
      isPanning = true;
      options.handleStartEvent(event);
      origX = x;
      origY = y;
      trigger('panzoomstart', {
        x: x,
        y: y,
        scale: scale
      }, options); // This works whether there are multiple
      // pointers or not

      var point = getMiddle(pointers);
      startClientX = point.clientX;
      startClientY = point.clientY;
      startScale = scale;
      startDistance = getDistance(pointers);
    }

    function move(event) {
      if (!isPanning || origX === undefined || origY === undefined || startClientX === undefined || startClientY === undefined) {
        return;
      }

      addPointer(pointers, event);
      var current = getMiddle(pointers);

      if (pointers.length > 1) {
        // Use the distance between the first 2 pointers
        // to determine the current scale
        var diff = getDistance(pointers) - startDistance;
        var toScale = constrainScale(diff * options.step / 80 + startScale).scale;
        zoomToPoint(toScale, current);
      }

      pan(origX + (current.clientX - startClientX) / scale, origY + (current.clientY - startClientY) / scale, {
        animate: false
      });
    }

    function handleUp(event) {
      // Don't call panzoomend when panning with 2 touches
      // until both touches end
      if (pointers.length === 1) {
        trigger('panzoomend', {
          x: x,
          y: y,
          scale: scale
        }, options);
      } // Note: don't remove all pointers
      // Can restart without having to reinitiate all of them
      // Remove the pointer regardless of the isPanning state


      removePointer(pointers, event);

      if (!isPanning) {
        return;
      }

      isPanning = false;
      origX = origY = startClientX = startClientY = undefined;
    }

    var bound = false;

    function bind() {
      if (bound) {
        return;
      }

      bound = true;
      onPointer('down', options.canvas ? parent : elem, handleDown);
      onPointer('move', document, move, {
        passive: true
      });
      onPointer('up', document, handleUp, {
        passive: true
      });
    }

    function destroy() {
      bound = false;
      destroyPointer('down', options.canvas ? parent : elem, handleDown);
      destroyPointer('move', document, move);
      destroyPointer('up', document, handleUp);
    }

    if (!options.noBind) {
      bind();
    }

    return {
      bind: bind,
      destroy: destroy,
      eventNames: events,
      getPan: function getPan() {
        return {
          x: x,
          y: y
        };
      },
      getScale: function getScale() {
        return scale;
      },
      getOptions: function getOptions() {
        return shallowClone(options);
      },
      pan: pan,
      reset: reset,
      setOptions: setOptions,
      setStyle: function setStyle(name, value) {
        return _setStyle(elem, name, value);
      },
      zoom: zoom,
      zoomIn: zoomIn,
      zoomOut: zoomOut,
      zoomToPoint: zoomToPoint,
      zoomWithWheel: zoomWithWheel
    };
  }

  Panzoom.defaultOptions = defaultOptions;
  return Panzoom;
});

},{}],2:[function(require,module,exports){
'use strict';

exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications


revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens(b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  } // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42


  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
} // base64 is 4/3 + up to two characters of the original data


function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars

  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

  for (var i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];

  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }

  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes

  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3
  // go through the array every three bytes, we'll deal with trailing stuff later

  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  } // pad the end with zeros, but make sure to not forget the extra bytes


  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }

  return parts.join('');
}

},{}],3:[function(require,module,exports){
"use strict";

},{}],4:[function(require,module,exports){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

/* eslint-disable no-proto */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var base64 = require('base64-js');

var ieee754 = require('ieee754');

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */

Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}

function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = {
      __proto__: Uint8Array.prototype,
      foo: function foo() {
        return 42;
      }
    };
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});

function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  } // Return an augmented `Uint8Array` instance


  var buf = new Uint8Array(length);
  buf.__proto__ = Buffer.prototype;
  return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */


function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }

    return allocUnsafe(arg);
  }

  return from(arg, encodingOrOffset, length);
} // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97


if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  });
}

Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value);
  }

  if (value == null) {
    throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
  }

  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }

  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }

  var valueOf = value.valueOf && value.valueOf();

  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }

  var b = fromObject(value);
  if (b) return b;

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }

  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/


Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
}; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148


Buffer.prototype.__proto__ = Uint8Array.prototype;
Buffer.__proto__ = Uint8Array;

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}

function alloc(size, fill, encoding) {
  assertSize(size);

  if (size <= 0) {
    return createBuffer(size);
  }

  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }

  return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/


Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};

function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */


Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */


Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};

function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }

  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }

  return buf;
}

function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);

  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }

  return buf;
}

function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }

  var buf;

  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  } // Return an augmented `Uint8Array` instance


  buf.__proto__ = Buffer.prototype;
  return buf;
}

function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);

    if (buf.length === 0) {
      return buf;
    }

    obj.copy(buf, 0, 0, len);
    return buf;
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }

    return fromArrayLike(obj);
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}

function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }

  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }

  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};

Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);

  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }

  if (a === b) return 0;
  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;

    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;

  if (length === undefined) {
    length = 0;

    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;

  for (i = 0; i < list.length; ++i) {
    var buf = list[i];

    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf);
    }

    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }

    buf.copy(buffer, pos);
    pos += buf.length;
  }

  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }

  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }

  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + _typeof(string));
  }

  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion

  var loweredCase = false;

  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;

      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;

      case 'hex':
        return len >>> 1;

      case 'base64':
        return base64ToBytes(string).length;

      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }

        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}

Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.
  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.

  if (start === undefined || start < 0) {
    start = 0;
  } // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.


  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  } // Force coersion to uint32. This will also coerce falsey/NaN values to 0.


  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
} // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154


Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;

  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }

  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }

  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;

  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }

  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }

  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;

  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }

  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }

  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.toLocaleString = Buffer.prototype.toString;

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }

  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + _typeof(target));
  }

  if (start === undefined) {
    start = 0;
  }

  if (end === undefined) {
    end = target ? target.length : 0;
  }

  if (thisStart === undefined) {
    thisStart = 0;
  }

  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }

  if (thisStart >= thisEnd) {
    return -1;
  }

  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
}; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf


function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1; // Normalize byteOffset

  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }

  byteOffset = +byteOffset; // Coerce to Number.

  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  } // Normalize byteOffset: negative offsets start from the end of the buffer


  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;

  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  } // Normalize val


  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  } // Finally, search either indexOf (if dir is true) or lastIndexOf


  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }

    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]

    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }

    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();

    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }

      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;

  if (dir) {
    var foundIndex = -1;

    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;

    for (i = byteOffset; i >= 0; i--) {
      var found = true;

      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }

      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;

  if (!length) {
    length = remaining;
  } else {
    length = Number(length);

    if (length > remaining) {
      length = remaining;
    }
  }

  var strLen = string.length;

  if (length > strLen / 2) {
    length = strLen / 2;
  }

  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }

  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0; // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0; // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;

    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';
  var loweredCase = false;

  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;

  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }

          break;

        case 2:
          secondByte = buf[i + 1];

          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;

            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }

          break;

        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];

          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;

            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }

          break;

        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];

          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;

            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }

      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
} // Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety


var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;

  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  } // Decode in chunks to avoid "call stack size exceeded".


  var res = '';
  var i = 0;

  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }

  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }

  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }

  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';

  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }

  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';

  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }

  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;
  var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance

  newBuf.__proto__ = Buffer.prototype;
  return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */


function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;

  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;

  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;

  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;

  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];

  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }

  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;

  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;

  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;

  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;

  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;

  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;

  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }

    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;

  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;

  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }

    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;

  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }

  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;

  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }

  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
}; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)


Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done

  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions

  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }

  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?

  if (end > this.length) end = this.length;

  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }

  return len;
}; // Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])


Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }

    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }

    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }

    if (val.length === 1) {
      var code = val.charCodeAt(0);

      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } // Invalid ranges are not set to a default, so can range check early.


  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;

  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;

    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }

    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
}; // HELPER FUNCTIONS
// ================


var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not

  str = str.trim().replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''

  if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not

  while (str.length % 4 !== 0) {
    str = str + '=';
  }

  return str;
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i); // is surrogate component

    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } // valid lead


        leadSurrogate = codePoint;
        continue;
      } // 2 leads in a row


      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      } // valid surrogate pair


      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null; // encode utf8

    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];

  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }

  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];

  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }

  return i;
} // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166


function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}

function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

},{"base64-js":2,"ieee754":28}],5:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
(function (window, factory) {
  /*global define: false, module: false */
  'use strict'; // universal module definition

  if (typeof define == 'function' && define.amd) {
    // AMD
    define(factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }
})(window, function factory() {
  'use strict';

  var matchesMethod = function () {
    var ElemProto = window.Element.prototype; // check for the standard method name first

    if (ElemProto.matches) {
      return 'matches';
    } // check un-prefixed


    if (ElemProto.matchesSelector) {
      return 'matchesSelector';
    } // check vendor prefixes


    var prefixes = ['webkit', 'moz', 'ms', 'o'];

    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';

      if (ElemProto[method]) {
        return method;
      }
    }
  }();

  return function matchesSelector(elem, selector) {
    return elem[matchesMethod](selector);
  };
});

},{}],6:[function(require,module,exports){
(function (process,global){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.6+9869a4bc
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
})(void 0, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = _typeof(x);

    return x !== null && (type === 'object' || type === 'function');
  }

  function isFunction(x) {
    return typeof x === 'function';
  }

  var _isArray = void 0;

  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }

  var isArray = _isArray;
  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;

  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;

    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };

  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }

  function setAsap(asapFn) {
    asap = asapFn;
  }

  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]'; // test for web worker but not in IE10

  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined'; // node

  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  } // vertx


  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }

    return useSetTimeout();
  }

  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, {
      characterData: true
    });
    return function () {
      node.data = iterations = ++iterations % 2;
    };
  } // web worker


  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }

  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }

  var queue = new Array(1000);

  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];
      callback(arg);
      queue[i] = undefined;
      queue[i + 1] = undefined;
    }

    len = 0;
  }

  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');

      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }

  var scheduleFlush = void 0; // Decide what async method to use to triggering processing of queued callbacks:

  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && typeof require === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }

  function then(onFulfillment, onRejection) {
    var parent = this;
    var child = new this.constructor(noop);

    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }

    var _state = parent._state;

    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }

    return child;
  }
  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */


  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && _typeof(object) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }

  var PROMISE_ID = Math.random().toString(36).substring(2);

  function noop() {}

  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;
  var TRY_CATCH_ERROR = {
    error: null
  };

  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      TRY_CATCH_ERROR.error = error;
      return TRY_CATCH_ERROR;
    }
  }

  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }

        sealed = true;

        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }

        sealed = true;
        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }

  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }

  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === TRY_CATCH_ERROR) {
        reject(promise, TRY_CATCH_ERROR.error);
        TRY_CATCH_ERROR.error = null;
      } else if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }

  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      handleMaybeThenable(promise, value, getThen(value));
    } else {
      fulfill(promise, value);
    }
  }

  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    publish(promise);
  }

  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._result = value;
    promise._state = FULFILLED;

    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._state = REJECTED;
    promise._result = reason;
    asap(publishRejection, promise);
  }

  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;
    parent._onerror = null;
    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }

  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child = void 0,
        callback = void 0,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      TRY_CATCH_ERROR.error = e;
      return TRY_CATCH_ERROR;
    }
  }

  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = void 0,
        failed = void 0;

    if (hasCallback) {
      value = tryCatch(callback, detail);

      if (value === TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value.error = null;
      } else {
        succeeded = true;
      }

      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }

    if (promise._state !== PENDING) {// noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }

  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }

  var id = 0;

  function nextId() {
    return id++;
  }

  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }

  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }

  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;
        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;

          this._enumerate(input);

          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);

          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;
      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    return Enumerator;
  }();
  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */


  function all(entries) {
    return new Enumerator(this, entries).promise;
  }
  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */


  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;

        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }
  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */


  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }

  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }
  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */


  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }
    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */


    Promise.prototype.catch = function _catch(onRejection) {
      return this.then(null, onRejection);
    };
    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */


    Promise.prototype.finally = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;

      if (isFunction(callback)) {
        return promise.then(function (value) {
          return constructor.resolve(callback()).then(function () {
            return value;
          });
        }, function (reason) {
          return constructor.resolve(callback()).then(function () {
            throw reason;
          });
        });
      }

      return promise.then(callback, callback);
    };

    return Promise;
  }();

  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;
  /*global self*/

  function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P) {
      var promiseToString = null;

      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {// silently ignored
      }

      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }

    local.Promise = Promise$1;
  } // Strange compat..


  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;
  return Promise$1;
});

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":69}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */
(function (global, factory) {
  // universal module definition

  /* jshint strict: false */

  /* globals define, module, window */
  if (typeof define == 'function' && define.amd) {
    // AMD - RequireJS
    define(factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }
})(typeof window != 'undefined' ? window : void 0, function () {
  "use strict";

  function EvEmitter() {}

  var proto = EvEmitter.prototype;

  proto.on = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    } // set events hash


    var events = this._events = this._events || {}; // set listeners array

    var listeners = events[eventName] = events[eventName] || []; // only add once

    if (listeners.indexOf(listener) == -1) {
      listeners.push(listener);
    }

    return this;
  };

  proto.once = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    } // add event


    this.on(eventName, listener); // set once flag
    // set onceEvents hash

    var onceEvents = this._onceEvents = this._onceEvents || {}; // set onceListeners object

    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {}; // set flag

    onceListeners[listener] = true;
    return this;
  };

  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];

    if (!listeners || !listeners.length) {
      return;
    }

    var index = listeners.indexOf(listener);

    if (index != -1) {
      listeners.splice(index, 1);
    }

    return this;
  };

  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];

    if (!listeners || !listeners.length) {
      return;
    } // copy over to avoid interference if .off() in listener


    listeners = listeners.slice(0);
    args = args || []; // once stuff

    var onceListeners = this._onceEvents && this._onceEvents[eventName];

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      var isOnce = onceListeners && onceListeners[listener];

      if (isOnce) {
        // remove listener
        // remove before trigger to prevent recursion
        this.off(eventName, listener); // unset once flag

        delete onceListeners[listener];
      } // trigger listener


      listener.apply(this, args);
    }

    return this;
  };

  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
  };

  return EvEmitter;
});

},{}],8:[function(require,module,exports){
(function (Buffer){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* build: `node build.js modules=ALL exclude=gestures,accessors requirejs minifier=uglifyjs` */

/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */
var fabric = fabric || {
  version: '4.3.1'
};

if (typeof exports !== 'undefined') {
  exports.fabric = fabric;
}
/* _AMD_START_ */
else if (typeof define === 'function' && define.amd) {
    define([], function () {
      return fabric;
    });
  }
/* _AMD_END_ */


if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) {
    fabric.document = document;
  } else {
    fabric.document = document.implementation.createHTMLDocument('');
  }

  fabric.window = window;
} else {
  // assume we're running under node.js when document/window are not present
  var jsdom = require('jsdom');

  var virtualWindow = new jsdom.JSDOM(decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'), {
    features: {
      FetchExternalResources: ['img']
    },
    resources: 'usable'
  }).window;
  fabric.document = virtualWindow.document;
  fabric.jsdomImplForWrapper = require('jsdom/lib/jsdom/living/generated/utils').implForWrapper;
  fabric.nodeCanvas = require('jsdom/lib/jsdom/utils').Canvas;
  fabric.window = virtualWindow;
  DOMParser = fabric.window.DOMParser;
}
/**
 * True when in environment that supports touch events
 * @type boolean
 */


fabric.isTouchSupported = 'ontouchstart' in fabric.window || 'ontouchstart' in fabric.document || fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0;
/**
 * True when in environment that's probably Node.js
 * @type boolean
 */

fabric.isLikelyNode = typeof Buffer !== 'undefined' && typeof window === 'undefined';
/* _FROM_SVG_START_ */

/**
 * Attributes parsed from all SVG elements
 * @type array
 */

fabric.SHARED_ATTRIBUTES = ['display', 'transform', 'fill', 'fill-opacity', 'fill-rule', 'opacity', 'stroke', 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'id', 'paint-order', 'vector-effect', 'instantiated_by_use', 'clip-path'];
/* _FROM_SVG_END_ */

/**
 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
 */

fabric.DPI = 96;
fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
fabric.commaWsp = '(?:\\s+,?\\s*|,\\s*)';
fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
fabric.reNonWord = /[ \n\.,;!\?\-]/;
fabric.fontPaths = {};
fabric.iMatrix = [1, 0, 0, 1, 0, 0];
fabric.svgNS = 'http://www.w3.org/2000/svg';
/**
 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
 * @since 1.7.14
 * @type Number
 * @default
 */

fabric.perfLimitSizeTotal = 2097152;
/**
 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
 * @since 1.7.14
 * @type Number
 * @default
 */

fabric.maxCacheSideLimit = 4096;
/**
 * Lowest pixel limit for cache canvases, set at 256PX
 * @since 1.7.14
 * @type Number
 * @default
 */

fabric.minCacheSideLimit = 256;
/**
 * Cache Object for widths of chars in text rendering.
 */

fabric.charWidthsCache = {};
/**
 * if webgl is enabled and available, textureSize will determine the size
 * of the canvas backend
 * @since 2.0.0
 * @type Number
 * @default
 */

fabric.textureSize = 2048;
/**
 * When 'true', style information is not retained when copy/pasting text, making
 * pasted text use destination style.
 * Defaults to 'false'.
 * @type Boolean
 * @default
 */

fabric.disableStyleCopyPaste = false;
/**
 * Enable webgl for filtering picture is available
 * A filtering backend will be initialized, this will both take memory and
 * time since a default 2048x2048 canvas will be created for the gl context
 * @since 2.0.0
 * @type Boolean
 * @default
 */

fabric.enableGLFiltering = true;
/**
 * Device Pixel Ratio
 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
 */

fabric.devicePixelRatio = fabric.window.devicePixelRatio || fabric.window.webkitDevicePixelRatio || fabric.window.mozDevicePixelRatio || 1;
/**
 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
 * which is unitless and not rendered equally across browsers.
 *
 * Values that work quite well (as of October 2017) are:
 * - Chrome: 1.5
 * - Edge: 1.75
 * - Firefox: 0.9
 * - Safari: 0.95
 *
 * @since 2.0.0
 * @type Number
 * @default 1
 */

fabric.browserShadowBlurConstant = 1;
/**
 * This object contains the result of arc to bezier conversion for faster retrieving if the same arc needs to be converted again.
 * It was an internal variable, is accessible since version 2.3.4
 */

fabric.arcToSegmentsCache = {};
/**
 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
 * you do not get any speed benefit and you get a big object in memory.
 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
 * can eventually clear it.
 * It was an internal variable, is accessible since version 2.3.4
 */

fabric.boundsOfCurveCache = {};
/**
 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
 * @default true
 */

fabric.cachesBoundsOfCurve = true;
/**
 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
 * this has to be set before instantiating the filtering backend ( before filtering the first image )
 * @type Boolean
 * @default false
 */

fabric.forceGLPutImageData = false;

fabric.initFilterBackend = function () {
  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
    console.log('max texture size: ' + fabric.maxTextureSize);
    return new fabric.WebglFilterBackend({
      tileSize: fabric.textureSize
    });
  } else if (fabric.Canvas2dFilterBackend) {
    return new fabric.Canvas2dFilterBackend();
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
  window.fabric = fabric;
}

(function () {
  /**
   * @private
   * @param {String} eventName
   * @param {Function} handler
   */
  function _removeEventListener(eventName, handler) {
    if (!this.__eventListeners[eventName]) {
      return;
    }

    var eventListener = this.__eventListeners[eventName];

    if (handler) {
      eventListener[eventListener.indexOf(handler)] = false;
    } else {
      fabric.util.array.fill(eventListener, false);
    }
  }
  /**
   * Observes specified event
   * @memberOf fabric.Observable
   * @alias on
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Self} thisArg
   * @chainable
   */


  function on(eventName, handler) {
    if (!this.__eventListeners) {
      this.__eventListeners = {};
    } // one object with key/value pairs was passed


    if (arguments.length === 1) {
      for (var prop in eventName) {
        this.on(prop, eventName[prop]);
      }
    } else {
      if (!this.__eventListeners[eventName]) {
        this.__eventListeners[eventName] = [];
      }

      this.__eventListeners[eventName].push(handler);
    }

    return this;
  }
  /**
   * Stops event observing for a particular event handler. Calling this method
   * without arguments removes all handlers for all events
   * @memberOf fabric.Observable
   * @alias off
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function to be deleted from EventListeners
   * @return {Self} thisArg
   * @chainable
   */


  function off(eventName, handler) {
    if (!this.__eventListeners) {
      return this;
    } // remove all key/value pairs (event name -> event handler)


    if (arguments.length === 0) {
      for (eventName in this.__eventListeners) {
        _removeEventListener.call(this, eventName);
      }
    } // one object with key/value pairs was passed
    else if (arguments.length === 1 && _typeof(arguments[0]) === 'object') {
        for (var prop in eventName) {
          _removeEventListener.call(this, prop, eventName[prop]);
        }
      } else {
        _removeEventListener.call(this, eventName, handler);
      }

    return this;
  }
  /**
   * Fires event with an optional options object
   * @memberOf fabric.Observable
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   * @return {Self} thisArg
   * @chainable
   */


  function fire(eventName, options) {
    if (!this.__eventListeners) {
      return this;
    }

    var listenersForEvent = this.__eventListeners[eventName];

    if (!listenersForEvent) {
      return this;
    }

    for (var i = 0, len = listenersForEvent.length; i < len; i++) {
      listenersForEvent[i] && listenersForEvent[i].call(this, options || {});
    }

    this.__eventListeners[eventName] = listenersForEvent.filter(function (value) {
      return value !== false;
    });
    return this;
  }
  /**
   * @namespace fabric.Observable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */


  fabric.Observable = {
    fire: fire,
    on: on,
    off: off
  };
})();
/**
 * @namespace fabric.Collection
 */


fabric.Collection = {
  _objects: [],

  /**
   * Adds objects to collection, Canvas or Group, then renders canvas
   * (if `renderOnAddRemove` is not `false`).
   * in case of Group no changes to bounding box are made.
   * Objects should be instances of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the add method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  add: function add() {
    this._objects.push.apply(this._objects, arguments);

    if (this._onObjectAdded) {
      for (var i = 0, length = arguments.length; i < length; i++) {
        this._onObjectAdded(arguments[i]);
      }
    }

    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
   * An object should be an instance of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the insertAt method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {Object} object Object to insert
   * @param {Number} index Index to insert object at
   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
   * @return {Self} thisArg
   * @chainable
   */
  insertAt: function insertAt(object, index, nonSplicing) {
    var objects = this._objects;

    if (nonSplicing) {
      objects[index] = object;
    } else {
      objects.splice(index, 0, object);
    }

    this._onObjectAdded && this._onObjectAdded(object);
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  remove: function remove() {
    var objects = this._objects,
        index,
        somethingRemoved = false;

    for (var i = 0, length = arguments.length; i < length; i++) {
      index = objects.indexOf(arguments[i]); // only call onObjectRemoved if an object was actually removed

      if (index !== -1) {
        somethingRemoved = true;
        objects.splice(index, 1);
        this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
      }
    }

    this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
    return this;
  },

  /**
   * Executes given function for each object in this group
   * @param {Function} callback
   *                   Callback invoked with current object as first argument,
   *                   index - as second and an array of all objects - as third.
   *                   Callback is invoked in a context of Global Object (e.g. `window`)
   *                   when no `context` argument is given
   *
   * @param {Object} context Context (aka thisObject)
   * @return {Self} thisArg
   * @chainable
   */
  forEachObject: function forEachObject(callback, context) {
    var objects = this.getObjects();

    for (var i = 0, len = objects.length; i < len; i++) {
      callback.call(context, objects[i], i, objects);
    }

    return this;
  },

  /**
   * Returns an array of children objects of this instance
   * Type parameter introduced in 1.3.10
   * since 2.3.5 this method return always a COPY of the array;
   * @param {String} [type] When specified, only objects of this type are returned
   * @return {Array}
   */
  getObjects: function getObjects(type) {
    if (typeof type === 'undefined') {
      return this._objects.concat();
    }

    return this._objects.filter(function (o) {
      return o.type === type;
    });
  },

  /**
   * Returns object at specified index
   * @param {Number} index
   * @return {Self} thisArg
   */
  item: function item(index) {
    return this._objects[index];
  },

  /**
   * Returns true if collection contains no objects
   * @return {Boolean} true if collection is empty
   */
  isEmpty: function isEmpty() {
    return this._objects.length === 0;
  },

  /**
   * Returns a size of a collection (i.e: length of an array containing its objects)
   * @return {Number} Collection size
   */
  size: function size() {
    return this._objects.length;
  },

  /**
   * Returns true if collection contains an object
   * @param {Object} object Object to check against
   * @return {Boolean} `true` if collection contains an object
   */
  contains: function contains(object) {
    return this._objects.indexOf(object) > -1;
  },

  /**
   * Returns number representation of a collection complexity
   * @return {Number} complexity
   */
  complexity: function complexity() {
    return this._objects.reduce(function (memo, current) {
      memo += current.complexity ? current.complexity() : 0;
      return memo;
    }, 0);
  }
};
/**
 * @namespace fabric.CommonMethods
 */

fabric.CommonMethods = {
  /**
   * Sets object's properties from options
   * @param {Object} [options] Options object
   */
  _setOptions: function _setOptions(options) {
    for (var prop in options) {
      this.set(prop, options[prop]);
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Gradient to
   */
  _initGradient: function _initGradient(filler, property) {
    if (filler && filler.colorStops && !(filler instanceof fabric.Gradient)) {
      this.set(property, new fabric.Gradient(filler));
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Pattern to
   * @param {Function} [callback] callback to invoke after pattern load
   */
  _initPattern: function _initPattern(filler, property, callback) {
    if (filler && filler.source && !(filler instanceof fabric.Pattern)) {
      this.set(property, new fabric.Pattern(filler, callback));
    } else {
      callback && callback();
    }
  },

  /**
   * @private
   */
  _setObject: function _setObject(obj) {
    for (var prop in obj) {
      this._set(prop, obj[prop]);
    }
  },

  /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  set: function set(key, value) {
    if (_typeof(key) === 'object') {
      this._setObject(key);
    } else {
      this._set(key, value);
    }

    return this;
  },
  _set: function _set(key, value) {
    this[key] = value;
  },

  /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   * @return {fabric.Object} thisArg
   * @chainable
   */
  toggle: function toggle(property) {
    var value = this.get(property);

    if (typeof value === 'boolean') {
      this.set(property, !value);
    }

    return this;
  },

  /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */
  get: function get(property) {
    return this[property];
  }
};

(function (global) {
  var sqrt = Math.sqrt,
      atan2 = Math.atan2,
      pow = Math.pow,
      PiBy180 = Math.PI / 180,
      PiBy2 = Math.PI / 2;
  /**
   * @namespace fabric.util
   */

  fabric.util = {
    /**
     * Calculate the cos of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    cos: function cos(angle) {
      if (angle === 0) {
        return 1;
      }

      if (angle < 0) {
        // cos(a) = cos(-a)
        angle = -angle;
      }

      var angleSlice = angle / PiBy2;

      switch (angleSlice) {
        case 1:
        case 3:
          return 0;

        case 2:
          return -1;
      }

      return Math.cos(angle);
    },

    /**
     * Calculate the sin of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    sin: function sin(angle) {
      if (angle === 0) {
        return 0;
      }

      var angleSlice = angle / PiBy2,
          sign = 1;

      if (angle < 0) {
        // sin(-a) = -sin(a)
        sign = -1;
      }

      switch (angleSlice) {
        case 1:
          return sign;

        case 2:
          return 0;

        case 3:
          return -sign;
      }

      return Math.sin(angle);
    },

    /**
     * Removes value from an array.
     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
     * @static
     * @memberOf fabric.util
     * @param {Array} array
     * @param {*} value
     * @return {Array} original array
     */
    removeFromArray: function removeFromArray(array, value) {
      var idx = array.indexOf(value);

      if (idx !== -1) {
        array.splice(idx, 1);
      }

      return array;
    },

    /**
     * Returns random number between 2 specified ones.
     * @static
     * @memberOf fabric.util
     * @param {Number} min lower limit
     * @param {Number} max upper limit
     * @return {Number} random value (between min and max)
     */
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    /**
     * Transforms degrees to radians.
     * @static
     * @memberOf fabric.util
     * @param {Number} degrees value in degrees
     * @return {Number} value in radians
     */
    degreesToRadians: function degreesToRadians(degrees) {
      return degrees * PiBy180;
    },

    /**
     * Transforms radians to degrees.
     * @static
     * @memberOf fabric.util
     * @param {Number} radians value in radians
     * @return {Number} value in degrees
     */
    radiansToDegrees: function radiansToDegrees(radians) {
      return radians / PiBy180;
    },

    /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {fabric.Point} point The point to rotate
     * @param {fabric.Point} origin The origin of the rotation
     * @param {Number} radians The radians of the angle for the rotation
     * @return {fabric.Point} The new rotated point
     */
    rotatePoint: function rotatePoint(point, origin, radians) {
      point.subtractEquals(origin);
      var v = fabric.util.rotateVector(point, radians);
      return new fabric.Point(v.x, v.y).addEquals(origin);
    },

    /**
     * Rotates `vector` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {Object} vector The vector to rotate (x and y)
     * @param {Number} radians The radians of the angle for the rotation
     * @return {Object} The new rotated point
     */
    rotateVector: function rotateVector(vector, radians) {
      var sin = fabric.util.sin(radians),
          cos = fabric.util.cos(radians),
          rx = vector.x * cos - vector.y * sin,
          ry = vector.x * sin + vector.y * cos;
      return {
        x: rx,
        y: ry
      };
    },

    /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Point} p The point to transform
     * @param  {Array} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {fabric.Point} The transformed point
     */
    transformPoint: function transformPoint(p, t, ignoreOffset) {
      if (ignoreOffset) {
        return new fabric.Point(t[0] * p.x + t[2] * p.y, t[1] * p.x + t[3] * p.y);
      }

      return new fabric.Point(t[0] * p.x + t[2] * p.y + t[4], t[1] * p.x + t[3] * p.y + t[5]);
    },

    /**
     * Returns coordinates of points's bounding rectangle (left, top, width, height)
     * @param {Array} points 4 points array
     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
     * @return {Object} Object with left, top, width, height properties
     */
    makeBoundingBoxFromPoints: function makeBoundingBoxFromPoints(points, transform) {
      if (transform) {
        for (var i = 0; i < points.length; i++) {
          points[i] = fabric.util.transformPoint(points[i], transform);
        }
      }

      var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x],
          minX = fabric.util.array.min(xPoints),
          maxX = fabric.util.array.max(xPoints),
          width = maxX - minX,
          yPoints = [points[0].y, points[1].y, points[2].y, points[3].y],
          minY = fabric.util.array.min(yPoints),
          maxY = fabric.util.array.max(yPoints),
          height = maxY - minY;
      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Invert transformation t
     * @static
     * @memberOf fabric.util
     * @param {Array} t The transform
     * @return {Array} The inverted transform
     */
    invertTransform: function invertTransform(t) {
      var a = 1 / (t[0] * t[3] - t[1] * t[2]),
          r = [a * t[3], -a * t[1], -a * t[2], a * t[0]],
          o = fabric.util.transformPoint({
        x: t[4],
        y: t[5]
      }, r, true);
      r[4] = -o.x;
      r[5] = -o.y;
      return r;
    },

    /**
     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
     * @static
     * @memberOf fabric.util
     * @param {Number|String} number number to operate on
     * @param {Number} fractionDigits number of fraction digits to "leave"
     * @return {Number}
     */
    toFixed: function toFixed(number, fractionDigits) {
      return parseFloat(Number(number).toFixed(fractionDigits));
    },

    /**
     * Converts from attribute value to pixel value if applicable.
     * Returns converted pixels or original value not converted.
     * @param {Number|String} value number to operate on
     * @param {Number} fontSize
     * @return {Number|String}
     */
    parseUnit: function parseUnit(value, fontSize) {
      var unit = /\D{0,2}$/.exec(value),
          number = parseFloat(value);

      if (!fontSize) {
        fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
      }

      switch (unit[0]) {
        case 'mm':
          return number * fabric.DPI / 25.4;

        case 'cm':
          return number * fabric.DPI / 2.54;

        case 'in':
          return number * fabric.DPI;

        case 'pt':
          return number * fabric.DPI / 72;
        // or * 4 / 3

        case 'pc':
          return number * fabric.DPI / 72 * 12;
        // or * 16

        case 'em':
          return number * fontSize;

        default:
          return number;
      }
    },

    /**
     * Function which always returns `false`.
     * @static
     * @memberOf fabric.util
     * @return {Boolean}
     */
    falseFunction: function falseFunction() {
      return false;
    },

    /**
     * Returns klass "Class" object of given namespace
     * @memberOf fabric.util
     * @param {String} type Type of object (eg. 'circle')
     * @param {String} namespace Namespace to get klass "Class" object from
     * @return {Object} klass "Class"
     */
    getKlass: function getKlass(type, namespace) {
      // capitalize first letter only
      type = fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
      return fabric.util.resolveNamespace(namespace)[type];
    },

    /**
     * Returns array of attributes for given svg that fabric parses
     * @memberOf fabric.util
     * @param {String} type Type of svg element (eg. 'circle')
     * @return {Array} string names of supported attributes
     */
    getSvgAttributes: function getSvgAttributes(type) {
      var attributes = ['instantiated_by_use', 'style', 'id', 'class'];

      switch (type) {
        case 'linearGradient':
          attributes = attributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
          break;

        case 'radialGradient':
          attributes = attributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
          break;

        case 'stop':
          attributes = attributes.concat(['offset', 'stop-color', 'stop-opacity']);
          break;
      }

      return attributes;
    },

    /**
     * Returns object of given namespace
     * @memberOf fabric.util
     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
     * @return {Object} Object for given namespace (default fabric)
     */
    resolveNamespace: function resolveNamespace(namespace) {
      if (!namespace) {
        return fabric;
      }

      var parts = namespace.split('.'),
          len = parts.length,
          i,
          obj = global || fabric.window;

      for (i = 0; i < len; ++i) {
        obj = obj[parts[i]];
      }

      return obj;
    },

    /**
     * Loads image element from given url and passes it to a callback
     * @memberOf fabric.util
     * @param {String} url URL representing an image
     * @param {Function} callback Callback; invoked with loaded image
     * @param {*} [context] Context to invoke callback in
     * @param {Object} [crossOrigin] crossOrigin value to set image element to
     */
    loadImage: function loadImage(url, callback, context, crossOrigin) {
      if (!url) {
        callback && callback.call(context, url);
        return;
      }

      var img = fabric.util.createImage();
      /** @ignore */

      var onLoadCallback = function onLoadCallback() {
        callback && callback.call(context, img, false);
        img = img.onload = img.onerror = null;
      };

      img.onload = onLoadCallback;
      /** @ignore */

      img.onerror = function () {
        fabric.log('Error loading ' + img.src);
        callback && callback.call(context, null, true);
        img = img.onload = img.onerror = null;
      }; // data-urls appear to be buggy with crossOrigin
      // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
      // see https://code.google.com/p/chromium/issues/detail?id=315152
      //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
      // crossOrigin null is the same as not set.


      if (url.indexOf('data') !== 0 && crossOrigin !== undefined && crossOrigin !== null) {
        img.crossOrigin = crossOrigin;
      } // IE10 / IE11-Fix: SVG contents from data: URI
      // will only be available if the IMG is present
      // in the DOM (and visible)


      if (url.substring(0, 14) === 'data:image/svg') {
        img.onload = null;
        fabric.util.loadImageInDom(img, onLoadCallback);
      }

      img.src = url;
    },

    /**
     * Attaches SVG image with data: URL to the dom
     * @memberOf fabric.util
     * @param {Object} img Image object with data:image/svg src
     * @param {Function} callback Callback; invoked with loaded image
     * @return {Object} DOM element (div containing the SVG image)
     */
    loadImageInDom: function loadImageInDom(img, onLoadCallback) {
      var div = fabric.document.createElement('div');
      div.style.width = div.style.height = '1px';
      div.style.left = div.style.top = '-100%';
      div.style.position = 'absolute';
      div.appendChild(img);
      fabric.document.querySelector('body').appendChild(div);
      /**
       * Wrap in function to:
       *   1. Call existing callback
       *   2. Cleanup DOM
       */

      img.onload = function () {
        onLoadCallback();
        div.parentNode.removeChild(div);
        div = null;
      };
    },

    /**
     * Creates corresponding fabric instances from their object representations
     * @static
     * @memberOf fabric.util
     * @param {Array} objects Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * @param {String} namespace Namespace to get klass "Class" object from
     * @param {Function} reviver Method for further parsing of object elements,
     * called after each fabric object created.
     */
    enlivenObjects: function enlivenObjects(objects, callback, namespace, reviver) {
      objects = objects || [];
      var enlivenedObjects = [],
          numLoadedObjects = 0,
          numTotalObjects = objects.length;

      function onLoaded() {
        if (++numLoadedObjects === numTotalObjects) {
          callback && callback(enlivenedObjects.filter(function (obj) {
            // filter out undefined objects (objects that gave error)
            return obj;
          }));
        }
      }

      if (!numTotalObjects) {
        callback && callback(enlivenedObjects);
        return;
      }

      objects.forEach(function (o, index) {
        // if sparse array
        if (!o || !o.type) {
          onLoaded();
          return;
        }

        var klass = fabric.util.getKlass(o.type, namespace);
        klass.fromObject(o, function (obj, error) {
          error || (enlivenedObjects[index] = obj);
          reviver && reviver(o, obj, error);
          onLoaded();
        });
      });
    },

    /**
     * Create and wait for loading of patterns
     * @static
     * @memberOf fabric.util
     * @param {Array} patterns Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * called after each fabric object created.
     */
    enlivenPatterns: function enlivenPatterns(patterns, callback) {
      patterns = patterns || [];

      function onLoaded() {
        if (++numLoadedPatterns === numPatterns) {
          callback && callback(enlivenedPatterns);
        }
      }

      var enlivenedPatterns = [],
          numLoadedPatterns = 0,
          numPatterns = patterns.length;

      if (!numPatterns) {
        callback && callback(enlivenedPatterns);
        return;
      }

      patterns.forEach(function (p, index) {
        if (p && p.source) {
          new fabric.Pattern(p, function (pattern) {
            enlivenedPatterns[index] = pattern;
            onLoaded();
          });
        } else {
          enlivenedPatterns[index] = p;
          onLoaded();
        }
      });
    },

    /**
     * Groups SVG elements (usually those retrieved from SVG document)
     * @static
     * @memberOf fabric.util
     * @param {Array} elements SVG elements to group
     * @param {Object} [options] Options object
     * @param {String} path Value to set sourcePath to
     * @return {fabric.Object|fabric.Group}
     */
    groupSVGElements: function groupSVGElements(elements, options, path) {
      var object;

      if (elements && elements.length === 1) {
        return elements[0];
      }

      if (options) {
        if (options.width && options.height) {
          options.centerPoint = {
            x: options.width / 2,
            y: options.height / 2
          };
        } else {
          delete options.width;
          delete options.height;
        }
      }

      object = new fabric.Group(elements, options);

      if (typeof path !== 'undefined') {
        object.sourcePath = path;
      }

      return object;
    },

    /**
     * Populates an object with properties of another object
     * @static
     * @memberOf fabric.util
     * @param {Object} source Source object
     * @param {Object} destination Destination object
     * @return {Array} properties Properties names to include
     */
    populateWithProperties: function populateWithProperties(source, destination, properties) {
      if (properties && Object.prototype.toString.call(properties) === '[object Array]') {
        for (var i = 0, len = properties.length; i < len; i++) {
          if (properties[i] in source) {
            destination[properties[i]] = source[properties[i]];
          }
        }
      }
    },

    /**
     * Draws a dashed line between two points
     *
     * This method is used to draw dashed line around selection area.
     * See <a href="http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas">dotted stroke in canvas</a>
     *
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x  start x coordinate
     * @param {Number} y start y coordinate
     * @param {Number} x2 end x coordinate
     * @param {Number} y2 end y coordinate
     * @param {Array} da dash array pattern
     */
    drawDashedLine: function drawDashedLine(ctx, x, y, x2, y2, da) {
      var dx = x2 - x,
          dy = y2 - y,
          len = sqrt(dx * dx + dy * dy),
          rot = atan2(dy, dx),
          dc = da.length,
          di = 0,
          draw = true;
      ctx.save();
      ctx.translate(x, y);
      ctx.moveTo(0, 0);
      ctx.rotate(rot);
      x = 0;

      while (len > x) {
        x += da[di++ % dc];

        if (x > len) {
          x = len;
        }

        ctx[draw ? 'lineTo' : 'moveTo'](x, 0);
        draw = !draw;
      }

      ctx.restore();
    },

    /**
     * Creates canvas element
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    createCanvasElement: function createCanvasElement() {
      return fabric.document.createElement('canvas');
    },

    /**
     * Creates a canvas element that is a copy of another and is also painted
     * @param {CanvasElement} canvas to copy size and content of
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    copyCanvasElement: function copyCanvasElement(canvas) {
      var newCanvas = fabric.util.createCanvasElement();
      newCanvas.width = canvas.width;
      newCanvas.height = canvas.height;
      newCanvas.getContext('2d').drawImage(canvas, 0, 0);
      return newCanvas;
    },

    /**
     * since 2.6.0 moved from canvas instance to utility.
     * @param {CanvasElement} canvasEl to copy size and content of
     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
     * @param {Number} quality <= 1 and > 0
     * @static
     * @memberOf fabric.util
     * @return {String} data url
     */
    toDataURL: function toDataURL(canvasEl, format, quality) {
      return canvasEl.toDataURL('image/' + format, quality);
    },

    /**
     * Creates image element (works on client and node)
     * @static
     * @memberOf fabric.util
     * @return {HTMLImageElement} HTML image element
     */
    createImage: function createImage() {
      return fabric.document.createElement('img');
    },

    /**
     * Multiply matrix A by matrix B to nest transformations
     * @static
     * @memberOf fabric.util
     * @param  {Array} a First transformMatrix
     * @param  {Array} b Second transformMatrix
     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
     * @return {Array} The product of the two transform matrices
     */
    multiplyTransformMatrices: function multiplyTransformMatrices(a, b, is2x2) {
      // Matrix multiply a * b
      return [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4], is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]];
    },

    /**
     * Decomposes standard 2x3 matrix into transform components
     * @static
     * @memberOf fabric.util
     * @param  {Array} a transformMatrix
     * @return {Object} Components of transform
     */
    qrDecompose: function qrDecompose(a) {
      var angle = atan2(a[1], a[0]),
          denom = pow(a[0], 2) + pow(a[1], 2),
          scaleX = sqrt(denom),
          scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX,
          skewX = atan2(a[0] * a[2] + a[1] * a[3], denom);
      return {
        angle: angle / PiBy180,
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: skewX / PiBy180,
        skewY: 0,
        translateX: a[4],
        translateY: a[5]
      };
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle] angle in degrees
     * @return {Number[]} transform matrix
     */
    calcRotateMatrix: function calcRotateMatrix(options) {
      if (!options.angle) {
        return fabric.iMatrix.concat();
      }

      var theta = fabric.util.degreesToRadians(options.angle),
          cos = fabric.util.cos(theta),
          sin = fabric.util.sin(theta);
      return [cos, sin, -sin, cos, 0, 0];
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet.
     * is called DimensionsTransformMatrix because those properties are the one that influence
     * the size of the resulting box of the object.
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @return {Number[]} transform matrix
     */
    calcDimensionsMatrix: function calcDimensionsMatrix(options) {
      var scaleX = typeof options.scaleX === 'undefined' ? 1 : options.scaleX,
          scaleY = typeof options.scaleY === 'undefined' ? 1 : options.scaleY,
          scaleMatrix = [options.flipX ? -scaleX : scaleX, 0, 0, options.flipY ? -scaleY : scaleY, 0, 0],
          multiply = fabric.util.multiplyTransformMatrices,
          degreesToRadians = fabric.util.degreesToRadians;

      if (options.skewX) {
        scaleMatrix = multiply(scaleMatrix, [1, 0, Math.tan(degreesToRadians(options.skewX)), 1], true);
      }

      if (options.skewY) {
        scaleMatrix = multiply(scaleMatrix, [1, Math.tan(degreesToRadians(options.skewY)), 0, 1], true);
      }

      return scaleMatrix;
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle]
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.translateX]
     * @param  {Number} [options.translateY]
     * @return {Number[]} transform matrix
     */
    composeMatrix: function composeMatrix(options) {
      var matrix = [1, 0, 0, 1, options.translateX || 0, options.translateY || 0],
          multiply = fabric.util.multiplyTransformMatrices;

      if (options.angle) {
        matrix = multiply(matrix, fabric.util.calcRotateMatrix(options));
      }

      if (options.scaleX !== 1 || options.scaleY !== 1 || options.skewX || options.skewY || options.flipX || options.flipY) {
        matrix = multiply(matrix, fabric.util.calcDimensionsMatrix(options));
      }

      return matrix;
    },

    /**
     * reset an object transform state to neutral. Top and left are not accounted for
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to transform
     */
    resetObjectTransform: function resetObjectTransform(target) {
      target.scaleX = 1;
      target.scaleY = 1;
      target.skewX = 0;
      target.skewY = 0;
      target.flipX = false;
      target.flipY = false;
      target.rotate(0);
    },

    /**
     * Extract Object transform values
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to read from
     * @return {Object} Components of transform
     */
    saveObjectTransform: function saveObjectTransform(target) {
      return {
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
      };
    },

    /**
     * Returns true if context has transparent pixel
     * at specified location (taking tolerance into account)
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x x coordinate
     * @param {Number} y y coordinate
     * @param {Number} tolerance Tolerance
     */
    isTransparent: function isTransparent(ctx, x, y, tolerance) {
      // If tolerance is > 0 adjust start coords to take into account.
      // If moves off Canvas fix to 0
      if (tolerance > 0) {
        if (x > tolerance) {
          x -= tolerance;
        } else {
          x = 0;
        }

        if (y > tolerance) {
          y -= tolerance;
        } else {
          y = 0;
        }
      }

      var _isTransparent = true,
          i,
          temp,
          imageData = ctx.getImageData(x, y, tolerance * 2 || 1, tolerance * 2 || 1),
          l = imageData.data.length; // Split image data - for tolerance > 1, pixelDataSize = 4;

      for (i = 3; i < l; i += 4) {
        temp = imageData.data[i];
        _isTransparent = temp <= 0;

        if (_isTransparent === false) {
          break; // Stop if colour found
        }
      }

      imageData = null;
      return _isTransparent;
    },

    /**
     * Parse preserveAspectRatio attribute from element
     * @param {string} attribute to be parsed
     * @return {Object} an object containing align and meetOrSlice attribute
     */
    parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute(attribute) {
      var meetOrSlice = 'meet',
          alignX = 'Mid',
          alignY = 'Mid',
          aspectRatioAttrs = attribute.split(' '),
          align;

      if (aspectRatioAttrs && aspectRatioAttrs.length) {
        meetOrSlice = aspectRatioAttrs.pop();

        if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
          align = meetOrSlice;
          meetOrSlice = 'meet';
        } else if (aspectRatioAttrs.length) {
          align = aspectRatioAttrs.pop();
        }
      } //divide align in alignX and alignY


      alignX = align !== 'none' ? align.slice(1, 4) : 'none';
      alignY = align !== 'none' ? align.slice(5, 8) : 'none';
      return {
        meetOrSlice: meetOrSlice,
        alignX: alignX,
        alignY: alignY
      };
    },

    /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @memberOf fabric.util
     * @param {String} [fontFamily] font family to clear
     */
    clearFabricFontCache: function clearFabricFontCache(fontFamily) {
      fontFamily = (fontFamily || '').toLowerCase();

      if (!fontFamily) {
        fabric.charWidthsCache = {};
      } else if (fabric.charWidthsCache[fontFamily]) {
        delete fabric.charWidthsCache[fontFamily];
      }
    },

    /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Number} ar aspect ratio
     * @param {Number} maximumArea Maximum area you want to achieve
     * @return {Object.x} Limited dimensions by X
     * @return {Object.y} Limited dimensions by Y
     */
    limitDimsByArea: function limitDimsByArea(ar, maximumArea) {
      var roughWidth = Math.sqrt(maximumArea * ar),
          perfLimitSizeY = Math.floor(maximumArea / roughWidth);
      return {
        x: Math.floor(roughWidth),
        y: perfLimitSizeY
      };
    },
    capValue: function capValue(min, value, max) {
      return Math.max(min, Math.min(value, max));
    },

    /**
     * Finds the scale for the object source to fit inside the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to fit into destination
     */
    findScaleToFit: function findScaleToFit(source, destination) {
      return Math.min(destination.width / source.width, destination.height / source.height);
    },

    /**
     * Finds the scale for the object source to cover entirely the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to cover destination
     */
    findScaleToCover: function findScaleToCover(source, destination) {
      return Math.max(destination.width / source.width, destination.height / source.height);
    },

    /**
     * given an array of 6 number returns something like `"matrix(...numbers)"`
     * @memberOf fabric.util
     * @param {Array} transform an array with 6 numbers
     * @return {String} transform matrix for svg
     * @return {Object.y} Limited dimensions by Y
     */
    matrixToSVG: function matrixToSVG(transform) {
      return 'matrix(' + transform.map(function (value) {
        return fabric.util.toFixed(value, fabric.Object.NUM_FRACTION_DIGITS);
      }).join(' ') + ')';
    },

    /**
     * given a width and height, return the size of the bounding box
     * that can contains the box with width/height with applied transform
     * described in options.
     * Use to calculate the boxes around objects for controls.
     * @memberOf fabric.util
     * @param {Number} width
     * @param {Number} height
     * @param {Object} options
     * @param {Number} options.scaleX
     * @param {Number} options.scaleY
     * @param {Number} options.skewX
     * @param {Number} options.skewY
     * @return {Object.x} width of containing
     * @return {Object.y} height of containing
     */
    sizeAfterTransform: function sizeAfterTransform(width, height, options) {
      var dimX = width / 2,
          dimY = height / 2,
          points = [{
        x: -dimX,
        y: -dimY
      }, {
        x: dimX,
        y: -dimY
      }, {
        x: -dimX,
        y: dimY
      }, {
        x: dimX,
        y: dimY
      }],
          transformMatrix = fabric.util.calcDimensionsMatrix(options),
          bbox = fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
      return {
        x: bbox.width,
        y: bbox.height
      };
    }
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  var _join = Array.prototype.join,
      commandLengths = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
  },
      repeatedCommands = {
    m: 'l',
    M: 'L'
  };

  function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
    var costh2 = fabric.util.cos(th2),
        sinth2 = fabric.util.sin(th2),
        costh3 = fabric.util.cos(th3),
        sinth3 = fabric.util.sin(th3),
        toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1,
        toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1,
        cp1X = fromX + mT * (-cosTh * rx * sinth2 - sinTh * ry * costh2),
        cp1Y = fromY + mT * (-sinTh * rx * sinth2 + cosTh * ry * costh2),
        cp2X = toX + mT * (cosTh * rx * sinth3 + sinTh * ry * costh3),
        cp2Y = toY + mT * (sinTh * rx * sinth3 - cosTh * ry * costh3);
    return ['C', cp1X, cp1Y, cp2X, cp2Y, toX, toY];
  }
  /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   */


  function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
    var PI = Math.PI,
        th = rotateX * PI / 180,
        sinTh = fabric.util.sin(th),
        cosTh = fabric.util.cos(th),
        fromX = 0,
        fromY = 0;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5,
        py = -cosTh * toY * 0.5 + sinTh * toX * 0.5,
        rx2 = rx * rx,
        ry2 = ry * ry,
        py2 = py * py,
        px2 = px * px,
        pl = rx2 * ry2 - rx2 * py2 - ry2 * px2,
        root = 0;

    if (pl < 0) {
      var s = Math.sqrt(1 - pl / (rx2 * ry2));
      rx *= s;
      ry *= s;
    } else {
      root = (large === sweep ? -1.0 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
    }

    var cx = root * rx * py / ry,
        cy = -root * ry * px / rx,
        cx1 = cosTh * cx - sinTh * cy + toX * 0.5,
        cy1 = sinTh * cx + cosTh * cy + toY * 0.5,
        mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry),
        dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);

    if (sweep === 0 && dtheta > 0) {
      dtheta -= 2 * PI;
    } else if (sweep === 1 && dtheta < 0) {
      dtheta += 2 * PI;
    } // Convert into cubic bezier segments <= 90deg


    var segments = Math.ceil(Math.abs(dtheta / PI * 2)),
        result = [],
        mDelta = dtheta / segments,
        mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2),
        th3 = mTheta + mDelta;

    for (var i = 0; i < segments; i++) {
      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
      fromX = result[i][5];
      fromY = result[i][6];
      mTheta = th3;
      th3 += mDelta;
    }

    return result;
  }
  /*
   * Private
   */


  function calcVectorAngle(ux, uy, vx, vy) {
    var ta = Math.atan2(uy, ux),
        tb = Math.atan2(vy, vx);

    if (tb >= ta) {
      return tb - ta;
    } else {
      return 2 * Math.PI - (ta - tb);
    }
  }
  /**
   * Calculate bounding box of a beziercurve
   * @param {Number} x0 starting point
   * @param {Number} y0
   * @param {Number} x1 first control point
   * @param {Number} y1
   * @param {Number} x2 secondo control point
   * @param {Number} y2
   * @param {Number} x3 end of bezier
   * @param {Number} y3
   */
  // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
  // TODO: can we normalize this with the starting points set at 0 and then translated the bbox?


  function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
    var argsString;

    if (fabric.cachesBoundsOfCurve) {
      argsString = _join.call(arguments);

      if (fabric.boundsOfCurveCache[argsString]) {
        return fabric.boundsOfCurveCache[argsString];
      }
    }

    var sqrt = Math.sqrt,
        min = Math.min,
        max = Math.max,
        abs = Math.abs,
        tvalues = [],
        bounds = [[], []],
        a,
        b,
        c,
        t,
        t1,
        t2,
        b2ac,
        sqrtb2ac;
    b = 6 * x0 - 12 * x1 + 6 * x2;
    a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
    c = 3 * x1 - 3 * x0;

    for (var i = 0; i < 2; ++i) {
      if (i > 0) {
        b = 6 * y0 - 12 * y1 + 6 * y2;
        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
        c = 3 * y1 - 3 * y0;
      }

      if (abs(a) < 1e-12) {
        if (abs(b) < 1e-12) {
          continue;
        }

        t = -c / b;

        if (0 < t && t < 1) {
          tvalues.push(t);
        }

        continue;
      }

      b2ac = b * b - 4 * c * a;

      if (b2ac < 0) {
        continue;
      }

      sqrtb2ac = sqrt(b2ac);
      t1 = (-b + sqrtb2ac) / (2 * a);

      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }

      t2 = (-b - sqrtb2ac) / (2 * a);

      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }

    var x,
        y,
        j = tvalues.length,
        jlen = j,
        mt;

    while (j--) {
      t = tvalues[j];
      mt = 1 - t;
      x = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
      bounds[0][j] = x;
      y = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
      bounds[1][j] = y;
    }

    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    var result = [{
      x: min.apply(null, bounds[0]),
      y: min.apply(null, bounds[1])
    }, {
      x: max.apply(null, bounds[0]),
      y: max.apply(null, bounds[1])
    }];

    if (fabric.cachesBoundsOfCurve) {
      fabric.boundsOfCurveCache[argsString] = result;
    }

    return result;
  }
  /**
   * Converts arc to a bunch of bezier curves
   * @param {Number} fx starting point x
   * @param {Number} fy starting point y
   * @param {Array} coords Arc command
   */


  function fromArcToBeziers(fx, fy, coords) {
    var rx = coords[1],
        ry = coords[2],
        rot = coords[3],
        large = coords[4],
        sweep = coords[5],
        tx = coords[6],
        ty = coords[7],
        segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segsNorm.length; i < len; i++) {
      segsNorm[i][1] += fx;
      segsNorm[i][2] += fy;
      segsNorm[i][3] += fx;
      segsNorm[i][4] += fy;
      segsNorm[i][5] += fx;
      segsNorm[i][6] += fy;
    }

    return segsNorm;
  }

  ;
  /**
   * This function take a parsed SVG path and make it simpler for fabricJS logic.
   * simplification consist of: only UPPERCASE absolute commands ( relative converted to absolute )
   * S converted in C, T converted in Q, A converted in C.
   * @param {Array} path the array of commands of a parsed svg path for fabric.Path
   * @return {Array} the simplified array of commands of a parsed svg path for fabric.Path
   */

  function makePathSimpler(path) {
    // x and y represent the last point of the path. the previous command point.
    // we add them to each relative command to make it an absolute comment.
    // we also swap the v V h H with L, because are easier to transform.
    var x = 0,
        y = 0,
        len = path.length,
        // x1 and y1 represent the last point of the subpath. the subpath is started with
    // m or M command. When a z or Z command is drawn, x and y need to be resetted to
    // the last x1 and y1.
    x1 = 0,
        y1 = 0,
        current,
        i,
        converted,
        // previous will host the letter of the previous command, to handle S and T.
    // controlX and controlY will host the previous reflected control point
    destinationPath = [],
        previous,
        controlX,
        controlY;

    for (i = 0; i < len; ++i) {
      converted = false;
      current = path[i].slice(0);

      switch (current[0]) {
        // first letter
        case 'l':
          // lineto, relative
          current[0] = 'L';
          current[1] += x;
          current[2] += y;
        // falls through

        case 'L':
          x = current[1];
          y = current[2];
          break;

        case 'h':
          // horizontal lineto, relative
          current[1] += x;
        // falls through

        case 'H':
          current[0] = 'L';
          current[2] = y;
          x = current[1];
          break;

        case 'v':
          // vertical lineto, relative
          current[1] += y;
        // falls through

        case 'V':
          current[0] = 'L';
          y = current[1];
          current[1] = x;
          current[2] = y;
          break;

        case 'm':
          // moveTo, relative
          current[0] = 'M';
          current[1] += x;
          current[2] += y;
        // falls through

        case 'M':
          x = current[1];
          y = current[2];
          x1 = current[1];
          y1 = current[2];
          break;

        case 'c':
          // bezierCurveTo, relative
          current[0] = 'C';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
          current[5] += x;
          current[6] += y;
        // falls through

        case 'C':
          controlX = current[3];
          controlY = current[4];
          x = current[5];
          y = current[6];
          break;

        case 's':
          // shorthand cubic bezierCurveTo, relative
          current[0] = 'S';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
        // falls through

        case 'S':
          // would be sScC but since we are swapping sSc for C, we check just that.
          if (previous === 'C') {
            // calculate reflection of previous control points
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          } else {
            // If there is no previous command or if the previous command was not a C, c, S, or s,
            // the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }

          x = current[3];
          y = current[4];
          current[0] = 'C';
          current[5] = current[3];
          current[6] = current[4];
          current[3] = current[1];
          current[4] = current[2];
          current[1] = controlX;
          current[2] = controlY; // current[3] and current[4] are NOW the second control point.
          // we keep it for the next reflection.

          controlX = current[3];
          controlY = current[4];
          break;

        case 'q':
          // quadraticCurveTo, relative
          current[0] = 'Q';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
        // falls through

        case 'Q':
          controlX = current[1];
          controlY = current[2];
          x = current[3];
          y = current[4];
          break;

        case 't':
          // shorthand quadraticCurveTo, relative
          current[0] = 'T';
          current[1] += x;
          current[2] += y;
        // falls through

        case 'T':
          if (previous === 'Q') {
            // calculate reflection of previous control point
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          } else {
            // If there is no previous command or if the previous command was not a Q, q, T or t,
            // assume the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }

          current[0] = 'Q';
          x = current[1];
          y = current[2];
          current[1] = controlX;
          current[2] = controlY;
          current[3] = x;
          current[4] = y;
          break;

        case 'a':
          current[0] = 'A';
          current[6] += x;
          current[7] += y;
        // falls through

        case 'A':
          converted = true;
          destinationPath = destinationPath.concat(fromArcToBeziers(x, y, current));
          x = current[6];
          y = current[7];
          break;

        case 'z':
        case 'Z':
          x = x1;
          y = y1;
          break;

        default:
      }

      if (!converted) {
        destinationPath.push(current);
      }

      previous = current[0];
    }

    return destinationPath;
  }

  ;
  /**
   * Calc length from point x1,y1 to x2,y2
   * @param {Number} x1 starting point x
   * @param {Number} y1 starting point y
   * @param {Number} x2 starting point x
   * @param {Number} y2 starting point y
   * @return {Number} length of segment
   */

  function calcLineLength(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  } // functions for the Cubic beizer
  // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350


  function CB1(t) {
    return t * t * t;
  }

  function CB2(t) {
    return 3 * t * t * (1 - t);
  }

  function CB3(t) {
    return 3 * t * (1 - t) * (1 - t);
  }

  function CB4(t) {
    return (1 - t) * (1 - t) * (1 - t);
  }

  function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
    return function (pct) {
      var c1 = CB1(pct),
          c2 = CB2(pct),
          c3 = CB3(pct),
          c4 = CB4(pct);
      return {
        x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
        y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
      };
    };
  }

  function getTangentCubicIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
    return function (pct) {
      var invT = 1 - pct,
          tangentX = 3 * invT * invT * (p2x - p1x) + 6 * invT * pct * (p3x - p2x) + 3 * pct * pct * (p4x - p3x),
          tangentY = 3 * invT * invT * (p2y - p1y) + 6 * invT * pct * (p3y - p2y) + 3 * pct * pct * (p4y - p3y);
      return Math.atan2(tangentY, tangentX);
    };
  }

  function QB1(t) {
    return t * t;
  }

  function QB2(t) {
    return 2 * t * (1 - t);
  }

  function QB3(t) {
    return (1 - t) * (1 - t);
  }

  function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
    return function (pct) {
      var c1 = QB1(pct),
          c2 = QB2(pct),
          c3 = QB3(pct);
      return {
        x: p3x * c1 + p2x * c2 + p1x * c3,
        y: p3y * c1 + p2y * c2 + p1y * c3
      };
    };
  }

  function getTangentQuadraticIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
    return function (pct) {
      var invT = 1 - pct,
          tangentX = 2 * invT * (p2x - p1x) + 2 * pct * (p3x - p2x),
          tangentY = 2 * invT * (p2y - p1y) + 2 * pct * (p3y - p2y);
      return Math.atan2(tangentY, tangentX);
    };
  } // this will run over a path segment ( a cubic or quadratic segment) and approximate it
  // with 100 segemnts. This will good enough to calculate the length of the curve


  function pathIterator(iterator, x1, y1) {
    var tempP = {
      x: x1,
      y: y1
    },
        p,
        tmpLen = 0,
        perc;

    for (perc = 0.01; perc <= 1; perc += 0.01) {
      p = iterator(perc);
      tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
      tempP = p;
    }

    return tmpLen;
  }
  /**
   * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
   * that correspond to that pixels run over the path.
   * The percentage will be then used to find the correct point on the canvas for the path.
   * @param {Array} segInfo fabricJS collection of information on a parsed path
   * @param {Number} distance from starting point, in pixels.
   * @return {Object} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
   */


  function findPercentageForDistance(segInfo, distance) {
    var perc = 0,
        tmpLen = 0,
        iterator = segInfo.iterator,
        tempP = {
      x: segInfo.x,
      y: segInfo.y
    },
        p,
        nextLen,
        nextStep = 0.01,
        angleFinder = segInfo.angleFinder,
        lastPerc; // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
    // the path

    while (tmpLen < distance && perc <= 1 && nextStep > 0.0001) {
      p = iterator(perc);
      lastPerc = perc;
      nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y); // compare tmpLen each cycle with distance, decide next perc to test.

      if (nextLen + tmpLen > distance) {
        // we discard this step and we make smaller steps.
        nextStep /= 2;
        perc -= nextStep;
      } else {
        tempP = p;
        perc += nextStep;
        tmpLen += nextLen;
      }
    }

    p.angle = angleFinder(lastPerc);
    return p;
  }
  /**
   * Run over a parsed and simplifed path and extrac some informations.
   * informations are length of each command and starting point
   * @param {Array} path fabricJS parsed path commands
   * @return {Array} path commands informations
   */


  function getPathSegmentsInfo(path) {
    var totalLength = 0,
        len = path.length,
        current,
        //x2 and y2 are the coords of segment start
    //x1 and y1 are the coords of the current point
    x1 = 0,
        y1 = 0,
        x2 = 0,
        y2 = 0,
        info = [],
        iterator,
        tempInfo,
        angleFinder;

    for (var i = 0; i < len; i++) {
      current = path[i];
      tempInfo = {
        x: x1,
        y: y1,
        command: current[0]
      };

      switch (current[0]) {
        //first letter
        case 'M':
          tempInfo.length = 0;
          x2 = x1 = current[1];
          y2 = y1 = current[2];
          break;

        case 'L':
          tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
          x1 = current[1];
          y1 = current[2];
          break;

        case 'C':
          iterator = getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
          angleFinder = getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
          tempInfo.iterator = iterator;
          tempInfo.angleFinder = angleFinder;
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[5];
          y1 = current[6];
          break;

        case 'Q':
          iterator = getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
          angleFinder = getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
          tempInfo.iterator = iterator;
          tempInfo.angleFinder = angleFinder;
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[3];
          y1 = current[4];
          break;

        case 'Z':
        case 'z':
          // we add those in order to ease calculations later
          tempInfo.destX = x2;
          tempInfo.destY = y2;
          tempInfo.length = calcLineLength(x1, y1, x2, y2);
          x1 = x2;
          y1 = y2;
          break;
      }

      totalLength += tempInfo.length;
      info.push(tempInfo);
    }

    info.push({
      length: totalLength,
      x: x1,
      y: y1
    });
    return info;
  }

  function getPointOnPath(path, distance, infos) {
    if (!infos) {
      infos = getPathSegmentsInfo(path);
    }

    var i = 0;

    while (distance - infos[i].length > 0 && i < infos.length - 2) {
      distance -= infos[i].length;
      i++;
    } // var distance = infos[infos.length - 1] * perc;


    var segInfo = infos[i],
        segPercent = distance / segInfo.length,
        command = segInfo.command,
        segment = path[i],
        info;

    switch (command) {
      case 'M':
        return {
          x: segInfo.x,
          y: segInfo.y,
          angle: 0
        };

      case 'Z':
      case 'z':
        info = new fabric.Point(segInfo.x, segInfo.y).lerp(new fabric.Point(segInfo.destX, segInfo.destY), segPercent);
        info.angle = Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x);
        return info;

      case 'L':
        info = new fabric.Point(segInfo.x, segInfo.y).lerp(new fabric.Point(segment[1], segment[2]), segPercent);
        info.angle = Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x);
        return info;

      case 'C':
        return findPercentageForDistance(segInfo, distance);

      case 'Q':
        return findPercentageForDistance(segInfo, distance);
    }
  }

  function parsePath(pathString) {
    var result = [],
        coords = [],
        currentPath,
        parsed,
        re = fabric.rePathCommand,
        rNumber = '[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*',
        rNumberCommaWsp = '(' + rNumber + ')' + fabric.commaWsp,
        rFlagCommaWsp = '([01])' + fabric.commaWsp + '?',
        rArcSeq = rNumberCommaWsp + '?' + rNumberCommaWsp + '?' + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp + rNumberCommaWsp + '?(' + rNumber + ')',
        regArcArgumentSequence = new RegExp(rArcSeq, 'g'),
        match,
        coordsStr,
        // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
    path;

    if (!pathString || !pathString.match) {
      return result;
    }

    path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);

    for (var i = 0, coordsParsed, len = path.length; i < len; i++) {
      currentPath = path[i];
      coordsStr = currentPath.slice(1).trim();
      coords.length = 0;
      var command = currentPath.charAt(0);
      coordsParsed = [command];

      if (command.toLowerCase() === 'a') {
        // arcs have special flags that apparently don't require spaces so handle special
        for (var args; args = regArcArgumentSequence.exec(coordsStr);) {
          for (var j = 1; j < args.length; j++) {
            coords.push(args[j]);
          }
        }
      } else {
        while (match = re.exec(coordsStr)) {
          coords.push(match[0]);
        }
      }

      for (var j = 0, jlen = coords.length; j < jlen; j++) {
        parsed = parseFloat(coords[j]);

        if (!isNaN(parsed)) {
          coordsParsed.push(parsed);
        }
      }

      var commandLength = commandLengths[command.toLowerCase()],
          repeatedCommand = repeatedCommands[command] || command;

      if (coordsParsed.length - 1 > commandLength) {
        for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
          result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
          command = repeatedCommand;
        }
      } else {
        result.push(coordsParsed);
      }
    }

    return result;
  }

  ;
  /**
   * Calculate bounding box of a elliptic-arc
   * @deprecated
   * @param {Number} fx start point of arc
   * @param {Number} fy
   * @param {Number} rx horizontal radius
   * @param {Number} ry vertical radius
   * @param {Number} rot angle of horizontal axis
   * @param {Number} large 1 or 0, whatever the arc is the big or the small on the 2 points
   * @param {Number} sweep 1 or 0, 1 clockwise or counterclockwise direction
   * @param {Number} tx end point of arc
   * @param {Number} ty
   */

  function getBoundsOfArc(fx, fy, rx, ry, rot, large, sweep, tx, ty) {
    var fromX = 0,
        fromY = 0,
        bound,
        bounds = [],
        segs = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segs.length; i < len; i++) {
      bound = getBoundsOfCurve(fromX, fromY, segs[i][1], segs[i][2], segs[i][3], segs[i][4], segs[i][5], segs[i][6]);
      bounds.push({
        x: bound[0].x + fx,
        y: bound[0].y + fy
      });
      bounds.push({
        x: bound[1].x + fx,
        y: bound[1].y + fy
      });
      fromX = segs[i][5];
      fromY = segs[i][6];
    }

    return bounds;
  }

  ;
  /**
   * Draws arc
   * @deprecated
   * @param {CanvasRenderingContext2D} ctx
   * @param {Number} fx
   * @param {Number} fy
   * @param {Array} coords coords of the arc, without the front 'A/a'
   */

  function drawArc(ctx, fx, fy, coords) {
    coords = coords.slice(0).unshift('X'); // command A or a does not matter

    var beziers = fromArcToBeziers(fx, fy, coords);
    beziers.forEach(function (bezier) {
      ctx.bezierCurveTo.apply(ctx, bezier.slice(1));
    });
  }

  ;
  fabric.util.parsePath = parsePath;
  fabric.util.makePathSimpler = makePathSimpler;
  fabric.util.getPathSegmentsInfo = getPathSegmentsInfo;
  fabric.util.fromArcToBeziers = fromArcToBeziers;
  /**
   * Typo of `fromArcToBeziers` kept for not breaking the api once corrected.
   * Will be removed in fabric 5.0
   * @deprecated
   */

  fabric.util.fromArcToBeizers = fromArcToBeziers;
  fabric.util.getBoundsOfCurve = getBoundsOfCurve;
  fabric.util.getPointOnPath = getPointOnPath; // kept because we do not want to make breaking changes.
  // but useless and deprecated.

  fabric.util.getBoundsOfArc = getBoundsOfArc;
  fabric.util.drawArc = drawArc;
})();

(function () {
  var slice = Array.prototype.slice;
  /**
   * Invokes method on all items in a given array
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} method Name of a method to invoke
   * @return {Array}
   */

  function invoke(array, method) {
    var args = slice.call(arguments, 2),
        result = [];

    for (var i = 0, len = array.length; i < len; i++) {
      result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
    }

    return result;
  }
  /**
   * Finds maximum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */


  function max(array, byProperty) {
    return find(array, byProperty, function (value1, value2) {
      return value1 >= value2;
    });
  }
  /**
   * Finds minimum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */


  function min(array, byProperty) {
    return find(array, byProperty, function (value1, value2) {
      return value1 < value2;
    });
  }
  /**
   * @private
   */


  function fill(array, value) {
    var k = array.length;

    while (k--) {
      array[k] = value;
    }

    return array;
  }
  /**
   * @private
   */


  function find(array, byProperty, condition) {
    if (!array || array.length === 0) {
      return;
    }

    var i = array.length - 1,
        result = byProperty ? array[i][byProperty] : array[i];

    if (byProperty) {
      while (i--) {
        if (condition(array[i][byProperty], result)) {
          result = array[i][byProperty];
        }
      }
    } else {
      while (i--) {
        if (condition(array[i], result)) {
          result = array[i];
        }
      }
    }

    return result;
  }
  /**
   * @namespace fabric.util.array
   */


  fabric.util.array = {
    fill: fill,
    invoke: invoke,
    min: min,
    max: max
  };
})();

(function () {
  /**
   * Copies all enumerable properties of one js object to another
   * this does not and cannot compete with generic utils.
   * Does not clone or extend fabric.Object subclasses.
   * This is mostly for internal use and has extra handling for fabricJS objects
   * it skips the canvas and group properties in deep cloning.
   * @memberOf fabric.util.object
   * @param {Object} destination Where to copy to
   * @param {Object} source Where to copy from
   * @return {Object}
   */
  function extend(destination, source, deep) {
    // JScript DontEnum bug is not taken care of
    // the deep clone is for internal use, is not meant to avoid
    // javascript traps or cloning html element or self referenced objects.
    if (deep) {
      if (!fabric.isLikelyNode && source instanceof Element) {
        // avoid cloning deep images, canvases,
        destination = source;
      } else if (source instanceof Array) {
        destination = [];

        for (var i = 0, len = source.length; i < len; i++) {
          destination[i] = extend({}, source[i], deep);
        }
      } else if (source && _typeof(source) === 'object') {
        for (var property in source) {
          if (property === 'canvas' || property === 'group') {
            // we do not want to clone this props at all.
            // we want to keep the keys in the copy
            destination[property] = null;
          } else if (source.hasOwnProperty(property)) {
            destination[property] = extend({}, source[property], deep);
          }
        }
      } else {
        // this sounds odd for an extend but is ok for recursive use
        destination = source;
      }
    } else {
      for (var property in source) {
        destination[property] = source[property];
      }
    }

    return destination;
  }
  /**
   * Creates an empty object and copies all enumerable properties of another object to it
   * @memberOf fabric.util.object
   * TODO: this function return an empty object if you try to clone null
   * @param {Object} object Object to clone
   * @return {Object}
   */


  function clone(object, deep) {
    return extend({}, object, deep);
  }
  /** @namespace fabric.util.object */


  fabric.util.object = {
    extend: extend,
    clone: clone
  };
  fabric.util.object.extend(fabric.util, fabric.Observable);
})();

(function () {
  /**
   * Camelizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to camelize
   * @return {String} Camelized version of a string
   */
  function camelize(string) {
    return string.replace(/-+(.)?/g, function (match, character) {
      return character ? character.toUpperCase() : '';
    });
  }
  /**
   * Capitalizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */


  function capitalize(string, firstLetterOnly) {
    return string.charAt(0).toUpperCase() + (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
  }
  /**
   * Escapes XML in a string
   * @memberOf fabric.util.string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */


  function escapeXml(string) {
    return string.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  /**
   * Divide a string in the user perceived single units
   * @memberOf fabric.util.string
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */


  function graphemeSplit(textstring) {
    var i = 0,
        chr,
        graphemes = [];

    for (i = 0, chr; i < textstring.length; i++) {
      if ((chr = getWholeChar(textstring, i)) === false) {
        continue;
      }

      graphemes.push(chr);
    }

    return graphemes;
  } // taken from mdn in the charAt doc page.


  function getWholeChar(str, i) {
    var code = str.charCodeAt(i);

    if (isNaN(code)) {
      return ''; // Position not found
    }

    if (code < 0xD800 || code > 0xDFFF) {
      return str.charAt(i);
    } // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)


    if (0xD800 <= code && code <= 0xDBFF) {
      if (str.length <= i + 1) {
        throw 'High surrogate without following low surrogate';
      }

      var next = str.charCodeAt(i + 1);

      if (0xDC00 > next || next > 0xDFFF) {
        throw 'High surrogate without following low surrogate';
      }

      return str.charAt(i) + str.charAt(i + 1);
    } // Low surrogate (0xDC00 <= code && code <= 0xDFFF)


    if (i === 0) {
      throw 'Low surrogate without preceding high surrogate';
    }

    var prev = str.charCodeAt(i - 1); // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)

    if (0xD800 > prev || prev > 0xDBFF) {
      throw 'Low surrogate without preceding high surrogate';
    } // We can pass over low surrogates now as the second component
    // in a pair which we have already processed


    return false;
  }
  /**
   * String utilities
   * @namespace fabric.util.string
   */


  fabric.util.string = {
    camelize: camelize,
    capitalize: capitalize,
    escapeXml: escapeXml,
    graphemeSplit: graphemeSplit
  };
})();

(function () {
  var slice = Array.prototype.slice,
      emptyFunction = function emptyFunction() {},
      IS_DONTENUM_BUGGY = function () {
    for (var p in {
      toString: 1
    }) {
      if (p === 'toString') {
        return false;
      }
    }

    return true;
  }(),

  /** @ignore */
  addMethods = function addMethods(klass, source, parent) {
    for (var property in source) {
      if (property in klass.prototype && typeof klass.prototype[property] === 'function' && (source[property] + '').indexOf('callSuper') > -1) {
        klass.prototype[property] = function (property) {
          return function () {
            var superclass = this.constructor.superclass;
            this.constructor.superclass = parent;
            var returnValue = source[property].apply(this, arguments);
            this.constructor.superclass = superclass;

            if (property !== 'initialize') {
              return returnValue;
            }
          };
        }(property);
      } else {
        klass.prototype[property] = source[property];
      }

      if (IS_DONTENUM_BUGGY) {
        if (source.toString !== Object.prototype.toString) {
          klass.prototype.toString = source.toString;
        }

        if (source.valueOf !== Object.prototype.valueOf) {
          klass.prototype.valueOf = source.valueOf;
        }
      }
    }
  };

  function Subclass() {}

  function callSuper(methodName) {
    var parentMethod = null,
        _this = this; // climb prototype chain to find method not equal to callee's method


    while (_this.constructor.superclass) {
      var superClassMethod = _this.constructor.superclass.prototype[methodName];

      if (_this[methodName] !== superClassMethod) {
        parentMethod = superClassMethod;
        break;
      } // eslint-disable-next-line


      _this = _this.constructor.superclass.prototype;
    }

    if (!parentMethod) {
      return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
    }

    return arguments.length > 1 ? parentMethod.apply(this, slice.call(arguments, 1)) : parentMethod.call(this);
  }
  /**
   * Helper for creation of "classes".
   * @memberOf fabric.util
   * @param {Function} [parent] optional "Class" to inherit from
   * @param {Object} [properties] Properties shared by all instances of this class
   *                  (be careful modifying objects defined here as this would affect all instances)
   */


  function createClass() {
    var parent = null,
        properties = slice.call(arguments, 0);

    if (typeof properties[0] === 'function') {
      parent = properties.shift();
    }

    function klass() {
      this.initialize.apply(this, arguments);
    }

    klass.superclass = parent;
    klass.subclasses = [];

    if (parent) {
      Subclass.prototype = parent.prototype;
      klass.prototype = new Subclass();
      parent.subclasses.push(klass);
    }

    for (var i = 0, length = properties.length; i < length; i++) {
      addMethods(klass, properties[i], parent);
    }

    if (!klass.prototype.initialize) {
      klass.prototype.initialize = emptyFunction;
    }

    klass.prototype.constructor = klass;
    klass.prototype.callSuper = callSuper;
    return klass;
  }

  fabric.util.createClass = createClass;
})();

(function () {
  // since ie11 can use addEventListener but they do not support options, i need to check
  var couldUseAttachEvent = !!fabric.document.createElement('div').attachEvent,
      touchEvents = ['touchstart', 'touchmove', 'touchend'];
  /**
   * Adds an event listener to an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */

  fabric.util.addListener = function (element, eventName, handler, options) {
    element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };
  /**
   * Removes an event listener from an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */


  fabric.util.removeListener = function (element, eventName, handler, options) {
    element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };

  function getTouchInfo(event) {
    var touchProp = event.changedTouches;

    if (touchProp && touchProp[0]) {
      return touchProp[0];
    }

    return event;
  }

  fabric.util.getPointer = function (event) {
    var element = event.target,
        scroll = fabric.util.getScrollLeftTop(element),
        _evt = getTouchInfo(event);

    return {
      x: _evt.clientX + scroll.left,
      y: _evt.clientY + scroll.top
    };
  };

  fabric.util.isTouchEvent = function (event) {
    return touchEvents.indexOf(event.type) > -1 || event.pointerType === 'touch';
  };
})();

(function () {
  /**
   * Cross-browser wrapper for setting element's style
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {Object} styles
   * @return {HTMLElement} Element that was passed as a first argument
   */
  function setStyle(element, styles) {
    var elementStyle = element.style;

    if (!elementStyle) {
      return element;
    }

    if (typeof styles === 'string') {
      element.style.cssText += ';' + styles;
      return styles.indexOf('opacity') > -1 ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1]) : element;
    }

    for (var property in styles) {
      if (property === 'opacity') {
        setOpacity(element, styles[property]);
      } else {
        var normalizedProperty = property === 'float' || property === 'cssFloat' ? typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat' : property;
        elementStyle[normalizedProperty] = styles[property];
      }
    }

    return element;
  }

  var parseEl = fabric.document.createElement('div'),
      supportsOpacity = typeof parseEl.style.opacity === 'string',
      supportsFilters = typeof parseEl.style.filter === 'string',
      reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,

  /** @ignore */
  setOpacity = function setOpacity(element) {
    return element;
  };

  if (supportsOpacity) {
    /** @ignore */
    setOpacity = function setOpacity(element, value) {
      element.style.opacity = value;
      return element;
    };
  } else if (supportsFilters) {
    /** @ignore */
    setOpacity = function setOpacity(element, value) {
      var es = element.style;

      if (element.currentStyle && !element.currentStyle.hasLayout) {
        es.zoom = 1;
      }

      if (reOpacity.test(es.filter)) {
        value = value >= 0.9999 ? '' : 'alpha(opacity=' + value * 100 + ')';
        es.filter = es.filter.replace(reOpacity, value);
      } else {
        es.filter += ' alpha(opacity=' + value * 100 + ')';
      }

      return element;
    };
  }

  fabric.util.setStyle = setStyle;
})();

(function () {
  var _slice = Array.prototype.slice;
  /**
   * Takes id and returns an element with that id (if one exists in a document)
   * @memberOf fabric.util
   * @param {String|HTMLElement} id
   * @return {HTMLElement|null}
   */

  function getById(id) {
    return typeof id === 'string' ? fabric.document.getElementById(id) : id;
  }

  var sliceCanConvertNodelists,

  /**
   * Converts an array-like object (e.g. arguments or NodeList) to an array
   * @memberOf fabric.util
   * @param {Object} arrayLike
   * @return {Array}
   */
  toArray = function toArray(arrayLike) {
    return _slice.call(arrayLike, 0);
  };

  try {
    sliceCanConvertNodelists = toArray(fabric.document.childNodes) instanceof Array;
  } catch (err) {}

  if (!sliceCanConvertNodelists) {
    toArray = function toArray(arrayLike) {
      var arr = new Array(arrayLike.length),
          i = arrayLike.length;

      while (i--) {
        arr[i] = arrayLike[i];
      }

      return arr;
    };
  }
  /**
   * Creates specified element with specified attributes
   * @memberOf fabric.util
   * @param {String} tagName Type of an element to create
   * @param {Object} [attributes] Attributes to set on an element
   * @return {HTMLElement} Newly created element
   */


  function makeElement(tagName, attributes) {
    var el = fabric.document.createElement(tagName);

    for (var prop in attributes) {
      if (prop === 'class') {
        el.className = attributes[prop];
      } else if (prop === 'for') {
        el.htmlFor = attributes[prop];
      } else {
        el.setAttribute(prop, attributes[prop]);
      }
    }

    return el;
  }
  /**
   * Adds class to an element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to add class to
   * @param {String} className Class to add to an element
   */


  function addClass(element, className) {
    if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) {
      element.className += (element.className ? ' ' : '') + className;
    }
  }
  /**
   * Wraps element with another element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to wrap
   * @param {HTMLElement|String} wrapper Element to wrap with
   * @param {Object} [attributes] Attributes to set on a wrapper
   * @return {HTMLElement} wrapper
   */


  function wrapElement(element, wrapper, attributes) {
    if (typeof wrapper === 'string') {
      wrapper = makeElement(wrapper, attributes);
    }

    if (element.parentNode) {
      element.parentNode.replaceChild(wrapper, element);
    }

    wrapper.appendChild(element);
    return wrapper;
  }
  /**
   * Returns element scroll offsets
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */


  function getScrollLeftTop(element) {
    var left = 0,
        top = 0,
        docElement = fabric.document.documentElement,
        body = fabric.document.body || {
      scrollLeft: 0,
      scrollTop: 0
    }; // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938

    while (element && (element.parentNode || element.host)) {
      // Set element to element parent, or 'host' in case of ShadowDOM
      element = element.parentNode || element.host;

      if (element === fabric.document) {
        left = body.scrollLeft || docElement.scrollLeft || 0;
        top = body.scrollTop || docElement.scrollTop || 0;
      } else {
        left += element.scrollLeft || 0;
        top += element.scrollTop || 0;
      }

      if (element.nodeType === 1 && element.style.position === 'fixed') {
        break;
      }
    }

    return {
      left: left,
      top: top
    };
  }
  /**
   * Returns offset for a given element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */


  function getElementOffset(element) {
    var docElem,
        doc = element && element.ownerDocument,
        box = {
      left: 0,
      top: 0
    },
        offset = {
      left: 0,
      top: 0
    },
        scrollLeftTop,
        offsetAttributes = {
      borderLeftWidth: 'left',
      borderTopWidth: 'top',
      paddingLeft: 'left',
      paddingTop: 'top'
    };

    if (!doc) {
      return offset;
    }

    for (var attr in offsetAttributes) {
      offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
    }

    docElem = doc.documentElement;

    if (typeof element.getBoundingClientRect !== 'undefined') {
      box = element.getBoundingClientRect();
    }

    scrollLeftTop = getScrollLeftTop(element);
    return {
      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
    };
  }
  /**
   * Returns style attribute value of a given element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get style attribute for
   * @param {String} attr Style attribute to get for element
   * @return {String} Style attribute value of the given element.
   */


  var getElementStyle;

  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
    getElementStyle = function getElementStyle(element, attr) {
      var style = fabric.document.defaultView.getComputedStyle(element, null);
      return style ? style[attr] : undefined;
    };
  } else {
    getElementStyle = function getElementStyle(element, attr) {
      var value = element.style[attr];

      if (!value && element.currentStyle) {
        value = element.currentStyle[attr];
      }

      return value;
    };
  }

  (function () {
    var style = fabric.document.documentElement.style,
        selectProp = 'userSelect' in style ? 'userSelect' : 'MozUserSelect' in style ? 'MozUserSelect' : 'WebkitUserSelect' in style ? 'WebkitUserSelect' : 'KhtmlUserSelect' in style ? 'KhtmlUserSelect' : '';
    /**
     * Makes element unselectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make unselectable
     * @return {HTMLElement} Element that was passed in
     */

    function makeElementUnselectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = fabric.util.falseFunction;
      }

      if (selectProp) {
        element.style[selectProp] = 'none';
      } else if (typeof element.unselectable === 'string') {
        element.unselectable = 'on';
      }

      return element;
    }
    /**
     * Makes element selectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make selectable
     * @return {HTMLElement} Element that was passed in
     */


    function makeElementSelectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = null;
      }

      if (selectProp) {
        element.style[selectProp] = '';
      } else if (typeof element.unselectable === 'string') {
        element.unselectable = '';
      }

      return element;
    }

    fabric.util.makeElementUnselectable = makeElementUnselectable;
    fabric.util.makeElementSelectable = makeElementSelectable;
  })();

  function getNodeCanvas(element) {
    var impl = fabric.jsdomImplForWrapper(element);
    return impl._canvas || impl._image;
  }

  ;

  function cleanUpJsdomNode(element) {
    if (!fabric.isLikelyNode) {
      return;
    }

    var impl = fabric.jsdomImplForWrapper(element);

    if (impl) {
      impl._image = null;
      impl._canvas = null; // unsure if necessary

      impl._currentSrc = null;
      impl._attributes = null;
      impl._classList = null;
    }
  }

  function setImageSmoothing(ctx, value) {
    ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
    ctx.imageSmoothingEnabled = value;
  }
  /**
   * setImageSmoothing sets the context imageSmoothingEnabled property.
   * Used by canvas and by ImageObject.
   * @memberOf fabric.util
   * @since 4.0.0
   * @param {HTMLRenderingContext2D} ctx to set on
   * @param {Boolean} value true or false
   */


  fabric.util.setImageSmoothing = setImageSmoothing;
  fabric.util.getById = getById;
  fabric.util.toArray = toArray;
  fabric.util.addClass = addClass;
  fabric.util.makeElement = makeElement;
  fabric.util.wrapElement = wrapElement;
  fabric.util.getScrollLeftTop = getScrollLeftTop;
  fabric.util.getElementOffset = getElementOffset;
  fabric.util.getNodeCanvas = getNodeCanvas;
  fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;
})();

(function () {
  function addParamToUrl(url, param) {
    return url + (/\?/.test(url) ? '&' : '?') + param;
  }

  function emptyFn() {}
  /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @memberOf fabric.util
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {String} [options.method="GET"]
   * @param {String} [options.parameters] parameters to append to url in GET or in body
   * @param {String} [options.body] body to send with POST or PUT request
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */


  function request(url, options) {
    options || (options = {});

    var method = options.method ? options.method.toUpperCase() : 'GET',
        onComplete = options.onComplete || function () {},
        xhr = new fabric.window.XMLHttpRequest(),
        body = options.body || options.parameters;
    /** @ignore */


    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        onComplete(xhr);
        xhr.onreadystatechange = emptyFn;
      }
    };

    if (method === 'GET') {
      body = null;

      if (typeof options.parameters === 'string') {
        url = addParamToUrl(url, options.parameters);
      }
    }

    xhr.open(method, url, true);

    if (method === 'POST' || method === 'PUT') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    xhr.send(body);
    return xhr;
  }

  fabric.util.request = request;
})();
/**
 * Wrapper around `console.log` (when available)
 * @param {*} [values] Values to log
 */


fabric.log = console.log;
/**
 * Wrapper around `console.warn` (when available)
 * @param {*} [values] Values to log as a warning
 */

fabric.warn = console.warn;

(function () {
  function noop() {
    return false;
  }

  function defaultEasing(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }
  /**
   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Number} [options.startValue=0] Starting value
   * @param {Number} [options.endValue=100] Ending value
   * @param {Number} [options.byValue=100] Value to modify the property by
   * @param {Function} [options.easing] Easing function
   * @param {Number} [options.duration=500] Duration of change (in ms)
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */


  function animate(options) {
    requestAnimFrame(function (timestamp) {
      options || (options = {});
      var start = timestamp || +new Date(),
          duration = options.duration || 500,
          finish = start + duration,
          time,
          onChange = options.onChange || noop,
          abort = options.abort || noop,
          onComplete = options.onComplete || noop,
          easing = options.easing || defaultEasing,
          startValue = 'startValue' in options ? options.startValue : 0,
          endValue = 'endValue' in options ? options.endValue : 100,
          byValue = options.byValue || endValue - startValue;
      options.onStart && options.onStart();

      (function tick(ticktime) {
        // TODO: move abort call after calculation
        // and pass (current,valuePerc, timePerc) as arguments
        time = ticktime || +new Date();
        var currentTime = time > finish ? duration : time - start,
            timePerc = currentTime / duration,
            current = easing(currentTime, startValue, byValue, duration),
            valuePerc = Math.abs((current - startValue) / byValue);

        if (abort()) {
          onComplete(endValue, 1, 1);
          return;
        }

        if (time > finish) {
          onChange(endValue, 1, 1);
          onComplete(endValue, 1, 1);
          return;
        } else {
          onChange(current, valuePerc, timePerc);
          requestAnimFrame(tick);
        }
      })(start);
    });
  }

  var _requestAnimFrame = fabric.window.requestAnimationFrame || fabric.window.webkitRequestAnimationFrame || fabric.window.mozRequestAnimationFrame || fabric.window.oRequestAnimationFrame || fabric.window.msRequestAnimationFrame || function (callback) {
    return fabric.window.setTimeout(callback, 1000 / 60);
  };

  var _cancelAnimFrame = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;
  /**
   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
   * @memberOf fabric.util
   * @param {Function} callback Callback to invoke
   * @param {DOMElement} element optional Element to associate with animation
   */


  function requestAnimFrame() {
    return _requestAnimFrame.apply(fabric.window, arguments);
  }

  function cancelAnimFrame() {
    return _cancelAnimFrame.apply(fabric.window, arguments);
  }

  fabric.util.animate = animate;
  fabric.util.requestAnimFrame = requestAnimFrame;
  fabric.util.cancelAnimFrame = cancelAnimFrame;
})();

(function () {
  // Calculate an in-between color. Returns a "rgba()" string.
  // Credit: Edwin Martin <edwin@bitstorm.org>
  //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
  function calculateColor(begin, end, pos) {
    var color = 'rgba(' + parseInt(begin[0] + pos * (end[0] - begin[0]), 10) + ',' + parseInt(begin[1] + pos * (end[1] - begin[1]), 10) + ',' + parseInt(begin[2] + pos * (end[2] - begin[2]), 10);
    color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
    color += ')';
    return color;
  }
  /**
   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {String} fromColor The starting color in hex or rgb(a) format.
   * @param {String} toColor The starting color in hex or rgb(a) format.
   * @param {Number} [duration] Duration of change (in ms).
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */


  function animateColor(fromColor, toColor, duration, options) {
    var startColor = new fabric.Color(fromColor).getSource(),
        endColor = new fabric.Color(toColor).getSource(),
        originalOnComplete = options.onComplete,
        originalOnChange = options.onChange;
    options = options || {};
    fabric.util.animate(fabric.util.object.extend(options, {
      duration: duration || 500,
      startValue: startColor,
      endValue: endColor,
      byValue: endColor,
      easing: function easing(currentTime, startValue, byValue, duration) {
        var posValue = options.colorEasing ? options.colorEasing(currentTime, duration) : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
        return calculateColor(startValue, byValue, posValue);
      },
      // has to take in account for color restoring;
      onComplete: function onComplete(current, valuePerc, timePerc) {
        if (originalOnComplete) {
          return originalOnComplete(calculateColor(endColor, endColor, 0), valuePerc, timePerc);
        }
      },
      onChange: function onChange(current, valuePerc, timePerc) {
        if (originalOnChange) {
          if (Array.isArray(current)) {
            return originalOnChange(calculateColor(current, current, 0), valuePerc, timePerc);
          }

          originalOnChange(current, valuePerc, timePerc);
        }
      }
    }));
  }

  fabric.util.animateColor = animateColor;
})();

(function () {
  function normalize(a, c, p, s) {
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      //handle the 0/0 case:
      if (c === 0 && a === 0) {
        s = p / (2 * Math.PI) * Math.asin(1);
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
    }

    return {
      a: a,
      c: c,
      p: p,
      s: s
    };
  }

  function elastic(opts, t, d) {
    return opts.a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p);
  }
  /**
   * Cubic easing out
   * @memberOf fabric.util.ease
   */


  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }
  /**
   * Cubic easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;

    if (t < 1) {
      return c / 2 * t * t * t + b;
    }

    return c / 2 * ((t -= 2) * t * t + 2) + b;
  }
  /**
   * Quartic easing in
   * @memberOf fabric.util.ease
   */


  function easeInQuart(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  }
  /**
   * Quartic easing out
   * @memberOf fabric.util.ease
   */


  function easeOutQuart(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }
  /**
   * Quartic easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutQuart(t, b, c, d) {
    t /= d / 2;

    if (t < 1) {
      return c / 2 * t * t * t * t + b;
    }

    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  }
  /**
   * Quintic easing in
   * @memberOf fabric.util.ease
   */


  function easeInQuint(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }
  /**
   * Quintic easing out
   * @memberOf fabric.util.ease
   */


  function easeOutQuint(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }
  /**
   * Quintic easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutQuint(t, b, c, d) {
    t /= d / 2;

    if (t < 1) {
      return c / 2 * t * t * t * t * t + b;
    }

    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  }
  /**
   * Sinusoidal easing in
   * @memberOf fabric.util.ease
   */


  function easeInSine(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }
  /**
   * Sinusoidal easing out
   * @memberOf fabric.util.ease
   */


  function easeOutSine(t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  }
  /**
   * Sinusoidal easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutSine(t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  }
  /**
   * Exponential easing in
   * @memberOf fabric.util.ease
   */


  function easeInExpo(t, b, c, d) {
    return t === 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  }
  /**
   * Exponential easing out
   * @memberOf fabric.util.ease
   */


  function easeOutExpo(t, b, c, d) {
    return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  }
  /**
   * Exponential easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutExpo(t, b, c, d) {
    if (t === 0) {
      return b;
    }

    if (t === d) {
      return b + c;
    }

    t /= d / 2;

    if (t < 1) {
      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    }

    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  }
  /**
   * Circular easing in
   * @memberOf fabric.util.ease
   */


  function easeInCirc(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  }
  /**
   * Circular easing out
   * @memberOf fabric.util.ease
   */


  function easeOutCirc(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  }
  /**
   * Circular easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutCirc(t, b, c, d) {
    t /= d / 2;

    if (t < 1) {
      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    }

    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  }
  /**
   * Elastic easing in
   * @memberOf fabric.util.ease
   */


  function easeInElastic(t, b, c, d) {
    var s = 1.70158,
        p = 0,
        a = c;

    if (t === 0) {
      return b;
    }

    t /= d;

    if (t === 1) {
      return b + c;
    }

    if (!p) {
      p = d * 0.3;
    }

    var opts = normalize(a, c, p, s);
    return -elastic(opts, t, d) + b;
  }
  /**
   * Elastic easing out
   * @memberOf fabric.util.ease
   */


  function easeOutElastic(t, b, c, d) {
    var s = 1.70158,
        p = 0,
        a = c;

    if (t === 0) {
      return b;
    }

    t /= d;

    if (t === 1) {
      return b + c;
    }

    if (!p) {
      p = d * 0.3;
    }

    var opts = normalize(a, c, p, s);
    return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) + opts.c + b;
  }
  /**
   * Elastic easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutElastic(t, b, c, d) {
    var s = 1.70158,
        p = 0,
        a = c;

    if (t === 0) {
      return b;
    }

    t /= d / 2;

    if (t === 2) {
      return b + c;
    }

    if (!p) {
      p = d * (0.3 * 1.5);
    }

    var opts = normalize(a, c, p, s);

    if (t < 1) {
      return -0.5 * elastic(opts, t, d) + b;
    }

    return opts.a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) * 0.5 + opts.c + b;
  }
  /**
   * Backwards easing in
   * @memberOf fabric.util.ease
   */


  function easeInBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }

    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  }
  /**
   * Backwards easing out
   * @memberOf fabric.util.ease
   */


  function easeOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }

    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  }
  /**
   * Backwards easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }

    t /= d / 2;

    if (t < 1) {
      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    }

    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  }
  /**
   * Bouncing easing in
   * @memberOf fabric.util.ease
   */


  function easeInBounce(t, b, c, d) {
    return c - easeOutBounce(d - t, 0, c, d) + b;
  }
  /**
   * Bouncing easing out
   * @memberOf fabric.util.ease
   */


  function easeOutBounce(t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
  }
  /**
   * Bouncing easing in and out
   * @memberOf fabric.util.ease
   */


  function easeInOutBounce(t, b, c, d) {
    if (t < d / 2) {
      return easeInBounce(t * 2, 0, c, d) * 0.5 + b;
    }

    return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
  }
  /**
   * Easing functions
   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
   * @namespace fabric.util.ease
   */


  fabric.util.ease = {
    /**
     * Quadratic easing in
     * @memberOf fabric.util.ease
     */
    easeInQuad: function easeInQuad(t, b, c, d) {
      return c * (t /= d) * t + b;
    },

    /**
     * Quadratic easing out
     * @memberOf fabric.util.ease
     */
    easeOutQuad: function easeOutQuad(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },

    /**
     * Quadratic easing in and out
     * @memberOf fabric.util.ease
     */
    easeInOutQuad: function easeInOutQuad(t, b, c, d) {
      t /= d / 2;

      if (t < 1) {
        return c / 2 * t * t + b;
      }

      return -c / 2 * (--t * (t - 2) - 1) + b;
    },

    /**
     * Cubic easing in
     * @memberOf fabric.util.ease
     */
    easeInCubic: function easeInCubic(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },
    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
    easeInSine: easeInSine,
    easeOutSine: easeOutSine,
    easeInOutSine: easeInOutSine,
    easeInExpo: easeInExpo,
    easeOutExpo: easeOutExpo,
    easeInOutExpo: easeInOutExpo,
    easeInCirc: easeInCirc,
    easeOutCirc: easeOutCirc,
    easeInOutCirc: easeInOutCirc,
    easeInElastic: easeInElastic,
    easeOutElastic: easeOutElastic,
    easeInOutElastic: easeInOutElastic,
    easeInBack: easeInBack,
    easeOutBack: easeOutBack,
    easeInOutBack: easeInOutBack,
    easeInBounce: easeInBounce,
    easeOutBounce: easeOutBounce,
    easeInOutBounce: easeInOutBounce
  };
})();

(function (global) {
  'use strict';
  /**
   * @name fabric
   * @namespace
   */

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      parseUnit = fabric.util.parseUnit,
      multiplyTransformMatrices = fabric.util.multiplyTransformMatrices,
      svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line', 'image', 'text'],
      svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
      svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
      svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],
      attributesMap = {
    cx: 'left',
    x: 'left',
    r: 'radius',
    cy: 'top',
    y: 'top',
    display: 'visible',
    visibility: 'visible',
    transform: 'transformMatrix',
    'fill-opacity': 'fillOpacity',
    'fill-rule': 'fillRule',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'letter-spacing': 'charSpacing',
    'paint-order': 'paintFirst',
    'stroke-dasharray': 'strokeDashArray',
    'stroke-dashoffset': 'strokeDashOffset',
    'stroke-linecap': 'strokeLineCap',
    'stroke-linejoin': 'strokeLineJoin',
    'stroke-miterlimit': 'strokeMiterLimit',
    'stroke-opacity': 'strokeOpacity',
    'stroke-width': 'strokeWidth',
    'text-decoration': 'textDecoration',
    'text-anchor': 'textAnchor',
    opacity: 'opacity',
    'clip-path': 'clipPath',
    'clip-rule': 'clipRule',
    'vector-effect': 'strokeUniform',
    'image-rendering': 'imageSmoothing'
  },
      colorAttributes = {
    stroke: 'strokeOpacity',
    fill: 'fillOpacity'
  },
      fSize = 'font-size',
      cPath = 'clip-path';
  fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
  fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
  fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
  fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);
  fabric.cssRules = {};
  fabric.gradientDefs = {};
  fabric.clipPaths = {};

  function normalizeAttr(attr) {
    // transform attribute names
    if (attr in attributesMap) {
      return attributesMap[attr];
    }

    return attr;
  }

  function normalizeValue(attr, value, parentAttributes, fontSize) {
    var isArray = Object.prototype.toString.call(value) === '[object Array]',
        parsed;

    if ((attr === 'fill' || attr === 'stroke') && value === 'none') {
      value = '';
    } else if (attr === 'strokeUniform') {
      return value === 'non-scaling-stroke';
    } else if (attr === 'strokeDashArray') {
      if (value === 'none') {
        value = null;
      } else {
        value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
      }
    } else if (attr === 'transformMatrix') {
      if (parentAttributes && parentAttributes.transformMatrix) {
        value = multiplyTransformMatrices(parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
      } else {
        value = fabric.parseTransformAttribute(value);
      }
    } else if (attr === 'visible') {
      value = value !== 'none' && value !== 'hidden'; // display=none on parent element always takes precedence over child element

      if (parentAttributes && parentAttributes.visible === false) {
        value = false;
      }
    } else if (attr === 'opacity') {
      value = parseFloat(value);

      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
        value *= parentAttributes.opacity;
      }
    } else if (attr === 'textAnchor'
    /* text-anchor */
    ) {
        value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
      } else if (attr === 'charSpacing') {
      // parseUnit returns px and we convert it to em
      parsed = parseUnit(value, fontSize) / fontSize * 1000;
    } else if (attr === 'paintFirst') {
      var fillIndex = value.indexOf('fill');
      var strokeIndex = value.indexOf('stroke');
      var value = 'fill';

      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
        value = 'stroke';
      } else if (fillIndex === -1 && strokeIndex > -1) {
        value = 'stroke';
      }
    } else if (attr === 'href' || attr === 'xlink:href' || attr === 'font') {
      return value;
    } else if (attr === 'imageSmoothing') {
      return value === 'optimizeQuality';
    } else {
      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
    }

    return !isArray && isNaN(parsed) ? value : parsed;
  }
  /**
    * @private
    */


  function getSvgRegex(arr) {
    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
  }
  /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */


  function _setStrokeFillOpacity(attributes) {
    for (var attr in colorAttributes) {
      if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') {
        continue;
      }

      if (typeof attributes[attr] === 'undefined') {
        if (!fabric.Object.prototype[attr]) {
          continue;
        }

        attributes[attr] = fabric.Object.prototype[attr];
      }

      if (attributes[attr].indexOf('url(') === 0) {
        continue;
      }

      var color = new fabric.Color(attributes[attr]);
      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
    }

    return attributes;
  }
  /**
   * @private
   */


  function _getMultipleNodes(doc, nodeNames) {
    var nodeName,
        nodeArray = [],
        nodeList,
        i,
        len;

    for (i = 0, len = nodeNames.length; i < len; i++) {
      nodeName = nodeNames[i];
      nodeList = doc.getElementsByTagName(nodeName);
      nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
    }

    return nodeArray;
  }
  /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {Array} Array of 6 elements representing transformation matrix
   */


  fabric.parseTransformAttribute = function () {
    function rotateMatrix(matrix, args) {
      var cos = fabric.util.cos(args[0]),
          sin = fabric.util.sin(args[0]),
          x = 0,
          y = 0;

      if (args.length === 3) {
        x = args[1];
        y = args[2];
      }

      matrix[0] = cos;
      matrix[1] = sin;
      matrix[2] = -sin;
      matrix[3] = cos;
      matrix[4] = x - (cos * x - sin * y);
      matrix[5] = y - (sin * x + cos * y);
    }

    function scaleMatrix(matrix, args) {
      var multiplierX = args[0],
          multiplierY = args.length === 2 ? args[1] : args[0];
      matrix[0] = multiplierX;
      matrix[3] = multiplierY;
    }

    function skewMatrix(matrix, args, pos) {
      matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
    }

    function translateMatrix(matrix, args) {
      matrix[4] = args[0];

      if (args.length === 2) {
        matrix[5] = args[1];
      }
    } // identity matrix


    var iMatrix = fabric.iMatrix,
        // == begin transform regexp
    number = fabric.reNum,
        commaWsp = fabric.commaWsp,
        skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))',
        skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))',
        rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + '))?\\s*\\))',
        scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + '))?\\s*\\))',
        translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' + commaWsp + '(' + number + '))?\\s*\\))',
        matrix = '(?:(matrix)\\s*\\(\\s*' + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + commaWsp + '(' + number + ')' + '\\s*\\))',
        transform = '(?:' + matrix + '|' + translate + '|' + scale + '|' + rotate + '|' + skewX + '|' + skewY + ')',
        transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')',
        transformList = '^\\s*(?:' + transforms + '?)\\s*$',
        // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
    reTransformList = new RegExp(transformList),
        // == end transform regexp
    reTransform = new RegExp(transform, 'g');
    return function (attributeValue) {
      // start with identity matrix
      var matrix = iMatrix.concat(),
          matrices = []; // return if no argument was given or
      // an argument does not match transform attribute regexp

      if (!attributeValue || attributeValue && !reTransformList.test(attributeValue)) {
        return matrix;
      }

      attributeValue.replace(reTransform, function (match) {
        var m = new RegExp(transform).exec(match).filter(function (match) {
          // match !== '' && match != null
          return !!match;
        }),
            operation = m[1],
            args = m.slice(2).map(parseFloat);

        switch (operation) {
          case 'translate':
            translateMatrix(matrix, args);
            break;

          case 'rotate':
            args[0] = fabric.util.degreesToRadians(args[0]);
            rotateMatrix(matrix, args);
            break;

          case 'scale':
            scaleMatrix(matrix, args);
            break;

          case 'skewX':
            skewMatrix(matrix, args, 2);
            break;

          case 'skewY':
            skewMatrix(matrix, args, 1);
            break;

          case 'matrix':
            matrix = args;
            break;
        } // snapshot current matrix into matrices array


        matrices.push(matrix.concat()); // reset

        matrix = iMatrix.concat();
      });
      var combinedMatrix = matrices[0];

      while (matrices.length > 1) {
        matrices.shift();
        combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
      }

      return combinedMatrix;
    };
  }();
  /**
   * @private
   */


  function parseStyleString(style, oStyle) {
    var attr, value;
    style.replace(/;\s*$/, '').split(';').forEach(function (chunk) {
      var pair = chunk.split(':');
      attr = pair[0].trim().toLowerCase();
      value = pair[1].trim();
      oStyle[attr] = value;
    });
  }
  /**
   * @private
   */


  function parseStyleObject(style, oStyle) {
    var attr, value;

    for (var prop in style) {
      if (typeof style[prop] === 'undefined') {
        continue;
      }

      attr = prop.toLowerCase();
      value = style[prop];
      oStyle[attr] = value;
    }
  }
  /**
   * @private
   */


  function getGlobalStylesForElement(element, svgUid) {
    var styles = {};

    for (var rule in fabric.cssRules[svgUid]) {
      if (elementMatchesRule(element, rule.split(' '))) {
        for (var property in fabric.cssRules[svgUid][rule]) {
          styles[property] = fabric.cssRules[svgUid][rule][property];
        }
      }
    }

    return styles;
  }
  /**
   * @private
   */


  function elementMatchesRule(element, selectors) {
    var firstMatching,
        parentMatching = true; //start from rightmost selector.

    firstMatching = selectorMatches(element, selectors.pop());

    if (firstMatching && selectors.length) {
      parentMatching = doesSomeParentMatch(element, selectors);
    }

    return firstMatching && parentMatching && selectors.length === 0;
  }

  function doesSomeParentMatch(element, selectors) {
    var selector,
        parentMatching = true;

    while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
      if (parentMatching) {
        selector = selectors.pop();
      }

      element = element.parentNode;
      parentMatching = selectorMatches(element, selector);
    }

    return selectors.length === 0;
  }
  /**
   * @private
   */


  function selectorMatches(element, selector) {
    var nodeName = element.nodeName,
        classNames = element.getAttribute('class'),
        id = element.getAttribute('id'),
        matcher,
        i; // i check if a selector matches slicing away part from it.
    // if i get empty string i should match

    matcher = new RegExp('^' + nodeName, 'i');
    selector = selector.replace(matcher, '');

    if (id && selector.length) {
      matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
      selector = selector.replace(matcher, '');
    }

    if (classNames && selector.length) {
      classNames = classNames.split(' ');

      for (i = classNames.length; i--;) {
        matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
        selector = selector.replace(matcher, '');
      }
    }

    return selector.length === 0;
  }
  /**
   * @private
   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
   */


  function elementById(doc, id) {
    var el;
    doc.getElementById && (el = doc.getElementById(id));

    if (el) {
      return el;
    }

    var node,
        i,
        len,
        nodelist = doc.getElementsByTagName('*');

    for (i = 0, len = nodelist.length; i < len; i++) {
      node = nodelist[i];

      if (id === node.getAttribute('id')) {
        return node;
      }
    }
  }
  /**
   * @private
   */


  function parseUseDirectives(doc) {
    var nodelist = _getMultipleNodes(doc, ['use', 'svg:use']),
        i = 0;

    while (nodelist.length && i < nodelist.length) {
      var el = nodelist[i],
          xlink = (el.getAttribute('xlink:href') || el.getAttribute('href')).substr(1),
          x = el.getAttribute('x') || 0,
          y = el.getAttribute('y') || 0,
          el2 = elementById(doc, xlink).cloneNode(true),
          currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')',
          parentNode,
          oldLength = nodelist.length,
          attr,
          j,
          attrs,
          len,
          namespace = fabric.svgNS;
      applyViewboxTransform(el2);

      if (/^svg$/i.test(el2.nodeName)) {
        var el3 = el2.ownerDocument.createElementNS(namespace, 'g');

        for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
          attr = attrs.item(j);
          el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
        } // el2.firstChild != null


        while (el2.firstChild) {
          el3.appendChild(el2.firstChild);
        }

        el2 = el3;
      }

      for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
        attr = attrs.item(j);

        if (attr.nodeName === 'x' || attr.nodeName === 'y' || attr.nodeName === 'xlink:href' || attr.nodeName === 'href') {
          continue;
        }

        if (attr.nodeName === 'transform') {
          currentTrans = attr.nodeValue + ' ' + currentTrans;
        } else {
          el2.setAttribute(attr.nodeName, attr.nodeValue);
        }
      }

      el2.setAttribute('transform', currentTrans);
      el2.setAttribute('instantiated_by_use', '1');
      el2.removeAttribute('id');
      parentNode = el.parentNode;
      parentNode.replaceChild(el2, el); // some browsers do not shorten nodelist after replaceChild (IE8)

      if (nodelist.length === oldLength) {
        i++;
      }
    }
  } // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
  // matches, e.g.: +14.56e-12, etc.


  var reViewBoxAttrValue = new RegExp('^' + '\\s*(' + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*,?' + '\\s*(' + fabric.reNum + '+)\\s*' + '$');
  /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */

  function applyViewboxTransform(element) {
    if (!fabric.svgViewBoxElementsRegEx.test(element.nodeName)) {
      return;
    }

    var viewBoxAttr = element.getAttribute('viewBox'),
        scaleX = 1,
        scaleY = 1,
        minX = 0,
        minY = 0,
        viewBoxWidth,
        viewBoxHeight,
        matrix,
        el,
        widthAttr = element.getAttribute('width'),
        heightAttr = element.getAttribute('height'),
        x = element.getAttribute('x') || 0,
        y = element.getAttribute('y') || 0,
        preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '',
        missingViewBox = !viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue)),
        missingDimAttr = !widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%',
        toBeParsed = missingViewBox && missingDimAttr,
        parsedDim = {},
        translateMatrix = '',
        widthDiff = 0,
        heightDiff = 0;
    parsedDim.width = 0;
    parsedDim.height = 0;
    parsedDim.toBeParsed = toBeParsed;

    if (missingViewBox) {
      if ((x || y) && element.parentNode.nodeName !== '#document') {
        translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
        matrix = (element.getAttribute('transform') || '') + translateMatrix;
        element.setAttribute('transform', matrix);
        element.removeAttribute('x');
        element.removeAttribute('y');
      }
    }

    if (toBeParsed) {
      return parsedDim;
    }

    if (missingViewBox) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr); // set a transform for elements that have x y and are inner(only) SVGs

      return parsedDim;
    }

    minX = -parseFloat(viewBoxAttr[1]);
    minY = -parseFloat(viewBoxAttr[2]);
    viewBoxWidth = parseFloat(viewBoxAttr[3]);
    viewBoxHeight = parseFloat(viewBoxAttr[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;

    if (!missingDimAttr) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      scaleX = parsedDim.width / viewBoxWidth;
      scaleY = parsedDim.height / viewBoxHeight;
    } else {
      parsedDim.width = viewBoxWidth;
      parsedDim.height = viewBoxHeight;
    } // default is to preserve aspect ratio


    preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);

    if (preserveAspectRatio.alignX !== 'none') {
      //translate all container for the effect of Mid, Min, Max
      if (preserveAspectRatio.meetOrSlice === 'meet') {
        scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX; // calculate additional translation to move the viewbox
      }

      if (preserveAspectRatio.meetOrSlice === 'slice') {
        scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY; // calculate additional translation to move the viewbox
      }

      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
      heightDiff = parsedDim.height - viewBoxHeight * scaleX;

      if (preserveAspectRatio.alignX === 'Mid') {
        widthDiff /= 2;
      }

      if (preserveAspectRatio.alignY === 'Mid') {
        heightDiff /= 2;
      }

      if (preserveAspectRatio.alignX === 'Min') {
        widthDiff = 0;
      }

      if (preserveAspectRatio.alignY === 'Min') {
        heightDiff = 0;
      }
    }

    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
      return parsedDim;
    }

    if ((x || y) && element.parentNode.nodeName !== '#document') {
      translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
    }

    matrix = translateMatrix + ' matrix(' + scaleX + ' 0' + ' 0 ' + scaleY + ' ' + (minX * scaleX + widthDiff) + ' ' + (minY * scaleY + heightDiff) + ') '; // seems unused.
    // parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);

    if (element.nodeName === 'svg') {
      el = element.ownerDocument.createElementNS(fabric.svgNS, 'g'); // element.firstChild != null

      while (element.firstChild) {
        el.appendChild(element.firstChild);
      }

      element.appendChild(el);
    } else {
      el = element;
      el.removeAttribute('x');
      el.removeAttribute('y');
      matrix = el.getAttribute('transform') + matrix;
    }

    el.setAttribute('transform', matrix);
    return parsedDim;
  }

  function hasAncestorWithNodeName(element, nodeName) {
    while (element && (element = element.parentNode)) {
      if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', '')) && !element.getAttribute('instantiated_by_use')) {
        return true;
      }
    }

    return false;
  }
  /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {SVGDocument} doc SVG document to parse
   * @param {Function} callback Callback to call when parsing is finished;
   * It's being passed an array of elements (parsed from a document).
   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
   * @param {Object} [parsingOptions] options for parsing document
   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
   */


  fabric.parseSVGDocument = function (doc, callback, reviver, parsingOptions) {
    if (!doc) {
      return;
    }

    parseUseDirectives(doc);
    var svgUid = fabric.Object.__uid++,
        i,
        len,
        options = applyViewboxTransform(doc),
        descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
    options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
    options.svgUid = svgUid;

    if (descendants.length === 0 && fabric.isLikelyNode) {
      // we're likely in node, where "o3-xml" library fails to gEBTN("*")
      // https://github.com/ajaxorg/node-o3-xml/issues/21
      descendants = doc.selectNodes('//*[name(.)!="svg"]');
      var arr = [];

      for (i = 0, len = descendants.length; i < len; i++) {
        arr[i] = descendants[i];
      }

      descendants = arr;
    }

    var elements = descendants.filter(function (el) {
      applyViewboxTransform(el);
      return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) && !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });

    if (!elements || elements && !elements.length) {
      callback && callback([], {});
      return;
    }

    var clipPaths = {};
    descendants.filter(function (el) {
      return el.nodeName.replace('svg:', '') === 'clipPath';
    }).forEach(function (el) {
      var id = el.getAttribute('id');
      clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function (el) {
        return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
      });
    });
    fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
    fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
    fabric.clipPaths[svgUid] = clipPaths; // Precedence of rules:   style > class > attribute

    fabric.parseElements(elements, function (instances, elements) {
      if (callback) {
        callback(instances, options, elements, descendants);
        delete fabric.gradientDefs[svgUid];
        delete fabric.cssRules[svgUid];
        delete fabric.clipPaths[svgUid];
      }
    }, clone(options), reviver, parsingOptions);
  };

  function recursivelyParseGradientsXlink(doc, gradient) {
    var gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'],
        xlinkAttr = 'xlink:href',
        xLink = gradient.getAttribute(xlinkAttr).substr(1),
        referencedGradient = elementById(doc, xLink);

    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
      recursivelyParseGradientsXlink(doc, referencedGradient);
    }

    gradientsAttrs.forEach(function (attr) {
      if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) {
        gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
      }
    });

    if (!gradient.children.length) {
      var referenceClone = referencedGradient.cloneNode(true);

      while (referenceClone.firstChild) {
        gradient.appendChild(referenceClone.firstChild);
      }
    }

    gradient.removeAttribute(xlinkAttr);
  }

  var reFontDeclaration = new RegExp('(normal|italic)?\\s*(normal|small-caps)?\\s*' + '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' + fabric.reNum + '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');
  extend(fabric, {
    /**
     * Parses a short font declaration, building adding its properties to a style object
     * @static
     * @function
     * @memberOf fabric
     * @param {String} value font declaration
     * @param {Object} oStyle definition
     */
    parseFontDeclaration: function parseFontDeclaration(value, oStyle) {
      var match = value.match(reFontDeclaration);

      if (!match) {
        return;
      }

      var fontStyle = match[1],
          // font variant is not used
      // fontVariant = match[2],
      fontWeight = match[3],
          fontSize = match[4],
          lineHeight = match[5],
          fontFamily = match[6];

      if (fontStyle) {
        oStyle.fontStyle = fontStyle;
      }

      if (fontWeight) {
        oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
      }

      if (fontSize) {
        oStyle.fontSize = parseUnit(fontSize);
      }

      if (fontFamily) {
        oStyle.fontFamily = fontFamily;
      }

      if (lineHeight) {
        oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
      }
    },

    /**
     * Parses an SVG document, returning all of the gradient declarations found in it
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
     */
    getGradientDefs: function getGradientDefs(doc) {
      var tagArray = ['linearGradient', 'radialGradient', 'svg:linearGradient', 'svg:radialGradient'],
          elList = _getMultipleNodes(doc, tagArray),
          el,
          j = 0,
          gradientDefs = {};

      j = elList.length;

      while (j--) {
        el = elList[j];

        if (el.getAttribute('xlink:href')) {
          recursivelyParseGradientsXlink(doc, el);
        }

        gradientDefs[el.getAttribute('id')] = el;
      }

      return gradientDefs;
    },

    /**
     * Returns an object of attributes' name/value, given element and an array of attribute names;
     * Parses parent "g" nodes recursively upwards.
     * @static
     * @memberOf fabric
     * @param {DOMElement} element Element to parse
     * @param {Array} attributes Array of attributes to parse
     * @return {Object} object containing parsed attributes' names/values
     */
    parseAttributes: function parseAttributes(element, attributes, svgUid) {
      if (!element) {
        return;
      }

      var value,
          parentAttributes = {},
          fontSize,
          parentFontSize;

      if (typeof svgUid === 'undefined') {
        svgUid = element.getAttribute('svgUid');
      } // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards


      if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
      }

      var ownAttributes = attributes.reduce(function (memo, attr) {
        value = element.getAttribute(attr);

        if (value) {
          // eslint-disable-line
          memo[attr] = value;
        }

        return memo;
      }, {}); // add values parsed from style, which take precedence over attributes
      // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)

      var cssAttrs = extend(getGlobalStylesForElement(element, svgUid), fabric.parseStyleAttribute(element));
      ownAttributes = extend(ownAttributes, cssAttrs);

      if (cssAttrs[cPath]) {
        element.setAttribute(cPath, cssAttrs[cPath]);
      }

      fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;

      if (ownAttributes[fSize]) {
        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
        ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
      }

      var normalizedAttr,
          normalizedValue,
          normalizedStyle = {};

      for (var attr in ownAttributes) {
        normalizedAttr = normalizeAttr(attr);
        normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
        normalizedStyle[normalizedAttr] = normalizedValue;
      }

      if (normalizedStyle && normalizedStyle.font) {
        fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
      }

      var mergedAttrs = extend(parentAttributes, normalizedStyle);
      return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
    },

    /**
     * Transforms an array of svg elements to corresponding fabric.* instances
     * @static
     * @memberOf fabric
     * @param {Array} elements Array of elements to parse
     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
     * @param {Object} [options] Options object
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     */
    parseElements: function parseElements(elements, callback, options, reviver, parsingOptions) {
      new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
    },

    /**
     * Parses "style" attribute, retuning an object with values
     * @static
     * @memberOf fabric
     * @param {SVGElement} element Element to parse
     * @return {Object} Objects with values parsed from style attribute of an element
     */
    parseStyleAttribute: function parseStyleAttribute(element) {
      var oStyle = {},
          style = element.getAttribute('style');

      if (!style) {
        return oStyle;
      }

      if (typeof style === 'string') {
        parseStyleString(style, oStyle);
      } else {
        parseStyleObject(style, oStyle);
      }

      return oStyle;
    },

    /**
     * Parses "points" attribute, returning an array of values
     * @static
     * @memberOf fabric
     * @param {String} points points attribute string
     * @return {Array} array of points
     */
    parsePointsAttribute: function parsePointsAttribute(points) {
      // points attribute is required and must not be empty
      if (!points) {
        return null;
      } // replace commas with whitespace and remove bookending whitespace


      points = points.replace(/,/g, ' ').trim();
      points = points.split(/\s+/);
      var parsedPoints = [],
          i,
          len;

      for (i = 0, len = points.length; i < len; i += 2) {
        parsedPoints.push({
          x: parseFloat(points[i]),
          y: parseFloat(points[i + 1])
        });
      } // odd number of points is an error
      // if (parsedPoints.length % 2 !== 0) {
      //   return null;
      // }


      return parsedPoints;
    },

    /**
     * Returns CSS rules for a given SVG document
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} CSS rules of this document
     */
    getCSSRules: function getCSSRules(doc) {
      var styles = doc.getElementsByTagName('style'),
          i,
          len,
          allRules = {},
          rules; // very crude parsing of style contents

      for (i = 0, len = styles.length; i < len; i++) {
        var styleContents = styles[i].textContent; // remove comments

        styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');

        if (styleContents.trim() === '') {
          continue;
        }

        rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
        rules = rules.map(function (rule) {
          return rule.trim();
        }); // eslint-disable-next-line no-loop-func

        rules.forEach(function (rule) {
          var match = rule.match(/([\s\S]*?)\s*\{([^}]*)\}/),
              ruleObj = {},
              declaration = match[2].trim(),
              propertyValuePairs = declaration.replace(/;$/, '').split(/\s*;\s*/);

          for (i = 0, len = propertyValuePairs.length; i < len; i++) {
            var pair = propertyValuePairs[i].split(/\s*:\s*/),
                property = pair[0],
                value = pair[1];
            ruleObj[property] = value;
          }

          rule = match[1];
          rule.split(',').forEach(function (_rule) {
            _rule = _rule.replace(/^svg/i, '').trim();

            if (_rule === '') {
              return;
            }

            if (allRules[_rule]) {
              fabric.util.object.extend(allRules[_rule], ruleObj);
            } else {
              allRules[_rule] = fabric.util.object.clone(ruleObj);
            }
          });
        });
      }

      return allRules;
    },

    /**
     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
     * @memberOf fabric
     * @param {String} url
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromURL: function loadSVGFromURL(url, callback, reviver, options) {
      url = url.replace(/^\n\s*/, '').trim();
      new fabric.util.request(url, {
        method: 'get',
        onComplete: onComplete
      });

      function onComplete(r) {
        var xml = r.responseXML;

        if (!xml || !xml.documentElement) {
          callback && callback(null);
          return false;
        }

        fabric.parseSVGDocument(xml.documentElement, function (results, _options, elements, allElements) {
          callback && callback(results, _options, elements, allElements);
        }, reviver, options);
      }
    },

    /**
     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
     * @memberOf fabric
     * @param {String} string
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromString: function loadSVGFromString(string, callback, reviver, options) {
      var parser = new fabric.window.DOMParser(),
          doc = parser.parseFromString(string.trim(), 'text/xml');
      fabric.parseSVGDocument(doc.documentElement, function (results, _options, elements, allElements) {
        callback(results, _options, elements, allElements);
      }, reviver, options);
    }
  });
})(typeof exports !== 'undefined' ? exports : void 0);

fabric.ElementsParser = function (elements, callback, options, reviver, parsingOptions, doc) {
  this.elements = elements;
  this.callback = callback;
  this.options = options;
  this.reviver = reviver;
  this.svgUid = options && options.svgUid || 0;
  this.parsingOptions = parsingOptions;
  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
  this.doc = doc;
};

(function (proto) {
  proto.parse = function () {
    this.instances = new Array(this.elements.length);
    this.numElements = this.elements.length;
    this.createObjects();
  };

  proto.createObjects = function () {
    var _this = this;

    this.elements.forEach(function (element, i) {
      element.setAttribute('svgUid', _this.svgUid);

      _this.createObject(element, i);
    });
  };

  proto.findTag = function (el) {
    return fabric[fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
  };

  proto.createObject = function (el, index) {
    var klass = this.findTag(el);

    if (klass && klass.fromElement) {
      try {
        klass.fromElement(el, this.createCallback(index, el), this.options);
      } catch (err) {
        fabric.log(err);
      }
    } else {
      this.checkIfDone();
    }
  };

  proto.createCallback = function (index, el) {
    var _this = this;

    return function (obj) {
      var _options;

      _this.resolveGradient(obj, el, 'fill');

      _this.resolveGradient(obj, el, 'stroke');

      if (obj instanceof fabric.Image && obj._originalElement) {
        _options = obj.parsePreserveAspectRatioAttribute(el);
      }

      obj._removeTransformMatrix(_options);

      _this.resolveClipPath(obj, el);

      _this.reviver && _this.reviver(el, obj);
      _this.instances[index] = obj;

      _this.checkIfDone();
    };
  };

  proto.extractPropertyDefinition = function (obj, property, storage) {
    var value = obj[property],
        regex = this.regexUrl;

    if (!regex.test(value)) {
      return;
    }

    regex.lastIndex = 0;
    var id = regex.exec(value)[1];
    regex.lastIndex = 0;
    return fabric[storage][this.svgUid][id];
  };

  proto.resolveGradient = function (obj, el, property) {
    var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');

    if (gradientDef) {
      var opacityAttr = el.getAttribute(property + '-opacity');
      var gradient = fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
      obj.set(property, gradient);
    }
  };

  proto.createClipPathCallback = function (obj, container) {
    return function (_newObj) {
      _newObj._removeTransformMatrix();

      _newObj.fillRule = _newObj.clipRule;
      container.push(_newObj);
    };
  };

  proto.resolveClipPath = function (obj, usingElement) {
    var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'),
        element,
        klass,
        objTransformInv,
        container,
        gTransform,
        options;

    if (clipPath) {
      container = [];
      objTransformInv = fabric.util.invertTransform(obj.calcTransformMatrix()); // move the clipPath tag as sibling to the real element that is using it

      var clipPathTag = clipPath[0].parentNode;
      var clipPathOwner = usingElement;

      while (clipPathOwner.parentNode && clipPathOwner.getAttribute('clip-path') !== obj.clipPath) {
        clipPathOwner = clipPathOwner.parentNode;
      }

      clipPathOwner.parentNode.appendChild(clipPathTag);

      for (var i = 0; i < clipPath.length; i++) {
        element = clipPath[i];
        klass = this.findTag(element);
        klass.fromElement(element, this.createClipPathCallback(obj, container), this.options);
      }

      if (container.length === 1) {
        clipPath = container[0];
      } else {
        clipPath = new fabric.Group(container);
      }

      gTransform = fabric.util.multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());

      if (clipPath.clipPath) {
        this.resolveClipPath(clipPath, clipPathOwner);
      }

      var options = fabric.util.qrDecompose(gTransform);
      clipPath.flipX = false;
      clipPath.flipY = false;
      clipPath.set('scaleX', options.scaleX);
      clipPath.set('scaleY', options.scaleY);
      clipPath.angle = options.angle;
      clipPath.skewX = options.skewX;
      clipPath.skewY = 0;
      clipPath.setPositionByOrigin({
        x: options.translateX,
        y: options.translateY
      }, 'center', 'center');
      obj.clipPath = clipPath;
    } else {
      // if clip-path does not resolve to any element, delete the property.
      delete obj.clipPath;
    }
  };

  proto.checkIfDone = function () {
    if (--this.numElements === 0) {
      this.instances = this.instances.filter(function (el) {
        // eslint-disable-next-line no-eq-null, eqeqeq
        return el != null;
      });
      this.callback(this.instances, this.elements);
    }
  };
})(fabric.ElementsParser.prototype);

(function (global) {
  'use strict';
  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.Point) {
    fabric.warn('fabric.Point is already defined');
    return;
  }

  fabric.Point = Point;
  /**
   * Point class
   * @class fabric.Point
   * @memberOf fabric
   * @constructor
   * @param {Number} x
   * @param {Number} y
   * @return {fabric.Point} thisArg
   */

  function Point(x, y) {
    this.x = x;
    this.y = y;
  }

  Point.prototype =
  /** @lends fabric.Point.prototype */
  {
    type: 'point',
    constructor: Point,

    /**
     * Adds another point to this one and returns another one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point instance with added values
     */
    add: function add(that) {
      return new Point(this.x + that.x, this.y + that.y);
    },

    /**
     * Adds another point to this one
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    addEquals: function addEquals(that) {
      this.x += that.x;
      this.y += that.y;
      return this;
    },

    /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point} new Point with added value
     */
    scalarAdd: function scalarAdd(scalar) {
      return new Point(this.x + scalar, this.y + scalar);
    },

    /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarAddEquals: function scalarAddEquals(scalar) {
      this.x += scalar;
      this.y += scalar;
      return this;
    },

    /**
     * Subtracts another point from this point and returns a new one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point object with subtracted values
     */
    subtract: function subtract(that) {
      return new Point(this.x - that.x, this.y - that.y);
    },

    /**
     * Subtracts another point from this point
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    subtractEquals: function subtractEquals(that) {
      this.x -= that.x;
      this.y -= that.y;
      return this;
    },

    /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    scalarSubtract: function scalarSubtract(scalar) {
      return new Point(this.x - scalar, this.y - scalar);
    },

    /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarSubtractEquals: function scalarSubtractEquals(scalar) {
      this.x -= scalar;
      this.y -= scalar;
      return this;
    },

    /**
     * Multiplies this point by a value and returns a new one
     * TODO: rename in scalarMultiply in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    multiply: function multiply(scalar) {
      return new Point(this.x * scalar, this.y * scalar);
    },

    /**
     * Multiplies this point by a value
     * TODO: rename in scalarMultiplyEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    multiplyEquals: function multiplyEquals(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    },

    /**
     * Divides this point by a value and returns a new one
     * TODO: rename in scalarDivide in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    divide: function divide(scalar) {
      return new Point(this.x / scalar, this.y / scalar);
    },

    /**
     * Divides this point by a value
     * TODO: rename in scalarDivideEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    divideEquals: function divideEquals(scalar) {
      this.x /= scalar;
      this.y /= scalar;
      return this;
    },

    /**
     * Returns true if this point is equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    eq: function eq(that) {
      return this.x === that.x && this.y === that.y;
    },

    /**
     * Returns true if this point is less than another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lt: function lt(that) {
      return this.x < that.x && this.y < that.y;
    },

    /**
     * Returns true if this point is less than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lte: function lte(that) {
      return this.x <= that.x && this.y <= that.y;
    },

    /**
      * Returns true if this point is greater another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gt: function gt(that) {
      return this.x > that.x && this.y > that.y;
    },

    /**
     * Returns true if this point is greater than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gte: function gte(that) {
      return this.x >= that.x && this.y >= that.y;
    },

    /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {fabric.Point} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {fabric.Point}
     */
    lerp: function lerp(that, t) {
      if (typeof t === 'undefined') {
        t = 0.5;
      }

      t = Math.max(Math.min(1, t), 0);
      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    },

    /**
     * Returns distance from this point and another one
     * @param {fabric.Point} that
     * @return {Number}
     */
    distanceFrom: function distanceFrom(that) {
      var dx = this.x - that.x,
          dy = this.y - that.y;
      return Math.sqrt(dx * dx + dy * dy);
    },

    /**
     * Returns the point between this point and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    midPointFrom: function midPointFrom(that) {
      return this.lerp(that);
    },

    /**
     * Returns a new point which is the min of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    min: function min(that) {
      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
    },

    /**
     * Returns a new point which is the max of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    max: function max(that) {
      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
    },

    /**
     * Returns string representation of this point
     * @return {String}
     */
    toString: function toString() {
      return this.x + ',' + this.y;
    },

    /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */
    setXY: function setXY(x, y) {
      this.x = x;
      this.y = y;
      return this;
    },

    /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */
    setX: function setX(x) {
      this.x = x;
      return this;
    },

    /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */
    setY: function setY(y) {
      this.y = y;
      return this;
    },

    /**
     * Sets x/y of this point from another point
     * @param {fabric.Point} that
     * @chainable
     */
    setFromPoint: function setFromPoint(that) {
      this.x = that.x;
      this.y = that.y;
      return this;
    },

    /**
     * Swaps x/y of this point and another point
     * @param {fabric.Point} that
     */
    swap: function swap(that) {
      var x = this.x,
          y = this.y;
      this.x = that.x;
      this.y = that.y;
      that.x = x;
      that.y = y;
    },

    /**
     * return a cloned instance of the point
     * @return {fabric.Point}
     */
    clone: function clone() {
      return new Point(this.x, this.y);
    }
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';
  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.Intersection) {
    fabric.warn('fabric.Intersection is already defined');
    return;
  }
  /**
   * Intersection class
   * @class fabric.Intersection
   * @memberOf fabric
   * @constructor
   */


  function Intersection(status) {
    this.status = status;
    this.points = [];
  }

  fabric.Intersection = Intersection;
  fabric.Intersection.prototype =
  /** @lends fabric.Intersection.prototype */
  {
    constructor: Intersection,

    /**
     * Appends a point to intersection
     * @param {fabric.Point} point
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoint: function appendPoint(point) {
      this.points.push(point);
      return this;
    },

    /**
     * Appends points to intersection
     * @param {Array} points
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoints: function appendPoints(points) {
      this.points = this.points.concat(points);
      return this;
    }
  };
  /**
   * Checks if one line intersects another
   * TODO: rename in intersectSegmentSegment
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {fabric.Point} b1
   * @param {fabric.Point} b2
   * @return {fabric.Intersection}
   */

  fabric.Intersection.intersectLineLine = function (a1, a2, b1, b2) {
    var result,
        uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
        ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
        uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);

    if (uB !== 0) {
      var ua = uaT / uB,
          ub = ubT / uB;

      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
        result = new Intersection('Intersection');
        result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
      } else {
        result = new Intersection();
      }
    } else {
      if (uaT === 0 || ubT === 0) {
        result = new Intersection('Coincident');
      } else {
        result = new Intersection('Parallel');
      }
    }

    return result;
  };
  /**
   * Checks if line intersects polygon
   * TODO: rename in intersectSegmentPolygon
   * fix detection of coincident
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {Array} points
   * @return {fabric.Intersection}
   */


  fabric.Intersection.intersectLinePolygon = function (a1, a2, points) {
    var result = new Intersection(),
        length = points.length,
        b1,
        b2,
        inter,
        i;

    for (i = 0; i < length; i++) {
      b1 = points[i];
      b2 = points[(i + 1) % length];
      inter = Intersection.intersectLineLine(a1, a2, b1, b2);
      result.appendPoints(inter.points);
    }

    if (result.points.length > 0) {
      result.status = 'Intersection';
    }

    return result;
  };
  /**
   * Checks if polygon intersects another polygon
   * @static
   * @param {Array} points1
   * @param {Array} points2
   * @return {fabric.Intersection}
   */


  fabric.Intersection.intersectPolygonPolygon = function (points1, points2) {
    var result = new Intersection(),
        length = points1.length,
        i;

    for (i = 0; i < length; i++) {
      var a1 = points1[i],
          a2 = points1[(i + 1) % length],
          inter = Intersection.intersectLinePolygon(a1, a2, points2);
      result.appendPoints(inter.points);
    }

    if (result.points.length > 0) {
      result.status = 'Intersection';
    }

    return result;
  };
  /**
   * Checks if polygon intersects rectangle
   * @static
   * @param {Array} points
   * @param {fabric.Point} r1
   * @param {fabric.Point} r2
   * @return {fabric.Intersection}
   */


  fabric.Intersection.intersectPolygonRectangle = function (points, r1, r2) {
    var min = r1.min(r2),
        max = r1.max(r2),
        topRight = new fabric.Point(max.x, min.y),
        bottomLeft = new fabric.Point(min.x, max.y),
        inter1 = Intersection.intersectLinePolygon(min, topRight, points),
        inter2 = Intersection.intersectLinePolygon(topRight, max, points),
        inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points),
        inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points),
        result = new Intersection();
    result.appendPoints(inter1.points);
    result.appendPoints(inter2.points);
    result.appendPoints(inter3.points);
    result.appendPoints(inter4.points);

    if (result.points.length > 0) {
      result.status = 'Intersection';
    }

    return result;
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.Color) {
    fabric.warn('fabric.Color is already defined.');
    return;
  }
  /**
   * Color class
   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
   *
   * @class fabric.Color
   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
   * @return {fabric.Color} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
   */


  function Color(color) {
    if (!color) {
      this.setSource([0, 0, 0, 1]);
    } else {
      this._tryParsingColor(color);
    }
  }

  fabric.Color = Color;
  fabric.Color.prototype =
  /** @lends fabric.Color.prototype */
  {
    /**
     * @private
     * @param {String|Array} color Color value to parse
     */
    _tryParsingColor: function _tryParsingColor(color) {
      var source;

      if (color in Color.colorNameMap) {
        color = Color.colorNameMap[color];
      }

      if (color === 'transparent') {
        source = [255, 255, 255, 0];
      }

      if (!source) {
        source = Color.sourceFromHex(color);
      }

      if (!source) {
        source = Color.sourceFromRgb(color);
      }

      if (!source) {
        source = Color.sourceFromHsl(color);
      }

      if (!source) {
        //if color is not recognize let's make black as canvas does
        source = [0, 0, 0, 1];
      }

      if (source) {
        this.setSource(source);
      }
    },

    /**
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @private
     * @param {Number} r Red color value
     * @param {Number} g Green color value
     * @param {Number} b Blue color value
     * @return {Array} Hsl color
     */
    _rgbToHsl: function _rgbToHsl(r, g, b) {
      r /= 255;
      g /= 255;
      b /= 255;
      var h,
          s,
          l,
          max = fabric.util.array.max([r, g, b]),
          min = fabric.util.array.min([r, g, b]);
      l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
    },

    /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {Array}
     */
    getSource: function getSource() {
      return this._source;
    },

    /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {Array} source
     */
    setSource: function setSource(source) {
      this._source = source;
    },

    /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */
    toRgb: function toRgb() {
      var source = this.getSource();
      return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
    },

    /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */
    toRgba: function toRgba() {
      var source = this.getSource();
      return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
    },

    /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */
    toHsl: function toHsl() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
    },

    /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */
    toHsla: function toHsla() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
    },

    /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */
    toHex: function toHex() {
      var source = this.getSource(),
          r,
          g,
          b;
      r = source[0].toString(16);
      r = r.length === 1 ? '0' + r : r;
      g = source[1].toString(16);
      g = g.length === 1 ? '0' + g : g;
      b = source[2].toString(16);
      b = b.length === 1 ? '0' + b : b;
      return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
    },

    /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */
    toHexa: function toHexa() {
      var source = this.getSource(),
          a;
      a = Math.round(source[3] * 255);
      a = a.toString(16);
      a = a.length === 1 ? '0' + a : a;
      return this.toHex() + a.toUpperCase();
    },

    /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */
    getAlpha: function getAlpha() {
      return this.getSource()[3];
    },

    /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {fabric.Color} thisArg
     */
    setAlpha: function setAlpha(alpha) {
      var source = this.getSource();
      source[3] = alpha;
      this.setSource(source);
      return this;
    },

    /**
     * Transforms color to its grayscale representation
     * @return {fabric.Color} thisArg
     */
    toGrayscale: function toGrayscale() {
      var source = this.getSource(),
          average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10),
          currentAlpha = source[3];
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {fabric.Color} thisArg
     */
    toBlackWhite: function toBlackWhite(threshold) {
      var source = this.getSource(),
          average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0),
          currentAlpha = source[3];
      threshold = threshold || 127;
      average = Number(average) < Number(threshold) ? 0 : 255;
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Overlays color with another color
     * @param {String|fabric.Color} otherColor
     * @return {fabric.Color} thisArg
     */
    overlayWith: function overlayWith(otherColor) {
      if (!(otherColor instanceof Color)) {
        otherColor = new Color(otherColor);
      }

      var result = [],
          alpha = this.getAlpha(),
          otherAlpha = 0.5,
          source = this.getSource(),
          otherSource = otherColor.getSource(),
          i;

      for (i = 0; i < 3; i++) {
        result.push(Math.round(source[i] * (1 - otherAlpha) + otherSource[i] * otherAlpha));
      }

      result[3] = alpha;
      this.setSource(result);
      return this;
    }
  };
  /**
   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * @static
   * @field
   * @memberOf fabric.Color
   */
  // eslint-disable-next-line max-len

  fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
  /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
   * @static
   * @field
   * @memberOf fabric.Color
   */

  fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
  /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   * @static
   * @field
   * @memberOf fabric.Color
   */

  fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
  /**
   * Map of the 148 color names with HEX code
   * @static
   * @field
   * @memberOf fabric.Color
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */

  fabric.Color.colorNameMap = {
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#00FFFF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000000',
    blanchedalmond: '#FFEBCD',
    blue: '#0000FF',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#00FFFF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgrey: '#A9A9A9',
    darkgreen: '#006400',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#FF00FF',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    grey: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgrey: '#D3D3D3',
    lightgreen: '#90EE90',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#00FF00',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#FF00FF',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#FF0000',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFFFFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FFFF00',
    yellowgreen: '#9ACD32'
  };
  /**
   * @private
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */

  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }

    if (t > 1) {
      t -= 1;
    }

    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }

    if (t < 1 / 2) {
      return q;
    }

    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }

    return p;
  }
  /**
   * Returns new color object, when given a color in RGB format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {fabric.Color}
   */


  fabric.Color.fromRgb = function (color) {
    return Color.fromSource(Color.sourceFromRgb(color));
  };
  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {Array} source
   */


  fabric.Color.sourceFromRgb = function (color) {
    var match = color.match(Color.reRGBa);

    if (match) {
      var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1),
          g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1),
          b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);
      return [parseInt(r, 10), parseInt(g, 10), parseInt(b, 10), match[4] ? parseFloat(match[4]) : 1];
    }
  };
  /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */


  fabric.Color.fromRgba = Color.fromRgb;
  /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf fabric.Color
   * @return {fabric.Color}
   */

  fabric.Color.fromHsl = function (color) {
    return Color.fromSource(Color.sourceFromHsl(color));
  };
  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf fabric.Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {Array} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */


  fabric.Color.sourceFromHsl = function (color) {
    var match = color.match(Color.reHSLa);

    if (!match) {
      return;
    }

    var h = (parseFloat(match[1]) % 360 + 360) % 360 / 360,
        s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1),
        l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1),
        r,
        g,
        b;

    if (s === 0) {
      r = g = b = l;
    } else {
      var q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
          p = l * 2 - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), match[4] ? parseFloat(match[4]) : 1];
  };
  /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */


  fabric.Color.fromHsla = Color.fromHsl;
  /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color Color value ex: FF5555
   * @return {fabric.Color}
   */

  fabric.Color.fromHex = function (color) {
    return Color.fromSource(Color.sourceFromHex(color));
  };
  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {Array} source
   */


  fabric.Color.sourceFromHex = function (color) {
    if (color.match(Color.reHex)) {
      var value = color.slice(color.indexOf('#') + 1),
          isShortNotation = value.length === 3 || value.length === 4,
          isRGBa = value.length === 8 || value.length === 4,
          r = isShortNotation ? value.charAt(0) + value.charAt(0) : value.substring(0, 2),
          g = isShortNotation ? value.charAt(1) + value.charAt(1) : value.substring(2, 4),
          b = isShortNotation ? value.charAt(2) + value.charAt(2) : value.substring(4, 6),
          a = isRGBa ? isShortNotation ? value.charAt(3) + value.charAt(3) : value.substring(6, 8) : 'FF';
      return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseFloat((parseInt(a, 16) / 255).toFixed(2))];
    }
  };
  /**
   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
   * @static
   * @memberOf fabric.Color
   * @param {Array} source
   * @return {fabric.Color}
   */


  fabric.Color.fromSource = function (source) {
    var oColor = new Color();
    oColor.setSource(source);
    return oColor;
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      scaleMap = ['e', 'se', 's', 'sw', 'w', 'nw', 'n', 'ne', 'e'],
      skewMap = ['ns', 'nesw', 'ew', 'nwse'],
      controls = {},
      LEFT = 'left',
      TOP = 'top',
      RIGHT = 'right',
      BOTTOM = 'bottom',
      CENTER = 'center',
      opposite = {
    top: BOTTOM,
    bottom: TOP,
    left: RIGHT,
    right: LEFT,
    center: CENTER
  },
      radiansToDegrees = fabric.util.radiansToDegrees,
      sign = Math.sign || function (x) {
    return (x > 0) - (x < 0) || +x;
  };
  /**
   * Combine control position and object angle to find the control direction compared
   * to the object center.
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   * @param {fabric.Control} control the control class
   * @return {Number} 0 - 7 a quadrant number
   */


  function findCornerQuadrant(fabricObject, control) {
    var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
    return Math.round(cornerAngle % 360 / 45);
  }

  function fireEvent(eventName, options) {
    var target = options.transform.target,
        canvas = target.canvas,
        canvasOptions = fabric.util.object.clone(options);
    canvasOptions.target = target;
    canvas && canvas.fire('object:' + eventName, canvasOptions);
    target.fire(eventName, options);
  }
  /**
   * Inspect event and fabricObject properties to understand if the scaling action
   * @param {Event} eventData from the user action
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @return {Boolean} true if scale is proportional
   */


  function scaleIsProportional(eventData, fabricObject) {
    var canvas = fabricObject.canvas,
        uniScaleKey = canvas.uniScaleKey,
        uniformIsToggled = eventData[uniScaleKey];
    return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
  }
  /**
   * Checks if transform is centered
   * @param {Object} transform transform data
   * @return {Boolean} true if transform is centered
   */


  function isTransformCentered(transform) {
    return transform.originX === CENTER && transform.originY === CENTER;
  }
  /**
   * Inspect fabricObject to understand if the current scaling action is allowed
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @param {String} by 'x' or 'y' or ''
   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
   * @return {Boolean} true if scaling is not allowed at current conditions
   */


  function scalingIsForbidden(fabricObject, by, scaleProportionally) {
    var lockX = fabricObject.lockScalingX,
        lockY = fabricObject.lockScalingY;

    if (lockX && lockY) {
      return true;
    }

    if (!by && (lockX || lockY) && scaleProportionally) {
      return true;
    }

    if (lockX && by === 'x') {
      return true;
    }

    if (lockY && by === 'y') {
      return true;
    }

    return false;
  }
  /**
   * return the correct cursor style for the scale action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */


  function scaleCursorStyleHandler(eventData, control, fabricObject) {
    var notAllowed = 'not-allowed',
        scaleProportionally = scaleIsProportional(eventData, fabricObject),
        by = '';

    if (control.x !== 0 && control.y === 0) {
      by = 'x';
    } else if (control.x === 0 && control.y !== 0) {
      by = 'y';
    }

    if (scalingIsForbidden(fabricObject, by, scaleProportionally)) {
      return notAllowed;
    }

    var n = findCornerQuadrant(fabricObject, control);
    return scaleMap[n] + '-resize';
  }
  /**
   * return the correct cursor style for the skew action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */


  function skewCursorStyleHandler(eventData, control, fabricObject) {
    var notAllowed = 'not-allowed';

    if (control.x !== 0 && fabricObject.lockSkewingY) {
      return notAllowed;
    }

    if (control.y !== 0 && fabricObject.lockSkewingX) {
      return notAllowed;
    }

    var n = findCornerQuadrant(fabricObject, control) % 4;
    return skewMap[n] + '-resize';
  }
  /**
   * Combine skew and scale style handlers to cover fabric standard use case
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */


  function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
    if (eventData[fabricObject.canvas.altActionKey]) {
      return controls.skewCursorStyleHandler(eventData, control, fabricObject);
    }

    return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
  }
  /**
   * Inspect event, control and fabricObject to return the correct action name
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} an action name
   */


  function scaleOrSkewActionName(eventData, control, fabricObject) {
    var isAlternative = eventData[fabricObject.canvas.altActionKey];

    if (control.x === 0) {
      // then is scaleY or skewX
      return isAlternative ? 'skewX' : 'scaleY';
    }

    if (control.y === 0) {
      // then is scaleY or skewX
      return isAlternative ? 'skewY' : 'scaleX';
    }
  }
  /**
   * Find the correct style for the control that is used for rotation.
   * this function is very simple and it just take care of not-allowed or standard cursor
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */


  function rotationStyleHandler(eventData, control, fabricObject) {
    if (fabricObject.lockRotation) {
      return 'not-allowed';
    }

    return control.cursorStyle;
  }

  function commonEventInfo(eventData, transform, x, y) {
    return {
      e: eventData,
      transform: transform,
      pointer: {
        x: x,
        y: y
      }
    };
  }
  /**
   * Wrap an action handler with saving/restoring object position on the transform.
   * this is the code that permits to objects to keep their position while transforming.
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */


  function wrapWithFixedAnchor(actionHandler) {
    return function (eventData, transform, x, y) {
      var target = transform.target,
          centerPoint = target.getCenterPoint(),
          constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY),
          actionPerformed = actionHandler(eventData, transform, x, y);
      target.setPositionByOrigin(constraint, transform.originX, transform.originY);
      return actionPerformed;
    };
  }
  /**
   * Transforms a point described by x and y in a distance from the top left corner of the object
   * bounding box.
   * @param {Object} transform
   * @param {String} originX
   * @param {String} originY
   * @param {number} x
   * @param {number} y
   * @return {Fabric.Point} the normalized point
   */


  function getLocalPoint(transform, originX, originY, x, y) {
    var target = transform.target,
        control = target.controls[transform.corner],
        zoom = target.canvas.getZoom(),
        padding = target.padding / zoom,
        localPoint = target.toLocalPoint(new fabric.Point(x, y), originX, originY);

    if (localPoint.x >= padding) {
      localPoint.x -= padding;
    }

    if (localPoint.x <= -padding) {
      localPoint.x += padding;
    }

    if (localPoint.y >= padding) {
      localPoint.y -= padding;
    }

    if (localPoint.y <= padding) {
      localPoint.y += padding;
    }

    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
  }
  /**
   * Detect if the fabric object is flipped on one side.
   * @param {fabric.Object} target
   * @return {Boolean} true if one flip, but not two.
   */


  function targetHasOneFlip(target) {
    return target.flipX !== target.flipY;
  }
  /**
   * Utility function to compensate the scale factor when skew is applied on both axes
   * @private
   */


  function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
    if (target[oppositeSkew] !== 0) {
      var newDim = target._getTransformedDimensions()[axis];

      var newValue = reference / newDim * target[scaleToCompensate];
      target.set(scaleToCompensate, newValue);
    }
  }
  /**
   * Action handler for skewing on the X axis
   * @private
   */


  function skewObjectX(eventData, transform, x, y) {
    var target = transform.target,
        // find how big the object would be, if there was no skewX. takes in account scaling
    dimNoSkew = target._getTransformedDimensions(0, target.skewY),
        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        // the mouse is in the center of the object, and we want it to stay there.
    // so the object will grow twice as much as the mouse.
    // this makes the skew growth to localPoint * 2 - dimNoSkew.
    totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x,
        currentSkew = target.skewX,
        newSkew;

    if (totalSkewSize < 2) {
      // let's make it easy to go back to position 0.
      newSkew = 0;
    } else {
      newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleX, dimNoSkew.y / target.scaleY)); // now we have to find the sign of the skew.
      // it mostly depend on the origin of transformation.

      if (transform.originX === LEFT && transform.originY === BOTTOM) {
        newSkew = -newSkew;
      }

      if (transform.originX === RIGHT && transform.originY === TOP) {
        newSkew = -newSkew;
      }

      if (targetHasOneFlip(target)) {
        newSkew = -newSkew;
      }
    }

    var hasSkewed = currentSkew !== newSkew;

    if (hasSkewed) {
      var dimBeforeSkewing = target._getTransformedDimensions().y;

      target.set('skewX', newSkew);
      compensateScaleForSkew(target, 'skewY', 'scaleY', 'y', dimBeforeSkewing);
      fireEvent('skewing', commonEventInfo(eventData, transform, x, y));
    }

    return hasSkewed;
  }
  /**
   * Action handler for skewing on the Y axis
   * @private
   */


  function skewObjectY(eventData, transform, x, y) {
    var target = transform.target,
        // find how big the object would be, if there was no skewX. takes in account scaling
    dimNoSkew = target._getTransformedDimensions(target.skewX, 0),
        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        // the mouse is in the center of the object, and we want it to stay there.
    // so the object will grow twice as much as the mouse.
    // this makes the skew growth to localPoint * 2 - dimNoSkew.
    totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y,
        currentSkew = target.skewY,
        newSkew;

    if (totalSkewSize < 2) {
      // let's make it easy to go back to position 0.
      newSkew = 0;
    } else {
      newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleY, dimNoSkew.x / target.scaleX)); // now we have to find the sign of the skew.
      // it mostly depend on the origin of transformation.

      if (transform.originX === LEFT && transform.originY === BOTTOM) {
        newSkew = -newSkew;
      }

      if (transform.originX === RIGHT && transform.originY === TOP) {
        newSkew = -newSkew;
      }

      if (targetHasOneFlip(target)) {
        newSkew = -newSkew;
      }
    }

    var hasSkewed = currentSkew !== newSkew;

    if (hasSkewed) {
      var dimBeforeSkewing = target._getTransformedDimensions().x;

      target.set('skewY', newSkew);
      compensateScaleForSkew(target, 'skewX', 'scaleX', 'x', dimBeforeSkewing);
      fireEvent('skewing', commonEventInfo(eventData, transform, x, y));
    }

    return hasSkewed;
  }
  /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function skewHandlerX(eventData, transform, x, y) {
    // step1 figure out and change transform origin.
    // if skewX > 0 and originY bottom we anchor on right
    // if skewX > 0 and originY top we anchor on left
    // if skewX < 0 and originY bottom we anchor on left
    // if skewX < 0 and originY top we anchor on right
    // if skewX is 0, we look for mouse position to understand where are we going.
    var target = transform.target,
        currentSkew = target.skewX,
        originX,
        originY = transform.originY;

    if (target.lockSkewingX) {
      return false;
    }

    if (currentSkew === 0) {
      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);

      if (localPointFromCenter.x > 0) {
        // we are pulling right, anchor left;
        originX = LEFT;
      } else {
        // we are pulling right, anchor right
        originX = RIGHT;
      }
    } else {
      if (currentSkew > 0) {
        originX = originY === TOP ? LEFT : RIGHT;
      }

      if (currentSkew < 0) {
        originX = originY === TOP ? RIGHT : LEFT;
      } // is the object flipped on one side only? swap the origin.


      if (targetHasOneFlip(target)) {
        originX = originX === LEFT ? RIGHT : LEFT;
      }
    } // once we have the origin, we find the anchor point


    transform.originX = originX;
    var finalHandler = wrapWithFixedAnchor(skewObjectX);
    return finalHandler(eventData, transform, x, y);
  }
  /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function skewHandlerY(eventData, transform, x, y) {
    // step1 figure out and change transform origin.
    // if skewY > 0 and originX left we anchor on top
    // if skewY > 0 and originX right we anchor on bottom
    // if skewY < 0 and originX left we anchor on bottom
    // if skewY < 0 and originX right we anchor on top
    // if skewY is 0, we look for mouse position to understand where are we going.
    var target = transform.target,
        currentSkew = target.skewY,
        originY,
        originX = transform.originX;

    if (target.lockSkewingY) {
      return false;
    }

    if (currentSkew === 0) {
      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);

      if (localPointFromCenter.y > 0) {
        // we are pulling down, anchor up;
        originY = TOP;
      } else {
        // we are pulling up, anchor down
        originY = BOTTOM;
      }
    } else {
      if (currentSkew > 0) {
        originY = originX === LEFT ? TOP : BOTTOM;
      }

      if (currentSkew < 0) {
        originY = originX === LEFT ? BOTTOM : TOP;
      } // is the object flipped on one side only? swap the origin.


      if (targetHasOneFlip(target)) {
        originY = originY === TOP ? BOTTOM : TOP;
      }
    } // once we have the origin, we find the anchor point


    transform.originY = originY;
    var finalHandler = wrapWithFixedAnchor(skewObjectY);
    return finalHandler(eventData, transform, x, y);
  }
  /**
   * Action handler for rotation and snapping, without anchor point.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   * @private
   */


  function rotationWithSnapping(eventData, transform, x, y) {
    var t = transform,
        target = t.target,
        pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);

    if (target.lockRotation) {
      return false;
    }

    var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x),
        curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x),
        angle = radiansToDegrees(curAngle - lastAngle + t.theta),
        hasRotated = true;

    if (target.snapAngle > 0) {
      var snapAngle = target.snapAngle,
          snapThreshold = target.snapThreshold || snapAngle,
          rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
          leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;

      if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
        angle = leftAngleLocked;
      } else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
        angle = rightAngleLocked;
      }
    } // normalize angle to positive value


    if (angle < 0) {
      angle = 360 + angle;
    }

    angle %= 360;
    hasRotated = target.angle !== angle;
    target.angle = angle;

    if (hasRotated) {
      fireEvent('rotating', commonEventInfo(eventData, transform, x, y));
    }

    return hasRotated;
  }
  /**
   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @param {Object} options additional information for scaling
   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
   * @return {Boolean} true if some change happened
   * @private
   */


  function scaleObject(eventData, transform, x, y, options) {
    options = options || {};
    var target = transform.target,
        lockScalingX = target.lockScalingX,
        lockScalingY = target.lockScalingY,
        by = options.by,
        newPoint,
        scaleX,
        scaleY,
        dim,
        scaleProportionally = scaleIsProportional(eventData, target),
        forbidScaling = scalingIsForbidden(target, by, scaleProportionally),
        signX,
        signY,
        gestureScale = transform.gestureScale;

    if (forbidScaling) {
      return false;
    }

    if (gestureScale) {
      scaleX = transform.scaleX * gestureScale;
      scaleY = transform.scaleY * gestureScale;
    } else {
      newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y); // use of sign: We use sign to detect change of direction of an action. sign usually change when
      // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
      // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
      // cross many time the origin point and flip the object. so we need a way to filter out the noise.
      // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.

      signX = by !== 'y' ? sign(newPoint.x) : 1;
      signY = by !== 'x' ? sign(newPoint.y) : 1;

      if (!transform.signX) {
        transform.signX = signX;
      }

      if (!transform.signY) {
        transform.signY = signY;
      }

      if (target.lockScalingFlip && (transform.signX !== signX || transform.signY !== signY)) {
        return false;
      }

      dim = target._getTransformedDimensions(); // missing detection of flip and logic to switch the origin

      if (scaleProportionally && !by) {
        // uniform scaling
        var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y),
            original = transform.original,
            originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY),
            scale = distance / originalDistance,
            hasScaled;
        scaleX = original.scaleX * scale;
        scaleY = original.scaleY * scale;
      } else {
        scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
        scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
      } // if we are scaling by center, we need to double the scale


      if (isTransformCentered(transform)) {
        scaleX *= 2;
        scaleY *= 2;
      }

      if (transform.signX !== signX && by !== 'y') {
        transform.originX = opposite[transform.originX];
        scaleX *= -1;
        transform.signX = signX;
      }

      if (transform.signY !== signY && by !== 'x') {
        transform.originY = opposite[transform.originY];
        scaleY *= -1;
        transform.signY = signY;
      }
    } // minScale is taken are in the setter.


    var oldScaleX = target.scaleX,
        oldScaleY = target.scaleY;

    if (!by) {
      !lockScalingX && target.set('scaleX', scaleX);
      !lockScalingY && target.set('scaleY', scaleY);
    } else {
      // forbidden cases already handled on top here.
      by === 'x' && target.set('scaleX', scaleX);
      by === 'y' && target.set('scaleY', scaleY);
    }

    hasScaled = oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;

    if (hasScaled) {
      fireEvent('scaling', commonEventInfo(eventData, transform, x, y));
    }

    return hasScaled;
  }
  /**
   * Generic scaling logic, to scale from corners either equally or freely.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function scaleObjectFromCorner(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y);
  }
  /**
   * Scaling logic for the X axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function scaleObjectX(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y, {
      by: 'x'
    });
  }
  /**
   * Scaling logic for the Y axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function scaleObjectY(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y, {
      by: 'y'
    });
  }
  /**
   * Composed action handler to either scale Y or skew X
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function scalingYOrSkewingX(eventData, transform, x, y) {
    // ok some safety needed here.
    if (eventData[transform.target.canvas.altActionKey]) {
      return controls.skewHandlerX(eventData, transform, x, y);
    }

    return controls.scalingY(eventData, transform, x, y);
  }
  /**
   * Composed action handler to either scale X or skew Y
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function scalingXOrSkewingY(eventData, transform, x, y) {
    // ok some safety needed here.
    if (eventData[transform.target.canvas.altActionKey]) {
      return controls.skewHandlerY(eventData, transform, x, y);
    }

    return controls.scalingX(eventData, transform, x, y);
  }
  /**
   * Action handler to change textbox width
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */


  function changeWidth(eventData, transform, x, y) {
    var target = transform.target,
        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1),
        multiplier = isTransformCentered(transform) ? 2 : 1,
        oldWidth = target.width,
        hasResized,
        newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
    target.set('width', Math.max(newWidth, 0));
    hasResized = oldWidth !== newWidth;

    if (hasResized) {
      fireEvent('resizing', commonEventInfo(eventData, transform, x, y));
    }

    return hasResized;
  }
  /**
   * Action handler
   * @private
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if the translation occurred
   */


  function dragHandler(eventData, transform, x, y) {
    var target = transform.target,
        newLeft = x - transform.offsetX,
        newTop = y - transform.offsetY,
        moveX = !target.get('lockMovementX') && target.left !== newLeft,
        moveY = !target.get('lockMovementY') && target.top !== newTop;
    moveX && target.set('left', newLeft);
    moveY && target.set('top', newTop);

    if (moveX || moveY) {
      fireEvent('moving', commonEventInfo(eventData, transform, x, y));
    }

    return moveX || moveY;
  }

  controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
  controls.skewCursorStyleHandler = skewCursorStyleHandler;
  controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
  controls.rotationWithSnapping = wrapWithFixedAnchor(rotationWithSnapping);
  controls.scalingEqually = wrapWithFixedAnchor(scaleObjectFromCorner);
  controls.scalingX = wrapWithFixedAnchor(scaleObjectX);
  controls.scalingY = wrapWithFixedAnchor(scaleObjectY);
  controls.scalingYOrSkewingX = scalingYOrSkewingX;
  controls.scalingXOrSkewingY = scalingXOrSkewingY;
  controls.changeWidth = wrapWithFixedAnchor(changeWidth);
  controls.skewHandlerX = skewHandlerX;
  controls.skewHandlerY = skewHandlerY;
  controls.dragHandler = dragHandler;
  controls.scaleOrSkewActionName = scaleOrSkewActionName;
  controls.rotationStyleHandler = rotationStyleHandler;
  controls.fireEvent = fireEvent;
  controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
  controls.getLocalPoint = getLocalPoint;
  fabric.controlsUtils = controls;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      degreesToRadians = fabric.util.degreesToRadians,
      controls = fabric.controlsUtils;
  /**
   * Render a round control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */

  function renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
        ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : this.transparentCorners,
        methodName = transparentCorners ? 'stroke' : 'fill',
        stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor),
        myLeft = left,
        myTop = top,
        size;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor; // as soon as fabric react v5, remove ie11, use proper ellipse code.

    if (xSize > ySize) {
      size = xSize;
      ctx.scale(1.0, ySize / xSize);
      myTop = top * xSize / ySize;
    } else if (ySize > xSize) {
      size = ySize;
      ctx.scale(xSize / ySize, 1.0);
      myLeft = left * ySize / xSize;
    } else {
      size = xSize;
    } // this is still wrong


    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
    ctx[methodName]();

    if (stroke) {
      ctx.stroke();
    }

    ctx.restore();
  }
  /**
   * Render a square control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */


  function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
        ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners,
        methodName = transparentCorners ? 'stroke' : 'fill',
        stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor),
        xSizeBy2 = xSize / 2,
        ySizeBy2 = ySize / 2;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
    ctx.strokeStyle = styleOverride.strokeCornerColor || fabricObject.strokeCornerColor; // this is still wrong

    ctx.lineWidth = 1;
    ctx.translate(left, top);
    ctx.rotate(degreesToRadians(fabricObject.angle)); // this does not work, and fixed with ( && ) does not make sense.
    // to have real transparent corners we need the controls on upperCanvas
    // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);

    ctx[methodName + 'Rect'](-xSizeBy2, -ySizeBy2, xSize, ySize);

    if (stroke) {
      ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    }

    ctx.restore();
  }

  controls.renderCircleControl = renderCircleControl;
  controls.renderSquareControl = renderSquareControl;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  function Control(options) {
    for (var i in options) {
      this[i] = options[i];
    }
  }

  fabric.Control = Control;
  fabric.Control.prototype =
  /** @lends fabric.Control.prototype */
  {
    /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the controlset.
     * @type {Boolean}
     * @default true
     */
    visible: true,

    /**
     * Name of the action that the control will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */
    actionName: 'scale',

    /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */
    angle: 0,

    /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    x: 0,

    /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    y: 0,

    /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundindbox, with an offset of 30 pixels vertically. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    offsetX: 0,

    /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */
    offsetY: 0,

    /**
     * Sets the length of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */
    sizeX: null,

    /**
     * Sets the height of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */
    sizeY: null,

    /**
     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */
    touchSizeX: null,

    /**
     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */
    touchSizeY: null,

    /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */
    cursorStyle: 'crosshair',

    /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */
    withConnection: false,

    /**
     * The control actionHandler, provide one to handle action ( control being moved )
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */
    actionHandler: function actionHandler()
    /* eventData, transformData, x, y */
    {},

    /**
     * The control handler for mouse down, provide one to handle mouse down on control
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */
    mouseDownHandler: function mouseDownHandler()
    /* eventData, transformData, x, y */
    {},

    /**
     * The control mouseUpHandler, provide one to handle an effect on mouse up.
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */
    mouseUpHandler: function mouseUpHandler()
    /* eventData, transformData, x, y */
    {},

    /**
     * Returns control actionHandler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getActionHandler: function getActionHandler()
    /* eventData, fabricObject, control */
    {
      return this.actionHandler;
    },

    /**
     * Returns control mouseDown handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getMouseDownHandler: function getMouseDownHandler()
    /* eventData, fabricObject, control */
    {
      return this.mouseDownHandler;
    },

    /**
     * Returns control mouseUp handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getMouseUpHandler: function getMouseUpHandler()
    /* eventData, fabricObject, control */
    {
      return this.mouseUpHandler;
    },

    /**
     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
     * function you can pass one in the constructor
     * the cursorStyle property
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */
    cursorStyleHandler: function cursorStyleHandler(eventData, control
    /* fabricObject */
    ) {
      return control.cursorStyle;
    },

    /**
     * Returns the action name. The basic implementation just return the actionName property.
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */
    getActionName: function getActionName(eventData, control
    /* fabricObject */
    ) {
      return control.actionName;
    },

    /**
     * Returns controls visibility
     * @param {fabric.Object} object on which the control is displayed
     * @param {String} controlKey key where the control is memorized on the
     * @return {Boolean}
     */
    getVisibility: function getVisibility(fabricObject, controlKey) {
      var objectVisibility = fabricObject._controlsVisibility;

      if (objectVisibility && typeof objectVisibility[controlKey] !== 'undefined') {
        return objectVisibility[controlKey];
      }

      return this.visible;
    },

    /**
     * Sets controls visibility
     * @param {Boolean} visibility for the object
     * @return {Void}
     */
    setVisibility: function setVisibility(visibility
    /* name, fabricObject */
    ) {
      this.visible = visibility;
    },
    positionHandler: function positionHandler(dim, finalMatrix
    /*, fabricObject, currentControl */
    ) {
      var point = fabric.util.transformPoint({
        x: this.x * dim.x + this.offsetX,
        y: this.y * dim.y + this.offsetY
      }, finalMatrix);
      return point;
    },

    /**
     * Returns the coords for this control based on object values.
     * @param {Number} objectAngle angle from the fabric object holding the control
     * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
     *   isTouch is true)
     * @param {Number} centerX x coordinate where the control center should be
     * @param {Number} centerY y coordinate where the control center should be
     * @param {boolean} isTouch true if touch corner, false if normal corner
     */
    calcCornerCoords: function calcCornerCoords(objectAngle, objectCornerSize, centerX, centerY, isTouch) {
      var cosHalfOffset,
          sinHalfOffset,
          cosHalfOffsetComp,
          sinHalfOffsetComp,
          xSize = isTouch ? this.touchSizeX : this.sizeX,
          ySize = isTouch ? this.touchSizeY : this.sizeY;

      if (xSize && ySize && xSize !== ySize) {
        // handle rectangular corners
        var controlTriangleAngle = Math.atan2(ySize, xSize);
        var cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2;
        var newTheta = controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
        var newThetaComp = Math.PI / 2 - controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
        cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta);
        sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta); // use complementary angle for two corners

        cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newThetaComp);
        sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newThetaComp);
      } else {
        // handle square corners
        // use default object corner size unless size is defined
        var cornerSize = xSize && ySize ? xSize : objectCornerSize;
        /* 0.7071067812 stands for sqrt(2)/2 */

        cornerHypotenuse = cornerSize * 0.7071067812; // complementary angles are equal since they're both 45 degrees

        var newTheta = fabric.util.degreesToRadians(45 - objectAngle);
        cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newTheta);
        sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newTheta);
      }

      return {
        tl: {
          x: centerX - sinHalfOffsetComp,
          y: centerY - cosHalfOffsetComp
        },
        tr: {
          x: centerX + cosHalfOffset,
          y: centerY - sinHalfOffset
        },
        bl: {
          x: centerX - cosHalfOffset,
          y: centerY + sinHalfOffset
        },
        br: {
          x: centerX + sinHalfOffsetComp,
          y: centerY + cosHalfOffsetComp
        }
      };
    },

    /**
    * Render function for the control.
    * When this function runs the context is unscaled. unrotate. Just retina scaled.
    * all the functions will have to translate to the point left,top before starting Drawing
    * if they want to draw a control where the position is detected.
    * left and top are the result of the positionHandler function
    * @param {RenderingContext2D} ctx the context where the control will be drawn
    * @param {Number} left position of the canvas where we are about to render the control.
    * @param {Number} top position of the canvas where we are about to render the control.
    * @param {Object} styleOverride
    * @param {fabric.Object} fabricObject the object where the control is about to be rendered
    */
    render: function render(ctx, left, top, styleOverride, fabricObject) {
      styleOverride = styleOverride || {};

      switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
        case 'circle':
          fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
          break;

        default:
          fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
      }
    }
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  /* _FROM_SVG_START_ */
  function getColorStop(el, multiplier) {
    var style = el.getAttribute('style'),
        offset = el.getAttribute('offset') || 0,
        color,
        colorAlpha,
        opacity,
        i; // convert percents to absolute values

    offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
    offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;

    if (style) {
      var keyValuePairs = style.split(/\s*;\s*/);

      if (keyValuePairs[keyValuePairs.length - 1] === '') {
        keyValuePairs.pop();
      }

      for (i = keyValuePairs.length; i--;) {
        var split = keyValuePairs[i].split(/\s*:\s*/),
            key = split[0].trim(),
            value = split[1].trim();

        if (key === 'stop-color') {
          color = value;
        } else if (key === 'stop-opacity') {
          opacity = value;
        }
      }
    }

    if (!color) {
      color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
    }

    if (!opacity) {
      opacity = el.getAttribute('stop-opacity');
    }

    color = new fabric.Color(color);
    colorAlpha = color.getAlpha();
    opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
    opacity *= colorAlpha * multiplier;
    return {
      offset: offset,
      color: color.toRgb(),
      opacity: opacity
    };
  }

  function getLinearCoords(el) {
    return {
      x1: el.getAttribute('x1') || 0,
      y1: el.getAttribute('y1') || 0,
      x2: el.getAttribute('x2') || '100%',
      y2: el.getAttribute('y2') || 0
    };
  }

  function getRadialCoords(el) {
    return {
      x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
      y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
      r1: 0,
      x2: el.getAttribute('cx') || '50%',
      y2: el.getAttribute('cy') || '50%',
      r2: el.getAttribute('r') || '50%'
    };
  }
  /* _FROM_SVG_END_ */


  var clone = fabric.util.object.clone;
  /**
   * Gradient class
   * @class fabric.Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   * @see {@link fabric.Gradient#initialize} for constructor definition
   */

  fabric.Gradient = fabric.util.createClass(
  /** @lends fabric.Gradient.prototype */
  {
    /**
     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetX: 0,

    /**
     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetY: 0,

    /**
     * A transform matrix to apply to the gradient before painting.
     * Imported from svg gradients, is not applied with the current transform in the center.
     * Before this transform is applied, the origin point is at the top left corner of the object
     * plus the addition of offsetY and offsetX.
     * @type Number[]
     * @default null
     */
    gradientTransform: null,

    /**
     * coordinates units for coords.
     * If `pixels`, the number of coords are in the same unit of width / height.
     * If set as `percentage` the coords are still a number, but 1 means 100% of width
     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
     * allowed values pixels or percentage.
     * @type String
     * @default 'pixels'
     */
    gradientUnits: 'pixels',

    /**
     * Gradient type linear or radial
     * @type String
     * @default 'pixels'
     */
    type: 'linear',

    /**
     * Constructor
     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
     * @param {Object} [options.type] gradient type linear or radial
     * @param {Object} [options.gradientUnits] gradient units
     * @param {Object} [options.offsetX] SVG import compatibility
     * @param {Object} [options.offsetY] SVG import compatibility
     * @param {Object[]} options.colorStops contains the colorstops.
     * @param {Object} options.coords contains the coords of the gradient
     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
     * @return {fabric.Gradient} thisArg
     */
    initialize: function initialize(options) {
      options || (options = {});
      options.coords || (options.coords = {});

      var coords,
          _this = this; // sets everything, then coords and colorstops get sets again


      Object.keys(options).forEach(function (option) {
        _this[option] = options[option];
      });

      if (this.id) {
        this.id += '_' + fabric.Object.__uid++;
      } else {
        this.id = fabric.Object.__uid++;
      }

      coords = {
        x1: options.coords.x1 || 0,
        y1: options.coords.y1 || 0,
        x2: options.coords.x2 || 0,
        y2: options.coords.y2 || 0
      };

      if (this.type === 'radial') {
        coords.r1 = options.coords.r1 || 0;
        coords.r2 = options.coords.r2 || 0;
      }

      this.coords = coords;
      this.colorStops = options.colorStops.slice();
    },

    /**
     * Adds another colorStop
     * @param {Object} colorStop Object with offset and color
     * @return {fabric.Gradient} thisArg
     */
    addColorStop: function addColorStop(colorStops) {
      for (var position in colorStops) {
        var color = new fabric.Color(colorStops[position]);
        this.colorStops.push({
          offset: parseFloat(position),
          color: color.toRgb(),
          opacity: color.getAlpha()
        });
      }

      return this;
    },

    /**
     * Returns object representation of a gradient
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object}
     */
    toObject: function toObject(propertiesToInclude) {
      var object = {
        type: this.type,
        coords: this.coords,
        colorStops: this.colorStops,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        gradientUnits: this.gradientUnits,
        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);
      return object;
    },

    /* _TO_SVG_START_ */

    /**
     * Returns SVG representation of an gradient
     * @param {Object} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */
    toSVG: function toSVG(object, options) {
      var coords = clone(this.coords, true),
          i,
          len,
          options = options || {},
          markup,
          commonAttributes,
          colorStops = clone(this.colorStops, true),
          needsSwap = coords.r1 > coords.r2,
          transform = this.gradientTransform ? this.gradientTransform.concat() : fabric.iMatrix.concat(),
          offsetX = -this.offsetX,
          offsetY = -this.offsetY,
          withViewport = !!options.additionalTransform,
          gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox'; // colorStops must be sorted ascending

      colorStops.sort(function (a, b) {
        return a.offset - b.offset;
      });

      if (gradientUnits === 'objectBoundingBox') {
        offsetX /= object.width;
        offsetY /= object.height;
      } else {
        offsetX += object.width / 2;
        offsetY += object.height / 2;
      }

      if (object.type === 'path' && this.gradientUnits !== 'percentage') {
        offsetX -= object.pathOffset.x;
        offsetY -= object.pathOffset.y;
      }

      transform[4] -= offsetX;
      transform[5] -= offsetY;
      commonAttributes = 'id="SVGID_' + this.id + '" gradientUnits="' + gradientUnits + '"';
      commonAttributes += ' gradientTransform="' + (withViewport ? options.additionalTransform + ' ' : '') + fabric.util.matrixToSVG(transform) + '" ';

      if (this.type === 'linear') {
        markup = ['<linearGradient ', commonAttributes, ' x1="', coords.x1, '" y1="', coords.y1, '" x2="', coords.x2, '" y2="', coords.y2, '">\n'];
      } else if (this.type === 'radial') {
        // svg radial gradient has just 1 radius. the biggest.
        markup = ['<radialGradient ', commonAttributes, ' cx="', needsSwap ? coords.x1 : coords.x2, '" cy="', needsSwap ? coords.y1 : coords.y2, '" r="', needsSwap ? coords.r1 : coords.r2, '" fx="', needsSwap ? coords.x2 : coords.x1, '" fy="', needsSwap ? coords.y2 : coords.y1, '">\n'];
      }

      if (this.type === 'radial') {
        if (needsSwap) {
          // svg goes from internal to external radius. if radius are inverted, swap color stops.
          colorStops = colorStops.concat();
          colorStops.reverse();

          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset = 1 - colorStops[i].offset;
          }
        }

        var minRadius = Math.min(coords.r1, coords.r2);

        if (minRadius > 0) {
          // i have to shift all colorStops and add new one in 0.
          var maxRadius = Math.max(coords.r1, coords.r2),
              percentageShift = minRadius / maxRadius;

          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
          }
        }
      }

      for (i = 0, len = colorStops.length; i < len; i++) {
        var colorStop = colorStops[i];
        markup.push('<stop ', 'offset="', colorStop.offset * 100 + '%', '" style="stop-color:', colorStop.color, typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';', '"/>\n');
      }

      markup.push(this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n');
      return markup.join('');
    },

    /* _TO_SVG_END_ */

    /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {CanvasGradient}
     */
    toLive: function toLive(ctx) {
      var gradient,
          coords = fabric.util.object.clone(this.coords),
          i,
          len;

      if (!this.type) {
        return;
      }

      if (this.type === 'linear') {
        gradient = ctx.createLinearGradient(coords.x1, coords.y1, coords.x2, coords.y2);
      } else if (this.type === 'radial') {
        gradient = ctx.createRadialGradient(coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
      }

      for (i = 0, len = this.colorStops.length; i < len; i++) {
        var color = this.colorStops[i].color,
            opacity = this.colorStops[i].opacity,
            offset = this.colorStops[i].offset;

        if (typeof opacity !== 'undefined') {
          color = new fabric.Color(color).setAlpha(opacity).toRgba();
        }

        gradient.addColorStop(offset, color);
      }

      return gradient;
    }
  });
  fabric.util.object.extend(fabric.Gradient, {
    /* _FROM_SVG_START_ */

    /**
     * Returns {@link fabric.Gradient} instance from an SVG element
     * @static
     * @memberOf fabric.Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {fabric.Object} instance
     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly gradients
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
     * @param {Object.number} width width part of the svg tag if viewBox is not specified
     * @param {Object.number} height height part of the svg tag if viewBox is not specified
     * @return {fabric.Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     */
    fromElement: function fromElement(el, instance, opacityAttr, svgOptions) {
      /**
       *  @example:
       *
       *  <linearGradient id="linearGrad1">
       *    <stop offset="0%" stop-color="white"/>
       *    <stop offset="100%" stop-color="black"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <linearGradient id="linearGrad2">
       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad1">
       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
       *  </radialGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad2">
       *    <stop offset="0" stop-color="rgb(255,255,255)" />
       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
       *    <stop offset="1" stop-color="rgb(255,255,255)" />
       *  </radialGradient>
       *
       */
      var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
      multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;

      if (isNaN(multiplier)) {
        multiplier = 1;
      }

      var colorStopEls = el.getElementsByTagName('stop'),
          type,
          gradientUnits = el.getAttribute('gradientUnits') === 'userSpaceOnUse' ? 'pixels' : 'percentage',
          gradientTransform = el.getAttribute('gradientTransform') || '',
          colorStops = [],
          coords,
          i,
          offsetX = 0,
          offsetY = 0,
          transformMatrix;

      if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
        type = 'linear';
        coords = getLinearCoords(el);
      } else {
        type = 'radial';
        coords = getRadialCoords(el);
      }

      for (i = colorStopEls.length; i--;) {
        colorStops.push(getColorStop(colorStopEls[i], multiplier));
      }

      transformMatrix = fabric.parseTransformAttribute(gradientTransform);

      __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);

      if (gradientUnits === 'pixels') {
        offsetX = -instance.left;
        offsetY = -instance.top;
      }

      var gradient = new fabric.Gradient({
        id: el.getAttribute('id'),
        type: type,
        coords: coords,
        colorStops: colorStops,
        gradientUnits: gradientUnits,
        gradientTransform: transformMatrix,
        offsetX: offsetX,
        offsetY: offsetY
      });
      return gradient;
    }
    /* _FROM_SVG_END_ */

  });
  /**
   * @private
   */

  function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
    var propValue, finalValue;
    Object.keys(options).forEach(function (prop) {
      propValue = options[prop];

      if (propValue === 'Infinity') {
        finalValue = 1;
      } else if (propValue === '-Infinity') {
        finalValue = 0;
      } else {
        finalValue = parseFloat(options[prop], 10);

        if (typeof propValue === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
          finalValue *= 0.01;

          if (gradientUnits === 'pixels') {
            // then we need to fix those percentages here in svg parsing
            if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
              finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
            }

            if (prop === 'y1' || prop === 'y2') {
              finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
            }
          }
        }
      }

      options[prop] = finalValue;
    });
  }
})();

(function () {
  'use strict';

  var toFixed = fabric.util.toFixed;
  /**
   * Pattern class
   * @class fabric.Pattern
   * @see {@link http://fabricjs.com/patterns|Pattern demo}
   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
   * @see {@link fabric.Pattern#initialize} for constructor definition
   */

  fabric.Pattern = fabric.util.createClass(
  /** @lends fabric.Pattern.prototype */
  {
    /**
     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @type String
     * @default
     */
    repeat: 'repeat',

    /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */
    crossOrigin: '',

    /**
     * transform matrix to change the pattern, imported from svgs.
     * @type Array
     * @default
     */
    patternTransform: null,

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {Function} [callback] function to invoke after callback init.
     * @return {fabric.Pattern} thisArg
     */
    initialize: function initialize(options, callback) {
      options || (options = {});
      this.id = fabric.Object.__uid++;
      this.setOptions(options);

      if (!options.source || options.source && typeof options.source !== 'string') {
        callback && callback(this);
        return;
      } else {
        // img src string
        var _this = this;

        this.source = fabric.util.createImage();
        fabric.util.loadImage(options.source, function (img, isError) {
          _this.source = img;
          callback && callback(_this, isError);
        }, null, this.crossOrigin);
      }
    },

    /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of a pattern instance
     */
    toObject: function toObject(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          source,
          object; // <img> element

      if (typeof this.source.src === 'string') {
        source = this.source.src;
      } // <canvas> element
      else if (_typeof(this.source) === 'object' && this.source.toDataURL) {
          source = this.source.toDataURL();
        }

      object = {
        type: 'pattern',
        source: source,
        repeat: this.repeat,
        crossOrigin: this.crossOrigin,
        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);
      return object;
    },

    /* _TO_SVG_START_ */

    /**
     * Returns SVG representation of a pattern
     * @param {fabric.Object} object
     * @return {String} SVG representation of a pattern
     */
    toSVG: function toSVG(object) {
      var patternSource = typeof this.source === 'function' ? this.source() : this.source,
          patternWidth = patternSource.width / object.width,
          patternHeight = patternSource.height / object.height,
          patternOffsetX = this.offsetX / object.width,
          patternOffsetY = this.offsetY / object.height,
          patternImgSrc = '';

      if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
        patternHeight = 1;

        if (patternOffsetY) {
          patternHeight += Math.abs(patternOffsetY);
        }
      }

      if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
        patternWidth = 1;

        if (patternOffsetX) {
          patternWidth += Math.abs(patternOffsetX);
        }
      }

      if (patternSource.src) {
        patternImgSrc = patternSource.src;
      } else if (patternSource.toDataURL) {
        patternImgSrc = patternSource.toDataURL();
      }

      return '<pattern id="SVGID_' + this.id + '" x="' + patternOffsetX + '" y="' + patternOffsetY + '" width="' + patternWidth + '" height="' + patternHeight + '">\n' + '<image x="0" y="0"' + ' width="' + patternSource.width + '" height="' + patternSource.height + '" xlink:href="' + patternImgSrc + '"></image>\n' + '</pattern>\n';
    },

    /* _TO_SVG_END_ */
    setOptions: function setOptions(options) {
      for (var prop in options) {
        this[prop] = options[prop];
      }
    },

    /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */
    toLive: function toLive(ctx) {
      var source = this.source; // if the image failed to load, return, and allow rest to continue loading

      if (!source) {
        return '';
      } // if an image


      if (typeof source.src !== 'undefined') {
        if (!source.complete) {
          return '';
        }

        if (source.naturalWidth === 0 || source.naturalHeight === 0) {
          return '';
        }
      }

      return ctx.createPattern(source, this.repeat);
    }
  });
})();

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      toFixed = fabric.util.toFixed;

  if (fabric.Shadow) {
    fabric.warn('fabric.Shadow is already defined.');
    return;
  }
  /**
   * Shadow class
   * @class fabric.Shadow
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @see {@link fabric.Shadow#initialize} for constructor definition
   */


  fabric.Shadow = fabric.util.createClass(
  /** @lends fabric.Shadow.prototype */
  {
    /**
     * Shadow color
     * @type String
     * @default
     */
    color: 'rgb(0,0,0)',

    /**
     * Shadow blur
     * @type Number
     */
    blur: 0,

    /**
     * Shadow horizontal offset
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Shadow vertical offset
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * Whether the shadow should affect stroke operations
     * @type Boolean
     * @default
     */
    affectStroke: false,

    /**
     * Indicates whether toObject should include default values
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * When `false`, the shadow will scale with the object.
     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
     * default to false
     * @type Boolean
     * @default
     */
    nonScaling: false,

    /**
     * Constructor
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     * @return {fabric.Shadow} thisArg
     */
    initialize: function initialize(options) {
      if (typeof options === 'string') {
        options = this._parseShadow(options);
      }

      for (var prop in options) {
        this[prop] = options[prop];
      }

      this.id = fabric.Object.__uid++;
    },

    /**
     * @private
     * @param {String} shadow Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */
    _parseShadow: function _parseShadow(shadow) {
      var shadowStr = shadow.trim(),
          offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [],
          color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';
      return {
        color: color.trim(),
        offsetX: parseInt(offsetsAndBlur[1], 10) || 0,
        offsetY: parseInt(offsetsAndBlur[2], 10) || 0,
        blur: parseInt(offsetsAndBlur[3], 10) || 0
      };
    },

    /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */
    toString: function toString() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
    },

    /* _TO_SVG_START_ */

    /**
     * Returns SVG representation of a shadow
     * @param {fabric.Object} object
     * @return {String} SVG representation of a shadow
     */
    toSVG: function toSVG(object) {
      var fBoxX = 40,
          fBoxY = 40,
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          offset = fabric.util.rotateVector({
        x: this.offsetX,
        y: this.offsetY
      }, fabric.util.degreesToRadians(-object.angle)),
          BLUR_BOX = 20,
          color = new fabric.Color(this.color);

      if (object.width && object.height) {
        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
        // we add some extra space to filter box to contain the blur ( 20 )
        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
      }

      if (object.flipX) {
        offset.x *= -1;
      }

      if (object.flipY) {
        offset.y *= -1;
      }

      return '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' + 'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' + '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' + toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' + '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) + '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' + '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' + '\t<feComposite in2="oBlur" operator="in" />\n' + '\t<feMerge>\n' + '\t\t<feMergeNode></feMergeNode>\n' + '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' + '\t</feMerge>\n' + '</filter>\n';
    },

    /* _TO_SVG_END_ */

    /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */
    toObject: function toObject() {
      if (this.includeDefaultValues) {
        return {
          color: this.color,
          blur: this.blur,
          offsetX: this.offsetX,
          offsetY: this.offsetY,
          affectStroke: this.affectStroke,
          nonScaling: this.nonScaling
        };
      }

      var obj = {},
          proto = fabric.Shadow.prototype;
      ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke', 'nonScaling'].forEach(function (prop) {
        if (this[prop] !== proto[prop]) {
          obj[prop] = this[prop];
        }
      }, this);
      return obj;
    }
  });
  /**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * @static
   * @field
   * @memberOf fabric.Shadow
   */
  // eslint-disable-next-line max-len

  fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/;
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  'use strict';

  if (fabric.StaticCanvas) {
    fabric.warn('fabric.StaticCanvas is already defined.');
    return;
  } // aliases for faster resolution


  var extend = fabric.util.object.extend,
      getElementOffset = fabric.util.getElementOffset,
      removeFromArray = fabric.util.removeFromArray,
      toFixed = fabric.util.toFixed,
      transformPoint = fabric.util.transformPoint,
      invertTransform = fabric.util.invertTransform,
      getNodeCanvas = fabric.util.getNodeCanvas,
      createCanvasElement = fabric.util.createCanvasElement,
      CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');
  /**
   * Static canvas class
   * @class fabric.StaticCanvas
   * @mixes fabric.Collection
   * @mixes fabric.Observable
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */

  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods,
  /** @lends fabric.StaticCanvas.prototype */
  {
    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function initialize(el, options) {
      options || (options = {});
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);

      this._initStatic(el, options);
    },

    /**
     * Background color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
     * @type {(String|fabric.Pattern)}
     * @default
     */
    backgroundColor: '',

    /**
     * Background image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as background, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    backgroundImage: null,

    /**
     * Overlay color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
     * @since 1.3.9
     * @type {(String|fabric.Pattern)}
     * @default
     */
    overlayColor: '',

    /**
     * Overlay image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    overlayImage: null,

    /**
     * Indicates whether toObject/toDatalessObject should include default values
     * if set to false, takes precedence over the object value.
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * Indicates whether objects' state should be saved
     * @type Boolean
     * @default
     */
    stateful: false,

    /**
     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
     * since the renders are quequed and executed one per frame.
     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
     * Left default to true to do not break documentation and old app, fiddles.
     * @type Boolean
     * @default
     */
    renderOnAddRemove: true,

    /**
     * Indicates whether object controls (borders/controls) are rendered above overlay image
     * @type Boolean
     * @default
     */
    controlsAboveOverlay: false,

    /**
     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
     * @type Boolean
     * @default
     */
    allowTouchScrolling: false,

    /**
     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
     * @type Boolean
     * @default
     */
    imageSmoothingEnabled: true,

    /**
     * The transformation (in the format of Canvas transform) which focuses the viewport
     * @type Array
     * @default
     */
    viewportTransform: fabric.iMatrix.concat(),

    /**
     * if set to false background image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    backgroundVpt: true,

    /**
     * if set to false overlya image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    overlayVpt: true,

    /**
     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
     * @type Boolean
     * @default
     */
    enableRetinaScaling: true,

    /**
     * Describe canvas element extension over design
     * properties are tl,tr,bl,br.
     * if canvas is not zoomed/panned those points are the four corner of canvas
     * if canvas is viewportTransformed you those points indicate the extension
     * of canvas element in plain untrasformed coordinates
     * The coordinates get updated with @method calcViewportBoundaries.
     * @memberOf fabric.StaticCanvas.prototype
     */
    vptCoords: {},

    /**
     * Based on vptCoords and object.aCoords, skip rendering of objects that
     * are not included in current viewport.
     * May greatly help in applications with crowded canvas and use of zoom/pan
     * If One of the corner of the bounding box of the object is on the canvas
     * the objects get rendered.
     * @memberOf fabric.StaticCanvas.prototype
     * @type Boolean
     * @default
     */
    skipOffscreen: true,

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
     * top left corner of the canvas.
     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * @private
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     */
    _initStatic: function _initStatic(el, options) {
      var cb = this.requestRenderAllBound;
      this._objects = [];

      this._createLowerCanvas(el);

      this._initOptions(options); // only initialize retina scaling once


      if (!this.interactive) {
        this._initRetinaScaling();
      }

      if (options.overlayImage) {
        this.setOverlayImage(options.overlayImage, cb);
      }

      if (options.backgroundImage) {
        this.setBackgroundImage(options.backgroundImage, cb);
      }

      if (options.backgroundColor) {
        this.setBackgroundColor(options.backgroundColor, cb);
      }

      if (options.overlayColor) {
        this.setOverlayColor(options.overlayColor, cb);
      }

      this.calcOffset();
    },

    /**
     * @private
     */
    _isRetinaScaling: function _isRetinaScaling() {
      return fabric.devicePixelRatio !== 1 && this.enableRetinaScaling;
    },

    /**
     * @private
     * @return {Number} retinaScaling if applied, otherwise 1;
     */
    getRetinaScaling: function getRetinaScaling() {
      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
    },

    /**
     * @private
     */
    _initRetinaScaling: function _initRetinaScaling() {
      if (!this._isRetinaScaling()) {
        return;
      }

      var scaleRatio = fabric.devicePixelRatio;

      this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);

      if (this.upperCanvasEl) {
        this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
      }
    },
    __initRetinaScaling: function __initRetinaScaling(scaleRatio, canvas, context) {
      canvas.setAttribute('width', this.width * scaleRatio);
      canvas.setAttribute('height', this.height * scaleRatio);
      context.scale(scaleRatio, scaleRatio);
    },

    /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     * @return {fabric.Canvas} instance
     * @chainable
     */
    calcOffset: function calcOffset() {
      this._offset = getElementOffset(this.lowerCanvasEl);
      return this;
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
     * @example <caption>Normal overlayImage with left/top = 0</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage with different properties</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage loaded from cross-origin</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    setOverlayImage: function setOverlayImage(image, callback, options) {
      return this.__setBgOverlayImage('overlayImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
     * @param {Function} callback Callback to invoke when image is loaded and set as background
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
     * @example <caption>Normal backgroundImage with left/top = 0</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage with different properties</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage loaded from cross-origin</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    // TODO: fix stretched examples
    setBackgroundImage: function setBackgroundImage(image, callback, options) {
      return this.__setBgOverlayImage('backgroundImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
     * @param {Function} callback Callback to invoke when foreground color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
     * @example <caption>Normal overlayColor - color value</caption>
     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setOverlayColor: function setOverlayColor(overlayColor, callback) {
      return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
     * @param {Function} callback Callback to invoke when background color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
     * @example <caption>Normal backgroundColor - color value</caption>
     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setBackgroundColor: function setBackgroundColor(backgroundColor, callback) {
      return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occurred or not.
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
     */
    __setBgOverlayImage: function __setBgOverlayImage(property, image, callback, options) {
      if (typeof image === 'string') {
        fabric.util.loadImage(image, function (img, isError) {
          if (img) {
            var instance = new fabric.Image(img, options);
            this[property] = instance;
            instance.canvas = this;
          }

          callback && callback(img, isError);
        }, this, options && options.crossOrigin);
      } else {
        options && image.setOptions(options);
        this[property] = image;
        image && (image.canvas = this);
        callback && callback(image, false);
      }

      return this;
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
     * @param {(Object|String|null)} color Object with pattern information, color value or null
     * @param {Function} [callback] Callback is invoked when color is set
     */
    __setBgOverlayColor: function __setBgOverlayColor(property, color, callback) {
      this[property] = color;

      this._initGradient(color, property);

      this._initPattern(color, property, callback);

      return this;
    },

    /**
     * @private
     */
    _createCanvasElement: function _createCanvasElement() {
      var element = createCanvasElement();

      if (!element) {
        throw CANVAS_INIT_ERROR;
      }

      if (!element.style) {
        element.style = {};
      }

      if (typeof element.getContext === 'undefined') {
        throw CANVAS_INIT_ERROR;
      }

      return element;
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initOptions: function _initOptions(options) {
      var lowerCanvasEl = this.lowerCanvasEl;

      this._setOptions(options);

      this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
      this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;

      if (!this.lowerCanvasEl.style) {
        return;
      }

      lowerCanvasEl.width = this.width;
      lowerCanvasEl.height = this.height;
      lowerCanvasEl.style.width = this.width + 'px';
      lowerCanvasEl.style.height = this.height + 'px';
      this.viewportTransform = this.viewportTransform.slice();
    },

    /**
     * Creates a bottom canvas
     * @private
     * @param {HTMLElement} [canvasEl]
     */
    _createLowerCanvas: function _createLowerCanvas(canvasEl) {
      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
      if (canvasEl && canvasEl.getContext) {
        this.lowerCanvasEl = canvasEl;
      } else {
        this.lowerCanvasEl = fabric.util.getById(canvasEl) || this._createCanvasElement();
      }

      fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');

      if (this.interactive) {
        this._applyCanvasStyle(this.lowerCanvasEl);
      }

      this.contextContainer = this.lowerCanvasEl.getContext('2d');
    },

    /**
     * Returns canvas width (in px)
     * @return {Number}
     */
    getWidth: function getWidth() {
      return this.width;
    },

    /**
     * Returns canvas height (in px)
     * @return {Number}
     */
    getHeight: function getHeight() {
      return this.height;
    },

    /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setWidth: function setWidth(value, options) {
      return this.setDimensions({
        width: value
      }, options);
    },

    /**
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setHeight: function setHeight(value, options) {
      return this.setDimensions({
        height: value
      }, options);
    },

    /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setDimensions: function setDimensions(dimensions, options) {
      var cssValue;
      options = options || {};

      for (var prop in dimensions) {
        cssValue = dimensions[prop];

        if (!options.cssOnly) {
          this._setBackstoreDimension(prop, dimensions[prop]);

          cssValue += 'px';
          this.hasLostContext = true;
        }

        if (!options.backstoreOnly) {
          this._setCssDimension(prop, cssValue);
        }
      }

      if (this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
      }

      this._initRetinaScaling();

      this.calcOffset();

      if (!options.cssOnly) {
        this.requestRenderAll();
      }

      return this;
    },

    /**
     * Helper for setting width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {Number} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setBackstoreDimension: function _setBackstoreDimension(prop, value) {
      this.lowerCanvasEl[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl[prop] = value;
      }

      if (this.cacheCanvasEl) {
        this.cacheCanvasEl[prop] = value;
      }

      this[prop] = value;
      return this;
    },

    /**
     * Helper for setting css width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {String} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setCssDimension: function _setCssDimension(prop, value) {
      this.lowerCanvasEl.style[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl.style[prop] = value;
      }

      if (this.wrapperEl) {
        this.wrapperEl.style[prop] = value;
      }

      return this;
    },

    /**
     * Returns canvas zoom level
     * @return {Number}
     */
    getZoom: function getZoom() {
      return this.viewportTransform[0];
    },

    /**
     * Sets viewport transform of this canvas instance
     * @param {Array} vpt the transform in the form of context.transform
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setViewportTransform: function setViewportTransform(vpt) {
      var activeObject = this._activeObject,
          backgroundObject = this.backgroundImage,
          overlayObject = this.overlayImage,
          object,
          i,
          len;
      this.viewportTransform = vpt;

      for (i = 0, len = this._objects.length; i < len; i++) {
        object = this._objects[i];
        object.group || object.setCoords(true);
      }

      if (activeObject) {
        activeObject.setCoords();
      }

      if (backgroundObject) {
        backgroundObject.setCoords(true);
      }

      if (overlayObject) {
        overlayObject.setCoords(true);
      }

      this.calcViewportBoundaries();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Sets zoom level of this canvas instance, the zoom centered around point
     * meaning that following zoom to point with the same point will have the visual
     * effect of the zoom originating from that point. The point won't move.
     * It has nothing to do with canvas center or visual center of the viewport.
     * @param {fabric.Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    zoomToPoint: function zoomToPoint(point, value) {
      // TODO: just change the scale, preserve other transformations
      var before = point,
          vpt = this.viewportTransform.slice(0);
      point = transformPoint(point, invertTransform(this.viewportTransform));
      vpt[0] = value;
      vpt[3] = value;
      var after = transformPoint(point, vpt);
      vpt[4] += before.x - after.x;
      vpt[5] += before.y - after.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setZoom: function setZoom(value) {
      this.zoomToPoint(new fabric.Point(0, 0), value);
      return this;
    },

    /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {fabric.Point} point to move to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    absolutePan: function absolutePan(point) {
      var vpt = this.viewportTransform.slice(0);
      vpt[4] = -point.x;
      vpt[5] = -point.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Pans viewpoint relatively
     * @param {fabric.Point} point (position vector) to move by
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    relativePan: function relativePan(point) {
      return this.absolutePan(new fabric.Point(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
    },

    /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */
    getElement: function getElement() {
      return this.lowerCanvasEl;
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was added
     */
    _onObjectAdded: function _onObjectAdded(obj) {
      this.stateful && obj.setupState();

      obj._set('canvas', this);

      obj.setCoords();
      this.fire('object:added', {
        target: obj
      });
      obj.fire('added');
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function _onObjectRemoved(obj) {
      this.fire('object:removed', {
        target: obj
      });
      obj.fire('removed');
      delete obj.canvas;
    },

    /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clearContext: function clearContext(ctx) {
      ctx.clearRect(0, 0, this.width, this.height);
      return this;
    },

    /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */
    getContext: function getContext() {
      return this.contextContainer;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function clear() {
      this._objects.length = 0;
      this.backgroundImage = null;
      this.overlayImage = null;
      this.backgroundColor = '';
      this.overlayColor = '';

      if (this._hasITextHandlers) {
        this.off('mouse:up', this._mouseUpITextHandler);
        this._iTextInstances = null;
        this._hasITextHandlers = false;
      }

      this.clearContext(this.contextContainer);
      this.fire('canvas:cleared');
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Renders the canvas
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function renderAll() {
      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._objects);
      return this;
    },

    /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAndReset: function renderAndReset() {
      this.isRendering = 0;
      this.renderAll();
    },

    /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    requestRenderAll: function requestRenderAll() {
      if (!this.isRendering) {
        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
      }

      return this;
    },

    /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport using
     * object absolute coordinates ( aCoords )
     * @return {Object} points.tl
     * @chainable
     */
    calcViewportBoundaries: function calcViewportBoundaries() {
      var points = {},
          width = this.width,
          height = this.height,
          iVpt = invertTransform(this.viewportTransform);
      points.tl = transformPoint({
        x: 0,
        y: 0
      }, iVpt);
      points.br = transformPoint({
        x: width,
        y: height
      }, iVpt);
      points.tr = new fabric.Point(points.br.x, points.tl.y);
      points.bl = new fabric.Point(points.tl.x, points.br.y);
      this.vptCoords = points;
      return points;
    },
    cancelRequestedRender: function cancelRequestedRender() {
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
    },

    /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderCanvas: function renderCanvas(ctx, objects) {
      var v = this.viewportTransform,
          path = this.clipPath;
      this.cancelRequestedRender();
      this.calcViewportBoundaries();
      this.clearContext(ctx);
      fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
      this.fire('before:render', {
        ctx: ctx
      });

      this._renderBackground(ctx);

      ctx.save(); //apply viewport transform once for all rendering process

      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);

      this._renderObjects(ctx, objects);

      ctx.restore();

      if (!this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }

      if (path) {
        path.canvas = this; // needed to setup a couple of variables

        path.shouldCache();
        path._transformDone = true;
        path.renderCache({
          forClipping: true
        });
        this.drawClipPathOnCanvas(ctx);
      }

      this._renderOverlay(ctx);

      if (this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }

      this.fire('after:render', {
        ctx: ctx
      });
    },

    /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCanvas: function drawClipPathOnCanvas(ctx) {
      var v = this.viewportTransform,
          path = this.clipPath;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]); // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4;

      ctx.globalCompositeOperation = 'destination-in';
      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */
    _renderObjects: function _renderObjects(ctx, objects) {
      var i, len;

      for (i = 0, len = objects.length; i < len; ++i) {
        objects[i] && objects[i].render(ctx);
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */
    _renderBackgroundOrOverlay: function _renderBackgroundOrOverlay(ctx, property) {
      var fill = this[property + 'Color'],
          object = this[property + 'Image'],
          v = this.viewportTransform,
          needsVpt = this[property + 'Vpt'];

      if (!fill && !object) {
        return;
      }

      if (fill) {
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.width, 0);
        ctx.lineTo(this.width, this.height);
        ctx.lineTo(0, this.height);
        ctx.closePath();
        ctx.fillStyle = fill.toLive ? fill.toLive(ctx, this) : fill;

        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }

        ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
        var m = fill.gradientTransform || fill.patternTransform;
        m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        ctx.fill();
        ctx.restore();
      }

      if (object) {
        ctx.save();

        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }

        object.render(ctx);
        ctx.restore();
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function _renderBackground(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'background');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderOverlay: function _renderOverlay(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'overlay');
    },

    /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     */
    getCenter: function getCenter() {
      return {
        top: this.height / 2,
        left: this.width / 2
      };
    },

    /**
     * Centers object horizontally in the canvas
     * @param {fabric.Object} object Object to center horizontally
     * @return {fabric.Canvas} thisArg
     */
    centerObjectH: function centerObjectH(object) {
      return this._centerObject(object, new fabric.Point(this.getCenter().left, object.getCenterPoint().y));
    },

    /**
     * Centers object vertically in the canvas
     * @param {fabric.Object} object Object to center vertically
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObjectV: function centerObjectV(object) {
      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, this.getCenter().top));
    },

    /**
     * Centers object vertically and horizontally in the canvas
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObject: function centerObject(object) {
      var center = this.getCenter();
      return this._centerObject(object, new fabric.Point(center.left, center.top));
    },

    /**
     * Centers object vertically and horizontally in the viewport
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObject: function viewportCenterObject(object) {
      var vpCenter = this.getVpCenter();
      return this._centerObject(object, vpCenter);
    },

    /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectH: function viewportCenterObjectH(object) {
      var vpCenter = this.getVpCenter();

      this._centerObject(object, new fabric.Point(vpCenter.x, object.getCenterPoint().y));

      return this;
    },

    /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectV: function viewportCenterObjectV(object) {
      var vpCenter = this.getVpCenter();
      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, vpCenter.y));
    },

    /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {fabric.Point} vpCenter, viewport center
     * @chainable
     */
    getVpCenter: function getVpCenter() {
      var center = this.getCenter(),
          iVpt = invertTransform(this.viewportTransform);
      return transformPoint({
        x: center.left,
        y: center.top
      }, iVpt);
    },

    /**
     * @private
     * @param {fabric.Object} object Object to center
     * @param {fabric.Point} center Center point
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    _centerObject: function _centerObject(object, center) {
      object.setPositionByOrigin(center, 'center', 'center');
      object.setCoords();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Returns dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */
    toDatalessJSON: function toDatalessJSON(propertiesToInclude) {
      return this.toDatalessObject(propertiesToInclude);
    },

    /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return this._toObjectMethod('toObject', propertiesToInclude);
    },

    /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function toDatalessObject(propertiesToInclude) {
      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
    },

    /**
     * @private
     */
    _toObjectMethod: function _toObjectMethod(methodName, propertiesToInclude) {
      var clipPath = this.clipPath,
          data = {
        version: fabric.version,
        objects: this._toObjects(methodName, propertiesToInclude)
      };

      if (clipPath) {
        data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
      }

      extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));
      fabric.util.populateWithProperties(this, data, propertiesToInclude);
      return data;
    },

    /**
     * @private
     */
    _toObjects: function _toObjects(methodName, propertiesToInclude) {
      return this._objects.filter(function (object) {
        return !object.excludeFromExport;
      }).map(function (instance) {
        return this._toObject(instance, methodName, propertiesToInclude);
      }, this);
    },

    /**
     * @private
     */
    _toObject: function _toObject(instance, methodName, propertiesToInclude) {
      var originalValue;

      if (!this.includeDefaultValues) {
        originalValue = instance.includeDefaultValues;
        instance.includeDefaultValues = false;
      }

      var object = instance[methodName](propertiesToInclude);

      if (!this.includeDefaultValues) {
        instance.includeDefaultValues = originalValue;
      }

      return object;
    },

    /**
     * @private
     */
    __serializeBgOverlay: function __serializeBgOverlay(methodName, propertiesToInclude) {
      var data = {},
          bgImage = this.backgroundImage,
          overlay = this.overlayImage;

      if (this.backgroundColor) {
        data.background = this.backgroundColor.toObject ? this.backgroundColor.toObject(propertiesToInclude) : this.backgroundColor;
      }

      if (this.overlayColor) {
        data.overlay = this.overlayColor.toObject ? this.overlayColor.toObject(propertiesToInclude) : this.overlayColor;
      }

      if (bgImage && !bgImage.excludeFromExport) {
        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
      }

      if (overlay && !overlay.excludeFromExport) {
        data.overlayImage = this._toObject(overlay, methodName, propertiesToInclude);
      }

      return data;
    },

    /* _TO_SVG_START_ */

    /**
     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
     * a zoomed canvas will then produce zoomed SVG output.
     * @type Boolean
     * @default
     */
    svgViewportTransformation: true,

    /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-coordinate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */
    toSVG: function toSVG(options, reviver) {
      options || (options = {});
      options.reviver = reviver;
      var markup = [];

      this._setSVGPreamble(markup, options);

      this._setSVGHeader(markup, options);

      if (this.clipPath) {
        markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
      }

      this._setSVGBgOverlayColor(markup, 'background');

      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);

      this._setSVGObjects(markup, reviver);

      if (this.clipPath) {
        markup.push('</g>\n');
      }

      this._setSVGBgOverlayColor(markup, 'overlay');

      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);

      markup.push('</svg>');
      return markup.join('');
    },

    /**
     * @private
     */
    _setSVGPreamble: function _setSVGPreamble(markup, options) {
      if (options.suppressPreamble) {
        return;
      }

      markup.push('<?xml version="1.0" encoding="', options.encoding || 'UTF-8', '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
    },

    /**
     * @private
     */
    _setSVGHeader: function _setSVGHeader(markup, options) {
      var width = options.width || this.width,
          height = options.height || this.height,
          vpt,
          viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      if (options.viewBox) {
        viewBox = 'viewBox="' + options.viewBox.x + ' ' + options.viewBox.y + ' ' + options.viewBox.width + ' ' + options.viewBox.height + '" ';
      } else {
        if (this.svgViewportTransformation) {
          vpt = this.viewportTransform;
          viewBox = 'viewBox="' + toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' + toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' + toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' + toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
        }
      }

      markup.push('<svg ', 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', '<desc>Created with Fabric.js ', fabric.version, '</desc>\n', '<defs>\n', this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), '</defs>\n');
    },
    createSVGClipPathMarkup: function createSVGClipPathMarkup(options) {
      var clipPath = this.clipPath;

      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        return '<clipPath id="' + clipPath.clipPathId + '" >\n' + this.clipPath.toClipPathSVG(options.reviver) + '</clipPath>\n';
      }

      return '';
    },

    /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */
    createSVGRefElementsMarkup: function createSVGRefElementsMarkup() {
      var _this = this,
          markup = ['background', 'overlay'].map(function (prop) {
        var fill = _this[prop + 'Color'];

        if (fill && fill.toLive) {
          var shouldTransform = _this[prop + 'Vpt'],
              vpt = _this.viewportTransform,
              object = {
            width: _this.width / (shouldTransform ? vpt[0] : 1),
            height: _this.height / (shouldTransform ? vpt[3] : 1)
          };
          return fill.toSVG(object, {
            additionalTransform: shouldTransform ? fabric.util.matrixToSVG(vpt) : ''
          });
        }
      });

      return markup.join('');
    },

    /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */
    createSVGFontFacesMarkup: function createSVGFontFacesMarkup() {
      var markup = '',
          fontList = {},
          obj,
          fontFamily,
          style,
          row,
          rowIndex,
          _char,
          charIndex,
          i,
          len,
          fontPaths = fabric.fontPaths,
          objects = [];

      this._objects.forEach(function add(object) {
        objects.push(object);

        if (object._objects) {
          object._objects.forEach(add);
        }
      });

      for (i = 0, len = objects.length; i < len; i++) {
        obj = objects[i];
        fontFamily = obj.fontFamily;

        if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
          continue;
        }

        fontList[fontFamily] = true;

        if (!obj.styles) {
          continue;
        }

        style = obj.styles;

        for (rowIndex in style) {
          row = style[rowIndex];

          for (charIndex in row) {
            _char = row[charIndex];
            fontFamily = _char.fontFamily;

            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
              fontList[fontFamily] = true;
            }
          }
        }
      }

      for (var j in fontList) {
        markup += ['\t\t@font-face {\n', '\t\t\tfont-family: \'', j, '\';\n', '\t\t\tsrc: url(\'', fontPaths[j], '\');\n', '\t\t}\n'].join('');
      }

      if (markup) {
        markup = ['\t<style type="text/css">', '<![CDATA[\n', markup, ']]>', '</style>\n'].join('');
      }

      return markup;
    },

    /**
     * @private
     */
    _setSVGObjects: function _setSVGObjects(markup, reviver) {
      var instance,
          i,
          len,
          objects = this._objects;

      for (i = 0, len = objects.length; i < len; i++) {
        instance = objects[i];

        if (instance.excludeFromExport) {
          continue;
        }

        this._setSVGObject(markup, instance, reviver);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function _setSVGObject(markup, instance, reviver) {
      markup.push(instance.toSVG(reviver));
    },

    /**
     * @private
     */
    _setSVGBgOverlayImage: function _setSVGBgOverlayImage(markup, property, reviver) {
      if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
        markup.push(this[property].toSVG(reviver));
      }
    },

    /**
     * @private
     */
    _setSVGBgOverlayColor: function _setSVGBgOverlayColor(markup, property) {
      var filler = this[property + 'Color'],
          vpt = this.viewportTransform,
          finalWidth = this.width,
          finalHeight = this.height;

      if (!filler) {
        return;
      }

      if (filler.toLive) {
        var repeat = filler.repeat,
            iVpt = fabric.util.invertTransform(vpt),
            shouldInvert = this[property + 'Vpt'],
            additionalTransform = shouldInvert ? fabric.util.matrixToSVG(iVpt) : '';
        markup.push('<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"', ' x="', filler.offsetX - finalWidth / 2, '" y="', filler.offsetY - finalHeight / 2, '" ', 'width="', repeat === 'repeat-y' || repeat === 'no-repeat' ? filler.source.width : finalWidth, '" height="', repeat === 'repeat-x' || repeat === 'no-repeat' ? filler.source.height : finalHeight, '" fill="url(#SVGID_' + filler.id + ')"', '></rect>\n');
      } else {
        markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', '></rect>\n');
      }
    },

    /* _TO_SVG_END_ */

    /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendToBack: function sendToBack(object) {
      if (!object) {
        return this;
      }

      var activeSelection = this._activeObject,
          i,
          obj,
          objs;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;

        for (i = objs.length; i--;) {
          obj = objs[i];
          removeFromArray(this._objects, obj);

          this._objects.unshift(obj);
        }
      } else {
        removeFromArray(this._objects, object);

        this._objects.unshift(object);
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringToFront: function bringToFront(object) {
      if (!object) {
        return this;
      }

      var activeSelection = this._activeObject,
          i,
          obj,
          objs;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;

        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          removeFromArray(this._objects, obj);

          this._objects.push(obj);
        }
      } else {
        removeFromArray(this._objects, object);

        this._objects.push(object);
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendBackwards: function sendBackwards(object, intersecting) {
      if (!object) {
        return this;
      }

      var activeSelection = this._activeObject,
          i,
          obj,
          idx,
          newIdx,
          objs,
          objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;

        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);

          if (idx > 0 + objsMoved) {
            newIdx = idx - 1;
            removeFromArray(this._objects, obj);

            this._objects.splice(newIdx, 0, obj);
          }

          objsMoved++;
        }
      } else {
        idx = this._objects.indexOf(object);

        if (idx !== 0) {
          // if object is not on the bottom of stack
          newIdx = this._findNewLowerIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);

          this._objects.splice(newIdx, 0, object);
        }
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewLowerIndex: function _findNewLowerIndex(object, idx, intersecting) {
      var newIdx, i;

      if (intersecting) {
        newIdx = idx; // traverse down the stack looking for the nearest intersecting object

        for (i = idx - 1; i >= 0; --i) {
          var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      } else {
        newIdx = idx - 1;
      }

      return newIdx;
    },

    /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringForward: function bringForward(object, intersecting) {
      if (!object) {
        return this;
      }

      var activeSelection = this._activeObject,
          i,
          obj,
          idx,
          newIdx,
          objs,
          objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;

        for (i = objs.length; i--;) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);

          if (idx < this._objects.length - 1 - objsMoved) {
            newIdx = idx + 1;
            removeFromArray(this._objects, obj);

            this._objects.splice(newIdx, 0, obj);
          }

          objsMoved++;
        }
      } else {
        idx = this._objects.indexOf(object);

        if (idx !== this._objects.length - 1) {
          // if object is not on top of stack (last item in an array)
          newIdx = this._findNewUpperIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);

          this._objects.splice(newIdx, 0, object);
        }
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewUpperIndex: function _findNewUpperIndex(object, idx, intersecting) {
      var newIdx, i, len;

      if (intersecting) {
        newIdx = idx; // traverse up the stack looking for the nearest intersecting object

        for (i = idx + 1, len = this._objects.length; i < len; ++i) {
          var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      } else {
        newIdx = idx + 1;
      }

      return newIdx;
    },

    /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {Number} index Position to move to
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    moveTo: function moveTo(object, index) {
      removeFromArray(this._objects, object);

      this._objects.splice(index, 0, object);

      return this.renderOnAddRemove && this.requestRenderAll();
    },

    /**
     * Clears a canvas element and dispose objects
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function dispose() {
      // cancel eventually ongoing renders
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }

      this.forEachObject(function (object) {
        object.dispose && object.dispose();
      });
      this._objects = [];

      if (this.backgroundImage && this.backgroundImage.dispose) {
        this.backgroundImage.dispose();
      }

      this.backgroundImage = null;

      if (this.overlayImage && this.overlayImage.dispose) {
        this.overlayImage.dispose();
      }

      this.overlayImage = null;
      this._iTextInstances = null;
      this.contextContainer = null;
      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
      this.lowerCanvasEl = undefined;
      return this;
    },

    /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function toString() {
      return '#<fabric.Canvas (' + this.complexity() + '): ' + '{ objects: ' + this._objects.length + ' }>';
    }
  });
  extend(fabric.StaticCanvas.prototype, fabric.Observable);
  extend(fabric.StaticCanvas.prototype, fabric.Collection);
  extend(fabric.StaticCanvas.prototype, fabric.DataURLExporter);
  extend(fabric.StaticCanvas,
  /** @lends fabric.StaticCanvas */
  {
    /**
     * @static
     * @type String
     * @default
     */
    EMPTY_JSON: '{"objects": [], "background": "white"}',

    /**
     * Provides a way to check support of some of the canvas methods
     * (either those of HTMLCanvasElement itself, or rendering context)
     *
     * @param {String} methodName Method to check support for;
     *                            Could be one of "setLineDash"
     * @return {Boolean | null} `true` if method is supported (or at least exists),
     *                          `null` if canvas element or context can not be initialized
     */
    supports: function supports(methodName) {
      var el = createCanvasElement();

      if (!el || !el.getContext) {
        return null;
      }

      var ctx = el.getContext('2d');

      if (!ctx) {
        return null;
      }

      switch (methodName) {
        case 'setLineDash':
          return typeof ctx.setLineDash !== 'undefined';

        default:
          return null;
      }
    }
  });
  /**
   * Returns Object representation of canvas
   * this alias is provided because if you call JSON.stringify on an instance,
   * the toJSON object will be invoked if it exists.
   * Having a toJSON method means you can do JSON.stringify(myCanvas)
   * @function
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} JSON compatible object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * canvas.includeDefaultValues = false;
   * var json = canvas.toJSON();
   */

  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;

  if (fabric.isLikelyNode) {
    fabric.StaticCanvas.prototype.createPNGStream = function () {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createPNGStream();
    };

    fabric.StaticCanvas.prototype.createJPEGStream = function (opts) {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createJPEGStream(opts);
    };
  }
})();
/**
 * BaseBrush class
 * @class fabric.BaseBrush
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */


fabric.BaseBrush = fabric.util.createClass(
/** @lends fabric.BaseBrush.prototype */
{
  /**
   * Color of a brush
   * @type String
   * @default
   */
  color: 'rgb(0, 0, 0)',

  /**
   * Width of a brush, has to be a Number, no string literals
   * @type Number
   * @default
   */
  width: 1,

  /**
   * Shadow object representing shadow of this shape.
   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
   * @type fabric.Shadow
   * @default
   */
  shadow: null,

  /**
   * Line endings style of a brush (one of "butt", "round", "square")
   * @type String
   * @default
   */
  strokeLineCap: 'round',

  /**
   * Corner style of a brush (one of "bevel", "round", "miter")
   * @type String
   * @default
   */
  strokeLineJoin: 'round',

  /**
   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
   * @type Number
   * @default
   */
  strokeMiterLimit: 10,

  /**
   * Stroke Dash Array.
   * @type Array
   * @default
   */
  strokeDashArray: null,

  /**
   * Sets brush styles
   * @private
   */
  _setBrushStyles: function _setBrushStyles() {
    var ctx = this.canvas.contextTop;
    ctx.strokeStyle = this.color;
    ctx.lineWidth = this.width;
    ctx.lineCap = this.strokeLineCap;
    ctx.miterLimit = this.strokeMiterLimit;
    ctx.lineJoin = this.strokeLineJoin;

    if (fabric.StaticCanvas.supports('setLineDash')) {
      ctx.setLineDash(this.strokeDashArray || []);
    }
  },

  /**
   * Sets the transformation on given context
   * @param {RenderingContext2d} ctx context to render on
   * @private
   */
  _saveAndTransform: function _saveAndTransform(ctx) {
    var v = this.canvas.viewportTransform;
    ctx.save();
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
  },

  /**
   * Sets brush shadow styles
   * @private
   */
  _setShadow: function _setShadow() {
    if (!this.shadow) {
      return;
    }

    var canvas = this.canvas,
        shadow = this.shadow,
        ctx = canvas.contextTop,
        zoom = canvas.getZoom();

    if (canvas && canvas._isRetinaScaling()) {
      zoom *= fabric.devicePixelRatio;
    }

    ctx.shadowColor = shadow.color;
    ctx.shadowBlur = shadow.blur * zoom;
    ctx.shadowOffsetX = shadow.offsetX * zoom;
    ctx.shadowOffsetY = shadow.offsetY * zoom;
  },
  needsFullRender: function needsFullRender() {
    var color = new fabric.Color(this.color);
    return color.getAlpha() < 1 || !!this.shadow;
  },

  /**
   * Removes brush shadow styles
   * @private
   */
  _resetShadow: function _resetShadow() {
    var ctx = this.canvas.contextTop;
    ctx.shadowColor = '';
    ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
  }
});

(function () {
  /**
   * PencilBrush class
   * @class fabric.PencilBrush
   * @extends fabric.BaseBrush
   */
  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush,
  /** @lends fabric.PencilBrush.prototype */
  {
    /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */
    decimate: 0.4,

    /**
     * Constructor
     * @param {fabric.Canvas} canvas
     * @return {fabric.PencilBrush} Instance of a pencil brush
     */
    initialize: function initialize(canvas) {
      this.canvas = canvas;
      this._points = [];
    },

    /**
     * Invoked inside on mouse down and mouse move
     * @param {Object} pointer
     */
    _drawSegment: function _drawSegment(ctx, p1, p2) {
      var midPoint = p1.midPointFrom(p2);
      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
      return midPoint;
    },

    /**
     * Invoked on mouse down
     * @param {Object} pointer
     */
    onMouseDown: function onMouseDown(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }

      this._prepareForDrawing(pointer); // capture coordinates immediately
      // this allows to draw dots (when movement never occurs)


      this._captureDrawingPath(pointer);

      this._render();
    },

    /**
     * Invoked on mouse move
     * @param {Object} pointer
     */
    onMouseMove: function onMouseMove(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }

      if (this._captureDrawingPath(pointer) && this._points.length > 1) {
        if (this.needsFullRender()) {
          // redraw curve
          // clear top canvas
          this.canvas.clearContext(this.canvas.contextTop);

          this._render();
        } else {
          var points = this._points,
              length = points.length,
              ctx = this.canvas.contextTop; // draw the curve update

          this._saveAndTransform(ctx);

          if (this.oldEnd) {
            ctx.beginPath();
            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
          }

          this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
          ctx.stroke();
          ctx.restore();
        }
      }
    },

    /**
     * Invoked on mouse up
     */
    onMouseUp: function onMouseUp(options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return true;
      }

      this.oldEnd = undefined;

      this._finalizeAndAddPath();

      return false;
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _prepareForDrawing: function _prepareForDrawing(pointer) {
      var p = new fabric.Point(pointer.x, pointer.y);

      this._reset();

      this._addPoint(p);

      this.canvas.contextTop.moveTo(p.x, p.y);
    },

    /**
     * @private
     * @param {fabric.Point} point Point to be added to points array
     */
    _addPoint: function _addPoint(point) {
      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
        return false;
      }

      this._points.push(point);

      return true;
    },

    /**
     * Clear points array and set contextTop canvas style.
     * @private
     */
    _reset: function _reset() {
      this._points = [];

      this._setBrushStyles();

      this._setShadow();
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _captureDrawingPath: function _captureDrawingPath(pointer) {
      var pointerPoint = new fabric.Point(pointer.x, pointer.y);
      return this._addPoint(pointerPoint);
    },

    /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     */
    _render: function _render() {
      var ctx = this.canvas.contextTop,
          i,
          len,
          p1 = this._points[0],
          p2 = this._points[1];

      this._saveAndTransform(ctx);

      ctx.beginPath(); //if we only have 2 points in the path and they are the same
      //it means that the user only clicked the canvas without moving the mouse
      //then we should be drawing a dot. A path isn't drawn between two identical dots
      //that's why we set them apart a bit

      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
        var width = this.width / 1000;
        p1 = new fabric.Point(p1.x, p1.y);
        p2 = new fabric.Point(p2.x, p2.y);
        p1.x -= width;
        p2.x += width;
      }

      ctx.moveTo(p1.x, p1.y);

      for (i = 1, len = this._points.length; i < len; i++) {
        // we pick the point between pi + 1 & pi + 2 as the
        // end point and p1 as our control point.
        this._drawSegment(ctx, p1, p2);

        p1 = this._points[i];
        p2 = this._points[i + 1];
      } // Draw last line as a straight line while
      // we wait for the next point to be able to calculate
      // the bezier control point


      ctx.lineTo(p1.x, p1.y);
      ctx.stroke();
      ctx.restore();
    },

    /**
     * Converts points to SVG path
     * @param {Array} points Array of points
     * @return {String} SVG path
     */
    convertPointsToSVGPath: function convertPointsToSVGPath(points) {
      var path = [],
          i,
          width = this.width / 1000,
          p1 = new fabric.Point(points[0].x, points[0].y),
          p2 = new fabric.Point(points[1].x, points[1].y),
          len = points.length,
          multSignX = 1,
          multSignY = 0,
          manyPoints = len > 2;

      if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
      }

      path.push('M ', p1.x - multSignX * width, ' ', p1.y - multSignY * width, ' ');

      for (i = 1; i < len; i++) {
        if (!p1.eq(p2)) {
          var midPoint = p1.midPointFrom(p2); // p1 is our bezier control point
          // midpoint is our endpoint
          // start point is p(i-1) value.

          path.push('Q ', p1.x, ' ', p1.y, ' ', midPoint.x, ' ', midPoint.y, ' ');
        }

        p1 = points[i];

        if (i + 1 < points.length) {
          p2 = points[i + 1];
        }
      }

      if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
      }

      path.push('L ', p1.x + multSignX * width, ' ', p1.y + multSignY * width);
      return path;
    },

    /**
     * Creates fabric.Path object to add on canvas
     * @param {String} pathData Path data
     * @return {fabric.Path} Path to add on canvas
     */
    createPath: function createPath(pathData) {
      var path = new fabric.Path(pathData, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray
      });

      if (this.shadow) {
        this.shadow.affectStroke = true;
        path.shadow = new fabric.Shadow(this.shadow);
      }

      return path;
    },

    /**
     * Decimate points array with the decimate value
     */
    decimatePoints: function decimatePoints(points, distance) {
      if (points.length <= 2) {
        return points;
      }

      var zoom = this.canvas.getZoom(),
          adjustedDistance = Math.pow(distance / zoom, 2),
          i,
          l = points.length - 1,
          lastPoint = points[0],
          newPoints = [lastPoint],
          cDistance;

      for (i = 1; i < l; i++) {
        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);

        if (cDistance >= adjustedDistance) {
          lastPoint = points[i];
          newPoints.push(lastPoint);
        }
      }

      if (newPoints.length === 1) {
        newPoints.push(new fabric.Point(newPoints[0].x, newPoints[0].y));
      }

      return newPoints;
    },

    /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new fabric path object
     * and add it to the fabric canvas.
     */
    _finalizeAndAddPath: function _finalizeAndAddPath() {
      var ctx = this.canvas.contextTop;
      ctx.closePath();

      if (this.decimate) {
        this._points = this.decimatePoints(this._points, this.decimate);
      }

      var pathData = this.convertPointsToSVGPath(this._points).join('');

      if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
        // do not create 0 width/height paths, as they are
        // rendered inconsistently across browsers
        // Firefox 4, for example, renders a dot,
        // whereas Chrome 10 renders nothing
        this.canvas.requestRenderAll();
        return;
      }

      var path = this.createPath(pathData);
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.fire('before:path:created', {
        path: path
      });
      this.canvas.add(path);
      this.canvas.requestRenderAll();
      path.setCoords();

      this._resetShadow(); // fire event 'path' created


      this.canvas.fire('path:created', {
        path: path
      });
    }
  });
})();
/**
 * CircleBrush class
 * @class fabric.CircleBrush
 */


fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush,
/** @lends fabric.CircleBrush.prototype */
{
  /**
   * Width of a brush
   * @type Number
   * @default
   */
  width: 10,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.CircleBrush} Instance of a circle brush
   */
  initialize: function initialize(canvas) {
    this.canvas = canvas;
    this.points = [];
  },

  /**
   * Invoked inside on mouse down and mouse move
   * @param {Object} pointer
   */
  drawDot: function drawDot(pointer) {
    var point = this.addPoint(pointer),
        ctx = this.canvas.contextTop;

    this._saveAndTransform(ctx);

    this.dot(ctx, point);
    ctx.restore();
  },
  dot: function dot(ctx, point) {
    ctx.fillStyle = point.fill;
    ctx.beginPath();
    ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
    ctx.closePath();
    ctx.fill();
  },

  /**
   * Invoked on mouse down
   */
  onMouseDown: function onMouseDown(pointer) {
    this.points.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);

    this._setShadow();

    this.drawDot(pointer);
  },

  /**
   * Render the full state of the brush
   * @private
   */
  _render: function _render() {
    var ctx = this.canvas.contextTop,
        i,
        len,
        points = this.points;

    this._saveAndTransform(ctx);

    for (i = 0, len = points.length; i < len; i++) {
      this.dot(ctx, points[i]);
    }

    ctx.restore();
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function onMouseMove(pointer) {
    if (this.needsFullRender()) {
      this.canvas.clearContext(this.canvas.contextTop);
      this.addPoint(pointer);

      this._render();
    } else {
      this.drawDot(pointer);
    }
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function onMouseUp() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove,
        i,
        len;
    this.canvas.renderOnAddRemove = false;
    var circles = [];

    for (i = 0, len = this.points.length; i < len; i++) {
      var point = this.points[i],
          circle = new fabric.Circle({
        radius: point.radius,
        left: point.x,
        top: point.y,
        originX: 'center',
        originY: 'center',
        fill: point.fill
      });
      this.shadow && (circle.shadow = new fabric.Shadow(this.shadow));
      circles.push(circle);
    }

    var group = new fabric.Group(circles);
    group.canvas = this.canvas;
    this.canvas.fire('before:path:created', {
      path: group
    });
    this.canvas.add(group);
    this.canvas.fire('path:created', {
      path: group
    });
    this.canvas.clearContext(this.canvas.contextTop);

    this._resetShadow();

    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @param {Object} pointer
   * @return {fabric.Point} Just added pointer point
   */
  addPoint: function addPoint(pointer) {
    var pointerPoint = new fabric.Point(pointer.x, pointer.y),
        circleRadius = fabric.util.getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
        circleColor = new fabric.Color(this.color).setAlpha(fabric.util.getRandomInt(0, 100) / 100).toRgba();
    pointerPoint.radius = circleRadius;
    pointerPoint.fill = circleColor;
    this.points.push(pointerPoint);
    return pointerPoint;
  }
});
/**
 * SprayBrush class
 * @class fabric.SprayBrush
 */

fabric.SprayBrush = fabric.util.createClass(fabric.BaseBrush,
/** @lends fabric.SprayBrush.prototype */
{
  /**
   * Width of a spray
   * @type Number
   * @default
   */
  width: 10,

  /**
   * Density of a spray (number of dots per chunk)
   * @type Number
   * @default
   */
  density: 20,

  /**
   * Width of spray dots
   * @type Number
   * @default
   */
  dotWidth: 1,

  /**
   * Width variance of spray dots
   * @type Number
   * @default
   */
  dotWidthVariance: 1,

  /**
   * Whether opacity of a dot should be random
   * @type Boolean
   * @default
   */
  randomOpacity: false,

  /**
   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
   * @type Boolean
   * @default
   */
  optimizeOverlapping: true,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.SprayBrush} Instance of a spray brush
   */
  initialize: function initialize(canvas) {
    this.canvas = canvas;
    this.sprayChunks = [];
  },

  /**
   * Invoked on mouse down
   * @param {Object} pointer
   */
  onMouseDown: function onMouseDown(pointer) {
    this.sprayChunks.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);

    this._setShadow();

    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function onMouseMove(pointer) {
    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function onMouseUp() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
    this.canvas.renderOnAddRemove = false;
    var rects = [];

    for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      var sprayChunk = this.sprayChunks[i];

      for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {
        var rect = new fabric.Rect({
          width: sprayChunk[j].width,
          height: sprayChunk[j].width,
          left: sprayChunk[j].x + 1,
          top: sprayChunk[j].y + 1,
          originX: 'center',
          originY: 'center',
          fill: this.color
        });
        rects.push(rect);
      }
    }

    if (this.optimizeOverlapping) {
      rects = this._getOptimizedRects(rects);
    }

    var group = new fabric.Group(rects);
    this.shadow && group.set('shadow', new fabric.Shadow(this.shadow));
    this.canvas.fire('before:path:created', {
      path: group
    });
    this.canvas.add(group);
    this.canvas.fire('path:created', {
      path: group
    });
    this.canvas.clearContext(this.canvas.contextTop);

    this._resetShadow();

    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @private
   * @param {Array} rects
   */
  _getOptimizedRects: function _getOptimizedRects(rects) {
    // avoid creating duplicate rects at the same coordinates
    var uniqueRects = {},
        key,
        i,
        len;

    for (i = 0, len = rects.length; i < len; i++) {
      key = rects[i].left + '' + rects[i].top;

      if (!uniqueRects[key]) {
        uniqueRects[key] = rects[i];
      }
    }

    var uniqueRectsArray = [];

    for (key in uniqueRects) {
      uniqueRectsArray.push(uniqueRects[key]);
    }

    return uniqueRectsArray;
  },

  /**
   * Render new chunk of spray brush
   */
  render: function render(sprayChunk) {
    var ctx = this.canvas.contextTop,
        i,
        len;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, len = sprayChunk.length; i < len; i++) {
      var point = sprayChunk[i];

      if (typeof point.opacity !== 'undefined') {
        ctx.globalAlpha = point.opacity;
      }

      ctx.fillRect(point.x, point.y, point.width, point.width);
    }

    ctx.restore();
  },

  /**
   * Render all spray chunks
   */
  _render: function _render() {
    var ctx = this.canvas.contextTop,
        i,
        ilen;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      this.render(this.sprayChunks[i]);
    }

    ctx.restore();
  },

  /**
   * @param {Object} pointer
   */
  addSprayChunk: function addSprayChunk(pointer) {
    this.sprayChunkPoints = [];
    var x,
        y,
        width,
        radius = this.width / 2,
        i;

    for (i = 0; i < this.density; i++) {
      x = fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
      y = fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);

      if (this.dotWidthVariance) {
        width = fabric.util.getRandomInt( // bottom clamp width to 1
        Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance);
      } else {
        width = this.dotWidth;
      }

      var point = new fabric.Point(x, y);
      point.width = width;

      if (this.randomOpacity) {
        point.opacity = fabric.util.getRandomInt(0, 100) / 100;
      }

      this.sprayChunkPoints.push(point);
    }

    this.sprayChunks.push(this.sprayChunkPoints);
  }
});
/**
 * PatternBrush class
 * @class fabric.PatternBrush
 * @extends fabric.BaseBrush
 */

fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush,
/** @lends fabric.PatternBrush.prototype */
{
  getPatternSrc: function getPatternSrc() {
    var dotWidth = 20,
        dotDistance = 5,
        patternCanvas = fabric.util.createCanvasElement(),
        patternCtx = patternCanvas.getContext('2d');
    patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
    patternCtx.fillStyle = this.color;
    patternCtx.beginPath();
    patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
    patternCtx.closePath();
    patternCtx.fill();
    return patternCanvas;
  },
  getPatternSrcFunction: function getPatternSrcFunction() {
    return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
  },

  /**
   * Creates "pattern" instance property
   */
  getPattern: function getPattern() {
    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), 'repeat');
  },

  /**
   * Sets brush styles
   */
  _setBrushStyles: function _setBrushStyles() {
    this.callSuper('_setBrushStyles');
    this.canvas.contextTop.strokeStyle = this.getPattern();
  },

  /**
   * Creates path
   */
  createPath: function createPath(pathData) {
    var path = this.callSuper('createPath', pathData),
        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);

    path.stroke = new fabric.Pattern({
      source: this.source || this.getPatternSrcFunction(),
      offsetX: -topLeft.x,
      offsetY: -topLeft.y
    });
    return path;
  }
});

(function () {
  var _getPointer = fabric.util.getPointer,
      degreesToRadians = fabric.util.degreesToRadians,
      abs = Math.abs,
      supportLineDash = fabric.StaticCanvas.supports('setLineDash'),
      isTouchEvent = fabric.util.isTouchEvent,
      STROKE_OFFSET = 0.5;
  /**
   * Canvas class
   * @class fabric.Canvas
   * @extends fabric.StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   * @see {@link fabric.Canvas#initialize} for constructor definition
   *
   * @fires object:modified at the end of a transform or any change when statefull is true
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   * the following events are deprecated:
   * @fires object:rotated at the end of a rotation transform
   * @fires object:scaled at the end of a scale transform
   * @fires object:moved at the end of translation transform
   * @fires object:skewed at the end of a skew transform
   */

  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas,
  /** @lends fabric.Canvas.prototype */
  {
    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function initialize(el, options) {
      options || (options = {});
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);

      this._initStatic(el, options);

      this._initInteractive();

      this._createCacheCanvas();
    },

    /**
     * When true, objects can be transformed by one side (unproportionally)
     * when dragged on the corners that normally would not do that.
     * @type Boolean
     * @default
     * @since fabric 4.0 // changed name and default value
     */
    uniformScaling: true,

    /**
     * Indicates which key switches uniform scaling.
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * totally wrong named. this sounds like `uniform scaling`
     * if Canvas.uniformScaling is true, pressing this will set it to false
     * and viceversa.
     * @since 1.6.2
     * @type String
     * @default
     */
    uniScaleKey: 'shiftKey',

    /**
     * When true, objects use center point as the origin of scale transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling: false,

    /**
     * When true, objects use center point as the origin of rotate transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation: false,

    /**
     * Indicates which key enable centered Transform
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    centeredKey: 'altKey',

    /**
     * Indicates which key enable alternate action on corner
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    altActionKey: 'shiftKey',

    /**
     * Indicates that canvas is interactive. This property should not be changed.
     * @type Boolean
     * @default
     */
    interactive: true,

    /**
     * Indicates whether group selection should be enabled
     * @type Boolean
     * @default
     */
    selection: true,

    /**
     * Indicates which key or keys enable multiple click selection
     * Pass value as a string or array of strings
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or empty or containing any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.2
     * @type String|Array
     * @default
     */
    selectionKey: 'shiftKey',

    /**
     * Indicates which key enable alternative selection
     * in case of target overlapping with active object
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * For a series of reason that come from the general expectations on how
     * things should work, this feature works only for preserveObjectStacking true.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.5
     * @type null|String
     * @default
     */
    altSelectionKey: null,

    /**
     * Color of selection
     * @type String
     * @default
     */
    selectionColor: 'rgba(100, 100, 255, 0.3)',
    // blue

    /**
     * Default dash array pattern
     * If not empty the selection border is dashed
     * @type Array
     */
    selectionDashArray: [],

    /**
     * Color of the border of selection (usually slightly darker than color of selection itself)
     * @type String
     * @default
     */
    selectionBorderColor: 'rgba(255, 255, 255, 0.3)',

    /**
     * Width of a line used in object/group selection
     * @type Number
     * @default
     */
    selectionLineWidth: 1,

    /**
     * Select only shapes that are fully contained in the dragged selection rectangle.
     * @type Boolean
     * @default
     */
    selectionFullyContained: false,

    /**
     * Default cursor value used when hovering over an object on canvas
     * @type String
     * @default
     */
    hoverCursor: 'move',

    /**
     * Default cursor value used when moving an object on canvas
     * @type String
     * @default
     */
    moveCursor: 'move',

    /**
     * Default cursor value used for the entire canvas
     * @type String
     * @default
     */
    defaultCursor: 'default',

    /**
     * Cursor value used during free drawing
     * @type String
     * @default
     */
    freeDrawingCursor: 'crosshair',

    /**
     * Cursor value used for rotation point
     * @type String
     * @default
     */
    rotationCursor: 'crosshair',

    /**
     * Cursor value used for disabled elements ( corners with disabled action )
     * @type String
     * @since 2.0.0
     * @default
     */
    notAllowedCursor: 'not-allowed',

    /**
     * Default element class that's given to wrapper (div) element of canvas
     * @type String
     * @default
     */
    containerClass: 'canvas-container',

    /**
     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
     * @type Boolean
     * @default
     */
    perPixelTargetFind: false,

    /**
     * Number of pixels around target pixel to tolerate (consider active) during object detection
     * @type Number
     * @default
     */
    targetFindTolerance: 0,

    /**
     * When true, target detection is skipped. Target detection will return always undefined.
     * click selection won't work anymore, events will fire with no targets.
     * if something is selected before setting it to true, it will be deselected at the first click.
     * area selection will still work. check the `selection` property too.
     * if you deactivate both, you should look into staticCanvas.
     * @type Boolean
     * @default
     */
    skipTargetFind: false,

    /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */
    isDrawingMode: false,

    /**
     * Indicates whether objects should remain in current stack position when selected.
     * When false objects are brought to top and rendered as part of the selection group
     * @type Boolean
     * @default
     */
    preserveObjectStacking: false,

    /**
     * Indicates the angle that an object will lock to while rotating.
     * @type Number
     * @since 1.6.7
     * @default
     */
    snapAngle: 0,

    /**
     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
     * When `null`, the snapThreshold will default to the snapAngle.
     * @type null|Number
     * @since 1.6.7
     * @default
     */
    snapThreshold: null,

    /**
     * Indicates if the right click on canvas can output the context menu or not
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    stopContextMenu: false,

    /**
     * Indicates if the canvas can fire right click events
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    fireRightClick: false,

    /**
     * Indicates if the canvas can fire middle click events
     * @type Boolean
     * @since 1.7.8
     * @default
     */
    fireMiddleClick: false,

    /**
     * Keep track of the subTargets for Mouse Events
     * @type fabric.Object[]
     */
    targets: [],

    /**
     * Keep track of the hovered target
     * @type fabric.Object
     * @private
     */
    _hoveredTarget: null,

    /**
     * hold the list of nested targets hovered
     * @type fabric.Object[]
     * @private
     */
    _hoveredTargets: [],

    /**
     * @private
     */
    _initInteractive: function _initInteractive() {
      this._currentTransform = null;
      this._groupSelector = null;

      this._initWrapperElement();

      this._createUpperCanvas();

      this._initEventListeners();

      this._initRetinaScaling();

      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);
      this.calcOffset();
    },

    /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */
    _chooseObjectsToRender: function _chooseObjectsToRender() {
      var activeObjects = this.getActiveObjects(),
          object,
          objsToRender,
          activeGroupObjects;

      if (activeObjects.length > 0 && !this.preserveObjectStacking) {
        objsToRender = [];
        activeGroupObjects = [];

        for (var i = 0, length = this._objects.length; i < length; i++) {
          object = this._objects[i];

          if (activeObjects.indexOf(object) === -1) {
            objsToRender.push(object);
          } else {
            activeGroupObjects.push(object);
          }
        }

        if (activeObjects.length > 1) {
          this._activeObject._objects = activeGroupObjects;
        }

        objsToRender.push.apply(objsToRender, activeGroupObjects);
      } else {
        objsToRender = this._objects;
      }

      return objsToRender;
    },

    /**
     * Renders both the top canvas and the secondary container canvas.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function renderAll() {
      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
        this.clearContext(this.contextTop);
        this.contextTopDirty = false;
      }

      if (this.hasLostContext) {
        this.renderTopLayer(this.contextTop);
      }

      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
      return this;
    },
    renderTopLayer: function renderTopLayer(ctx) {
      ctx.save();

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._render();
        this.contextTopDirty = true;
      } // we render the top context - last object


      if (this.selection && this._groupSelector) {
        this._drawSelection(ctx);

        this.contextTopDirty = true;
      }

      ctx.restore();
    },

    /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    renderTop: function renderTop() {
      var ctx = this.contextTop;
      this.clearContext(ctx);
      this.renderTopLayer(ctx);
      this.fire('after:render');
      return this;
    },

    /**
     * @private
     */
    _normalizePointer: function _normalizePointer(object, pointer) {
      var m = object.calcTransformMatrix(),
          invertedM = fabric.util.invertTransform(m),
          vptPointer = this.restorePointerVpt(pointer);
      return fabric.util.transformPoint(vptPointer, invertedM);
    },

    /**
     * Returns true if object is transparent at a certain location
     * @param {fabric.Object} target Object to check
     * @param {Number} x Left coordinate
     * @param {Number} y Top coordinate
     * @return {Boolean}
     */
    isTargetTransparent: function isTargetTransparent(target, x, y) {
      // in case the target is the activeObject, we cannot execute this optimization
      // because we need to draw controls too.
      if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
        var normalizedPointer = this._normalizePointer(target, {
          x: x,
          y: y
        }),
            targetRelativeX = Math.max(target.cacheTranslationX + normalizedPointer.x * target.zoomX, 0),
            targetRelativeY = Math.max(target.cacheTranslationY + normalizedPointer.y * target.zoomY, 0);

        var isTransparent = fabric.util.isTransparent(target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);
        return isTransparent;
      }

      var ctx = this.contextCache,
          originalColor = target.selectionBackgroundColor,
          v = this.viewportTransform;
      target.selectionBackgroundColor = '';
      this.clearContext(ctx);
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      target.render(ctx);
      ctx.restore();
      target === this._activeObject && target._renderControls(ctx, {
        hasBorders: false,
        transparentCorners: false
      }, {
        hasBorders: false
      });
      target.selectionBackgroundColor = originalColor;
      var isTransparent = fabric.util.isTransparent(ctx, x, y, this.targetFindTolerance);
      return isTransparent;
    },

    /**
     * takes an event and determines if selection key has been pressed
     * @private
     * @param {Event} e Event object
     */
    _isSelectionKeyPressed: function _isSelectionKeyPressed(e) {
      var selectionKeyPressed = false;

      if (Object.prototype.toString.call(this.selectionKey) === '[object Array]') {
        selectionKeyPressed = !!this.selectionKey.find(function (key) {
          return e[key] === true;
        });
      } else {
        selectionKeyPressed = e[this.selectionKey];
      }

      return selectionKeyPressed;
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _shouldClearSelection: function _shouldClearSelection(e, target) {
      var activeObjects = this.getActiveObjects(),
          activeObject = this._activeObject;
      return !target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target;
    },

    /**
     * centeredScaling from object can't override centeredScaling from canvas.
     * this should be fixed, since object setting should take precedence over canvas.
     * also this should be something that will be migrated in the control properties.
     * as ability to define the origin of the transformation that the control provide.
     * @private
     * @param {fabric.Object} target
     * @param {String} action
     * @param {Boolean} altKey
     */
    _shouldCenterTransform: function _shouldCenterTransform(target, action, altKey) {
      if (!target) {
        return;
      }

      var centerTransform;

      if (action === 'scale' || action === 'scaleX' || action === 'scaleY' || action === 'resizing') {
        centerTransform = this.centeredScaling || target.centeredScaling;
      } else if (action === 'rotate') {
        centerTransform = this.centeredRotation || target.centeredRotation;
      }

      return centerTransform ? !altKey : altKey;
    },

    /**
     * should disappear before release 4.0
     * @private
     */
    _getOriginFromCorner: function _getOriginFromCorner(target, corner) {
      var origin = {
        x: target.originX,
        y: target.originY
      };

      if (corner === 'ml' || corner === 'tl' || corner === 'bl') {
        origin.x = 'right';
      } else if (corner === 'mr' || corner === 'tr' || corner === 'br') {
        origin.x = 'left';
      }

      if (corner === 'tl' || corner === 'mt' || corner === 'tr') {
        origin.y = 'bottom';
      } else if (corner === 'bl' || corner === 'mb' || corner === 'br') {
        origin.y = 'top';
      }

      return origin;
    },

    /**
     * @private
     * @param {Boolean} alreadySelected true if target is already selected
     * @param {String} corner a string representing the corner ml, mr, tl ...
     * @param {Event} e Event object
     * @param {fabric.Object} [target] inserted back to help overriding. Unused
     */
    _getActionFromCorner: function _getActionFromCorner(alreadySelected, corner, e, target) {
      if (!corner || !alreadySelected) {
        return 'drag';
      }

      var control = target.controls[corner];
      return control.getActionName(e, control, target);
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _setupCurrentTransform: function _setupCurrentTransform(e, target, alreadySelected) {
      if (!target) {
        return;
      }

      var pointer = this.getPointer(e),
          corner = target.__corner,
          control = target.controls[corner],
          actionHandler = alreadySelected && corner ? control.getActionHandler(e, target, control) : fabric.controlsUtils.dragHandler,
          action = this._getActionFromCorner(alreadySelected, corner, e, target),
          origin = this._getOriginFromCorner(target, corner),
          altKey = e[this.centeredKey],
          transform = {
        target: target,
        action: action,
        actionHandler: actionHandler,
        corner: corner,
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        // used by transation
        offsetX: pointer.x - target.left,
        offsetY: pointer.y - target.top,
        originX: origin.x,
        originY: origin.y,
        ex: pointer.x,
        ey: pointer.y,
        lastX: pointer.x,
        lastY: pointer.y,
        // unsure they are useful anymore.
        // left: target.left,
        // top: target.top,
        theta: degreesToRadians(target.angle),
        // end of unsure
        width: target.width * target.scaleX,
        shiftKey: e.shiftKey,
        altKey: altKey,
        original: fabric.util.saveObjectTransform(target)
      };

      if (this._shouldCenterTransform(target, action, altKey)) {
        transform.originX = 'center';
        transform.originY = 'center';
      }

      transform.original.originX = origin.x;
      transform.original.originY = origin.y;
      this._currentTransform = transform;

      this._beforeTransform(e);
    },

    /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */
    setCursor: function setCursor(value) {
      this.upperCanvasEl.style.cursor = value;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */
    _drawSelection: function _drawSelection(ctx) {
      var groupSelector = this._groupSelector,
          left = groupSelector.left,
          top = groupSelector.top,
          aleft = abs(left),
          atop = abs(top);

      if (this.selectionColor) {
        ctx.fillStyle = this.selectionColor;
        ctx.fillRect(groupSelector.ex - (left > 0 ? 0 : -left), groupSelector.ey - (top > 0 ? 0 : -top), aleft, atop);
      }

      if (!this.selectionLineWidth || !this.selectionBorderColor) {
        return;
      }

      ctx.lineWidth = this.selectionLineWidth;
      ctx.strokeStyle = this.selectionBorderColor; // selection border

      if (this.selectionDashArray.length > 1 && !supportLineDash) {
        var px = groupSelector.ex + STROKE_OFFSET - (left > 0 ? 0 : aleft),
            py = groupSelector.ey + STROKE_OFFSET - (top > 0 ? 0 : atop);
        ctx.beginPath();
        fabric.util.drawDashedLine(ctx, px, py, px + aleft, py, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py + atop - 1, px + aleft, py + atop - 1, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py, px, py + atop, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px + aleft - 1, py, px + aleft - 1, py + atop, this.selectionDashArray);
        ctx.closePath();
        ctx.stroke();
      } else {
        fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);

        ctx.strokeRect(groupSelector.ex + STROKE_OFFSET - (left > 0 ? 0 : aleft), groupSelector.ey + STROKE_OFFSET - (top > 0 ? 0 : atop), aleft, atop);
      }
    },

    /**
     * Method that determines what object we are clicking on
     * the skipGroup parameter is for internal use, is needed for shift+click action
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
     * @return {fabric.Object} the target found
     */
    findTarget: function findTarget(e, skipGroup) {
      if (this.skipTargetFind) {
        return;
      }

      var ignoreZoom = true,
          pointer = this.getPointer(e, ignoreZoom),
          activeObject = this._activeObject,
          aObjects = this.getActiveObjects(),
          activeTarget,
          activeTargetSubs,
          isTouch = isTouchEvent(e); // first check current group (if one exists)
      // active group does not check sub targets like normal groups.
      // if active group just exits.

      this.targets = [];

      if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        return activeObject;
      } // if we hit the corner of an activeObject, let's return that.


      if (aObjects.length === 1 && activeObject._findTargetCorner(pointer, isTouch)) {
        return activeObject;
      }

      if (aObjects.length === 1 && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        if (!this.preserveObjectStacking) {
          return activeObject;
        } else {
          activeTarget = activeObject;
          activeTargetSubs = this.targets;
          this.targets = [];
        }
      }

      var target = this._searchPossibleTargets(this._objects, pointer);

      if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
        target = activeTarget;
        this.targets = activeTargetSubs;
      }

      return target;
    },

    /**
     * Checks point is inside the object.
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @param {fabric.Object} obj Object to test against
     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */
    _checkTarget: function _checkTarget(pointer, obj, globalPointer) {
      if (obj && obj.visible && obj.evented && ( // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
      // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
      obj.containsPoint(pointer) || !!obj._findTargetCorner(pointer))) {
        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
          var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);

          if (!isTransparent) {
            return true;
          }
        } else {
          return true;
        }
      }
    },

    /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {fabric.Object} object that contains pointer
     * @private
     */
    _searchPossibleTargets: function _searchPossibleTargets(objects, pointer) {
      // Cache all targets where their bounding box contains point.
      var target,
          i = objects.length,
          subTarget; // Do not check for currently grouped objects, since we check the parent group itself.
      // until we call this function specifically to search inside the activeGroup

      while (i--) {
        var objToCheck = objects[i];
        var pointerToUse = objToCheck.group ? this._normalizePointer(objToCheck.group, pointer) : pointer;

        if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
          target = objects[i];

          if (target.subTargetCheck && target instanceof fabric.Group) {
            subTarget = this._searchPossibleTargets(target._objects, pointer);
            subTarget && this.targets.push(subTarget);
          }

          break;
        }
      }

      return target;
    },

    /**
     * Returns pointer coordinates without the effect of the viewport
     * @param {Object} pointer with "x" and "y" number values
     * @return {Object} object with "x" and "y" number values
     */
    restorePointerVpt: function restorePointerVpt(pointer) {
      return fabric.util.transformPoint(pointer, fabric.util.invertTransform(this.viewportTransform));
    },

    /**
     * Returns pointer coordinates relative to canvas.
     * Can return coordinates with or without viewportTransform.
     * ignoreZoom false gives back coordinates that represent
     * the point clicked on canvas element.
     * ignoreZoom true gives back coordinates after being processed
     * by the viewportTransform ( sort of coordinates of what is displayed
     * on the canvas where you are clicking.
     * ignoreZoom true = HTMLElement coordinates relative to top,left
     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
     * To interact with your shapes top and left you want to use ignoreZoom true
     * most of the time, while ignoreZoom false will give you coordinates
     * compatible with the object.oCoords system.
     * of the time.
     * @param {Event} e
     * @param {Boolean} ignoreZoom
     * @return {Object} object with "x" and "y" number values
     */
    getPointer: function getPointer(e, ignoreZoom) {
      // return cached values if we are in the event processing chain
      if (this._absolutePointer && !ignoreZoom) {
        return this._absolutePointer;
      }

      if (this._pointer && ignoreZoom) {
        return this._pointer;
      }

      var pointer = _getPointer(e),
          upperCanvasEl = this.upperCanvasEl,
          bounds = upperCanvasEl.getBoundingClientRect(),
          boundsWidth = bounds.width || 0,
          boundsHeight = bounds.height || 0,
          cssScale;

      if (!boundsWidth || !boundsHeight) {
        if ('top' in bounds && 'bottom' in bounds) {
          boundsHeight = Math.abs(bounds.top - bounds.bottom);
        }

        if ('right' in bounds && 'left' in bounds) {
          boundsWidth = Math.abs(bounds.right - bounds.left);
        }
      }

      this.calcOffset();
      pointer.x = pointer.x - this._offset.left;
      pointer.y = pointer.y - this._offset.top;

      if (!ignoreZoom) {
        pointer = this.restorePointerVpt(pointer);
      }

      var retinaScaling = this.getRetinaScaling();

      if (retinaScaling !== 1) {
        pointer.x /= retinaScaling;
        pointer.y /= retinaScaling;
      }

      if (boundsWidth === 0 || boundsHeight === 0) {
        // If bounds are not available (i.e. not visible), do not apply scale.
        cssScale = {
          width: 1,
          height: 1
        };
      } else {
        cssScale = {
          width: upperCanvasEl.width / boundsWidth,
          height: upperCanvasEl.height / boundsHeight
        };
      }

      return {
        x: pointer.x * cssScale.width,
        y: pointer.y * cssScale.height
      };
    },

    /**
     * @private
     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
     */
    _createUpperCanvas: function _createUpperCanvas() {
      var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ''),
          lowerCanvasEl = this.lowerCanvasEl,
          upperCanvasEl = this.upperCanvasEl; // there is no need to create a new upperCanvas element if we have already one.

      if (upperCanvasEl) {
        upperCanvasEl.className = '';
      } else {
        upperCanvasEl = this._createCanvasElement();
        this.upperCanvasEl = upperCanvasEl;
      }

      fabric.util.addClass(upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);
      this.wrapperEl.appendChild(upperCanvasEl);

      this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);

      this._applyCanvasStyle(upperCanvasEl);

      this.contextTop = upperCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _createCacheCanvas: function _createCacheCanvas() {
      this.cacheCanvasEl = this._createCanvasElement();
      this.cacheCanvasEl.setAttribute('width', this.width);
      this.cacheCanvasEl.setAttribute('height', this.height);
      this.contextCache = this.cacheCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _initWrapperElement: function _initWrapperElement() {
      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
        'class': this.containerClass
      });
      fabric.util.setStyle(this.wrapperEl, {
        width: this.width + 'px',
        height: this.height + 'px',
        position: 'relative'
      });
      fabric.util.makeElementUnselectable(this.wrapperEl);
    },

    /**
     * @private
     * @param {HTMLElement} element canvas element to apply styles on
     */
    _applyCanvasStyle: function _applyCanvasStyle(element) {
      var width = this.width || element.width,
          height = this.height || element.height;
      fabric.util.setStyle(element, {
        position: 'absolute',
        width: width + 'px',
        height: height + 'px',
        left: 0,
        top: 0,
        'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
        '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
      });
      element.width = width;
      element.height = height;
      fabric.util.makeElementUnselectable(element);
    },

    /**
     * Copy the entire inline style from one element (fromEl) to another (toEl)
     * @private
     * @param {Element} fromEl Element style is copied from
     * @param {Element} toEl Element copied style is applied to
     */
    _copyCanvasStyle: function _copyCanvasStyle(fromEl, toEl) {
      toEl.style.cssText = fromEl.style.cssText;
    },

    /**
     * Returns context of canvas where object selection is drawn
     * @return {CanvasRenderingContext2D}
     */
    getSelectionContext: function getSelectionContext() {
      return this.contextTop;
    },

    /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */
    getSelectionElement: function getSelectionElement() {
      return this.upperCanvasEl;
    },

    /**
     * Returns currently active object
     * @return {fabric.Object} active object
     */
    getActiveObject: function getActiveObject() {
      return this._activeObject;
    },

    /**
     * Returns an array with the current selected objects
     * @return {fabric.Object} active object
     */
    getActiveObjects: function getActiveObjects() {
      var active = this._activeObject;

      if (active) {
        if (active.type === 'activeSelection' && active._objects) {
          return active._objects.slice(0);
        } else {
          return [active];
        }
      }

      return [];
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function _onObjectRemoved(obj) {
      // removing active object should fire "selection:cleared" events
      if (obj === this._activeObject) {
        this.fire('before:selection:cleared', {
          target: obj
        });

        this._discardActiveObject();

        this.fire('selection:cleared', {
          target: obj
        });
        obj.fire('deselected');
      }

      if (obj === this._hoveredTarget) {
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }

      this.callSuper('_onObjectRemoved', obj);
    },

    /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {fabric.Object} obj old activeObject
     */
    _fireSelectionEvents: function _fireSelectionEvents(oldObjects, e) {
      var somethingChanged = false,
          objects = this.getActiveObjects(),
          added = [],
          removed = [],
          opt = {
        e: e
      };
      oldObjects.forEach(function (oldObject) {
        if (objects.indexOf(oldObject) === -1) {
          somethingChanged = true;
          oldObject.fire('deselected', opt);
          removed.push(oldObject);
        }
      });
      objects.forEach(function (object) {
        if (oldObjects.indexOf(object) === -1) {
          somethingChanged = true;
          object.fire('selected', opt);
          added.push(object);
        }
      });

      if (oldObjects.length > 0 && objects.length > 0) {
        opt.selected = added;
        opt.deselected = removed; // added for backward compatibility

        opt.updated = added[0] || removed[0];
        opt.target = this._activeObject;
        somethingChanged && this.fire('selection:updated', opt);
      } else if (objects.length > 0) {
        opt.selected = added; // added for backward compatibility

        opt.target = this._activeObject;
        this.fire('selection:created', opt);
      } else if (oldObjects.length > 0) {
        opt.deselected = removed;
        this.fire('selection:cleared', opt);
      }
    },

    /**
     * Sets given object as the only active object on canvas
     * @param {fabric.Object} object Object to set as an active one
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setActiveObject: function setActiveObject(object, e) {
      var currentActives = this.getActiveObjects();

      this._setActiveObject(object, e);

      this._fireSelectionEvents(currentActives, e);

      return this;
    },

    /**
     * @private
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the selection happened
     */
    _setActiveObject: function _setActiveObject(object, e) {
      if (this._activeObject === object) {
        return false;
      }

      if (!this._discardActiveObject(e, object)) {
        return false;
      }

      if (object.onSelect({
        e: e
      })) {
        return false;
      }

      this._activeObject = object;
      return true;
    },

    /**
     * @private
     */
    _discardActiveObject: function _discardActiveObject(e, object) {
      var obj = this._activeObject;

      if (obj) {
        // onDeselect return TRUE to cancel selection;
        if (obj.onDeselect({
          e: e,
          object: object
        })) {
          return false;
        }

        this._activeObject = null;
      }

      return true;
    },

    /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    discardActiveObject: function discardActiveObject(e) {
      var currentActives = this.getActiveObjects(),
          activeObject = this.getActiveObject();

      if (currentActives.length) {
        this.fire('before:selection:cleared', {
          target: activeObject,
          e: e
        });
      }

      this._discardActiveObject(e);

      this._fireSelectionEvents(currentActives, e);

      return this;
    },

    /**
     * Clears a canvas element and removes all event listeners
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function dispose() {
      var wrapper = this.wrapperEl;
      this.removeListeners();
      wrapper.removeChild(this.upperCanvasEl);
      wrapper.removeChild(this.lowerCanvasEl);
      this.contextCache = null;
      this.contextTop = null;
      ['upperCanvasEl', 'cacheCanvasEl'].forEach(function (element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }.bind(this));

      if (wrapper.parentNode) {
        wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
      }

      delete this.wrapperEl;
      fabric.StaticCanvas.prototype.dispose.call(this);
      return this;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function clear() {
      // this.discardActiveGroup();
      this.discardActiveObject();
      this.clearContext(this.contextTop);
      return this.callSuper('clear');
    },

    /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */
    drawControls: function drawControls(ctx) {
      var activeObject = this._activeObject;

      if (activeObject) {
        activeObject._renderControls(ctx);
      }
    },

    /**
     * @private
     */
    _toObject: function _toObject(instance, methodName, propertiesToInclude) {
      //If the object is part of the current selection group, it should
      //be transformed appropriately
      //i.e. it should be serialised as it would appear if the selection group
      //were to be destroyed.
      var originalProperties = this._realizeGroupTransformOnObject(instance),
          object = this.callSuper('_toObject', instance, methodName, propertiesToInclude); //Undo the damage we did by changing all of its properties


      this._unwindGroupTransformOnObject(instance, originalProperties);

      return object;
    },

    /**
     * Realises an object's group transformation on it
     * @private
     * @param {fabric.Object} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */
    _realizeGroupTransformOnObject: function _realizeGroupTransformOnObject(instance) {
      if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
        var layoutProps = ['angle', 'flipX', 'flipY', 'left', 'scaleX', 'scaleY', 'skewX', 'skewY', 'top']; //Copy all the positionally relevant properties across now

        var originalValues = {};
        layoutProps.forEach(function (prop) {
          originalValues[prop] = instance[prop];
        });

        this._activeObject.realizeTransform(instance);

        return originalValues;
      } else {
        return null;
      }
    },

    /**
     * Restores the changed properties of instance
     * @private
     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
     */
    _unwindGroupTransformOnObject: function _unwindGroupTransformOnObject(instance, originalValues) {
      if (originalValues) {
        instance.set(originalValues);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function _setSVGObject(markup, instance, reviver) {
      //If the object is in a selection group, simulate what would happen to that
      //object when the group is deselected
      var originalProperties = this._realizeGroupTransformOnObject(instance);

      this.callSuper('_setSVGObject', markup, instance, reviver);

      this._unwindGroupTransformOnObject(instance, originalProperties);
    },
    setViewportTransform: function setViewportTransform(vpt) {
      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
        this._activeObject.clearContextTop();
      }

      fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
    }
  }); // copying static properties manually to work around Opera's bug,
  // where "prototype" property is enumerable and overrides existing prototype

  for (var prop in fabric.StaticCanvas) {
    if (prop !== 'prototype') {
      fabric.Canvas[prop] = fabric.StaticCanvas[prop];
    }
  }
})();

(function () {
  var addListener = fabric.util.addListener,
      removeListener = fabric.util.removeListener,
      RIGHT_CLICK = 3,
      MIDDLE_CLICK = 2,
      LEFT_CLICK = 1,
      addEventOptions = {
    passive: false
  };

  function checkClick(e, value) {
    return e.button && e.button === value - 1;
  }

  fabric.util.object.extend(fabric.Canvas.prototype,
  /** @lends fabric.Canvas.prototype */
  {
    /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */
    mainTouchId: null,

    /**
     * Adds mouse listeners to canvas
     * @private
     */
    _initEventListeners: function _initEventListeners() {
      // in case we initialized the class twice. This should not happen normally
      // but in some kind of applications where the canvas element may be changed
      // this is a workaround to having double listeners.
      this.removeListeners();

      this._bindEvents();

      this.addOrRemove(addListener, 'add');
    },

    /**
     * return an event prefix pointer or mouse.
     * @private
     */
    _getEventPrefix: function _getEventPrefix() {
      return this.enablePointerEvents ? 'pointer' : 'mouse';
    },
    addOrRemove: function addOrRemove(functor, eventjsFunctor) {
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();

      functor(fabric.window, 'resize', this._onResize);
      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
      functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
      functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
      functor(canvasElement, 'wheel', this._onMouseWheel);
      functor(canvasElement, 'contextmenu', this._onContextMenu);
      functor(canvasElement, 'dblclick', this._onDoubleClick);
      functor(canvasElement, 'dragover', this._onDragOver);
      functor(canvasElement, 'dragenter', this._onDragEnter);
      functor(canvasElement, 'dragleave', this._onDragLeave);
      functor(canvasElement, 'drop', this._onDrop);

      if (!this.enablePointerEvents) {
        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
      }

      if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
        eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
        eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
        eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
        eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
        eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
      }
    },

    /**
     * Removes all event listeners
     */
    removeListeners: function removeListeners() {
      this.addOrRemove(removeListener, 'remove'); // if you dispose on a mouseDown, before mouse up, you need to clean document to...

      var eventTypePrefix = this._getEventPrefix();

      removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     */
    _bindEvents: function _bindEvents() {
      if (this.eventsBound) {
        // for any reason we pass here twice we do not want to bind events twice.
        return;
      }

      this._onMouseDown = this._onMouseDown.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onGesture = this._onGesture.bind(this);
      this._onDrag = this._onDrag.bind(this);
      this._onShake = this._onShake.bind(this);
      this._onLongPress = this._onLongPress.bind(this);
      this._onOrientationChange = this._onOrientationChange.bind(this);
      this._onMouseWheel = this._onMouseWheel.bind(this);
      this._onMouseOut = this._onMouseOut.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onContextMenu = this._onContextMenu.bind(this);
      this._onDoubleClick = this._onDoubleClick.bind(this);
      this._onDragOver = this._onDragOver.bind(this);
      this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
      this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
      this._onDrop = this._simpleEventHandler.bind(this, 'drop');
      this.eventsBound = true;
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js gesture
     * @param {Event} [self] Inner Event object
     */
    _onGesture: function _onGesture(e, self) {
      this.__onTransformGesture && this.__onTransformGesture(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js drag
     * @param {Event} [self] Inner Event object
     */
    _onDrag: function _onDrag(e, self) {
      this.__onDrag && this.__onDrag(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */
    _onMouseWheel: function _onMouseWheel(e) {
      this.__onMouseWheel(e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseOut: function _onMouseOut(e) {
      var target = this._hoveredTarget;
      this.fire('mouse:out', {
        target: target,
        e: e
      });
      this._hoveredTarget = null;
      target && target.fire('mouseout', {
        e: e
      });

      var _this = this;

      this._hoveredTargets.forEach(function (_target) {
        _this.fire('mouse:out', {
          target: target,
          e: e
        });

        _target && target.fire('mouseout', {
          e: e
        });
      });

      this._hoveredTargets = [];

      if (this._iTextInstances) {
        this._iTextInstances.forEach(function (obj) {
          if (obj.isEditing) {
            obj.hiddenTextarea.focus();
          }
        });
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */
    _onMouseEnter: function _onMouseEnter(e) {
      // This find target and consequent 'mouse:over' is used to
      // clear old instances on hovered target.
      // calling findTarget has the side effect of killing target.__corner.
      // as a short term fix we are not firing this if we are currently transforming.
      // as a long term fix we need to separate the action of finding a target with the
      // side effects we added to it.
      if (!this._currentTransform && !this.findTarget(e)) {
        this.fire('mouse:over', {
          target: null,
          e: e
        });
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js orientation change
     * @param {Event} [self] Inner Event object
     */
    _onOrientationChange: function _onOrientationChange(e, self) {
      this.__onOrientationChange && this.__onOrientationChange(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onShake: function _onShake(e, self) {
      this.__onShake && this.__onShake(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onLongPress: function _onLongPress(e, self) {
      this.__onLongPress && this.__onLongPress(e, self);
    },

    /**
     * prevent default to allow drop event to be fired
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */
    _onDragOver: function _onDragOver(e) {
      e.preventDefault();

      var target = this._simpleEventHandler('dragover', e);

      this._fireEnterLeaveEvents(target, e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onContextMenu: function _onContextMenu(e) {
      if (this.stopContextMenu) {
        e.stopPropagation();
        e.preventDefault();
      }

      return false;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onDoubleClick: function _onDoubleClick(e) {
      this._cacheTransformEventData(e);

      this._handleEvent(e, 'dblclick');

      this._resetTransformEventData(e);
    },

    /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */
    getPointerId: function getPointerId(evt) {
      var changedTouches = evt.changedTouches;

      if (changedTouches) {
        return changedTouches[0] && changedTouches[0].identifier;
      }

      if (this.enablePointerEvents) {
        return evt.pointerId;
      }

      return -1;
    },

    /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */
    _isMainEvent: function _isMainEvent(evt) {
      if (evt.isPrimary === true) {
        return true;
      }

      if (evt.isPrimary === false) {
        return false;
      }

      if (evt.type === 'touchend' && evt.touches.length === 0) {
        return true;
      }

      if (evt.changedTouches) {
        return evt.changedTouches[0].identifier === this.mainTouchId;
      }

      return true;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchStart: function _onTouchStart(e) {
      e.preventDefault();

      if (this.mainTouchId === null) {
        this.mainTouchId = this.getPointerId(e);
      }

      this.__onMouseDown(e);

      this._resetTransformEventData();

      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();

      addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions); // Unbind mousedown to prevent double triggers from touch devices

      removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDown: function _onMouseDown(e) {
      this.__onMouseDown(e);

      this._resetTransformEventData();

      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();

      removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      addListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      addListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchEnd: function _onTouchEnd(e) {
      if (e.touches.length > 0) {
        // if there are still touches stop here
        return;
      }

      this.__onMouseUp(e);

      this._resetTransformEventData();

      this.mainTouchId = null;

      var eventTypePrefix = this._getEventPrefix();

      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);

      var _this = this;

      if (this._willAddMouseDown) {
        clearTimeout(this._willAddMouseDown);
      }

      this._willAddMouseDown = setTimeout(function () {
        // Wait 400ms before rebinding mousedown to prevent double triggers
        // from touch devices
        addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
        _this._willAddMouseDown = 0;
      }, 400);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUp: function _onMouseUp(e) {
      this.__onMouseUp(e);

      this._resetTransformEventData();

      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();

      if (this._isMainEvent(e)) {
        removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
        removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
        addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMove: function _onMouseMove(e) {
      !this.allowTouchScrolling && e.preventDefault && e.preventDefault();

      this.__onMouseMove(e);
    },

    /**
     * @private
     */
    _onResize: function _onResize() {
      this.calcOffset();
    },

    /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */
    _shouldRender: function _shouldRender(target) {
      var activeObject = this._activeObject;

      if (!!activeObject !== !!target || activeObject && target && activeObject !== target) {
        // this covers: switch of target, from target to no target, selection of target
        // multiSelection with key and mouse
        return true;
      } else if (activeObject && activeObject.isEditing) {
        // if we mouse up/down over a editing textbox a cursor change,
        // there is no need to re render
        return false;
      }

      return false;
    },

    /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseUp: function __onMouseUp(e) {
      var target,
          transform = this._currentTransform,
          groupSelector = this._groupSelector,
          shouldRender = false,
          isClick = !groupSelector || groupSelector.left === 0 && groupSelector.top === 0;

      this._cacheTransformEventData(e);

      target = this._target;

      this._handleEvent(e, 'up:before'); // if right/middle click just fire events and return
      // target undefined will make the _handleEvent search the target


      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
        }

        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
        }

        this._resetTransformEventData();

        return;
      }

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this._onMouseUpInDrawingMode(e);

        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      if (transform) {
        this._finalizeCurrentTransform(e);

        shouldRender = transform.actionPerformed;
      }

      if (!isClick) {
        var targetWasActive = target === this._activeObject;

        this._maybeGroupObjects(e);

        if (!shouldRender) {
          shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
        }
      }

      if (target) {
        var corner = target._findTargetCorner(this.getPointer(e, true), fabric.util.isTouchEvent(e));

        var control = target.controls[corner],
            mouseUpHandler = control && control.getMouseUpHandler(e, target, control);

        if (mouseUpHandler) {
          var pointer = this.getPointer(e);
          mouseUpHandler(e, transform, pointer.x, pointer.y);
        }

        target.isMoving = false;
      }

      this._setCursorFromEvent(e, target);

      this._handleEvent(e, 'up', LEFT_CLICK, isClick);

      this._groupSelector = null;
      this._currentTransform = null; // reset the target information about which corner is selected

      target && (target.__corner = 0);

      if (shouldRender) {
        this.requestRenderAll();
      } else if (!isClick) {
        this.renderTop();
      }
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @return {Fabric.Object} target return the the target found, for internal reasons.
     */
    _simpleEventHandler: function _simpleEventHandler(eventType, e) {
      var target = this.findTarget(e),
          targets = this.targets,
          options = {
        e: e,
        target: target,
        subTargets: targets
      };
      this.fire(eventType, options);
      target && target.fire(eventType, options);

      if (!targets) {
        return target;
      }

      for (var i = 0; i < targets.length; i++) {
        targets[i].fire(eventType, options);
      }

      return target;
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @param {fabric.Object} targetObj receiving event
     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
     */
    _handleEvent: function _handleEvent(e, eventType, button, isClick) {
      var target = this._target,
          targets = this.targets || [],
          options = {
        e: e,
        target: target,
        subTargets: targets,
        button: button || LEFT_CLICK,
        isClick: isClick || false,
        pointer: this._pointer,
        absolutePointer: this._absolutePointer,
        transform: this._currentTransform
      };

      if (eventType === 'up') {
        options.currentTarget = this.findTarget(e);
        options.currentSubTargets = this.targets;
      }

      this.fire('mouse:' + eventType, options);
      target && target.fire('mouse' + eventType, options);

      for (var i = 0; i < targets.length; i++) {
        targets[i].fire('mouse' + eventType, options);
      }
    },

    /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */
    _finalizeCurrentTransform: function _finalizeCurrentTransform(e) {
      var transform = this._currentTransform,
          target = transform.target,
          eventName,
          options = {
        e: e,
        target: target,
        transform: transform,
        action: transform.action
      };

      if (target._scaling) {
        target._scaling = false;
      }

      target.setCoords();

      if (transform.actionPerformed || this.stateful && target.hasStateChanged()) {
        if (transform.actionPerformed) {
          // this is not friendly to the new control api.
          // is deprecated.
          eventName = this._addEventOptions(options, transform);

          this._fire(eventName, options);
        }

        this._fire('modified', options);
      }
    },

    /**
     * Mutate option object in order to add by property and give back the event name.
     * @private
     * @deprecated since 4.2.0
     * @param {Object} options to mutate
     * @param {Object} transform to inspect action from
     */
    _addEventOptions: function _addEventOptions(options, transform) {
      // we can probably add more details at low cost
      // scale change, rotation changes, translation changes
      var eventName, by;

      switch (transform.action) {
        case 'scaleX':
          eventName = 'scaled';
          by = 'x';
          break;

        case 'scaleY':
          eventName = 'scaled';
          by = 'y';
          break;

        case 'skewX':
          eventName = 'skewed';
          by = 'x';
          break;

        case 'skewY':
          eventName = 'skewed';
          by = 'y';
          break;

        case 'scale':
          eventName = 'scaled';
          by = 'equally';
          break;

        case 'rotate':
          eventName = 'rotated';
          break;

        case 'drag':
          eventName = 'moved';
          break;
      }

      options.by = by;
      return eventName;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDownInDrawingMode: function _onMouseDownInDrawingMode(e) {
      this._isCurrentlyDrawing = true;

      if (this.getActiveObject()) {
        this.discardActiveObject(e).requestRenderAll();
      }

      var pointer = this.getPointer(e);
      this.freeDrawingBrush.onMouseDown(pointer, {
        e: e,
        pointer: pointer
      });

      this._handleEvent(e, 'down');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMoveInDrawingMode: function _onMouseMoveInDrawingMode(e) {
      if (this._isCurrentlyDrawing) {
        var pointer = this.getPointer(e);
        this.freeDrawingBrush.onMouseMove(pointer, {
          e: e,
          pointer: pointer
        });
      }

      this.setCursor(this.freeDrawingCursor);

      this._handleEvent(e, 'move');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUpInDrawingMode: function _onMouseUpInDrawingMode(e) {
      var pointer = this.getPointer(e);
      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({
        e: e,
        pointer: pointer
      });

      this._handleEvent(e, 'up');
    },

    /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    __onMouseDown: function __onMouseDown(e) {
      this._cacheTransformEventData(e);

      this._handleEvent(e, 'down:before');

      var target = this._target; // if right click just fire events

      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'down', RIGHT_CLICK);
        }

        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'down', MIDDLE_CLICK);
        }

        return;
      }

      if (this.isDrawingMode) {
        this._onMouseDownInDrawingMode(e);

        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      } // ignore if some object is being transformed at this moment


      if (this._currentTransform) {
        return;
      }

      var pointer = this._pointer; // save pointer for check in __onMouseUp event

      this._previousPointer = pointer;

      var shouldRender = this._shouldRender(target),
          shouldGroup = this._shouldGroup(e, target);

      if (this._shouldClearSelection(e, target)) {
        this.discardActiveObject(e);
      } else if (shouldGroup) {
        this._handleGrouping(e, target);

        target = this._activeObject;
      }

      if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
        this._groupSelector = {
          ex: pointer.x,
          ey: pointer.y,
          top: 0,
          left: 0
        };
      }

      if (target) {
        var alreadySelected = target === this._activeObject;

        if (target.selectable) {
          this.setActiveObject(target, e);
        }

        var corner = target._findTargetCorner(this.getPointer(e, true), fabric.util.isTouchEvent(e));

        target.__corner = corner;

        if (target === this._activeObject && (corner || !shouldGroup)) {
          this._setupCurrentTransform(e, target, alreadySelected);

          var control = target.controls[corner],
              pointer = this.getPointer(e),
              mouseDownHandler = control && control.getMouseDownHandler(e, target, control);

          if (mouseDownHandler) {
            mouseDownHandler(e, this._currentTransform, pointer.x, pointer.y);
          }
        }
      }

      this._handleEvent(e, 'down'); // we must renderAll so that we update the visuals


      (shouldRender || shouldGroup) && this.requestRenderAll();
    },

    /**
     * reset cache form common information needed during event processing
     * @private
     */
    _resetTransformEventData: function _resetTransformEventData() {
      this._target = null;
      this._pointer = null;
      this._absolutePointer = null;
    },

    /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */
    _cacheTransformEventData: function _cacheTransformEventData(e) {
      // reset in order to avoid stale caching
      this._resetTransformEventData();

      this._pointer = this.getPointer(e, true);
      this._absolutePointer = this.restorePointerVpt(this._pointer);
      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
    },

    /**
     * @private
     */
    _beforeTransform: function _beforeTransform(e) {
      var t = this._currentTransform;
      this.stateful && t.target.saveState();
      this.fire('before:transform', {
        e: e,
        transform: t
      });
    },

    /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    __onMouseMove: function __onMouseMove(e) {
      this._handleEvent(e, 'move:before');

      this._cacheTransformEventData(e);

      var target, pointer;

      if (this.isDrawingMode) {
        this._onMouseMoveInDrawingMode(e);

        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      var groupSelector = this._groupSelector; // We initially clicked in an empty area, so we draw a box for multiple selection

      if (groupSelector) {
        pointer = this._pointer;
        groupSelector.left = pointer.x - groupSelector.ex;
        groupSelector.top = pointer.y - groupSelector.ey;
        this.renderTop();
      } else if (!this._currentTransform) {
        target = this.findTarget(e) || null;

        this._setCursorFromEvent(e, target);

        this._fireOverOutEvents(target, e);
      } else {
        this._transformObject(e);
      }

      this._handleEvent(e, 'move');

      this._resetTransformEventData();
    },

    /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */
    _fireOverOutEvents: function _fireOverOutEvents(target, e) {
      var _hoveredTarget = this._hoveredTarget,
          _hoveredTargets = this._hoveredTargets,
          targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);
      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _hoveredTarget,
        evtOut: 'mouseout',
        canvasEvtOut: 'mouse:out',
        evtIn: 'mouseover',
        canvasEvtIn: 'mouse:over'
      });

      for (var i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'mouseout',
          evtIn: 'mouseover'
        });
      }

      this._hoveredTarget = target;
      this._hoveredTargets = this.targets.concat();
    },

    /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Event} e Event object fired on ondrag
     * @private
     */
    _fireEnterLeaveEvents: function _fireEnterLeaveEvents(target, e) {
      var _draggedoverTarget = this._draggedoverTarget,
          _hoveredTargets = this._hoveredTargets,
          targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);
      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _draggedoverTarget,
        evtOut: 'dragleave',
        evtIn: 'dragenter'
      });

      for (var i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'dragleave',
          evtIn: 'dragenter'
        });
      }

      this._draggedoverTarget = target;
    },

    /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Event} e Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */
    fireSyntheticInOutEvents: function fireSyntheticInOutEvents(target, e, config) {
      var inOpt,
          outOpt,
          oldTarget = config.oldTarget,
          outFires,
          inFires,
          targetChanged = oldTarget !== target,
          canvasEvtIn = config.canvasEvtIn,
          canvasEvtOut = config.canvasEvtOut;

      if (targetChanged) {
        inOpt = {
          e: e,
          target: target,
          previousTarget: oldTarget
        };
        outOpt = {
          e: e,
          target: oldTarget,
          nextTarget: target
        };
      }

      inFires = target && targetChanged;
      outFires = oldTarget && targetChanged;

      if (outFires) {
        canvasEvtOut && this.fire(canvasEvtOut, outOpt);
        oldTarget.fire(config.evtOut, outOpt);
      }

      if (inFires) {
        canvasEvtIn && this.fire(canvasEvtIn, inOpt);
        target.fire(config.evtIn, inOpt);
      }
    },

    /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseWheel: function __onMouseWheel(e) {
      this._cacheTransformEventData(e);

      this._handleEvent(e, 'wheel');

      this._resetTransformEventData();
    },

    /**
     * @private
     * @param {Event} e Event fired on mousemove
     */
    _transformObject: function _transformObject(e) {
      var pointer = this.getPointer(e),
          transform = this._currentTransform;
      transform.reset = false;
      transform.target.isMoving = true;
      transform.shiftKey = e.shiftKey;
      transform.altKey = e[this.centeredKey];

      this._performTransformAction(e, transform, pointer);

      transform.actionPerformed && this.requestRenderAll();
    },

    /**
     * @private
     */
    _performTransformAction: function _performTransformAction(e, transform, pointer) {
      var x = pointer.x,
          y = pointer.y,
          action = transform.action,
          actionPerformed = false,
          actionHandler = transform.actionHandler; // this object could be created from the function in the control handlers

      if (actionHandler) {
        actionPerformed = actionHandler(e, transform, x, y);
      }

      if (action === 'drag' && actionPerformed) {
        this.setCursor(transform.target.moveCursor || this.moveCursor);
      }

      transform.actionPerformed = transform.actionPerformed || actionPerformed;
    },

    /**
     * @private
     */
    _fire: fabric.controlsUtils.fireEvent,

    /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */
    _setCursorFromEvent: function _setCursorFromEvent(e, target) {
      if (!target) {
        this.setCursor(this.defaultCursor);
        return false;
      }

      var hoverCursor = target.hoverCursor || this.hoverCursor,
          activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ? this._activeObject : null,
          // only show proper corner when group selection is not active
      corner = (!activeSelection || !activeSelection.contains(target)) && // here we call findTargetCorner always with undefined for the touch parameter.
      // we assume that if you are using a cursor you do not need to interact with
      // the bigger touch area.
      target._findTargetCorner(this.getPointer(e, true));

      if (!corner) {
        if (target.subTargetCheck) {
          // hoverCursor should come from top-most subTarget,
          // so we walk the array backwards
          this.targets.concat().reverse().map(function (_target) {
            hoverCursor = _target.hoverCursor || hoverCursor;
          });
        }

        this.setCursor(hoverCursor);
      } else {
        this.setCursor(this.getCornerCursor(corner, target, e));
      }
    },

    /**
     * @private
     */
    getCornerCursor: function getCornerCursor(corner, target, e) {
      var control = target.controls[corner];
      return control.cursorStyleHandler(e, control, target);
    }
  });
})();

(function () {
  var min = Math.min,
      max = Math.max;
  fabric.util.object.extend(fabric.Canvas.prototype,
  /** @lends fabric.Canvas.prototype */
  {
    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     * @return {Boolean}
     */
    _shouldGroup: function _shouldGroup(e, target) {
      var activeObject = this._activeObject;
      return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection && (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({
        e: e
      });
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _handleGrouping: function _handleGrouping(e, target) {
      var activeObject = this._activeObject; // avoid multi select when shift click on a corner

      if (activeObject.__corner) {
        return;
      }

      if (target === activeObject) {
        // if it's a group, find target again, using activeGroup objects
        target = this.findTarget(e, true); // if even object is not found or we are on activeObjectCorner, bail out

        if (!target || !target.selectable) {
          return;
        }
      }

      if (activeObject && activeObject.type === 'activeSelection') {
        this._updateActiveSelection(target, e);
      } else {
        this._createActiveSelection(target, e);
      }
    },

    /**
     * @private
     */
    _updateActiveSelection: function _updateActiveSelection(target, e) {
      var activeSelection = this._activeObject,
          currentActiveObjects = activeSelection._objects.slice(0);

      if (activeSelection.contains(target)) {
        activeSelection.removeWithUpdate(target);
        this._hoveredTarget = target;
        this._hoveredTargets = this.targets.concat();

        if (activeSelection.size() === 1) {
          // activate last remaining object
          this._setActiveObject(activeSelection.item(0), e);
        }
      } else {
        activeSelection.addWithUpdate(target);
        this._hoveredTarget = activeSelection;
        this._hoveredTargets = this.targets.concat();
      }

      this._fireSelectionEvents(currentActiveObjects, e);
    },

    /**
     * @private
     */
    _createActiveSelection: function _createActiveSelection(target, e) {
      var currentActives = this.getActiveObjects(),
          group = this._createGroup(target);

      this._hoveredTarget = group; // ISSUE 4115: should we consider subTargets here?
      // this._hoveredTargets = [];
      // this._hoveredTargets = this.targets.concat();

      this._setActiveObject(group, e);

      this._fireSelectionEvents(currentActives, e);
    },

    /**
     * @private
     * @param {Object} target
     */
    _createGroup: function _createGroup(target) {
      var objects = this._objects,
          isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target),
          groupObjects = isActiveLower ? [this._activeObject, target] : [target, this._activeObject];
      this._activeObject.isEditing && this._activeObject.exitEditing();
      return new fabric.ActiveSelection(groupObjects, {
        canvas: this
      });
    },

    /**
     * @private
     * @param {Event} e mouse event
     */
    _groupSelectedObjects: function _groupSelectedObjects(e) {
      var group = this._collectObjects(e),
          aGroup; // do not create group for 1 element only


      if (group.length === 1) {
        this.setActiveObject(group[0], e);
      } else if (group.length > 1) {
        aGroup = new fabric.ActiveSelection(group.reverse(), {
          canvas: this
        });
        this.setActiveObject(aGroup, e);
      }
    },

    /**
     * @private
     */
    _collectObjects: function _collectObjects(e) {
      var group = [],
          currentObject,
          x1 = this._groupSelector.ex,
          y1 = this._groupSelector.ey,
          x2 = x1 + this._groupSelector.left,
          y2 = y1 + this._groupSelector.top,
          selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)),
          selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)),
          allowIntersect = !this.selectionFullyContained,
          isClick = x1 === x2 && y1 === y2; // we iterate reverse order to collect top first in case of click.

      for (var i = this._objects.length; i--;) {
        currentObject = this._objects[i];

        if (!currentObject || !currentObject.selectable || !currentObject.visible) {
          continue;
        }

        if (allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2) || currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2) || allowIntersect && currentObject.containsPoint(selectionX1Y1) || allowIntersect && currentObject.containsPoint(selectionX2Y2)) {
          group.push(currentObject); // only add one object if it's a click

          if (isClick) {
            break;
          }
        }
      }

      if (group.length > 1) {
        group = group.filter(function (object) {
          return !object.onSelect({
            e: e
          });
        });
      }

      return group;
    },

    /**
     * @private
     */
    _maybeGroupObjects: function _maybeGroupObjects(e) {
      if (this.selection && this._groupSelector) {
        this._groupSelectedObjects(e);
      }

      this.setCursor(this.defaultCursor); // clear selection and current transformation

      this._groupSelector = null;
    }
  });
})();

(function () {
  fabric.util.object.extend(fabric.StaticCanvas.prototype,
  /** @lends fabric.StaticCanvas.prototype */
  {
    /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     */
    toDataURL: function toDataURL(options) {
      options || (options = {});
      var format = options.format || 'png',
          quality = options.quality || 1,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1),
          canvasEl = this.toCanvasElement(multiplier, options);
      return fabric.util.toDataURL(canvasEl, format, quality);
    },

    /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [cropping] Cropping informations
     * @param {Number} [cropping.left] Cropping left offset.
     * @param {Number} [cropping.top] Cropping top offset.
     * @param {Number} [cropping.width] Cropping width.
     * @param {Number} [cropping.height] Cropping height.
     */
    toCanvasElement: function toCanvasElement(multiplier, cropping) {
      multiplier = multiplier || 1;
      cropping = cropping || {};
      var scaledWidth = (cropping.width || this.width) * multiplier,
          scaledHeight = (cropping.height || this.height) * multiplier,
          zoom = this.getZoom(),
          originalWidth = this.width,
          originalHeight = this.height,
          newZoom = zoom * multiplier,
          vp = this.viewportTransform,
          translateX = (vp[4] - (cropping.left || 0)) * multiplier,
          translateY = (vp[5] - (cropping.top || 0)) * multiplier,
          originalInteractive = this.interactive,
          newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
          originalRetina = this.enableRetinaScaling,
          canvasEl = fabric.util.createCanvasElement(),
          originalContextTop = this.contextTop;
      canvasEl.width = scaledWidth;
      canvasEl.height = scaledHeight;
      this.contextTop = null;
      this.enableRetinaScaling = false;
      this.interactive = false;
      this.viewportTransform = newVp;
      this.width = scaledWidth;
      this.height = scaledHeight;
      this.calcViewportBoundaries();
      this.renderCanvas(canvasEl.getContext('2d'), this._objects);
      this.viewportTransform = vp;
      this.width = originalWidth;
      this.height = originalHeight;
      this.calcViewportBoundaries();
      this.interactive = originalInteractive;
      this.enableRetinaScaling = originalRetina;
      this.contextTop = originalContextTop;
      return canvasEl;
    }
  });
})();

fabric.util.object.extend(fabric.StaticCanvas.prototype,
/** @lends fabric.StaticCanvas.prototype */
{
  /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * });
   */
  loadFromJSON: function loadFromJSON(json, callback, reviver) {
    if (!json) {
      return;
    } // serialize if it wasn't already


    var serialized = typeof json === 'string' ? JSON.parse(json) : fabric.util.object.clone(json);

    var _this = this,
        clipPath = serialized.clipPath,
        renderOnAddRemove = this.renderOnAddRemove;

    this.renderOnAddRemove = false;
    delete serialized.clipPath;

    this._enlivenObjects(serialized.objects, function (enlivenedObjects) {
      _this.clear();

      _this._setBgOverlay(serialized, function () {
        if (clipPath) {
          _this._enlivenObjects([clipPath], function (enlivenedCanvasClip) {
            _this.clipPath = enlivenedCanvasClip[0];

            _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
          });
        } else {
          _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
        }
      });
    }, reviver);

    return this;
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Array} restored canvas objects
   * @param {Function} cached renderOnAddRemove callback
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  __setupCanvas: function __setupCanvas(serialized, enlivenedObjects, renderOnAddRemove, callback) {
    var _this = this;

    enlivenedObjects.forEach(function (obj, index) {
      // we splice the array just in case some custom classes restored from JSON
      // will add more object to canvas at canvas init.
      _this.insertAt(obj, index);
    });
    this.renderOnAddRemove = renderOnAddRemove; // remove parts i cannot set as options

    delete serialized.objects;
    delete serialized.backgroundImage;
    delete serialized.overlayImage;
    delete serialized.background;
    delete serialized.overlay; // this._initOptions does too many things to just
    // call it. Normally loading an Object from JSON
    // create the Object instance. Here the Canvas is
    // already an instance and we are just loading things over it

    this._setOptions(serialized);

    this.renderAll();
    callback && callback();
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  _setBgOverlay: function _setBgOverlay(serialized, callback) {
    var loaded = {
      backgroundColor: false,
      overlayColor: false,
      backgroundImage: false,
      overlayImage: false
    };

    if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
      callback && callback();
      return;
    }

    var cbIfLoaded = function cbIfLoaded() {
      if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
        callback && callback();
      }
    };

    this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);

    this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);

    this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);

    this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
  },

  /**
   * @private
   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
   * @param {(Object|String)} value Value to set
   * @param {Object} loaded Set loaded property to true if property is set
   * @param {Object} callback Callback function to invoke after property is set
   */
  __setBgOverlay: function __setBgOverlay(property, value, loaded, callback) {
    var _this = this;

    if (!value) {
      loaded[property] = true;
      callback && callback();
      return;
    }

    if (property === 'backgroundImage' || property === 'overlayImage') {
      fabric.util.enlivenObjects([value], function (enlivedObject) {
        _this[property] = enlivedObject[0];
        loaded[property] = true;
        callback && callback();
      });
    } else {
      this['set' + fabric.util.string.capitalize(property, true)](value, function () {
        loaded[property] = true;
        callback && callback();
      });
    }
  },

  /**
   * @private
   * @param {Array} objects
   * @param {Function} callback
   * @param {Function} [reviver]
   */
  _enlivenObjects: function _enlivenObjects(objects, callback, reviver) {
    if (!objects || objects.length === 0) {
      callback && callback([]);
      return;
    }

    fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
      callback && callback(enlivenedObjects);
    }, null, reviver);
  },

  /**
   * @private
   * @param {String} format
   * @param {Function} callback
   */
  _toDataURL: function _toDataURL(format, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURL(format));
    });
  },

  /**
   * @private
   * @param {String} format
   * @param {Number} multiplier
   * @param {Function} callback
   */
  _toDataURLWithMultiplier: function _toDataURLWithMultiplier(format, multiplier, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURLWithMultiplier(format, multiplier));
    });
  },

  /**
   * Clones canvas instance
   * @param {Object} [callback] Receives cloned instance as a first argument
   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
   */
  clone: function clone(callback, properties) {
    var data = JSON.stringify(this.toJSON(properties));
    this.cloneWithoutData(function (clone) {
      clone.loadFromJSON(data, function () {
        callback && callback(clone);
      });
    });
  },

  /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions, clipping properties, etc.
   * but leaves data empty (so that you can populate it with your own)
   * @param {Object} [callback] Receives cloned instance as a first argument
   */
  cloneWithoutData: function cloneWithoutData(callback) {
    var el = fabric.util.createCanvasElement();
    el.width = this.width;
    el.height = this.height;
    var clone = new fabric.Canvas(el);

    if (this.backgroundImage) {
      clone.setBackgroundImage(this.backgroundImage.src, function () {
        clone.renderAll();
        callback && callback(clone);
      });
      clone.backgroundImageOpacity = this.backgroundImageOpacity;
      clone.backgroundImageStretch = this.backgroundImageStretch;
    } else {
      callback && callback(clone);
    }
  }
});

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      capitalize = fabric.util.string.capitalize,
      degreesToRadians = fabric.util.degreesToRadians,
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash'),
      objectCaching = !fabric.isLikelyNode,
      ALIASING_LIMIT = 2;

  if (fabric.Object) {
    return;
  }
  /**
   * Root object class from which all 2d shape classes inherit from
   * @class fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   * @see {@link fabric.Object#initialize} for constructor definition
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   * @fires modified
   * @fires modified
   * @fires moved
   * @fires scaled
   * @fires rotated
   * @fires skewed
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */


  fabric.Object = fabric.util.createClass(fabric.CommonMethods,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Type of an object (rect, circle, path, etc.).
     * Note that this property is meant to be read-only and not meant to be modified.
     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
     * @type String
     * @default
     */
    type: 'object',

    /**
     * Horizontal origin of transformation of an object (one of "left", "right", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originX: 'left',

    /**
     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originY: 'top',

    /**
     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
     * @type Number
     * @default
     */
    top: 0,

    /**
     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
     * @type Number
     * @default
     */
    left: 0,

    /**
     * Object width
     * @type Number
     * @default
     */
    width: 0,

    /**
     * Object height
     * @type Number
     * @default
     */
    height: 0,

    /**
     * Object scale factor (horizontal)
     * @type Number
     * @default
     */
    scaleX: 1,

    /**
     * Object scale factor (vertical)
     * @type Number
     * @default
     */
    scaleY: 1,

    /**
     * When true, an object is rendered as flipped horizontally
     * @type Boolean
     * @default
     */
    flipX: false,

    /**
     * When true, an object is rendered as flipped vertically
     * @type Boolean
     * @default
     */
    flipY: false,

    /**
     * Opacity of an object
     * @type Number
     * @default
     */
    opacity: 1,

    /**
     * Angle of rotation of an object (in degrees)
     * @type Number
     * @default
     */
    angle: 0,

    /**
     * Angle of skew on x axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewX: 0,

    /**
     * Angle of skew on y axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewY: 0,

    /**
     * Size of object's controlling corners (in pixels)
     * @type Number
     * @default
     */
    cornerSize: 13,

    /**
     * Size of object's controlling corners when touch interaction is detected
     * @type Number
     * @default
     */
    touchCornerSize: 24,

    /**
     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
     * @type Boolean
     * @default
     */
    transparentCorners: true,

    /**
     * Default cursor value used when hovering over this object on canvas
     * @type String
     * @default
     */
    hoverCursor: null,

    /**
     * Default cursor value used when moving this object on canvas
     * @type String
     * @default
     */
    moveCursor: null,

    /**
     * Padding between object and its controlling borders (in pixels)
     * @type Number
     * @default
     */
    padding: 0,

    /**
     * Color of controlling borders of an object (when it's active)
     * @type String
     * @default
     */
    borderColor: 'rgb(178,204,255)',

    /**
     * Array specifying dash pattern of an object's borders (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    borderDashArray: null,

    /**
     * Color of controlling corners of an object (when it's active)
     * @type String
     * @default
     */
    cornerColor: 'rgb(178,204,255)',

    /**
     * Color of controlling corners of an object (when it's active and transparentCorners false)
     * @since 1.6.2
     * @type String
     * @default
     */
    cornerStrokeColor: null,

    /**
     * Specify style of control, 'rect' or 'circle'
     * @since 1.6.2
     * @type String
     */
    cornerStyle: 'rect',

    /**
     * Array specifying dash pattern of an object's control (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    cornerDashArray: null,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being scaled via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling: false,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being rotated via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation: true,

    /**
     * Color of object's fill
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    fill: 'rgb(0,0,0)',

    /**
     * Fill rule used to fill an object
     * accepted values are nonzero, evenodd
     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
     * @type String
     * @default
     */
    fillRule: 'nonzero',

    /**
     * Composite rule used for canvas globalCompositeOperation
     * @type String
     * @default
     */
    globalCompositeOperation: 'source-over',

    /**
     * Background color of an object.
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    backgroundColor: '',

    /**
     * Selection Background color of an object. colored layer behind the object when it is active.
     * does not mix good with globalCompositeOperation methods.
     * @type String
     * @default
     */
    selectionBackgroundColor: '',

    /**
     * When defined, an object is rendered via stroke and this property specifies its color
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    stroke: null,

    /**
     * Width of a stroke used to render this object
     * @type Number
     * @default
     */
    strokeWidth: 1,

    /**
     * Array specifying dash pattern of an object's stroke (stroke must be defined)
     * @type Array
     */
    strokeDashArray: null,

    /**
     * Line offset of an object's stroke
     * @type Number
     * @default
     */
    strokeDashOffset: 0,

    /**
     * Line endings style of an object's stroke (one of "butt", "round", "square")
     * @type String
     * @default
     */
    strokeLineCap: 'butt',

    /**
     * Corner style of an object's stroke (one of "bevel", "round", "miter")
     * @type String
     * @default
     */
    strokeLineJoin: 'miter',

    /**
     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
     * @type Number
     * @default
     */
    strokeMiterLimit: 4,

    /**
     * Shadow object representing shadow of this shape
     * @type fabric.Shadow
     * @default
     */
    shadow: null,

    /**
     * Opacity of object's controlling borders when object is active and moving
     * @type Number
     * @default
     */
    borderOpacityWhenMoving: 0.4,

    /**
     * Scale factor of object's controlling borders
     * bigger number will make a thicker border
     * border is 1, so this is basically a border thickness
     * since there is no way to change the border itself.
     * @type Number
     * @default
     */
    borderScaleFactor: 1,

    /**
     * Minimum allowed scale value of an object
     * @type Number
     * @default
     */
    minScaleLimit: 0,

    /**
     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
     * But events still fire on it.
     * @type Boolean
     * @default
     */
    selectable: true,

    /**
     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
     * @type Boolean
     * @default
     */
    evented: true,

    /**
     * When set to `false`, an object is not rendered on canvas
     * @type Boolean
     * @default
     */
    visible: true,

    /**
     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
     * @type Boolean
     * @default
     */
    hasControls: true,

    /**
     * When set to `false`, object's controlling borders are not rendered
     * @type Boolean
     * @default
     */
    hasBorders: true,

    /**
     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
     * @type Boolean
     * @default
     */
    perPixelTargetFind: false,

    /**
     * When `false`, default object's values are not included in its serialization
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * When `true`, object horizontal movement is locked
     * @type Boolean
     * @default
     */
    lockMovementX: false,

    /**
     * When `true`, object vertical movement is locked
     * @type Boolean
     * @default
     */
    lockMovementY: false,

    /**
     * When `true`, object rotation is locked
     * @type Boolean
     * @default
     */
    lockRotation: false,

    /**
     * When `true`, object horizontal scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingX: false,

    /**
     * When `true`, object vertical scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingY: false,

    /**
     * When `true`, object horizontal skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingX: false,

    /**
     * When `true`, object vertical skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingY: false,

    /**
     * When `true`, object cannot be flipped by scaling into negative values
     * @type Boolean
     * @default
     */
    lockScalingFlip: false,

    /**
     * When `true`, object is not exported in OBJECT/JSON
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    excludeFromExport: false,

    /**
     * When `true`, object is cached on an additional canvas.
     * When `false`, object is not cached unless necessary ( clipPath )
     * default to true
     * @since 1.7.0
     * @type Boolean
     * @default true
     */
    objectCaching: objectCaching,

    /**
     * When `true`, object properties are checked for cache invalidation. In some particular
     * situation you may want this to be disabled ( spray brush, very big, groups)
     * or if your application does not allow you to modify properties for groups child you want
     * to disable it for groups.
     * default to false
     * since 1.7.0
     * @type Boolean
     * @default false
     */
    statefullCache: false,

    /**
     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
     * too much and will be redrawn with correct details at the end of scaling.
     * this setting is performance and application dependant.
     * default to true
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    noScaleCache: true,

    /**
     * When `false`, the stoke width will scale with the object.
     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
     * default to false
     * @since 2.6.0
     * @type Boolean
     * @default false
     * @type Boolean
     * @default false
     */
    strokeUniform: false,

    /**
     * When set to `true`, object's cache will be rerendered next render call.
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    dirty: true,

    /**
     * keeps the value of the last hovered corner during mouse move.
     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
     * It should be private, but there is no harm in using it as
     * a read-only property.
     * @type number|string|any
     * @default 0
     */
    __corner: 0,

    /**
     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
     * @type String
     * @default
     */
    paintFirst: 'fill',

    /**
     * List of properties to consider when checking if state
     * of an object is changed (fabric.Object#hasStateChanged)
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: ('top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' + 'stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit ' + 'angle opacity fill globalCompositeOperation shadow visible backgroundColor ' + 'skewX skewY fillRule paintFirst clipPath strokeUniform').split(' '),

    /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */
    cacheProperties: ('fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform' + ' strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath').split(' '),

    /**
     * List of properties to consider for animating colors.
     * @type Array
     */
    colorProperties: 'fill stroke backgroundColor'.split(' '),

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the object has rendered, and the context is placed in the center
     * of the object cacheCanvas.
     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will make the object clip to the outside of the clipPath
     * since 2.4.0
     * @type boolean
     * @default false
     */
    inverted: false,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will have its top and left relative to canvas, and will
     * not be influenced by the object transform. This will make the clipPath relative
     * to the canvas, but clipping just a particular object.
     * WARNING this is beta, this feature may change or be renamed.
     * since 2.4.0
     * @type boolean
     * @default false
     */
    absolutePositioned: false,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function initialize(options) {
      if (options) {
        this.setOptions(options);
      }
    },

    /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */
    _createCacheCanvas: function _createCacheCanvas() {
      this._cacheProperties = {};
      this._cacheCanvas = fabric.util.createCanvasElement();
      this._cacheContext = this._cacheCanvas.getContext('2d');

      this._updateCacheCanvas(); // if canvas gets created, is empty, so dirty.


      this.dirty = true;
    },

    /**
     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _limitCacheSize: function _limitCacheSize(dims) {
      var perfLimitSizeTotal = fabric.perfLimitSizeTotal,
          width = dims.width,
          height = dims.height,
          max = fabric.maxCacheSideLimit,
          min = fabric.minCacheSideLimit;

      if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
        if (width < min) {
          dims.width = min;
        }

        if (height < min) {
          dims.height = min;
        }

        return dims;
      }

      var ar = width / height,
          limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal),
          capValue = fabric.util.capValue,
          x = capValue(min, limitedDims.x, max),
          y = capValue(min, limitedDims.y, max);

      if (width > x) {
        dims.zoomX /= width / x;
        dims.width = x;
        dims.capped = true;
      }

      if (height > y) {
        dims.zoomY /= height / y;
        dims.height = y;
        dims.capped = true;
      }

      return dims;
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
      var objectScale = this.getTotalObjectScaling(),
          // caculate dimensions without skewing
      dim = this._getTransformedDimensions(0, 0),
          neededX = dim.x * objectScale.scaleX / this.scaleX,
          neededY = dim.y * objectScale.scaleY / this.scaleY;

      return {
        // for sure this ALIASING_LIMIT is slightly creating problem
        // in situation in which the cache canvas gets an upper limit
        // also objectScale contains already scaleX and scaleY
        width: neededX + ALIASING_LIMIT,
        height: neededY + ALIASING_LIMIT,
        zoomX: objectScale.scaleX,
        zoomY: objectScale.scaleY,
        x: neededX,
        y: neededY
      };
    },

    /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */
    _updateCacheCanvas: function _updateCacheCanvas() {
      var targetCanvas = this.canvas;

      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
        var target = targetCanvas._currentTransform.target,
            action = targetCanvas._currentTransform.action;

        if (this === target && action.slice && action.slice(0, 5) === 'scale') {
          return false;
        }
      }

      var canvas = this._cacheCanvas,
          dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          minCacheSize = fabric.minCacheSideLimit,
          width = dims.width,
          height = dims.height,
          drawingWidth,
          drawingHeight,
          zoomX = dims.zoomX,
          zoomY = dims.zoomY,
          dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight,
          zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY,
          shouldRedraw = dimensionsChanged || zoomChanged,
          additionalWidth = 0,
          additionalHeight = 0,
          shouldResizeCanvas = false;

      if (dimensionsChanged) {
        var canvasWidth = this._cacheCanvas.width,
            canvasHeight = this._cacheCanvas.height,
            sizeGrowing = width > canvasWidth || height > canvasHeight,
            sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) && canvasWidth > minCacheSize && canvasHeight > minCacheSize;
        shouldResizeCanvas = sizeGrowing || sizeShrinking;

        if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
          additionalWidth = width * 0.1;
          additionalHeight = height * 0.1;
        }
      }

      if (shouldRedraw) {
        if (shouldResizeCanvas) {
          canvas.width = Math.ceil(width + additionalWidth);
          canvas.height = Math.ceil(height + additionalHeight);
        } else {
          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);

          this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
        }

        drawingWidth = dims.x / 2;
        drawingHeight = dims.y / 2;
        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
        this.cacheWidth = width;
        this.cacheHeight = height;

        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);

        this._cacheContext.scale(zoomX, zoomY);

        this.zoomX = zoomX;
        this.zoomY = zoomY;
        return true;
      }

      return false;
    },

    /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */
    setOptions: function setOptions(options) {
      this._setOptions(options);

      this._initGradient(options.fill, 'fill');

      this._initGradient(options.stroke, 'stroke');

      this._initPattern(options.fill, 'fill');

      this._initPattern(options.stroke, 'stroke');
    },

    /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */
    transform: function transform(ctx) {
      var needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
      var m = this.calcTransformMatrix(!needFullTransform);
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    },

    /**
     * Returns an object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          object = {
        type: this.type,
        version: fabric.version,
        originX: this.originX,
        originY: this.originY,
        left: toFixed(this.left, NUM_FRACTION_DIGITS),
        top: toFixed(this.top, NUM_FRACTION_DIGITS),
        width: toFixed(this.width, NUM_FRACTION_DIGITS),
        height: toFixed(this.height, NUM_FRACTION_DIGITS),
        fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
        stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
        strokeWidth: toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
        strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
        strokeLineCap: this.strokeLineCap,
        strokeDashOffset: this.strokeDashOffset,
        strokeLineJoin: this.strokeLineJoin,
        strokeUniform: this.strokeUniform,
        strokeMiterLimit: toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
        scaleX: toFixed(this.scaleX, NUM_FRACTION_DIGITS),
        scaleY: toFixed(this.scaleY, NUM_FRACTION_DIGITS),
        angle: toFixed(this.angle, NUM_FRACTION_DIGITS),
        flipX: this.flipX,
        flipY: this.flipY,
        opacity: toFixed(this.opacity, NUM_FRACTION_DIGITS),
        shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
        visible: this.visible,
        backgroundColor: this.backgroundColor,
        fillRule: this.fillRule,
        paintFirst: this.paintFirst,
        globalCompositeOperation: this.globalCompositeOperation,
        skewX: toFixed(this.skewX, NUM_FRACTION_DIGITS),
        skewY: toFixed(this.skewY, NUM_FRACTION_DIGITS)
      };

      if (this.clipPath) {
        object.clipPath = this.clipPath.toObject(propertiesToInclude);
        object.clipPath.inverted = this.clipPath.inverted;
        object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
      }

      fabric.util.populateWithProperties(this, object, propertiesToInclude);

      if (!this.includeDefaultValues) {
        object = this._removeDefaultValues(object);
      }

      return object;
    },

    /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toDatalessObject: function toDatalessObject(propertiesToInclude) {
      // will be overwritten by subclasses
      return this.toObject(propertiesToInclude);
    },

    /**
     * @private
     * @param {Object} object
     */
    _removeDefaultValues: function _removeDefaultValues(object) {
      var prototype = fabric.util.getKlass(object.type).prototype,
          stateProperties = prototype.stateProperties;
      stateProperties.forEach(function (prop) {
        if (prop === 'left' || prop === 'top') {
          return;
        }

        if (object[prop] === prototype[prop]) {
          delete object[prop];
        }

        var isArray = Object.prototype.toString.call(object[prop]) === '[object Array]' && Object.prototype.toString.call(prototype[prop]) === '[object Array]'; // basically a check for [] === []

        if (isArray && object[prop].length === 0 && prototype[prop].length === 0) {
          delete object[prop];
        }
      });
      return object;
    },

    /**
     * Returns a string representation of an instance
     * @return {String}
     */
    toString: function toString() {
      return '#<fabric.' + capitalize(this.type) + '>';
    },

    /**
     * Return the object scale factor counting also the group scaling
     * @return {Object} object with scaleX and scaleY properties
     */
    getObjectScaling: function getObjectScaling() {
      var options = fabric.util.qrDecompose(this.calcTransformMatrix());
      return {
        scaleX: Math.abs(options.scaleX),
        scaleY: Math.abs(options.scaleY)
      };
    },

    /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */
    getTotalObjectScaling: function getTotalObjectScaling() {
      var scale = this.getObjectScaling(),
          scaleX = scale.scaleX,
          scaleY = scale.scaleY;

      if (this.canvas) {
        var zoom = this.canvas.getZoom();
        var retina = this.canvas.getRetinaScaling();
        scaleX *= zoom * retina;
        scaleY *= zoom * retina;
      }

      return {
        scaleX: scaleX,
        scaleY: scaleY
      };
    },

    /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */
    getObjectOpacity: function getObjectOpacity() {
      var opacity = this.opacity;

      if (this.group) {
        opacity *= this.group.getObjectOpacity();
      }

      return opacity;
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Object} thisArg
     */
    _set: function _set(key, value) {
      var shouldConstrainValue = key === 'scaleX' || key === 'scaleY',
          isChanged = this[key] !== value,
          groupNeedsUpdate = false;

      if (shouldConstrainValue) {
        value = this._constrainScale(value);
      }

      if (key === 'scaleX' && value < 0) {
        this.flipX = !this.flipX;
        value *= -1;
      } else if (key === 'scaleY' && value < 0) {
        this.flipY = !this.flipY;
        value *= -1;
      } else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) {
        value = new fabric.Shadow(value);
      } else if (key === 'dirty' && this.group) {
        this.group.set('dirty', value);
      }

      this[key] = value;

      if (isChanged) {
        groupNeedsUpdate = this.group && this.group.isOnACache();

        if (this.cacheProperties.indexOf(key) > -1) {
          this.dirty = true;
          groupNeedsUpdate && this.group.set('dirty', true);
        } else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
          this.group.set('dirty', true);
        }
      }

      return this;
    },

    /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */
    setOnGroup: function setOnGroup() {// implemented by sub-classes, as needed.
    },

    /**
     * Retrieves viewportTransform from Object's canvas if possible
     * @method getViewportTransform
     * @memberOf fabric.Object.prototype
     * @return {Array}
     */
    getViewportTransform: function getViewportTransform() {
      if (this.canvas && this.canvas.viewportTransform) {
        return this.canvas.viewportTransform;
      }

      return fabric.iMatrix.concat();
    },

    /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf fabric.Object.prototype
     * @return {Boolean}
     */
    isNotVisible: function isNotVisible() {
      return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    },

    /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function render(ctx) {
      // do not render if width/height are zeros or object is not visible
      if (this.isNotVisible()) {
        return;
      }

      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }

      ctx.save();

      this._setupCompositeOperation(ctx);

      this.drawSelectionBackground(ctx);
      this.transform(ctx);

      this._setOpacity(ctx);

      this._setShadow(ctx, this);

      if (this.shouldCache()) {
        this.renderCache();
        this.drawCacheOnCanvas(ctx);
      } else {
        this._removeCacheCanvas();

        this.dirty = false;
        this.drawObject(ctx);

        if (this.objectCaching && this.statefullCache) {
          this.saveState({
            propertySet: 'cacheProperties'
          });
        }
      }

      ctx.restore();
    },
    renderCache: function renderCache(options) {
      options = options || {};

      if (!this._cacheCanvas) {
        this._createCacheCanvas();
      }

      if (this.isCacheDirty()) {
        this.statefullCache && this.saveState({
          propertySet: 'cacheProperties'
        });
        this.drawObject(this._cacheContext, options.forClipping);
        this.dirty = false;
      }
    },

    /**
     * Remove cacheCanvas and its dimensions from the objects
     */
    _removeCacheCanvas: function _removeCacheCanvas() {
      this._cacheCanvas = null;
      this.cacheWidth = 0;
      this.cacheHeight = 0;
    },

    /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasStroke: function hasStroke() {
      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
    },

    /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasFill: function hasFill() {
      return this.fill && this.fill !== 'transparent';
    },

    /**
     * When set to `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */
    needsItsOwnCache: function needsItsOwnCache() {
      if (this.paintFirst === 'stroke' && this.hasFill() && this.hasStroke() && _typeof(this.shadow) === 'object') {
        return true;
      }

      if (this.clipPath) {
        return true;
      }

      return false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */
    shouldCache: function shouldCache() {
      this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache());
      return this.ownCaching;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     */
    willDrawShadow: function willDrawShadow() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    },

    /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCache: function drawClipPathOnCache(ctx) {
      var path = this.clipPath;
      ctx.save(); // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4

      if (path.inverted) {
        ctx.globalCompositeOperation = 'destination-out';
      } else {
        ctx.globalCompositeOperation = 'destination-in';
      } //ctx.scale(1 / 2, 1 / 2);


      if (path.absolutePositioned) {
        var m = fabric.util.invertTransform(this.calcTransformMatrix());
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }

      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function drawObject(ctx, forClipping) {
      var originalFill = this.fill,
          originalStroke = this.stroke;

      if (forClipping) {
        this.fill = 'black';
        this.stroke = '';

        this._setClippingProperties(ctx);
      } else {
        this._renderBackground(ctx);
      }

      this._render(ctx);

      this._drawClipPath(ctx);

      this.fill = originalFill;
      this.stroke = originalStroke;
    },
    _drawClipPath: function _drawClipPath(ctx) {
      var path = this.clipPath;

      if (!path) {
        return;
      } // needed to setup a couple of variables
      // path canvas gets overridden with this one.
      // TODO find a better solution?


      path.canvas = this.canvas;
      path.shouldCache();
      path._transformDone = true;
      path.renderCache({
        forClipping: true
      });
      this.drawClipPathOnCache(ctx);
    },

    /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas: function drawCacheOnCanvas(ctx) {
      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    },

    /**
     * Check if cache is dirty
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */
    isCacheDirty: function isCacheDirty(skipCanvas) {
      if (this.isNotVisible()) {
        return false;
      }

      if (this._cacheCanvas && !skipCanvas && this._updateCacheCanvas()) {
        // in this case the context is already cleared.
        return true;
      } else {
        if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged('cacheProperties')) {
          if (this._cacheCanvas && !skipCanvas) {
            var width = this.cacheWidth / this.zoomX;
            var height = this.cacheHeight / this.zoomY;

            this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
          }

          return true;
        }
      }

      return false;
    },

    /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function _renderBackground(ctx) {
      if (!this.backgroundColor) {
        return;
      }

      var dim = this._getNonTransformedDimensions();

      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y); // if there is background color no other shadows
      // should be casted

      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setOpacity: function _setOpacity(ctx) {
      if (this.group && !this.group._transformDone) {
        ctx.globalAlpha = this.getObjectOpacity();
      } else {
        ctx.globalAlpha *= this.opacity;
      }
    },
    _setStrokeStyles: function _setStrokeStyles(ctx, decl) {
      var stroke = decl.stroke;

      if (stroke) {
        ctx.lineWidth = decl.strokeWidth;
        ctx.lineCap = decl.strokeLineCap;
        ctx.lineDashOffset = decl.strokeDashOffset;
        ctx.lineJoin = decl.strokeLineJoin;
        ctx.miterLimit = decl.strokeMiterLimit;

        if (stroke.toLive) {
          if (stroke.gradientUnits === 'percentage' || stroke.gradientTrasnform || stroke.patternTransform) {
            // need to transform gradient in a pattern.
            // this is a slow process. If you are hitting this codepath, and the object
            // is not using caching, you should consider switching it on.
            // we need a canvas as big as the current object caching canvas.
            this._applyPatternForTransformedGradient(ctx, stroke);
          } else {
            // is a simple gradient or pattern
            ctx.strokeStyle = stroke.toLive(ctx, this);

            this._applyPatternGradientTransform(ctx, stroke);
          }
        } else {
          // is a color
          ctx.strokeStyle = decl.stroke;
        }
      }
    },
    _setFillStyles: function _setFillStyles(ctx, decl) {
      var fill = decl.fill;

      if (fill) {
        if (fill.toLive) {
          ctx.fillStyle = fill.toLive(ctx, this);

          this._applyPatternGradientTransform(ctx, decl.fill);
        } else {
          ctx.fillStyle = fill;
        }
      }
    },
    _setClippingProperties: function _setClippingProperties(ctx) {
      ctx.globalAlpha = 1;
      ctx.strokeStyle = 'transparent';
      ctx.fillStyle = '#000000';
    },

    /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     * @param {Function} alternative function to call if browser does not support lineDash
     */
    _setLineDash: function _setLineDash(ctx, dashArray, alternative) {
      if (!dashArray || dashArray.length === 0) {
        return;
      } // Spec requires the concatenation of two copies the dash list when the number of elements is odd


      if (1 & dashArray.length) {
        dashArray.push.apply(dashArray, dashArray);
      }

      if (supportsLineDash) {
        ctx.setLineDash(dashArray);
      } else {
        alternative && alternative(ctx);
      }
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     */
    _renderControls: function _renderControls(ctx, styleOverride) {
      var vpt = this.getViewportTransform(),
          matrix = this.calcTransformMatrix(),
          options,
          drawBorders,
          drawControls;
      styleOverride = styleOverride || {};
      drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
      drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
      matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
      options = fabric.util.qrDecompose(matrix);
      ctx.save();
      ctx.translate(options.translateX, options.translateY);
      ctx.lineWidth = 1 * this.borderScaleFactor;

      if (!this.group) {
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      }

      if (styleOverride.forActiveSelection) {
        ctx.rotate(degreesToRadians(options.angle));
        drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
      } else {
        ctx.rotate(degreesToRadians(this.angle));
        drawBorders && this.drawBorders(ctx, styleOverride);
      }

      drawControls && this.drawControls(ctx, styleOverride);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setShadow: function _setShadow(ctx) {
      if (!this.shadow) {
        return;
      }

      var shadow = this.shadow,
          canvas = this.canvas,
          scaling,
          multX = canvas && canvas.viewportTransform[0] || 1,
          multY = canvas && canvas.viewportTransform[3] || 1;

      if (shadow.nonScaling) {
        scaling = {
          scaleX: 1,
          scaleY: 1
        };
      } else {
        scaling = this.getObjectScaling();
      }

      if (canvas && canvas._isRetinaScaling()) {
        multX *= fabric.devicePixelRatio;
        multY *= fabric.devicePixelRatio;
      }

      ctx.shadowColor = shadow.color;
      ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant * (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _removeShadow: function _removeShadow(ctx) {
      if (!this.shadow) {
        return;
      }

      ctx.shadowColor = '';
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */
    _applyPatternGradientTransform: function _applyPatternGradientTransform(ctx, filler) {
      if (!filler || !filler.toLive) {
        return {
          offsetX: 0,
          offsetY: 0
        };
      }

      var t = filler.gradientTransform || filler.patternTransform;
      var offsetX = -this.width / 2 + filler.offsetX || 0,
          offsetY = -this.height / 2 + filler.offsetY || 0;

      if (filler.gradientUnits === 'percentage') {
        ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
      } else {
        ctx.transform(1, 0, 0, 1, offsetX, offsetY);
      }

      if (t) {
        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
      }

      return {
        offsetX: offsetX,
        offsetY: offsetY
      };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderPaintInOrder: function _renderPaintInOrder(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderStroke(ctx);

        this._renderFill(ctx);
      } else {
        this._renderFill(ctx);

        this._renderStroke(ctx);
      }
    },

    /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render()
    /* ctx */
    {},

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderFill: function _renderFill(ctx) {
      if (!this.fill) {
        return;
      }

      ctx.save();

      this._setFillStyles(ctx, this);

      if (this.fillRule === 'evenodd') {
        ctx.fill('evenodd');
      } else {
        ctx.fill();
      }

      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderStroke: function _renderStroke(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();

      if (this.strokeUniform && this.group) {
        var scaling = this.getObjectScaling();
        ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
      } else if (this.strokeUniform) {
        ctx.scale(1 / this.scaleX, 1 / this.scaleY);
      }

      this._setLineDash(ctx, this.strokeDashArray, this._renderDashedStroke);

      this._setStrokeStyles(ctx, this);

      ctx.stroke();
      ctx.restore();
    },

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Gradient} filler a fabric gradient instance
     */
    _applyPatternForTransformedGradient: function _applyPatternForTransformedGradient(ctx, filler) {
      var dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          pCanvas = fabric.util.createCanvasElement(),
          pCtx,
          retinaScaling = this.canvas.getRetinaScaling(),
          width = dims.x / this.scaleX / retinaScaling,
          height = dims.y / this.scaleY / retinaScaling;

      pCanvas.width = width;
      pCanvas.height = height;
      pCtx = pCanvas.getContext('2d');
      pCtx.beginPath();
      pCtx.moveTo(0, 0);
      pCtx.lineTo(width, 0);
      pCtx.lineTo(width, height);
      pCtx.lineTo(0, height);
      pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);

      this._applyPatternGradientTransform(pCtx, filler);

      pCtx.fillStyle = filler.toLive(ctx);
      pCtx.fill();
      ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
      ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
      ctx.strokeStyle = pCtx.createPattern(pCanvas, 'no-repeat');
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function _findCenterFromElement() {
      return {
        x: this.left + this.width / 2,
        y: this.top + this.height / 2
      };
    },

    /**
     * This function is an helper for svg import. it decompose the transformMatrix
     * and assign properties to object.
     * untransformed coordinates
     * @private
     * @chainable
     */
    _assignTransformMatrixProps: function _assignTransformMatrixProps() {
      if (this.transformMatrix) {
        var options = fabric.util.qrDecompose(this.transformMatrix);
        this.flipX = false;
        this.flipY = false;
        this.set('scaleX', options.scaleX);
        this.set('scaleY', options.scaleY);
        this.angle = options.angle;
        this.skewX = options.skewX;
        this.skewY = 0;
      }
    },

    /**
     * This function is an helper for svg import. it removes the transform matrix
     * and set to object properties that fabricjs can handle
     * @private
     * @param {Object} preserveAspectRatioOptions
     * @return {thisArg}
     */
    _removeTransformMatrix: function _removeTransformMatrix(preserveAspectRatioOptions) {
      var center = this._findCenterFromElement();

      if (this.transformMatrix) {
        this._assignTransformMatrixProps();

        center = fabric.util.transformPoint(center, this.transformMatrix);
      }

      this.transformMatrix = null;

      if (preserveAspectRatioOptions) {
        this.scaleX *= preserveAspectRatioOptions.scaleX;
        this.scaleY *= preserveAspectRatioOptions.scaleY;
        this.cropX = preserveAspectRatioOptions.cropX;
        this.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        this.width = preserveAspectRatioOptions.width;
        this.height = preserveAspectRatioOptions.height;
      }

      this.setPositionByOrigin(center, 'center', 'center');
    },

    /**
     * Clones an instance, using a callback method will work for every object.
     * @param {Function} callback Callback is invoked with a clone as a first argument
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     */
    clone: function clone(callback, propertiesToInclude) {
      var objectForm = this.toObject(propertiesToInclude);

      if (this.constructor.fromObject) {
        this.constructor.fromObject(objectForm, callback);
      } else {
        fabric.Object._fromObject('Object', objectForm, callback);
      }
    },

    /**
     * Creates an instance of fabric.Image out of an object
     * makes use of toCanvasElement.
     * Once this method was based on toDataUrl and loadImage, so it also had a quality
     * and format option. toCanvasElement is faster and produce no loss of quality.
     * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
     * toCanvasElement and then toBlob from the obtained canvas is also a good option.
     * This method is sync now, but still support the callback because we did not want to break.
     * When fabricJS 5.0 will be planned, this will probably be changed to not have a callback.
     * @param {Function} callback callback, invoked with an instance as a first argument
     * @param {Object} [options] for clone as image, passed to toDataURL
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {fabric.Object} thisArg
     */
    cloneAsImage: function cloneAsImage(callback, options) {
      var canvasEl = this.toCanvasElement(options);

      if (callback) {
        callback(new fabric.Image(canvasEl));
      }

      return this;
    },

    /**
     * Converts an object into a HTMLCanvas element
     * @param {Object} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
     */
    toCanvasElement: function toCanvasElement(options) {
      options || (options = {});
      var utils = fabric.util,
          origParams = utils.saveObjectTransform(this),
          originalGroup = this.group,
          originalShadow = this.shadow,
          abs = Math.abs,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
      delete this.group;

      if (options.withoutTransform) {
        utils.resetObjectTransform(this);
      }

      if (options.withoutShadow) {
        this.shadow = null;
      }

      var el = fabric.util.createCanvasElement(),
          // skip canvas zoom and calculate with setCoords now.
      boundingRect = this.getBoundingRect(true, true),
          shadow = this.shadow,
          scaling,
          shadowOffset = {
        x: 0,
        y: 0
      },
          shadowBlur,
          width,
          height;

      if (shadow) {
        shadowBlur = shadow.blur;

        if (shadow.nonScaling) {
          scaling = {
            scaleX: 1,
            scaleY: 1
          };
        } else {
          scaling = this.getObjectScaling();
        } // consider non scaling shadow.


        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.scaleX);
        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.scaleY);
      }

      width = boundingRect.width + shadowOffset.x;
      height = boundingRect.height + shadowOffset.y; // if the current width/height is not an integer
      // we need to make it so.

      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      var canvas = new fabric.StaticCanvas(el, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false
      });

      if (options.format === 'jpeg') {
        canvas.backgroundColor = '#fff';
      }

      this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');
      var originalCanvas = this.canvas;
      canvas.add(this);
      var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.shadow = originalShadow;
      this.set('canvas', originalCanvas);

      if (originalGroup) {
        this.group = originalGroup;
      }

      this.set(origParams).setCoords(); // canvas.dispose will call image.dispose that will nullify the elements
      // since this canvas is a simple element for the process, we remove references
      // to objects in this way in order to avoid object trashing.

      canvas._objects = [];
      canvas.dispose();
      canvas = null;
      return canvasEl;
    },

    /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */
    toDataURL: function toDataURL(options) {
      options || (options = {});
      return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    },

    /**
     * Returns true if specified type is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */
    isType: function isType(type) {
      return this.type === type;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */
    complexity: function complexity() {
      return 1;
    },

    /**
     * Returns a JSON representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} JSON
     */
    toJSON: function toJSON(propertiesToInclude) {
      // delegate, not alias
      return this.toObject(propertiesToInclude);
    },

    /**
     * Sets "angle" of an instance with centered rotation
     * @param {Number} angle Angle value (in degrees)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    rotate: function rotate(angle) {
      var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;

      if (shouldCenterOrigin) {
        this._setOriginToCenter();
      }

      this.set('angle', angle);

      if (shouldCenterOrigin) {
        this._resetOrigin();
      }

      return this;
    },

    /**
     * Centers object horizontally on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerH: function centerH() {
      this.canvas && this.canvas.centerObjectH(this);
      return this;
    },

    /**
     * Centers object horizontally on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterH: function viewportCenterH() {
      this.canvas && this.canvas.viewportCenterObjectH(this);
      return this;
    },

    /**
     * Centers object vertically on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerV: function centerV() {
      this.canvas && this.canvas.centerObjectV(this);
      return this;
    },

    /**
     * Centers object vertically on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterV: function viewportCenterV() {
      this.canvas && this.canvas.viewportCenterObjectV(this);
      return this;
    },

    /**
     * Centers object vertically and horizontally on canvas to which is was added last
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    center: function center() {
      this.canvas && this.canvas.centerObject(this);
      return this;
    },

    /**
     * Centers object on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenter: function viewportCenter() {
      this.canvas && this.canvas.viewportCenterObject(this);
      return this;
    },

    /**
     * Returns coordinates of a pointer relative to an object
     * @param {Event} e Event to operate upon
     * @param {Object} [pointer] Pointer to operate upon (instead of event)
     * @return {Object} Coordinates of a pointer (x, y)
     */
    getLocalPointer: function getLocalPointer(e, pointer) {
      pointer = pointer || this.canvas.getPointer(e);

      var pClicked = new fabric.Point(pointer.x, pointer.y),
          objectLeftTop = this._getLeftTopCoords();

      if (this.angle) {
        pClicked = fabric.util.rotatePoint(pClicked, objectLeftTop, degreesToRadians(-this.angle));
      }

      return {
        x: pClicked.x - objectLeftTop.x,
        y: pClicked.y - objectLeftTop.y
      };
    },

    /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */
    _setupCompositeOperation: function _setupCompositeOperation(ctx) {
      if (this.globalCompositeOperation) {
        ctx.globalCompositeOperation = this.globalCompositeOperation;
      }
    }
  });
  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);
  extend(fabric.Object.prototype, fabric.Observable);
  /**
   * Defines the number of fraction digits to use when serializing object values.
   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type Number
   */

  fabric.Object.NUM_FRACTION_DIGITS = 2;

  fabric.Object._fromObject = function (className, object, callback, extraParam) {
    var klass = fabric[className];
    object = clone(object, true);
    fabric.util.enlivenPatterns([object.fill, object.stroke], function (patterns) {
      if (typeof patterns[0] !== 'undefined') {
        object.fill = patterns[0];
      }

      if (typeof patterns[1] !== 'undefined') {
        object.stroke = patterns[1];
      }

      fabric.util.enlivenObjects([object.clipPath], function (enlivedProps) {
        object.clipPath = enlivedProps[0];
        var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
        callback && callback(instance);
      });
    });
  };
  /**
   * Unique id used internally when creating SVG elements
   * @static
   * @memberOf fabric.Object
   * @type Number
   */


  fabric.Object.__uid = 0;
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  var degreesToRadians = fabric.util.degreesToRadians,
      originXOffset = {
    left: -0.5,
    center: 0,
    right: 0.5
  },
      originYOffset = {
    top: -0.5,
    center: 0,
    bottom: 0.5
  };
  fabric.util.object.extend(fabric.Object.prototype,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToGivenOrigin: function translateToGivenOrigin(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
      var x = point.x,
          y = point.y,
          offsetX,
          offsetY,
          dim;

      if (typeof fromOriginX === 'string') {
        fromOriginX = originXOffset[fromOriginX];
      } else {
        fromOriginX -= 0.5;
      }

      if (typeof toOriginX === 'string') {
        toOriginX = originXOffset[toOriginX];
      } else {
        toOriginX -= 0.5;
      }

      offsetX = toOriginX - fromOriginX;

      if (typeof fromOriginY === 'string') {
        fromOriginY = originYOffset[fromOriginY];
      } else {
        fromOriginY -= 0.5;
      }

      if (typeof toOriginY === 'string') {
        toOriginY = originYOffset[toOriginY];
      } else {
        toOriginY -= 0.5;
      }

      offsetY = toOriginY - fromOriginY;

      if (offsetX || offsetY) {
        dim = this._getTransformedDimensions();
        x = point.x + offsetX * dim.x;
        y = point.y + offsetY * dim.y;
      }

      return new fabric.Point(x, y);
    },

    /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToCenterPoint: function translateToCenterPoint(point, originX, originY) {
      var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');

      if (this.angle) {
        return fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
      }

      return p;
    },

    /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {fabric.Point} center The point which corresponds to center of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToOriginPoint: function translateToOriginPoint(center, originX, originY) {
      var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);

      if (this.angle) {
        return fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
      }

      return p;
    },

    /**
     * Returns the real center coordinates of the object
     * @return {fabric.Point}
     */
    getCenterPoint: function getCenterPoint() {
      var leftTop = new fabric.Point(this.left, this.top);
      return this.translateToCenterPoint(leftTop, this.originX, this.originY);
    },

    /**
     * Returns the coordinates of the object based on center coordinates
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @return {fabric.Point}
     */
    // getOriginPoint: function(center) {
    //   return this.translateToOriginPoint(center, this.originX, this.originY);
    // },

    /**
     * Returns the coordinates of the object as if it has a different origin
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    getPointByOrigin: function getPointByOrigin(originX, originY) {
      var center = this.getCenterPoint();
      return this.translateToOriginPoint(center, originX, originY);
    },

    /**
     * Returns the point in local coordinates
     * @param {fabric.Point} point The point relative to the global coordinate system
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    toLocalPoint: function toLocalPoint(point, originX, originY) {
      var center = this.getCenterPoint(),
          p,
          p2;

      if (typeof originX !== 'undefined' && typeof originY !== 'undefined') {
        p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
      } else {
        p = new fabric.Point(this.left, this.top);
      }

      p2 = new fabric.Point(point.x, point.y);

      if (this.angle) {
        p2 = fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
      }

      return p2.subtractEquals(p);
    },

    /**
     * Returns the point in global coordinates
     * @param {fabric.Point} The point relative to the local coordinate system
     * @return {fabric.Point}
     */
    // toGlobalPoint: function(point) {
    //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
    // },

    /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {fabric.Point} pos The new position of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */
    setPositionByOrigin: function setPositionByOrigin(pos, originX, originY) {
      var center = this.translateToCenterPoint(pos, originX, originY),
          position = this.translateToOriginPoint(center, this.originX, this.originY);
      this.set('left', position.x);
      this.set('top', position.y);
    },

    /**
     * @param {String} to One of 'left', 'center', 'right'
     */
    adjustPosition: function adjustPosition(to) {
      var angle = degreesToRadians(this.angle),
          hypotFull = this.getScaledWidth(),
          xFull = fabric.util.cos(angle) * hypotFull,
          yFull = fabric.util.sin(angle) * hypotFull,
          offsetFrom,
          offsetTo; //TODO: this function does not consider mixed situation like top, center.

      if (typeof this.originX === 'string') {
        offsetFrom = originXOffset[this.originX];
      } else {
        offsetFrom = this.originX - 0.5;
      }

      if (typeof to === 'string') {
        offsetTo = originXOffset[to];
      } else {
        offsetTo = to - 0.5;
      }

      this.left += xFull * (offsetTo - offsetFrom);
      this.top += yFull * (offsetTo - offsetFrom);
      this.setCoords();
      this.originX = to;
    },

    /**
     * Sets the origin/position of the object to it's center point
     * @private
     * @return {void}
     */
    _setOriginToCenter: function _setOriginToCenter() {
      this._originalOriginX = this.originX;
      this._originalOriginY = this.originY;
      var center = this.getCenterPoint();
      this.originX = 'center';
      this.originY = 'center';
      this.left = center.x;
      this.top = center.y;
    },

    /**
     * Resets the origin/position of the object to it's original origin
     * @private
     * @return {void}
     */
    _resetOrigin: function _resetOrigin() {
      var originPoint = this.translateToOriginPoint(this.getCenterPoint(), this._originalOriginX, this._originalOriginY);
      this.originX = this._originalOriginX;
      this.originY = this._originalOriginY;
      this.left = originPoint.x;
      this.top = originPoint.y;
      this._originalOriginX = null;
      this._originalOriginY = null;
    },

    /**
     * @private
     */
    _getLeftTopCoords: function _getLeftTopCoords() {
      return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
    }
  });
})();

(function () {
  function arrayFromCoords(coords) {
    return [new fabric.Point(coords.tl.x, coords.tl.y), new fabric.Point(coords.tr.x, coords.tr.y), new fabric.Point(coords.br.x, coords.br.y), new fabric.Point(coords.bl.x, coords.bl.y)];
  }

  var util = fabric.util,
      degreesToRadians = util.degreesToRadians,
      multiplyMatrices = util.multiplyTransformMatrices,
      transformPoint = util.transformPoint;
  util.object.extend(fabric.Object.prototype,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Describe object's corner position in canvas element coordinates.
     * properties are depending on control keys and padding the main controls.
     * each property is an object with x, y and corner.
     * The `corner` property contains in a similar manner the 4 points of the
     * interactive area of the corner.
     * The coordinates depends from the controls positionHandler and are used
     * to draw and locate controls
     * @memberOf fabric.Object.prototype
     */
    oCoords: null,

    /**
     * Describe object's corner position in canvas object absolute coordinates
     * properties are tl,tr,bl,br and describe the four main corner.
     * each property is an object with x, y, instance of Fabric.Point.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, top, left.
     * Those coordinates are useful to understand where an object is. They get updated
     * with oCoords but they do not need to be updated when zoom or panning change.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcACoords();
     * @memberOf fabric.Object.prototype
     */
    aCoords: null,

    /**
     * Describe object's corner position in canvas element coordinates.
     * includes padding. Used of object detection.
     * set and refreshed with setCoords and calcCoords.
     * @memberOf fabric.Object.prototype
     */
    lineCoords: null,

    /**
     * storage for object transform matrix
     */
    ownMatrixCache: null,

    /**
     * storage for object full transform matrix
     */
    matrixCache: null,

    /**
     * custom controls interface
     * controls are added by default_controls.js
     */
    controls: {},

    /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * @param {Boolean} absolute will return aCoords if true or lineCoords
     * @return {Object} {tl, tr, br, bl} points
     */
    _getCoords: function _getCoords(absolute, calculate) {
      if (calculate) {
        return absolute ? this.calcACoords() : this.calcLineCoords();
      }

      if (!this.aCoords || !this.lineCoords) {
        this.setCoords(true);
      }

      return absolute ? this.aCoords : this.lineCoords;
    },

    /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * The coords are returned in an array.
     * @return {Array} [tl, tr, br, bl] of points
     */
    getCoords: function getCoords(absolute, calculate) {
      return arrayFromCoords(this._getCoords(absolute, calculate));
    },

    /**
     * Checks if object intersects with an area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with an area formed by 2 points
     */
    intersectsWithRect: function intersectsWithRect(pointTL, pointBR, absolute, calculate) {
      var coords = this.getCoords(absolute, calculate),
          intersection = fabric.Intersection.intersectPolygonRectangle(coords, pointTL, pointBR);
      return intersection.status === 'Intersection';
    },

    /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with another object
     */
    intersectsWithObject: function intersectsWithObject(other, absolute, calculate) {
      var intersection = fabric.Intersection.intersectPolygonPolygon(this.getCoords(absolute, calculate), other.getCoords(absolute, calculate));
      return intersection.status === 'Intersection' || other.isContainedWithinObject(this, absolute, calculate) || this.isContainedWithinObject(other, absolute, calculate);
    },

    /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area of another object
     */
    isContainedWithinObject: function isContainedWithinObject(other, absolute, calculate) {
      var points = this.getCoords(absolute, calculate),
          otherCoords = absolute ? other.aCoords : other.lineCoords,
          i = 0,
          lines = other._getImageLines(otherCoords);

      for (; i < 4; i++) {
        if (!other.containsPoint(points[i], lines)) {
          return false;
        }
      }

      return true;
    },

    /**
     * Checks if object is fully contained within area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area formed by 2 points
     */
    isContainedWithinRect: function isContainedWithinRect(pointTL, pointBR, absolute, calculate) {
      var boundingRect = this.getBoundingRect(absolute, calculate);
      return boundingRect.left >= pointTL.x && boundingRect.left + boundingRect.width <= pointBR.x && boundingRect.top >= pointTL.y && boundingRect.top + boundingRect.height <= pointBR.y;
    },

    /**
     * Checks if point is inside the object
     * @param {fabric.Point} point Point to check against
     * @param {Object} [lines] object returned from @method _getImageLines
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if point is inside the object
     */
    containsPoint: function containsPoint(point, lines, absolute, calculate) {
      var coords = this._getCoords(absolute, calculate),
          lines = lines || this._getImageLines(coords),
          xPoints = this._findCrossPoints(point, lines); // if xPoints is odd then point is inside the object


      return xPoints !== 0 && xPoints % 2 === 1;
    },

    /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
     * @return {Boolean} true if object is fully or partially contained within canvas
     */
    isOnScreen: function isOnScreen(calculate) {
      if (!this.canvas) {
        return false;
      }

      var pointTL = this.canvas.vptCoords.tl,
          pointBR = this.canvas.vptCoords.br;
      var points = this.getCoords(true, calculate); // if some point is on screen, the object is on screen.

      if (points.some(function (point) {
        return point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y;
      })) {
        return true;
      } // no points on screen, check intersection with absolute coordinates


      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }

      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Checks if the object contains the midpoint between canvas extremities
     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
     * @private
     * @param {Fabric.Point} pointTL Top Left point
     * @param {Fabric.Point} pointBR Top Right point
     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
     * @return {Boolean} true if the object contains the point
     */
    _containsCenterOfCanvas: function _containsCenterOfCanvas(pointTL, pointBR, calculate) {
      // worst case scenario the object is so big that contains the screen
      var centerPoint = {
        x: (pointTL.x + pointBR.x) / 2,
        y: (pointTL.y + pointBR.y) / 2
      };

      if (this.containsPoint(centerPoint, null, true, calculate)) {
        return true;
      }

      return false;
    },

    /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is partially contained within canvas
     */
    isPartiallyOnScreen: function isPartiallyOnScreen(calculate) {
      if (!this.canvas) {
        return false;
      }

      var pointTL = this.canvas.vptCoords.tl,
          pointBR = this.canvas.vptCoords.br;

      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }

      var allPointsAreOutside = this.getCoords(true, calculate).every(function (point) {
        return (point.x >= pointBR.x || point.x <= pointTL.x) && (point.y >= pointBR.y || point.y <= pointTL.y);
      });
      return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Method that returns an object with the object edges in it, given the coordinates of the corners
     * @private
     * @param {Object} oCoords Coordinates of the object corners
     */
    _getImageLines: function _getImageLines(oCoords) {
      var lines = {
        topline: {
          o: oCoords.tl,
          d: oCoords.tr
        },
        rightline: {
          o: oCoords.tr,
          d: oCoords.br
        },
        bottomline: {
          o: oCoords.br,
          d: oCoords.bl
        },
        leftline: {
          o: oCoords.bl,
          d: oCoords.tl
        }
      }; // // debugging
      // if (this.canvas.contextTop) {
      //   this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
      // }

      return lines;
    },

    /**
     * Helper method to determine how many cross points are between the 4 object edges
     * and the horizontal line determined by a point on canvas
     * @private
     * @param {fabric.Point} point Point to check
     * @param {Object} lines Coordinates of the object being evaluated
     */
    // remove yi, not used but left code here just in case.
    _findCrossPoints: function _findCrossPoints(point, lines) {
      var b1,
          b2,
          a1,
          a2,
          xi,
          // yi,
      xcount = 0,
          iLine;

      for (var lineKey in lines) {
        iLine = lines[lineKey]; // optimisation 1: line below point. no cross

        if (iLine.o.y < point.y && iLine.d.y < point.y) {
          continue;
        } // optimisation 2: line above point. no cross


        if (iLine.o.y >= point.y && iLine.d.y >= point.y) {
          continue;
        } // optimisation 3: vertical line case


        if (iLine.o.x === iLine.d.x && iLine.o.x >= point.x) {
          xi = iLine.o.x; // yi = point.y;
        } // calculate the intersection point
        else {
            b1 = 0;
            b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
            a1 = point.y - b1 * point.x;
            a2 = iLine.o.y - b2 * iLine.o.x;
            xi = -(a1 - a2) / (b1 - b2); // yi = a1 + b1 * xi;
          } // dont count xi < point.x cases


        if (xi >= point.x) {
          xcount += 1;
        } // optimisation 4: specific for square images


        if (xcount === 2) {
          break;
        }
      }

      return xcount;
    },

    /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
     * @return {Object} Object with left, top, width, height properties
     */
    getBoundingRect: function getBoundingRect(absolute, calculate) {
      var coords = this.getCoords(absolute, calculate);
      return util.makeBoundingBoxFromPoints(coords);
    },

    /**
     * Returns width of an object's bounding box counting transformations
     * before 2.0 it was named getWidth();
     * @return {Number} width value
     */
    getScaledWidth: function getScaledWidth() {
      return this._getTransformedDimensions().x;
    },

    /**
     * Returns height of an object bounding box counting transformations
     * before 2.0 it was named getHeight();
     * @return {Number} height value
     */
    getScaledHeight: function getScaledHeight() {
      return this._getTransformedDimensions().y;
    },

    /**
     * Makes sure the scale is valid and modifies it if necessary
     * @private
     * @param {Number} value
     * @return {Number}
     */
    _constrainScale: function _constrainScale(value) {
      if (Math.abs(value) < this.minScaleLimit) {
        if (value < 0) {
          return -this.minScaleLimit;
        } else {
          return this.minScaleLimit;
        }
      } else if (value === 0) {
        return 0.0001;
      }

      return value;
    },

    /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scale: function scale(value) {
      this._set('scaleX', value);

      this._set('scaleY', value);

      return this.setCoords();
    },

    /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToWidth: function scaleToWidth(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
      return this.scale(value / this.width / boundingRectFactor);
    },

    /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToHeight: function scaleToHeight(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
      return this.scale(value / this.height / boundingRectFactor);
    },

    /**
     * Calculates and returns the .coords of an object.
     * unused by the library, only for the end dev.
     * @return {Object} Object with tl, tr, br, bl ....
     * @chainable
     * @deprecated
     */
    calcCoords: function calcCoords(absolute) {
      // this is a compatibility function to avoid removing calcCoords now.
      if (absolute) {
        return this.calcACoords();
      }

      return this.calcOCoords();
    },
    calcLineCoords: function calcLineCoords() {
      var vpt = this.getViewportTransform(),
          padding = this.padding,
          angle = degreesToRadians(this.angle),
          cos = util.cos(angle),
          sin = util.sin(angle),
          cosP = cos * padding,
          sinP = sin * padding,
          cosPSinP = cosP + sinP,
          cosPMinusSinP = cosP - sinP,
          aCoords = this.calcACoords();
      var lineCoords = {
        tl: transformPoint(aCoords.tl, vpt),
        tr: transformPoint(aCoords.tr, vpt),
        bl: transformPoint(aCoords.bl, vpt),
        br: transformPoint(aCoords.br, vpt)
      };

      if (padding) {
        lineCoords.tl.x -= cosPMinusSinP;
        lineCoords.tl.y -= cosPSinP;
        lineCoords.tr.x += cosPSinP;
        lineCoords.tr.y -= cosPMinusSinP;
        lineCoords.bl.x -= cosPSinP;
        lineCoords.bl.y += cosPMinusSinP;
        lineCoords.br.x += cosPMinusSinP;
        lineCoords.br.y += cosPSinP;
      }

      return lineCoords;
    },
    calcOCoords: function calcOCoords() {
      var rotateMatrix = this._calcRotateMatrix(),
          translateMatrix = this._calcTranslateMatrix(),
          vpt = this.getViewportTransform(),
          startMatrix = multiplyMatrices(vpt, translateMatrix),
          finalMatrix = multiplyMatrices(startMatrix, rotateMatrix),
          finalMatrix = multiplyMatrices(finalMatrix, [1 / vpt[0], 0, 0, 1 / vpt[3], 0, 0]),
          dim = this._calculateCurrentDimensions(),
          coords = {};

      this.forEachControl(function (control, key, fabricObject) {
        coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
      }); // debug code
      // var canvas = this.canvas;
      // setTimeout(function() {
      //   canvas.contextTop.clearRect(0, 0, 700, 700);
      //   canvas.contextTop.fillStyle = 'green';
      //   Object.keys(coords).forEach(function(key) {
      //     var control = coords[key];
      //     canvas.contextTop.fillRect(control.x, control.y, 3, 3);
      //   });
      // }, 50);

      return coords;
    },
    calcACoords: function calcACoords() {
      var rotateMatrix = this._calcRotateMatrix(),
          translateMatrix = this._calcTranslateMatrix(),
          finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix),
          dim = this._getTransformedDimensions(),
          w = dim.x / 2,
          h = dim.y / 2;

      return {
        // corners
        tl: transformPoint({
          x: -w,
          y: -h
        }, finalMatrix),
        tr: transformPoint({
          x: w,
          y: -h
        }, finalMatrix),
        bl: transformPoint({
          x: -w,
          y: h
        }, finalMatrix),
        br: transformPoint({
          x: w,
          y: h
        }, finalMatrix)
      };
    },

    /**
     * Sets corner and controls position coordinates based on current angle, width and height, left and top.
     * oCoords are used to find the corners
     * aCoords are used to quickly find an object on the canvas
     * lineCoords are used to quickly find object during pointer events.
     * See {@link https://github.com/kangax/fabric.js/wiki/When-to-call-setCoords|When-to-call-setCoords}
     * @param {Boolean} [skipCorners] skip calculation of oCoords.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setCoords: function setCoords(skipCorners) {
      this.aCoords = this.calcACoords(); // in case we are in a group, for how the inner group target check works,
      // lineCoords are exactly aCoords. Since the vpt gets absorbed by the normalized pointer.

      this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();

      if (skipCorners) {
        return this;
      } // set coordinates of the draggable boxes in the corners used to scale/rotate the image


      this.oCoords = this.calcOCoords();
      this._setCornerCoords && this._setCornerCoords();
      return this;
    },

    /**
     * calculate rotation matrix of an object
     * @return {Array} rotation matrix for the object
     */
    _calcRotateMatrix: function _calcRotateMatrix() {
      return util.calcRotateMatrix(this);
    },

    /**
     * calculate the translation matrix for an object transform
     * @return {Array} rotation matrix for the object
     */
    _calcTranslateMatrix: function _calcTranslateMatrix() {
      var center = this.getCenterPoint();
      return [1, 0, 0, 1, center.x, center.y];
    },
    transformMatrixKey: function transformMatrixKey(skipGroup) {
      var sep = '_',
          prefix = '';

      if (!skipGroup && this.group) {
        prefix = this.group.transformMatrixKey(skipGroup) + sep;
      }

      ;
      return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY + sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY + sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * There are some situation in which this is useful to avoid the fake rotation.
     * @return {Array} transform matrix for the object
     */
    calcTransformMatrix: function calcTransformMatrix(skipGroup) {
      var matrix = this.calcOwnMatrix();

      if (skipGroup || !this.group) {
        return matrix;
      }

      var key = this.transformMatrixKey(skipGroup),
          cache = this.matrixCache || (this.matrixCache = {});

      if (cache.key === key) {
        return cache.value;
      }

      if (this.group) {
        matrix = multiplyMatrices(this.group.calcTransformMatrix(false), matrix);
      }

      cache.key = key;
      cache.value = matrix;
      return matrix;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {Array} transform matrix for the object
     */
    calcOwnMatrix: function calcOwnMatrix() {
      var key = this.transformMatrixKey(true),
          cache = this.ownMatrixCache || (this.ownMatrixCache = {});

      if (cache.key === key) {
        return cache.value;
      }

      var tMatrix = this._calcTranslateMatrix(),
          options = {
        angle: this.angle,
        translateX: tMatrix[4],
        translateY: tMatrix[5],
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: this.skewX,
        skewY: this.skewY,
        flipX: this.flipX,
        flipY: this.flipY
      };

      cache.key = key;
      cache.value = util.composeMatrix(options);
      return cache.value;
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @deprecated since 3.4.0, please use fabric.util._calcDimensionsTransformMatrix
     * not including or including flipX, flipY to emulate the flipping boolean
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _calcDimensionsTransformMatrix: function _calcDimensionsTransformMatrix(skewX, skewY, flipping) {
      return util.calcDimensionsMatrix({
        skewX: skewX,
        skewY: skewY,
        scaleX: this.scaleX * (flipping && this.flipX ? -1 : 1),
        scaleY: this.scaleY * (flipping && this.flipY ? -1 : 1)
      });
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getNonTransformedDimensions: function _getNonTransformedDimensions() {
      var strokeWidth = this.strokeWidth,
          w = this.width + strokeWidth,
          h = this.height + strokeWidth;
      return {
        x: w,
        y: h
      };
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param {Number} skewX, a value to override current skewX
     * @param {Number} skewY, a value to override current skewY
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getTransformedDimensions: function _getTransformedDimensions(skewX, skewY) {
      if (typeof skewX === 'undefined') {
        skewX = this.skewX;
      }

      if (typeof skewY === 'undefined') {
        skewY = this.skewY;
      }

      var dimensions = this._getNonTransformedDimensions(),
          dimX,
          dimY,
          noSkew = skewX === 0 && skewY === 0;

      if (this.strokeUniform) {
        dimX = this.width;
        dimY = this.height;
      } else {
        dimX = dimensions.x;
        dimY = dimensions.y;
      }

      if (noSkew) {
        return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
      }

      var bbox = util.sizeAfterTransform(dimX, dimY, {
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: skewX,
        skewY: skewY
      });
      return this._finalizeDimensions(bbox.x, bbox.y);
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */
    _finalizeDimensions: function _finalizeDimensions(width, height) {
      return this.strokeUniform ? {
        x: width + this.strokeWidth,
        y: height + this.strokeWidth
      } : {
        x: width,
        y: height
      };
    },

    /*
     * Calculate object dimensions for controls box, including padding and canvas zoom.
     * and active selection
     * private
     */
    _calculateCurrentDimensions: function _calculateCurrentDimensions() {
      var vpt = this.getViewportTransform(),
          dim = this._getTransformedDimensions(),
          p = transformPoint(dim, vpt, true);

      return p.scalarAdd(2 * this.padding);
    }
  });
})();

fabric.util.object.extend(fabric.Object.prototype,
/** @lends fabric.Object.prototype */
{
  /**
   * Moves an object to the bottom of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendToBack: function sendToBack() {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
    } else if (this.canvas) {
      this.canvas.sendToBack(this);
    }

    return this;
  },

  /**
   * Moves an object to the top of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringToFront: function bringToFront() {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
    } else if (this.canvas) {
      this.canvas.bringToFront(this);
    }

    return this;
  },

  /**
   * Moves an object down in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendBackwards: function sendBackwards(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
    } else if (this.canvas) {
      this.canvas.sendBackwards(this, intersecting);
    }

    return this;
  },

  /**
   * Moves an object up in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringForward: function bringForward(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
    } else if (this.canvas) {
      this.canvas.bringForward(this, intersecting);
    }

    return this;
  },

  /**
   * Moves an object to specified level in stack of drawn objects
   * @param {Number} index New position of object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  moveTo: function moveTo(index) {
    if (this.group && this.group.type !== 'activeSelection') {
      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
    } else if (this.canvas) {
      this.canvas.moveTo(this, index);
    }

    return this;
  }
});
/* _TO_SVG_START_ */

(function () {
  function getSvgColorString(prop, value) {
    if (!value) {
      return prop + ': none; ';
    } else if (value.toLive) {
      return prop + ': url(#SVGID_' + value.id + '); ';
    } else {
      var color = new fabric.Color(value),
          str = prop + ': ' + color.toRgb() + '; ',
          opacity = color.getAlpha();

      if (opacity !== 1) {
        //change the color in rgb + opacity
        str += prop + '-opacity: ' + opacity.toString() + '; ';
      }

      return str;
    }
  }

  var toFixed = fabric.util.toFixed;
  fabric.util.object.extend(fabric.Object.prototype,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function getSvgStyles(skipShadow) {
      var fillRule = this.fillRule ? this.fillRule : 'nonzero',
          strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
          strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
          strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
          strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
          strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
          strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
          opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
          visibility = this.visible ? '' : ' visibility: hidden;',
          filter = skipShadow ? '' : this.getSvgFilter(),
          fill = getSvgColorString('fill', this.fill),
          stroke = getSvgColorString('stroke', this.stroke);
      return [stroke, 'stroke-width: ', strokeWidth, '; ', 'stroke-dasharray: ', strokeDashArray, '; ', 'stroke-linecap: ', strokeLineCap, '; ', 'stroke-dashoffset: ', strokeDashOffset, '; ', 'stroke-linejoin: ', strokeLineJoin, '; ', 'stroke-miterlimit: ', strokeMiterLimit, '; ', fill, 'fill-rule: ', fillRule, '; ', 'opacity: ', opacity, ';', filter, visibility].join('');
    },

    /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */
    getSvgSpanStyles: function getSvgSpanStyles(style, useWhiteSpace) {
      var term = '; ';
      var fontFamily = style.fontFamily ? 'font-family: ' + (style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1 ? '\'' + style.fontFamily + '\'' : style.fontFamily) + term : '';
      var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '',
          fontFamily = fontFamily,
          fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '',
          fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '',
          fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '',
          fill = style.fill ? getSvgColorString('fill', style.fill) : '',
          stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '',
          textDecoration = this.getSvgTextDecoration(style),
          deltaY = style.deltaY ? 'baseline-shift: ' + -style.deltaY + '; ' : '';

      if (textDecoration) {
        textDecoration = 'text-decoration: ' + textDecoration + term;
      }

      return [stroke, strokeWidth, fontFamily, fontSize, fontStyle, fontWeight, textDecoration, fill, deltaY, useWhiteSpace ? 'white-space: pre; ' : ''].join('');
    },

    /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */
    getSvgTextDecoration: function getSvgTextDecoration(style) {
      return ['overline', 'underline', 'line-through'].filter(function (decoration) {
        return style[decoration.replace('-', '')];
      }).join(' ');
    },

    /**
     * Returns filter for svg shadow
     * @return {String}
     */
    getSvgFilter: function getSvgFilter() {
      return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
    },

    /**
     * Returns id attribute for svg output
     * @return {String}
     */
    getSvgCommons: function getSvgCommons() {
      return [this.id ? 'id="' + this.id + '" ' : '', this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : ''].join('');
    },

    /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */
    getSvgTransform: function getSvgTransform(full, additionalTransform) {
      var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
          svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
      return svgTransform + (additionalTransform || '') + '" ';
    },
    _setSVGBg: function _setSVGBg(textBgRects) {
      if (this.backgroundColor) {
        var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
        textBgRects.push('\t\t<rect ', this._getFillAttributes(this.backgroundColor), ' x="', toFixed(-this.width / 2, NUM_FRACTION_DIGITS), '" y="', toFixed(-this.height / 2, NUM_FRACTION_DIGITS), '" width="', toFixed(this.width, NUM_FRACTION_DIGITS), '" height="', toFixed(this.height, NUM_FRACTION_DIGITS), '"></rect>\n');
      }
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function toSVG(reviver) {
      return this._createBaseSVGMarkup(this._toSVG(reviver), {
        reviver: reviver
      });
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function toClipPathSVG(reviver) {
      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
        reviver: reviver
      });
    },

    /**
     * @private
     */
    _createBaseClipPathSVGMarkup: function _createBaseClipPathSVGMarkup(objectMarkup, options) {
      options = options || {};
      var reviver = options.reviver,
          additionalTransform = options.additionalTransform || '',
          commonPieces = [this.getSvgTransform(true, additionalTransform), this.getSvgCommons()].join(''),
          // insert commons in the markup, style and svgCommons
      index = objectMarkup.indexOf('COMMON_PARTS');
      objectMarkup[index] = commonPieces;
      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
    },

    /**
     * @private
     */
    _createBaseSVGMarkup: function _createBaseSVGMarkup(objectMarkup, options) {
      options = options || {};
      var noStyle = options.noStyle,
          reviver = options.reviver,
          styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ',
          shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '',
          clipPath = this.clipPath,
          vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
          absoluteClipPath = clipPath && clipPath.absolutePositioned,
          stroke = this.stroke,
          fill = this.fill,
          shadow = this.shadow,
          commonPieces,
          markup = [],
          clipPathMarkup,
          // insert commons in the markup, style and svgCommons
      index = objectMarkup.indexOf('COMMON_PARTS'),
          additionalTransform = options.additionalTransform;

      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' + clipPath.toClipPathSVG(reviver) + '</clipPath>\n';
      }

      if (absoluteClipPath) {
        markup.push('<g ', shadowInfo, this.getSvgCommons(), ' >\n');
      }

      markup.push('<g ', this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '', ' >\n');
      commonPieces = [styleInfo, vectorEffect, noStyle ? '' : this.addPaintOrder(), ' ', additionalTransform ? 'transform="' + additionalTransform + '" ' : ''].join('');
      objectMarkup[index] = commonPieces;

      if (fill && fill.toLive) {
        markup.push(fill.toSVG(this));
      }

      if (stroke && stroke.toLive) {
        markup.push(stroke.toSVG(this));
      }

      if (shadow) {
        markup.push(shadow.toSVG(this));
      }

      if (clipPath) {
        markup.push(clipPathMarkup);
      }

      markup.push(objectMarkup.join(''));
      markup.push('</g>\n');
      absoluteClipPath && markup.push('</g>\n');
      return reviver ? reviver(markup.join('')) : markup.join('');
    },
    addPaintOrder: function addPaintOrder() {
      return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
    }
  });
})();
/* _TO_SVG_END_ */


(function () {
  var extend = fabric.util.object.extend,
      originalSet = 'stateProperties';
  /*
    Depends on `stateProperties`
  */

  function saveProps(origin, destination, props) {
    var tmpObj = {},
        deep = true;
    props.forEach(function (prop) {
      tmpObj[prop] = origin[prop];
    });
    extend(origin[destination], tmpObj, deep);
  }

  function _isEqual(origValue, currentValue, firstPass) {
    if (origValue === currentValue) {
      // if the objects are identical, return
      return true;
    } else if (Array.isArray(origValue)) {
      if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
        return false;
      }

      for (var i = 0, len = origValue.length; i < len; i++) {
        if (!_isEqual(origValue[i], currentValue[i])) {
          return false;
        }
      }

      return true;
    } else if (origValue && _typeof(origValue) === 'object') {
      var keys = Object.keys(origValue),
          key;

      if (!currentValue || _typeof(currentValue) !== 'object' || !firstPass && keys.length !== Object.keys(currentValue).length) {
        return false;
      }

      for (var i = 0, len = keys.length; i < len; i++) {
        key = keys[i]; // since clipPath is in the statefull cache list and the clipPath objects
        // would be iterated as an object, this would lead to possible infinite recursion
        // we do not want to compare those.

        if (key === 'canvas' || key === 'group') {
          continue;
        }

        if (!_isEqual(origValue[key], currentValue[key])) {
          return false;
        }
      }

      return true;
    }
  }

  fabric.util.object.extend(fabric.Object.prototype,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Returns true if object state (one of its state properties) was changed
     * @param {String} [propertySet] optional name for the set of property we want to save
     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
     */
    hasStateChanged: function hasStateChanged(propertySet) {
      propertySet = propertySet || originalSet;
      var dashedPropertySet = '_' + propertySet;

      if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
        return true;
      }

      return !_isEqual(this[dashedPropertySet], this, true);
    },

    /**
     * Saves state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    saveState: function saveState(options) {
      var propertySet = options && options.propertySet || originalSet,
          destination = '_' + propertySet;

      if (!this[destination]) {
        return this.setupState(options);
      }

      saveProps(this, destination, this[propertySet]);

      if (options && options.stateProperties) {
        saveProps(this, destination, options.stateProperties);
      }

      return this;
    },

    /**
     * Setups state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    setupState: function setupState(options) {
      options = options || {};
      var propertySet = options.propertySet || originalSet;
      options.propertySet = propertySet;
      this['_' + propertySet] = {};
      this.saveState(options);
      return this;
    }
  });
})();

(function () {
  var degreesToRadians = fabric.util.degreesToRadians;
  fabric.util.object.extend(fabric.Object.prototype,
  /** @lends fabric.Object.prototype */
  {
    /**
     * Determines which corner has been clicked
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
     */
    _findTargetCorner: function _findTargetCorner(pointer, forTouch) {
      // objects in group, anykind, are not self modificable,
      // must not return an hovered corner.
      if (!this.hasControls || this.group || !this.canvas || this.canvas._activeObject !== this) {
        return false;
      }

      var ex = pointer.x,
          ey = pointer.y,
          xPoints,
          lines,
          keys = Object.keys(this.oCoords),
          j = keys.length - 1,
          i;
      this.__corner = 0; // cycle in reverse order so we pick first the one on top

      for (; j >= 0; j--) {
        i = keys[j];

        if (!this.isControlVisible(i)) {
          continue;
        }

        lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner); // // debugging
        //
        // this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);

        xPoints = this._findCrossPoints({
          x: ex,
          y: ey
        }, lines);

        if (xPoints !== 0 && xPoints % 2 === 1) {
          this.__corner = i;
          return i;
        }
      }

      return false;
    },

    /**
     * Calls a function for each control. The function gets called,
     * with the control, the object that is calling the iterator and the control's key
     * @param {Function} fn function to iterate over the controls over
     */
    forEachControl: function forEachControl(fn) {
      for (var i in this.controls) {
        fn(this.controls[i], i, this);
      }

      ;
    },

    /**
     * Sets the coordinates of the draggable boxes in the corners of
     * the image used to scale/rotate it.
     * note: if we would switch to ROUND corner area, all of this would disappear.
     * everything would resolve to a single point and a pythagorean theorem for the distance
     * @private
     */
    _setCornerCoords: function _setCornerCoords() {
      var coords = this.oCoords;

      for (var control in coords) {
        var controlObject = this.controls[control];
        coords[control].corner = controlObject.calcCornerCoords(this.angle, this.cornerSize, coords[control].x, coords[control].y, false);
        coords[control].touchCorner = controlObject.calcCornerCoords(this.angle, this.touchCornerSize, coords[control].x, coords[control].y, true);
      }
    },

    /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawSelectionBackground: function drawSelectionBackground(ctx) {
      if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) {
        return this;
      }

      ctx.save();

      var center = this.getCenterPoint(),
          wh = this._calculateCurrentDimensions(),
          vpt = this.canvas.viewportTransform;

      ctx.translate(center.x, center.y);
      ctx.scale(1 / vpt[0], 1 / vpt[3]);
      ctx.rotate(degreesToRadians(this.angle));
      ctx.fillStyle = this.selectionBackgroundColor;
      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBorders: function drawBorders(ctx, styleOverride) {
      styleOverride = styleOverride || {};

      var wh = this._calculateCurrentDimensions(),
          strokeWidth = this.borderScaleFactor,
          width = wh.x + strokeWidth,
          height = wh.y + strokeWidth,
          hasControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls,
          shouldStroke = false;

      ctx.save();
      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;

      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);

      ctx.strokeRect(-width / 2, -height / 2, width, height);

      if (hasControls) {
        ctx.beginPath();
        this.forEachControl(function (control, key, fabricObject) {
          // in this moment, the ctx is centered on the object.
          // width and height of the above function are the size of the bbox.
          if (control.withConnection && control.getVisibility(fabricObject, key)) {
            // reset movement for each control
            shouldStroke = true;
            ctx.moveTo(control.x * width, control.y * height);
            ctx.lineTo(control.x * width + control.offsetX, control.y * height + control.offsetY);
          }
        });

        if (shouldStroke) {
          ctx.stroke();
        }
      }

      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box when it is inside a group.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBordersInGroup: function drawBordersInGroup(ctx, options, styleOverride) {
      styleOverride = styleOverride || {};
      var bbox = fabric.util.sizeAfterTransform(this.width, this.height, options),
          strokeWidth = this.strokeWidth,
          strokeUniform = this.strokeUniform,
          borderScaleFactor = this.borderScaleFactor,
          width = bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor,
          height = bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
      ctx.save();

      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);

      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
      ctx.strokeRect(-width / 2, -height / 2, width, height);
      ctx.restore();
      return this;
    },

    /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawControls: function drawControls(ctx, styleOverride) {
      styleOverride = styleOverride || {};
      ctx.save();
      ctx.setTransform(this.canvas.getRetinaScaling(), 0, 0, this.canvas.getRetinaScaling(), 0, 0);
      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;

      if (!this.transparentCorners) {
        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
      }

      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);

      this.setCoords();
      this.forEachControl(function (control, key, fabricObject) {
        if (control.getVisibility(fabricObject, key)) {
          control.render(ctx, fabricObject.oCoords[key].x, fabricObject.oCoords[key].y, styleOverride, fabricObject);
        }
      });
      ctx.restore();
      return this;
    },

    /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @returns {Boolean} true if the specified control is visible, false otherwise
     */
    isControlVisible: function isControlVisible(controlKey) {
      return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    },

    /**
     * Sets the visibility of the specified control.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlVisible: function setControlVisible(controlKey, visible) {
      if (!this._controlsVisibility) {
        this._controlsVisibility = {};
      }

      this._controlsVisibility[controlKey] = visible;
      return this;
    },

    /**
     * Sets the visibility state of object controls.
     * @param {Object} [options] Options object
     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlsVisibility: function setControlsVisibility(options) {
      options || (options = {});

      for (var p in options) {
        this.setControlVisible(p, options[p]);
      }

      return this;
    },

    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onDeselect: function onDeselect() {// implemented by sub-classes, as needed.
    },

    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onSelect: function onSelect() {// implemented by sub-classes, as needed.
    }
  });
})();

fabric.util.object.extend(fabric.StaticCanvas.prototype,
/** @lends fabric.StaticCanvas.prototype */
{
  /**
   * Animation duration (in ms) for fx* methods
   * @type Number
   * @default
   */
  FX_DURATION: 500,

  /**
   * Centers object horizontally with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectH: function fxCenterObjectH(object, callbacks) {
    callbacks = callbacks || {};

    var empty = function empty() {},
        _onComplete = callbacks.onComplete || empty,
        _onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.left,
      endValue: this.getCenter().left,
      duration: this.FX_DURATION,
      onChange: function onChange(value) {
        object.set('left', value);

        _this.requestRenderAll();

        _onChange();
      },
      onComplete: function onComplete() {
        object.setCoords();

        _onComplete();
      }
    });
    return this;
  },

  /**
   * Centers object vertically with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectV: function fxCenterObjectV(object, callbacks) {
    callbacks = callbacks || {};

    var empty = function empty() {},
        _onComplete2 = callbacks.onComplete || empty,
        _onChange2 = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.top,
      endValue: this.getCenter().top,
      duration: this.FX_DURATION,
      onChange: function onChange(value) {
        object.set('top', value);

        _this.requestRenderAll();

        _onChange2();
      },
      onComplete: function onComplete() {
        object.setCoords();

        _onComplete2();
      }
    });
    return this;
  },

  /**
   * Same as `fabric.Canvas#remove` but animated
   * @param {fabric.Object} object Object to remove
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxRemove: function fxRemove(object, callbacks) {
    callbacks = callbacks || {};

    var empty = function empty() {},
        _onComplete3 = callbacks.onComplete || empty,
        _onChange3 = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.opacity,
      endValue: 0,
      duration: this.FX_DURATION,
      onChange: function onChange(value) {
        object.set('opacity', value);

        _this.requestRenderAll();

        _onChange3();
      },
      onComplete: function onComplete() {
        _this.remove(object);

        _onComplete3();
      }
    });
    return this;
  }
});
fabric.util.object.extend(fabric.Object.prototype,
/** @lends fabric.Object.prototype */
{
  /**
   * Animates object's properties
   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
   * @return {fabric.Object} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @chainable
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   *
   * As string — one property
   *
   * object.animate('left', ...);
   * object.animate('left', { duration: ... });
   *
   */
  animate: function animate() {
    if (arguments[0] && _typeof(arguments[0]) === 'object') {
      var propsToAnimate = [],
          prop,
          skipCallbacks;

      for (prop in arguments[0]) {
        propsToAnimate.push(prop);
      }

      for (var i = 0, len = propsToAnimate.length; i < len; i++) {
        prop = propsToAnimate[i];
        skipCallbacks = i !== len - 1;

        this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks);
      }
    } else {
      this._animate.apply(this, arguments);
    }

    return this;
  },

  /**
   * @private
   * @param {String} property Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
   */
  _animate: function _animate(property, to, options, skipCallbacks) {
    var _this = this,
        propPair;

    to = to.toString();

    if (!options) {
      options = {};
    } else {
      options = fabric.util.object.clone(options);
    }

    if (~property.indexOf('.')) {
      propPair = property.split('.');
    }

    var propIsColor = _this.colorProperties.indexOf(property) > -1 || propPair && _this.colorProperties.indexOf(propPair[1]) > -1;
    var currentValue = propPair ? this.get(propPair[0])[propPair[1]] : this.get(property);

    if (!('from' in options)) {
      options.from = currentValue;
    }

    if (!propIsColor) {
      if (~to.indexOf('=')) {
        to = currentValue + parseFloat(to.replace('=', ''));
      } else {
        to = parseFloat(to);
      }
    }

    var _options = {
      startValue: options.from,
      endValue: to,
      byValue: options.by,
      easing: options.easing,
      duration: options.duration,
      abort: options.abort && function () {
        return options.abort.call(_this);
      },
      onChange: function onChange(value, valueProgress, timeProgress) {
        if (propPair) {
          _this[propPair[0]][propPair[1]] = value;
        } else {
          _this.set(property, value);
        }

        if (skipCallbacks) {
          return;
        }

        options.onChange && options.onChange(value, valueProgress, timeProgress);
      },
      onComplete: function onComplete(value, valueProgress, timeProgress) {
        if (skipCallbacks) {
          return;
        }

        _this.setCoords();

        options.onComplete && options.onComplete(value, valueProgress, timeProgress);
      }
    };

    if (propIsColor) {
      fabric.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
    } else {
      fabric.util.animate(_options);
    }
  }
});

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      coordProps = {
    x1: 1,
    x2: 1,
    y1: 1,
    y2: 1
  },
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash');

  if (fabric.Line) {
    fabric.warn('fabric.Line is already defined');
    return;
  }
  /**
   * Line class
   * @class fabric.Line
   * @extends fabric.Object
   * @see {@link fabric.Line#initialize} for constructor definition
   */


  fabric.Line = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Line.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'line',

    /**
     * x value or first line edge
     * @type Number
     * @default
     */
    x1: 0,

    /**
     * y value or first line edge
     * @type Number
     * @default
     */
    y1: 0,

    /**
     * x value or second line edge
     * @type Number
     * @default
     */
    x2: 0,

    /**
     * y value or second line edge
     * @type Number
     * @default
     */
    y2: 0,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),

    /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {fabric.Line} thisArg
     */
    initialize: function initialize(points, options) {
      if (!points) {
        points = [0, 0, 0, 0];
      }

      this.callSuper('initialize', options);
      this.set('x1', points[0]);
      this.set('y1', points[1]);
      this.set('x2', points[2]);
      this.set('y2', points[3]);

      this._setWidthHeight(options);
    },

    /**
     * @private
     * @param {Object} [options] Options
     */
    _setWidthHeight: function _setWidthHeight(options) {
      options || (options = {});
      this.width = Math.abs(this.x2 - this.x1);
      this.height = Math.abs(this.y2 - this.y1);
      this.left = 'left' in options ? options.left : this._getLeftToOriginX();
      this.top = 'top' in options ? options.top : this._getTopToOriginY();
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     */
    _set: function _set(key, value) {
      this.callSuper('_set', key, value);

      if (typeof coordProps[key] !== 'undefined') {
        this._setWidthHeight();
      }

      return this;
    },

    /**
     * @private
     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
     */
    _getLeftToOriginX: makeEdgeToOriginGetter({
      // property names
      origin: 'originX',
      axis1: 'x1',
      axis2: 'x2',
      dimension: 'width'
    }, {
      // possible values of origin
      nearest: 'left',
      center: 'center',
      farthest: 'right'
    }),

    /**
     * @private
     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
     */
    _getTopToOriginY: makeEdgeToOriginGetter({
      // property names
      origin: 'originY',
      axis1: 'y1',
      axis2: 'y2',
      dimension: 'height'
    }, {
      // possible values of origin
      nearest: 'top',
      center: 'center',
      farthest: 'bottom'
    }),

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      ctx.beginPath();

      if (!this.strokeDashArray || this.strokeDashArray && supportsLineDash) {
        // move from center (of virtual box) to its left/top corner
        // we can't assume x1, y1 is top left and x2, y2 is bottom right
        var p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
      }

      ctx.lineWidth = this.strokeWidth; // TODO: test this
      // make sure setting "fill" changes color of a line
      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)

      var origStrokeStyle = ctx.strokeStyle;
      ctx.strokeStyle = this.stroke || ctx.fillStyle;
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      var p = this.calcLinePoints();
      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, p.x1, p.y1, p.x2, p.y2, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function _findCenterFromElement() {
      return {
        x: (this.x1 + this.x2) / 2,
        y: (this.y1 + this.y2) / 2
      };
    },

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     */
    _getNonTransformedDimensions: function _getNonTransformedDimensions() {
      var dim = this.callSuper('_getNonTransformedDimensions');

      if (this.strokeLineCap === 'butt') {
        if (this.width === 0) {
          dim.y -= this.strokeWidth;
        }

        if (this.height === 0) {
          dim.x -= this.strokeWidth;
        }
      }

      return dim;
    },

    /**
     * Recalculates line points given width and height
     * @private
     */
    calcLinePoints: function calcLinePoints() {
      var xMult = this.x1 <= this.x2 ? -1 : 1,
          yMult = this.y1 <= this.y2 ? -1 : 1,
          x1 = xMult * this.width * 0.5,
          y1 = yMult * this.height * 0.5,
          x2 = xMult * this.width * -0.5,
          y2 = yMult * this.height * -0.5;
      return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      };
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var p = this.calcLinePoints();
      return ['<line ', 'COMMON_PARTS', 'x1="', p.x1, '" y1="', p.y1, '" x2="', p.x2, '" y2="', p.y2, '" />\n'];
    }
    /* _TO_SVG_END_ */

  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
   * @static
   * @memberOf fabric.Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */

  fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));
  /**
   * Returns fabric.Line instance from an SVG element
   * @static
   * @memberOf fabric.Line
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */

  fabric.Line.fromElement = function (element, callback, options) {
    options = options || {};
    var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES),
        points = [parsedAttributes.x1 || 0, parsedAttributes.y1 || 0, parsedAttributes.x2 || 0, parsedAttributes.y2 || 0];
    callback(new fabric.Line(points, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Line instance from an object representation
   * @static
   * @memberOf fabric.Line
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */


  fabric.Line.fromObject = function (object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    }

    ;
    var options = clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];

    fabric.Object._fromObject('Line', options, _callback, 'points');
  };
  /**
   * Produces a function that calculates distance from canvas edge to Line origin.
   */


  function makeEdgeToOriginGetter(propertyNames, originValues) {
    var origin = propertyNames.origin,
        axis1 = propertyNames.axis1,
        axis2 = propertyNames.axis2,
        dimension = propertyNames.dimension,
        nearest = originValues.nearest,
        center = originValues.center,
        farthest = originValues.farthest;
    return function () {
      switch (this.get(origin)) {
        case nearest:
          return Math.min(this.get(axis1), this.get(axis2));

        case center:
          return Math.min(this.get(axis1), this.get(axis2)) + 0.5 * this.get(dimension);

        case farthest:
          return Math.max(this.get(axis1), this.get(axis2));
      }
    };
  }
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      pi = Math.PI;

  if (fabric.Circle) {
    fabric.warn('fabric.Circle is already defined.');
    return;
  }
  /**
   * Circle class
   * @class fabric.Circle
   * @extends fabric.Object
   * @see {@link fabric.Circle#initialize} for constructor definition
   */


  fabric.Circle = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Circle.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'circle',

    /**
     * Radius of this circle
     * @type Number
     * @default
     */
    radius: 0,

    /**
     * Start angle of the circle, moving clockwise
     * deprecated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 0
     */
    startAngle: 0,

    /**
     * End angle of the circle
     * deprecated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 2Pi
     */
    endAngle: pi * 2,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Circle} thisArg
     */
    _set: function _set(key, value) {
      this.callSuper('_set', key, value);

      if (key === 'radius') {
        this.setRadius(value);
      }

      return this;
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return this.callSuper('toObject', ['radius', 'startAngle', 'endAngle'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var svgString,
          x = 0,
          y = 0,
          angle = (this.endAngle - this.startAngle) % (2 * pi);

      if (angle === 0) {
        svgString = ['<circle ', 'COMMON_PARTS', 'cx="' + x + '" cy="' + y + '" ', 'r="', this.radius, '" />\n'];
      } else {
        var startX = fabric.util.cos(this.startAngle) * this.radius,
            startY = fabric.util.sin(this.startAngle) * this.radius,
            endX = fabric.util.cos(this.endAngle) * this.radius,
            endY = fabric.util.sin(this.endAngle) * this.radius,
            largeFlag = angle > pi ? '1' : '0';
        svgString = ['<path d="M ' + startX + ' ' + startY, ' A ' + this.radius + ' ' + this.radius, ' 0 ', +largeFlag + ' 1', ' ' + endX + ' ' + endY, '" ', 'COMMON_PARTS', ' />\n'];
      }

      return svgString;
    },

    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function _render(ctx) {
      ctx.beginPath();
      ctx.arc(0, 0, this.radius, this.startAngle, this.endAngle, false);

      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusX: function getRadiusX() {
      return this.get('radius') * this.get('scaleX');
    },

    /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusY: function getRadiusY() {
      return this.get('radius') * this.get('scaleY');
    },

    /**
     * Sets radius of an object (and updates width accordingly)
     * @return {fabric.Circle} thisArg
     */
    setRadius: function setRadius(value) {
      this.radius = value;
      return this.set('width', value * 2).set('height', value * 2);
    }
  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
   * @static
   * @memberOf fabric.Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */

  fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));
  /**
   * Returns {@link fabric.Circle} instance from an SVG element
   * @static
   * @memberOf fabric.Circle
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @param {Object} [options] Options object
   * @throws {Error} If value of `r` attribute is missing or invalid
   */

  fabric.Circle.fromElement = function (element, callback) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);

    if (!isValidRadius(parsedAttributes)) {
      throw new Error('value of `r` attribute is required and can not be negative');
    }

    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
    callback(new fabric.Circle(parsedAttributes));
  };
  /**
   * @private
   */


  function isValidRadius(attributes) {
    return 'radius' in attributes && attributes.radius >= 0;
  }
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Circle} instance from an object representation
   * @static
   * @memberOf fabric.Circle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {Object} Instance of fabric.Circle
   */


  fabric.Circle.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Circle', object, callback);
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.Triangle) {
    fabric.warn('fabric.Triangle is already defined');
    return;
  }
  /**
   * Triangle class
   * @class fabric.Triangle
   * @extends fabric.Object
   * @return {fabric.Triangle} thisArg
   * @see {@link fabric.Triangle#initialize} for constructor definition
   */


  fabric.Triangle = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Triangle.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'triangle',

    /**
     * Width is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    width: 100,

    /**
     * Height is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    height: 100,

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-widthBy2, heightBy2);
      ctx.lineTo(0, -heightBy2);
      ctx.lineTo(widthBy2, heightBy2);
      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;
      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, -widthBy2, heightBy2, 0, -heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, 0, -heightBy2, widthBy2, heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, widthBy2, heightBy2, -widthBy2, heightBy2, this.strokeDashArray);
      ctx.closePath();
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2,
          points = [-widthBy2 + ' ' + heightBy2, '0 ' + -heightBy2, widthBy2 + ' ' + heightBy2].join(',');
      return ['<polygon ', 'COMMON_PARTS', 'points="', points, '" />'];
    }
    /* _TO_SVG_END_ */

  });
  /**
   * Returns {@link fabric.Triangle} instance from an object representation
   * @static
   * @memberOf fabric.Triangle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */

  fabric.Triangle.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Triangle', object, callback);
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      piBy2 = Math.PI * 2;

  if (fabric.Ellipse) {
    fabric.warn('fabric.Ellipse is already defined.');
    return;
  }
  /**
   * Ellipse class
   * @class fabric.Ellipse
   * @extends fabric.Object
   * @return {fabric.Ellipse} thisArg
   * @see {@link fabric.Ellipse#initialize} for constructor definition
   */


  fabric.Ellipse = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Ellipse.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'ellipse',

    /**
     * Horizontal radius
     * @type Number
     * @default
     */
    rx: 0,

    /**
     * Vertical radius
     * @type Number
     * @default
     */
    ry: 0,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {fabric.Ellipse} thisArg
     */
    initialize: function initialize(options) {
      this.callSuper('initialize', options);
      this.set('rx', options && options.rx || 0);
      this.set('ry', options && options.ry || 0);
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Ellipse} thisArg
     */
    _set: function _set(key, value) {
      this.callSuper('_set', key, value);

      switch (key) {
        case 'rx':
          this.rx = value;
          this.set('width', value * 2);
          break;

        case 'ry':
          this.ry = value;
          this.set('height', value * 2);
          break;
      }

      return this;
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRx: function getRx() {
      return this.get('rx') * this.get('scaleX');
    },

    /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRy: function getRy() {
      return this.get('ry') * this.get('scaleY');
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      return ['<ellipse ', 'COMMON_PARTS', 'cx="0" cy="0" ', 'rx="', this.rx, '" ry="', this.ry, '" />\n'];
    },

    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function _render(ctx) {
      ctx.beginPath();
      ctx.save();
      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
      ctx.arc(0, 0, this.rx, 0, piBy2, false);
      ctx.restore();

      this._renderPaintInOrder(ctx);
    }
  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
   * @static
   * @memberOf fabric.Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */

  fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));
  /**
   * Returns {@link fabric.Ellipse} instance from an SVG element
   * @static
   * @memberOf fabric.Ellipse
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @return {fabric.Ellipse}
   */

  fabric.Ellipse.fromElement = function (element, callback) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);
    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
    callback(new fabric.Ellipse(parsedAttributes));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Ellipse} instance from an object representation
   * @static
   * @memberOf fabric.Ellipse
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {fabric.Ellipse}
   */


  fabric.Ellipse.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Ellipse', object, callback);
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend;

  if (fabric.Rect) {
    fabric.warn('fabric.Rect is already defined');
    return;
  }
  /**
   * Rectangle class
   * @class fabric.Rect
   * @extends fabric.Object
   * @return {fabric.Rect} thisArg
   * @see {@link fabric.Rect#initialize} for constructor definition
   */


  fabric.Rect = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Rect.prototype */
  {
    /**
     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'rect',

    /**
     * Horizontal border radius
     * @type Number
     * @default
     */
    rx: 0,

    /**
     * Vertical border radius
     * @type Number
     * @default
     */
    ry: 0,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function initialize(options) {
      this.callSuper('initialize', options);

      this._initRxRy();
    },

    /**
     * Initializes rx/ry attributes
     * @private
     */
    _initRxRy: function _initRxRy() {
      if (this.rx && !this.ry) {
        this.ry = this.rx;
      } else if (this.ry && !this.rx) {
        this.rx = this.ry;
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      // 1x1 case (used in spray brush) optimization was removed because
      // with caching and higher zoom level this makes more damage than help
      var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0,
          ry = this.ry ? Math.min(this.ry, this.height / 2) : 0,
          w = this.width,
          h = this.height,
          x = -this.width / 2,
          y = -this.height / 2,
          isRounded = rx !== 0 || ry !== 0,

      /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
      k = 1 - 0.5522847498;
      ctx.beginPath();
      ctx.moveTo(x + rx, y);
      ctx.lineTo(x + w - rx, y);
      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
      ctx.lineTo(x + w, y + h - ry);
      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
      ctx.lineTo(x + rx, y + h);
      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
      ctx.lineTo(x, y + ry);
      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;
      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var x = -this.width / 2,
          y = -this.height / 2;
      return ['<rect ', 'COMMON_PARTS', 'x="', x, '" y="', y, '" rx="', this.rx, '" ry="', this.ry, '" width="', this.width, '" height="', this.height, '" />\n'];
    }
    /* _TO_SVG_END_ */

  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
   * @static
   * @memberOf fabric.Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */

  fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));
  /**
   * Returns {@link fabric.Rect} instance from an SVG element
   * @static
   * @memberOf fabric.Rect
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */

  fabric.Rect.fromElement = function (element, callback, options) {
    if (!element) {
      return callback(null);
    }

    options = options || {};
    var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
    parsedAttributes.left = parsedAttributes.left || 0;
    parsedAttributes.top = parsedAttributes.top || 0;
    parsedAttributes.height = parsedAttributes.height || 0;
    parsedAttributes.width = parsedAttributes.width || 0;
    var rect = new fabric.Rect(extend(options ? fabric.util.object.clone(options) : {}, parsedAttributes));
    rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
    callback(rect);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Rect} instance from an object representation
   * @static
   * @memberOf fabric.Rect
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
   */


  fabric.Rect.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Rect', object, callback);
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      toFixed = fabric.util.toFixed;

  if (fabric.Polyline) {
    fabric.warn('fabric.Polyline is already defined');
    return;
  }
  /**
   * Polyline class
   * @class fabric.Polyline
   * @extends fabric.Object
   * @see {@link fabric.Polyline#initialize} for constructor definition
   */


  fabric.Polyline = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Polyline.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polyline',

    /**
     * Points array
     * @type Array
     * @default
     */
    points: null,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),

    /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {fabric.Polyline} thisArg
     * @example
     * var poly = new fabric.Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */
    initialize: function initialize(points, options) {
      options = options || {};
      this.points = points || [];
      this.callSuper('initialize', options);

      this._setPositionDimensions(options);
    },
    _setPositionDimensions: function _setPositionDimensions(options) {
      var calcDim = this._calcDimensions(options),
          correctLeftTop;

      this.width = calcDim.width;
      this.height = calcDim.height;

      if (!options.fromSVG) {
        correctLeftTop = this.translateToGivenOrigin({
          x: calcDim.left - this.strokeWidth / 2,
          y: calcDim.top - this.strokeWidth / 2
        }, 'left', 'top', this.originX, this.originY);
      }

      if (typeof options.left === 'undefined') {
        this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
      }

      if (typeof options.top === 'undefined') {
        this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
      }

      this.pathOffset = {
        x: calcDim.left + this.width / 2,
        y: calcDim.top + this.height / 2
      };
    },

    /**
     * Calculate the polygon min and max point from points array,
     * returning an object with left, top, width, height to measure the
     * polygon size
     * @return {Object} object.left X coordinate of the polygon leftmost point
     * @return {Object} object.top Y coordinate of the polygon topmost point
     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
     * @private
     */
    _calcDimensions: function _calcDimensions() {
      var points = this.points,
          minX = min(points, 'x') || 0,
          minY = min(points, 'y') || 0,
          maxX = max(points, 'x') || 0,
          maxY = max(points, 'y') || 0,
          width = maxX - minX,
          height = maxY - minY;
      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        points: this.points.concat()
      });
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var points = [],
          diffX = this.pathOffset.x,
          diffY = this.pathOffset.y,
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      for (var i = 0, len = this.points.length; i < len; i++) {
        points.push(toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',', toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' ');
      }

      return ['<' + this.type + ' ', 'COMMON_PARTS', 'points="', points.join(''), '" />\n'];
    },

    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    commonRender: function commonRender(ctx) {
      var point,
          len = this.points.length,
          x = this.pathOffset.x,
          y = this.pathOffset.y;

      if (!len || isNaN(this.points[len - 1].y)) {
        // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return false;
      }

      ctx.beginPath();
      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);

      for (var i = 0; i < len; i++) {
        point = this.points[i];
        ctx.lineTo(point.x - x, point.y - y);
      }

      return true;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      var p1, p2;
      ctx.beginPath();

      for (var i = 0, len = this.points.length; i < len; i++) {
        p1 = this.points[i];
        p2 = this.points[i + 1] || p1;
        fabric.util.drawDashedLine(ctx, p1.x, p1.y, p2.x, p2.y, this.strokeDashArray);
      }
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */
    complexity: function complexity() {
      return this.get('points').length;
    }
  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
   * @static
   * @memberOf fabric.Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */

  fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
  /**
   * Returns fabric.Polyline instance from an SVG element
   * @static
   * @memberOf fabric.Polyline
   * @param {SVGElement} element Element to parser
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */

  fabric.Polyline.fromElementGenerator = function (_class) {
    return function (element, callback, options) {
      if (!element) {
        return callback(null);
      }

      options || (options = {});
      var points = fabric.parsePointsAttribute(element.getAttribute('points')),
          parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
      parsedAttributes.fromSVG = true;
      callback(new fabric[_class](points, extend(parsedAttributes, options)));
    };
  };

  fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polyline instance from an object representation
   * @static
   * @memberOf fabric.Polyline
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */

  fabric.Polyline.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Polyline', object, callback, 'points');
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.Polygon) {
    fabric.warn('fabric.Polygon is already defined');
    return;
  }
  /**
   * Polygon class
   * @class fabric.Polygon
   * @extends fabric.Polyline
   * @see {@link fabric.Polygon#initialize} for constructor definition
   */


  fabric.Polygon = fabric.util.createClass(fabric.Polyline,
  /** @lends fabric.Polygon.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polygon',

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }

      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      this.callSuper('_renderDashedStroke', ctx);
      ctx.closePath();
    }
  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
   * @static
   * @memberOf fabric.Polygon
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
   */

  fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
  /**
   * Returns {@link fabric.Polygon} instance from an SVG element
   * @static
   * @memberOf fabric.Polygon
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */

  fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polygon instance from an object representation
   * @static
   * @memberOf fabric.Polygon
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */

  fabric.Polygon.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Polygon', object, callback, 'points');
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      extend = fabric.util.object.extend,
      _toString = Object.prototype.toString,
      toFixed = fabric.util.toFixed;

  if (fabric.Path) {
    fabric.warn('fabric.Path is already defined');
    return;
  }
  /**
   * Path class
   * @class fabric.Path
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
   * @see {@link fabric.Path#initialize} for constructor definition
   */


  fabric.Path = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Path.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'path',

    /**
     * Array of path points
     * @type Array
     * @default
     */
    path: null,
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),
    stateProperties: fabric.Object.prototype.stateProperties.concat('path'),

    /**
     * Constructor
     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Object} [options] Options object
     * @return {fabric.Path} thisArg
     */
    initialize: function initialize(path, options) {
      options = options || {};
      this.callSuper('initialize', options);

      if (!path) {
        path = [];
      }

      var fromArray = _toString.call(path) === '[object Array]';
      this.path = fromArray ? fabric.util.makePathSimpler(path) : fabric.util.makePathSimpler(fabric.util.parsePath(path));

      if (!this.path) {
        return;
      }

      fabric.Polyline.prototype._setPositionDimensions.call(this, options);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _renderPathCommands: function _renderPathCommands(ctx) {
      var current,
          // current instruction
      subpathStartX = 0,
          subpathStartY = 0,
          x = 0,
          // current x
      y = 0,
          // current y
      controlX = 0,
          // current control point x
      controlY = 0,
          // current control point y
      l = -this.pathOffset.x,
          t = -this.pathOffset.y;
      ctx.beginPath();

      for (var i = 0, len = this.path.length; i < len; ++i) {
        current = this.path[i];

        switch (current[0]) {
          // first letter
          case 'L':
            // lineto, absolute
            x = current[1];
            y = current[2];
            ctx.lineTo(x + l, y + t);
            break;

          case 'M':
            // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            ctx.moveTo(x + l, y + t);
            break;

          case 'C':
            // bezierCurveTo, absolute
            x = current[5];
            y = current[6];
            controlX = current[3];
            controlY = current[4];
            ctx.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
            break;

          case 'Q':
            // quadraticCurveTo, absolute
            ctx.quadraticCurveTo(current[1] + l, current[2] + t, current[3] + l, current[4] + t);
            x = current[3];
            y = current[4];
            controlX = current[1];
            controlY = current[2];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            ctx.closePath();
            break;
        }
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _render: function _render(ctx) {
      this._renderPathCommands(ctx);

      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function toString() {
      return '#<fabric.Path (' + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        path: this.path.map(function (item) {
          return item.slice();
        })
      });
    },

    /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function toDatalessObject(propertiesToInclude) {
      var o = this.toObject(['sourcePath'].concat(propertiesToInclude));

      if (o.sourcePath) {
        delete o.path;
      }

      return o;
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var path = this.path.map(function (path) {
        return path.join(' ');
      }).join(' ');
      return ['<path ', 'COMMON_PARTS', 'd="', path, '" stroke-linecap="round" ', '/>\n'];
    },
    _getOffsetTransform: function _getOffsetTransform() {
      var digits = fabric.Object.NUM_FRACTION_DIGITS;
      return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' + toFixed(-this.pathOffset.y, digits) + ')';
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function toClipPathSVG(reviver) {
      var additionalTransform = this._getOffsetTransform();

      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(), {
        reviver: reviver,
        additionalTransform: additionalTransform
      });
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function toSVG(reviver) {
      var additionalTransform = this._getOffsetTransform();

      return this._createBaseSVGMarkup(this._toSVG(), {
        reviver: reviver,
        additionalTransform: additionalTransform
      });
    },

    /* _TO_SVG_END_ */

    /**
     * Returns number representation of an instance complexity
     * @return {Number} complexity of this instance
     */
    complexity: function complexity() {
      return this.path.length;
    },

    /**
     * @private
     */
    _calcDimensions: function _calcDimensions() {
      var aX = [],
          aY = [],
          current,
          // current instruction
      subpathStartX = 0,
          subpathStartY = 0,
          x = 0,
          // current x
      y = 0,
          // current y
      bounds;

      for (var i = 0, len = this.path.length; i < len; ++i) {
        current = this.path[i];

        switch (current[0]) {
          // first letter
          case 'L':
            // lineto, absolute
            x = current[1];
            y = current[2];
            bounds = [];
            break;

          case 'M':
            // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            bounds = [];
            break;

          case 'C':
            // bezierCurveTo, absolute
            bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[3], current[4], current[5], current[6]);
            x = current[5];
            y = current[6];
            break;

          case 'Q':
            // quadraticCurveTo, absolute
            bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[1], current[2], current[3], current[4]);
            x = current[3];
            y = current[4];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            break;
        }

        bounds.forEach(function (point) {
          aX.push(point.x);
          aY.push(point.y);
        });
        aX.push(x);
        aY.push(y);
      }

      var minX = min(aX) || 0,
          minY = min(aY) || 0,
          maxX = max(aX) || 0,
          maxY = max(aY) || 0,
          deltaX = maxX - minX,
          deltaY = maxY - minY;
      return {
        left: minX,
        top: minY,
        width: deltaX,
        height: deltaY
      };
    }
  });
  /**
   * Creates an instance of fabric.Path from an object
   * @static
   * @memberOf fabric.Path
   * @param {Object} object
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */

  fabric.Path.fromObject = function (object, callback) {
    if (typeof object.sourcePath === 'string') {
      var pathUrl = object.sourcePath;
      fabric.loadSVGFromURL(pathUrl, function (elements) {
        var path = elements[0];
        path.setOptions(object);
        callback && callback(path);
      });
    } else {
      fabric.Object._fromObject('Path', object, callback, 'path');
    }
  };
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
   * @static
   * @memberOf fabric.Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */


  fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(['d']);
  /**
   * Creates an instance of fabric.Path from an SVG <path> element
   * @static
   * @memberOf fabric.Path
   * @param {SVGElement} element to parse
   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
   * @param {Object} [options] Options object
   * @param {Function} [callback] Options callback invoked after parsing is finished
   */

  fabric.Path.fromElement = function (element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
    parsedAttributes.fromSVG = true;
    callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      min = fabric.util.array.min,
      max = fabric.util.array.max;

  if (fabric.Group) {
    return;
  }
  /**
   * Group class
   * @class fabric.Group
   * @extends fabric.Object
   * @mixes fabric.Collection
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.Group#initialize} for constructor definition
   */


  fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection,
  /** @lends fabric.Group.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'group',

    /**
     * Width of stroke
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
     * @type Boolean
     * @default
     */
    subTargetCheck: false,

    /**
     * Groups are container, do not render anything on theyr own, ence no cache properties
     * @type Array
     * @default
     */
    cacheProperties: [],

    /**
     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
     * available setting this boolean to true.
     * @type Boolean
     * @since 2.0.0
     * @default
     */
    useSetOnGroup: false,

    /**
     * Constructor
     * @param {Object} objects Group objects
     * @param {Object} [options] Options object
     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
     * @return {Object} thisArg
     */
    initialize: function initialize(objects, options, isAlreadyGrouped) {
      options = options || {};
      this._objects = []; // if objects enclosed in a group have been grouped already,
      // we cannot change properties of objects.
      // Thus we need to set options to group without objects,

      isAlreadyGrouped && this.callSuper('initialize', options);
      this._objects = objects || [];

      for (var i = this._objects.length; i--;) {
        this._objects[i].group = this;
      }

      if (!isAlreadyGrouped) {
        var center = options && options.centerPoint; // we want to set origins before calculating the bounding box.
        // so that the topleft can be set with that in mind.
        // if specific top and left are passed, are overwritten later
        // with the callSuper('initialize', options)

        if (options.originX !== undefined) {
          this.originX = options.originX;
        }

        if (options.originY !== undefined) {
          this.originY = options.originY;
        } // if coming from svg i do not want to calc bounds.
        // i assume width and height are passed along options


        center || this._calcBounds();

        this._updateObjectsCoords(center);

        delete options.centerPoint;
        this.callSuper('initialize', options);
      } else {
        this._updateObjectsACoords();
      }

      this.setCoords();
    },

    /**
     * @private
     */
    _updateObjectsACoords: function _updateObjectsACoords() {
      var skipControls = true;

      for (var i = this._objects.length; i--;) {
        this._objects[i].setCoords(skipControls);
      }
    },

    /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */
    _updateObjectsCoords: function _updateObjectsCoords(center) {
      var center = center || this.getCenterPoint();

      for (var i = this._objects.length; i--;) {
        this._updateObjectCoords(this._objects[i], center);
      }
    },

    /**
     * @private
     * @param {Object} object
     * @param {fabric.Point} center, current center of group.
     */
    _updateObjectCoords: function _updateObjectCoords(object, center) {
      var objectLeft = object.left,
          objectTop = object.top,
          skipControls = true;
      object.set({
        left: objectLeft - center.x,
        top: objectTop - center.y
      });
      object.group = this;
      object.setCoords(skipControls);
    },

    /**
     * Returns string represenation of a group
     * @return {String}
     */
    toString: function toString() {
      return '#<fabric.Group: (' + this.complexity() + ')>';
    },

    /**
     * Adds an object to a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    addWithUpdate: function addWithUpdate(object) {
      this._restoreObjectsState();

      fabric.util.resetObjectTransform(this);

      if (object) {
        this._objects.push(object);

        object.group = this;

        object._set('canvas', this.canvas);
      }

      this._calcBounds();

      this._updateObjectsCoords();

      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * Removes an object from a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    removeWithUpdate: function removeWithUpdate(object) {
      this._restoreObjectsState();

      fabric.util.resetObjectTransform(this);
      this.remove(object);

      this._calcBounds();

      this._updateObjectsCoords();

      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * @private
     */
    _onObjectAdded: function _onObjectAdded(object) {
      this.dirty = true;
      object.group = this;

      object._set('canvas', this.canvas);
    },

    /**
     * @private
     */
    _onObjectRemoved: function _onObjectRemoved(object) {
      this.dirty = true;
      delete object.group;
    },

    /**
     * @private
     */
    _set: function _set(key, value) {
      var i = this._objects.length;

      if (this.useSetOnGroup) {
        while (i--) {
          this._objects[i].setOnGroup(key, value);
        }
      }

      if (key === 'canvas') {
        while (i--) {
          this._objects[i]._set(key, value);
        }
      }

      fabric.Object.prototype._set.call(this, key, value);
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      var _includeDefaultValues = this.includeDefaultValues;

      var objsToObject = this._objects.map(function (obj) {
        var originalDefaults = obj.includeDefaultValues;
        obj.includeDefaultValues = _includeDefaultValues;

        var _obj = obj.toObject(propertiesToInclude);

        obj.includeDefaultValues = originalDefaults;
        return _obj;
      });

      var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Returns object representation of an instance, in dataless mode.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function toDatalessObject(propertiesToInclude) {
      var objsToObject,
          sourcePath = this.sourcePath;

      if (sourcePath) {
        objsToObject = sourcePath;
      } else {
        var _includeDefaultValues = this.includeDefaultValues;
        objsToObject = this._objects.map(function (obj) {
          var originalDefaults = obj.includeDefaultValues;
          obj.includeDefaultValues = _includeDefaultValues;

          var _obj = obj.toDatalessObject(propertiesToInclude);

          obj.includeDefaultValues = originalDefaults;
          return _obj;
        });
      }

      var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */
    render: function render(ctx) {
      this._transformDone = true;
      this.callSuper('render', ctx);
      this._transformDone = false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */
    shouldCache: function shouldCache() {
      var ownCache = fabric.Object.prototype.shouldCache.call(this);

      if (ownCache) {
        for (var i = 0, len = this._objects.length; i < len; i++) {
          if (this._objects[i].willDrawShadow()) {
            this.ownCaching = false;
            return false;
          }
        }
      }

      return ownCache;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */
    willDrawShadow: function willDrawShadow() {
      if (fabric.Object.prototype.willDrawShadow.call(this)) {
        return true;
      }

      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].willDrawShadow()) {
          return true;
        }
      }

      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function isOnACache() {
      return this.ownCaching || this.group && this.group.isOnACache();
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function drawObject(ctx) {
      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i].render(ctx);
      }

      this._drawClipPath(ctx);
    },

    /**
     * Check if cache is dirty
     */
    isCacheDirty: function isCacheDirty(skipCanvas) {
      if (this.callSuper('isCacheDirty', skipCanvas)) {
        return true;
      }

      if (!this.statefullCache) {
        return false;
      }

      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].isCacheDirty(true)) {
          if (this._cacheCanvas) {
            // if this group has not a cache canvas there is nothing to clean
            var x = this.cacheWidth / this.zoomX,
                y = this.cacheHeight / this.zoomY;

            this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
          }

          return true;
        }
      }

      return false;
    },

    /**
     * Restores original state of each of group objects (original state is that which was before group was created).
     * @private
     * @return {fabric.Group} thisArg
     * @chainable
     */
    _restoreObjectsState: function _restoreObjectsState() {
      this._objects.forEach(this._restoreObjectState, this);

      return this;
    },

    /**
     * Realises the transform from this group onto the supplied object
     * i.e. it tells you what would happen if the supplied object was in
     * the group, and then the group was destroyed. It mutates the supplied
     * object.
     * @param {fabric.Object} object
     * @return {fabric.Object} transformedObject
     */
    realizeTransform: function realizeTransform(object) {
      var matrix = object.calcTransformMatrix(),
          options = fabric.util.qrDecompose(matrix),
          center = new fabric.Point(options.translateX, options.translateY);
      object.flipX = false;
      object.flipY = false;
      object.set('scaleX', options.scaleX);
      object.set('scaleY', options.scaleY);
      object.skewX = options.skewX;
      object.skewY = options.skewY;
      object.angle = options.angle;
      object.setPositionByOrigin(center, 'center', 'center');
      return object;
    },

    /**
     * Restores original state of a specified object in group
     * @private
     * @param {fabric.Object} object
     * @return {fabric.Group} thisArg
     */
    _restoreObjectState: function _restoreObjectState(object) {
      this.realizeTransform(object);
      delete object.group;
      object.setCoords();
      return this;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    destroy: function destroy() {
      // when group is destroyed objects needs to get a repaint to be eventually
      // displayed on canvas.
      this._objects.forEach(function (object) {
        object.set('dirty', true);
      });

      return this._restoreObjectsState();
    },

    /**
     * make a group an active selection, remove the group from canvas
     * the group has to be on canvas for this to work.
     * @return {fabric.ActiveSelection} thisArg
     * @chainable
     */
    toActiveSelection: function toActiveSelection() {
      if (!this.canvas) {
        return;
      }

      var objects = this._objects,
          canvas = this.canvas;
      this._objects = [];
      var options = this.toObject();
      delete options.objects;
      var activeSelection = new fabric.ActiveSelection([]);
      activeSelection.set(options);
      activeSelection.type = 'activeSelection';
      canvas.remove(this);
      objects.forEach(function (object) {
        object.group = activeSelection;
        object.dirty = true;
        canvas.add(object);
      });
      activeSelection.canvas = canvas;
      activeSelection._objects = objects;
      canvas._activeObject = activeSelection;
      activeSelection.setCoords();
      return activeSelection;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    ungroupOnCanvas: function ungroupOnCanvas() {
      return this._restoreObjectsState();
    },

    /**
     * Sets coordinates of all objects inside group
     * @return {fabric.Group} thisArg
     * @chainable
     */
    setObjectsCoords: function setObjectsCoords() {
      var skipControls = true;
      this.forEachObject(function (object) {
        object.setCoords(skipControls);
      });
      return this;
    },

    /**
     * @private
     */
    _calcBounds: function _calcBounds(onlyWidthHeight) {
      var aX = [],
          aY = [],
          o,
          prop,
          props = ['tr', 'br', 'bl', 'tl'],
          i = 0,
          iLen = this._objects.length,
          j,
          jLen = props.length;

      for (; i < iLen; ++i) {
        o = this._objects[i];
        o.aCoords = o.calcACoords();

        for (j = 0; j < jLen; j++) {
          prop = props[j];
          aX.push(o.aCoords[prop].x);
          aY.push(o.aCoords[prop].y);
        }
      }

      this._getBounds(aX, aY, onlyWidthHeight);
    },

    /**
     * @private
     */
    _getBounds: function _getBounds(aX, aY, onlyWidthHeight) {
      var minXY = new fabric.Point(min(aX), min(aY)),
          maxXY = new fabric.Point(max(aX), max(aY)),
          top = minXY.y || 0,
          left = minXY.x || 0,
          width = maxXY.x - minXY.x || 0,
          height = maxXY.y - minXY.y || 0;
      this.width = width;
      this.height = height;

      if (!onlyWidthHeight) {
        // the bounding box always finds the topleft most corner.
        // whatever is the group origin, we set up here the left/top position.
        this.setPositionByOrigin({
          x: left,
          y: top
        }, 'left', 'top');
      }
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function _toSVG(reviver) {
      var svgString = ['<g ', 'COMMON_PARTS', ' >\n'];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t\t', this._objects[i].toSVG(reviver));
      }

      svgString.push('</g>\n');
      return svgString;
    },

    /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */
    getSvgStyles: function getSvgStyles() {
      var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ? 'opacity: ' + this.opacity + ';' : '',
          visibility = this.visible ? '' : ' visibility: hidden;';
      return [opacity, this.getSvgFilter(), visibility].join('');
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function toClipPathSVG(reviver) {
      var svgString = [];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
      }

      return this._createBaseClipPathSVGMarkup(svgString, {
        reviver: reviver
      });
    }
    /* _TO_SVG_END_ */

  });
  /**
   * Returns {@link fabric.Group} instance from an object representation
   * @static
   * @memberOf fabric.Group
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an group instance is created
   */

  fabric.Group.fromObject = function (object, callback) {
    var objects = object.objects,
        options = fabric.util.object.clone(object, true);
    delete options.objects;

    if (typeof objects === 'string') {
      // it has to be an url or something went wrong.
      fabric.loadSVGFromURL(objects, function (elements) {
        var group = fabric.util.groupSVGElements(elements, object, objects);
        group.set(options);
        callback && callback(group);
      });
      return;
    }

    fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
      fabric.util.enlivenObjects([object.clipPath], function (enlivedClipPath) {
        var options = fabric.util.object.clone(object, true);
        options.clipPath = enlivedClipPath[0];
        delete options.objects;
        callback && callback(new fabric.Group(enlivenedObjects, options, true));
      });
    });
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  if (fabric.ActiveSelection) {
    return;
  }
  /**
   * Group class
   * @class fabric.ActiveSelection
   * @extends fabric.Group
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
   */


  fabric.ActiveSelection = fabric.util.createClass(fabric.Group,
  /** @lends fabric.ActiveSelection.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'activeSelection',

    /**
     * Constructor
     * @param {Object} objects ActiveSelection objects
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function initialize(objects, options) {
      options = options || {};
      this._objects = objects || [];

      for (var i = this._objects.length; i--;) {
        this._objects[i].group = this;
      }

      if (options.originX) {
        this.originX = options.originX;
      }

      if (options.originY) {
        this.originY = options.originY;
      }

      this._calcBounds();

      this._updateObjectsCoords();

      fabric.Object.prototype.initialize.call(this, options);
      this.setCoords();
    },

    /**
     * Change te activeSelection to a normal group,
     * High level function that automatically adds it to canvas as
     * active object. no events fired.
     * @since 2.0.0
     * @return {fabric.Group}
     */
    toGroup: function toGroup() {
      var objects = this._objects.concat();

      this._objects = [];
      var options = fabric.Object.prototype.toObject.call(this);
      var newGroup = new fabric.Group([]);
      delete options.type;
      newGroup.set(options);
      objects.forEach(function (object) {
        object.canvas.remove(object);
        object.group = newGroup;
      });
      newGroup._objects = objects;

      if (!this.canvas) {
        return newGroup;
      }

      var canvas = this.canvas;
      canvas.add(newGroup);
      canvas._activeObject = newGroup;
      newGroup.setCoords();
      return newGroup;
    },

    /**
     * If returns true, deselection is cancelled.
     * @since 2.0.0
     * @return {Boolean} [cancel]
     */
    onDeselect: function onDeselect() {
      this.destroy();
      return false;
    },

    /**
     * Returns string representation of a group
     * @return {String}
     */
    toString: function toString() {
      return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * @return {Boolean}
     */
    shouldCache: function shouldCache() {
      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function isOnACache() {
      return false;
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */
    _renderControls: function _renderControls(ctx, styleOverride, childrenOverride) {
      ctx.save();
      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      this.callSuper('_renderControls', ctx, styleOverride);
      childrenOverride = childrenOverride || {};

      if (typeof childrenOverride.hasControls === 'undefined') {
        childrenOverride.hasControls = false;
      }

      childrenOverride.forActiveSelection = true;

      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i]._renderControls(ctx, childrenOverride);
      }

      ctx.restore();
    }
  });
  /**
   * Returns {@link fabric.ActiveSelection} instance from an object representation
   * @static
   * @memberOf fabric.ActiveSelection
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
   */

  fabric.ActiveSelection.fromObject = function (object, callback) {
    fabric.util.enlivenObjects(object.objects, function (enlivenedObjects) {
      delete object.objects;
      callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
    });
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var extend = fabric.util.object.extend;

  if (!global.fabric) {
    global.fabric = {};
  }

  if (global.fabric.Image) {
    fabric.warn('fabric.Image is already defined.');
    return;
  }
  /**
   * Image class
   * @class fabric.Image
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   * @see {@link fabric.Image#initialize} for constructor definition
   */


  fabric.Image = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Image.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'image',

    /**
     * Width of a stroke.
     * For image quality a stroke multiple of 2 gives better results.
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default
     */
    srcFromAttribute: false,

    /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleX: 1,

    /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleY: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingX: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingY: 1,

    /**
     * minimum scale factor under which any resizeFilter is triggered to resize the image
     * 0 will disable the automatic resize. 1 will trigger automatically always.
     * number bigger than 1 are not implemented yet.
     * @type Number
     */
    minimumScaleTrigger: 0.5,

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),

    /**
     * key used to retrieve the texture representing this image
     * @since 2.0.0
     * @type String
     * @default
     */
    cacheKey: '',

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropX: 0,

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropY: 0,

    /**
     * Indicates whether this canvas will use image smoothing when painting this image.
     * Also influence if the cacheCanvas for this image uses imageSmoothing
     * @since 4.0.0-beta.11
     * @type Boolean
     * @default
     */
    imageSmoothing: true,

    /**
     * Constructor
     * @param {HTMLImageElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */
    initialize: function initialize(element, options) {
      options || (options = {});
      this.filters = [];
      this.cacheKey = 'texture' + fabric.Object.__uid++;
      this.callSuper('initialize', options);

      this._initElement(element, options);
    },

    /**
     * Returns image element which this instance if based on
     * @return {HTMLImageElement} Image element
     */
    getElement: function getElement() {
      return this._element || {};
    },

    /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setElement: function setElement(element, options) {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._element = element;
      this._originalElement = element;

      this._initConfig(options);

      if (this.filters.length !== 0) {
        this.applyFilters();
      } // resizeFilters work on the already filtered copy.
      // we need to apply resizeFilters AFTER normal filters.
      // applyResizeFilters is run more often than normal filters
      // and is triggered by user interactions rather than dev code


      if (this.resizeFilter) {
        this.applyResizeFilters();
      }

      return this;
    },

    /**
     * Delete a single texture if in webgl mode
     */
    removeTexture: function removeTexture(key) {
      var backend = fabric.filterBackend;

      if (backend && backend.evictCachesForKey) {
        backend.evictCachesForKey(key);
      }
    },

    /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */
    dispose: function dispose() {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._cacheContext = undefined;
      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach(function (element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }.bind(this));
    },

    /**
     * Get the crossOrigin value (of the corresponding image element)
     */
    getCrossOrigin: function getCrossOrigin() {
      return this._originalElement && (this._originalElement.crossOrigin || null);
    },

    /**
     * Returns original size of an image
     * @return {Object} Object with "width" and "height" properties
     */
    getOriginalSize: function getOriginalSize() {
      var element = this.getElement();
      return {
        width: element.naturalWidth || element.width,
        height: element.naturalHeight || element.height
      };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _stroke: function _stroke(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      var w = this.width / 2,
          h = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-w, -h);
      ctx.lineTo(w, -h);
      ctx.lineTo(w, h);
      ctx.lineTo(-w, h);
      ctx.lineTo(-w, -h);
      ctx.closePath();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function _renderDashedStroke(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;
      ctx.save();

      this._setStrokeStyles(ctx, this);

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
      ctx.restore();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      var filters = [];
      this.filters.forEach(function (filterObj) {
        if (filterObj) {
          filters.push(filterObj.toObject());
        }
      });
      var object = extend(this.callSuper('toObject', ['cropX', 'cropY'].concat(propertiesToInclude)), {
        src: this.getSrc(),
        crossOrigin: this.getCrossOrigin(),
        filters: filters
      });

      if (this.resizeFilter) {
        object.resizeFilter = this.resizeFilter.toObject();
      }

      return object;
    },

    /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
     * @return {Boolean}
     */
    hasCrop: function hasCrop() {
      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function _toSVG() {
      var svgString = [],
          imageMarkup = [],
          strokeSvg,
          element = this._element,
          x = -this.width / 2,
          y = -this.height / 2,
          clipPath = '',
          imageRendering = '';

      if (!element) {
        return [];
      }

      if (this.hasCrop()) {
        var clipPathId = fabric.Object.__uid++;
        svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', '</clipPath>\n');
        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
      }

      if (!this.imageSmoothing) {
        imageRendering = '" image-rendering="optimizeSpeed';
      }

      imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true), '" x="', x - this.cropX, '" y="', y - this.cropY, // we're essentially moving origin of transformation from top/left corner to the center of the shape
      // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
      // so that object's center aligns with container's left/top
      '" width="', element.width || element.naturalWidth, '" height="', element.height || element.height, imageRendering, '"', clipPath, '></image>\n');

      if (this.stroke || this.strokeDashArray) {
        var origFill = this.fill;
        this.fill = null;
        strokeSvg = ['\t<rect ', 'x="', x, '" y="', y, '" width="', this.width, '" height="', this.height, '" style="', this.getSvgStyles(), '"/>\n'];
        this.fill = origFill;
      }

      if (this.paintFirst !== 'fill') {
        svgString = svgString.concat(strokeSvg, imageMarkup);
      } else {
        svgString = svgString.concat(imageMarkup, strokeSvg);
      }

      return svgString;
    },

    /* _TO_SVG_END_ */

    /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */
    getSrc: function getSrc(filtered) {
      var element = filtered ? this._element : this._originalElement;

      if (element) {
        if (element.toDataURL) {
          return element.toDataURL();
        }

        if (this.srcFromAttribute) {
          return element.getAttribute('src');
        } else {
          return element.src;
        }
      } else {
        return this.src || '';
      }
    },

    /**
     * Sets source of an image
     * @param {String} src Source string (URL)
     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
     * @param {Object} [options] Options object
     * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setSrc: function setSrc(src, callback, options) {
      fabric.util.loadImage(src, function (img, isError) {
        this.setElement(img, options);

        this._setWidthHeight();

        callback && callback(this, isError);
      }, this, options && options.crossOrigin);
      return this;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */
    toString: function toString() {
      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
    },
    applyResizeFilters: function applyResizeFilters() {
      var filter = this.resizeFilter,
          minimumScale = this.minimumScaleTrigger,
          objectScale = this.getTotalObjectScaling(),
          scaleX = objectScale.scaleX,
          scaleY = objectScale.scaleY,
          elementToFilter = this._filteredEl || this._originalElement;

      if (this.group) {
        this.set('dirty', true);
      }

      if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
        this._element = elementToFilter;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        this._lastScaleX = scaleX;
        this._lastScaleY = scaleY;
        return;
      }

      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }

      var canvasEl = fabric.util.createCanvasElement(),
          cacheKey = this._filteredEl ? this.cacheKey + '_filtered' : this.cacheKey,
          sourceWidth = elementToFilter.width,
          sourceHeight = elementToFilter.height;
      canvasEl.width = sourceWidth;
      canvasEl.height = sourceHeight;
      this._element = canvasEl;
      this._lastScaleX = filter.scaleX = scaleX;
      this._lastScaleY = filter.scaleY = scaleY;
      fabric.filterBackend.applyFilters([filter], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
      this._filterScalingX = canvasEl.width / this._originalElement.width;
      this._filterScalingY = canvasEl.height / this._originalElement.height;
    },

    /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     * @return {thisArg} return the fabric.Image object
     * @chainable
     */
    applyFilters: function applyFilters(filters) {
      filters = filters || this.filters || [];
      filters = filters.filter(function (filter) {
        return filter && !filter.isNeutralState();
      });
      this.set('dirty', true); // needs to clear out or WEBGL will not resize correctly

      this.removeTexture(this.cacheKey + '_filtered');

      if (filters.length === 0) {
        this._element = this._originalElement;
        this._filteredEl = null;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        return this;
      }

      var imgElement = this._originalElement,
          sourceWidth = imgElement.naturalWidth || imgElement.width,
          sourceHeight = imgElement.naturalHeight || imgElement.height;

      if (this._element === this._originalElement) {
        // if the element is the same we need to create a new element
        var canvasEl = fabric.util.createCanvasElement();
        canvasEl.width = sourceWidth;
        canvasEl.height = sourceHeight;
        this._element = canvasEl;
        this._filteredEl = canvasEl;
      } else {
        // clear the existing element to get new filter data
        // also dereference the eventual resized _element
        this._element = this._filteredEl;

        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight); // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y


        this._lastScaleX = 1;
        this._lastScaleY = 1;
      }

      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }

      fabric.filterBackend.applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);

      if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
        this._filterScalingX = this._element.width / this._originalElement.width;
        this._filterScalingY = this._element.height / this._originalElement.height;
      }

      return this;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);

      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
        this.applyResizeFilters();
      }

      this._stroke(ctx);

      this._renderPaintInOrder(ctx);
    },

    /**
     * Paint the cached copy of the object on the target context.
     * it will set the imageSmoothing for the draw operation
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas: function drawCacheOnCanvas(ctx) {
      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
      fabric.Object.prototype.drawCacheOnCanvas.call(this, ctx);
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */
    shouldCache: function shouldCache() {
      return this.needsItsOwnCache();
    },
    _renderFill: function _renderFill(ctx) {
      var elementToDraw = this._element;

      if (!elementToDraw) {
        return;
      }

      var scaleX = this._filterScalingX,
          scaleY = this._filterScalingY,
          w = this.width,
          h = this.height,
          min = Math.min,
          max = Math.max,
          // crop values cannot be lesser than 0.
      cropX = max(this.cropX, 0),
          cropY = max(this.cropY, 0),
          elWidth = elementToDraw.naturalWidth || elementToDraw.width,
          elHeight = elementToDraw.naturalHeight || elementToDraw.height,
          sX = cropX * scaleX,
          sY = cropY * scaleY,
          // the width height cannot exceed element width/height, starting from the crop offset.
      sW = min(w * scaleX, elWidth - sX),
          sH = min(h * scaleY, elHeight - sY),
          x = -w / 2,
          y = -h / 2,
          maxDestW = min(w, elWidth / scaleX - cropX),
          maxDestH = min(h, elHeight / scaleX - cropY);
      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    },

    /**
     * needed to check if image needs resize
     * @private
     */
    _needsResize: function _needsResize() {
      var scale = this.getTotalObjectScaling();
      return scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY;
    },

    /**
     * @private
     */
    _resetWidthHeight: function _resetWidthHeight() {
      this.set(this.getOriginalSize());
    },

    /**
     * The Image class's initialization method. This method is automatically
     * called by the constructor.
     * @private
     * @param {HTMLImageElement|String} element The element representing the image
     * @param {Object} [options] Options object
     */
    _initElement: function _initElement(element, options) {
      this.setElement(fabric.util.getById(element), options);
      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initConfig: function _initConfig(options) {
      options || (options = {});
      this.setOptions(options);

      this._setWidthHeight(options);
    },

    /**
     * @private
     * @param {Array} filters to be initialized
     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
     */
    _initFilters: function _initFilters(filters, callback) {
      if (filters && filters.length) {
        fabric.util.enlivenObjects(filters, function (enlivenedObjects) {
          callback && callback(enlivenedObjects);
        }, 'fabric.Image.filters');
      } else {
        callback && callback();
      }
    },

    /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     * @param {Object} [options] Object with width/height properties
     */
    _setWidthHeight: function _setWidthHeight(options) {
      options || (options = {});
      var el = this.getElement();
      this.width = options.width || el.naturalWidth || el.width || 0;
      this.height = options.height || el.naturalHeight || el.height || 0;
    },

    /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     * @return {Object}
     */
    parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute() {
      var pAR = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
          rWidth = this._element.width,
          rHeight = this._element.height,
          scaleX = 1,
          scaleY = 1,
          offsetLeft = 0,
          offsetTop = 0,
          cropX = 0,
          cropY = 0,
          offset,
          pWidth = this.width,
          pHeight = this.height,
          parsedAttributes = {
        width: pWidth,
        height: pHeight
      };

      if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
        if (pAR.meetOrSlice === 'meet') {
          scaleX = scaleY = fabric.util.findScaleToFit(this._element, parsedAttributes);
          offset = (pWidth - rWidth * scaleX) / 2;

          if (pAR.alignX === 'Min') {
            offsetLeft = -offset;
          }

          if (pAR.alignX === 'Max') {
            offsetLeft = offset;
          }

          offset = (pHeight - rHeight * scaleY) / 2;

          if (pAR.alignY === 'Min') {
            offsetTop = -offset;
          }

          if (pAR.alignY === 'Max') {
            offsetTop = offset;
          }
        }

        if (pAR.meetOrSlice === 'slice') {
          scaleX = scaleY = fabric.util.findScaleToCover(this._element, parsedAttributes);
          offset = rWidth - pWidth / scaleX;

          if (pAR.alignX === 'Mid') {
            cropX = offset / 2;
          }

          if (pAR.alignX === 'Max') {
            cropX = offset;
          }

          offset = rHeight - pHeight / scaleY;

          if (pAR.alignY === 'Mid') {
            cropY = offset / 2;
          }

          if (pAR.alignY === 'Max') {
            cropY = offset;
          }

          rWidth = pWidth / scaleX;
          rHeight = pHeight / scaleY;
        }
      } else {
        scaleX = pWidth / rWidth;
        scaleY = pHeight / rHeight;
      }

      return {
        width: rWidth,
        height: rHeight,
        scaleX: scaleX,
        scaleY: scaleY,
        offsetLeft: offsetLeft,
        offsetTop: offsetTop,
        cropX: cropX,
        cropY: cropY
      };
    }
  });
  /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */

  fabric.Image.CSS_CANVAS = 'canvas-img';
  /**
   * Alias for getSrc
   * @static
   */

  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;
  /**
   * Creates an instance of fabric.Image from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} callback Callback to invoke when an image instance is created
   */

  fabric.Image.fromObject = function (_object, callback) {
    var object = fabric.util.object.clone(_object);
    fabric.util.loadImage(object.src, function (img, isError) {
      if (isError) {
        callback && callback(null, true);
        return;
      }

      fabric.Image.prototype._initFilters.call(object, object.filters, function (filters) {
        object.filters = filters || [];

        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function (resizeFilters) {
          object.resizeFilter = resizeFilters[0];
          fabric.util.enlivenObjects([object.clipPath], function (enlivedProps) {
            object.clipPath = enlivedProps[0];
            var image = new fabric.Image(img, object);
            callback(image, false);
          });
        });
      });
    }, null, object.crossOrigin);
  };
  /**
   * Creates an instance of fabric.Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument). Second argument is a boolean indicating if an error occurred or not.
   * @param {Object} [imgOptions] Options object
   */


  fabric.Image.fromURL = function (url, callback, imgOptions) {
    fabric.util.loadImage(url, function (img, isError) {
      callback && callback(new fabric.Image(img, imgOptions), isError);
    }, null, imgOptions && imgOptions.crossOrigin);
  };
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */


  fabric.Image.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y width height preserveAspectRatio xlink:href crossOrigin image-rendering'.split(' '));
  /**
   * Returns {@link fabric.Image} instance from an SVG element
   * @static
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} callback Callback to execute when fabric.Image object is created
   * @return {fabric.Image} Instance of fabric.Image
   */

  fabric.Image.fromElement = function (element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Image.ATTRIBUTE_NAMES);
    fabric.Image.fromURL(parsedAttributes['xlink:href'], callback, extend(options ? fabric.util.object.clone(options) : {}, parsedAttributes));
  };
  /* _FROM_SVG_END_ */

})(typeof exports !== 'undefined' ? exports : void 0);

fabric.util.object.extend(fabric.Object.prototype,
/** @lends fabric.Object.prototype */
{
  /**
   * @private
   * @return {Number} angle value
   */
  _getAngleValueForStraighten: function _getAngleValueForStraighten() {
    var angle = this.angle % 360;

    if (angle > 0) {
      return Math.round((angle - 1) / 90) * 90;
    }

    return Math.round(angle / 90) * 90;
  },

  /**
   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  straighten: function straighten() {
    this.rotate(this._getAngleValueForStraighten());
    return this;
  },

  /**
   * Same as {@link fabric.Object.prototype.straighten} but with animation
   * @param {Object} callbacks Object with callback functions
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Object} thisArg
   * @chainable
   */
  fxStraighten: function fxStraighten(callbacks) {
    callbacks = callbacks || {};

    var empty = function empty() {},
        _onComplete4 = callbacks.onComplete || empty,
        _onChange4 = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: this.get('angle'),
      endValue: this._getAngleValueForStraighten(),
      duration: this.FX_DURATION,
      onChange: function onChange(value) {
        _this.rotate(value);

        _onChange4();
      },
      onComplete: function onComplete() {
        _this.setCoords();

        _onComplete4();
      }
    });
    return this;
  }
});
fabric.util.object.extend(fabric.StaticCanvas.prototype,
/** @lends fabric.StaticCanvas.prototype */
{
  /**
   * Straightens object, then rerenders canvas
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  straightenObject: function straightenObject(object) {
    object.straighten();
    this.requestRenderAll();
    return this;
  },

  /**
   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxStraightenObject: function fxStraightenObject(object) {
    object.fxStraighten({
      onChange: this.requestRenderAllBound
    });
    return this;
  }
});

(function () {
  'use strict';
  /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */

  function testPrecision(gl, precision) {
    var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);

    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      return false;
    }

    return true;
  }
  /**
   * Indicate whether this filtering backend is supported by the user's browser.
   * @param {Number} tileSize check if the tileSize is supported
   * @returns {Boolean} Whether the user's browser supports WebGL.
   */


  fabric.isWebglSupported = function (tileSize) {
    if (fabric.isLikelyNode) {
      return false;
    }

    tileSize = tileSize || fabric.WebglFilterBackend.prototype.tileSize;
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    var isSupported = false; // eslint-disable-next-line

    if (gl) {
      fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
      isSupported = fabric.maxTextureSize >= tileSize;
      var precisions = ['highp', 'mediump', 'lowp'];

      for (var i = 0; i < 3; i++) {
        if (testPrecision(gl, precisions[i])) {
          fabric.webGlPrecision = precisions[i];
          break;
        }

        ;
      }
    }

    this.isSupported = isSupported;
    return isSupported;
  };

  fabric.WebglFilterBackend = WebglFilterBackend;
  /**
   * WebGL filter backend.
   */

  function WebglFilterBackend(options) {
    if (options && options.tileSize) {
      this.tileSize = options.tileSize;
    }

    this.setupGLContext(this.tileSize, this.tileSize);
    this.captureGPUInfo();
  }

  ;
  WebglFilterBackend.prototype =
  /** @lends fabric.WebglFilterBackend.prototype */
  {
    tileSize: 2048,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {},

    /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */
    setupGLContext: function setupGLContext(width, height) {
      this.dispose();
      this.createWebGLCanvas(width, height); // eslint-disable-next-line

      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
      this.chooseFastestCopyGLTo2DMethod(width, height);
    },

    /**
     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
     * putImageData is faster than drawImage for that specific operation.
     */
    chooseFastestCopyGLTo2DMethod: function chooseFastestCopyGLTo2DMethod(width, height) {
      var canMeasurePerf = typeof window.performance !== 'undefined',
          canUseImageData;

      try {
        new ImageData(1, 1);
        canUseImageData = true;
      } catch (e) {
        canUseImageData = false;
      } // eslint-disable-next-line no-undef


      var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined'; // eslint-disable-next-line no-undef

      var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';

      if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
        return;
      }

      var targetCanvas = fabric.util.createCanvasElement(); // eslint-disable-next-line no-undef

      var imageBuffer = new ArrayBuffer(width * height * 4);

      if (fabric.forceGLPutImageData) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
        return;
      }

      var testContext = {
        imageBuffer: imageBuffer,
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
      };
      var startTime, drawImageTime, putImageDataTime;
      targetCanvas.width = width;
      targetCanvas.height = height;
      startTime = window.performance.now();
      copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
      drawImageTime = window.performance.now() - startTime;
      startTime = window.performance.now();
      copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
      putImageDataTime = window.performance.now() - startTime;

      if (drawImageTime > putImageDataTime) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
      } else {
        this.copyGLTo2D = copyGLTo2DDrawImage;
      }
    },

    /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */
    createWebGLCanvas: function createWebGLCanvas(width, height) {
      var canvas = fabric.util.createCanvasElement();
      canvas.width = width;
      canvas.height = height;
      var glOptions = {
        alpha: true,
        premultipliedAlpha: false,
        depth: false,
        stencil: false,
        antialias: false
      },
          gl = canvas.getContext('webgl', glOptions);

      if (!gl) {
        gl = canvas.getContext('experimental-webgl', glOptions);
      }

      if (!gl) {
        return;
      }

      gl.clearColor(0, 0, 0, 0); // this canvas can fire webglcontextlost and webglcontextrestored

      this.canvas = canvas;
      this.gl = gl;
    },

    /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */
    applyFilters: function applyFilters(filters, source, width, height, targetCanvas, cacheKey) {
      var gl = this.gl;
      var cachedTexture;

      if (cacheKey) {
        cachedTexture = this.getCachedTexture(cacheKey, source);
      }

      var pipelineState = {
        originalWidth: source.width || source.originalWidth,
        originalHeight: source.height || source.originalHeight,
        sourceWidth: width,
        sourceHeight: height,
        destinationWidth: width,
        destinationHeight: height,
        context: gl,
        sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
        targetTexture: this.createTexture(gl, width, height),
        originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture && source),
        passes: filters.length,
        webgl: true,
        aPosition: this.aPosition,
        programCache: this.programCache,
        pass: 0,
        filterBackend: this,
        targetCanvas: targetCanvas
      };
      var tempFbo = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
      filters.forEach(function (filter) {
        filter && filter.applyTo(pipelineState);
      });
      resizeCanvasIfNeeded(pipelineState);
      this.copyGLTo2D(gl, pipelineState);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.deleteTexture(pipelineState.sourceTexture);
      gl.deleteTexture(pipelineState.targetTexture);
      gl.deleteFramebuffer(tempFbo);
      targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
      return pipelineState;
    },

    /**
     * Detach event listeners, remove references, and clean up caches.
     */
    dispose: function dispose() {
      if (this.canvas) {
        this.canvas = null;
        this.gl = null;
      }

      this.clearWebGLCaches();
    },

    /**
     * Wipe out WebGL-related caches.
     */
    clearWebGLCaches: function clearWebGLCaches() {
      this.programCache = {};
      this.textureCache = {};
    },

    /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the texture to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {Number} width The width to initialize the texture at.
     * @param {Number} height The height to initialize the texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
     * @returns {WebGLTexture}
     */
    createTexture: function createTexture(gl, width, height, textureImageSource) {
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

      if (textureImageSource) {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
      } else {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      }

      return texture;
    },

    /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */
    getCachedTexture: function getCachedTexture(uniqueId, textureImageSource) {
      if (this.textureCache[uniqueId]) {
        return this.textureCache[uniqueId];
      } else {
        var texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
        this.textureCache[uniqueId] = texture;
        return texture;
      }
    },

    /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */
    evictCachesForKey: function evictCachesForKey(cacheKey) {
      if (this.textureCache[cacheKey]) {
        this.gl.deleteTexture(this.textureCache[cacheKey]);
        delete this.textureCache[cacheKey];
      }
    },
    copyGLTo2D: copyGLTo2DDrawImage,

    /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */
    captureGPUInfo: function captureGPUInfo() {
      if (this.gpuInfo) {
        return this.gpuInfo;
      }

      var gl = this.gl,
          gpuInfo = {
        renderer: '',
        vendor: ''
      };

      if (!gl) {
        return gpuInfo;
      }

      var ext = gl.getExtension('WEBGL_debug_renderer_info');

      if (ext) {
        var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
        var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);

        if (renderer) {
          gpuInfo.renderer = renderer.toLowerCase();
        }

        if (vendor) {
          gpuInfo.vendor = vendor.toLowerCase();
        }
      }

      this.gpuInfo = gpuInfo;
      return gpuInfo;
    }
  };
})();

function resizeCanvasIfNeeded(pipelineState) {
  var targetCanvas = pipelineState.targetCanvas,
      width = targetCanvas.width,
      height = targetCanvas.height,
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight;

  if (width !== dWidth || height !== dHeight) {
    targetCanvas.width = dWidth;
    targetCanvas.height = dHeight;
  }
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas.
 *
 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
 * desired output image appearing in the bottom-left corner of the WebGL canvas.
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */


function copyGLTo2DDrawImage(gl, pipelineState) {
  var glCanvas = gl.canvas,
      targetCanvas = pipelineState.targetCanvas,
      ctx = targetCanvas.getContext('2d');
  ctx.translate(0, targetCanvas.height); // move it down again

  ctx.scale(1, -1); // vertical flip
  // where is my image on the big glcanvas?

  var sourceY = glCanvas.height - targetCanvas.height;
  ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */


function copyGLTo2DPutImageData(gl, pipelineState) {
  var targetCanvas = pipelineState.targetCanvas,
      ctx = targetCanvas.getContext('2d'),
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight,
      numBytes = dWidth * dHeight * 4; // eslint-disable-next-line no-undef

  var u8 = new Uint8Array(this.imageBuffer, 0, numBytes); // eslint-disable-next-line no-undef

  var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
  gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
  var imgData = new ImageData(u8Clamped, dWidth, dHeight);
  ctx.putImageData(imgData, 0, 0);
}

(function () {
  'use strict';

  var noop = function noop() {};

  fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;
  /**
   * Canvas 2D filter backend.
   */

  function Canvas2dFilterBackend() {}

  ;
  Canvas2dFilterBackend.prototype =
  /** @lends fabric.Canvas2dFilterBackend.prototype */
  {
    evictCachesForKey: noop,
    dispose: noop,
    clearWebGLCaches: noop,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {},

    /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */
    applyFilters: function applyFilters(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
      var ctx = targetCanvas.getContext('2d');
      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
      var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var pipelineState = {
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        imageData: imageData,
        originalEl: sourceElement,
        originalImageData: originalImageData,
        canvasEl: targetCanvas,
        ctx: ctx,
        filterBackend: this
      };
      filters.forEach(function (filter) {
        filter.applyTo(pipelineState);
      });

      if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
        targetCanvas.width = pipelineState.imageData.width;
        targetCanvas.height = pipelineState.imageData.height;
      }

      ctx.putImageData(pipelineState.imageData, 0, 0);
      return pipelineState;
    }
  };
})();
/**
 * @namespace fabric.Image.filters
 * @memberOf fabric.Image
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 */


fabric.Image = fabric.Image || {};
fabric.Image.filters = fabric.Image.filters || {};
/**
 * Root filter class from which all filter classes inherit from
 * @class fabric.Image.filters.BaseFilter
 * @memberOf fabric.Image.filters
 */

fabric.Image.filters.BaseFilter = fabric.util.createClass(
/** @lends fabric.Image.filters.BaseFilter.prototype */
{
  /**
   * Filter type
   * @param {String} type
   * @default
   */
  type: 'BaseFilter',

  /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */
  vertexSource: 'attribute vec2 aPosition;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vTexCoord = aPosition;\n' + 'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' + '}',
  fragmentSource: 'precision highp float;\n' + 'varying vec2 vTexCoord;\n' + 'uniform sampler2D uTexture;\n' + 'void main() {\n' + 'gl_FragColor = texture2D(uTexture, vTexCoord);\n' + '}',

  /**
   * Constructor
   * @param {Object} [options] Options object
   */
  initialize: function initialize(options) {
    if (options) {
      this.setOptions(options);
    }
  },

  /**
   * Sets filter's properties from options
   * @param {Object} [options] Options object
   */
  setOptions: function setOptions(options) {
    for (var prop in options) {
      this[prop] = options[prop];
    }
  },

  /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */
  createProgram: function createProgram(gl, fragmentSource, vertexSource) {
    fragmentSource = fragmentSource || this.fragmentSource;
    vertexSource = vertexSource || this.vertexSource;

    if (fabric.webGlPrecision !== 'highp') {
      fragmentSource = fragmentSource.replace(/precision highp float/g, 'precision ' + fabric.webGlPrecision + ' float');
    }

    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vertexShader, vertexSource);
    gl.compileShader(vertexShader);

    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
      throw new Error( // eslint-disable-next-line prefer-template
      'Vertex shader compile error for ' + this.type + ': ' + gl.getShaderInfoLog(vertexShader));
    }

    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);

    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      throw new Error( // eslint-disable-next-line prefer-template
      'Fragment shader compile error for ' + this.type + ': ' + gl.getShaderInfoLog(fragmentShader));
    }

    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);

    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      throw new Error( // eslint-disable-next-line prefer-template
      'Shader link error for "${this.type}" ' + gl.getProgramInfoLog(program));
    }

    var attributeLocations = this.getAttributeLocations(gl, program);
    var uniformLocations = this.getUniformLocations(gl, program) || {};
    uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
    uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
    return {
      program: program,
      attributeLocations: attributeLocations,
      uniformLocations: uniformLocations
    };
  },

  /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */
  getAttributeLocations: function getAttributeLocations(gl, program) {
    return {
      aPosition: gl.getAttribLocation(program, 'aPosition')
    };
  },

  /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */
  getUniformLocations: function getUniformLocations()
  /* gl, program */
  {
    // in case i do not need any special uniform i need to return an empty object
    return {};
  },

  /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */
  sendAttributeData: function sendAttributeData(gl, attributeLocations, aPositionData) {
    var attributeLocation = attributeLocations.aPosition;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.enableVertexAttribArray(attributeLocation);
    gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
    gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
  },
  _setupFrameBuffer: function _setupFrameBuffer(options) {
    var gl = options.context,
        width,
        height;

    if (options.passes > 1) {
      width = options.destinationWidth;
      height = options.destinationHeight;

      if (options.sourceWidth !== width || options.sourceHeight !== height) {
        gl.deleteTexture(options.targetTexture);
        options.targetTexture = options.filterBackend.createTexture(gl, width, height);
      }

      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
    } else {
      // draw last filter on canvas and not to framebuffer.
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.finish();
    }
  },
  _swapTextures: function _swapTextures(options) {
    options.passes--;
    options.pass++;
    var temp = options.targetTexture;
    options.targetTexture = options.sourceTexture;
    options.sourceTexture = temp;
  },

  /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/
  isNeutralState: function isNeutralState()
  /* options */
  {
    var main = this.mainParameter,
        _class = fabric.Image.filters[this.type].prototype;

    if (main) {
      if (Array.isArray(_class[main])) {
        for (var i = _class[main].length; i--;) {
          if (this[main][i] !== _class[main][i]) {
            return false;
          }
        }

        return true;
      } else {
        return _class[main] === this[main];
      }
    } else {
      return false;
    }
  },

  /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyTo: function applyTo(options) {
    if (options.webgl) {
      this._setupFrameBuffer(options);

      this.applyToWebGL(options);

      this._swapTextures(options);
    } else {
      this.applyTo2d(options);
    }
  },

  /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  retrieveShader: function retrieveShader(options) {
    if (!options.programCache.hasOwnProperty(this.type)) {
      options.programCache[this.type] = this.createProgram(options.context);
    }

    return options.programCache[this.type];
  },

  /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyToWebGL: function applyToWebGL(options) {
    var gl = options.context;
    var shader = this.retrieveShader(options);

    if (options.pass === 0 && options.originalTexture) {
      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
    } else {
      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
    }

    gl.useProgram(shader.program);
    this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
    gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
    gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
    this.sendUniformData(gl, shader.uniformLocations);
    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  },
  bindAdditionalTexture: function bindAdditionalTexture(gl, texture, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, texture); // reset active texture to 0 as usual

    gl.activeTexture(gl.TEXTURE0);
  },
  unbindAdditionalTexture: function unbindAdditionalTexture(gl, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.activeTexture(gl.TEXTURE0);
  },
  getMainParameter: function getMainParameter() {
    return this[this.mainParameter];
  },
  setMainParameter: function setMainParameter(value) {
    this[this.mainParameter] = value;
  },

  /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */
  sendUniformData: function sendUniformData()
  /* gl, uniformLocations */
  {// Intentionally left blank.  Override me in subclasses.
  },

  /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */
  createHelpLayer: function createHelpLayer(options) {
    if (!options.helpLayer) {
      var helpLayer = document.createElement('canvas');
      helpLayer.width = options.sourceWidth;
      helpLayer.height = options.sourceHeight;
      options.helpLayer = helpLayer;
    }
  },

  /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */
  toObject: function toObject() {
    var object = {
      type: this.type
    },
        mainP = this.mainParameter;

    if (mainP) {
      object[mainP] = this[mainP];
    }

    return object;
  },

  /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */
  toJSON: function toJSON() {
    // delegate, not alias
    return this.toObject();
  }
});

fabric.Image.filters.BaseFilter.fromObject = function (object, callback) {
  var filter = new fabric.Image.filters[object.type](object);
  callback && callback(filter);
  return filter;
};

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Color Matrix filter class
   * @class fabric.Image.filters.ColorMatrix
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
   * @example <caption>Kodachrome filter</caption>
   * var filter = new fabric.Image.filters.ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.ColorMatrix = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.ColorMatrix.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'ColorMatrix',
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'varying vec2 vTexCoord;\n' + 'uniform mat4 uColorMatrix;\n' + 'uniform vec4 uConstants;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'color *= uColorMatrix;\n' + 'color += uConstants;\n' + 'gl_FragColor = color;\n' + '}',

    /**
     * Colormatrix for pixels.
     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
     * outside the -1, 1 range.
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Array} matrix array of 20 numbers.
     * @default
     */
    matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
    mainParameter: 'matrix',

    /**
     * Lock the colormatrix on the color part, skipping alpha, manly for non webgl scenario
     * to save some calculation
     */
    colorsOnly: true,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function initialize(options) {
      this.callSuper('initialize', options); // create a new array instead mutating the prototype with push

      this.matrix = this.matrix.slice(0);
    },

    /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = data.length,
          m = this.matrix,
          r,
          g,
          b,
          a,
          i,
          colorsOnly = this.colorsOnly;

      for (i = 0; i < iLen; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        if (colorsOnly) {
          data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
        } else {
          a = data[i + 3];
          data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
        uConstants: gl.getUniformLocation(program, 'uConstants')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      var m = this.matrix,
          matrix = [m[0], m[1], m[2], m[3], m[5], m[6], m[7], m[8], m[10], m[11], m[12], m[13], m[15], m[16], m[17], m[18]],
          constants = [m[4], m[9], m[14], m[19]];
      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
      gl.uniform4fv(uniformLocations.uConstants, constants);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] function to invoke after filter creation
   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
   */

  fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Brightness filter class
   * @class fabric.Image.filters.Brightness
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Brightness = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Brightness.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Brightness',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uBrightness;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'color.rgb += uBrightness;\n' + 'gl_FragColor = color;\n' + '}',

    /**
     * Brightness value, from -1 to 1.
     * translated to -255 to 255 for 2d
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Number} brightness
     * @default
     */
    brightness: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'brightness',

    /**
    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
    *
    * @param {Object} options
    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
    */
    applyTo2d: function applyTo2d(options) {
      if (this.brightness === 0) {
        return;
      }

      var imageData = options.imageData,
          data = imageData.data,
          i,
          len = data.length,
          brightness = Math.round(this.brightness * 255);

      for (i = 0; i < len; i += 4) {
        data[i] = data[i] + brightness;
        data[i + 1] = data[i + 1] + brightness;
        data[i + 2] = data[i + 2] + brightness;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uBrightness: gl.getUniformLocation(program, 'uBrightness')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
   */

  fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @class fabric.Image.filters.Convolute
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example <caption>Sharpen filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.Convolute = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Convolute.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Convolute',

    /*
     * Opaque value (true/false)
     */
    opaque: false,

    /*
     * matrix for the filter, max 9x9
     */
    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: {
      Convolute_3_1: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[9];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 0);\n' + 'for (float h = 0.0; h < 3.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 3.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n' + 'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n' + '}\n' + '}\n' + 'gl_FragColor = color;\n' + '}',
      Convolute_3_0: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[9];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 1);\n' + 'for (float h = 0.0; h < 3.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 3.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n' + 'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n' + '}\n' + '}\n' + 'float alpha = texture2D(uTexture, vTexCoord).a;\n' + 'gl_FragColor = color;\n' + 'gl_FragColor.a = alpha;\n' + '}',
      Convolute_5_1: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[25];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 0);\n' + 'for (float h = 0.0; h < 5.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 5.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' + 'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n' + '}\n' + '}\n' + 'gl_FragColor = color;\n' + '}',
      Convolute_5_0: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[25];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 1);\n' + 'for (float h = 0.0; h < 5.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 5.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' + 'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n' + '}\n' + '}\n' + 'float alpha = texture2D(uTexture, vTexCoord).a;\n' + 'gl_FragColor = color;\n' + 'gl_FragColor.a = alpha;\n' + '}',
      Convolute_7_1: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[49];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 0);\n' + 'for (float h = 0.0; h < 7.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 7.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' + 'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n' + '}\n' + '}\n' + 'gl_FragColor = color;\n' + '}',
      Convolute_7_0: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[49];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 1);\n' + 'for (float h = 0.0; h < 7.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 7.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' + 'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n' + '}\n' + '}\n' + 'float alpha = texture2D(uTexture, vTexCoord).a;\n' + 'gl_FragColor = color;\n' + 'gl_FragColor.a = alpha;\n' + '}',
      Convolute_9_1: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[81];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 0);\n' + 'for (float h = 0.0; h < 9.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 9.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' + 'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n' + '}\n' + '}\n' + 'gl_FragColor = color;\n' + '}',
      Convolute_9_0: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uMatrix[81];\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = vec4(0, 0, 0, 1);\n' + 'for (float h = 0.0; h < 9.0; h+=1.0) {\n' + 'for (float w = 0.0; w < 9.0; w+=1.0) {\n' + 'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' + 'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n' + '}\n' + '}\n' + 'float alpha = texture2D(uTexture, vTexCoord).a;\n' + 'gl_FragColor = color;\n' + 'gl_FragColor.a = alpha;\n' + '}'
    },

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Convolute.prototype
     * @param {Object} [options] Options object
     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
     * @param {Array} [options.matrix] Filter matrix
     */

    /**
    * Retrieves the cached shader.
    * @param {Object} options
    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
    */
    retrieveShader: function retrieveShader(options) {
      var size = Math.sqrt(this.matrix.length);
      var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
      var shaderSource = this.fragmentSource[cacheKey];

      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }

      return options.programCache[cacheKey];
    },

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          weights = this.matrix,
          side = Math.round(Math.sqrt(weights.length)),
          halfSide = Math.floor(side / 2),
          sw = imageData.width,
          sh = imageData.height,
          output = options.ctx.createImageData(sw, sh),
          dst = output.data,
          // go through the destination image pixels
      alphaFac = this.opaque ? 1 : 0,
          r,
          g,
          b,
          a,
          dstOff,
          scx,
          scy,
          srcOff,
          wt,
          x,
          y,
          cx,
          cy;

      for (y = 0; y < sh; y++) {
        for (x = 0; x < sw; x++) {
          dstOff = (y * sw + x) * 4; // calculate the weighed sum of the source image pixels that
          // fall under the convolution matrix

          r = 0;
          g = 0;
          b = 0;
          a = 0;

          for (cy = 0; cy < side; cy++) {
            for (cx = 0; cx < side; cx++) {
              scy = y + cy - halfSide;
              scx = x + cx - halfSide; // eslint-disable-next-line max-depth

              if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
                continue;
              }

              srcOff = (scy * sw + scx) * 4;
              wt = weights[cy * side + cx];
              r += data[srcOff] * wt;
              g += data[srcOff + 1] * wt;
              b += data[srcOff + 2] * wt; // eslint-disable-next-line max-depth

              if (!alphaFac) {
                a += data[srcOff + 3] * wt;
              }
            }
          }

          dst[dstOff] = r;
          dst[dstOff + 1] = g;
          dst[dstOff + 2] = b;

          if (!alphaFac) {
            dst[dstOff + 3] = a;
          } else {
            dst[dstOff + 3] = data[dstOff + 3];
          }
        }
      }

      options.imageData = output;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uMatrix: gl.getUniformLocation(program, 'uMatrix'),
        uOpaque: gl.getUniformLocation(program, 'uOpaque'),
        uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
        uSize: gl.getUniformLocation(program, 'uSize')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return extend(this.callSuper('toObject'), {
        opaque: this.opaque,
        matrix: this.matrix
      });
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
   */

  fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Grayscale image filter class
   * @class fabric.Image.filters.Grayscale
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Grayscale = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Grayscale.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Grayscale',
    fragmentSource: {
      average: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'float average = (color.r + color.b + color.g) / 3.0;\n' + 'gl_FragColor = vec4(average, average, average, color.a);\n' + '}',
      lightness: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform int uMode;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 col = texture2D(uTexture, vTexCoord);\n' + 'float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n' + 'gl_FragColor = vec4(average, average, average, col.a);\n' + '}',
      luminosity: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform int uMode;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 col = texture2D(uTexture, vTexCoord);\n' + 'float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n' + 'gl_FragColor = vec4(average, average, average, col.a);\n' + '}'
    },

    /**
     * Grayscale mode, between 'average', 'lightness', 'luminosity'
     * @param {String} type
     * @default
     */
    mode: 'average',
    mainParameter: 'mode',

    /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          i,
          len = data.length,
          value,
          mode = this.mode;

      for (i = 0; i < len; i += 4) {
        if (mode === 'average') {
          value = (data[i] + data[i + 1] + data[i + 2]) / 3;
        } else if (mode === 'lightness') {
          value = (Math.min(data[i], data[i + 1], data[i + 2]) + Math.max(data[i], data[i + 1], data[i + 2])) / 2;
        } else if (mode === 'luminosity') {
          value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
        }

        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
      }
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function retrieveShader(options) {
      var cacheKey = this.type + '_' + this.mode;

      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var shaderSource = this.fragmentSource[this.mode];
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }

      return options.programCache[cacheKey];
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uMode: gl.getUniformLocation(program, 'uMode')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      // default average mode.
      var mode = 1;
      gl.uniform1i(uniformLocations.uMode, mode);
    },

    /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/
    isNeutralState: function isNeutralState() {
      return false;
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
   */

  fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Invert filter class
   * @class fabric.Image.filters.Invert
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */

  filters.Invert = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Invert.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Invert',
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform int uInvert;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'if (uInvert == 1) {\n' + 'gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n' + '} else {\n' + 'gl_FragColor = color;\n' + '}\n' + '}',

    /**
     * Filter invert. if false, does nothing
     * @param {Boolean} invert
     * @default
     */
    invert: true,
    mainParameter: 'invert',

    /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          i,
          len = data.length;

      for (i = 0; i < len; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
      }
    },

    /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function isNeutralState() {
      return !this.invert;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uInvert: gl.getUniformLocation(program, 'uInvert')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1i(uniformLocations.uInvert, this.invert);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
   */

  fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Noise filter class
   * @class fabric.Image.filters.Noise
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.Noise = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Noise.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Noise',

    /**
     * Fragment source for the noise program
     */
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uStepH;\n' + 'uniform float uNoise;\n' + 'uniform float uSeed;\n' + 'varying vec2 vTexCoord;\n' + 'float rand(vec2 co, float seed, float vScale) {\n' + 'return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n' + '}\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n' + 'gl_FragColor = color;\n' + '}',

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'noise',

    /**
     * Noise value, from
     * @param {Number} noise
     * @default
     */
    noise: 0,

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      if (this.noise === 0) {
        return;
      }

      var imageData = options.imageData,
          data = imageData.data,
          i,
          len = data.length,
          noise = this.noise,
          rand;

      for (i = 0, len = data.length; i < len; i += 4) {
        rand = (0.5 - Math.random()) * noise;
        data[i] += rand;
        data[i + 1] += rand;
        data[i + 2] += rand;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uNoise: gl.getUniformLocation(program, 'uNoise'),
        uSeed: gl.getUniformLocation(program, 'uSeed')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
      gl.uniform1f(uniformLocations.uSeed, Math.random());
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return extend(this.callSuper('toObject'), {
        noise: this.noise
      });
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
   */

  fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Pixelate filter class
   * @class fabric.Image.filters.Pixelate
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Pixelate = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Pixelate.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Pixelate',
    blocksize: 4,
    mainParameter: 'blocksize',

    /**
     * Fragment source for the Pixelate program
     */
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uBlocksize;\n' + 'uniform float uStepW;\n' + 'uniform float uStepH;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'float blockW = uBlocksize * uStepW;\n' + 'float blockH = uBlocksize * uStepW;\n' + 'int posX = int(vTexCoord.x / blockW);\n' + 'int posY = int(vTexCoord.y / blockH);\n' + 'float fposX = float(posX);\n' + 'float fposY = float(posY);\n' + 'vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n' + 'vec4 color = texture2D(uTexture, squareCoords);\n' + 'gl_FragColor = color;\n' + '}',

    /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = imageData.height,
          jLen = imageData.width,
          index,
          i,
          j,
          r,
          g,
          b,
          a,
          _i,
          _j,
          _iLen,
          _jLen;

      for (i = 0; i < iLen; i += this.blocksize) {
        for (j = 0; j < jLen; j += this.blocksize) {
          index = i * 4 * jLen + j * 4;
          r = data[index];
          g = data[index + 1];
          b = data[index + 2];
          a = data[index + 3];
          _iLen = Math.min(i + this.blocksize, iLen);
          _jLen = Math.min(j + this.blocksize, jLen);

          for (_i = i; _i < _iLen; _i++) {
            for (_j = j; _j < _jLen; _j++) {
              index = _i * 4 * jLen + _j * 4;
              data[index] = r;
              data[index + 1] = g;
              data[index + 2] = b;
              data[index + 3] = a;
            }
          }
        }
      }
    },

    /**
     * Indicate when the filter is not gonna apply changes to the image
     **/
    isNeutralState: function isNeutralState() {
      return this.blocksize === 1;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
        uStepW: gl.getUniformLocation(program, 'uStepW'),
        uStepH: gl.getUniformLocation(program, 'uStepH')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
   */

  fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Remove white filter class
   * @class fabric.Image.filters.RemoveColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.RemoveColor = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.RemoveColor.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'RemoveColor',

    /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */
    color: '#FFFFFF',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform vec4 uLow;\n' + 'uniform vec4 uHigh;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'gl_FragColor = texture2D(uTexture, vTexCoord);\n' + 'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' + 'gl_FragColor.a = 0.0;\n' + '}\n' + '}',

    /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/
    distance: 0.02,

    /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/
    useAlpha: false,

    /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */

    /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          i,
          distance = this.distance * 255,
          r,
          g,
          b,
          source = new fabric.Color(this.color).getSource(),
          lowC = [source[0] - distance, source[1] - distance, source[2] - distance],
          highC = [source[0] + distance, source[1] + distance, source[2] + distance];

      for (i = 0; i < data.length; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) {
          data[i + 3] = 0;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uLow: gl.getUniformLocation(program, 'uLow'),
        uHigh: gl.getUniformLocation(program, 'uHigh')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource(),
          distance = parseFloat(this.distance),
          lowC = [0 + source[0] / 255 - distance, 0 + source[1] / 255 - distance, 0 + source[2] / 255 - distance, 1],
          highC = [source[0] / 255 + distance, source[1] / 255 + distance, source[2] / 255 + distance, 1];
      gl.uniform4fv(uniformLocations.uLow, lowC);
      gl.uniform4fv(uniformLocations.uHigh, highC);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return extend(this.callSuper('toObject'), {
        color: this.color,
        distance: this.distance
      });
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
   */

  fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  var matrices = {
    Brownie: [0.59970, 0.34553, -0.27082, 0, 0.186, -0.03770, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0],
    Vintage: [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.04660, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0],
    Kodachrome: [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0],
    Technicolor: [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.23110, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0],
    Polaroid: [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0],
    Sepia: [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0],
    BlackWhite: [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]
  };

  for (var key in matrices) {
    filters[key] = createClass(filters.ColorMatrix,
    /** @lends fabric.Image.filters.Sepia.prototype */
    {
      /**
       * Filter type
       * @param {String} type
       * @default
       */
      type: key,

      /**
       * Colormatrix for the effect
       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
       * outside the -1, 1 range.
       * @param {Array} matrix array of 20 numbers.
       * @default
       */
      matrix: matrices[key],

      /**
       * Lock the matrix export for this kind of static, parameter less filters.
       */
      mainParameter: false,

      /**
       * Lock the colormatrix on the color part, skipping alpha
       */
      colorsOnly: true
    });
    fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
  }
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Color Blend filter class
   * @class fabric.Image.filter.BlendColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendColor = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Blend.prototype */
  {
    type: 'BlendColor',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    color: '#F95C63',

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend color operation.
     **/
    alpha: 1,

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
      screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
      add: 'gl_FragColor.rgb += uColor.rgb;\n',
      diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
      subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
      lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
      darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
      exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
      overlay: 'if (uColor.r < 0.5) {\n' + 'gl_FragColor.r *= 2.0 * uColor.r;\n' + '} else {\n' + 'gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n' + '}\n' + 'if (uColor.g < 0.5) {\n' + 'gl_FragColor.g *= 2.0 * uColor.g;\n' + '} else {\n' + 'gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n' + '}\n' + 'if (uColor.b < 0.5) {\n' + 'gl_FragColor.b *= 2.0 * uColor.b;\n' + '} else {\n' + 'gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n' + '}\n',
      tint: 'gl_FragColor.rgb *= (1.0 - uColor.a);\n' + 'gl_FragColor.rgb += uColor.rgb;\n'
    },

    /**
     * build the fragment source for the filters, joining the common part with
     * the specific one.
     * @param {String} mode the mode of the filter, a key of this.fragmentSource
     * @return {String} the source to be compiled
     * @private
     */
    buildSource: function buildSource(mode) {
      return 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform vec4 uColor;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'gl_FragColor = color;\n' + 'if (color.a > 0.0) {\n' + this.fragmentSource[mode] + '}\n' + '}';
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function retrieveShader(options) {
      var cacheKey = this.type + '_' + this.mode,
          shaderSource;

      if (!options.programCache.hasOwnProperty(cacheKey)) {
        shaderSource = this.buildSource(this.mode);
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }

      return options.programCache[cacheKey];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = data.length,
          tr,
          tg,
          tb,
          r,
          g,
          b,
          source,
          alpha1 = 1 - this.alpha;
      source = new fabric.Color(this.color).getSource();
      tr = source[0] * this.alpha;
      tg = source[1] * this.alpha;
      tb = source[2] * this.alpha;

      for (var i = 0; i < iLen; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            break;

          case 'screen':
            data[i] = 255 - (255 - r) * (255 - tr) / 255;
            data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
            data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
            break;

          case 'add':
            data[i] = r + tr;
            data[i + 1] = g + tg;
            data[i + 2] = b + tb;
            break;

          case 'diff':
          case 'difference':
            data[i] = Math.abs(r - tr);
            data[i + 1] = Math.abs(g - tg);
            data[i + 2] = Math.abs(b - tb);
            break;

          case 'subtract':
            data[i] = r - tr;
            data[i + 1] = g - tg;
            data[i + 2] = b - tb;
            break;

          case 'darken':
            data[i] = Math.min(r, tr);
            data[i + 1] = Math.min(g, tg);
            data[i + 2] = Math.min(b, tb);
            break;

          case 'lighten':
            data[i] = Math.max(r, tr);
            data[i + 1] = Math.max(g, tg);
            data[i + 2] = Math.max(b, tb);
            break;

          case 'overlay':
            data[i] = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
            data[i + 1] = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
            data[i + 2] = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
            break;

          case 'exclusion':
            data[i] = tr + r - 2 * tr * r / 255;
            data[i + 1] = tg + g - 2 * tg * g / 255;
            data[i + 2] = tb + b - 2 * tb * b / 255;
            break;

          case 'tint':
            data[i] = tr + r * alpha1;
            data[i + 1] = tg + g * alpha1;
            data[i + 2] = tb + b * alpha1;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uColor: gl.getUniformLocation(program, 'uColor')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource();
      source[0] = this.alpha * source[0] / 255;
      source[1] = this.alpha * source[1] / 255;
      source[2] = this.alpha * source[2] / 255;
      source[3] = this.alpha;
      gl.uniform4fv(uniformLocations.uColor, source);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return {
        type: this.type,
        color: this.color,
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
   */

  fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Image Blend filter class
   * @class fabric.Image.filter.BlendImage
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendImage = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.BlendImage.prototype */
  {
    type: 'BlendImage',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    image: null,

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend image operation.
     * not implemented.
     **/
    alpha: 1,
    vertexSource: 'attribute vec2 aPosition;\n' + 'varying vec2 vTexCoord;\n' + 'varying vec2 vTexCoord2;\n' + 'uniform mat3 uTransformMatrix;\n' + 'void main() {\n' + 'vTexCoord = aPosition;\n' + 'vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n' + 'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' + '}',

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform sampler2D uImage;\n' + 'uniform vec4 uColor;\n' + 'varying vec2 vTexCoord;\n' + 'varying vec2 vTexCoord2;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'vec4 color2 = texture2D(uImage, vTexCoord2);\n' + 'color.rgba *= color2.rgba;\n' + 'gl_FragColor = color;\n' + '}',
      mask: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform sampler2D uImage;\n' + 'uniform vec4 uColor;\n' + 'varying vec2 vTexCoord;\n' + 'varying vec2 vTexCoord2;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'vec4 color2 = texture2D(uImage, vTexCoord2);\n' + 'color.a = color2.a;\n' + 'gl_FragColor = color;\n' + '}'
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function retrieveShader(options) {
      var cacheKey = this.type + '_' + this.mode;
      var shaderSource = this.fragmentSource[this.mode];

      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }

      return options.programCache[cacheKey];
    },
    applyToWebGL: function applyToWebGL(options) {
      // load texture to blend.
      var gl = options.context,
          texture = this.createTexture(options.filterBackend, this.image);
      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
      this.callSuper('applyToWebGL', options);
      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    },
    createTexture: function createTexture(backend, image) {
      return backend.getCachedTexture(image.cacheKey, image._element);
    },

    /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    calculateMatrix: function calculateMatrix() {
      var image = this.image,
          width = image._element.width,
          height = image._element.height;
      return [1 / image.scaleX, 0, 0, 0, 1 / image.scaleY, 0, -image.left / width, -image.top / height, 1];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          resources = options.filterBackend.resources,
          data = imageData.data,
          iLen = data.length,
          width = imageData.width,
          height = imageData.height,
          tr,
          tg,
          tb,
          ta,
          r,
          g,
          b,
          a,
          canvas1,
          context,
          image = this.image,
          blendData;

      if (!resources.blendImage) {
        resources.blendImage = fabric.util.createCanvasElement();
      }

      canvas1 = resources.blendImage;
      context = canvas1.getContext('2d');

      if (canvas1.width !== width || canvas1.height !== height) {
        canvas1.width = width;
        canvas1.height = height;
      } else {
        context.clearRect(0, 0, width, height);
      }

      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
      context.drawImage(image._element, 0, 0, width, height);
      blendData = context.getImageData(0, 0, width, height).data;

      for (var i = 0; i < iLen; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        tr = blendData[i];
        tg = blendData[i + 1];
        tb = blendData[i + 2];
        ta = blendData[i + 3];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            data[i + 3] = a * ta / 255;
            break;

          case 'mask':
            data[i + 3] = ta;
            break;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
        uImage: gl.getUniformLocation(program, 'uImage')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      var matrix = this.calculateMatrix();
      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.

      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return {
        type: this.type,
        image: this.image && this.image.toObject(),
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} callback to be invoked after filter creation
   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
   */

  fabric.Image.filters.BlendImage.fromObject = function (object, callback) {
    fabric.Image.fromObject(object.image, function (image) {
      var options = fabric.util.object.clone(object);
      options.image = image;
      callback(new fabric.Image.filters.BlendImage(options));
    });
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      pow = Math.pow,
      floor = Math.floor,
      sqrt = Math.sqrt,
      abs = Math.abs,
      round = Math.round,
      sin = Math.sin,
      ceil = Math.ceil,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Resize image filter class
   * @class fabric.Image.filters.Resize
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */

  filters.Resize = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Resize.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Resize',

    /**
     * Resize type
     * for webgl resizeType is just lanczos, for canvas2d can be:
     * bilinear, hermite, sliceHack, lanczos.
     * @param {String} resizeType
     * @default
     */
    resizeType: 'hermite',

    /**
     * Scale factor for resizing, x axis
     * @param {Number} scaleX
     * @default
     */
    scaleX: 1,

    /**
     * Scale factor for resizing, y axis
     * @param {Number} scaleY
     * @default
     */
    scaleY: 1,

    /**
     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
     * @param {Number} lanczosLobes
     * @default
     */
    lanczosLobes: 3,

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uDelta: gl.getUniformLocation(program, 'uDelta'),
        uTaps: gl.getUniformLocation(program, 'uTaps')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
      gl.uniform1fv(uniformLocations.uTaps, this.taps);
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function retrieveShader(options) {
      var filterWindow = this.getFilterWindow(),
          cacheKey = this.type + '_' + filterWindow;

      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var fragmentShader = this.generateShader(filterWindow);
        options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
      }

      return options.programCache[cacheKey];
    },
    getFilterWindow: function getFilterWindow() {
      var scale = this.tempScale;
      return Math.ceil(this.lanczosLobes / scale);
    },
    getTaps: function getTaps() {
      var lobeFunction = this.lanczosCreate(this.lanczosLobes),
          scale = this.tempScale,
          filterWindow = this.getFilterWindow(),
          taps = new Array(filterWindow);

      for (var i = 1; i <= filterWindow; i++) {
        taps[i - 1] = lobeFunction(i * scale);
      }

      return taps;
    },

    /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */
    generateShader: function generateShader(filterWindow) {
      var offsets = new Array(filterWindow),
          fragmentShader = this.fragmentSourceTOP,
          filterWindow;

      for (var i = 1; i <= filterWindow; i++) {
        offsets[i - 1] = i + '.0 * uDelta';
      }

      fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
      fragmentShader += 'void main() {\n';
      fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
      fragmentShader += '  float sum = 1.0;\n';
      offsets.forEach(function (offset, i) {
        fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
      });
      fragmentShader += '  gl_FragColor = color / sum;\n';
      fragmentShader += '}';
      return fragmentShader;
    },
    fragmentSourceTOP: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform vec2 uDelta;\n' + 'varying vec2 vTexCoord;\n',

    /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function applyTo(options) {
      if (options.webgl) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;

        this._setupFrameBuffer(options);

        this.applyToWebGL(options);

        this._swapTextures(options);

        options.sourceWidth = options.destinationWidth;
        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;

        this._setupFrameBuffer(options);

        this.applyToWebGL(options);

        this._swapTextures(options);

        options.sourceHeight = options.destinationHeight;
      } else {
        this.applyTo2d(options);
      }
    },
    isNeutralState: function isNeutralState() {
      return this.scaleX === 1 && this.scaleY === 1;
    },
    lanczosCreate: function lanczosCreate(lobes) {
      return function (x) {
        if (x >= lobes || x <= -lobes) {
          return 0.0;
        }

        if (x < 1.19209290E-07 && x > -1.19209290E-07) {
          return 1.0;
        }

        x *= Math.PI;
        var xx = x / lobes;
        return sin(x) / x * sin(xx) / xx;
      };
    },

    /**
     * Applies filter to canvas element
     * @memberOf fabric.Image.filters.Resize.prototype
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} scaleX
     * @param {Number} scaleY
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          scaleX = this.scaleX,
          scaleY = this.scaleY;
      this.rcpScaleX = 1 / scaleX;
      this.rcpScaleY = 1 / scaleY;
      var oW = imageData.width,
          oH = imageData.height,
          dW = round(oW * scaleX),
          dH = round(oH * scaleY),
          newData;

      if (this.resizeType === 'sliceHack') {
        newData = this.sliceByTwo(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'hermite') {
        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'bilinear') {
        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'lanczos') {
        newData = this.lanczosResize(options, oW, oH, dW, dH);
      }

      options.imageData = newData;
    },

    /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    sliceByTwo: function sliceByTwo(options, oW, oH, dW, dH) {
      var imageData = options.imageData,
          mult = 0.5,
          doneW = false,
          doneH = false,
          stepW = oW * mult,
          stepH = oH * mult,
          resources = fabric.filterBackend.resources,
          tmpCanvas,
          ctx,
          sX = 0,
          sY = 0,
          dX = oW,
          dY = 0;

      if (!resources.sliceByTwo) {
        resources.sliceByTwo = document.createElement('canvas');
      }

      tmpCanvas = resources.sliceByTwo;

      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
        tmpCanvas.width = oW * 1.5;
        tmpCanvas.height = oH;
      }

      ctx = tmpCanvas.getContext('2d');
      ctx.clearRect(0, 0, oW * 1.5, oH);
      ctx.putImageData(imageData, 0, 0);
      dW = floor(dW);
      dH = floor(dH);

      while (!doneW || !doneH) {
        oW = stepW;
        oH = stepH;

        if (dW < floor(stepW * mult)) {
          stepW = floor(stepW * mult);
        } else {
          stepW = dW;
          doneW = true;
        }

        if (dH < floor(stepH * mult)) {
          stepH = floor(stepH * mult);
        } else {
          stepH = dH;
          doneH = true;
        }

        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
        sX = dX;
        sY = dY;
        dY += stepH;
      }

      return ctx.getImageData(sX, sY, dW, dH);
    },

    /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    lanczosResize: function lanczosResize(options, oW, oH, dW, dH) {
      function process(u) {
        var v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
        center.x = (u + 0.5) * ratioX;
        icenter.x = floor(center.x);

        for (v = 0; v < dH; v++) {
          center.y = (v + 0.5) * ratioY;
          icenter.y = floor(center.y);
          a = 0;
          red = 0;
          green = 0;
          blue = 0;
          alpha = 0;

          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
            if (i < 0 || i >= oW) {
              continue;
            }

            fX = floor(1000 * abs(i - center.x));

            if (!cacheLanc[fX]) {
              cacheLanc[fX] = {};
            }

            for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
              if (j < 0 || j >= oH) {
                continue;
              }

              fY = floor(1000 * abs(j - center.y));

              if (!cacheLanc[fX][fY]) {
                cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
              }

              weight = cacheLanc[fX][fY];

              if (weight > 0) {
                idx = (j * oW + i) * 4;
                a += weight;
                red += weight * srcData[idx];
                green += weight * srcData[idx + 1];
                blue += weight * srcData[idx + 2];
                alpha += weight * srcData[idx + 3];
              }
            }
          }

          idx = (v * dW + u) * 4;
          destData[idx] = red / a;
          destData[idx + 1] = green / a;
          destData[idx + 2] = blue / a;
          destData[idx + 3] = alpha / a;
        }

        if (++u < dW) {
          return process(u);
        } else {
          return destImg;
        }
      }

      var srcData = options.imageData.data,
          destImg = options.ctx.createImageData(dW, dH),
          destData = destImg.data,
          lanczos = this.lanczosCreate(this.lanczosLobes),
          ratioX = this.rcpScaleX,
          ratioY = this.rcpScaleY,
          rcpRatioX = 2 / this.rcpScaleX,
          rcpRatioY = 2 / this.rcpScaleY,
          range2X = ceil(ratioX * this.lanczosLobes / 2),
          range2Y = ceil(ratioY * this.lanczosLobes / 2),
          cacheLanc = {},
          center = {},
          icenter = {};
      return process(0);
    },

    /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    bilinearFiltering: function bilinearFiltering(options, oW, oH, dW, dH) {
      var a,
          b,
          c,
          d,
          x,
          y,
          i,
          j,
          xDiff,
          yDiff,
          chnl,
          color,
          offset = 0,
          origPix,
          ratioX = this.rcpScaleX,
          ratioY = this.rcpScaleY,
          w4 = 4 * (oW - 1),
          img = options.imageData,
          pixels = img.data,
          destImage = options.ctx.createImageData(dW, dH),
          destPixels = destImage.data;

      for (i = 0; i < dH; i++) {
        for (j = 0; j < dW; j++) {
          x = floor(ratioX * j);
          y = floor(ratioY * i);
          xDiff = ratioX * j - x;
          yDiff = ratioY * i - y;
          origPix = 4 * (y * oW + x);

          for (chnl = 0; chnl < 4; chnl++) {
            a = pixels[origPix + chnl];
            b = pixels[origPix + 4 + chnl];
            c = pixels[origPix + w4 + chnl];
            d = pixels[origPix + w4 + 4 + chnl];
            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
            destPixels[offset++] = color;
          }
        }
      }

      return destImage;
    },

    /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    hermiteFastResize: function hermiteFastResize(options, oW, oH, dW, dH) {
      var ratioW = this.rcpScaleX,
          ratioH = this.rcpScaleY,
          ratioWHalf = ceil(ratioW / 2),
          ratioHHalf = ceil(ratioH / 2),
          img = options.imageData,
          data = img.data,
          img2 = options.ctx.createImageData(dW, dH),
          data2 = img2.data;

      for (var j = 0; j < dH; j++) {
        for (var i = 0; i < dW; i++) {
          var x2 = (i + j * dW) * 4,
              weight = 0,
              weights = 0,
              weightsAlpha = 0,
              gxR = 0,
              gxG = 0,
              gxB = 0,
              gxA = 0,
              centerY = (j + 0.5) * ratioH;

          for (var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
            var dy = abs(centerY - (yy + 0.5)) / ratioHHalf,
                centerX = (i + 0.5) * ratioW,
                w0 = dy * dy;

            for (var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
              var dx = abs(centerX - (xx + 0.5)) / ratioWHalf,
                  w = sqrt(w0 + dx * dx);
              /* eslint-disable max-depth */

              if (w > 1 && w < -1) {
                continue;
              } //hermite filter


              weight = 2 * w * w * w - 3 * w * w + 1;

              if (weight > 0) {
                dx = 4 * (xx + yy * oW); //alpha

                gxA += weight * data[dx + 3];
                weightsAlpha += weight; //colors

                if (data[dx + 3] < 255) {
                  weight = weight * data[dx + 3] / 250;
                }

                gxR += weight * data[dx];
                gxG += weight * data[dx + 1];
                gxB += weight * data[dx + 2];
                weights += weight;
              }
              /* eslint-enable max-depth */

            }
          }

          data2[x2] = gxR / weights;
          data2[x2 + 1] = gxG / weights;
          data2[x2 + 2] = gxB / weights;
          data2[x2 + 3] = gxA / weightsAlpha;
        }
      }

      return img2;
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject() {
      return {
        type: this.type,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        resizeType: this.resizeType,
        lanczosLobes: this.lanczosLobes
      };
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
   */

  fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Contrast filter class
   * @class fabric.Image.filters.Contrast
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Contrast = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Contrast.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Contrast',
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uContrast;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n' + 'color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n' + 'gl_FragColor = color;\n' + '}',

    /**
     * contrast value, range from -1 to 1.
     * @param {Number} contrast
     * @default 0
     */
    contrast: 0,
    mainParameter: 'contrast',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Contrast.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
     */

    /**
      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
      *
      * @param {Object} options
      * @param {ImageData} options.imageData The Uint8Array to be filtered.
      */
    applyTo2d: function applyTo2d(options) {
      if (this.contrast === 0) {
        return;
      }

      var imageData = options.imageData,
          i,
          len,
          data = imageData.data,
          len = data.length,
          contrast = Math.floor(this.contrast * 255),
          contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));

      for (i = 0; i < len; i += 4) {
        data[i] = contrastF * (data[i] - 128) + 128;
        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uContrast: gl.getUniformLocation(program, 'uContrast')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uContrast, this.contrast);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
   */

  fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Saturate filter class
   * @class fabric.Image.filters.Saturation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Saturation({
   *   saturation: 100
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Saturation = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Saturation.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Saturation',
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform float uSaturation;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'float rgMax = max(color.r, color.g);\n' + 'float rgbMax = max(rgMax, color.b);\n' + 'color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n' + 'color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n' + 'color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n' + 'gl_FragColor = color;\n' + '}',
    saturation: 0,
    mainParameter: 'saturation',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Saturate.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
     */

    /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      if (this.saturation === 0) {
        return;
      }

      var imageData = options.imageData,
          data = imageData.data,
          len = data.length,
          adjust = -this.saturation,
          i,
          max;

      for (i = 0; i < len; i += 4) {
        max = Math.max(data[i], data[i + 1], data[i + 2]);
        data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uSaturation: gl.getUniformLocation(program, 'uSaturation')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
   */

  fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Blur filter class
   * @class fabric.Image.filters.Blur
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.Blur = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Blur.prototype */
  {
    type: 'Blur',

    /*
    'gl_FragColor = vec4(0.0);',
    'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
    'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
    'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
    'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
    'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
    'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
    'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
    'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
    'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
    'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
    'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
    'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
    'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
    'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
    'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
    */

    /* eslint-disable max-len */
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform vec2 uDelta;\n' + 'varying vec2 vTexCoord;\n' + 'const float nSamples = 15.0;\n' + 'vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n' + 'float random(vec3 scale) {\n' +
    /* use the fragment position for a different seed per-pixel */
    'return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n' + '}\n' + 'void main() {\n' + 'vec4 color = vec4(0.0);\n' + 'float total = 0.0;\n' + 'float offset = random(v3offset);\n' + 'for (float t = -nSamples; t <= nSamples; t++) {\n' + 'float percent = (t + offset - 0.5) / nSamples;\n' + 'float weight = 1.0 - abs(percent);\n' + 'color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n' + 'total += weight;\n' + '}\n' + 'gl_FragColor = color / total;\n' + '}',

    /* eslint-enable max-len */

    /**
     * blur value, in percentage of image dimensions.
     * specific to keep the image blur constant at different resolutions
     * range between 0 and 1.
     */
    blur: 0,
    mainParameter: 'blur',
    applyTo: function applyTo(options) {
      if (options.webgl) {
        // this aspectRatio is used to give the same blur to vertical and horizontal
        this.aspectRatio = options.sourceWidth / options.sourceHeight;
        options.passes++;

        this._setupFrameBuffer(options);

        this.horizontal = true;
        this.applyToWebGL(options);

        this._swapTextures(options);

        this._setupFrameBuffer(options);

        this.horizontal = false;
        this.applyToWebGL(options);

        this._swapTextures(options);
      } else {
        this.applyTo2d(options);
      }
    },
    applyTo2d: function applyTo2d(options) {
      // paint canvasEl with current image data.
      //options.ctx.putImageData(options.imageData, 0, 0);
      options.imageData = this.simpleBlur(options);
    },
    simpleBlur: function simpleBlur(options) {
      var resources = options.filterBackend.resources,
          canvas1,
          canvas2,
          width = options.imageData.width,
          height = options.imageData.height;

      if (!resources.blurLayer1) {
        resources.blurLayer1 = fabric.util.createCanvasElement();
        resources.blurLayer2 = fabric.util.createCanvasElement();
      }

      canvas1 = resources.blurLayer1;
      canvas2 = resources.blurLayer2;

      if (canvas1.width !== width || canvas1.height !== height) {
        canvas2.width = canvas1.width = width;
        canvas2.height = canvas1.height = height;
      }

      var ctx1 = canvas1.getContext('2d'),
          ctx2 = canvas2.getContext('2d'),
          nSamples = 15,
          random,
          percent,
          j,
          i,
          blur = this.blur * 0.06 * 0.5; // load first canvas

      ctx1.putImageData(options.imageData, 0, 0);
      ctx2.clearRect(0, 0, width, height);

      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * width + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, j, random);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }

      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * height + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, random, j);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }

      options.ctx.drawImage(canvas1, 0, 0);
      var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
      ctx1.globalAlpha = 1;
      ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
      return newImageData;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        delta: gl.getUniformLocation(program, 'uDelta')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      var delta = this.chooseRightDelta();
      gl.uniform2fv(uniformLocations.delta, delta);
    },

    /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */
    chooseRightDelta: function chooseRightDelta() {
      var blurScale = 1,
          delta = [0, 0],
          blur;

      if (this.horizontal) {
        if (this.aspectRatio > 1) {
          // image is wide, i want to shrink radius horizontal
          blurScale = 1 / this.aspectRatio;
        }
      } else {
        if (this.aspectRatio < 1) {
          // image is tall, i want to shrink radius vertical
          blurScale = this.aspectRatio;
        }
      }

      blur = blurScale * this.blur * 0.12;

      if (this.horizontal) {
        delta[0] = blur;
      } else {
        delta[1] = blur;
      }

      return delta;
    }
  });
  /**
   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
   */

  filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * Gamma filter class
   * @class fabric.Image.filters.Gamma
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Gamma({
   *   gamma: [1, 0.5, 2.1]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.Gamma = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Gamma.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Gamma',
    fragmentSource: 'precision highp float;\n' + 'uniform sampler2D uTexture;\n' + 'uniform vec3 uGamma;\n' + 'varying vec2 vTexCoord;\n' + 'void main() {\n' + 'vec4 color = texture2D(uTexture, vTexCoord);\n' + 'vec3 correction = (1.0 / uGamma);\n' + 'color.r = pow(color.r, correction.r);\n' + 'color.g = pow(color.g, correction.g);\n' + 'color.b = pow(color.b, correction.b);\n' + 'gl_FragColor = color;\n' + 'gl_FragColor.rgb *= color.a;\n' + '}',

    /**
     * Gamma array value, from 0.01 to 2.2.
     * @param {Array} gamma
     * @default
     */
    gamma: [1, 1, 1],

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'gamma',

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function initialize(options) {
      this.gamma = [1, 1, 1];
      filters.BaseFilter.prototype.initialize.call(this, options);
    },

    /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function applyTo2d(options) {
      var imageData = options.imageData,
          data = imageData.data,
          gamma = this.gamma,
          len = data.length,
          rInv = 1 / gamma[0],
          gInv = 1 / gamma[1],
          bInv = 1 / gamma[2],
          i;

      if (!this.rVals) {
        // eslint-disable-next-line
        this.rVals = new Uint8Array(256); // eslint-disable-next-line

        this.gVals = new Uint8Array(256); // eslint-disable-next-line

        this.bVals = new Uint8Array(256);
      } // This is an optimization - pre-compute a look-up table for each color channel
      // instead of performing these pow calls for each pixel in the image.


      for (i = 0, len = 256; i < len; i++) {
        this.rVals[i] = Math.pow(i / 255, rInv) * 255;
        this.gVals[i] = Math.pow(i / 255, gInv) * 255;
        this.bVals[i] = Math.pow(i / 255, bInv) * 255;
      }

      for (i = 0, len = data.length; i < len; i += 4) {
        data[i] = this.rVals[data[i]];
        data[i + 1] = this.gVals[data[i + 1]];
        data[i + 2] = this.bVals[data[i + 2]];
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function getUniformLocations(gl, program) {
      return {
        uGamma: gl.getUniformLocation(program, 'uGamma')
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function sendUniformData(gl, uniformLocations) {
      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
   */

  fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */

  filters.Composed = createClass(filters.BaseFilter,
  /** @lends fabric.Image.filters.Composed.prototype */
  {
    type: 'Composed',

    /**
     * A non sparse array of filters to apply
     */
    subFilters: [],

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function initialize(options) {
      this.callSuper('initialize', options); // create a new array instead mutating the prototype with push

      this.subFilters = this.subFilters.slice(0);
    },

    /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */
    applyTo: function applyTo(options) {
      options.passes += this.subFilters.length - 1;
      this.subFilters.forEach(function (filter) {
        filter.applyTo(options);
      });
    },

    /**
     * Serialize this filter into JSON.
     *
     * @returns {Object} A JSON representation of this filter.
     */
    toObject: function toObject() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        subFilters: this.subFilters.map(function (filter) {
          return filter.toObject();
        })
      });
    },
    isNeutralState: function isNeutralState() {
      return !this.subFilters.some(function (filter) {
        return !filter.isNeutralState();
      });
    }
  });
  /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   */

  fabric.Image.filters.Composed.fromObject = function (object, callback) {
    var filters = object.subFilters || [],
        subFilters = filters.map(function (filter) {
      return new fabric.Image.filters[filter.type](filter);
    }),
        instance = new fabric.Image.filters.Composed({
      subFilters: subFilters
    });
    callback && callback(instance);
    return instance;
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;
  /**
   * HueRotation filter class
   * @class fabric.Image.filters.HueRotation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */

  filters.HueRotation = createClass(filters.ColorMatrix,
  /** @lends fabric.Image.filters.HueRotation.prototype */
  {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'HueRotation',

    /**
     * HueRotation value, from -1 to 1.
     * the unit is radians
     * @param {Number} myParameter
     * @default
     */
    rotation: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'rotation',
    calculateMatrix: function calculateMatrix() {
      var rad = this.rotation * Math.PI,
          cos = fabric.util.cos(rad),
          sin = fabric.util.sin(rad),
          aThird = 1 / 3,
          aThirdSqtSin = Math.sqrt(aThird) * sin,
          OneMinusCos = 1 - cos;
      this.matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
      this.matrix[0] = cos + OneMinusCos / 3;
      this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[6] = cos + aThird * OneMinusCos;
      this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[12] = cos + aThird * OneMinusCos;
    },

    /**
     * HueRotation isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function isNeutralState(options) {
      this.calculateMatrix();
      return filters.BaseFilter.prototype.isNeutralState.call(this, options);
    },

    /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function applyTo(options) {
      this.calculateMatrix();
      filters.BaseFilter.prototype.applyTo.call(this, options);
    }
  });
  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
   */

  fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : void 0);

(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {}),
      clone = fabric.util.object.clone;

  if (fabric.Text) {
    fabric.warn('fabric.Text is already defined');
    return;
  }

  var additionalProps = ('fontFamily fontWeight fontSize text underline overline linethrough' + ' textAlign fontStyle lineHeight textBackgroundColor charSpacing styles path').split(' ');
  /**
   * Text class
   * @class fabric.Text
   * @extends fabric.Object
   * @return {fabric.Text} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   * @see {@link fabric.Text#initialize} for constructor definition
   */

  fabric.Text = fabric.util.createClass(fabric.Object,
  /** @lends fabric.Text.prototype */
  {
    /**
     * Properties which when set cause object to change dimensions
     * @type Array
     * @private
     */
    _dimensionAffectingProps: ['fontSize', 'fontWeight', 'fontFamily', 'fontStyle', 'lineHeight', 'text', 'charSpacing', 'textAlign', 'styles', 'path'],

    /**
     * @private
     */
    _reNewline: /\r?\n/,

    /**
     * Use this regular expression to filter for whitespaces that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpacesAndTabs: /[ \t\r]/g,

    /**
     * Use this regular expression to filter for whitespace that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpaceAndTab: /[ \t\r]/,

    /**
     * Use this regular expression to filter consecutive groups of non spaces.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reWords: /\S+/g,

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'text',

    /**
     * Font size (in pixels)
     * @type Number
     * @default
     */
    fontSize: 40,

    /**
     * Font weight (e.g. bold, normal, 400, 600, 800)
     * @type {(Number|String)}
     * @default
     */
    fontWeight: 'normal',

    /**
     * Font family
     * @type String
     * @default
     */
    fontFamily: 'Times New Roman',

    /**
     * Text decoration underline.
     * @type Boolean
     * @default
     */
    underline: false,

    /**
     * Text decoration overline.
     * @type Boolean
     * @default
     */
    overline: false,

    /**
     * Text decoration linethrough.
     * @type Boolean
     * @default
     */
    linethrough: false,

    /**
     * Text alignment. Possible values: "left", "center", "right", "justify",
     * "justify-left", "justify-center" or "justify-right".
     * @type String
     * @default
     */
    textAlign: 'left',

    /**
     * Font style . Possible values: "", "normal", "italic" or "oblique".
     * @type String
     * @default
     */
    fontStyle: 'normal',

    /**
     * Line height
     * @type Number
     * @default
     */
    lineHeight: 1.16,

    /**
     * Superscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    superscript: {
      size: 0.60,
      // fontSize factor
      baseline: -0.35 // baseline-shift factor (upwards)

    },

    /**
     * Subscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    subscript: {
      size: 0.60,
      // fontSize factor
      baseline: 0.11 // baseline-shift factor (downwards)

    },

    /**
     * Background color of text lines
     * @type String
     * @default
     */
    textBackgroundColor: '',

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat(additionalProps),

    /**
     * List of properties to consider when checking if cache needs refresh
     * @type Array
     */
    cacheProperties: fabric.Object.prototype.cacheProperties.concat(additionalProps),

    /**
     * When defined, an object is rendered via stroke and this property specifies its color.
     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
     * @type String
     * @default
     */
    stroke: null,

    /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
     * @type fabric.Shadow
     * @default
     */
    shadow: null,

    /**
     * @private
     */
    _fontSizeFraction: 0.222,

    /**
     * @private
     */
    offsets: {
      underline: 0.10,
      linethrough: -0.315,
      overline: -0.88
    },

    /**
     * Text Line proportion to font Size (in pixels)
     * @type Number
     * @default
     */
    _fontSizeMult: 1.13,

    /**
     * additional space between characters
     * expressed in thousands of em unit
     * @type Number
     * @default
     */
    charSpacing: 0,

    /**
     * Object containing character styles - top-level properties -> line numbers,
     * 2nd-level properties - character numbers
     * @type Object
     * @default
     */
    styles: null,

    /**
     * Reference to a context to measure text char or couple of chars
     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
     * once created it will be referenced on fabric._measuringContext to avoid creating a canvas for every
     * text object created.
     * @type {CanvasRenderingContext2D}
     * @default
     */
    _measuringContext: null,

    /**
     * Baseline shift, styles only, keep at 0 for the main text object
     * @type {Number}
     * @default
     */
    deltaY: 0,

    /**
     * Array of properties that define a style unit (of 'styles').
     * @type {Array}
     * @default
     */
    _styleProperties: ['stroke', 'strokeWidth', 'fill', 'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'underline', 'overline', 'linethrough', 'deltaY', 'textBackgroundColor'],

    /**
     * contains characters bounding boxes
     */
    __charBounds: [],

    /**
     * use this size when measuring text. To avoid IE11 rounding errors
     * @type {Number}
     * @default
     * @readonly
     * @private
     */
    CACHE_FONT_SIZE: 400,

    /**
     * contains the min text width to avoid getting 0
     * @type {Number}
     * @default
     */
    MIN_TEXT_WIDTH: 2,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    initialize: function initialize(text, options) {
      this.styles = options ? options.styles || {} : {};
      this.text = text;
      this.__skipDimension = true;
      this.callSuper('initialize', options);

      if (this.path) {
        this.setPathInfo();
      }

      this.__skipDimension = false;
      this.initDimensions();
      this.setCoords();
      this.setupState({
        propertySet: '_dimensionAffectingProps'
      });
    },

    /**
     * If text has a path, it will add the extra information needed
     * for path and text calculations
     * @return {fabric.Text} thisArg
     */
    setPathInfo: function setPathInfo() {
      var path = this.path;

      if (path) {
        path.segmentsInfo = fabric.util.getPathSegmentsInfo(path.path);
      }
    },

    /**
     * Return a context for measurement of text string.
     * if created it gets stored for reuse
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    getMeasuringContext: function getMeasuringContext() {
      // if we did not return we have to measure something.
      if (!fabric._measuringContext) {
        fabric._measuringContext = this.canvas && this.canvas.contextCache || fabric.util.createCanvasElement().getContext('2d');
      }

      return fabric._measuringContext;
    },

    /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */
    _splitText: function _splitText() {
      var newLines = this._splitTextIntoLines(this.text);

      this.textLines = newLines.lines;
      this._textLines = newLines.graphemeLines;
      this._unwrappedTextLines = newLines._unwrappedLines;
      this._text = newLines.graphemeText;
      return newLines;
    },

    /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */
    initDimensions: function initDimensions() {
      if (this.__skipDimension) {
        return;
      }

      this._splitText();

      this._clearCache();

      if (this.path) {
        this.width = this.path.width;
        this.height = this.path.height;
      } else {
        this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
        this.height = this.calcTextHeight();
      }

      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }

      this.saveState({
        propertySet: '_dimensionAffectingProps'
      });
    },

    /**
     * Enlarge space boxes and shift the others
     */
    enlargeSpaces: function enlargeSpaces() {
      var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) {
          continue;
        }

        accumulatedSpace = 0;
        line = this._textLines[i];
        currentLineWidth = this.getLineWidth(i);

        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
          numberOfSpaces = spaces.length;
          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;

          for (var j = 0, jlen = line.length; j <= jlen; j++) {
            charBound = this.__charBounds[i][j];

            if (this._reSpaceAndTab.test(line[j])) {
              charBound.width += diffSpace;
              charBound.kernedWidth += diffSpace;
              charBound.left += accumulatedSpace;
              accumulatedSpace += diffSpace;
            } else {
              charBound.left += accumulatedSpace;
            }
          }
        }
      }
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */
    isEndOfWrapping: function isEndOfWrapping(lineIndex) {
      return lineIndex === this._textLines.length - 1;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always for text and Itext.
     * @return Number
     */
    missingNewlineOffset: function missingNewlineOffset() {
      return 1;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */
    toString: function toString() {
      return '#<fabric.Text (' + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
      var dims = this.callSuper('_getCacheCanvasDimensions');
      var fontSize = this.fontSize;
      dims.width += fontSize * dims.zoomX;
      dims.height += fontSize * dims.zoomY;
      return dims;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      this._setTextStyles(ctx);

      this._renderTextLinesBackground(ctx);

      this._renderTextDecoration(ctx, 'underline');

      this._renderText(ctx);

      this._renderTextDecoration(ctx, 'overline');

      this._renderTextDecoration(ctx, 'linethrough');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderText: function _renderText(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderTextStroke(ctx);

        this._renderTextFill(ctx);
      } else {
        this._renderTextFill(ctx);

        this._renderTextStroke(ctx);
      }
    },

    /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */
    _setTextStyles: function _setTextStyles(ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';
      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    },

    /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of fabric.Text object
     */
    calcTextWidth: function calcTextWidth() {
      var maxWidth = this.getLineWidth(0);

      for (var i = 1, len = this._textLines.length; i < len; i++) {
        var currentLineWidth = this.getLineWidth(i);

        if (currentLineWidth > maxWidth) {
          maxWidth = currentLineWidth;
        }
      }

      return maxWidth;
    },

    /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */
    _renderTextLine: function _renderTextLine(method, ctx, line, left, top, lineIndex) {
      this._renderChars(method, ctx, line, left, top, lineIndex);
    },

    /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextLinesBackground: function _renderTextLinesBackground(ctx) {
      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
        return;
      }

      var heightOfLine,
          lineLeftOffset,
          originalFill = ctx.fillStyle,
          line,
          lastColor,
          leftOffset = this._getLeftOffset(),
          lineTopOffset = this._getTopOffset(),
          boxStart = 0,
          boxWidth = 0,
          charBox,
          currentColor,
          path = this.path;

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);

        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
          lineTopOffset += heightOfLine;
          continue;
        }

        line = this._textLines[i];
        lineLeftOffset = this._getLineLeftOffset(i);
        boxWidth = 0;
        boxStart = 0;
        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');

        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');

          if (path) {
            ctx.save();
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);
            ctx.fillStyle = currentColor;
            currentColor && ctx.fillRect(-charBox.width / 2, -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction), charBox.width, heightOfLine / this.lineHeight);
            ctx.restore();
          } else if (currentColor !== lastColor) {
            ctx.fillStyle = lastColor;
            lastColor && ctx.fillRect(leftOffset + lineLeftOffset + boxStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastColor = currentColor;
          } else {
            boxWidth += charBox.kernedWidth;
          }
        }

        if (currentColor && !path) {
          ctx.fillStyle = currentColor;
          ctx.fillRect(leftOffset + lineLeftOffset + boxStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
        }

        lineTopOffset += heightOfLine;
      }

      ctx.fillStyle = originalFill; // if there is text background color no
      // other shadows should be casted

      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {Object} decl style declaration for cache
     * @param {String} decl.fontFamily fontFamily
     * @param {String} decl.fontStyle fontStyle
     * @param {String} decl.fontWeight fontWeight
     * @return {Object} reference to cache
     */
    getFontCache: function getFontCache(decl) {
      var fontFamily = decl.fontFamily.toLowerCase();

      if (!fabric.charWidthsCache[fontFamily]) {
        fabric.charWidthsCache[fontFamily] = {};
      }

      var cache = fabric.charWidthsCache[fontFamily],
          cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();

      if (!cache[cacheProp]) {
        cache[cacheProp] = {};
      }

      return cache[cacheProp];
    },

    /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */
    _measureChar: function _measureChar(_char, charStyle, previousChar, prevCharStyle) {
      // first i try to return from cache
      var fontCache = this.getFontCache(charStyle),
          fontDeclaration = this._getFontDeclaration(charStyle),
          previousFontDeclaration = this._getFontDeclaration(prevCharStyle),
          couple = previousChar + _char,
          stylesAreEqual = fontDeclaration === previousFontDeclaration,
          width,
          coupleWidth,
          previousWidth,
          fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE,
          kernedWidth;

      if (previousChar && fontCache[previousChar] !== undefined) {
        previousWidth = fontCache[previousChar];
      }

      if (fontCache[_char] !== undefined) {
        kernedWidth = width = fontCache[_char];
      }

      if (stylesAreEqual && fontCache[couple] !== undefined) {
        coupleWidth = fontCache[couple];
        kernedWidth = coupleWidth - previousWidth;
      }

      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
        var ctx = this.getMeasuringContext(); // send a TRUE to specify measuring font size CACHE_FONT_SIZE

        this._setTextStyles(ctx, charStyle, true);
      }

      if (width === undefined) {
        kernedWidth = width = ctx.measureText(_char).width;
        fontCache[_char] = width;
      }

      if (previousWidth === undefined && stylesAreEqual && previousChar) {
        previousWidth = ctx.measureText(previousChar).width;
        fontCache[previousChar] = previousWidth;
      }

      if (stylesAreEqual && coupleWidth === undefined) {
        // we can measure the kerning couple and subtract the width of the previous character
        coupleWidth = ctx.measureText(couple).width;
        fontCache[couple] = coupleWidth;
        kernedWidth = coupleWidth - previousWidth;
      }

      return {
        width: width * fontMultiplier,
        kernedWidth: kernedWidth * fontMultiplier
      };
    },

    /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */
    getHeightOfChar: function getHeightOfChar(line, _char) {
      return this.getValueOfPropertyAt(line, _char, 'fontSize');
    },

    /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    measureLine: function measureLine(lineIndex) {
      var lineInfo = this._measureLine(lineIndex);

      if (this.charSpacing !== 0) {
        lineInfo.width -= this._getWidthOfCharSpacing();
      }

      if (lineInfo.width < 0) {
        lineInfo.width = 0;
      }

      return lineInfo;
    },

    /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
     */
    _measureLine: function _measureLine(lineIndex) {
      var width = 0,
          i,
          grapheme,
          line = this._textLines[lineIndex],
          prevGrapheme,
          graphemeInfo,
          numOfSpaces = 0,
          lineBounds = new Array(line.length),
          positionInPath = 0,
          startingPoint,
          totalPathLength,
          path = this.path;
      this.__charBounds[lineIndex] = lineBounds;

      if (path) {
        startingPoint = fabric.util.getPointOnPath(path.path, 0, path.segmentsInfo);
        totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
        startingPoint.x += path.pathOffset.x;
        startingPoint.y += path.pathOffset.y;
      }

      for (i = 0; i < line.length; i++) {
        grapheme = line[i];
        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);

        if (path) {
          if (positionInPath > totalPathLength) {
            positionInPath %= totalPathLength;
          } // it would probably much fater to send all the grapheme position for a line
          // and calculate path position/angle at once.


          this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
        }

        lineBounds[i] = graphemeInfo;
        width += graphemeInfo.kernedWidth;
        positionInPath += graphemeInfo.kernedWidth;
        prevGrapheme = grapheme;
      } // this latest bound box represent the last character of the line
      // to simplify cursor handling in interactive mode.


      lineBounds[i] = {
        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
        width: 0,
        kernedWidth: 0,
        height: this.fontSize
      };
      return {
        width: width,
        numOfSpaces: numOfSpaces
      };
    },

    /**
     * Calculate the angle  and the left,top position of the char that follow a path.
     * It appends it to graphemeInfo to be reused later at rendering
     * @private
     * @param {Number} positionInPath to be measured
     * @param {Object} graphemeInfo current grapheme box information
     * @param {Object} startingPoint position of the point
     */
    _setGraphemeOnPath: function _setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint) {
      var centerPosition = positionInPath + graphemeInfo.kernedWidth / 2,
          path = this.path; // we are at currentPositionOnPath. we want to know what point on the path is.

      var info = fabric.util.getPointOnPath(path.path, centerPosition, path.segmentsInfo);
      graphemeInfo.renderLeft = info.x - startingPoint.x;
      graphemeInfo.renderTop = info.y - startingPoint.y;
      graphemeInfo.angle = info.angle;
    },

    /**
     * Measure and return the info of a single grapheme.
     * needs the the info of previous graphemes already filled
     * @private
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     */
    _getGraphemeBox: function _getGraphemeBox(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
      var style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {},
          info = this._measureChar(grapheme, style, prevGrapheme, prevStyle),
          kernedWidth = info.kernedWidth,
          width = info.width,
          charSpacing;

      if (this.charSpacing !== 0) {
        charSpacing = this._getWidthOfCharSpacing();
        width += charSpacing;
        kernedWidth += charSpacing;
      }

      var box = {
        width: width,
        left: 0,
        height: style.fontSize,
        kernedWidth: kernedWidth,
        deltaY: style.deltaY
      };

      if (charIndex > 0 && !skipLeft) {
        var previousBox = this.__charBounds[lineIndex][charIndex - 1];
        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
      }

      return box;
    },

    /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */
    getHeightOfLine: function getHeightOfLine(lineIndex) {
      if (this.__lineHeights[lineIndex]) {
        return this.__lineHeights[lineIndex];
      }

      var line = this._textLines[lineIndex],
          // char 0 is measured before the line cycle because it nneds to char
      // emptylines
      maxHeight = this.getHeightOfChar(lineIndex, 0);

      for (var i = 1, len = line.length; i < len; i++) {
        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
      }

      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
    },

    /**
     * Calculate text box height
     */
    calcTextHeight: function calcTextHeight() {
      var lineHeight,
          height = 0;

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineHeight = this.getHeightOfLine(i);
        height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
      }

      return height;
    },

    /**
     * @private
     * @return {Number} Left offset
     */
    _getLeftOffset: function _getLeftOffset() {
      return -this.width / 2;
    },

    /**
     * @private
     * @return {Number} Top offset
     */
    _getTopOffset: function _getTopOffset() {
      return -this.height / 2;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */
    _renderTextCommon: function _renderTextCommon(ctx, method) {
      ctx.save();

      var lineHeights = 0,
          left = this._getLeftOffset(),
          top = this._getTopOffset();

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        var heightOfLine = this.getHeightOfLine(i),
            maxHeight = heightOfLine / this.lineHeight,
            leftOffset = this._getLineLeftOffset(i);

        this._renderTextLine(method, ctx, this._textLines[i], left + leftOffset, top + lineHeights + maxHeight, i);

        lineHeights += heightOfLine;
      }

      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextFill: function _renderTextFill(ctx) {
      if (!this.fill && !this.styleHas('fill')) {
        return;
      }

      this._renderTextCommon(ctx, 'fillText');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextStroke: function _renderTextStroke(ctx) {
      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();

      this._setLineDash(ctx, this.strokeDashArray);

      ctx.beginPath();

      this._renderTextCommon(ctx, 'strokeText');

      ctx.closePath();
      ctx.restore();
    },

    /**
     * @private
     * @param {String} method fillText or strokeText.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} line Content of the line, splitted in an array by grapheme
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */
    _renderChars: function _renderChars(method, ctx, line, left, top, lineIndex) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox,
          boxWidth = 0,
          timeToRender,
          path = this.path,
          shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path;
      ctx.save();
      top -= lineHeight * this._fontSizeFraction / this.lineHeight;

      if (shortCut) {
        // render all the line in one pass without checking
        this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top, lineHeight);

        ctx.restore();
        return;
      }

      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing || path;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];

        if (boxWidth === 0) {
          left += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        } else {
          boxWidth += charBox.kernedWidth;
        }

        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }

        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
        }

        if (timeToRender) {
          if (path) {
            ctx.save();
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);

            this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);

            ctx.restore();
          } else {
            this._renderChar(method, ctx, lineIndex, i, charsToRender, left, top, lineHeight);
          }

          charsToRender = '';
          actualStyle = nextStyle;
          left += boxWidth;
          boxWidth = 0;
        }
      }

      ctx.restore();
    },

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {fabric.Gradient} filler a fabric gradient instance
     * @return {CanvasPattern} a pattern to use as fill/stroke style
     */
    _applyPatternGradientTransformText: function _applyPatternGradientTransformText(filler) {
      var pCanvas = fabric.util.createCanvasElement(),
          pCtx,
          // TODO: verify compatibility with strokeUniform
      width = this.width + this.strokeWidth,
          height = this.height + this.strokeWidth;
      pCanvas.width = width;
      pCanvas.height = height;
      pCtx = pCanvas.getContext('2d');
      pCtx.beginPath();
      pCtx.moveTo(0, 0);
      pCtx.lineTo(width, 0);
      pCtx.lineTo(width, height);
      pCtx.lineTo(0, height);
      pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.fillStyle = filler.toLive(pCtx);

      this._applyPatternGradientTransform(pCtx, filler);

      pCtx.fill();
      return pCtx.createPattern(pCanvas, 'no-repeat');
    },
    handleFiller: function handleFiller(ctx, property, filler) {
      var offsetX, offsetY;

      if (filler.toLive) {
        if (filler.gradientUnits === 'percentage' || filler.gradientTrasnform || filler.patternTransform) {
          // need to transform gradient in a pattern.
          // this is a slow process. If you are hitting this codepath, and the object
          // is not using caching, you should consider switching it on.
          // we need a canvas as big as the current object caching canvas.
          offsetX = -this.width / 2;
          offsetY = -this.height / 2;
          ctx.translate(offsetX, offsetY);
          ctx[property] = this._applyPatternGradientTransformText(filler);
          return {
            offsetX: offsetX,
            offsetY: offsetY
          };
        } else {
          // is a simple gradient or pattern
          ctx[property] = filler.toLive(ctx, this);
          return this._applyPatternGradientTransform(ctx, filler);
        }
      } else {
        // is a color
        ctx[property] = filler;
      }

      return {
        offsetX: 0,
        offsetY: 0
      };
    },
    _setStrokeStyles: function _setStrokeStyles(ctx, decl) {
      ctx.lineWidth = decl.strokeWidth;
      ctx.lineCap = this.strokeLineCap;
      ctx.lineDashOffset = this.strokeDashOffset;
      ctx.lineJoin = this.strokeLineJoin;
      ctx.miterLimit = this.strokeMiterLimit;
      return this.handleFiller(ctx, 'strokeStyle', decl.stroke);
    },
    _setFillStyles: function _setFillStyles(ctx, decl) {
      return this.handleFiller(ctx, 'fillStyle', decl.fill);
    },

    /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */
    _renderChar: function _renderChar(method, ctx, lineIndex, charIndex, _char, left, top) {
      var decl = this._getStyleDeclaration(lineIndex, charIndex),
          fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          shouldFill = method === 'fillText' && fullDecl.fill,
          shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth,
          fillOffsets,
          strokeOffsets;

      if (!shouldStroke && !shouldFill) {
        return;
      }

      ctx.save();
      shouldFill && (fillOffsets = this._setFillStyles(ctx, fullDecl));
      shouldStroke && (strokeOffsets = this._setStrokeStyles(ctx, fullDecl));
      ctx.font = this._getFontDeclaration(fullDecl);

      if (decl && decl.textBackgroundColor) {
        this._removeShadow(ctx);
      }

      if (decl && decl.deltaY) {
        top += decl.deltaY;
      }

      shouldFill && ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
      shouldStroke && ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
      ctx.restore();
    },

    /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSuperscript: function setSuperscript(start, end) {
      return this._setScript(start, end, this.superscript);
    },

    /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSubscript: function setSubscript(start, end) {
      return this._setScript(start, end, this.subscript);
    },

    /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    _setScript: function _setScript(start, end, schema) {
      var loc = this.get2DCursorLocation(start, true),
          fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
          dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
          style = {
        fontSize: fontSize * schema.size,
        deltaY: dy + fontSize * schema.baseline
      };
      this.setSelectionStyles(style, start, end);
      return this;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChanged: function _hasStyleChanged(prevStyle, thisStyle) {
      return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.deltaY !== thisStyle.deltaY;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChangedForSvg: function _hasStyleChangedForSvg(prevStyle, thisStyle) {
      return this._hasStyleChanged(prevStyle, thisStyle) || prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough;
    },

    /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */
    _getLineLeftOffset: function _getLineLeftOffset(lineIndex) {
      var lineWidth = this.getLineWidth(lineIndex);

      if (this.textAlign === 'center') {
        return (this.width - lineWidth) / 2;
      }

      if (this.textAlign === 'right') {
        return this.width - lineWidth;
      }

      if (this.textAlign === 'justify-center' && this.isEndOfWrapping(lineIndex)) {
        return (this.width - lineWidth) / 2;
      }

      if (this.textAlign === 'justify-right' && this.isEndOfWrapping(lineIndex)) {
        return this.width - lineWidth;
      }

      return 0;
    },

    /**
     * @private
     */
    _clearCache: function _clearCache() {
      this.__lineWidths = [];
      this.__lineHeights = [];
      this.__charBounds = [];
    },

    /**
     * @private
     */
    _shouldClearDimensionCache: function _shouldClearDimensionCache() {
      var shouldClear = this._forceClearCache;
      shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));

      if (shouldClear) {
        this.dirty = true;
        this._forceClearCache = false;
      }

      return shouldClear;
    },

    /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    getLineWidth: function getLineWidth(lineIndex) {
      if (this.__lineWidths[lineIndex]) {
        return this.__lineWidths[lineIndex];
      }

      var width,
          line = this._textLines[lineIndex],
          lineInfo;

      if (line === '') {
        width = 0;
      } else {
        lineInfo = this.measureLine(lineIndex);
        width = lineInfo.width;
      }

      this.__lineWidths[lineIndex] = width;
      return width;
    },
    _getWidthOfCharSpacing: function _getWidthOfCharSpacing() {
      if (this.charSpacing !== 0) {
        return this.fontSize * this.charSpacing / 1000;
      }

      return 0;
    },

    /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the character number
     * @param {String} property the property name
     * @returns the value of 'property'
     */
    getValueOfPropertyAt: function getValueOfPropertyAt(lineIndex, charIndex, property) {
      var charStyle = this._getStyleDeclaration(lineIndex, charIndex);

      if (charStyle && typeof charStyle[property] !== 'undefined') {
        return charStyle[property];
      }

      return this[property];
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextDecoration: function _renderTextDecoration(ctx, type) {
      if (!this[type] && !this.styleHas(type)) {
        return;
      }

      var heightOfLine,
          size,
          _size,
          lineLeftOffset,
          dy,
          _dy,
          line,
          lastDecoration,
          leftOffset = this._getLeftOffset(),
          topOffset = this._getTopOffset(),
          top,
          boxStart,
          boxWidth,
          charBox,
          currentDecoration,
          maxHeight,
          currentFill,
          lastFill,
          path = this.path,
          charSpacing = this._getWidthOfCharSpacing();

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);

        if (!this[type] && !this.styleHas(type, i)) {
          topOffset += heightOfLine;
          continue;
        }

        line = this._textLines[i];
        maxHeight = heightOfLine / this.lineHeight;
        lineLeftOffset = this._getLineLeftOffset(i);
        boxStart = 0;
        boxWidth = 0;
        lastDecoration = this.getValueOfPropertyAt(i, 0, type);
        lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
        top = topOffset + maxHeight * (1 - this._fontSizeFraction);
        size = this.getHeightOfChar(i, 0);
        dy = this.getValueOfPropertyAt(i, 0, 'deltaY');

        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentDecoration = this.getValueOfPropertyAt(i, j, type);
          currentFill = this.getValueOfPropertyAt(i, j, 'fill');
          _size = this.getHeightOfChar(i, j);
          _dy = this.getValueOfPropertyAt(i, j, 'deltaY');

          if (path && currentDecoration && currentFill) {
            ctx.save();
            ctx.fillStyle = lastFill;
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);
            ctx.fillRect(-charBox.kernedWidth / 2, this.offsets[type] * _size + _dy, charBox.kernedWidth, this.fontSize / 15);
            ctx.restore();
          } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) && boxWidth > 0) {
            lastDecoration && lastFill && ctx.fillRect(leftOffset + lineLeftOffset + boxStart, top + this.offsets[type] * size + dy, boxWidth, this.fontSize / 15);
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastDecoration = currentDecoration;
            lastFill = currentFill;
            size = _size;
            dy = _dy;
          } else {
            boxWidth += charBox.kernedWidth;
          }
        }

        ctx.fillStyle = currentFill;
        currentDecoration && currentFill && ctx.fillRect(leftOffset + lineLeftOffset + boxStart, top + this.offsets[type] * size + dy, boxWidth - charSpacing, this.fontSize / 15);
        topOffset += heightOfLine;
      } // if there is text background color no
      // other shadows should be casted


      this._removeShadow(ctx);
    },

    /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */
    _getFontDeclaration: function _getFontDeclaration(styleObject, forMeasuring) {
      var style = styleObject || this,
          family = this.fontFamily,
          fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
      var fontFamily = family === undefined || family.indexOf('\'') > -1 || family.indexOf(',') > -1 || family.indexOf('"') > -1 || fontIsGeneric ? style.fontFamily : '"' + style.fontFamily + '"';
      return [// node-canvas needs "weight style", while browsers need "style weight"
      // verify if this can be fixed in JSDOM
      fabric.isLikelyNode ? style.fontWeight : style.fontStyle, fabric.isLikelyNode ? style.fontStyle : style.fontWeight, forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px', fontFamily].join(' ');
    },

    /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function render(ctx) {
      // do not render if object is not visible
      if (!this.visible) {
        return;
      }

      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
      }

      this.callSuper('render', ctx);
    },

    /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns {Array} Lines in the text
     */
    _splitTextIntoLines: function _splitTextIntoLines(text) {
      var lines = text.split(this._reNewline),
          newLines = new Array(lines.length),
          newLine = ['\n'],
          newText = [];

      for (var i = 0; i < lines.length; i++) {
        newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
        newText = newText.concat(newLines[i], newLine);
      }

      newText.pop();
      return {
        _unwrappedLines: newLines,
        lines: lines,
        graphemeText: newText,
        graphemeLines: newLines
      };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      var additionalProperties = ['text', 'fontSize', 'fontWeight', 'fontFamily', 'fontStyle', 'lineHeight', 'underline', 'overline', 'linethrough', 'textAlign', 'textBackgroundColor', 'charSpacing'].concat(propertiesToInclude);
      var obj = this.callSuper('toObject', additionalProperties);
      obj.styles = clone(this.styles, true);
      return obj;
    },

    /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    set: function set(key, value) {
      this.callSuper('set', key, value);
      var needsDims = false;
      var isAddingPath = false;

      if (_typeof(key) === 'object') {
        for (var _key in key) {
          if (_key === 'path') {
            this.setPathInfo();
          }

          needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
          isAddingPath = isAddingPath || _key === 'path';
        }
      } else {
        needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
        isAddingPath = key === 'path';
      }

      if (isAddingPath) {
        this.setPathInfo();
      }

      if (needsDims) {
        this.initDimensions();
        this.setCoords();
      }

      return this;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */
    complexity: function complexity() {
      return 1;
    }
  });
  /* _FROM_SVG_START_ */

  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
   * @static
   * @memberOf fabric.Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */

  fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));
  /**
   * Default SVG font size
   * @static
   * @memberOf fabric.Text
   */

  fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;
  /**
   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf fabric.Text
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */

  fabric.Text.fromElement = function (element, callback, options) {
    if (!element) {
      return callback(null);
    }

    var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES),
        parsedAnchor = parsedAttributes.textAnchor || 'left';
    options = fabric.util.object.extend(options ? clone(options) : {}, parsedAttributes);
    options.top = options.top || 0;
    options.left = options.left || 0;

    if (parsedAttributes.textDecoration) {
      var textDecoration = parsedAttributes.textDecoration;

      if (textDecoration.indexOf('underline') !== -1) {
        options.underline = true;
      }

      if (textDecoration.indexOf('overline') !== -1) {
        options.overline = true;
      }

      if (textDecoration.indexOf('line-through') !== -1) {
        options.linethrough = true;
      }

      delete options.textDecoration;
    }

    if ('dx' in parsedAttributes) {
      options.left += parsedAttributes.dx;
    }

    if ('dy' in parsedAttributes) {
      options.top += parsedAttributes.dy;
    }

    if (!('fontSize' in options)) {
      options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
    }

    var textContent = ''; // The XML is not properly parsed in IE9 so a workaround to get
    // textContent is through firstChild.data. Another workaround would be
    // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)

    if (!('textContent' in element)) {
      if ('firstChild' in element && element.firstChild !== null) {
        if ('data' in element.firstChild && element.firstChild.data !== null) {
          textContent = element.firstChild.data;
        }
      }
    } else {
      textContent = element.textContent;
    }

    textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
    var originalStrokeWidth = options.strokeWidth;
    options.strokeWidth = 0;
    var text = new fabric.Text(textContent, options),
        textHeightScaleFactor = text.getScaledHeight() / text.height,
        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
        scaledDiff = lineHeightDiff * textHeightScaleFactor,
        textHeight = text.getScaledHeight() + scaledDiff,
        offX = 0;
    /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */

    if (parsedAnchor === 'center') {
      offX = text.getScaledWidth() / 2;
    }

    if (parsedAnchor === 'right') {
      offX = text.getScaledWidth();
    }

    text.set({
      left: text.left - offX,
      top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
      strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1
    });
    callback(text);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Text instance from an object representation
   * @static
   * @memberOf fabric.Text
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
   */


  fabric.Text.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Text', object, callback, 'text');
  };

  fabric.Text.genericFonts = ['sans-serif', 'serif', 'cursive', 'fantasy', 'monospace'];
  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  fabric.util.object.extend(fabric.Text.prototype,
  /** @lends fabric.Text.prototype */
  {
    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function isEmptyStyles(lineIndex) {
      if (!this.styles) {
        return true;
      }

      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return true;
      }

      var obj = typeof lineIndex === 'undefined' ? this.styles : {
        line: this.styles[lineIndex]
      };

      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          // eslint-disable-next-line no-unused-vars
          for (var p3 in obj[p1][p2]) {
            return false;
          }
        }
      }

      return true;
    },

    /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */
    styleHas: function styleHas(property, lineIndex) {
      if (!this.styles || !property || property === '') {
        return false;
      }

      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return false;
      }

      var obj = typeof lineIndex === 'undefined' ? this.styles : {
        0: this.styles[lineIndex]
      }; // eslint-disable-next-line

      for (var p1 in obj) {
        // eslint-disable-next-line
        for (var p2 in obj[p1]) {
          if (typeof obj[p1][p2][property] !== 'undefined') {
            return true;
          }
        }
      }

      return false;
    },

    /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     *
     * @param {string} property The property to compare between characters and text.
     */
    cleanStyle: function cleanStyle(property) {
      if (!this.styles || !property || property === '') {
        return false;
      }

      var obj = this.styles,
          stylesCount = 0,
          letterCount,
          stylePropertyValue,
          allStyleObjectPropertiesMatch = true,
          graphemeCount = 0,
          styleObject; // eslint-disable-next-line

      for (var p1 in obj) {
        letterCount = 0; // eslint-disable-next-line

        for (var p2 in obj[p1]) {
          var styleObject = obj[p1][p2],
              stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);
          stylesCount++;

          if (stylePropertyHasBeenSet) {
            if (!stylePropertyValue) {
              stylePropertyValue = styleObject[property];
            } else if (styleObject[property] !== stylePropertyValue) {
              allStyleObjectPropertiesMatch = false;
            }

            if (styleObject[property] === this[property]) {
              delete styleObject[property];
            }
          } else {
            allStyleObjectPropertiesMatch = false;
          }

          if (Object.keys(styleObject).length !== 0) {
            letterCount++;
          } else {
            delete obj[p1][p2];
          }
        }

        if (letterCount === 0) {
          delete obj[p1];
        }
      } // if every grapheme has the same style set then
      // delete those styles and set it on the parent


      for (var i = 0; i < this._textLines.length; i++) {
        graphemeCount += this._textLines[i].length;
      }

      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
        this[property] = stylePropertyValue;
        this.removeStyle(property);
      }
    },

    /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */
    removeStyle: function removeStyle(property) {
      if (!this.styles || !property || property === '') {
        return;
      }

      var obj = this.styles,
          line,
          lineNum,
          charNum;

      for (lineNum in obj) {
        line = obj[lineNum];

        for (charNum in line) {
          delete line[charNum][property];

          if (Object.keys(line[charNum]).length === 0) {
            delete line[charNum];
          }
        }

        if (Object.keys(line).length === 0) {
          delete obj[lineNum];
        }
      }
    },

    /**
     * @private
     */
    _extendStyles: function _extendStyles(index, styles) {
      var loc = this.get2DCursorLocation(index);

      if (!this._getLineStyle(loc.lineIndex)) {
        this._setLineStyle(loc.lineIndex);
      }

      if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
        this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
      }

      fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
    },

    /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */
    get2DCursorLocation: function get2DCursorLocation(selectionStart, skipWrapping) {
      if (typeof selectionStart === 'undefined') {
        selectionStart = this.selectionStart;
      }

      var lines = skipWrapping ? this._unwrappedTextLines : this._textLines,
          len = lines.length;

      for (var i = 0; i < len; i++) {
        if (selectionStart <= lines[i].length) {
          return {
            lineIndex: i,
            charIndex: selectionStart
          };
        }

        selectionStart -= lines[i].length + this.missingNewlineOffset(i);
      }

      return {
        lineIndex: i - 1,
        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
      };
    },

    /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */
    getSelectionStyles: function getSelectionStyles(startIndex, endIndex, complete) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }

      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }

      var styles = [];

      for (var i = startIndex; i < endIndex; i++) {
        styles.push(this.getStyleAtPosition(i, complete));
      }

      return styles;
    },

    /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */
    getStyleAtPosition: function getStyleAtPosition(position, complete) {
      var loc = this.get2DCursorLocation(position),
          style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) : this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
      return style || {};
    },

    /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @return {fabric.IText} thisArg
     * @chainable
     */
    setSelectionStyles: function setSelectionStyles(styles, startIndex, endIndex) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }

      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }

      for (var i = startIndex; i < endIndex; i++) {
        this._extendStyles(i, styles);
      }
      /* not included in _extendStyles to avoid clearing cache more than once */


      this._forceClearCache = true;
      return this;
    },

    /**
     * get the reference, not a clone, of the style object for a given character
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Object} style object
     */
    _getStyleDeclaration: function _getStyleDeclaration(lineIndex, charIndex) {
      var lineStyle = this.styles && this.styles[lineIndex];

      if (!lineStyle) {
        return null;
      }

      return lineStyle[charIndex];
    },

    /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */
    getCompleteStyleDeclaration: function getCompleteStyleDeclaration(lineIndex, charIndex) {
      var style = this._getStyleDeclaration(lineIndex, charIndex) || {},
          styleObject = {},
          prop;

      for (var i = 0; i < this._styleProperties.length; i++) {
        prop = this._styleProperties[i];
        styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
      }

      return styleObject;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function _setStyleDeclaration(lineIndex, charIndex, style) {
      this.styles[lineIndex][charIndex] = style;
    },

    /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function _deleteStyleDeclaration(lineIndex, charIndex) {
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function _getLineStyle(lineIndex) {
      return !!this.styles[lineIndex];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */
    _setLineStyle: function _setLineStyle(lineIndex) {
      this.styles[lineIndex] = {};
    },

    /**
     * @param {Number} lineIndex
     * @private
     */
    _deleteLineStyle: function _deleteLineStyle(lineIndex) {
      delete this.styles[lineIndex];
    }
  });
})();

(function () {
  function parseDecoration(object) {
    if (object.textDecoration) {
      object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
      object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
      object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
      delete object.textDecoration;
    }
  }
  /**
   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
   * prefix when observing canvas.
   * @class fabric.IText
   * @extends fabric.Text
   * @mixes fabric.Observable
   *
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   *
   * @return {fabric.IText} thisArg
   * @see {@link fabric.IText#initialize} for constructor definition
   *
   * <p>Supported key combinations:</p>
   * <pre>
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * </pre>
   *
   * <p>Supported mouse/touch combination</p>
   * <pre>
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * </pre>
   */


  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable,
  /** @lends fabric.IText.prototype */
  {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'i-text',

    /**
     * Index where text selection starts (or where cursor is when there is no selection)
     * @type Number
     * @default
     */
    selectionStart: 0,

    /**
     * Index where text selection ends
     * @type Number
     * @default
     */
    selectionEnd: 0,

    /**
     * Color of text selection
     * @type String
     * @default
     */
    selectionColor: 'rgba(17,119,255,0.3)',

    /**
     * Indicates whether text is in editing mode
     * @type Boolean
     * @default
     */
    isEditing: false,

    /**
     * Indicates whether a text can be edited
     * @type Boolean
     * @default
     */
    editable: true,

    /**
     * Border color of text object while it's in editing mode
     * @type String
     * @default
     */
    editingBorderColor: 'rgba(102,153,255,0.25)',

    /**
     * Width of cursor (in px)
     * @type Number
     * @default
     */
    cursorWidth: 2,

    /**
     * Color of text cursor color in editing mode.
     * if not set (default) will take color from the text.
     * if set to a color value that fabric can understand, it will
     * be used instead of the color of the text at the current position.
     * @type String
     * @default
     */
    cursorColor: '',

    /**
     * Delay between cursor blink (in ms)
     * @type Number
     * @default
     */
    cursorDelay: 1000,

    /**
     * Duration of cursor fadein (in ms)
     * @type Number
     * @default
     */
    cursorDuration: 600,

    /**
     * Indicates whether internal text char widths can be cached
     * @type Boolean
     * @default
     */
    caching: true,

    /**
     * @private
     */
    _reSpace: /\s|\n/,

    /**
     * @private
     */
    _currentCursorOpacity: 0,

    /**
     * @private
     */
    _selectionDirection: null,

    /**
     * @private
     */
    _abortCursorAnimation: false,

    /**
     * @private
     */
    __widthOfSpace: [],

    /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */
    inCompositionMode: false,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.IText} thisArg
     */
    initialize: function initialize(text, options) {
      this.callSuper('initialize', text, options);
      this.initBehavior();
    },

    /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */
    setSelectionStart: function setSelectionStart(index) {
      index = Math.max(index, 0);

      this._updateAndFire('selectionStart', index);
    },

    /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */
    setSelectionEnd: function setSelectionEnd(index) {
      index = Math.min(index, this.text.length);

      this._updateAndFire('selectionEnd', index);
    },

    /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */
    _updateAndFire: function _updateAndFire(property, index) {
      if (this[property] !== index) {
        this._fireSelectionChanged();

        this[property] = index;
      }

      this._updateTextarea();
    },

    /**
     * Fires the even of selection changed
     * @private
     */
    _fireSelectionChanged: function _fireSelectionChanged() {
      this.fire('selection:changed');
      this.canvas && this.canvas.fire('text:selection:changed', {
        target: this
      });
    },

    /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */
    initDimensions: function initDimensions() {
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this.callSuper('initDimensions');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function render(ctx) {
      this.clearContextTop();
      this.callSuper('render', ctx); // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
      // the correct position but not at every cursor animation.

      this.cursorOffsetCache = {};
      this.renderCursorOrSelection();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function _render(ctx) {
      this.callSuper('_render', ctx);
    },

    /**
     * Prepare and clean the contextTop
     */
    clearContextTop: function clearContextTop(skipRestore) {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }

      var ctx = this.canvas.contextTop,
          v = this.canvas.viewportTransform;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this.transform(ctx);

      this._clearTextArea(ctx);

      skipRestore || ctx.restore();
    },

    /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */
    renderCursorOrSelection: function renderCursorOrSelection() {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }

      var boundaries = this._getCursorBoundaries(),
          ctx = this.canvas.contextTop;

      this.clearContextTop(true);

      if (this.selectionStart === this.selectionEnd) {
        this.renderCursor(boundaries, ctx);
      } else {
        this.renderSelection(boundaries, ctx);
      }

      ctx.restore();
    },
    _clearTextArea: function _clearTextArea(ctx) {
      // we add 4 pixel, to be sure to do not leave any pixel out
      var width = this.width + 4,
          height = this.height + 4;
      ctx.clearRect(-width / 2, -height / 2, width, height);
    },

    /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * @private
     * @param {Array} chars Array of characters
     * @param {String} typeOfBoundaries
     */
    _getCursorBoundaries: function _getCursorBoundaries(position) {
      // left/top are left/top of entire text box
      // leftOffset/topOffset are offset from that left/top point of a text box
      if (typeof position === 'undefined') {
        position = this.selectionStart;
      }

      var left = this._getLeftOffset(),
          top = this._getTopOffset(),
          offsets = this._getCursorBoundariesOffsets(position);

      return {
        left: left,
        top: top,
        leftOffset: offsets.left,
        topOffset: offsets.top
      };
    },

    /**
     * @private
     */
    _getCursorBoundariesOffsets: function _getCursorBoundariesOffsets(position) {
      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
        return this.cursorOffsetCache;
      }

      var lineLeftOffset,
          lineIndex,
          charIndex,
          topOffset = 0,
          leftOffset = 0,
          boundaries,
          cursorPosition = this.get2DCursorLocation(position);
      charIndex = cursorPosition.charIndex;
      lineIndex = cursorPosition.lineIndex;

      for (var i = 0; i < lineIndex; i++) {
        topOffset += this.getHeightOfLine(i);
      }

      lineLeftOffset = this._getLineLeftOffset(lineIndex);
      var bound = this.__charBounds[lineIndex][charIndex];
      bound && (leftOffset = bound.left);

      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
        leftOffset -= this._getWidthOfCharSpacing();
      }

      boundaries = {
        top: topOffset,
        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
      };
      this.cursorOffsetCache = boundaries;
      return this.cursorOffsetCache;
    },

    /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderCursor: function renderCursor(boundaries, ctx) {
      var cursorLocation = this.get2DCursorLocation(),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
          multiplier = this.scaleX * this.canvas.getZoom(),
          cursorWidth = this.cursorWidth / multiplier,
          topOffset = boundaries.topOffset,
          dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');
      topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);

      if (this.inCompositionMode) {
        this.renderSelection(boundaries, ctx);
      }

      ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
      ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
      ctx.fillRect(boundaries.left + boundaries.leftOffset - cursorWidth / 2, topOffset + boundaries.top + dy, cursorWidth, charHeight);
    },

    /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderSelection: function renderSelection(boundaries, ctx) {
      var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
          selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
          isJustify = this.textAlign.indexOf('justify') !== -1,
          start = this.get2DCursorLocation(selectionStart),
          end = this.get2DCursorLocation(selectionEnd),
          startLine = start.lineIndex,
          endLine = end.lineIndex,
          startChar = start.charIndex < 0 ? 0 : start.charIndex,
          endChar = end.charIndex < 0 ? 0 : end.charIndex;

      for (var i = startLine; i <= endLine; i++) {
        var lineOffset = this._getLineLeftOffset(i) || 0,
            lineHeight = this.getHeightOfLine(i),
            realLineHeight = 0,
            boxStart = 0,
            boxEnd = 0;

        if (i === startLine) {
          boxStart = this.__charBounds[startLine][startChar].left;
        }

        if (i >= startLine && i < endLine) {
          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
        } else if (i === endLine) {
          if (endChar === 0) {
            boxEnd = this.__charBounds[endLine][endChar].left;
          } else {
            var charSpacing = this._getWidthOfCharSpacing();

            boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
          }
        }

        realLineHeight = lineHeight;

        if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) {
          lineHeight /= this.lineHeight;
        }

        if (this.inCompositionMode) {
          ctx.fillStyle = this.compositionColor || 'black';
          ctx.fillRect(boundaries.left + lineOffset + boxStart, boundaries.top + boundaries.topOffset + lineHeight, boxEnd - boxStart, 1);
        } else {
          ctx.fillStyle = this.selectionColor;
          ctx.fillRect(boundaries.left + lineOffset + boxStart, boundaries.top + boundaries.topOffset, boxEnd - boxStart, lineHeight);
        }

        boundaries.topOffset += realLineHeight;
      }
    },

    /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */
    getCurrentCharFontSize: function getCurrentCharFontSize() {
      var cp = this._getCurrentCharIndex();

      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
    },

    /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * Unused from the library, is for the end user
     * @return {String} Character color (fill)
     */
    getCurrentCharColor: function getCurrentCharColor() {
      var cp = this._getCurrentCharIndex();

      return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
    },

    /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */
    _getCurrentCharIndex: function _getCurrentCharIndex() {
      var cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
          charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
      return {
        l: cursorPosition.lineIndex,
        c: charIndex
      };
    }
  });
  /**
   * Returns fabric.IText instance from an object representation
   * @static
   * @memberOf fabric.IText
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as argument
   */

  fabric.IText.fromObject = function (object, callback) {
    parseDecoration(object);

    if (object.styles) {
      for (var i in object.styles) {
        for (var j in object.styles[i]) {
          parseDecoration(object.styles[i][j]);
        }
      }
    }

    fabric.Object._fromObject('IText', object, callback, 'text');
  };
})();

(function () {
  var clone = fabric.util.object.clone;
  fabric.util.object.extend(fabric.IText.prototype,
  /** @lends fabric.IText.prototype */
  {
    /**
     * Initializes all the interactive behavior of IText
     */
    initBehavior: function initBehavior() {
      this.initAddedHandler();
      this.initRemovedHandler();
      this.initCursorSelectionHandlers();
      this.initDoubleClickSimulation();
      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    },
    onDeselect: function onDeselect() {
      this.isEditing && this.exitEditing();
      this.selected = false;
    },

    /**
     * Initializes "added" event handler
     */
    initAddedHandler: function initAddedHandler() {
      var _this = this;

      this.on('added', function () {
        var canvas = _this.canvas;

        if (canvas) {
          if (!canvas._hasITextHandlers) {
            canvas._hasITextHandlers = true;

            _this._initCanvasHandlers(canvas);
          }

          canvas._iTextInstances = canvas._iTextInstances || [];

          canvas._iTextInstances.push(_this);
        }
      });
    },
    initRemovedHandler: function initRemovedHandler() {
      var _this = this;

      this.on('removed', function () {
        var canvas = _this.canvas;

        if (canvas) {
          canvas._iTextInstances = canvas._iTextInstances || [];
          fabric.util.removeFromArray(canvas._iTextInstances, _this);

          if (canvas._iTextInstances.length === 0) {
            canvas._hasITextHandlers = false;

            _this._removeCanvasHandlers(canvas);
          }
        }
      });
    },

    /**
     * register canvas event to manage exiting on other instances
     * @private
     */
    _initCanvasHandlers: function _initCanvasHandlers(canvas) {
      canvas._mouseUpITextHandler = function () {
        if (canvas._iTextInstances) {
          canvas._iTextInstances.forEach(function (obj) {
            obj.__isMousedown = false;
          });
        }
      };

      canvas.on('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * remove canvas event to manage exiting on other instances
     * @private
     */
    _removeCanvasHandlers: function _removeCanvasHandlers(canvas) {
      canvas.off('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * @private
     */
    _tick: function _tick() {
      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
    },

    /**
     * @private
     */
    _animateCursor: function _animateCursor(obj, targetOpacity, duration, completeMethod) {
      var tickState;
      tickState = {
        isAborted: false,
        abort: function abort() {
          this.isAborted = true;
        }
      };
      obj.animate('_currentCursorOpacity', targetOpacity, {
        duration: duration,
        onComplete: function onComplete() {
          if (!tickState.isAborted) {
            obj[completeMethod]();
          }
        },
        onChange: function onChange() {
          // we do not want to animate a selection, only cursor
          if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
            obj.renderCursorOrSelection();
          }
        },
        abort: function abort() {
          return tickState.isAborted;
        }
      });
      return tickState;
    },

    /**
     * @private
     */
    _onTickComplete: function _onTickComplete() {
      var _this = this;

      if (this._cursorTimeout1) {
        clearTimeout(this._cursorTimeout1);
      }

      this._cursorTimeout1 = setTimeout(function () {
        _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
      }, 100);
    },

    /**
     * Initializes delayed cursor
     */
    initDelayedCursor: function initDelayedCursor(restart) {
      var _this = this,
          delay = restart ? 0 : this.cursorDelay;

      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this._cursorTimeout2 = setTimeout(function () {
        _this._tick();
      }, delay);
    },

    /**
     * Aborts cursor animation and clears all timeouts
     */
    abortCursorAnimation: function abortCursorAnimation() {
      var shouldClear = this._currentTickState || this._currentTickCompleteState,
          canvas = this.canvas;
      this._currentTickState && this._currentTickState.abort();
      this._currentTickCompleteState && this._currentTickCompleteState.abort();
      clearTimeout(this._cursorTimeout1);
      clearTimeout(this._cursorTimeout2);
      this._currentCursorOpacity = 0; // to clear just itext area we need to transform the context
      // it may not be worth it

      if (shouldClear && canvas) {
        canvas.clearContext(canvas.contextTop || canvas.contextContainer);
      }
    },

    /**
     * Selects entire text
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectAll: function selectAll() {
      this.selectionStart = 0;
      this.selectionEnd = this._text.length;

      this._fireSelectionChanged();

      this._updateTextarea();

      return this;
    },

    /**
     * Returns selected text
     * @return {String}
     */
    getSelectedText: function getSelectedText() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
    },

    /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryLeft: function findWordBoundaryLeft(startFrom) {
      var offset = 0,
          index = startFrom - 1; // remove space before cursor first

      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index--;
        }
      }

      while (/\S/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryRight: function findWordBoundaryRight(startFrom) {
      var offset = 0,
          index = startFrom; // remove space after cursor first

      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index++;
        }
      }

      while (/\S/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryLeft: function findLineBoundaryLeft(startFrom) {
      var offset = 0,
          index = startFrom - 1;

      while (!/\n/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryRight: function findLineBoundaryRight(startFrom) {
      var offset = 0,
          index = startFrom;

      while (!/\n/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */
    searchWordBoundary: function searchWordBoundary(selectionStart, direction) {
      var text = this._text,
          index = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart,
          _char = text[index],
          // wrong
      reNonWord = fabric.reNonWord;

      while (!reNonWord.test(_char) && index > 0 && index < text.length) {
        index += direction;
        _char = text[index];
      }

      if (reNonWord.test(_char)) {
        index += direction === 1 ? 0 : 1;
      }

      return index;
    },

    /**
     * Selects a word based on the index
     * @param {Number} selectionStart Index of a character
     */
    selectWord: function selectWord(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.searchWordBoundary(selectionStart, -1),

      /* search backwards */
      newSelectionEnd = this.searchWordBoundary(selectionStart, 1);
      /* search forward */

      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;

      this._fireSelectionChanged();

      this._updateTextarea();

      this.renderCursorOrSelection();
    },

    /**
     * Selects a line based on the index
     * @param {Number} selectionStart Index of a character
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectLine: function selectLine(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.findLineBoundaryLeft(selectionStart),
          newSelectionEnd = this.findLineBoundaryRight(selectionStart);
      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;

      this._fireSelectionChanged();

      this._updateTextarea();

      return this;
    },

    /**
     * Enters editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    enterEditing: function enterEditing(e) {
      if (this.isEditing || !this.editable) {
        return;
      }

      if (this.canvas) {
        this.canvas.calcOffset();
        this.exitEditingOnOthers(this.canvas);
      }

      this.isEditing = true;
      this.initHiddenTextarea(e);
      this.hiddenTextarea.focus();
      this.hiddenTextarea.value = this.text;

      this._updateTextarea();

      this._saveEditingProps();

      this._setEditingProps();

      this._textBeforeEdit = this.text;

      this._tick();

      this.fire('editing:entered');

      this._fireSelectionChanged();

      if (!this.canvas) {
        return this;
      }

      this.canvas.fire('text:editing:entered', {
        target: this
      });
      this.initMouseMoveHandler();
      this.canvas.requestRenderAll();
      return this;
    },
    exitEditingOnOthers: function exitEditingOnOthers(canvas) {
      if (canvas._iTextInstances) {
        canvas._iTextInstances.forEach(function (obj) {
          obj.selected = false;

          if (obj.isEditing) {
            obj.exitEditing();
          }
        });
      }
    },

    /**
     * Initializes "mousemove" event handler
     */
    initMouseMoveHandler: function initMouseMoveHandler() {
      this.canvas.on('mouse:move', this.mouseMoveHandler);
    },

    /**
     * @private
     */
    mouseMoveHandler: function mouseMoveHandler(options) {
      if (!this.__isMousedown || !this.isEditing) {
        return;
      }

      var newSelectionStart = this.getSelectionStartFromPointer(options.e),
          currentStart = this.selectionStart,
          currentEnd = this.selectionEnd;

      if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) {
        return;
      }

      if (newSelectionStart > this.__selectionStartOnMouseDown) {
        this.selectionStart = this.__selectionStartOnMouseDown;
        this.selectionEnd = newSelectionStart;
      } else {
        this.selectionStart = newSelectionStart;
        this.selectionEnd = this.__selectionStartOnMouseDown;
      }

      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
        this.restartCursorIfNeeded();

        this._fireSelectionChanged();

        this._updateTextarea();

        this.renderCursorOrSelection();
      }
    },

    /**
     * @private
     */
    _setEditingProps: function _setEditingProps() {
      this.hoverCursor = 'text';

      if (this.canvas) {
        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
      }

      this.borderColor = this.editingBorderColor;
      this.hasControls = this.selectable = false;
      this.lockMovementX = this.lockMovementY = true;
    },

    /**
     * convert from textarea to grapheme indexes
     */
    fromStringToGraphemeSelection: function fromStringToGraphemeSelection(start, end, text) {
      var smallerTextStart = text.slice(0, start),
          graphemeStart = fabric.util.string.graphemeSplit(smallerTextStart).length;

      if (start === end) {
        return {
          selectionStart: graphemeStart,
          selectionEnd: graphemeStart
        };
      }

      var smallerTextEnd = text.slice(start, end),
          graphemeEnd = fabric.util.string.graphemeSplit(smallerTextEnd).length;
      return {
        selectionStart: graphemeStart,
        selectionEnd: graphemeStart + graphemeEnd
      };
    },

    /**
     * convert from fabric to textarea values
     */
    fromGraphemeToStringSelection: function fromGraphemeToStringSelection(start, end, _text) {
      var smallerTextStart = _text.slice(0, start),
          graphemeStart = smallerTextStart.join('').length;

      if (start === end) {
        return {
          selectionStart: graphemeStart,
          selectionEnd: graphemeStart
        };
      }

      var smallerTextEnd = _text.slice(start, end),
          graphemeEnd = smallerTextEnd.join('').length;

      return {
        selectionStart: graphemeStart,
        selectionEnd: graphemeStart + graphemeEnd
      };
    },

    /**
     * @private
     */
    _updateTextarea: function _updateTextarea() {
      this.cursorOffsetCache = {};

      if (!this.hiddenTextarea) {
        return;
      }

      if (!this.inCompositionMode) {
        var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
      }

      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateFromTextArea: function updateFromTextArea() {
      if (!this.hiddenTextarea) {
        return;
      }

      this.cursorOffsetCache = {};
      this.text = this.hiddenTextarea.value;

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }

      var newSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;

      if (!this.inCompositionMode) {
        this.selectionStart = newSelection.selectionStart;
      }

      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateTextareaPosition: function updateTextareaPosition() {
      if (this.selectionStart === this.selectionEnd) {
        var style = this._calcTextareaPosition();

        this.hiddenTextarea.style.left = style.left;
        this.hiddenTextarea.style.top = style.top;
      }
    },

    /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */
    _calcTextareaPosition: function _calcTextareaPosition() {
      if (!this.canvas) {
        return {
          x: 1,
          y: 1
        };
      }

      var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
          boundaries = this._getCursorBoundaries(desiredPosition),
          cursorLocation = this.get2DCursorLocation(desiredPosition),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
          leftOffset = boundaries.leftOffset,
          m = this.calcTransformMatrix(),
          p = {
        x: boundaries.left + leftOffset,
        y: boundaries.top + boundaries.topOffset + charHeight
      },
          retinaScaling = this.canvas.getRetinaScaling(),
          upperCanvas = this.canvas.upperCanvasEl,
          upperCanvasWidth = upperCanvas.width / retinaScaling,
          upperCanvasHeight = upperCanvas.height / retinaScaling,
          maxWidth = upperCanvasWidth - charHeight,
          maxHeight = upperCanvasHeight - charHeight,
          scaleX = upperCanvas.clientWidth / upperCanvasWidth,
          scaleY = upperCanvas.clientHeight / upperCanvasHeight;

      p = fabric.util.transformPoint(p, m);
      p = fabric.util.transformPoint(p, this.canvas.viewportTransform);
      p.x *= scaleX;
      p.y *= scaleY;

      if (p.x < 0) {
        p.x = 0;
      }

      if (p.x > maxWidth) {
        p.x = maxWidth;
      }

      if (p.y < 0) {
        p.y = 0;
      }

      if (p.y > maxHeight) {
        p.y = maxHeight;
      } // add canvas offset on document


      p.x += this.canvas._offset.left;
      p.y += this.canvas._offset.top;
      return {
        left: p.x + 'px',
        top: p.y + 'px',
        fontSize: charHeight + 'px',
        charHeight: charHeight
      };
    },

    /**
     * @private
     */
    _saveEditingProps: function _saveEditingProps() {
      this._savedProps = {
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        lockMovementX: this.lockMovementX,
        lockMovementY: this.lockMovementY,
        hoverCursor: this.hoverCursor,
        selectable: this.selectable,
        defaultCursor: this.canvas && this.canvas.defaultCursor,
        moveCursor: this.canvas && this.canvas.moveCursor
      };
    },

    /**
     * @private
     */
    _restoreEditingProps: function _restoreEditingProps() {
      if (!this._savedProps) {
        return;
      }

      this.hoverCursor = this._savedProps.hoverCursor;
      this.hasControls = this._savedProps.hasControls;
      this.borderColor = this._savedProps.borderColor;
      this.selectable = this._savedProps.selectable;
      this.lockMovementX = this._savedProps.lockMovementX;
      this.lockMovementY = this._savedProps.lockMovementY;

      if (this.canvas) {
        this.canvas.defaultCursor = this._savedProps.defaultCursor;
        this.canvas.moveCursor = this._savedProps.moveCursor;
      }
    },

    /**
     * Exits from editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    exitEditing: function exitEditing() {
      var isTextChanged = this._textBeforeEdit !== this.text;
      var hiddenTextarea = this.hiddenTextarea;
      this.selected = false;
      this.isEditing = false;
      this.selectionEnd = this.selectionStart;

      if (hiddenTextarea) {
        hiddenTextarea.blur && hiddenTextarea.blur();
        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      }

      this.hiddenTextarea = null;
      this.abortCursorAnimation();

      this._restoreEditingProps();

      this._currentCursorOpacity = 0;

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }

      this.fire('editing:exited');
      isTextChanged && this.fire('modified');

      if (this.canvas) {
        this.canvas.off('mouse:move', this.mouseMoveHandler);
        this.canvas.fire('text:editing:exited', {
          target: this
        });
        isTextChanged && this.canvas.fire('object:modified', {
          target: this
        });
      }

      return this;
    },

    /**
     * @private
     */
    _removeExtraneousStyles: function _removeExtraneousStyles() {
      for (var prop in this.styles) {
        if (!this._textLines[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */
    removeStyleFromTo: function removeStyleFromTo(start, end) {
      var cursorStart = this.get2DCursorLocation(start, true),
          cursorEnd = this.get2DCursorLocation(end, true),
          lineStart = cursorStart.lineIndex,
          charStart = cursorStart.charIndex,
          lineEnd = cursorEnd.lineIndex,
          charEnd = cursorEnd.charIndex,
          i,
          styleObj;

      if (lineStart !== lineEnd) {
        // step1 remove the trailing of lineStart
        if (this.styles[lineStart]) {
          for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
            delete this.styles[lineStart][i];
          }
        } // step2 move the trailing of lineEnd to lineStart if needed


        if (this.styles[lineEnd]) {
          for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
            styleObj = this.styles[lineEnd][i];

            if (styleObj) {
              this.styles[lineStart] || (this.styles[lineStart] = {});
              this.styles[lineStart][charStart + i - charEnd] = styleObj;
            }
          }
        } // step3 detects lines will be completely removed.


        for (i = lineStart + 1; i <= lineEnd; i++) {
          delete this.styles[i];
        } // step4 shift remaining lines.


        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
      } else {
        // remove and shift left on the same line
        if (this.styles[lineStart]) {
          styleObj = this.styles[lineStart];

          var diff = charEnd - charStart,
              numericChar,
              _char;

          for (i = charStart; i < charEnd; i++) {
            delete styleObj[i];
          }

          for (_char in this.styles[lineStart]) {
            numericChar = parseInt(_char, 10);

            if (numericChar >= charEnd) {
              styleObj[numericChar - diff] = styleObj[_char];
              delete styleObj[_char];
            }
          }
        }
      }
    },

    /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */
    shiftLineStyles: function shiftLineStyles(lineIndex, offset) {
      // shift all line styles by offset upward or downward
      // do not clone deep. we need new array, not new style objects
      var clonedStyles = clone(this.styles);

      for (var line in this.styles) {
        var numericLine = parseInt(line, 10);

        if (numericLine > lineIndex) {
          this.styles[numericLine + offset] = clonedStyles[numericLine];

          if (!clonedStyles[numericLine - offset]) {
            delete this.styles[numericLine];
          }
        }
      }
    },
    restartCursorIfNeeded: function restartCursorIfNeeded() {
      if (!this._currentTickState || this._currentTickState.isAborted || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted) {
        this.initDelayedCursor();
      }
    },

    /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */
    insertNewlineStyleObject: function insertNewlineStyleObject(lineIndex, charIndex, qty, copiedStyle) {
      var currentCharStyle,
          newLineStyles = {},
          somethingAdded = false,
          isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;
      qty || (qty = 1);
      this.shiftLineStyles(lineIndex, qty);

      if (this.styles[lineIndex]) {
        currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
      } // we clone styles of all chars
      // after cursor onto the current line


      for (var index in this.styles[lineIndex]) {
        var numIndex = parseInt(index, 10);

        if (numIndex >= charIndex) {
          somethingAdded = true;
          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index]; // remove lines from the previous line since they're on a new line now

          if (!(isEndOfLine && charIndex === 0)) {
            delete this.styles[lineIndex][index];
          }
        }
      }

      var styleCarriedOver = false;

      if (somethingAdded && !isEndOfLine) {
        // if is end of line, the extra style we copied
        // is probably not something we want
        this.styles[lineIndex + qty] = newLineStyles;
        styleCarriedOver = true;
      }

      if (styleCarriedOver) {
        // skip the last line of since we already prepared it.
        qty--;
      } // for the all the lines or all the other lines
      // we clone current char style onto the next (otherwise empty) line


      while (qty > 0) {
        if (copiedStyle && copiedStyle[qty - 1]) {
          this.styles[lineIndex + qty] = {
            0: clone(copiedStyle[qty - 1])
          };
        } else if (currentCharStyle) {
          this.styles[lineIndex + qty] = {
            0: clone(currentCharStyle)
          };
        } else {
          delete this.styles[lineIndex + qty];
        }

        qty--;
      }

      this._forceClearCache = true;
    },

    /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */
    insertCharStyleObject: function insertCharStyleObject(lineIndex, charIndex, quantity, copiedStyle) {
      if (!this.styles) {
        this.styles = {};
      }

      var currentLineStyles = this.styles[lineIndex],
          currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};
      quantity || (quantity = 1); // shift all char styles by quantity forward
      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4

      for (var index in currentLineStylesCloned) {
        var numericIndex = parseInt(index, 10);

        if (numericIndex >= charIndex) {
          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex]; // only delete the style if there was nothing moved there

          if (!currentLineStylesCloned[numericIndex - quantity]) {
            delete currentLineStyles[numericIndex];
          }
        }
      }

      this._forceClearCache = true;

      if (copiedStyle) {
        while (quantity--) {
          if (!Object.keys(copiedStyle[quantity]).length) {
            continue;
          }

          if (!this.styles[lineIndex]) {
            this.styles[lineIndex] = {};
          }

          this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
        }

        return;
      }

      if (!currentLineStyles) {
        return;
      }

      var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];

      while (newStyle && quantity--) {
        this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
      }
    },

    /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */
    insertNewStyleBlock: function insertNewStyleBlock(insertedText, start, copiedStyle) {
      var cursorLoc = this.get2DCursorLocation(start, true),
          addedLines = [0],
          linesLength = 0; // get an array of how many char per lines are being added.

      for (var i = 0; i < insertedText.length; i++) {
        if (insertedText[i] === '\n') {
          linesLength++;
          addedLines[linesLength] = 0;
        } else {
          addedLines[linesLength]++;
        }
      } // for the first line copy the style from the current char position.


      if (addedLines[0] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
      }

      linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);

      for (var i = 1; i < linesLength; i++) {
        if (addedLines[i] > 0) {
          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        } else if (copiedStyle) {
          this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
        }

        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
      } // we use i outside the loop to get it like linesLength


      if (addedLines[i] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
      }
    },

    /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */
    setSelectionStartEndWithShift: function setSelectionStartEndWithShift(start, end, newSelection) {
      if (newSelection <= start) {
        if (end === start) {
          this._selectionDirection = 'left';
        } else if (this._selectionDirection === 'right') {
          this._selectionDirection = 'left';
          this.selectionEnd = start;
        }

        this.selectionStart = newSelection;
      } else if (newSelection > start && newSelection < end) {
        if (this._selectionDirection === 'right') {
          this.selectionEnd = newSelection;
        } else {
          this.selectionStart = newSelection;
        }
      } else {
        // newSelection is > selection start and end
        if (end === start) {
          this._selectionDirection = 'right';
        } else if (this._selectionDirection === 'left') {
          this._selectionDirection = 'right';
          this.selectionStart = end;
        }

        this.selectionEnd = newSelection;
      }
    },
    setSelectionInBoundaries: function setSelectionInBoundaries() {
      var length = this.text.length;

      if (this.selectionStart > length) {
        this.selectionStart = length;
      } else if (this.selectionStart < 0) {
        this.selectionStart = 0;
      }

      if (this.selectionEnd > length) {
        this.selectionEnd = length;
      } else if (this.selectionEnd < 0) {
        this.selectionEnd = 0;
      }
    }
  });
})();

fabric.util.object.extend(fabric.IText.prototype,
/** @lends fabric.IText.prototype */
{
  /**
   * Initializes "dbclick" event handler
   */
  initDoubleClickSimulation: function initDoubleClickSimulation() {
    // for double click
    this.__lastClickTime = +new Date(); // for triple click

    this.__lastLastClickTime = +new Date();
    this.__lastPointer = {};
    this.on('mousedown', this.onMouseDown);
  },

  /**
   * Default event handler to simulate triple click
   * @private
   */
  onMouseDown: function onMouseDown(options) {
    if (!this.canvas) {
      return;
    }

    this.__newClickTime = +new Date();
    var newPointer = options.pointer;

    if (this.isTripleClick(newPointer)) {
      this.fire('tripleclick', options);

      this._stopEvent(options.e);
    }

    this.__lastLastClickTime = this.__lastClickTime;
    this.__lastClickTime = this.__newClickTime;
    this.__lastPointer = newPointer;
    this.__lastIsEditing = this.isEditing;
    this.__lastSelected = this.selected;
  },
  isTripleClick: function isTripleClick(newPointer) {
    return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === newPointer.x && this.__lastPointer.y === newPointer.y;
  },

  /**
   * @private
   */
  _stopEvent: function _stopEvent(e) {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
  },

  /**
   * Initializes event handlers related to cursor or selection
   */
  initCursorSelectionHandlers: function initCursorSelectionHandlers() {
    this.initMousedownHandler();
    this.initMouseupHandler();
    this.initClicks();
  },

  /**
   * Default handler for double click, select a word
   */
  doubleClickHandler: function doubleClickHandler(options) {
    if (!this.isEditing) {
      return;
    }

    this.selectWord(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Default handler for triple click, select a line
   */
  tripleClickHandler: function tripleClickHandler(options) {
    if (!this.isEditing) {
      return;
    }

    this.selectLine(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Initializes double and triple click event handlers
   */
  initClicks: function initClicks() {
    this.on('mousedblclick', this.doubleClickHandler);
    this.on('tripleclick', this.tripleClickHandler);
  },

  /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */
  _mouseDownHandler: function _mouseDownHandler(options) {
    if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) {
      return;
    }

    this.__isMousedown = true;

    if (this.selected) {
      this.inCompositionMode = false;
      this.setCursorByClick(options.e);
    }

    if (this.isEditing) {
      this.__selectionStartOnMouseDown = this.selectionStart;

      if (this.selectionStart === this.selectionEnd) {
        this.abortCursorAnimation();
      }

      this.renderCursorOrSelection();
    }
  },

  /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */
  _mouseDownHandlerBefore: function _mouseDownHandlerBefore(options) {
    if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) {
      return;
    } // we want to avoid that an object that was selected and then becomes unselectable,
    // may trigger editing mode in some way.


    this.selected = this === this.canvas._activeObject;
  },

  /**
   * Initializes "mousedown" event handler
   */
  initMousedownHandler: function initMousedownHandler() {
    this.on('mousedown', this._mouseDownHandler);
    this.on('mousedown:before', this._mouseDownHandlerBefore);
  },

  /**
   * Initializes "mouseup" event handler
   */
  initMouseupHandler: function initMouseupHandler() {
    this.on('mouseup', this.mouseUpHandler);
  },

  /**
   * standard handler for mouse up, overridable
   * @private
   */
  mouseUpHandler: function mouseUpHandler(options) {
    this.__isMousedown = false;

    if (!this.editable || this.group || options.transform && options.transform.actionPerformed || options.e.button && options.e.button !== 1) {
      return;
    }

    if (this.canvas) {
      var currentActive = this.canvas._activeObject;

      if (currentActive && currentActive !== this) {
        // avoid running this logic when there is an active object
        // this because is possible with shift click and fast clicks,
        // to rapidly deselect and reselect this object and trigger an enterEdit
        return;
      }
    }

    if (this.__lastSelected && !this.__corner) {
      this.selected = false;
      this.__lastSelected = false;
      this.enterEditing(options.e);

      if (this.selectionStart === this.selectionEnd) {
        this.initDelayedCursor(true);
      } else {
        this.renderCursorOrSelection();
      }
    } else {
      this.selected = true;
    }
  },

  /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {Event} e Event object
   */
  setCursorByClick: function setCursorByClick(e) {
    var newSelection = this.getSelectionStartFromPointer(e),
        start = this.selectionStart,
        end = this.selectionEnd;

    if (e.shiftKey) {
      this.setSelectionStartEndWithShift(start, end, newSelection);
    } else {
      this.selectionStart = newSelection;
      this.selectionEnd = newSelection;
    }

    if (this.isEditing) {
      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },

  /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {Event} e Event object
   * @return {Number} Index of a character
   */
  getSelectionStartFromPointer: function getSelectionStartFromPointer(e) {
    var mouseOffset = this.getLocalPointer(e),
        prevWidth = 0,
        width = 0,
        height = 0,
        charIndex = 0,
        lineIndex = 0,
        lineLeftOffset,
        line;

    for (var i = 0, len = this._textLines.length; i < len; i++) {
      if (height <= mouseOffset.y) {
        height += this.getHeightOfLine(i) * this.scaleY;
        lineIndex = i;

        if (i > 0) {
          charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
        }
      } else {
        break;
      }
    }

    lineLeftOffset = this._getLineLeftOffset(lineIndex);
    width = lineLeftOffset * this.scaleX;
    line = this._textLines[lineIndex];

    for (var j = 0, jlen = line.length; j < jlen; j++) {
      prevWidth = width; // i removed something about flipX here, check.

      width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;

      if (width <= mouseOffset.x) {
        charIndex++;
      } else {
        break;
      }
    }

    return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
  },

  /**
   * @private
   */
  _getNewSelectionStartFromOffset: function _getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, index, jlen) {
    // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
    var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth,
        distanceBtwNextCharAndCursor = width - mouseOffset.x,
        offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor || distanceBtwNextCharAndCursor < 0 ? 0 : 1,
        newSelectionStart = index + offset; // if object is horizontally flipped, mirror cursor location from the end

    if (this.flipX) {
      newSelectionStart = jlen - newSelectionStart;
    }

    if (newSelectionStart > this._text.length) {
      newSelectionStart = this._text.length;
    }

    return newSelectionStart;
  }
});
fabric.util.object.extend(fabric.IText.prototype,
/** @lends fabric.IText.prototype */
{
  /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */
  initHiddenTextarea: function initHiddenTextarea() {
    this.hiddenTextarea = fabric.document.createElement('textarea');
    this.hiddenTextarea.setAttribute('autocapitalize', 'off');
    this.hiddenTextarea.setAttribute('autocorrect', 'off');
    this.hiddenTextarea.setAttribute('autocomplete', 'off');
    this.hiddenTextarea.setAttribute('spellcheck', 'false');
    this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
    this.hiddenTextarea.setAttribute('wrap', 'off');

    var style = this._calcTextareaPosition(); // line-height: 1px; was removed from the style to fix this:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=870966


    this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top + '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' + ' paddingｰtop: ' + style.fontSize + ';';
    fabric.document.body.appendChild(this.hiddenTextarea);
    fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));

    if (!this._clickHandlerInitialized && this.canvas) {
      fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
      this._clickHandlerInitialized = true;
    }
  },

  /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behaviour for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the fabric.Itext or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = fabric.util.object.clone(this.keysMap);
   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
   */
  keysMap: {
    9: 'exitEditing',
    27: 'exitEditing',
    33: 'moveCursorUp',
    34: 'moveCursorDown',
    35: 'moveCursorRight',
    36: 'moveCursorLeft',
    37: 'moveCursorLeft',
    38: 'moveCursorUp',
    39: 'moveCursorRight',
    40: 'moveCursorDown'
  },

  /**
   * For functionalities on keyUp + ctrl || cmd
   */
  ctrlKeysMapUp: {
    67: 'copy',
    88: 'cut'
  },

  /**
   * For functionalities on keyDown + ctrl || cmd
   */
  ctrlKeysMapDown: {
    65: 'selectAll'
  },
  onClick: function onClick() {
    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
    this.hiddenTextarea && this.hiddenTextarea.focus();
  },

  /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {Event} e Event object
   */
  onKeyDown: function onKeyDown(e) {
    if (!this.isEditing) {
      return;
    }

    if (e.keyCode in this.keysMap) {
      this[this.keysMap[e.keyCode]](e);
    } else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapDown[e.keyCode]](e);
    } else {
      return;
    }

    e.stopImmediatePropagation();
    e.preventDefault();

    if (e.keyCode >= 33 && e.keyCode <= 40) {
      // if i press an arrow key just update selection
      this.inCompositionMode = false;
      this.clearContextTop();
      this.renderCursorOrSelection();
    } else {
      this.canvas && this.canvas.requestRenderAll();
    }
  },

  /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {Event} e Event object
   */
  onKeyUp: function onKeyUp(e) {
    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
      this._copyDone = false;
      return;
    }

    if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapUp[e.keyCode]](e);
    } else {
      return;
    }

    e.stopImmediatePropagation();
    e.preventDefault();
    this.canvas && this.canvas.requestRenderAll();
  },

  /**
   * Handles onInput event
   * @param {Event} e Event object
   */
  onInput: function onInput(e) {
    var fromPaste = this.fromPaste;
    this.fromPaste = false;
    e && e.stopPropagation();

    if (!this.isEditing) {
      return;
    } // decisions about style changes.


    var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
        charCount = this._text.length,
        nextCharCount = nextText.length,
        removedText,
        insertedText,
        charDiff = nextCharCount - charCount,
        selectionStart = this.selectionStart,
        selectionEnd = this.selectionEnd,
        selection = selectionStart !== selectionEnd,
        copiedStyle,
        removeFrom,
        removeTo;

    if (this.hiddenTextarea.value === '') {
      this.styles = {};
      this.updateFromTextArea();
      this.fire('changed');

      if (this.canvas) {
        this.canvas.fire('text:changed', {
          target: this
        });
        this.canvas.requestRenderAll();
      }

      return;
    }

    var textareaSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
    var backDelete = selectionStart > textareaSelection.selectionStart;

    if (selection) {
      removedText = this._text.slice(selectionStart, selectionEnd);
      charDiff += selectionEnd - selectionStart;
    } else if (nextCharCount < charCount) {
      if (backDelete) {
        removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
      } else {
        removedText = this._text.slice(selectionStart, selectionStart - charDiff);
      }
    }

    insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);

    if (removedText && removedText.length) {
      if (insertedText.length) {
        // let's copy some style before deleting.
        // we want to copy the style before the cursor OR the style at the cursor if selection
        // is bigger than 0.
        copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false); // now duplicate the style one for each inserted text.

        copiedStyle = insertedText.map(function () {
          // this return an array of references, but that is fine since we are
          // copying the style later.
          return copiedStyle[0];
        });
      }

      if (selection) {
        removeFrom = selectionStart;
        removeTo = selectionEnd;
      } else if (backDelete) {
        // detect differences between forwardDelete and backDelete
        removeFrom = selectionEnd - removedText.length;
        removeTo = selectionEnd;
      } else {
        removeFrom = selectionEnd;
        removeTo = selectionEnd + removedText.length;
      }

      this.removeStyleFromTo(removeFrom, removeTo);
    }

    if (insertedText.length) {
      if (fromPaste && insertedText.join('') === fabric.copiedText && !fabric.disableStyleCopyPaste) {
        copiedStyle = fabric.copiedTextStyle;
      }

      this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
    }

    this.updateFromTextArea();
    this.fire('changed');

    if (this.canvas) {
      this.canvas.fire('text:changed', {
        target: this
      });
      this.canvas.requestRenderAll();
    }
  },

  /**
   * Composition start
   */
  onCompositionStart: function onCompositionStart() {
    this.inCompositionMode = true;
  },

  /**
   * Composition end
   */
  onCompositionEnd: function onCompositionEnd() {
    this.inCompositionMode = false;
  },
  // /**
  //  * Composition update
  //  */
  onCompositionUpdate: function onCompositionUpdate(e) {
    this.compositionStart = e.target.selectionStart;
    this.compositionEnd = e.target.selectionEnd;
    this.updateTextareaPosition();
  },

  /**
   * Copies selected text
   * @param {Event} e Event object
   */
  copy: function copy() {
    if (this.selectionStart === this.selectionEnd) {
      //do not cut-copy if no selection
      return;
    }

    fabric.copiedText = this.getSelectedText();

    if (!fabric.disableStyleCopyPaste) {
      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
    } else {
      fabric.copiedTextStyle = null;
    }

    this._copyDone = true;
  },

  /**
   * Pastes text
   * @param {Event} e Event object
   */
  paste: function paste() {
    this.fromPaste = true;
  },

  /**
   * @private
   * @param {Event} e Event object
   * @return {Object} Clipboard data object
   */
  _getClipboardData: function _getClipboardData(e) {
    return e && e.clipboardData || fabric.window.clipboardData;
  },

  /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */
  _getWidthBeforeCursor: function _getWidthBeforeCursor(lineIndex, charIndex) {
    var widthBeforeCursor = this._getLineLeftOffset(lineIndex),
        bound;

    if (charIndex > 0) {
      bound = this.__charBounds[lineIndex][charIndex - 1];
      widthBeforeCursor += bound.left + bound.width;
    }

    return widthBeforeCursor;
  },

  /**
   * Gets start offset of a selection
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getDownCursorOffset: function getDownCursorOffset(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex; // if on last line, down cursor goes to end of line


    if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
      // move to the end of a text
      return this._text.length - selectionProp;
    }

    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
        textAfterCursor = this._textLines[lineIndex].slice(charIndex);

    return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
  },

  /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  _getSelectionForOffset: function _getSelectionForOffset(e, isRight) {
    if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
      return this.selectionEnd;
    } else {
      return this.selectionStart;
    }
  },

  /**
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getUpCursorOffset: function getUpCursorOffset(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;

    if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
      // if on first line, up cursor goes to start of line
      return -selectionProp;
    }

    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1); // return a negative offset


    return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
  },

  /**
   * for a given width it founds the matching character.
   * @private
   */
  _getIndexOnLine: function _getIndexOnLine(lineIndex, width) {
    var line = this._textLines[lineIndex],
        lineLeftOffset = this._getLineLeftOffset(lineIndex),
        widthOfCharsOnLine = lineLeftOffset,
        indexOnLine = 0,
        charWidth,
        foundMatch;

    for (var j = 0, jlen = line.length; j < jlen; j++) {
      charWidth = this.__charBounds[lineIndex][j].width;
      widthOfCharsOnLine += charWidth;

      if (widthOfCharsOnLine > width) {
        foundMatch = true;
        var leftEdge = widthOfCharsOnLine - charWidth,
            rightEdge = widthOfCharsOnLine,
            offsetFromLeftEdge = Math.abs(leftEdge - width),
            offsetFromRightEdge = Math.abs(rightEdge - width);
        indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
        break;
      }
    } // reached end


    if (!foundMatch) {
      indexOnLine = line.length - 1;
    }

    return indexOnLine;
  },

  /**
   * Moves cursor down
   * @param {Event} e Event object
   */
  moveCursorDown: function moveCursorDown(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }

    this._moveCursorUpOrDown('Down', e);
  },

  /**
   * Moves cursor up
   * @param {Event} e Event object
   */
  moveCursorUp: function moveCursorUp(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }

    this._moveCursorUpOrDown('Up', e);
  },

  /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {Event} e Event object
   */
  _moveCursorUpOrDown: function _moveCursorUpOrDown(direction, e) {
    // getUpCursorOffset
    // getDownCursorOffset
    var action = 'get' + direction + 'CursorOffset',
        offset = this[action](e, this._selectionDirection === 'right');

    if (e.shiftKey) {
      this.moveCursorWithShift(offset);
    } else {
      this.moveCursorWithoutShift(offset);
    }

    if (offset !== 0) {
      this.setSelectionInBoundaries();
      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this.initDelayedCursor();

      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },

  /**
   * Moves cursor with shift
   * @param {Number} offset
   */
  moveCursorWithShift: function moveCursorWithShift(offset) {
    var newSelection = this._selectionDirection === 'left' ? this.selectionStart + offset : this.selectionEnd + offset;
    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
    return offset !== 0;
  },

  /**
   * Moves cursor up without shift
   * @param {Number} offset
   */
  moveCursorWithoutShift: function moveCursorWithoutShift(offset) {
    if (offset < 0) {
      this.selectionStart += offset;
      this.selectionEnd = this.selectionStart;
    } else {
      this.selectionEnd += offset;
      this.selectionStart = this.selectionEnd;
    }

    return offset !== 0;
  },

  /**
   * Moves cursor left
   * @param {Event} e Event object
   */
  moveCursorLeft: function moveCursorLeft(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }

    this._moveCursorLeftOrRight('Left', e);
  },

  /**
   * @private
   * @return {Boolean} true if a change happened
   */
  _move: function _move(e, prop, direction) {
    var newValue;

    if (e.altKey) {
      newValue = this['findWordBoundary' + direction](this[prop]);
    } else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) {
      newValue = this['findLineBoundary' + direction](this[prop]);
    } else {
      this[prop] += direction === 'Left' ? -1 : 1;
      return true;
    }

    if (_typeof(newValue) !== undefined && this[prop] !== newValue) {
      this[prop] = newValue;
      return true;
    }
  },

  /**
   * @private
   */
  _moveLeft: function _moveLeft(e, prop) {
    return this._move(e, prop, 'Left');
  },

  /**
   * @private
   */
  _moveRight: function _moveRight(e, prop) {
    return this._move(e, prop, 'Right');
  },

  /**
   * Moves cursor left without keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithoutShift: function moveCursorLeftWithoutShift(e) {
    var change = true;
    this._selectionDirection = 'left'; // only move cursor when there is no selection,
    // otherwise we discard it, and leave cursor on same place

    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
      change = this._moveLeft(e, 'selectionStart');
    }

    this.selectionEnd = this.selectionStart;
    return change;
  },

  /**
   * Moves cursor left while keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithShift: function moveCursorLeftWithShift(e) {
    if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) {
      return this._moveLeft(e, 'selectionEnd');
    } else if (this.selectionStart !== 0) {
      this._selectionDirection = 'left';
      return this._moveLeft(e, 'selectionStart');
    }
  },

  /**
   * Moves cursor right
   * @param {Event} e Event object
   */
  moveCursorRight: function moveCursorRight(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }

    this._moveCursorLeftOrRight('Right', e);
  },

  /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {Event} e Event object
   */
  _moveCursorLeftOrRight: function _moveCursorLeftOrRight(direction, e) {
    var actionName = 'moveCursor' + direction + 'With';
    this._currentCursorOpacity = 1;

    if (e.shiftKey) {
      actionName += 'Shift';
    } else {
      actionName += 'outShift';
    }

    if (this[actionName](e)) {
      this.abortCursorAnimation();
      this.initDelayedCursor();

      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },

  /**
   * Moves cursor right while keeping selection
   * @param {Event} e
   */
  moveCursorRightWithShift: function moveCursorRightWithShift(e) {
    if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) {
      return this._moveRight(e, 'selectionStart');
    } else if (this.selectionEnd !== this._text.length) {
      this._selectionDirection = 'right';
      return this._moveRight(e, 'selectionEnd');
    }
  },

  /**
   * Moves cursor right without keeping selection
   * @param {Event} e Event object
   */
  moveCursorRightWithoutShift: function moveCursorRightWithoutShift(e) {
    var changed = true;
    this._selectionDirection = 'right';

    if (this.selectionStart === this.selectionEnd) {
      changed = this._moveRight(e, 'selectionStart');
      this.selectionEnd = this.selectionStart;
    } else {
      this.selectionStart = this.selectionEnd;
    }

    return changed;
  },

  /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  removeChars: function removeChars(start, end) {
    if (typeof end === 'undefined') {
      end = start + 1;
    }

    this.removeStyleFromTo(start, end);

    this._text.splice(start, end - start);

    this.text = this._text.join('');
    this.set('dirty', true);

    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }

    this._removeExtraneousStyles();
  },

  /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  insertChars: function insertChars(text, style, start, end) {
    if (typeof end === 'undefined') {
      end = start;
    }

    if (end > start) {
      this.removeStyleFromTo(start, end);
    }

    var graphemes = fabric.util.string.graphemeSplit(text);
    this.insertNewStyleBlock(graphemes, start, style);
    this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
    this.text = this._text.join('');
    this.set('dirty', true);

    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }

    this._removeExtraneousStyles();
  }
});
/* _TO_SVG_START_ */

(function () {
  var toFixed = fabric.util.toFixed,
      multipleSpacesRegex = /  +/g;
  fabric.util.object.extend(fabric.Text.prototype,
  /** @lends fabric.Text.prototype */
  {
    /**
     * Returns SVG representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function _toSVG() {
      var offsets = this._getSVGLeftTopOffsets(),
          textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);

      return this._wrapSVGTextAndBg(textAndBg);
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function toSVG(reviver) {
      return this._createBaseSVGMarkup(this._toSVG(), {
        reviver: reviver,
        noStyle: true,
        withShadow: true
      });
    },

    /**
     * @private
     */
    _getSVGLeftTopOffsets: function _getSVGLeftTopOffsets() {
      return {
        textLeft: -this.width / 2,
        textTop: -this.height / 2,
        lineTop: this.getHeightOfLine(0)
      };
    },

    /**
     * @private
     */
    _wrapSVGTextAndBg: function _wrapSVGTextAndBg(textAndBg) {
      var noShadow = true,
          textDecoration = this.getSvgTextDecoration(this);
      return [textAndBg.textBgRects.join(''), '\t\t<text xml:space="preserve" ', this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : '', this.fontSize ? 'font-size="' + this.fontSize + '" ' : '', this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : '', this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : '', textDecoration ? 'text-decoration="' + textDecoration + '" ' : '', 'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >', textAndBg.textSpans.join(''), '</text>\n'];
    },

    /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */
    _getSVGTextAndBg: function _getSVGTextAndBg(textTopOffset, textLeftOffset) {
      var textSpans = [],
          textBgRects = [],
          height = textTopOffset,
          lineOffset; // bounding-box background

      this._setSVGBg(textBgRects); // text and text-background


      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineOffset = this._getLineLeftOffset(i);

        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
        }

        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);

        height += this.getHeightOfLine(i);
      }

      return {
        textSpans: textSpans,
        textBgRects: textBgRects
      };
    },

    /**
     * @private
     */
    _createTextCharSpan: function _createTextCharSpan(_char, styleDecl, left, top) {
      var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex),
          styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace),
          fillStyles = styleProps ? 'style="' + styleProps + '"' : '',
          dy = styleDecl.deltaY,
          dySpan = '',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      if (dy) {
        dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
      }

      return ['<tspan x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="', toFixed(top, NUM_FRACTION_DIGITS), '" ', dySpan, fillStyles, '>', fabric.util.string.escapeXml(_char), '</tspan>'].join('');
    },
    _setSVGTextLineText: function _setSVGTextLineText(textSpans, lineIndex, textLeftOffset, textTopOffset) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox,
          style,
          boxWidth = 0,
          line = this._textLines[lineIndex],
          timeToRender;
      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;

      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];

        if (boxWidth === 0) {
          textLeftOffset += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        } else {
          boxWidth += charBox.kernedWidth;
        }

        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }

        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
        }

        if (timeToRender) {
          style = this._getStyleDeclaration(lineIndex, i) || {};
          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
          charsToRender = '';
          actualStyle = nextStyle;
          textLeftOffset += boxWidth;
          boxWidth = 0;
        }
      }
    },
    _pushTextBgRect: function _pushTextBgRect(textBgRects, color, left, top, width, height) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
      textBgRects.push('\t\t<rect ', this._getFillAttributes(color), ' x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="', toFixed(top, NUM_FRACTION_DIGITS), '" width="', toFixed(width, NUM_FRACTION_DIGITS), '" height="', toFixed(height, NUM_FRACTION_DIGITS), '"></rect>\n');
    },
    _setSVGTextLineBg: function _setSVGTextLineBg(textBgRects, i, leftOffset, textTopOffset) {
      var line = this._textLines[i],
          heightOfLine = this.getHeightOfLine(i) / this.lineHeight,
          boxWidth = 0,
          boxStart = 0,
          charBox,
          currentColor,
          lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');

      for (var j = 0, jlen = line.length; j < jlen; j++) {
        charBox = this.__charBounds[i][j];
        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');

        if (currentColor !== lastColor) {
          lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
          boxStart = charBox.left;
          boxWidth = charBox.width;
          lastColor = currentColor;
        } else {
          boxWidth += charBox.kernedWidth;
        }
      }

      currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
    },

    /**
     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
     *
     * @private
     * @param {*} value
     * @return {String}
     */
    _getFillAttributes: function _getFillAttributes(value) {
      var fillColor = value && typeof value === 'string' ? new fabric.Color(value) : '';

      if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
        return 'fill="' + value + '"';
      }

      return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
    },

    /**
     * @private
     */
    _getSVGLineTopOffset: function _getSVGLineTopOffset(lineIndex) {
      var lineTopOffset = 0,
          lastHeight = 0;

      for (var j = 0; j < lineIndex; j++) {
        lineTopOffset += this.getHeightOfLine(j);
      }

      lastHeight = this.getHeightOfLine(j);
      return {
        lineTop: lineTopOffset,
        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
      };
    },

    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function getSvgStyles(skipShadow) {
      var svgStyle = fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
      return svgStyle + ' white-space: pre;';
    }
  });
})();
/* _TO_SVG_END_ */


(function (global) {
  'use strict';

  var fabric = global.fabric || (global.fabric = {});
  /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   * @class fabric.Textbox
   * @extends fabric.IText
   * @mixes fabric.Observable
   * @return {fabric.Textbox} thisArg
   * @see {@link fabric.Textbox#initialize} for constructor definition
   */

  fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {
    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'textbox',

    /**
     * Minimum width of textbox, in pixels.
     * @type Number
     * @default
     */
    minWidth: 20,

    /**
     * Minimum calculated width of a textbox, in pixels.
     * fixed to 2 so that an empty textbox cannot go to 0
     * and is still selectable without text.
     * @type Number
     * @default
     */
    dynamicMinWidth: 2,

    /**
     * Cached array of text wrapping.
     * @type Array
     */
    __cachedLines: null,

    /**
     * Override standard Object class values
     */
    lockScalingFlip: true,

    /**
     * Override standard Object class values
     * Textbox needs this on false
     */
    noScaleCache: false,

    /**
     * Properties which when set cause object to change dimensions
     * @type Object
     * @private
     */
    _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),

    /**
     * Use this regular expression to split strings in breakable lines
     * @private
     */
    _wordJoiners: /[ \t\r]/,

    /**
     * Use this boolean property in order to split strings that have no white space concept.
     * this is a cheap way to help with chinese/japanese
     * @type Boolean
     * @since 2.6.0
     */
    splitByGrapheme: false,

    /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */
    initDimensions: function initDimensions() {
      if (this.__skipDimension) {
        return;
      }

      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();

      this._clearCache(); // clear dynamicMinWidth as it will be different after we re-wrap line


      this.dynamicMinWidth = 0; // wrap lines

      this._styleMap = this._generateStyleMap(this._splitText()); // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap

      if (this.dynamicMinWidth > this.width) {
        this._set('width', this.dynamicMinWidth);
      }

      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      } // clear cache and re-calculate height


      this.height = this.calcTextHeight();
      this.saveState({
        propertySet: '_dimensionAffectingProps'
      });
    },

    /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */
    _generateStyleMap: function _generateStyleMap(textInfo) {
      var realLineCount = 0,
          realLineCharCount = 0,
          charCount = 0,
          map = {};

      for (var i = 0; i < textInfo.graphemeLines.length; i++) {
        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
          realLineCharCount = 0;
          charCount++;
          realLineCount++;
        } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
          // this case deals with space's that are removed from end of lines when wrapping
          realLineCharCount++;
          charCount++;
        }

        map[i] = {
          line: realLineCount,
          offset: realLineCharCount
        };
        charCount += textInfo.graphemeLines[i].length;
        realLineCharCount += textInfo.graphemeLines[i].length;
      }

      return map;
    },

    /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */
    styleHas: function styleHas(property, lineIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];

        if (map) {
          lineIndex = map.line;
        }
      }

      return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
    },

    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function isEmptyStyles(lineIndex) {
      if (!this.styles) {
        return true;
      }

      var offset = 0,
          nextLineIndex = lineIndex + 1,
          nextOffset,
          obj,
          shouldLimit = false,
          map = this._styleMap[lineIndex],
          mapNextLine = this._styleMap[lineIndex + 1];

      if (map) {
        lineIndex = map.line;
        offset = map.offset;
      }

      if (mapNextLine) {
        nextLineIndex = mapNextLine.line;
        shouldLimit = nextLineIndex === lineIndex;
        nextOffset = mapNextLine.offset;
      }

      obj = typeof lineIndex === 'undefined' ? this.styles : {
        line: this.styles[lineIndex]
      };

      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
            // eslint-disable-next-line no-unused-vars
            for (var p3 in obj[p1][p2]) {
              return false;
            }
          }
        }
      }

      return true;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _getStyleDeclaration: function _getStyleDeclaration(lineIndex, charIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];

        if (!map) {
          return null;
        }

        lineIndex = map.line;
        charIndex = map.offset + charIndex;
      }

      return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function _setStyleDeclaration(lineIndex, charIndex, style) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;
      this.styles[lineIndex][charIndex] = style;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function _deleteStyleDeclaration(lineIndex, charIndex) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function _getLineStyle(lineIndex) {
      var map = this._styleMap[lineIndex];
      return !!this.styles[map.line];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */
    _setLineStyle: function _setLineStyle(lineIndex) {
      var map = this._styleMap[lineIndex];
      this.styles[map.line] = {};
    },

    /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */
    _wrapText: function _wrapText(lines, desiredWidth) {
      var wrapped = [],
          i;
      this.isWrapping = true;

      for (i = 0; i < lines.length; i++) {
        wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
      }

      this.isWrapping = false;
      return wrapped;
    },

    /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * it gets called when charBounds are not available yet.
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     * @private
     */
    _measureWord: function _measureWord(word, lineIndex, charOffset) {
      var width = 0,
          prevGrapheme,
          skipLeft = true;
      charOffset = charOffset || 0;

      for (var i = 0, len = word.length; i < len; i++) {
        var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);

        width += box.kernedWidth;
        prevGrapheme = word[i];
      }

      return width;
    },

    /**
     * Wraps a line of text using the width of the Textbox and a context.
     * @param {Array} line The grapheme array that represent the line
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */
    _wrapLine: function _wrapLine(_line, lineIndex, desiredWidth, reservedSpace) {
      var lineWidth = 0,
          splitByGrapheme = this.splitByGrapheme,
          graphemeLines = [],
          line = [],
          // spaces in different languages?
      words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners),
          word = '',
          offset = 0,
          infix = splitByGrapheme ? '' : ' ',
          wordWidth = 0,
          infixWidth = 0,
          largestWordWidth = 0,
          lineJustStarted = true,
          additionalSpace = this._getWidthOfCharSpacing(),
          reservedSpace = reservedSpace || 0; // fix a difference between split and graphemeSplit


      if (words.length === 0) {
        words.push([]);
      }

      desiredWidth -= reservedSpace;

      for (var i = 0; i < words.length; i++) {
        // if using splitByGrapheme words are already in graphemes.
        word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
        wordWidth = this._measureWord(word, lineIndex, offset);
        offset += word.length;
        lineWidth += infixWidth + wordWidth - additionalSpace;

        if (lineWidth > desiredWidth && !lineJustStarted) {
          graphemeLines.push(line);
          line = [];
          lineWidth = wordWidth;
          lineJustStarted = true;
        } else {
          lineWidth += additionalSpace;
        }

        if (!lineJustStarted && !splitByGrapheme) {
          line.push(infix);
        }

        line = line.concat(word);
        infixWidth = splitByGrapheme ? 0 : this._measureWord([infix], lineIndex, offset);
        offset++;
        lineJustStarted = false; // keep track of largest word

        if (wordWidth > largestWordWidth) {
          largestWordWidth = wordWidth;
        }
      }

      i && graphemeLines.push(line);

      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
      }

      return graphemeLines;
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */
    isEndOfWrapping: function isEndOfWrapping(lineIndex) {
      if (!this._styleMap[lineIndex + 1]) {
        // is last line, return true;
        return true;
      }

      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
        // this is last line before a line break, return true;
        return true;
      }

      return false;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * @return Number
     */
    missingNewlineOffset: function missingNewlineOffset(lineIndex) {
      if (this.splitByGrapheme) {
        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
      }

      return 1;
    },

    /**
    * Gets lines of text to render in the Textbox. This function calculates
    * text wrapping on the fly every time it is called.
    * @param {String} text text to split
    * @returns {Array} Array of lines in the Textbox.
    * @override
    */
    _splitTextIntoLines: function _splitTextIntoLines(text) {
      var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
          graphemeLines = this._wrapText(newText.lines, this.width),
          lines = new Array(graphemeLines.length);

      for (var i = 0; i < graphemeLines.length; i++) {
        lines[i] = graphemeLines[i].join('');
      }

      newText.lines = lines;
      newText.graphemeLines = graphemeLines;
      return newText;
    },
    getMinWidth: function getMinWidth() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    },
    _removeExtraneousStyles: function _removeExtraneousStyles() {
      var linesToKeep = {};

      for (var prop in this._styleMap) {
        if (this._textLines[prop]) {
          linesToKeep[this._styleMap[prop].line] = 1;
        }
      }

      for (var prop in this.styles) {
        if (!linesToKeep[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function toObject(propertiesToInclude) {
      return this.callSuper('toObject', ['minWidth', 'splitByGrapheme'].concat(propertiesToInclude));
    }
  });
  /**
   * Returns fabric.Textbox instance from an object representation
   * @static
   * @memberOf fabric.Textbox
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
   */

  fabric.Textbox.fromObject = function (object, callback) {
    return fabric.Object._fromObject('Textbox', object, callback, 'text');
  };
})(typeof exports !== 'undefined' ? exports : void 0);

(function () {
  var controlsUtils = fabric.controlsUtils,
      scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler,
      scaleStyleHandler = controlsUtils.scaleCursorStyleHandler,
      scalingEqually = controlsUtils.scalingEqually,
      scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX,
      scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY,
      scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName,
      objectControls = fabric.Object.prototype.controls;
  objectControls.ml = new fabric.Control({
    x: -0.5,
    y: 0,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingXOrSkewingY,
    getActionName: scaleOrSkewActionName
  });
  objectControls.mr = new fabric.Control({
    x: 0.5,
    y: 0,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingXOrSkewingY,
    getActionName: scaleOrSkewActionName
  });
  objectControls.mb = new fabric.Control({
    x: 0,
    y: 0.5,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingYOrSkewingX,
    getActionName: scaleOrSkewActionName
  });
  objectControls.mt = new fabric.Control({
    x: 0,
    y: -0.5,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingYOrSkewingX,
    getActionName: scaleOrSkewActionName
  });
  objectControls.tl = new fabric.Control({
    x: -0.5,
    y: -0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });
  objectControls.tr = new fabric.Control({
    x: 0.5,
    y: -0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });
  objectControls.bl = new fabric.Control({
    x: -0.5,
    y: 0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });
  objectControls.br = new fabric.Control({
    x: 0.5,
    y: 0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });
  objectControls.mtr = new fabric.Control({
    x: 0,
    y: -0.5,
    actionHandler: controlsUtils.rotationWithSnapping,
    cursorStyleHandler: controlsUtils.rotationStyleHandler,
    offsetY: -40,
    withConnection: true,
    actionName: 'rotate'
  });

  if (fabric.Textbox) {
    // this is breaking the prototype inheritance, no time / ideas to fix it.
    // is important to document that if you want to have all objects to have a
    // specific custom control, you have to add it to Object prototype and to Textbox
    // prototype. The controls are shared as references. So changes to control `tr`
    // can still apply to all objects if needed.
    var textBoxControls = fabric.Textbox.prototype.controls = {};
    textBoxControls.mtr = objectControls.mtr;
    textBoxControls.tr = objectControls.tr;
    textBoxControls.br = objectControls.br;
    textBoxControls.tl = objectControls.tl;
    textBoxControls.bl = objectControls.bl;
    textBoxControls.mt = objectControls.mt;
    textBoxControls.mb = objectControls.mb;
    textBoxControls.mr = new fabric.Control({
      x: 0.5,
      y: 0,
      actionHandler: controlsUtils.changeWidth,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionName: 'resizing'
    });
    textBoxControls.ml = new fabric.Control({
      x: -0.5,
      y: 0,
      actionHandler: controlsUtils.changeWidth,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionName: 'resizing'
    });
  }
})();

}).call(this,require("buffer").Buffer)
},{"buffer":4,"jsdom":3,"jsdom/lib/jsdom/living/generated/utils":3,"jsdom/lib/jsdom/utils":3}],9:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */
(function (window, factory) {
  // universal module definition

  /*jshint strict: false */

  /*globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['desandro-matches-selector/matches-selector'], function (matchesSelector) {
      return factory(window, matchesSelector);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('desandro-matches-selector'));
  } else {
    // browser global
    window.fizzyUIUtils = factory(window, window.matchesSelector);
  }
})(window, function factory(window, matchesSelector) {
  'use strict';

  var utils = {}; // ----- extend ----- //
  // extends objects

  utils.extend = function (a, b) {
    for (var prop in b) {
      a[prop] = b[prop];
    }

    return a;
  }; // ----- modulo ----- //


  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  }; // ----- makeArray ----- //


  var arraySlice = Array.prototype.slice; // turn element or nodeList into an array

  utils.makeArray = function (obj) {
    if (Array.isArray(obj)) {
      // use object if already an array
      return obj;
    } // return empty array if undefined or null. #6


    if (obj === null || obj === undefined) {
      return [];
    }

    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number';

    if (isArrayLike) {
      // convert nodeList to array
      return arraySlice.call(obj);
    } // array of single index


    return [obj];
  }; // ----- removeFrom ----- //


  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);

    if (index != -1) {
      ary.splice(index, 1);
    }
  }; // ----- getParent ----- //


  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;

      if (matchesSelector(elem, selector)) {
        return elem;
      }
    }
  }; // ----- getQueryElement ----- //
  // use element as selector string


  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }

    return elem;
  }; // ----- handleEvent ----- //
  // enable .ontype to trigger from .addEventListener( elem, 'type' )


  utils.handleEvent = function (event) {
    var method = 'on' + event.type;

    if (this[method]) {
      this[method](event);
    }
  }; // ----- filterFindElements ----- //


  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    var ffElems = [];
    elems.forEach(function (elem) {
      // check that elem is an actual element
      if (!(elem instanceof HTMLElement)) {
        return;
      } // add elem if no selector


      if (!selector) {
        ffElems.push(elem);
        return;
      } // filter & find items if we have a selector
      // filter


      if (matchesSelector(elem, selector)) {
        ffElems.push(elem);
      } // find children


      var childElems = elem.querySelectorAll(selector); // concat childElems to filterFound array

      for (var i = 0; i < childElems.length; i++) {
        ffElems.push(childElems[i]);
      }
    });
    return ffElems;
  }; // ----- debounceMethod ----- //


  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100; // original method

    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';

    _class.prototype[methodName] = function () {
      var timeout = this[timeoutName];
      clearTimeout(timeout);
      var args = arguments;

      var _this = this;

      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  }; // ----- docReady ----- //


  utils.docReady = function (callback) {
    var readyState = document.readyState;

    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(callback);
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }; // ----- htmlInit ----- //
  // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/


  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };

  var console = window.console;
  /**
   * allow user to initialize classes via [data-namespace] or .js-namespace class
   * htmlInit( Widget, 'widgetName' )
   * options are parsed from data-namespace-options
   */

  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
      var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
      var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
      var dataOptionsAttr = dataAttr + '-options';
      var jQuery = window.jQuery;
      elems.forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
        var options;

        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
          }

          return;
        } // initialize


        var instance = new WidgetClass(elem, options); // make available via $().data('namespace')

        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  }; // -----  ----- //


  return utils;
});

},{"desandro-matches-selector":5}],10:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* flatpickr v4.5.7, @license MIT */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.flatpickr = factory());
})(void 0, function () {
  'use strict';
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign.apply(this, arguments);
  };

  var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
  var defaults = {
    _disable: [],
    _enable: [],
    allowInput: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enable: [],
    enableSeconds: false,
    enableTime: false,
    errorHandler: function errorHandler(err) {
      return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function getWeek(givenDate) {
      var date = new Date(givenDate.getTime());
      date.setHours(0, 0, 0, 0); // Thursday in current week decides the year.

      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7); // January 4 is always in week 1.

      var week1 = new Date(date.getFullYear(), 0, 4); // Adjust to Thursday in week 1 and count number of weeks from date to week1.

      return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
  };
  var english = {
    weekdays: {
      shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    },
    months: {
      shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function ordinal(nth) {
      var s = nth % 100;
      if (s > 3 && s < 21) return "th";

      switch (s % 10) {
        case 1:
          return "st";

        case 2:
          return "nd";

        case 3:
          return "rd";

        default:
          return "th";
      }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year"
  };

  var pad = function pad(number) {
    return ("0" + number).slice(-2);
  };

  var int = function int(bool) {
    return bool === true ? 1 : 0;
  };
  /* istanbul ignore next */


  function debounce(func, wait, immediate) {
    if (immediate === void 0) {
      immediate = false;
    }

    var timeout;
    return function () {
      var context = this,
          args = arguments;
      timeout !== null && clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }

  var arrayify = function arrayify(obj) {
    return obj instanceof Array ? obj : [obj];
  };

  function toggleClass(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
  }

  function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
  }

  function clearNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function findParent(node, condition) {
    if (condition(node)) return node;else if (node.parentNode) return findParent(node.parentNode, condition);
    return undefined; // nothing found
  }

  function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"),
        numInput = createElement("input", "numInput " + inputClassName),
        arrowUp = createElement("span", "arrowUp"),
        arrowDown = createElement("span", "arrowDown");

    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
      numInput.type = "number";
    } else {
      numInput.type = "text";
      numInput.pattern = "\\d*";
    }

    if (opts !== undefined) for (var key in opts) {
      numInput.setAttribute(key, opts[key]);
    }
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
  }

  function getEventTarget(event) {
    if (typeof event.composedPath === "function") {
      var path = event.composedPath();
      return path[0];
    }

    return event.target;
  }

  var do_nothing = function do_nothing() {
    return undefined;
  };

  var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
  };

  var revFormat = {
    D: do_nothing,
    F: function F(dateObj, monthName, locale) {
      dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function G(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    H: function H(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    J: function J(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    K: function K(dateObj, amPM, locale) {
      dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function M(dateObj, shortMonth, locale) {
      dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function S(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    U: function U(_, unixSeconds) {
      return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function W(dateObj, weekNum) {
      var weekNumber = parseInt(weekNum);
      return new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    },
    Y: function Y(dateObj, year) {
      dateObj.setFullYear(parseFloat(year));
    },
    Z: function Z(_, ISODate) {
      return new Date(ISODate);
    },
    d: function d(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    h: function h(dateObj, hour) {
      dateObj.setHours(parseFloat(hour));
    },
    i: function i(dateObj, minutes) {
      dateObj.setMinutes(parseFloat(minutes));
    },
    j: function j(dateObj, day) {
      dateObj.setDate(parseFloat(day));
    },
    l: do_nothing,
    m: function m(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function n(dateObj, month) {
      dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function s(dateObj, seconds) {
      dateObj.setSeconds(parseFloat(seconds));
    },
    u: function u(_, unixMillSeconds) {
      return new Date(parseFloat(unixMillSeconds));
    },
    w: do_nothing,
    y: function y(dateObj, year) {
      dateObj.setFullYear(2000 + parseFloat(year));
    }
  };
  var tokenRegex = {
    D: "(\\w+)",
    F: "(\\w+)",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "(\\w+)",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "(\\w+)",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
  };
  var formats = {
    // get the date in UTC
    Z: function Z(date) {
      return date.toISOString();
    },
    // weekday name, short, e.g. Thu
    D: function D(date, locale, options) {
      return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    // full month name e.g. January
    F: function F(date, locale, options) {
      return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    // padded hour 1-12
    G: function G(date, locale, options) {
      return pad(formats.h(date, locale, options));
    },
    // hours with leading zero e.g. 03
    H: function H(date) {
      return pad(date.getHours());
    },
    // day (1-30) with ordinal suffix e.g. 1st, 2nd
    J: function J(date, locale) {
      return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    // AM/PM
    K: function K(date, locale) {
      return locale.amPM[int(date.getHours() > 11)];
    },
    // shorthand month e.g. Jan, Sep, Oct, etc
    M: function M(date, locale) {
      return monthToStr(date.getMonth(), true, locale);
    },
    // seconds 00-59
    S: function S(date) {
      return pad(date.getSeconds());
    },
    // unix timestamp
    U: function U(date) {
      return date.getTime() / 1000;
    },
    W: function W(date, _, options) {
      return options.getWeek(date);
    },
    // full year e.g. 2016
    Y: function Y(date) {
      return date.getFullYear();
    },
    // day in month, padded (01-30)
    d: function d(date) {
      return pad(date.getDate());
    },
    // hour from 1-12 (am/pm)
    h: function h(date) {
      return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    // minutes, padded with leading zero e.g. 09
    i: function i(date) {
      return pad(date.getMinutes());
    },
    // day in month (1-30)
    j: function j(date) {
      return date.getDate();
    },
    // weekday name, full, e.g. Thursday
    l: function l(date, locale) {
      return locale.weekdays.longhand[date.getDay()];
    },
    // padded month number (01-12)
    m: function m(date) {
      return pad(date.getMonth() + 1);
    },
    // the month number (1-12)
    n: function n(date) {
      return date.getMonth() + 1;
    },
    // seconds 0-59
    s: function s(date) {
      return date.getSeconds();
    },
    // Unix Milliseconds
    u: function u(date) {
      return date.getTime();
    },
    // number of the day of the week
    w: function w(date) {
      return date.getDay();
    },
    // last two digits of year e.g. 16 for 2016
    y: function y(date) {
      return String(date.getFullYear()).substring(2);
    }
  };

  var createDateFormatter = function createDateFormatter(_a) {
    var _b = _a.config,
        config = _b === void 0 ? defaults : _b,
        _c = _a.l10n,
        l10n = _c === void 0 ? english : _c;
    return function (dateObj, frmt, overrideLocale) {
      var locale = overrideLocale || l10n;

      if (config.formatDate !== undefined) {
        return config.formatDate(dateObj, frmt, locale);
      }

      return frmt.split("").map(function (c, i, arr) {
        return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
      }).join("");
    };
  };

  var createDateParser = function createDateParser(_a) {
    var _b = _a.config,
        config = _b === void 0 ? defaults : _b,
        _c = _a.l10n,
        l10n = _c === void 0 ? english : _c;
    return function (date, givenFormat, timeless, customLocale) {
      if (date !== 0 && !date) return undefined;
      var locale = customLocale || l10n;
      var parsedDate;
      var date_orig = date;
      if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== undefined // timestamp
      ) // create a copy
        parsedDate = new Date(date);else if (typeof date === "string") {
        // date string
        var format = givenFormat || (config || defaults).dateFormat;
        var datestr = String(date).trim();

        if (datestr === "today") {
          parsedDate = new Date();
          timeless = true;
        } else if (/Z$/.test(datestr) || /GMT$/.test(datestr) // datestrings w/ timezone
        ) parsedDate = new Date(date);else if (config && config.parseDate) parsedDate = config.parseDate(date, format);else {
          parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
          var matched = void 0,
              ops = [];

          for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
            var token_1 = format[i];
            var isBackSlash = token_1 === "\\";
            var escaped = format[i - 1] === "\\" || isBackSlash;

            if (tokenRegex[token_1] && !escaped) {
              regexStr += tokenRegex[token_1];
              var match = new RegExp(regexStr).exec(date);

              if (match && (matched = true)) {
                ops[token_1 !== "Y" ? "push" : "unshift"]({
                  fn: revFormat[token_1],
                  val: match[++matchIndex]
                });
              }
            } else if (!isBackSlash) regexStr += "."; // don't really care


            ops.forEach(function (_a) {
              var fn = _a.fn,
                  val = _a.val;
              return parsedDate = fn(parsedDate, val, locale) || parsedDate;
            });
          }

          parsedDate = matched ? parsedDate : undefined;
        }
      }
      /* istanbul ignore next */

      if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
        config.errorHandler(new Error("Invalid date provided: " + date_orig));
        return undefined;
      }

      if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    };
  };
  /**
   * Compute the difference in dates, measured in ms
   */


  function compareDates(date1, date2, timeless) {
    if (timeless === void 0) {
      timeless = true;
    }

    if (timeless !== false) {
      return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    }

    return date1.getTime() - date2.getTime();
  }

  var isBetween = function isBetween(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
  };

  var duration = {
    DAY: 86400000
  };

  if (typeof Object.assign !== "function") {
    Object.assign = function (target) {
      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }

      if (!target) {
        throw TypeError("Cannot convert undefined or null to object");
      }

      var _loop_1 = function _loop_1(source) {
        if (source) {
          Object.keys(source).forEach(function (key) {
            return target[key] = source[key];
          });
        }
      };

      for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var source = args_1[_a];

        _loop_1(source);
      }

      return target;
    };
  }

  var DEBOUNCED_CHANGE_MS = 300;

  function FlatpickrInstance(element, instanceConfig) {
    var self = {
      config: _assign({}, flatpickr.defaultConfig),
      l10n: english
    };
    self.parseDate = createDateParser({
      config: self.config,
      l10n: self.l10n
    });
    self._handlers = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self._createElement = createElement;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;

    function setupHelperFunctions() {
      self.utils = {
        getDaysInMonth: function getDaysInMonth(month, yr) {
          if (month === void 0) {
            month = self.currentMonth;
          }

          if (yr === void 0) {
            yr = self.currentYear;
          }

          if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
          return self.l10n.daysInMonth[month];
        }
      };
    }

    function init() {
      self.element = self.input = element;
      self.isOpen = false;
      parseConfig();
      setupLocale();
      setupInputs();
      setupDates();
      setupHelperFunctions();
      if (!self.isMobile) build();
      bindEvents();

      if (self.selectedDates.length || self.config.noCalendar) {
        if (self.config.enableTime) {
          setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj || self.config.minDate : undefined);
        }

        updateValue(false);
      }

      setCalendarWidth();
      self.showTimeInput = self.selectedDates.length > 0 || self.config.noCalendar;
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      /* TODO: investigate this further
                 Currently, there is weird positioning behavior in safari causing pages
        to scroll up. https://github.com/chmln/flatpickr/issues/563
                 However, most browsers are not Safari and positioning is expensive when used
        in scale. https://github.com/chmln/flatpickr/issues/1096
      */

      if (!self.isMobile && isSafari) {
        positionCalendar();
      }

      triggerEvent("onReady");
    }

    function bindToInstance(fn) {
      return fn.bind(self);
    }

    function setCalendarWidth() {
      var config = self.config;
      if (config.weekNumbers === false && config.showMonths === 1) return;else if (config.noCalendar !== true) {
        window.requestAnimationFrame(function () {
          if (self.calendarContainer !== undefined) {
            self.calendarContainer.style.visibility = "hidden";
            self.calendarContainer.style.display = "block";
          }

          if (self.daysContainer !== undefined) {
            var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
            self.daysContainer.style.width = daysWidth + "px";
            self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
            self.calendarContainer.style.removeProperty("visibility");
            self.calendarContainer.style.removeProperty("display");
          }
        });
      }
    }
    /**
     * The handler for all events targeting the time inputs
     */


    function updateTime(e) {
      if (self.selectedDates.length === 0) {
        setDefaultTime();
      }

      if (e !== undefined && e.type !== "blur") {
        timeWrapper(e);
      }

      var prevValue = self._input.value;
      setHoursFromInputs();
      updateValue();

      if (self._input.value !== prevValue) {
        self._debouncedChange();
      }
    }

    function ampm2military(hour, amPM) {
      return hour % 12 + 12 * int(amPM === self.l10n.amPM[1]);
    }

    function military2ampm(hour) {
      switch (hour % 24) {
        case 0:
        case 12:
          return 12;

        default:
          return hour % 12;
      }
    }
    /**
     * Syncs the selected date object time with user's time input
     */


    function setHoursFromInputs() {
      if (self.hourElement === undefined || self.minuteElement === undefined) return;
      var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
          minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
          seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;

      if (self.amPM !== undefined) {
        hours = ampm2military(hours, self.amPM.textContent);
      }

      var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
      var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;

      if (limitMaxHours) {
        var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
        hours = Math.min(hours, maxTime.getHours());
        if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
        if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
      }

      if (limitMinHours) {
        var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
        hours = Math.max(hours, minTime.getHours());
        if (hours === minTime.getHours()) minutes = Math.max(minutes, minTime.getMinutes());
        if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
      }

      setHours(hours, minutes, seconds);
    }
    /**
     * Syncs time input values with a date
     */


    function setHoursFromDate(dateObj) {
      var date = dateObj || self.latestSelectedDateObj;
      if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }

    function setDefaultHours() {
      var hours = self.config.defaultHour;
      var minutes = self.config.defaultMinute;
      var seconds = self.config.defaultSeconds;

      if (self.config.minDate !== undefined) {
        var min_hr = self.config.minDate.getHours();
        var min_minutes = self.config.minDate.getMinutes();
        hours = Math.max(hours, min_hr);
        if (hours === min_hr) minutes = Math.max(min_minutes, minutes);
        if (hours === min_hr && minutes === min_minutes) seconds = self.config.minDate.getSeconds();
      }

      if (self.config.maxDate !== undefined) {
        var max_hr = self.config.maxDate.getHours();
        var max_minutes = self.config.maxDate.getMinutes();
        hours = Math.min(hours, max_hr);
        if (hours === max_hr) minutes = Math.min(max_minutes, minutes);
        if (hours === max_hr && minutes === max_minutes) seconds = self.config.maxDate.getSeconds();
      }

      setHours(hours, minutes, seconds);
    }
    /**
     * Sets the hours, minutes, and optionally seconds
     * of the latest selected date object and the
     * corresponding time inputs
     * @param {Number} hours the hour. whether its military
     *                 or am-pm gets inferred from config
     * @param {Number} minutes the minutes
     * @param {Number} seconds the seconds (optional)
     */


    function setHours(hours, minutes, seconds) {
      if (self.latestSelectedDateObj !== undefined) {
        self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
      }

      if (!self.hourElement || !self.minuteElement || self.isMobile) return;
      self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
      self.minuteElement.value = pad(minutes);
      if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
      if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
    }
    /**
     * Handles the year input and incrementing events
     * @param {Event} event the keyup or increment event
     */


    function onYearInput(event) {
      var year = parseInt(event.target.value) + (event.delta || 0);

      if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
        changeYear(year);
      }
    }
    /**
     * Essentially addEventListener + tracking
     * @param {Element} element the element to addEventListener to
     * @param {String} event the event name
     * @param {Function} handler the event handler
     */


    function bind(element, event, handler, options) {
      if (event instanceof Array) return event.forEach(function (ev) {
        return bind(element, ev, handler, options);
      });
      if (element instanceof Array) return element.forEach(function (el) {
        return bind(el, event, handler, options);
      });
      element.addEventListener(event, handler, options);

      self._handlers.push({
        element: element,
        event: event,
        handler: handler,
        options: options
      });
    }
    /**
     * A mousedown handler which mimics click.
     * Minimizes latency, since we don't need to wait for mouseup in most cases.
     * Also, avoids handling right clicks.
     *
     * @param {Function} handler the event handler
     */


    function onClick(handler) {
      return function (evt) {
        evt.which === 1 && handler(evt);
      };
    }

    function triggerChange() {
      triggerEvent("onChange");
    }
    /**
     * Adds all the necessary event listeners
     */


    function bindEvents() {
      if (self.config.wrap) {
        ["open", "close", "toggle", "clear"].forEach(function (evt) {
          Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
            return bind(el, "click", self[evt]);
          });
        });
      }

      if (self.isMobile) {
        setupMobile();
        return;
      }

      var debouncedResize = debounce(onResize, 50);
      self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
      if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function (e) {
        if (self.config.mode === "range") onMouseOver(e.target);
      });
      bind(window.document.body, "keydown", onKeyDown);
      if (!self.config.static) bind(self._input, "keydown", onKeyDown);
      if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
      if (window.ontouchstart !== undefined) bind(window.document, "click", documentClick);else bind(window.document, "mousedown", onClick(documentClick));
      bind(window.document, "focus", documentClick, {
        capture: true
      });

      if (self.config.clickOpens === true) {
        bind(self._input, "focus", self.open);
        bind(self._input, "mousedown", onClick(self.open));
      }

      if (self.daysContainer !== undefined) {
        bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
        bind(self.monthNav, ["keyup", "increment"], onYearInput);
        bind(self.daysContainer, "mousedown", onClick(selectDate));
      }

      if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
        var selText = function selText(e) {
          return e.target.select();
        };

        bind(self.timeContainer, ["increment"], updateTime);
        bind(self.timeContainer, "blur", updateTime, {
          capture: true
        });
        bind(self.timeContainer, "mousedown", onClick(timeIncrement));
        bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
        if (self.secondElement !== undefined) bind(self.secondElement, "focus", function () {
          return self.secondElement && self.secondElement.select();
        });

        if (self.amPM !== undefined) {
          bind(self.amPM, "mousedown", onClick(function (e) {
            updateTime(e);
            triggerChange();
          }));
        }
      }
    }
    /**
     * Set the calendar view to a particular date.
     * @param {Date} jumpDate the date to set the view to
     */


    function jumpToDate(jumpDate) {
      var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);

      try {
        if (jumpTo !== undefined) {
          self.currentYear = jumpTo.getFullYear();
          self.currentMonth = jumpTo.getMonth();
        }
      } catch (e) {
        /* istanbul ignore next */
        e.message = "Invalid date supplied: " + jumpTo;
        self.config.errorHandler(e);
      }

      self.redraw();
    }
    /**
     * The up/down arrow handler for time inputs
     * @param {Event} e the click event
     */


    function timeIncrement(e) {
      if (~e.target.className.indexOf("arrow")) incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
    }
    /**
     * Increments/decrements the value of input associ-
     * ated with the up/down arrow by dispatching an
     * "increment" event on the input.
     *
     * @param {Event} e the click event
     * @param {Number} delta the diff (usually 1 or -1)
     * @param {Element} inputElem the input element
     */


    function incrementNumInput(e, delta, inputElem) {
      var target = e && e.target;
      var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
      var event = createEvent("increment");
      event.delta = delta;
      input && input.dispatchEvent(event);
    }

    function build() {
      var fragment = window.document.createDocumentFragment();
      self.calendarContainer = createElement("div", "flatpickr-calendar");
      self.calendarContainer.tabIndex = -1;

      if (!self.config.noCalendar) {
        fragment.appendChild(buildMonthNav());
        self.innerContainer = createElement("div", "flatpickr-innerContainer");

        if (self.config.weekNumbers) {
          var _a = buildWeeks(),
              weekWrapper = _a.weekWrapper,
              weekNumbers = _a.weekNumbers;

          self.innerContainer.appendChild(weekWrapper);
          self.weekNumbers = weekNumbers;
          self.weekWrapper = weekWrapper;
        }

        self.rContainer = createElement("div", "flatpickr-rContainer");
        self.rContainer.appendChild(buildWeekdays());

        if (!self.daysContainer) {
          self.daysContainer = createElement("div", "flatpickr-days");
          self.daysContainer.tabIndex = -1;
        }

        buildDays();
        self.rContainer.appendChild(self.daysContainer);
        self.innerContainer.appendChild(self.rContainer);
        fragment.appendChild(self.innerContainer);
      }

      if (self.config.enableTime) {
        fragment.appendChild(buildTime());
      }

      toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
      toggleClass(self.calendarContainer, "animate", self.config.animate === true);
      toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
      self.calendarContainer.appendChild(fragment);
      var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;

      if (self.config.inline || self.config.static) {
        self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");

        if (self.config.inline) {
          if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
        }

        if (self.config.static) {
          var wrapper = createElement("div", "flatpickr-wrapper");
          if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
          wrapper.appendChild(self.element);
          if (self.altInput) wrapper.appendChild(self.altInput);
          wrapper.appendChild(self.calendarContainer);
        }
      }

      if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }

    function createDay(className, date, dayNumber, i) {
      var dateIsEnabled = isEnabled(date, true),
          dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
      dayElement.dateObj = date;
      dayElement.$i = i;
      dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));

      if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
        self.todayDateElem = dayElement;
        dayElement.classList.add("today");
        dayElement.setAttribute("aria-current", "date");
      }

      if (dateIsEnabled) {
        dayElement.tabIndex = -1;

        if (isDateSelected(date)) {
          dayElement.classList.add("selected");
          self.selectedDateElem = dayElement;

          if (self.config.mode === "range") {
            toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
            toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
            if (className === "nextMonthDay") dayElement.classList.add("inRange");
          }
        }
      } else {
        dayElement.classList.add("disabled");
      }

      if (self.config.mode === "range") {
        if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
      }

      if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) {
        self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
      }

      triggerEvent("onDayCreate", dayElement);
      return dayElement;
    }

    function focusOnDayElem(targetNode) {
      targetNode.focus();
      if (self.config.mode === "range") onMouseOver(targetNode);
    }

    function getFirstAvailableDay(delta) {
      var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
      var endMonth = delta > 0 ? self.config.showMonths : -1;

      for (var m = startMonth; m != endMonth; m += delta) {
        var month = self.daysContainer.children[m];
        var startIndex = delta > 0 ? 0 : month.children.length - 1;
        var endIndex = delta > 0 ? month.children.length : -1;

        for (var i = startIndex; i != endIndex; i += delta) {
          var c = month.children[i];
          if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
        }
      }

      return undefined;
    }

    function getNextAvailableDay(current, delta) {
      var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
      var endMonth = delta > 0 ? self.config.showMonths : -1;
      var loopDelta = delta > 0 ? 1 : -1;

      for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
        var month = self.daysContainer.children[m];
        var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
        var numMonthDays = month.children.length;

        for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
          var c = month.children[i];
          if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
        }
      }

      self.changeMonth(loopDelta);
      focusOnDay(getFirstAvailableDay(loopDelta), 0);
      return undefined;
    }

    function focusOnDay(current, offset) {
      var dayFocused = isInView(document.activeElement || document.body);
      var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
      if (startElem === undefined) return self._input.focus();
      if (!dayFocused) return focusOnDayElem(startElem);
      getNextAvailableDay(startElem, offset);
    }

    function buildMonthDays(year, month) {
      var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
      var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
      var daysInMonth = self.utils.getDaysInMonth(month),
          days = window.document.createDocumentFragment(),
          isMultiMonth = self.config.showMonths > 1,
          prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
          nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
      var dayNumber = prevMonthDays + 1 - firstOfMonth,
          dayIndex = 0; // prepend days from the ending of previous month

      for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
        days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
      } // Start at 1 since there is no 0th day


      for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
        days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
      } // append days from the next month


      for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
        days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
      } //updateNavigationCurrentMonth();


      var dayContainer = createElement("div", "dayContainer");
      dayContainer.appendChild(days);
      return dayContainer;
    }

    function buildDays() {
      if (self.daysContainer === undefined) {
        return;
      }

      clearNode(self.daysContainer); // TODO: week numbers for each month

      if (self.weekNumbers) clearNode(self.weekNumbers);
      var frag = document.createDocumentFragment();

      for (var i = 0; i < self.config.showMonths; i++) {
        var d = new Date(self.currentYear, self.currentMonth, 1);
        d.setMonth(self.currentMonth + i);
        frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
      }

      self.daysContainer.appendChild(frag);
      self.days = self.daysContainer.firstChild;

      if (self.config.mode === "range" && self.selectedDates.length === 1) {
        onMouseOver();
      }
    }

    function buildMonth() {
      var container = createElement("div", "flatpickr-month");
      var monthNavFragment = window.document.createDocumentFragment();
      var monthElement = createElement("span", "cur-month");
      var yearInput = createNumberInput("cur-year", {
        tabindex: "-1"
      });
      var yearElement = yearInput.getElementsByTagName("input")[0];
      yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);

      if (self.config.minDate) {
        yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
      }

      if (self.config.maxDate) {
        yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
        yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
      }

      var currentMonth = createElement("div", "flatpickr-current-month");
      currentMonth.appendChild(monthElement);
      currentMonth.appendChild(yearInput);
      monthNavFragment.appendChild(currentMonth);
      container.appendChild(monthNavFragment);
      return {
        container: container,
        yearElement: yearElement,
        monthElement: monthElement
      };
    }

    function buildMonths() {
      clearNode(self.monthNav);
      self.monthNav.appendChild(self.prevMonthNav);

      if (self.config.showMonths) {
        self.yearElements = [];
        self.monthElements = [];
      }

      for (var m = self.config.showMonths; m--;) {
        var month = buildMonth();
        self.yearElements.push(month.yearElement);
        self.monthElements.push(month.monthElement);
        self.monthNav.appendChild(month.container);
      }

      self.monthNav.appendChild(self.nextMonthNav);
    }

    function buildMonthNav() {
      self.monthNav = createElement("div", "flatpickr-months");
      self.yearElements = [];
      self.monthElements = [];
      self.prevMonthNav = createElement("span", "flatpickr-prev-month");
      self.prevMonthNav.innerHTML = self.config.prevArrow;
      self.nextMonthNav = createElement("span", "flatpickr-next-month");
      self.nextMonthNav.innerHTML = self.config.nextArrow;
      buildMonths();
      Object.defineProperty(self, "_hidePrevMonthArrow", {
        get: function get() {
          return self.__hidePrevMonthArrow;
        },
        set: function set(bool) {
          if (self.__hidePrevMonthArrow !== bool) {
            toggleClass(self.prevMonthNav, "disabled", bool);
            self.__hidePrevMonthArrow = bool;
          }
        }
      });
      Object.defineProperty(self, "_hideNextMonthArrow", {
        get: function get() {
          return self.__hideNextMonthArrow;
        },
        set: function set(bool) {
          if (self.__hideNextMonthArrow !== bool) {
            toggleClass(self.nextMonthNav, "disabled", bool);
            self.__hideNextMonthArrow = bool;
          }
        }
      });
      self.currentYearElement = self.yearElements[0];
      updateNavigationCurrentMonth();
      return self.monthNav;
    }

    function buildTime() {
      self.calendarContainer.classList.add("hasTime");
      if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
      self.timeContainer = createElement("div", "flatpickr-time");
      self.timeContainer.tabIndex = -1;
      var separator = createElement("span", "flatpickr-time-separator", ":");
      var hourInput = createNumberInput("flatpickr-hour");
      self.hourElement = hourInput.getElementsByTagName("input")[0];
      var minuteInput = createNumberInput("flatpickr-minute");
      self.minuteElement = minuteInput.getElementsByTagName("input")[0];
      self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
      self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? self.config.defaultHour : military2ampm(self.config.defaultHour));
      self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
      self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
      self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
      self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
      self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
      self.minuteElement.setAttribute("min", "0");
      self.minuteElement.setAttribute("max", "59");
      self.timeContainer.appendChild(hourInput);
      self.timeContainer.appendChild(separator);
      self.timeContainer.appendChild(minuteInput);
      if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");

      if (self.config.enableSeconds) {
        self.timeContainer.classList.add("hasSeconds");
        var secondInput = createNumberInput("flatpickr-second");
        self.secondElement = secondInput.getElementsByTagName("input")[0];
        self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : self.config.defaultSeconds);
        self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
        self.secondElement.setAttribute("min", "0");
        self.secondElement.setAttribute("max", "59");
        self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
        self.timeContainer.appendChild(secondInput);
      }

      if (!self.config.time_24hr) {
        // add self.amPM if appropriate
        self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
        self.amPM.title = self.l10n.toggleTitle;
        self.amPM.tabIndex = -1;
        self.timeContainer.appendChild(self.amPM);
      }

      return self.timeContainer;
    }

    function buildWeekdays() {
      if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");else clearNode(self.weekdayContainer);

      for (var i = self.config.showMonths; i--;) {
        var container = createElement("div", "flatpickr-weekdaycontainer");
        self.weekdayContainer.appendChild(container);
      }

      updateWeekdays();
      return self.weekdayContainer;
    }

    function updateWeekdays() {
      var firstDayOfWeek = self.l10n.firstDayOfWeek;
      var weekdays = self.l10n.weekdays.shorthand.slice();

      if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
        weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
      }

      for (var i = self.config.showMonths; i--;) {
        self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
      }
    }
    /* istanbul ignore next */


    function buildWeeks() {
      self.calendarContainer.classList.add("hasWeeks");
      var weekWrapper = createElement("div", "flatpickr-weekwrapper");
      weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
      var weekNumbers = createElement("div", "flatpickr-weeks");
      weekWrapper.appendChild(weekNumbers);
      return {
        weekWrapper: weekWrapper,
        weekNumbers: weekNumbers
      };
    }

    function changeMonth(value, is_offset) {
      if (is_offset === void 0) {
        is_offset = true;
      }

      var delta = is_offset ? value : value - self.currentMonth;
      if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
      self.currentMonth += delta;

      if (self.currentMonth < 0 || self.currentMonth > 11) {
        self.currentYear += self.currentMonth > 11 ? 1 : -1;
        self.currentMonth = (self.currentMonth + 12) % 12;
        triggerEvent("onYearChange");
      }

      buildDays();
      triggerEvent("onMonthChange");
      updateNavigationCurrentMonth();
    }

    function clear(triggerChangeEvent, toInitial) {
      if (triggerChangeEvent === void 0) {
        triggerChangeEvent = true;
      }

      if (toInitial === void 0) {
        toInitial = true;
      }

      self.input.value = "";
      if (self.altInput !== undefined) self.altInput.value = "";
      if (self.mobileInput !== undefined) self.mobileInput.value = "";
      self.selectedDates = [];
      self.latestSelectedDateObj = undefined;

      if (toInitial === true) {
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
      }

      self.showTimeInput = false;

      if (self.config.enableTime === true) {
        setDefaultHours();
      }

      self.redraw();
      if (triggerChangeEvent) // triggerChangeEvent is true (default) or an Event
        triggerEvent("onChange");
    }

    function close() {
      self.isOpen = false;

      if (!self.isMobile) {
        if (self.calendarContainer !== undefined) {
          self.calendarContainer.classList.remove("open");
        }

        if (self._input !== undefined) {
          self._input.classList.remove("active");
        }
      }

      triggerEvent("onClose");
    }

    function destroy() {
      if (self.config !== undefined) triggerEvent("onDestroy");

      for (var i = self._handlers.length; i--;) {
        var h = self._handlers[i];
        h.element.removeEventListener(h.event, h.handler, h.options);
      }

      self._handlers = [];

      if (self.mobileInput) {
        if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
        self.mobileInput = undefined;
      } else if (self.calendarContainer && self.calendarContainer.parentNode) {
        if (self.config.static && self.calendarContainer.parentNode) {
          var wrapper = self.calendarContainer.parentNode;
          wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);

          if (wrapper.parentNode) {
            while (wrapper.firstChild) {
              wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
            }

            wrapper.parentNode.removeChild(wrapper);
          }
        } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
      }

      if (self.altInput) {
        self.input.type = "text";
        if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
        delete self.altInput;
      }

      if (self.input) {
        self.input.type = self.input._type;
        self.input.classList.remove("flatpickr-input");
        self.input.removeAttribute("readonly");
        self.input.value = "";
      }

      ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
        try {
          delete self[k];
        } catch (_) {}
      });
    }

    function isCalendarElem(elem) {
      if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
      return self.calendarContainer.contains(elem);
    }

    function documentClick(e) {
      if (self.isOpen && !self.config.inline) {
        var eventTarget_1 = getEventTarget(e);
        var isCalendarElement = isCalendarElem(eventTarget_1);
        var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || // web components
        // e.path is not present in all browsers. circumventing typechecks
        e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
        var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
        var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
          return elem.contains(eventTarget_1);
        });

        if (lostFocus && isIgnored) {
          self.close();

          if (self.config.mode === "range" && self.selectedDates.length === 1) {
            self.clear(false);
            self.redraw();
          }
        }
      }
    }

    function changeYear(newYear) {
      if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
      var newYearNum = newYear,
          isNewYear = self.currentYear !== newYearNum;
      self.currentYear = newYearNum || self.currentYear;

      if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
        self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
      } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
        self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
      }

      if (isNewYear) {
        self.redraw();
        triggerEvent("onYearChange");
      }
    }

    function isEnabled(date, timeless) {
      if (timeless === void 0) {
        timeless = true;
      }

      var dateToCheck = self.parseDate(date, undefined, timeless); // timeless

      if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
      if (self.config.enable.length === 0 && self.config.disable.length === 0) return true;
      if (dateToCheck === undefined) return false;
      var bool = self.config.enable.length > 0,
          array = bool ? self.config.enable : self.config.disable;

      for (var i = 0, d = void 0; i < array.length; i++) {
        d = array[i];
        if (typeof d === "function" && d(dateToCheck) // disabled by function
        ) return bool;else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) // disabled by date
          return bool;else if (typeof d === "string" && dateToCheck !== undefined) {
          // disabled by date string
          var parsed = self.parseDate(d, undefined, true);
          return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
        } else if ( // disabled by range
        _typeof(d) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
      }

      return !bool;
    }

    function isInView(elem) {
      if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && self.daysContainer.contains(elem);
      return false;
    }

    function onKeyDown(e) {
      // e.key                      e.keyCode
      // "Backspace"                        8
      // "Tab"                              9
      // "Enter"                           13
      // "Escape"     (IE "Esc")           27
      // "ArrowLeft"  (IE "Left")          37
      // "ArrowUp"    (IE "Up")            38
      // "ArrowRight" (IE "Right")         39
      // "ArrowDown"  (IE "Down")          40
      // "Delete"     (IE "Del")           46
      var isInput = e.target === self._input;
      var allowInput = self.config.allowInput;
      var allowKeydown = self.isOpen && (!allowInput || !isInput);
      var allowInlineKeydown = self.config.inline && isInput && !allowInput;

      if (e.keyCode === 13 && isInput) {
        if (allowInput) {
          self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
          return e.target.blur();
        } else self.open();
      } else if (isCalendarElem(e.target) || allowKeydown || allowInlineKeydown) {
        var isTimeObj = !!self.timeContainer && self.timeContainer.contains(e.target);

        switch (e.keyCode) {
          case 13:
            if (isTimeObj) {
              updateTime();
              focusAndClose();
            } else selectDate(e);

            break;

          case 27:
            // escape
            e.preventDefault();
            focusAndClose();
            break;

          case 8:
          case 46:
            if (isInput && !self.config.allowInput) {
              e.preventDefault();
              self.clear();
            }

            break;

          case 37:
          case 39:
            if (!isTimeObj) {
              e.preventDefault();

              if (self.daysContainer !== undefined && (allowInput === false || document.activeElement && isInView(document.activeElement))) {
                var delta_1 = e.keyCode === 39 ? 1 : -1;
                if (!e.ctrlKey) focusOnDay(undefined, delta_1);else {
                  e.stopPropagation();
                  changeMonth(delta_1);
                  focusOnDay(getFirstAvailableDay(1), 0);
                }
              }
            } else if (self.hourElement) self.hourElement.focus();

            break;

          case 38:
          case 40:
            e.preventDefault();
            var delta = e.keyCode === 40 ? 1 : -1;

            if (self.daysContainer && e.target.$i !== undefined || e.target === self.input) {
              if (e.ctrlKey) {
                e.stopPropagation();
                changeYear(self.currentYear - delta);
                focusOnDay(getFirstAvailableDay(1), 0);
              } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
            } else if (self.config.enableTime) {
              if (!isTimeObj && self.hourElement) self.hourElement.focus();
              updateTime(e);

              self._debouncedChange();
            }

            break;

          case 9:
            if (isTimeObj) {
              var elems = [self.hourElement, self.minuteElement, self.secondElement, self.amPM].filter(function (x) {
                return x;
              });
              var i = elems.indexOf(e.target);

              if (i !== -1) {
                var target = elems[i + (e.shiftKey ? -1 : 1)];

                if (target !== undefined) {
                  e.preventDefault();
                  target.focus();
                } else if (e.shiftKey) {
                  e.preventDefault();

                  self._input.focus();
                }
              }
            }

            break;

          default:
            break;
        }
      }

      if (self.amPM !== undefined && e.target === self.amPM) {
        switch (e.key) {
          case self.l10n.amPM[0].charAt(0):
          case self.l10n.amPM[0].charAt(0).toLowerCase():
            self.amPM.textContent = self.l10n.amPM[0];
            setHoursFromInputs();
            updateValue();
            break;

          case self.l10n.amPM[1].charAt(0):
          case self.l10n.amPM[1].charAt(0).toLowerCase():
            self.amPM.textContent = self.l10n.amPM[1];
            setHoursFromInputs();
            updateValue();
            break;
        }
      }

      triggerEvent("onKeyDown", e);
    }

    function onMouseOver(elem) {
      if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("disabled"))) return;
      var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(),
          initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(),
          rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()),
          rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime()),
          lastDate = self.daysContainer.lastChild.lastChild.dateObj.getTime();
      var containsDisabled = false;
      var minRange = 0,
          maxRange = 0;

      for (var t = rangeStartDate; t < lastDate; t += duration.DAY) {
        if (!isEnabled(new Date(t), true)) {
          containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
          if (t < initialDate && (!minRange || t > minRange)) minRange = t;else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
      }

      for (var m = 0; m < self.config.showMonths; m++) {
        var month = self.daysContainer.children[m];
        var prevMonth = self.daysContainer.children[m - 1];

        var _loop_1 = function _loop_1(i, l) {
          var dayElem = month.children[i],
              date = dayElem.dateObj;
          var timestamp = date.getTime();
          var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;

          if (outOfRange) {
            dayElem.classList.add("notAllowed");
            ["inRange", "startRange", "endRange"].forEach(function (c) {
              dayElem.classList.remove(c);
            });
            return "continue";
          } else if (containsDisabled && !outOfRange) return "continue";

          ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
            dayElem.classList.remove(c);
          });

          if (elem !== undefined) {
            elem.classList.add(hoverDate < self.selectedDates[0].getTime() ? "startRange" : "endRange");

            if (month.contains(elem) || !(m > 0 && prevMonth && prevMonth.lastChild.dateObj.getTime() >= timestamp)) {
              if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
              if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
          }
        };

        for (var i = 0, l = month.children.length; i < l; i++) {
          _loop_1(i, l);
        }
      }
    }

    function onResize() {
      if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }

    function setDefaultTime() {
      self.setDate(self.config.minDate !== undefined ? new Date(self.config.minDate.getTime()) : new Date(), false);
      setDefaultHours();
      updateValue();
    }

    function open(e, positionElement) {
      if (positionElement === void 0) {
        positionElement = self._positionElement;
      }

      if (self.isMobile === true) {
        if (e) {
          e.preventDefault();
          e.target && e.target.blur();
        }

        if (self.mobileInput !== undefined) {
          self.mobileInput.focus();
          self.mobileInput.click();
        }

        triggerEvent("onOpen");
        return;
      }

      if (self._input.disabled || self.config.inline) return;
      var wasOpen = self.isOpen;
      self.isOpen = true;

      if (!wasOpen) {
        self.calendarContainer.classList.add("open");

        self._input.classList.add("active");

        triggerEvent("onOpen");
        positionCalendar(positionElement);
      }

      if (self.config.enableTime === true && self.config.noCalendar === true) {
        if (self.selectedDates.length === 0) {
          setDefaultTime();
        }

        if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) {
          setTimeout(function () {
            return self.hourElement.select();
          }, 50);
        }
      }
    }

    function minMaxDateSetter(type) {
      return function (date) {
        var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
        var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];

        if (dateObj !== undefined) {
          self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
        }

        if (self.selectedDates) {
          self.selectedDates = self.selectedDates.filter(function (d) {
            return isEnabled(d);
          });
          if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
          updateValue();
        }

        if (self.daysContainer) {
          redraw();
          if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();else self.currentYearElement.removeAttribute(type);
          self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
        }
      };
    }

    function parseConfig() {
      var boolOpts = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];

      var userConfig = _assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));

      var formats = {};
      self.config.parseDate = userConfig.parseDate;
      self.config.formatDate = userConfig.formatDate;
      Object.defineProperty(self.config, "enable", {
        get: function get() {
          return self.config._enable;
        },
        set: function set(dates) {
          self.config._enable = parseDateRules(dates);
        }
      });
      Object.defineProperty(self.config, "disable", {
        get: function get() {
          return self.config._disable;
        },
        set: function set(dates) {
          self.config._disable = parseDateRules(dates);
        }
      });
      var timeMode = userConfig.mode === "time";

      if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
        formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : flatpickr.defaultConfig.dateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
      }

      if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
        formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : flatpickr.defaultConfig.altFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
      }

      Object.defineProperty(self.config, "minDate", {
        get: function get() {
          return self.config._minDate;
        },
        set: minMaxDateSetter("min")
      });
      Object.defineProperty(self.config, "maxDate", {
        get: function get() {
          return self.config._maxDate;
        },
        set: minMaxDateSetter("max")
      });

      var minMaxTimeSetter = function minMaxTimeSetter(type) {
        return function (val) {
          self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i");
        };
      };

      Object.defineProperty(self.config, "minTime", {
        get: function get() {
          return self.config._minTime;
        },
        set: minMaxTimeSetter("min")
      });
      Object.defineProperty(self.config, "maxTime", {
        get: function get() {
          return self.config._maxTime;
        },
        set: minMaxTimeSetter("max")
      });

      if (userConfig.mode === "time") {
        self.config.noCalendar = true;
        self.config.enableTime = true;
      }

      Object.assign(self.config, formats, userConfig);

      for (var i = 0; i < boolOpts.length; i++) {
        self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
      }

      HOOKS.filter(function (hook) {
        return self.config[hook] !== undefined;
      }).forEach(function (hook) {
        self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
      });
      self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      for (var i = 0; i < self.config.plugins.length; i++) {
        var pluginConf = self.config.plugins[i](self) || {};

        for (var key in pluginConf) {
          if (HOOKS.indexOf(key) > -1) {
            self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
          } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
        }
      }

      triggerEvent("onParseConfig");
    }

    function setupLocale() {
      if (_typeof(self.config.locale) !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
      self.l10n = _assign({}, flatpickr.l10ns["default"], _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
      tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
      self.formatDate = createDateFormatter(self);
      self.parseDate = createDateParser({
        config: self.config,
        l10n: self.l10n
      });
    }

    function positionCalendar(customPositionElement) {
      if (self.calendarContainer === undefined) return;
      triggerEvent("onPreCalendarPosition");
      var positionElement = customPositionElement || self._positionElement;
      var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function (acc, child) {
        return acc + child.offsetHeight;
      }, 0),
          calendarWidth = self.calendarContainer.offsetWidth,
          configPos = self.config.position.split(" "),
          configPosVertical = configPos[0],
          configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
          inputBounds = positionElement.getBoundingClientRect(),
          distanceFromBottom = window.innerHeight - inputBounds.bottom,
          showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
      var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
      toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
      toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
      if (self.config.inline) return;
      var left = window.pageXOffset + inputBounds.left - (configPosHorizontal != null && configPosHorizontal === "center" ? (calendarWidth - inputBounds.width) / 2 : 0);
      var right = window.document.body.offsetWidth - inputBounds.right;
      var rightMost = left + calendarWidth > window.document.body.offsetWidth;
      var centerMost = right + calendarWidth > window.document.body.offsetWidth;
      toggleClass(self.calendarContainer, "rightMost", rightMost);
      if (self.config.static) return;
      self.calendarContainer.style.top = top + "px";

      if (!rightMost) {
        self.calendarContainer.style.left = left + "px";
        self.calendarContainer.style.right = "auto";
      } else if (!centerMost) {
        self.calendarContainer.style.left = "auto";
        self.calendarContainer.style.right = right + "px";
      } else {
        var doc = document.styleSheets[0]; // some testing environments don't have css support

        if (doc === undefined) return;
        var bodyWidth = window.document.body.offsetWidth;
        var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
        var centerBefore = ".flatpickr-calendar.centerMost:before";
        var centerAfter = ".flatpickr-calendar.centerMost:after";
        var centerIndex = doc.cssRules.length;
        var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
        toggleClass(self.calendarContainer, "rightMost", false);
        toggleClass(self.calendarContainer, "centerMost", true);
        doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
        self.calendarContainer.style.left = centerLeft + "px";
        self.calendarContainer.style.right = "auto";
      }
    }

    function redraw() {
      if (self.config.noCalendar || self.isMobile) return;
      updateNavigationCurrentMonth();
      buildDays();
    }

    function focusAndClose() {
      self._input.focus();

      if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
        // hack - bugs in the way IE handles focus keeps the calendar open
        setTimeout(self.close, 0);
      } else {
        self.close();
      }
    }

    function selectDate(e) {
      e.preventDefault();
      e.stopPropagation();

      var isSelectable = function isSelectable(day) {
        return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("disabled") && !day.classList.contains("notAllowed");
      };

      var t = findParent(e.target, isSelectable);
      if (t === undefined) return;
      var target = t;
      var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
      var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
      self.selectedDateElem = target;
      if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
        var selectedIndex = isDateSelected(selectedDate);
        if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);else self.selectedDates.push(selectedDate);
      } else if (self.config.mode === "range") {
        if (self.selectedDates.length === 2) {
          self.clear(false, false);
        }

        self.latestSelectedDateObj = selectedDate;
        self.selectedDates.push(selectedDate); // unless selecting same date twice, sort ascendingly

        if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {
          return a.getTime() - b.getTime();
        });
      }
      setHoursFromInputs();

      if (shouldChangeMonth) {
        var isNewYear = self.currentYear !== selectedDate.getFullYear();
        self.currentYear = selectedDate.getFullYear();
        self.currentMonth = selectedDate.getMonth();
        if (isNewYear) triggerEvent("onYearChange");
        triggerEvent("onMonthChange");
      }

      updateNavigationCurrentMonth();
      buildDays();
      updateValue();
      if (self.config.enableTime) setTimeout(function () {
        return self.showTimeInput = true;
      }, 50); // maintain focus

      if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);else if (self.selectedDateElem !== undefined && self.hourElement === undefined) {
        self.selectedDateElem && self.selectedDateElem.focus();
      }
      if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();

      if (self.config.closeOnSelect) {
        var single = self.config.mode === "single" && !self.config.enableTime;
        var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;

        if (single || range) {
          focusAndClose();
        }
      }

      triggerChange();
    }

    var CALLBACKS = {
      locale: [setupLocale, updateWeekdays],
      showMonths: [buildMonths, setCalendarWidth, buildWeekdays]
    };

    function set(option, value) {
      if (option !== null && _typeof(option) === "object") Object.assign(self.config, option);else {
        self.config[option] = value;
        if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function (x) {
          return x();
        });else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
      }
      self.redraw();
      updateValue(false);
    }

    function setSelectedDate(inputDate, format) {
      var dates = [];
      if (inputDate instanceof Array) dates = inputDate.map(function (d) {
        return self.parseDate(d, format);
      });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
        switch (self.config.mode) {
          case "single":
          case "time":
            dates = [self.parseDate(inputDate, format)];
            break;

          case "multiple":
            dates = inputDate.split(self.config.conjunction).map(function (date) {
              return self.parseDate(date, format);
            });
            break;

          case "range":
            dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
              return self.parseDate(date, format);
            });
            break;

          default:
            break;
        }
      } else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
      self.selectedDates = dates.filter(function (d) {
        return d instanceof Date && isEnabled(d, false);
      });
      if (self.config.mode === "range") self.selectedDates.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
    }

    function setDate(date, triggerChange, format) {
      if (triggerChange === void 0) {
        triggerChange = false;
      }

      if (format === void 0) {
        format = self.config.dateFormat;
      }

      if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
      setSelectedDate(date, format);
      self.showTimeInput = self.selectedDates.length > 0;
      self.latestSelectedDateObj = self.selectedDates[0];
      self.redraw();
      jumpToDate();
      setHoursFromDate();
      updateValue(triggerChange);
      if (triggerChange) triggerEvent("onChange");
    }

    function parseDateRules(arr) {
      return arr.slice().map(function (rule) {
        if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
          return self.parseDate(rule, undefined, true);
        } else if (rule && _typeof(rule) === "object" && rule.from && rule.to) return {
          from: self.parseDate(rule.from, undefined),
          to: self.parseDate(rule.to, undefined)
        };

        return rule;
      }).filter(function (x) {
        return x;
      }); // remove falsy values
    }

    function setupDates() {
      self.selectedDates = [];
      self.now = self.parseDate(self.config.now) || new Date(); // Workaround IE11 setting placeholder as the input's value

      var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
      if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
      self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
      self.currentYear = self._initialDate.getFullYear();
      self.currentMonth = self._initialDate.getMonth();
      if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
      if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
      if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
      self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
      self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
      Object.defineProperty(self, "showTimeInput", {
        get: function get() {
          return self._showTimeInput;
        },
        set: function set(bool) {
          self._showTimeInput = bool;
          if (self.calendarContainer) toggleClass(self.calendarContainer, "showTimeInput", bool);
          self.isOpen && positionCalendar();
        }
      });
    }

    function setupInputs() {
      self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
      /* istanbul ignore next */

      if (!self.input) {
        self.config.errorHandler(new Error("Invalid input element specified"));
        return;
      } // hack: store previous type to restore it after destroy()


      self.input._type = self.input.type;
      self.input.type = "text";
      self.input.classList.add("flatpickr-input");
      self._input = self.input;

      if (self.config.altInput) {
        // replicate self.element
        self.altInput = createElement(self.input.nodeName, self.input.className + " " + self.config.altInputClass);
        self._input = self.altInput;
        self.altInput.placeholder = self.input.placeholder;
        self.altInput.disabled = self.input.disabled;
        self.altInput.required = self.input.required;
        self.altInput.tabIndex = self.input.tabIndex;
        self.altInput.type = "text";
        self.input.setAttribute("type", "hidden");
        if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
      }

      if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
      self._positionElement = self.config.positionElement || self._input;
    }

    function setupMobile() {
      var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
      self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
      self.mobileInput.step = self.input.getAttribute("step") || "any";
      self.mobileInput.tabIndex = 1;
      self.mobileInput.type = inputType;
      self.mobileInput.disabled = self.input.disabled;
      self.mobileInput.required = self.input.required;
      self.mobileInput.placeholder = self.input.placeholder;
      self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";

      if (self.selectedDates.length > 0) {
        self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
      }

      if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
      if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
      self.input.type = "hidden";
      if (self.altInput !== undefined) self.altInput.type = "hidden";

      try {
        if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
      } catch (_a) {}

      bind(self.mobileInput, "change", function (e) {
        self.setDate(e.target.value, false, self.mobileFormatStr);
        triggerEvent("onChange");
        triggerEvent("onClose");
      });
    }

    function toggle(e) {
      if (self.isOpen === true) return self.close();
      self.open(e);
    }

    function triggerEvent(event, data) {
      // If the instance has been destroyed already, all hooks have been removed
      if (self.config === undefined) return;
      var hooks = self.config[event];

      if (hooks !== undefined && hooks.length > 0) {
        for (var i = 0; hooks[i] && i < hooks.length; i++) {
          hooks[i](self.selectedDates, self.input.value, self, data);
        }
      }

      if (event === "onChange") {
        self.input.dispatchEvent(createEvent("change")); // many front-end frameworks bind to the input event

        self.input.dispatchEvent(createEvent("input"));
      }
    }

    function createEvent(name) {
      var e = document.createEvent("Event");
      e.initEvent(name, true, true);
      return e;
    }

    function isDateSelected(date) {
      for (var i = 0; i < self.selectedDates.length; i++) {
        if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
      }

      return false;
    }

    function isDateInRange(date) {
      if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
      return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
    }

    function updateNavigationCurrentMonth() {
      if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
      self.yearElements.forEach(function (yearElement, i) {
        var d = new Date(self.currentYear, self.currentMonth, 1);
        d.setMonth(self.currentMonth + i);
        self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
        yearElement.value = d.getFullYear().toString();
      });
      self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
      self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }

    function getDateStr(format) {
      return self.selectedDates.map(function (dObj) {
        return self.formatDate(dObj, format);
      }).filter(function (d, i, arr) {
        return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
      }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    /**
     * Updates the values of inputs associated with the calendar
     */


    function updateValue(triggerChange) {
      if (triggerChange === void 0) {
        triggerChange = true;
      }

      if (self.selectedDates.length === 0) return self.clear(triggerChange);

      if (self.mobileInput !== undefined && self.mobileFormatStr) {
        self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
      }

      self.input.value = getDateStr(self.config.dateFormat);

      if (self.altInput !== undefined) {
        self.altInput.value = getDateStr(self.config.altFormat);
      }

      if (triggerChange !== false) triggerEvent("onValueUpdate");
    }

    function onMonthNavClick(e) {
      e.preventDefault();
      var isPrevMonth = self.prevMonthNav.contains(e.target);
      var isNextMonth = self.nextMonthNav.contains(e.target);

      if (isPrevMonth || isNextMonth) {
        changeMonth(isPrevMonth ? -1 : 1);
      } else if (self.yearElements.indexOf(e.target) >= 0) {
        e.target.select();
      } else if (e.target.classList.contains("arrowUp")) {
        self.changeYear(self.currentYear + 1);
      } else if (e.target.classList.contains("arrowDown")) {
        self.changeYear(self.currentYear - 1);
      }
    }

    function timeWrapper(e) {
      e.preventDefault();
      var isKeyDown = e.type === "keydown",
          input = e.target;

      if (self.amPM !== undefined && e.target === self.amPM) {
        self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
      }

      var min = parseFloat(input.getAttribute("min")),
          max = parseFloat(input.getAttribute("max")),
          step = parseFloat(input.getAttribute("step")),
          curValue = parseInt(input.value, 10),
          delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
      var newValue = curValue + step * delta;

      if (typeof input.value !== "undefined" && input.value.length === 2) {
        var isHourElem = input === self.hourElement,
            isMinuteElem = input === self.minuteElement;

        if (newValue < min) {
          newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
          if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
        } else if (newValue > max) {
          newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
          if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
        }

        if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
          self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
        }

        input.value = pad(newValue);
      }
    }

    init();
    return self;
  }
  /* istanbul ignore next */


  function _flatpickr(nodeList, config) {
    // static list
    var nodes = Array.prototype.slice.call(nodeList).filter(function (x) {
      return x instanceof HTMLElement;
    });
    var instances = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      try {
        if (node.getAttribute("data-fp-omit") !== null) continue;

        if (node._flatpickr !== undefined) {
          node._flatpickr.destroy();

          node._flatpickr = undefined;
        }

        node._flatpickr = FlatpickrInstance(node, config || {});
        instances.push(node._flatpickr);
      } catch (e) {
        console.error(e);
      }
    }

    return instances.length === 1 ? instances[0] : instances;
  }
  /* istanbul ignore next */


  if (typeof HTMLElement !== "undefined") {
    // browser env
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
      return _flatpickr(this, config);
    };

    HTMLElement.prototype.flatpickr = function (config) {
      return _flatpickr([this], config);
    };
  }
  /* istanbul ignore next */


  var flatpickr = function flatpickr(selector, config) {
    if (typeof selector === "string") {
      return _flatpickr(window.document.querySelectorAll(selector), config);
    } else if (selector instanceof Node) {
      return _flatpickr([selector], config);
    } else {
      return _flatpickr(selector, config);
    }
  };
  /* istanbul ignore next */


  flatpickr.defaultConfig = defaults;
  flatpickr.l10ns = {
    en: _assign({}, english),
    "default": _assign({}, english)
  };

  flatpickr.localize = function (l10n) {
    flatpickr.l10ns["default"] = _assign({}, flatpickr.l10ns["default"], l10n);
  };

  flatpickr.setDefaults = function (config) {
    flatpickr.defaultConfig = _assign({}, flatpickr.defaultConfig, config);
  };

  flatpickr.parseDate = createDateParser({});
  flatpickr.formatDate = createDateFormatter({});
  flatpickr.compareDates = compareDates;
  /* istanbul ignore next */

  if (typeof jQuery !== "undefined") {
    jQuery.fn.flatpickr = function (config) {
      return _flatpickr(this, config);
    };
  }

  Date.prototype.fp_incr = function (days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
  };

  if (typeof window !== "undefined") {
    window.flatpickr = flatpickr;
  }

  return flatpickr;
});

},{}],11:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Flickity asNavFor v2.0.1
 * enable asNavFor for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/
(function (window, factory) {
  // universal module definition

  /*jshint strict: false */

  /*globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['flickity/js/index', 'fizzy-ui-utils/utils'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('flickity'), require('fizzy-ui-utils'));
  } else {
    // browser global
    window.Flickity = factory(window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(Flickity, utils) {
  'use strict'; // -------------------------- asNavFor prototype -------------------------- //
  // Flickity.defaults.asNavFor = null;

  Flickity.createMethods.push('_createAsNavFor');
  var proto = Flickity.prototype;

  proto._createAsNavFor = function () {
    this.on('activate', this.activateAsNavFor);
    this.on('deactivate', this.deactivateAsNavFor);
    this.on('destroy', this.destroyAsNavFor);
    var asNavForOption = this.options.asNavFor;

    if (!asNavForOption) {
      return;
    } // HACK do async, give time for other flickity to be initalized


    var _this = this;

    setTimeout(function initNavCompanion() {
      _this.setNavCompanion(asNavForOption);
    });
  };

  proto.setNavCompanion = function (elem) {
    elem = utils.getQueryElement(elem);
    var companion = Flickity.data(elem); // stop if no companion or companion is self

    if (!companion || companion == this) {
      return;
    }

    this.navCompanion = companion; // companion select

    var _this = this;

    this.onNavCompanionSelect = function () {
      _this.navCompanionSelect();
    };

    companion.on('select', this.onNavCompanionSelect); // click

    this.on('staticClick', this.onNavStaticClick);
    this.navCompanionSelect(true);
  };

  proto.navCompanionSelect = function (isInstant) {
    if (!this.navCompanion) {
      return;
    } // select slide that matches first cell of slide


    var selectedCell = this.navCompanion.selectedCells[0];
    var firstIndex = this.navCompanion.cells.indexOf(selectedCell);
    var lastIndex = firstIndex + this.navCompanion.selectedCells.length - 1;
    var selectIndex = Math.floor(lerp(firstIndex, lastIndex, this.navCompanion.cellAlign));
    this.selectCell(selectIndex, false, isInstant); // set nav selected class

    this.removeNavSelectedElements(); // stop if companion has more cells than this one

    if (selectIndex >= this.cells.length) {
      return;
    }

    var selectedCells = this.cells.slice(firstIndex, lastIndex + 1);
    this.navSelectedElements = selectedCells.map(function (cell) {
      return cell.element;
    });
    this.changeNavSelectedClass('add');
  };

  function lerp(a, b, t) {
    return (b - a) * t + a;
  }

  proto.changeNavSelectedClass = function (method) {
    this.navSelectedElements.forEach(function (navElem) {
      navElem.classList[method]('is-nav-selected');
    });
  };

  proto.activateAsNavFor = function () {
    this.navCompanionSelect(true);
  };

  proto.removeNavSelectedElements = function () {
    if (!this.navSelectedElements) {
      return;
    }

    this.changeNavSelectedClass('remove');
    delete this.navSelectedElements;
  };

  proto.onNavStaticClick = function (event, pointer, cellElement, cellIndex) {
    if (typeof cellIndex == 'number') {
      this.navCompanion.selectCell(cellIndex);
    }
  };

  proto.deactivateAsNavFor = function () {
    this.removeNavSelectedElements();
  };

  proto.destroyAsNavFor = function () {
    if (!this.navCompanion) {
      return;
    }

    this.navCompanion.off('select', this.onNavCompanionSelect);
    this.off('staticClick', this.onNavStaticClick);
    delete this.navCompanion;
  }; // -----  ----- //


  return Flickity;
});

},{"fizzy-ui-utils":9,"flickity":17}],12:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// add, remove cell
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', 'fizzy-ui-utils/utils'], function (Flickity, utils) {
      return factory(window, Flickity, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, utils) {
  'use strict'; // append cells to a document fragment

  function getCellsFragment(cells) {
    var fragment = document.createDocumentFragment();
    cells.forEach(function (cell) {
      fragment.appendChild(cell.element);
    });
    return fragment;
  } // -------------------------- add/remove cell prototype -------------------------- //


  var proto = Flickity.prototype;
  /**
   * Insert, prepend, or append cells
   * @param {Element, Array, NodeList} elems
   * @param {Integer} index
   */

  proto.insert = function (elems, index) {
    var cells = this._makeCells(elems);

    if (!cells || !cells.length) {
      return;
    }

    var len = this.cells.length; // default to append

    index = index === undefined ? len : index; // add cells with document fragment

    var fragment = getCellsFragment(cells); // append to slider

    var isAppend = index == len;

    if (isAppend) {
      this.slider.appendChild(fragment);
    } else {
      var insertCellElement = this.cells[index].element;
      this.slider.insertBefore(fragment, insertCellElement);
    } // add to this.cells


    if (index === 0) {
      // prepend, add to start
      this.cells = cells.concat(this.cells);
    } else if (isAppend) {
      // append, add to end
      this.cells = this.cells.concat(cells);
    } else {
      // insert in this.cells
      var endCells = this.cells.splice(index, len - index);
      this.cells = this.cells.concat(cells).concat(endCells);
    }

    this._sizeCells(cells);

    this.cellChange(index, true);
  };

  proto.append = function (elems) {
    this.insert(elems, this.cells.length);
  };

  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };
  /**
   * Remove cells
   * @param {Element, Array, NodeList} elems
   */


  proto.remove = function (elems) {
    var cells = this.getCells(elems);

    if (!cells || !cells.length) {
      return;
    }

    var minCellIndex = this.cells.length - 1; // remove cells from collection & DOM

    cells.forEach(function (cell) {
      cell.remove();
      var index = this.cells.indexOf(cell);
      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom(this.cells, cell);
    }, this);
    this.cellChange(minCellIndex, true);
  };
  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */


  proto.cellSizeChange = function (elem) {
    var cell = this.getCell(elem);

    if (!cell) {
      return;
    }

    cell.getSize();
    var index = this.cells.indexOf(cell);
    this.cellChange(index);
  };
  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */


  proto.cellChange = function (changedCellIndex, isPositioningSlider) {
    var prevSelectedElem = this.selectedElement;

    this._positionCells(changedCellIndex);

    this._getWrapShiftCells();

    this.setGallerySize(); // update selectedIndex
    // try to maintain position & select previous selected element

    var cell = this.getCell(prevSelectedElem);

    if (cell) {
      this.selectedIndex = this.getCellSlideIndex(cell);
    }

    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
    this.emitEvent('cellChange', [changedCellIndex]); // position slider

    this.select(this.selectedIndex); // do not position slider after lazy load

    if (isPositioningSlider) {
      this.positionSliderAtSelected();
    }
  }; // -----  ----- //


  return Flickity;
});

},{"./flickity":16,"fizzy-ui-utils":9}],13:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// animate
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['fizzy-ui-utils/utils'], function (utils) {
      return factory(window, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('fizzy-ui-utils'));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
  }
})(window, function factory(window, utils) {
  'use strict'; // -------------------------- animate -------------------------- //

  var proto = {};

  proto.startAnimation = function () {
    if (this.isAnimating) {
      return;
    }

    this.isAnimating = true;
    this.restingFrames = 0;
    this.animate();
  };

  proto.animate = function () {
    this.applyDragForce();
    this.applySelectedAttraction();
    var previousX = this.x;
    this.integratePhysics();
    this.positionSlider();
    this.settle(previousX); // animate next frame

    if (this.isAnimating) {
      var _this = this;

      requestAnimationFrame(function animateFrame() {
        _this.animate();
      });
    }
  };

  proto.positionSlider = function () {
    var x = this.x; // wrap position around

    if (this.options.wrapAround && this.cells.length > 1) {
      x = utils.modulo(x, this.slideableWidth);
      x = x - this.slideableWidth;
      this.shiftWrapCells(x);
    }

    this.setTranslateX(x, this.isAnimating);
    this.dispatchScrollEvent();
  };

  proto.setTranslateX = function (x, is3d) {
    x += this.cursorPosition; // reverse if right-to-left and using transform

    x = this.options.rightToLeft ? -x : x;
    var translateX = this.getPositionValue(x); // use 3D tranforms for hardware acceleration on iOS
    // but use 2D when settled, for better font-rendering

    this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
  };

  proto.dispatchScrollEvent = function () {
    var firstSlide = this.slides[0];

    if (!firstSlide) {
      return;
    }

    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent('scroll', null, [progress, positionX]);
  };

  proto.positionSliderAtSelected = function () {
    if (!this.cells.length) {
      return;
    }

    this.x = -this.selectedSlide.target;
    this.velocity = 0; // stop wobble

    this.positionSlider();
  };

  proto.getPositionValue = function (position) {
    if (this.options.percentPosition) {
      // percent position, round to 2 digits, like 12.34%
      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
    } else {
      // pixel positioning
      return Math.round(position) + 'px';
    }
  };

  proto.settle = function (previousX) {
    // keep track of frames where x hasn't moved
    if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
      this.restingFrames++;
    } // stop animating if resting for 3 or more frames


    if (this.restingFrames > 2) {
      this.isAnimating = false;
      delete this.isFreeScrolling; // render position with translateX when settled

      this.positionSlider();
      this.dispatchEvent('settle', null, [this.selectedIndex]);
    }
  };

  proto.shiftWrapCells = function (x) {
    // shift before cells
    var beforeGap = this.cursorPosition + x;

    this._shiftCells(this.beforeShiftCells, beforeGap, -1); // shift after cells


    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);

    this._shiftCells(this.afterShiftCells, afterGap, 1);
  };

  proto._shiftCells = function (cells, gap, shift) {
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var cellShift = gap > 0 ? shift : 0;
      cell.wrapShift(cellShift);
      gap -= cell.size.outerWidth;
    }
  };

  proto._unshiftCells = function (cells) {
    if (!cells || !cells.length) {
      return;
    }

    for (var i = 0; i < cells.length; i++) {
      cells[i].wrapShift(0);
    }
  }; // -------------------------- physics -------------------------- //


  proto.integratePhysics = function () {
    this.x += this.velocity;
    this.velocity *= this.getFrictionFactor();
  };

  proto.applyForce = function (force) {
    this.velocity += force;
  };

  proto.getFrictionFactor = function () {
    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
  };

  proto.getRestingPosition = function () {
    // my thanks to Steven Wittens, who simplified this math greatly
    return this.x + this.velocity / (1 - this.getFrictionFactor());
  };

  proto.applyDragForce = function () {
    if (!this.isDraggable || !this.isPointerDown) {
      return;
    } // change the position to drag position by applying force


    var dragVelocity = this.dragX - this.x;
    var dragForce = dragVelocity - this.velocity;
    this.applyForce(dragForce);
  };

  proto.applySelectedAttraction = function () {
    // do not attract if pointer down or no slides
    var dragDown = this.isDraggable && this.isPointerDown;

    if (dragDown || this.isFreeScrolling || !this.slides.length) {
      return;
    }

    var distance = this.selectedSlide.target * -1 - this.x;
    var force = distance * this.options.selectedAttraction;
    this.applyForce(force);
  };

  return proto;
});

},{"fizzy-ui-utils":9}],14:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Flickity.Cell
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['get-size/get-size'], function (getSize) {
      return factory(window, getSize);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('get-size'));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(window, window.getSize);
  }
})(window, function factory(window, getSize) {
  'use strict';

  function Cell(elem, parent) {
    this.element = elem;
    this.parent = parent;
    this.create();
  }

  var proto = Cell.prototype;

  proto.create = function () {
    this.element.style.position = 'absolute';
    this.element.setAttribute('aria-hidden', 'true');
    this.x = 0;
    this.shift = 0;
  };

  proto.destroy = function () {
    // reset style
    this.unselect();
    this.element.style.position = '';
    var side = this.parent.originSide;
    this.element.style[side] = '';
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  proto.setPosition = function (x) {
    this.x = x;
    this.updateTarget();
    this.renderPosition(x);
  }; // setDefaultTarget v1 method, backwards compatibility, remove in v3


  proto.updateTarget = proto.setDefaultTarget = function () {
    var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
    this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
  };

  proto.renderPosition = function (x) {
    // render position of cell with in slider
    var side = this.parent.originSide;
    this.element.style[side] = this.parent.getPositionValue(x);
  };

  proto.select = function () {
    this.element.classList.add('is-selected');
    this.element.removeAttribute('aria-hidden');
  };

  proto.unselect = function () {
    this.element.classList.remove('is-selected');
    this.element.setAttribute('aria-hidden', 'true');
  };
  /**
   * @param {Integer} factor - 0, 1, or -1
  **/


  proto.wrapShift = function (shift) {
    this.shift = shift;
    this.renderPosition(this.x + this.parent.slideableWidth * shift);
  };

  proto.remove = function () {
    this.element.parentNode.removeChild(this.element);
  };

  return Cell;
});

},{"get-size":24}],15:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// drag
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', 'unidragger/unidragger', 'fizzy-ui-utils/utils'], function (Flickity, Unidragger, utils) {
      return factory(window, Flickity, Unidragger, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unidragger'), require('fizzy-ui-utils'));
  } else {
    // browser global
    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unidragger, utils) {
  'use strict'; // ----- defaults ----- //

  utils.extend(Flickity.defaults, {
    draggable: '>1',
    dragThreshold: 3
  }); // ----- create ----- //

  Flickity.createMethods.push('_createDrag'); // -------------------------- drag prototype -------------------------- //

  var proto = Flickity.prototype;
  utils.extend(proto, Unidragger.prototype);
  proto._touchActionValue = 'pan-y'; // --------------------------  -------------------------- //

  var isTouch = ('createTouch' in document);
  var isTouchmoveScrollCanceled = false;

  proto._createDrag = function () {
    this.on('activate', this.onActivateDrag);
    this.on('uiChange', this._uiChangeDrag);
    this.on('deactivate', this.onDeactivateDrag);
    this.on('cellChange', this.updateDraggable); // TODO updateDraggable on resize? if groupCells & slides change
    // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
    // #457, RubaXa/Sortable#973

    if (isTouch && !isTouchmoveScrollCanceled) {
      window.addEventListener('touchmove', function () {});
      isTouchmoveScrollCanceled = true;
    }
  };

  proto.onActivateDrag = function () {
    this.handles = [this.viewport];
    this.bindHandles();
    this.updateDraggable();
  };

  proto.onDeactivateDrag = function () {
    this.unbindHandles();
    this.element.classList.remove('is-draggable');
  };

  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if (this.options.draggable == '>1') {
      this.isDraggable = this.slides.length > 1;
    } else {
      this.isDraggable = this.options.draggable;
    }

    if (this.isDraggable) {
      this.element.classList.add('is-draggable');
    } else {
      this.element.classList.remove('is-draggable');
    }
  }; // backwards compatibility


  proto.bindDrag = function () {
    this.options.draggable = true;
    this.updateDraggable();
  };

  proto.unbindDrag = function () {
    this.options.draggable = false;
    this.updateDraggable();
  };

  proto._uiChangeDrag = function () {
    delete this.isFreeScrolling;
  }; // -------------------------- pointer events -------------------------- //


  proto.pointerDown = function (event, pointer) {
    if (!this.isDraggable) {
      this._pointerDownDefault(event, pointer);

      return;
    }

    var isOkay = this.okayPointerDown(event);

    if (!isOkay) {
      return;
    }

    this._pointerDownPreventDefault(event);

    this.pointerDownFocus(event); // blur

    if (document.activeElement != this.element) {
      // do not blur if already focused
      this.pointerDownBlur();
    } // stop if it was moving


    this.dragX = this.x;
    this.viewport.classList.add('is-pointer-down'); // track scrolling

    this.pointerDownScroll = getScrollPosition();
    window.addEventListener('scroll', this);

    this._pointerDownDefault(event, pointer);
  }; // default pointerDown logic, used for staticClick


  proto._pointerDownDefault = function (event, pointer) {
    // track start event position
    // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    }; // bind move and end events

    this._bindPostStartEvents(event);

    this.dispatchEvent('pointerDown', event, [pointer]);
  };

  var focusNodes = {
    INPUT: true,
    TEXTAREA: true,
    SELECT: true
  };

  proto.pointerDownFocus = function (event) {
    var isFocusNode = focusNodes[event.target.nodeName];

    if (!isFocusNode) {
      this.focus();
    }
  };

  proto._pointerDownPreventDefault = function (event) {
    var isTouchStart = event.type == 'touchstart';
    var isTouchPointer = event.pointerType == 'touch';
    var isFocusNode = focusNodes[event.target.nodeName];

    if (!isTouchStart && !isTouchPointer && !isFocusNode) {
      event.preventDefault();
    }
  }; // ----- move ----- //


  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > this.options.dragThreshold;
  }; // ----- up ----- //


  proto.pointerUp = function (event, pointer) {
    delete this.isTouchScrolling;
    this.viewport.classList.remove('is-pointer-down');
    this.dispatchEvent('pointerUp', event, [pointer]);

    this._dragPointerUp(event, pointer);
  };

  proto.pointerDone = function () {
    window.removeEventListener('scroll', this);
    delete this.pointerDownScroll;
  }; // -------------------------- dragging -------------------------- //


  proto.dragStart = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }

    this.dragStartPosition = this.x;
    this.startAnimation();
    window.removeEventListener('scroll', this);
    this.dispatchEvent('dragStart', event, [pointer]);
  };

  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);

    this.dispatchEvent('pointerMove', event, [pointer, moveVector]);

    this._dragMove(event, pointer, moveVector);
  };

  proto.dragMove = function (event, pointer, moveVector) {
    if (!this.isDraggable) {
      return;
    }

    event.preventDefault();
    this.previousDragX = this.dragX; // reverse if right-to-left

    var direction = this.options.rightToLeft ? -1 : 1;

    if (this.options.wrapAround) {
      // wrap around move. #589
      moveVector.x = moveVector.x % this.slideableWidth;
    }

    var dragX = this.dragStartPosition + moveVector.x * direction;

    if (!this.options.wrapAround && this.slides.length) {
      // slow drag
      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }

    this.dragX = dragX;
    this.dragMoveTime = new Date();
    this.dispatchEvent('dragMove', event, [pointer, moveVector]);
  };

  proto.dragEnd = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }

    if (this.options.freeScroll) {
      this.isFreeScrolling = true;
    } // set selectedIndex based on where flick will end up


    var index = this.dragEndRestingSelect();

    if (this.options.freeScroll && !this.options.wrapAround) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      var restingX = this.getRestingPosition();
      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!this.options.freeScroll && index == this.selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }

    delete this.previousDragX; // apply selection
    // TODO refactor this, selecting here feels weird
    // HACK, set flag so dragging stays in correct direction

    this.isDragSelect = this.options.wrapAround;
    this.select(index);
    delete this.isDragSelect;
    this.dispatchEvent('dragEnd', event, [pointer]);
  };

  proto.dragEndRestingSelect = function () {
    var restingX = this.getRestingPosition(); // how far away from selected slide

    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex)); // get closet resting going up and going down

    var positiveResting = this._getClosestResting(restingX, distance, 1);

    var negativeResting = this._getClosestResting(restingX, distance, -1); // use closer resting for wrap-around


    var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    return index;
  };
  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */


  proto._getClosestResting = function (restingX, distance, increment) {
    var index = this.selectedIndex;
    var minDistance = Infinity;
    var condition = this.options.contain && !this.options.wrapAround ? // if contain, keep going if distance is equal to minDistance
    function (d, md) {
      return d <= md;
    } : function (d, md) {
      return d < md;
    };

    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);

      if (distance === null) {
        break;
      }

      distance = Math.abs(distance);
    }

    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };
  /**
   * measure distance between x and a slide target
   * @param {Number} x
   * @param {Integer} index - slide index
   */


  proto.getSlideDistance = function (x, index) {
    var len = this.slides.length; // wrap around if at least 2 slides

    var isWrapAround = this.options.wrapAround && len > 1;
    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    var slide = this.slides[slideIndex];

    if (!slide) {
      return null;
    } // add distance for wrap-around slides


    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };

  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100) {
      return 0;
    }

    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
    var delta = this.previousDragX - this.dragX;

    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }

    return 0;
  }; // ----- staticClick ----- //


  proto.staticClick = function (event, pointer) {
    // get clickedCell, if cell was clicked
    var clickedCell = this.getParentCell(event.target);
    var cellElem = clickedCell && clickedCell.element;
    var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
    this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
  }; // ----- scroll ----- //


  proto.onscroll = function () {
    var scroll = getScrollPosition();
    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
    var scrollMoveY = this.pointerDownScroll.y - scroll.y; // cancel click/tap if scroll is too much

    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this._pointerDone();
    }
  }; // ----- utils ----- //


  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  } // -----  ----- //


  return Flickity;
});

},{"./flickity":16,"fizzy-ui-utils":9,"unidragger":76}],16:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Flickity main
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './cell', './slide', './animate'], function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
      return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('ev-emitter'), require('get-size'), require('fizzy-ui-utils'), require('./cell'), require('./slide'), require('./animate'));
  } else {
    // browser global
    var _Flickity = window.Flickity;
    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
  }
})(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
  'use strict'; // vars

  var jQuery = window.jQuery;
  var getComputedStyle = window.getComputedStyle;
  var console = window.console;

  function moveElements(elems, toElem) {
    elems = utils.makeArray(elems);

    while (elems.length) {
      toElem.appendChild(elems.shift());
    }
  } // -------------------------- Flickity -------------------------- //
  // globally unique identifiers


  var GUID = 0; // internal store of all Flickity intances

  var instances = {};

  function Flickity(element, options) {
    var queryElement = utils.getQueryElement(element);

    if (!queryElement) {
      if (console) {
        console.error('Bad element for Flickity: ' + (queryElement || element));
      }

      return;
    }

    this.element = queryElement; // do not initialize twice on same element

    if (this.element.flickityGUID) {
      var instance = instances[this.element.flickityGUID];
      instance.option(options);
      return instance;
    } // add jQuery


    if (jQuery) {
      this.$element = jQuery(this.element);
    } // options


    this.options = utils.extend({}, this.constructor.defaults);
    this.option(options); // kick things off

    this._create();
  }

  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: 'center',
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075,
    // friction when free-scrolling
    friction: 0.28,
    // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true // watchCSS: false,
    // wrapAround: false

  }; // hash of methods triggered on _create()

  Flickity.createMethods = [];
  var proto = Flickity.prototype; // inherit EventEmitter

  utils.extend(proto, EvEmitter.prototype);

  proto._create = function () {
    // add id for Flickity.data
    var id = this.guid = ++GUID;
    this.element.flickityGUID = id; // expando

    instances[id] = this; // associate via id
    // initial properties

    this.selectedIndex = 0; // how many frames slider has been in same position

    this.restingFrames = 0; // initial physics properties

    this.x = 0;
    this.velocity = 0;
    this.originSide = this.options.rightToLeft ? 'right' : 'left'; // create viewport & slider

    this.viewport = document.createElement('div');
    this.viewport.className = 'flickity-viewport';

    this._createSlider();

    if (this.options.resize || this.options.watchCSS) {
      window.addEventListener('resize', this);
    } // add listeners from on option


    for (var eventName in this.options.on) {
      var listener = this.options.on[eventName];
      this.on(eventName, listener);
    }

    Flickity.createMethods.forEach(function (method) {
      this[method]();
    }, this);

    if (this.options.watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };
  /**
   * set options
   * @param {Object} opts
   */


  proto.option = function (opts) {
    utils.extend(this.options, opts);
  };

  proto.activate = function () {
    if (this.isActive) {
      return;
    }

    this.isActive = true;
    this.element.classList.add('flickity-enabled');

    if (this.options.rightToLeft) {
      this.element.classList.add('flickity-rtl');
    }

    this.getSize(); // move initial cell elements so they can be loaded as cells

    var cellElems = this._filterFindCellElements(this.element.children);

    moveElements(cellElems, this.slider);
    this.viewport.appendChild(this.slider);
    this.element.appendChild(this.viewport); // get cells from children

    this.reloadCells();

    if (this.options.accessibility) {
      // allow element to focusable
      this.element.tabIndex = 0; // listen for key presses

      this.element.addEventListener('keydown', this);
    }

    this.emitEvent('activate');
    this.selectInitialIndex(); // flag for initial activation, for using initialIndex

    this.isInitActivated = true; // ready event. #493

    this.dispatchEvent('ready');
  }; // slider positions the cells


  proto._createSlider = function () {
    // slider element does all the positioning
    var slider = document.createElement('div');
    slider.className = 'flickity-slider';
    slider.style[this.originSide] = 0;
    this.slider = slider;
  };

  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, this.options.cellSelector);
  }; // goes through all children


  proto.reloadCells = function () {
    // collection of item elements
    this.cells = this._makeCells(this.slider.children);
    this.positionCells();

    this._getWrapShiftCells();

    this.setGallerySize();
  };
  /**
   * turn elements into Flickity.Cells
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - collection of new Flickity Cells
   */


  proto._makeCells = function (elems) {
    var cellElems = this._filterFindCellElements(elems); // create new Flickity for collection


    var cells = cellElems.map(function (cellElem) {
      return new Cell(cellElem, this);
    }, this);
    return cells;
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.getLastSlide = function () {
    return this.slides[this.slides.length - 1];
  }; // positions all cells


  proto.positionCells = function () {
    // size all cells
    this._sizeCells(this.cells); // position all cells


    this._positionCells(0);
  };
  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */


  proto._positionCells = function (index) {
    index = index || 0; // also measure maxCellHeight
    // start 0 if positioning all cells

    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
    var cellX = 0; // get cellX

    if (index > 0) {
      var startCell = this.cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }

    var len = this.cells.length;

    for (var i = index; i < len; i++) {
      var cell = this.cells[i];
      cell.setPosition(cellX);
      cellX += cell.size.outerWidth;
      this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
    } // keep track of cellX for wrap-around


    this.slideableWidth = cellX; // slides

    this.updateSlides(); // contain slides target

    this._containSlides(); // update slidesWidth


    this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
  };
  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells
   */


  proto._sizeCells = function (cells) {
    cells.forEach(function (cell) {
      cell.getSize();
    });
  }; // --------------------------  -------------------------- //


  proto.updateSlides = function () {
    this.slides = [];

    if (!this.cells.length) {
      return;
    }

    var slide = new Slide(this);
    this.slides.push(slide);
    var isOriginLeft = this.originSide == 'left';
    var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

    var canCellFit = this._getCanCellFit();

    this.cells.forEach(function (cell, i) {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }

      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);

      if (canCellFit.call(this, i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();
        slide = new Slide(this);
        this.slides.push(slide);
        slide.addCell(cell);
      }
    }, this); // last slide

    slide.updateTarget(); // update .selectedSlide

    this.updateSelectedSlide();
  };

  proto._getCanCellFit = function () {
    var groupCells = this.options.groupCells;

    if (!groupCells) {
      return function () {
        return false;
      };
    } else if (typeof groupCells == 'number') {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      var number = parseInt(groupCells, 10);
      return function (i) {
        return i % number !== 0;
      };
    } // default, group by width of slide
    // parse '75%


    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
    var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
    return function (i, slideWidth) {
      return slideWidth <= (this.size.innerWidth + 1) * percent;
    };
  }; // alias _init for jQuery plugin .flickity()


  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
    this.setCellAlign();
    this.cursorPosition = this.size.innerWidth * this.cellAlign;
  };

  var cellAlignShorthands = {
    // cell align, then based on origin side
    center: {
      left: 0.5,
      right: 0.5
    },
    left: {
      left: 0,
      right: 1
    },
    right: {
      right: 0,
      left: 1
    }
  };

  proto.setCellAlign = function () {
    var shorthand = cellAlignShorthands[this.options.cellAlign];
    this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
  };

  proto.setGallerySize = function () {
    if (this.options.setGallerySize) {
      var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
      this.viewport.style.height = height + 'px';
    }
  };

  proto._getWrapShiftCells = function () {
    // only for wrap-around
    if (!this.options.wrapAround) {
      return;
    } // unshift previous cells


    this._unshiftCells(this.beforeShiftCells);

    this._unshiftCells(this.afterShiftCells); // get before cells
    // initial gap


    var gapX = this.cursorPosition;
    var cellIndex = this.cells.length - 1;
    this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1); // get after cells
    // ending gap between last cell and end of gallery viewport

    gapX = this.size.innerWidth - this.cursorPosition; // start cloning at first cell, working forwards

    this.afterShiftCells = this._getGapCells(gapX, 0, 1);
  };

  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    var cells = [];

    while (gapX > 0) {
      var cell = this.cells[cellIndex];

      if (!cell) {
        break;
      }

      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }

    return cells;
  }; // ----- contain ----- //
  // contain cell targets so no excess sliding


  proto._containSlides = function () {
    if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
      return;
    }

    var isRightToLeft = this.options.rightToLeft;
    var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
    var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
    var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin]; // content is less than gallery size

    var isContentSmaller = contentWidth < this.size.innerWidth; // bounds

    var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
    var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign); // contain each cell target

    this.slides.forEach(function (slide) {
      if (isContentSmaller) {
        // all cells fit inside gallery
        slide.target = contentWidth * this.cellAlign;
      } else {
        // contain to bounds
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      }
    }, this);
  }; // -----  ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */


  proto.dispatchEvent = function (type, event, args) {
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);

    if (jQuery && this.$element) {
      // default trigger with type if no event
      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
      var $event = type;

      if (event) {
        // create jQuery event
        var jQEvent = jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }

      this.$element.trigger($event, args);
    }
  }; // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */


  proto.select = function (index, isWrap, isInstant) {
    if (!this.isActive) {
      return;
    }

    index = parseInt(index, 10);

    this._wrapSelect(index);

    if (this.options.wrapAround || isWrap) {
      index = utils.modulo(index, this.slides.length);
    } // bail if invalid index


    if (!this.slides[index]) {
      return;
    }

    var prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.updateSelectedSlide();

    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }

    if (this.options.adaptiveHeight) {
      this.setGallerySize();
    } // events


    this.dispatchEvent('select', null, [index]); // change event if new index

    if (index != prevIndex) {
      this.dispatchEvent('change', null, [index]);
    } // old v1 event name, remove in v3


    this.dispatchEvent('cellSelect');
  }; // wraps position for wrapAround, to move to closest slide. #113


  proto._wrapSelect = function (index) {
    var len = this.slides.length;
    var isWrapping = this.options.wrapAround && len > 1;

    if (!isWrapping) {
      return index;
    }

    var wrapIndex = utils.modulo(index, len); // go to shortest

    var delta = Math.abs(wrapIndex - this.selectedIndex);
    var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
    var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);

    if (!this.isDragSelect && backWrapDelta < delta) {
      index += len;
    } else if (!this.isDragSelect && forewardWrapDelta < delta) {
      index -= len;
    } // wrap position so slider is within normal area


    if (index < 0) {
      this.x -= this.slideableWidth;
    } else if (index >= len) {
      this.x += this.slideableWidth;
    }
  };

  proto.previous = function (isWrap, isInstant) {
    this.select(this.selectedIndex - 1, isWrap, isInstant);
  };

  proto.next = function (isWrap, isInstant) {
    this.select(this.selectedIndex + 1, isWrap, isInstant);
  };

  proto.updateSelectedSlide = function () {
    var slide = this.slides[this.selectedIndex]; // selectedIndex could be outside of slides, if triggered before resize()

    if (!slide) {
      return;
    } // unselect previous selected slide


    this.unselectSelectedSlide(); // update new selected slide

    this.selectedSlide = slide;
    slide.select();
    this.selectedCells = slide.cells;
    this.selectedElements = slide.getCellElements(); // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
    // Remove in v3?

    this.selectedCell = slide.cells[0];
    this.selectedElement = this.selectedElements[0];
  };

  proto.unselectSelectedSlide = function () {
    if (this.selectedSlide) {
      this.selectedSlide.unselect();
    }
  };

  proto.selectInitialIndex = function () {
    var initialIndex = this.options.initialIndex; // already activated, select previous selectedIndex

    if (this.isInitActivated) {
      this.select(this.selectedIndex, false, true);
      return;
    } // select with selector string


    if (initialIndex && typeof initialIndex == 'string') {
      var cell = this.queryCell(initialIndex);

      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }

    var index = 0; // select with number

    if (initialIndex && this.slides[initialIndex]) {
      index = initialIndex;
    } // select instantly


    this.select(index, false, true);
  };
  /**
   * select slide from number or cell element
   * @param {Element or Number} elem
   */


  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    var cell = this.queryCell(value);

    if (!cell) {
      return;
    }

    var index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };

  proto.getCellSlideIndex = function (cell) {
    // get index of slides that has cell
    for (var i = 0; i < this.slides.length; i++) {
      var slide = this.slides[i];
      var index = slide.cells.indexOf(cell);

      if (index != -1) {
        return i;
      }
    }
  }; // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem
   * @returns {Flickity.Cell} item
   */


  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    for (var i = 0; i < this.cells.length; i++) {
      var cell = this.cells[i];

      if (cell.element == elem) {
        return cell;
      }
    }
  };
  /**
   * get collection of Flickity.Cells, given Elements
   * @param {Element, Array, NodeList} elems
   * @returns {Array} cells - Flickity.Cells
   */


  proto.getCells = function (elems) {
    elems = utils.makeArray(elems);
    var cells = [];
    elems.forEach(function (elem) {
      var cell = this.getCell(elem);

      if (cell) {
        cells.push(cell);
      }
    }, this);
    return cells;
  };
  /**
   * get cell elements
   * @returns {Array} cellElems
   */


  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };
  /**
   * get parent cell from an element
   * @param {Element} elem
   * @returns {Flickit.Cell} cell
   */


  proto.getParentCell = function (elem) {
    // first check if elem is cell
    var cell = this.getCell(elem);

    if (cell) {
      return cell;
    } // try to get parent cell elem


    elem = utils.getParent(elem, '.flickity-slider > *');
    return this.getCell(elem);
  };
  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */


  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) {
      return this.selectedSlide.getCellElements();
    }

    index = index === undefined ? this.selectedIndex : index;
    var len = this.slides.length;

    if (1 + adjCount * 2 >= len) {
      return this.getCellElements();
    }

    var cellElems = [];

    for (var i = index - adjCount; i <= index + adjCount; i++) {
      var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
      var slide = this.slides[slideIndex];

      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }

    return cellElems;
  };
  /**
   * select slide from number or cell element
   * @param {Element, Selector String, or Number} selector
   */


  proto.queryCell = function (selector) {
    if (typeof selector == 'number') {
      // use number as index
      return this.cells[selector];
    }

    if (typeof selector == 'string') {
      // do not select invalid selectors from hash: #123, #/. #791
      if (selector.match(/^[#\.]?[\d\/]/)) {
        return;
      } // use string as selector, get element


      selector = this.element.querySelector(selector);
    } // get cell from element


    return this.getCell(selector);
  }; // -------------------------- events -------------------------- //


  proto.uiChange = function () {
    this.emitEvent('uiChange');
  }; // keep focus on element when child UI elements are clicked


  proto.childUIPointerDown = function (event) {
    // HACK iOS does not allow touch events to bubble up?!
    if (event.type != 'touchstart') {
      event.preventDefault();
    }

    this.focus();
  }; // ----- resize ----- //


  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };

  utils.debounceMethod(Flickity, 'onresize', 150);

  proto.resize = function () {
    if (!this.isActive) {
      return;
    }

    this.getSize(); // wrap values

    if (this.options.wrapAround) {
      this.x = utils.modulo(this.x, this.slideableWidth);
    }

    this.positionCells();

    this._getWrapShiftCells();

    this.setGallerySize();
    this.emitEvent('resize'); // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers

    var selectedElement = this.selectedElements && this.selectedElements[0];
    this.selectCell(selectedElement, false, true);
  }; // watches the :after property, activates/deactivates


  proto.watchCSS = function () {
    var watchOption = this.options.watchCSS;

    if (!watchOption) {
      return;
    }

    var afterContent = getComputedStyle(this.element, ':after').content; // activate if :after { content: 'flickity' }

    if (afterContent.indexOf('flickity') != -1) {
      this.activate();
    } else {
      this.deactivate();
    }
  }; // ----- keydown ----- //
  // go previous/next if left/right keys pressed


  proto.onkeydown = function (event) {
    // only work if element is in focus
    var isNotFocused = document.activeElement && document.activeElement != this.element;

    if (!this.options.accessibility || isNotFocused) {
      return;
    }

    var handler = Flickity.keyboardHandlers[event.keyCode];

    if (handler) {
      handler.call(this);
    }
  };

  Flickity.keyboardHandlers = {
    // left arrow
    37: function _() {
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this.uiChange();
      this[leftMethod]();
    },
    // right arrow
    39: function _() {
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this.uiChange();
      this[rightMethod]();
    }
  }; // ----- focus ----- //

  proto.focus = function () {
    // TODO remove scrollTo once focus options gets more support
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
    var prevScrollY = window.pageYOffset;
    this.element.focus({
      preventScroll: true
    }); // hack to fix scroll jump after focus, #76

    if (window.pageYOffset != prevScrollY) {
      window.scrollTo(window.pageXOffset, prevScrollY);
    }
  }; // -------------------------- destroy -------------------------- //
  // deactivate all Flickity functionality, but keep stuff available


  proto.deactivate = function () {
    if (!this.isActive) {
      return;
    }

    this.element.classList.remove('flickity-enabled');
    this.element.classList.remove('flickity-rtl');
    this.unselectSelectedSlide(); // destroy cells

    this.cells.forEach(function (cell) {
      cell.destroy();
    });
    this.element.removeChild(this.viewport); // move child elements back into element

    moveElements(this.slider.children, this.element);

    if (this.options.accessibility) {
      this.element.removeAttribute('tabIndex');
      this.element.removeEventListener('keydown', this);
    } // set flags


    this.isActive = false;
    this.emitEvent('deactivate');
  };

  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener('resize', this);
    this.allOff();
    this.emitEvent('destroy');

    if (jQuery && this.$element) {
      jQuery.removeData(this.element, 'flickity');
    }

    delete this.element.flickityGUID;
    delete instances[this.guid];
  }; // -------------------------- prototype -------------------------- //


  utils.extend(proto, animatePrototype); // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {Element} elem
   * @returns {Flickity}
   */

  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    var id = elem && elem.flickityGUID;
    return id && instances[id];
  };

  utils.htmlInit(Flickity, 'flickity');

  if (jQuery && jQuery.bridget) {
    jQuery.bridget('flickity', Flickity);
  } // set internal jQuery, for Webpack + jQuery v3, #478


  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };

  Flickity.Cell = Cell;
  Flickity.Slide = Slide;
  return Flickity;
});

},{"./animate":13,"./cell":14,"./slide":22,"ev-emitter":7,"fizzy-ui-utils":9,"get-size":24}],17:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Flickity v2.2.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2018 Metafizzy
 */
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', './drag', './prev-next-button', './page-dots', './player', './add-remove-cell', './lazyload'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('./flickity'), require('./drag'), require('./prev-next-button'), require('./page-dots'), require('./player'), require('./add-remove-cell'), require('./lazyload'));
  }
})(window, function factory(Flickity) {
  /*jshint strict: false*/
  return Flickity;
});

},{"./add-remove-cell":12,"./drag":15,"./flickity":16,"./lazyload":18,"./page-dots":19,"./player":20,"./prev-next-button":21}],18:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// lazyload
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', 'fizzy-ui-utils/utils'], function (Flickity, utils) {
      return factory(window, Flickity, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, utils) {
  'use strict';

  Flickity.createMethods.push('_createLazyload');
  var proto = Flickity.prototype;

  proto._createLazyload = function () {
    this.on('select', this.lazyLoad);
  };

  proto.lazyLoad = function () {
    var lazyLoad = this.options.lazyLoad;

    if (!lazyLoad) {
      return;
    } // get adjacent cells, use lazyLoad option for adjacent count


    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
    var cellElems = this.getAdjacentCellElements(adjCount); // get lazy images in those cells

    var lazyImages = [];
    cellElems.forEach(function (cellElem) {
      var lazyCellImages = getCellLazyImages(cellElem);
      lazyImages = lazyImages.concat(lazyCellImages);
    }); // load lazy images

    lazyImages.forEach(function (img) {
      new LazyLoader(img, this);
    }, this);
  };

  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.nodeName == 'IMG') {
      var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
      var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
      var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');

      if (lazyloadAttr || srcAttr || srcsetAttr) {
        return [cellElem];
      }
    } // select lazy images in cell


    var lazySelector = 'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
    var imgs = cellElem.querySelectorAll(lazySelector);
    return utils.makeArray(imgs);
  } // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   */


  function LazyLoader(img, flickity) {
    this.img = img;
    this.flickity = flickity;
    this.load();
  }

  LazyLoader.prototype.handleEvent = utils.handleEvent;

  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this); // get src & srcset

    var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
    var srcset = this.img.getAttribute('data-flickity-lazyload-srcset'); // set src & serset

    this.img.src = src;

    if (srcset) {
      this.img.setAttribute('srcset', srcset);
    } // remove attr


    this.img.removeAttribute('data-flickity-lazyload');
    this.img.removeAttribute('data-flickity-lazyload-src');
    this.img.removeAttribute('data-flickity-lazyload-srcset');
  };

  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };

  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };

  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
    var cell = this.flickity.getParentCell(this.img);
    var cellElem = cell && cell.element;
    this.flickity.cellSizeChange(cellElem);
    this.img.classList.add(className);
    this.flickity.dispatchEvent('lazyLoad', event, cellElem);
  }; // -----  ----- //


  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});

},{"./flickity":16,"fizzy-ui-utils":9}],19:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// page dots
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', 'unipointer/unipointer', 'fizzy-ui-utils/utils'], function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unipointer, utils) {
  // -------------------------- PageDots -------------------------- //
  'use strict';

  function PageDots(parent) {
    this.parent = parent;

    this._create();
  }

  PageDots.prototype = Object.create(Unipointer.prototype);

  PageDots.prototype._create = function () {
    // create holder element
    this.holder = document.createElement('ol');
    this.holder.className = 'flickity-page-dots'; // create dots, array of elements

    this.dots = []; // events

    this.handleClick = this.onClick.bind(this);
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };

  PageDots.prototype.activate = function () {
    this.setDots();
    this.holder.addEventListener('click', this.handleClick);
    this.bindStartEvent(this.holder); // add to DOM

    this.parent.element.appendChild(this.holder);
  };

  PageDots.prototype.deactivate = function () {
    this.holder.removeEventListener('click', this.handleClick);
    this.unbindStartEvent(this.holder); // remove from DOM

    this.parent.element.removeChild(this.holder);
  };

  PageDots.prototype.setDots = function () {
    // get difference between number of slides and number of dots
    var delta = this.parent.slides.length - this.dots.length;

    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };

  PageDots.prototype.addDots = function (count) {
    var fragment = document.createDocumentFragment();
    var newDots = [];
    var length = this.dots.length;
    var max = length + count;

    for (var i = length; i < max; i++) {
      var dot = document.createElement('li');
      dot.className = 'dot';
      dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
      fragment.appendChild(dot);
      newDots.push(dot);
    }

    this.holder.appendChild(fragment);
    this.dots = this.dots.concat(newDots);
  };

  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count); // remove from DOM

    removeDots.forEach(function (dot) {
      this.holder.removeChild(dot);
    }, this);
  };

  PageDots.prototype.updateSelected = function () {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.className = 'dot';
      this.selectedDot.removeAttribute('aria-current');
    } // don't proceed if no dots


    if (!this.dots.length) {
      return;
    }

    this.selectedDot = this.dots[this.parent.selectedIndex];
    this.selectedDot.className = 'dot is-selected';
    this.selectedDot.setAttribute('aria-current', 'step');
  };

  PageDots.prototype.onTap = // old method name, backwards-compatible
  PageDots.prototype.onClick = function (event) {
    var target = event.target; // only care about dot clicks

    if (target.nodeName != 'LI') {
      return;
    }

    this.parent.uiChange();
    var index = this.dots.indexOf(target);
    this.parent.select(index);
  };

  PageDots.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  };

  Flickity.PageDots = PageDots; // -------------------------- Flickity -------------------------- //

  utils.extend(Flickity.defaults, {
    pageDots: true
  });
  Flickity.createMethods.push('_createPageDots');
  var proto = Flickity.prototype;

  proto._createPageDots = function () {
    if (!this.options.pageDots) {
      return;
    }

    this.pageDots = new PageDots(this); // events

    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };

  proto.activatePageDots = function () {
    this.pageDots.activate();
  };

  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected();
  };

  proto.updatePageDots = function () {
    this.pageDots.setDots();
  };

  proto.deactivatePageDots = function () {
    this.pageDots.deactivate();
  }; // -----  ----- //


  Flickity.PageDots = PageDots;
  return Flickity;
});

},{"./flickity":16,"fizzy-ui-utils":9,"unipointer":77}],20:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// player & autoPlay
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['ev-emitter/ev-emitter', 'fizzy-ui-utils/utils', './flickity'], function (EvEmitter, utils, Flickity) {
      return factory(EvEmitter, utils, Flickity);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('ev-emitter'), require('fizzy-ui-utils'), require('./flickity'));
  } else {
    // browser global
    factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
  }
})(window, function factory(EvEmitter, utils, Flickity) {
  'use strict'; // -------------------------- Player -------------------------- //

  function Player(parent) {
    this.parent = parent;
    this.state = 'stopped'; // visibility change event handler

    this.onVisibilityChange = this.visibilityChange.bind(this);
    this.onVisibilityPlay = this.visibilityPlay.bind(this);
  }

  Player.prototype = Object.create(EvEmitter.prototype); // start play

  Player.prototype.play = function () {
    if (this.state == 'playing') {
      return;
    } // do not play if page is hidden, start playing when page is visible


    var isPageHidden = document.hidden;

    if (isPageHidden) {
      document.addEventListener('visibilitychange', this.onVisibilityPlay);
      return;
    }

    this.state = 'playing'; // listen to visibility change

    document.addEventListener('visibilitychange', this.onVisibilityChange); // start ticking

    this.tick();
  };

  Player.prototype.tick = function () {
    // do not tick if not playing
    if (this.state != 'playing') {
      return;
    }

    var time = this.parent.options.autoPlay; // default to 3 seconds

    time = typeof time == 'number' ? time : 3000;

    var _this = this; // HACK: reset ticks if stopped and started within interval


    this.clear();
    this.timeout = setTimeout(function () {
      _this.parent.next(true);

      _this.tick();
    }, time);
  };

  Player.prototype.stop = function () {
    this.state = 'stopped';
    this.clear(); // remove visibility change event

    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };

  Player.prototype.clear = function () {
    clearTimeout(this.timeout);
  };

  Player.prototype.pause = function () {
    if (this.state == 'playing') {
      this.state = 'paused';
      this.clear();
    }
  };

  Player.prototype.unpause = function () {
    // re-start play if paused
    if (this.state == 'paused') {
      this.play();
    }
  }; // pause if page visibility is hidden, unpause if visible


  Player.prototype.visibilityChange = function () {
    var isPageHidden = document.hidden;
    this[isPageHidden ? 'pause' : 'unpause']();
  };

  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
  }; // -------------------------- Flickity -------------------------- //


  utils.extend(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });
  Flickity.createMethods.push('_createPlayer');
  var proto = Flickity.prototype;

  proto._createPlayer = function () {
    this.player = new Player(this);
    this.on('activate', this.activatePlayer);
    this.on('uiChange', this.stopPlayer);
    this.on('pointerDown', this.stopPlayer);
    this.on('deactivate', this.deactivatePlayer);
  };

  proto.activatePlayer = function () {
    if (!this.options.autoPlay) {
      return;
    }

    this.player.play();
    this.element.addEventListener('mouseenter', this);
  }; // Player API, don't hate the ... thanks I know where the door is


  proto.playPlayer = function () {
    this.player.play();
  };

  proto.stopPlayer = function () {
    this.player.stop();
  };

  proto.pausePlayer = function () {
    this.player.pause();
  };

  proto.unpausePlayer = function () {
    this.player.unpause();
  };

  proto.deactivatePlayer = function () {
    this.player.stop();
    this.element.removeEventListener('mouseenter', this);
  }; // ----- mouseenter/leave ----- //
  // pause auto-play on hover


  proto.onmouseenter = function () {
    if (!this.options.pauseAutoPlayOnHover) {
      return;
    }

    this.player.pause();
    this.element.addEventListener('mouseleave', this);
  }; // resume auto-play on hover off


  proto.onmouseleave = function () {
    this.player.unpause();
    this.element.removeEventListener('mouseleave', this);
  }; // -----  ----- //


  Flickity.Player = Player;
  return Flickity;
});

},{"./flickity":16,"ev-emitter":7,"fizzy-ui-utils":9}],21:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// prev/next buttons
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./flickity', 'unipointer/unipointer', 'fizzy-ui-utils/utils'], function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unipointer, utils) {
  'use strict';

  var svgURI = 'http://www.w3.org/2000/svg'; // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(direction, parent) {
    this.direction = direction;
    this.parent = parent;

    this._create();
  }

  PrevNextButton.prototype = Object.create(Unipointer.prototype);

  PrevNextButton.prototype._create = function () {
    // properties
    this.isEnabled = true;
    this.isPrevious = this.direction == -1;
    var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
    this.isLeft = this.direction == leftDirection;
    var element = this.element = document.createElement('button');
    element.className = 'flickity-button flickity-prev-next-button';
    element.className += this.isPrevious ? ' previous' : ' next'; // prevent button from submitting form http://stackoverflow.com/a/10836076/182183

    element.setAttribute('type', 'button'); // init as disabled

    this.disable();
    element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next'); // create arrow

    var svg = this.createSVG();
    element.appendChild(svg); // events

    this.parent.on('select', this.update.bind(this));
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };

  PrevNextButton.prototype.activate = function () {
    this.bindStartEvent(this.element);
    this.element.addEventListener('click', this); // add to DOM

    this.parent.element.appendChild(this.element);
  };

  PrevNextButton.prototype.deactivate = function () {
    // remove from DOM
    this.parent.element.removeChild(this.element); // click events

    this.unbindStartEvent(this.element);
    this.element.removeEventListener('click', this);
  };

  PrevNextButton.prototype.createSVG = function () {
    var svg = document.createElementNS(svgURI, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100');
    var path = document.createElementNS(svgURI, 'path');
    var pathMovements = getArrowMovements(this.parent.options.arrowShape);
    path.setAttribute('d', pathMovements);
    path.setAttribute('class', 'arrow'); // rotate arrow

    if (!this.isLeft) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
    }

    svg.appendChild(path);
    return svg;
  }; // get SVG path movmement


  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == 'string') {
      return shape;
    } // create movement string


    return 'M ' + shape.x0 + ',50' + ' L ' + shape.x1 + ',' + (shape.y1 + 50) + ' L ' + shape.x2 + ',' + (shape.y2 + 50) + ' L ' + shape.x3 + ',50 ' + ' L ' + shape.x2 + ',' + (50 - shape.y2) + ' L ' + shape.x1 + ',' + (50 - shape.y1) + ' Z';
  }

  PrevNextButton.prototype.handleEvent = utils.handleEvent;

  PrevNextButton.prototype.onclick = function () {
    if (!this.isEnabled) {
      return;
    }

    this.parent.uiChange();
    var method = this.isPrevious ? 'previous' : 'next';
    this.parent[method]();
  }; // -----  ----- //


  PrevNextButton.prototype.enable = function () {
    if (this.isEnabled) {
      return;
    }

    this.element.disabled = false;
    this.isEnabled = true;
  };

  PrevNextButton.prototype.disable = function () {
    if (!this.isEnabled) {
      return;
    }

    this.element.disabled = true;
    this.isEnabled = false;
  };

  PrevNextButton.prototype.update = function () {
    // index of first or last slide, if previous or next
    var slides = this.parent.slides; // enable is wrapAround and at least 2 slides

    if (this.parent.options.wrapAround && slides.length > 1) {
      this.enable();
      return;
    }

    var lastIndex = slides.length ? slides.length - 1 : 0;
    var boundIndex = this.isPrevious ? 0 : lastIndex;
    var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
    this[method]();
  };

  PrevNextButton.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  }; // -------------------------- Flickity prototype -------------------------- //


  utils.extend(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30
    }
  });
  Flickity.createMethods.push('_createPrevNextButtons');
  var proto = Flickity.prototype;

  proto._createPrevNextButtons = function () {
    if (!this.options.prevNextButtons) {
      return;
    }

    this.prevButton = new PrevNextButton(-1, this);
    this.nextButton = new PrevNextButton(1, this);
    this.on('activate', this.activatePrevNextButtons);
  };

  proto.activatePrevNextButtons = function () {
    this.prevButton.activate();
    this.nextButton.activate();
    this.on('deactivate', this.deactivatePrevNextButtons);
  };

  proto.deactivatePrevNextButtons = function () {
    this.prevButton.deactivate();
    this.nextButton.deactivate();
    this.off('deactivate', this.deactivatePrevNextButtons);
  }; // --------------------------  -------------------------- //


  Flickity.PrevNextButton = PrevNextButton;
  return Flickity;
});

},{"./flickity":16,"fizzy-ui-utils":9,"unipointer":77}],22:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// slide
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }
})(window, function factory() {
  'use strict';

  function Slide(parent) {
    this.parent = parent;
    this.isOriginLeft = parent.originSide == 'left';
    this.cells = [];
    this.outerWidth = 0;
    this.height = 0;
  }

  var proto = Slide.prototype;

  proto.addCell = function (cell) {
    this.cells.push(cell);
    this.outerWidth += cell.size.outerWidth;
    this.height = Math.max(cell.size.outerHeight, this.height); // first cell stuff

    if (this.cells.length == 1) {
      this.x = cell.x; // x comes from first cell

      var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
      this.firstMargin = cell.size[beginMargin];
    }
  };

  proto.updateTarget = function () {
    var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
    var lastCell = this.getLastCell();
    var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
    this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.select = function () {
    this.cells.forEach(function (cell) {
      cell.select();
    });
  };

  proto.unselect = function () {
    this.cells.forEach(function (cell) {
      cell.unselect();
    });
  };

  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  return Slide;
});

},{}],23:[function(require,module,exports){
"use strict";

/*
 * Fuzzy
 * https://github.com/myork/fuzzy
 *
 * Copyright (c) 2012 Matt York
 * Licensed under the MIT license.
 */
(function () {
  var root = this;
  var fuzzy = {}; // Use in node or in browser

  if (typeof exports !== 'undefined') {
    module.exports = fuzzy;
  } else {
    root.fuzzy = fuzzy;
  } // Return all elements of `array` that have a fuzzy
  // match against `pattern`.


  fuzzy.simpleFilter = function (pattern, array) {
    return array.filter(function (str) {
      return fuzzy.test(pattern, str);
    });
  }; // Does `pattern` fuzzy match `str`?


  fuzzy.test = function (pattern, str) {
    return fuzzy.match(pattern, str) !== null;
  }; // If `pattern` matches `str`, wrap each matching character
  // in `opts.pre` and `opts.post`. If no match, return null


  fuzzy.match = function (pattern, str, opts) {
    opts = opts || {};
    var patternIdx = 0,
        result = [],
        len = str.length,
        totalScore = 0,
        currScore = 0 // prefix
    ,
        pre = opts.pre || '' // suffix
    ,
        post = opts.post || '' // String to compare against. This might be a lowercase version of the
    // raw string
    ,
        compareString = opts.caseSensitive && str || str.toLowerCase(),
        ch;
    pattern = opts.caseSensitive && pattern || pattern.toLowerCase(); // For each character in the string, either add it to the result
    // or wrap in template if it's the next string in the pattern

    for (var idx = 0; idx < len; idx++) {
      ch = str[idx];

      if (compareString[idx] === pattern[patternIdx]) {
        ch = pre + ch + post;
        patternIdx += 1; // consecutive characters should increase the score more than linearly

        currScore += 1 + currScore;
      } else {
        currScore = 0;
      }

      totalScore += currScore;
      result[result.length] = ch;
    } // return rendered string if we have a match for every char


    if (patternIdx === pattern.length) {
      // if the string is an exact match with pattern, totalScore should be maxed
      totalScore = compareString === pattern ? Infinity : totalScore;
      return {
        rendered: result.join(''),
        score: totalScore
      };
    }

    return null;
  }; // The normal entry point. Filters `arr` for matches against `pattern`.
  // It returns an array with matching values of the type:
  //
  //     [{
  //         string:   '<b>lah' // The rendered string
  //       , index:    2        // The index of the element in `arr`
  //       , original: 'blah'   // The original element in `arr`
  //     }]
  //
  // `opts` is an optional argument bag. Details:
  //
  //    opts = {
  //        // string to put before a matching character
  //        pre:     '<b>'
  //
  //        // string to put after matching character
  //      , post:    '</b>'
  //
  //        // Optional function. Input is an entry in the given arr`,
  //        // output should be the string to test `pattern` against.
  //        // In this example, if `arr = [{crying: 'koala'}]` we would return
  //        // 'koala'.
  //      , extract: function(arg) { return arg.crying; }
  //    }


  fuzzy.filter = function (pattern, arr, opts) {
    if (!arr || arr.length === 0) {
      return [];
    }

    if (typeof pattern !== 'string') {
      return arr;
    }

    opts = opts || {};
    return arr.reduce(function (prev, element, idx, arr) {
      var str = element;

      if (opts.extract) {
        str = opts.extract(element);
      }

      var rendered = fuzzy.match(pattern, str, opts);

      if (rendered != null) {
        prev[prev.length] = {
          string: rendered.rendered,
          score: rendered.score,
          index: idx,
          original: element
        };
      }

      return prev;
    }, []) // Sort by score. Browsers are inconsistent wrt stable/unstable
    // sorting, so force stable by using the index in the case of tie.
    // See http://ofb.net/~sethml/is-sort-stable.html
    .sort(function (a, b) {
      var compare = b.score - a.score;
      if (compare) return compare;
      return a.index - b.index;
    });
  };
})();

},{}],24:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

/* globals console: false */
(function (window, factory) {
  /* jshint strict: false */

  /* globals define, module */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }
})(window, function factory() {
  'use strict'; // -------------------------- helpers -------------------------- //
  // get a number from a string, not a percentage

  function getStyleSize(value) {
    var num = parseFloat(value); // not a percent like '100%', and a number

    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  }

  function noop() {}

  var logError = typeof console == 'undefined' ? noop : function (message) {
    console.error(message);
  }; // -------------------------- measurements -------------------------- //

  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
  var measurementsLength = measurements.length;

  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };

    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      size[measurement] = 0;
    }

    return size;
  } // -------------------------- getStyle -------------------------- //

  /**
   * getStyle, get style of element, check for Firefox bug
   * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
   */


  function getStyle(elem) {
    var style = getComputedStyle(elem);

    if (!style) {
      logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
    }

    return style;
  } // -------------------------- setup -------------------------- //


  var isSetup = false;
  var isBoxSizeOuter;
  /**
   * setup
   * check isBoxSizerOuter
   * do on first getSize() rather than on page load for Firefox bug
   */

  function setup() {
    // setup once
    if (isSetup) {
      return;
    }

    isSetup = true; // -------------------------- box sizing -------------------------- //

    /**
     * Chrome & Safari measure the outer-width on style.width on border-box elems
     * IE11 & Firefox<29 measures the inner-width
     */

    var div = document.createElement('div');
    div.style.width = '200px';
    div.style.padding = '1px 2px 3px 4px';
    div.style.borderStyle = 'solid';
    div.style.borderWidth = '1px 2px 3px 4px';
    div.style.boxSizing = 'border-box';
    var body = document.body || document.documentElement;
    body.appendChild(div);
    var style = getStyle(div); // round value for browser zoom. desandro/masonry#928

    isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
    getSize.isBoxSizeOuter = isBoxSizeOuter;
    body.removeChild(div);
  } // -------------------------- getSize -------------------------- //


  function getSize(elem) {
    setup(); // use querySeletor if elem is string

    if (typeof elem == 'string') {
      elem = document.querySelector(elem);
    } // do not proceed on non-objects


    if (!elem || _typeof(elem) != 'object' || !elem.nodeType) {
      return;
    }

    var style = getStyle(elem); // if hidden, everything is 0

    if (style.display == 'none') {
      return getZeroSize();
    }

    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;
    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box'; // get all measurements

    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      var value = style[measurement];
      var num = parseFloat(value); // any 'auto', 'medium' value will be 0

      size[measurement] = !isNaN(num) ? num : 0;
    }

    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth;
    var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter; // overwrite width and height if we can get it from style

    var styleWidth = getStyleSize(style.width);

    if (styleWidth !== false) {
      size.width = styleWidth + ( // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
    }

    var styleHeight = getStyleSize(style.height);

    if (styleHeight !== false) {
      size.height = styleHeight + ( // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
    }

    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);
    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;
    return size;
  }

  return getSize;
});

},{}],25:[function(require,module,exports){
"use strict";

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline = /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;
  Hogan.tags = {
    '#': 1,
    '^': 2,
    '<': 3,
    '$': 4,
    '/': 5,
    '!': 6,
    '>': 7,
    '=': 8,
    '_v': 9,
    '{': 10,
    '&': 11,
    '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({
          tag: '_t',
          text: new String(buf)
        });
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;

      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags['_v'] || tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null;

        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j + 1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString();
            }

            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({
          tag: '\n'
        });
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(text.substring(text.indexOf('=', index) + 1, closeIndex)).split(' ');
      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];
      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';

        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }

          state = IN_TAG;
        }

        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({
            tag: tagType,
            n: trim(buf),
            otag: otag,
            ctag: ctag,
            i: tagType == '/' ? seenTag - otag.length : i + ctag.length
          });
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;

          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);
    return tokens;
  };

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  } // the tags allowed inside super templates


  var allowedInSuper = {
    '_t': true,
    '\n': true,
    '$': true,
    '/': true
  };

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;
    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }

        opener = stack.pop();

        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }

        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = tokens.length == 0 || tokens[0].tag == '\n';
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];

    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }

    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];

    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }

    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function (codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
  };

  var serialNo = 0;

  Hogan.generate = function (tree, text, options) {
    serialNo = 0;
    var context = {
      code: '',
      subs: {},
      partials: {}
    };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  };

  Hogan.wrapMain = function (code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  };

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function (codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  };

  Hogan.makePartials = function (codeObj) {
    var key,
        template = {
      subs: {},
      partials: codeObj.partials,
      name: codeObj.name
    };

    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }

    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }

    return template;
  };

  function esc(s) {
    return s.replace(rSlash, '\\\\').replace(rQuot, '\\\"').replace(rNewline, '\\n').replace(rCr, '\\r').replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
  }

  function chooseMethod(s) {
    return ~s.indexOf('.') ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {
      name: node.n,
      partials: {}
    };
    context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function _(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + 'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' + 't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },
    '^': function _(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },
    '>': createPartial,
    '<': function _(node, context) {
      var ctx = {
        partials: {},
        code: '',
        subs: {},
        inPartial: true
      };
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },
    '$': function $(node, context) {
      var ctx = {
        subs: {},
        code: '',
        partials: context.partials,
        prefix: node.n
      };
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;

      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },
    '\n': function _(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },
    '_v': function _v(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },
    '_t': function _t(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },
    '{': tripleStache,
    '&': tripleStache
  };

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function (nodelist, context) {
    var func;

    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }

    return context;
  };

  Hogan.parse = function (tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  };

  Hogan.cache = {};

  Hogan.cacheKey = function (text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  };

  Hogan.compile = function (text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;

      for (var name in partials) {
        delete partials[name].instance;
      }

      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  };
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],26:[function(require,module,exports){
"use strict";

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
// This file is for use with Node.js. See dist/ for browser files.
var Hogan = require('./compiler');

Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":25,"./template":27}],27:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  };

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function r(context, partials, indent) {
      return '';
    },
    // variable escaping
    v: hoganEscape,
    // triple stache
    t: coerceToString,
    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },
    // render internal -- a hook for overrides that catches partials too
    ri: function ri(context, partials, indent) {
      return this.r(context, partials, indent);
    },
    // ensurePartial
    ep: function ep(symbol, partials) {
      var partial = this.partials[symbol]; // check to see that if we've instantiated this partial before

      var template = partials[partial.name];

      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }

        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      } // We use this to check whether the partials dictionary has changed


      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};

        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
          }
        }

        template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
      }

      this.partials[symbol].instance = template;
      return template;
    },
    // tries to find a partial in the current scope and render it
    rp: function rp(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);

      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },
    // render a section
    rs: function rs(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },
    // maybe start a section
    s: function s(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push(_typeof(val) == 'object' ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },
    // find values with dotted names
    d: function d(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);

          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },
    // find values with normal names
    f: function f(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);

        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return returnFound ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },
    // higher order templates
    ls: function ls(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;
      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;
      return false;
    },
    // compile text
    ct: function ct(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }

      return this.c.compile(text, this.options).render(cx, partials);
    },
    // template result buffering
    b: function b(s) {
      this.buf += s;
    },
    fl: function fl() {
      var r = this.buf;
      this.buf = '';
      return r;
    },
    // method replace section
    ms: function ms(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },
    // method replace variable
    mv: function mv(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },
    sub: function sub(name, context, partials, indent) {
      var f = this.subs[name];

      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }
  }; //Find a key in an object

  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && _typeof(scope) == 'object') {
      if (scope[key] !== undefined) {
        val = scope[key]; // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {}

    ;
    PartialTemplate.prototype = instance;

    function Substitutions() {}

    ;
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {}; //hehe. substext.

    partial.buf = '';
    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;

    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }

    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;

    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }

    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String(val === null || val === undefined ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ? str.replace(rAmp, '&amp;').replace(rLt, '&lt;').replace(rGt, '&gt;').replace(rApos, '&#39;').replace(rQuot, '&quot;') : str;
  }

  var isArray = Array.isArray || function (a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],28:[function(require,module,exports){
"use strict";

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;

  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;

  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }

  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);

    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }

    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }

    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;

  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

},{}],29:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */
(function (global, factory) {
  "use strict";

  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
    // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function (w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }

      return factory(w);
    };
  } else {
    factory(global);
  } // Pass this if window is not defined yet

})(typeof window !== "undefined" ? window : void 0, function (window, noGlobal) {
  // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
  // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
  // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
  // enough that all such attempts are guarded in a try block.
  "use strict";

  var arr = [];
  var getProto = Object.getPrototypeOf;
  var _slice = arr.slice;
  var flat = arr.flat ? function (array) {
    return arr.flat.call(array);
  } : function (array) {
    return arr.concat.apply([], array);
  };
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var fnToString = hasOwn.toString;
  var ObjectFunctionString = fnToString.call(Object);
  var support = {};

  var isFunction = function isFunction(obj) {
    // Support: Chrome <=57, Firefox <=52
    // In some browsers, typeof returns "function" for HTML <object> elements
    // (i.e., `typeof document.createElement( "object" ) === "function"`).
    // We don't want to classify *any* DOM node as a function.
    // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
    // Plus for old WebKit, typeof returns "function" for HTML collections
    // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
    return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
  };

  var isWindow = function isWindow(obj) {
    return obj != null && obj === obj.window;
  };

  var document = window.document;
  var preservedScriptAttributes = {
    type: true,
    src: true,
    nonce: true,
    noModule: true
  };

  function DOMEval(code, node, doc) {
    doc = doc || document;
    var i,
        val,
        script = doc.createElement("script");
    script.text = code;

    if (node) {
      for (i in preservedScriptAttributes) {
        // Support: Firefox 64+, Edge 18+
        // Some browsers don't support the "nonce" property on scripts.
        // On the other hand, just using `getAttribute` is not enough as
        // the `nonce` attribute is reset to an empty string whenever it
        // becomes browsing-context connected.
        // See https://github.com/whatwg/html/issues/2369
        // See https://html.spec.whatwg.org/#nonce-attributes
        // The `node.getAttribute` check was added for the sake of
        // `jQuery.globalEval` so that it can fake a nonce-containing node
        // via an object.
        val = node[i] || node.getAttribute && node.getAttribute(i);

        if (val) {
          script.setAttribute(i, val);
        }
      }
    }

    doc.head.appendChild(script).parentNode.removeChild(script);
  }

  function toType(obj) {
    if (obj == null) {
      return obj + "";
    } // Support: Android <=2.3 only (functionish RegExp)


    return _typeof(obj) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : _typeof(obj);
  }
  /* global Symbol */
  // Defining this global in .eslintrc.json would create a danger of using the global
  // unguarded in another place, it seems safer to define global only for this module


  var version = "3.6.4",
      // Define a local copy of jQuery
  jQuery = function jQuery(selector, context) {
    // The jQuery object is actually just the init constructor 'enhanced'
    // Need init if jQuery is called (just allow error to be thrown if not included)
    return new jQuery.fn.init(selector, context);
  };

  jQuery.fn = jQuery.prototype = {
    // The current version of jQuery being used
    jquery: version,
    constructor: jQuery,
    // The default length of a jQuery object is 0
    length: 0,
    toArray: function toArray() {
      return _slice.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function get(num) {
      // Return all the elements in a clean array
      if (num == null) {
        return _slice.call(this);
      } // Return just the one element from the set


      return num < 0 ? this[num + this.length] : this[num];
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function pushStack(elems) {
      // Build a new jQuery matched element set
      var ret = jQuery.merge(this.constructor(), elems); // Add the old object onto the stack (as a reference)

      ret.prevObject = this; // Return the newly-formed element set

      return ret;
    },
    // Execute a callback for every element in the matched set.
    each: function each(callback) {
      return jQuery.each(this, callback);
    },
    map: function map(callback) {
      return this.pushStack(jQuery.map(this, function (elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function slice() {
      return this.pushStack(_slice.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    even: function even() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return (i + 1) % 2;
      }));
    },
    odd: function odd() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return i % 2;
      }));
    },
    eq: function eq(i) {
      var len = this.length,
          j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor();
    },
    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };

  jQuery.extend = jQuery.fn.extend = function () {
    var options,
        name,
        src,
        copy,
        copyIsArray,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false; // Handle a deep copy situation

    if (typeof target === "boolean") {
      deep = target; // Skip the boolean and the target

      target = arguments[i] || {};
      i++;
    } // Handle case when target is a string or something (possible in deep copy)


    if (_typeof(target) !== "object" && !isFunction(target)) {
      target = {};
    } // Extend jQuery itself if only one argument is passed


    if (i === length) {
      target = this;
      i--;
    }

    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
        // Extend the base object
        for (name in options) {
          copy = options[name]; // Prevent Object.prototype pollution
          // Prevent never-ending loop

          if (name === "__proto__" || target === copy) {
            continue;
          } // Recurse if we're merging plain objects or arrays


          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            src = target[name]; // Ensure proper type for the source value

            if (copyIsArray && !Array.isArray(src)) {
              clone = [];
            } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
              clone = {};
            } else {
              clone = src;
            }

            copyIsArray = false; // Never move original objects, clone them

            target[name] = jQuery.extend(deep, clone, copy); // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    } // Return the modified object


    return target;
  };

  jQuery.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    // Assume jQuery is ready without the ready module
    isReady: true,
    error: function error(msg) {
      throw new Error(msg);
    },
    noop: function noop() {},
    isPlainObject: function isPlainObject(obj) {
      var proto, Ctor; // Detect obvious negatives
      // Use toString instead of jQuery.type to catch host objects

      if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
      }

      proto = getProto(obj); // Objects with no prototype (e.g., `Object.create( null )`) are plain

      if (!proto) {
        return true;
      } // Objects with prototype are plain iff they were constructed by a global Object function


      Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
      return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
    },
    isEmptyObject: function isEmptyObject(obj) {
      var name;

      for (name in obj) {
        return false;
      }

      return true;
    },
    // Evaluates a script in a provided context; falls back to the global one
    // if not specified.
    globalEval: function globalEval(code, options, doc) {
      DOMEval(code, {
        nonce: options && options.nonce
      }, doc);
    },
    each: function each(obj, callback) {
      var length,
          i = 0;

      if (isArrayLike(obj)) {
        length = obj.length;

        for (; i < length; i++) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      } else {
        for (i in obj) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      }

      return obj;
    },
    // results is for internal usage only
    makeArray: function makeArray(arr, results) {
      var ret = results || [];

      if (arr != null) {
        if (isArrayLike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }

      return ret;
    },
    inArray: function inArray(elem, arr, i) {
      return arr == null ? -1 : indexOf.call(arr, elem, i);
    },
    // Support: Android <=4.0 only, PhantomJS 1 only
    // push.apply(_, arraylike) throws on ancient WebKit
    merge: function merge(first, second) {
      var len = +second.length,
          j = 0,
          i = first.length;

      for (; j < len; j++) {
        first[i++] = second[j];
      }

      first.length = i;
      return first;
    },
    grep: function grep(elems, callback, invert) {
      var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert; // Go through the array, only saving the items
      // that pass the validator function

      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);

        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }

      return matches;
    },
    // arg is for internal usage only
    map: function map(elems, callback, arg) {
      var length,
          value,
          i = 0,
          ret = []; // Go through the array, translating each of the items to their new values

      if (isArrayLike(elems)) {
        length = elems.length;

        for (; i < length; i++) {
          value = callback(elems[i], i, arg);

          if (value != null) {
            ret.push(value);
          }
        } // Go through every key on the object,

      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);

          if (value != null) {
            ret.push(value);
          }
        }
      } // Flatten any nested arrays


      return flat(ret);
    },
    // A global GUID counter for objects
    guid: 1,
    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  });

  if (typeof Symbol === "function") {
    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
  } // Populate the class2type map


  jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });

  function isArrayLike(obj) {
    // Support: real iOS 8.2 only (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = !!obj && "length" in obj && obj.length,
        type = toType(obj);

    if (isFunction(obj) || isWindow(obj)) {
      return false;
    }

    return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
  }

  var Sizzle =
  /*!
   * Sizzle CSS Selector Engine v2.3.10
   * https://sizzlejs.com/
   *
   * Copyright JS Foundation and other contributors
   * Released under the MIT license
   * https://js.foundation/
   *
   * Date: 2023-02-14
   */
  function (window) {
    var i,
        support,
        Expr,
        getText,
        isXML,
        tokenize,
        compile,
        select,
        outermostContext,
        sortInput,
        hasDuplicate,
        // Local document vars
    setDocument,
        document,
        docElem,
        documentIsHTML,
        rbuggyQSA,
        rbuggyMatches,
        matches,
        contains,
        // Instance-specific data
    expando = "sizzle" + 1 * new Date(),
        preferredDoc = window.document,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        nonnativeSelectorCache = createCache(),
        sortOrder = function sortOrder(a, b) {
      if (a === b) {
        hasDuplicate = true;
      }

      return 0;
    },
        // Instance methods
    hasOwn = {}.hasOwnProperty,
        arr = [],
        pop = arr.pop,
        pushNative = arr.push,
        push = arr.push,
        slice = arr.slice,
        // Use a stripped-down indexOf as it's faster than native
    // https://jsperf.com/thor-indexof-vs-for/5
    indexOf = function indexOf(list, elem) {
      var i = 0,
          len = list.length;

      for (; i < len; i++) {
        if (list[i] === elem) {
          return i;
        }
      }

      return -1;
    },
        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" + "ismap|loop|multiple|open|readonly|required|scoped",
        // Regular expressions
    // http://www.w3.org/TR/css3-selectors/#whitespace
    whitespace = "[\\x20\\t\\r\\n\\f]",
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
    attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
    // or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
        pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)",
        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"),
        rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
        rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
        rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
        rdescend = new RegExp(whitespace + "|>"),
        rpseudo = new RegExp(pseudos),
        ridentifier = new RegExp("^" + identifier + "$"),
        matchExpr = {
      "ID": new RegExp("^#(" + identifier + ")"),
      "CLASS": new RegExp("^\\.(" + identifier + ")"),
      "TAG": new RegExp("^(" + identifier + "|[*])"),
      "ATTR": new RegExp("^" + attributes),
      "PSEUDO": new RegExp("^" + pseudos),
      "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
      "bool": new RegExp("^(?:" + booleans + ")$", "i"),
      // For use in libraries implementing .is()
      // We use this for POS matching in `select`
      "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    },
        rhtml = /HTML$/i,
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,
        rnative = /^[^{]+\{\s*\[native \w/,
        // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        rsibling = /[+~]/,
        // CSS escapes
    // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
        funescape = function funescape(escape, nonHex) {
      var high = "0x" + escape.slice(1) - 0x10000;
      return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
      nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
      // Support: IE <=11+
      // For values outside the Basic Multilingual Plane (BMP), manually construct a
      // surrogate pair
      high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    },
        // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        fcssescape = function fcssescape(ch, asCodePoint) {
      if (asCodePoint) {
        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
        if (ch === "\0") {
          return "\uFFFD";
        } // Control characters and (dependent upon position) numbers get escaped as code points


        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
      } // Other potentially-special ASCII characters get backslash-escaped


      return "\\" + ch;
    },
        // Used for iframes
    // See setDocument()
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE
    unloadHandler = function unloadHandler() {
      setDocument();
    },
        inDisabledFieldset = addCombinator(function (elem) {
      return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
    }, {
      dir: "parentNode",
      next: "legend"
    }); // Optimize for push.apply( _, NodeList )


    try {
      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes); // Support: Android<4.0
      // Detect silently failing push.apply
      // eslint-disable-next-line no-unused-expressions

      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {
        apply: arr.length ? // Leverage slice if possible
        function (target, els) {
          pushNative.apply(target, slice.call(els));
        } : // Support: IE<9
        // Otherwise append directly
        function (target, els) {
          var j = target.length,
              i = 0; // Can't trust NodeList.length

          while (target[j++] = els[i++]) {}

          target.length = j - 1;
        }
      };
    }

    function Sizzle(selector, context, results, seed) {
      var m,
          i,
          elem,
          nid,
          match,
          groups,
          newSelector,
          newContext = context && context.ownerDocument,
          // nodeType defaults to 9, since context defaults to document
      nodeType = context ? context.nodeType : 9;
      results = results || []; // Return early from calls with invalid selector or context

      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      } // Try to shortcut find operations (as opposed to filters) in HTML documents


      if (!seed) {
        setDocument(context);
        context = context || document;

        if (documentIsHTML) {
          // If the selector is sufficiently simple, try using a "get*By*" DOM method
          // (excepting DocumentFragment context, where the methods don't exist)
          if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
            // ID selector
            if (m = match[1]) {
              // Document context
              if (nodeType === 9) {
                if (elem = context.getElementById(m)) {
                  // Support: IE, Opera, Webkit
                  // TODO: identify versions
                  // getElementById can match elements by name instead of ID
                  if (elem.id === m) {
                    results.push(elem);
                    return results;
                  }
                } else {
                  return results;
                } // Element context

              } else {
                // Support: IE, Opera, Webkit
                // TODO: identify versions
                // getElementById can match elements by name instead of ID
                if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                  results.push(elem);
                  return results;
                }
              } // Type selector

            } else if (match[2]) {
              push.apply(results, context.getElementsByTagName(selector));
              return results; // Class selector
            } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
              push.apply(results, context.getElementsByClassName(m));
              return results;
            }
          } // Take advantage of querySelectorAll


          if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && ( // Support: IE 8 only
          // Exclude object elements
          nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
            newSelector = selector;
            newContext = context; // qSA considers elements outside a scoping root when evaluating child or
            // descendant combinators, which is not what we want.
            // In such cases, we work around the behavior by prefixing every selector in the
            // list with an ID selector referencing the scope context.
            // The technique has to be used as well when a leading combinator is used
            // as such selectors are not recognized by querySelectorAll.
            // Thanks to Andrew Dupont for this technique.

            if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
              // Expand context for sibling selectors
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context; // We can use :scope instead of the ID hack if the browser
              // supports it & if we're not changing the context.

              if (newContext !== context || !support.scope) {
                // Capture the context ID, setting it first if necessary
                if (nid = context.getAttribute("id")) {
                  nid = nid.replace(rcssescape, fcssescape);
                } else {
                  context.setAttribute("id", nid = expando);
                }
              } // Prefix every selector in the list


              groups = tokenize(selector);
              i = groups.length;

              while (i--) {
                groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
              }

              newSelector = groups.join(",");
            }

            try {
              push.apply(results, newContext.querySelectorAll(newSelector));
              return results;
            } catch (qsaError) {
              nonnativeSelectorCache(selector, true);
            } finally {
              if (nid === expando) {
                context.removeAttribute("id");
              }
            }
          }
        }
      } // All others


      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }
    /**
     * Create key-value caches of limited size
     * @returns {function(string, object)} Returns the Object data after storing it on itself with
     *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
     *	deleting the oldest entry
     */


    function createCache() {
      var keys = [];

      function cache(key, value) {
        // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
        if (keys.push(key + " ") > Expr.cacheLength) {
          // Only keep the most recent entries
          delete cache[keys.shift()];
        }

        return cache[key + " "] = value;
      }

      return cache;
    }
    /**
     * Mark a function for special use by Sizzle
     * @param {Function} fn The function to mark
     */


    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }
    /**
     * Support testing using an element
     * @param {Function} fn Passed the created element and returns a boolean result
     */


    function assert(fn) {
      var el = document.createElement("fieldset");

      try {
        return !!fn(el);
      } catch (e) {
        return false;
      } finally {
        // Remove from its parent by default
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        } // release memory in IE


        el = null;
      }
    }
    /**
     * Adds the same handler for all of the specified attrs
     * @param {String} attrs Pipe-separated list of attributes
     * @param {Function} handler The method that will be applied
     */


    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
          i = arr.length;

      while (i--) {
        Expr.attrHandle[arr[i]] = handler;
      }
    }
    /**
     * Checks document order of two siblings
     * @param {Element} a
     * @param {Element} b
     * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
     */


    function siblingCheck(a, b) {
      var cur = b && a,
          diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex; // Use IE sourceIndex if available on both nodes

      if (diff) {
        return diff;
      } // Check if b follows a


      if (cur) {
        while (cur = cur.nextSibling) {
          if (cur === b) {
            return -1;
          }
        }
      }

      return a ? 1 : -1;
    }
    /**
     * Returns a function to use in pseudos for input types
     * @param {String} type
     */


    function createInputPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }
    /**
     * Returns a function to use in pseudos for buttons
     * @param {String} type
     */


    function createButtonPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }
    /**
     * Returns a function to use in pseudos for :enabled/:disabled
     * @param {Boolean} disabled true for :disabled; false for :enabled
     */


    function createDisabledPseudo(disabled) {
      // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
      return function (elem) {
        // Only certain elements can match :enabled or :disabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
        if ("form" in elem) {
          // Check for inherited disabledness on relevant non-disabled elements:
          // * listed form-associated elements in a disabled fieldset
          //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
          // * option elements in a disabled optgroup
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
          // All such elements have a "form" property.
          if (elem.parentNode && elem.disabled === false) {
            // Option elements defer to a parent optgroup if present
            if ("label" in elem) {
              if ("label" in elem.parentNode) {
                return elem.parentNode.disabled === disabled;
              } else {
                return elem.disabled === disabled;
              }
            } // Support: IE 6 - 11
            // Use the isDisabled shortcut property to check for disabled fieldset ancestors


            return elem.isDisabled === disabled || // Where there is no isDisabled, check manually

            /* jshint -W018 */
            elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
          }

          return elem.disabled === disabled; // Try to winnow out elements that can't be disabled before trusting the disabled property.
          // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
          // even exist on them, let alone have a boolean value.
        } else if ("label" in elem) {
          return elem.disabled === disabled;
        } // Remaining elements are neither :enabled nor :disabled


        return false;
      };
    }
    /**
     * Returns a function to use in pseudos for positionals
     * @param {Function} fn
     */


    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        argument = +argument;
        return markFunction(function (seed, matches) {
          var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length; // Match elements found at the specified indexes

          while (i--) {
            if (seed[j = matchIndexes[i]]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }
    /**
     * Checks a node for validity as a Sizzle context
     * @param {Element|Object=} context
     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
     */


    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    } // Expose support vars for convenience


    support = Sizzle.support = {};
    /**
     * Detects XML nodes
     * @param {Element|Object} elem An element or a document
     * @returns {Boolean} True iff elem is a non-HTML XML node
     */

    isXML = Sizzle.isXML = function (elem) {
      var namespace = elem && elem.namespaceURI,
          docElem = elem && (elem.ownerDocument || elem).documentElement; // Support: IE <=8
      // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
      // https://bugs.jquery.com/ticket/4833

      return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
    };
    /**
     * Sets document-related variables once based on the current document
     * @param {Element|Object} [doc] An element or document object to use to set the document
     * @returns {Object} Returns the current document
     */


    setDocument = Sizzle.setDocument = function (node) {
      var hasCompare,
          subWindow,
          doc = node ? node.ownerDocument || node : preferredDoc; // Return early if doc is invalid or already selected
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq

      if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      } // Update global variables


      document = doc;
      docElem = document.documentElement;
      documentIsHTML = !isXML(document); // Support: IE 9 - 11+, Edge 12 - 18+
      // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq

      if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
        // Support: IE 11, Edge
        if (subWindow.addEventListener) {
          subWindow.addEventListener("unload", unloadHandler, false); // Support: IE 9 - 10 only
        } else if (subWindow.attachEvent) {
          subWindow.attachEvent("onunload", unloadHandler);
        }
      } // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
      // Safari 4 - 5 only, Opera <=11.6 - 12.x only
      // IE/Edge & older browsers don't support the :scope pseudo-class.
      // Support: Safari 6.0 only
      // Safari 6.0 supports :scope but it's an alias of :root there.


      support.scope = assert(function (el) {
        docElem.appendChild(el).appendChild(document.createElement("div"));
        return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
      }); // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
      // Make sure the the `:has()` argument is parsed unforgivingly.
      // We include `*` in the test to detect buggy implementations that are
      // _selectively_ forgiving (specifically when the list includes at least
      // one valid selector).
      // Note that we treat complete lack of support for `:has()` as if it were
      // spec-compliant support, which is fine because use of `:has()` in such
      // environments will fail in the qSA path and fall back to jQuery traversal
      // anyway.

      support.cssHas = assert(function () {
        try {
          document.querySelector(":has(*,:jqfake)");
          return false;
        } catch (e) {
          return true;
        }
      });
      /* Attributes
      ---------------------------------------------------------------------- */
      // Support: IE<8
      // Verify that getAttribute really returns attributes and not properties
      // (excepting IE8 booleans)

      support.attributes = assert(function (el) {
        el.className = "i";
        return !el.getAttribute("className");
      });
      /* getElement(s)By*
      ---------------------------------------------------------------------- */
      // Check if getElementsByTagName("*") returns only elements

      support.getElementsByTagName = assert(function (el) {
        el.appendChild(document.createComment(""));
        return !el.getElementsByTagName("*").length;
      }); // Support: IE<9

      support.getElementsByClassName = rnative.test(document.getElementsByClassName); // Support: IE<10
      // Check if getElementById returns elements by name
      // The broken getElementById methods don't pick up programmatically-set names,
      // so use a roundabout getElementsByName test

      support.getById = assert(function (el) {
        docElem.appendChild(el).id = expando;
        return !document.getElementsByName || !document.getElementsByName(expando).length;
      }); // ID filter and find

      if (support.getById) {
        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            return elem.getAttribute("id") === attrId;
          };
        };

        Expr.find["ID"] = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var elem = context.getElementById(id);
            return elem ? [elem] : [];
          }
        };
      } else {
        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        }; // Support: IE 6 - 7 only
        // getElementById is not reliable as a find shortcut


        Expr.find["ID"] = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var node,
                i,
                elems,
                elem = context.getElementById(id);

            if (elem) {
              // Verify the id attribute
              node = elem.getAttributeNode("id");

              if (node && node.value === id) {
                return [elem];
              } // Fall back on getElementsByName


              elems = context.getElementsByName(id);
              i = 0;

              while (elem = elems[i++]) {
                node = elem.getAttributeNode("id");

                if (node && node.value === id) {
                  return [elem];
                }
              }
            }

            return [];
          }
        };
      } // Tag


      Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag); // DocumentFragment nodes don't have gEBTN
        } else if (support.qsa) {
          return context.querySelectorAll(tag);
        }
      } : function (tag, context) {
        var elem,
            tmp = [],
            i = 0,
            // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
        results = context.getElementsByTagName(tag); // Filter out possible comments

        if (tag === "*") {
          while (elem = results[i++]) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }

          return tmp;
        }

        return results;
      }; // Class

      Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };
      /* QSA/matchesSelector
      ---------------------------------------------------------------------- */
      // QSA and matchesSelector support
      // matchesSelector(:active) reports false when true (IE9/Opera 11.5)


      rbuggyMatches = []; // qSa(:focus) reports false when true (Chrome 21)
      // We allow this because of a bug in IE8/9 that throws an error
      // whenever `document.activeElement` is accessed on an iframe
      // So, we allow :focus to pass through QSA all the time to avoid the IE error
      // See https://bugs.jquery.com/ticket/13378

      rbuggyQSA = [];

      if (support.qsa = rnative.test(document.querySelectorAll)) {
        // Build QSA regex
        // Regex strategy adopted from Diego Perini
        assert(function (el) {
          var input; // Select is set to empty string on purpose
          // This is to test IE's treatment of not explicitly
          // setting a boolean content attribute,
          // since its presence should be enough
          // https://bugs.jquery.com/ticket/12359

          docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>"; // Support: IE8, Opera 11-12.16
          // Nothing should be selected when empty strings follow ^= or $= or *=
          // The test attribute must be unknown in Opera but "safe" for WinRT
          // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section

          if (el.querySelectorAll("[msallowcapture^='']").length) {
            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
          } // Support: IE8
          // Boolean attributes and "value" are not treated correctly


          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          } // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+


          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          } // Support: IE 11+, Edge 15 - 18+
          // IE 11/Edge don't find elements on a `[name='']` query in some cases.
          // Adding a temporary attribute to the document before the selection works
          // around the issue.
          // Interestingly, IE 10 & older don't seem to have the issue.


          input = document.createElement("input");
          input.setAttribute("name", "");
          el.appendChild(input);

          if (!el.querySelectorAll("[name='']").length) {
            rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
          } // Webkit/Opera - :checked should return selected option elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          // IE8 throws error here and will not see later tests


          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          } // Support: Safari 8+, iOS 8+
          // https://bugs.webkit.org/show_bug.cgi?id=136851
          // In-page `selector#id sibling-combinator selector` fails


          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          } // Support: Firefox <=3.6 - 5 only
          // Old Firefox doesn't throw on a badly-escaped identifier.


          el.querySelectorAll("\\\f");
          rbuggyQSA.push("[\\r\\n\\f]");
        });
        assert(function (el) {
          el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>"; // Support: Windows 8 Native Apps
          // The type and name attributes are restricted during .innerHTML assignment

          var input = document.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D"); // Support: IE8
          // Enforce case-sensitivity of name attribute

          if (el.querySelectorAll("[name=d]").length) {
            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
          } // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
          // IE8 throws error here and will not see later tests


          if (el.querySelectorAll(":enabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          } // Support: IE9-11+
          // IE's :disabled selector does not pick up the children of disabled fieldsets


          docElem.appendChild(el).disabled = true;

          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          } // Support: Opera 10 - 11 only
          // Opera 10-11 does not throw on post-comma invalid pseudos


          el.querySelectorAll("*,:x");
          rbuggyQSA.push(",.*:");
        });
      }

      if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
        assert(function (el) {
          // Check to see if it's possible to do matchesSelector
          // on a disconnected node (IE 9)
          support.disconnectedMatch = matches.call(el, "*"); // This should fail with an exception
          // Gecko does not error, returns false instead

          matches.call(el, "[s!='']:x");
          rbuggyMatches.push("!=", pseudos);
        });
      }

      if (!support.cssHas) {
        // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
        // Our regular `try-catch` mechanism fails to detect natively-unsupported
        // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
        // in browsers that parse the `:has()` argument as a forgiving selector list.
        // https://drafts.csswg.org/selectors/#relational now requires the argument
        // to be parsed unforgivingly, but browsers have not yet fully adjusted.
        rbuggyQSA.push(":has");
      }

      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
      /* Contains
      ---------------------------------------------------------------------- */

      hasCompare = rnative.test(docElem.compareDocumentPosition); // Element contains another
      // Purposefully self-exclusive
      // As in, an element does not contain itself

      contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
        // Support: IE <9 only
        // IE doesn't have `contains` on `document` so we need to check for
        // `documentElement` presence.
        // We need to fall back to `a` when `documentElement` is missing
        // as `ownerDocument` of elements within `<template/>` may have
        // a null one - a default behavior of all modern browsers.
        var adown = a.nodeType === 9 && a.documentElement || a,
            bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function (a, b) {
        if (b) {
          while (b = b.parentNode) {
            if (b === a) {
              return true;
            }
          }
        }

        return false;
      };
      /* Sorting
      ---------------------------------------------------------------------- */
      // Document order sorting

      sortOrder = hasCompare ? function (a, b) {
        // Flag for duplicate removal
        if (a === b) {
          hasDuplicate = true;
          return 0;
        } // Sort on method existence if only one input has compareDocumentPosition


        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;

        if (compare) {
          return compare;
        } // Calculate position if both inputs belong to the same document
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq


        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1; // Disconnected nodes

        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
          // Choose the first element that is related to our preferred document
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) {
            return -1;
          } // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq


          if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) {
            return 1;
          } // Maintain original order


          return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
        }

        return compare & 4 ? -1 : 1;
      } : function (a, b) {
        // Exit early if the nodes are identical
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }

        var cur,
            i = 0,
            aup = a.parentNode,
            bup = b.parentNode,
            ap = [a],
            bp = [b]; // Parentless nodes are either documents or disconnected

        if (!aup || !bup) {
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.

          /* eslint-disable eqeqeq */
          return a == document ? -1 : b == document ? 1 :
          /* eslint-enable eqeqeq */
          aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0; // If the nodes are siblings, we can do a quick check
        } else if (aup === bup) {
          return siblingCheck(a, b);
        } // Otherwise we need full lists of their ancestors for comparison


        cur = a;

        while (cur = cur.parentNode) {
          ap.unshift(cur);
        }

        cur = b;

        while (cur = cur.parentNode) {
          bp.unshift(cur);
        } // Walk down the tree looking for a discrepancy


        while (ap[i] === bp[i]) {
          i++;
        }

        return i ? // Do a sibling check if the nodes have a common ancestor
        siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.

        /* eslint-disable eqeqeq */
        ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 :
        /* eslint-enable eqeqeq */
        0;
      };
      return document;
    };

    Sizzle.matches = function (expr, elements) {
      return Sizzle(expr, null, null, elements);
    };

    Sizzle.matchesSelector = function (elem, expr) {
      setDocument(elem);

      if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr); // IE 9's matchesSelector returns false on disconnected nodes

          if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
          // fragment in IE 9
          elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {
          nonnativeSelectorCache(expr, true);
        }
      }

      return Sizzle(expr, document, null, [elem]).length > 0;
    };

    Sizzle.contains = function (context, elem) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((context.ownerDocument || context) != document) {
        setDocument(context);
      }

      return contains(context, elem);
    };

    Sizzle.attr = function (elem, name) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((elem.ownerDocument || elem) != document) {
        setDocument(elem);
      }

      var fn = Expr.attrHandle[name.toLowerCase()],
          // Don't get fooled by Object.prototype properties (jQuery #13807)
      val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };

    Sizzle.escape = function (sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };

    Sizzle.error = function (msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };
    /**
     * Document sorting and removing duplicates
     * @param {ArrayLike} results
     */


    Sizzle.uniqueSort = function (results) {
      var elem,
          duplicates = [],
          j = 0,
          i = 0; // Unless we *know* we can detect duplicates, assume their presence

      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);

      if (hasDuplicate) {
        while (elem = results[i++]) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }

        while (j--) {
          results.splice(duplicates[j], 1);
        }
      } // Clear input after sorting to release objects
      // See https://github.com/jquery/sizzle/pull/225


      sortInput = null;
      return results;
    };
    /**
     * Utility function for retrieving the text value of an array of DOM nodes
     * @param {Array|Element} elem
     */


    getText = Sizzle.getText = function (elem) {
      var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;

      if (!nodeType) {
        // If no nodeType, this is expected to be an array
        while (node = elem[i++]) {
          // Do not traverse comment nodes
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        // Use textContent for elements
        // innerText usage removed for consistency of new lines (jQuery #11153)
        if (typeof elem.textContent === "string") {
          return elem.textContent;
        } else {
          // Traverse its children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      } // Do not include comment or processing instruction nodes


      return ret;
    };

    Expr = Sizzle.selectors = {
      // Can be adjusted by the user
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        "ATTR": function ATTR(match) {
          match[1] = match[1].replace(runescape, funescape); // Move the given value to match[3] whether quoted or unquoted

          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }

          return match.slice(0, 4);
        },
        "CHILD": function CHILD(match) {
          /* matches from matchExpr["CHILD"]
          	1 type (only|nth|...)
          	2 what (child|of-type)
          	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
          	4 xn-component of xn+y argument ([+-]?\d*n|)
          	5 sign of xn-component
          	6 x of xn-component
          	7 sign of y-component
          	8 y of y-component
          */
          match[1] = match[1].toLowerCase();

          if (match[1].slice(0, 3) === "nth") {
            // nth-* requires argument
            if (!match[3]) {
              Sizzle.error(match[0]);
            } // numeric x and y parameters for Expr.filter.CHILD
            // remember that false/true cast respectively to 0/1


            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +(match[7] + match[8] || match[3] === "odd"); // other types prohibit arguments
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }

          return match;
        },
        "PSEUDO": function PSEUDO(match) {
          var excess,
              unquoted = !match[6] && match[2];

          if (matchExpr["CHILD"].test(match[0])) {
            return null;
          } // Accept quoted arguments as-is


          if (match[3]) {
            match[2] = match[4] || match[5] || ""; // Strip excess characters from unquoted arguments
          } else if (unquoted && rpseudo.test(unquoted) && ( // Get excess from tokenize (recursively)
          excess = tokenize(unquoted, true)) && ( // advance to the next closing parenthesis
          excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            // excess is a negative index
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          } // Return only captures needed by the pseudo filter method (type and argument)


          return match.slice(0, 3);
        }
      },
      filter: {
        "TAG": function TAG(nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function () {
            return true;
          } : function (elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        "CLASS": function CLASS(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        "ATTR": function ATTR(name, operator, check) {
          return function (elem) {
            var result = Sizzle.attr(elem, name);

            if (result == null) {
              return operator === "!=";
            }

            if (!operator) {
              return true;
            }

            result += "";
            /* eslint-disable max-len */

            return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
            /* eslint-enable max-len */
          };
        },
        "CHILD": function CHILD(type, what, _argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
              forward = type.slice(-4) !== "last",
              ofType = what === "of-type";
          return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
          function (elem) {
            return !!elem.parentNode;
          } : function (elem, _context, xml) {
            var cache,
                uniqueCache,
                outerCache,
                node,
                nodeIndex,
                start,
                dir = simple !== forward ? "nextSibling" : "previousSibling",
                parent = elem.parentNode,
                name = ofType && elem.nodeName.toLowerCase(),
                useCache = !xml && !ofType,
                diff = false;

            if (parent) {
              // :(first|last|only)-(child|of-type)
              if (simple) {
                while (dir) {
                  node = elem;

                  while (node = node[dir]) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  } // Reverse direction for :only-* (if we haven't yet done so)


                  start = dir = type === "only" && !start && "nextSibling";
                }

                return true;
              }

              start = [forward ? parent.firstChild : parent.lastChild]; // non-xml :nth-child(...) stores cache data on `parent`

              if (forward && useCache) {
                // Seek `elem` from a previously-cached index
                // ...in a gzip-friendly way
                node = parent;
                outerCache = node[expando] || (node[expando] = {}); // Support: IE <9 only
                // Defend against cloned attroperties (jQuery gh-1709)

                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                cache = uniqueCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = nodeIndex && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];

                while (node = ++nodeIndex && node && node[dir] || ( // Fallback to seeking `elem` from the start
                diff = nodeIndex = 0) || start.pop()) {
                  // When found, cache indexes on `parent` and break
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    uniqueCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                }
              } else {
                // Use previously-cached element index if available
                if (useCache) {
                  // ...in a gzip-friendly way
                  node = elem;
                  outerCache = node[expando] || (node[expando] = {}); // Support: IE <9 only
                  // Defend against cloned attroperties (jQuery gh-1709)

                  uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                  cache = uniqueCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex;
                } // xml :nth-child(...)
                // or :nth-last-child(...) or :nth(-last)?-of-type(...)


                if (diff === false) {
                  // Use the same loop as above to seek `elem` from the start
                  while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                      // Cache the index of each encountered element
                      if (useCache) {
                        outerCache = node[expando] || (node[expando] = {}); // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)

                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                        uniqueCache[type] = [dirruns, diff];
                      }

                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
              } // Incorporate the offset, then check against cycle size


              diff -= last;
              return diff === first || diff % first === 0 && diff / first >= 0;
            }
          };
        },
        "PSEUDO": function PSEUDO(pseudo, argument) {
          // pseudo-class names are case-insensitive
          // http://www.w3.org/TR/selectors/#pseudo-classes
          // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
          // Remember that setFilters inherits from pseudos
          var args,
              fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo); // The user may use createPseudo to indicate that
          // arguments are needed to create the filter function
          // just as Sizzle does

          if (fn[expando]) {
            return fn(argument);
          } // But maintain support for old signatures


          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
              var idx,
                  matched = fn(seed, argument),
                  i = matched.length;

              while (i--) {
                idx = indexOf(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function (elem) {
              return fn(elem, 0, args);
            };
          }

          return fn;
        }
      },
      pseudos: {
        // Potentially complex pseudos
        "not": markFunction(function (selector) {
          // Trim the selector passed to compile
          // to avoid treating leading and trailing
          // spaces as combinators
          var input = [],
              results = [],
              matcher = compile(selector.replace(rtrim, "$1"));
          return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
            var elem,
                unmatched = matcher(seed, null, xml, []),
                i = seed.length; // Match elements unmatched by `matcher`

            while (i--) {
              if (elem = unmatched[i]) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function (elem, _context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results); // Don't keep the element (issue #299)

            input[0] = null;
            return !results.pop();
          };
        }),
        "has": markFunction(function (selector) {
          return function (elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        "contains": markFunction(function (text) {
          text = text.replace(runescape, funescape);
          return function (elem) {
            return (elem.textContent || getText(elem)).indexOf(text) > -1;
          };
        }),
        // "Whether an element is represented by a :lang() selector
        // is based solely on the element's language value
        // being equal to the identifier C,
        // or beginning with the identifier C immediately followed by "-".
        // The matching of C against the element's language value is performed case-insensitively.
        // The identifier C does not have to be a valid language name."
        // http://www.w3.org/TR/selectors/#lang-pseudo
        "lang": markFunction(function (lang) {
          // lang value must be a valid identifier
          if (!ridentifier.test(lang || "")) {
            Sizzle.error("unsupported lang: " + lang);
          }

          lang = lang.replace(runescape, funescape).toLowerCase();
          return function (elem) {
            var elemLang;

            do {
              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);

            return false;
          };
        }),
        // Miscellaneous
        "target": function target(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        "root": function root(elem) {
          return elem === docElem;
        },
        "focus": function focus(elem) {
          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        // Boolean properties
        "enabled": createDisabledPseudo(false),
        "disabled": createDisabledPseudo(true),
        "checked": function checked(elem) {
          // In CSS3, :checked should return both checked and selected elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          var nodeName = elem.nodeName.toLowerCase();
          return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
        },
        "selected": function selected(elem) {
          // Accessing this property makes selected-by-default
          // options in Safari work properly
          if (elem.parentNode) {
            // eslint-disable-next-line no-unused-expressions
            elem.parentNode.selectedIndex;
          }

          return elem.selected === true;
        },
        // Contents
        "empty": function empty(elem) {
          // http://www.w3.org/TR/selectors/#empty-pseudo
          // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
          //   but not by others (comment: 8; processing instruction: 7; etc.)
          // nodeType < 6 works because attributes (2) do not appear as children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }

          return true;
        },
        "parent": function parent(elem) {
          return !Expr.pseudos["empty"](elem);
        },
        // Element/input types
        "header": function header(elem) {
          return rheader.test(elem.nodeName);
        },
        "input": function input(elem) {
          return rinputs.test(elem.nodeName);
        },
        "button": function button(elem) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === "button" || name === "button";
        },
        "text": function text(elem) {
          var attr;
          return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && ( // Support: IE <10 only
          // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
          (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        // Position-in-collection
        "first": createPositionalPseudo(function () {
          return [0];
        }),
        "last": createPositionalPseudo(function (_matchIndexes, length) {
          return [length - 1];
        }),
        "eq": createPositionalPseudo(function (_matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        "even": createPositionalPseudo(function (matchIndexes, length) {
          var i = 0;

          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "odd": createPositionalPseudo(function (matchIndexes, length) {
          var i = 1;

          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument > length ? length : argument;

          for (; --i >= 0;) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;

          for (; ++i < length;) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        })
      }
    };
    Expr.pseudos["nth"] = Expr.pseudos["eq"]; // Add button/input type pseudos

    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }

    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    } // Easy API for creating new setFilters


    function setFilters() {}

    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();

    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
      var matched,
          match,
          tokens,
          type,
          soFar,
          groups,
          preFilters,
          cached = tokenCache[selector + " "];

      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }

      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;

      while (soFar) {
        // Comma and first run
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            // Don't consume trailing commas as valid
            soFar = soFar.slice(match[0].length) || soFar;
          }

          groups.push(tokens = []);
        }

        matched = false; // Combinators

        if (match = rleadingCombinator.exec(soFar)) {
          matched = match.shift();
          tokens.push({
            value: matched,
            // Cast descendant combinators to space
            type: match[0].replace(rtrim, " ")
          });
          soFar = soFar.slice(matched.length);
        } // Filters


        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }

        if (!matched) {
          break;
        }
      } // Return the length of the invalid excess
      // if we're just parsing
      // Otherwise, throw an error or return tokens


      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
      tokenCache(selector, groups).slice(0);
    };

    function toSelector(tokens) {
      var i = 0,
          len = tokens.length,
          selector = "";

      for (; i < len; i++) {
        selector += tokens[i].value;
      }

      return selector;
    }

    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
          skip = combinator.next,
          key = skip || dir,
          checkNonElements = base && key === "parentNode",
          doneName = done++;
      return combinator.first ? // Check against closest ancestor/preceding element
      function (elem, context, xml) {
        while (elem = elem[dir]) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }

        return false;
      } : // Check against all ancestor/preceding elements
      function (elem, context, xml) {
        var oldCache,
            uniqueCache,
            outerCache,
            newCache = [dirruns, doneName]; // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching

        if (xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {}); // Support: IE <9 only
              // Defend against cloned attroperties (jQuery gh-1709)

              uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

              if (skip && skip === elem.nodeName.toLowerCase()) {
                elem = elem[dir] || elem;
              } else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                // Assign to newCache so results back-propagate to previous elements
                return newCache[2] = oldCache[2];
              } else {
                // Reuse newcache so results back-propagate to previous elements
                uniqueCache[key] = newCache; // A match means we're done; a fail means we have to keep checking

                if (newCache[2] = matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          }
        }

        return false;
      };
    }

    function elementMatcher(matchers) {
      return matchers.length > 1 ? function (elem, context, xml) {
        var i = matchers.length;

        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }

        return true;
      } : matchers[0];
    }

    function multipleContexts(selector, contexts, results) {
      var i = 0,
          len = contexts.length;

      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }

      return results;
    }

    function condense(unmatched, map, filter, context, xml) {
      var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;

      for (; i < len; i++) {
        if (elem = unmatched[i]) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);

            if (mapped) {
              map.push(i);
            }
          }
        }
      }

      return newUnmatched;
    }

    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }

      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }

      return markFunction(function (seed, results, context, xml) {
        var temp,
            i,
            elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            // Get initial elements from seed or context
        elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
            // Prefilter to get matcher input, preserving a map for seed-results synchronization
        matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
            matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
        postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
        [] : // ...otherwise use results directly
        results : matcherIn; // Find primary matches

        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        } // Apply postFilter


        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml); // Un-match failing elements by moving them back to matcherIn

          i = temp.length;

          while (i--) {
            if (elem = temp[i]) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }

        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              // Get the final matcherOut by condensing this intermediate into postFinder contexts
              temp = [];
              i = matcherOut.length;

              while (i--) {
                if (elem = matcherOut[i]) {
                  // Restore matcherIn since elem is not yet a final match
                  temp.push(matcherIn[i] = elem);
                }
              }

              postFinder(null, matcherOut = [], temp, xml);
            } // Move matched elements from seed to results to keep them synchronized


            i = matcherOut.length;

            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          } // Add elements to results, through postFinder if defined

        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);

          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }

    function matcherFromTokens(tokens) {
      var checkContext,
          matcher,
          j,
          len = tokens.length,
          leadingRelative = Expr.relative[tokens[0].type],
          implicitRelative = leadingRelative || Expr.relative[" "],
          i = leadingRelative ? 1 : 0,
          // The foundational matcher ensures that elements are reachable from top-level context(s)
      matchContext = addCombinator(function (elem) {
        return elem === checkContext;
      }, implicitRelative, true),
          matchAnyContext = addCombinator(function (elem) {
        return indexOf(checkContext, elem) > -1;
      }, implicitRelative, true),
          matchers = [function (elem, context, xml) {
        var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml)); // Avoid hanging onto element (issue #299)

        checkContext = null;
        return ret;
      }];

      for (; i < len; i++) {
        if (matcher = Expr.relative[tokens[i].type]) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches); // Return special upon seeing a positional matcher

          if (matcher[expando]) {
            // Find the next relative operator (if any) for proper handling
            j = ++i;

            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }

            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector( // If the preceding token was a descendant combinator, insert an implicit any-element `*`
            tokens.slice(0, i - 1).concat({
              value: tokens[i - 2].type === " " ? "*" : ""
            })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
          }

          matchers.push(matcher);
        }
      }

      return elementMatcher(matchers);
    }

    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function superMatcher(seed, context, xml, results, outermost) {
        var elem,
            j,
            matcher,
            matchedCount = 0,
            i = "0",
            unmatched = seed && [],
            setMatched = [],
            contextBackup = outermostContext,
            // We must always have either seed elements or outermost context
        elems = seed || byElement && Expr.find["TAG"]("*", outermost),
            // Use integer dirruns iff this is the outermost matcher
        dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
            len = elems.length;

        if (outermost) {
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          outermostContext = context == document || context || outermost;
        } // Add elements passing elementMatchers directly to results
        // Support: IE<9, Safari
        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id


        for (; i !== len && (elem = elems[i]) != null; i++) {
          if (byElement && elem) {
            j = 0; // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq

            if (!context && elem.ownerDocument != document) {
              setDocument(elem);
              xml = !documentIsHTML;
            }

            while (matcher = elementMatchers[j++]) {
              if (matcher(elem, context || document, xml)) {
                results.push(elem);
                break;
              }
            }

            if (outermost) {
              dirruns = dirrunsUnique;
            }
          } // Track unmatched elements for set filters


          if (bySet) {
            // They will have gone through all possible matchers
            if (elem = !matcher && elem) {
              matchedCount--;
            } // Lengthen the array for every element, matched or not


            if (seed) {
              unmatched.push(elem);
            }
          }
        } // `i` is now the count of elements visited above, and adding it to `matchedCount`
        // makes the latter nonnegative.


        matchedCount += i; // Apply set filters to unmatched elements
        // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
        // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
        // no element matchers and no seed.
        // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
        // case, which will result in a "00" `matchedCount` that differs from `i` but is also
        // numerically zero.

        if (bySet && i !== matchedCount) {
          j = 0;

          while (matcher = setMatchers[j++]) {
            matcher(unmatched, setMatched, context, xml);
          }

          if (seed) {
            // Reintegrate element matches to eliminate the need for sorting
            if (matchedCount > 0) {
              while (i--) {
                if (!(unmatched[i] || setMatched[i])) {
                  setMatched[i] = pop.call(results);
                }
              }
            } // Discard index placeholder values to get only actual matches


            setMatched = condense(setMatched);
          } // Add matches to results


          push.apply(results, setMatched); // Seedless set matches succeeding multiple successful matchers stipulate sorting

          if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
            Sizzle.uniqueSort(results);
          }
        } // Override manipulation of globals by nested matchers


        if (outermost) {
          dirruns = dirrunsUnique;
          outermostContext = contextBackup;
        }

        return unmatched;
      };

      return bySet ? markFunction(superMatcher) : superMatcher;
    }

    compile = Sizzle.compile = function (selector, match
    /* Internal Use Only */
    ) {
      var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[selector + " "];

      if (!cached) {
        // Generate a function of recursive functions that can be used to check each element
        if (!match) {
          match = tokenize(selector);
        }

        i = match.length;

        while (i--) {
          cached = matcherFromTokens(match[i]);

          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        } // Cache the compiled function


        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers)); // Save selector and tokenization

        cached.selector = selector;
      }

      return cached;
    };
    /**
     * A low-level selection function that works with Sizzle's compiled
     *  selector functions
     * @param {String|Function} selector A selector or a pre-compiled
     *  selector function built with Sizzle.compile
     * @param {Element} context
     * @param {Array} [results]
     * @param {Array} [seed] A set of elements to match against
     */


    select = Sizzle.select = function (selector, context, results, seed) {
      var i,
          tokens,
          token,
          type,
          find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize(selector = compiled.selector || selector);
      results = results || []; // Try to minimize operations if there is only one selector in the list and no seed
      // (the latter of which guarantees us context)

      if (match.length === 1) {
        // Reduce context if the leading compound selector is an ID
        tokens = match[0] = match[0].slice(0);

        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];

          if (!context) {
            return results; // Precompiled matchers will still verify ancestry, so step up a level
          } else if (compiled) {
            context = context.parentNode;
          }

          selector = selector.slice(tokens.shift().value.length);
        } // Fetch a seed set for right-to-left matching


        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;

        while (i--) {
          token = tokens[i]; // Abort if we hit a combinator

          if (Expr.relative[type = token.type]) {
            break;
          }

          if (find = Expr.find[type]) {
            // Search, expanding context for leading sibling combinators
            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
              // If seed is empty or no tokens remain, we can return early
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);

              if (!selector) {
                push.apply(results, seed);
                return results;
              }

              break;
            }
          }
        }
      } // Compile and execute a filtering function if one is not provided
      // Provide `match` to avoid retokenization if we modified the selector above


      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    }; // One-time assignments
    // Sort stability


    support.sortStable = expando.split("").sort(sortOrder).join("") === expando; // Support: Chrome 14-35+
    // Always assume duplicates if they aren't passed to the comparison function

    support.detectDuplicates = !!hasDuplicate; // Initialize against the default document

    setDocument(); // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
    // Detached nodes confoundingly follow *each other*

    support.sortDetached = assert(function (el) {
      // Should return 1, but returns 4 (following)
      return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
    }); // Support: IE<8
    // Prevent attribute/property "interpolation"
    // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx

    if (!assert(function (el) {
      el.innerHTML = "<a href='#'></a>";
      return el.firstChild.getAttribute("href") === "#";
    })) {
      addHandle("type|href|height|width", function (elem, name, isXML) {
        if (!isXML) {
          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }
      });
    } // Support: IE<9
    // Use defaultValue in place of getAttribute("value")


    if (!support.attributes || !assert(function (el) {
      el.innerHTML = "<input/>";
      el.firstChild.setAttribute("value", "");
      return el.firstChild.getAttribute("value") === "";
    })) {
      addHandle("value", function (elem, _name, isXML) {
        if (!isXML && elem.nodeName.toLowerCase() === "input") {
          return elem.defaultValue;
        }
      });
    } // Support: IE<9
    // Use getAttributeNode to fetch booleans when getAttribute lies


    if (!assert(function (el) {
      return el.getAttribute("disabled") == null;
    })) {
      addHandle(booleans, function (elem, name, isXML) {
        var val;

        if (!isXML) {
          return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        }
      });
    }

    return Sizzle;
  }(window);

  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors; // Deprecated

  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  jQuery.escapeSelector = Sizzle.escape;

  var dir = function dir(elem, _dir, until) {
    var matched = [],
        truncate = until !== undefined;

    while ((elem = elem[_dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        if (truncate && jQuery(elem).is(until)) {
          break;
        }

        matched.push(elem);
      }
    }

    return matched;
  };

  var _siblings = function siblings(n, elem) {
    var matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }

    return matched;
  };

  var rneedsContext = jQuery.expr.match.needsContext;

  function nodeName(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  }

  var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i; // Implement the identical functionality for filter and not

  function winnow(elements, qualifier, not) {
    if (isFunction(qualifier)) {
      return jQuery.grep(elements, function (elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    } // Single element


    if (qualifier.nodeType) {
      return jQuery.grep(elements, function (elem) {
        return elem === qualifier !== not;
      });
    } // Arraylike of elements (jQuery, arguments, Array)


    if (typeof qualifier !== "string") {
      return jQuery.grep(elements, function (elem) {
        return indexOf.call(qualifier, elem) > -1 !== not;
      });
    } // Filtered directly for both simple and complex selectors


    return jQuery.filter(qualifier, elements, not);
  }

  jQuery.filter = function (expr, elems, not) {
    var elem = elems[0];

    if (not) {
      expr = ":not(" + expr + ")";
    }

    if (elems.length === 1 && elem.nodeType === 1) {
      return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
    }

    return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
      return elem.nodeType === 1;
    }));
  };

  jQuery.fn.extend({
    find: function find(selector) {
      var i,
          ret,
          len = this.length,
          self = this;

      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function () {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }

      ret = this.pushStack([]);

      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      }

      return len > 1 ? jQuery.uniqueSort(ret) : ret;
    },
    filter: function filter(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function not(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function is(selector) {
      return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
      // so $("p:first").is("p:last") won't return true for a doc with two "p".
      typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  }); // Initialize a jQuery object
  // A central reference to the root jQuery(document)

  var rootjQuery,
      // A simple way to check for HTML strings
  // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
  // Strict HTML recognition (trac-11290: must start with <)
  // Shortcut simple #id case for speed
  rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
      init = jQuery.fn.init = function (selector, context, root) {
    var match, elem; // HANDLE: $(""), $(null), $(undefined), $(false)

    if (!selector) {
      return this;
    } // Method init() accepts an alternate rootjQuery
    // so migrate can support jQuery.sub (gh-2101)


    root = root || rootjQuery; // Handle HTML strings

    if (typeof selector === "string") {
      if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
        // Assume that strings that start and end with <> are HTML and skip the regex check
        match = [null, selector, null];
      } else {
        match = rquickExpr.exec(selector);
      } // Match html or make sure no context is specified for #id


      if (match && (match[1] || !context)) {
        // HANDLE: $(html) -> $(array)
        if (match[1]) {
          context = context instanceof jQuery ? context[0] : context; // Option to run scripts is true for back-compat
          // Intentionally let the error be thrown if parseHTML is not present

          jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true)); // HANDLE: $(html, props)

          if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
            for (match in context) {
              // Properties of context are called as methods if possible
              if (isFunction(this[match])) {
                this[match](context[match]); // ...and otherwise set as attributes
              } else {
                this.attr(match, context[match]);
              }
            }
          }

          return this; // HANDLE: $(#id)
        } else {
          elem = document.getElementById(match[2]);

          if (elem) {
            // Inject the element directly into the jQuery object
            this[0] = elem;
            this.length = 1;
          }

          return this;
        } // HANDLE: $(expr, $(...))

      } else if (!context || context.jquery) {
        return (context || root).find(selector); // HANDLE: $(expr, context)
        // (which is just equivalent to: $(context).find(expr)
      } else {
        return this.constructor(context).find(selector);
      } // HANDLE: $(DOMElement)

    } else if (selector.nodeType) {
      this[0] = selector;
      this.length = 1;
      return this; // HANDLE: $(function)
      // Shortcut for document ready
    } else if (isFunction(selector)) {
      return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
      selector(jQuery);
    }

    return jQuery.makeArray(selector, this);
  }; // Give the init function the jQuery prototype for later instantiation


  init.prototype = jQuery.fn; // Initialize central reference

  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
      // Methods guaranteed to produce a unique set when starting from a unique set
  guaranteedUnique = {
    children: true,
    contents: true,
    next: true,
    prev: true
  };
  jQuery.fn.extend({
    has: function has(target) {
      var targets = jQuery(target, this),
          l = targets.length;
      return this.filter(function () {
        var i = 0;

        for (; i < l; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function closest(selectors, context) {
      var cur,
          i = 0,
          l = this.length,
          matched = [],
          targets = typeof selectors !== "string" && jQuery(selectors); // Positional selectors never match, since there's no _selection_ context

      if (!rneedsContext.test(selectors)) {
        for (; i < l; i++) {
          for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
            // Always skip document fragments
            if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
            cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
              matched.push(cur);
              break;
            }
          }
        }
      }

      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
    },
    // Determine the position of an element within the set
    index: function index(elem) {
      // No argument, return index in parent
      if (!elem) {
        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      } // Index in selector


      if (typeof elem === "string") {
        return indexOf.call(jQuery(elem), this[0]);
      } // Locate the position of the desired element


      return indexOf.call(this, // If it receives a jQuery object, the first element is used
      elem.jquery ? elem[0] : elem);
    },
    add: function add(selector, context) {
      return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function addBack(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });

  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1) {}

    return cur;
  }

  jQuery.each({
    parent: function parent(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function parents(elem) {
      return dir(elem, "parentNode");
    },
    parentsUntil: function parentsUntil(elem, _i, until) {
      return dir(elem, "parentNode", until);
    },
    next: function next(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function prev(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function nextAll(elem) {
      return dir(elem, "nextSibling");
    },
    prevAll: function prevAll(elem) {
      return dir(elem, "previousSibling");
    },
    nextUntil: function nextUntil(elem, _i, until) {
      return dir(elem, "nextSibling", until);
    },
    prevUntil: function prevUntil(elem, _i, until) {
      return dir(elem, "previousSibling", until);
    },
    siblings: function siblings(elem) {
      return _siblings((elem.parentNode || {}).firstChild, elem);
    },
    children: function children(elem) {
      return _siblings(elem.firstChild);
    },
    contents: function contents(elem) {
      if (elem.contentDocument != null && // Support: IE 11+
      // <object> elements with no `data` attribute has an object
      // `contentDocument` with a `null` prototype.
      getProto(elem.contentDocument)) {
        return elem.contentDocument;
      } // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
      // Treat the template element as a regular one in browsers that
      // don't support it.


      if (nodeName(elem, "template")) {
        elem = elem.content || elem;
      }

      return jQuery.merge([], elem.childNodes);
    }
  }, function (name, fn) {
    jQuery.fn[name] = function (until, selector) {
      var matched = jQuery.map(this, fn, until);

      if (name.slice(-5) !== "Until") {
        selector = until;
      }

      if (selector && typeof selector === "string") {
        matched = jQuery.filter(selector, matched);
      }

      if (this.length > 1) {
        // Remove duplicates
        if (!guaranteedUnique[name]) {
          jQuery.uniqueSort(matched);
        } // Reverse order for parents* and prev-derivatives


        if (rparentsprev.test(name)) {
          matched.reverse();
        }
      }

      return this.pushStack(matched);
    };
  });
  var rnothtmlwhite = /[^\x20\t\r\n\f]+/g; // Convert String-formatted options into Object-formatted ones

  function createOptions(options) {
    var object = {};
    jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
      object[flag] = true;
    });
    return object;
  }
  /*
   * Create a callback list using the following parameters:
   *
   *	options: an optional list of space-separated options that will change how
   *			the callback list behaves or a more traditional option object
   *
   * By default a callback list will act like an event callback list and can be
   * "fired" multiple times.
   *
   * Possible options:
   *
   *	once:			will ensure the callback list can only be fired once (like a Deferred)
   *
   *	memory:			will keep track of previous values and will call any callback added
   *					after the list has been fired right away with the latest "memorized"
   *					values (like a Deferred)
   *
   *	unique:			will ensure a callback can only be added once (no duplicate in the list)
   *
   *	stopOnFalse:	interrupt callings when a callback returns false
   *
   */


  jQuery.Callbacks = function (options) {
    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

    var // Flag to know if list is currently firing
    firing,
        // Last fire value for non-forgettable lists
    memory,
        // Flag to know if list was already fired
    _fired,
        // Flag to prevent firing
    _locked,
        // Actual callback list
    list = [],
        // Queue of execution data for repeatable lists
    queue = [],
        // Index of currently firing callback (modified by add/remove as needed)
    firingIndex = -1,
        // Fire callbacks
    fire = function fire() {
      // Enforce single-firing
      _locked = _locked || options.once; // Execute callbacks for all pending executions,
      // respecting firingIndex overrides and runtime changes

      _fired = firing = true;

      for (; queue.length; firingIndex = -1) {
        memory = queue.shift();

        while (++firingIndex < list.length) {
          // Run callback and check for early termination
          if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
            // Jump to end and forget the data so .add doesn't re-fire
            firingIndex = list.length;
            memory = false;
          }
        }
      } // Forget the data if we're done with it


      if (!options.memory) {
        memory = false;
      }

      firing = false; // Clean up if we're done firing for good

      if (_locked) {
        // Keep an empty list if we have data for future add calls
        if (memory) {
          list = []; // Otherwise, this object is spent
        } else {
          list = "";
        }
      }
    },
        // Actual Callbacks object
    self = {
      // Add a callback or a collection of callbacks to the list
      add: function add() {
        if (list) {
          // If we have memory from a past run, we should fire after adding
          if (memory && !firing) {
            firingIndex = list.length - 1;
            queue.push(memory);
          }

          (function add(args) {
            jQuery.each(args, function (_, arg) {
              if (isFunction(arg)) {
                if (!options.unique || !self.has(arg)) {
                  list.push(arg);
                }
              } else if (arg && arg.length && toType(arg) !== "string") {
                // Inspect recursively
                add(arg);
              }
            });
          })(arguments);

          if (memory && !firing) {
            fire();
          }
        }

        return this;
      },
      // Remove a callback from the list
      remove: function remove() {
        jQuery.each(arguments, function (_, arg) {
          var index;

          while ((index = jQuery.inArray(arg, list, index)) > -1) {
            list.splice(index, 1); // Handle firing indexes

            if (index <= firingIndex) {
              firingIndex--;
            }
          }
        });
        return this;
      },
      // Check if a given callback is in the list.
      // If no argument is given, return whether or not list has callbacks attached.
      has: function has(fn) {
        return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
      },
      // Remove all callbacks from the list
      empty: function empty() {
        if (list) {
          list = [];
        }

        return this;
      },
      // Disable .fire and .add
      // Abort any current/pending executions
      // Clear all callbacks and values
      disable: function disable() {
        _locked = queue = [];
        list = memory = "";
        return this;
      },
      disabled: function disabled() {
        return !list;
      },
      // Disable .fire
      // Also disable .add unless we have memory (since it would have no effect)
      // Abort any pending executions
      lock: function lock() {
        _locked = queue = [];

        if (!memory && !firing) {
          list = memory = "";
        }

        return this;
      },
      locked: function locked() {
        return !!_locked;
      },
      // Call all callbacks with the given context and arguments
      fireWith: function fireWith(context, args) {
        if (!_locked) {
          args = args || [];
          args = [context, args.slice ? args.slice() : args];
          queue.push(args);

          if (!firing) {
            fire();
          }
        }

        return this;
      },
      // Call all the callbacks with the given arguments
      fire: function fire() {
        self.fireWith(this, arguments);
        return this;
      },
      // To know if the callbacks have already been called at least once
      fired: function fired() {
        return !!_fired;
      }
    };

    return self;
  };

  function Identity(v) {
    return v;
  }

  function Thrower(ex) {
    throw ex;
  }

  function adoptValue(value, resolve, reject, noValue) {
    var method;

    try {
      // Check for promise aspect first to privilege synchronous behavior
      if (value && isFunction(method = value.promise)) {
        method.call(value).done(resolve).fail(reject); // Other thenables
      } else if (value && isFunction(method = value.then)) {
        method.call(value, resolve, reject); // Other non-thenables
      } else {
        // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
        // * false: [ value ].slice( 0 ) => resolve( value )
        // * true: [ value ].slice( 1 ) => resolve()
        resolve.apply(undefined, [value].slice(noValue));
      } // For Promises/A+, convert exceptions into rejections
      // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
      // Deferred#then to conditionally suppress rejection.

    } catch (value) {
      // Support: Android 4.0 only
      // Strict mode functions invoked without .call/.apply get global-object context
      reject.apply(undefined, [value]);
    }
  }

  jQuery.extend({
    Deferred: function Deferred(func) {
      var tuples = [// action, add listener, callbacks,
      // ... .then handlers, argument index, [final state]
      ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
          _state = "pending",
          _promise = {
        state: function state() {
          return _state;
        },
        always: function always() {
          deferred.done(arguments).fail(arguments);
          return this;
        },
        "catch": function _catch(fn) {
          return _promise.then(null, fn);
        },
        // Keep pipe for back-compat
        pipe: function pipe()
        /* fnDone, fnFail, fnProgress */
        {
          var fns = arguments;
          return jQuery.Deferred(function (newDefer) {
            jQuery.each(tuples, function (_i, tuple) {
              // Map tuples (progress, done, fail) to arguments (done, fail, progress)
              var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]]; // deferred.progress(function() { bind to newDefer or newDefer.notify })
              // deferred.done(function() { bind to newDefer or newDefer.resolve })
              // deferred.fail(function() { bind to newDefer or newDefer.reject })

              deferred[tuple[1]](function () {
                var returned = fn && fn.apply(this, arguments);

                if (returned && isFunction(returned.promise)) {
                  returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                } else {
                  newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                }
              });
            });
            fns = null;
          }).promise();
        },
        then: function then(onFulfilled, onRejected, onProgress) {
          var maxDepth = 0;

          function resolve(depth, deferred, handler, special) {
            return function () {
              var that = this,
                  args = arguments,
                  mightThrow = function mightThrow() {
                var returned, then; // Support: Promises/A+ section 2.3.3.3.3
                // https://promisesaplus.com/#point-59
                // Ignore double-resolution attempts

                if (depth < maxDepth) {
                  return;
                }

                returned = handler.apply(that, args); // Support: Promises/A+ section 2.3.1
                // https://promisesaplus.com/#point-48

                if (returned === deferred.promise()) {
                  throw new TypeError("Thenable self-resolution");
                } // Support: Promises/A+ sections 2.3.3.1, 3.5
                // https://promisesaplus.com/#point-54
                // https://promisesaplus.com/#point-75
                // Retrieve `then` only once


                then = returned && ( // Support: Promises/A+ section 2.3.4
                // https://promisesaplus.com/#point-64
                // Only check objects and functions for thenability
                _typeof(returned) === "object" || typeof returned === "function") && returned.then; // Handle a returned thenable

                if (isFunction(then)) {
                  // Special processors (notify) just wait for resolution
                  if (special) {
                    then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special)); // Normal processors (resolve) also hook into progress
                  } else {
                    // ...and disregard older resolution values
                    maxDepth++;
                    then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                  } // Handle all other returned values

                } else {
                  // Only substitute handlers pass on context
                  // and multiple values (non-spec behavior)
                  if (handler !== Identity) {
                    that = undefined;
                    args = [returned];
                  } // Process the value(s)
                  // Default process is resolve


                  (special || deferred.resolveWith)(that, args);
                }
              },
                  // Only normal processors (resolve) catch and reject exceptions
              process = special ? mightThrow : function () {
                try {
                  mightThrow();
                } catch (e) {
                  if (jQuery.Deferred.exceptionHook) {
                    jQuery.Deferred.exceptionHook(e, process.stackTrace);
                  } // Support: Promises/A+ section 2.3.3.3.4.1
                  // https://promisesaplus.com/#point-61
                  // Ignore post-resolution exceptions


                  if (depth + 1 >= maxDepth) {
                    // Only substitute handlers pass on context
                    // and multiple values (non-spec behavior)
                    if (handler !== Thrower) {
                      that = undefined;
                      args = [e];
                    }

                    deferred.rejectWith(that, args);
                  }
                }
              }; // Support: Promises/A+ section 2.3.3.3.1
              // https://promisesaplus.com/#point-57
              // Re-resolve promises immediately to dodge false rejection from
              // subsequent errors


              if (depth) {
                process();
              } else {
                // Call an optional hook to record the stack, in case of exception
                // since it's otherwise lost when execution goes async
                if (jQuery.Deferred.getStackHook) {
                  process.stackTrace = jQuery.Deferred.getStackHook();
                }

                window.setTimeout(process);
              }
            };
          }

          return jQuery.Deferred(function (newDefer) {
            // progress_handlers.add( ... )
            tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith)); // fulfilled_handlers.add( ... )

            tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity)); // rejected_handlers.add( ... )

            tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
          }).promise();
        },
        // Get a promise for this deferred
        // If obj is provided, the promise aspect is added to the object
        promise: function promise(obj) {
          return obj != null ? jQuery.extend(obj, _promise) : _promise;
        }
      },
          deferred = {}; // Add list-specific methods

      jQuery.each(tuples, function (i, tuple) {
        var list = tuple[2],
            stateString = tuple[5]; // promise.progress = list.add
        // promise.done = list.add
        // promise.fail = list.add

        _promise[tuple[1]] = list.add; // Handle state

        if (stateString) {
          list.add(function () {
            // state = "resolved" (i.e., fulfilled)
            // state = "rejected"
            _state = stateString;
          }, // rejected_callbacks.disable
          // fulfilled_callbacks.disable
          tuples[3 - i][2].disable, // rejected_handlers.disable
          // fulfilled_handlers.disable
          tuples[3 - i][3].disable, // progress_callbacks.lock
          tuples[0][2].lock, // progress_handlers.lock
          tuples[0][3].lock);
        } // progress_handlers.fire
        // fulfilled_handlers.fire
        // rejected_handlers.fire


        list.add(tuple[3].fire); // deferred.notify = function() { deferred.notifyWith(...) }
        // deferred.resolve = function() { deferred.resolveWith(...) }
        // deferred.reject = function() { deferred.rejectWith(...) }

        deferred[tuple[0]] = function () {
          deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
          return this;
        }; // deferred.notifyWith = list.fireWith
        // deferred.resolveWith = list.fireWith
        // deferred.rejectWith = list.fireWith


        deferred[tuple[0] + "With"] = list.fireWith;
      }); // Make the deferred a promise

      _promise.promise(deferred); // Call given func if any


      if (func) {
        func.call(deferred, deferred);
      } // All done!


      return deferred;
    },
    // Deferred helper
    when: function when(singleValue) {
      var // count of uncompleted subordinates
      remaining = arguments.length,
          // count of unprocessed arguments
      i = remaining,
          // subordinate fulfillment data
      resolveContexts = Array(i),
          resolveValues = _slice.call(arguments),
          // the primary Deferred
      primary = jQuery.Deferred(),
          // subordinate callback factory
      updateFunc = function updateFunc(i) {
        return function (value) {
          resolveContexts[i] = this;
          resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;

          if (! --remaining) {
            primary.resolveWith(resolveContexts, resolveValues);
          }
        };
      }; // Single- and empty arguments are adopted like Promise.resolve


      if (remaining <= 1) {
        adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining); // Use .then() to unwrap secondary thenables (cf. gh-3000)

        if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
          return primary.then();
        }
      } // Multiple arguments are aggregated like Promise.all array elements


      while (i--) {
        adoptValue(resolveValues[i], updateFunc(i), primary.reject);
      }

      return primary.promise();
    }
  }); // These usually indicate a programmer mistake during development,
  // warn about them ASAP rather than swallowing them by default.

  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

  jQuery.Deferred.exceptionHook = function (error, stack) {
    // Support: IE 8 - 9 only
    // Console exists when dev tools are open, which can happen at any time
    if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
      window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    }
  };

  jQuery.readyException = function (error) {
    window.setTimeout(function () {
      throw error;
    });
  }; // The deferred used on DOM ready


  var readyList = jQuery.Deferred();

  jQuery.fn.ready = function (fn) {
    readyList.then(fn) // Wrap jQuery.readyException in a function so that the lookup
    // happens at the time of error handling instead of callback
    // registration.
    .catch(function (error) {
      jQuery.readyException(error);
    });
    return this;
  };

  jQuery.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,
    // A counter to track how many items to wait for before
    // the ready event fires. See trac-6781
    readyWait: 1,
    // Handle when the DOM is ready
    ready: function ready(wait) {
      // Abort if there are pending holds or we're already ready
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      } // Remember that the DOM is ready


      jQuery.isReady = true; // If a normal DOM Ready event fired, decrement, and wait if need be

      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      } // If there are functions bound, to execute


      readyList.resolveWith(document, [jQuery]);
    }
  });
  jQuery.ready.then = readyList.then; // The ready event handler and self cleanup method

  function completed() {
    document.removeEventListener("DOMContentLoaded", completed);
    window.removeEventListener("load", completed);
    jQuery.ready();
  } // Catch cases where $(document).ready() is called
  // after the browser event has already occurred.
  // Support: IE <=9 - 10 only
  // Older IE sometimes signals "interactive" too soon


  if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
    // Handle it asynchronously to allow scripts the opportunity to delay ready
    window.setTimeout(jQuery.ready);
  } else {
    // Use the handy event callback
    document.addEventListener("DOMContentLoaded", completed); // A fallback to window.onload, that will always work

    window.addEventListener("load", completed);
  } // Multifunctional method to get and set values of a collection
  // The value/s can optionally be executed if it's a function


  var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
        len = elems.length,
        bulk = key == null; // Sets many values

    if (toType(key) === "object") {
      chainable = true;

      for (i in key) {
        access(elems, fn, i, key[i], true, emptyGet, raw);
      } // Sets one value

    } else if (value !== undefined) {
      chainable = true;

      if (!isFunction(value)) {
        raw = true;
      }

      if (bulk) {
        // Bulk operations run against the entire set
        if (raw) {
          fn.call(elems, value);
          fn = null; // ...except when executing function values
        } else {
          bulk = fn;

          fn = function fn(elem, _key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }

      if (fn) {
        for (; i < len; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }

    if (chainable) {
      return elems;
    } // Gets


    if (bulk) {
      return fn.call(elems);
    }

    return len ? fn(elems[0], key) : emptyGet;
  }; // Matches dashed string for camelizing


  var rmsPrefix = /^-ms-/,
      rdashAlpha = /-([a-z])/g; // Used by camelCase as callback to replace()

  function fcamelCase(_all, letter) {
    return letter.toUpperCase();
  } // Convert dashed to camelCase; used by the css and data modules
  // Support: IE <=9 - 11, Edge 12 - 15
  // Microsoft forgot to hump their vendor prefix (trac-9572)


  function camelCase(string) {
    return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
  }

  var acceptData = function acceptData(owner) {
    // Accepts only:
    //  - Node
    //    - Node.ELEMENT_NODE
    //    - Node.DOCUMENT_NODE
    //  - Object
    //    - Any
    return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
  };

  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }

  Data.uid = 1;
  Data.prototype = {
    cache: function cache(owner) {
      // Check if the owner object already has a cache
      var value = owner[this.expando]; // If not, create one

      if (!value) {
        value = {}; // We can accept data for non-element nodes in modern browsers,
        // but we should not, see trac-8335.
        // Always return an empty object.

        if (acceptData(owner)) {
          // If it is a node unlikely to be stringify-ed or looped over
          // use plain assignment
          if (owner.nodeType) {
            owner[this.expando] = value; // Otherwise secure it in a non-enumerable property
            // configurable must be true to allow the property to be
            // deleted when data is removed
          } else {
            Object.defineProperty(owner, this.expando, {
              value: value,
              configurable: true
            });
          }
        }
      }

      return value;
    },
    set: function set(owner, data, value) {
      var prop,
          cache = this.cache(owner); // Handle: [ owner, key, value ] args
      // Always use camelCase key (gh-2257)

      if (typeof data === "string") {
        cache[camelCase(data)] = value; // Handle: [ owner, { properties } ] args
      } else {
        // Copy the properties one-by-one to the cache object
        for (prop in data) {
          cache[camelCase(prop)] = data[prop];
        }
      }

      return cache;
    },
    get: function get(owner, key) {
      return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
      owner[this.expando] && owner[this.expando][camelCase(key)];
    },
    access: function access(owner, key, value) {
      // In cases where either:
      //
      //   1. No key was specified
      //   2. A string key was specified, but no value provided
      //
      // Take the "read" path and allow the get method to determine
      // which value to return, respectively either:
      //
      //   1. The entire cache object
      //   2. The data stored at the key
      //
      if (key === undefined || key && typeof key === "string" && value === undefined) {
        return this.get(owner, key);
      } // When the key is not a string, or both a key and value
      // are specified, set or extend (existing objects) with either:
      //
      //   1. An object of properties
      //   2. A key and value
      //


      this.set(owner, key, value); // Since the "set" path can have two possible entry points
      // return the expected data based on which path was taken[*]

      return value !== undefined ? value : key;
    },
    remove: function remove(owner, key) {
      var i,
          cache = owner[this.expando];

      if (cache === undefined) {
        return;
      }

      if (key !== undefined) {
        // Support array or space separated string of keys
        if (Array.isArray(key)) {
          // If key is an array of keys...
          // We always set camelCase keys, so remove that.
          key = key.map(camelCase);
        } else {
          key = camelCase(key); // If a key with the spaces exists, use it.
          // Otherwise, create an array by matching non-whitespace

          key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
        }

        i = key.length;

        while (i--) {
          delete cache[key[i]];
        }
      } // Remove the expando if there's no more data


      if (key === undefined || jQuery.isEmptyObject(cache)) {
        // Support: Chrome <=35 - 45
        // Webkit & Blink performance suffers when deleting properties
        // from DOM nodes, so set to undefined instead
        // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
        if (owner.nodeType) {
          owner[this.expando] = undefined;
        } else {
          delete owner[this.expando];
        }
      }
    },
    hasData: function hasData(owner) {
      var cache = owner[this.expando];
      return cache !== undefined && !jQuery.isEmptyObject(cache);
    }
  };
  var dataPriv = new Data();
  var dataUser = new Data(); //	Implementation Summary
  //
  //	1. Enforce API surface and semantic compatibility with 1.9.x branch
  //	2. Improve the module's maintainability by reducing the storage
  //		paths to a single mechanism.
  //	3. Use the same single mechanism to support "private" and "user" data.
  //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
  //	5. Avoid exposing implementation details on user objects (eg. expando properties)
  //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      rmultiDash = /[A-Z]/g;

  function getData(data) {
    if (data === "true") {
      return true;
    }

    if (data === "false") {
      return false;
    }

    if (data === "null") {
      return null;
    } // Only convert to a number if it doesn't change the string


    if (data === +data + "") {
      return +data;
    }

    if (rbrace.test(data)) {
      return JSON.parse(data);
    }

    return data;
  }

  function dataAttr(elem, key, data) {
    var name; // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute

    if (data === undefined && elem.nodeType === 1) {
      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
      data = elem.getAttribute(name);

      if (typeof data === "string") {
        try {
          data = getData(data);
        } catch (e) {} // Make sure we set the data so it isn't changed later


        dataUser.set(elem, key, data);
      } else {
        data = undefined;
      }
    }

    return data;
  }

  jQuery.extend({
    hasData: function hasData(elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function data(elem, name, _data) {
      return dataUser.access(elem, name, _data);
    },
    removeData: function removeData(elem, name) {
      dataUser.remove(elem, name);
    },
    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    _data: function _data(elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function _removeData(elem, name) {
      dataPriv.remove(elem, name);
    }
  });
  jQuery.fn.extend({
    data: function data(key, value) {
      var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes; // Gets all values

      if (key === undefined) {
        if (this.length) {
          data = dataUser.get(elem);

          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
            i = attrs.length;

            while (i--) {
              // Support: IE 11 only
              // The attrs elements can be null (trac-14894)
              if (attrs[i]) {
                name = attrs[i].name;

                if (name.indexOf("data-") === 0) {
                  name = camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }

            dataPriv.set(elem, "hasDataAttrs", true);
          }
        }

        return data;
      } // Sets multiple values


      if (_typeof(key) === "object") {
        return this.each(function () {
          dataUser.set(this, key);
        });
      }

      return access(this, function (value) {
        var data; // The calling jQuery object (element matches) is not empty
        // (and therefore has an element appears at this[ 0 ]) and the
        // `value` parameter was not undefined. An empty jQuery object
        // will result in `undefined` for elem = this[ 0 ] which will
        // throw an exception if an attempt to read a data cache is made.

        if (elem && value === undefined) {
          // Attempt to get data from the cache
          // The key will always be camelCased in Data
          data = dataUser.get(elem, key);

          if (data !== undefined) {
            return data;
          } // Attempt to "discover" the data in
          // HTML5 custom data-* attrs


          data = dataAttr(elem, key);

          if (data !== undefined) {
            return data;
          } // We tried really hard, but the data doesn't exist.


          return;
        } // Set the data...


        this.each(function () {
          // We always store the camelCased key
          dataUser.set(this, key, value);
        });
      }, null, value, arguments.length > 1, null, true);
    },
    removeData: function removeData(key) {
      return this.each(function () {
        dataUser.remove(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function queue(elem, type, data) {
      var queue;

      if (elem) {
        type = (type || "fx") + "queue";
        queue = dataPriv.get(elem, type); // Speed up dequeue by getting out quickly if this is just a lookup

        if (data) {
          if (!queue || Array.isArray(data)) {
            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }

        return queue || [];
      }
    },
    dequeue: function dequeue(elem, type) {
      type = type || "fx";

      var queue = jQuery.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = jQuery._queueHooks(elem, type),
          next = function next() {
        jQuery.dequeue(elem, type);
      }; // If the fx queue is dequeued, always remove the progress sentinel


      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }

      if (fn) {
        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if (type === "fx") {
          queue.unshift("inprogress");
        } // Clear up the last queue stop function


        delete hooks.stop;
        fn.call(elem, next, hooks);
      }

      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    // Not public - generate a queueHooks object, or return the current one
    _queueHooks: function _queueHooks(elem, type) {
      var key = type + "queueHooks";
      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
        empty: jQuery.Callbacks("once memory").add(function () {
          dataPriv.remove(elem, [type + "queue", key]);
        })
      });
    }
  });
  jQuery.fn.extend({
    queue: function queue(type, data) {
      var setter = 2;

      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }

      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }

      return data === undefined ? this : this.each(function () {
        var queue = jQuery.queue(this, type, data); // Ensure a hooks for this queue

        jQuery._queueHooks(this, type);

        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function dequeue(type) {
      return this.each(function () {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function clearQueue(type) {
      return this.queue(type || "fx", []);
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function promise(type, obj) {
      var tmp,
          count = 1,
          defer = jQuery.Deferred(),
          elements = this,
          i = this.length,
          resolve = function resolve() {
        if (! --count) {
          defer.resolveWith(elements, [elements]);
        }
      };

      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }

      type = type || "fx";

      while (i--) {
        tmp = dataPriv.get(elements[i], type + "queueHooks");

        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }

      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var documentElement = document.documentElement;

  var isAttached = function isAttached(elem) {
    return jQuery.contains(elem.ownerDocument, elem);
  },
      composed = {
    composed: true
  }; // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
  // Check attachment across shadow DOM boundaries when possible (gh-3504)
  // Support: iOS 10.0-10.2 only
  // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
  // leading to errors. We need to check for `getRootNode`.


  if (documentElement.getRootNode) {
    isAttached = function isAttached(elem) {
      return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
  }

  var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
    // isHiddenWithinTree might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem; // Inline style trumps all

    return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
    // Support: Firefox <=43 - 45
    // Disconnected elements can have computed display: none, so first confirm that elem is
    // in the document.
    isAttached(elem) && jQuery.css(elem, "display") === "none";
  };

  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
        scale,
        maxIterations = 20,
        currentValue = tween ? function () {
      return tween.cur();
    } : function () {
      return jQuery.css(elem, prop, "");
    },
        initial = currentValue(),
        unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
        // Starting value computation is required for potential unit mismatches
    initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

    if (initialInUnit && initialInUnit[3] !== unit) {
      // Support: Firefox <=54
      // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
      initial = initial / 2; // Trust units reported by jQuery.css

      unit = unit || initialInUnit[3]; // Iteratively approximate from a nonzero starting point

      initialInUnit = +initial || 1;

      while (maxIterations--) {
        // Evaluate and update our best guess (doubling guesses that zero out).
        // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
        jQuery.style(elem, prop, initialInUnit + unit);

        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
          maxIterations = 0;
        }

        initialInUnit = initialInUnit / scale;
      }

      initialInUnit = initialInUnit * 2;
      jQuery.style(elem, prop, initialInUnit + unit); // Make sure we update the tween properties later on

      valueParts = valueParts || [];
    }

    if (valueParts) {
      initialInUnit = +initialInUnit || +initial || 0; // Apply relative offset (+=/-=) if specified

      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];

      if (tween) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }

    return adjusted;
  }

  var defaultDisplayMap = {};

  function getDefaultDisplay(elem) {
    var temp,
        doc = elem.ownerDocument,
        nodeName = elem.nodeName,
        display = defaultDisplayMap[nodeName];

    if (display) {
      return display;
    }

    temp = doc.body.appendChild(doc.createElement(nodeName));
    display = jQuery.css(temp, "display");
    temp.parentNode.removeChild(temp);

    if (display === "none") {
      display = "block";
    }

    defaultDisplayMap[nodeName] = display;
    return display;
  }

  function showHide(elements, show) {
    var display,
        elem,
        values = [],
        index = 0,
        length = elements.length; // Determine new display value for elements that need to change

    for (; index < length; index++) {
      elem = elements[index];

      if (!elem.style) {
        continue;
      }

      display = elem.style.display;

      if (show) {
        // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
        // check is required in this first loop unless we have a nonempty display value (either
        // inline or about-to-be-restored)
        if (display === "none") {
          values[index] = dataPriv.get(elem, "display") || null;

          if (!values[index]) {
            elem.style.display = "";
          }
        }

        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
          values[index] = getDefaultDisplay(elem);
        }
      } else {
        if (display !== "none") {
          values[index] = "none"; // Remember what we're overwriting

          dataPriv.set(elem, "display", display);
        }
      }
    } // Set the display of the elements in a second loop to avoid constant reflow


    for (index = 0; index < length; index++) {
      if (values[index] != null) {
        elements[index].style.display = values[index];
      }
    }

    return elements;
  }

  jQuery.fn.extend({
    show: function show() {
      return showHide(this, true);
    },
    hide: function hide() {
      return showHide(this);
    },
    toggle: function toggle(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }

      return this.each(function () {
        if (isHiddenWithinTree(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });
  var rcheckableType = /^(?:checkbox|radio)$/i;
  var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
  var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

  (function () {
    var fragment = document.createDocumentFragment(),
        div = fragment.appendChild(document.createElement("div")),
        input = document.createElement("input"); // Support: Android 4.0 - 4.3 only
    // Check state lost if the name is set (trac-11217)
    // Support: Windows Web Apps (WWA)
    // `name` and `type` must use .setAttribute for WWA (trac-14901)

    input.setAttribute("type", "radio");
    input.setAttribute("checked", "checked");
    input.setAttribute("name", "t");
    div.appendChild(input); // Support: Android <=4.1 only
    // Older WebKit doesn't clone checked state correctly in fragments

    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked; // Support: IE <=11 only
    // Make sure textarea (and checkbox) defaultValue is properly cloned

    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue; // Support: IE <=9 only
    // IE <=9 replaces <option> tags with their contents when inserted outside of
    // the select element.

    div.innerHTML = "<option></option>";
    support.option = !!div.lastChild;
  })(); // We have to close these tags to support XHTML (trac-13200)


  var wrapMap = {
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do. So we cannot shorten
    // this by omitting <tbody> or other required elements.
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td; // Support: IE <=9 only

  if (!support.option) {
    wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
  }

  function getAll(context, tag) {
    // Support: IE <=9 - 11 only
    // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
    var ret;

    if (typeof context.getElementsByTagName !== "undefined") {
      ret = context.getElementsByTagName(tag || "*");
    } else if (typeof context.querySelectorAll !== "undefined") {
      ret = context.querySelectorAll(tag || "*");
    } else {
      ret = [];
    }

    if (tag === undefined || tag && nodeName(context, tag)) {
      return jQuery.merge([context], ret);
    }

    return ret;
  } // Mark scripts as having already been evaluated


  function setGlobalEval(elems, refElements) {
    var i = 0,
        l = elems.length;

    for (; i < l; i++) {
      dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
  }

  var rhtml = /<|&#?\w+;/;

  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
        tmp,
        tag,
        wrap,
        attached,
        j,
        fragment = context.createDocumentFragment(),
        nodes = [],
        i = 0,
        l = elems.length;

    for (; i < l; i++) {
      elem = elems[i];

      if (elem || elem === 0) {
        // Add nodes directly
        if (toType(elem) === "object") {
          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge(nodes, elem.nodeType ? [elem] : elem); // Convert non-html into a text node
        } else if (!rhtml.test(elem)) {
          nodes.push(context.createTextNode(elem)); // Convert html into DOM nodes
        } else {
          tmp = tmp || fragment.appendChild(context.createElement("div")); // Deserialize a standard representation

          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2]; // Descend through wrappers to the right content

          j = wrap[0];

          while (j--) {
            tmp = tmp.lastChild;
          } // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit


          jQuery.merge(nodes, tmp.childNodes); // Remember the top-level container

          tmp = fragment.firstChild; // Ensure the created nodes are orphaned (trac-12392)

          tmp.textContent = "";
        }
      }
    } // Remove wrapper from fragment


    fragment.textContent = "";
    i = 0;

    while (elem = nodes[i++]) {
      // Skip elements already in the context collection (trac-4087)
      if (selection && jQuery.inArray(elem, selection) > -1) {
        if (ignored) {
          ignored.push(elem);
        }

        continue;
      }

      attached = isAttached(elem); // Append to fragment

      tmp = getAll(fragment.appendChild(elem), "script"); // Preserve script evaluation history

      if (attached) {
        setGlobalEval(tmp);
      } // Capture executables


      if (scripts) {
        j = 0;

        while (elem = tmp[j++]) {
          if (rscriptType.test(elem.type || "")) {
            scripts.push(elem);
          }
        }
      }
    }

    return fragment;
  }

  var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  } // Support: IE <=9 - 11+
  // focus() and blur() are asynchronous, except when they are no-op.
  // So expect focus to be synchronous when the element is already active,
  // and blur to be synchronous when the element is not already active.
  // (focus and blur are always synchronous in other supported browsers,
  // this just defines when we can count on it).


  function expectSync(elem, type) {
    return elem === safeActiveElement() === (type === "focus");
  } // Support: IE <=9 only
  // Accessing document.activeElement can throw unexpectedly
  // https://bugs.jquery.com/ticket/13393


  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }

  function _on(elem, types, selector, data, fn, one) {
    var origFn, type; // Types can be a map of types/handlers

    if (_typeof(types) === "object") {
      // ( types-Object, selector, data )
      if (typeof selector !== "string") {
        // ( types-Object, data )
        data = data || selector;
        selector = undefined;
      }

      for (type in types) {
        _on(elem, type, selector, data, types[type], one);
      }

      return elem;
    }

    if (data == null && fn == null) {
      // ( types, fn )
      fn = selector;
      data = selector = undefined;
    } else if (fn == null) {
      if (typeof selector === "string") {
        // ( types, selector, fn )
        fn = data;
        data = undefined;
      } else {
        // ( types, data, fn )
        fn = data;
        data = selector;
        selector = undefined;
      }
    }

    if (fn === false) {
      fn = returnFalse;
    } else if (!fn) {
      return elem;
    }

    if (one === 1) {
      origFn = fn;

      fn = function fn(event) {
        // Can use an empty set, since event contains the info
        jQuery().off(event);
        return origFn.apply(this, arguments);
      }; // Use same guid so caller can remove using origFn


      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
    }

    return elem.each(function () {
      jQuery.event.add(this, types, fn, data, selector);
    });
  }
  /*
   * Helper functions for managing events -- not part of the public interface.
   * Props to Dean Edwards' addEvent library for many of the ideas.
   */


  jQuery.event = {
    global: {},
    add: function add(elem, types, handler, data, selector) {
      var handleObjIn,
          eventHandle,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.get(elem); // Only attach events to objects that accept data

      if (!acceptData(elem)) {
        return;
      } // Caller can pass in an object of custom data in lieu of the handler


      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      } // Ensure that invalid selectors throw exceptions at attach time
      // Evaluate against documentElement in case elem is a non-element node (e.g., document)


      if (selector) {
        jQuery.find.matchesSelector(documentElement, selector);
      } // Make sure that the handler has a unique ID, used to find/remove it later


      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      } // Init the element's event structure and main handler, if this is the first


      if (!(events = elemData.events)) {
        events = elemData.events = Object.create(null);
      }

      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function (e) {
          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
        };
      } // Handle multiple events separated by a space


      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;

      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort(); // There *must* be a type, no attaching namespace-only handlers

        if (!type) {
          continue;
        } // If event changes its type, use the special event handlers for the changed type


        special = jQuery.event.special[type] || {}; // If selector defined, determine special event api type, otherwise given type

        type = (selector ? special.delegateType : special.bindType) || type; // Update special based on newly reset type

        special = jQuery.event.special[type] || {}; // handleObj is passed to all event handlers

        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn); // Init the event handler queue if we're the first

        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0; // Only use addEventListener if the special events handler returns false

          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle);
            }
          }
        }

        if (special.add) {
          special.add.call(elem, handleObj);

          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        } // Add to the element's handler list, delegates in front


        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        } // Keep track of which events have ever been used, for event optimization


        jQuery.event.global[type] = true;
      }
    },
    // Detach an event or set of events from an element
    remove: function remove(elem, types, handler, selector, mappedTypes) {
      var j,
          origCount,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

      if (!elemData || !(events = elemData.events)) {
        return;
      } // Once for each type.namespace in types; type may be omitted


      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;

      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort(); // Unbind all events (on this namespace, if provided) for the element

        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }

          continue;
        }

        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"); // Remove matching events

        origCount = j = handlers.length;

        while (j--) {
          handleObj = handlers[j];

          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);

            if (handleObj.selector) {
              handlers.delegateCount--;
            }

            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        } // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)


        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }

          delete events[type];
        }
      } // Remove data and the expando if it's no longer used


      if (jQuery.isEmptyObject(events)) {
        dataPriv.remove(elem, "handle events");
      }
    },
    dispatch: function dispatch(nativeEvent) {
      var i,
          j,
          ret,
          matched,
          handleObj,
          handlerQueue,
          args = new Array(arguments.length),
          // Make a writable jQuery.Event from the native event object
      event = jQuery.event.fix(nativeEvent),
          handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
          special = jQuery.event.special[event.type] || {}; // Use the fix-ed jQuery.Event rather than the (read-only) native event

      args[0] = event;

      for (i = 1; i < arguments.length; i++) {
        args[i] = arguments[i];
      }

      event.delegateTarget = this; // Call the preDispatch hook for the mapped type, and let it bail if desired

      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      } // Determine handlers


      handlerQueue = jQuery.event.handlers.call(this, event, handlers); // Run delegates first; they may want to stop propagation beneath us

      i = 0;

      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;

        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          // If the event is namespaced, then each handler is only invoked if it is
          // specially universal or its namespaces are a superset of the event's.
          if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      } // Call the postDispatch hook for the mapped type


      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }

      return event.result;
    },
    handlers: function handlers(event, _handlers) {
      var i,
          handleObj,
          sel,
          matchedHandlers,
          matchedSelectors,
          handlerQueue = [],
          delegateCount = _handlers.delegateCount,
          cur = event.target; // Find delegate handlers

      if (delegateCount && // Support: IE <=9
      // Black-hole SVG <use> instance trees (trac-13180)
      cur.nodeType && // Support: Firefox <=42
      // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
      // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
      // Support: IE 11 only
      // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
      !(event.type === "click" && event.button >= 1)) {
        for (; cur !== this; cur = cur.parentNode || this) {
          // Don't check non-elements (trac-13208)
          // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
          if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
            matchedHandlers = [];
            matchedSelectors = {};

            for (i = 0; i < delegateCount; i++) {
              handleObj = _handlers[i]; // Don't conflict with Object.prototype properties (trac-13203)

              sel = handleObj.selector + " ";

              if (matchedSelectors[sel] === undefined) {
                matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
              }

              if (matchedSelectors[sel]) {
                matchedHandlers.push(handleObj);
              }
            }

            if (matchedHandlers.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matchedHandlers
              });
            }
          }
        }
      } // Add the remaining (directly-bound) handlers


      cur = this;

      if (delegateCount < _handlers.length) {
        handlerQueue.push({
          elem: cur,
          handlers: _handlers.slice(delegateCount)
        });
      }

      return handlerQueue;
    },
    addProp: function addProp(name, hook) {
      Object.defineProperty(jQuery.Event.prototype, name, {
        enumerable: true,
        configurable: true,
        get: isFunction(hook) ? function () {
          if (this.originalEvent) {
            return hook(this.originalEvent);
          }
        } : function () {
          if (this.originalEvent) {
            return this.originalEvent[name];
          }
        },
        set: function set(value) {
          Object.defineProperty(this, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
          });
        }
      });
    },
    fix: function fix(originalEvent) {
      return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
    },
    special: {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      click: {
        // Utilize native event to ensure correct state for checkable inputs
        setup: function setup(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data; // Claim the first handler

          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            // dataPriv.set( el, "click", ... )
            leverageNative(el, "click", returnTrue);
          } // Return false to allow normal processing in the caller


          return false;
        },
        trigger: function trigger(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data; // Force setup before triggering a click

          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            leverageNative(el, "click");
          } // Return non-false to allow normal event-path propagation


          return true;
        },
        // For cross-browser consistency, suppress native .click() on links
        // Also prevent it if we're currently inside a leveraged native-event stack
        _default: function _default(event) {
          var target = event.target;
          return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(event) {
          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    }
  }; // Ensure the presence of an event listener that handles manually-triggered
  // synthetic events by interrupting progress until reinvoked in response to
  // *native* events that it fires directly, ensuring that state changes have
  // already occurred before other listeners are invoked.

  function leverageNative(el, type, expectSync) {
    // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
    if (!expectSync) {
      if (dataPriv.get(el, type) === undefined) {
        jQuery.event.add(el, type, returnTrue);
      }

      return;
    } // Register the controller as a special universal handler for all event namespaces


    dataPriv.set(el, type, false);
    jQuery.event.add(el, type, {
      namespace: false,
      handler: function handler(event) {
        var notAsync,
            result,
            saved = dataPriv.get(this, type);

        if (event.isTrigger & 1 && this[type]) {
          // Interrupt processing of the outer synthetic .trigger()ed event
          // Saved data should be false in such cases, but might be a leftover capture object
          // from an async native handler (gh-4350)
          if (!saved.length) {
            // Store arguments for use when handling the inner native event
            // There will always be at least one argument (an event object), so this array
            // will not be confused with a leftover capture object.
            saved = _slice.call(arguments);
            dataPriv.set(this, type, saved); // Trigger the native event and capture its result
            // Support: IE <=9 - 11+
            // focus() and blur() are asynchronous

            notAsync = expectSync(this, type);
            this[type]();
            result = dataPriv.get(this, type);

            if (saved !== result || notAsync) {
              dataPriv.set(this, type, false);
            } else {
              result = {};
            }

            if (saved !== result) {
              // Cancel the outer synthetic event
              event.stopImmediatePropagation();
              event.preventDefault(); // Support: Chrome 86+
              // In Chrome, if an element having a focusout handler is blurred by
              // clicking outside of it, it invokes the handler synchronously. If
              // that handler calls `.remove()` on the element, the data is cleared,
              // leaving `result` undefined. We need to guard against this.

              return result && result.value;
            } // If this is an inner synthetic event for an event with a bubbling surrogate
            // (focus or blur), assume that the surrogate already propagated from triggering the
            // native event and prevent that from happening again here.
            // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
            // bubbling surrogate propagates *after* the non-bubbling base), but that seems
            // less bad than duplication.

          } else if ((jQuery.event.special[type] || {}).delegateType) {
            event.stopPropagation();
          } // If this is a native event triggered above, everything is now in order
          // Fire an inner synthetic event with the original arguments

        } else if (saved.length) {
          // ...and capture the result
          dataPriv.set(this, type, {
            value: jQuery.event.trigger( // Support: IE <=9 - 11+
            // Extend with the prototype to reset the above stopImmediatePropagation()
            jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
          }); // Abort handling of the native event

          event.stopImmediatePropagation();
        }
      }
    });
  }

  jQuery.removeEvent = function (elem, type, handle) {
    // This "if" is needed for plain objects
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle);
    }
  };

  jQuery.Event = function (src, props) {
    // Allow instantiation without the 'new' keyword
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    } // Event object


    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type; // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.

      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
      src.returnValue === false ? returnTrue : returnFalse; // Create target properties
      // Support: Safari <=6 - 7 only
      // Target should not be a text node (trac-504, trac-13143)

      this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
      this.currentTarget = src.currentTarget;
      this.relatedTarget = src.relatedTarget; // Event type
    } else {
      this.type = src;
    } // Put explicitly provided properties onto the event object


    if (props) {
      jQuery.extend(this, props);
    } // Create a timestamp if incoming event doesn't have one


    this.timeStamp = src && src.timeStamp || Date.now(); // Mark it as fixed

    this[jQuery.expando] = true;
  }; // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
  // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html


  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    isSimulated: false,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;

      if (e && !this.isSimulated) {
        e.preventDefault();
      }
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;

      if (e && !this.isSimulated) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;

      if (e && !this.isSimulated) {
        e.stopImmediatePropagation();
      }

      this.stopPropagation();
    }
  }; // Includes all common event props including KeyEvent and MouseEvent specific props

  jQuery.each({
    altKey: true,
    bubbles: true,
    cancelable: true,
    changedTouches: true,
    ctrlKey: true,
    detail: true,
    eventPhase: true,
    metaKey: true,
    pageX: true,
    pageY: true,
    shiftKey: true,
    view: true,
    "char": true,
    code: true,
    charCode: true,
    key: true,
    keyCode: true,
    button: true,
    buttons: true,
    clientX: true,
    clientY: true,
    offsetX: true,
    offsetY: true,
    pointerId: true,
    pointerType: true,
    screenX: true,
    screenY: true,
    targetTouches: true,
    toElement: true,
    touches: true,
    which: true
  }, jQuery.event.addProp);
  jQuery.each({
    focus: "focusin",
    blur: "focusout"
  }, function (type, delegateType) {
    jQuery.event.special[type] = {
      // Utilize native event if possible so blur/focus sequence is correct
      setup: function setup() {
        // Claim the first handler
        // dataPriv.set( this, "focus", ... )
        // dataPriv.set( this, "blur", ... )
        leverageNative(this, type, expectSync); // Return false to allow normal processing in the caller

        return false;
      },
      trigger: function trigger() {
        // Force setup before trigger
        leverageNative(this, type); // Return non-false to allow normal event-path propagation

        return true;
      },
      // Suppress native focus or blur if we're currently inside
      // a leveraged native-event stack
      _default: function _default(event) {
        return dataPriv.get(event.target, type);
      },
      delegateType: delegateType
    };
  }); // Create mouseenter/leave events using mouseover/out and event-time checks
  // so that event delegation works in jQuery.
  // Do the same for pointerenter/pointerleave and pointerover/pointerout
  //
  // Support: Safari 7 only
  // Safari sends mouseenter too often; see:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
  // for the description of the bug (it existed in older Chrome versions as well).

  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function handle(event) {
        var ret,
            target = this,
            related = event.relatedTarget,
            handleObj = event.handleObj; // For mouseenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window

        if (!related || related !== target && !jQuery.contains(target, related)) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }

        return ret;
      }
    };
  });
  jQuery.fn.extend({
    on: function on(types, selector, data, fn) {
      return _on(this, types, selector, data, fn);
    },
    one: function one(types, selector, data, fn) {
      return _on(this, types, selector, data, fn, 1);
    },
    off: function off(types, selector, fn) {
      var handleObj, type;

      if (types && types.preventDefault && types.handleObj) {
        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }

      if (_typeof(types) === "object") {
        // ( types-object [, selector] )
        for (type in types) {
          this.off(type, selector, types[type]);
        }

        return this;
      }

      if (selector === false || typeof selector === "function") {
        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }

      if (fn === false) {
        fn = returnFalse;
      }

      return this.each(function () {
        jQuery.event.remove(this, types, fn, selector);
      });
    }
  });
  var // Support: IE <=10 - 11, Edge 12 - 13 only
  // In IE/Edge using regex groups here causes severe slowdowns.
  // See https://connect.microsoft.com/IE/feedback/details/1736512/
  rnoInnerhtml = /<script|<style|<link/i,
      // checked="checked" or checked
  rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g; // Prefer a tbody over its parent table for containing new rows

  function manipulationTarget(elem, content) {
    if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
      return jQuery(elem).children("tbody")[0] || elem;
    }

    return elem;
  } // Replace/restore the type attribute of script elements for safe DOM manipulation


  function disableScript(elem) {
    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
    return elem;
  }

  function restoreScript(elem) {
    if ((elem.type || "").slice(0, 5) === "true/") {
      elem.type = elem.type.slice(5);
    } else {
      elem.removeAttribute("type");
    }

    return elem;
  }

  function cloneCopyEvent(src, dest) {
    var i, l, type, pdataOld, udataOld, udataCur, events;

    if (dest.nodeType !== 1) {
      return;
    } // 1. Copy private data: events, handlers, etc.


    if (dataPriv.hasData(src)) {
      pdataOld = dataPriv.get(src);
      events = pdataOld.events;

      if (events) {
        dataPriv.remove(dest, "handle events");

        for (type in events) {
          for (i = 0, l = events[type].length; i < l; i++) {
            jQuery.event.add(dest, type, events[type][i]);
          }
        }
      }
    } // 2. Copy user data


    if (dataUser.hasData(src)) {
      udataOld = dataUser.access(src);
      udataCur = jQuery.extend({}, udataOld);
      dataUser.set(dest, udataCur);
    }
  } // Fix IE bugs, see support tests


  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase(); // Fails to persist the checked state of a cloned checkbox or radio button.

    if (nodeName === "input" && rcheckableType.test(src.type)) {
      dest.checked = src.checked; // Fails to return the selected option to the default selected state when cloning options
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }

  function domManip(collection, args, callback, ignored) {
    // Flatten any nested arrays
    args = flat(args);
    var fragment,
        first,
        scripts,
        hasScripts,
        node,
        doc,
        i = 0,
        l = collection.length,
        iNoClone = l - 1,
        value = args[0],
        valueIsFunction = isFunction(value); // We can't cloneNode fragments that contain checked, in WebKit

    if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
      return collection.each(function (index) {
        var self = collection.eq(index);

        if (valueIsFunction) {
          args[0] = value.call(this, index, self.html());
        }

        domManip(self, args, callback, ignored);
      });
    }

    if (l) {
      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
      first = fragment.firstChild;

      if (fragment.childNodes.length === 1) {
        fragment = first;
      } // Require either new content or an interest in ignored elements to invoke the callback


      if (first || ignored) {
        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
        hasScripts = scripts.length; // Use the original fragment for the last item
        // instead of the first because it can end up
        // being emptied incorrectly in certain situations (trac-8070).

        for (; i < l; i++) {
          node = fragment;

          if (i !== iNoClone) {
            node = jQuery.clone(node, true, true); // Keep references to cloned scripts for later restoration

            if (hasScripts) {
              // Support: Android <=4.0 only, PhantomJS 1 only
              // push.apply(_, arraylike) throws on ancient WebKit
              jQuery.merge(scripts, getAll(node, "script"));
            }
          }

          callback.call(collection[i], node, i);
        }

        if (hasScripts) {
          doc = scripts[scripts.length - 1].ownerDocument; // Reenable scripts

          jQuery.map(scripts, restoreScript); // Evaluate executable scripts on first document insertion

          for (i = 0; i < hasScripts; i++) {
            node = scripts[i];

            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
              if (node.src && (node.type || "").toLowerCase() !== "module") {
                // Optional AJAX dependency, but won't run scripts if not present
                if (jQuery._evalUrl && !node.noModule) {
                  jQuery._evalUrl(node.src, {
                    nonce: node.nonce || node.getAttribute("nonce")
                  }, doc);
                }
              } else {
                // Unwrap a CDATA section containing script contents. This shouldn't be
                // needed as in XML documents they're already not visible when
                // inspecting element contents and in HTML documents they have no
                // meaning but we're preserving that logic for backwards compatibility.
                // This will be removed completely in 4.0. See gh-4904.
                DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
              }
            }
          }
        }
      }
    }

    return collection;
  }

  function _remove(elem, selector, keepData) {
    var node,
        nodes = selector ? jQuery.filter(selector, elem) : elem,
        i = 0;

    for (; (node = nodes[i]) != null; i++) {
      if (!keepData && node.nodeType === 1) {
        jQuery.cleanData(getAll(node));
      }

      if (node.parentNode) {
        if (keepData && isAttached(node)) {
          setGlobalEval(getAll(node, "script"));
        }

        node.parentNode.removeChild(node);
      }
    }

    return elem;
  }

  jQuery.extend({
    htmlPrefilter: function htmlPrefilter(html) {
      return html;
    },
    clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
      var i,
          l,
          srcElements,
          destElements,
          clone = elem.cloneNode(true),
          inPage = isAttached(elem); // Fix IE cloning issues

      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
        destElements = getAll(clone);
        srcElements = getAll(elem);

        for (i = 0, l = srcElements.length; i < l; i++) {
          fixInput(srcElements[i], destElements[i]);
        }
      } // Copy the events from the original to the clone


      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);

          for (i = 0, l = srcElements.length; i < l; i++) {
            cloneCopyEvent(srcElements[i], destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      } // Preserve script evaluation history


      destElements = getAll(clone, "script");

      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      } // Return the cloned set


      return clone;
    },
    cleanData: function cleanData(elems) {
      var data,
          elem,
          type,
          special = jQuery.event.special,
          i = 0;

      for (; (elem = elems[i]) !== undefined; i++) {
        if (acceptData(elem)) {
          if (data = elem[dataPriv.expando]) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type); // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            } // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove


            elem[dataPriv.expando] = undefined;
          }

          if (elem[dataUser.expando]) {
            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[dataUser.expando] = undefined;
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    detach: function detach(selector) {
      return _remove(this, selector, true);
    },
    remove: function remove(selector) {
      return _remove(this, selector);
    },
    text: function text(value) {
      return access(this, function (value) {
        return value === undefined ? jQuery.text(this) : this.empty().each(function () {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            this.textContent = value;
          }
        });
      }, null, value, arguments.length);
    },
    append: function append() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function prepend() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function before() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function after() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    empty: function empty() {
      var elem,
          i = 0;

      for (; (elem = this[i]) != null; i++) {
        if (elem.nodeType === 1) {
          // Prevent memory leaks
          jQuery.cleanData(getAll(elem, false)); // Remove any remaining nodes

          elem.textContent = "";
        }
      }

      return this;
    },
    clone: function clone(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function () {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function html(value) {
      return access(this, function (value) {
        var elem = this[0] || {},
            i = 0,
            l = this.length;

        if (value === undefined && elem.nodeType === 1) {
          return elem.innerHTML;
        } // See if we can take a shortcut and just use innerHTML


        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = jQuery.htmlPrefilter(value);

          try {
            for (; i < l; i++) {
              elem = this[i] || {}; // Remove element nodes and prevent memory leaks

              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }

            elem = 0; // If using innerHTML throws an exception, use the fallback method
          } catch (e) {}
        }

        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function replaceWith() {
      var ignored = []; // Make the changes, replacing each non-ignored context element with the new content

      return domManip(this, arguments, function (elem) {
        var parent = this.parentNode;

        if (jQuery.inArray(this, ignored) < 0) {
          jQuery.cleanData(getAll(this));

          if (parent) {
            parent.replaceChild(elem, this);
          }
        } // Force callback invocation

      }, ignored);
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (name, original) {
    jQuery.fn[name] = function (selector) {
      var elems,
          ret = [],
          insert = jQuery(selector),
          last = insert.length - 1,
          i = 0;

      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems); // Support: Android <=4.0 only, PhantomJS 1 only
        // .get() because push.apply(_, arraylike) throws on ancient WebKit

        push.apply(ret, elems.get());
      }

      return this.pushStack(ret);
    };
  });
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var rcustomProp = /^--/;

  var getStyles = function getStyles(elem) {
    // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
    // IE throws on elements created in popups
    // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
    var view = elem.ownerDocument.defaultView;

    if (!view || !view.opener) {
      view = window;
    }

    return view.getComputedStyle(elem);
  };

  var swap = function swap(elem, options, callback) {
    var ret,
        name,
        old = {}; // Remember the old values, and insert the new ones

    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }

    ret = callback.call(elem); // Revert the old values

    for (name in options) {
      elem.style[name] = old[name];
    }

    return ret;
  };

  var rboxStyle = new RegExp(cssExpand.join("|"), "i");
  var whitespace = "[\\x20\\t\\r\\n\\f]";
  var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

  (function () {
    // Executing both pixelPosition & boxSizingReliable tests require only one layout
    // so they're executed at the same time to save the second computation.
    function computeStyleTests() {
      // This is a singleton, we need to execute it only once
      if (!div) {
        return;
      }

      container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
      div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
      documentElement.appendChild(container).appendChild(div);
      var divStyle = window.getComputedStyle(div);
      pixelPositionVal = divStyle.top !== "1%"; // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44

      reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12; // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
      // Some styles come back with percentage values, even though they shouldn't

      div.style.right = "60%";
      pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36; // Support: IE 9 - 11 only
      // Detect misreporting of content dimensions for box-sizing:border-box elements

      boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36; // Support: IE 9 only
      // Detect overflow:scroll screwiness (gh-3699)
      // Support: Chrome <=64
      // Don't get tricked when zoom affects offsetWidth (gh-4029)

      div.style.position = "absolute";
      scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
      documentElement.removeChild(container); // Nullify the div so it wouldn't be stored in the memory and
      // it will also be a sign that checks already performed

      div = null;
    }

    function roundPixelMeasures(measure) {
      return Math.round(parseFloat(measure));
    }

    var pixelPositionVal,
        boxSizingReliableVal,
        scrollboxSizeVal,
        pixelBoxStylesVal,
        reliableTrDimensionsVal,
        reliableMarginLeftVal,
        container = document.createElement("div"),
        div = document.createElement("div"); // Finish early in limited (non-browser) environments

    if (!div.style) {
      return;
    } // Support: IE <=9 - 11 only
    // Style of cloned element affects source element cloned (trac-8908)


    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";
    jQuery.extend(support, {
      boxSizingReliable: function boxSizingReliable() {
        computeStyleTests();
        return boxSizingReliableVal;
      },
      pixelBoxStyles: function pixelBoxStyles() {
        computeStyleTests();
        return pixelBoxStylesVal;
      },
      pixelPosition: function pixelPosition() {
        computeStyleTests();
        return pixelPositionVal;
      },
      reliableMarginLeft: function reliableMarginLeft() {
        computeStyleTests();
        return reliableMarginLeftVal;
      },
      scrollboxSize: function scrollboxSize() {
        computeStyleTests();
        return scrollboxSizeVal;
      },
      // Support: IE 9 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Behavior in IE 9 is more subtle than in newer versions & it passes
      // some versions of this test; make sure not to make it pass there!
      //
      // Support: Firefox 70+
      // Only Firefox includes border widths
      // in computed dimensions. (gh-4529)
      reliableTrDimensions: function reliableTrDimensions() {
        var table, tr, trChild, trStyle;

        if (reliableTrDimensionsVal == null) {
          table = document.createElement("table");
          tr = document.createElement("tr");
          trChild = document.createElement("div");
          table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
          tr.style.cssText = "border:1px solid"; // Support: Chrome 86+
          // Height set through cssText does not get applied.
          // Computed height then comes back as 0.

          tr.style.height = "1px";
          trChild.style.height = "9px"; // Support: Android 8 Chrome 86+
          // In our bodyBackground.html iframe,
          // display for all div elements is set to "inline",
          // which causes a problem only in Android 8 Chrome 86.
          // Ensuring the div is display: block
          // gets around this issue.

          trChild.style.display = "block";
          documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
          trStyle = window.getComputedStyle(tr);
          reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
          documentElement.removeChild(table);
        }

        return reliableTrDimensionsVal;
      }
    });
  })();

  function curCSS(elem, name, computed) {
    var width,
        minWidth,
        maxWidth,
        ret,
        isCustomProp = rcustomProp.test(name),
        // Support: Firefox 51+
    // Retrieving style before computed somehow
    // fixes an issue with getting wrong values
    // on detached elements
    style = elem.style;
    computed = computed || getStyles(elem); // getPropertyValue is needed for:
    //   .css('filter') (IE 9 only, trac-12537)
    //   .css('--customProperty) (gh-3144)

    if (computed) {
      // Support: IE <=9 - 11+
      // IE only supports `"float"` in `getPropertyValue`; in computed styles
      // it's only available as `"cssFloat"`. We no longer modify properties
      // sent to `.css()` apart from camelCasing, so we need to check both.
      // Normally, this would create difference in behavior: if
      // `getPropertyValue` returns an empty string, the value returned
      // by `.css()` would be `undefined`. This is usually the case for
      // disconnected elements. However, in IE even disconnected elements
      // with no styles return `"none"` for `getPropertyValue( "float" )`
      ret = computed.getPropertyValue(name) || computed[name];

      if (isCustomProp && ret) {
        // Support: Firefox 105+, Chrome <=105+
        // Spec requires trimming whitespace for custom properties (gh-4926).
        // Firefox only trims leading whitespace. Chrome just collapses
        // both leading & trailing whitespace to a single space.
        //
        // Fall back to `undefined` if empty string returned.
        // This collapses a missing definition with property defined
        // and set to an empty string but there's no standard API
        // allowing us to differentiate them without a performance penalty
        // and returning `undefined` aligns with older jQuery.
        //
        // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
        // as whitespace while CSS does not, but this is not a problem
        // because CSS preprocessing replaces them with U+000A LINE FEED
        // (which *is* CSS whitespace)
        // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
        ret = ret.replace(rtrimCSS, "$1") || undefined;
      }

      if (ret === "" && !isAttached(elem)) {
        ret = jQuery.style(elem, name);
      } // A tribute to the "awesome hack by Dean Edwards"
      // Android Browser returns percentage for some values,
      // but width seems to be reliably pixels.
      // This is against the CSSOM draft spec:
      // https://drafts.csswg.org/cssom/#resolved-values


      if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
        // Remember the original values
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth; // Put in the new values to get a computed value out

        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width; // Revert the changed values

        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }

    return ret !== undefined ? // Support: IE <=9 - 11 only
    // IE returns zIndex value as an integer.
    ret + "" : ret;
  }

  function addGetHookIf(conditionFn, hookFn) {
    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function get() {
        if (conditionFn()) {
          // Hook not needed (or it's not possible to use it due
          // to missing dependency), remove it.
          delete this.get;
          return;
        } // Hook needed; redefine it so that the support test is not executed again.


        return (this.get = hookFn).apply(this, arguments);
      }
    };
  }

  var cssPrefixes = ["Webkit", "Moz", "ms"],
      emptyStyle = document.createElement("div").style,
      vendorProps = {}; // Return a vendor-prefixed property or undefined

  function vendorPropName(name) {
    // Check for vendor prefixed names
    var capName = name[0].toUpperCase() + name.slice(1),
        i = cssPrefixes.length;

    while (i--) {
      name = cssPrefixes[i] + capName;

      if (name in emptyStyle) {
        return name;
      }
    }
  } // Return a potentially-mapped jQuery.cssProps or vendor prefixed property


  function finalPropName(name) {
    var final = jQuery.cssProps[name] || vendorProps[name];

    if (final) {
      return final;
    }

    if (name in emptyStyle) {
      return name;
    }

    return vendorProps[name] = vendorPropName(name) || name;
  }

  var // Swappable if display is none or starts with table
  // except "table", "table-cell", or "table-caption"
  // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
  rdisplayswap = /^(none|table(?!-c[ea]).+)/,
      cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  },
      cssNormalTransform = {
    letterSpacing: "0",
    fontWeight: "400"
  };

  function setPositiveNumber(_elem, value, subtract) {
    // Any relative (+/-) values have already been
    // normalized at this point
    var matches = rcssNum.exec(value);
    return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
    Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
  }

  function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
    var i = dimension === "width" ? 1 : 0,
        extra = 0,
        delta = 0; // Adjustment may not be necessary

    if (box === (isBorderBox ? "border" : "content")) {
      return 0;
    }

    for (; i < 4; i += 2) {
      // Both box models exclude margin
      if (box === "margin") {
        delta += jQuery.css(elem, box + cssExpand[i], true, styles);
      } // If we get here with a content-box, we're seeking "padding" or "border" or "margin"


      if (!isBorderBox) {
        // Add padding
        delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles); // For "border" or "margin", add border

        if (box !== "padding") {
          delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles); // But still keep track of it otherwise
        } else {
          extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        } // If we get here with a border-box (content + padding + border), we're seeking "content" or
        // "padding" or "margin"

      } else {
        // For "content", subtract padding
        if (box === "content") {
          delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        } // For "content" or "padding", subtract border


        if (box !== "margin") {
          delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    } // Account for positive content-box scroll gutter when requested by providing computedVal


    if (!isBorderBox && computedVal >= 0) {
      // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
      // Assuming integer scroll gutter, subtract the rest and round down
      delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5 // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
      // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0;
    }

    return delta;
  }

  function getWidthOrHeight(elem, dimension, extra) {
    // Start with computed style
    var styles = getStyles(elem),
        // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
    // Fake content-box until we know it's needed to know the true value.
    boxSizingNeeded = !support.boxSizingReliable() || extra,
        isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
        valueIsBorderBox = isBorderBox,
        val = curCSS(elem, dimension, styles),
        offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1); // Support: Firefox <=54
    // Return a confounding non-pixel value or feign ignorance, as appropriate.

    if (rnumnonpx.test(val)) {
      if (!extra) {
        return val;
      }

      val = "auto";
    } // Support: IE 9 - 11 only
    // Use offsetWidth/offsetHeight for when box sizing is unreliable.
    // In those cases, the computed value can be trusted to be border-box.


    if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
    // IE/Edge misreport `getComputedStyle` of table rows with width/height
    // set in CSS while `offset*` properties report correct values.
    // Interestingly, in some cases IE 9 doesn't suffer from this issue.
    !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
    // This happens for inline elements with no explicit setting (gh-3571)
    val === "auto" || // Support: Android <=4.1 - 4.3 only
    // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
    !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
    elem.getClientRects().length) {
      isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box"; // Where available, offsetWidth/offsetHeight approximate border box dimensions.
      // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
      // retrieved value as a content box dimension.

      valueIsBorderBox = offsetProp in elem;

      if (valueIsBorderBox) {
        val = elem[offsetProp];
      }
    } // Normalize "" and auto


    val = parseFloat(val) || 0; // Adjust for the element's box model

    return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
    val) + "px";
  }

  jQuery.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function get(elem, computed) {
          if (computed) {
            // We should always get a number back from opacity
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }
      }
    },
    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      "animationIterationCount": true,
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "gridArea": true,
      "gridColumn": true,
      "gridColumnEnd": true,
      "gridColumnStart": true,
      "gridRow": true,
      "gridRowEnd": true,
      "gridRowStart": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },
    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {},
    // Get and set the style property on a DOM Node
    style: function style(elem, name, value, extra) {
      // Don't set styles on text and comment nodes
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      } // Make sure that we're working with the right name


      var ret,
          type,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name),
          style = elem.style; // Make sure that we're working with the right name. We don't
      // want to query the value if it is a CSS custom property
      // since they are user-defined.

      if (!isCustomProp) {
        name = finalPropName(origName);
      } // Gets hook for the prefixed version, then unprefixed version


      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // Check if we're setting a value

      if (value !== undefined) {
        type = _typeof(value); // Convert "+=" or "-=" to relative numbers (trac-7345)

        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
          value = adjustCSS(elem, name, ret); // Fixes bug trac-9237

          type = "number";
        } // Make sure that null and NaN values aren't set (trac-7116)


        if (value == null || value !== value) {
          return;
        } // If a number was passed in, add the unit (except for certain CSS properties)
        // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
        // "px" to a few hardcoded values.


        if (type === "number" && !isCustomProp) {
          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
        } // background-* props affect original clone's values


        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        } // If a hook was provided, use that value, otherwise just set the specified value


        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          if (isCustomProp) {
            style.setProperty(name, value);
          } else {
            style[name] = value;
          }
        }
      } else {
        // If a hook was provided get the non-computed value from there
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        } // Otherwise just get the value from the style object


        return style[name];
      }
    },
    css: function css(elem, name, extra, styles) {
      var val,
          num,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name); // Make sure that we're working with the right name. We don't
      // want to modify the value if it is a CSS custom property
      // since they are user-defined.

      if (!isCustomProp) {
        name = finalPropName(origName);
      } // Try prefixed name followed by the unprefixed name


      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // If a hook was provided get the computed value from there

      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      } // Otherwise, if a way to get the computed value exists, use that


      if (val === undefined) {
        val = curCSS(elem, name, styles);
      } // Convert "normal" to computed value


      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      } // Make numeric if forced or a qualifier was provided and val looks numeric


      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || isFinite(num) ? num || 0 : val;
      }

      return val;
    }
  });
  jQuery.each(["height", "width"], function (_i, dimension) {
    jQuery.cssHooks[dimension] = {
      get: function get(elem, computed, extra) {
        if (computed) {
          // Certain elements can have dimension info if we invisibly show them
          // but it must have a current display style that would benefit
          return rdisplayswap.test(jQuery.css(elem, "display")) && ( // Support: Safari 8+
          // Table columns in Safari have non-zero offsetWidth & zero
          // getBoundingClientRect().width unless display is changed.
          // Support: IE <=11 only
          // Running getBoundingClientRect on a disconnected node
          // in IE throws an error.
          !elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
            return getWidthOrHeight(elem, dimension, extra);
          }) : getWidthOrHeight(elem, dimension, extra);
        }
      },
      set: function set(elem, value, extra) {
        var matches,
            styles = getStyles(elem),
            // Only read styles.position if the test has a chance to fail
        // to avoid forcing a reflow.
        scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",
            // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
        boxSizingNeeded = scrollboxSizeBuggy || extra,
            isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
            subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0; // Account for unreliable border-box dimensions by comparing offset* to computed and
        // faking a content-box to get border and padding (gh-3699)

        if (isBorderBox && scrollboxSizeBuggy) {
          subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
        } // Convert to pixels if value adjustment is needed


        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
          elem.style[dimension] = value;
          value = jQuery.css(elem, dimension);
        }

        return setPositiveNumber(elem, value, subtract);
      }
    };
  });
  jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
    if (computed) {
      return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
        marginLeft: 0
      }, function () {
        return elem.getBoundingClientRect().left;
      })) + "px";
    }
  }); // These hooks are used by animate to expand properties

  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {
      expand: function expand(value) {
        var i = 0,
            expanded = {},
            // Assumes a single number if not a string
        parts = typeof value === "string" ? value.split(" ") : [value];

        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }

        return expanded;
      }
    };

    if (prefix !== "margin") {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({
    css: function css(name, value) {
      return access(this, function (elem, name, value) {
        var styles,
            len,
            map = {},
            i = 0;

        if (Array.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;

          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }

          return map;
        }

        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    }
  });

  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }

  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function init(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function cur() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function run(percent) {
      var eased,
          hooks = Tween.propHooks[this.prop];

      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }

      this.now = (this.end - this.start) * eased + this.start;

      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }

      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }

      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {
    _default: {
      get: function get(tween) {
        var result; // Use a property on the element directly when it is not a DOM element,
        // or when there is no matching style property that exists.

        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
          return tween.elem[tween.prop];
        } // Passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails.
        // Simple values such as "10px" are parsed to Float;
        // complex values such as "rotate(1rad)" are returned as-is.


        result = jQuery.css(tween.elem, tween.prop, ""); // Empty strings, null, undefined and "auto" are converted to 0.

        return !result || result === "auto" ? 0 : result;
      },
      set: function set(tween) {
        // Use step hook for back compat.
        // Use cssHook if its there.
        // Use .style if available and use plain properties where available.
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }
  }; // Support: IE <=9 only
  // Panic based approach to setting things on disconnected nodes

  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function set(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }
  };
  jQuery.easing = {
    linear: function linear(p) {
      return p;
    },
    swing: function swing(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
    _default: "swing"
  };
  jQuery.fx = Tween.prototype.init; // Back compat <1.8 extension point

  jQuery.fx.step = {};
  var fxNow,
      inProgress,
      rfxtypes = /^(?:toggle|show|hide)$/,
      rrun = /queueHooks$/;

  function schedule() {
    if (inProgress) {
      if (document.hidden === false && window.requestAnimationFrame) {
        window.requestAnimationFrame(schedule);
      } else {
        window.setTimeout(schedule, jQuery.fx.interval);
      }

      jQuery.fx.tick();
    }
  } // Animations created synchronously will run synchronously


  function createFxNow() {
    window.setTimeout(function () {
      fxNow = undefined;
    });
    return fxNow = Date.now();
  } // Generate parameters to create a standard animation


  function genFx(type, includeWidth) {
    var which,
        i = 0,
        attrs = {
      height: type
    }; // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right

    includeWidth = includeWidth ? 1 : 0;

    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }

    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }

  function createTween(value, prop, animation) {
    var tween,
        collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
        index = 0,
        length = collection.length;

    for (; index < length; index++) {
      if (tween = collection[index].call(animation, prop, value)) {
        // We're done with this property
        return tween;
      }
    }
  }

  function defaultPrefilter(elem, props, opts) {
    var prop,
        value,
        toggle,
        hooks,
        oldfire,
        propTween,
        restoreDisplay,
        display,
        isBox = "width" in props || "height" in props,
        anim = this,
        orig = {},
        style = elem.style,
        hidden = elem.nodeType && isHiddenWithinTree(elem),
        dataShow = dataPriv.get(elem, "fxshow"); // Queue-skipping animations hijack the fx hooks

    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");

      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;

        hooks.empty.fire = function () {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }

      hooks.unqueued++;
      anim.always(function () {
        // Ensure the complete handler is called before this completes
        anim.always(function () {
          hooks.unqueued--;

          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    } // Detect show/hide animations


    for (prop in props) {
      value = props[prop];

      if (rfxtypes.test(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";

        if (value === (hidden ? "hide" : "show")) {
          // Pretend to be hidden if this is a "show" and
          // there is still data from a stopped show/hide
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true; // Ignore all other no-op show/hide data
          } else {
            continue;
          }
        }

        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
      }
    } // Bail out if this is a no-op like .hide().hide()


    propTween = !jQuery.isEmptyObject(props);

    if (!propTween && jQuery.isEmptyObject(orig)) {
      return;
    } // Restrict "overflow" and "display" styles during box animations


    if (isBox && elem.nodeType === 1) {
      // Support: IE <=9 - 11, Edge 12 - 15
      // Record all 3 overflow attributes because IE does not infer the shorthand
      // from identically-valued overflowX and overflowY and Edge just mirrors
      // the overflowX value there.
      opts.overflow = [style.overflow, style.overflowX, style.overflowY]; // Identify a display type, preferring old show/hide data over the CSS cascade

      restoreDisplay = dataShow && dataShow.display;

      if (restoreDisplay == null) {
        restoreDisplay = dataPriv.get(elem, "display");
      }

      display = jQuery.css(elem, "display");

      if (display === "none") {
        if (restoreDisplay) {
          display = restoreDisplay;
        } else {
          // Get nonempty value(s) by temporarily forcing visibility
          showHide([elem], true);
          restoreDisplay = elem.style.display || restoreDisplay;
          display = jQuery.css(elem, "display");
          showHide([elem]);
        }
      } // Animate inline elements as inline-block


      if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
        if (jQuery.css(elem, "float") === "none") {
          // Restore the original display value at the end of pure show/hide animations
          if (!propTween) {
            anim.done(function () {
              style.display = restoreDisplay;
            });

            if (restoreDisplay == null) {
              display = style.display;
              restoreDisplay = display === "none" ? "" : display;
            }
          }

          style.display = "inline-block";
        }
      }
    }

    if (opts.overflow) {
      style.overflow = "hidden";
      anim.always(function () {
        style.overflow = opts.overflow[0];
        style.overflowX = opts.overflow[1];
        style.overflowY = opts.overflow[2];
      });
    } // Implement show/hide animations


    propTween = false;

    for (prop in orig) {
      // General show/hide setup for this element animation
      if (!propTween) {
        if (dataShow) {
          if ("hidden" in dataShow) {
            hidden = dataShow.hidden;
          }
        } else {
          dataShow = dataPriv.access(elem, "fxshow", {
            display: restoreDisplay
          });
        } // Store hidden/visible for toggle so `.stop().toggle()` "reverses"


        if (toggle) {
          dataShow.hidden = !hidden;
        } // Show elements before animating them


        if (hidden) {
          showHide([elem], true);
        }
        /* eslint-disable no-loop-func */


        anim.done(function () {
          /* eslint-enable no-loop-func */
          // The final step of a "hide" animation is actually hiding the element
          if (!hidden) {
            showHide([elem]);
          }

          dataPriv.remove(elem, "fxshow");

          for (prop in orig) {
            jQuery.style(elem, prop, orig[prop]);
          }
        });
      } // Per-property setup


      propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);

      if (!(prop in dataShow)) {
        dataShow[prop] = propTween.start;

        if (hidden) {
          propTween.end = propTween.start;
          propTween.start = 0;
        }
      }
    }
  }

  function propFilter(props, specialEasing) {
    var index, name, easing, value, hooks; // camelCase, specialEasing and expand cssHook pass

    for (index in props) {
      name = camelCase(index);
      easing = specialEasing[name];
      value = props[index];

      if (Array.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }

      if (index !== name) {
        props[name] = value;
        delete props[index];
      }

      hooks = jQuery.cssHooks[name];

      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name]; // Not quite $.extend, this won't overwrite existing keys.
        // Reusing 'index' because we have the correct "name"

        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }

  function Animation(elem, properties, options) {
    var result,
        stopped,
        index = 0,
        length = Animation.prefilters.length,
        deferred = jQuery.Deferred().always(function () {
      // Don't match elem in the :animated selector
      delete tick.elem;
    }),
        tick = function tick() {
      if (stopped) {
        return false;
      }

      var currentTime = fxNow || createFxNow(),
          remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
          // Support: Android 2.3 only
      // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
      temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;

      for (; index < length; index++) {
        animation.tweens[index].run(percent);
      }

      deferred.notifyWith(elem, [animation, percent, remaining]); // If there's more to do, yield

      if (percent < 1 && length) {
        return remaining;
      } // If this was an empty animation, synthesize a final progress notification


      if (!length) {
        deferred.notifyWith(elem, [animation, 1, 0]);
      } // Resolve the animation and report its conclusion


      deferred.resolveWith(elem, [animation]);
      return false;
    },
        animation = deferred.promise({
      elem: elem,
      props: jQuery.extend({}, properties),
      opts: jQuery.extend(true, {
        specialEasing: {},
        easing: jQuery.easing._default
      }, options),
      originalProperties: properties,
      originalOptions: options,
      startTime: fxNow || createFxNow(),
      duration: options.duration,
      tweens: [],
      createTween: function createTween(prop, end) {
        var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
        animation.tweens.push(tween);
        return tween;
      },
      stop: function stop(gotoEnd) {
        var index = 0,
            // If we are going to the end, we want to run all the tweens
        // otherwise we skip this part
        length = gotoEnd ? animation.tweens.length : 0;

        if (stopped) {
          return this;
        }

        stopped = true;

        for (; index < length; index++) {
          animation.tweens[index].run(1);
        } // Resolve when we played the last frame; otherwise, reject


        if (gotoEnd) {
          deferred.notifyWith(elem, [animation, 1, 0]);
          deferred.resolveWith(elem, [animation, gotoEnd]);
        } else {
          deferred.rejectWith(elem, [animation, gotoEnd]);
        }

        return this;
      }
    }),
        props = animation.props;

    propFilter(props, animation.opts.specialEasing);

    for (; index < length; index++) {
      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);

      if (result) {
        if (isFunction(result.stop)) {
          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
        }

        return result;
      }
    }

    jQuery.map(props, createTween, animation);

    if (isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    } // Attach callbacks from options


    animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    }));
    return animation;
  }

  jQuery.Animation = jQuery.extend(Animation, {
    tweeners: {
      "*": [function (prop, value) {
        var tween = this.createTween(prop, value);
        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
        return tween;
      }]
    },
    tweener: function tweener(props, callback) {
      if (isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.match(rnothtmlwhite);
      }

      var prop,
          index = 0,
          length = props.length;

      for (; index < length; index++) {
        prop = props[index];
        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
        Animation.tweeners[prop].unshift(callback);
      }
    },
    prefilters: [defaultPrefilter],
    prefilter: function prefilter(callback, prepend) {
      if (prepend) {
        Animation.prefilters.unshift(callback);
      } else {
        Animation.prefilters.push(callback);
      }
    }
  });

  jQuery.speed = function (speed, easing, fn) {
    var opt = speed && _typeof(speed) === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !isFunction(easing) && easing
    }; // Go to the end state if fx are off

    if (jQuery.fx.off) {
      opt.duration = 0;
    } else {
      if (typeof opt.duration !== "number") {
        if (opt.duration in jQuery.fx.speeds) {
          opt.duration = jQuery.fx.speeds[opt.duration];
        } else {
          opt.duration = jQuery.fx.speeds._default;
        }
      }
    } // Normalize opt.queue - true/undefined/null -> "fx"


    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    } // Queueing


    opt.old = opt.complete;

    opt.complete = function () {
      if (isFunction(opt.old)) {
        opt.old.call(this);
      }

      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };

    return opt;
  };

  jQuery.fn.extend({
    fadeTo: function fadeTo(speed, to, easing, callback) {
      // Show any hidden elements after setting opacity to 0
      return this.filter(isHiddenWithinTree).css("opacity", 0).show() // Animate to the value specified
      .end().animate({
        opacity: to
      }, speed, easing, callback);
    },
    animate: function animate(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
          optall = jQuery.speed(speed, easing, callback),
          doAnimation = function doAnimation() {
        // Operate on a copy of prop so per-property easing won't be lost
        var anim = Animation(this, jQuery.extend({}, prop), optall); // Empty animations, or finishing resolves immediately

        if (empty || dataPriv.get(this, "finish")) {
          anim.stop(true);
        }
      };

      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function stop(type, clearQueue, gotoEnd) {
      var stopQueue = function stopQueue(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };

      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }

      if (clearQueue) {
        this.queue(type || "fx", []);
      }

      return this.each(function () {
        var dequeue = true,
            index = type != null && type + "queueHooks",
            timers = jQuery.timers,
            data = dataPriv.get(this);

        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }

        for (index = timers.length; index--;) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        } // Start the next in the queue if the last step wasn't forced.
        // Timers currently will call their complete callbacks, which
        // will dequeue but only if they were gotoEnd.


        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function finish(type) {
      if (type !== false) {
        type = type || "fx";
      }

      return this.each(function () {
        var index,
            data = dataPriv.get(this),
            queue = data[type + "queue"],
            hooks = data[type + "queueHooks"],
            timers = jQuery.timers,
            length = queue ? queue.length : 0; // Enable finishing flag on private data

        data.finish = true; // Empty the queue first

        jQuery.queue(this, type, []);

        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        } // Look for any active animations, and finish them


        for (index = timers.length; index--;) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        } // Look for any animations in the old queue and finish them


        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        } // Turn off finishing flag


        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function (_i, name) {
    var cssFn = jQuery.fn[name];

    jQuery.fn[name] = function (speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  }); // Generate shortcuts for custom animations

  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (name, props) {
    jQuery.fn[name] = function (speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];

  jQuery.fx.tick = function () {
    var timer,
        i = 0,
        timers = jQuery.timers;
    fxNow = Date.now();

    for (; i < timers.length; i++) {
      timer = timers[i]; // Run the timer and safely remove it when done (allowing for external removal)

      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }

    if (!timers.length) {
      jQuery.fx.stop();
    }

    fxNow = undefined;
  };

  jQuery.fx.timer = function (timer) {
    jQuery.timers.push(timer);
    jQuery.fx.start();
  };

  jQuery.fx.interval = 13;

  jQuery.fx.start = function () {
    if (inProgress) {
      return;
    }

    inProgress = true;
    schedule();
  };

  jQuery.fx.stop = function () {
    inProgress = null;
  };

  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  }; // Based off of the plugin by Clint Helfers, with permission.

  jQuery.fn.delay = function (time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function (next, hooks) {
      var timeout = window.setTimeout(next, time);

      hooks.stop = function () {
        window.clearTimeout(timeout);
      };
    });
  };

  (function () {
    var input = document.createElement("input"),
        select = document.createElement("select"),
        opt = select.appendChild(document.createElement("option"));
    input.type = "checkbox"; // Support: Android <=4.3 only
    // Default value for a checkbox should be "on"

    support.checkOn = input.value !== ""; // Support: IE <=11 only
    // Must access selectedIndex to make default options select

    support.optSelected = opt.selected; // Support: IE <=11 only
    // An input loses its value after becoming a radio

    input = document.createElement("input");
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  })();

  var boolHook,
      attrHandle = jQuery.expr.attrHandle;
  jQuery.fn.extend({
    attr: function attr(name, value) {
      return access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function removeAttr(name) {
      return this.each(function () {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function attr(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType; // Don't get/set attributes on text, comment and attribute nodes

      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      } // Fallback to prop when attributes are not supported


      if (typeof elem.getAttribute === "undefined") {
        return jQuery.prop(elem, name, value);
      } // Attribute hooks are determined by the lowercase version
      // Grab necessary hook if one is defined


      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
      }

      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
          return;
        }

        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }

        elem.setAttribute(name, value + "");
        return value;
      }

      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }

      ret = jQuery.find.attr(elem, name); // Non-existent attributes return null, we normalize to undefined

      return ret == null ? undefined : ret;
    },
    attrHooks: {
      type: {
        set: function set(elem, value) {
          if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
            var val = elem.value;
            elem.setAttribute("type", value);

            if (val) {
              elem.value = val;
            }

            return value;
          }
        }
      }
    },
    removeAttr: function removeAttr(elem, value) {
      var name,
          i = 0,
          // Attribute names can contain non-HTML whitespace characters
      // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
      attrNames = value && value.match(rnothtmlwhite);

      if (attrNames && elem.nodeType === 1) {
        while (name = attrNames[i++]) {
          elem.removeAttribute(name);
        }
      }
    }
  }); // Hooks for boolean attributes

  boolHook = {
    set: function set(elem, value, name) {
      if (value === false) {
        // Remove boolean attributes when set to false
        jQuery.removeAttr(elem, name);
      } else {
        elem.setAttribute(name, name);
      }

      return name;
    }
  };
  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;

    attrHandle[name] = function (elem, name, isXML) {
      var ret,
          handle,
          lowercaseName = name.toLowerCase();

      if (!isXML) {
        // Avoid an infinite loop by temporarily removing this function from the getter
        handle = attrHandle[lowercaseName];
        attrHandle[lowercaseName] = ret;
        ret = getter(elem, name, isXML) != null ? lowercaseName : null;
        attrHandle[lowercaseName] = handle;
      }

      return ret;
    };
  });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
      rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function prop(name, value) {
      return access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function removeProp(name) {
      return this.each(function () {
        delete this[jQuery.propFix[name] || name];
      });
    }
  });
  jQuery.extend({
    prop: function prop(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType; // Don't get/set properties on text, comment and attribute nodes

      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }

      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        // Fix name and attach hooks
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }

      if (value !== undefined) {
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }

        return elem[name] = value;
      }

      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }

      return elem[name];
    },
    propHooks: {
      tabIndex: {
        get: function get(elem) {
          // Support: IE <=9 - 11 only
          // elem.tabIndex doesn't always return the
          // correct value when it hasn't been explicitly set
          // Use proper attribute retrieval (trac-12072)
          var tabindex = jQuery.find.attr(elem, "tabindex");

          if (tabindex) {
            return parseInt(tabindex, 10);
          }

          if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
            return 0;
          }

          return -1;
        }
      }
    },
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  }); // Support: IE <=11 only
  // Accessing the selectedIndex property
  // forces the browser to respect setting selected
  // on the option
  // The getter ensures a default option is selected
  // when in an optgroup
  // eslint rule "no-unused-expressions" is disabled for this code
  // since it considers such accessions noop

  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function get(elem) {
        /* eslint no-unused-expressions: "off" */
        var parent = elem.parentNode;

        if (parent && parent.parentNode) {
          parent.parentNode.selectedIndex;
        }

        return null;
      },
      set: function set(elem) {
        /* eslint no-unused-expressions: "off" */
        var parent = elem.parentNode;

        if (parent) {
          parent.selectedIndex;

          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }

  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    jQuery.propFix[this.toLowerCase()] = this;
  }); // Strip and collapse whitespace according to HTML spec
  // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace

  function stripAndCollapse(value) {
    var tokens = value.match(rnothtmlwhite) || [];
    return tokens.join(" ");
  }

  function getClass(elem) {
    return elem.getAttribute && elem.getAttribute("class") || "";
  }

  function classesToArray(value) {
    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === "string") {
      return value.match(rnothtmlwhite) || [];
    }

    return [];
  }

  jQuery.fn.extend({
    addClass: function addClass(value) {
      var classNames, cur, curValue, className, i, finalValue;

      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).addClass(value.call(this, j, getClass(this)));
        });
      }

      classNames = classesToArray(value);

      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this);
          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];

              if (cur.indexOf(" " + className + " ") < 0) {
                cur += className + " ";
              }
            } // Only assign if different to avoid unneeded rendering.


            finalValue = stripAndCollapse(cur);

            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }

      return this;
    },
    removeClass: function removeClass(value) {
      var classNames, cur, curValue, className, i, finalValue;

      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).removeClass(value.call(this, j, getClass(this)));
        });
      }

      if (!arguments.length) {
        return this.attr("class", "");
      }

      classNames = classesToArray(value);

      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this); // This expression is here for better compressibility (see addClass)

          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i]; // Remove *all* instances

              while (cur.indexOf(" " + className + " ") > -1) {
                cur = cur.replace(" " + className + " ", " ");
              }
            } // Only assign if different to avoid unneeded rendering.


            finalValue = stripAndCollapse(cur);

            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }

      return this;
    },
    toggleClass: function toggleClass(value, stateVal) {
      var classNames,
          className,
          i,
          self,
          type = _typeof(value),
          isValidValue = type === "string" || Array.isArray(value);

      if (isFunction(value)) {
        return this.each(function (i) {
          jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
        });
      }

      if (typeof stateVal === "boolean" && isValidValue) {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }

      classNames = classesToArray(value);
      return this.each(function () {
        if (isValidValue) {
          // Toggle individual class names
          self = jQuery(this);

          for (i = 0; i < classNames.length; i++) {
            className = classNames[i]; // Check each className given, space separated list

            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          } // Toggle whole class name

        } else if (value === undefined || type === "boolean") {
          className = getClass(this);

          if (className) {
            // Store className if set
            dataPriv.set(this, "__className__", className);
          } // If the element has a class name or if we're passed `false`,
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.


          if (this.setAttribute) {
            this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
          }
        }
      });
    },
    hasClass: function hasClass(selector) {
      var className,
          elem,
          i = 0;
      className = " " + selector + " ";

      while (elem = this[i++]) {
        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
          return true;
        }
      }

      return false;
    }
  });
  var rreturn = /\r/g;
  jQuery.fn.extend({
    val: function val(value) {
      var hooks,
          ret,
          valueIsFunction,
          elem = this[0];

      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }

          ret = elem.value; // Handle most common string cases

          if (typeof ret === "string") {
            return ret.replace(rreturn, "");
          } // Handle cases where value is null/undef or number


          return ret == null ? "" : ret;
        }

        return;
      }

      valueIsFunction = isFunction(value);
      return this.each(function (i) {
        var val;

        if (this.nodeType !== 1) {
          return;
        }

        if (valueIsFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        } // Treat null/undefined as ""; convert numbers to string


        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (Array.isArray(val)) {
          val = jQuery.map(val, function (value) {
            return value == null ? "" : value + "";
          });
        }

        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()]; // If set returns undefined, fall back to normal setting

        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }
  });
  jQuery.extend({
    valHooks: {
      option: {
        get: function get(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val : // Support: IE <=10 - 11 only
          // option.text throws exceptions (trac-14686, trac-14858)
          // Strip and collapse whitespace
          // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
          stripAndCollapse(jQuery.text(elem));
        }
      },
      select: {
        get: function get(elem) {
          var value,
              option,
              i,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one",
              values = one ? null : [],
              max = one ? index + 1 : options.length;

          if (index < 0) {
            i = max;
          } else {
            i = one ? index : 0;
          } // Loop through all the selected options


          for (; i < max; i++) {
            option = options[i]; // Support: IE <=9 only
            // IE8-9 doesn't update selected after form reset (trac-2551)

            if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
            !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
              // Get the specific value for the option
              value = jQuery(option).val(); // We don't need an array for one selects

              if (one) {
                return value;
              } // Multi-Selects return an array


              values.push(value);
            }
          }

          return values;
        },
        set: function set(elem, value) {
          var optionSet,
              option,
              options = elem.options,
              values = jQuery.makeArray(value),
              i = options.length;

          while (i--) {
            option = options[i];
            /* eslint-disable no-cond-assign */

            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
              optionSet = true;
            }
            /* eslint-enable no-cond-assign */

          } // Force browsers to behave consistently when non-matching value is set


          if (!optionSet) {
            elem.selectedIndex = -1;
          }

          return values;
        }
      }
    }
  }); // Radios and checkboxes getter/setter

  jQuery.each(["radio", "checkbox"], function () {
    jQuery.valHooks[this] = {
      set: function set(elem, value) {
        if (Array.isArray(value)) {
          return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
        }
      }
    };

    if (!support.checkOn) {
      jQuery.valHooks[this].get = function (elem) {
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  }); // Return jQuery for attributes-only inclusion

  support.focusin = "onfocusin" in window;

  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
      stopPropagationCallback = function stopPropagationCallback(e) {
    e.stopPropagation();
  };

  jQuery.extend(jQuery.event, {
    trigger: function trigger(event, data, elem, onlyHandlers) {
      var i,
          cur,
          tmp,
          bubbleType,
          ontype,
          handle,
          special,
          lastElement,
          eventPath = [elem || document],
          type = hasOwn.call(event, "type") ? event.type : event,
          namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = lastElement = tmp = elem = elem || document; // Don't do events on text and comment nodes

      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      } // focus/blur morphs to focusin/out; ensure we're not firing them right now


      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }

      if (type.indexOf(".") > -1) {
        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }

      ontype = type.indexOf(":") < 0 && "on" + type; // Caller can pass in a jQuery.Event object, Object, or just an event type string

      event = event[jQuery.expando] ? event : new jQuery.Event(type, _typeof(event) === "object" && event); // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)

      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null; // Clean up the event in case it is being reused

      event.result = undefined;

      if (!event.target) {
        event.target = elem;
      } // Clone any incoming data and prepend the event, creating the handler arg list


      data = data == null ? [event] : jQuery.makeArray(data, [event]); // Allow special events to draw outside the lines

      special = jQuery.event.special[type] || {};

      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      } // Determine event propagation path in advance, per W3C events spec (trac-9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)


      if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
        bubbleType = special.delegateType || type;

        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }

        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        } // Only add window if we got to document (e.g., not plain obj or detached DOM)


        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      } // Fire handlers on the event path


      i = 0;

      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        lastElement = cur;
        event.type = i > 1 ? bubbleType : special.bindType || type; // jQuery handler

        handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");

        if (handle) {
          handle.apply(cur, data);
        } // Native handler


        handle = ontype && cur[ontype];

        if (handle && handle.apply && acceptData(cur)) {
          event.result = handle.apply(cur, data);

          if (event.result === false) {
            event.preventDefault();
          }
        }
      }

      event.type = type; // If nobody prevented the default action, do it now

      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
          // Call a native DOM method on the target with the same name as the event.
          // Don't do default actions on window, that's where global variables be (trac-6170)
          if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ontype];

            if (tmp) {
              elem[ontype] = null;
            } // Prevent re-triggering of the same event, since we already bubbled it above


            jQuery.event.triggered = type;

            if (event.isPropagationStopped()) {
              lastElement.addEventListener(type, stopPropagationCallback);
            }

            elem[type]();

            if (event.isPropagationStopped()) {
              lastElement.removeEventListener(type, stopPropagationCallback);
            }

            jQuery.event.triggered = undefined;

            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }

      return event.result;
    },
    // Piggyback on a donor event to simulate a different one
    // Used only for `focus(in | out)` events
    simulate: function simulate(type, elem, event) {
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true
      });
      jQuery.event.trigger(e, null, elem);
    }
  });
  jQuery.fn.extend({
    trigger: function trigger(type, data) {
      return this.each(function () {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function triggerHandler(type, data) {
      var elem = this[0];

      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  }); // Support: Firefox <=44
  // Firefox doesn't have focus(in | out) events
  // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
  //
  // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
  // focus(in | out) events fire after focus & blur events,
  // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
  // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857

  if (!support.focusin) {
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function (orig, fix) {
      // Attach a single capturing handler on the document while someone wants focusin/focusout
      var handler = function handler(event) {
        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
      };

      jQuery.event.special[fix] = {
        setup: function setup() {
          // Handle: regular nodes (via `this.ownerDocument`), window
          // (via `this.document`) & document (via `this`).
          var doc = this.ownerDocument || this.document || this,
              attaches = dataPriv.access(doc, fix);

          if (!attaches) {
            doc.addEventListener(orig, handler, true);
          }

          dataPriv.access(doc, fix, (attaches || 0) + 1);
        },
        teardown: function teardown() {
          var doc = this.ownerDocument || this.document || this,
              attaches = dataPriv.access(doc, fix) - 1;

          if (!attaches) {
            doc.removeEventListener(orig, handler, true);
            dataPriv.remove(doc, fix);
          } else {
            dataPriv.access(doc, fix, attaches);
          }
        }
      };
    });
  }

  var location = window.location;
  var nonce = {
    guid: Date.now()
  };
  var rquery = /\?/; // Cross-browser xml parsing

  jQuery.parseXML = function (data) {
    var xml, parserErrorElem;

    if (!data || typeof data !== "string") {
      return null;
    } // Support: IE 9 - 11 only
    // IE throws on parseFromString with invalid input.


    try {
      xml = new window.DOMParser().parseFromString(data, "text/xml");
    } catch (e) {}

    parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];

    if (!xml || parserErrorElem) {
      jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
        return el.textContent;
      }).join("\n") : data));
    }

    return xml;
  };

  var rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;

  function buildParams(prefix, obj, traditional, add) {
    var name;

    if (Array.isArray(obj)) {
      // Serialize array item.
      jQuery.each(obj, function (i, v) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(prefix + "[" + (_typeof(v) === "object" && v != null ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && toType(obj) === "object") {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj);
    }
  } // Serialize an array of form elements or a set of
  // key/values into a query string


  jQuery.param = function (a, traditional) {
    var prefix,
        s = [],
        add = function add(key, valueOrFunction) {
      // If value is a function, invoke it and use its return value
      var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
      s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
    };

    if (a == null) {
      return "";
    } // If an array was passed in, assume that it is an array of form elements.


    if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
      // Serialize the form elements
      jQuery.each(a, function () {
        add(this.name, this.value);
      });
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    } // Return the resulting serialization


    return s.join("&");
  };

  jQuery.fn.extend({
    serialize: function serialize() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function () {
        var type = this.type; // Use .is( ":disabled" ) so that fieldset[disabled] works

        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function (_i, elem) {
        var val = jQuery(this).val();

        if (val == null) {
          return null;
        }

        if (Array.isArray(val)) {
          return jQuery.map(val, function (val) {
            return {
              name: elem.name,
              value: val.replace(rCRLF, "\r\n")
            };
          });
        }

        return {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  });
  var r20 = /%20/g,
      rhash = /#.*$/,
      rantiCache = /([?&])_=[^&]*/,
      rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
      // trac-7653, trac-8125, trac-8152: local protocol detection
  rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      rnoContent = /^(?:GET|HEAD)$/,
      rprotocol = /^\/\//,

  /* Prefilters
   * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
   * 2) These are called:
   *    - BEFORE asking for a transport
   *    - AFTER param serialization (s.data is a string if s.processData is true)
   * 3) key is the dataType
   * 4) the catchall symbol "*" can be used
   * 5) execution will start with transport dataType and THEN continue down to "*" if needed
   */
  prefilters = {},

  /* Transports bindings
   * 1) key is the dataType
   * 2) the catchall symbol "*" can be used
   * 3) selection will start with transport dataType and THEN go to "*" if needed
   */
  transports = {},
      // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
  allTypes = "*/".concat("*"),
      // Anchor tag for parsing the document origin
  originAnchor = document.createElement("a");
  originAnchor.href = location.href; // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport

  function addToPrefiltersOrTransports(structure) {
    // dataTypeExpression is optional and defaults to "*"
    return function (dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }

      var dataType,
          i = 0,
          dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

      if (isFunction(func)) {
        // For each dataType in the dataTypeExpression
        while (dataType = dataTypes[i++]) {
          // Prepend if requested
          if (dataType[0] === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func); // Otherwise append
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  } // Base inspection function for prefilters and transports


  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
        seekingTransport = structure === transports;

    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);

        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }

    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  } // A special extend for ajax options
  // that takes "flat" options (not to be deep extended)
  // Fixes trac-9887


  function ajaxExtend(target, src) {
    var key,
        deep,
        flatOptions = jQuery.ajaxSettings.flatOptions || {};

    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
      }
    }

    if (deep) {
      jQuery.extend(true, target, deep);
    }

    return target;
  }
  /* Handles responses to an ajax request:
   * - finds the right dataType (mediates between content-type and expected dataType)
   * - returns the corresponding response
   */


  function ajaxHandleResponses(s, jqXHR, responses) {
    var ct,
        type,
        finalDataType,
        firstDataType,
        contents = s.contents,
        dataTypes = s.dataTypes; // Remove auto dataType and get content-type in the process

    while (dataTypes[0] === "*") {
      dataTypes.shift();

      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    } // Check if we're dealing with a known content-type


    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    } // Check to see if we have a response for the expected dataType


    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      // Try convertible dataTypes
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }

        if (!firstDataType) {
          firstDataType = type;
        }
      } // Or just use first one


      finalDataType = finalDataType || firstDataType;
    } // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response


    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }

      return responses[finalDataType];
    }
  }
  /* Chain conversions given the request and the original response
   * Also sets the responseXXX fields on the jqXHR instance
   */


  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
        current,
        conv,
        tmp,
        prev,
        converters = {},
        // Work with a copy of dataTypes in case we need to modify it for conversion
    dataTypes = s.dataTypes.slice(); // Create converters map with lowercased keys

    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }

    current = dataTypes.shift(); // Convert to each sequential dataType

    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      } // Apply the dataFilter if provided


      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }

      prev = current;
      current = dataTypes.shift();

      if (current) {
        // There's only work to do if current dataType is non-auto
        if (current === "*") {
          current = prev; // Convert response if prev dataType is non-auto and differs from current
        } else if (prev !== "*" && prev !== current) {
          // Seek a direct converter
          conv = converters[prev + " " + current] || converters["* " + current]; // If none found, seek a pair

          if (!conv) {
            for (conv2 in converters) {
              // If conv2 outputs current
              tmp = conv2.split(" ");

              if (tmp[1] === current) {
                // If prev can be converted to accepted input
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];

                if (conv) {
                  // Condense equivalence converters
                  if (conv === true) {
                    conv = converters[conv2]; // Otherwise, insert the intermediate dataType
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }

                  break;
                }
              }
            }
          } // Apply converter (if not an equivalence)


          if (conv !== true) {
            // Unless errors are allowed to bubble, catch and return them
            if (conv && s.throws) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }

    return {
      state: "success",
      data: response
    };
  }

  jQuery.extend({
    // Counter for holding the number of active queries
    active: 0,
    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test(location.protocol),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",

      /*
      timeout: 0,
      data: null,
      dataType: null,
      username: null,
      password: null,
      cache: null,
      throws: false,
      traditional: false,
      headers: {},
      */
      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {
        // Convert anything to text
        "* text": String,
        // Text to html (true = no transformation)
        "text html": true,
        // Evaluate text as a json expression
        "text json": JSON.parse,
        // Parse text as xml
        "text xml": jQuery.parseXML
      },
      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },
    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function ajaxSetup(target, settings) {
      return settings ? // Building a settings object
      ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
      ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    // Main method
    ajax: function ajax(url, options) {
      // If url is an object, simulate pre-1.5 signature
      if (_typeof(url) === "object") {
        options = url;
        url = undefined;
      } // Force options to be an object


      options = options || {};

      var transport,
          // URL without anti-cache param
      cacheURL,
          // Response headers
      responseHeadersString,
          responseHeaders,
          // timeout handle
      timeoutTimer,
          // Url cleanup var
      urlAnchor,
          // Request state (becomes false upon send and true upon completion)
      completed,
          // To know if global events are to be dispatched
      fireGlobals,
          // Loop variable
      i,
          // uncached part of the url
      uncached,
          // Create the final options object
      s = jQuery.ajaxSetup({}, options),
          // Callbacks context
      callbackContext = s.context || s,
          // Context for global events is callbackContext if it is a DOM node or jQuery collection
      globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
          // Deferreds
      deferred = jQuery.Deferred(),
          completeDeferred = jQuery.Callbacks("once memory"),
          // Status-dependent callbacks
      _statusCode = s.statusCode || {},
          // Headers (they are sent all at once)
      requestHeaders = {},
          requestHeadersNames = {},
          // Default abort message
      strAbort = "canceled",
          // Fake xhr
      jqXHR = {
        readyState: 0,
        // Builds headers hashtable if needed
        getResponseHeader: function getResponseHeader(key) {
          var match;

          if (completed) {
            if (!responseHeaders) {
              responseHeaders = {};

              while (match = rheaders.exec(responseHeadersString)) {
                responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
              }
            }

            match = responseHeaders[key.toLowerCase() + " "];
          }

          return match == null ? null : match.join(", ");
        },
        // Raw string
        getAllResponseHeaders: function getAllResponseHeaders() {
          return completed ? responseHeadersString : null;
        },
        // Caches the header
        setRequestHeader: function setRequestHeader(name, value) {
          if (completed == null) {
            name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
            requestHeaders[name] = value;
          }

          return this;
        },
        // Overrides response content-type header
        overrideMimeType: function overrideMimeType(type) {
          if (completed == null) {
            s.mimeType = type;
          }

          return this;
        },
        // Status-dependent callbacks
        statusCode: function statusCode(map) {
          var code;

          if (map) {
            if (completed) {
              // Execute the appropriate callbacks
              jqXHR.always(map[jqXHR.status]);
            } else {
              // Lazy-add the new callbacks in a way that preserves old ones
              for (code in map) {
                _statusCode[code] = [_statusCode[code], map[code]];
              }
            }
          }

          return this;
        },
        // Cancel the request
        abort: function abort(statusText) {
          var finalText = statusText || strAbort;

          if (transport) {
            transport.abort(finalText);
          }

          done(0, finalText);
          return this;
        }
      }; // Attach deferreds


      deferred.promise(jqXHR); // Add protocol if not provided (prefilters might expect it)
      // Handle falsy url in the settings object (trac-10093: consistency with old signature)
      // We also use the url parameter if available

      s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//"); // Alias method option to type as per ticket trac-12004

      s.type = options.method || options.type || s.method || s.type; // Extract dataTypes list

      s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""]; // A cross-domain request is in order when the origin doesn't match the current origin.

      if (s.crossDomain == null) {
        urlAnchor = document.createElement("a"); // Support: IE <=8 - 11, Edge 12 - 15
        // IE throws exception on accessing the href property if url is malformed,
        // e.g. http://example.com:80x/

        try {
          urlAnchor.href = s.url; // Support: IE <=8 - 11 only
          // Anchor's host property isn't correctly set when s.url is relative

          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
        } catch (e) {
          // If there is an error parsing the URL, assume it is crossDomain,
          // it can be rejected by the transport if it is invalid
          s.crossDomain = true;
        }
      } // Convert data if not already a string


      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      } // Apply prefilters


      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR); // If request was aborted inside a prefilter, stop there

      if (completed) {
        return jqXHR;
      } // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)


      fireGlobals = jQuery.event && s.global; // Watch for a new set of requests

      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      } // Uppercase the type


      s.type = s.type.toUpperCase(); // Determine if request has content

      s.hasContent = !rnoContent.test(s.type); // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on
      // Remove hash to simplify url manipulation

      cacheURL = s.url.replace(rhash, ""); // More options handling for requests with no content

      if (!s.hasContent) {
        // Remember the hash so we can put it back
        uncached = s.url.slice(cacheURL.length); // If data is available and should be processed, append data to url

        if (s.data && (s.processData || typeof s.data === "string")) {
          cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data; // trac-9682: remove data so that it's not used in an eventual retry

          delete s.data;
        } // Add or update anti-cache param if needed


        if (s.cache === false) {
          cacheURL = cacheURL.replace(rantiCache, "$1");
          uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
        } // Put hash and anti-cache on the URL that will be requested (gh-1732)


        s.url = cacheURL + uncached; // Change '%20' to '+' if this is encoded form body content (gh-2658)
      } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
        s.data = s.data.replace(r20, "+");
      } // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.


      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }

        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      } // Set the correct header, if data is being sent


      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      } // Set the Accepts header for the server, depending on the dataType


      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]); // Check for headers option

      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      } // Allow custom headers/mimetypes and early abort


      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
        // Abort if not done already and return
        return jqXHR.abort();
      } // Aborting is no longer a cancellation


      strAbort = "abort"; // Install callbacks on deferreds

      completeDeferred.add(s.complete);
      jqXHR.done(s.success);
      jqXHR.fail(s.error); // Get transport

      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR); // If no transport, we auto-abort

      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1; // Send global event

        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        } // If request was aborted inside ajaxSend, stop there


        if (completed) {
          return jqXHR;
        } // Timeout


        if (s.async && s.timeout > 0) {
          timeoutTimer = window.setTimeout(function () {
            jqXHR.abort("timeout");
          }, s.timeout);
        }

        try {
          completed = false;
          transport.send(requestHeaders, done);
        } catch (e) {
          // Rethrow post-completion exceptions
          if (completed) {
            throw e;
          } // Propagate others as results


          done(-1, e);
        }
      } // Callback for when everything is done


      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText; // Ignore repeat invocations

        if (completed) {
          return;
        }

        completed = true; // Clear timeout if it exists

        if (timeoutTimer) {
          window.clearTimeout(timeoutTimer);
        } // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)


        transport = undefined; // Cache response headers

        responseHeadersString = headers || ""; // Set readyState

        jqXHR.readyState = status > 0 ? 4 : 0; // Determine if successful

        isSuccess = status >= 200 && status < 300 || status === 304; // Get response data

        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        } // Use a noop converter for missing script but not if jsonp


        if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
          s.converters["text script"] = function () {};
        } // Convert no matter what (that way responseXXX fields are always set)


        response = ajaxConvert(s, response, jqXHR, isSuccess); // If successful, handle type chaining

        if (isSuccess) {
          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");

            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }

            modified = jqXHR.getResponseHeader("etag");

            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          } // if no content


          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent"; // if not modified
          } else if (status === 304) {
            statusText = "notmodified"; // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          // Extract error from statusText and normalize for non-aborts
          error = statusText;

          if (status || !statusText) {
            statusText = "error";

            if (status < 0) {
              status = 0;
            }
          }
        } // Set data for the fake xhr object


        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + ""; // Success/Error

        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        } // Status-dependent callbacks


        jqXHR.statusCode(_statusCode);
        _statusCode = undefined;

        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        } // Complete


        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]); // Handle the global AJAX counter

          if (! --jQuery.active) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }

      return jqXHR;
    },
    getJSON: function getJSON(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function getScript(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function (_i, method) {
    jQuery[method] = function (url, data, callback, type) {
      // Shift arguments if data argument was omitted
      if (isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      } // The url can be an options object (which then must have .url)


      return jQuery.ajax(jQuery.extend({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject(url) && url));
    };
  });
  jQuery.ajaxPrefilter(function (s) {
    var i;

    for (i in s.headers) {
      if (i.toLowerCase() === "content-type") {
        s.contentType = s.headers[i] || "";
      }
    }
  });

  jQuery._evalUrl = function (url, options, doc) {
    return jQuery.ajax({
      url: url,
      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
      type: "GET",
      dataType: "script",
      cache: true,
      async: false,
      global: false,
      // Only evaluate the response if it is successful (gh-4126)
      // dataFilter is not invoked for failure responses, so using it instead
      // of the default converter is kludgy but it works.
      converters: {
        "text script": function textScript() {}
      },
      dataFilter: function dataFilter(response) {
        jQuery.globalEval(response, options, doc);
      }
    });
  };

  jQuery.fn.extend({
    wrapAll: function wrapAll(html) {
      var wrap;

      if (this[0]) {
        if (isFunction(html)) {
          html = html.call(this[0]);
        } // The elements to wrap the target around


        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }

        wrap.map(function () {
          var elem = this;

          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }

          return elem;
        }).append(this);
      }

      return this;
    },
    wrapInner: function wrapInner(html) {
      if (isFunction(html)) {
        return this.each(function (i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }

      return this.each(function () {
        var self = jQuery(this),
            contents = self.contents();

        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function wrap(html) {
      var htmlIsFunction = isFunction(html);
      return this.each(function (i) {
        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function unwrap(selector) {
      this.parent(selector).not("body").each(function () {
        jQuery(this).replaceWith(this.childNodes);
      });
      return this;
    }
  });

  jQuery.expr.pseudos.hidden = function (elem) {
    return !jQuery.expr.pseudos.visible(elem);
  };

  jQuery.expr.pseudos.visible = function (elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  };

  jQuery.ajaxSettings.xhr = function () {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  };

  var xhrSuccessStatus = {
    // File protocol always yields status code 0, assume 200
    0: 200,
    // Support: IE <=9 only
    // trac-1450: sometimes IE returns 1223 when it should be 204
    1223: 204
  },
      xhrSupported = jQuery.ajaxSettings.xhr();
  support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
  support.ajax = xhrSupported = !!xhrSupported;
  jQuery.ajaxTransport(function (options) {
    var _callback, errorCallback; // Cross domain only allowed if supported through XMLHttpRequest


    if (support.cors || xhrSupported && !options.crossDomain) {
      return {
        send: function send(headers, complete) {
          var i,
              xhr = options.xhr();
          xhr.open(options.type, options.url, options.async, options.username, options.password); // Apply custom fields if provided

          if (options.xhrFields) {
            for (i in options.xhrFields) {
              xhr[i] = options.xhrFields[i];
            }
          } // Override mime type if needed


          if (options.mimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(options.mimeType);
          } // X-Requested-With header
          // For cross-domain requests, seeing as conditions for a preflight are
          // akin to a jigsaw puzzle, we simply never set it to be sure.
          // (it can always be set on a per-request basis or even using ajaxSetup)
          // For same-domain requests, won't change header if already provided.


          if (!options.crossDomain && !headers["X-Requested-With"]) {
            headers["X-Requested-With"] = "XMLHttpRequest";
          } // Set headers


          for (i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          } // Callback


          _callback = function callback(type) {
            return function () {
              if (_callback) {
                _callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

                if (type === "abort") {
                  xhr.abort();
                } else if (type === "error") {
                  // Support: IE <=9 only
                  // On a manual native abort, IE9 throws
                  // errors on any property access that is not readyState
                  if (typeof xhr.status !== "number") {
                    complete(0, "error");
                  } else {
                    complete( // File: protocol always yields status 0; see trac-8605, trac-14207
                    xhr.status, xhr.statusText);
                  }
                } else {
                  complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                    binary: xhr.response
                  } : {
                    text: xhr.responseText
                  }, xhr.getAllResponseHeaders());
                }
              }
            };
          }; // Listen to events


          xhr.onload = _callback();
          errorCallback = xhr.onerror = xhr.ontimeout = _callback("error"); // Support: IE 9 only
          // Use onreadystatechange to replace onabort
          // to handle uncaught aborts

          if (xhr.onabort !== undefined) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function () {
              // Check readyState before timeout as it changes
              if (xhr.readyState === 4) {
                // Allow onerror to be called first,
                // but that will not handle a native abort
                // Also, save errorCallback to a variable
                // as xhr.onerror cannot be accessed
                window.setTimeout(function () {
                  if (_callback) {
                    errorCallback();
                  }
                });
              }
            };
          } // Create the abort callback


          _callback = _callback("abort");

          try {
            // Do send the request (this may raise an exception)
            xhr.send(options.hasContent && options.data || null);
          } catch (e) {
            // trac-14683: Only rethrow if this hasn't been notified as an error yet
            if (_callback) {
              throw e;
            }
          }
        },
        abort: function abort() {
          if (_callback) {
            _callback();
          }
        }
      };
    }
  }); // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)

  jQuery.ajaxPrefilter(function (s) {
    if (s.crossDomain) {
      s.contents.script = false;
    }
  }); // Install script dataType

  jQuery.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function textScript(text) {
        jQuery.globalEval(text);
        return text;
      }
    }
  }); // Handle cache's special case and crossDomain

  jQuery.ajaxPrefilter("script", function (s) {
    if (s.cache === undefined) {
      s.cache = false;
    }

    if (s.crossDomain) {
      s.type = "GET";
    }
  }); // Bind script tag hack transport

  jQuery.ajaxTransport("script", function (s) {
    // This transport only deals with cross domain or forced-by-attrs requests
    if (s.crossDomain || s.scriptAttrs) {
      var script, _callback2;

      return {
        send: function send(_, complete) {
          script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
            charset: s.scriptCharset,
            src: s.url
          }).on("load error", _callback2 = function callback(evt) {
            script.remove();
            _callback2 = null;

            if (evt) {
              complete(evt.type === "error" ? 404 : 200, evt.type);
            }
          }); // Use native DOM manipulation to avoid our domManip AJAX trickery

          document.head.appendChild(script[0]);
        },
        abort: function abort() {
          if (_callback2) {
            _callback2();
          }
        }
      };
    }
  });
  var oldCallbacks = [],
      rjsonp = /(=)\?(?=&|$)|\?\?/; // Default jsonp settings

  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
      this[callback] = true;
      return callback;
    }
  }); // Detect, normalize options and install callbacks for jsonp requests

  jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
    var callbackName,
        overwritten,
        responseContainer,
        jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data"); // Handle iff the expected data type is "jsonp" or we have a parameter to set

    if (jsonProp || s.dataTypes[0] === "jsonp") {
      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback; // Insert callback into url or form data

      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      } // Use data converter to retrieve json after script execution


      s.converters["script json"] = function () {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }

        return responseContainer[0];
      }; // Force json dataType


      s.dataTypes[0] = "json"; // Install callback

      overwritten = window[callbackName];

      window[callbackName] = function () {
        responseContainer = arguments;
      }; // Clean-up function (fires after converters)


      jqXHR.always(function () {
        // If previous value didn't exist - remove it
        if (overwritten === undefined) {
          jQuery(window).removeProp(callbackName); // Otherwise restore preexisting value
        } else {
          window[callbackName] = overwritten;
        } // Save back as free


        if (s[callbackName]) {
          // Make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback; // Save the callback name for future use

          oldCallbacks.push(callbackName);
        } // Call if it was a function and we have a response


        if (responseContainer && isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }

        responseContainer = overwritten = undefined;
      }); // Delegate to script

      return "script";
    }
  }); // Support: Safari 8 only
  // In Safari 8 documents created via document.implementation.createHTMLDocument
  // collapse sibling forms: the second one becomes a child of the first one.
  // Because of that, this security measure has to be disabled in Safari 8.
  // https://bugs.webkit.org/show_bug.cgi?id=137337

  support.createHTMLDocument = function () {
    var body = document.implementation.createHTMLDocument("").body;
    body.innerHTML = "<form></form><form></form>";
    return body.childNodes.length === 2;
  }(); // Argument "data" should be string of html
  // context (optional): If specified, the fragment will be created in this context,
  // defaults to document
  // keepScripts (optional): If true, will include scripts passed in the html string


  jQuery.parseHTML = function (data, context, keepScripts) {
    if (typeof data !== "string") {
      return [];
    }

    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }

    var base, parsed, scripts;

    if (!context) {
      // Stop scripts or inline event handlers from being executed immediately
      // by using document.implementation
      if (support.createHTMLDocument) {
        context = document.implementation.createHTMLDocument(""); // Set the base href for the created document
        // so any parsed elements with URLs
        // are based on the document's URL (gh-2965)

        base = context.createElement("base");
        base.href = document.location.href;
        context.head.appendChild(base);
      } else {
        context = document;
      }
    }

    parsed = rsingleTag.exec(data);
    scripts = !keepScripts && []; // Single tag

    if (parsed) {
      return [context.createElement(parsed[1])];
    }

    parsed = buildFragment([data], context, scripts);

    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }

    return jQuery.merge([], parsed.childNodes);
  };
  /**
   * Load a url into a page
   */


  jQuery.fn.load = function (url, params, callback) {
    var selector,
        type,
        response,
        self = this,
        off = url.indexOf(" ");

    if (off > -1) {
      selector = stripAndCollapse(url.slice(off));
      url = url.slice(0, off);
    } // If it's a function


    if (isFunction(params)) {
      // We assume that it's the callback
      callback = params;
      params = undefined; // Otherwise, build a param string
    } else if (params && _typeof(params) === "object") {
      type = "POST";
    } // If we have elements to modify, make the request


    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: type || "GET",
        dataType: "html",
        data: params
      }).done(function (responseText) {
        // Save response for use in complete callback
        response = arguments;
        self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
        jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
        responseText); // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
      }).always(callback && function (jqXHR, status) {
        self.each(function () {
          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
        });
      });
    }

    return this;
  };

  jQuery.expr.pseudos.animated = function (elem) {
    return jQuery.grep(jQuery.timers, function (fn) {
      return elem === fn.elem;
    }).length;
  };

  jQuery.offset = {
    setOffset: function setOffset(elem, options, i) {
      var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = jQuery.css(elem, "position"),
          curElem = jQuery(elem),
          props = {}; // Set position first, in-case top/left are set even on static elem

      if (position === "static") {
        elem.style.position = "relative";
      }

      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1; // Need to be able to calculate position if either
      // top or left is auto and position is either absolute or fixed

      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }

      if (isFunction(options)) {
        // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
        options = options.call(elem, i, jQuery.extend({}, curOffset));
      }

      if (options.top != null) {
        props.top = options.top - curOffset.top + curTop;
      }

      if (options.left != null) {
        props.left = options.left - curOffset.left + curLeft;
      }

      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }
  };
  jQuery.fn.extend({
    // offset() relates an element's border box to the document origin
    offset: function offset(options) {
      // Preserve chaining for setter
      if (arguments.length) {
        return options === undefined ? this : this.each(function (i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }

      var rect,
          win,
          elem = this[0];

      if (!elem) {
        return;
      } // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
      // Support: IE <=11 only
      // Running getBoundingClientRect on a
      // disconnected node in IE throws an error


      if (!elem.getClientRects().length) {
        return {
          top: 0,
          left: 0
        };
      } // Get document-relative position by adding viewport scroll to viewport-relative gBCR


      rect = elem.getBoundingClientRect();
      win = elem.ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },
    // position() relates an element's margin box to its offset parent's padding box
    // This corresponds to the behavior of CSS absolute positioning
    position: function position() {
      if (!this[0]) {
        return;
      }

      var offsetParent,
          offset,
          doc,
          elem = this[0],
          parentOffset = {
        top: 0,
        left: 0
      }; // position:fixed elements are offset from the viewport, which itself always has zero offset

      if (jQuery.css(elem, "position") === "fixed") {
        // Assume position:fixed implies availability of getBoundingClientRect
        offset = elem.getBoundingClientRect();
      } else {
        offset = this.offset(); // Account for the *real* offset parent, which can be the document or its root element
        // when a statically positioned element is identified

        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;

        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.parentNode;
        }

        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
          // Incorporate borders into its offset, since they are outside its content origin
          parentOffset = jQuery(offsetParent).offset();
          parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
          parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
        }
      } // Subtract parent offsets and element margins


      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    // This method will return documentElement in the following cases:
    // 1) For the element inside the iframe without offsetParent, this method will return
    //    documentElement of the parent window
    // 2) For the hidden or detached element
    // 3) For body or html element, i.e. in case of the html node - it will return itself
    //
    // but those exceptions were never presented as a real life use-cases
    // and might be considered as more preferable results.
    //
    // This logic, however, is not guaranteed and can change at any point in the future
    offsetParent: function offsetParent() {
      return this.map(function () {
        var offsetParent = this.offsetParent;

        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || documentElement;
      });
    }
  }); // Create scrollLeft and scrollTop methods

  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (method, prop) {
    var top = "pageYOffset" === prop;

    jQuery.fn[method] = function (val) {
      return access(this, function (elem, method, val) {
        // Coalesce documents and windows
        var win;

        if (isWindow(elem)) {
          win = elem;
        } else if (elem.nodeType === 9) {
          win = elem.defaultView;
        }

        if (val === undefined) {
          return win ? win[prop] : elem[method];
        }

        if (win) {
          win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length);
    };
  }); // Support: Safari <=7 - 9.1, Chrome <=37 - 49
  // Add the top/left cssHooks using jQuery.fn.position
  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
  // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
  // getComputedStyle returns percent when specified for top/left/bottom/right;
  // rather than make the css module depend on the offset module, just check for it here

  jQuery.each(["top", "left"], function (_i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop); // If curCSS returns percentage, fallback to offset

        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  }); // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods

  jQuery.each({
    Height: "height",
    Width: "width"
  }, function (name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function (defaultExtra, funcName) {
      // Margin is only for outerHeight, outerWidth
      jQuery.fn[funcName] = function (margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
            extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return access(this, function (elem, type, value) {
          var doc;

          if (isWindow(elem)) {
            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
            return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
          } // Get document width or height


          if (elem.nodeType === 9) {
            doc = elem.documentElement; // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
            // whichever is greatest

            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }

          return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
          jQuery.css(elem, type, extra) : // Set width or height on the element
          jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable);
      };
    });
  });
  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
    jQuery.fn[type] = function (fn) {
      return this.on(type, fn);
    };
  });
  jQuery.fn.extend({
    bind: function bind(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function unbind(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function delegate(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function undelegate(selector, types, fn) {
      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    },
    hover: function hover(fnOver, fnOut) {
      return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
    }
  });
  jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {
    // Handle event binding
    jQuery.fn[name] = function (data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  }); // Support: Android <=4.0 only
  // Make sure we trim BOM and NBSP
  // Require that the "whitespace run" starts from a non-whitespace
  // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.

  var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g; // Bind a function to a context, optionally partially applying any
  // arguments.
  // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
  // However, it is not slated for removal any time soon

  jQuery.proxy = function (fn, context) {
    var tmp, args, proxy;

    if (typeof context === "string") {
      tmp = fn[context];
      context = fn;
      fn = tmp;
    } // Quick check to determine if target is callable, in the spec
    // this throws a TypeError, but we will just return undefined.


    if (!isFunction(fn)) {
      return undefined;
    } // Simulated bind


    args = _slice.call(arguments, 2);

    proxy = function proxy() {
      return fn.apply(context || this, args.concat(_slice.call(arguments)));
    }; // Set the guid of unique handler to the same of original handler, so it can be removed


    proxy.guid = fn.guid = fn.guid || jQuery.guid++;
    return proxy;
  };

  jQuery.holdReady = function (hold) {
    if (hold) {
      jQuery.readyWait++;
    } else {
      jQuery.ready(true);
    }
  };

  jQuery.isArray = Array.isArray;
  jQuery.parseJSON = JSON.parse;
  jQuery.nodeName = nodeName;
  jQuery.isFunction = isFunction;
  jQuery.isWindow = isWindow;
  jQuery.camelCase = camelCase;
  jQuery.type = toType;
  jQuery.now = Date.now;

  jQuery.isNumeric = function (obj) {
    // As of jQuery 3.0, isNumeric is limited to
    // strings and numbers (primitives or objects)
    // that can be coerced to finite numbers (gh-2662)
    var type = jQuery.type(obj);
    return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    !isNaN(obj - parseFloat(obj));
  };

  jQuery.trim = function (text) {
    return text == null ? "" : (text + "").replace(rtrim, "$1");
  }; // Register as a named AMD module, since jQuery can be concatenated with other
  // files that may use define, but not via a proper concatenation script that
  // understands anonymous AMD modules. A named AMD is safest and most robust
  // way to register. Lowercase jquery is used because AMD module names are
  // derived from file names, and jQuery is normally delivered in a lowercase
  // file name. Do this after creating the global so that if an AMD module wants
  // to call noConflict to hide this version of jQuery, it will work.
  // Note that for maximum portability, libraries that are not jQuery should
  // declare themselves as anonymous modules, and avoid setting a global if an
  // AMD loader is present. jQuery is a special case. For more information, see
  // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon


  if (typeof define === "function" && define.amd) {
    define("jquery", [], function () {
      return jQuery;
    });
  }

  var // Map over jQuery in case of overwrite
  _jQuery = window.jQuery,
      // Map over the $ in case of overwrite
  _$ = window.$;

  jQuery.noConflict = function (deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }

    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }

    return jQuery;
  }; // Expose jQuery and $ identifiers, even in AMD
  // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
  // and CommonJS for browser emulators (trac-13566)


  if (typeof noGlobal === "undefined") {
    window.jQuery = window.$ = jQuery;
  }

  return jQuery;
});

},{}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var countries_1 = require("./lib/countries");

exports.countries = [countries_1.andorra, countries_1.austria, countries_1.belgium, countries_1.bulgaria, countries_1.croatia, countries_1.cyprus, countries_1.czechRepublic, countries_1.denmark, countries_1.estonia, countries_1.europe, countries_1.finland, countries_1.france, countries_1.germany, countries_1.greece, countries_1.hungary, countries_1.ireland, countries_1.italy, countries_1.latvia, countries_1.lithuania, countries_1.luxembourg, countries_1.malta, countries_1.netherlands, countries_1.norway, countries_1.poland, countries_1.portugal, countries_1.romania, countries_1.russia, countries_1.serbia, countries_1.slovakiaRepublic, countries_1.slovenia, countries_1.spain, countries_1.sweden, countries_1.switzerland, countries_1.unitedKingdom];

var countries_2 = require("./lib/countries");

exports.andorra = countries_2.andorra;
exports.austria = countries_2.austria;
exports.belgium = countries_2.belgium;
exports.bulgaria = countries_2.bulgaria;
exports.croatia = countries_2.croatia;
exports.cyprus = countries_2.cyprus;
exports.czechRepublic = countries_2.czechRepublic;
exports.denmark = countries_2.denmark;
exports.estonia = countries_2.estonia;
exports.europe = countries_2.europe;
exports.finland = countries_2.finland;
exports.france = countries_2.france;
exports.germany = countries_2.germany;
exports.greece = countries_2.greece;
exports.hungary = countries_2.hungary;
exports.ireland = countries_2.ireland;
exports.italy = countries_2.italy;
exports.latvia = countries_2.latvia;
exports.lithuania = countries_2.lithuania;
exports.luxembourg = countries_2.luxembourg;
exports.malta = countries_2.malta;
exports.netherlands = countries_2.netherlands;
exports.norway = countries_2.norway;
exports.poland = countries_2.poland;
exports.portugal = countries_2.portugal;
exports.romania = countries_2.romania;
exports.russia = countries_2.russia;
exports.serbia = countries_2.serbia;
exports.slovakiaRepublic = countries_2.slovakiaRepublic;
exports.slovenia = countries_2.slovenia;
exports.spain = countries_2.spain;
exports.sweden = countries_2.sweden;
exports.switzerland = countries_2.switzerland;
exports.unitedKingdom = countries_2.unitedKingdom;

var jsvat_1 = require("./lib/jsvat");

exports.checkVAT = jsvat_1.checkVAT;

},{"./lib/countries":46,"./lib/jsvat":66}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.andorra = {
  name: 'Andorra',
  codes: ['AD', 'AND', '020'],
  calcFn: function calcFn(vat) {
    return vat.length === 8;
  },
  rules: {
    multipliers: {},
    regex: [/^(AD)([fealecdgopuFEALECDGOPU]{1}\d{6}[fealecdgopuFEALECDGOPU]{1})$/]
  }
};

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.austria = {
  name: 'Austria',
  codes: ['AT', 'AUT', '040'],
  calcFn: function calcFn(vat) {
    var total = 0;

    for (var i = 0; i < 7; i++) {
      var temp = Number(vat.charAt(i)) * exports.austria.rules.multipliers.common[i];

      if (temp > 9) {
        total += Math.floor(temp / 10) + temp % 10;
      } else {
        total += temp;
      }
    }

    total = 10 - (total + 4) % 10;
    if (total === 10) total = 0;
    return total === Number(vat.slice(7, 8));
  },
  rules: {
    multipliers: {
      common: [1, 2, 1, 2, 1, 2, 1]
    },
    regex: [/^(AT)U(\d{8})$/]
  }
};

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.belgium = {
  name: 'Belgium',
  codes: ['BE', 'BEL', '056'],
  calcFn: function calcFn(vat) {
    var newVat = vat.length === 9 ? '0' + vat : vat;
    if (Number(newVat.slice(1, 2)) === 0) return false;
    var check = 97 - Number(newVat.slice(0, 8)) % 97;
    return check === Number(newVat.slice(8, 10));
  },
  rules: {
    multipliers: {},
    regex: [/^(BE)(0?\d{9})$/]
  }
};

},{}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulgaria = {
  name: 'Bulgaria',
  codes: ['BG', 'BGR', '100'],
  calcFn: function calcFn(vat) {
    if (vat.length === 9) return _checkNineLengthVat(vat);
    var multipliers = exports.bulgaria.rules.multipliers;
    return _isPhysicalPerson(vat, multipliers.physical) || _isForeigner(vat, multipliers) || _miscellaneousVAT(vat, multipliers);
  },
  rules: {
    multipliers: {
      physical: [2, 4, 8, 5, 10, 9, 7, 3, 6],
      foreigner: [21, 19, 17, 13, 11, 9, 7, 3, 1],
      miscellaneous: [4, 3, 2, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(BG)(\d{9,10})$/]
  }
};

function _increase(value, vat, from, to, incr) {
  var result = value;

  for (var i = from; i < to; i++) {
    result += Number(vat.charAt(i)) * (i + incr);
  }

  return result;
}

function _increase2(value, vat, from, to, multipliers) {
  var result = value;

  for (var i = from; i < to; i++) {
    result += Number(vat.charAt(i)) * multipliers[i];
  }

  return result;
}

function _checkNineLengthVat(vat) {
  var total;

  var temp = _increase(0, vat, 0, 8, 1);

  var expect = Number(vat.slice(8));
  total = temp % 11;
  if (total !== 10) return total === expect;
  temp = _increase(0, vat, 0, 8, 3);
  total = temp % 11;
  if (total === 10) total = 0;
  return total === expect;
}

function _isPhysicalPerson(vat, physicalMultipliers) {
  // 10 digit VAT code - see if it relates to a standard physical person
  if (/^\d\d[0-5]\d[0-3]\d\d{4}$/.test(vat)) {
    // Check month
    var month = Number(vat.slice(2, 4));

    if (month > 0 && month < 13 || month > 20 && month < 33 || month > 40 && month < 53) {
      var total = _increase2(0, vat, 0, 9, physicalMultipliers); // Establish check digit.


      total = total % 11;
      if (total === 10) total = 0; // Check to see if the check digit given is correct, If not, try next type of person

      if (total === Number(vat.substr(9, 1))) return true;
    }
  }

  return false;
}

function _isForeigner(vat, multipliers) {
  // Extract the next digit and multiply by the counter.
  var total = _increase2(0, vat, 0, 9, multipliers.foreigner); // Check to see if the check digit given is correct, If not, try next type of person


  return total % 10 === Number(vat.substr(9, 1));
}

function _miscellaneousVAT(vat, multipliers) {
  // Finally, if not yet identified, see if it conforms to a miscellaneous VAT number
  var total = _increase2(0, vat, 0, 9, multipliers.miscellaneous); // Establish check digit.


  total = 11 - total % 11;
  if (total === 10) return false;
  if (total === 11) total = 0; // Check to see if the check digit given is correct, If not, we have an error with the VAT number

  var expect = Number(vat.substr(9, 1));
  return total === expect;
}

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.croatia = {
  name: 'Croatia',
  codes: ['HR', 'HRV', '191'],
  calcFn: function calcFn(vat) {
    // Checks the check digits of a Croatian VAT number using ISO 7064, MOD 11-10 for check digit.
    var product = 10;
    var sum = 0;

    for (var i = 0; i < 10; i++) {
      // Extract the next digit and implement the algorithm
      sum = (Number(vat.charAt(i)) + product) % 10;

      if (sum === 0) {
        sum = 10;
      }

      product = 2 * sum % 11;
    } // Now check that we have the right check digit


    var expect = Number(vat.slice(10, 11));
    return (product + expect) % 10 === 1;
  },
  rules: {
    multipliers: {},
    regex: [/^(HR)(\d{11})$/]
  }
};

},{}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cyprus = {
  name: 'Cyprus',
  codes: ['CY', 'CYP', '196'],
  calcFn: function calcFn(vat) {
    // Not allowed to start with '12'
    if (Number(vat.slice(0, 2)) === 12) return false; // Extract the next digit and multiply by the counter.

    var total = extractAndMultiplyByCounter(vat, 0); // Establish check digit using modulus 26, and translate to char. equivalent.

    total = total % 26;
    total = String.fromCharCode(total + 65); // Check to see if the check digit given is correct

    var expect = vat.substr(8, 1);
    return total === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(CY)([0-59]\d{7}[A-Z])$/]
  }
};

function extractAndMultiplyByCounter(vat, total) {
  var result = total;

  for (var i = 0; i < 8; i++) {
    var temp = Number(vat.charAt(i));

    if (i % 2 === 0) {
      switch (temp) {
        case 0:
          temp = 1;
          break;

        case 1:
          temp = 0;
          break;

        case 2:
          temp = 5;
          break;

        case 3:
          temp = 7;
          break;

        case 4:
          temp = 9;
          break;

        default:
          temp = temp * 2 + 3;
      }
    }

    result += temp;
  }

  return result;
}

},{}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.czechRepublic = {
  name: 'Czech Republic',
  codes: ['CZ', 'CZE', '203'],
  calcFn: function calcFn(vat) {
    var rules = exports.czechRepublic.rules;
    var multipliers = rules.multipliers,
        additional = rules.additional,
        lookup = rules.lookup;
    if (!additional) return false;
    return isLegalEntities(vat, multipliers.common, additional) || isIndividualType2(vat, multipliers.common, additional, lookup) || isIndividualType3(vat, additional) || isIndividualType1(vat, additional);
  },
  rules: {
    multipliers: {
      common: [8, 7, 6, 5, 4, 3, 2]
    },
    lookup: [8, 7, 6, 5, 4, 3, 2, 1, 0, 9, 10],
    regex: [/^(CZ)(\d{8,10})(\d{3})?$/],
    additional: [/^\d{8}$/, /^[0-5][0-9][0|1|5|6]\d[0-3]\d\d{3}$/, /^6\d{8}$/, /^\d{2}[0-3|5-8]\d[0-3]\d\d{4}$/]
  }
};

function isLegalEntities(vat, multipliers, additional) {
  var total = 0;

  if (additional[0].test(vat)) {
    // Extract the next digit and multiply by the counter.
    for (var i = 0; i < 7; i++) {
      total += Number(vat.charAt(i)) * multipliers[i];
    } // Establish check digit.


    total = 11 - total % 11;
    if (total === 10) total = 0;
    if (total === 11) total = 1; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(7, 8));
    return total === expect;
  }

  return false;
}

function isIndividualType1(vat, additional) {
  if (additional[1].test(vat)) {
    return Number(vat.slice(0, 2)) <= 62;
  }

  return false;
}

function isIndividualType2(vat, multipliers, additional, lookup) {
  var total = 0;

  if (additional[2].test(vat)) {
    // Extract the next digit and multiply by the counter.
    for (var j = 0; j < 7; j++) {
      total += Number(vat.charAt(j + 1)) * multipliers[j];
    } // Establish check digit.


    total = 11 - total % 11;
    if (total === 10) total = 0;
    if (total === 11) total = 1; // Convert calculated check digit according to a lookup table

    var expect = Number(vat.slice(8, 9));
    if (!lookup) return false;
    return lookup[total - 1] === expect;
  }

  return false;
}

function isIndividualType3(vat, additional) {
  if (additional[3].test(vat)) {
    var temp = Number(vat.slice(0, 2)) + Number(vat.slice(2, 4)) + Number(vat.slice(4, 6)) + Number(vat.slice(6, 8)) + Number(vat.slice(8));
    var expect = Number(vat) % 11 === 0;
    return !!(temp % 11 === 0 && expect);
  }

  return false;
}

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denmark = {
  name: 'Denmark',
  codes: ['DK', 'DNK', '208'],
  calcFn: function calcFn(vat) {
    var total = 0;

    for (var i = 0; i < 8; i++) {
      total += Number(vat.charAt(i)) * exports.denmark.rules.multipliers.common[i];
    }

    return total % 11 === 0;
  },
  rules: {
    multipliers: {
      common: [2, 7, 6, 5, 4, 3, 2, 1]
    },
    regex: [/^(DK)(\d{8})$/]
  }
};

},{}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estonia = {
  name: 'Estonia',
  codes: ['EE', 'EST', '233'],
  calcFn: function calcFn(vat) {
    var total = 0;
    var expect; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(vat.charAt(i)) * exports.estonia.rules.multipliers.common[i];
    } // Establish check digits using modulus 10.


    total = 10 - total % 10;
    if (total === 10) total = 0; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    expect = Number(vat.slice(8, 9));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [3, 7, 1, 3, 7, 1, 3, 7]
    },
    regex: [/^(EE)(10\d{7})$/]
  }
};

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.europe = {
  name: 'Europe',
  codes: ['EU', 'EUR', '000'],
  calcFn: function calcFn() {
    // We know little about EU numbers apart from the fact that the first 3 digits represent the
    // country, and that there are nine digits in total.
    return true;
  },
  rules: {
    multipliers: {},
    regex: [/^(EU)(\d{9})$/]
  }
};

},{}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finland = {
  name: 'Finland',
  codes: ['FI', 'FIN', '246'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 7; i++) {
      total += Number(vat.charAt(i)) * exports.finland.rules.multipliers.common[i];
    } // Establish check digit.


    total = 11 - total % 11;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(vat.slice(7, 8));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [7, 9, 10, 5, 8, 4, 2]
    },
    regex: [/^(FI)(\d{8})$/]
  }
};

},{}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.france = {
  name: 'France',
  codes: ['FR', 'FRA', '250'],
  calcFn: function calcFn(vat) {
    var total; // Checks the check digits of a French VAT number.

    if (!/^\d{11}$/.test(vat)) return true; // Extract the last nine digits as an integer.

    total = Number(vat.substring(2)); // Establish check digit.

    total = (total * 100 + 12) % 97; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(0, 2));
    return total === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(FR)(\d{11})$/, /^(FR)([A-HJ-NP-Z]\d{10})$/, /^(FR)(\d[A-HJ-NP-Z]\d{9})$/, /^(FR)([A-HJ-NP-Z]{2}\d{9})$/]
  }
};

},{}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.germany = {
  name: 'Germany',
  codes: ['DE', 'DEU', '276'],
  calcFn: function calcFn(vat) {
    // Checks the check digits of a German VAT number.
    var product = 10;
    var sum = 0;
    var checkDigit = 0;
    var expect;

    for (var i = 0; i < 8; i++) {
      // Extract the next digit and implement peculiar algorithm!.
      sum = (Number(vat.charAt(i)) + product) % 10;

      if (sum === 0) {
        sum = 10;
      }

      product = 2 * sum % 11;
    } // Establish check digit.


    if (11 - product === 10) {
      checkDigit = 0;
    } else {
      checkDigit = 11 - product;
    } // Compare it with the last two characters of the VAT number. If the same, then it is a valid
    // check digit.


    expect = Number(vat.slice(8, 9));
    return checkDigit === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(DE)([1-9]\d{8})$/]
  }
};

},{}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.greece = {
  name: 'Greece',
  codes: ['GR', 'GRC', '300'],
  calcFn: function calcFn(vat) {
    var total = 0; // eight character numbers should be prefixed with an 0.

    var newVat = vat.length === 8 ? '0' + vat : vat; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(newVat.charAt(i)) * exports.greece.rules.multipliers.common[i];
    } // Establish check digit.


    total = total % 11;
    total = total > 9 ? 0 : total; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(newVat.slice(8, 9));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [256, 128, 64, 32, 16, 8, 4, 2]
    },
    regex: [/^(EL)(\d{9})$/]
  }
};

},{}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hungary = {
  name: 'Hungary',
  codes: ['HU', 'HUN', '348'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 7; i++) {
      total += Number(vat.charAt(i)) * exports.hungary.rules.multipliers.common[i];
    } // Establish check digit.


    total = 10 - total % 10;
    if (total === 10) total = 0; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(7, 8));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [9, 7, 3, 1, 9, 7, 3]
    },
    regex: [/^(HU)(\d{8})$/]
  }
};

},{}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var andorra_1 = require("./andorra");

exports.andorra = andorra_1.andorra;

var austria_1 = require("./austria");

exports.austria = austria_1.austria;

var belgium_1 = require("./belgium");

exports.belgium = belgium_1.belgium;

var bulgaria_1 = require("./bulgaria");

exports.bulgaria = bulgaria_1.bulgaria;

var croatiat_1 = require("./croatiat");

exports.croatia = croatiat_1.croatia;

var cyprus_1 = require("./cyprus");

exports.cyprus = cyprus_1.cyprus;

var czechRepublic_1 = require("./czechRepublic");

exports.czechRepublic = czechRepublic_1.czechRepublic;

var denmark_1 = require("./denmark");

exports.denmark = denmark_1.denmark;

var estonia_1 = require("./estonia");

exports.estonia = estonia_1.estonia;

var europe_1 = require("./europe");

exports.europe = europe_1.europe;

var finland_1 = require("./finland");

exports.finland = finland_1.finland;

var france_1 = require("./france");

exports.france = france_1.france;

var germany_1 = require("./germany");

exports.germany = germany_1.germany;

var greece_1 = require("./greece");

exports.greece = greece_1.greece;

var hungary_1 = require("./hungary");

exports.hungary = hungary_1.hungary;

var ireland_1 = require("./ireland");

exports.ireland = ireland_1.ireland;

var italy_1 = require("./italy");

exports.italy = italy_1.italy;

var latvia_1 = require("./latvia");

exports.latvia = latvia_1.latvia;

var lithuania_1 = require("./lithuania");

exports.lithuania = lithuania_1.lithuania;

var luxembourg_1 = require("./luxembourg");

exports.luxembourg = luxembourg_1.luxembourg;

var malta_1 = require("./malta");

exports.malta = malta_1.malta;

var netherlands_1 = require("./netherlands");

exports.netherlands = netherlands_1.netherlands;

var norway_1 = require("./norway");

exports.norway = norway_1.norway;

var poland_1 = require("./poland");

exports.poland = poland_1.poland;

var portugal_1 = require("./portugal");

exports.portugal = portugal_1.portugal;

var romania_1 = require("./romania");

exports.romania = romania_1.romania;

var russia_1 = require("./russia");

exports.russia = russia_1.russia;

var serbia_1 = require("./serbia");

exports.serbia = serbia_1.serbia;

var slovakiaRepublic_1 = require("./slovakiaRepublic");

exports.slovakiaRepublic = slovakiaRepublic_1.slovakiaRepublic;

var slovenia_1 = require("./slovenia");

exports.slovenia = slovenia_1.slovenia;

var spain_1 = require("./spain");

exports.spain = spain_1.spain;

var sweden_1 = require("./sweden");

exports.sweden = sweden_1.sweden;

var switzerland_1 = require("./switzerland");

exports.switzerland = switzerland_1.switzerland;

var unitedKingdom_1 = require("./unitedKingdom");

exports.unitedKingdom = unitedKingdom_1.unitedKingdom;

},{"./andorra":31,"./austria":32,"./belgium":33,"./bulgaria":34,"./croatiat":35,"./cyprus":36,"./czechRepublic":37,"./denmark":38,"./estonia":39,"./europe":40,"./finland":41,"./france":42,"./germany":43,"./greece":44,"./hungary":45,"./ireland":47,"./italy":48,"./latvia":49,"./lithuania":50,"./luxembourg":51,"./malta":52,"./netherlands":53,"./norway":54,"./poland":55,"./portugal":56,"./romania":57,"./russia":58,"./serbia":59,"./slovakiaRepublic":60,"./slovenia":61,"./spain":62,"./sweden":63,"./switzerland":64,"./unitedKingdom":65}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ireland = {
  name: 'Ireland',
  codes: ['IE', 'IRL', '372'],
  calcFn: function calcFn(vat) {
    var _a = exports.ireland.rules,
        typeFormats = _a.typeFormats,
        multipliers = _a.multipliers;
    if (!typeFormats || !typeFormats.first) return false;
    var total = 0;
    var newVat = vat; // If the code is type 1 format, we need to convert it to the new before performing the validation.

    if (typeFormats.first.test(vat)) {
      newVat = '0' + vat.substring(2, 7) + vat.substring(0, 1) + vat.substring(7, 8);
    } // Extract the next digit and multiply by the counter.


    for (var i = 0; i < 7; i++) {
      total += Number(newVat.charAt(i)) * multipliers.common[i];
    } // If the number is type 3 then we need to include the trailing A or H in the calculation


    if (typeFormats.third.test(newVat)) {
      // Add in a multiplier for the character A (1*9=9) or H (8*9=72)
      total += newVat.charAt(8) === 'H' ? 72 : 9;
    } // Establish check digit using modulus 23, and translate to char. equivalent.


    total = total % 23;
    total = total === 0 ? 'W' : String.fromCharCode(total + 64); // Compare it with the eighth character of the VAT number. If it's the same, then it's valid.

    var expect = newVat.slice(7, 8);
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [8, 7, 6, 5, 4, 3, 2]
    },
    typeFormats: {
      first: /^\d[A-Z*+]/,
      third: /^\d{7}[A-Z][AH]$/
    },
    regex: [/^(IE)(\d{7}[A-W])$/, /^(IE)([7-9][A-Z*+)]\d{5}[A-W])$/, /^(IE)(\d{7}[A-W][AH])$/]
  }
};

},{}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.italy = {
  name: 'Italy',
  codes: ['IT', 'ITA', '380'],
  calcFn: function calcFn(vat) {
    var total = 0;
    var temp; // The last three digits are the issuing office, and cannot exceed more 201, unless 999 or 888

    if (Number(vat.slice(0, 7)) === 0) {
      return false;
    }

    temp = Number(vat.slice(7, 10));

    if (temp < 1 || temp > 201 && temp !== 999 && temp !== 888) {
      return false;
    } // Extract the next digit and multiply by the appropriate


    for (var i = 0; i < 10; i++) {
      temp = Number(vat.charAt(i)) * exports.italy.rules.multipliers.common[i];
      if (temp > 9) total += Math.floor(temp / 10) + temp % 10;else total += temp;
    } // Establish check digit.


    total = 10 - total % 10;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(vat.slice(10, 11));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [1, 2, 1, 2, 1, 2, 1, 2, 1, 2]
    },
    regex: [/^(IT)(\d{11})$/]
  }
};

},{}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latvia = {
  name: 'Latvia',
  codes: ['LV', 'LVA', '428'],
  calcFn: function calcFn(vat) {
    var total = 0; // Differentiate between legal entities and natural bodies. For the latter we simply check that
    // the first six digits correspond to valid DDMMYY dates.

    if (/^[0-3]/.test(vat)) {
      return Boolean(/^[0-3][0-9][0-1][0-9]/.test(vat));
    } else {
      // Extract the next digit and multiply by the counter.
      for (var i = 0; i < 10; i++) {
        total += Number(vat.charAt(i)) * exports.latvia.rules.multipliers.common[i];
      } // Establish check digits by getting modulus 11.


      if (total % 11 === 4 && Number(vat[0]) === 9) total = total - 45;

      if (total % 11 === 4) {
        total = 4 - total % 11;
      } else if (total % 11 > 4) {
        total = 14 - total % 11;
      } else if (total % 11 < 4) {
        total = 3 - total % 11;
      } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


      var expect = Number(vat.slice(10, 11));
      return total === expect;
    }
  },
  rules: {
    multipliers: {
      common: [9, 1, 4, 8, 3, 10, 2, 5, 7, 6]
    },
    regex: [/^(LV)(\d{11})$/]
  }
};

},{}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lithuania = {
  name: 'Lithuania',
  codes: ['LT', 'LTU', '440'],
  calcFn: function calcFn(vat) {
    return _check9DigitVat(vat, exports.lithuania.rules) || _check12DigitVat(vat, exports.lithuania.rules);
  },
  rules: {
    multipliers: {
      short: [3, 4, 5, 6, 7, 8, 9, 1],
      med: [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2],
      alt: [3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4]
    },
    check: /^\d{10}1/,
    regex: [/^(LT)(\d{9}|\d{12})$/]
  }
};

function _extractDigit(vat, multiplierList, key) {
  return Number(vat.charAt(key)) * multiplierList[key];
}

function _doubleCheckCalculation(vat, total, rules) {
  var result = total;

  if (result % 11 === 10) {
    result = 0;

    for (var i = 0; i < 8; i++) {
      result += _extractDigit(vat, rules.multipliers.short, i);
    }
  }

  return result;
}

function extractDigit(vat, total) {
  var result = total;

  for (var i = 0; i < 8; i++) {
    result += Number(vat.charAt(i)) * (i + 1);
  }

  return result;
}

function checkDigit(total) {
  var result = total % 11;

  if (result === 10) {
    result = 0;
  }

  return result;
}

function _check9DigitVat(vat, rules) {
  // 9 character VAT numbers are for legal persons
  var total = 0;

  if (vat.length === 9) {
    // 8th character must be one
    if (!/^\d{7}1/.test(vat)) return false; // Extract the next digit and multiply by the counter+1.

    total = extractDigit(vat, total); // Can have a double check digit calculation!

    total = _doubleCheckCalculation(vat, total, rules); // Establish check digit.

    total = checkDigit(total); // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(8, 9));
    return total === expect;
  }

  return false;
}

function extractDigit12(vat, total, rules) {
  var result = total;

  for (var k = 0; k < 11; k++) {
    result += _extractDigit(vat, rules.multipliers.med, k);
  }

  return result;
}

function _doubleCheckCalculation12(vat, total, rules) {
  var result = total;

  if (total % 11 === 10) {
    result = 0;

    for (var l = 0; l < 11; l++) {
      result += _extractDigit(vat, rules.multipliers.alt, l);
    }
  }

  return result;
}

function _check12DigitVat(vat, rules) {
  var total = 0; // 12 character VAT numbers are for temporarily registered taxpayers

  if (vat.length === 12) {
    if (!rules.check) return false; // 11th character must be one

    if (!rules.check.test(vat)) return false; // Extract the next digit and multiply by the counter+1.

    total = extractDigit12(vat, total, rules); // Can have a double check digit calculation!

    total = _doubleCheckCalculation12(vat, total, rules); // Establish check digit.

    total = checkDigit(total); // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(11, 12));
    return total === expect;
  }

  return false;
}

},{}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.luxembourg = {
  name: 'Luxembourg',
  codes: ['LU', 'LUX', '442'],
  calcFn: function calcFn(vat) {
    var expect = Number(vat.slice(6, 8));
    var checkDigit = Number(vat.slice(0, 6)) % 89; // Checks the check digits of a Luxembourg VAT number.

    return checkDigit === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(LU)(\d{8})$/]
  }
};

},{}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.malta = {
  name: 'Malta',
  codes: ['MT', 'MLT', '470'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 6; i++) {
      total += Number(vat.charAt(i)) * exports.malta.rules.multipliers.common[i];
    } // Establish check digits by getting modulus 37.


    total = 37 - total % 37; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(6, 8));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [3, 4, 6, 7, 8, 9]
    },
    regex: [/^(MT)([1-9]\d{7})$/]
  }
};

},{}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.netherlands = {
  name: 'Netherlands',
  codes: ['NL', 'NLD', '528'],
  calcFn: function calcFn(input) {
    var vat = input.replace(/[\ \-\_]/g, '').toUpperCase();
    var _a = exports.netherlands.rules,
        additional = _a.additional,
        multipliers = _a.multipliers;
    if (!additional) return false;
    var match = vat.match(additional[0]);
    if (!match || !match[1]) return false;
    var numb = match[1];
    var characterValues = ("NL" + vat).split('').map(getCharValue);
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(numb.charAt(i)) * multipliers.common[i];
    } // Establish check digits by getting modulus 11.


    total = total % 11;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(numb.slice(8, 9)); // is either 11 proof or 97 mod proof.

    return total === expect || isNinetySevenMod(characterValues.join(''));
  },
  rules: {
    multipliers: {
      common: [9, 8, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(NL)(\d{9}B\d{2})$/],
    additional: [/^(\d{9})B\d{2}$/]
  }
};

function getCharValue(char) {
  // if one of these set values
  if (char === '+') return 36;
  if (char === '*') return 37; // if A...Z return code VAL -55

  var code = char.charCodeAt(0) - 55;
  if (code > 9 && code < 91) return code;
  return parseInt(char, 10);
}

function isNinetySevenMod(value) {
  var remainder = mod(value, 97);
  return remainder === 1;
} // custom module function, to check module on values above Number limit


function mod(value, divisor) {
  // Initialize result
  var res = 0;

  for (var _i = 0, _a = value.split(''); _i < _a.length; _i++) {
    var char = _a[_i];
    res = (res * 10 + +char) % divisor;
  }

  return res;
}

},{}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.norway = {
  name: 'Norway',
  codes: ['NO', 'NOR', '578'],
  calcFn: function calcFn(vat) {
    var total = 0; // See http://www.brreg.no/english/coordination/number.html
    // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(vat.charAt(i)) * exports.norway.rules.multipliers.common[i];
    } // Establish check digits by getting modulus 11. Check digits > 9 are invalid


    total = 11 - total % 11;

    if (total === 11) {
      total = 0;
    }

    if (total < 10) {
      // Compare it with the last character of the VAT number. If it's the same, then it's valid.
      var expect = Number(vat.slice(8, 9));
      return total === expect;
    }

    return false;
  },
  rules: {
    multipliers: {
      common: [3, 2, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(NO)(\d{9})$/]
  }
};

},{}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poland = {
  name: 'Poland',
  codes: ['PL', 'POL', '616'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 9; i++) {
      total += Number(vat.charAt(i)) * exports.poland.rules.multipliers.common[i];
    } // Establish check digits subtracting modulus 11 from 11.


    total = total % 11;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(vat.slice(9, 10));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [6, 5, 7, 2, 3, 4, 5, 6, 7]
    },
    regex: [/^(PL)(\d{10})$/]
  }
};

},{}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portugal = {
  name: 'Portugal',
  codes: ['PT', 'PRT', '620'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(vat.charAt(i)) * exports.portugal.rules.multipliers.common[i];
    } // Establish check digits subtracting modulus 11 from 11.


    total = 11 - total % 11;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(vat.slice(8, 9));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [9, 8, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(PT)(\d{9})$/]
  }
};

},{}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.romania = {
  name: 'Romania',
  codes: ['RO', 'ROU', '642'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    var vatLength = vat.length;
    var multipliers = exports.romania.rules.multipliers.common.slice(10 - vatLength);

    for (var i = 0; i < vat.length - 1; i++) {
      total += Number(vat.charAt(i)) * multipliers[i];
    } // Establish check digits by getting modulus 11.


    total = 10 * total % 11;
    if (total === 10) total = 0; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    var expect = Number(vat.slice(vat.length - 1, vat.length));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [7, 5, 3, 2, 1, 7, 5, 3, 2]
    },
    regex: [/^(RO)([1-9]\d{1,9})$/]
  }
};

},{}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.russia = {
  name: 'Russian Federation',
  codes: ['RU', 'RUS', '643'],
  calcFn: function calcFn(vat) {
    // See http://russianpartner.biz/test_inn.html for algorithm
    return _check10DigitINN(vat, exports.russia.rules) || _check12DigitINN(vat, exports.russia.rules);
  },
  rules: {
    multipliers: {
      m_1: [2, 4, 10, 3, 5, 9, 4, 6, 8, 0],
      m_2: [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0],
      m_3: [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0]
    },
    regex: [/^(RU)(\d{10}|\d{12})$/]
  }
};

function _check10DigitINN(vat, rules) {
  var total = 0;

  if (vat.length === 10) {
    for (var i = 0; i < 10; i++) {
      total += Number(vat.charAt(i)) * rules.multipliers.m_1[i];
    }

    total = total % 11;

    if (total > 9) {
      total = total % 10;
    } // Compare it with the last character of the VAT number. If it is the same, then it's valid


    var expect = Number(vat.slice(9, 10));
    return total === expect;
  }

  return false;
}

function _check12DigitINN(vat, rules) {
  var total1 = 0;
  var total2 = 0;

  if (vat.length === 12) {
    for (var j = 0; j < 11; j++) {
      total1 += Number(vat.charAt(j)) * rules.multipliers.m_2[j];
    }

    total1 = total1 % 11;

    if (total1 > 9) {
      total1 = total1 % 10;
    }

    for (var k = 0; k < 11; k++) {
      total2 += Number(vat.charAt(k)) * rules.multipliers.m_3[k];
    }

    total2 = total2 % 11;

    if (total2 > 9) {
      total2 = total2 % 10;
    } // Compare the first check with the 11th character and the second check with the 12th and last
    // character of the VAT number. If they're both the same, then it's valid


    var expect = total1 === Number(vat.slice(10, 11));
    var expect2 = total2 === Number(vat.slice(11, 12));
    return expect && expect2;
  }

  return false;
}

},{}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serbia = {
  name: 'Serbia',
  codes: ['RS', 'SRB', '688'],
  calcFn: function calcFn(vat) {
    // Checks the check digits of a Serbian VAT number using ISO 7064, MOD 11-10 for check digit.
    var product = 10;
    var sum = 0;

    for (var i = 0; i < 8; i++) {
      // Extract the next digit and implement the algorithm
      sum = (Number(vat.charAt(i)) + product) % 10;

      if (sum === 0) {
        sum = 10;
      }

      product = 2 * sum % 11;
    } // Now check that we have the right check digit


    var expect = 1;
    var checkDigit = (product + Number(vat.slice(8, 9))) % 10;
    return checkDigit === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(RS)(\d{9})$/]
  }
};

},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slovakiaRepublic = {
  name: 'Slovakia Republic',
  codes: ['SK', 'SVK', '703'],
  calcFn: function calcFn(vat) {
    var expect = 0;
    var checkDigit = Number(vat) % 11;
    return checkDigit === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(SK)([1-9]\d[2346-9]\d{7})$/]
  }
};

},{}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slovenia = {
  name: 'Slovenia',
  codes: ['SI', 'SVN', '705'],
  calcFn: function calcFn(vat) {
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 7; i++) {
      total += Number(vat.charAt(i)) * exports.slovenia.rules.multipliers.common[i];
    } // Establish check digits using modulus 11


    total = 11 - total % 11;

    if (total === 10) {
      total = 0;
    } // Compare the number with the last character of the VAT number. If it is the
    // same, then it's a valid check digit.


    var expect = Number(vat.slice(7, 8));
    return !!(total !== 11 && total === expect);
  },
  rules: {
    multipliers: {
      common: [8, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(SI)([1-9]\d{7})$/]
  }
};

},{}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spain = {
  name: 'Spain',
  codes: ['ES', 'ESP', '724'],
  calcFn: function calcFn(vat) {
    var _a = exports.spain.rules,
        additional = _a.additional,
        multipliers = _a.multipliers;
    if (!additional) return false; // National juridical entities

    if (additional[0].test(vat)) return isNationalJuridicalEntities(vat, multipliers.common); // Juridical entities other than national ones

    if (additional[1].test(vat)) return isNonNationalJuridical(vat, multipliers.common); // Personal number (NIF) (starting with numeric of Y or Z)

    if (additional[2].test(vat)) return isPersonalYtoZ(vat); // Personal number (NIF) (starting with K, L, M, or X)

    if (additional[3].test(vat)) return isPersonalKtoX(vat);
    return false;
  },
  rules: {
    multipliers: {
      common: [2, 1, 2, 1, 2, 1, 2]
    },
    regex: [/^(ES)([A-Z]\d{8})$/, /^(ES)([A-HN-SW]\d{7}[A-J])$/, /^(ES)([0-9YZ]\d{7}[A-Z])$/, /^(ES)([KLMX]\d{7}[A-Z])$/],
    additional: [/^[A-H|J|U|V]\d{8}$/, /^[A-H|N-S|W]\d{7}[A-J]$/, /^[0-9|Y|Z]\d{7}[A-Z]$/, /^[K|L|M|X]\d{7}[A-Z]$/]
  }
};

function extractDigitAndMultiplyByCounter(vat, multipliers, total) {
  var temp;
  var result = total;

  for (var i = 0; i < 7; i++) {
    temp = Number(vat.charAt(i + 1)) * multipliers[i];

    if (temp > 9) {
      result += Math.floor(temp / 10) + temp % 10;
    } else {
      result += temp;
    }
  }

  return result;
}

function isNationalJuridicalEntities(vat, multipliers) {
  var total = extractDigitAndMultiplyByCounter(vat, multipliers, 0); // Now calculate the check digit itself.

  total = 10 - total % 10;

  if (total === 10) {
    total = 0;
  } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


  var expect = Number(vat.slice(8, 9));
  return total === expect;
}

function isNonNationalJuridical(vat, multipliers) {
  var total = extractDigitAndMultiplyByCounter(vat, multipliers, 0); // Now calculate the check digit itself.

  total = 10 - total % 10;
  var totalStr = String.fromCharCode(total + 64); // Compare it with the last character of the VAT number. If it's the same, then it's valid.

  var expect = vat.slice(8, 9);
  return totalStr === expect;
}

function isPersonalYtoZ(vat) {
  var tempNumber = vat;
  if (tempNumber.substring(0, 1) === 'Y') tempNumber = tempNumber.replace(/Y/, '1');
  if (tempNumber.substring(0, 1) === 'Z') tempNumber = tempNumber.replace(/Z/, '2');
  var expect = 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(+tempNumber.substring(0, 8) % 23);
  return tempNumber.charAt(8) === expect;
}

function isPersonalKtoX(vat) {
  var expect = 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(Number(vat.substring(1, 8)) % 23);
  return vat.charAt(8) === expect;
}

},{}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sweden = {
  name: 'Sweden',
  codes: ['SE', 'SWE', '752'],
  calcFn: function calcFn(vat) {
    var expect; // Calculate R where R = R1 + R3 + R5 + R7 + R9, and Ri = INT(Ci/5) + (Ci*2) modulo 10

    var R = 0;

    for (var i = 0; i < 9; i = i + 2) {
      var digit = Number(vat.charAt(i));
      R += Math.floor(digit / 5) + digit * 2 % 10;
    } // Calculate S where S = C2 + C4 + C6 + C8


    var S = 0;

    for (var j = 1; j < 9; j = j + 2) {
      S += Number(vat.charAt(j));
    }

    var checkDigit = (10 - (R + S) % 10) % 10; // Compare it with the last character of the VAT number. If it's the same, then it's valid.

    expect = Number(vat.slice(9, 10));
    return checkDigit === expect;
  },
  rules: {
    multipliers: {},
    regex: [/^(SE)(\d{10}01)$/]
  }
};

},{}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switzerland = {
  name: 'Switzerland',
  codes: ['CH', 'CHE', '756'],
  calcFn: function calcFn(vat) {
    var total = 0;

    for (var i = 0; i < 8; i++) {
      total += Number(vat.charAt(i)) * exports.switzerland.rules.multipliers.common[i];
    } // Establish check digit.s


    total = 11 - total % 11;
    if (total === 10) return false;
    if (total === 11) total = 0; // Check to see if the check digit given is correct, If not, we have an error with the VAT number

    var expect = Number(vat.substr(8, 1));
    return total === expect;
  },
  rules: {
    multipliers: {
      common: [5, 4, 3, 2, 7, 6, 5, 4]
    },
    regex: [/^(CHE)(\d{9})(MWST|TVA|IVA)?$/]
  }
};

},{}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unitedKingdom = {
  name: 'United Kingdom',
  codes: ['GB', 'GBR', '826'],
  calcFn: function calcFn(vat) {
    // Government departments
    if (vat.substr(0, 2) === 'GD') return isGovernmentDepartment(vat); // Health authorities

    if (vat.substr(0, 2) === 'HA') return isHealthAuthorities(vat); // Standard and commercial numbers

    return isStandardOrCommercialNumber(vat, exports.unitedKingdom.rules.multipliers.common);
  },
  rules: {
    multipliers: {
      common: [8, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(GB)?(\d{9})$/, /^(GB)?(\d{12})$/, /^(GB)?(GD\d{3})$/, /^(GB)?(HA\d{3})$/]
  }
};

function isGovernmentDepartment(vat) {
  var expect = 500;
  return Number(vat.substr(2, 3)) < expect;
}

function isHealthAuthorities(vat) {
  var expect = 499;
  return Number(vat.substr(2, 3)) > expect;
}

function isStandardOrCommercialNumber(vat, multipliers) {
  var total = 0; // 0 VAT numbers disallowed!

  if (Number(vat.slice(0)) === 0) return false; // Check range is OK for modulus 97 calculation

  var no = Number(vat.slice(0, 7)); // Extract the next digit and multiply by the counter.

  for (var i = 0; i < 7; i++) {
    total += Number(vat.charAt(i)) * multipliers[i];
  } // Old numbers use a simple 97 modulus, but new numbers use an adaptation of that (less 55). Our
  // VAT number could use either system, so we check it against both.
  // Establish check digits by subtracting 97 from total until negative.


  var checkDigit = total;

  while (checkDigit > 0) {
    checkDigit = checkDigit - 97;
  } // Get the absolute value and compare it with the last two characters of the VAT number. If the
  // same, then it is a valid traditional check digit. However, even then the number must fit within
  // certain specified ranges.


  checkDigit = Math.abs(checkDigit);

  if (checkDigit === Number(vat.slice(7, 9)) && no < 9990001 && (no < 100000 || no > 999999) && (no < 9490001 || no > 9700000)) {
    return true;
  } // Now try the new method by subtracting 55 from the check digit if we can - else add 42


  if (checkDigit >= 55) {
    checkDigit = checkDigit - 55;
  } else {
    checkDigit = checkDigit + 42;
  }

  var expect = Number(vat.slice(7, 9));
  return Boolean(checkDigit === expect && no > 1000000);
}

},{}],66:[function(require,module,exports){
"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function makeResult(vat, isValid, country) {
  return {
    value: vat || undefined,
    isValid: Boolean(isValid),
    isValidFormat: country ? isVatValidToRegexp(vat, country.rules.regex).isValid : false,
    isSupportedCountry: Boolean(country),
    country: !country ? undefined : {
      name: country.name,
      isoCode: {
        short: country.codes[0],
        long: country.codes[1],
        numeric: country.codes[2]
      }
    }
  };
}

function removeExtraChars(vat) {
  if (vat === void 0) {
    vat = '';
  }

  return vat.toString().toUpperCase().replace(/(\s|-|\.)+/g, '');
}

function getCountryCodes(country) {
  return __spreadArrays(country.codes, [country.name === 'Greece' ? 'EL' : undefined]).filter(Boolean);
}

function getCountry(vat, countriesList) {
  for (var _i = 0, countriesList_1 = countriesList; _i < countriesList_1.length; _i++) {
    var country = countriesList_1[_i];
    if (startsWithCode(vat, country)) return __assign({}, country);
  }

  return undefined;
}

function startsWithCode(vat, country) {
  var countryCodes = getCountryCodes(country);
  return countryCodes.filter(function (code) {
    return vat.startsWith(code);
  }).length > 0;
}

function isVatValidToRegexp(vat, regexArr) {
  for (var _i = 0, regexArr_1 = regexArr; _i < regexArr_1.length; _i++) {
    var regex = regexArr_1[_i];
    var isValid = regex.test(vat);
    if (isValid) return {
      isValid: true,
      regex: regex
    };
  }

  return {
    isValid: false,
    regex: undefined
  };
}

function isVatValid(vat, country) {
  var regexpValidRes = isVatValidToRegexp(vat, country.rules.regex);
  if (!regexpValidRes.isValid || !regexpValidRes.regex) return false;
  var regexResult = regexpValidRes.regex.exec(vat);
  if (!regexResult) return false;
  return country.calcFn(regexResult[2]);
}

function checkVAT(vat, countriesList) {
  if (countriesList === void 0) {
    countriesList = [];
  }

  if (!vat) return makeResult(vat, false);
  var cleanVAT = removeExtraChars(vat);
  var country = getCountry(cleanVAT, countriesList);
  var isValid = country ? isVatValid(cleanVAT, country) : false;
  return makeResult(cleanVAT, isValid, country);
}

exports.checkVAT = checkVAT;

},{}],67:[function(require,module,exports){
"use strict";

module.exports = function load(src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};

  cb = cb || function () {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb); // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload

  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd(script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };

  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd(script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

},{}],68:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};

  var type = _typeof(val);

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, n, name) {
  if (ms < n) {
    return;
  }

  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }

  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],69:[function(require,module,exports){
"use strict";

// shim for using process in browser
var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }

  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();

function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}

var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }

  draining = false;

  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }

  if (queue.length) {
    drainQueue();
  }
}

function drainQueue() {
  if (draining) {
    return;
  }

  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;

  while (len) {
    currentQueue = queue;
    queue = [];

    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }

    queueIndex = -1;
    len = queue.length;
  }

  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}

process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  queue.push(new Item(fun, args));

  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}; // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues

process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
  return [];
};

process.binding = function (name) {
  throw new Error('process.binding is not supported');
};

process.cwd = function () {
  return '/';
};

process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};

process.umask = function () {
  return 0;
};

},{}],70:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }

  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],71:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.SimpleLightbox = factory();
  }
})(void 0, function () {
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var obj = arguments[i];

      if (obj) {
        for (var key in obj) {
          obj.hasOwnProperty(key) && (target[key] = obj[key]);
        }
      }
    }

    return target;
  }

  function addClass(element, className) {
    if (element && className) {
      element.className += ' ' + className;
    }
  }

  function removeClass(element, className) {
    if (element && className) {
      element.className = element.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), ' ').trim();
    }
  }

  function parseHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    return div.childNodes[0];
  }

  function matches(el, selector) {
    return (el.matches || el.matchesSelector || el.msMatchesSelector).call(el, selector);
  }

  function getWindowHeight() {
    return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
  }

  function SimpleLightbox(options) {
    this.init.apply(this, arguments);
  }

  SimpleLightbox.defaults = {
    // add custom classes to lightbox elements
    elementClass: '',
    elementLoadingClass: 'slbLoading',
    htmlClass: 'slbActive',
    closeBtnClass: '',
    nextBtnClass: '',
    prevBtnClass: '',
    loadingTextClass: '',
    // customize / localize controls captions
    closeBtnCaption: 'Close',
    nextBtnCaption: 'Next',
    prevBtnCaption: 'Previous',
    loadingCaption: 'Loading...',
    bindToItems: true,
    // set click event handler to trigger lightbox on provided $items
    closeOnOverlayClick: true,
    closeOnEscapeKey: true,
    nextOnImageClick: true,
    showCaptions: true,
    captionAttribute: 'title',
    // choose data source for library to glean image caption from
    urlAttribute: 'href',
    // where to expect large image
    startAt: 0,
    // start gallery at custom index
    loadingTimeout: 100,
    // time after loading element will appear
    appendTarget: 'body',
    // append elsewhere if needed
    beforeSetContent: null,
    // convenient hooks for extending library behavoiur
    beforeClose: null,
    afterClose: null,
    beforeDestroy: null,
    afterDestroy: null,
    videoRegex: new RegExp(/youtube.com|vimeo.com/) // regex which tests load url for iframe content

  };
  assign(SimpleLightbox.prototype, {
    init: function init(options) {
      options = this.options = assign({}, SimpleLightbox.defaults, options);
      var self = this;
      var elements;

      if (options.$items) {
        elements = options.$items.get();
      }

      if (options.elements) {
        elements = [].slice.call(typeof options.elements === 'string' ? document.querySelectorAll(options.elements) : options.elements);
      }

      this.eventRegistry = {
        lightbox: [],
        thumbnails: []
      };
      this.items = [];
      this.captions = [];

      if (elements) {
        elements.forEach(function (element, index) {
          self.items.push(element.getAttribute(options.urlAttribute));
          self.captions.push(element.getAttribute(options.captionAttribute));

          if (options.bindToItems) {
            self.addEvent(element, 'click', function (e) {
              e.preventDefault();
              self.showPosition(index);
            }, 'thumbnails');
          }
        });
      }

      if (options.items) {
        this.items = options.items;
      }

      if (options.captions) {
        this.captions = options.captions;
      }
    },
    addEvent: function addEvent(element, eventName, callback, scope) {
      this.eventRegistry[scope || 'lightbox'].push({
        element: element,
        eventName: eventName,
        callback: callback
      });
      element.addEventListener(eventName, callback);
      return this;
    },
    removeEvents: function removeEvents(scope) {
      this.eventRegistry[scope].forEach(function (item) {
        item.element.removeEventListener(item.eventName, item.callback);
      });
      this.eventRegistry[scope] = [];
      return this;
    },
    next: function next() {
      return this.showPosition(this.currentPosition + 1);
    },
    prev: function prev() {
      return this.showPosition(this.currentPosition - 1);
    },
    normalizePosition: function normalizePosition(position) {
      if (position >= this.items.length) {
        position = 0;
      } else if (position < 0) {
        position = this.items.length - 1;
      }

      return position;
    },
    showPosition: function showPosition(position) {
      var newPosition = this.normalizePosition(position);

      if (typeof this.currentPosition !== 'undefined') {
        this.direction = newPosition > this.currentPosition ? 'next' : 'prev';
      }

      this.currentPosition = newPosition;
      return this.setupLightboxHtml().prepareItem(this.currentPosition, this.setContent).show();
    },
    loading: function loading(on) {
      var self = this;
      var options = this.options;

      if (on) {
        this.loadingTimeout = setTimeout(function () {
          addClass(self.$el, options.elementLoadingClass);
          self.$content.innerHTML = '<p class="slbLoadingText ' + options.loadingTextClass + '">' + options.loadingCaption + '</p>';
          self.show();
        }, options.loadingTimeout);
      } else {
        removeClass(this.$el, options.elementLoadingClass);
        clearTimeout(this.loadingTimeout);
      }
    },
    prepareItem: function prepareItem(position, callback) {
      var self = this;
      var url = this.items[position];
      this.loading(true);

      if (this.options.videoRegex.test(url)) {
        callback.call(self, parseHtml('<div class="slbIframeCont"><iframe class="slbIframe" frameborder="0" allowfullscreen src="' + url + '"></iframe></div>'));
      } else {
        var $imageCont = parseHtml('<div class="slbImageWrap"><img class="slbImage" src="' + url + '" /></div>');
        this.$currentImage = $imageCont.querySelector('.slbImage');

        if (this.options.showCaptions && this.captions[position]) {
          $imageCont.appendChild(parseHtml('<div class="slbCaption">' + this.captions[position] + '</div>'));
        }

        this.loadImage(url, function () {
          self.setImageDimensions();
          callback.call(self, $imageCont);
          self.loadImage(self.items[self.normalizePosition(self.currentPosition + 1)]);
        });
      }

      return this;
    },
    loadImage: function loadImage(url, callback) {
      if (!this.options.videoRegex.test(url)) {
        var image = new Image();
        callback && (image.onload = callback);
        image.src = url;
      }
    },
    setupLightboxHtml: function setupLightboxHtml() {
      var o = this.options;

      if (!this.$el) {
        this.$el = parseHtml('<div class="slbElement ' + o.elementClass + '">' + '<div class="slbOverlay"></div>' + '<div class="slbWrapOuter">' + '<div class="slbWrap">' + '<div class="slbContentOuter">' + '<div class="slbContent"></div>' + '<button type="button" title="' + o.closeBtnCaption + '" class="slbCloseBtn ' + o.closeBtnClass + '">×</button>' + (this.items.length > 1 ? '<div class="slbArrows">' + '<button type="button" title="' + o.prevBtnCaption + '" class="prev slbArrow' + o.prevBtnClass + '">' + o.prevBtnCaption + '</button>' + '<button type="button" title="' + o.nextBtnCaption + '" class="next slbArrow' + o.nextBtnClass + '">' + o.nextBtnCaption + '</button>' + '</div>' : '') + '</div>' + '</div>' + '</div>' + '</div>');
        this.$content = this.$el.querySelector('.slbContent');
      }

      this.$content.innerHTML = '';
      return this;
    },
    show: function show() {
      if (!this.modalInDom) {
        document.querySelector(this.options.appendTarget).appendChild(this.$el);
        addClass(document.documentElement, this.options.htmlClass);
        this.setupLightboxEvents();
        this.modalInDom = true;
      }

      return this;
    },
    setContent: function setContent(content) {
      var $content = typeof content === 'string' ? parseHtml(content) : content;
      this.loading(false);
      this.setupLightboxHtml();
      removeClass(this.$content, 'slbDirectionNext');
      removeClass(this.$content, 'slbDirectionPrev');

      if (this.direction) {
        addClass(this.$content, this.direction === 'next' ? 'slbDirectionNext' : 'slbDirectionPrev');
      }

      if (this.options.beforeSetContent) {
        this.options.beforeSetContent($content, this);
      }

      this.$content.appendChild($content);
      return this;
    },
    setImageDimensions: function setImageDimensions() {
      if (this.$currentImage) {
        this.$currentImage.style.maxHeight = getWindowHeight() + 'px';
      }
    },
    setupLightboxEvents: function setupLightboxEvents() {
      var self = this;

      if (this.eventRegistry.lightbox.length) {
        return this;
      }

      this.addEvent(this.$el, 'click', function (e) {
        var $target = e.target;

        if (matches($target, '.slbCloseBtn') || self.options.closeOnOverlayClick && matches($target, '.slbWrap')) {
          self.close();
        } else if (matches($target, '.slbArrow')) {
          matches($target, '.next') ? self.next() : self.prev();
        } else if (self.options.nextOnImageClick && self.items.length > 1 && matches($target, '.slbImage')) {
          self.next();
        }
      }).addEvent(document, 'keyup', function (e) {
        self.options.closeOnEscapeKey && e.keyCode === 27 && self.close();

        if (self.items.length > 1) {
          (e.keyCode === 39 || e.keyCode === 68) && self.next();
          (e.keyCode === 37 || e.keyCode === 65) && self.prev();
        }
      }).addEvent(window, 'resize', function () {
        self.setImageDimensions();
      });
      return this;
    },
    close: function close() {
      if (this.modalInDom) {
        this.runHook('beforeClose');
        this.removeEvents('lightbox');
        this.$el && this.$el.parentNode.removeChild(this.$el);
        removeClass(document.documentElement, this.options.htmlClass);
        this.modalInDom = false;
        this.runHook('afterClose');
      }

      this.direction = undefined;
      this.currentPosition = this.options.startAt;
    },
    destroy: function destroy() {
      this.close();
      this.runHook('beforeDestroy');
      this.removeEvents('thumbnails');
      this.runHook('afterDestroy');
    },
    runHook: function runHook(name) {
      this.options[name] && this.options[name](this);
    }
  });

  SimpleLightbox.open = function (options) {
    var instance = new SimpleLightbox(options);
    return options.content ? instance.setContent(options.content).show() : instance.showPosition(instance.options.startAt);
  };

  SimpleLightbox.registerAsJqueryPlugin = function ($) {
    $.fn.simpleLightbox = function (options) {
      var lightboxInstance;
      var $items = this;
      return this.each(function () {
        if (!$.data(this, 'simpleLightbox')) {
          lightboxInstance = lightboxInstance || new SimpleLightbox($.extend({}, options, {
            $items: $items
          }));
          $.data(this, 'simpleLightbox', lightboxInstance);
        }
      });
    };

    $.SimpleLightbox = SimpleLightbox;
  };

  if (typeof window !== 'undefined' && window.jQuery) {
    SimpleLightbox.registerAsJqueryPlugin(window.jQuery);
  }

  return SimpleLightbox;
});

},{}],72:[function(require,module,exports){
'use strict';

var Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/

Sister = function Sister() {
  var sister = {},
      events = {};
  /**
   * @name handler
   * @function
   * @param {Object} data Event data.
   */

  /**
   * @param {String} name Event name.
   * @param {handler} handler
   * @return {listener}
   */

  sister.on = function (name, handler) {
    var listener = {
      name: name,
      handler: handler
    };
    events[name] = events[name] || [];
    events[name].unshift(listener);
    return listener;
  };
  /**
   * @param {listener}
   */


  sister.off = function (listener) {
    var index = events[listener.name].indexOf(listener);

    if (index !== -1) {
      events[listener.name].splice(index, 1);
    }
  };
  /**
   * @param {String} name Event name.
   * @param {Object} data Event data.
   */


  sister.trigger = function (name, data) {
    var listeners = events[name],
        i;

    if (listeners) {
      i = listeners.length;

      while (i--) {
        listeners[i].handler(data);
      }
    }
  };

  return sister;
};

module.exports = Sister;

},{}],73:[function(require,module,exports){
'use strict';
/**
 * A typeahead component for inputs
 * @class Suggestions
 *
 * @param {HTMLInputElement} el A valid HTML input element
 * @param {Array} data An array of data used for results
 * @param {Object} options
 * @param {Number} [options.limit=5] Max number of results to display in the auto suggest list.
 * @param {Number} [options.minLength=2] Number of characters typed into an input to trigger suggestions.
 * @return {Suggestions} `this`
 * @example
 * // in the browser
 * var input = document.querySelector('input');
 * var data = [
 *   'Roy Eldridge',
 *   'Roy Hargrove',
 *   'Rex Stewart'
 * ];
 *
 * new Suggestions(input, data);
 *
 * // with options
 * var input = document.querySelector('input');
 * var data = [{
 *   name: 'Roy Eldridge',
 *   year: 1911
 * }, {
 *   name: 'Roy Hargrove',
 *   year: 1969
 * }, {
 *   name: 'Rex Stewart',
 *   year: 1907
 * }];
 *
 * var typeahead = new Suggestions(input, data, {
 *   filter: false, // Disable filtering
 *   minLength: 3, // Number of characters typed into an input to trigger suggestions.
 *   limit: 3 //  Max number of results to display.
 * });
 *
 * // As we're passing an object of an arrays as data, override
 * // `getItemValue` by specifying the specific property to search on.
 * typeahead.getItemValue = function(item) { return item.name };
 *
 * input.addEventListener('change', function() {
 *   console.log(typeahead.selected); // Current selected item.
 * });
 *
 * // With browserify
 * var Suggestions = require('suggestions');
 *
 * new Suggestions(input, data);
 */

var Suggestions = require('./src/suggestions');

window.Suggestions = module.exports = Suggestions;

},{"./src/suggestions":75}],74:[function(require,module,exports){
"use strict";
'Use strict';

var List = function List(component) {
  this.component = component;
  this.items = [];
  this.active = 0;
  this.wrapper = document.createElement('div');
  this.wrapper.className = 'suggestions-wrapper';
  this.element = document.createElement('ul');
  this.element.className = 'suggestions';
  this.wrapper.appendChild(this.element); // selectingListItem is set to true in the time between the mousedown and mouseup when clicking an item in the list
  // mousedown on a list item will cause the input to blur which normally hides the list, so this flag is used to keep
  // the list open until the mouseup

  this.selectingListItem = false;
  component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
  return this;
};

List.prototype.show = function () {
  this.element.style.display = 'block';
};

List.prototype.hide = function () {
  this.element.style.display = 'none';
};

List.prototype.add = function (item) {
  this.items.push(item);
};

List.prototype.clear = function () {
  this.items = [];
  this.active = 0;
};

List.prototype.isEmpty = function () {
  return !this.items.length;
};

List.prototype.isVisible = function () {
  return this.element.style.display === 'block';
};

List.prototype.draw = function () {
  this.element.innerHTML = '';

  if (this.items.length === 0) {
    this.hide();
    return;
  }

  for (var i = 0; i < this.items.length; i++) {
    this.drawItem(this.items[i], this.active === i);
  }

  this.show();
};

List.prototype.drawItem = function (item, active) {
  var li = document.createElement('li'),
      a = document.createElement('a');
  if (active) li.className += ' active';
  a.innerHTML = item.string;
  li.appendChild(a);
  this.element.appendChild(li);
  li.addEventListener('mousedown', function () {
    this.selectingListItem = true;
  }.bind(this));
  li.addEventListener('mouseup', function () {
    this.handleMouseUp.call(this, item);
  }.bind(this));
};

List.prototype.handleMouseUp = function (item) {
  this.selectingListItem = false;
  this.component.value(item.original);
  this.clear();
  this.draw();
};

List.prototype.move = function (index) {
  this.active = index;
  this.draw();
};

List.prototype.previous = function () {
  this.move(this.active === 0 ? this.items.length - 1 : this.active - 1);
};

List.prototype.next = function () {
  this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
};

List.prototype.drawError = function (msg) {
  var li = document.createElement('li');
  li.innerHTML = msg;
  this.element.appendChild(li);
  this.show();
};

module.exports = List;

},{}],75:[function(require,module,exports){
'use strict';

var extend = require('xtend');

var fuzzy = require('fuzzy');

var List = require('./list');

var Suggestions = function Suggestions(el, data, options) {
  options = options || {};
  this.options = extend({
    minLength: 2,
    limit: 5,
    filter: true
  }, options);
  this.el = el;
  this.data = data || [];
  this.list = new List(this);
  this.query = '';
  this.selected = null;
  this.list.draw();
  this.el.addEventListener('keyup', function (e) {
    this.handleKeyUp(e.keyCode);
  }.bind(this), false);
  this.el.addEventListener('keydown', function (e) {
    this.handleKeyDown(e);
  }.bind(this));
  this.el.addEventListener('focus', function () {
    this.handleFocus();
  }.bind(this));
  this.el.addEventListener('blur', function () {
    this.handleBlur();
  }.bind(this));
  this.el.addEventListener('paste', function (e) {
    this.handlePaste(e);
  }.bind(this)); // use user-provided render function if given, otherwise just use the default

  this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this);
  this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
  return this;
};

Suggestions.prototype.handleKeyUp = function (keyCode) {
  // 40 - DOWN
  // 38 - UP
  // 27 - ESC
  // 13 - ENTER
  // 9 - TAB
  if (keyCode === 40 || keyCode === 38 || keyCode === 27 || keyCode === 13 || keyCode === 9) return;
  this.handleInputChange(this.el.value);
};

Suggestions.prototype.handleKeyDown = function (e) {
  switch (e.keyCode) {
    case 13: // ENTER

    case 9:
      // TAB
      if (!this.list.isEmpty()) {
        if (this.list.isVisible()) {
          e.preventDefault();
        }

        this.value(this.list.items[this.list.active].original);
        this.list.hide();
      }

      break;

    case 27:
      // ESC
      if (!this.list.isEmpty()) this.list.hide();
      break;

    case 38:
      // UP
      this.list.previous();
      break;

    case 40:
      // DOWN
      this.list.next();
      break;
  }
};

Suggestions.prototype.handleBlur = function () {
  if (!this.list.selectingListItem) {
    this.list.hide();
  }
};

Suggestions.prototype.handlePaste = function (e) {
  if (e.clipboardData) {
    this.handleInputChange(e.clipboardData.getData('Text'));
  } else {
    var self = this;
    setTimeout(function () {
      self.handleInputChange(e.target.value);
    }, 100);
  }
};

Suggestions.prototype.handleInputChange = function (query) {
  this.query = this.normalize(query);
  this.list.clear();

  if (this.query.length < this.options.minLength) {
    this.list.draw();
    return;
  }

  this.getCandidates(function (data) {
    for (var i = 0; i < data.length; i++) {
      this.list.add(data[i]);
      if (i === this.options.limit - 1) break;
    }

    this.list.draw();
  }.bind(this));
};

Suggestions.prototype.handleFocus = function () {
  if (!this.list.isEmpty()) this.list.show();
  this.list.selectingListItem = false;
};
/**
 * Update data previously passed
 *
 * @param {Array} revisedData
 */


Suggestions.prototype.update = function (revisedData) {
  this.data = revisedData;
  this.handleKeyUp();
};
/**
 * Clears data
 */


Suggestions.prototype.clear = function () {
  this.data = [];
  this.list.clear();
};
/**
 * Normalize the results list and input value for matching
 *
 * @param {String} value
 * @return {String}
 */


Suggestions.prototype.normalize = function (value) {
  value = value.toLowerCase();
  return value;
};
/**
 * Evaluates whether an array item qualifies as a match with the current query
 *
 * @param {String} candidate a possible item from the array passed
 * @param {String} query the current query
 * @return {Boolean}
 */


Suggestions.prototype.match = function (candidate, query) {
  return candidate.indexOf(query) > -1;
};

Suggestions.prototype.value = function (value) {
  this.selected = value;
  this.el.value = this.getItemValue(value);

  if (document.createEvent) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent('change', true, false);
    this.el.dispatchEvent(e);
  } else {
    this.el.fireEvent('onchange');
  }
};

Suggestions.prototype.getCandidates = function (callback) {
  var options = {
    pre: '<strong>',
    post: '</strong>',
    extract: function (d) {
      return this.getItemValue(d);
    }.bind(this)
  };
  var results;

  if (this.options.filter) {
    results = fuzzy.filter(this.query, this.data, options);
    results = results.map(function (item) {
      return {
        original: item.original,
        string: this.render(item.original, item.string)
      };
    }.bind(this));
  } else {
    results = this.data.map(function (d) {
      var renderedString = this.render(d);
      return {
        original: d,
        string: renderedString
      };
    }.bind(this));
  }

  callback(results);
};
/**
 * For a given item in the data array, return what should be used as the candidate string
 *
 * @param {Object|String} item an item from the data array
 * @return {String} item
 */


Suggestions.prototype.getItemValue = function (item) {
  return item;
};
/**
 * For a given item in the data array, return a string of html that should be rendered in the dropdown
 * @param {Object|String} item an item from the data array
 * @param {String} sourceFormatting a string that has pre-formatted html that should be passed directly through the render function 
 * @return {String} html
 */


Suggestions.prototype.render = function (item, sourceFormatting) {
  if (sourceFormatting) {
    // use existing formatting on the source string
    return sourceFormatting;
  }

  var boldString = item.original ? this.getItemValue(item.original) : this.getItemValue(item);
  var indexString = this.normalize(boldString);
  var indexOfQuery = indexString.lastIndexOf(this.query);

  while (indexOfQuery > -1) {
    var endIndexOfQuery = indexOfQuery + this.query.length;
    boldString = boldString.slice(0, indexOfQuery) + '<strong>' + boldString.slice(indexOfQuery, endIndexOfQuery) + '</strong>' + boldString.slice(endIndexOfQuery);
    indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
  }

  return boldString;
};
/**
 * Render an custom error message in the suggestions list
 * @param {String} msg An html string to render as an error message
 */


Suggestions.prototype.renderError = function (msg) {
  this.list.drawError(msg);
};

module.exports = Suggestions;

},{"./list":74,"fuzzy":23,"xtend":158}],76:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */
(function (window, factory) {
  // universal module definition

  /*jshint strict: false */

  /*globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['unipointer/unipointer'], function (Unipointer) {
      return factory(window, Unipointer);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('unipointer'));
  } else {
    // browser global
    window.Unidragger = factory(window, window.Unipointer);
  }
})(window, function factory(window, Unipointer) {
  'use strict'; // -------------------------- Unidragger -------------------------- //

  function Unidragger() {} // inherit Unipointer & EvEmitter


  var proto = Unidragger.prototype = Object.create(Unipointer.prototype); // ----- bind start ----- //

  proto.bindHandles = function () {
    this._bindHandles(true);
  };

  proto.unbindHandles = function () {
    this._bindHandles(false);
  };
  /**
   * Add or remove start event
   * @param {Boolean} isAdd
   */


  proto._bindHandles = function (isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd; // bind each handle

    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
    var touchAction = isAdd ? this._touchActionValue : '';

    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];

      this._bindStartEvent(handle, isAdd);

      handle[bindMethod]('click', this); // touch-action: none to override browser touch gestures. metafizzy/flickity#540

      if (window.PointerEvent) {
        handle.style.touchAction = touchAction;
      }
    }
  }; // prototype so it can be overwriteable by Flickity


  proto._touchActionValue = 'none'; // ----- start event ----- //

  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */

  proto.pointerDown = function (event, pointer) {
    var isOkay = this.okayPointerDown(event);

    if (!isOkay) {
      return;
    } // track start event position


    this.pointerDownPointer = pointer;
    event.preventDefault();
    this.pointerDownBlur(); // bind move and end events

    this._bindPostStartEvents(event);

    this.emitEvent('pointerDown', [event, pointer]);
  }; // nodes that have text fields


  var cursorNodes = {
    TEXTAREA: true,
    INPUT: true,
    SELECT: true,
    OPTION: true
  }; // input types that do not have text fields

  var clickTypes = {
    radio: true,
    checkbox: true,
    button: true,
    submit: true,
    image: true,
    file: true
  }; // dismiss inputs with text fields. flickity#403, flickity#404

  proto.okayPointerDown = function (event) {
    var isCursorNode = cursorNodes[event.target.nodeName];
    var isClickType = clickTypes[event.target.type];
    var isOkay = !isCursorNode || isClickType;

    if (!isOkay) {
      this._pointerReset();
    }

    return isOkay;
  }; // kludge to blur previously focused input


  proto.pointerDownBlur = function () {
    var focused = document.activeElement; // do not blur body for IE10, metafizzy/flickity#117

    var canBlur = focused && focused.blur && focused != document.body;

    if (canBlur) {
      focused.blur();
    }
  }; // ----- move event ----- //

  /**
   * drag move
   * @param {Event} event
   * @param {Event or Touch} pointer
   */


  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);

    this.emitEvent('pointerMove', [event, pointer, moveVector]);

    this._dragMove(event, pointer, moveVector);
  }; // base pointer move logic


  proto._dragPointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    }; // start drag if pointer has moved far enough to start drag

    if (!this.isDragging && this.hasDragStarted(moveVector)) {
      this._dragStart(event, pointer);
    }

    return moveVector;
  }; // condition if pointer has moved far enough to start drag


  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  }; // ----- end event ----- //

  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   */


  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);

    this._dragPointerUp(event, pointer);
  };

  proto._dragPointerUp = function (event, pointer) {
    if (this.isDragging) {
      this._dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this._staticClick(event, pointer);
    }
  }; // -------------------------- drag -------------------------- //
  // dragStart


  proto._dragStart = function (event, pointer) {
    this.isDragging = true; // prevent clicks

    this.isPreventingClicks = true;
    this.dragStart(event, pointer);
  };

  proto.dragStart = function (event, pointer) {
    this.emitEvent('dragStart', [event, pointer]);
  }; // dragMove


  proto._dragMove = function (event, pointer, moveVector) {
    // do not drag if not dragging yet
    if (!this.isDragging) {
      return;
    }

    this.dragMove(event, pointer, moveVector);
  };

  proto.dragMove = function (event, pointer, moveVector) {
    event.preventDefault();
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  }; // dragEnd


  proto._dragEnd = function (event, pointer) {
    // set flags
    this.isDragging = false; // re-enable clicking async

    setTimeout(function () {
      delete this.isPreventingClicks;
    }.bind(this));
    this.dragEnd(event, pointer);
  };

  proto.dragEnd = function (event, pointer) {
    this.emitEvent('dragEnd', [event, pointer]);
  }; // ----- onclick ----- //
  // handle all clicks and prevent clicks when dragging


  proto.onclick = function (event) {
    if (this.isPreventingClicks) {
      event.preventDefault();
    }
  }; // ----- staticClick ----- //
  // triggered after pointer down & up with no/tiny movement


  proto._staticClick = function (event, pointer) {
    // ignore emulated mouse up clicks
    if (this.isIgnoringMouseUp && event.type == 'mouseup') {
      return;
    }

    this.staticClick(event, pointer); // set flag for emulated clicks 300ms after touchend

    if (event.type != 'mouseup') {
      this.isIgnoringMouseUp = true; // reset flag after 300ms

      setTimeout(function () {
        delete this.isIgnoringMouseUp;
      }.bind(this), 400);
    }
  };

  proto.staticClick = function (event, pointer) {
    this.emitEvent('staticClick', [event, pointer]);
  }; // ----- utils ----- //


  Unidragger.getPointerPoint = Unipointer.getPointerPoint; // -----  ----- //

  return Unidragger;
});

},{"unipointer":77}],77:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */
(function (window, factory) {
  // universal module definition

  /* jshint strict: false */

  /*global define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['ev-emitter/ev-emitter'], function (EvEmitter) {
      return factory(window, EvEmitter);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('ev-emitter'));
  } else {
    // browser global
    window.Unipointer = factory(window, window.EvEmitter);
  }
})(window, function factory(window, EvEmitter) {
  'use strict';

  function noop() {}

  function Unipointer() {} // inherit EvEmitter


  var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);

  proto.bindStartEvent = function (elem) {
    this._bindStartEvent(elem, true);
  };

  proto.unbindStartEvent = function (elem) {
    this._bindStartEvent(elem, false);
  };
  /**
   * Add or remove start event
   * @param {Boolean} isAdd - remove if falsey
   */


  proto._bindStartEvent = function (elem, isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd;
    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener'; // default to mouse events

    var startEvent = 'mousedown';

    if (window.PointerEvent) {
      // Pointer Events
      startEvent = 'pointerdown';
    } else if ('ontouchstart' in window) {
      // Touch Events. iOS Safari
      startEvent = 'touchstart';
    }

    elem[bindMethod](startEvent, this);
  }; // trigger handler methods for events


  proto.handleEvent = function (event) {
    var method = 'on' + event.type;

    if (this[method]) {
      this[method](event);
    }
  }; // returns the touch that we're keeping track of


  proto.getTouch = function (touches) {
    for (var i = 0; i < touches.length; i++) {
      var touch = touches[i];

      if (touch.identifier == this.pointerIdentifier) {
        return touch;
      }
    }
  }; // ----- start event ----- //


  proto.onmousedown = function (event) {
    // dismiss clicks from right or middle buttons
    var button = event.button;

    if (button && button !== 0 && button !== 1) {
      return;
    }

    this._pointerDown(event, event);
  };

  proto.ontouchstart = function (event) {
    this._pointerDown(event, event.changedTouches[0]);
  };

  proto.onpointerdown = function (event) {
    this._pointerDown(event, event);
  };
  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */


  proto._pointerDown = function (event, pointer) {
    // dismiss right click and other pointers
    // button = 0 is okay, 1-4 not
    if (event.button || this.isPointerDown) {
      return;
    }

    this.isPointerDown = true; // save pointer identifier to match up touch events

    this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;
    this.pointerDown(event, pointer);
  };

  proto.pointerDown = function (event, pointer) {
    this._bindPostStartEvents(event);

    this.emitEvent('pointerDown', [event, pointer]);
  }; // hash of events to be bound after start event


  var postStartEvents = {
    mousedown: ['mousemove', 'mouseup'],
    touchstart: ['touchmove', 'touchend', 'touchcancel'],
    pointerdown: ['pointermove', 'pointerup', 'pointercancel']
  };

  proto._bindPostStartEvents = function (event) {
    if (!event) {
      return;
    } // get proper events to match start event


    var events = postStartEvents[event.type]; // bind events to node

    events.forEach(function (eventName) {
      window.addEventListener(eventName, this);
    }, this); // save these arguments

    this._boundPointerEvents = events;
  };

  proto._unbindPostStartEvents = function () {
    // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
    if (!this._boundPointerEvents) {
      return;
    }

    this._boundPointerEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, this);
    }, this);

    delete this._boundPointerEvents;
  }; // ----- move event ----- //


  proto.onmousemove = function (event) {
    this._pointerMove(event, event);
  };

  proto.onpointermove = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerMove(event, event);
    }
  };

  proto.ontouchmove = function (event) {
    var touch = this.getTouch(event.changedTouches);

    if (touch) {
      this._pointerMove(event, touch);
    }
  };
  /**
   * pointer move
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */


  proto._pointerMove = function (event, pointer) {
    this.pointerMove(event, pointer);
  }; // public


  proto.pointerMove = function (event, pointer) {
    this.emitEvent('pointerMove', [event, pointer]);
  }; // ----- end event ----- //


  proto.onmouseup = function (event) {
    this._pointerUp(event, event);
  };

  proto.onpointerup = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerUp(event, event);
    }
  };

  proto.ontouchend = function (event) {
    var touch = this.getTouch(event.changedTouches);

    if (touch) {
      this._pointerUp(event, touch);
    }
  };
  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */


  proto._pointerUp = function (event, pointer) {
    this._pointerDone();

    this.pointerUp(event, pointer);
  }; // public


  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);
  }; // ----- pointer done ----- //
  // triggered on pointer up & pointer cancel


  proto._pointerDone = function () {
    this._pointerReset();

    this._unbindPostStartEvents();

    this.pointerDone();
  };

  proto._pointerReset = function () {
    // reset properties
    this.isPointerDown = false;
    delete this.pointerIdentifier;
  };

  proto.pointerDone = noop; // ----- pointer cancel ----- //

  proto.onpointercancel = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerCancel(event, event);
    }
  };

  proto.ontouchcancel = function (event) {
    var touch = this.getTouch(event.changedTouches);

    if (touch) {
      this._pointerCancel(event, touch);
    }
  };
  /**
   * pointer cancel
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */


  proto._pointerCancel = function (event, pointer) {
    this._pointerDone();

    this.pointerCancel(event, pointer);
  }; // public


  proto.pointerCancel = function (event, pointer) {
    this.emitEvent('pointerCancel', [event, pointer]);
  }; // -----  ----- //
  // utility function for getting x/y coords from event


  Unipointer.getPointerPoint = function (pointer) {
    return {
      x: pointer.pageX,
      y: pointer.pageY
    };
  }; // -----  ----- //


  return Unipointer;
});

},{"ev-emitter":7}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toDate = _interopRequireDefault(require("./lib/toDate"));

var _toFloat = _interopRequireDefault(require("./lib/toFloat"));

var _toInt = _interopRequireDefault(require("./lib/toInt"));

var _toBoolean = _interopRequireDefault(require("./lib/toBoolean"));

var _equals = _interopRequireDefault(require("./lib/equals"));

var _contains = _interopRequireDefault(require("./lib/contains"));

var _matches = _interopRequireDefault(require("./lib/matches"));

var _isEmail = _interopRequireDefault(require("./lib/isEmail"));

var _isURL = _interopRequireDefault(require("./lib/isURL"));

var _isMACAddress = _interopRequireDefault(require("./lib/isMACAddress"));

var _isIP = _interopRequireDefault(require("./lib/isIP"));

var _isIPRange = _interopRequireDefault(require("./lib/isIPRange"));

var _isFQDN = _interopRequireDefault(require("./lib/isFQDN"));

var _isBoolean = _interopRequireDefault(require("./lib/isBoolean"));

var _isAlpha = _interopRequireWildcard(require("./lib/isAlpha"));

var _isAlphanumeric = _interopRequireWildcard(require("./lib/isAlphanumeric"));

var _isNumeric = _interopRequireDefault(require("./lib/isNumeric"));

var _isPort = _interopRequireDefault(require("./lib/isPort"));

var _isLowercase = _interopRequireDefault(require("./lib/isLowercase"));

var _isUppercase = _interopRequireDefault(require("./lib/isUppercase"));

var _isAscii = _interopRequireDefault(require("./lib/isAscii"));

var _isFullWidth = _interopRequireDefault(require("./lib/isFullWidth"));

var _isHalfWidth = _interopRequireDefault(require("./lib/isHalfWidth"));

var _isVariableWidth = _interopRequireDefault(require("./lib/isVariableWidth"));

var _isMultibyte = _interopRequireDefault(require("./lib/isMultibyte"));

var _isSurrogatePair = _interopRequireDefault(require("./lib/isSurrogatePair"));

var _isInt = _interopRequireDefault(require("./lib/isInt"));

var _isFloat = _interopRequireWildcard(require("./lib/isFloat"));

var _isDecimal = _interopRequireDefault(require("./lib/isDecimal"));

var _isHexadecimal = _interopRequireDefault(require("./lib/isHexadecimal"));

var _isDivisibleBy = _interopRequireDefault(require("./lib/isDivisibleBy"));

var _isHexColor = _interopRequireDefault(require("./lib/isHexColor"));

var _isISRC = _interopRequireDefault(require("./lib/isISRC"));

var _isMD = _interopRequireDefault(require("./lib/isMD5"));

var _isHash = _interopRequireDefault(require("./lib/isHash"));

var _isJWT = _interopRequireDefault(require("./lib/isJWT"));

var _isJSON = _interopRequireDefault(require("./lib/isJSON"));

var _isEmpty = _interopRequireDefault(require("./lib/isEmpty"));

var _isLength = _interopRequireDefault(require("./lib/isLength"));

var _isByteLength = _interopRequireDefault(require("./lib/isByteLength"));

var _isUUID = _interopRequireDefault(require("./lib/isUUID"));

var _isMongoId = _interopRequireDefault(require("./lib/isMongoId"));

var _isAfter = _interopRequireDefault(require("./lib/isAfter"));

var _isBefore = _interopRequireDefault(require("./lib/isBefore"));

var _isIn = _interopRequireDefault(require("./lib/isIn"));

var _isCreditCard = _interopRequireDefault(require("./lib/isCreditCard"));

var _isIdentityCard = _interopRequireDefault(require("./lib/isIdentityCard"));

var _isISIN = _interopRequireDefault(require("./lib/isISIN"));

var _isISBN = _interopRequireDefault(require("./lib/isISBN"));

var _isISSN = _interopRequireDefault(require("./lib/isISSN"));

var _isMobilePhone = _interopRequireWildcard(require("./lib/isMobilePhone"));

var _isCurrency = _interopRequireDefault(require("./lib/isCurrency"));

var _isISO = _interopRequireDefault(require("./lib/isISO8601"));

var _isRFC = _interopRequireDefault(require("./lib/isRFC3339"));

var _isISO31661Alpha = _interopRequireDefault(require("./lib/isISO31661Alpha2"));

var _isISO31661Alpha2 = _interopRequireDefault(require("./lib/isISO31661Alpha3"));

var _isBase = _interopRequireDefault(require("./lib/isBase64"));

var _isDataURI = _interopRequireDefault(require("./lib/isDataURI"));

var _isMagnetURI = _interopRequireDefault(require("./lib/isMagnetURI"));

var _isMimeType = _interopRequireDefault(require("./lib/isMimeType"));

var _isLatLong = _interopRequireDefault(require("./lib/isLatLong"));

var _isPostalCode = _interopRequireWildcard(require("./lib/isPostalCode"));

var _ltrim = _interopRequireDefault(require("./lib/ltrim"));

var _rtrim = _interopRequireDefault(require("./lib/rtrim"));

var _trim = _interopRequireDefault(require("./lib/trim"));

var _escape = _interopRequireDefault(require("./lib/escape"));

var _unescape = _interopRequireDefault(require("./lib/unescape"));

var _stripLow = _interopRequireDefault(require("./lib/stripLow"));

var _whitelist = _interopRequireDefault(require("./lib/whitelist"));

var _blacklist = _interopRequireDefault(require("./lib/blacklist"));

var _isWhitelisted = _interopRequireDefault(require("./lib/isWhitelisted"));

var _normalizeEmail = _interopRequireDefault(require("./lib/normalizeEmail"));

var _toString = _interopRequireDefault(require("./lib/util/toString"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var version = '10.11.0';
var validator = {
  version: version,
  toDate: _toDate.default,
  toFloat: _toFloat.default,
  toInt: _toInt.default,
  toBoolean: _toBoolean.default,
  equals: _equals.default,
  contains: _contains.default,
  matches: _matches.default,
  isEmail: _isEmail.default,
  isURL: _isURL.default,
  isMACAddress: _isMACAddress.default,
  isIP: _isIP.default,
  isIPRange: _isIPRange.default,
  isFQDN: _isFQDN.default,
  isBoolean: _isBoolean.default,
  isAlpha: _isAlpha.default,
  isAlphaLocales: _isAlpha.locales,
  isAlphanumeric: _isAlphanumeric.default,
  isAlphanumericLocales: _isAlphanumeric.locales,
  isNumeric: _isNumeric.default,
  isPort: _isPort.default,
  isLowercase: _isLowercase.default,
  isUppercase: _isUppercase.default,
  isAscii: _isAscii.default,
  isFullWidth: _isFullWidth.default,
  isHalfWidth: _isHalfWidth.default,
  isVariableWidth: _isVariableWidth.default,
  isMultibyte: _isMultibyte.default,
  isSurrogatePair: _isSurrogatePair.default,
  isInt: _isInt.default,
  isFloat: _isFloat.default,
  isFloatLocales: _isFloat.locales,
  isDecimal: _isDecimal.default,
  isHexadecimal: _isHexadecimal.default,
  isDivisibleBy: _isDivisibleBy.default,
  isHexColor: _isHexColor.default,
  isISRC: _isISRC.default,
  isMD5: _isMD.default,
  isHash: _isHash.default,
  isJWT: _isJWT.default,
  isJSON: _isJSON.default,
  isEmpty: _isEmpty.default,
  isLength: _isLength.default,
  isByteLength: _isByteLength.default,
  isUUID: _isUUID.default,
  isMongoId: _isMongoId.default,
  isAfter: _isAfter.default,
  isBefore: _isBefore.default,
  isIn: _isIn.default,
  isCreditCard: _isCreditCard.default,
  isIdentityCard: _isIdentityCard.default,
  isISIN: _isISIN.default,
  isISBN: _isISBN.default,
  isISSN: _isISSN.default,
  isMobilePhone: _isMobilePhone.default,
  isMobilePhoneLocales: _isMobilePhone.locales,
  isPostalCode: _isPostalCode.default,
  isPostalCodeLocales: _isPostalCode.locales,
  isCurrency: _isCurrency.default,
  isISO8601: _isISO.default,
  isRFC3339: _isRFC.default,
  isISO31661Alpha2: _isISO31661Alpha.default,
  isISO31661Alpha3: _isISO31661Alpha2.default,
  isBase64: _isBase.default,
  isDataURI: _isDataURI.default,
  isMagnetURI: _isMagnetURI.default,
  isMimeType: _isMimeType.default,
  isLatLong: _isLatLong.default,
  ltrim: _ltrim.default,
  rtrim: _rtrim.default,
  trim: _trim.default,
  escape: _escape.default,
  unescape: _unescape.default,
  stripLow: _stripLow.default,
  whitelist: _whitelist.default,
  blacklist: _blacklist.default,
  isWhitelisted: _isWhitelisted.default,
  normalizeEmail: _normalizeEmail.default,
  toString: _toString.default
};
var _default = validator;
exports.default = _default;
module.exports = exports.default;
module.exports.default = exports.default;

},{"./lib/blacklist":80,"./lib/contains":81,"./lib/equals":82,"./lib/escape":83,"./lib/isAfter":84,"./lib/isAlpha":85,"./lib/isAlphanumeric":86,"./lib/isAscii":87,"./lib/isBase64":88,"./lib/isBefore":89,"./lib/isBoolean":90,"./lib/isByteLength":91,"./lib/isCreditCard":92,"./lib/isCurrency":93,"./lib/isDataURI":94,"./lib/isDecimal":95,"./lib/isDivisibleBy":96,"./lib/isEmail":97,"./lib/isEmpty":98,"./lib/isFQDN":99,"./lib/isFloat":100,"./lib/isFullWidth":101,"./lib/isHalfWidth":102,"./lib/isHash":103,"./lib/isHexColor":104,"./lib/isHexadecimal":105,"./lib/isIP":106,"./lib/isIPRange":107,"./lib/isISBN":108,"./lib/isISIN":109,"./lib/isISO31661Alpha2":110,"./lib/isISO31661Alpha3":111,"./lib/isISO8601":112,"./lib/isISRC":113,"./lib/isISSN":114,"./lib/isIdentityCard":115,"./lib/isIn":116,"./lib/isInt":117,"./lib/isJSON":118,"./lib/isJWT":119,"./lib/isLatLong":120,"./lib/isLength":121,"./lib/isLowercase":122,"./lib/isMACAddress":123,"./lib/isMD5":124,"./lib/isMagnetURI":125,"./lib/isMimeType":126,"./lib/isMobilePhone":127,"./lib/isMongoId":128,"./lib/isMultibyte":129,"./lib/isNumeric":130,"./lib/isPort":131,"./lib/isPostalCode":132,"./lib/isRFC3339":133,"./lib/isSurrogatePair":134,"./lib/isURL":135,"./lib/isUUID":136,"./lib/isUppercase":137,"./lib/isVariableWidth":138,"./lib/isWhitelisted":139,"./lib/ltrim":140,"./lib/matches":141,"./lib/normalizeEmail":142,"./lib/rtrim":143,"./lib/stripLow":144,"./lib/toBoolean":145,"./lib/toDate":146,"./lib/toFloat":147,"./lib/toInt":148,"./lib/trim":149,"./lib/unescape":150,"./lib/util/toString":154,"./lib/whitelist":155}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commaDecimal = exports.dotDecimal = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
var alpha = {
  'en-US': /^[A-Z]+$/i,
  'bg-BG': /^[А-Я]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[A-ZÆØÅ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'el-GR': /^[Α-ω]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'nb-NO': /^[A-ZÆØÅ]+$/i,
  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[A-ZÆØÅ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[A-ZÅÄÖ]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
exports.alpha = alpha;
var alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'bg-BG': /^[0-9А-Я]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'el-GR': /^[0-9Α-ω]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
exports.alphanumeric = alphanumeric;
var decimal = {
  'en-US': '.',
  ar: '٫'
};
exports.decimal = decimal;
var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
exports.englishLocales = englishLocales;

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = "en-".concat(englishLocales[i]);
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
  decimal[locale] = decimal['en-US'];
} // Source: http://www.localeplanet.com/java/


var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
exports.arabicLocales = arabicLocales;

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = "ar-".concat(arabicLocales[_i]);
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
  decimal[_locale] = decimal.ar;
} // Source: https://en.wikipedia.org/wiki/Decimal_mark


var dotDecimal = [];
exports.dotDecimal = dotDecimal;
var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'ku-IQ', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
exports.commaDecimal = commaDecimal;

for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
  decimal[dotDecimal[_i2]] = decimal['en-US'];
}

for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
  decimal[commaDecimal[_i3]] = ',';
}

alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
decimal['pt-BR'] = decimal['pt-PT']; // see #862

alpha['pl-Pl'] = alpha['pl-PL'];
alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
decimal['pl-Pl'] = decimal['pl-PL'];

},{}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blacklist;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function blacklist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contains;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _toString = _interopRequireDefault(require("./util/toString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function contains(str, elem) {
  (0, _assertString.default)(str);
  return str.indexOf((0, _toString.default)(elem)) >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/toString":154}],82:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equals;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function equals(str, comparison) {
  (0, _assertString.default)(str);
  return str === comparison;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = escape;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function escape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAfter;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _toDate = _interopRequireDefault(require("./toDate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isAfter(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original > comparison);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./toDate":146,"./util/assertString":151}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlpha;
exports.locales = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _alpha = require("./alpha");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isAlpha(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str);

  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alpha);
exports.locales = locales;

},{"./alpha":79,"./util/assertString":151}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlphanumeric;
exports.locales = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _alpha = require("./alpha");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isAlphanumeric(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str);

  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alphanumeric);
exports.locales = locales;

},{"./alpha":79,"./util/assertString":151}],87:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAscii;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-control-regex */


var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString.default)(str);
  return ascii.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBase64;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var notBase64 = /[^A-Z0-9+\/=]/i;

function isBase64(str) {
  (0, _assertString.default)(str);
  var len = str.length;

  if (!len || len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }

  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBefore;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _toDate = _interopRequireDefault(require("./toDate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isBefore(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original < comparison);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./toDate":146,"./util/assertString":151}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isBoolean(str) {
  (0, _assertString.default)(str);
  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],91:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}
/* eslint-disable prefer-rest-params */


function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */


var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCurrency;

var _merge = _interopRequireDefault(require("./util/merge"));

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function currencyRegex(options) {
  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
  options.digits_after_decimal.forEach(function (digit, index) {
    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
  });
  var symbol = "(\\".concat(options.symbol.replace(/\./g, '\\.'), ")").concat(options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)

  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)


  if (options.allow_negative_sign_placeholder) {
    pattern = "( (?!\\-))?".concat(pattern);
  } else if (options.allow_space_after_symbol) {
    pattern = " ?".concat(pattern);
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  } // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space


  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_decimal: true,
  require_decimal: false,
  digits_after_decimal: [2],
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/merge":153}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDataURI;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

function isDataURI(str) {
  (0, _assertString.default)(str);
  var data = str.split(',');

  if (data.length < 2) {
    return false;
  }

  var attributes = data.shift().trim().split(';');
  var schemeAndMediaType = attributes.shift();

  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
    return false;
  }

  var mediaType = schemeAndMediaType.substr(5);

  if (mediaType !== '' && !validMediaType.test(mediaType)) {
    return false;
  }

  for (var i = 0; i < attributes.length; i++) {
    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {// ok
    } else if (!validAttribute.test(attributes[i])) {
      return false;
    }
  }

  for (var _i = 0; _i < data.length; _i++) {
    if (!validData.test(data[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDecimal;

var _merge = _interopRequireDefault(require("./util/merge"));

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _includes = _interopRequireDefault(require("./util/includes"));

var _alpha = require("./alpha");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function decimalRegExp(options) {
  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
  return regExp;
}

var default_decimal_options = {
  force_decimal: false,
  decimal_digits: '1,',
  locale: 'en-US'
};
var blacklist = ['', '-', '+'];

function isDecimal(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_decimal_options);

  if (options.locale in _alpha.decimal) {
    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
  }

  throw new Error("Invalid locale '".concat(options.locale, "'"));
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./alpha":79,"./util/assertString":151,"./util/includes":152,"./util/merge":153}],96:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDivisibleBy;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _toFloat = _interopRequireDefault(require("./toFloat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isDivisibleBy(str, num) {
  (0, _assertString.default)(str);
  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./toFloat":147,"./util/assertString":151}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _merge = _interopRequireDefault(require("./util/merge"));

var _isByteLength = _interopRequireDefault(require("./isByteLength"));

var _isFQDN = _interopRequireDefault(require("./isFQDN"));

var _isIP = _interopRequireDefault(require("./isIP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isByteLength":91,"./isFQDN":99,"./isIP":106,"./util/assertString":151,"./util/merge":153}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _merge = _interopRequireDefault(require("./util/merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var default_is_empty_options = {
  ignore_whitespace: false
};

function isEmpty(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_is_empty_options);
  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/merge":153}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _merge = _interopRequireDefault(require("./util/merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/merge":153}],100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFloat;
exports.locales = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _alpha = require("./alpha");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isFloat(str, options) {
  (0, _assertString.default)(str);
  options = options || {};
  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));

  if (str === '' || str === '.' || str === '-' || str === '+') {
    return false;
  }

  var value = parseFloat(str.replace(',', '.'));
  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}

var locales = Object.keys(_alpha.decimal);
exports.locales = locales;

},{"./alpha":79,"./util/assertString":151}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFullWidth;
exports.fullWidth = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.fullWidth = fullWidth;

function isFullWidth(str) {
  (0, _assertString.default)(str);
  return fullWidth.test(str);
}

},{"./util/assertString":151}],102:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHalfWidth;
exports.halfWidth = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.halfWidth = halfWidth;

function isHalfWidth(str) {
  (0, _assertString.default)(str);
  return halfWidth.test(str);
}

},{"./util/assertString":151}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHash;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var lengths = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
};

function isHash(str, algorithm) {
  (0, _assertString.default)(str);
  var hash = new RegExp("^[a-f0-9]{".concat(lengths[algorithm], "}$"));
  return hash.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexColor;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

function isHexColor(str) {
  (0, _assertString.default)(str);
  return hexcolor.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],105:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexadecimal;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var hexadecimal = /^[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString.default)(str);
  return hexadecimal.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIPRange;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _isIP = _interopRequireDefault(require("./isIP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var subnetMaybe = /^\d{1,2}$/;

function isIPRange(str) {
  (0, _assertString.default)(str);
  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet

  if (parts.length !== 2) {
    return false;
  }

  if (!subnetMaybe.test(parts[1])) {
    return false;
  } // Disallow preceding 0 i.e. 01, 02, ...


  if (parts[1].length > 1 && parts[1].startsWith('0')) {
    return false;
  }

  return (0, _isIP.default)(parts[0], 4) && parts[1] <= 32 && parts[1] >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isIP":106,"./util/assertString":151}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISBN;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }

  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i;

  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }

    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }

    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }

    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISIN;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;

function isISIN(str) {
  (0, _assertString.default)(str);

  if (!isin.test(str)) {
    return false;
  }

  var checksumStr = str.replace(/[A-Z]/g, function (character) {
    return parseInt(character, 36);
  });
  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble = true;

  for (var i = checksumStr.length - 2; i >= 0; i--) {
    digit = checksumStr.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],110:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO31661Alpha2;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _includes = _interopRequireDefault(require("./util/includes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2


var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];

function isISO31661Alpha2(str) {
  (0, _assertString.default)(str);
  return (0, _includes.default)(validISO31661Alpha2CountriesCodes, str.toUpperCase());
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/includes":152}],111:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO31661Alpha3;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _includes = _interopRequireDefault(require("./util/includes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3


var validISO31661Alpha3CountriesCodes = ['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'];

function isISO31661Alpha3(str) {
  (0, _assertString.default)(str);
  return (0, _includes.default)(validISO31661Alpha3CountriesCodes, str.toUpperCase());
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/includes":152}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO8601;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */
// from http://goo.gl/0ejHHW


var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

var isValidDate = function isValidDate(str) {
  // str must have passed the ISO8601 check
  // this check is meant to catch invalid dates
  // like 2009-02-31
  // first check for ordinal dates
  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);

  if (ordinalMatch) {
    var oYear = Number(ordinalMatch[1]);
    var oDay = Number(ordinalMatch[2]); // if is leap year

    if (oYear % 4 === 0 && oYear % 100 !== 0) return oDay <= 366;
    return oDay <= 365;
  }

  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
  var year = match[1];
  var month = match[2];
  var day = match[3];
  var monthString = month ? "0".concat(month).slice(-2) : month;
  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare

  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
  if (isNaN(d.getUTCFullYear())) return false;

  if (month && day) {
    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
  }

  return true;
};

function isISO8601(str, options) {
  (0, _assertString.default)(str);
  var check = iso8601.test(str);
  if (!options) return check;
  if (check && options.strict) return isValidDate(str);
  return check;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISRC;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // see http://isrc.ifpi.org/en/isrc-standard/code-syntax


var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

function isISRC(str) {
  (0, _assertString.default)(str);
  return isrc.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],114:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISSN;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var issn = '^\\d{4}-?\\d{3}[\\dX]$';

function isISSN(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var testIssn = issn;
  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');

  if (!testIssn.test(str)) {
    return false;
  }

  var digits = str.replace('-', '').toUpperCase();
  var checksum = 0;

  for (var i = 0; i < digits.length; i++) {
    var digit = digits[i];
    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
  }

  return checksum % 11 === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],115:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIdentityCard;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var validators = {
  ES: function ES(str) {
    (0, _assertString.default)(str);
    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
    var charsValue = {
      X: 0,
      Y: 1,
      Z: 2
    };
    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input

    var sanitized = str.trim().toUpperCase(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    } // validate the control digit


    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
      return charsValue[char];
    });
    return sanitized.endsWith(controlDigits[number % 23]);
  }
};

function isIdentityCard(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      if (validators.hasOwnProperty(key)) {
        var validator = validators[key];

        if (validator(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],116:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIn;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _toString = _interopRequireDefault(require("./util/toString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function isIn(str, options) {
  (0, _assertString.default)(str);
  var i;

  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];

    for (i in options) {
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString.default)(options[i]);
      }
    }

    return array.indexOf(str) >= 0;
  } else if (_typeof(options) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151,"./util/toString":154}],117:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInt;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.

  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],118:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isJSON;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function isJSON(str) {
  (0, _assertString.default)(str);

  try {
    var obj = JSON.parse(str);
    return !!obj && _typeof(obj) === 'object';
  } catch (e) {
    /* ignore */
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],119:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isJWT;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var jwt = /^([A-Za-z0-9\-_~+\/]+[=]{0,2})\.([A-Za-z0-9\-_~+\/]+[=]{0,2})(?:\.([A-Za-z0-9\-_~+\/]+[=]{0,2}))?$/;

function isJWT(str) {
  (0, _assertString.default)(str);
  return jwt.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],120:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;

function _default(str) {
  (0, _assertString.default)(str);
  if (!str.includes(',')) return false;
  var pair = str.split(',');
  return lat.test(pair[0]) && long.test(pair[1]);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],121:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLength;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}
/* eslint-disable prefer-rest-params */


function isLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowercase;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isLowercase(str) {
  (0, _assertString.default)(str);
  return str === str.toLowerCase();
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],123:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMACAddress;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
var macAddressNoColons = /^([0-9a-fA-F]){12}$/;

function isMACAddress(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_colons) {
    return macAddressNoColons.test(str);
  }

  return macAddress.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],124:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMD5;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString.default)(str);
  return md5.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],125:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMagnetURI;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;

function isMagnetURI(url) {
  (0, _assertString.default)(url);
  return magnetURI.test(url.trim());
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],126:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMimeType;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/
// Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).


var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"

var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"

var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

function isMimeType(str) {
  (0, _assertString.default)(str);
  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;
exports.locales = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */


var phones = {
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-KW': /^(\+?965)[569]\d{7}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'bn-BD': /\+?(88)?0?1[356789][0-9]{8}\b/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28)\d{7}$/,
  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
  'en-MU': /^(\+?230|0)?\d{8}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[89]\d{7}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'vi-VN': /^(\+?84|0)((3([2-9]))|(5([689]))|(7([0|6-9]))|(8([1-5]))|(9([0-9])))([0-9]{7})$/,
  'zh-CN': /^((\+|00)86)?1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */
// aliases

phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];

function isMobilePhone(str, locale, options) {
  (0, _assertString.default)(str);

  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }

  if (Array.isArray(locale)) {
    return locale.some(function (key) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }

      return false;
    });
  } else if (locale in phones) {
    return phones[locale].test(str); // alias falsey locale as 'any'
  } else if (!locale || locale === 'any') {
    for (var key in phones) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(phones);
exports.locales = locales;

},{"./util/assertString":151}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMongoId;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _isHexadecimal = _interopRequireDefault(require("./isHexadecimal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isMongoId(str) {
  (0, _assertString.default)(str);
  return (0, _isHexadecimal.default)(str) && str.length === 24;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isHexadecimal":105,"./util/assertString":151}],129:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMultibyte;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-control-regex */


var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString.default)(str);
  return multibyte.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],130:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumeric;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var numeric = /^[+-]?([0-9]*[.])?[0-9]+$/;
var numericNoSymbols = /^[0-9]+$/;

function isNumeric(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_symbols) {
    return numericNoSymbols.test(str);
  }

  return numeric.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],131:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPort;

var _isInt = _interopRequireDefault(require("./isInt"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isPort(str) {
  return (0, _isInt.default)(str, {
    min: 0,
    max: 65535
  });
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isInt":117}],132:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.locales = void 0;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // common patterns


var threeDigit = /^\d{3}$/;
var fourDigit = /^\d{4}$/;
var fiveDigit = /^\d{5}$/;
var sixDigit = /^\d{6}$/;
var patterns = {
  AD: /^AD\d{3}$/,
  AT: fourDigit,
  AU: fourDigit,
  BE: fourDigit,
  BG: fourDigit,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: fourDigit,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: fiveDigit,
  DK: fourDigit,
  DZ: fiveDigit,
  EE: fiveDigit,
  ES: fiveDigit,
  FI: fiveDigit,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HU: fourDigit,
  IL: fiveDigit,
  IN: sixDigit,
  IS: threeDigit,
  IT: fiveDigit,
  JP: /^\d{3}\-\d{4}$/,
  KE: fiveDigit,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: fourDigit,
  LV: /^LV\-\d{4}$/,
  MX: fiveDigit,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: fourDigit,
  PL: /^\d{2}\-\d{3}$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: sixDigit,
  RU: sixDigit,
  SA: fiveDigit,
  SE: /^\d{3}\s?\d{2}$/,
  SI: fourDigit,
  SK: /^\d{3}\s?\d{2}$/,
  TN: fourDigit,
  TW: /^\d{3}(\d{2})?$/,
  UA: fiveDigit,
  US: /^\d{5}(-\d{4})?$/,
  ZA: fourDigit,
  ZM: fiveDigit
};
var locales = Object.keys(patterns);
exports.locales = locales;

function _default(str, locale) {
  (0, _assertString.default)(str);

  if (locale in patterns) {
    return patterns[locale].test(str);
  } else if (locale === 'any') {
    for (var key in patterns) {
      if (patterns.hasOwnProperty(key)) {
        var pattern = patterns[key];

        if (pattern.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

},{"./util/assertString":151}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRFC3339;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */


var dateFullYear = /[0-9]{4}/;
var dateMonth = /(0[1-9]|1[0-2])/;
var dateMDay = /([12]\d|0[1-9]|3[01])/;
var timeHour = /([01][0-9]|2[0-3])/;
var timeMinute = /[0-5][0-9]/;
var timeSecond = /([0-5][0-9]|60)/;
var timeSecFrac = /(\.[0-9]+)?/;
var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
var rfc3339 = new RegExp("".concat(fullDate.source, "[ tT]").concat(fullTime.source));

function isRFC3339(str) {
  (0, _assertString.default)(str);
  return rfc3339.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],134:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSurrogatePair;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString.default)(str);
  return surrogatePair.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],135:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _isFQDN = _interopRequireDefault(require("./isFQDN"));

var _isIP = _interopRequireDefault(require("./isIP"));

var _merge = _interopRequireDefault(require("./util/merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isFQDN":99,"./isIP":106,"./util/assertString":151,"./util/merge":153}],136:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUUID;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var uuid = {
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
  (0, _assertString.default)(str);
  var pattern = uuid[version];
  return pattern && pattern.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],137:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUppercase;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isUppercase(str) {
  (0, _assertString.default)(str);
  return str === str.toUpperCase();
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],138:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVariableWidth;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _isFullWidth = require("./isFullWidth");

var _isHalfWidth = require("./isHalfWidth");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isVariableWidth(str) {
  (0, _assertString.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./isFullWidth":101,"./isHalfWidth":102,"./util/assertString":151}],139:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWhitelisted;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isWhitelisted(str, chars) {
  (0, _assertString.default)(str);

  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],140:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ltrim;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ltrim(str, chars) {
  (0, _assertString.default)(str);
  var pattern = chars ? new RegExp("^[".concat(chars, "]+"), 'g') : /^\s+/g;
  return str.replace(pattern, '');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function matches(str, pattern, modifiers) {
  (0, _assertString.default)(str);

  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }

  return pattern.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeEmail;

var _merge = _interopRequireDefault(require("./util/merge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var default_normalize_email_options = {
  // The following options apply to all email addresses
  // Lowercases the local part of the email address.
  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
  // The domain is always lowercased, as per RFC 1035
  all_lowercase: true,
  // The following conversions are specific to GMail
  // Lowercases the local part of the GMail address (known to be case-insensitive)
  gmail_lowercase: true,
  // Removes dots from the local part of the email address, as that's ignored by GMail
  gmail_remove_dots: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  gmail_remove_subaddress: true,
  // Conversts the googlemail.com domain to gmail.com
  gmail_convert_googlemaildotcom: true,
  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
  outlookdotcom_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  outlookdotcom_remove_subaddress: true,
  // The following conversions are specific to Yahoo
  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
  yahoo_lowercase: true,
  // Removes the subaddress (e.g. "-foo") from the email address
  yahoo_remove_subaddress: true,
  // The following conversions are specific to Yandex
  // Lowercases the local part of the Yandex address (known to be case-insensitive)
  yandex_lowercase: true,
  // The following conversions are specific to iCloud
  // Lowercases the local part of the iCloud address (known to be case-insensitive)
  icloud_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  icloud_remove_subaddress: true
}; // List of domains used by iCloud

var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/

var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
// This list is likely incomplete

var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru

var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots

function dotsReplacer(match) {
  if (match.length > 1) {
    return match;
  }

  return '';
}

function normalizeEmail(email, options) {
  options = (0, _merge.default)(options, default_normalize_email_options);
  var raw_parts = email.split('@');
  var domain = raw_parts.pop();
  var user = raw_parts.join('@');
  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035

  parts[1] = parts[1].toLowerCase();

  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    // Address is GMail
    if (options.gmail_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (options.gmail_remove_dots) {
      // this does not replace consecutive dots like example..email@gmail.com
      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.gmail_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
    // Address is iCloud
    if (options.icloud_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.icloud_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
    // Address is Outlook.com
    if (options.outlookdotcom_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.outlookdotcom_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
    // Address is Yahoo
    if (options.yahoo_remove_subaddress) {
      var components = parts[0].split('-');
      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.yahoo_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
    if (options.all_lowercase || options.yandex_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preffered
  } else if (options.all_lowercase) {
    // Any other address
    parts[0] = parts[0].toLowerCase();
  }

  return parts.join('@');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/merge":153}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rtrim;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function rtrim(str, chars) {
  (0, _assertString.default)(str);
  var pattern = chars ? new RegExp("[".concat(chars, "]")) : /\s/;
  var idx = str.length - 1;

  for (; idx >= 0 && pattern.test(str[idx]); idx--) {
    ;
  }

  return idx < str.length ? str.substr(0, idx + 1) : str;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],144:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripLow;

var _assertString = _interopRequireDefault(require("./util/assertString"));

var _blacklist = _interopRequireDefault(require("./blacklist"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function stripLow(str, keep_new_lines) {
  (0, _assertString.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist.default)(str, chars);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./blacklist":80,"./util/assertString":151}],145:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toBoolean;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function toBoolean(str, strict) {
  (0, _assertString.default)(str);

  if (strict) {
    return str === '1' || str === 'true';
  }

  return str !== '0' && str !== 'false' && str !== '';
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toDate;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function toDate(date) {
  (0, _assertString.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toFloat;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function toFloat(str) {
  (0, _assertString.default)(str);
  return parseFloat(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],148:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toInt;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function toInt(str, radix) {
  (0, _assertString.default)(str);
  return parseInt(str, radix || 10);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],149:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;

var _rtrim = _interopRequireDefault(require("./rtrim"));

var _ltrim = _interopRequireDefault(require("./ltrim"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function trim(str, chars) {
  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./ltrim":140,"./rtrim":143}],150:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unescape;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function unescape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],151:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;

},{}],152:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var includes = function includes(arr, val) {
  return arr.some(function (arrVal) {
    return val === arrVal;
  });
};

var _default = includes;
exports.default = _default;
module.exports = exports.default;
module.exports.default = exports.default;

},{}],153:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;

},{}],154:[function(require,module,exports){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toString;

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function toString(input) {
  if (_typeof(input) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }

  return String(input);
}

module.exports = exports.default;
module.exports.default = exports.default;

},{}],155:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = whitelist;

var _assertString = _interopRequireDefault(require("./util/assertString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function whitelist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports.default = exports.default;

},{"./util/assertString":151}],156:[function(require,module,exports){
"use strict";

module.exports = function (e) {
  var s = "string" == typeof e.elem ? document.getElementById(e.elem) : e.elem,
      o = "js-Dropdown-title",
      i = "is-selected",
      t = "is-open",
      n = s.options,
      l = n.length,
      d = document.createElement("div");
  d.className = "js-Dropdown", s.id && (d.id = "custom-" + s.id);
  var a = document.createElement("button");
  a.className = o, a.textContent = n[0].textContent;
  var c = document.createElement("ul");
  c.className = "js-Dropdown-list";

  for (var r = 0; r < l; r++) {
    var u = document.createElement("li");
    u.innerText = n[r].textContent, u.setAttribute("data-value", n[r].value), u.setAttribute("data-index", r), s.selectedIndex === r && (u.classList.add(i), a.textContent = n[r].textContent), c.appendChild(u);
  }

  function m() {
    c.classList.toggle(t);
  }

  function v() {
    c.classList.remove(t);
  }

  return d.appendChild(a), d.appendChild(c), d.addEventListener("click", function (e) {
    e.preventDefault();
    var t = e.target;
    t.className === o && m();

    if ("LI" === t.tagName) {
      d.querySelector("." + o).innerText = t.innerText, s.options.selectedIndex = t.getAttribute("data-index");
      var n = new CustomEvent("change");
      s.dispatchEvent(n);

      for (var a = 0; a < l; a++) {
        c.querySelectorAll("li")[a].classList.remove(i);
      }

      t.classList.add(i), v();
    }
  }), s.parentNode.insertBefore(d, s), s.style.display = "none", document.addEventListener("click", function (e) {
    d.contains(e.target) || v();
  }), {
    toggle: m,
    close: v,
    open: function open() {
      c.classList.add(t);
    }
  };
};

},{}],157:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.WHATWGFetch = {});
})(void 0, function (exports) {
  'use strict';

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }

    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }

    return value;
  } // Build a destructive iterator for the value list


  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return {
          done: value === undefined,
          value: value
        };
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }

    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }

    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;

      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);

        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);

      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  } // HTTP methods whose capitalization should be normalized


  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }

      this.url = input.url;
      this.credentials = input.credentials;

      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }

      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;

      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';

    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }

    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }

    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, {
      body: this._bodyInit
    });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2

    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();

      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';

    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, {
      status: 0,
      statusText: ''
    });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, {
      status: status,
      headers: {
        location: url
      }
    });
  };

  exports.DOMException = self.DOMException;

  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function (message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };

    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

},{}],158:[function(require,module,exports){
"use strict";

module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
  var target = {};

  for (var i = 0; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}

},{}],159:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = require('./constants/PlayerStates');

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,
    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

},{"./constants/PlayerStates":161}],160:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = require('./functionNames');

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = require('./eventNames');

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = require('./FunctionStateMap');

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable promise/prefer-await-to-then */


var debug = (0, _debug2.default)('youtube-player');
var YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */

YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);
      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */


YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState(); // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread

          var value = player[functionName].apply(player, args); // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.

          if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();
                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);
                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);
                  clearTimeout(timeout);
                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

},{"./FunctionStateMap":159,"./eventNames":162,"./functionNames":163,"debug":166}],161:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

},{}],162:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */

exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

},{}],163:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */

exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

},{}],164:[function(require,module,exports){
'use strict';

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

var _sister = require('sister');

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = require('./loadYouTubeIframeApi');

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = require('./YouTubePlayer');

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */


var youtubeIframeAPI = void 0;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;
      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);
        emitter.on('ready', function () {
          resolve(player);
        });
        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;
  return playerApi;
};

module.exports = exports['default'];

},{"./YouTubePlayer":160,"./loadYouTubeIframeApi":165,"sister":72}],165:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);
      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady; // The API will call this function when page has finished downloading
    // the JavaScript for the player API.

    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });
  return iframeAPIReady;
};

module.exports = exports['default'];

},{"load-script":67}],166:[function(require,module,exports){
(function (process){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */
exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */

exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  } // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */


exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  var useColors = this.useColors;
  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
  if (!useColors) return;
  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;

    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.debug;
  } catch (e) {} // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */


exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this,require('_process'))
},{"./debug":167,"_process":69}],167:[function(require,module,exports){
"use strict";

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */
exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');
/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};
/**
 * Previous log timestamp.
 */

var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */


function createDebug(namespace) {
  function debug() {
    // disabled?
    if (!debug.enabled) return;
    var self = debug; // set `diff` timestamp

    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr; // turn the `arguments` into a proper Array

    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    } // apply any `formatters` transformations


    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];

      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val); // now we need to remove `args[index]` since it's inlined in the `format`

        args.splice(index, 1);
        index--;
      }

      return match;
    }); // apply env-specific formatting (colors, etc.)

    exports.formatArgs.call(self, args);
    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace); // env-specific initialization logic for debug instances

  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */


function enable(namespaces) {
  exports.save(namespaces);
  exports.names = [];
  exports.skips = [];
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings

    namespaces = split[i].replace(/\*/g, '.*?');

    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}
/**
 * Disable debug output.
 *
 * @api public
 */


function disable() {
  exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */


function enabled(name) {
  var i, len;

  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }

  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }

  return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */


function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":68}],168:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogAjaxformHandling = exports.initAtomPassowords = void 0;

var _flickity = _interopRequireDefault(require("flickity"));

var _simpleLightbox = _interopRequireDefault(require("./simple-lightbox.js"));

var _youtubePlayer = _interopRequireDefault(require("youtube-player"));

var _passwordStrength = require("./password-strength");

var _atomAmount = _interopRequireDefault(require("atom-amount"));

var _atomButton = _interopRequireDefault(require("atom-button"));

var _atomDropdown = _interopRequireDefault(require("atom-dropdown"));

var _atomCartNotification = _interopRequireDefault(require("atom-cart-notification"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

var _atomInputDatepicker = _interopRequireDefault(require("atom-input-datepicker"));

var _atomTile = _interopRequireDefault(require("atom-tile"));

var _atomToggleState = _interopRequireDefault(require("atom-toggle-state"));

var _atomEditFlyout = _interopRequireDefault(require("atom-edit-flyout"));

var _atomTooltip = _interopRequireDefault(require("atom-tooltip"));

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// atom-input
var initAtomEmail = function initAtomEmail() {
  var inputElements = document.querySelectorAll('.atom-input-element input[type="email"]');
  inputElements.forEach(function (inputElement) {
    inputElement.addEventListener('input', function () {
      inputElement.value = inputElement.value.toLowerCase();
    });
  });
}; // atom-password


var initAtomPassoword = function initAtomPassoword(el) {
  var inputElement = el.querySelector('.atom-input-element');
  var input = el.querySelector('input');
  var notes = el.querySelector('.atom-input-notes');
  var basicRules = {
    length: 8,
    upper: 1,
    lower: 1,
    number: 1,
    special: 1
  };
  var rules = {};
  [].forEach.call(notes.querySelectorAll('[data-key]'), function (selectedElement) {
    var selectedRule = selectedElement.dataset.key;

    if (basicRules[selectedRule]) {
      rules[selectedRule] = basicRules[selectedRule];
    }
  });
  var dataLabels = [];
  notes.querySelector('.atom-input-strengthtext').attributes.forEach(function (attribute) {
    if (attribute.name.startsWith('data-label-')) {
      dataLabels.push(attribute.value);
    }
  });
  var defaultLabels = {
    0: 'very weak',
    1: 'weak',
    2: 'average',
    3: 'strong',
    4: 'very strong'
  };
  var customLabels = Object.fromEntries(dataLabels.entries());
  var opts = {
    rules: rules,
    labels: _objectSpread(_objectSpread({}, defaultLabels), customLabels)
  };

  _passwordStrength.PasswordStrength.setup(opts);

  var isOverDecipher = function isOverDecipher(e) {
    var rightOffset = 55;
    var firefoxFixForOffsetX = e.offsetX ? e.offsetX : e.layerX;
    return this.offsetWidth - firefoxFixForOffsetX < rightOffset;
  };

  var hasCursorClass = 'has-cursor';
  inputElement.addEventListener('click', function (e) {
    var _this = this;

    var decipher = function decipher() {
      if (isOverDecipher.bind(_this)(e)) {
        if (input.getAttribute('type') === 'password') {
          input.setAttribute('type', 'text');
        } else {
          input.setAttribute('type', 'password');
        }
      }
    };

    window.debounce(decipher, 150);
  });
  inputElement.addEventListener('mousemove', function (e) {
    var current = e.target;

    if (isOverDecipher.bind(this)(e)) {
      current.classList.add(hasCursorClass);
    } else {
      current.classList.remove(hasCursorClass);
    }
  });

  var resetInputElement = function resetInputElement() {
    inputElement.classList.remove('atom-input-strength-0', 'atom-input-strength-1', 'atom-input-strength-2', 'atom-input-strength-3', 'atom-input-strength-4', 'atom-input-strength-5');
  };

  var resetNotes = function resetNotes() {
    resetInputElement();
    el.querySelector('.atom-input-strength').classList.remove('atom-input-strength-0', 'atom-input-strength-1', 'atom-input-strength-2', 'atom-input-strength-3', 'atom-input-strength-4', 'atom-input-strength-5');

    if (input.value === '') {
      [].forEach.call(el.querySelectorAll('.atom-input-note'), function (note) {
        note.classList.remove('success', 'failed');
      });
      el.querySelector('.atom-input-strengthtext').innerText = '';
    }
  };

  var PWS;

  var updateNotes = function updateNotes() {
    if (!el.classList.contains('nonotes')) {
      resetNotes();

      if (input.value !== '') {
        var closeDelay = 2000;
        PWS = (0, _passwordStrength.PasswordStrength)(input, opts);
        var solvedRules = 0;
        PWS.rules.forEach(function (value) {
          if (el.querySelector('[data-key="' + value.name + '"]') != null) {
            if (value.isPassed()) {
              solvedRules++;
              el.querySelector('[data-key="' + value.name + '"]').classList.add('success');
              el.querySelector('[data-key="' + value.name + '"]').classList.remove('failed');
            } else {
              el.querySelector('[data-key="' + value.name + '"]').classList.remove('success');
              el.querySelector('[data-key="' + value.name + '"]').classList.add('failed');
            }
          }
        });
        var strengthClass = 'atom-input-strength-' + solvedRules;
        inputElement.classList.add(strengthClass);
        el.querySelector('.atom-input-strength').classList.add(strengthClass);

        if (solvedRules >= PWS.rules.length) {
          el.dataset.isValidPassword = true;
          setTimeout(function () {
            notes.classList.add(_state.default.DISABLED);
            resetInputElement();
          }, closeDelay);
        } else {
          el.dataset.isValidPassword = false;
        }
      }
    }
  };

  input.addEventListener('focus', function () {
    el.classList.add('hasFocus');
    updateNotes();
  });
  input.addEventListener('focusout', function () {
    el.classList.remove('hasFocus');
    notes.classList.remove(_state.default.DISABLED);
  });
  input.addEventListener('pwsRuleMatchChange', function () {
    updateNotes();
    notes.classList.remove(_state.default.DISABLED);
  });
  input.addEventListener('pwsLabelChange', function () {
    var _PWS;

    el.querySelector('.atom-input-strengthtext').innerText = (_PWS = PWS) === null || _PWS === void 0 ? void 0 : _PWS.label;
  });
  updateNotes();
};

var initAtomPassowords = function initAtomPassowords() {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  if (!elements) return;
  [].forEach.call(elements.querySelectorAll('.atom-input--password'), function (el) {
    initAtomPassoword(el);
  });
};

exports.initAtomPassowords = initAtomPassowords;

var dialogAjaxformHandling = function dialogAjaxformHandling() {
  [].forEach.call(document.querySelectorAll('.dialog-ajaxform'), function (el) {
    if (!el.classList.contains('dialog-ajaxform--no-submit')) {
      var cancelButton = el.querySelector('.atom-dialog-button-cancel .atom-button');

      if (cancelButton) {
        cancelButton.addEventListener('click', function (e) {
          var _window$openSimpleLig;

          e.preventDefault();
          (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
        });
      }

      el.addEventListener('submit', function (e) {
        e.preventDefault();

        if (el.classList.contains('has-loading')) {
          _tools.default.enableLoading();
        }

        var action = el.getAttribute('action');
        var hasErrors = false;
        [].forEach.call(el.querySelectorAll('input, checkbox, radio, select, textarea'), function (subElement) {
          var errors = validate(subElement, false);

          if (errors.length > 0) {
            hasErrors = true;
            handleErrors(errors);

            _tools.default.disableLoading();
          }
        });

        var onSubmit = function onSubmit(data) {
          var redirect = false;

          if (data !== undefined) {
            var jsonData = typeof data === 'string' ? JSON.parse(data) : data;

            if (_typeof(jsonData) === 'object' && typeof jsonData.redirect === 'string') {
              redirect = jsonData.redirect;
            }

            if (_typeof(jsonData) === 'object' && jsonData.successText !== undefined) {
              var content = el.querySelector('.cmscomponent-dialog-success-content');

              if (content !== null) {
                content.innerHTML = jsonData.successText;
              }
            }
          }

          el.querySelectorAll('.cmscomponent-dialog-success-close, .cmscomponent-dialog-error-close').forEach(function (btn) {
            btn.addEventListener('click', function (subEvent) {
              var _window$openSimpleLig2;

              subEvent.preventDefault();
              (_window$openSimpleLig2 = window.openSimpleLightbox) === null || _window$openSimpleLig2 === void 0 ? void 0 : _window$openSimpleLig2.close();

              if (redirect !== false) {
                document.location.href = redirect;
              }
            });
          });
        };

        var onSuccess = function onSuccess(data) {
          onSubmit(data);

          _tools.default.disableLoading();

          if (!window.dialogSuccessDispatcher(data, el)) {
            return;
          }

          el.querySelector('.atom-dialog-form').style.display = 'none';
          el.querySelector('.cmscomponent-dialog-success').style.display = 'block';
          el.querySelector('.cmscomponent-dialog-error').style.display = 'none';
        };

        var onError = function onError() {
          onSubmit();

          _tools.default.disableLoading();

          el.querySelector('.atom-dialog-form').style.display = 'none';
          el.querySelector('.cmscomponent-dialog-success').style.display = 'none';
          el.querySelector('.cmscomponent-dialog-error').style.display = 'block';
        };

        var onReset = function onReset() {
          _tools.default.disableLoading();

          el.querySelector('.atom-dialog-form').style.display = 'block';
          el.querySelector('.cmscomponent-dialog-success').style.display = 'none';
          el.querySelector('.cmscomponent-dialog-error').style.display = 'none';
        };

        if (!hasErrors) {
          window.jQuery.post(action, window.jQuery(el).serialize()).done(onSuccess).fail(onError);
        }

        window.jQuery(document).on('afterClose.fb', function () {
          onReset();
        });
      });
    }
  });
};

exports.dialogAjaxformHandling = dialogAjaxformHandling;
window.addEventListener('simpleLightboxEventOpen', function () {
  initAtomPassowords(window.openSimpleLightbox.$el);
  dialogAjaxformHandling();
});
window.addEventListener('InitComponents', function () {
  // atom-totop
  var minimalScrollValue = 200;
  var totop = document.querySelector('.atom-totop');
  var waypointElement = document.getElementsByTagName('footer')[0];

  if (totop !== null) {
    totop.addEventListener('click', function () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
    new Waypoint({
      element: waypointElement,
      handler: function handler(direction) {
        if (direction === 'down') {
          totop.classList.remove('atom-totop--fixed');
          totop.classList.add('atom-totop--red');
        } else {
          totop.classList.add('atom-totop--fixed');
          totop.classList.remove('atom-totop--red');
        }
      },
      offset: function offset() {
        return window.innerHeight - 10;
      }
    });
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY || window.pageYOffset;

      if (scrollY > minimalScrollValue) {
        totop.classList.remove('opacity-0');
      } else {
        totop.classList.add('opacity-0');
      }
    });
  }

  _atomAmount.default.init();

  _atomButton.default.init();

  _atomCartNotification.default.init();

  _atomDeliveryTime.default.init();

  _atomDropdown.default.init();

  _atomTile.default.initAll();

  _atomToggleState.default.init();

  _atomEditFlyout.default.init();

  new _atomInputDatepicker.default();

  _atomTooltip.default.init(document); // atom-expander


  Array.prototype.forEach.call(document.querySelectorAll('.expander'), function (el) {
    var maxClickY = 50;
    el.addEventListener('click', function (e) {
      var target = e.target;

      if (target.classList.contains('expander')) {
        var clickY = this.offsetHeight - e.offsetY;

        if (_tools.default.screen('lg', true) && clickY <= maxClickY) {
          el.classList.toggle('expander--expanded');
        }
      }
    });
  }); // atom-marquee

  window.flkty = [];
  Array.prototype.forEach.call(document.querySelectorAll('.marquee'), function (el, index, array) {
    var marquee = function marquee() {
      var fullWidth = 0;
      var elRect = el.getBoundingClientRect();
      var elWidth = elRect.width;
      el.querySelectorAll(':scope > *').forEach(function (elem) {
        var elemRect = elem.getBoundingClientRect();
        var elemWidth = elemRect.width;
        fullWidth += elemWidth;
      });

      if (Math.floor(fullWidth) > Math.floor(elWidth)) {
        el.classList.remove('flex');
        var uid = guid();
        el.setAttribute('data-flkty', uid);
        window.flkty[uid] = new _flickity.default(el, {
          cellAlign: 'left',
          contain: true,
          draggable: true,
          pageDots: false,
          freeScroll: false,
          prevNextButtons: false,
          wrapAround: true,
          friction: 0.6,
          autoPlay: 4000
        });
      } else {
        el.classList.add('flex');
        var flkty = el.getAttribute('data-flkty');

        if (typeof flkty === 'string') {
          window.flkty[flkty].destroy();
          el.removeAttribute('data-flkty');
          delete window.flkty[flkty];
        }
      }
    };

    window.setTimeout(function () {
      marquee();
    }, 300);
    window.addEventListener('resize', function (event) {
      marquee();
    });
  }); // atom-video

  Array.prototype.forEach.call(document.querySelectorAll('.atom-video'), function (video, index, array) {
    var initVideo = function initVideo() {
      var videoElement = video.querySelector('.atom-video-container');
      var uniqueId = guid();
      var videoId = videoElement.getAttribute('data-videoid');
      videoElement.dataset.uniqueid = uniqueId;
      var youTubePlayerInstance = (0, _youtubePlayer.default)(videoElement, {
        videoId: videoId,
        // events: {
        //   onStateChange: onPlayerStateChange
        // },
        playerVars: {
          showinfo: 0,
          rel: 0
        }
      });
      if (typeof window.youTubePlayers === 'undefined') window.youTubePlayers = {};
      window.youTubePlayers[uniqueId] = youTubePlayerInstance;
    }; // calculate and set video height by ratio if we're not inside a stageproduct


    var setRatio = function setRatio(videoId) {
      var videoElement = document.querySelector('.atom-video .atom-video-container[data-videoid="' + videoId + '"]');

      if (videoElement && !videoElement.closest('.cmscomponent-stageproduct')) {
        var _videoElement$dataset;

        var defaultRatio = 16 / 9;
        var desiredRatio = videoElement === null || videoElement === void 0 ? void 0 : (_videoElement$dataset = videoElement.dataset) === null || _videoElement$dataset === void 0 ? void 0 : _videoElement$dataset.videoRatio;
        var ratio = desiredRatio && desiredRatio !== '' ? desiredRatio : defaultRatio;
        videoElement.style.height = "".concat(videoElement.offsetWidth / ratio, "px");
      }
    };

    initVideo();
    setRatio(video.querySelector('.atom-video-container').getAttribute('data-videoid'));
    window.addEventListener('resize', function () {
      setRatio(video.querySelector('.atom-video-container').getAttribute('data-videoid'));
    });
  }); // atom-expander

  Array.prototype.forEach.call(document.querySelectorAll('.atom-expander'), function (el) {
    var toggle = el.querySelector('.atom-expander-toggle');
    el.querySelectorAll('*:not(a) > img').forEach(function (img) {
      img.addEventListener('click', function (e) {
        _simpleLightbox.default.open({
          items: [e.currentTarget.src]
        });
      });
    });
    toggle.addEventListener('click', function (e) {
      var isOpen = el.classList.contains('open');

      if (typeof el.getAttribute('data-closeother') === 'string') {
        Array.prototype.forEach.call(document.querySelectorAll('.atom-expander'), function (expander) {
          expander.classList.remove('open');
        });

        if (!isOpen) {
          el.classList.add('open');
        } else {
          el.classList.remove('open');
        }
      } else {
        el.classList.toggle('open');
      }
    });
  }); // form live validation

  [].forEach.call(document.querySelectorAll('.atom-input, .atom-textarea, .atom-radio'), function (el) {
    var element = el.querySelector('input, textarea');
    handleErrors(validate(element, true));

    if (element.getAttribute('type') === 'radio') {
      element.addEventListener('change', function () {
        // get all radios that belong to that namespace
        var radioName = element.name;
        var radios = document.querySelectorAll('input[name="' + radioName + '"]');

        if (radios !== null) {
          Array.prototype.forEach.call(radios, function (radio) {
            handleErrors(validate(radio));
          });
        }
      });
    }

    var noFocusOut = el.closest('.dialog-ajaxform--no-focusout') || el.closest('.no-focus-out');

    if (!noFocusOut) {
      element.addEventListener('focusout', function () {
        handleErrors(validate(element));
      });
    }
  });
  initAtomPassowords();
  initAtomEmail();
  dialogAjaxformHandling(); // contact form

  [].forEach.call(document.querySelectorAll('.cmscomponent-form-contact'), function (el) {
    el.querySelectorAll('.switch-alreadycustomer input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.closest('.cmscomponent-form-answer1')) {
          el.querySelector('.switched-alreadycustomer').classList.remove('hidden');
        } else {
          el.querySelector('.switched-alreadycustomer').classList.add('hidden');
        }
      });
    });
  });

  function validateQuerySelectorAll(querySelector) {
    var errors = [],
        hasErrors = false;
    document.querySelectorAll(querySelector).forEach(function (element) {
      errors = validate(element);

      if (errors.length > 0) {
        hasErrors = true;
        handleErrors(errors);
      }
    });
    return hasErrors;
  }

  document.querySelectorAll('.cmscomponent-form-payment-submit').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var billingFormSubsetSelector = '.cmscomponent-form-billing-form';
      var checkbox = document.querySelector('.cmscomponent-form-billing-checkbox input[type="checkbox"]');

      if (checkbox && checkbox.checked) {
        billingFormSubsetSelector = '.cmscomponent-form-billing-container';
      }

      var billingFormSelector = '.cmscomponent-form-billing';
      var paymentFormSelector = '.cmscomponent-form-payment';
      var formElementSelector = 'input, select, textarea';
      var hasErrors = validateQuerySelectorAll(billingFormSelector + ' ' + billingFormSubsetSelector + ' ' + formElementSelector + ' ,' + paymentFormSelector + ' ' + formElementSelector);

      if (!hasErrors) {
        var toSend = {};
        document.querySelectorAll(billingFormSelector).forEach(function (formCheckoutBilling) {
          var partOneDataArray = $(formCheckoutBilling).serializeArray();
          partOneDataArray.forEach(function (data) {
            toSend[data.name] = data.value;
          });
        });
        document.querySelectorAll(paymentFormSelector).forEach(function (formCheckoutPayment) {
          var partTwoDataArray = $(formCheckoutPayment).serializeArray();
          partTwoDataArray.forEach(function (data) {
            toSend[data.name] = data.value;
          });
        });
        $.ajax({
          type: 'POST',
          url: '/checkout/multi/payment-method',
          data: toSend,
          success: function success(link) {
            window.location.href = link;
          }
        });
      }
    });
  });
});
window.addEventListener('asmInit', function () {
  initAtomPassowords(document.querySelector('.cmscomponent-assisted-service-mode'));
});

},{"./password-strength":227,"./simple-lightbox.js":231,"atom-amount":169,"atom-button":171,"atom-cart-notification":172,"atom-delivery-time":174,"atom-dropdown":175,"atom-edit-flyout":176,"atom-input-datepicker":177,"atom-tile":178,"atom-toggle-state":179,"atom-tooltip":180,"flickity":17,"state":232,"tools":236,"youtube-player":164}],169:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AtomAmount = {
  init: function init() {
    var _this = this;

    this.rootSelector = '.atom-amount';
    this.decreaseSelector = this.rootSelector + '-decrease';
    this.increaseSelector = this.rootSelector + '-increase';
    this.disabledClass = 'disabled';
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (amount) {
      amount.querySelector('.atom-amount-decrease').addEventListener('click', function () {
        _this.updateAmount(amount, -1);

        _this.toggleButtons(amount);
      });
      amount.querySelector('.atom-amount-increase').addEventListener('click', function () {
        _this.updateAmount(amount, 1);

        _this.toggleButtons(amount);
      });
      amount.querySelector('input').addEventListener('change', function () {
        _this.updateAmount(amount, 0);

        _this.toggleButtons(amount);
      });
    });
  },
  updateAmount: function updateAmount(amount, value) {
    var radix = 10;
    var maxValue = parseInt(amount.dataset.maxvalue, radix);
    var amountInput = amount.querySelector('input');
    amountInput.value = parseInt(amountInput.value, radix) + value;

    if (amountInput.value < 1) {
      amountInput.value = 1;
    }

    if (amountInput.value >= maxValue) {
      amountInput.value = maxValue;
    }
  },
  toggleButtons: function toggleButtons(amount) {
    var radix = 10;
    var maxValue = parseInt(amount.dataset.maxvalue, radix);
    var amountInput = amount.querySelector('input');
    var amountValue = parseInt(amountInput.value, radix);

    if (amountValue === 1) {
      amount.querySelector(this.decreaseSelector).classList.add(this.disabledClass);
    } else {
      amount.querySelector(this.decreaseSelector).classList.remove(this.disabledClass);
    }

    if (amountValue === maxValue) {
      amount.querySelector(this.increaseSelector).classList.add(this.disabledClass);
    } else {
      amount.querySelector(this.increaseSelector).classList.remove(this.disabledClass);
    }
  }
};
var _default = AtomAmount;
exports.default = _default;

},{}],170:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Badge = {
  init: function init() {
    this.rootSelector = '.atom-badge';
  },
  getBadge: function getBadge(data) {
    return "\n      <span class=\"atom-badge ".concat(data.styleModifierBadge, "\">\n        ").concat(data.badge.label, "\n      </span>\n    ");
  },
  getBadges: function getBadges(data) {
    var _this = this;

    if (data && data.length) {
      return data.map(function (badgeData) {
        return "".concat(_this.getBadge(badgeData));
      }).join('');
    } else {
      return '';
    }
  },
  clearBadgeClasses: function clearBadgeClasses(element, newClass) {
    var badgeClasses = ['blue', 'yellow', 'green', 'red', 'light-gray', 'light-green', 'dark-green', 'light-red', 'hidden'];
    [].forEach.call(badgeClasses, function (badgeClass) {
      element.classList.remove(badgeClass);
    });
    element.classList.add(newClass);
  }
};
var _default = Badge;
exports.default = _default;

},{}],171:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AtomButton = {
  init: function init() {
    this.rootSelector = '.atom-button';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var buttonAnimation = 'atom-button-revert';
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (button) {
      button.addEventListener('click', function () {
        button.classList.remove(buttonAnimation);
        button.classList.add(buttonAnimation);
      });
    });
  }
};
var _default = AtomButton;
exports.default = _default;

},{}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _simpleLightbox = _interopRequireDefault(require("../simple-lightbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomCartNotification = {
  init: function init() {
    this.rootSelector = '.atom-cart-notification';
    this.buttonSelector = '.cart-notification-button > button';
    this.formSelector = '.cart-notification-form';
    this.cartSelector = 'header .atom-cart-counter';
    this.errorDialogSelector = '.cmscomponent-stageproduct-textcontent .cmscomponent-stageproduct-dialog';
    this.errorButtonSelector = '.slbContent .cmscomponent-dialog-error .atom-button';
    this.cartEmptyClass = 'atom-cart-counter-empty';
    this.cartNotEmptyClass = 'atom-cart-counter-notempty';
    this.cartCounterClass = 'atom-cart-counter-count';
    this.headerSelector = 'header';
    this.sticky = false;
    this.successStatus = 'success';
    this.bindListeners();
    this.setWaypoints();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.buttonSelector), function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        button.classList.add(_state.default.LOADING);

        var action = _this.getAction(button);

        if (action !== null) {
          var formData = _this.getFormData(button);

          _this.enableLoading();

          var cartItem = formData;
          delete cartItem.CSRFToken;

          try {
            window.vueStores.cart.add(cartItem).then(function (data) {
              console.log('atom-cart-notification.js success callback:', data);
              button.classList.remove(_state.default.LOADING);

              _this.disableLoading();
            });
          } catch (e) {
            console.info("atom-cart-notification.js: Can't reach Vue cartStore or no response");
            console.error(e);

            _this.showError();
          }
        } else {
          console.log('atom-cart-notification.js no form-action available');

          _this.showError();
        }
      });
    });
  },
  getFormData: function getFormData(button) {
    var form = button.closest(this.formSelector);
    var data = new FormData(form);
    var value = Object.fromEntries(data.entries());
    return value;
  },
  enableLoading: function enableLoading() {
    _tools.default.enableLoading();
  },
  disableLoading: function disableLoading() {
    _tools.default.disableLoading();
  },
  getAction: function getAction(button) {
    var form = button.closest(this.formSelector);
    return form !== null ? form.getAttribute('action') : null;
  },
  cleanUpSuccess: function cleanUpSuccess() {
    var root = document.querySelector(this.rootSelector);
    var timeout = 4000;

    if (root !== null) {
      setTimeout(function () {
        root.classList.remove(_state.default.OPEN, _state.default.NO_TRANSITIONS);
      }, timeout);
    }
  },
  showSuccess: function showSuccess(data) {
    var root = document.querySelector(this.rootSelector);

    if (data.status === this.successStatus) {
      this.disableLoading();

      if (root !== null) {
        var cart = document.querySelector(this.cartSelector);
        var emptyCart = cart.querySelector('.' + this.cartEmptyClass);
        var fullCart = cart.querySelector('.' + this.cartNotEmptyClass);

        if (fullCart && fullCart.classList.contains(_state.default.HIDDEN)) {
          fullCart.classList.remove(_state.default.HIDDEN);
          emptyCart.classList.add(_state.default.HIDDEN);
        }

        var cartCounter = cart.querySelector('.' + this.cartCounterClass);

        if (cartCounter !== null && data.numberOfEntries !== undefined) {
          var radix = 10;
          var intNumberOfEntries = parseInt(data.numberOfEntries, radix); // change style on ajax update > 999

          if (data.numberOfEntries === '999+') {
            cartCounter.classList.add('atom-cart-counter-count--fourdigits');
          } else if (intNumberOfEntries > 99) {
            cartCounter.classList.add('atom-cart-counter-count--threedigits');
          }

          cartCounter.innerText = data.numberOfEntries;
          cart.classList.add(_state.default.LOADED);
          var timeout = 2000;
          setTimeout(function () {
            cart.classList.remove(_state.default.LOADED);
          }, timeout);
        }

        root.classList.add(_state.default.OPEN);

        if (this.sticky === true) {
          root.classList.add(_state.default.NO_TRANSITIONS);
        }
      }

      this.cleanUpSuccess();
    } else {
      this.showError(data);
    }
  },
  showError: function showError(data) {
    this.disableLoading();

    if (data !== undefined && typeof data.redirect === 'string') {
      _tools.default.redirect(data.redirect);
    } else {
      var error = document.querySelector(this.errorDialogSelector);

      if (error) {
        _simpleLightbox.default.open({
          element: error
        });

        this.addErrorListener();
      }
    }
  },
  setWaypoints: function setWaypoints() {
    var _this2 = this;

    var root = document.querySelector(this.rootSelector);

    if (root !== null) {
      this.Waypoint = window.Waypoint;

      if (this.Waypoint !== undefined) {
        var header = document.querySelector(this.headerSelector);

        if (header !== null) {
          var topPosition = 30;
          var topOffset = topPosition * 2;
          this.waypoints = new this.Waypoint({
            element: header,
            handler: function handler(direction) {
              if (direction === 'up') {
                _this2.disableStickyness();
              } else {
                _this2.enableStickyness();
              }
            },
            offset: -header.clientHeight + topOffset
          });
        }
      }
    }
  },
  enableStickyness: function enableStickyness() {
    this.sticky = true;
    var root = document.querySelector(this.rootSelector);

    if (root) {
      root.classList.add(_state.default.STICKY, _state.default.NO_TRANSITIONS);
    }
  },
  disableStickyness: function disableStickyness() {
    this.sticky = false;
    var root = document.querySelector(this.rootSelector);

    if (root) {
      root.classList.remove(_state.default.STICKY);
    }
  },
  addErrorListener: function addErrorListener() {
    var button = document.querySelector(this.errorButtonSelector);

    if (button) {
      button.addEventListener('click', function (e) {
        var _window$openSimpleLig;

        e.preventDefault();
        (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
      });
    }
  }
};
var _default = AtomCartNotification;
exports.default = _default;

},{"../simple-lightbox":231,"state":232,"tools":236}],173:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AtomCheckbox = {
  init: function init() {
    this.rootSelector = '.atom-checkbox';
    this.labelSelector = '.atom-checkbox-label';
  },
  interpolate: function interpolate(template, data) {
    var itemTemplate = $('<div>' + template.innerHTML + '</div>');
    var checkboxData = data.checkbox;
    var input = itemTemplate.find('input');
    var root = itemTemplate.find(this.rootSelector);
    root.attr('data-href', checkboxData.href);
    input.attr('id', checkboxData.id).attr('name', checkboxData.name).attr('value', checkboxData.value);

    if (checkboxData.checked) {
      input.attr('checked', 'checked');
    }

    if (checkboxData.disabled) {
      input.attr('checked', 'checked');
    }

    if (checkboxData.required) {
      input.attr('required', 'required');
    }

    itemTemplate.find('label[for]').attr('for', checkboxData.id);
    itemTemplate.find(this.labelSelector).html(checkboxData.label);
    return itemTemplate.html();
  },
  bindListener: function bindListener(element, callback) {
    var checkboxWithHref = element.querySelector('[data-href] input');

    if (checkboxWithHref) {
      checkboxWithHref.addEventListener('click', function () {
        callback();
      });
    }
  },
  reinitialize: function reinitialize() {
    this.init();
  },
  bindCustomListeners: function bindCustomListeners(element, selector, callback, scope) {
    var _this = this;

    [].forEach.call(element.querySelectorAll(selector), function (checkbox) {
      _this.bindListener(checkbox, callback.bind(scope, element, checkbox));
    });
  }
};
var _default = AtomCheckbox;
exports.default = _default;

},{}],174:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomDeliveryTime = {
  init: function init() {
    this.rootSelector = '.atom-delivery-time';
    this.availabilitySelector = '.atom-delivery-time__availability';
    this.dateSelector = '.atom-delivery-time__date';
    this.dateTextSelector = '.atom-delivery-time__date-text';
    this.rangePrefix = 'is-';
    this.minAvailabilityLength = 1;
    this.show();
  },
  show: function show() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (deliveryTime) {
      var availability = deliveryTime.querySelector(_this.availabilitySelector);

      if (!availability.classList.contains(_state.default.HIDDEN)) {
        var date = deliveryTime.querySelector(_this.dateSelector);

        if (date) {
          date.classList.remove(_state.default.HIDDEN);
        }
      }
    });
  },
  update: function update(element, data) {
    var availability = element.querySelector(this.availabilitySelector);

    if (data && data.availability && availability) {
      availability.classList.remove(_state.default.HIDDEN);
      availability.classList.remove(this.rangePrefix);
      availability.classList.add(this.rangePrefix + data.availability.range);
      availability.innerText = data.availability.text;
    } else {
      if (availability) {
        availability.classList.add(_state.default.HIDDEN);
      }
    }

    var dateText = element.querySelector(this.dateTextSelector);

    if (dateText) {
      var date = element.querySelector(this.dateSelector);

      if (data && data.date) {
        date.classList.remove(_state.default.HIDDEN);
        dateText.innerText = data.date.text;
      } else {
        if (date) {
          date.classList.add(_state.default.HIDDEN);
        }
      }
    }
  }
};
var _default = AtomDeliveryTime;
exports.default = _default;

},{"state":232}],175:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vanillaJsDropdown = _interopRequireDefault(require("vanilla-js-dropdown"));

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireWildcard(require("event-names"));

var _tools = _interopRequireDefault(require("tools"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomDropdown = {
  init: function init() {
    var _this = this;

    this.rootSelector = '.atom-dropdown';
    this.bodySelector = 'body';
    this.checkboxClass = 'checkbox';
    this.checkboxSelector = this.rootSelector + '.' + this.checkboxClass;
    this.selectSelector = this.rootSelector + ' select';
    this.listItemSelector = '.atom-dropdown-select option';
    this.labelSelector = '.atom-dropdown-label';
    this.dropdownSelector = '.js-Dropdown';
    this.dropdownListSelector = '.js-Dropdown-list';
    this.dropdownListItemSelector = this.dropdownListSelector + ' li';
    this.dropdownTitleSelector = '.js-Dropdown-title';
    this.submitSelector = '.atom-dropdown-submit';
    this.submitButtonSelector = this.submitSelector + ' .atom-button';
    this.formSelector = this.checkboxSelector + ' form';
    this.backTitleClass = 'atom-dropdown-back-title';
    this.backTitleSelector = '.' + this.backTitleClass;
    this.colorClass = 'is-color';
    this.htmlLinkClass = 'has-htmllink';
    this.whiteRgb = '255,255,255';
    this.singleItemLength = 1;
    this.autoWithMutation = 'js-atom-dropdown--auto-width';
    this.noButtonClass = 'atom-dropdown--no-button';
    window.atomDropdownListener = this.handleOutsideClick.bind(this);
    [].forEach.call(document.querySelectorAll(this.selectSelector), function (select) {
      _this.initSelect(select);
    });
    [].forEach.call(document.querySelectorAll(this.checkboxSelector), function (element) {
      _this.initCheckbox(element);
    });
    this.bindUpdater();
  },
  addLabelListener: function addLabelListener(root) {
    var _this2 = this;

    var label = root.querySelector(this.labelSelector);

    if (label) {
      if (root.querySelector(this.dropdownListSelector)) {
        label.addEventListener('click', function (e) {
          _this2.openModal(e.currentTarget, root);
        });
      }
    }
  },
  initCheckbox: function initCheckbox(element) {
    var _this3 = this;

    this.addCheckboxes(element);
    this.addCloseButton(element);
    this.checkIfSelected(element);
    this.changeBackLink(element);
    this.addLabelListener(element);
    [].forEach.call(element.querySelectorAll(this.dropdownListItemSelector), function (item) {
      item.addEventListener('click', function (e) {
        var currentItem = e.currentTarget;
        e.preventDefault();
        e.stopImmediatePropagation();

        _this3.toggleItem(currentItem, element);
      });
    });
    var submitButton = element.querySelector(this.submitButtonSelector);

    if (submitButton) {
      submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        _this3.sendCloseEvent(e);

        _this3.sendSortFilterCloseEvent(e);
      });
    }
  },
  sendCloseEvent: function sendCloseEvent(e) {
    var filter = e.currentTarget.closest('.cmscomponent-filter');

    if (filter) {
      _tools.default.sendEvent(_eventNames.default.CMSCOMPONENT_FILTER_CLOSE, {
        message: filter
      });
    }
  },
  sendSortFilterCloseEvent: function sendSortFilterCloseEvent(e) {
    var sortFilter = e.currentTarget.closest('.cmscomponent-sort-filter');

    if (sortFilter) {
      _tools.default.sendEvent(_eventNames.default.CMSCOMPONENT_SORT_FILTER_CLOSE, {
        message: sortFilter
      });
    }
  },
  initSelect: function initSelect(select) {
    var _this4 = this;

    if (select.children.length > 0) {
      var customSelectObj = new _vanillaJsDropdown.default({
        elem: select
      }); // observe changes in ul to adapt them to button to rotate arrow-icon

      var button = this.getButton(select);
      var ariaLabel = select.getAttribute('aria-label') || '';
      button.setAttribute('aria-label', ariaLabel); // Add aria-label to the button

      var root = select.closest(this.rootSelector);
      var watchNode = root.querySelector('.js-Dropdown-list');
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      }; // Add focusout event listener to close dropdown on leave

      watchNode.addEventListener('focusout', function (e) {
        if (!watchNode.contains(e.relatedTarget)) {
          customSelectObj.close();
          updateTabIndexAndAriaLabel(watchNode, false); // Set tabindex to -1 when closed
        }
      });

      var updateTabIndexAndAriaLabel = function updateTabIndexAndAriaLabel(watchNode, isOpen) {
        // Set tabindex of ul to -1 to skip it
        watchNode.setAttribute('tabindex', -1);
        var listItems = watchNode.querySelectorAll('li');
        listItems.forEach(function (item) {
          item.setAttribute('tabindex', isOpen ? 0 : -1);
          item.setAttribute('aria-label', item.textContent.trim()); // Add keydown event listener for Enter key

          item.addEventListener('keydown', function (e) {
            console.log('Keydown event triggered:', e.key); // Debugging line

            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopImmediatePropagation(); // Simulate click on Enter key press

              item.click();
            }
          });
        });
      }; // Initially set tabindex to -1 since dropdown is closed


      updateTabIndexAndAriaLabel(watchNode, false);
      this.addHtmlLinks(root);

      if (this.isCheckbox(root) === false) {
        this.updateWidth(select, root);

        if (this.isAutoWidth(root)) {
          this.addLabelListener(root);
          root.classList.add(this.noButtonClass);
        }

        button.addEventListener('click', function (e) {
          var isOpen = e.target.classList.contains(_state.default.OPEN);

          if (isOpen) {
            window.setTimeout(function () {
              customSelectObj.close();
              updateTabIndexAndAriaLabel(watchNode, false);
            }, 10);
          } else {
            _this4.closeOpenModals();

            updateTabIndexAndAriaLabel(watchNode, true);
          }
        });

        var callback = function callback(event) {
          if (watchNode.closest('[data-dropdown-event="1"]')) {
            for (var i = 0; i < event.length; i++) {
              var mutationRecord = event[i];

              if (mutationRecord.target !== undefined && mutationRecord.target.tagName === 'LI' && mutationRecord.target.classList.contains(_state.default.SELECTED)) {
                _tools.default.sendEvent(_eventNames.default.ATOM_DROPDOWN_CHANGED, {
                  message: mutationRecord
                });
              }
            }
          }

          if (watchNode.classList.contains(_state.default.OPEN)) {
            button.classList.add(_state.default.OPEN);
          } else {
            button.classList.remove(_state.default.OPEN);
          }
        };

        var observer = new MutationObserver(callback);
        observer.observe(watchNode, config);

        if (this.isDisabled(select)) {
          button.classList.add(_state.default.DISABLED);
        }
      } else {
        setTimeout(function () {
          _this4.addSelections(root);
        }, 200);
      }

      var globalObserver = new MutationObserver(function (event) {
        var lastMutation;

        for (var i = 0; i < event.length; i++) {
          var mutationRecord = event[i];

          if (mutationRecord.target !== undefined && mutationRecord.target.tagName === 'LI') {
            lastMutation = mutationRecord;
          }
        }

        if (lastMutation) {
          _this4.sendGlobalEvent(select, _this4.getSelectOptionByEvent(lastMutation, select), select.dataset.ajax);
        }
      }); // redirect to href if it has been set

      [].forEach.call(watchNode.querySelectorAll('li'), function (li) {
        li.addEventListener('click', function (e) {
          var option = _this4.getSelectOptionByEvent(e, select);

          if (option !== null && typeof option.dataset.href !== 'undefined') {
            if (!select.dataset.ajax) {
              _this4.loadingIndicator(root);

              window.location.href = option.dataset.href;
            }
          }
        });
      });

      if (this.isColor(root) === true) {
        setTimeout(function () {
          _this4.addColors(root);
        }, 200);
      } // delay observer to prevent getting into update loop


      setTimeout(function () {
        globalObserver.observe(watchNode, config);
      }, 200);
    }
  },
  getSelectLength: function getSelectLength(select) {
    return select.querySelectorAll('option').length;
  },
  isDisabled: function isDisabled(select) {
    return this.getSelectLength(select) === this.singleItemLength;
  },
  getSelectOptionByEvent: function getSelectOptionByEvent(e, select) {
    var target = e.target;

    if (e.target.nodeName !== 'LI') {
      target = e.target.closest('li');
    }

    return select.querySelector('option[value="' + target.dataset.value + '"]');
  },
  sendGlobalEvent: function sendGlobalEvent(element, option, ajax) {
    var eventName = (0, _eventNames.getEventName)(element, _eventNames.default.ATOM_DROPDOWN_ALL_CHANGED);

    _tools.default.sendEvent(eventName, {
      message: element,
      option: option,
      ajax: ajax
    });
  },
  isColor: function isColor(root) {
    return root !== null && root.classList.contains(this.colorClass);
  },
  addSelections: function addSelections(root) {
    var _this5 = this;

    [].forEach.call(root.querySelectorAll(this.listItemSelector), function (item) {
      var selectedName = 'selected';
      var itemValue = item.getAttribute('value');
      var customItem = root.querySelector(_this5.dropdownListItemSelector + '[data-value="' + itemValue + '"]');
      var itemSelection = item.getAttribute(selectedName);

      if (customItem !== null && itemSelection !== null) {
        customItem.setAttribute(selectedName, true);
        customItem.classList.add(_state.default.SELECTED);
      }
    });
  },
  addColors: function addColors(root) {
    var _this6 = this;

    [].forEach.call(root.querySelectorAll(this.listItemSelector), function (item) {
      var itemValue = item.getAttribute('value');
      var customItem = root.querySelector(_this6.dropdownListItemSelector + '[data-value="' + itemValue + '"] label');
      var itemBackground = item.dataset.background;
      var foregroundClass = item.dataset.foreground === _this6.whiteRgb ? null : 'is-black';

      if (customItem !== null) {
        if (itemBackground !== undefined) {
          customItem.setAttribute('style', 'background:rgb(' + itemBackground + ')');
        }

        if (foregroundClass !== null) {
          customItem.classList.add(foregroundClass);
        }
      }
    });
  },
  toggleItem: function toggleItem(item, element) {
    var input = item.querySelector('input[type="checkbox"]');

    if (item.classList.contains(_state.default.SELECTED)) {
      item.classList.remove(_state.default.SELECTED);
      input.removeAttribute('checked');
    } else {
      item.classList.add(_state.default.SELECTED);
      input.setAttribute('checked', true);
    }

    this.checkIfSelected(element);
    this.autoSubmit(element);
  },
  bindUpdater: function bindUpdater() {
    var _this7 = this;

    $(document).on('afterShow.fb', function (e, instance) {
      _this7.update(instance);
    });
  },
  updateWidth: function updateWidth(select, root) {
    if (!this.isAutoWidth(root) && !this.isDisabled(select)) {
      var button = this.getButton(select);
      var $button = $(button);
      var selectWidth = $(select).width();

      if (selectWidth > $button.width()) {
        var base = 10;
        var leftWidth = parseInt($button.css('padding-left'), base);
        var rightWidth = parseInt($button.css('padding-right'), base);
        $button.css('width', leftWidth + selectWidth + rightWidth);
      }
    }
  },
  isAutoWidth: function isAutoWidth(root) {
    return _tools.default.hasMutation(root, this.autoWithMutation);
  },
  autoSubmit: function autoSubmit(element) {
    var form = element.querySelector(this.formSelector);

    if (form.dataset.autosubmit) {
      this.loadingIndicator(element);
      form.submit();
    }
  },
  loadingIndicator: function loadingIndicator(element) {
    element.classList.add(_state.default.LOADING);
  },
  getButton: function getButton(select) {
    return select.closest(this.rootSelector).querySelector(this.dropdownTitleSelector);
  },
  update: function update(scope) {
    var _this8 = this;

    var content = scope.current !== undefined && scope.current.$content !== undefined ? scope.current.$content : null;

    if (content !== null) {
      [].forEach.call(content[0].querySelectorAll(this.selectSelector), function (select) {
        _this8.updateWidth(select);
      });
    }
  },
  isCheckbox: function isCheckbox(element) {
    return element.classList.contains(this.checkboxClass);
  },
  openModal: function openModal(label, element) {
    var _this9 = this;

    var dropdownList = element.querySelector(this.dropdownListSelector);

    if (dropdownList.classList.contains(_state.default.VISIBLE)) {
      label.classList.remove(_state.default.OPEN);
      dropdownList.classList.remove(_state.default.VISIBLE, _state.default.LOADING);
      var dropdown = dropdownList.closest(this.dropdownSelector);
      dropdown.classList.remove(_state.default.RIGHT);
      this.removeModalListener();
    } else {
      this.removeModalListener();
      this.closeOpenModals();
      this.setBackTitle(element, label);
      label.classList.add(_state.default.OPEN);
      dropdownList.classList.add(_state.default.LOADING);
      dropdownList.classList.add(_state.default.VISIBLE);

      if (_tools.default.inHorizontalViewport(dropdownList) === false) {
        var _dropdown = dropdownList.closest(this.dropdownSelector);

        _dropdown.classList.add(_state.default.RIGHT);
      }

      dropdownList.classList.remove(_state.default.LOADING);
      setTimeout(function () {
        _this9.addModalListener();
      }, 100);
    }
  },
  closeOpenModals: function closeOpenModals() {
    var openDropdowns = document.querySelectorAll(this.rootSelector + ' .' + _state.default.RIGHT);
    openDropdowns.forEach(function (element) {
      element.classList.remove(_state.default.RIGHT);
    });
    var openLabels = document.querySelectorAll(this.rootSelector + ' ' + this.labelSelector);
    openLabels.forEach(function (element) {
      element.classList.remove(_state.default.OPEN);
    });
    var openDropdownLists = document.querySelectorAll(this.rootSelector + ' ' + this.dropdownListSelector);
    openDropdownLists.forEach(function (element) {
      element.classList.remove(_state.default.VISIBLE);
      element.classList.remove(_state.default.OPEN);
      var listItems = element.querySelectorAll('li');
      listItems.forEach(function (item) {
        item.setAttribute('tabindex', -1);
      });
    });
  },
  addModalListener: function addModalListener() {
    document.querySelector(this.bodySelector).addEventListener('click', window.atomDropdownListener);
  },
  handleOutsideClick: function handleOutsideClick(e) {
    if (e.currentTarget.classList.contains(this.checkboxSelector) === false && e.currentTarget.classList.contains(this.labelSelector) === false && e.currentTarget.classList.contains(this.rootSelector) === false) {
      e.stopImmediatePropagation();
      this.closeOpenModals();
      this.removeModalListener();
    }
  },
  removeModalListener: function removeModalListener() {
    document.querySelector(this.bodySelector).removeEventListener('click', window.atomDropdownListener);
  },
  addCheckboxes: function addCheckboxes(element) {
    var checkboxTemplate = '<div class="atom-checkbox small"><input type="checkbox" value="#VALUE#" name="#NAME#" id="#ID#"/><label for="#ID#"></label></div>';
    var list = element.querySelectorAll(this.dropdownListItemSelector);
    var select = element.querySelector(this.selectSelector);

    if (list.length > 0) {
      [].forEach.call(list, function (item) {
        var name = select.getAttribute('name');
        var value = item.dataset.value;
        var id = select.getAttribute('id') + '_' + value;
        var checkboxHtml = checkboxTemplate.replace('#NAME#', name);
        checkboxHtml = checkboxHtml.replace('#VALUE#', value);
        checkboxHtml = checkboxHtml.replace(/#ID#/g, id);
        item.innerHTML = checkboxHtml + item.innerHTML;
      });
    }
  },
  addCloseButton: function addCloseButton(element) {
    var select = element.querySelector(this.selectSelector);

    if (select.dataset.ajax) {
      var dropdown = element.querySelector(this.dropdownSelector);
      var submit = element.querySelector(this.submitSelector);

      if (dropdown && submit) {
        dropdown.appendChild(submit);
      }
    }
  },
  checkIfSelected: function checkIfSelected(element) {
    var selectedList = element.querySelectorAll(this.dropdownListItemSelector + '.' + _state.default.SELECTED);
    var submit = element.querySelector(this.submitButtonSelector);

    if (submit) {
      if (selectedList.length > 0) {
        submit.removeAttribute('disabled');
      } else {
        submit.setAttribute('disabled', true);
      }
    }
  },
  changeBackLink: function changeBackLink(element) {
    var form = element.querySelector(this.formSelector);
    var backText = form.dataset.back;
    var dropdownTitle = element.querySelector(this.dropdownTitleSelector);

    if (dropdownTitle) {
      dropdownTitle.innerHTML = '<span class="atom-dropdown-back-text">' + backText + '</span><span class="' + this.backTitleClass + '"></span>';
    }
  },
  setBackTitle: function setBackTitle(element, label) {
    var backTitle = element.querySelector(this.backTitleSelector);

    if (backTitle !== null) {
      var text = label.innerText.toLowerCase();
      text = text.charAt(0).toUpperCase() + text.slice(1);
      backTitle.innerText = text;
    }
  },
  addHtmlLinks: function addHtmlLinks(root) {
    var _this10 = this;

    [].forEach.call(root.querySelectorAll('select option[data-html]'), function (htmlLink) {
      _this10.enhanceLinkEntry(root, htmlLink);
    });
  },
  enhanceLinkEntry: function enhanceLinkEntry(root, htmlLink) {
    var linkValue = htmlLink.getAttribute('value');
    var entry = root.querySelector(this.dropdownListItemSelector + '[data-value="' + linkValue + '"]');

    if (entry) {
      entry.classList.add(this.htmlLinkClass);
      entry.innerHTML = htmlLink.dataset.html;
    }
  },
  reinitialize: function reinitialize(root) {
    var _this11 = this;

    [].forEach.call(root.querySelectorAll(this.selectSelector), function (select) {
      _this11.initSelect(select);
    });
    [].forEach.call(root.querySelectorAll(this.checkboxSelector), function (checkbox) {
      _this11.initCheckbox(checkbox);
    });
  }
};
var _default = AtomDropdown;
exports.default = _default;

},{"event-names":224,"state":232,"tools":236,"vanilla-js-dropdown":156}],176:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomEditFlyout = {
  init: function init() {
    this.editFlyout = '.atom-edit-flyout';
    this.editFlyoutLabel = '.atom-edit-flyout__label';
    this.editFlyoutFlyout = '.atom-edit-flyout__flyout';
    this.editFlyoutIconOnly = '.atom-edit-flyout--icon-only';
    this.editFlyoutClass = _tools.default.getClassFromSelector(this.editFlyout);
    this.editFlyoutIconOnlyClass = _tools.default.getClassFromSelector(this.editFlyoutIconOnly);
    this.reinitialize();
  },
  initFlyout: function initFlyout(flyout) {
    flyout.addEventListener('click', this.handleClick.bind(this));
    flyout.querySelector(this.editFlyoutFlyout).addEventListener('click', function (e) {
      return e.stopPropagation();
    });
  },
  initIconOnlyFlyout: function initIconOnlyFlyout(flyout) {
    var label = flyout.querySelector(this.editFlyoutLabel);

    if (label) {
      label.addEventListener('click', this.handleClick.bind(this));
      flyout.addEventListener('mouseenter', this.showLabel.bind(this));
      flyout.addEventListener('mouseleave', this.handleMouseLeave.bind(this, flyout));
    }
  },
  handleMouseLeave: function handleMouseLeave(flyout, event) {
    if (!flyout.classList.contains(_state.default.OPEN)) {
      this.hideLabel(event);
    }
  },
  handleClick: function handleClick(e) {
    var _this = this;

    e.stopImmediatePropagation();
    var flyout = e.currentTarget.classList.contains(this.editFlyoutClass) ? e.currentTarget : e.currentTarget.closest(this.editFlyout);
    var label = flyout.querySelector(this.editFlyoutLabel);

    var clickWatcherEditToggle = function clickWatcherEditToggle(event) {
      if (!window.clickInside(event, _this.editFlyoutFlyout)) {
        if (label && flyout.classList.contains(_this.editFlyoutIconOnlyClass)) {
          label.classList.remove(_state.default.VISIBLE);
        }

        flyout.classList.remove(_state.default.OPEN);
        document.removeEventListener('click', clickWatcherEditToggle);
      }
    };

    flyout.classList.toggle(_state.default.OPEN);

    if (flyout.classList.contains(_state.default.OPEN)) {
      setTimeout(function () {
        document.addEventListener('click', clickWatcherEditToggle);
      }, 100);
    }
  },
  showLabel: function showLabel(e) {
    var label = e.currentTarget.querySelector(this.editFlyoutLabel);

    if (label) {
      label.classList.add(_state.default.VISIBLE);
    }
  },
  hideLabel: function hideLabel(e) {
    var label = e.currentTarget.querySelector(this.editFlyoutLabel);

    if (label) {
      label.classList.remove(_state.default.VISIBLE);
    }
  },
  reinitialize: function reinitialize(root) {
    var _this2 = this;

    var rootElement = root !== null && root !== void 0 ? root : document;
    [].forEach.call(rootElement.querySelectorAll(this.editFlyout), function (flyout) {
      _this2.initFlyout(flyout);
    });
    [].forEach.call(rootElement.querySelectorAll(this.editFlyoutIconOnly), function (flyout) {
      _this2.initIconOnlyFlyout(flyout);
    });
  }
};
var _default = AtomEditFlyout;
exports.default = _default;

},{"state":232,"tools":236}],177:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flatpickr = _interopRequireDefault(require("flatpickr"));

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireWildcard(require("event-names"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InputDatePicker = /*#__PURE__*/function () {
  function InputDatePicker() {
    _classCallCheck(this, InputDatePicker);

    this.rootSelector = '.atom-input-datepicker';
    this.inputSelector = '.atom-input-datepicker__input';
    this.drilldownSelector = '.atom-input-datepicker__drilldown';
    this.tagSelector = '.atom-tag';
    this.modes = {
      range: 'range'
    };
    this.rangeSeperator = ':';
    this.rangeModeLength = 2;
    this.defaultModeLength = 1;
    this.instances = [];
    this.setupDatePicker();
    this.bindListeners();
  }

  _createClass(InputDatePicker, [{
    key: "bindListeners",
    value: function bindListeners(element, instance) {
      var _this = this;

      if (element) {
        element.addEventListener('click', this.handleOpenEvent.bind(this, instance, element));
        element.querySelector(this.drilldownSelector).addEventListener('transitionend', this.handleTransitionEnd.bind(this, instance, element));
        var tag = element.querySelector(this.tagSelector);

        if (tag) {
          tag.addEventListener('click', this.handleTagClick.bind(this, element));
        }
      } else {
        window.addEventListener('resize', function () {
          _this.close();
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      [].forEach.call(this.instances, function (instance) {
        var _this2$getCalendar;

        instance.close();
        (_this2$getCalendar = _this2.getCalendar(instance)) === null || _this2$getCalendar === void 0 ? void 0 : _this2$getCalendar.classList.remove(_state.default.EXPANDED);
        instance.popupOpen = false;
      });
    }
  }, {
    key: "reinitialize",
    value: function reinitialize(parent) {
      var _this3 = this;

      if (parent) {
        [].forEach.call(this.instances, function (instance) {
          instance.destroy();
        });
        [].forEach.call(parent.querySelectorAll(this.rootSelector), function (element) {
          _this3.initDatePicker(element);
        });
      }
    }
  }, {
    key: "handleChangeEvent",
    value: function handleChangeEvent(mode, element, selectedDates, dateStr) {
      if (mode === this.modes.range && selectedDates.length === this.rangeModeLength || mode !== this.modes.range && selectedDates.length === this.defaultModeLength) {
        _tools.default.sendEvent((0, _eventNames.getEventName)(element, _eventNames.default.ATOM_INPUT_DATEPICKER_CHANGED), {
          dateStr: this.getFormattedDateStr(dateStr),
          root: element
        });
      }
    }
  }, {
    key: "isInNavigation",
    value: function isInNavigation(element) {
      return this.isLowerBreakpoint() && element.closest(".".concat(_state.default.OPEN));
    }
  }, {
    key: "isLowerBreakpoint",
    value: function isLowerBreakpoint() {
      return _tools.default.screen('md');
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd(instance, element) {
      if (instance.popupOpen && this.isInNavigation(element)) {
        var _this$getCalendar;

        (_this$getCalendar = this.getCalendar(instance)) === null || _this$getCalendar === void 0 ? void 0 : _this$getCalendar.classList.add(_state.default.EXPANDED);
        instance.open();
      }
    }
  }, {
    key: "getCalendar",
    value: function getCalendar(instance) {
      return instance.calendarContainer;
    }
  }, {
    key: "handleOpenEvent",
    value: function handleOpenEvent(instance, element, e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (instance && instance.open) {
        if (instance.popupOpen) {
          if (this.isInNavigation(element)) {
            var drilldown = this.getDrilldownByElement(element);

            if (drilldown) {
              drilldown.classList.remove(_state.default.OPEN);
            }

            instance.close();
          } else {
            var _this$getCalendar2;

            instance.close();
            (_this$getCalendar2 = this.getCalendar(instance)) === null || _this$getCalendar2 === void 0 ? void 0 : _this$getCalendar2.classList.remove(_state.default.EXPANDED);
          }

          instance.popupOpen = false;
        } else {
          if (this.isInNavigation(element)) {
            var _drilldown = this.getDrilldownByElement(element);

            if (_drilldown) {
              _drilldown.classList.add(_state.default.OPEN);
            }
          } else {
            instance.open();
          }

          instance.popupOpen = true;
        }
      }
    }
  }, {
    key: "getDrilldownByElement",
    value: function getDrilldownByElement(element) {
      if (element && element.querySelector) {
        return element.querySelector(this.drilldownSelector);
      }

      return null;
    }
  }, {
    key: "getFormattedDateStr",
    value: function getFormattedDateStr(dateStr) {
      var dateSplit = dateStr.split(' ');
      return "".concat(dateSplit[0]).concat(this.rangeSeperator).concat(dateSplit[2]);
    }
  }, {
    key: "getLocaleData",
    value: function getLocaleData() {
      return window.inputDatepickerLocale ? window.inputDatepickerLocale : {};
    }
  }, {
    key: "setupDatePicker",
    value: function setupDatePicker() {
      var _this4 = this;

      [].forEach.call(document.querySelectorAll(this.rootSelector), function (element) {
        if (!element.dataset.initialized) {
          _this4.initDatePicker(element);
        }
      });
    }
  }, {
    key: "handleTagClick",
    value: function handleTagClick(element, e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var current = e.currentTarget;
      var action = current.getAttribute('href');

      if (current && action) {
        _tools.default.sendEvent((0, _eventNames.getEventName)(element, _eventNames.default.ATOM_INPUT_DATEPICKER_RESET), {
          action: action,
          root: element
        });
      }
    }
  }, {
    key: "initDatePicker",
    value: function initDatePicker(element) {
      var mode = element.getAttribute('data-mode');
      var localeData = this.getLocaleData();
      var minDate = element.dataset.minDate;
      var maxDate = element.dataset.maxDate;
      element.dataset.initialized = true;
      localeData.firstDayOfWeek = 1;
      var flatpickrConfig = {
        clickOpens: false,
        dateFormat: 'Y-m-d',
        locale: localeData,
        disableMobile: true,
        maxDate: maxDate,
        minDate: minDate,
        prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19px" height="9px" style="transform:rotate(-90deg)"><path fill="#000000" d="M-0.010,7.977 L9.499,-0.004 L19.009,7.977 L16.963,9.014 L9.499,2.653 L2.036,9.014 L-0.010,7.977 Z" /></svg>',
        nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19px" height="9px" style="transform:rotate(90deg)"><path fill="#000000" d="M-0.010,7.977 L9.499,-0.004 L19.009,7.977 L16.963,9.014 L9.499,2.653 L2.036,9.014 L-0.010,7.977 Z" /></svg>',
        disable: [function (date) {
          return date.getDay() === 0;
        }],
        onChange: this.handleChangeEvent.bind(this, mode, element)
      };

      if (mode === this.modes.range) {
        delete flatpickrConfig.disable;
        flatpickrConfig.mode = this.modes.range;
      }

      var instance = (0, _flatpickr.default)(element.querySelector('input'), flatpickrConfig);
      this.instances.push(instance);
      this.bindListeners(element, instance);
    }
  }]);

  return InputDatePicker;
}();

var _default = InputDatePicker;
exports.default = _default;

},{"event-names":224,"flatpickr":10,"state":232,"tools":236}],178:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AtomTile = /*#__PURE__*/function () {
  function AtomTile(root) {
    _classCallCheck(this, AtomTile);

    this.root = root;

    if (this.isClickable()) {
      this.bindEvents();
    }
  }

  _createClass(AtomTile, [{
    key: "isClickable",
    value: function isClickable() {
      return this.root.getAttribute('href') ? true : false;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      this.root.addEventListener('click', this.handleClick.bind(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      _tools.default.redirect(this.root.getAttribute('href'));
    }
  }], [{
    key: "initAll",
    value: function initAll() {
      AtomTile.instances = [];
      AtomTile.initInElement(document);
    }
  }, {
    key: "initInElement",
    value: function initInElement(element) {
      [].forEach.call(element.querySelectorAll(AtomTile.rootSelector), function (tileElement) {
        AtomTile.init(tileElement);
      });
    }
  }, {
    key: "init",
    value: function init(element) {
      var rootElement = element.classList.contains(AtomTile.rootClass) ? element : element.querySelector(AtomTile.rootSelector);

      if (rootElement) {
        AtomTile.instances.push(new AtomTile(rootElement));
      } else {
        console.warn("No ".concat(AtomTile.rootClass, " found in"), element);
      }
    }
  }]);

  return AtomTile;
}();

_defineProperty(AtomTile, "rootClass", 'atom-tile-generic');

_defineProperty(AtomTile, "rootSelector", ".".concat(AtomTile.rootClass));

_defineProperty(AtomTile, "instances", []);

var _default = AtomTile;
exports.default = _default;

},{"tools":236}],179:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _simpleLightbox = _interopRequireDefault(require("../simple-lightbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomToggleState = {
  init: function init() {
    var _this = this;

    this.rootSelector = '.atom-toggle-state';
    this.wishlistSelector = 'header .atom-wishlist-notification';
    this.errorDialogSelector = '.cmscomponent-stageproduct-textcontent .cmscomponent-stageproduct-dialog';
    this.errorButtonSelector = '.slbContent .cmscomponent-dialog-error .atom-button';
    this.contentSelector = 'header .atom-wishlist-notification-content';
    this.iconSelectedSelector = '.atom-wishlist-notification-select';
    this.iconUnselectedSelector = '.atom-wishlist-notification-unselect';
    this.selectedSelector = '.atom-toggle-state__selected';
    this.counterClass = 'atom-wishlist-notification-count';
    this.headerSelector = 'header';
    this.sticky = false;
    this.toggleAttribute = 'data-toggle-state-url';
    this.successStatus = true;
    this.toggleHeader = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest'
    };
    this.modelHeader = {
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest'
    };
    this.bindListeners();
    this.setWaypoints();

    window.wishlistShowAddAnimation = function (data) {
      _this.showAddAnimation(data);
    };

    window.wishlistShowRemoveAnimation = function (data) {
      _this.showRemoveAnimation(data);
    };
  },
  bindListeners: function bindListeners() {
    var _this2 = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (toggle) {
      if (!_this2.isInProduct(toggle)) {
        _this2.bindListenersForElement(toggle);
      }
    });
  },
  bindListenersForElement: function bindListenersForElement(element) {
    if (this.hasUrl(element)) {
      this.requestModel(element);
    } else {
      this.addClickListener(element);
    }
  },
  bindListenersForParent: function bindListenersForParent(parent) {
    var element = parent.querySelector(this.rootSelector);

    if (element) {
      this.bindListenersForElement(element);
    }
  },
  addClickListener: function addClickListener(element) {
    var _this3 = this;

    element.addEventListener('click', function () {
      var selected = _this3.toggleState(element);

      var action = _this3.getAction(element, selected);

      var splittedAction = action === null || action === void 0 ? void 0 : action.split('/');
      var productCode = splittedAction[(splittedAction === null || splittedAction === void 0 ? void 0 : splittedAction.length) - 1];
      var storeAction = selected ? 'add' : 'remove';

      try {
        window.vueStores.wishlist[storeAction](productCode);
      } catch (e) {
        console.info("Can't reach Vue Store: wishlistStore");
        console.error(e);

        _this3.showError();

        _this3.toggleState(element);
      }
    });
  },
  requestModels: function requestModels(root, externalUrl) {
    var _this4 = this;

    var url = externalUrl || root.dataset.toggleStateUrl;

    if (url !== null && url !== undefined) {
      return _tools.default.service(url, 'GET', undefined, this.modelHeader, undefined, true).then(function (response) {
        response.json().then(function (json) {
          _this4.handleModels(root, json);
        }).catch(function (error) {
          console.debug(error);

          if (response.status !== _tools.default.validStatusCode) {
            _this4.showError();
          } else {
            // this is propabily a 302. ie11 can't really check this so i'll redirect to the request.url which is action
            document.location.href = url;
          }
        }).catch(function (error) {
          console.debug(error);

          _this4.showError();
        });
      });
    } else {
      return Promise.resolve();
    }
  },
  requestModel: function requestModel(element) {
    var _this5 = this;

    var action = element.dataset.toggleStateUrl;

    if (action !== null && action !== undefined) {
      _tools.default.service(action, 'GET', undefined, this.modelHeader, undefined, true).then(function (response) {
        response.json().then(function (json) {
          _this5.handleModel(json, element);
        }).catch(function (error) {
          console.debug(error);

          if (response.status !== _tools.default.validStatusCode) {
            _this5.showError();
          } else {
            // this is propabily a 302. ie11 can't really check this so i'll redirect to the request.url which is action
            document.location.href = action;
          }
        });
      }).catch(function (error) {
        console.debug(error);

        _this5.showError();
      });
    }
  },
  handleModels: function handleModels(root, data) {
    for (var i = 0; i < data.length; i++) {
      var itemData = data[i];
      var productCode = itemData.productCode;
      var item = root.querySelector('[data-product-code="' + productCode + '"]');

      if (item) {
        var toggleState = item.querySelector(this.rootSelector);

        if (toggleState) {
          this.handleModel(itemData, toggleState);
        }
      }
    }

    root.removeAttribute(this.toggleAttribute);
  },
  handleModel: function handleModel(data, element) {
    if (data.selected) {
      element.classList.add(_state.default.SELECTED);
    } else {
      element.classList.remove(_state.default.SELECTED);
    }

    element.dataset.select = data.selectAction;
    element.dataset.unselect = data.unselectAction;
    element.removeAttribute(this.toggleAttribute);
    this.addClickListener(element);
  },
  hasUrl: function hasUrl(element) {
    return element && element.dataset.toggleStateUrl || element.closest('[' + this.toggleAttribute + ']');
  },
  toggleState: function toggleState(element) {
    var selected = true;

    if (element.classList.contains(_state.default.SELECTED)) {
      element.classList.remove(_state.default.SELECTED);
      selected = false;
      this.fallingHeart(element);
    } else {
      element.classList.add(_state.default.SELECTED);
    }

    return selected;
  },
  fallingHeart: function fallingHeart(element) {
    var selected = element.querySelector(this.selectedSelector);

    if (selected !== null) {
      var fallingHeart = selected.cloneNode(true);
      fallingHeart.classList.add(_state.default.LOADING);
      element.appendChild(fallingHeart);
      var animationTime = 2000;
      setTimeout(function () {
        element.removeChild(fallingHeart);
      }, animationTime);
    }
  },
  getAction: function getAction(element, selected) {
    var selectedName = selected ? 'select' : 'unselect';
    return element !== null ? element.dataset[selectedName] : null;
  },
  cleanUpSuccess: function cleanUpSuccess() {
    var content = document.querySelector(this.contentSelector);
    var timeout = 4000;

    if (content !== null) {
      setTimeout(function () {
        content.classList.remove(_state.default.OPEN, _state.default.NO_TRANSITIONS);
      }, timeout);
    }
  },
  changeCounter: function changeCounter(count) {
    var wishlist = document.querySelector(this.wishlistSelector);

    if (wishlist) {
      var counter = wishlist.querySelector('.' + this.counterClass);

      if (counter !== null && count !== undefined) {
        if (count === '999+') {
          counter.setAttribute('style', 'font-size: 8px');
        }

        counter.innerText = count;
      }
    }
  },
  showAddAnimation: function showAddAnimation(data) {
    var content = document.querySelector(this.contentSelector);

    if (content !== null) {
      var wishlist = document.querySelector(this.wishlistSelector);
      var selectedIcon = wishlist.querySelector(this.iconSelectedSelector);
      var unselectedIcon = wishlist.querySelector(this.iconUnselectedSelector);

      if (selectedIcon !== null && selectedIcon.classList.contains(_state.default.HIDDEN)) {
        unselectedIcon.classList.add(_state.default.HIDDEN);
        selectedIcon.classList.remove(_state.default.HIDDEN);
      }

      this.changeCounter(data.numberOfEntries);

      if (selectedIcon !== null) {
        selectedIcon.classList.add(_state.default.LOADED);
        var timeout = 2000;
        setTimeout(function () {
          selectedIcon.classList.remove(_state.default.LOADED);
        }, timeout);
      }

      content.classList.add(_state.default.OPEN);

      if (this.sticky === true) {
        content.classList.add(_state.default.NO_TRANSITIONS);
      }
    }

    this.cleanUpSuccess();
  },
  showRemoveAnimation: function showRemoveAnimation(data) {
    this.changeCounter(data.numberOfEntries);

    if (data.numberOfEntries < 1) {
      var wishlist = document.querySelector(this.wishlistSelector);

      if (wishlist) {
        var selectedIcon = wishlist.querySelector(this.iconSelectedSelector);
        var unselectedIcon = wishlist.querySelector(this.iconUnselectedSelector);

        if (unselectedIcon !== null) {
          selectedIcon.classList.add(_state.default.HIDDEN);
          unselectedIcon.classList.remove(_state.default.HIDDEN);
        }
      }
    }
  },
  showSuccess: function showSuccess(data, selected) {
    if (data.status === this.successStatus) {
      if (selected === true) {
        this.showAddAnimation(data);
      } else {
        this.showRemoveAnimation(data);
      }
    } else {
      this.showError(data);
    }
  },
  showError: function showError(data) {
    if (data !== undefined && typeof data.redirect === 'string') {
      _tools.default.redirect(data.redirect);
    } else {
      var error = document.querySelector(this.errorDialogSelector);

      if (error) {
        _simpleLightbox.default.open({
          element: error
        });

        this.addErrorListener();
      }
    }
  },
  isInProduct: function isInProduct(root) {
    return root.closest('.cmscomponent-product');
  },
  setWaypoints: function setWaypoints() {
    var _this6 = this;

    var content = document.querySelector(this.contentSelector);

    if (content !== null) {
      this.Waypoint = window.Waypoint;

      if (this.Waypoint !== undefined) {
        var header = document.querySelector(this.headerSelector);

        if (header !== null) {
          var topPosition = 30;
          var topOffset = topPosition * 2;
          this.waypoints = new this.Waypoint({
            element: header,
            handler: function handler(direction) {
              if (direction === 'up') {
                _this6.disableStickyness();
              } else {
                _this6.enableStickyness();
              }
            },
            offset: -header.clientHeight + topOffset
          });
        }
      }
    }
  },
  enableStickyness: function enableStickyness() {
    this.sticky = true;
    var content = document.querySelector(this.contentSelector);
    content.classList.add(_state.default.STICKY, _state.default.NO_TRANSITIONS);
  },
  disableStickyness: function disableStickyness() {
    this.sticky = false;
    var content = document.querySelector(this.contentSelector);
    content.classList.remove(_state.default.STICKY);
  },
  addErrorListener: function addErrorListener() {
    var button = document.querySelector(this.errorButtonSelector);

    if (button) {
      button.addEventListener('click', function (e) {
        var _window$openSimpleLig;

        e.preventDefault();
        (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
      });
    }
  }
};
var _default = AtomToggleState;
exports.default = _default;

},{"../simple-lightbox":231,"state":232,"tools":236}],180:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tooltip = /*#__PURE__*/function () {
  function Tooltip(el) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.el = el;
    this.overlay = el.querySelector('.atom-tooltip__overlay');
    this.openTime = 3000;
    this.el.addEventListener('click', function () {
      return _this.handleClick();
    });
  }

  _createClass(Tooltip, [{
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      this.overlay.classList.add(_state.default.ACTIVE);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        return _this2.overlay.classList.remove(_state.default.ACTIVE);
      }, this.openTime);
    }
  }], [{
    key: "init",
    value: function init(parent) {
      [].forEach.call(parent.querySelectorAll('.atom-tooltip'), function (element) {
        (function () {
          return new Tooltip(element);
        })();
      });
    }
  }]);

  return Tooltip;
}();

var _default = Tooltip;
exports.default = _default;

},{"state":232}],181:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AttachmentIcons = {
  getFileTypeFromFileExtension: function getFileTypeFromFileExtension(ext) {
    var fileExtensionsToIcon = {
      jpg: 'img',
      jpeg: 'img',
      png: 'img',
      gif: 'img',
      bmp: 'img',
      tiff: 'img',
      tif: 'img',
      svg: 'img',
      mp4: 'video',
      avi: 'video',
      mpeg: 'video',
      webm: 'video',
      mov: 'video',
      pdf: 'doc',
      doc: 'doc',
      docx: 'doc',
      ppt: 'doc',
      pptx: 'doc',
      xls: 'tables',
      xlsx: 'tables',
      csv: 'tables',
      html: 'text',
      xml: 'text',
      txt: 'text',
      rtf: 'text',
      Rex: 'text',
      zip: 'zip',
      gz: 'zip',
      default: 'attachment'
    };

    for (var item in fileExtensionsToIcon) {
      if (item === ext) {
        return fileExtensionsToIcon[item];
      }
    }

    return fileExtensionsToIcon.default;
  },
  getIconFilePath: function getIconFilePath(iconPath, fileExtension) {
    return iconPath + 'icon-file-' + AttachmentIcons.getFileTypeFromFileExtension(fileExtension) + '.svg';
  }
};
var _default = AttachmentIcons;
exports.default = _default;

},{}],182:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var NeedAnalyserTileText = {
  data: {
    'two-first': {
      second: {
        dy: '-40',
        x: 96
      }
    },
    'two-second': {
      second: {
        dy: '-40',
        x: 90
      }
    }
  },
  getStyle: function getStyle(style) {
    return this.data[style];
  }
};
var _default = NeedAnalyserTileText;
exports.default = _default;

},{}],183:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _cmscomponentNeedanalyserTileText = _interopRequireDefault(require("cmscomponent-needanalyser-tile-text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var NeedAnalyser = {
  init: function init() {
    var _this = this;

    this.name = 'cmscomponent-needanalyser';
    this.root = document.getElementById(this.name);

    if (this.root !== null) {
      this.$root = $(this.getRootSelector());
      this.serviceUrl = this.root.dataset.serviceUrl;
      this.templateTile = this.getTemplate('tile');
      this.templateTileText = this.getTemplate('tile-text');
      this.currentStep = 0;
      this.currentTileIndex = -1;
      this.steps = [];
      this.startClass = 'is-start';
      this.treeKey = 'tree';
      this.selectionKey = 'selection';
      this.contentSelector = '.inner-content';
      this.tileSelector = '.cmscomponent-needanalyser-tile';
      this.tileContentSelector = '.cmscomponent-needanalyser-tile-content';
      this.tileRowSeleector = '.cmscomponent-needanalyser-tile-row';
      this.tileTemplateSelector = '#template-cmscomponent-needanalyser-tile';
      this.tileIconSelector = '.cmscomponent-needanalyser-tile-content .atom-icon';
      this.sublineSelector = '.cmscomponent-needanalyser-subline';
      this.infoLabelSelector = '.cmscomponent-needanalyser-info-label';
      this.infoSelector = '.cmscomponent-needanalyser-info';
      this.infoContainerSelector = '.cmscomponent-needanalyser-info-container';
      this.headlineSelector = '.cmscomponent-needanalyser-question-headline';
      this.questionHeadlineSelector = '.atom-headline ';
      this.rangeSelector = '.cmscomponent-needanalyser-range';
      this.rangeHeadlineSelector = '.cmscomponent-progressbar-title';
      this.rangeProgressSelector = '.cmscomponent-progressbar-bar';
      this.rangeStepTemplateSelector = '#template-cmscomponent-needanalyser-range-step';
      this.yesSelector = '.cmscomponent-needanalyser-icon-yes';
      this.noSelector = '.cmscomponent-needanalyser-icon-no';
      this.controlsSelector = '.cmscomponent-needanalyser-controls';
      this.previousSelector = '.cmscomponent-needanalyser-previous button';
      this.svgTemplateSelector = '#template-cmscomponent-needanalyser-tile-text';
      this.svgSelector = '.cmscomponent-needanalyser-svg';
      this.progressReachedClass = 'cmscomponent-progressbar-dot--reached';
      this.needAnalyserToolClass = 'template-needanalyser-tool';
      this.needAnalyserExitClass = 'template-needanalyser';
      this.templateNode = document.querySelector('.' + this.needAnalyserToolClass);
      this.isReset = false;
      this.startTileRow;
      this.fullData = {};
      this.selection = [];
      this.isWidget = false;
      this.isStartStep = false;
      this.isExit = false;
      this.defaultTileClass = 'is-two';
      this.tileClasses = {
        2: this.defaultTileClass,
        3: 'is-three',
        4: 'is-four'
      };
      this.getData().then(function (data) {
        var localData = data;
        localData = _this.prepareData(localData);

        _this.setupSteps(localData);
      }).catch(function (error) {
        console.log(error);

        _this.handleLoadingError();
      });
      this.bindListeners();
    }
  },
  prepareData: function prepareData(data) {
    var localData = data;

    if (typeof data === 'string') {
      localData = JSON.parse(localData);
    }

    return localData;
  },
  getData: function getData() {
    return this.service(this.serviceUrl);
  },
  service: function service(url) {
    if (url === '') {
      this.isWidget = true;
      return Promise.resolve({});
    } else {
      return Promise.resolve($.ajax({
        headers: {
          Accept: 'application/json; charset=utf-8'
        },
        type: 'GET',
        url: url
      }));
    }
  },
  storeSelection: function storeSelection($element) {
    var $tile = $element.parents(this.tileSelector);
    this.selection.push($tile.data(this.selectionKey));
  },
  getUrlParam: function getUrlParam(param) {
    return window.getUrlParam(param);
  },
  handleLoadingError: function handleLoadingError() {// TODO set error state
  },
  setupSteps: function setupSteps(data) {
    var _this2 = this;

    this.fullData = this.data = data;
    var urlParam = this.getUrlParam(this.treeKey);

    if (urlParam === null) {
      this.root.classList.add(_state.default.LOADED);
    } else {
      var widgetSelection = this.getUrlParam(this.selectionKey);

      if (widgetSelection !== null) {
        this.selection.push(widgetSelection);
      }

      this.nextStep(urlParam);
      this.wait(500).then(function () {
        _this2.root.classList.add(_state.default.LOADED);
      });
    }
  },
  startStep: function startStep() {
    this.isStartStep = true;
    this.startQuestion = this.$root.find(this.headlineSelector + ' ' + this.questionHeadlineSelector).text();
    this.startTileRow = this.$root.find(this.tileRowSeleector).html();
    this.root.classList.add(this.startClass);
  },
  getHTML: function getHTML(url) {
    return Promise.resolve($.ajax({
      headers: {
        Accept: 'text/plain; charset=utf-8'
      },
      type: 'GET',
      url: url
    }));
  },
  saveHTML: function saveHTML() {
    this.savedHTML = document.querySelector(this.contentSelector).innerHTML;
  },
  replaceHTML: function replaceHTML(html) {
    var _this3 = this;

    var fadeOutDelay = 700;
    var delay = 400;
    var $templateNode = $(this.templateNode);
    this.$root.animate({
      opacity: 0
    }, fadeOutDelay, function () {
      $templateNode.css('pointer-events', 'none');
      $templateNode.animate({
        opacity: 0
      }, delay, function () {
        _this3.switchTemplateClass();

        document.querySelector(_this3.contentSelector).innerHTML = html;

        _this3.enhanceHTML();

        $templateNode.animate({
          opacity: 1
        }, delay, function () {
          $templateNode.css('pointer-events', 'all');
        });
      });
    });
  },
  selectionUrl: function selectionUrl(url) {
    var paramString = '';
    var isFirst = false;
    var params = {
      printing: 'print',
      metal: 'metal-yes'
    };

    if (url.indexOf('?') === -1) {
      isFirst = true;
    }

    paramString = isFirst ? '?' : '&';
    paramString += 'ref=need';

    if (this.selection[0] === params.printing) {
      paramString += '&' + params.printing + '=1';
    } else {
      for (var i = 0; i < this.selection.length; i++) {
        var currentSelection = this.selection[i];

        if (currentSelection === params.metal) {
          paramString += '&' + params.metal + '=1';
        }
      }
    }

    return url + paramString;
  },
  enhanceHTML: function enhanceHTML() {
    window.fixRadios();
    window.initAtomDropdown();
    window.initCmscomponentProductrate();
  },
  switchTemplateClass: function switchTemplateClass() {
    if (this.isExit === true) {
      this.templateNode.classList.remove(this.needAnalyserToolClass);
      this.templateNode.classList.add(this.needAnalyserExitClass);
    } else {
      this.templateNode.classList.remove(this.needAnalyserExitClass);
      this.templateNode.classList.add(this.needAnalyserToolClass);
    }
  },
  handleProductMarkup: function handleProductMarkup(url) {
    var _this4 = this;

    this.getHTML(url).then(function (html) {
      _this4.isExit = true;

      _this4.saveHTML();

      _this4.replaceHTML(html);
    });
  },
  getMappingProductId: function getMappingProductId(productId) {
    return typeof this.data.mapping !== 'undefined' && typeof this.data.mapping[productId] !== 'undefined' ? this.data.mapping[productId] : '';
  },
  addProductId: function addProductId(url) {
    var localUrl = url;
    var productIdKey = 'productId';

    if (url.indexOf(productIdKey) !== -1) {
      var currentData = this.data[this.currentStep].tiles[this.currentTileIndex];

      if (typeof currentData.productId !== 'undefined') {
        localUrl = localUrl.replace(productIdKey, this.getMappingProductId(currentData.productId));
      }
    }

    return localUrl;
  },
  handleRedirect: function handleRedirect(url) {
    document.location.href = this.selectionUrl(this.addProductId(url));
  },
  nextStep: function nextStep(tree) {
    var _this5 = this;

    var maxTreeLength = 5;

    if (tree.length > maxTreeLength) {
      // TODO needed for availabilitycheck MEWACECIMP-3132
      // console.log(this.selection);
      this.handleRedirect(tree);
    } else {
      if (this.currentStep === 0) {
        this.startStep();
      }

      this.currentStep = tree;
      this.steps.push(this.currentStep);
      this.setupRange().then(function () {
        _this5.setupTiles().then(function () {
          _this5.setupControls();

          _this5.isStartStep = false;
        });
      });
    }
  },
  fadeOut: function fadeOut($element, time) {
    $element.animate({
      opacity: 0,
      height: 0
    }, time !== undefined ? time : 300, function () {
      $element.removeClass(_state.default.VISIBLE).css({
        opacity: '',
        height: ''
      });
    });
  },
  setupControls: function setupControls() {
    var _this6 = this;

    var promise = new Promise(function (resolve) {
      var $controls = _this6.$root.find(_this6.controlsSelector);

      if (_this6.isReset === false) {
        $controls.addClass(_state.default.VISIBLE);
      } else {
        _this6.fadeOut($controls);
      }

      resolve();
    });
    return promise;
  },
  getTreeDepth: function getTreeDepth() {
    var data = this.fullData;
    var step = this.currentStep;
    var depth = 0;

    var recursiveDepth = function recursiveDepth(currentDepth, tree, dataSet) {
      var maxDepth = 20;
      var insideDepth = currentDepth;

      if (insideDepth === maxDepth) {
        return maxDepth;
      }

      if (typeof dataSet[tree] !== 'undefined' && typeof dataSet[tree].tiles !== 'undefined') {
        var newTree = dataSet[tree].tiles[0].tree;

        if (typeof newTree !== 'undefined') {
          insideDepth++;
          insideDepth = recursiveDepth(insideDepth, newTree, dataSet);
        }
      }

      return insideDepth;
    };

    depth = recursiveDepth(depth, step, data);
    return depth;
  },
  setupRange: function setupRange() {
    var _this7 = this;

    var promise = new Promise(function (resolve) {
      var $range = $(_this7.root.querySelector(_this7.rangeSelector));

      var $question = _this7.$root.find(_this7.headlineSelector);

      var $questionAtom = $question.find(_this7.questionHeadlineSelector);

      if (_this7.isReset === false) {
        var $rangeStepTemplate = $('body').find(_this7.rangeStepTemplateSelector).html();

        var data = _this7.getCurrentData();

        var $progressBar = $range.find(_this7.rangeProgressSelector);
        $range.find(_this7.rangeHeadlineSelector).text(data.range);
        $progressBar.html('');
        var depth = typeof data.steps === 'undefined' ? _this7.getTreeDepth() : data.steps;
        var done = data.stepsDone;

        for (var i = 0; i < depth; i++) {
          var $stepClone = $($rangeStepTemplate);

          if (i < done) {
            $stepClone.addClass(_this7.progressReachedClass);
          }

          $progressBar.append($stepClone);
        }

        $range.addClass(_state.default.VISIBLE);
        var delay = _this7.isStartStep === true ? 700 : 0;

        _this7.wait(delay).then(function () {
          $questionAtom.text(data.question);
          $question.addClass(_state.default.VISIBLE);
          resolve();
        });
      } else {
        $question.animate({
          opacity: 0
        }, 500);

        _this7.wait(300).then(function () {
          $range.animate({
            opacity: 0
          }, 300);

          _this7.wait(1200).then(function () {
            $question.removeClass(_state.default.VISIBLE).css('opacity', '');
            $range.removeClass(_state.default.VISIBLE).css('opacity', '');
            resolve();
          });
        });
      }
    });
    return promise;
  },
  reset: function reset() {
    var _this8 = this;

    this.selection = [];
    this.isReset = true;
    this.setupControls().then(function () {
      _this8.wait(300).then(function () {
        _this8.setupRange().then(function () {
          _this8.isReset = false;

          _this8.$root.find(_this8.headlineSelector + ' ' + _this8.questionHeadlineSelector).text(_this8.startQuestion);

          _this8.root.classList.remove(_this8.startClass);

          _this8.$root.find(_this8.tileRowSeleector).html(_this8.startTileRow).removeClass(_this8.getAllTileClasses()).removeClass(_state.default.VISIBLE).addClass(_this8.defaultTileClass);

          _this8.currentStep = 0;
        });
      });
    });
  },
  previous: function previous() {
    this.selection.pop();
    this.steps.pop();
    var previousStep = this.steps.pop();

    if (typeof previousStep === 'undefined') {
      this.reset();
    } else {
      this.nextStep(previousStep);
    }
  },
  checkOverlapping: function checkOverlapping($svg) {
    var svgWidth = $svg.width();
    var $anchor = $svg.find('.anchor');
    var textWidth = $anchor[0].getBoundingClientRect().width;

    if (textWidth > svgWidth) {
      var scalingBuffer = 10;
      var scaling = (svgWidth * 100 / textWidth - scalingBuffer) / 100;
      scaling = scaling.toString().substr(0, 4);
      $anchor.attr({
        transform: 'scale(' + scaling + ')',
        x: '100%',
        y: '110%'
      });
    }

    $svg.css('opacity', '1');
  },
  createSVGIcon: function createSVGIcon(data) {
    var style = data['icon-style'];

    var tileStyles = _cmscomponentNeedanalyserTileText.default.getStyle(style);

    var svgMarkup = $('body').find(this.svgTemplateSelector).html();
    svgMarkup = svgMarkup.replace(/{style}/g, style);
    var $svg = $(svgMarkup);
    $.each(tileStyles, function (key) {
      var $svgElement = $svg.find('.' + key);
      var elementStyles = tileStyles[key];
      $.each(elementStyles, function (attr) {
        $svgElement.attr(attr, elementStyles[attr]);
      });
    });
    var iconFirstText = data['icon-text-first'];
    var iconSecondText = data['icon-text-second'];
    var iconThirdText = data['icon-text-third'];

    if (typeof iconFirstText !== 'undefined') {
      $svg.find('.first').text(iconFirstText);
    }

    if (typeof iconSecondText !== 'undefined') {
      $svg.find('.second').text(iconSecondText);
    }

    if (typeof iconThirdText !== 'undefined') {
      $svg.find('.third').text(iconThirdText);
    }

    svgMarkup = $('<div>').append($svg).html();
    return svgMarkup;
  },
  getTileClass: function getTileClass(length) {
    return this.tileClasses[length] || this.defaultTileClass;
  },
  getAllTileClasses: function getAllTileClasses() {
    return Object.values(this.tileClasses).join(' ');
  },
  setupTiles: function setupTiles() {
    var _this9 = this;

    var promise = new Promise(function (resolve) {
      var data = _this9.getCurrentData();

      var $tileRow = _this9.$root.find(_this9.tileRowSeleector);

      var tileClass = _this9.getTileClass(data.tiles.length);

      var tileTemplate = document.querySelector(_this9.tileTemplateSelector).innerHTML;
      $tileRow.html('').removeClass(_this9.getAllTileClasses()).addClass(tileClass);

      for (var i = 0; i < data.tiles.length; i++) {
        var tileData = data.tiles[i];
        var tree = typeof tileData.tree !== 'undefined' ? tileData.tree : tileData.exit;
        var newTileMarkup = tileTemplate.replace(/{tree}/g, tree);
        newTileMarkup = newTileMarkup.replace(/{selection}/g, tileData.selection);
        var $tileClone = $(newTileMarkup);

        if (_this9.data.debug === true) {
          $tileClone.append('<div style="position:absolute;top:0;left:0;opacity:0.5;font-size:10px;">DEBUG: Tree ' + tree + '</div>');
        }

        if (typeof tileData.info === 'undefined') {
          $tileClone.find(_this9.infoSelector).remove();
        }

        var icon = void 0;

        if (typeof tileData.yes !== 'undefined') {
          icon = $(_this9.$root.find(_this9.yesSelector)[0].innerHTML);
        } else if (typeof tileData.no !== 'undefined') {
          icon = $(_this9.$root.find(_this9.noSelector)[0].innerHTML);
        } else {
          icon = _this9.createSVGIcon(tileData);
        }

        if (typeof icon !== 'undefined') {
          $tileClone.find(_this9.tileIconSelector).html(icon);
        }

        $tileClone.find(_this9.sublineSelector).text(tileData.text);
        $tileRow.append($tileClone);

        if (typeof tileData.yes === 'undefined' && typeof tileData.no === 'undefined') {
          _this9.checkOverlapping($tileClone.find(_this9.svgSelector));
        }
      }

      var delay = _this9.isStartStep === true ? 400 : 0;

      _this9.wait(delay).then(function () {
        $tileRow.addClass(_state.default.VISIBLE);
        resolve();
      });
    });
    return promise;
  },
  wait: function wait(delay) {
    var promise = new Promise(function (resolve) {
      var timeout = setTimeout(function () {
        clearTimeout(timeout);
        resolve();
      }, delay);
    });
    return promise;
  },
  getCurrentData: function getCurrentData() {
    return this.data[this.currentStep];
  },
  getTemplate: function getTemplate(id) {
    return document.getElementById('template-' + this.name + '-' + id);
  },
  getRootSelector: function getRootSelector() {
    return '#' + this.root.getAttribute('id');
  },
  bindListeners: function bindListeners() {
    var _this10 = this;

    var hiddenClass = 'is-hidden';
    this.$root.on('click', this.tileContentSelector, function (element) {
      var $element = $(element.currentTarget);
      var $tile = $element.parent(_this10.tileSelector);
      var tree = $tile.data(_this10.treeKey);
      _this10.currentTileIndex = $tile.index();

      if (_this10.isWidget) {
        window.location.href = tree + '&' + _this10.selectionKey + '=' + $tile.data(_this10.selectionKey);
      } else {
        _this10.storeSelection($element);

        _this10.nextStep(tree);
      }
    });
    this.$root.on('click', this.infoLabelSelector, function (element) {
      var $element = $(element.currentTarget);
      var $info = $element.parents(_this10.infoSelector);
      var info = $info[0];
      var $tileContent = $info.prev();
      var tileContent = $tileContent[0];

      if (info.classList.contains(hiddenClass)) {
        tileContent.classList.add(hiddenClass);
        info.classList.remove(hiddenClass);
      }
    });
    this.$root.on('click', this.infoContainerSelector, function (element) {
      var $element = $(element.currentTarget);
      var $info = $element.parents(_this10.infoSelector);
      var $tileContent = $info.prev();
      var tileContent = $tileContent[0];
      $info[0].classList.add(hiddenClass);
      tileContent.classList.remove(hiddenClass);
    });
    this.$root.on('click', this.previousSelector, function () {
      _this10.previous();
    });
  }
};
var _default = NeedAnalyser;
exports.default = _default;

},{"cmscomponent-needanalyser-tile-text":182,"es6-promise":6,"state":232}],184:[function(require,module,exports){
"use strict";

var _state = _interopRequireDefault(require("state"));

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var _cmscomponentAvailabilitycheck = _interopRequireDefault(require("cmscomponent-availabilitycheck"));

var _cmscomponentNeedanalyser = _interopRequireDefault(require("cmscomponent-needanalyser"));

var _cmscomponentHeaderExtended = _interopRequireDefault(require("cmscomponent-header-extended"));

var _cmscomponentCategories = _interopRequireDefault(require("cmscomponent-categories"));

var _cmscomponentCart = _interopRequireDefault(require("cmscomponent-cart"));

var _cmscomponentDeliveryPointFlyout = _interopRequireDefault(require("cmscomponent-delivery-point-flyout"));

var _cmscomponentDialogWarning = _interopRequireDefault(require("cmscomponent-dialog-warning"));

var _cmscomponentLoginFlyout = _interopRequireDefault(require("cmscomponent-login-flyout"));

var _cmscomponentMarquee = _interopRequireDefault(require("cmscomponent-marquee"));

var _cmscomponentPagination = _interopRequireDefault(require("cmscomponent-pagination"));

var _cmscomponentProduct = _interopRequireDefault(require("cmscomponent-product"));

var _cmscomponentProductGrid = _interopRequireDefault(require("cmscomponent-product-grid"));

var _cmscomponentProductSettings = _interopRequireDefault(require("cmscomponent-product-settings"));

var _cmscomponentProductSpecifications = _interopRequireDefault(require("cmscomponent-product-specifications"));

var _cmscomponentFilter = _interopRequireDefault(require("cmscomponent-filter"));

var _cmscomponentFilterSearch = _interopRequireDefault(require("cmscomponent-filter-search"));

var _cmscomponentSortFilter = _interopRequireDefault(require("cmscomponent-sort-filter"));

var _cmscomponentFormServiceticket = _interopRequireDefault(require("cmscomponent-form-serviceticket"));

var _cmscomponentSearch = _interopRequireDefault(require("cmscomponent-search"));

var _cmscomponentServiceticketDetail = _interopRequireDefault(require("cmscomponent-serviceticket-detail"));

var _cmscomponentStage = _interopRequireDefault(require("cmscomponent-stage"));

var _cmscomponentTeaserbox = _interopRequireDefault(require("cmscomponent-teaserbox"));

var _cmscomponentTeaserboxSlider = _interopRequireDefault(require("cmscomponent-teaserbox-slider"));

var _cmscomponentTileList = _interopRequireDefault(require("cmscomponent-tile-list"));

var _cmscomponentStageproduct = _interopRequireDefault(require("cmscomponent-stageproduct"));

var _cmscomponentUpload = _interopRequireDefault(require("cmscomponent-upload"));

var _cmscomponentRegistrationExtended = _interopRequireDefault(require("cmscomponent-registration-extended"));

var _cmscomponentWishlist = _interopRequireDefault(require("cmscomponent-wishlist"));

var _cmscomponentPatchSelector = _interopRequireDefault(require("cmscomponent-patch-selector"));

var _cmscomponentWearer = _interopRequireDefault(require("cmscomponent-wearer"));

var _cmscomponentUtilityBar = _interopRequireDefault(require("cmscomponent-utility-bar"));

var _cmscomponentFormTextarea = _interopRequireDefault(require("cmscomponent-form-textarea"));

var _cmscomponentTileExpander = _interopRequireDefault(require("cmscomponent-tile-expander"));

var _cmscomponentDataSwitch = _interopRequireDefault(require("cmscomponent-data-switch"));

var _cmscomponentShowMore = _interopRequireDefault(require("cmscomponent-show-more"));

var _cmscomponentFormRegistration = _interopRequireDefault(require("cmscomponent-form-registration"));

var _cmscomponentSearchLocal = _interopRequireDefault(require("cmscomponent-search-local"));

var _cmscomponentFaq = _interopRequireDefault(require("cmscomponent-faq"));

var _simpleLightbox = _interopRequireDefault(require("./simple-lightbox"));

var _cmscomponentAnchorNav = _interopRequireDefault(require("cmscomponent-anchor-nav"));

var _cmscomponentTemporaryAddressForm = _interopRequireDefault(require("cmscomponent-temporary-address-form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = require('flickity');

require('flickity-as-nav-for');

window.addEventListener('simpleLightboxEventOpen', function () {
  _cmscomponentAvailabilitycheck.default.init();
});
window.addEventListener('InitComponents', function () {
  _cmscomponentHeaderExtended.default.init(); // cmscomponent-newsletter


  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-newsletter'), function (el) {
    var button = el.querySelector('.atom-button');
    var form = el.querySelector('.cmscomponent-newsletter-form');
    var actionUrl = form.getAttribute('action');
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var email = el.querySelector('.atom-input input').value;
      el.querySelector('.cmscomponent-newsletter-email .atom-input').classList.remove('error');
      el.querySelector('.cmscomponent-newsletter-error').classList.add('hidden');

      if ((0, _isEmail.default)(email)) {
        var token = el.querySelector('.newsletter-csrf-token input').value;
        var newsletterType = el.querySelector('.newsletter-newsletter-type input').value;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', actionUrl);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            el.querySelector('.cmscomponent-newsletter-slides').classList.add('isSuccess');
          } else {
            el.querySelector('.cmscomponent-newsletter-slides').classList.add('isError');
          }
        };

        xhr.onerror = function () {
          el.querySelector('.cmscomponent-newsletter-slides').classList.add('isError');
        };

        xhr.send(encodeURI('CSRFToken=' + token + '&email=' + email + '&newsletterType=' + newsletterType));
      } else {
        el.querySelector('.cmscomponent-newsletter-email .atom-input').classList.add('error');
      }
    });
  }); // cmscomponent-promoteaser

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-promoteaser'), function (el) {
    el.addEventListener('click', function (e) {
      window.location.href = el.getAttribute('data-href');
    });
  });

  window.initCmscomponentProductrate = function () {
    // cmscomponent-productrate
    Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-productrate'), function (el) {
      var allTiles = el.querySelectorAll('.item');
      var allTexts = el.querySelectorAll('.info');
      var submitButton = el.querySelector('.cmscomponent-productrate-buttons');
      var price = el.querySelector('.atom-pricetag-price-cost');
      var pricing = el.querySelector('.pricing');

      var checkPrice = function checkPrice() {
        // disable button when price is not set
        var visibleTile = el.querySelector('.right .info.visible');

        if (visibleTile !== null) {
          price = visibleTile.dataset.hasprice;

          if (price != 'false') {
            el.querySelector('.showButtons').classList.remove('hidden');
          } else {
            el.querySelector('.showButtons').classList.add('hidden');
          }
        }
      }; // set first button as checked if none has been checked


      var checkedTile = false;
      Array.prototype.forEach.call(allTiles, function (tile, index) {
        if (tile.querySelector('input').checked) checkedTile = index;
      });

      if (!checkedTile && allTiles[0]) {
        allTiles[0].querySelector('input').checked = 'checked';
      } // display text to selected tile


      Array.prototype.forEach.call(allTiles, function (tile, index) {
        var radioButton = tile.querySelector('input');

        if (radioButton.checked) {
          allTexts[index].classList.add('visible');
        }

        radioButton.addEventListener('change', function () {
          var correspondingText = allTexts[index];
          Array.prototype.forEach.call(allTexts, function (text) {
            text.classList.remove('visible');
          });
          correspondingText.classList.add('visible');
          checkPrice();
        });
        radioButton.addEventListener('click', function (current) {});
      });
      submitButton.addEventListener('click', function () {
        var selectedProduct = el.querySelector('input[type="radio"]:checked');
        var contractualPeriod = selectedProduct.value;
        var productName = selectedProduct.dataset.name;
        var productId = selectedProduct.dataset.id;
        var openAvailabilityCheck = selectedProduct.dataset.availabilitycheck === 'true' ? true : false;
        var addtobasketurl = selectedProduct.dataset.addtobasketurl;
        var basketurl = selectedProduct.dataset.basketurl;
        var hideQuestions = selectedProduct.dataset.hidequestions;

        if (openAvailabilityCheck === true) {
          window.availabilityzone(productId, productName, contractualPeriod, hideQuestions);
        } else {
          $.post(addtobasketurl, {
            product: productId,
            contractualPeriod: contractualPeriod
          }, function () {
            window.location.href = basketurl;
          });
        }
      });
      var disableButton = el.querySelector('.cmscomponent-productrate-buttons-disable');
      var showbutton = disableButton.dataset.showbutton;

      if (showbutton != 'false') {
        disableButton.classList.remove('hidden');
      }

      checkPrice();
    });
  };

  initCmscomponentProductrate(); // cmscomponent-teaserproduct

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-teaserproduct'), function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
      window.location.href = el.getAttribute('data-href');
    });
  }); // cmscomponent-login

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-login'), function (loginForm) {
    var selectTab = function selectTab(toggleSelector) {
      loginForm.querySelector('[data-toggle="inner-content-left"]').classList.remove('active');
      loginForm.querySelector('[data-toggle="inner-content-right"]').classList.remove('active');
      loginForm.querySelector('[data-toggle="' + toggleSelector + '"]').classList.add('active');
      loginForm.querySelector('.inner-content-left').classList.add('hidden');
      loginForm.querySelector('.inner-content-right').classList.add('hidden');
      loginForm.querySelector('.' + toggleSelector).classList.remove('hidden');
    };

    loginForm.querySelectorAll('.cmscomponent-login-tabs > div').forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        var toggleSelector = tab.getAttribute('data-toggle');
        selectTab(toggleSelector);
      });
    }); // add e-mail address to lost password link

    var lostPasswordAnchor = loginForm.querySelector('.cmscomponent-form-login-forgot a');
    var urlBase = lostPasswordAnchor.getAttribute('href').split('?')[0];
    loginForm.querySelector('.cmscomponent-form-login-email input').addEventListener('keyup', function () {
      lostPasswordAnchor.setAttribute('href', urlBase + '?email=' + this.value);
    });
  });

  _cmscomponentAvailabilitycheck.default.init(); // toggle billing address input fields


  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-form-billing'), function (el) {
    var checkChangeBilling = function checkChangeBilling() {
      var checkbox = el.querySelector('input[type=checkbox]');
      var formSelector = '.cmscomponent-form-billing-form';
      var addressDataSelector = '.cmscomponent-form-billing-address-data';
      var vatSelector = '.cmscomponent-form-billing-vat';
      if (!checkbox) return false;

      if (checkbox.checked === true) {
        el.querySelector(formSelector).classList.add(_state.default.HIDDEN);
        el.querySelector(addressDataSelector).classList.remove(_state.default.HIDDEN);
        el.querySelector(vatSelector).classList.remove(_state.default.HIDDEN);
      } else {
        el.querySelector(formSelector).classList.remove(_state.default.HIDDEN);
        el.querySelector(addressDataSelector).classList.add(_state.default.HIDDEN);
        el.querySelector(vatSelector).classList.add(_state.default.HIDDEN);
      }
    };

    el.addEventListener('click', function () {
      checkChangeBilling();
    });
    checkChangeBilling();
  }); // add new comment to a ticket

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-your-request-detail'), function (requestdetail) {
    var textarea = requestdetail.querySelector('.cmscomponent-your-request-detail-newcomment-textarea');
    var hiddenfield = requestdetail.querySelector('.cmscomponent-your-request-detail-newcomment-textarea-open');
    textarea.addEventListener('click', function (e) {
      hiddenfield.classList.remove('hidden');
    });
  }); // allow submitting when checkbox is checked / confirm

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-checkout-submit'), function (el) {
    var submit = el.querySelector('.cmscomponent-checkout-submit-button button[type="submit"]');
    var agbParent = el.querySelector('.atom-checkbox');
    var agb = agbParent.querySelector('input[type="checkbox"]');
    submit.addEventListener('click', function (e) {
      if (agb.checked !== true) {
        e.preventDefault();
        handleErrors(validate(checkBox));
      } else {
        window.setTimeout(function () {
          submit.disabled = true;
          $('.cmscomponent-checkout-submit-button button[type="submit"]').attr('disabled', 'disabled');
        }, 50);
        window.setTimeout(function () {
          $('.cmscomponent-checkout-submit-button button[type="submit"]').removeAttr('disabled');
        }, 120000);
      }
    });
    var checkBox = el.querySelector('input[type=checkbox]');
    checkBox.addEventListener('click', function () {
      var isChecked = checkBox.checked ? true : false;
      var checkedSelector = isChecked === true ? ':not(:checked)' : ':checked';
      var otherCheckBoxes = document.querySelectorAll('.cmscomponent-checkout-submit input[type="checkbox"]' + checkedSelector);
      handleErrors(validate(checkBox));
      Array.prototype.forEach.call(otherCheckBoxes, function (selectedCheckbox) {
        selectedCheckbox.checked = isChecked === true ? 'checked' : '';
        handleErrors(validate(selectedCheckbox));
      });
      handleErrors(validate(checkBox));
    });
  }); // ordersdetail modals

  [].forEach.call(document.querySelectorAll('.cmscomponent-ordersdetail'), function (ordersdetail) {
    ordersdetail.querySelectorAll('.js-openupgrade').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var upgradecontainer = link.closest('.js-upgradecontainer');
        var modal = upgradecontainer.querySelector('.atom-dialog-content');

        _simpleLightbox.default.open({
          element: modal
        });
      });
    });
  }); // totopbig - back to top

  [].forEach.call(document.querySelectorAll('.cmscomponent-totopbig'), function (el) {
    el.querySelector('.cmscomponent-totopbig-link').addEventListener('click', function () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  });

  _cmscomponentNeedanalyser.default.init();

  _cmscomponentCategories.default.init();

  _cmscomponentCart.default.init();

  _cmscomponentDeliveryPointFlyout.default.init();

  _cmscomponentDialogWarning.default.init();

  _cmscomponentLoginFlyout.default.init();

  _cmscomponentMarquee.default.init();

  _cmscomponentProduct.default.init();

  _cmscomponentProductGrid.default.init();

  _cmscomponentProductSettings.default.init();

  _cmscomponentProductSpecifications.default.init();

  _cmscomponentFaq.default.initAll();

  _cmscomponentFilter.default.init();

  _cmscomponentFilterSearch.default.init();

  _cmscomponentSortFilter.default.init();

  _cmscomponentFormServiceticket.default.init();

  _cmscomponentFormTextarea.default.init();

  _cmscomponentSearch.default.init();

  _cmscomponentServiceticketDetail.default.init();

  _cmscomponentStage.default.init();

  _cmscomponentStageproduct.default.init();

  _cmscomponentTeaserbox.default.init();

  _cmscomponentTeaserboxSlider.default.init();

  _cmscomponentTileList.default.init();

  _cmscomponentTileExpander.default.init();

  _cmscomponentUpload.default.init();

  _cmscomponentRegistrationExtended.default.init();

  _cmscomponentWishlist.default.init();

  _cmscomponentPatchSelector.default.init();

  _cmscomponentWearer.default.init();

  _cmscomponentUtilityBar.default.init();

  _cmscomponentPagination.default.init();

  _cmscomponentShowMore.default.initAll();

  _cmscomponentFormRegistration.default.init();

  _cmscomponentSearchLocal.default.init();

  _cmscomponentAnchorNav.default.init();

  _cmscomponentTemporaryAddressForm.default.init();

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-data-switch'), function (el) {
    new _cmscomponentDataSwitch.default(el);
  }); // cmscomponent testbox

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-testbox'), function (el) {
    var formSelector = '.cmscomponent-testbox .cmscomponent-form-contact';

    var update = function update() {
      fixRadios();
      var selectedProduct = el.querySelector('.cmscomponent-testbox-product input:checked');
      var selectedProductValue = selectedProduct ? selectedProduct.value : '';
      var selectedPrinting = el.querySelector('.cmscomponent-testbox-printing input:checked');
      var selectedPrintingValue = selectedPrinting ? selectedPrinting.value : '';
      var selectedMetal = el.querySelector('.cmscomponent-testbox-metal input:checked');
      var selectedMetalValue = selectedMetal ? selectedMetal.value : '';

      if (selectedProductValue !== '') {
        el.querySelector('.cmscomponent-testbox-printing').classList.remove('opacity-0');
      } else {
        el.querySelector('.cmscomponent-testbox-printing').classList.add('opacity-0');
      }

      if (selectedPrintingValue !== '' && selectedPrintingValue !== 'yes') {
        el.querySelector('.cmscomponent-testbox-metal').classList.remove('opacity-0');
      } else {
        el.querySelector('.cmscomponent-testbox-metal').classList.add('opacity-0');
      }

      if (selectedMetalValue !== '' || selectedPrintingValue === 'yes') {
        el.parentNode.querySelector(formSelector).classList.add(_state.default.VISIBLE);
      } else {
        el.parentNode.querySelector(formSelector).classList.remove(_state.default.VISIBLE);
      }

      updateConfig({
        'Product type': selectedProductValue,
        'Printing company': selectedPrintingValue,
        'Containing metal': selectedMetalValue,
        'Recommended Product': getProductRecommendation(selectedProductValue, selectedPrintingValue, selectedMetalValue)
      });
    };

    var getProductRecommendation = function getProductRecommendation(selectedProductValue, selectedPrintingValue, selectedMetalValue) {
      var product = '';

      if (selectedPrintingValue !== 'yes') {
        if (selectedMetalValue === 'yes') {
          product = 'METAL';
        } else {
          product = 'OIL';
        }
      } else {
        product = 'INK';
      }

      return selectedProductValue + ' ' + product;
    };

    var updateConfig = function updateConfig(config) {
      var form = el.parentNode.querySelector(formSelector);
      var targetField = form.querySelector('textarea:last-child');
      targetField.textContent = 'TESTBOX ORDER\r\n' + joinObject(config);
    };

    Array.prototype.forEach.call(el.querySelectorAll('input'), function (inputElement) {
      inputElement.addEventListener('change', function () {
        update();
      });
    });
  }); // account-modals

  Array.prototype.forEach.call(document.querySelectorAll('.cmscomponent-addresses'), function (account) {
    account.querySelectorAll('.js-openAddNewContent').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var addAddress = link.closest('.js-openAddNewContentContainer');
        var modal = addAddress.querySelector('.atom-dialog-content');

        _simpleLightbox.default.open({
          element: modal
        });
      });
    });
  }); // show login-modal if first visit

  if (!localStorage.getItem('returningVisitor')) {
    localStorage.setItem('returningVisitor', 'true');
    var modal = document.getElementById('js-login-modal');
    modal && _simpleLightbox.default.open({
      element: modal
    }); // eslint-disable-line no-new
  }
});

},{"./simple-lightbox":231,"cmscomponent-anchor-nav":185,"cmscomponent-availabilitycheck":186,"cmscomponent-cart":187,"cmscomponent-categories":188,"cmscomponent-data-switch":189,"cmscomponent-delivery-point-flyout":190,"cmscomponent-dialog-warning":191,"cmscomponent-faq":192,"cmscomponent-filter":194,"cmscomponent-filter-search":193,"cmscomponent-form-registration":195,"cmscomponent-form-serviceticket":196,"cmscomponent-form-textarea":197,"cmscomponent-header-extended":198,"cmscomponent-login-flyout":199,"cmscomponent-marquee":200,"cmscomponent-needanalyser":183,"cmscomponent-pagination":201,"cmscomponent-patch-selector":202,"cmscomponent-product":206,"cmscomponent-product-grid":203,"cmscomponent-product-settings":204,"cmscomponent-product-specifications":205,"cmscomponent-registration-extended":207,"cmscomponent-search":209,"cmscomponent-search-local":208,"cmscomponent-serviceticket-detail":210,"cmscomponent-show-more":211,"cmscomponent-sort-filter":212,"cmscomponent-stage":213,"cmscomponent-stageproduct":214,"cmscomponent-teaserbox":216,"cmscomponent-teaserbox-slider":215,"cmscomponent-temporary-address-form":217,"cmscomponent-tile-expander":218,"cmscomponent-tile-list":219,"cmscomponent-upload":220,"cmscomponent-utility-bar":221,"cmscomponent-wearer":222,"cmscomponent-wishlist":223,"flickity":17,"flickity-as-nav-for":11,"state":232,"validator/lib/isEmail":97}],185:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AnchorNav = {
  init: function init() {
    this.rootSelector = '.cmscomponent-anchor-nav';
    this.root = document.querySelector(this.rootSelector);

    if (this.root) {
      this.generateAnchorPoints();
    }
  },
  createLink: function createLink(anchor) {
    var element = document.createElement('div');
    element.innerHTML = anchor.getAttribute('anchor');
    return element;
  },
  onAnchorClick: function onAnchorClick(anchor) {
    window.scrollTo(0, anchor.getBoundingClientRect().top - 20);
  },
  generateAnchorPoints: function generateAnchorPoints() {
    var _this = this;

    document.querySelectorAll('[anchor]').forEach(function (anchor) {
      if (anchor.getAttribute('anchor')) {
        var link = _this.createLink(anchor);

        _this.root.appendChild(link);

        link.addEventListener('click', function () {
          _this.onAnchorClick(anchor);
        });
      }
    });
  }
};
var _default = AnchorNav;
exports.default = _default;

},{}],186:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var AvailabilityCheck = {
  init: function init() {
    //cmscomponent-availabilitycheck
    Array.prototype.forEach.call(document.querySelectorAll('#availabilitycheck'), function (el) {
      if (!el.querySelector('.radioButtonBox')) return;
      el.querySelector('.check .atom-button') ? el.querySelector('.check .atom-button').disabled = true : undefined;
      var hasRadioButtons = !_toConsumableArray(el.querySelector('.radioButtonBox').classList).includes('hidden');

      var checkPLZ = function checkPLZ(targetElement) {
        if (hasRadioButtons) return;

        if (targetElement.value.length > 0) {
          el.querySelector('.check .atom-button') ? el.querySelector('.check .atom-button').disabled = false : undefined;
        } else {
          el.querySelector('.check .atom-button') ? el.querySelector('.check .atom-button').disabled = true : undefined;
        }
      };

      checkPLZ(el.querySelector('input[type="postalcode"]'));
      el.querySelector('input[type="postalcode"]').addEventListener('input', function (ev) {
        checkPLZ(ev.currentTarget);
      });
      var selectedRadios = el.querySelectorAll('.cmscomponent-availabilitycheck-printing-yes input[type="radio"], .cmscomponent-availabilitycheck-printing-no input[type="radio"]');
      var selectedCleaningRadios = el.querySelectorAll('.cmscomponent-availabilitycheck-cleaning-yes input[type="radio"], .cmscomponent-availabilitycheck-cleaning-no input[type="radio"]');
      Array.prototype.forEach.call(selectedRadios, function (radio) {
        radio.addEventListener('click', function () {
          var isNo = this.closest('.cmscomponent-availabilitycheck-printing-no') !== null;

          if (isNo) {
            el.querySelector('.query').classList.remove('hidden');
            el.querySelector('.check .atom-button') ? el.querySelector('.check .atom-button').disabled = true : undefined;
            Array.prototype.forEach.call(selectedCleaningRadios, function (item) {
              item.checked = false;
            });
          } else {
            el.querySelector('.query').classList.add('hidden');
            el.querySelector('.check .atom-button') ? el.querySelector('.check .atom-button').disabled = false : undefined;
          }
        });
      });
      Array.prototype.forEach.call(selectedCleaningRadios, function (radio) {
        radio.addEventListener('click', function () {
          el.querySelector('.check .atom-button').disabled = false;
        });
      });
      var cancelButton = el.querySelector('.buttons .cancel');

      if (cancelButton) {
        cancelButton.addEventListener('click', function (e) {
          var _window$openSimpleLig;

          e.preventDefault();
          (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
        });
      }
    });
  },
  getSelection: function getSelection() {
    var params = this.getUrlParams();
    return params;
  },
  getUrlParams: function getUrlParams() {
    var params = ['print', 'metal-yes', 'ref'];
    var resultParams = {};

    for (var i = 0; i < params.length; i++) {
      var result = new RegExp('[?&]' + params[i] + '=([^&#]*)').exec(window.location.href);

      if (result !== null) {
        resultParams[params[i]] = decodeURI(result[1]);
      }
    }

    return resultParams;
  }
};
var _default = AvailabilityCheck;
exports.default = _default;

},{}],187:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cart = {
  init: function init() {
    this.rootSelector = '.cmscomponent-cart';
    this.noticeWrapperSelector = '.notice-textfield-wrapper';
    this.noticeSelector = '.cmscomponent-cart-item-footer-notice';
    this.noticeLinkSelector = '.cmscomponent-cart-item-footer-notice-link';
    this.noticeTextfieldSelector = '.notice-textfield';
    this.noticeTextareaSelector = this.noticeTextfieldSelector + ' textarea';
    this.closeSelector = this.noticeTextfieldSelector + ' .close';
    this.saveSelector = '.cmscomponent-cart-item-notice-save';
    this.couponDeleteSelector = '.cmscomponent-cart-coupon-delete-button';
    this.shippingLinkSelector = '.cmscomponent-cart-delivery-shipping-link input';
    this.shippingLinkSelectorRadio = '.cmscomponent-cart-delivery-shipping-link .atom-radio';
    this.deleteLinkSelector = '.cmscomponent-cart-item-delete__button';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (cart) {
      [].forEach.call(cart.querySelectorAll(_this.deleteLinkSelector), function (deleteLink) {
        deleteLink.addEventListener('click', function (e) {
          e.preventDefault();
          var form = deleteLink.closest('form');

          if (form !== null) {
            form.submit();
          }
        });
      });
      [].forEach.call(cart.querySelectorAll(_this.shippingLinkSelectorRadio), function (shippingLink) {
        shippingLink.addEventListener('keypress', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            var form = shippingLink.closest('form');

            if (form !== null) {
              form.submit();
            }
          }
        });
      });
      [].forEach.call(cart.querySelectorAll(_this.shippingLinkSelector), function (shippingLink) {
        shippingLink.addEventListener('change', function () {
          var form = shippingLink.closest('form');

          if (form !== null) {
            form.submit();
          }
        });
      });
      [].forEach.call(cart.querySelectorAll(_this.noticeLinkSelector), function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          _this.handleClick(link);
        });
      });
      [].forEach.call(cart.querySelectorAll(_this.noticeSelector + ' ' + _this.closeSelector), function (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();

          _this.handleCloseClick(close);
        });
      });
      [].forEach.call(cart.querySelectorAll(_this.noticeTextfieldSelector), function (textFieldArea) {
        var typingTimer;
        var loadingSpinner;
        var showLoadingSpinnerInterval = 1000;
        var doneTypingInterval = 1500;
        textFieldArea.addEventListener('keyup', function () {
          _this.resetSaveStateLabels(textFieldArea);

          clearTimeout(loadingSpinner);
          clearTimeout(typingTimer);
          loadingSpinner = setTimeout(function () {
            _this.updateSavingStateLabel(textFieldArea, false);
          }, showLoadingSpinnerInterval);
          typingTimer = setTimeout(function () {
            _this.handleAutomaticSaving(textFieldArea);
          }, doneTypingInterval);
        });
      });
      var couponDelete = cart.querySelector(_this.couponDeleteSelector);

      if (couponDelete !== null) {
        couponDelete.addEventListener('click', function (e) {
          e.preventDefault();

          _this.handleCouponDeleteClick(couponDelete);
        });
      }
    });
  },
  resetSaveStateLabels: function resetSaveStateLabels(textFieldArea) {
    var saveSelector = textFieldArea.querySelector(this.saveSelector);
    saveSelector.classList.remove(_state.default.LOADED);
    saveSelector.classList.remove(_state.default.LOADING);
    saveSelector.classList.remove(_state.default.ERROR);
  },
  updateSavingStateLabel: function updateSavingStateLabel(textFieldArea, isSaved) {
    var saveSelector = textFieldArea.querySelector(this.saveSelector);
    saveSelector.classList.remove(_state.default.ERROR);

    if (!isSaved) {
      saveSelector.classList.remove(_state.default.LOADED);
      saveSelector.classList.add(_state.default.LOADING);
    } else {
      saveSelector.classList.remove(_state.default.LOADING);
      saveSelector.classList.add(_state.default.LOADED);
    }
  },
  handleCouponDeleteClick: function handleCouponDeleteClick(couponDelete) {
    var form = couponDelete.closest('form');

    if (form !== null) {
      form.submit();
    }
  },
  handleClick: function handleClick(element) {
    var notice = element.closest(this.noticeSelector);

    if (notice !== null) {
      this.open(notice);
    }
  },
  handleCloseClick: function handleCloseClick(element) {
    var noticeWrapper = element.closest(this.noticeWrapperSelector);

    if (noticeWrapper !== null) {
      var textarea = noticeWrapper.querySelector(this.noticeTextareaSelector);

      if (textarea !== null) {
        textarea.value = '';
        this.handleAutomaticSaving(textarea);
      }
    }
  },
  handleAutomaticSaving: function handleAutomaticSaving(textFieldArea) {
    var notice = textFieldArea.closest(this.noticeSelector);

    if (notice !== null) {
      var errors = validate(notice.querySelector(this.noticeTextareaSelector));

      if (errors.length === 0) {
        this.submit(textFieldArea);
      } else {
        handleErrors(errors);
        this.showSavingErrorLabel(textFieldArea);
      }
    } else {
      this.showSavingErrorLabel(textFieldArea);
    }
  },
  showSavingErrorLabel: function showSavingErrorLabel(textFieldArea) {
    var saveSelector = textFieldArea.querySelector(this.saveSelector);
    this.resetSaveStateLabels(textFieldArea);
    saveSelector.classList.add(_state.default.ERROR);
  },
  open: function open(notice) {
    notice.classList.add(_state.default.OPEN);
  },
  submit: function submit(textFieldArea) {
    var _this2 = this;

    var notice = textFieldArea.closest(this.noticeSelector);
    var form = notice.querySelector('form');
    var action = form.getAttribute('action');
    var method = form.getAttribute('method');

    var formData = _tools.default.getFormData(form, false);

    _tools.default.service(action, method, formData, undefined, form).then(function (response) {
      if (response && response.status === 200) {
        _this2.updateSavingStateLabel(textFieldArea, true);
      } else {
        _this2.showSavingErrorLabel(textFieldArea);
      }
    });
  }
};
var _default = Cart;
exports.default = _default;

},{"state":232,"tools":236}],188:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = require('flickity');

var Categories = {
  init: function init() {
    this.rootSelector = '.cmscomponent-categories';
    this.breakpointBelow = 'lg';
    this.instance = {};
    this.levels = ['', '.cmscomponent-categories-items', '.cmscomponent-categories-items > .cmscomponent-categories-item > .cmscomponent-categories-list.is-visible', '.cmscomponent-categories-list.is-visible .cmscomponent-categories-list.is-visible'];
    this.root = document.querySelectorAll(this.rootSelector);
    this.options = {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left'
    };
    this.setupSliders();
    this.bindListeners();
  },
  setupSliders: function setupSliders() {
    var _this = this;

    Array.prototype.forEach.call(this.root, function (node) {
      var xpath = _tools.default.getXPathOfElement(node);

      var level = node.dataset.level;
      var levelListSelector = _this.levels[level];
      var list = node.querySelectorAll(levelListSelector);

      if (list.length > 0) {
        if (_tools.default.screen(_this.breakpointBelow)) {
          _this.instance[xpath] = new Flickity(list[0], _this.options);
        } else {
          if (typeof _this.instance[xpath] !== 'undefined') {
            _this.instance[xpath].destroy();
          }
        }
      }
    });
  },
  bindListeners: function bindListeners() {
    var _this2 = this;

    window.addEventListener('resize', function () {
      _this2.setupSliders();
    });
  }
};
var _default = Categories;
exports.default = _default;

},{"flickity":17,"tools":236}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

var _templates = _interopRequireDefault(require("../templates"));

var _atomDropdown = _interopRequireDefault(require("atom-dropdown"));

var _atomTooltip = _interopRequireDefault(require("atom-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DataSwitch = /*#__PURE__*/function () {
  function DataSwitch(el) {
    var _this = this;

    _classCallCheck(this, DataSwitch);

    this.el = el;
    this.filterSearch = el.querySelector('ul[data-switch]');
    this.switchDropdown = el.querySelector('[data-switch]');
    this.dataBindings = {};
    this.supportedSubComponents = {
      'atoms-dropdown': {
        partials: {
          'atoms-tooltip': 'atoms-tooltip'
        },
        init: function init(subElement) {
          _atomDropdown.default.reinitialize(subElement);

          _atomTooltip.default.init(subElement);
        }
      },
      'atoms-icon-product': {
        partials: {
          'atoms-dropdown': 'atoms-dropdown',
          'atoms-checkbox': 'atoms-checkbox',
          'atoms-tooltip': 'atoms-tooltip'
        },
        init: function init(subElement) {
          _atomDropdown.default.reinitialize(subElement);

          _atomTooltip.default.init(subElement);
        }
      }
    };
    [].forEach.call(el.querySelectorAll('[data-binding]'), function (bindingElement) {
      _this.dataBindings[bindingElement.dataset.binding] = bindingElement;
    });

    if (this.filterSearch) {
      this.bindFilterSearchListener();
    }

    this.switchDropdown.addEventListener('change', this.handleChange.bind(this));
  }

  _createClass(DataSwitch, [{
    key: "bindFilterSearchListener",
    value: function bindFilterSearchListener() {
      var _this2 = this;

      var filterSearchListItems = this.filterSearch.querySelectorAll('li');
      var filterSearchInput = this.filterSearch.previousElementSibling.querySelector('input');
      [].forEach.call(filterSearchListItems, function (listItem) {
        listItem.addEventListener('click', function () {
          return _this2.handleFilterSearchItemSelected(listItem);
        });
      });
      filterSearchInput.addEventListener('keydown', function (e) {
        if (e.key && e.key === 'Enter') {
          var selectedItem = Object.values(filterSearchListItems).filter(function (listItem) {
            return listItem.classList.contains(_state.default.SELECTED);
          })[0];

          _this2.handleFilterSearchItemSelected(selectedItem);
        }
      });
    }
  }, {
    key: "loadData",
    value: function loadData(serviceGetUrl) {
      var _this3 = this;

      this.el.classList.add(_state.default.LOADING);

      _tools.default.service(serviceGetUrl, 'GET', undefined, undefined).then(function (response) {
        response.json().then(_this3.handleData.bind(_this3));
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var serviceGetUrl = this.switchDropdown.querySelectorAll('option')[this.switchDropdown.selectedIndex].dataset.href;
      this.loadData(serviceGetUrl);
    }
  }, {
    key: "handleFilterSearchItemSelected",
    value: function handleFilterSearchItemSelected(listItem) {
      var serviceGetUrl = listItem.dataset.href;
      this.loadData(serviceGetUrl);
    }
  }, {
    key: "handleData",
    value: function handleData(json) {
      var _this4 = this;

      var allComponents = [];
      Object.keys(json).forEach(function (dataNode) {
        if (_this4.dataBindings.hasOwnProperty(dataNode)) {
          allComponents.push(_this4.updateComponent(_this4.dataBindings[dataNode], _this4.dataBindings[dataNode].dataset.template, json[dataNode]));
        }
      });
      Promise.all(allComponents).then(function () {
        _this4.el.classList.remove(_state.default.LOADING);
      });
    }
  }, {
    key: "updateComponent",
    value: function updateComponent(el, template, data) {
      var _this5 = this;

      return new Promise(function (resolve) {
        var arrayData = Array.isArray(data) ? data : [data];
        var allTemplates = [];
        var renderedDataWithOrder = [];
        arrayData.forEach(function (componentData, index) {
          allTemplates.push(_templates.default.load(template, componentData, undefined, index).then(function (renderedData) {
            renderedDataWithOrder[renderedData.renderedIndex] = renderedData.rendered;
          }).catch(function (error) {
            console.debug(error);
          }));
        });
        Promise.all(allTemplates).then(function () {
          renderedDataWithOrder.forEach(function (rendered, index) {
            if (index === 0) {
              el.innerHTML = rendered;
            } else {
              el.innerHTML += rendered;
            }
          });

          _this5.supportedSubComponents[template].init(el);

          resolve();
        });
      });
    }
  }]);

  return DataSwitch;
}();

var _default = DataSwitch;
exports.default = _default;

},{"../templates":235,"atom-dropdown":175,"atom-tooltip":180,"state":232,"tools":236}],190:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryPointFlyout = {
  init: function init() {
    this.rootSelector = '.cmscomponent-delivery-point-flyout';
    this.deliveryPointAbroadContainer = '.cmscomponent-delivery-point-flyout__abroad';
    this.dialogWarningSelector = '.cmscomponent-dialog-warning__container';
    this.dialogWarningButtonContainer = '.cmscomponent-dialog-warning__buttons';
    this.dialogWarningConfirm = '.cmscomponent-dialog-warning__confirm';
    this.deliveryPointToggleSelector = '.csstoggle--deliveryPoint';
    this.deliveryPointFlyoutOpenClass = 'cssflyout-open--deliveryPoint';
    this.selectDeliveryPoint = '.global-account-box-list';
    this.isSelectedClass = 'is-selected';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    this.bindToggleListener();
    this.bindSelectDeliveryPointListener();
  },
  bindToggleListener: function bindToggleListener() {
    var _this = this;

    var deliveryPointToggle = document.querySelector(this.deliveryPointToggleSelector);

    if (deliveryPointToggle !== null) {
      var clickWatcherDeliveryPointToggle = function clickWatcherDeliveryPointToggle(e) {
        if (!window.clickInside(e, 'cmscomponent-delivery-point-flyout')) {
          deliveryPointToggle.click();
        }
      };

      deliveryPointToggle.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.toggle(_this.deliveryPointFlyoutOpenClass);
        /**
         * Align flyout to toggle element (vue header behaviour)
         */

        var deliveryPointFlyout = document.querySelector(_this.rootSelector);

        if (document.body.clientWidth > 991) {
          var deliveryPointFlyoutWindowPositons = deliveryPointFlyout.parentElement.getBoundingClientRect();
          var toggleWidth = deliveryPointToggle.clientWidth;
          var toggleWindowPositons = deliveryPointToggle.getBoundingClientRect();
          deliveryPointFlyout.style.left = "".concat(toggleWindowPositons.left + toggleWidth - deliveryPointFlyout.offsetWidth - deliveryPointFlyoutWindowPositons.left, "px");
        } else {
          deliveryPointFlyout.style.left = null;
        }

        if (document.body.classList.contains(_this.deliveryPointFlyoutOpenClass)) {
          setTimeout(function () {
            document.addEventListener('click', clickWatcherDeliveryPointToggle);
          }, 100);
        } else {
          document.removeEventListener('click', clickWatcherDeliveryPointToggle);
        }
      });
    }
  },
  bindSelectDeliveryPointListener: function bindSelectDeliveryPointListener() {
    var _this2 = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (deliveryPointFlyout) {
      [].forEach.call(deliveryPointFlyout.querySelectorAll(_this2.selectDeliveryPoint), function (link) {
        if (!link.classList.contains(_this2.isSelectedClass)) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var form = link.closest('form');
            var customerId = e.currentTarget.dataset.target;

            if (form) {
              var customerIdInputField = form.elements.customerId;

              if (customerIdInputField && customerId) {
                customerIdInputField.value = customerId;

                if (form.closest(_this2.deliveryPointAbroadContainer)) {
                  var dialogWarning = document.querySelector(_this2.dialogWarningSelector);
                  var buttonContainer = dialogWarning.querySelector(_this2.dialogWarningButtonContainer);
                  var confirm = buttonContainer.querySelector(_this2.dialogWarningConfirm);
                  dialogWarning.classList.add(_state.default.VISIBLE);
                  confirm.querySelector('button').addEventListener('click', function (clickEvent) {
                    clickEvent.preventDefault();
                    form.submit();
                  });
                } else {
                  form.submit();
                }
              }
            }
          });
        }
      });
    });
  }
};
var _default = DeliveryPointFlyout;
exports.default = _default;

},{"state":232}],191:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogWarning = {
  init: function init() {
    this.rootSelector = '.cmscomponent-dialog-warning__container';
    this.dialogWarningCancel = '.cmscomponent-dialog-warning__cancel';
    this.dialogWarningButtonContainer = '.cmscomponent-dialog-warning__buttons';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (dialog) {
      [].forEach.call(dialog.querySelectorAll(_this.dialogWarningButtonContainer), function (buttons) {
        var cancelButton = buttons.querySelector(_this.dialogWarningCancel);
        cancelButton.querySelector('button').addEventListener('click', function (clickEvent) {
          clickEvent.preventDefault();
          dialog.classList.remove(_state.default.VISIBLE);
        });
      });
    });
  }
};
var _default = DialogWarning;
exports.default = _default;

},{"state":232}],192:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Faq = /*#__PURE__*/function () {
  function Faq(root) {
    _classCallCheck(this, Faq);

    this.root = root;
    this.animationDelay = 100;
    this.nav = this.root.querySelector('.cmscomponent-faq-nav');
    this.createNav();
  }

  _createClass(Faq, [{
    key: "createNav",
    value: function createNav() {
      var _this = this;

      this.root.querySelectorAll(Faq.moreInfoSelector).forEach(function (element) {
        var headline = element.querySelector(Faq.headlineSelector);

        if (headline && headline.textContent) {
          var listItem = document.createElement('li');
          var link = document.createElement('a');
          var linkLabel = document.createTextNode(headline.textContent);
          link.addEventListener('click', function () {
            _tools.default.scrollTo(headline, _this.animationDelay, true);
          });
          link.appendChild(linkLabel);
          listItem.appendChild(link);

          _this.nav.appendChild(listItem);
        }
      });
    }
  }], [{
    key: "initAll",
    value: function initAll() {
      Faq.instances = [];
      [].forEach.call(document.querySelectorAll(Faq.rootSelector), function (element) {
        Faq.init(element);
      });
    }
  }, {
    key: "init",
    value: function init(element) {
      var rootElement = element.classList.contains(Faq.rootClass) ? element : element.querySelector(Faq.rootSelector);

      if (rootElement) {
        Faq.instances.push(new Faq(rootElement));
      } else {
        console.warn("No ".concat(Faq.rootClass, " found in"), element);
      }
    }
  }]);

  return Faq;
}();

_defineProperty(Faq, "rootClass", 'cmscomponent-faq');

_defineProperty(Faq, "rootSelector", ".".concat(Faq.rootClass));

_defineProperty(Faq, "headlineSelector", '.atom-headline');

_defineProperty(Faq, "moreInfoSelector", '.cmscomponent-faq-content .cmscomponent-moreinfo');

_defineProperty(Faq, "instances", []);

var _default = Faq;
exports.default = _default;

},{"tools":236}],193:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _validation = require("../validation");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterSearch = {
  init: function init() {
    this.rootSelector = '.cmscomponent-filter-search';
    this.listSelector = '.cmscomponent-filter-search__list';
    this.inputContainerSelector = '.cmscomponent-filter-search__input';
    this.resultSelector = '.cmscomponent-filter-search__result';
    this.resultValueSelector = '.cmscomponent-filter-search__result-value';
    this.inputSelector = '.cmscomponent-filter-search__input .atom-input-element input';
    this.listItemSelector = '.cmscomponent-filter-search__list-item';
    this.dataLabelSelector = '[data-label]';
    this.dataValueSelector = '[data-value]';
    this.enterKey = 'Enter';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (component) {
      var suggestions = component.querySelector(_this.listSelector);
      var resultContainer = component.querySelector(_this.resultSelector);
      [].forEach.call(component.querySelectorAll(_this.inputSelector), function (inputField) {
        _this.bindInputListeners(component, inputField, suggestions, resultContainer);

        _this.bindListItemListener(suggestions, inputField, resultContainer);

        _this.bindResultClickListener(inputField, resultContainer, suggestions);

        _this.setPreselectedItem(suggestions, resultContainer, inputField);
      });
    });
  },
  setPreselectedItem: function setPreselectedItem(suggestions, resultContainer, inputField) {
    var selectedItem = this.findSelectedItem(suggestions);
    var inputContainer = inputField.closest(this.inputContainerSelector);

    if (selectedItem) {
      this.showResult(resultContainer, inputContainer, selectedItem);
    }
  },
  findSelectedItem: function findSelectedItem(suggestions) {
    var selectedItem;
    var listItems = suggestions.querySelectorAll(this.listItemSelector);

    for (var i = 0; i < listItems.length; i++) {
      if (listItems[i].classList.contains(_state.default.SELECTED)) {
        selectedItem = listItems[i];
      }
    }

    return selectedItem;
  },
  showAllItems: function showAllItems(listItems) {
    for (var i = 0; i < listItems.length; i++) {
      listItems[i].classList.remove(_state.default.HIDDEN);
    }
  },
  validate: function validate(inputField, hasSelectedItem) {
    var isInitial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var errors = [];
    var mainElement = inputField.closest('.atom-input');
    mainElement.classList.remove('error');

    if (inputField.getAttribute('required') && !hasSelectedItem && !isInitial) {
      errors.push({
        element: inputField,
        error: _validation.errorMessages.emptyRequired
      });
    }

    handleErrors(errors);
  },
  showResult: function showResult(resultContainer, inputContainer, selectedItem) {
    var hasSecondValue = !!selectedItem.querySelector(this.dataValueSelector);
    var label = selectedItem.querySelector(this.dataLabelSelector).dataset.label;
    var resultValueHTML = "<div class=\"cmscomponent-filter-search__value\">".concat(label, "</div>");

    if (hasSecondValue) {
      var value = selectedItem.querySelector(this.dataValueSelector).dataset.value;
      resultValueHTML = "<div class=\"cmscomponent-filter-search__label\">".concat(label, "</div>\n                         <div class=\"cmscomponent-filter-search__value is-uppercase\">").concat(value, "</div>");
    }

    var resultValueElement = resultContainer.querySelector(this.resultValueSelector);
    resultValueElement.innerHTML = resultValueHTML;
    inputContainer.classList.add(_state.default.HIDDEN);
    resultContainer.classList.add(_state.default.VISIBLE);
  },
  onEnter: function onEnter(inputField, suggestions, listItems, resultContainer) {
    var _this2 = this;

    inputField.addEventListener('keydown', function (e) {
      var selectedItem = _this2.findSelectedItem(suggestions);

      var filteredListItems = Object.values(listItems).filter(function (listItem) {
        return !listItem.classList.contains(_state.default.HIDDEN);
      });
      var inputContainer = inputField.closest(_this2.inputContainerSelector);

      if (e.key && e.key === _this2.enterKey) {
        if (selectedItem) {
          selectedItem.classList.remove(_state.default.SELECTED);
        }

        selectedItem = filteredListItems[0];
        inputField.value = selectedItem.dataset.key;
        selectedItem.classList.add(_state.default.SELECTED);
        suggestions.classList.remove(_state.default.VISIBLE);

        _this2.showResult(resultContainer, inputContainer, selectedItem);

        _this2.validate(inputField, true, false);
      }
    });
  },
  closeList: function closeList(suggestions, inputField, resultContainer, isInitial) {
    var selectedItem = this.findSelectedItem(suggestions);
    var inputContainer = inputField.closest(this.inputContainerSelector);

    if (selectedItem) {
      var selectedItemIdentifier = selectedItem.dataset.key;

      if (inputField.value !== selectedItemIdentifier) {
        inputField.value = selectedItemIdentifier;
      }

      this.showResult(resultContainer, inputContainer, selectedItem);
    }

    this.validate(inputField, selectedItem !== undefined, isInitial);
    suggestions.classList.remove(_state.default.VISIBLE);
  },
  bindInputListeners: function bindInputListeners(component, inputField, suggestions, resultContainer) {
    var _this3 = this;

    var filter;
    var isInitial = true;
    var listItems = suggestions.querySelectorAll(this.listItemSelector);
    inputField.addEventListener('focus', function () {
      filter = '';
      inputField.value = '';
      isInitial = false;

      _this3.showAllItems(listItems);

      if (!suggestions.classList.contains(_state.default.VISIBLE)) {
        var clickOutsideElement = inputField.closest(_this3.rootSelector);
        (0, _utils.addClickOutsideListener)(clickOutsideElement, function () {
          _this3.closeList(suggestions, inputField, resultContainer, isInitial);
        });
      }

      suggestions.classList.add(_state.default.VISIBLE);
    });
    inputField.addEventListener('keyup', function (e) {
      e.preventDefault();
      filter = inputField.value.toLowerCase();

      for (var i = 0; i < listItems.length; i++) {
        var value = listItems[i].textContent;

        if (value.toLowerCase().indexOf(filter) > -1) {
          listItems[i].classList.remove(_state.default.HIDDEN);
        } else {
          listItems[i].classList.add(_state.default.HIDDEN);
        }
      }
    });
    this.onEnter(inputField, suggestions, listItems, resultContainer);
  },
  bindListItemListener: function bindListItemListener(suggestions, inputField, resultContainer) {
    var _this4 = this;

    var listItems = suggestions.querySelectorAll(this.listItemSelector);
    [].forEach.call(listItems, function (listItem) {
      listItem.addEventListener('click', function (e) {
        e.preventDefault();
        var selectedItem = e.currentTarget;
        var inputContainer = inputField.closest(_this4.inputContainerSelector);
        listItems.forEach(function (item) {
          return item.classList.remove(_state.default.SELECTED);
        });

        _this4.showResult(resultContainer, inputContainer, selectedItem);

        _this4.validate(inputField, true, false);

        inputField.value = listItem.dataset.key;
        selectedItem.classList.add(_state.default.SELECTED);
        suggestions.classList.remove(_state.default.VISIBLE);
      });
    });
  },
  bindResultClickListener: function bindResultClickListener(inputField, resultContainer, suggestions) {
    var _this5 = this;

    resultContainer.addEventListener('click', function () {
      var inputContainer = inputField.closest(_this5.inputContainerSelector);
      inputContainer.classList.remove(_state.default.HIDDEN);
      resultContainer.classList.remove(_state.default.VISIBLE);
      inputField.focus();
    });
  }
};
var _default = FilterSearch;
exports.default = _default;

},{"../utils":237,"../validation":238,"state":232}],194:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireDefault(require("event-names"));

var _atomCheckbox = _interopRequireDefault(require("atom-checkbox"));

var _atomDropdown = _interopRequireDefault(require("atom-dropdown"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filter = {
  init: function init() {
    this.rootSelector = '.cmscomponent-filter';
    this.toggleSelector = '.cmscomponent-filter__toggle';
    this.contentSelector = '.cmscomponent-filter__content';
    this.filterItemsSelector = '.cmscomponent-filter__items';
    this.tagsSelector = '.cmscomponent-filter__tags';
    this.tagItemSelector = '.cmscomponent-filter__tags__category .atom-tag';
    this.expanderSelector = '.cmscomponent-filter__item-expander';
    this.bodyHtmlSelector = 'html, body';
    this.checkboxSelector = '.cmscomponent-filter__items > .atom-checkbox';
    this.optionsPlaceholder = '{options}';
    this.lastRoot = undefined;
    this.breakpointBelow = 'md';
    this.isInOpen = false;
    this.expandHeightThreshold = 90;
    this.expandOffsetTop = 20;
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (filter) {
      _this.initFilter(filter, true);

      _this.initCheckboxes(filter);
    });
    var body = document.querySelector('body');
    body.removeEventListener(_eventNames.default.CMSCOMPONENT_FILTER_CHANGED, this.handleChangeEvent.bind(this), false);
    body.addEventListener(_eventNames.default.CMSCOMPONENT_FILTER_CHANGED, this.handleChangeEvent.bind(this), false);
    body.removeEventListener(_eventNames.default.CMSCOMPONENT_FILTER_CLOSE, this.handleFilterClose.bind(this), false);
    body.addEventListener(_eventNames.default.CMSCOMPONENT_FILTER_CLOSE, this.handleFilterClose.bind(this), false);
    window.addEventListener('resize', function () {
      if (!_this.isInOpen) {
        _this.close();
      }

      _this.checkFilter();
    });
  },
  initCheckboxes: function initCheckboxes(root) {
    _atomCheckbox.default.reinitialize();

    _atomCheckbox.default.bindCustomListeners(root, this.checkboxSelector, this.handleCheckboxClick, this);
  },
  handleCheckboxClick: function handleCheckboxClick(root, checkbox) {
    var href = checkbox.dataset.href;

    if (href) {
      _tools.default.sendEvent(_eventNames.default.CMSCOMPONENT_FILTER_CHECKBOX_CHANGED, {
        filter: root,
        action: href
      });
    }
  },
  handleFilterClose: function handleFilterClose(e) {
    var filter = e.detail.message;

    if (filter) {
      this.handleClick(filter);
    }
  },
  checkFilter: function checkFilter() {
    var _this2 = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (filter) {
      if (_this2.hasExpander(filter)) {
        _this2.handleExpander(filter, true);
      }
    });
  },
  hasExpander: function hasExpander(filter) {
    return filter.classList.contains(_state.default.HAS_EXPANDER);
  },
  resetFilterItems: function resetFilterItems(filterItems) {
    [].forEach.call(filterItems.querySelectorAll(':scope > *'), function (item) {
      item.classList.remove(_state.default.HIDDEN);
      item.style.order = null;
    });
  },
  handleExpander: function handleExpander(filter, reset) {
    var _this3 = this;

    var expander = filter.querySelector(this.expanderSelector);
    var filterItems = expander.closest(this.filterItemsSelector);

    var mobile = _tools.default.screen(this.breakpointBelow, true);

    filter.classList.remove(_state.default.HAS_EXPANDER);
    filter.classList.remove(_state.default.EXPANDED);
    filterItems.classList.remove(_state.default.LOADED);

    if (reset) {
      this.resetFilterItems(filterItems);
    }

    if (this.canExpand(filterItems)) {
      filter.classList.add(_state.default.HAS_EXPANDER);

      if (!mobile) {
        this.prepareExpander(filterItems);

        if (!reset) {
          expander.addEventListener('click', function () {
            _this3.handleExpanderClick(filter, filterItems);
          });
        }
      }
    } else {
      filterItems.classList.add(_state.default.LOADED);
    }
  },
  handleExpanderClick: function handleExpanderClick(filter, filterItems) {
    if (filterItems !== null) {
      filter.classList.add(_state.default.EXPANDED);
      filter.classList.remove(_state.default.HAS_EXPANDER);
      [].forEach.call(filterItems.querySelectorAll('.' + _state.default.HIDDEN), function (hiddenItem) {
        hiddenItem.classList.remove(_state.default.HIDDEN);
      });
    }
  },
  initFilter: function initFilter(filter, firstTime, hasExpander) {
    var _this4 = this;

    if (firstTime === true) {
      [].forEach.call(filter.querySelectorAll(this.toggleSelector), function (toggle) {
        toggle.addEventListener('click', function () {
          _this4.handleClick(filter);
        });
      });
    }

    if (firstTime || hasExpander) {
      this.handleExpander(filter);
    }

    [].forEach.call(filter.querySelectorAll(this.tagItemSelector), function (item) {
      item.addEventListener('click', _this4.handleTagItemClick.bind(_this4, filter));
    });
  },
  prepareExpander: function prepareExpander(filterItems) {
    var lastPosition;
    var orders = [];

    for (var i = 0; i < filterItems.children.length; i++) {
      var item = filterItems.children[i];
      var isExpander = item.classList.contains('max-items');

      if (item.offsetTop > this.expandOffsetTop) {
        if (!lastPosition) {
          lastPosition = i;
        }
      }

      if (isExpander) {
        item.style.order = lastPosition;
      }

      if (lastPosition && !isExpander) {
        item.classList.add(_state.default.HIDDEN);
        orders[i + 1] = item;
      } else if (!isExpander) {
        orders[i] = item;
      }
    }

    for (var _i = 0; _i < orders.length; _i++) {
      var order = orders[_i];

      if (order) {
        order.style.order = _i;
      }
    }

    filterItems.classList.add(_state.default.LOADED);
  },
  canExpand: function canExpand(filterItems) {
    return filterItems.scrollHeight > this.expandHeightThreshold;
  },
  handleChangeEvent: function handleChangeEvent(e) {
    var root = e.detail.root;
    var filterData = e.detail.filterData;
    var currentSelect = e.detail.currentSelect;
    this.updateFilter(root, filterData, currentSelect);
  },
  handleClick: function handleClick(element) {
    var content = element.querySelector(this.contentSelector);

    if (content.classList.contains(_state.default.OPEN)) {
      this.close(content);
    } else {
      this.lastRoot = element.closest(this.rootSelector);
      this.open(content);
    }
  },
  close: function close(content) {
    var selectedContent = content || document.querySelector(this.rootSelector + ' ' + this.contentSelector + '.' + _state.default.OPEN);

    if (selectedContent !== null) {
      selectedContent.classList.remove(_state.default.OPEN);
    }

    this.enableScrolling();
    this.isInOpen = false;
  },
  open: function open(content) {
    var _this5 = this;

    this.isInOpen = true;
    content.classList.add(_state.default.OPEN);
    this.disableScrolling();

    var handleEnd = function handleEnd() {
      _this5.isInOpen = false;
    };

    content.removeEventListener('transitionend', handleEnd);
    content.addEventListener('transitionend', handleEnd);
  },
  getCategoriesTemplate: function getCategoriesTemplate(data) {
    var items = data.tagCategories && data.tagCategories.map(function (item) {
      var tags = item.tags.map(function (element) {
        var tag = element.tag;
        return "\n          <a data-target=\"".concat(tag.uniqueItemId, "\" href=\"").concat(tag.href, "\" class=\"atom-tag ").concat(tag.styleModifier, "\">\n            <span class=\"atom-tag-text\">").concat(tag.text, "</span>\n            <svg class=\"icon-no\" xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\">\n              <polygon points=\"42 4.247 37.753 0 21 16.753 4.247 0 0 4.247 16.753 21 0 37.753 4.247 42 21 25.247 37.753 42 42 37.753 25.247 21 42 4.247\"/>\n            </svg>\n          </a>\n        ");
      }).join('');
      return "\n        <div class=\"cmscomponent-filter__tags__category\">\n          ".concat(item.name ? "\n            <span class=\"cmscomponent-filter__tags__label inline-block\">".concat(item.name, ":</span>\n          ") : '', "\n          ").concat(tags, "\n        </div>\n      ");
    }).join('');

    if (items === undefined) {
      items = '';
    }

    return "\n      <div class=\"cmscomponent-filter__tags ".concat(data.tagCategories ? '' : 'is-empty', "\">\n        ").concat(items, "\n      </div>\n    ");
  },
  updateFilter: function updateFilter(root, filterData, currentSelect) {
    var template = root.querySelector('#template-cmscomponent-filter__items');
    var itemTemplate = root.querySelector('#template-cmscomponent-filter__item');
    var checkboxTemplate = root.querySelector('#template-cmscomponent-filter__checkbox');
    var tags = root.querySelector(this.tagsSelector);
    var minLength = 100;

    if (itemTemplate && itemTemplate.innerHTML.length > minLength) {
      if (template) {
        var templateClone = template.innerHTML;
        var items = '';

        for (var i = 0; i < filterData.items.length; i++) {
          var item = filterData.items[i];

          if (item) {
            if (item.dropdown) {
              items += this.handleDropdownItem(itemTemplate, item);
            } else {
              items += this.handleCheckboxItem(checkboxTemplate, item);
            }
          }
        }

        tags.outerHTML = this.getCategoriesTemplate(filterData);
        templateClone = templateClone.replace(/{items}/g, items);
        this.setNewFilterMarkup(root, templateClone, currentSelect);
      }
    } else {
      console.debug('baseFilter not set.');
    }
  },
  setOptionsPlaceholder: function setOptionsPlaceholder(item) {
    var start = item.indexOf('<option');
    var end = item.indexOf('</option>');
    var newText = item;

    if (start && end) {
      newText = item.slice(0, start) + this.optionsPlaceholder + item.slice(end, item.length);
    }

    return newText;
  },
  handleTagItemClick: function handleTagItemClick(filterRoot, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var current = e.currentTarget;
    var href = current.getAttribute('href');

    _tools.default.sendEvent(_eventNames.default.CMSCOMPONENT_FILTER_TAG_CHANGED, {
      filter: filterRoot,
      action: href
    });
  },
  handleCheckboxItem: function handleCheckboxItem(template, itemData) {
    return _atomCheckbox.default.interpolate(template, itemData.checkbox);
  },
  handleDropdownItem: function handleDropdownItem(template, itemData) {
    var itemTemplate = $(template.innerHTML);
    var optionTemplate = $(itemTemplate.find('option'))[0].outerHTML;
    var dropdownData = itemData.dropdown;
    var item = template.innerHTML;
    var options = '';
    var type = dropdownData.isColor ? 'is-color' : '';
    item = this.setOptionsPlaceholder(item);
    item = item.replace('atom-dropdown checkbox', 'atom-dropdown checkbox ' + type);
    item = item.interpolate({
      name: dropdownData.name,
      label: dropdownData.label
    });

    for (var prop in dropdownData) {
      if (prop === 'items') {
        for (var i = 0; i < dropdownData.items.length; i++) {
          var itemObj = dropdownData.items[i];

          if (itemObj) {
            var selectedMatch = 'selected="selected"';
            var selected = itemObj.isSelected ? selectedMatch : '';
            selected = selected + ' data-href="' + itemObj.href + '"';

            if (itemObj.background && itemObj.foreground) {
              selected = selected + ' data-background="' + itemObj.background + '" data-foreground="' + itemObj.foreground + '"';
            }

            var newOption = '' + optionTemplate;
            newOption = '' + newOption.replace(selectedMatch, selected);
            options = options + newOption.interpolate({
              key: itemObj.key,
              value: itemObj.value
            });
          }
        }
      }
    }

    item = item.replace(/{options}/g, options);
    return item;
  },
  setNewFilterMarkup: function setNewFilterMarkup(root, markup, currentSelect) {
    var _this6 = this;

    var items = root.querySelector(this.filterItemsSelector);

    if (items) {
      var hasExpander = this.hasExpander(root);
      items.innerHTML = markup;
      this.reinitComponents(items, root, hasExpander);

      if (currentSelect) {
        var name = currentSelect.getAttribute('name');
        var dropdown = root.querySelector('[name="' + name + '"');

        if (dropdown) {
          var parent = dropdown.closest('.atom-dropdown');
          var label = parent.querySelector('.atom-dropdown-label');
          var jsDropdown = parent.querySelector('.js-Dropdown');

          var handleEnd = function handleEnd(e) {
            if (e.propertyName === 'transform') {
              _this6.disableMobileLoading(root);
            }
          };

          jsDropdown.removeEventListener('transitionend', handleEnd);
          jsDropdown.addEventListener('transitionend', handleEnd);

          if (_tools.default.screen(this.breakpointBelow)) {
            this.enableMobileLoading(root);
          }

          label.click();
        }
      }
    }
  },
  enableMobileLoading: function enableMobileLoading(root) {
    root.classList.add(_state.default.LOADING);
  },
  disableMobileLoading: function disableMobileLoading(root) {
    root.classList.remove(_state.default.LOADING);
  },
  reinitComponents: function reinitComponents(items, root, hasExpander) {
    _atomDropdown.default.reinitialize(items);

    this.initFilter(root, false, hasExpander);
    this.initCheckboxes(root);
  },
  disableScrolling: function disableScrolling() {
    _tools.default.disableScrolling();
  },
  enableScrolling: function enableScrolling() {
    _tools.default.enableScrolling();

    if (this.lastRoot) {
      _tools.default.scrollToInstant(this.lastRoot);
    }
  }
};
var _default = Filter;
exports.default = _default;

},{"atom-checkbox":173,"atom-dropdown":175,"event-names":224,"state":232,"tools":236}],195:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _templates = _interopRequireDefault(require("templates"));

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormRegistration = {
  init: function init() {
    var _this = this;

    this.defineSelectors();

    if (this.checkRoot()) {
      _tools.default.loadComplete(function () {
        _this.displayNoneElements = _tools.default.removeRequiredForDisplayNoneElements(_this.root);

        _this.setIsNew();

        _this.onSubmit();

        _this.showInitialAlert();
      });
    }
  },
  setIsNew: function setIsNew() {
    var _document$querySelect;

    this.isNew = ((_document$querySelect = document.querySelector(this.form)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.openOnLoad) || false;

    if (this.isNew) {
      // Expand registration form on startup
      this.responseNewRegistration();
    }
  },
  checkRoot: function checkRoot() {
    return !!document.querySelector(this.root);
  },
  getCredentialsUrl: function getCredentialsUrl() {
    var _document$querySelect2;

    return (_document$querySelect2 = document.querySelector(this.form)) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.dataset.checkCredentialsUrl;
  },
  startLoadingAnimation: function startLoadingAnimation() {
    var _document$querySelect3;

    (_document$querySelect3 = document.querySelector(this.form)) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.classList.add(this.isLoading);
  },
  stopLoadingAnimation: function stopLoadingAnimation() {
    var _document$querySelect4;

    (_document$querySelect4 = document.querySelector(this.form)) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.classList.remove(this.isLoading);
  },
  responseNewRegistration: function responseNewRegistration() {
    var _document$querySelect5;

    (_document$querySelect5 = document.querySelector(this.root)) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.classList.add(this.showNew);

    _tools.default.giveBackRequiredToFormerDisplayNoneElements(this.displayNoneElements);

    document.querySelector(this.submitText).innerHTML = document.querySelector(this.registerButtonText).innerHTML;
    document.querySelectorAll("".concat(this.initial, " input")).forEach(function (el) {
      return el.setAttribute('disabled', 'disabled');
    });
  },
  beforeSubmit: function beforeSubmit() {
    document.querySelectorAll("".concat(this.initial, " input")).forEach(function (el) {
      return el.removeAttribute('disabled');
    });
  },
  getRenderedAtomAlert: function getRenderedAtomAlert(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('atoms-alert', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  showInitialAlert: function showInitialAlert() {
    var atomAlert = document.querySelector(this.atomAlert);

    if (atomAlert) {
      this.showAlert();
    } else {
      this.hideAlert();
    }
  },
  showAlert: function showAlert() {
    var formAlert = document.querySelector(this.formAlert);

    if (formAlert) {
      formAlert.classList.add(_state.default.VISIBLE);
    }
  },
  hideAlert: function hideAlert() {
    var formAlert = document.querySelector(this.formAlert);

    if (formAlert) {
      formAlert.classList.remove(_state.default.VISIBLE);
    }
  },
  createAlert: function createAlert(data) {
    var _this2 = this;

    var formAlert = document.querySelector(this.formAlert);

    if (formAlert) {
      this.getRenderedAtomAlert(data).then(function (html) {
        formAlert.innerHTML = html;

        _this2.showAlert();
      });
    }
  },
  handleAlert: function handleAlert(data) {
    if (data.message && data.atomAlertType) {
      var alertData = {
        alert: {
          styleModifier: data.atomAlertType,
          message: data.message
        }
      };
      this.createAlert(alertData);
    } else {
      this.hideAlert();
    }
  },
  handleNewRegistration: function handleNewRegistration(data) {
    if (data.new !== undefined) {
      this.responseNewRegistration();
      this.isNew = true;
    }
  },
  handleSubmit: function handleSubmit(form, data) {
    if (data.immediateSubmit) {
      this.beforeSubmit();
      form.submit();
    }
  },
  onSubmit: function onSubmit() {
    var _this3 = this;

    var form = document.querySelector(this.form);
    window.prepareFormForValidation(form);

    if (form) {
      form.addEventListener('submit', function (e) {
        window.validateForm(document.querySelector(_this3.form), e, function (hasError) {
          // Submit form natively if there is no error
          if (hasError || form.classList.contains('form--has-error')) {
            e.preventDefault();
          } // Check for user credentials to potentially expand the form


          if (!_this3.isNew && !hasError) {
            _this3.startLoadingAnimation();

            _tools.default.service(_this3.getCredentialsUrl(), 'POST', new URLSearchParams({
              customerId: document.querySelector(_this3.customerId).value,
              mail: document.querySelector(_this3.mail).value
            }).toString(), undefined, form).then(function (response) {
              response.json().then(function (data) {
                _this3.stopLoadingAnimation();

                _this3.handleAlert(data);

                if (data.atomAlertType && data.message) {
                  var _document$querySelect6;

                  (_document$querySelect6 = document.querySelector(_this3.form)) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.classList.add('form--has-error');
                } else {
                  var _document$querySelect7;

                  (_document$querySelect7 = document.querySelector(_this3.form)) === null || _document$querySelect7 === void 0 ? void 0 : _document$querySelect7.classList.remove('form--has-error');
                }

                _this3.handleNewRegistration(data);

                if (!data.atomAlertType && !data.message) {
                  _this3.handleSubmit(form, data);
                }
              });
            });
          }

          _this3.beforeSubmit();
        });
      });
    }
  },
  defineSelectors: function defineSelectors() {
    this.root = '.cmscomponent-form-registration';
    this.form = '.cmscomponent-form-registration__form';
    this.formAlert = '.cmscomponent-form-registration__alert';
    this.alert = "".concat(this.root, " .atom-alert-message");
    this.customerId = "".concat(this.root, " #input_customerId");
    this.mail = "".concat(this.root, " #input_mail");
    this.isLoading = 'is-loading';
    this.initial = '.cmscomponent-form-registration__initial';
    this.new = '.cmscomponent-form-registration__new';
    this.showNew = 'cmscomponent-form-registration--new';
    this.registerButtonText = '.cmscomponent-form-registration__register-button-text';
    this.submitText = "".concat(this.root, " [type=submit] span");
    this.atomAlert = "".concat(this.root, " .atom-alert");
  }
};
var _default = FormRegistration;
exports.default = _default;

},{"state":232,"templates":235,"tools":236}],196:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FormServiceTicket = {
  init: function init() {
    this.rootSelector = '.cmscomponent-form-serviceticket';
    this.closeSelector = '.cmscomponent-form-serviceticket-newcomment-textarea-close';
    this.textareaWrapperSelector = '.cmscomponent-form-serviceticket-newcomment-textarea-wrapper';
    this.deleteSelector = '.cmscomponent-uploadfile-upload-delete';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      root.addEventListener('reset', _this.handleReset.bind(_this, root));
      [].forEach.call(root.querySelectorAll(_this.closeSelector), function (close) {
        close.addEventListener('click', _this.handleCloseClick.bind(_this, close));
      });
    });
  },
  handleReset: function handleReset(root) {
    [].forEach.call(root.querySelectorAll(this.deleteSelector), function (deleteBtn) {
      deleteBtn.click();
    });
  },
  handleCloseClick: function handleCloseClick(close) {
    var textarea = close.closest(this.textareaWrapperSelector).querySelector('.atom-textarea textarea');

    if (textarea) {
      textarea.value = '';
    }
  }
};
var _default = FormServiceTicket;
exports.default = _default;

},{}],197:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FormTextarea = {
  init: function init() {
    this.rootSelector = '.cmscomponent-form__textarea';
    this.closeSelector = '.cmscomponent-form__textarea-close';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      root.querySelector(_this.closeSelector).addEventListener('click', _this.handleCloseClick.bind(_this, root));
    });
  },
  handleCloseClick: function handleCloseClick(root) {
    var textarea = root.querySelector('.atom-textarea textarea');

    if (textarea) {
      textarea.value = '';
    }
  }
};
var _default = FormTextarea;
exports.default = _default;

},{}],198:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _cmscomponentLoginFlyout = _interopRequireDefault(require("cmscomponent-login-flyout"));

var _simpleLightbox = _interopRequireDefault(require("../simple-lightbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderExtended = {
  init: function init() {
    this.rootSelector = 'header';
    this.extendedSelector = 'header-extended';
    this.navItemsSelector = '.navitems';
    this.navItemSelector = '.navitem';
    this.flyoutClass = 'header-flyout';
    this.flyoutSelector = '.' + this.flyoutClass;
    this.bodySelector = 'body';
    this.flyoutContentSelector = '.cmscomponent-flyout';
    this.columnLinkSelector = '.cmscomponent-flyout-column a';
    this.backSelector = '.cmscomponent-flyout-back';
    this.headlineSelector = '.cmscomponent-entry-headline';
    this.entryListSelector = '.cmscomponent-entry-list';
    this.entryListBackSelector = '.cmscomponent-entry-list-back';
    this.entryListBackTextSelector = '.cmscomponent-entry-list-back-text';
    this.backTextSelector = '.cmscomponent-flyout-back-text';
    this.loginFlyoutSelector = '.cmscomponent-login-flyout .atom-dialog-content';
    this.headerCssNavigationSelector = '.header__css-navigation';
    this.cssToggleSelector = '.csstoggle:not(.csstoggle--deliveryPoint)';
    this.cssFlyoutOpenClass = 'cssflyout-open';
    this.lastOpenedItem;
    this.lastOpenedFlyout;
    this.lastDrillDownItem;
    this.currentDepth = 0;
    this.naviBreakpoint = 'lg';
    this.smallClass = 'is-small';
    this.bindListeners(); // expose closeFlyout

    window.headerExtendedCloseFlyout = this.closeFlyout.bind(this);
  },
  isExtended: function isExtended(element) {
    return element.classList.contains(this.extendedSelector);
  },
  getFlyoutByItem: function getFlyoutByItem(item) {
    return item.nextElementSibling;
  },
  getEntryListByItem: function getEntryListByItem(item) {
    var $parent = $(item).parent(this.headlineSelector);
    return $parent.next(this.entryListSelector);
  },
  hasFlyout: function hasFlyout(item) {
    var flyout = this.getFlyoutByItem(item);
    return flyout && flyout.classList.contains(this.flyoutClass);
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (element) {
      if (_this.isExtended(element)) {
        [].forEach.call(element.querySelectorAll(_this.navItemSelector), function (item) {
          if (_this.hasFlyout(item)) {
            item.addEventListener('mouseover', function (e) {
              if (_this.isLargeBreakpoint()) {
                _this.openNavItem(e);
              }
            });
            item.addEventListener('click', function (e) {
              if (_this.isSmallBreakpoint()) {
                _this.openNavItem(e);
              } else {
                e.preventDefault();
                e.stopImmediatePropagation();
              }
            });
          }
        });
        [].forEach.call(element.querySelectorAll(_this.columnLinkSelector), function (link) {
          link.addEventListener('click', function (e) {
            if (_this.isSmallBreakpoint()) {
              _this.clickColumnLink(e);
            }
          });
        });

        var backLinkClick = function backLinkClick(link) {
          link.addEventListener('click', function (e) {
            if (_this.isSmallBreakpoint()) {
              _this.clickBack(e);
            }
          });
        };

        [].forEach.call(element.querySelectorAll(_this.backSelector), backLinkClick);
        [].forEach.call(element.querySelectorAll(_this.entryListBackSelector), backLinkClick);
      }

      var headerCssNavigation = element.querySelector(_this.headerCssNavigationSelector);

      if (headerCssNavigation && headerCssNavigation.getAttribute('href')) {
        headerCssNavigation.addEventListener('click', _this.handleLoginFlyout.bind(_this, element));
      }

      document.querySelector(_this.bodySelector).addEventListener('mouseover', function (e) {
        if (e.currentTarget.classList.contains(_state.default.EXPANDED) && _this.isExtended(element)) {
          if (_this.lastOpenedFlyout) {
            var flyout = _this.getFlyoutByItem(_this.lastOpenedItem);

            var parent = _this.lastOpenedFlyout.parentElement;

            if (flyout.classList.contains(_state.default.OPEN) && !_tools.default.isChildOf(parent, e.target)) {
              _this.closeFlyout(_this.lastOpenedItem, flyout);
            }
          }
        }
      });
    });
    this.bindCssFlyout();
  },
  handleLoginFlyout: function handleLoginFlyout(root, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var loginFlyout = root.querySelector(this.loginFlyoutSelector);

    if (loginFlyout) {
      _simpleLightbox.default.open({
        element: loginFlyout,
        beforeClose: function beforeClose() {
          _cmscomponentLoginFlyout.default.resetLoginFlyout(loginFlyout);
        }
      });
    }
  },
  bindCssFlyout: function bindCssFlyout() {
    var _this2 = this;

    var cssToggle = document.querySelector(this.cssToggleSelector);

    if (cssToggle !== null) {
      var clickWatcher = function clickWatcher(e) {
        if (!window.clickInside(e, 'header-cssitems')) {
          cssToggle.click();
        }
      };

      cssToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var href = e.currentTarget.getAttribute('href');

        if (href === null) {
          var body = document.querySelector(_this2.bodySelector);
          body.classList.toggle(_this2.cssFlyoutOpenClass);

          if (body.classList.contains(_this2.cssFlyoutOpenClass)) {
            setTimeout(function () {
              document.addEventListener('click', clickWatcher);
            }, 100);
          } else {
            document.removeEventListener('click', clickWatcher);
          }
        } else {
          window.location.href = href;
        }
      });
    }
  },
  closeFlyout: function closeFlyout(item, flyout) {
    var myItem = item;
    var myFlyout = flyout;

    if (myItem === undefined) {
      myItem = this.lastOpenedItem;
    }

    if (myFlyout === undefined) {
      myFlyout = this.lastOpenedFlyout;
    }

    if (myFlyout !== undefined) {
      myFlyout.classList.remove(_state.default.OPEN);

      if (this.isSmallBreakpoint()) {
        myFlyout.classList.remove(this.smallClass);
      }
    }

    if (myItem !== undefined) {
      myItem.classList.remove(_state.default.ACTIVE);
      this.resetNavItems(myItem);
    }

    if (flyout !== undefined) {
      this.resetLastFlyout(flyout, item);
    }

    this.lastOpenedFlyout = undefined;
    this.disableBodyClick();
  },
  resetNavItems: function resetNavItems(item) {
    var $navItems = $(item).parents(this.navItemsSelector);
    this.currentDepth = 0;
    [].forEach.call($navItems[0].querySelectorAll(this.entryListSelector), function (list) {
      list.classList.remove(_state.default.OPEN);
    });
    $navItems.css('transform', '');
  },
  setFlyoutContentHeight: function setFlyoutContentHeight(flyout) {
    var content = flyout.querySelector(this.flyoutContentSelector);
    var height = 0;

    if (content) {
      var delay = 21;

      var onTransitionEnd = function onTransitionEnd() {
        content.style.height = '';
        content.classList.add(_state.default.LOADED);
        content.removeEventListener('transitionend', onTransitionEnd);
      };

      height = content.clientHeight;

      if (this.isLargeBreakpoint()) {
        content.addEventListener('transitionend', onTransitionEnd);
        content.classList.add(_state.default.LOADING);
        setTimeout(function () {
          // force redraw
          content.style.height = height + 'px';
        }, delay);
      } else {
        onTransitionEnd();
      }
    }
  },
  resetLastFlyout: function resetLastFlyout(flyout, item) {
    if (flyout) {
      flyout.classList.remove(_state.default.OPEN);
    }

    if (item) {
      item.classList.remove(_state.default.ACTIVE);
    }

    if (flyout) {
      var content = flyout.querySelector(this.flyoutContentSelector);

      if (content) {
        content.classList.remove(_state.default.LOADING);
        content.classList.remove(_state.default.LOADED);
        content.style.height = '';
      }
    }

    this.lastOpenedFlyout = undefined;
  },
  openFlyout: function openFlyout(item, flyout) {
    if (flyout !== this.lastOpenedFlyout) {
      if (this.lastOpenedFlyout && flyout) {
        this.resetLastFlyout(this.lastOpenedFlyout, this.lastOpenedItem);
      }

      flyout.classList.add(_state.default.OPEN);
      this.setFlyoutContentHeight(flyout);

      if (this.isSmallBreakpoint()) {
        flyout.classList.add(this.smallClass);
      }

      if (this.isLargeBreakpoint()) {
        this.enableBodyClick();
        this.resetNavItems(item);
      }

      item.classList.add(_state.default.ACTIVE);
      this.lastOpenedFlyout = flyout;
      this.lastOpenedItem = item;
      this.setBackText(item, flyout);
      this.drillDown(item);
    }
  },
  toggleFlyout: function toggleFlyout(item) {
    var flyout = this.getFlyoutByItem(item);

    if (flyout.classList.contains(_state.default.OPEN)) {
      this.closeFlyout(item, flyout);
    } else {
      this.openFlyout(item, flyout);
    }
  },
  isLargeBreakpoint: function isLargeBreakpoint() {
    return _tools.default.screen('lg', false);
  },
  isSmallBreakpoint: function isSmallBreakpoint() {
    return _tools.default.screen(this.naviBreakpoint);
  },
  drillDown: function drillDown(item) {
    if (this.isSmallBreakpoint()) {
      this.currentDepth++;
      this.lastDrillDownItem = item;
      this.changeDrillDownPosition(item);
    }
  },
  drillUp: function drillUp(item) {
    if (this.isSmallBreakpoint()) {
      this.currentDepth--;
      var $entryList = this.getEntryListByItem(this.lastDrillDownItem);

      if ($entryList.length > 0) {
        $entryList.removeClass(_state.default.OPEN);
      }

      this.changeDrillDownPosition(item);
    }
  },
  changeDrillDownPosition: function changeDrillDownPosition(item) {
    var $current = $(item);
    var $navItems = $current.parents(this.navItemsSelector);
    var drillDownWidth = 100;
    var startPosition = 0;
    var position = this.currentDepth > 0 ? -(this.currentDepth * drillDownWidth) : startPosition;
    $navItems.css({
      transform: 'translateX(' + position + '%)'
    });
  },
  enableBodyClick: function enableBodyClick() {
    document.querySelector(this.bodySelector).classList.add(_state.default.EXPANDED);
  },
  disableBodyClick: function disableBodyClick() {
    document.querySelector(this.bodySelector).classList.remove(_state.default.EXPANDED);
  },
  openNavItem: function openNavItem(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.openFlyout(e.currentTarget, this.getFlyoutByItem(e.currentTarget));
  },
  clickColumnLink: function clickColumnLink(e) {
    var current = e.currentTarget;
    var $entryList = this.getEntryListByItem(current);

    if (!current.classList.contains(_state.default.EMPTY)) {
      if ($entryList.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.setBackText(e.currentTarget, $entryList[0]);
        $entryList.addClass(_state.default.OPEN);
        this.drillDown(e.currentTarget);
      }
    }
  },
  clickBack: function clickBack(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.drillUp(this.lastOpenedItem);

    if (this.currentDepth === 0) {
      this.toggleFlyout(this.lastOpenedItem);
    }
  },
  setBackText: function setBackText(item, parent) {
    if (this.isSmallBreakpoint()) {
      var back = parent.querySelector(this.backSelector + ', ' + this.entryListBackSelector);

      if (back !== null) {
        back.querySelector(this.backTextSelector + ', ' + this.entryListBackTextSelector).innerText = item.innerText;
      }
    }
  }
};
var _default = HeaderExtended;
exports.default = _default;

},{"../simple-lightbox":231,"cmscomponent-login-flyout":199,"state":232,"tools":236}],199:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginFlyout = {
  init: function init() {
    this.rootSelector = '.cmscomponent-login-flyout';
    this.cancelSelector = '.atom-dialog-button-cancel button';
    this.submitSelector = '.atom-dialog-button-submit button';
    this.alertSelector = '.atom-alert';
    this.alertMessageSelector = '.atom-alert-message';
    this.formSelector = '.cmscomponent-login-flyout__form';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.formSelector), function (form) {
      var cancel = form.querySelector(_this.cancelSelector);

      if (cancel) {
        cancel.addEventListener('click', _this.handleCancel.bind(_this));
      }

      form.addEventListener('submit', _this.handleSubmit.bind(_this, form));
      var submit = form.querySelector(_this.submitSelector);

      if (submit) {
        submit.addEventListener('click', _this.handleSubmit.bind(_this, form));
      }
    });
  },
  validate: function (_validate) {
    function validate(_x) {
      return _validate.apply(this, arguments);
    }

    validate.toString = function () {
      return _validate.toString();
    };

    return validate;
  }(function (form) {
    var hasErrors = false;
    [].forEach.call(form.querySelectorAll('input'), function (element) {
      var errors = validate(element);

      if (errors.length > 0) {
        window.handleErrors(errors);
        hasErrors = true;
      }
    });
    return hasErrors;
  }),
  handleSubmit: function handleSubmit(form, e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    var hasErrors = this.validate(form);

    if (!hasErrors) {
      this.handleRequest(form);
    }
  },
  handleCancel: function handleCancel() {
    var _window$openSimpleLig;

    (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
  },
  handleRequest: function handleRequest(form) {
    var _this2 = this;

    _tools.default.setLoading(true, form);

    _tools.default.disableSimpleLightbox();

    this.hideAlert(form);
    var action = form.getAttribute('action');

    var formData = _tools.default.getFormData(form, false);

    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest'
    };

    _tools.default.service(action, 'POST', formData, headers, form).then(function (response) {
      var isError = response.headers.get('Y-LOGIN-FAILED');

      _tools.default.enableSimpleLightbox();

      if (!isError) {
        _tools.default.redirect(form.getAttribute('data-target-url'));
      } else {
        response.json().then(function (json) {
          if (json.shouldRedirect && json.redirectUrl) {
            _tools.default.redirect(json.redirectUrl);
          } else {
            _this2.handleErrorJson(form, json);
          }
        }).catch(function () {
          _this2.showError(form);
        });
      }
    }).catch(function () {
      _this2.showError(form);
    });
  },
  hideAlert: function hideAlert(form) {
    var alert = form.querySelector(this.alertSelector);

    if (alert) {
      alert.classList.remove(_state.default.VISIBLE);
    }
  },
  setAlert: function setAlert(form, message) {
    var alert = form.querySelector(this.alertSelector);

    if (alert) {
      var alertMessage = alert.querySelector(this.alertMessageSelector);
      alertMessage.innerHTML = message;
      alert.classList.add(_state.default.VISIBLE);
    }
  },
  handleErrorJson: function handleErrorJson(form, json) {
    if (json.status === false) {
      if (json.error) {
        this.setAlert(form, json.error);
      } else {
        this.showError(form);
      }
    } else {
      this.showError(form);
    }

    _tools.default.setLoading(false, form);
  },
  showError: function showError(form) {
    var errorMessage = form.dataset.genericError;

    if (errorMessage) {
      this.setAlert(form, errorMessage);
    }

    _tools.default.setLoading(false, form);
  },
  resetLoginFlyout: function resetLoginFlyout(flyout) {
    var alert = flyout.querySelector('.atom-alert.warning');

    if (alert) {
      alert.classList.remove(_state.default.VISIBLE);
    }

    [].forEach.call(flyout.querySelectorAll('.cmscomponent-login-flyout__form-content .atom-input'), function (input) {
      input.classList.remove(_state.default.ERROR);
    });
  }
};
var _default = LoginFlyout;
exports.default = _default;

},{"state":232,"tools":236}],200:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Marquee = {
  init: function init() {
    this.rootSelector = '.cmscomponent-marquee';
    this.contentSelector = '.cmscomponent-marquee-contents';
    this.cloneContentClass = 'cmscomponent-marquee-clonecontents';
    this.cloneContentSelector = '.' + this.cloneContentClass;
    this.containerSelector = '.cmscomponent-marquee-container';
    this.startAnimation();
  },
  startAnimation: function startAnimation() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (el) {
      var clientWidth = $(window).outerWidth();
      var factor = 2;
      var minWidth = clientWidth * factor;
      var content = $(el).find(_this.contentSelector);

      _this.cloneChildren(el, content, minWidth);

      var cloneContainer = $(el).find(_this.contentSelector).clone().attr('class', _this.cloneContentClass);
      $(el).find(_this.containerSelector).append(cloneContainer);
      var marqueeContentsOuterWidth = $(el).find(_this.contentSelector).outerWidth();
      $(el).find(_this.containerSelector).width(marqueeContentsOuterWidth);
      setTimeout(function () {
        $(_this.contentSelector + ', ' + _this.cloneContentSelector).addClass(_state.default.READY);
      }, 200);
    });
  },
  cloneChildren: function cloneChildren(el, content, minWidth) {
    var contentWidth = content.outerWidth();

    if (minWidth > contentWidth) {
      var clonedChildren = content.children().clone();
      $(el).find(this.contentSelector).append(clonedChildren);
      var newContent = $(el).find(this.contentSelector);
      contentWidth = newContent.outerWidth();

      if (minWidth > contentWidth) {
        this.cloneChildren(el, newContent, minWidth);
      }
    }
  }
};
var _default = Marquee;
exports.default = _default;

},{"state":232}],201:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireWildcard(require("event-names"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = {
  init: function init() {
    this.rootClass = 'cmscomponent-pagination';
    this.rootSelector = ".".concat(this.rootClass, "[data-ajax]");
    this.linkSelector = 'a';
    this.updateSelectors = ['.cmscomponent-pagination-first', '.cmscomponent-pagination-previous', '.cmscomponent-pagination-label', '.cmscomponent-pagination-next', '.cmscomponent-pagination-last'];
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    var body = document.querySelector('body');
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      [].forEach.call(root.querySelectorAll(_this.linkSelector), function (link) {
        link.addEventListener('click', _this.handleLinkClick.bind(_this, root));
      });
      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.CONTENT_CHANGED), _this.handleProductGridEvent.bind(_this), false);
    });
  },
  handleProductGridEvent: function handleProductGridEvent(e) {
    var root = e.detail.root;
    var pagination = e.detail.pagination;
    this.updatePagination(root, pagination);
  },
  handleLinkClick: function handleLinkClick(root, e) {
    var _this2 = this;

    e.preventDefault();
    var current = e.currentTarget;
    var change = current.dataset.change;
    var action = root.dataset.ajax;
    this.enableLoading(root);
    this.sendEvent({}, root, (0, _eventNames.getEventName)(root, _eventNames.default.CONTENT_LOADING));

    _tools.default.service(action + change, 'GET', undefined, undefined).then(function (response) {
      response.json().then(function (json) {
        _this2.disableLoading(root);

        _this2.updatePagination(root, json.pagination);

        _this2.sendEvent(json, root, (0, _eventNames.getEventName)(root, _eventNames.default.CMSCOMPONENT_PAGINATION_CHANGED));
      }).catch(function (error) {
        _this2.disableLoading(root);

        console.debug(error);
      });
    }).catch(function () {
      _this2.disableLoading(root);

      console.debug('catch');
    });
  },
  sendEvent: function sendEvent(data, root, event) {
    _tools.default.sendEvent(event, {
      message: data,
      root: root
    });
  },
  updatePagination: function updatePagination(root, pagination) {
    var isRootPaginationRoot = root.classList.contains(this.rootClass);
    var paginationRoot = isRootPaginationRoot ? root : root.querySelector(this.rootSelector);

    if (pagination && !pagination.empty) {
      paginationRoot.classList.remove(_state.default.HIDDEN);
      paginationRoot.dataset.ajax = pagination.ajax.action;
      [].forEach.call(root.querySelectorAll(this.updateSelectors), function (element) {
        var key = element.classList[0].replace('cmscomponent-pagination-', '');

        if (key !== 'label') {
          element.dataset.change = pagination.ajax[key];

          if (pagination[key]) {
            element.setAttribute('href', pagination[key]);
          } else {
            element.removeAttribute('href');
          }
        } else {
          element.innerText = pagination[key];
        }
      });
    } else if (paginationRoot && pagination && pagination.empty) {
      paginationRoot.classList.add(_state.default.HIDDEN);
    }
  },
  enableLoading: function enableLoading(root) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    root.classList.add(_state.default.LOADING);
  },
  disableLoading: function disableLoading(root) {
    root.classList.remove(_state.default.LOADING);
  }
};
var _default = Pagination;
exports.default = _default;

},{"event-names":224,"state":232,"tools":236}],202:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fabric = require("fabric");

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PatchSelector = /*#__PURE__*/function () {
  function PatchSelector() {
    var _this = this;

    _classCallCheck(this, PatchSelector);

    this.defineSelectors();

    if (!this.shouldLoad()) {
      return;
    }

    _tools.default.loadComplete(function () {
      _this.prepareIconData();

      _this.initFabric();

      _this.build();

      _this.events();
    });
  }

  _createClass(PatchSelector, [{
    key: "shouldLoad",
    value: function shouldLoad() {
      return document.querySelectorAll(this.patchSelector).length > 0;
    }
  }, {
    key: "initFabric",
    value: function initFabric() {
      this.canvas = new _fabric.fabric.Canvas(_tools.default.getClassFromSelector(this.canvasSelector), {
        hoverCursor: 'pointer',
        selection: false,
        targetFindTolerance: 2
      });
    }
  }, {
    key: "defineSelectors",
    value: function defineSelectors() {
      this.patchSelector = '.cmscomponent-patch-selector';
      this.imageSelector = '.cmscomponent-patch-selector__image';
      this.canvasSelector = '#cmscomponent-patch-selector__canvas';
      this.canvasPreloadSelector = '#cmscomponent-patch-selector__canvas-preload';
      this.iconSelector = '.cmscomponent-patch-selector__icon';
      this.dataSelector = '.cmscomponent-patch-selector__data';
      this.repairPointSelector = '.cmscomponent-patch-selector__repair-point';
    }
  }, {
    key: "build",
    value: function build() {
      var _this2 = this;

      var radix = 10;
      var patchSelector = document.querySelector(this.patchSelector);
      var innerWidth = parseInt(window.getComputedStyle(patchSelector).getPropertyValue('width'), radix);
      this.canvas.setWidth(innerWidth);
      this.canvas.setHeight(400);
      var imageElement = document.querySelector(this.imageSelector);
      var canvasPreloadElement = document.querySelector(this.canvasPreloadSelector);
      var canvasPreloadContext = canvasPreloadElement.getContext('2d');
      canvasPreloadElement.width = imageElement.width;
      canvasPreloadElement.height = imageElement.height;
      var bgImage = new Image();

      bgImage.onload = function () {
        canvasPreloadContext.drawImage(bgImage, 0, 0); // can be used to load vector graphics once IE11 gets scraped

        _fabric.fabric.Image.fromURL(canvasPreloadElement.toDataURL(), function (image) {
          var imageWidth = image.width;
          var imageHeight = image.height;

          var canvasWidth = _this2.canvas.getWidth();

          var canvasHeight = _this2.canvas.getHeight();

          var imageRatio = imageWidth / imageHeight;
          var canvasRatio = canvasWidth / canvasHeight;
          imageElement.remove();
          canvasPreloadElement.remove();

          if (imageRatio <= canvasRatio) {
            if (imageHeight > canvasHeight) {
              image.scaleToHeight(canvasHeight);
            }
          } else {
            if (imageWidth > canvasWidth) {
              image.scaleToWidth(canvasWidth);
            }
          }

          image.selectable = false;
          image.evented = false;
          image.x = 200;
          image.y = 300;

          _this2.canvas.centerObject(image);

          _this2.canvas.add(image);
        });
      };

      if (imageElement.src.endsWith('svg')) {
        console.error('Do not use SVG for the patch-selector.');
        document.querySelector(this.patchSelector).remove();
      }

      bgImage.src = imageElement.src;
    }
  }, {
    key: "prepareIconData",
    value: function prepareIconData() {
      var iconElement = document.querySelector(this.iconSelector);
      this.iconData = iconElement.innerHTML;
      iconElement.remove();
    }
  }, {
    key: "addRepairPoint",
    value: function () {
      var _addRepairPoint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pointer) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return this.addCircle();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = pointer;

                _context.t0.positionRepairPointToCursor.call(_context.t0, _context.t1, _context.t2);

                this.setInputData();
                this.handleErrorState();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addRepairPoint(_x) {
        return _addRepairPoint.apply(this, arguments);
      }

      return addRepairPoint;
    }()
  }, {
    key: "addCircle",
    value: function () {
      var _addCircle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var circle, iconPos, iconBg, icon, iconGroup, repairPoint;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                circle = new _fabric.fabric.Circle({
                  radius: 10,
                  fill: 'transparent',
                  stroke: '#e60021',
                  // $color-mewa-red
                  strokeWidth: 2
                });
                iconPos = [12, -10];
                iconBg = new _fabric.fabric.Circle({
                  radius: 10,
                  fill: 'white',
                  left: iconPos[0],
                  top: iconPos[1]
                });
                _context2.next = 5;
                return this.loadDeleteIcon();

              case 5:
                icon = _context2.sent;
                icon.left = iconPos[0] + 6;
                icon.top = iconPos[1] + 3;
                icon.scaleToWidth(10);
                iconGroup = new _fabric.fabric.Group([iconBg, icon], {
                  name: _tools.default.getClassFromSelector(this.iconSelector)
                });
                this.changeDisplayState(iconGroup, PatchSelector.EDisplayState.none);
                repairPoint = new _fabric.fabric.Group([circle, iconGroup], {
                  selectable: true,
                  hasControls: false,
                  hasBorders: false,
                  name: _tools.default.getClassFromSelector(this.repairPointSelector),
                  subTargetCheck: true
                });
                this.canvas.add(repairPoint);
                this.canvas.setActiveObject(repairPoint);
                return _context2.abrupt("return", repairPoint);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addCircle() {
        return _addCircle.apply(this, arguments);
      }

      return addCircle;
    }()
  }, {
    key: "positionRepairPointToCursor",
    value: function positionRepairPointToCursor(repairPoint, pointer) {
      var elOffset = [repairPoint.height / 2, repairPoint.width / 2];
      repairPoint.left = pointer.x - elOffset[0];
      repairPoint.top = pointer.y - elOffset[1];
      repairPoint.setCoords();
    }
  }, {
    key: "events",
    value: function events() {
      var _this3 = this;

      var checkDisplayNone = function checkDisplayNone(display) {
        return display === PatchSelector.EDisplayState.none;
      };

      var getIcon = function getIcon(e) {
        var _e$target, _e$target$_objects;

        return e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$_objects = _e$target._objects) === null || _e$target$_objects === void 0 ? void 0 : _e$target$_objects.find(function (obj) {
          return (obj === null || obj === void 0 ? void 0 : obj.name) === _tools.default.getClassFromSelector(_this3.iconSelector);
        });
      }; // Icon is only passed by if it is bellow the pointer once mouse:down is triggered


      this.canvas.on({
        'object:moving': function objectMoving(e) {
          var iconObject = getIcon(e);

          _this3.changeDisplayState(iconObject, PatchSelector.EDisplayState.none);

          e.target.opacity = 0.5;

          _this3.setInputData();
        },
        'object:modified': function objectModified(e) {
          e.target.opacity = 1;

          _this3.setInputData();
        },
        'mouse:down': function mouseDown(e) {
          if (e.subTargets.length === 0) {
            var pointer = _this3.canvas.getPointer(e.e);

            _this3.addRepairPoint(pointer);
          } else {
            var _e$subTargets$;

            var clickedOnIcon = (e === null || e === void 0 ? void 0 : (_e$subTargets$ = e.subTargets[0]) === null || _e$subTargets$ === void 0 ? void 0 : _e$subTargets$.name) === _tools.default.getClassFromSelector(_this3.iconSelector);

            var iconObject = getIcon(e);
            var iconDisplayNone = checkDisplayNone((iconObject === null || iconObject === void 0 ? void 0 : iconObject.display) || (iconObject === null || iconObject === void 0 ? void 0 : iconObject.display));

            if (iconDisplayNone) {
              _this3.changeDisplayState(iconObject, PatchSelector.EDisplayState.visible);
            } else if (!iconDisplayNone && !clickedOnIcon) {
              _this3.changeDisplayState(iconObject, PatchSelector.EDisplayState.none);
            } else if (!iconDisplayNone) {
              _this3.removeRepairPoint(e);
            }
          }
        }
      });
      this.validateOnSubmit();
    }
  }, {
    key: "removeRepairPoint",
    value: function removeRepairPoint(event) {
      this.canvas.remove(event.target);
      this.setInputData();
      this.handleErrorState();
    }
  }, {
    key: "loadDeleteIcon",
    value: function loadDeleteIcon() {
      var svgIcon = this.iconData;
      return new Promise(function (resolve) {
        _fabric.fabric.loadSVGFromString(svgIcon, function (objects, options) {
          resolve(_fabric.fabric.util.groupSVGElements(objects, options));
        });
      });
    }
  }, {
    key: "setInputData",
    value: function setInputData() {
      this.canvas.renderAll();
      document.querySelector(this.dataSelector).value = document.querySelector(this.canvasSelector).toDataURL();
    }
  }, {
    key: "changeDisplayState",
    value: function changeDisplayState(obj, displayState) {
      obj.set('display', displayState);

      switch (displayState) {
        case PatchSelector.EDisplayState.visible:
          obj.set({
            opacity: 1
          });
          break;

        case PatchSelector.EDisplayState.none:
          obj.set({
            opacity: 0
          });
          break;
      }

      this.canvas.renderAll();
    }
  }, {
    key: "countRepairPoints",
    value: function countRepairPoints() {
      var _this$canvas;

      return ((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.getObjects().length) - 1;
    }
  }, {
    key: "handleErrorState",
    value: function handleErrorState() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var patchSelector = document.querySelector(this.patchSelector);

      if (this.countRepairPoints() < 1) {
        error();
        patchSelector.classList.add('error');
      } else {
        success();
        patchSelector.classList.remove('error');
      }
    }
  }, {
    key: "validateOnSubmit",
    value: function validateOnSubmit() {
      var _this4 = this;

      var patchSelectorForm = document.querySelector(this.patchSelector).closest('form');
      var patchSelectorFormSubmit = patchSelectorForm.querySelector('button[type=submit]');
      window.prepareFormForValidation(patchSelectorForm);
      patchSelectorFormSubmit.addEventListener('click', function (e) {
        _this4.handleErrorState(undefined, function () {
          e.preventDefault();
        });
      }, true);
    }
  }], [{
    key: "init",
    value: function init() {
      this._patchSelector = new PatchSelector();
      return this._patchSelector;
    }
  }]);

  return PatchSelector;
}();

_defineProperty(PatchSelector, "_patchSelector", void 0);

_defineProperty(PatchSelector, "EDisplayState", Object.freeze({
  none: 1,
  visible: 2
}));

var _default = PatchSelector;
exports.default = _default;

},{"fabric":8,"tools":236}],203:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventNames = _interopRequireWildcard(require("event-names"));

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _templates = _interopRequireDefault(require("templates"));

var _cmscomponentProduct = _interopRequireDefault(require("cmscomponent-product"));

var _atomBadge = _interopRequireDefault(require("atom-badge"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

var _atomToggleState = _interopRequireDefault(require("atom-toggle-state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var UpdateAsync = {
  init: function init() {
    this.rootSelector = '.cmscomponent-product-grid';
    this.itemSelector = '.cmscomponent-product';
    this.itemPriceSelector = '.cmscomponent-product__price-price';
    this.itemPreTextSelector = '.cmscomponent-product__price-pretext';
    this.itemStrikePriceSelector = '.cmscomponent-product__price-strikeprice';
    this.itemValueSelector = '.cmscomponent-product__price-value';
    this.itemCurrencySelector = '.cmscomponent-product__price-currency';
    this.listSelector = '.cmscomponent-product-grid-products-list';
    this.badgeSelector = '.cmscomponent-product__badges-wrapper';
    this.sortingSelector = '.cmscomponent-product-grid-sorting';
    this.amountSelector = '.cmscomponent-product-grid-product-amount';
    this.productVisualSelector = '.cmscomponent-product__visual img';
    this.checkToggleStateLoader();

    _tools.default.PriceUrlLoader.productPriceUrlUpdater(this.rootSelector);

    _atomBadge.default.init();

    _atomDeliveryTime.default.init();
  },
  checkToggleStateLoader: function checkToggleStateLoader() {
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      _atomToggleState.default.requestModels(root);
    });
  },
  requestToggleState: function requestToggleState(root, data) {
    if (data.productGridToggleStateUrl) {
      return _atomToggleState.default.requestModels(root, data.productGridToggleStateUrl).then(function () {});
    } else {
      return Promise.resolve();
    }
  },
  updateAmount: function updateAmount(root, text) {
    this.updateElement(root, this.amountSelector, text);
  },
  updateElement: function updateElement(root, selector, text) {
    var element = root.querySelector(selector);

    if (element) {
      element.innerText = text;
    }
  },
  changeUrl: function changeUrl(data) {
    history.replaceState(null, null, data.url);
  },
  updateProductList: function () {
    var _updateProductList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(root, data) {
      var productListData, newList, noToggleListeners;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              productListData = data.products;
              this.updateAmount(root, data.productsAmount);
              _context.next = 4;
              return this.getNewProductList(productListData);

            case 4:
              newList = _context.sent;
              noToggleListeners = data.productGridToggleStateUrl ? true : false;
              this.setProductListMarkup(root, newList);
              [].forEach.call(root.querySelectorAll(_cmscomponentProduct.default.rootSelector), function (productItem) {
                _cmscomponentProduct.default.bindListenerForProduct(productItem, noToggleListeners);
              });

              if (data.priceUrl) {
                root.dataset.priceUrl = data.priceUrl;

                _tools.default.PriceUrlLoader.productPriceUrlUpdater(this.rootSelector);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function updateProductList(_x, _x2) {
      return _updateProductList.apply(this, arguments);
    }

    return updateProductList;
  }(),
  setProductListMarkup: function setProductListMarkup(root, markup) {
    var list = root.querySelector(this.listSelector);

    if (list) {
      list.innerHTML = markup;
    }
  },
  getProductTempate: function getProductTempate(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('cmscomponents-product', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getNewProductList: function () {
    var _getNewProductList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
      var list, i, product;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              list = '';

              if (!data) {
                _context2.next = 14;
                break;
              }

              i = 0;

            case 3:
              if (!(i < data.length)) {
                _context2.next = 14;
                break;
              }

              product = data[i];

              if (!product) {
                _context2.next = 11;
                break;
              }

              _context2.t0 = list;
              _context2.next = 9;
              return this.getProductTempate(product);

            case 9:
              _context2.t1 = _context2.sent;
              list = _context2.t0 + _context2.t1;

            case 11:
              i++;
              _context2.next = 3;
              break;

            case 14:
              return _context2.abrupt("return", list);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getNewProductList(_x3) {
      return _getNewProductList.apply(this, arguments);
    }

    return getNewProductList;
  }()
};
var ProductGrid = {
  init: function init() {
    this.rootSelector = '.cmscomponent-product-grid';
    this.gridProductsSelector = '.cmscomponent-product-grid-products';
    this.productGridProductsHeadlineSelector = '.cmscomponent-product-grid-products-headline';
    this.productSelector = '.cmscomponent-product';
    this.listSelector = '.cmscomponent-product-grid-products-list';
    this.formLoadingSelector = this.listSelector + ' .atom-form-loading';
    this.loader = {};
    UpdateAsync.init();
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    var body = document.querySelector('body');
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root, index) {
      _this.prepareFormLoading(root);

      _this.enableLoading(root);

      var groupSibling = _tools.default.getQuerySiblings('[data-event-prefix]', root);

      var groupName = (0, _eventNames.getCleanGroupName)(groupSibling, _eventNames.default.ATOM_DROPDOWN_ALL_CHANGED);
      root.dataset.eventPrefix = groupName;
      (0, _eventNames.updateEventPrefix)(root, index);
      body.addEventListener((0, _eventNames.getEventNameByGroup)(groupName, index, _eventNames.default.CONTENT_CHANGED), _this.handleChangeEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventNameByGroup)(groupName, index, _eventNames.default.CONTENT_LOADING), _this.handleLoadingEvent.bind(_this), false);

      _this.disableLoading(root);
    });
  },
  prepareFormLoading: function prepareFormLoading(root) {
    var loading = this.getFormLoading(root);
    this.loader[root] = loading;
  },
  getFormLoading: function getFormLoading(root) {
    if (!this.loader[root]) {
      this.removeFormLoading(root);
    }

    return this.loader[root];
  },
  removeFormLoading: function removeFormLoading(root) {
    var formLoading = root.querySelector(this.formLoadingSelector);

    if (formLoading) {
      this.loader[root] = formLoading.outerHTML;
      formLoading.parentNode.removeChild(formLoading);
    }
  },
  getRootFromEvent: function getRootFromEvent(e) {
    var prefix = (0, _eventNames.getPrefixFromEventName)(e.type);
    return this.getRootByEventPrefix(prefix);
  },
  getRootByEventPrefix: function getRootByEventPrefix(eventPrefix) {
    if (eventPrefix) {
      return document.querySelector("".concat(this.rootSelector, "[data-event-prefix='").concat(eventPrefix, "']"));
    }

    return null;
  },
  handleChangeEvent: function handleChangeEvent(e) {
    var root = this.getRootFromEvent(e);

    if (root) {
      this.updateEvent(root, e.detail);
    }
  },
  handleLoadingEvent: function handleLoadingEvent(e) {
    var root = this.getRootFromEvent(e);

    if (root) {
      this.enableLoading(root);
    }
  },
  enableLoading: function enableLoading(root) {
    var tmpLoading = document.createElement('div');
    var loading = this.getFormLoading(root);
    var list = root.querySelector(UpdateAsync.listSelector);
    tmpLoading.innerHTML = loading;
    list.prepend.apply(list, _toConsumableArray(tmpLoading.children));
    root.classList.add(_state.default.LOADING);
  },
  disableLoading: function disableLoading(root) {
    this.removeFormLoading(root);
    root.classList.remove(_state.default.LOADING);
  },
  reinitializeComponents: function reinitializeComponents(root) {
    _cmscomponentProduct.default.init();

    _atomBadge.default.init();

    _atomDeliveryTime.default.init();
  },
  updateEvent: function updateEvent(root, data) {
    var _this2 = this;

    this.enableLoading(root);
    UpdateAsync.requestToggleState(root, data.productGrid).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _tools.default.scrollIntoElement();

              _context3.next = 3;
              return UpdateAsync.updateProductList(root, data.productGrid);

            case 3:
              UpdateAsync.changeUrl(data.productGrid);

              _this2.reinitializeComponents(root);

              _this2.disableLoading(root);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
  },
  update: function update(root, html) {
    if (root) {
      _templates.default.updateAllSelectors(root, html, [this.gridProductsSelector, this.productGridProductsHeadlineSelector]);
    }
  }
};
var _default = ProductGrid;
exports.default = _default;

},{"atom-badge":170,"atom-delivery-time":174,"atom-toggle-state":179,"cmscomponent-product":206,"event-names":224,"state":232,"templates":235,"tools":236}],204:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _eventNames = _interopRequireDefault(require("event-names"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = require('flickity');

var ProductSettings = {
  init: function init() {
    this.rootSelector = '.cmscomponent-product-settings';
    this.listSelector = '.cmscomponent-product-settings-slider';
    this.colorNameSelector = '.cmscomponent-product-settings-color-name';
    this.colorValueSelector = '.cmscomponent-product-settings-color-value';
    this.hasSelectionSelector = '.has-selection';
    this.hasSliderSelector = '.has-slider';
    this.instance;
    this.root = document.querySelectorAll(this.rootSelector);
    this.rootSlider = document.querySelectorAll(this.rootSelector + this.hasSliderSelector);
    this.options = {
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      groupCells: true,
      cellAlign: 'left',
      watchCSS: true
    };
    this.setupSliders();
    this.bindListeners();
  },
  setupSliders: function setupSliders() {
    var _this = this;

    if (this.rootSlider !== null) {
      [].forEach.call(this.rootSlider, function (node) {
        var lists = node.querySelectorAll(_this.listSelector);
        [].forEach.call(lists, function (list) {
          var index = _tools.default.getNodeIndex(list.querySelector(_this.hasSelectionSelector));

          _this.options.initialIndex = index;
          _this.instance = new Flickity(list, _this.options);
        });
      });
    }
  },
  bindListeners: function bindListeners() {
    var _this2 = this;

    if (this.root !== null) {
      [].forEach.call(this.root, function (root) {
        if (root.querySelector(_this2.colorNameSelector) !== null) {
          [].forEach.call(root.querySelectorAll(_this2.colorValueSelector), function (colorValue) {
            colorValue.addEventListener('mouseover', _this2.handleMouseOver.bind(_this2));
            colorValue.addEventListener('mouseout', _this2.handleMouseOut.bind(_this2));
          });
        }
      });
    }
  },
  handleMouseOver: function handleMouseOver(e) {
    var element = e.currentTarget;
    var name = element.dataset.name;
    var root = element.closest(this.rootSelector);
    this.selectedColorName = root.querySelector(this.colorNameSelector).innerText;

    if (name !== '' && name !== undefined) {
      this.setColorName(name, e);
      var image = element.dataset.image;
      this.dispatchMouseEvent(image, element, _eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOVER);
    }
  },
  handleMouseOut: function handleMouseOut(e) {
    var element = e.currentTarget;
    this.setColorName(this.selectedColorName, e);
    this.dispatchMouseEvent('', element, _eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOUT);
  },
  dispatchMouseEvent: function dispatchMouseEvent(image, element, event) {
    if (image !== undefined) {
      var customEvent = new CustomEvent(event, {
        detail: {
          image: image,
          element: element
        },
        bubbles: false,
        cancelable: true
      });
      document.querySelector('body').dispatchEvent(customEvent);
    }
  },
  setColorName: function setColorName(name, event) {
    var element = event.currentTarget;
    var root = element.closest(this.rootSelector);
    root.querySelector(this.colorNameSelector).innerText = name;
  },
  getProductSettingsSizes: function getProductSettingsSizes(productSettings) {
    var sizes = productSettings.sizes;
    var values = sizes.values.map(function (value) {
      return "\n        <a\n          class=\"cmscomponent-product-settings-size-value\n          ".concat(value.hasMore ? ' has-more' : '', "\n          ").concat(value.disabled ? ' is-disabled' : '', "\n          ").concat(value.selected ? ' has-selection' : '', "\n          ").concat(value.notClickable ? ' is-not-clickable' : '', "\n          ").concat(value.isUnisize ? ' is-zero' : '', "\"\n          href=\"").concat(value.href, "\"\n        >\n          ").concat(value.hasMore ? '<span>...</span>' : "".concat(value.text), "\n        </a>\n      ");
    }).join('');
    return "\n      <div class=\"cmscomponent-product-settings-sizes\">\n        <span class=\"cmscomponent-product-settings-size-label\">".concat(sizes.label, "</span>\n        <div class=\"cmscomponent-product-settings-size-values\">\n          <div class=\"cmscomponent-product-settings-slider\">\n            ").concat(values, "\n          </div>\n        </div>\n      </div>\n    ");
  },
  getProductSettingsColors: function getProductSettingsColors(productSettings) {
    var color = productSettings.colors;
    var values = color.values.map(function (value) {
      return "\n        <a\n          class=\"cmscomponent-product-settings-color-value\n          ".concat(value.hasMore ? ' has-more' : '', "\n          ").concat(value.disabled ? ' is-disabled' : '', "\n          ").concat(value.selected ? ' has-selection' : '', "\n          ").concat(value.notClickable ? ' is-not-clickable' : '', "\"\n          ").concat(value.name ? " data-name=\"".concat(value.name, "\"") : '', "\n          ").concat(value.imageUrl ? " data-image=\"".concat(value.imageUrl, "\"") : '', "\n          ").concat(value.hasMore ? '' : " style=\"background-image:url('".concat(value.img, "')\""), "\n          href=\"").concat(value.href, "\"\n        >\n          ").concat(value.hasMore ? "<span>+".concat(value.hasMore, "</span>") : '', "\n        </a>\n      ");
    }).join('');
    return "\n      <div class=\"cmscomponent-product-settings-colors\">\n        <div class=\"cmscomponent-product-settings-color\">\n          <span class=\"cmscomponent-product-settings-color-label\">".concat(color.label, "</span>\n          ").concat(color.selectedName ? "\n            <span class=\"cmscomponent-product-settings-color-name\">".concat(color.selectedName, "</span>\n          ") : '', "\n        </div>\n        <div class=\"cmscomponent-product-settings-color-values\">\n          <div class=\"cmscomponent-product-settings-slider\">\n            ").concat(values, "\n          </div>\n        </div>\n      </div>\n    ");
  }
};
var _default = ProductSettings;
exports.default = _default;

},{"event-names":224,"flickity":17,"tools":236}],205:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ProductSpecifications = {
  init: function init() {}
};
var _default = ProductSpecifications;
exports.default = _default;

},{}],206:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

var _atomToggleState = _interopRequireDefault(require("atom-toggle-state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Product = {
  init: function init() {
    var _this = this;

    this.rootSelector = '.cmscomponent-product';
    this.contentSelector = '.cmscomponent-product__content';
    this.detailsSelector = '.cmscomponent-product__details';
    this.detailsWrapperSelector = '.cmscomponent-product__details-wrapper';
    this.visualSelector = '.cmscomponent-product__visual';
    this.itemPriceSelector = '.cmscomponent-product__price-price';
    this.itemPreTextSelector = '.cmscomponent-product__price-pretext';
    this.itemStrikePriceSelector = '.cmscomponent-product__price-strikeprice';
    this.itemValueSelector = '.cmscomponent-product__price-value';
    this.itemCurrencySelector = '.cmscomponent-product__price-currency';
    this.badgeSelector = '.cmscomponent-product__badges-wrapper';
    this.deliveryTimeSelector = '.cmscomponent-product__delivery-time';
    this.discountAmount = '.atom-pricetag-discount-amount';

    _toConsumableArray(document.querySelectorAll(this.rootSelector)).map(function (root) {
      var currencyExists = root.querySelector("".concat(_this.itemStrikePriceSelector, " ").concat(_this.itemCurrencySelector));
      if (!currencyExists) return;
      var itemStrikePriceElement = root.querySelector(_this.itemStrikePriceSelector);
      currencyExists.innerHTML.length === 0 ? itemStrikePriceElement.classList.add(_state.default.HIDDEN) : itemStrikePriceElement.classList.remove(_state.default.HIDDEN);
    });

    this.lastTarget;
    this.root = document.querySelectorAll(this.rootSelector);
    this.itemElementList = [{
      name: 'price',
      selector: this.itemPriceSelector + ' ' + this.itemValueSelector
    }, {
      name: 'currency',
      selector: this.itemPriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'strikePriceCurrency',
      selector: this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'discountAmount',
      selector: this.discountAmount
    }, {
      name: 'preText',
      selector: this.itemPreTextSelector
    }, {
      name: 'strikethroughPrice',
      selector: this.itemStrikePriceSelector + ' ' + this.itemValueSelector,
      parent: this.itemStrikePriceSelector
    }, {
      name: 'badges',
      selector: this.badgeSelector,
      updateAll: true
    }];
    this.bindListeners();
    this.checkToggleStateLoader();
    this.checkPriceUrlLoader();
  },
  bindListeners: function bindListeners() {
    var _this2 = this;

    [].forEach.call(this.root, function (product) {
      _this2.bindListenerForProduct(product);
    });
  },
  bindListenerForProduct: function bindListenerForProduct(product, noToggleListeners) {
    var _this3 = this;

    product.addEventListener('mouseover', function (e) {
      if (_this3.isLargeBreakpoint()) {
        _this3.mouseOver(e);
      }
    });
    product.addEventListener('mouseout', function (e) {
      if (_this3.isLargeBreakpoint()) {
        _this3.mouseOut(e);
      }
    });
    var visual = product.querySelector(this.visualSelector);

    if (visual) {
      visual.addEventListener('click', this.handleClick.bind(this));
    }

    if (!noToggleListeners) {
      _atomToggleState.default.bindListenersForParent(product);
    }
  },
  handleClick: function handleClick(e) {
    if (!this.isNotOverToggle(e)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  checkToggleStateLoader: function checkToggleStateLoader() {
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      _atomToggleState.default.requestModels(root);
    });
  },
  checkPriceUrlLoader: function checkPriceUrlLoader() {
    var _this4 = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var priceUrl = root.dataset.priceUrl;

      if (priceUrl !== undefined) {
        _tools.default.PriceUrlLoader.getPrices(root).then(function (data) {
          if (data !== undefined) {
            var price = data[0];

            _this4.handlePrice(price, root);
          }
        }).catch(function (error) {
          console.debug(error);
        });
      }
    });
  },
  handlePrice: function handlePrice(price, root) {
    if (price && price.cheapestPrice) {
      price.price = price.cheapestPrice;
      price.strikethroughPrice = undefined;
    }

    _tools.default.PriceUrlLoader.handlePrice(price, root, this.itemElementList);

    if (price !== undefined) {
      this.handleDeliveryTime(price, root);
    }

    this.disableLoading(root);
  },
  handleDeliveryTime: function handleDeliveryTime(price, root) {
    var data = price.deliveryTime;
    [].forEach.call(root.querySelectorAll(this.deliveryTimeSelector), function (deliveryTime) {
      _atomDeliveryTime.default.update(deliveryTime, data);
    });
  },
  disableLoading: function disableLoading(root) {
    root.removeAttribute('data-price-url');
  },
  isLargeBreakpoint: function isLargeBreakpoint() {
    return _tools.default.screen('lg', false);
  },
  isNotOverToggle: function isNotOverToggle(e) {
    return e.srcElement.tagName !== 'svg' && e.srcElement.tagName !== 'path' && !e.target.classList.contains('cmscomponent-product__toggle-form');
  },
  mouseOver: function mouseOver(e) {
    if (this.isNotOverToggle(e)) {
      var current = e.currentTarget;
      var $current = $(current);

      if (this.lastTarget === undefined || $current[0] !== this.lastTarget[0]) {
        var height = current.offsetHeight;
        var details = current.querySelector(this.detailsSelector);
        var detailsWrapper = current.querySelector(this.detailsWrapperSelector);
        var content = current.querySelector(this.contentSelector);
        var bottomPosition = 0;
        content.style.bottom = bottomPosition + 'px';
        current.classList.add(_state.default.OPEN);
        details.style.height = detailsWrapper.offsetHeight + 'px';
        current.style.height = height + 'px';
        this.lastTarget = $current;
      }
    } else {
      this.closeOverlay(e);
    }
  },
  mouseOut: function mouseOut(e) {
    if (this.lastTarget && $(e.relatedTarget).parents(this.rootSelector)[0] !== this.lastTarget[0]) {
      this.closeOverlay(e);
    }
  },
  closeOverlay: function closeOverlay(e) {
    var current = e.currentTarget;
    var details = current.querySelector(this.detailsSelector);
    var content = current.querySelector(this.contentSelector);
    content.style.bottom = '';
    current.style.height = '';
    details.style.height = '';
    this.lastTarget = undefined;
    current.classList.remove(_state.default.OPEN);
  }
};
var _default = Product;
exports.default = _default;

},{"atom-delivery-time":174,"atom-toggle-state":179,"state":232,"tools":236}],207:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RegistrationExtended = {
  init: function init() {
    this.rootSelector = '.cmscomponent-registration-extended';
    this.invoiceNumberSelector = '.cmscomponent-registration-extended-invoice-number input';
    this.vatNumberSelector = '.cmscomponent-registration-extended-vat-number input';
    this.minLength = 3;
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    Array.prototype.forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var invoiceNumber = root.querySelector(_this.invoiceNumberSelector);
      var vatNumber = root.querySelector(_this.vatNumberSelector);
      invoiceNumber.addEventListener('change', _this.checkRequirements.bind(_this, invoiceNumber, root, true));
      vatNumber.addEventListener('change', _this.checkRequirements.bind(_this, vatNumber, root));
    });
  },
  checkRequirements: function checkRequirements(element, root, isInvoice) {
    var isInvoiceNumber = isInvoice !== undefined ? isInvoice : false;
    var secondElementSelector = isInvoiceNumber === true ? this.vatNumberSelector : this.invoiceNumberSelector;
    var secondElement = root.querySelector(secondElementSelector);

    if (element.value.length >= this.minLength) {
      secondElement.removeAttribute('required');
    } else {
      secondElement.setAttribute('required', 'required');
    }
  }
};
var _default = RegistrationExtended;
exports.default = _default;

},{}],208:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _utils = require("../../js/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchLocal = /*#__PURE__*/function () {
  function SearchLocal(root) {
    _classCallCheck(this, SearchLocal);

    this.root = root;
    this.input = this.root.querySelector('.atom-input input');
    this.close = this.root.querySelector('.cmscomponent-search-local__close-icon');
    this.search = this.root.querySelector('.cmscomponent-search-local__search-icon');
    this.flyout = this.root.closest('.cmscomponent-delivery-point-flyout');
    this.searchElements = ['global-account-box-list'];
    this.bindEvents();
  }

  _createClass(SearchLocal, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      if (this.input) {
        this.input.addEventListener('keyup', this.keyup.bind(this));
      }

      if (this.close) {
        this.close.addEventListener('click', this.handleClose.bind(this));
      }

      if (this.search) {
        this.search.addEventListener('click', this.handleSearch.bind(this));
      } // Reset flyout when it gets closed by DeliveryPointFlyout click events


      if (this.flyout) {
        (0, _utils.addClickOutsideListener)(this.flyout, function () {
          if (document.body.classList.contains('cssflyout-open--deliveryPoint')) {
            _this.handleClose();
          }
        }, false);
      }
    }
  }, {
    key: "keyup",
    value: function keyup(e) {
      if (e.keyCode === _tools.default.keyCode.ESC) {
        this.handleClose();
      } else if (!this.isEmpty()) {
        this.handleSearch();
        this.showClose();
      } else {
        this.hideClose();
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch() {
      if (!this.isEmpty()) {
        var siblings = _tools.default.getAllSiblings(this.root);

        this.showElements(siblings);
        this.hideElements(this.getUnmatchingElements(siblings, this.getSearchValue()));
      }
    }
  }, {
    key: "showElements",
    value: function showElements(siblings) {
      var _this2 = this;

      [].forEach.call(siblings, function (sibling) {
        var elements = _this2.getAllSearchElementsBySibling(sibling);

        sibling.classList.remove(_state.default.HIDDEN);
        [].forEach.call(elements, function (element) {
          element.classList.remove(_state.default.HIDDEN);
        });
      });
    }
  }, {
    key: "hideElements",
    value: function hideElements(elements) {
      if (elements && elements.length) {
        [].forEach.call(elements, function (elementList) {
          [].forEach.call(elementList, function (element) {
            element.classList.add(_state.default.HIDDEN);
          });
        });
      }
    }
  }, {
    key: "getUnmatchingElements",
    value: function getUnmatchingElements(siblings, value) {
      var _this3 = this;

      var result = [];
      [].forEach.call(siblings, function (sibling) {
        var unmatchedSearchElements = _this3.getUnmatchingSearchElements(sibling, value);

        if (unmatchedSearchElements.length) {
          result.push(unmatchedSearchElements);
        }

        if (_this3.hasNoMoreVisibleElements(sibling, unmatchedSearchElements.length)) {
          sibling.classList.add(_state.default.HIDDEN);
        }
      });
      return result;
    }
  }, {
    key: "hasNoMoreVisibleElements",
    value: function hasNoMoreVisibleElements(sibling, unmatchedCount) {
      return this.getAllSearchElementsBySibling(sibling).length === unmatchedCount ? true : false;
    }
  }, {
    key: "getAllSearchElementsBySibling",
    value: function getAllSearchElementsBySibling(sibling) {
      var elements = [];
      [].forEach.call(this.searchElements, function (elementClass) {
        [].forEach.call(sibling.querySelectorAll(".".concat(elementClass)), function (element) {
          elements.push(element);
        });
      });
      return elements;
    }
  }, {
    key: "getUnmatchingSearchElements",
    value: function getUnmatchingSearchElements(sibling, value) {
      var _this4 = this;

      var result = [];
      [].forEach.call(this.getAllSearchElementsBySibling(sibling), function (element) {
        if (!_this4.isTextInElement(element, value)) {
          result.push(element);
        }
      });
      return result;
    }
  }, {
    key: "isTextInElement",
    value: function isTextInElement(element, value) {
      var result = false;
      [].forEach.call(element.querySelectorAll('*'), function (node) {
        var regex = new RegExp(value, 'gi');

        if (node.textContent.match(regex)) {
          result = true;
        }
      });
      return result;
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var siblings = _tools.default.getAllSiblings(this.root);

      this.input.value = '';
      this.showElements(siblings);
      this.hideClose();
    }
  }, {
    key: "showClose",
    value: function showClose() {
      this.root.classList.remove(_state.default.EMPTY);
    }
  }, {
    key: "hideClose",
    value: function hideClose() {
      var siblings = _tools.default.getAllSiblings(this.root);

      this.showElements(siblings);
      this.root.classList.add(_state.default.EMPTY);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.input && this.input.value.length === 0;
    }
  }, {
    key: "getSearchValue",
    value: function getSearchValue() {
      return this.input ? this.input.value : null;
    }
  }], [{
    key: "init",
    value: function init() {
      SearchLocal.instances = [];
      [].forEach.call(document.querySelectorAll(SearchLocal.rootSelector), function (element) {
        SearchLocal.instances.push(new SearchLocal(element));
      });
    }
  }]);

  return SearchLocal;
}();

_defineProperty(SearchLocal, "rootSelector", '.cmscomponent-search-local');

_defineProperty(SearchLocal, "instances", []);

var _default = SearchLocal;
exports.default = _default;

},{"../../js/utils":237,"state":232,"tools":236}],209:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _suggestions = _interopRequireDefault(require("suggestions"));

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var search = {
  setup: {
    notEmptyClass: 'has-query'
  },
  init: function init() {
    this.rootSelector = '.cmscomponent-search';
    this.inputWrapperSelector = '.cmscomponent-search-input';
    this.inputSelector = this.inputWrapperSelector + ' input';
    this.searchSelector = '.cmscomponent-search-search';
    this.closeSelector = '.cmscomponent-search-close';
    this.spacerSelector = '.cmscomponent-search-spacer';
    this.suggestionsWrapperSelector = '.suggestions-wrapper';
    this.productSelector = '.cmscomponent-search-product';
    this.productsClass = 'cmscomponent-search-products';
    this.productsSelector = '.' + this.productsClass;
    this.minSearchQueryLength = 2;
    this.minSuggestionLength = 3;
    this.resultLimit = 3;
    this.lowerBreakpoint = 'md';
    this.fullWidthScalingFactor = .5;
    this.enterKeyCode = 13;
    this.expanding = false;
    this.products = null;
    this.followLinkProductLength = 1;
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (component) {
      [].forEach.call(component.querySelectorAll(_this.inputSelector), function (input) {
        input.addEventListener('keydown', function (e) {
          if (e.keyCode && e.keyCode === _this.enterKeyCode) {
            e.stopImmediatePropagation();
          }
        });
        var typeahead = new _suggestions.default(input, [], {
          minLength: _this.minSuggestionLength,
          limit: _this.resultLimit
        });
        _this.typeahead = typeahead;

        typeahead.getItemValue = function (item) {
          return item.term;
        };

        var update = function update() {
          _this.query(component, typeahead, input.value);

          if (input.value.length > 0) {
            component.classList.add(_this.setup.notEmptyClass);
          } else {
            component.classList.remove(_this.setup.notEmptyClass);
          }

          _this.removeProducts(component);
        };

        input.addEventListener('keyup', function () {
          if (_this.isExpanded(component) === false && _this.expanding === false) {
            _this.expand(component);
          }

          window.debounce(update, 200);
        });
        var form = component;

        var checkSubmit = function checkSubmit(e) {
          if (input.value.length >= _this.minSearchQueryLength) {
            var emptySuggestions = typeahead.data === null || typeahead.data.length === 0;

            if (emptySuggestions === true && _this.products && _this.products.length === _this.followLinkProductLength) {
              var product = _this.products[0];

              if (product.url) {
                e.preventDefault();
                document.location.href = product.url;
              }
            } else {
              form.submit();
            }

            return true;
          } else {
            if (e !== undefined) {
              e.preventDefault();
            }

            return false;
          }
        };

        input.addEventListener('change', function () {
          if (typeahead.selected !== null) {
            input.value = typeahead.selected.term;
            checkSubmit();
          }
        });
        input.addEventListener('focus', function (e) {
          e.stopImmediatePropagation();

          _this.expand(component);
        });

        _this.addBlurListener(component, input, update);

        form.addEventListener('submit', function (e) {
          return checkSubmit(e);
        });
        component.querySelector(_this.closeSelector).addEventListener('click', function () {
          _this.collapse(component, input, update);
        });
        component.querySelector(_this.searchSelector).addEventListener('click', function (e) {
          return checkSubmit(e);
        });
        update();
      });
    });
  },
  query: function query(component, typeahead, q) {
    if (q.length < this.minSuggestionLength) {
      return;
    }

    var queryUrl = component.dataset.query;
    var xhr = new XMLHttpRequest();
    var scope = this;
    xhr.open('GET', queryUrl + q, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onreadystatechange = function () {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        var response = JSON.parse(this.response);

        if (response && response.suggestions !== undefined) {
          typeahead.update(response.suggestions);

          if (response && response.products !== undefined && response.products.length >= 1) {
            scope.removeProducts(component);
            scope.addProducts(response.products, component);
          }
        }
      }
    };

    xhr.send();
  },
  isExpanded: function isExpanded(component) {
    return component.classList.contains(_state.default.EXPANDED);
  },
  expand: function expand(component) {
    var _this2 = this;

    this.expanding = true;
    var height = component.clientHeight;
    var width = component.clientWidth;
    var spacer = component.querySelector(this.spacerSelector);
    var inputWrapper = component.querySelector(this.inputWrapperSelector);
    inputWrapper.style.width = inputWrapper.clientWidth + 'px'; // force redraw

    setTimeout(function () {
      spacer.style.height = height + 'px';
      spacer.style.width = width + 'px';
      component.classList.add(_state.default.EXPANDED);
      inputWrapper.style.width = _this2.getExpandWidth(component) + 'px';
      _this2.expanding = false;
    }, 100);
  },
  getExpandWidth: function getExpandWidth(component) {
    var width;
    var parentWidth = this.getParentWidth(component);

    if (!_tools.default.screen(this.lowerBreakpoint)) {
      width = parentWidth * this.fullWidthScalingFactor;
    } else {
      width = parentWidth;
    }

    return width;
  },
  getParentWidth: function getParentWidth(component) {
    var parent = component.parentNode;
    return parent.clientWidth;
  },
  collapse: function collapse(component, input, update) {
    var spacer = component.querySelector(this.spacerSelector);
    var inputWrapper = component.querySelector(this.inputWrapperSelector);
    spacer.removeAttribute('style');
    inputWrapper.removeAttribute('style');
    component.classList.remove(_state.default.EXPANDED);
    input.value = '';
    update();
  },
  getProductMarkup: function getProductMarkup(product) {
    var badge = '';

    if (product.badgeLabel !== undefined) {
      badge = "\n        <div class=\"cmscomponent-search-product-badge\">\n          <span class=\"atom-badge ".concat(product.badgeColor, "\">").concat(product.badgeLabel, "</span>\n        </div>");
    }

    return "\n      <a class=\"cmscomponent-search-product\" href=\"".concat(product.url, "\">\n        <img src=\"").concat(product.directBaseProductImageAsset, "\" class=\"cmscomponent-search-product-image\" />\n        <div class=\"cmscomponent-search-product-content\">\n          <div class=\"cmscomponent-search-product-name\">").concat(product.name, "</div>\n          ").concat(badge, "\n        </div>\n      </a>\n    ");
  },
  addProducts: function addProducts(products, component) {
    var _this3 = this;

    this.products = products;
    var wrapper = component.querySelector(this.suggestionsWrapperSelector);
    var productsDiv = wrapper.appendChild(document.createElement('div'));
    productsDiv.classList.add(this.productsClass);

    if (wrapper !== null) {
      [].forEach.call(products, function (product) {
        productsDiv.innerHTML += _this3.getProductMarkup(product);
      });

      if (this.typeahead !== undefined && this.typeahead.list !== undefined && this.typeahead.list.selectingListItem !== undefined) {
        this.typeahead.list.selectingListItem = true;
      }
    }
  },
  removeProducts: function removeProducts(component) {
    var products = component.querySelector(this.productsSelector);
    this.products = null;

    if (products !== null) {
      products.remove();
    }
  },
  addBlurListener: function addBlurListener(component, input, update) {
    var _this4 = this;

    document.addEventListener('click', function (e) {
      var isInside = component.contains(e.target);

      if (isInside === false) {
        _this4.collapse(component, input, update);
      }
    });
  }
};
var _default = search;
exports.default = _default;

},{"state":232,"suggestions":73,"tools":236}],210:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _attachmentIcons = _interopRequireDefault(require("attachment-icons"));

var _templates = _interopRequireDefault(require("templates"));

var _simpleLightbox = _interopRequireDefault(require("../simple-lightbox"));

var _cmscomponentUpload = _interopRequireDefault(require("./cmscomponent-upload"));

var _cmscomponentFormServiceticket = _interopRequireDefault(require("./cmscomponent-form-serviceticket"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ServiceticketDetail = {
  init: function init() {
    this.rootSelector = '.cmscomponent-serviceticket-detail';
    this.commentsSelector = '.cmscomponent-serviceticket-detail-comments';
    this.addCommentSelector = '.cmscomponent-serviceticket-detail-comments__comment';
    this.ticketFormSelector = '.cmscomponent-form-serviceticket';
    this.ticketFormParentSelector = '.cmscomponent-serviceticket-detail-comments__form';
    this.ticketFormButtonsSelector = this.ticketFormSelector + ' .cmscomponent-form-serviceticket-newcomment-buttons';
    this.ticketFormCancelSelector = this.ticketFormButtonsSelector + ' .atom-button.ghost';
    this.ticketFormSubmitSelector = this.ticketFormButtonsSelector + ' .atom-button.secondary';
    this.errorDialogSelector = this.ticketFormSelector + ' .atom-dialog-content';
    this.errorButtonSelector = '.slbContent .cmscomponent-dialog-error .atom-button';
    this.commentsListSelector = '.cmscomponent-serviceticket-detail-comments__list';
    this.commentEntryTemplateSelector = '#template-cmscomponent-serviceticket-detail-comments__entry';
    this.attachmentTemplateSelector = '.cmscomponent-serviceticket-detail-comments__entry-attachment';
    this.entryInfoTemplateSelector = '.cmscomponent-serviceticket-detail-comments__entry-info';
    this.loadMoreSelector = '.cmscomponent-serviceticket-detail-comments__load-more';
    this.readMoreSelector = '.cmscomponent-serviceticket-detail-comments__read-more';
    this.readMoreTextSelector = '.cmscomponent-serviceticket-detail-comments__read-more-text';
    this.modalSelector = '.cmscomponent-dialog-success';
    this.modalContentSelector = '.cmscomponent-dialog-success-content';
    this.dialogCloseSelector = '.atom-button';
    this.loadingSelector = '.cmscomponents-serviceticket-detail__loading';
    this.loadUrlSelector = '.cmscomponent-serviceticket-detail';
    this.modelContentClass = 'atom-dialog-content';
    this.modelStylingClass = 'cmscomponent-serviceticket-detail__dialog';
    this.interactionSeperator = ';';
    this.interactionsToLoad = new Array();
    this.interactionsToLoadAmount = 0;
    this.commentAction = '';
    this.commentDescriptionSelector = '.cmscomponent-serviceticket-detail-comments__entry-description';
    this.commentDescriptionIframeSelector = '.cmscomponent-serviceticket-detail-comments__entry-description-iframe';
    this.commentDescriptionIframeContainerSelector = '.cmscomponent-serviceticket-detail-comments__entry-description-iframe-container';
    this.commentEntrySelector = '.cmscomponent-serviceticket-detail-comments__entry ';
    this.commentCount = 0;
    this.serviceTicketDetailPlaceholderSelector = '.cmscomponent-serviceticket-detail-placeholder';

    if (document.querySelector(this.rootSelector)) {
      this.loadData();
    }
  },
  load: function load() {
    var _this = this;

    _cmscomponentFormServiceticket.default.init();

    this.hasMoreComments();
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var addCommentLink = root.querySelector(_this.addCommentSelector);
      var ticketFormCancel = root.querySelector(_this.ticketFormCancelSelector);
      var ticketFormSubmit = root.querySelector(_this.ticketFormSubmitSelector);

      if (addCommentLink) {
        addCommentLink.addEventListener('click', _this.handleAddComment.bind(_this, root));
      }

      if (ticketFormCancel) {
        ticketFormCancel.addEventListener('click', _this.handleFormCancel.bind(_this, root));
      }

      if (ticketFormSubmit) {
        ticketFormSubmit.addEventListener('click', _this.handleFormSubmit.bind(_this, root));
      }

      document.addEventListener('click', function (e) {
        if (e.target.matches(_this.loadMoreSelector)) {
          _this.loadMoreComments();
        }

        if (e.target.matches(_this.readMoreTextSelector)) {
          _this.handleReadMoreClick(e.target.closest(_this.commentEntrySelector));
        }
      });
    });
  },
  hasMoreComments: function hasMoreComments() {
    if (this.interactionsToLoad.length > 0) {
      document.querySelector(this.loadMoreSelector).classList.remove('hidden');
    } else {
      document.querySelector(this.loadMoreSelector).classList.add('hidden');
    }
  },
  addDialogCloseListener: function addDialogCloseListener(modal) {
    var _this2 = this;

    var button = modal.querySelector(this.dialogCloseSelector);

    if (button) {
      var handleDialogCloseClick = function handleDialogCloseClick(e) {
        var _window$openSimpleLig;

        e.preventDefault();
        var content = modal.querySelector(_this2.modalContentSelector);

        if (content) {
          content.innerHTML = '';
        }

        (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
      };

      button.addEventListener('click', handleDialogCloseClick.bind(modal));
    }
  },
  fetchInteractionData: function fetchInteractionData(interactionId) {
    return _tools.default.service(this.commentAction + interactionId, 'GET', undefined, undefined);
  },
  handleAttachment: function handleAttachment(template, attachmentData) {
    var attachmentHref = '{attachmentHref}';
    var attachmentIcon = '{attachmentIcon}';
    var attachmentText = '{attachmentText}';
    var attachmentTemplate = $(template.innerHTML).find(this.attachmentTemplateSelector);
    var attachment = attachmentTemplate[0].outerHTML;

    for (var attachmentProp in attachmentData) {
      if (attachmentProp === 'name') {
        var fileName = attachmentData[attachmentProp];
        var fileExtension = fileName.split('.').pop();
        attachment = attachment.replace(new RegExp(attachmentText, 'g'), fileName);
        attachment = attachment.replace(new RegExp(attachmentIcon, 'g'), _attachmentIcons.default.getFileTypeFromFileExtension(fileExtension));
      } else if (attachmentProp === 'text' || attachmentProp === 'size' || attachmentProp === 'href' || attachmentProp === 'icon') {
        var propCapitalized = attachmentProp.charAt(0).toUpperCase() + attachmentProp.slice(1);
        var attachmentRegExp = new RegExp('{attachment' + propCapitalized + '}', 'g');
        attachment = attachment.replace(attachmentRegExp, attachmentData[attachmentProp]);
      }
    }

    if (attachment.indexOf(attachmentHref) !== -1) {
      attachment = attachment.replace(new RegExp(attachmentHref, 'g'), '');
      attachment = attachment.replace(/href=""/g, '');
    }

    attachment = attachment.replace('data-src', 'src');
    attachment = attachment.replace(/hidden/g, '');
    return attachment;
  },
  addInteraction: function addInteraction(root, interaction) {
    var _this3 = this;

    var first = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var commentsList = root.querySelector(this.commentsListSelector);
    var template = root.querySelector(this.commentEntryTemplateSelector);

    if (template) {
      var templateClone = template.innerHTML;
      var attachments = '';
      var hasAttachments = false;
      this.interactionDataList[interaction.interactionId] = interaction;

      for (var prop in interaction) {
        if (prop === 'isClient') {
          var regExp = new RegExp('{' + prop + '}', 'g');
          var clientClass = interaction[prop] ? '' : 'is-support';
          templateClone = templateClone.replace(regExp, clientClass);
        } else if (prop !== 'attachments') {
          var _regExp = new RegExp('{' + prop + '}', 'g');

          templateClone = templateClone.replace(_regExp, interaction[prop]);
        } else {
          // eslint-disable-next-line no-loop-func
          [].forEach.call(interaction[prop], function (attachmentData) {
            if (attachmentData.fileAttachment) {
              attachments += _this3.handleAttachment(template, attachmentData.fileAttachment);
            } else {
              attachments += _this3.handleAttachment(template, attachmentData);
            }

            hasAttachments = true;
          });
        }
      }

      var isFirst = first ? 'is-first' : '';
      var hiddenInfo = isFirst && hasAttachments ? '' : 'hidden';
      templateClone = templateClone.replace(/{attachments}/g, attachments);
      templateClone = templateClone.replace(/{interactionId}/g, '');
      templateClone = templateClone.replace(/{href}/g, '');
      templateClone = templateClone.replace(/{isFirst}/g, isFirst);
      templateClone = templateClone.replace(/{hiddenInfo}/g, hiddenInfo);
    }
  },
  resetTicketForm: function resetTicketForm(root) {
    var ticketFormParent = root.querySelector(this.ticketFormParentSelector);
    var ticketForm = ticketFormParent.querySelector('form');

    if (ticketFormParent) {
      ticketFormParent.classList.remove(_state.default.OPEN);
    }

    if (ticketForm) {
      ticketForm.reset();
    }

    history.replaceState(null, null, window.location.pathname);
  },
  handleFormSubmit: function handleFormSubmit(root, e) {
    var _this4 = this;

    e.preventDefault();
    var ticketForm = root.querySelector(this.ticketFormSelector);
    var hasErrors = false;
    [].forEach.call(ticketForm.querySelectorAll('input, select, textarea'), function (el) {
      var errors = validate(el);

      if (errors.length > 0) {
        handleErrors(errors);
        hasErrors = true;
      }
    });

    if (!hasErrors) {
      var action = ticketForm.getAttribute('action');

      var formData = _tools.default.getFormData(ticketForm, true);

      var headers = {
        'X-Requested-With': 'XMLHttpRequest'
      };

      _tools.default.enableLoading();

      formData.get('attachment').size <= 0 && formData.delete('attachment');

      _tools.default.service(action, 'POST', formData, headers, ticketForm).then(function (response) {
        response.json().then(function (json) {
          _tools.default.disableLoading();

          _this4.showSuccess(root, json);

          _this4.renderNewComment(json, true);
        }).catch(function (error) {
          _tools.default.disableLoading();

          console.debug(error);

          _this4.showError(root);
        });
      });
    }
  },
  showSuccess: function showSuccess(root, data) {
    var _this5 = this;

    var ticketForm = root.querySelector(this.ticketFormSelector);
    var delay = 800;
    var ticketFormParent = root.querySelector(this.ticketFormParentSelector);

    if (ticketFormParent) {
      ticketFormParent.classList.add(_state.default.OPEN);
      setTimeout(function () {
        _this5.addInteraction(root, data, true);
      }, delay);
    } else {
      this.addInteraction(root, data, true);
    }

    var addCommentLink = root.querySelector(this.addCommentSelector);

    if (addCommentLink) {
      addCommentLink.classList.remove(_state.default.HIDDEN);
    }

    this.changeUrlState();
  },
  changeUrlState: function changeUrlState() {
    history.replaceState(null, null, window.location.pathname + '#commentadded');
  },
  showError: function showError(root) {
    var error = root.querySelector(this.errorDialogSelector);

    if (error) {
      _simpleLightbox.default.open({
        element: error
      });

      this.addErrorListener();
    }
  },
  addErrorListener: function addErrorListener() {
    var button = document.querySelector(this.errorButtonSelector);

    if (button) {
      button.addEventListener('click', function (e) {
        var _window$openSimpleLig2;

        e.preventDefault();
        (_window$openSimpleLig2 = window.openSimpleLightbox) === null || _window$openSimpleLig2 === void 0 ? void 0 : _window$openSimpleLig2.close();
      });
    }
  },
  handleFormCancel: function handleFormCancel(root, e) {
    e.preventDefault();
    var addCommentLink = root.querySelector(this.addCommentSelector);
    var ticketForm = root.querySelector(this.ticketFormSelector);

    if (addCommentLink) {
      addCommentLink.classList.remove(_state.default.HIDDEN);
    }

    if (ticketForm) {
      ticketForm.classList.remove(_state.default.VISIBLE);
    }
  },
  handleAddComment: function handleAddComment(root, e) {
    e.preventDefault();
    var addCommentLink = e.currentTarget;

    if (addCommentLink) {
      addCommentLink.classList.add(_state.default.HIDDEN);
    }

    this.resetTicketForm(root);
    this.fadeInTicketForm(root);
  },
  fadeInTicketForm: function fadeInTicketForm(root) {
    var ticketForm = root.querySelector(this.ticketFormSelector);
    var delay = 800;

    if (ticketForm) {
      _tools.default.scrollTo(root.querySelector(this.ticketFormParentSelector), delay);

      _tools.default.show(ticketForm, delay);
    }
  },
  ensureList: function ensureList(prop) {
    return Array.isArray(prop) ? prop : [prop];
  },
  useData: function useData(data) {
    data.serviceTicketDetail.comments || (data.serviceTicketDetail.comments = {});
    data.serviceTicketDetail.comments.entries || (data.serviceTicketDetail.comments.entries = []);
    data.serviceTicketDetail.interactionIds || (data.serviceTicketDetail.interactionIds = []);
    var visibleComments = this.ensureList(data.serviceTicketDetail.comments.entries).map(function (comment) {
      return comment.interactionId;
    });
    this.interactionsToLoadAmount = visibleComments.length;
    this.interactionsToLoad = this.ensureList(data.serviceTicketDetail.interactionIds).map(function (interactionId) {
      return interactionId.id;
    });
    this.commentAction = data.serviceTicketDetail.comments.commentAction;
  },
  loadData: function loadData() {
    var _this6 = this;

    if (document.querySelector(this.loadUrlSelector)) {
      _tools.default.enableLoading();

      var loadUrl = document.querySelector(this.loadUrlSelector).dataset.load;

      _tools.default.service(loadUrl, 'GET', undefined, undefined).then(function (response) {
        response.json().then(function (data) {
          _this6.useData(data);

          var commentEntries = _toConsumableArray(_this6.ensureList(data.serviceTicketDetail.comments.entries).values());

          data.serviceTicketDetail.comments.entries = undefined;
          data.serviceTicketDetail.comments.commentCount = commentEntries.length + _this6.interactionsToLoad.length;

          _this6.getRenderedTemplate(data).then(function (loadedData) {
            _this6.update(loadedData);

            commentEntries.forEach(function (commentEntry) {
              return _this6.renderNewComment(commentEntry);
            });

            _tools.default.disableLoading();

            document.querySelector(_this6.serviceTicketDetailPlaceholderSelector).remove();

            _this6.load();
          });
        });
      });
    }
  },
  handleReadMoreClick: function handleReadMoreClick(commentEntryElement) {
    var iframeContainerElement = commentEntryElement.querySelector(this.commentDescriptionIframeContainerSelector);
    var readMoreElement = commentEntryElement.querySelector(this.readMoreTextSelector);
    this.expandIframe(iframeContainerElement);
    this.removeReadMore(readMoreElement);
  },
  removeReadMore: function removeReadMore(readMoreElement) {
    readMoreElement.remove();
  },
  expandIframe: function expandIframe(iframeElement) {
    iframeElement.classList.add('expanded');
  },
  getRenderedTemplate: function getRenderedTemplate(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('cmscomponents-serviceticket-detail', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRenderedTemplateCommentsEntry: function getRenderedTemplateCommentsEntry(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('atoms-serviceticket-detail-comments-entry', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  renderNewComment: function renderNewComment(commentData) {
    var _this7 = this;

    var insertBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return new Promise(function (resolve) {
      _this7.getRenderedTemplateCommentsEntry(commentData).then(function (renderedData) {
        var newComment = _this7.addComment(renderedData, insertBefore);

        _this7.commentSetIframe(newComment, commentData.descriptionFull || commentData.description || '');

        resolve();
      });
    });
  },
  loadMoreComments: function loadMoreComments() {
    var _this8 = this;

    _tools.default.enableLoading();

    var loadedAllComments = new Array();

    _toConsumableArray(Array(this.interactionsToLoadAmount)).map(function () {
      loadedAllComments.push(new Promise(function (resolve) {
        var interactionId = _this8.interactionsToLoad.shift();

        interactionId ? _this8.fetchInteractionData(interactionId).then(function (response) {
          return response.json();
        }).then(function (newInteractionData) {
          _this8.renderNewComment(newInteractionData).then(function () {
            return resolve();
          });
        }) : resolve();
      }));
    }, this);

    Promise.all(loadedAllComments).then(function () {
      _this8.hasMoreComments();

      _tools.default.disableLoading();
    });
  },
  commentSetIframe: function commentSetIframe(comment, content) {
    var iframeElement = comment.querySelector(this.commentDescriptionIframeSelector);
    var iframeStyles = "<style>\n      html, body {\n        margin: 0;\n        padding: 0;\n      }\n      * {\n        color: #1f1f28 !important;\n        font-family: Arial, sans-serif;\n        font-size: 13px;\n        line-height: 22px;\n      }\n      @media (prefers-color-scheme: dark) {\n        * {\n          color: #fff !important;\n        }\n      }\n    </style>";
    iframeElement.srcdoc = "".concat(iframeStyles, " ").concat(content);
  },
  addComment: function addComment(html) {
    var insertBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var createElement = function createElement() {
      var div = document.createElement('div');
      div.innerHTML = html.trim();
      return div.firstChild;
    };

    var commentsList = document.querySelector(this.commentsListSelector);
    var newComment = createElement();

    if (insertBefore) {
      commentsList.insertBefore(newComment, commentsList.children[1]);
    } else {
      commentsList.insertBefore(newComment, _toConsumableArray(commentsList.children)[commentsList.children.length - 2]);
    }

    return newComment;
  },
  update: function update(html) {
    document.querySelector(this.rootSelector) ? document.querySelector(this.rootSelector).outerHTML = html : undefined;

    _cmscomponentUpload.default.init();
  }
};
var _default = ServiceticketDetail;
exports.default = _default;

},{"../simple-lightbox":231,"./cmscomponent-form-serviceticket":196,"./cmscomponent-upload":220,"attachment-icons":181,"state":232,"templates":235,"tools":236}],211:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ShowMore = /*#__PURE__*/function () {
  function ShowMore(root) {
    _classCallCheck(this, ShowMore);

    this.root = root;
    this.button = this.root.querySelector('.cmscomponent-show-more__button');
    this.parent = this.root.parentNode;
    this.itemClass = 'cmscomponent-show-more__items';
    this.itemSelector = ".".concat(this.itemClass);
    this.breakpointBelow = 'md';
    this.bindEvents();
    this.initExpander(true);
  }

  _createClass(ShowMore, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      if (this.button) {
        this.button.addEventListener('click', this.handleClick.bind(this));
      }

      window.addEventListener('resize', function () {
        _this.checkFilter();
      });
    }
  }, {
    key: "checkFilter",
    value: function checkFilter() {
      if (this.hasExpander()) {
        this.handleExpander(true);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.parent !== null) {
        this.parent.classList.add(_state.default.EXPANDED);
        this.parent.classList.remove(_state.default.HAS_EXPANDER);
        [].forEach.call(this.parent.querySelectorAll('.' + _state.default.HIDDEN), function (hiddenItem) {
          hiddenItem.classList.remove(_state.default.HIDDEN);
        });
      }
    }
  }, {
    key: "hasExpander",
    value: function hasExpander() {
      return this.parent.classList.contains(_state.default.HAS_EXPANDER);
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      return this.parent.classList.contains(_state.default.EXPANDED);
    }
  }, {
    key: "handleExpander",
    value: function handleExpander(reset) {
      var mobile = _tools.default.screen(this.breakpointBelow, true);

      this.parent.classList.remove(_state.default.HAS_EXPANDER);
      this.parent.classList.remove(_state.default.EXPANDED);
      this.parent.classList.remove(_state.default.LOADED);

      if (reset) {
        this.resetFilterItems(this.parent);
      }

      if (this.canExpand(this.parent)) {
        this.parent.classList.add(_state.default.HAS_EXPANDER);

        if (!mobile) {
          this.prepareExpander(this.parent);
        }
      } else {
        this.parent.classList.add(_state.default.LOADED);
      }
    }
  }, {
    key: "resetFilterItems",
    value: function resetFilterItems(container) {
      [].forEach.call(container.querySelectorAll(':scope > *'), function (item) {
        item.classList.remove(_state.default.HIDDEN);
        item.style.order = null;
      });
    }
  }, {
    key: "canExpand",
    value: function canExpand(container) {
      return container.scrollHeight > this.expandHeightThreshold;
    }
  }, {
    key: "isInFirstRow",
    value: function isInFirstRow(element) {
      return element.offsetTop <= this.expandOffsetTop;
    }
  }, {
    key: "prepareExpander",
    value: function prepareExpander(container) {
      var lastPosition;
      var orders = [];

      for (var i = 0; i < container.children.length; i++) {
        var item = container.children[i];
        var isExpander = item.classList.contains(ShowMore.rootClass);

        if (!this.isInFirstRow(item)) {
          if (!lastPosition) {
            lastPosition = i;
          }
        }

        if (isExpander) {
          item.style.order = lastPosition;
        }

        if (lastPosition && !isExpander) {
          item.classList.add(_state.default.HIDDEN);
          orders[i + 1] = item;
        } else if (!isExpander) {
          orders[i] = item;
        }
      }

      this.setHiddenOrders(orders);
      this.fixPosition(lastPosition, container);
      container.classList.add(_state.default.LOADED);
    }
  }, {
    key: "setHiddenOrders",
    value: function setHiddenOrders(items) {
      for (var i = 0; i < items.length; i++) {
        var order = items[i];

        if (order) {
          order.style.order = i;
        }
      }
    }
  }, {
    key: "fixPosition",
    value: function fixPosition(order, container) {
      if (!this.isInFirstRow(this.root)) {
        var previousOrder = order - 1;
        var element = container.children[previousOrder];

        if (element) {
          element.style.order = order;
          element.classList.add(_state.default.HIDDEN);
          this.root.style.order = previousOrder;
        }
      }
    }
  }, {
    key: "prepareParent",
    value: function prepareParent() {
      this.parent.classList.add(this.itemClass);
    }
  }, {
    key: "setupConditions",
    value: function setupConditions() {
      var firstItem = this.parent.querySelector('*');
      var expandBuffer = 10;
      this.expandOffsetTop = firstItem.offsetHeight / 2;
      this.expandHeightThreshold = firstItem.offsetHeight * 2 + expandBuffer;
    }
  }, {
    key: "initExpander",
    value: function initExpander(firstTime) {
      if (firstTime && !this.isExpanded()) {
        this.prepareParent();
        this.setupConditions();
        this.handleExpander();
      }
    }
  }], [{
    key: "initAll",
    value: function initAll() {
      ShowMore.instances = [];
      [].forEach.call(document.querySelectorAll(ShowMore.rootSelector), function (element) {
        ShowMore.init(element);
      });
    }
  }, {
    key: "init",
    value: function init(element) {
      var rootElement = element.classList.contains(ShowMore.rootClass) ? element : element.querySelector(ShowMore.rootSelector);

      if (rootElement) {
        ShowMore.instances.push(new ShowMore(rootElement));
      } else {
        console.warn("No ".concat(ShowMore.rootClass, " found in"), element);
      }
    }
  }]);

  return ShowMore;
}();

_defineProperty(ShowMore, "rootClass", 'cmscomponent-show-more');

_defineProperty(ShowMore, "rootSelector", ".".concat(ShowMore.rootClass));

_defineProperty(ShowMore, "instances", []);

var _default = ShowMore;
exports.default = _default;

},{"state":232,"tools":236}],212:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireDefault(require("event-names"));

var _tools = _interopRequireDefault(require("tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortFilter = {
  init: function init() {
    this.rootSelector = '.cmscomponent-sort-filter';
    this.toggleSelector = '.cmscomponent-sort-filter__toggle';
    this.contentSelector = '.cmscomponent-sort-filter__content';
    this.filterItemsSelector = '.cmscomponent-sort-filter__items';
    this.expanderSelector = '.cmscomponent-sort-filter__item-expander';
    this.filterSelector = '.js-Dropdown-list .is-selected';
    this.ordersAndContractsContentSelector = '.cmscomponent-your-orders-and-contracts-items';
    this.invoiceContentSelector = '.cmscomponent-css-invoices';
    this.contentEntries = '.atom-your-order-and-contract';
    this.noEntriesSelector = '.cmscomponent-sort-filter-no-entries';
    this.submitSelector = '.atom-dropdown-submit';
    this.submitButtonSelector = this.submitSelector + ' .atom-button';
    this.bindListeners();
    this.handleSort('date_desc', this.selectContentQuerySelector());
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (filter) {
      [].forEach.call(filter.querySelectorAll(_this.toggleSelector), function (toggle) {
        toggle.addEventListener('click', function () {
          _this.handleClick(filter);
        });
      });
      var expander = filter.querySelector(_this.expanderSelector);
      expander.addEventListener('click', function () {
        var filterItems = expander.closest(_this.filterItemsSelector);

        if (filterItems !== null) {
          filterItems.removeAttribute('data-max-items');
        }
      });
    });
    document.getElementsByTagName('body')[0].addEventListener(_eventNames.default.ATOM_DROPDOWN_ALL_CHANGED, this.handleDropdownEvent.bind(this));
    document.getElementsByTagName('body')[0].addEventListener(_eventNames.default.CMSCOMPONENT_SORT_FILTER_CLOSE, this.handleCloseEvent.bind(this));
    window.addEventListener('resize', function () {
      _this.close();
    });
  },
  selectContentQuerySelector: function selectContentQuerySelector() {
    return document.querySelectorAll(this.contentEntries).length ? this.contentEntries : this.invoiceContentSelector + ' a';
  },
  handleCloseEvent: function handleCloseEvent(event) {
    var selectedFilterOverlay = '.' + event.detail.message.className;
    var closeSelectedFilterOverlay = document.querySelector(selectedFilterOverlay);
    this.handleClick(closeSelectedFilterOverlay);
  },
  handleDropdownEvent: function handleDropdownEvent(event) {
    var selectedDropdown = event.detail.message.name;
    var contentContainerSelector = document.querySelectorAll(this.ordersAndContractsContentSelector).length ? this.ordersAndContractsContentSelector : this.invoiceContentSelector;

    if (selectedDropdown === 'sortoforder' || selectedDropdown === 'filter') {
      this.handleFilter(event, contentContainerSelector, this.selectContentQuerySelector());
    } else if (selectedDropdown === 'sorting') {
      this.handleSort(event.detail.option.value, this.selectContentQuerySelector());
    }
  },
  handleFilter: function handleFilter(event, contentContainerSelector, contentQuerySelector) {
    var _this2 = this;

    var filterContainer = event.detail.option.closest('.cmscomponent-sort-filter__items');
    var allOptions = filterContainer.querySelectorAll('.atom-checkbox.small input[checked="true"]');
    var allEntries = document.querySelectorAll(contentQuerySelector);
    var noEntriesFound = document.querySelector(this.noEntriesSelector);
    [].forEach.call(document.querySelectorAll(contentContainerSelector), function (selectedElements) {
      var allElements = selectedElements.querySelectorAll(contentQuerySelector);

      if (!allOptions.length) {
        [].forEach.call(allElements, function (element) {
          _this2.handleShowElement(element);
        });
      } else {
        [].forEach.call(allElements, function (element) {
          if (_this2.handleOptionCheck(element, allOptions)) {
            _this2.handleShowElement(element);
          } else {
            _this2.handleHideElement(element);
          }
        });
      }
    });

    if (this.handleVisibilityCheck(allEntries)) {
      this.handleHideElement(noEntriesFound);
    } else {
      this.handleShowElement(noEntriesFound);
    }
  },
  handleVisibilityCheck: function handleVisibilityCheck(entries) {
    var result = false;
    [].forEach.call(entries, function (entry) {
      if (entry.classList.contains(_state.default.VISIBLE)) {
        result = true;
      }
    });
    return result;
  },
  handleOptionCheck: function handleOptionCheck(element, options) {
    var result = false;
    [].forEach.call(options, function (checkedOptions) {
      if (checkedOptions.value in element.dataset) {
        result = true;
      }
    });
    return result;
  },
  handleShowElement: function handleShowElement(element) {
    element.classList.remove(_state.default.HIDDEN);
    element.classList.add(_state.default.VISIBLE);
  },
  handleHideElement: function handleHideElement(element) {
    element.classList.remove(_state.default.VISIBLE);
    element.classList.add(_state.default.HIDDEN);
  },
  isDate: function isDate(value) {
    var dateLength = 8;

    if (value && value.indexOf('.') === 2 && value.length >= dateLength) {
      return true;
    } else {
      return false;
    }
  },
  handleSort: function handleSort(value, contentQuerySelector) {
    var _this3 = this;

    [].forEach.call(document.querySelectorAll(contentQuerySelector), function (theDate) {
      if (_this3.isDate(theDate.dataset[value.split('_')[0]])) {
        _this3.sortingEntries(value, contentQuerySelector, true);
      } else {
        _this3.sortingEntries(value, contentQuerySelector, false);
      }
    });
  },
  sortingEntries: function sortingEntries(value, contentQuerySelector, isDate) {
    var _this4 = this;

    var sortArray = new Array();
    var dataValue = value.split('_')[0];
    var priceValueMatch = {};
    [].forEach.call(document.querySelectorAll(contentQuerySelector), function (selectedOrderEntrie) {
      var selectedValue = selectedOrderEntrie.dataset[dataValue];

      if (isDate) {
        sortArray.push(selectedValue.split('.').join(''));
      } else {
        // fix price seperator
        var priceSeperator = ',';

        if (typeof selectedValue === 'string' && selectedValue.indexOf(priceSeperator) !== -1) {
          var correctPriceSeperator = '.';
          var oldValue = selectedValue;
          selectedValue = selectedValue.replace(priceSeperator, correctPriceSeperator);
          priceValueMatch[selectedValue] = oldValue;
        } else {
          priceValueMatch[selectedValue] = selectedValue;
        }

        sortArray.push(selectedValue);
      }
    });

    if (value.split('_')[1] === 'asc') {
      sortArray.sort(function (a, b) {
        return a - b;
      }); // For ascending sort
    } else {
      sortArray.sort(function (a, b) {
        return b - a;
      }); // For descending sort
    }

    if (isDate) {
      sortArray.forEach(function (entry, index) {
        [].forEach.call(document.querySelectorAll(contentQuerySelector + '[data-' + dataValue + '="' + _this4.formatingDate(entry) + '"]'), function (selectedEntrie) {
          selectedEntrie.style.order = index;
        });
      });
    } else {
      sortArray.forEach(function (entry, index) {
        var entryValue = priceValueMatch[entry];
        [].forEach.call(document.querySelectorAll(contentQuerySelector + '[data-' + dataValue + '="' + entryValue + '"]'), function (selectedEntrie) {
          selectedEntrie.style.order = index;
        });
      });
    }
  },
  formatingDate: function formatingDate(entry) {
    var day = entry.slice(0, 2);
    var month = entry.slice(2, 4);
    var year = entry.slice(4, 6);
    return day + '.' + month + '.' + year;
  },
  handleClick: function handleClick(element) {
    var content = element.querySelector(this.contentSelector);

    if (content.classList.contains(_state.default.OPEN)) {
      this.close(content);
    } else {
      this.open(content);
    }
  },
  close: function close(content) {
    var selectedContent = content || document.querySelector(this.rootSelector + ' ' + this.contentSelector + '.' + _state.default.OPEN);

    if (selectedContent !== null) {
      selectedContent.classList.remove(_state.default.OPEN);
    }

    _tools.default.enableScrolling();
  },
  open: function open(content) {
    content.classList.add(_state.default.OPEN);

    _tools.default.disableScrolling();
  }
};
var _default = SortFilter;
exports.default = _default;

},{"event-names":224,"state":232,"tools":236}],213:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("../tools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = require('flickity');

var stage = {
  init: function init() {
    if (!window.sliders) {
      window.sliders = {};
    }

    [].forEach.call(document.querySelectorAll('.cmscomponent-stage'), function (sliderContainer) {
      var uniqueId = window.guid();
      var mainSlider = sliderContainer.querySelector('.main-carousel');
      var navigationItems = sliderContainer.querySelectorAll('.navigation-item');
      var lastNavigationItem = navigationItems[navigationItems.length - 1];
      var remaining = document.querySelector('.remaining');

      var activeSlide = function activeSlide(index) {
        navigationItems[index].classList.add('is-loading');
        navigationItems[index].classList.add('navigation-item-is-active');
      };

      function initSlider() {
        var flickityInstance = new Flickity(mainSlider, {
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
          autoPlay: 6000,
          on: {
            ready: function ready() {
              activeSlide(this.selectedIndex);
            }
          }
        });
        window.sliders[uniqueId] = flickityInstance;

        var fillLoadingBarsBefore = function fillLoadingBarsBefore(maxIndex) {
          navigationItems.forEach(function (navigationItem, navigationItemIndex) {
            if (navigationItemIndex < maxIndex) {
              navigationItem.classList.add('is-loading');
              navigationItem.classList.add('is-full');
            } else {
              navigationItem.classList.remove('is-loading');
              navigationItem.classList.remove('is-full');
            }
          });
        };

        var startLoadingAnimation = function startLoadingAnimation(navigationItem) {
          navigationItem.classList.add('is-loading');
        };

        var startFadeOutAnimation = function startFadeOutAnimation() {
          remaining.classList.add('is-loading');
          flickityInstance.stopPlayer();
        };

        var stopFadeOutAnimation = function stopFadeOutAnimation() {
          remaining.classList.remove('is-loading');
        };

        var stopFadeOutAnimationIfPlaying = function stopFadeOutAnimationIfPlaying() {
          if (remaining.classList.contains('is-loading')) {
            stopFadeOutAnimation();
          }
        };

        var resetAnimations = function resetAnimations() {
          navigationItems.forEach(function (navigationItem) {
            navigationItem.classList.remove('is-loading');
            navigationItem.classList.remove('is-full');
          });
          remaining.classList.remove('is-loading');
        };

        var restartSlider = function restartSlider() {
          resetAnimations();
          setTimeout(function () {
            startLoadingAnimation(navigationItems[0]);
            flickityInstance.playPlayer();
            flickityInstance.select(0);
          });
        };

        var isLastSlide = function isLastSlide() {
          return flickityInstance.selectedIndex === navigationItems.length - 1;
        }; // Tab Navigation


        navigationItems.forEach(function (navigationItem, navigationItemIndex) {
          navigationItem.addEventListener('click', function () {
            var currentSlideIndex = flickityInstance.selectedIndex; // don't do anything at all while we are in fade out loading state!

            if (isLastSlide() && remaining.classList.contains('is-loading')) {
              return;
            }

            stopFadeOutAnimationIfPlaying();

            if (navigationItemIndex === currentSlideIndex) {
              return;
            }

            flickityInstance.stopPlayer(); // fill all loading bars, except the current one

            fillLoadingBarsBefore(navigationItemIndex); // select the clicked index

            flickityInstance.select(navigationItemIndex);
            flickityInstance.playPlayer();
          });
        });
        lastNavigationItem.addEventListener('animationend', function () {
          startFadeOutAnimation();
        });
        remaining.addEventListener('animationend', function () {
          restartSlider();
        }); // Flickity

        flickityInstance.on('change', function () {
          var correspondingNavigationItem = navigationItems[flickityInstance.selectedIndex];

          if (isLastSlide()) {
            flickityInstance.stopPlayer();
          }

          navigationItems.forEach(function (navigationItem) {
            navigationItem.classList.remove('navigation-item-is-active');
          });
          correspondingNavigationItem.classList.add('navigation-item-is-active');
          setTimeout(function () {
            return startLoadingAnimation(correspondingNavigationItem);
          });
        });
        /*
          Set flickity labels for mobile devices
          */

        var updateElementText = function updateElementText(element, text) {
          element.innerText = text;
        };

        var applyNavigationItemLabels = function applyNavigationItemLabels() {
          [].forEach.call(navigationItems, function (navigationItem, index) {
            var labelElement = navigationItem.querySelector('.navigation-text');
            var label = labelElement.getAttribute('data-label');

            function formatNumber(number) {
              return (number < 10 ? '0' : '') + number;
            }

            if (!_tools.default.screen('sm')) {
              // Desktop, Tablet
              updateElementText(navigationItem.querySelector('.navigation-text'), label);
            } else {
              // Mobile
              updateElementText(navigationItem.querySelector('.navigation-text'), formatNumber(index + 1));
            }
          });
        };

        window.addEventListener('resize', function () {
          applyNavigationItemLabels();
        });
        applyNavigationItemLabels();
      }

      var allImages = mainSlider.querySelectorAll('picture img');
      var imageLoadCounter = 0;

      var checkImagesLoaded = function checkImagesLoaded() {
        imageLoadCounter++;

        if (imageLoadCounter === allImages.length) {
          initSlider();
        }
      };

      [].forEach.call(allImages, function (image) {
        image.onerror = function () {
          var reloadText = '#reload';

          if (image.srcset.indexOf(reloadText) === -1) {
            // safari 400 problem reload
            image.srcset = image.srcset + '#reload';
          }
        };

        if (image.complete) {
          checkImagesLoaded();
        } else {
          image.addEventListener('load', function () {
            checkImagesLoaded();
          });
        }
      });
    });
  }
};
var _default = stage;
exports.default = _default;

},{"../tools":236,"flickity":17}],214:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireDefault(require("event-names"));

var _tools = _interopRequireDefault(require("tools"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

var _zoom = _interopRequireDefault(require("zoom"));

var _screens = _interopRequireDefault(require("screens"));

var _vanillaZoom = _interopRequireDefault(require("vanillaZoom"));

var _templates = _interopRequireDefault(require("templates"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = require('flickity');

require('flickity-as-nav-for');

var StageProduct = {
  init: function init() {
    this.rootSelector = '.cmscomponent-stageproduct';
    this.pricesHeadlineSelector = '.cmscomponent-stageproduct-prices-headline';
    this.amountLimitSelector = '[data-amount-limit]';
    this.pricetagSelector = '.cmscomponent-stageproduct-pricing .atom-pricetag';
    this.naviBreakpoint = 'md';
    this.currentGraduation = 0;
    this.graduationData = [];
    this.sliderSelectedClass = 'is-nav-selected';
    this.sliderSelectedSelector = '.' + this.sliderSelectedClass;
    this.sliderHeightTreshhold = 350;
    this.root = null;
    this.itemPriceTagSelector = '.atom-pricetag';
    this.itemPriceSelector = '.atom-pricetag-price-cost';
    this.itemStrikePriceSelector = '.atom-pricetag-strikeprice';
    this.itemValueSelector = '.atom-pricetag-price-value';
    this.itemCurrencySelector = '.atom-pricetag-currency-value';
    this.itemDeliverySelector = '.atom-pricetag-delivery span';
    this.itemPreTextSelector = '.atom-pricetag-price-prefix';
    this.deliveryTimeSelector = '.cmscomponent-stageproduct-cart-delivery';
    this.addToCartSelector = '.cmscomponent-stageproduct-cart .atom-button';
    this.vanillaZoomOverlaySelector = '.vanilla-zoom--overlay';
    this.currentZoomWrapperSelector = '.vanilla-zoom-wrapper.is-selected';
    this.previewSelector = this.vanillaZoomOverlaySelector + ' .preview';
    this.badgeSelector = '.cmscomponent-stageproduct-badges-wrapper';
    this.textContentSelector = '.cmscomponent-stageproduct-textcontent';
    this.zoomOverlayClass = 'cmscomponent-stageproduct__zoom-overlay';
    this.zoomOverlaySelector = '.' + this.zoomOverlayClass;
    this.zoomBackgroundClass = 'cmscomponent-stageproduct__zoom-background';
    this.zoomBackgroundSelector = '.' + this.zoomBackgroundClass;
    this.zoomPositionClass = 'cmscomponent-stageproduct__zoom-position';
    this.zoomPositionSelector = '.' + this.zoomPositionClass;
    this.customStyleClass = 'cmscomponent-stageproduct__custom-style';
    this.customStyleSelector = '.' + this.customStyleClass;
    this.slideSelector = '.cmscomponent-stageproduct-slide';
    this.picturesSelector = '.cmscomponent-stageproduct-pictures';
    this.thumbnailClass = 'cmscomponent-stageproduct-thumbnail';
    this.thumbnailSelector = '.' + this.thumbnailClass;
    this.pricesDataSelector = '.cmscomponent-stageproduct-prices';
    this.pricesDataTableSelector = '.cmscomponent-stageproduct-prices-table';
    this.bodySelector = 'body';
    this.dataPriceUpdateUrlSelector = 'data-price-update-url';
    this.stageproductAmountSelector = '.cmscomponent-stageproduct-amount';
    this.stageproductAmountDropdownSelector = "".concat(this.stageproductAmountSelector, " select");
    this.discountAmount = '.atom-pricetag-discount-amount';
    this.dataPriceUpdateLoading = 'data-price-update-loading';
    this.enableGraduationPriceChange = false;
    this.zoom = new _zoom.default();
    this.itemElementList = [{
      name: 'price',
      selector: this.itemPriceSelector
    }, {
      name: 'currency',
      selector: '.atom-pricetag-price .atom-pricetag-price-currency small'
    }, {
      name: 'unit',
      selector: '.atom-pricetag-price .atom-pricetag-per small'
    }, {
      name: 'strikePriceCurrency',
      selector: this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'discountAmount',
      selector: this.discountAmount
    }, {
      name: 'preText',
      selector: this.itemPreTextSelector
    }, {
      name: 'strikethroughPrice',
      selector: this.itemStrikePriceSelector + ' ' + this.itemValueSelector,
      parent: this.itemStrikePriceSelector
    }, {
      name: 'delivery',
      selector: this.itemDeliverySelector
    }, {
      name: 'badges',
      selector: this.badgeSelector,
      updateAll: true
    }];
    this.getGraduationData();
    this.initSliders();
    this.bindListeners();
    this.checkPriceUrlLoader();

    _atomDeliveryTime.default.init();

    if (document.querySelector(this.stageproductAmountDropdownSelector) && document.querySelector(this.rootSelector).getAttribute(this.dataPriceUpdateUrlSelector)) {
      this.updatePrice(document.querySelector(this.stageproductAmountDropdownSelector));
    }
  },
  checkPriceUrlLoader: function checkPriceUrlLoader() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var priceUrl = root.dataset.priceUrl;

      if (priceUrl !== undefined) {
        _tools.default.PriceUrlLoader.getPrices(root).then(function (data) {
          if (data !== undefined) {
            var price = data[0];

            _this.handlePrice(price, root);

            _this.handleAddToCart(price, root);

            _this.handlePricesData(price, root);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  },
  handlePricesData: function handlePricesData(price, root) {
    var _this2 = this;

    if (price.pricesData && price.pricesData.length) {
      var pricesColRendered = '';
      price.pricesData.map(function (data) {
        pricesColRendered = pricesColRendered + _this2.getPricesCol(data);
      });
      this.updatePricesData(pricesColRendered, root);
    } else {
      this.hidePricesData(root);
    }
  },
  updatePricesData: function updatePricesData(rendered, root) {
    if (rendered.length) {
      var pricesDataTable = root.querySelector(this.pricesDataTableSelector);

      if (pricesDataTable) {
        pricesDataTable.innerHTML = rendered;
      }
    }
  },
  hidePricesData: function hidePricesData(root) {
    var pricesData = root.querySelector(this.pricesDataSelector);

    if (pricesData) {
      pricesData.classList.add(_state.default.HIDDEN);
    }
  },
  getPricesCol: function getPricesCol(pricesCol) {
    if (pricesCol) {
      return "\n        <div class=\"cmscomponent-stageproduct-prices-col\">".concat(pricesCol.limitText, "</div>\n        <div class=\"cmscomponent-stageproduct-prices-col\"\n             data-amount-limit=\"").concat(pricesCol.limit, "\"\n             data-amount-delivery=\"").concat(pricesCol.delivery, "\"\n             data-amount-strike-price=\"").concat(pricesCol.strikePrice, "\">\n             ").concat(pricesCol.strikePrice ? "<div class=\"atom-pricetag-strikeprice\">\n              <span class=\"atom-pricetag-price-value\">".concat(pricesCol.strikePrice, "</span>\n              <span class=\"atom-pricetag-currency-value\">").concat(pricesCol.currency, "</span>\n            </div>") : '', "\n          <span class=\"price\">").concat(pricesCol.price, "</span> <span class=\"currency\">").concat(pricesCol.currency, "</span>\n          ").concat(pricesCol.unit ? "\n            <span class=\"unit\">".concat(pricesCol.unit, "</span>\n            ") : '', "\n        </div>\n      ");
    } else {
      return;
    }
  },
  handleAddToCart: function handleAddToCart(price, root) {
    if (price.disabled !== undefined && price.disabled === false) {
      var addToCartButton = root.querySelector(this.addToCartSelector);

      if (addToCartButton !== null) {
        addToCartButton.removeAttribute('disabled');
      }
    }
  },
  handleDeliveryTime: function handleDeliveryTime(price, root) {
    var deliveryTime = root.querySelector(this.deliveryTimeSelector);
    var data = price.deliveryTime;

    if (deliveryTime) {
      _atomDeliveryTime.default.update(deliveryTime, data);
    }
  },
  handlePrice: function handlePrice(price, root) {
    _tools.default.PriceUrlLoader.handlePrice(price, root, this.itemElementList, this.itemPriceTagSelector);

    if (price !== undefined) {
      this.handleDeliveryTime(price, root);
    }

    this.disableLoading(root);
  },
  disableLoading: function disableLoading(root) {
    root.removeAttribute('data-price-url');
  },
  checkSliderArrows: function checkSliderArrows(nav, topArrow, bottomArrow) {
    if (this.sliderIsScrollable(nav)) {
      var page = this.getScrollThumbsPage(nav);
      var scrollHeight = nav.scrollHeight;
      var maxScrollTop = nav.scrollTop + nav.clientHeight;
      var isDownScrollable = !(maxScrollTop >= scrollHeight);

      if (!page) {
        topArrow.classList.add(_state.default.DISABLED);
      } else {
        topArrow.classList.remove(_state.default.DISABLED);
      }

      if (isDownScrollable) {
        bottomArrow.classList.remove(_state.default.DISABLED);
      } else {
        bottomArrow.classList.add(_state.default.DISABLED);
      }
    } else {
      topArrow.classList.add(_state.default.DISABLED);
      bottomArrow.classList.add(_state.default.DISABLED);
    }
  },
  getScrollThumbsPage: function getScrollThumbsPage(nav) {
    var clientHeight = nav.clientHeight;
    var top = nav.scrollTop;
    return Math.ceil(top / clientHeight);
  },
  getScrollThumbsPageNext: function getScrollThumbsPageNext(nav, up) {
    var defaultPage = up ? 0 : 1;
    var modifier = up ? -1 : 1;
    return top ? this.getScrollThumbsPage(nav) + modifier : defaultPage;
  },
  scrollThumbs: function scrollThumbs(up, nav, topArrow, bottomArrow) {
    if (this.sliderIsScrollable(nav)) {
      var clientHeight = nav.clientHeight;
      var page = this.getScrollThumbsPageNext(nav, up);
      var scrollY = clientHeight * page;

      if (typeof nav.scrollTo === 'function') {
        nav.scrollTo({
          top: scrollY,
          behavior: 'smooth'
        });
      }
    }
  },
  sliderIsScrollable: function sliderIsScrollable(nav) {
    var result = false;

    if (nav.scrollHeight > this.sliderHeightTreshhold) {
      result = true;
    }

    return result;
  },
  handleSliderScroll: function handleSliderScroll(nav, topArrow, bottomArrow) {
    this.checkSliderArrows(nav, topArrow, bottomArrow);
  },
  initSliders: function initSliders() {
    var _this3 = this;

    if (!window.sliders) {
      window.sliders = {};
    }

    [].forEach.call(document.querySelectorAll(this.picturesSelector), function (sliderContainer) {
      var uniqueId = window.guid();
      var mainSlider = sliderContainer.querySelector('.main-carousel');
      var nav = sliderContainer.querySelector('.main-carousel-nav .navbar');
      var navCells = nav.querySelectorAll('.carousel-cell');
      var topArrow = sliderContainer.querySelector('.arrow-top');
      var bottomArrow = sliderContainer.querySelector('.arrow-bottom');

      if (navCells.length === 0) {
        topArrow.classList.add(_state.default.DISABLED);
        bottomArrow.classList.add(_state.default.DISABLED);
      } else {
        var flickityInstance = new Flickity(mainSlider, {
          contain: true,
          prevNextButtons: false,
          setGallerySize: false
        });
        window.sliders[uniqueId] = flickityInstance;
        [].forEach.call(navCells, function (navCell, index) {
          navCell.addEventListener('click', function () {
            flickityInstance.select(index);
          });
        });
        nav.addEventListener('scroll', _this3.handleSliderScroll.bind(_this3, nav, topArrow, bottomArrow));
        flickityInstance.on('select', function () {
          var currentSelectedNavCell = nav.querySelector(_this3.sliderSelectedSelector);

          if (currentSelectedNavCell) {
            currentSelectedNavCell.classList.remove(_this3.sliderSelectedClass);
          }

          var selectedNavCell = navCells[flickityInstance.selectedIndex];
          selectedNavCell.classList.add(_this3.sliderSelectedClass);

          _this3.checkSliderArrows(nav, topArrow, bottomArrow);
        });
        navCells[flickityInstance.selectedIndex].classList.add(_this3.sliderSelectedClass);
        topArrow.addEventListener('click', function () {
          _this3.scrollThumbs(true, nav, topArrow, bottomArrow);
        });
        bottomArrow.addEventListener('click', function () {
          _this3.scrollThumbs(false, nav, topArrow, bottomArrow);
        });

        var isVideoElement = function isVideoElement(element) {
          return element.tagName === 'VIDEO';
        };

        var isYouTubePlayerElement = function isYouTubePlayerElement(element) {
          return element.classList.contains('atom-video');
        };

        var getYouTubePlayerInstance = function getYouTubePlayerInstance(element) {
          var instance = null;
          var videoElement = element.querySelector('.atom-video-container');
          var videoUniqueId = videoElement.dataset.uniqueid;

          if (typeof window.youTubePlayers !== 'undefined') {
            instance = window.youTubePlayers[videoUniqueId];
          }

          return instance;
        }; // helper function to reset all "video" element thumbnails to "pause"


        var resetVideoThumbnails = function resetVideoThumbnails(thumbnails) {
          [].forEach.call(thumbnails, function (thumbnail) {
            if (!thumbnail.dataset.pausethumbnail) {
              return;
            }

            thumbnail.src = thumbnail.dataset.playthumbnail;
          });
        };

        var stopVideoPlayer = function stopVideoPlayer(allSlides) {
          [].forEach.call(allSlides, function (slide) {
            if (!isVideoElement(slide) || !isYouTubePlayerElement(slide)) {
              return;
            }

            slide.pause();
            slide.currentTime = 0;
          });
        };

        var stopYoutubePlayer = function stopYoutubePlayer(allSlides) {
          [].forEach.call(allSlides, function (slide) {
            if (!isYouTubePlayerElement(slide)) {
              return;
            }

            getYouTubePlayerInstance(slide).stopVideo();
          });
        };

        var allSlides = sliderContainer.querySelectorAll(_this3.slideSelector);
        var allThumbnails = sliderContainer.querySelectorAll(_this3.thumbnailSelector);
        [].forEach.call(allSlides, function (slide, index) {
          var videoWidth = slide.parentNode.offsetWidth;
          var videoHeight = slide.parentNode.offsetHeight;
          var radix = 10;

          if (isVideoElement(slide)) {
            slide.addEventListener('ended', function () {
              allThumbnails[index].src = allThumbnails[index].dataset.playthumbnail;

              if (_tools.default.screen('sm', true)) {
                flickityInstance.select(index + 1);
              }
            });
            slide.addEventListener('pause', function () {
              allThumbnails[index].src = allThumbnails[index].dataset.playthumbnail;
            });
            slide.addEventListener('play', function () {
              allThumbnails[index].src = allThumbnails[index].dataset.pausethumbnail;
            });
            slide.style.height = "".concat(videoHeight, "px");
            slide.style.width = "".concat(videoWidth, "px");
          } else if (isYouTubePlayerElement(slide)) {
            var youtubeInstance = getYouTubePlayerInstance(slide);

            if (!youtubeInstance) {
              return;
            }

            youtubeInstance.setSize(videoWidth, videoHeight);
            allThumbnails[index].src = allThumbnails[index].dataset.playthumbnail;

            if (_tools.default.screen('sm', true)) {
              youtubeInstance.on('stateChange', function (event) {
                if (event.data === 0) {
                  flickityInstance.select(index + 1);
                }
              });
            }
          } else {
            var desktopMediaQuery = window.matchMedia("(min-width: ".concat(_screens.default.lg, ")"));
            $(slide).parent('a').on('click', function (event) {
              event.preventDefault();
              event.stopImmediatePropagation();
              event.stopPropagation();
            });

            if (desktopMediaQuery.matches) {
              var vanillaZoomElement = $(slide).parents('.vanilla-zoom');
              vanillaZoomElement.on('mousemove', function (event) {
                if (desktopMediaQuery.matches) {
                  _this3.showZoomOverlay(sliderContainer, event);
                }
              });

              var vanillaZoomElementInit = _vanillaZoom.default.init(vanillaZoomElement[0]);

              vanillaZoomElementInit.addEventListener('mouseout', function () {
                _this3.hideZoomOverlay(sliderContainer);
              });
            }

            desktopMediaQuery.addListener(function () {
              try {
                $(slide).parents('.vanilla-zoom').data('vanillaZzoom').teardown();
              } catch (e) {
                console.log(e);
              }

              if (desktopMediaQuery.matches) {
                var _vanillaZoomElement = $(slide).parents('.vanilla-zoom');

                _vanillaZoom.default.init(_vanillaZoomElement[0]);
              }
            });
          }
        });
        flickityInstance.on('change', function () {
          var currentSlideIndex = flickityInstance.selectedIndex;
          var currentSlide = allSlides[currentSlideIndex];
          var currentThumbnail = allThumbnails[currentSlideIndex];
          resetVideoThumbnails(allThumbnails);
          stopVideoPlayer(allSlides);
          stopYoutubePlayer(allSlides);

          if (isVideoElement(currentSlide)) {
            currentThumbnail.src = currentThumbnail.dataset.pausethumbnail;
            currentSlide.play();
            navCells[flickityInstance.selectedIndex].classList.remove(_this3.sliderSelectedClass);
          } else if (isYouTubePlayerElement(currentSlide)) {
            currentThumbnail.src = currentThumbnail.dataset.pausethumbnail;
            getYouTubePlayerInstance(currentSlide).mute();
            getYouTubePlayerInstance(currentSlide).playVideo();
            navCells[flickityInstance.selectedIndex].classList.remove(_this3.sliderSelectedClass);
          }
        });

        _this3.zoom.setOptions({
          preview: _this3.thumbnailClass,
          group: sliderContainer
        });

        flickityInstance.on('staticClick', function () {
          var imgSrc = sliderContainer.querySelector('.vanilla-zoom-wrapper.is-selected img.preview').getAttribute('src');
          var previewImg = sliderContainer.querySelector("img.preview[src='".concat(imgSrc, "']"));

          _this3.zoom.handleClick(previewImg);
        });

        _this3.checkSliderArrows(nav, topArrow, bottomArrow);
      }
    });
  },
  getCurrentZoomWrapper: function getCurrentZoomWrapper(container) {
    return container.querySelector(this.currentZoomWrapperSelector);
  },
  getZoomOverlay: function getZoomOverlay(container, zoomWrapper) {
    var localZoomWrapper = zoomWrapper;

    if (localZoomWrapper === undefined) {
      localZoomWrapper = this.getCurrentZoomWrapper(container);
    }

    var zoomOverlay = localZoomWrapper.querySelector(this.zoomOverlaySelector);

    if (zoomOverlay === null) {
      var zoomOverlayElement = document.createElement('div');
      var zoomBackgroundElement = document.createElement('div');
      var zoomPositionElement = document.createElement('div');
      zoomOverlayElement.classList.add(this.zoomOverlayClass);
      zoomBackgroundElement.classList.add(this.zoomBackgroundClass);
      zoomPositionElement.classList.add(this.zoomPositionClass);
      localZoomWrapper.appendChild(zoomOverlayElement);
      zoomOverlayElement.appendChild(zoomBackgroundElement);
      zoomOverlayElement.appendChild(zoomPositionElement);
      zoomOverlay = localZoomWrapper.querySelector(this.zoomOverlaySelector);
    }

    return zoomOverlay;
  },
  showZoomOverlay: function showZoomOverlay(container, event) {
    var zoomWrapper = this.getCurrentZoomWrapper(container);
    var zoomOverlay = this.getZoomOverlay(container, zoomWrapper);
    var slide = zoomWrapper.querySelector(this.slideSelector);
    var zoomBackground = zoomOverlay.querySelector(this.zoomBackgroundSelector);
    var zoomPosition = zoomOverlay.querySelector(this.zoomPositionSelector);

    if (zoomBackground && zoomPosition) {
      var image = 'url(' + slide.getAttribute('src') + ')';
      zoomBackground.style.backgroundImage = image;
      zoomPosition.style.backgroundImage = image;
      var positions = this.getZoomPositions(zoomWrapper, zoomOverlay, event);
      this.removeZoomStyle(container);
      this.appendZoomStyle(positions, container);
      zoomPosition.style.clip = "rect(".concat(positions.top, "px, ").concat(positions.leftEnd, "px, ").concat(positions.topEnd, "px, ").concat(positions.left, "px)");
      zoomWrapper.classList.add('vanilla-zoom-wrapper--active');
      zoomOverlay.classList.remove(_state.default.HIDDEN);
    }
  },
  hideZoomOverlay: function hideZoomOverlay(container) {
    var zoomWrapper = this.getCurrentZoomWrapper(container);
    var zoomOverlay = this.getZoomOverlay(container);
    zoomWrapper.classList.remove('vanilla-zoom-wrapper--active');
    zoomOverlay.classList.add(_state.default.HIDDEN);
    this.removeZoomStyle(container);
  },
  getZoomPositions: function getZoomPositions(zoomWrapper, zoomOverlay, event) {
    var radix = 10;
    var proportion = zoomWrapper.offsetWidth / zoomOverlay.offsetWidth;
    var rect = $(event.currentTarget).offset();
    var x = event.pageX - rect.left;
    var y = event.pageY - rect.top;
    var scaledLeft = parseInt(x / proportion, radix);
    var scaledTop = parseInt(y / proportion, radix);
    var rectWidth = 30;
    var topPosition = scaledTop - rectWidth / 2;
    var leftPosition = scaledLeft - rectWidth / 2;
    var topEnd = topPosition + rectWidth;
    var leftEnd = leftPosition + rectWidth;
    return {
      left: leftPosition,
      top: topPosition,
      leftEnd: leftEnd,
      topEnd: topEnd
    };
  },
  appendZoomStyle: function appendZoomStyle(positions, container) {
    var left = positions.left - 1;
    var top = positions.top - 1;
    var customStyle = container.appendChild(document.createElement('style'));
    customStyle.innerHTML = "\n      .cmscomponent-stageproduct__zoom-position:after {\n        top: ".concat(top, "px;\n        left: ").concat(left, "px;\n       }\n    ");
    customStyle.classList.add(this.customStyleClass);
  },
  removeZoomStyle: function removeZoomStyle(container) {
    var child = container.querySelector(this.customStyleSelector);

    if (child) {
      child.remove();
    }
  },
  bindListeners: function bindListeners() {
    var _this4 = this,
        _document$querySelect;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      [].forEach.call(root.querySelectorAll(_this4.pricesHeadlineSelector), function (headline) {
        headline.addEventListener('click', function () {
          _this4.handleClick(headline);
        });
      });
    });
    var body = document.querySelector(this.bodySelector);

    var handleDropdownEvent = function handleDropdownEvent(event) {
      _this4.handleDropdownEvent.bind(_this4)(event);
    };

    var handleExternalMouseover = function handleExternalMouseover(event) {
      _this4.handleExternalMouseover.bind(_this4)(event);
    };

    var handleExternalMouseout = function handleExternalMouseout(event) {
      _this4.handleExternalMouseout.bind(_this4)(event);
    };

    body.removeEventListener(_eventNames.default.ATOM_DROPDOWN_CHANGED, handleDropdownEvent, false);
    body.addEventListener(_eventNames.default.ATOM_DROPDOWN_CHANGED, handleDropdownEvent, false);
    body.removeEventListener(_eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOVER, handleExternalMouseover);
    body.addEventListener(_eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOVER, handleExternalMouseover);
    body.removeEventListener(_eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOUT, handleExternalMouseout);
    body.addEventListener(_eventNames.default.CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOUT, handleExternalMouseout);
    (_document$querySelect = document.querySelector(this.stageproductAmountDropdownSelector)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('change', function (event) {
      document.querySelector('.cart-notification-form').classList.add('is-loading');

      _this4.updatePrice(event.currentTarget);
    });
  },
  handleProductSettingsMouse: function handleProductSettingsMouse(mouseover, data) {
    if (data !== undefined && data.detail !== undefined && data.detail.image !== undefined) {
      var image = data.detail.image;
      var element = data.detail.element || null;

      if (element !== null) {
        var root = element.closest(this.rootSelector);

        if (root !== null) {
          var vanillaZoomOverlay = root.querySelector(this.vanillaZoomOverlaySelector);
          var preview = root.querySelector(this.previewSelector);

          if (mouseover === true) {
            vanillaZoomOverlay.classList.add(_state.default.EXPANDED, _state.default.LOADING);
            preview.dataset.original = preview.getAttribute('src');

            preview.onload = function () {
              vanillaZoomOverlay.classList.remove(_state.default.LOADING);
            };

            preview.setAttribute('src', image);
          } else {
            vanillaZoomOverlay.classList.remove(_state.default.EXPANDED, _state.default.LOADING);
            preview.setAttribute('src', preview.dataset.original);
            preview.removeAttribute('original');
          }
        }
      }
    }
  },
  handleExternalMouseover: function handleExternalMouseover(data) {
    this.handleProductSettingsMouse(true, data);
  },
  handleExternalMouseout: function handleExternalMouseout(data) {
    this.handleProductSettingsMouse(false, data);
  },
  handleClick: function handleClick(headline) {
    if (this.isSmallBreakpoint()) {
      if (headline.classList.contains(_state.default.OPEN)) {
        headline.classList.remove(_state.default.OPEN);
      } else {
        headline.classList.add(_state.default.OPEN);
      }
    }
  },
  handleDropdownEvent: function handleDropdownEvent(event) {
    if (this.enableGraduationPriceChange === true) {
      var mutationRecord = event.detail !== undefined && event.detail.message !== undefined ? event.detail.message : {};
      var mutationTargetData = mutationRecord.target !== undefined && mutationRecord.target.dataset !== undefined ? mutationRecord.target.dataset : null;

      if (mutationTargetData !== null) {
        var selectedRoot = this.getRoot(mutationRecord.target);

        if (this.root !== selectedRoot) {
          this.root = selectedRoot;
          this.currentGraduation = this.root.dataset.graduation;
        }

        this.changeGraduationPrice(mutationTargetData);
      }
    }
  },
  changeGraduationPrice: function changeGraduationPrice(dataset) {
    var newGraduation = this.getGraduationByValue(dataset.value);

    if (newGraduation !== this.currentGraduation) {
      this.currentGraduation = newGraduation;
      this.setGraduation();
    }
  },
  getGraduationData: function getGraduationData() {
    var _this5 = this;

    this.graduationData = [];
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      _this5.root = root;
      [].forEach.call(root.querySelectorAll(_this5.amountLimitSelector), function (amountLimit) {
        var dataset = amountLimit.dataset;
        dataset.price = amountLimit.querySelector('.price').innerText;

        _this5.graduationData.push(dataset);
      });
    });
  },
  getGraduationByValue: function getGraduationByValue(value) {
    var graduation = this.currentGraduation;
    var radix = 10;

    for (var i = 0; i < this.graduationData.length; i++) {
      var data = this.graduationData[i];
      var limit = parseInt(data.amountLimit, radix);

      if (value >= limit) {
        graduation = i;
      } else {
        break;
      }
    }

    return graduation;
  },
  getRoot: function getRoot(element) {
    return element.closest(this.rootSelector);
  },
  setGraduation: function setGraduation() {
    var pricetag = this.root.querySelector(this.pricetagSelector);
    console.log('🚀 ~ file: cmscomponent-stageproduct.js ~ line 806 ~ pricetag', pricetag);

    if (pricetag !== undefined) {
      var graduationData = this.graduationData[this.currentGraduation];
      var strikePriceValue = pricetag.querySelector('.atom-pricetag-strikeprice .atom-pricetag-price-value');
      var priceValue = pricetag.querySelector('.atom-pricetag-price .atom-pricetag-price-cost');
      var delivery = pricetag.querySelector('.atom-pricetag-delivery span');
      strikePriceValue.innerText = graduationData.amountStrikePrice;
      priceValue.innerText = graduationData.price;
      delivery.innerText = graduationData.amountDelivery;
      this.root.dataset.graduation = this.currentGraduation;
    }
  },
  isSmallBreakpoint: function isSmallBreakpoint() {
    return _tools.default.screen(this.naviBreakpoint);
  },
  getPriceForAmount: function getPriceForAmount(amount) {
    var _this6 = this;

    return new Promise(function (resolve) {
      var updateLink = document.querySelector(_this6.rootSelector).getAttribute(_this6.dataPriceUpdateUrlSelector);
      var updateUrl = new URL("".concat(location.protocol, "//").concat(location.host).concat(updateLink));
      updateUrl.searchParams.append('amount', amount);
      updateLink && _tools.default.service(updateUrl.href, 'GET').then(function (response) {
        return response.json();
      }).then(function (response) {
        resolve(response);
      });
    });
  },
  onDemandLoading: function onDemandLoading(load) {
    var rootElement = document.querySelector(this.rootSelector);
    load ? rootElement.classList.add(this.dataPriceUpdateLoading) : rootElement.classList.remove(this.dataPriceUpdateLoading);
  },
  updatePrice: function updatePrice(dropdownElement) {
    var _this7 = this;

    this.onDemandLoading(true);
    this.getPriceForAmount(dropdownElement.value).then(function (pricetagData) {
      if (pricetagData === undefined) return _this7.onDemandLoading(false);
      var rootElement = document.querySelector(_this7.rootSelector);

      _tools.default.PriceUrlLoader.handlePrice(pricetagData, rootElement, _this7.itemElementList, _this7.itemPriceTagSelector);

      _this7.handlePricesData(pricetagData, document.querySelector(_this7.rootSelector));

      _this7.handleDeliveryTime(pricetagData, rootElement);

      _this7.onDemandLoading(false);

      document.querySelector('.cart-notification-form').classList.remove('is-loading');
    });
  }
};
var _default = StageProduct;
exports.default = _default;

},{"atom-delivery-time":174,"event-names":224,"flickity":17,"flickity-as-nav-for":11,"screens":230,"state":232,"templates":235,"tools":236,"vanillaZoom":239,"zoom":240}],215:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var Flickity = require('flickity');

var TeaserboxSlider = {
  init: function init() {
    this.rootSelector = '.cmscomponent-teaserbox-slider';
    this.wrapperSelector = '.cmscomponent-teaserbox-slider-wrapper';
    this.createSlider();

    _tools.default.PriceUrlLoader.productPriceUrlUpdater(this.rootSelector);
  },
  getImages: function getImages(parent) {
    return new Promise(function (resolve) {
      var images = parent.querySelectorAll('img');
      var counter = 0;
      [].forEach.call(images, function (image) {
        if (image.complete) {
          counter++;
        } else {
          image.onload = function () {
            counter++;

            if (counter === images.length) {
              resolve();
            }
          };
        }

        if (counter === images.length) {
          resolve();
        }
      });
    });
  },
  createSlider: function createSlider() {
    var _this = this;

    var percentageVisible = _tools.default.screen('sm') ? 10 : 55;
    var buttonClass = 'has-no-buttons';
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (sliderContainer) {
      var uniqueId = window.guid();
      var mainSlider = sliderContainer.querySelector('.main-carousel');

      _this.getImages(mainSlider).then(function () {
        var flickityInstance = new Flickity(mainSlider, {
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          draggable: true,
          groupCells: true,
          imagesLoaded: true,
          wrapAround: true,
          cellAlign: 'left',
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 45,
            x3: 40
          },
          on: {
            ready: function ready() {
              _tools.default.scrollIntoElement(mainSlider, percentageVisible).then(function () {
                _this.handleScrollAnimation(flickityInstance);
              });
            }
          }
        });
        flickityInstance.on('dragStart', function () {
          var wrapper = sliderContainer.querySelector(_this.wrapperSelector);

          if (wrapper) {
            wrapper.classList.add(buttonClass);
          }
        });
        window.sliders[uniqueId] = flickityInstance;
      });
    });
  },
  handleScrollAnimation: function handleScrollAnimation(instance) {
    this.handleCellsRecursivly(0, instance.cells);
  },
  handleCellsRecursivly: function handleCellsRecursivly(index, cells) {
    var _this2 = this;

    if (index + 1 <= cells.length) {
      var elementDelay = 300;
      this.animateElement(cells[index]);
      setTimeout(function () {
        var newIndex = index + 1;

        _this2.handleCellsRecursivly(newIndex, cells);
      }, elementDelay);
    }
  },
  animateElement: function animateElement(cell) {
    if (cell.element) {
      cell.element.classList.add(_state.default.LOADED);
    }
  }
};
var _default = TeaserboxSlider;
exports.default = _default;

},{"es6-promise":6,"flickity":17,"state":232,"tools":236}],216:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _screens = _interopRequireDefault(require("screens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOT IN USE!
// see  => source/js/cmscomponents/cmscomponent-teaserbox-slider.js
var Flickity = require('flickity');

var Teaserbox = {
  init: function init() {
    this.rootSelector = '.cmscomponent-teaserbox';
    this.bindListeners();
  },
  delete: function _delete(el) {
    var flkty = el.getAttribute('data-flkty');

    if (typeof flkty === 'string') {
      window.flkty[flkty].destroy();
      el.removeAttribute('data-flkty');
      el.classList.remove('flickity-ready');
      delete window.flkty[flkty];
    }
  },
  bindListeners: function bindListeners() {
    var _this = this;

    window.addEventListener('resize', function () {
      window.debounce(_this.createSlider.bind(_this), 100);
    });
    window.setTimeout(function () {
      _this.createSlider();
    }, 300);
  },
  createSlider: function createSlider() {
    var _this2 = this;

    Array.prototype.forEach.call(document.querySelectorAll(this.rootSelector + ' .cmscomponent-teaserbox-teaser'), function (el) {
      var radix = 10;
      var teaserbox = el.closest(_this2.rootSelector);
      var fourItemsClass = 'cmscomponent-teaserbox--hasfouritems';
      var screenSize = window.innerWidth || document.documentElement.clientWidth;
      var screenMd = parseInt(_screens.default.md, radix);
      var screenLg = parseInt(_screens.default.lg, radix);
      var breakpoint = screenMd;

      if (teaserbox.classList.contains(fourItemsClass)) {
        breakpoint = screenLg;
      }

      if (screenSize <= breakpoint) {
        var uid = window.guid();

        _this2.delete(el);

        el.setAttribute('data-flkty', uid);
        window.flkty[uid] = new Flickity(el, {
          cellAlign: 'center',
          contain: true,
          draggable: true,
          pageDots: false,
          freeScroll: false,
          prevNextButtons: true,
          adaptiveHeight: false,
          autoPlay: false,
          wrapAround: true,
          friction: 0.6,
          on: {
            ready: function ready() {
              el.classList.add('flickity-ready');
            }
          }
        });
        window.flkty[uid].on('change', function () {
          el.querySelectorAll('.flickity-button').forEach(function (button) {
            button.classList.add('flickity-button-hidden');
          });
        });
      } else {
        _this2.delete(el);
      }
    });
  }
};
var _default = Teaserbox;
exports.default = _default;

},{"flickity":17,"screens":230}],217:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TemporaryAddressForm = {
  init: function init() {
    var _this = this;

    var roots = document.querySelectorAll('.cmscomponent-temporary-address-form');

    if (!roots.length) {
      return;
    }

    roots.forEach(function (root) {
      // parent
      _this.expand(root);

      var form = root.querySelector('.cmscomponent-temporary-address-form__form');
      var parent = root.closest('.choose-address-box-address');
      var radio = parent.querySelector('input[type=radio]');
      var radioIsSelected = radio != undefined && radio.checked === true;

      if (!radioIsSelected) {
        form.querySelectorAll('input[required]').forEach(function (input) {
          input.removeAttribute('required');
          input.setAttribute('_required', '');
        });
      }
    });
  },
  expand: function expand(root) {
    var expand = root.querySelector('.cmscomponent-temporary-address-form__expand');
    var form = root.querySelector('.cmscomponent-temporary-address-form__form');
    var parent = root.closest('.choose-address-box-address');
    var parentRadios = parent.closest('.choose-address-addresses-box');
    var radio = parent.querySelector('input[type=radio]');
    var radios = parentRadios.querySelectorAll('input[type=radio]');
    var closedClass = 'cmscomponent-temporary-address-form__expand--closed';
    var expandClass = 'cmscomponent-temporary-address-form__form--expanded';

    var doExpand = function doExpand() {
      expand.classList.add(closedClass);
      form.classList.add(expandClass);
      form.querySelectorAll('input[_required]').forEach(function (input) {
        input.removeAttribute('_required');
        input.setAttribute('required', '');
      });
    };

    var doRetract = function doRetract() {
      expand.classList.remove(closedClass);
      form.classList.remove(expandClass);
      form.querySelectorAll('input[required]').forEach(function (input) {
        input.removeAttribute('required');
        input.setAttribute('_required', '');
      });
    };

    var doToggle = function doToggle() {
      expand.classList.contains(closedClass) ? doRetract() : doExpand();
    };

    radios.forEach(function (_radio) {
      _radio.addEventListener('click', function () {
        if (_radio === radio) {
          doExpand();
        } else {
          doRetract();
        }
      });
    });
    expand.addEventListener('click', function () {
      doToggle();
      radio.checked = true;
    });

    if (radio.checked === true) {
      doToggle();
    }
  }
};
var _default = TemporaryAddressForm;
exports.default = _default;

},{}],218:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TileExpander = {
  init: function init() {
    var _this = this;

    this.rootSelector = '.atom-tile--expander';
    this.expanderButton = '.atom-tile__expander-button';
    this.expanderWrapper = '.atom-tile__subtiles-wrapper';
    this.expanderContent = '.atom-tile__subtiles';
    this.openClassName = _state.default.OPEN + '-expander';
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      root.addEventListener('click', function (e) {
        var isOpenEditFlyoutClick = window.clickInside(e, 'atom-edit-flyout');
        e.preventDefault();

        if (!isOpenEditFlyoutClick) {
          _this.toggle(root);
        } else {
          if (root.classList.contains(_this.openClassName)) {
            _this.close(root);
          }
        }
      });
    });
  },
  toggle: function toggle(root) {
    root.classList.toggle(this.openClassName);

    if (root.classList.contains(this.openClassName)) {
      this.open(root);
    } else {
      this.close(root);
    }
  },
  open: function open(root) {
    var wrapper = root.querySelector(this.expanderWrapper);
    var content = root.querySelector(this.expanderContent);
    var height = content.offsetHeight;
    wrapper.style.height = height + 'px';
  },
  close: function close(root) {
    var wrapper = root.querySelector(this.expanderWrapper);
    wrapper.style.height = '0px';
  }
};
var _default = TileExpander;
exports.default = _default;

},{"state":232}],219:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventNames = _interopRequireWildcard(require("event-names"));

var _state = _interopRequireDefault(require("state"));

var _tools = _interopRequireDefault(require("tools"));

var _templates = _interopRequireDefault(require("templates"));

var _atomEditFlyout = _interopRequireDefault(require("atom-edit-flyout"));

var _atomTile = _interopRequireDefault(require("atom-tile"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TileList = {
  init: function init() {
    this.rootSelector = '.cmscomponent-tile-list';
    this.headSelector = '.cmscomponent-tile-list__head';
    this.itemsSelector = '.cmscomponent-tile-list__items';
    this.emptySelector = '.cmscomponent-tile-list__empty';
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    var body = document.querySelector('body');
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root, index) {
      var groupSibling = _tools.default.getQuerySiblings('[data-event-prefix]', root);

      var groupName = (0, _eventNames.getCleanGroupName)(groupSibling, _eventNames.default.ATOM_DROPDOWN_ALL_CHANGED);
      root.dataset.eventPrefix = groupName;
      (0, _eventNames.updateEventPrefix)(root, index);
      body.addEventListener((0, _eventNames.getEventNameByGroup)(groupName, index, _eventNames.default.CONTENT_CHANGED), _this.handleChangeEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventNameByGroup)(groupName, index, _eventNames.default.CONTENT_LOADING), _this.handleLoadingEvent.bind(_this), false);
    });
  },
  getRootFromEvent: function getRootFromEvent(e) {
    var prefix = (0, _eventNames.getPrefixFromEventName)(e.type);
    return this.getRootByEventPrefix(prefix);
  },
  getRootByEventPrefix: function getRootByEventPrefix(eventPrefix) {
    if (eventPrefix) {
      return document.querySelector("".concat(this.rootSelector, "[data-event-prefix='").concat(eventPrefix, "']"));
    }

    return null;
  },
  handleChangeEvent: function handleChangeEvent(e) {
    var root = this.getRootFromEvent(e);

    if (root) {
      this.updateEvent(root, e.detail);
    }
  },
  handleLoadingEvent: function handleLoadingEvent(e) {
    var root = this.getRootFromEvent(e);

    if (root) {
      this.enableLoading(root);
    }
  },
  enableLoading: function enableLoading(root) {
    root.classList.add(_state.default.LOADING);
  },
  disableLoading: function disableLoading(root) {
    root.classList.remove(_state.default.LOADING);
  },
  getRenderedTemplate: function getRenderedTemplate(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('cmscomponents-tile-list', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateEvent: function updateEvent(root, data) {
    var _this2 = this;

    this.getRenderedTemplate(data).then(function (html) {
      _this2.updateEmptyState(root, data);

      _this2.update(root, html);

      _this2.reinitialize(root);

      _this2.disableLoading(root);
    });
  },
  reinitialize: function reinitialize(root) {
    _atomEditFlyout.default.reinitialize(root);

    _atomTile.default.initInElement(root);
  },
  updateEmptyState: function updateEmptyState(root, data) {
    if (root) {
      var empty = root.querySelector(this.emptySelector);

      if (empty) {
        if (data.tilelist && data.tilelist.items && data.tilelist.items.length > 0) {
          root.classList.remove(_state.default.EMPTY);
        } else {
          root.classList.add(_state.default.EMPTY);
        }
      }
    }
  },
  update: function update(root, html) {
    if (root) {
      _templates.default.updateAllSelectors(root, html, [this.headSelector, this.itemsSelector]);
    }
  }
};
var _default = TileList;
exports.default = _default;

},{"atom-edit-flyout":176,"atom-tile":178,"event-names":224,"state":232,"templates":235,"tools":236}],220:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("./../state"));

var _attachmentIcons = _interopRequireDefault(require("../attachment-icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Upload = {
  init: function init() {
    this.rootSelector = '.cmscomponent-uploadfile';
    this.uploadedFilesSelector = '.cmscomponent-uploadfile-uploaded-files';
    this.fileTemplateSelector = '.cmscomponent-uploadfile-upload-template';
    this.deleteSelector = this.uploadedFilesSelector + ' .cmscomponent-uploadfile-upload-delete';
    this.hasFilesClass = 'has-files';
    this.addFileSelector = '.cmscomponent-uploadfile-addfile';
    this.fileSizeLimitSelector = '.cmscomponent-uploadfile-max-size';
    this.fileSizeErrorSelector = '.cmscomponent-uploadfile-max-error';
    this.fileExtErrorSelector = '.cmscomponent-uploadfile-ext-error';
    this.fileIconSelector = '.cmscomponent-uploadfile-icon';
    this.bindListeners();
  },
  getFileSizeLimit: function getFileSizeLimit(root) {
    var fileSizeLimit = 0;

    if (root) {
      var radix = 10;
      var fileSizeLimitElement = root.querySelector(this.fileSizeLimitSelector);
      var fileSizeLimitMB = parseInt(fileSizeLimitElement.textContent, radix);
      fileSizeLimit = fileSizeLimitMB * 1024 * 1024;
    }

    return fileSizeLimit;
  },
  showError: function showError(root) {
    if (root) {
      root.querySelector(this.fileSizeErrorSelector).classList.remove(_state.default.HIDDEN);
    }
  },
  hideError: function hideError(root) {
    if (root) {
      root.querySelector(this.fileSizeErrorSelector).classList.add(_state.default.HIDDEN);
    }
  },
  isBelowFileSizeLimit: function isBelowFileSizeLimit(fileData, root) {
    return fileData.size <= this.getFileSizeLimit(root);
  },
  checkFileExtension: function checkFileExtension(fileName, allowedFileExtensions, root) {
    var result = true;
    var fileExtension = fileName.split('.').pop();

    if (allowedFileExtensions.indexOf(fileExtension.toLowerCase()) === -1) {
      this.handleExtError('show', root);
      result = false;
    }

    return result;
  },
  handleExtError: function handleExtError(mode, root) {
    var elem = root.querySelector(this.fileExtErrorSelector);

    try {
      switch (mode) {
        case 'show':
          elem.classList.remove(_state.default.HIDDEN);
          break;

        case 'hide':
          elem.classList.add(_state.default.HIDDEN);
          break;

        default:
          elem.classList.add(_state.default.HIDDEN);
      }
    } catch (error) {
      console.warn(error);
    }
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var init = function init() {
        var upload = root.querySelector(_this.addFileSelector + ':not(.hidden)');
        var input = upload.querySelector('.uploadfile:not(.' + _this.hasFilesClass + ')');
        var fileTemplate = root.querySelector(_this.fileTemplateSelector);
        var attachedFiles = root.querySelector(_this.uploadedFilesSelector);
        var allowedFileExtensions = root.dataset.vext.split(',');
        var iconPath = root.dataset.path;
        var acceptsList = allowedFileExtensions.map(function (ext) {
          return '.'.concat(ext);
        });
        Array.from(root.querySelectorAll('.uploadfile')).forEach(function (el) {
          return el.setAttribute('accept', acceptsList.toString());
        });

        var addFile = function addFile() {// const $upload = $(upload);
          // const $clone = $upload.clone();
          // const $cloneInput = $clone.find('input');
          // $upload.addClass(State.HIDDEN);
          // $clone.insertAfter(upload);
          // if ($cloneInput) {
          //   $cloneInput.attr('id', '');
          //   $cloneInput[0].value = '';
          // }
          // init();
        };

        var openDialog = function openDialog(e) {
          e.stopImmediatePropagation();

          _this.handleExtError('hide', root);

          $(input).click();
        };

        upload.removeEventListener('click', openDialog);
        upload.addEventListener('click', openDialog);
        input.addEventListener('change', function (e) {
          var files = input.files;
          e.stopImmediatePropagation();

          if (files.length && _this.checkFileExtension(input.files[0].name, allowedFileExtensions, root)) {
            var fileAdded = false;
            var newId = window.guid();
            var $input = $(input);

            _this.hideError(root);

            $input.attr('id', newId);
            attachedFiles.innerHTML = '';
            $(files).each(function (key, data) {
              var fileName = data.name;

              if (fileName && _this.isBelowFileSizeLimit(data, root)) {
                var $fileTemplate = $(fileTemplate).clone();

                var icon = _attachmentIcons.default.getIconFilePath(iconPath, fileName.split('.').pop());

                fileAdded = true;
                $fileTemplate.find('.cmscomponent-uploadfile-file').attr('data-id', newId).text(fileName);
                $fileTemplate.find(_this.fileIconSelector).attr('src', icon);
                $fileTemplate.appendTo(attachedFiles);
                $fileTemplate.removeClass(_state.default.HIDDEN);
              }
            });

            if (fileAdded) {
              addFile();
              input.classList.add(_this.hasFilesClass);
            } else {
              _this.showError(root);

              input.value = '';
            }

            attachedFiles.classList.remove(_state.default.HIDDEN);
          }
        });
      };

      $('body').on('click', _this.deleteSelector, function (e) {
        var $delete = $(e.currentTarget);
        var fileTemplateElement = $delete.closest(_this.fileTemplateSelector);
        var uploadFileElement = fileTemplateElement.find('[data-id]');
        var trashId = uploadFileElement.attr('data-id');
        var $fileInput = $(root).find('[id=' + trashId + ']');

        _this.hideError(root);

        _this.handleExtError('hide', root);

        if ($fileInput) {
          $fileInput.parents(_this.addFileSelector).remove();
        }

        fileTemplateElement.remove();
      });
      init();
    });
  }
};
var _default = Upload;
exports.default = _default;

},{"../attachment-icons":181,"./../state":232}],221:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _eventNames = _interopRequireWildcard(require("event-names"));

var _atomCheckbox = _interopRequireDefault(require("atom-checkbox"));

var _atomDropdown = _interopRequireDefault(require("atom-dropdown"));

var _atomInputDatepicker = _interopRequireDefault(require("atom-input-datepicker"));

var _cmscomponentShowMore = _interopRequireDefault(require("cmscomponent-show-more"));

var _tools = _interopRequireDefault(require("tools"));

var _templates = _interopRequireDefault(require("templates"));

var _utils = require("../../js/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UtilityBar = {
  init: function init() {
    this.rootSelector = '.cmscomponent-utility-bar';
    this.toggleSelector = '.cmscomponent-utility-bar__toggle';
    this.closeSelector = '.cmscomponent-utility-bar__close';
    this.contentSelector = '.cmscomponent-utility-bar__content';
    this.itemsSelector = '.cmscomponent-utility-bar__items';
    this.tagsSelector = '.cmscomponent-utility-bar__tags';
    this.tagsLargeSelector = '.cmscomponent-utility-bar__lg-tags';
    this.tagItemSelector = '.cmscomponent-utility-bar__tags-category .atom-tag';
    this.sortingSelector = '.cmscomponent-utility-bar__sorting';
    this.searchSelector = '.cmscomponent-utility-bar__search';
    this.searchSortingContainerSelector = '.cmscomponent-utility-bar__search-and-sorting';
    this.searchIconSelector = '.cmscomponent-utility-bar__search-icon';
    this.deleteIconSelector = '.cmscomponent-utility-bar__delete-icon';
    this.backIconSelector = '.cmscomponent-utility-bar__back-icon';
    this.atomsInputDatepicker = new _atomInputDatepicker.default();
    this.currentSearchQuery = '';
    this.isInitial = true;
    this.bindListeners();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    var body = document.querySelector('body');
    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root, index) {
      (0, _eventNames.updateEventPrefix)(root, index);

      _this.initCheckboxes(root);

      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.ATOM_DROPDOWN_ALL_CHANGED), _this.handleDropdownEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.CMSCOMPONENT_PAGINATION_CHANGED), _this.handlePaginationEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.ATOM_INPUT_DATEPICKER_CHANGED), _this.handleDatepickerEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.ATOM_INPUT_DATEPICKER_RESET), _this.handleDatepickerEvent.bind(_this), false);
      body.addEventListener((0, _eventNames.getEventName)(root, _eventNames.default.CONTENT_LOADING), _this.handleLoadingEvent.bind(_this), false);
      [].forEach.call(root.querySelectorAll("".concat(_this.toggleSelector, ", ").concat(_this.closeSelector)), function (toggle) {
        toggle.addEventListener('click', function () {
          _this.handleClick(root);
        });
      });

      _this.bindTagList(root);

      var search = root.querySelector(_this.searchSelector);

      if (search) {
        search.addEventListener('keyup', _this.handleKeyCode.bind(_this, root));

        _this.handleSearchIcon(root, search);

        _this.handleExpandedSearch(root, search);
      }
    });
    window.addEventListener('resize', function () {
      if (!_this.isInOpen) {
        _this.close();
      }
    });
  },
  handleSearchIcon: function handleSearchIcon(root, search) {
    var _this2 = this;

    var searchIcon = root.querySelector(this.searchIconSelector);

    if (searchIcon) {
      searchIcon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (_this2.isInitial) {
          _this2.handleSearchFocus(search);
        } else {
          _this2.handleSearch(root);
        }
      });
    }
  },
  handleExpandedSearch: function handleExpandedSearch(root, search) {
    var _this3 = this;

    var searchInputField = search.querySelector('input');
    var backIcon = root.querySelector(this.backIconSelector);
    var deleteIcon = search.querySelector(this.deleteIconSelector);
    search.addEventListener('click', this.handleSearchFocus.bind(this, search));

    if (deleteIcon) {
      deleteIcon.addEventListener('click', function () {
        searchInputField.focus();
        searchInputField.value = '';

        if (_this3.currentSearchQuery !== searchInputField.value) {
          _this3.handleSearch(root);
        }

        _this3.hideDeleteIcon(deleteIcon);
      });
      searchInputField.addEventListener('keyup', this.handleDeleteIcon.bind(this, deleteIcon, searchInputField));
    }

    if (backIcon) {
      backIcon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        _this3.handleSearchFocusOut(search);
      });
    }
  },
  handleSearchFocus: function handleSearchFocus(search) {
    var _this4 = this;

    var inputField = search.querySelector('input');
    var searchContainer = search.closest(this.searchSortingContainerSelector);
    var deleteIcon = search.querySelector(this.deleteIconSelector);
    inputField.focus();
    this.isInitial = false;

    if (!searchContainer.classList.contains(_state.default.EXPANDED)) {
      (0, _utils.addClickOutsideListener)(search, function () {
        return _this4.handleSearchFocusOut(search);
      });
    }

    this.handleDeleteIcon(deleteIcon, inputField);
    search.classList.add(_state.default.OPEN);
    searchContainer.classList.add(_state.default.EXPANDED);

    if (inputField.value.length >= 1) {
      this.showDeleteIcon(search);
    }
  },
  handleSearchFocusOut: function handleSearchFocusOut(search) {
    var inputField = search.querySelector('input');
    var deleteIcon = search.querySelector(this.deleteIconSelector);
    var searchContainer = search.closest(this.searchSortingContainerSelector);
    inputField.blur();
    this.isInitial = true;
    search.classList.remove(_state.default.OPEN);
    searchContainer.classList.remove(_state.default.EXPANDED);

    if (deleteIcon) {
      this.hideDeleteIcon(deleteIcon);
    }
  },
  showDeleteIcon: function showDeleteIcon(deleteIcon) {
    deleteIcon.classList.add(_state.default.VISIBLE);
  },
  handleDeleteIcon: function handleDeleteIcon(deleteIcon, inputField) {
    if (!deleteIcon.classList.contains(_state.default.VISIBLE)) {
      this.showDeleteIcon(deleteIcon);
    }

    if (inputField && inputField.value === '') {
      this.hideDeleteIcon(deleteIcon);
    }
  },
  hideDeleteIcon: function hideDeleteIcon(deleteIcon) {
    deleteIcon.classList.remove(_state.default.VISIBLE);
  },
  handleKeyCode: function handleKeyCode(root, e) {
    var search = root.querySelector(this.searchSelector);
    var isExpandedSearch = search.classList.contains(_state.default.EXPANDED);

    if (e && e.keyCode === _tools.default.keyCode.ENTER) {
      this.handleSearch(root);
      this.handleSearchFocusOut(search);
      clearTimeout(window.searchDebounce);
    } else if (isExpandedSearch && e.keyCode === _tools.default.keyCode.ESC) {
      this.handleSearchFocusOut(search);
    }
  },
  handleSearch: function handleSearch(root) {
    if (root) {
      var search = root.querySelector(this.searchSelector);
      var input = search.querySelector('input');
      var action = search.dataset.searchAction;
      var value = input === null || input === void 0 ? void 0 : input.value;

      if (root && action && input && value !== this.currentSearchQuery) {
        var param = "q=".concat(value);
        this.currentSearchQuery = value;
        this.handleActionEvent(action, root, param);
      }
    }
  },
  bindTagList: function bindTagList(root) {
    var _this5 = this;

    [].forEach.call(root.querySelectorAll(this.tagItemSelector), function (item) {
      item.addEventListener('click', _this5.handleTagItemClick.bind(_this5, root));
    });
  },
  handleTagItemClick: function handleTagItemClick(root, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var current = e.currentTarget;
    var action = current.getAttribute('href');

    if (root && action) {
      this.handleActionEvent(action, root);
    }
  },
  handleLoadingEvent: function handleLoadingEvent(e) {
    var root = this.getRootFromEvent(e);

    if (root) {
      this.enableLoading(root, true);
    }
  },
  handleDropdownEvent: function handleDropdownEvent(e) {
    var ajax = e.detail.ajax;

    if (ajax) {
      var currentSelect = e.detail.message;
      var root = currentSelect.closest(this.rootSelector);
      var action = e.detail.option.dataset.href || undefined;

      if (root && action) {
        this.handleActionEvent(action, root);
      }
    }
  },
  handleDatepickerEvent: function handleDatepickerEvent(e) {
    if (e.detail && e.detail.root) {
      var datePicker = e.detail.root;
      var root = datePicker.closest(this.rootSelector);

      if (e.detail.dateStr) {
        var action = datePicker.dataset.action;

        if (root && action) {
          var inputName = datePicker.querySelector('.atom-input-datepicker__input').getAttribute('name');
          var param = "".concat(inputName, "=").concat(e.detail.dateStr);
          this.handleActionEvent(action, root, param);
        }
      } else if (e.detail.action) {
        this.handleActionEvent(e.detail.action, root);
      }
    }
  },
  getRootFromEvent: function getRootFromEvent(e) {
    var prefix = (0, _eventNames.getPrefixFromEventName)(e.type);
    return this.getRootByEventPrefix(prefix);
  },
  handlePaginationEvent: function handlePaginationEvent(e) {
    var _this6 = this;

    var root = this.getRootFromEvent(e);

    if (root) {
      this.updateEvent(root, e.detail.message, true).then(function () {
        _this6.disableLoading(root);
      });
    }
  },
  handleActionEvent: function handleActionEvent(action, root, param) {
    var _this7 = this;

    this.enableLoading(root);
    var paramSeperator = action.indexOf('?') !== -1 ? '&' : '?';
    var paramString = param ? "".concat(paramSeperator).concat(param) : '';
    var actionWithParam = "".concat(action).concat(paramString);

    _tools.default.service(actionWithParam, 'GET', undefined, undefined).then(function (response) {
      response.json().then(function (json) {
        _this7.updateEvent(root, json, false).then(function () {
          _this7.disableLoading(root);
        });
      }).catch(function (error) {
        _this7.disableLoading(root);

        console.debug(error);
      });
    }).catch(function (error) {
      _this7.disableLoading(root);

      console.debug(error);
    });
  },
  getRootByEventPrefix: function getRootByEventPrefix(eventPrefix) {
    if (eventPrefix) {
      return document.querySelector("".concat(this.rootSelector, "[data-event-prefix='").concat(eventPrefix, "']"));
    }

    return null;
  },
  getContentRoot: function getContentRoot(root) {
    var content;
    [].forEach.call(document.querySelectorAll(_eventNames.eventPrefixSelector), function (element) {
      if (root !== element) {
        content = element;
      }
    });
    return content;
  },
  getRenderedTemplate: function getRenderedTemplate(data) {
    return new Promise(function (resolve, reject) {
      _templates.default.load('cmscomponents-utility-bar', data).then(function (renderedData) {
        resolve(renderedData.rendered);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateEvent: function updateEvent(root, data, isPagination) {
    var _this8 = this;

    return new Promise(function (resolve) {
      if (root) {
        var eventRoot = _this8.getContentRoot(root);

        var eventPagination = null;

        if (isPagination) {
          eventPagination = null;
        } else {
          eventPagination = data.pagination;
        }

        _tools.default.sendEvent((0, _eventNames.getEventName)(root, _eventNames.default.CONTENT_CHANGED), _objectSpread({
          root: eventRoot,
          pagination: eventPagination
        }, data));
      }

      _tools.default.changeUrl(data.url);

      if (data.utilityBar) {
        _this8.getRenderedTemplate(data).then(function (html) {
          _this8.update(root, html);

          _this8.reinitialize(root);

          resolve();
        });
      } else {
        resolve();
      }
    });
  },
  initCheckboxes: function initCheckboxes(root) {
    _atomCheckbox.default.reinitialize(root);

    _atomCheckbox.default.bindCustomListeners(root, _atomCheckbox.default.rootSelector, this.handleCheckboxClick, this);
  },
  reinitialize: function reinitialize(root) {
    var itemsRoot = root.querySelector(this.itemsSelector);

    _atomDropdown.default.reinitialize(itemsRoot);

    _atomDropdown.default.reinitialize(root.querySelector(this.sortingSelector));

    this.initCheckboxes(root);

    _cmscomponentShowMore.default.init(itemsRoot);

    this.atomsInputDatepicker.reinitialize(itemsRoot);
  },
  handleCheckboxClick: function handleCheckboxClick(root, checkbox) {
    if (root && checkbox) {
      var action = checkbox.dataset.href;
      this.handleActionEvent(action, root);
    }
  },
  update: function update(root, html) {
    if (root) {
      _templates.default.updateAllSelectors(root, html, [this.itemsSelector, this.tagsSelector, this.tagsLargeSelector, this.sortingSelector]);

      this.bindTagList(root);
    }
  },
  enableLoading: function enableLoading(root, isExternal) {
    if (!isExternal) {
      _tools.default.sendEvent((0, _eventNames.getEventName)(root, _eventNames.default.CONTENT_LOADING), {
        message: {},
        root: root
      });
    }
  },
  disableLoading: function disableLoading(root) {
    root.classList.remove(_state.default.LOADING);
  },
  handleClick: function handleClick(element) {
    var content = element.querySelector(this.contentSelector);

    if (content && content.classList.contains(_state.default.OPEN)) {
      this.close(content);
    } else {
      this.lastRoot = element.closest(this.rootSelector);
      this.open(content);
    }
  },
  close: function close(content) {
    var selectedContent = content || document.querySelector(this.rootSelector + ' ' + this.contentSelector + '.' + _state.default.OPEN);

    if (selectedContent !== null) {
      selectedContent.classList.remove(_state.default.OPEN);
    }

    this.enableScrolling();
    this.isInOpen = false;
  },
  open: function open(content) {
    var _this9 = this;

    this.isInOpen = true;
    content.classList.add(_state.default.OPEN);

    _tools.default.disableScrolling();

    var handleEnd = function handleEnd() {
      _this9.isInOpen = false;
    };

    content.removeEventListener('transitionend', handleEnd);
    content.addEventListener('transitionend', handleEnd);
  },
  enableScrolling: function enableScrolling() {
    _tools.default.enableScrolling();

    if (this.lastRoot) {
      _tools.default.scrollToInstant(this.lastRoot);
    }
  }
};
var _default = UtilityBar;
exports.default = _default;

},{"../../js/utils":237,"atom-checkbox":173,"atom-dropdown":175,"atom-input-datepicker":177,"cmscomponent-show-more":211,"event-names":224,"state":232,"templates":235,"tools":236}],222:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wearer = {
  init: function init() {
    Wearer.defineSelectors();

    if (document.querySelectorAll(Wearer.productSelection).length > 0) {
      Wearer.checkFormSubmission();
      Wearer.registerCheckboxEvents();
    }

    Wearer.watchProducts(function () {
      Wearer.registerCheckboxEvents();
    });
  },
  registerCheckboxEvents: function registerCheckboxEvents() {
    var _this = this;

    document.querySelectorAll(Wearer.checkboxInput).forEach(function (checkboxInput) {
      checkboxInput.addEventListener('click', function () {
        _this.removeErrors();

        if (!Wearer.hasValidProductSelection()) {
          // trigger error state of checkboxes because no selection has been made
          Wearer.handleErrorState();
        }
      });
    });
  },
  checkFormSubmission: function checkFormSubmission() {
    var _this2 = this;

    var form = document.querySelector(Wearer.form);
    window.prepareFormForValidation(form);
    form.addEventListener('submit', function (e) {
      window.validateForm(document.querySelector(Wearer.form), e, function () {
        if (Wearer.hasValidProductSelection()) {
          // form submit action is kicked but wearer selecton is done
          _this2.removeErrors();
        } else {
          // form has some errors left
          if (!_this2.hasValidProductSelection()) {
            Wearer.handleErrorState(e);
          }
        }
      });
    }, false);
  },
  removeErrors: function removeErrors() {
    Wearer.getProducts().forEach(function (product) {
      product.classList.remove(_state.default.ERROR);
    });
  },
  handleErrorState: function handleErrorState(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    Wearer.getProducts().forEach(function (product) {
      product.classList.add(_state.default.ERROR);
    });
  },
  hasValidProductSelection: function hasValidProductSelection() {
    var checkedElements = document.querySelectorAll("".concat(Wearer.productSelection, " ").concat(Wearer.product, " ").concat(Wearer.checkboxInput, ":checked"));
    return checkedElements.length > 0;
  },
  watchProducts: function watchProducts(callback) {
    var targetNode = document.querySelector('.cmscomponent-form-new-wearer__product-selection');
    var config = {
      attributes: false,
      childList: true,
      subtree: true
    };
    var observer = new MutationObserver(function () {
      return callback();
    });

    if (targetNode) {
      observer.observe(targetNode, config);
    }
  },
  getProducts: function getProducts() {
    var form = document.querySelector(Wearer.form);
    return form.querySelectorAll("".concat(Wearer.productSelection, " ").concat(Wearer.product));
  },
  defineSelectors: function defineSelectors() {
    Wearer.form = '.cmscomponent-form';
    Wearer.submit = '[type=submit]';
    Wearer.productSelection = '.cmscomponent-form-new-wearer__product-selection';
    Wearer.product = '.atom-icon-product';
    Wearer.checkboxInput = '.atom-checkbox__input';
  }
};
var _default = Wearer;
exports.default = _default;

},{"state":232}],223:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wishlist = {
  init: function init() {
    this.rootSelector = '.cmscomponent-wishlist';
    this.itemSelector = '.cmscomponent-wishlist-item';
    this.deleteSelector = '.cmscomponent-wishlist-item-delete';
    this.contentSelector = '.cmscomponent-wishlist-item-content';
    this.itemContentsSelector = '.cmscomponent-wishlist-item-contents';
    this.itemOptionsSelector = '.cmscomponent-wishlist-item-options';
    this.itemPriceSelector = '.atom-pricetag-price-cost';
    this.itemStrikePriceSelector = '.atom-pricetag-strikeprice';
    this.itemValueSelector = '.atom-pricetag-price-value';
    this.itemCurrencySelector = '.atom-pricetag-currency-value';
    this.itemDeliverySelector = '.atom-pricetag-delivery span';
    this.deliveryTimeSelector = '.cmscomponent-wishlist-item-cta-delivery';
    this.itemPreTextSelector = '.atom-pricetag-price-prefix';
    this.itemPricetagCurrencySelector = '.atom-pricetag-price .atom-pricetag-price-currency small';
    this.addToCartSelector = '.cmscomponent-wishlist-item-cta .atom-button';
    this.hasDeliveryTimeClass = 'has-delivery-time';
    this.root = document.querySelectorAll(this.rootSelector);
    this.itemElementList = [{
      name: 'price',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing ' + this.itemPriceSelector
    }, {
      name: 'price',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing--mobile ' + this.itemPriceSelector
    }, {
      name: 'price',
      selector: this.itemOptionsSelector + ' ' + this.itemPriceSelector
    }, {
      name: 'currency',
      selector: this.itemOptionsSelector + ' ' + this.itemPricetagCurrencySelector
    }, {
      name: 'currency',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing ' + this.itemPricetagCurrencySelector
    }, {
      name: 'currency',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing--mobile ' + this.itemPricetagCurrencySelector
    }, {
      name: 'currency',
      selector: this.itemOptionsSelector + ' ' + this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'currency',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing ' + this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'currency',
      selector: this.itemContentsSelector + ' .cmscomponent-wishlist-item-pricing--mobile ' + this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
    }, {
      name: 'preText',
      selector: this.itemPreTextSelector
    }, {
      name: 'strikethroughPrice',
      selector: this.itemOptionsSelector + ' ' + this.itemStrikePriceSelector + ' ' + this.itemValueSelector,
      parent: this.itemStrikePriceSelector
    }, {
      name: 'strikethroughPrice',
      selector: this.itemContentsSelector + ' ' + this.itemStrikePriceSelector + ' ' + this.itemValueSelector,
      parent: this.itemStrikePriceSelector
    }, {
      name: 'delivery',
      selector: this.itemDeliverySelector
    }];
    this.checkPriceUrlLoader();
    this.bindListeners();

    _atomDeliveryTime.default.init();
  },
  bindListeners: function bindListeners() {
    var _this = this;

    [].forEach.call(this.root, function (instance) {
      [].forEach.call(instance.querySelectorAll(_this.deleteSelector), function (deleteElement) {
        deleteElement.addEventListener('click', _this.handleDelete.bind(_this));
      });
    });
  },
  handleDelete: function handleDelete(e) {
    e.preventDefault();
    var current = e.currentTarget;
    current.closest('form').submit();
  },
  checkPriceUrlLoader: function checkPriceUrlLoader() {
    var _this2 = this;

    [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
      var priceUrl = root.dataset.priceUrl;

      if (priceUrl !== undefined) {
        _tools.default.PriceUrlLoader.getPrices(root).then(function (data) {
          if (data !== undefined) {
            _this2.handlePrices(data, root);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  },
  handlePrices: function handlePrices(prices, root) {
    var index = 0;

    for (var j = 0; j < prices.length; j++) {
      var productCode = prices[j].productCode;
      var item = document.querySelector('[data-product-code="' + productCode + '"]');
      var currentPrice = prices[index];

      if (item !== null && currentPrice !== undefined) {
        this.handleAddToCart(currentPrice, item);
        this.handleDeliveryTime(currentPrice, item);

        for (var i = 0; i < this.itemElementList.length; i++) {
          var element = this.itemElementList[i];
          var node = item.querySelector(element.selector);

          if (node !== null) {
            var newValue = currentPrice[element.name];

            if (newValue !== undefined && newValue !== null) {
              node.innerHTML = newValue;
            } else {
              var parent = item.querySelector(element.parent);

              if (parent !== null) {
                parent.style.display = 'none';
                parent.classList.add(_state.default.HIDDEN);
              }
            }
          }
        }
      }

      index++;
    }

    this.disableLoading(root);
  },
  handleDeliveryTime: function handleDeliveryTime(price, root) {
    var deliveryTime = root.querySelector(this.deliveryTimeSelector);
    var data = price.deliveryTime;

    if (deliveryTime && data) {
      _atomDeliveryTime.default.update(deliveryTime, data);

      if (!data.date) {
        root.classList.remove(this.hasDeliveryTimeClass);
      } else {
        root.classList.add(this.hasDeliveryTimeClass);
      }
    } else if (deliveryTime) {
      deliveryTime.classList.add(_state.default.HIDDEN);
      root.classList.remove(this.hasDeliveryTimeClass);
    }
  },
  handleAddToCart: function handleAddToCart(price, root) {
    if (price.disabled !== undefined && price.disabled === false) {
      var addToCartButton = root.querySelector(this.addToCartSelector);

      if (addToCartButton !== null) {
        addToCartButton.removeAttribute('disabled');
      }
    }
  },
  disableLoading: function disableLoading(root) {
    delete root.dataset.priceUrl;
  }
};
var _default = Wishlist;
exports.default = _default;

},{"atom-delivery-time":174,"state":232,"tools":236}],224:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getCleanGroupName = exports.getEventNameByGroup = exports.getEventName = exports.updateEventPrefix = exports.getEventPrefix = exports.getPrefixFromEventName = exports.eventPrefixSelector = exports.eventSeperator = void 0;
var EventNames = {
  ATOM_DROPDOWN_CHANGED: 'atom-dropdown-changed',
  ATOM_DROPDOWN_ALL_CHANGED: 'atom-dropdown-all-changed',
  ATOM_INPUT_DATEPICKER_CHANGED: 'atom-input-datepicker-changed',
  ATOM_INPUT_DATEPICKER_RESET: 'atom-input-datepicker-reset',
  CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOVER: 'cmscomponent-product-settings-mouseover',
  CMSCOMPONENT_PRODUCT_SETTINGS_MOUSEOUT: 'cmscomponent-product-settings-mouseout',
  CMSCOMPONENT_PAGINATION_CHANGED: 'cmscomponent-pagination-changed',
  CMSCOMPONENT_FILTER_CHANGED: 'cmscomponent-filter-changed',
  CMSCOMPONENT_FILTER_TAG_CHANGED: 'cmscomponent-filter-tag-changed',
  CMSCOMPONENT_FILTER_CHECKBOX_CHANGED: 'cmscomponent-filter-checkbox-changed',
  CMSCOMPONENT_FILTER_CLOSE: 'cmscomponent-filter-close',
  CMSCOMPONENT_SORT_FILTER_CLOSE: 'cmscomponent-sort-filter-close',
  CONTENT_LOADING: 'content-loading',
  CONTENT_CHANGED: 'content-changed'
};
var eventSeperator = '#';
exports.eventSeperator = eventSeperator;
var eventPrefixSelector = '[data-event-prefix]';
exports.eventPrefixSelector = eventPrefixSelector;

var getPrefixFromEventName = function getPrefixFromEventName(eventName) {
  if (eventName) {
    return eventName.split(eventSeperator)[0];
  }

  return '';
};

exports.getPrefixFromEventName = getPrefixFromEventName;

var getEventPrefix = function getEventPrefix(element) {
  if (element) {
    var parent = element.closest(eventPrefixSelector);
    return parent ? "".concat(parent.dataset.eventPrefix).concat(eventSeperator) : '';
  }

  return '';
};

exports.getEventPrefix = getEventPrefix;

var updateEventPrefix = function updateEventPrefix(element, index) {
  if (element) {
    element.dataset.eventPrefix = "".concat(element.dataset.eventPrefix, "_").concat(index);
  }
};

exports.updateEventPrefix = updateEventPrefix;

var getEventName = function getEventName(element, eventName, prefix) {
  var eventPrefix = prefix || getEventPrefix(element);
  return "".concat(eventPrefix).concat(eventName);
};

exports.getEventName = getEventName;

var getEventNameByGroup = function getEventNameByGroup(name, index, eventName) {
  if (name) {
    var prefix = "".concat(name, "_").concat(index).concat(eventSeperator);
    return getEventName(undefined, eventName, prefix);
  }

  return null;
};

exports.getEventNameByGroup = getEventNameByGroup;

var getCleanGroupName = function getCleanGroupName(sibling, name) {
  return getEventPrefix(sibling, name).split(eventSeperator)[0];
};

exports.getCleanGroupName = getCleanGroupName;
var _default = EventNames;
exports.default = _default;

},{}],225:[function(require,module,exports){
"use strict";

var _jquery = _interopRequireDefault(require("./jquery-3.6.4.min"));

require("./polyfills.js");

require("./tools.js");

require("./atoms.js");

require("./cmscomponents.js");

require("./templates.js");

var _simpleLightbox = _interopRequireDefault(require("./simple-lightbox.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ = _jquery.default;

if (window.jQuery !== undefined) {
  window.$ = window.jQuery;
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.isInitialized !== undefined && window.isInitialized()) {
    // DOMContentLoaded already initialized. Do nothing.
    return;
  }

  window.dispatchEvent(new CustomEvent('InitComponents'));
});

},{"./atoms.js":168,"./cmscomponents.js":184,"./jquery-3.6.4.min":226,"./polyfills.js":228,"./simple-lightbox.js":231,"./templates.js":235,"./tools.js":236}],226:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! jQuery v3.6.4 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function (e, t) {
  "use strict";

  "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
    if (!e.document) throw new Error("jQuery v3.6.4 - jQuery requires a window with a document");
    return t(e);
  } : t(e);
}("undefined" != typeof window ? window : void 0, function (C, e) {
  "use strict";

  var t = [],
      r = Object.getPrototypeOf,
      s = t.slice,
      g = t.flat ? function (e) {
    return t.flat.call(e);
  } : function (e) {
    return t.concat.apply([], e);
  },
      u = t.push,
      i = t.indexOf,
      n = {},
      o = n.toString,
      y = n.hasOwnProperty,
      a = y.toString,
      l = a.call(Object),
      v = {},
      m = function m(e) {
    return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
  },
      x = function x(e) {
    return null != e && e === e.window;
  },
      E = C.document,
      c = {
    type: !0,
    src: !0,
    nonce: !0,
    noModule: !0
  };

  function b(e, t, n) {
    var r,
        i,
        o = (n = n || E).createElement("script");
    if (o.text = e, t) for (r in c) {
      (i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i);
    }
    n.head.appendChild(o).parentNode.removeChild(o);
  }

  function w(e) {
    return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? n[o.call(e)] || "object" : _typeof(e);
  }

  var f = "3.6.4",
      S = function S(e, t) {
    return new S.fn.init(e, t);
  };

  function p(e) {
    var t = !!e && "length" in e && e.length,
        n = w(e);
    return !m(e) && !x(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e);
  }

  S.fn = S.prototype = {
    jquery: f,
    constructor: S,
    length: 0,
    toArray: function toArray() {
      return s.call(this);
    },
    get: function get(e) {
      return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
    },
    pushStack: function pushStack(e) {
      var t = S.merge(this.constructor(), e);
      return t.prevObject = this, t;
    },
    each: function each(e) {
      return S.each(this, e);
    },
    map: function map(n) {
      return this.pushStack(S.map(this, function (e, t) {
        return n.call(e, t, e);
      }));
    },
    slice: function slice() {
      return this.pushStack(s.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    even: function even() {
      return this.pushStack(S.grep(this, function (e, t) {
        return (t + 1) % 2;
      }));
    },
    odd: function odd() {
      return this.pushStack(S.grep(this, function (e, t) {
        return t % 2;
      }));
    },
    eq: function eq(e) {
      var t = this.length,
          n = +e + (e < 0 ? t : 0);
      return this.pushStack(0 <= n && n < t ? [this[n]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor();
    },
    push: u,
    sort: t.sort,
    splice: t.splice
  }, S.extend = S.fn.extend = function () {
    var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        s = 1,
        u = arguments.length,
        l = !1;

    for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || m(a) || (a = {}), s === u && (a = this, s--); s < u; s++) {
      if (null != (e = arguments[s])) for (t in e) {
        r = e[t], "__proto__" !== t && a !== r && (l && r && (S.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[t], o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}, i = !1, a[t] = S.extend(l, o, r)) : void 0 !== r && (a[t] = r));
      }
    }

    return a;
  }, S.extend({
    expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
    isReady: !0,
    error: function error(e) {
      throw new Error(e);
    },
    noop: function noop() {},
    isPlainObject: function isPlainObject(e) {
      var t, n;
      return !(!e || "[object Object]" !== o.call(e)) && (!(t = r(e)) || "function" == typeof (n = y.call(t, "constructor") && t.constructor) && a.call(n) === l);
    },
    isEmptyObject: function isEmptyObject(e) {
      var t;

      for (t in e) {
        return !1;
      }

      return !0;
    },
    globalEval: function globalEval(e, t, n) {
      b(e, {
        nonce: t && t.nonce
      }, n);
    },
    each: function each(e, t) {
      var n,
          r = 0;

      if (p(e)) {
        for (n = e.length; r < n; r++) {
          if (!1 === t.call(e[r], r, e[r])) break;
        }
      } else for (r in e) {
        if (!1 === t.call(e[r], r, e[r])) break;
      }

      return e;
    },
    makeArray: function makeArray(e, t) {
      var n = t || [];
      return null != e && (p(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
    },
    inArray: function inArray(e, t, n) {
      return null == t ? -1 : i.call(t, e, n);
    },
    merge: function merge(e, t) {
      for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
        e[i++] = t[r];
      }

      return e.length = i, e;
    },
    grep: function grep(e, t, n) {
      for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) {
        !t(e[i], i) !== a && r.push(e[i]);
      }

      return r;
    },
    map: function map(e, t, n) {
      var r,
          i,
          o = 0,
          a = [];
      if (p(e)) for (r = e.length; o < r; o++) {
        null != (i = t(e[o], o, n)) && a.push(i);
      } else for (o in e) {
        null != (i = t(e[o], o, n)) && a.push(i);
      }
      return g(a);
    },
    guid: 1,
    support: v
  }), "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]), S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
    n["[object " + t + "]"] = t.toLowerCase();
  });

  var d = function (n) {
    var e,
        d,
        b,
        o,
        i,
        h,
        f,
        g,
        w,
        u,
        l,
        T,
        C,
        a,
        E,
        y,
        s,
        c,
        v,
        S = "sizzle" + 1 * new Date(),
        p = n.document,
        k = 0,
        r = 0,
        m = ue(),
        x = ue(),
        A = ue(),
        N = ue(),
        j = function j(e, t) {
      return e === t && (l = !0), 0;
    },
        D = {}.hasOwnProperty,
        t = [],
        q = t.pop,
        L = t.push,
        H = t.push,
        O = t.slice,
        P = function P(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }

      return -1;
    },
        R = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        M = "[\\x20\\t\\r\\n\\f]",
        I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        W = "\\[" + M + "*(" + I + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + M + "*\\]",
        F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)",
        $ = new RegExp(M + "+", "g"),
        B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
        _ = new RegExp("^" + M + "*," + M + "*"),
        z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
        U = new RegExp(M + "|>"),
        X = new RegExp(F),
        V = new RegExp("^" + I + "$"),
        G = {
      ID: new RegExp("^#(" + I + ")"),
      CLASS: new RegExp("^\\.(" + I + ")"),
      TAG: new RegExp("^(" + I + "|[*])"),
      ATTR: new RegExp("^" + W),
      PSEUDO: new RegExp("^" + F),
      CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
      bool: new RegExp("^(?:" + R + ")$", "i"),
      needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i")
    },
        Y = /HTML$/i,
        Q = /^(?:input|select|textarea|button)$/i,
        J = /^h\d$/i,
        K = /^[^{]+\{\s*\[native \w/,
        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee = /[+~]/,
        te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
        ne = function ne(e, t) {
      var n = "0x" + e.slice(1) - 65536;
      return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320));
    },
        re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ie = function ie(e, t) {
      return t ? "\0" === e ? "\uFFFD" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
    },
        oe = function oe() {
      T();
    },
        ae = be(function (e) {
      return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
    }, {
      dir: "parentNode",
      next: "legend"
    });

    try {
      H.apply(t = O.call(p.childNodes), p.childNodes), t[p.childNodes.length].nodeType;
    } catch (e) {
      H = {
        apply: t.length ? function (e, t) {
          L.apply(e, O.call(t));
        } : function (e, t) {
          var n = e.length,
              r = 0;

          while (e[n++] = t[r++]) {
            ;
          }

          e.length = n - 1;
        }
      };
    }

    function se(t, e, n, r) {
      var i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = e && e.ownerDocument,
          p = e ? e.nodeType : 9;
      if (n = n || [], "string" != typeof t || !t || 1 !== p && 9 !== p && 11 !== p) return n;

      if (!r && (T(e), e = e || C, E)) {
        if (11 !== p && (u = Z.exec(t))) if (i = u[1]) {
          if (9 === p) {
            if (!(a = e.getElementById(i))) return n;
            if (a.id === i) return n.push(a), n;
          } else if (f && (a = f.getElementById(i)) && v(e, a) && a.id === i) return n.push(a), n;
        } else {
          if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
          if ((i = u[3]) && d.getElementsByClassName && e.getElementsByClassName) return H.apply(n, e.getElementsByClassName(i)), n;
        }

        if (d.qsa && !N[t + " "] && (!y || !y.test(t)) && (1 !== p || "object" !== e.nodeName.toLowerCase())) {
          if (c = t, f = e, 1 === p && (U.test(t) || z.test(t))) {
            (f = ee.test(t) && ve(e.parentNode) || e) === e && d.scope || ((s = e.getAttribute("id")) ? s = s.replace(re, ie) : e.setAttribute("id", s = S)), o = (l = h(t)).length;

            while (o--) {
              l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
            }

            c = l.join(",");
          }

          try {
            return H.apply(n, f.querySelectorAll(c)), n;
          } catch (e) {
            N(t, !0);
          } finally {
            s === S && e.removeAttribute("id");
          }
        }
      }

      return g(t.replace(B, "$1"), e, n, r);
    }

    function ue() {
      var r = [];
      return function e(t, n) {
        return r.push(t + " ") > b.cacheLength && delete e[r.shift()], e[t + " "] = n;
      };
    }

    function le(e) {
      return e[S] = !0, e;
    }

    function ce(e) {
      var t = C.createElement("fieldset");

      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), t = null;
      }
    }

    function fe(e, t) {
      var n = e.split("|"),
          r = n.length;

      while (r--) {
        b.attrHandle[n[r]] = t;
      }
    }

    function pe(e, t) {
      var n = t && e,
          r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while (n = n.nextSibling) {
        if (n === t) return -1;
      }
      return e ? 1 : -1;
    }

    function de(t) {
      return function (e) {
        return "input" === e.nodeName.toLowerCase() && e.type === t;
      };
    }

    function he(n) {
      return function (e) {
        var t = e.nodeName.toLowerCase();
        return ("input" === t || "button" === t) && e.type === n;
      };
    }

    function ge(t) {
      return function (e) {
        return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && ae(e) === t : e.disabled === t : "label" in e && e.disabled === t;
      };
    }

    function ye(a) {
      return le(function (o) {
        return o = +o, le(function (e, t) {
          var n,
              r = a([], e.length, o),
              i = r.length;

          while (i--) {
            e[n = r[i]] && (e[n] = !(t[n] = e[n]));
          }
        });
      });
    }

    function ve(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }

    for (e in d = se.support = {}, i = se.isXML = function (e) {
      var t = e && e.namespaceURI,
          n = e && (e.ownerDocument || e).documentElement;
      return !Y.test(t || n && n.nodeName || "HTML");
    }, T = se.setDocument = function (e) {
      var t,
          n,
          r = e ? e.ownerDocument || e : p;
      return r != C && 9 === r.nodeType && r.documentElement && (a = (C = r).documentElement, E = !i(C), p != C && (n = C.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", oe, !1) : n.attachEvent && n.attachEvent("onunload", oe)), d.scope = ce(function (e) {
        return a.appendChild(e).appendChild(C.createElement("div")), "undefined" != typeof e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
      }), d.cssHas = ce(function () {
        try {
          return C.querySelector(":has(*,:jqfake)"), !1;
        } catch (e) {
          return !0;
        }
      }), d.attributes = ce(function (e) {
        return e.className = "i", !e.getAttribute("className");
      }), d.getElementsByTagName = ce(function (e) {
        return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length;
      }), d.getElementsByClassName = K.test(C.getElementsByClassName), d.getById = ce(function (e) {
        return a.appendChild(e).id = S, !C.getElementsByName || !C.getElementsByName(S).length;
      }), d.getById ? (b.filter.ID = function (e) {
        var t = e.replace(te, ne);
        return function (e) {
          return e.getAttribute("id") === t;
        };
      }, b.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && E) {
          var n = t.getElementById(e);
          return n ? [n] : [];
        }
      }) : (b.filter.ID = function (e) {
        var n = e.replace(te, ne);
        return function (e) {
          var t = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
          return t && t.value === n;
        };
      }, b.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && E) {
          var n,
              r,
              i,
              o = t.getElementById(e);

          if (o) {
            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            i = t.getElementsByName(e), r = 0;

            while (o = i[r++]) {
              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            }
          }

          return [];
        }
      }), b.find.TAG = d.getElementsByTagName ? function (e, t) {
        return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : d.qsa ? t.querySelectorAll(e) : void 0;
      } : function (e, t) {
        var n,
            r = [],
            i = 0,
            o = t.getElementsByTagName(e);

        if ("*" === e) {
          while (n = o[i++]) {
            1 === n.nodeType && r.push(n);
          }

          return r;
        }

        return o;
      }, b.find.CLASS = d.getElementsByClassName && function (e, t) {
        if ("undefined" != typeof t.getElementsByClassName && E) return t.getElementsByClassName(e);
      }, s = [], y = [], (d.qsa = K.test(C.querySelectorAll)) && (ce(function (e) {
        var t;
        a.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + M + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || y.push("\\[" + M + "*(?:value|" + R + ")"), e.querySelectorAll("[id~=" + S + "-]").length || y.push("~="), (t = C.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || y.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || y.push(":checked"), e.querySelectorAll("a#" + S + "+*").length || y.push(".#.+[+~]"), e.querySelectorAll("\\\f"), y.push("[\\r\\n\\f]");
      }), ce(function (e) {
        e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
        var t = C.createElement("input");
        t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"), a.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), y.push(",.*:");
      })), (d.matchesSelector = K.test(c = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector)) && ce(function (e) {
        d.disconnectedMatch = c.call(e, "*"), c.call(e, "[s!='']:x"), s.push("!=", F);
      }), d.cssHas || y.push(":has"), y = y.length && new RegExp(y.join("|")), s = s.length && new RegExp(s.join("|")), t = K.test(a.compareDocumentPosition), v = t || K.test(a.contains) ? function (e, t) {
        var n = 9 === e.nodeType && e.documentElement || e,
            r = t && t.parentNode;
        return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
      } : function (e, t) {
        if (t) while (t = t.parentNode) {
          if (t === e) return !0;
        }
        return !1;
      }, j = t ? function (e, t) {
        if (e === t) return l = !0, 0;
        var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
        return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !d.sortDetached && t.compareDocumentPosition(e) === n ? e == C || e.ownerDocument == p && v(p, e) ? -1 : t == C || t.ownerDocument == p && v(p, t) ? 1 : u ? P(u, e) - P(u, t) : 0 : 4 & n ? -1 : 1);
      } : function (e, t) {
        if (e === t) return l = !0, 0;
        var n,
            r = 0,
            i = e.parentNode,
            o = t.parentNode,
            a = [e],
            s = [t];
        if (!i || !o) return e == C ? -1 : t == C ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0;
        if (i === o) return pe(e, t);
        n = e;

        while (n = n.parentNode) {
          a.unshift(n);
        }

        n = t;

        while (n = n.parentNode) {
          s.unshift(n);
        }

        while (a[r] === s[r]) {
          r++;
        }

        return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0;
      }), C;
    }, se.matches = function (e, t) {
      return se(e, null, null, t);
    }, se.matchesSelector = function (e, t) {
      if (T(e), d.matchesSelector && E && !N[t + " "] && (!s || !s.test(t)) && (!y || !y.test(t))) try {
        var n = c.call(e, t);
        if (n || d.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n;
      } catch (e) {
        N(t, !0);
      }
      return 0 < se(t, C, null, [e]).length;
    }, se.contains = function (e, t) {
      return (e.ownerDocument || e) != C && T(e), v(e, t);
    }, se.attr = function (e, t) {
      (e.ownerDocument || e) != C && T(e);
      var n = b.attrHandle[t.toLowerCase()],
          r = n && D.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
      return void 0 !== r ? r : d.attributes || !E ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
    }, se.escape = function (e) {
      return (e + "").replace(re, ie);
    }, se.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, se.uniqueSort = function (e) {
      var t,
          n = [],
          r = 0,
          i = 0;

      if (l = !d.detectDuplicates, u = !d.sortStable && e.slice(0), e.sort(j), l) {
        while (t = e[i++]) {
          t === e[i] && (r = n.push(i));
        }

        while (r--) {
          e.splice(n[r], 1);
        }
      }

      return u = null, e;
    }, o = se.getText = function (e) {
      var t,
          n = "",
          r = 0,
          i = e.nodeType;

      if (i) {
        if (1 === i || 9 === i || 11 === i) {
          if ("string" == typeof e.textContent) return e.textContent;

          for (e = e.firstChild; e; e = e.nextSibling) {
            n += o(e);
          }
        } else if (3 === i || 4 === i) return e.nodeValue;
      } else while (t = e[r++]) {
        n += o(t);
      }

      return n;
    }, (b = se.selectors = {
      cacheLength: 50,
      createPseudo: le,
      match: G,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: !0
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: !0
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        ATTR: function ATTR(e) {
          return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        },
        CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e;
        },
        PSEUDO: function PSEUDO(e) {
          var t,
              n = !e[6] && e[2];
          return G.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = h(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
        }
      },
      filter: {
        TAG: function TAG(e) {
          var t = e.replace(te, ne).toLowerCase();
          return "*" === e ? function () {
            return !0;
          } : function (e) {
            return e.nodeName && e.nodeName.toLowerCase() === t;
          };
        },
        CLASS: function CLASS(e) {
          var t = m[e + " "];
          return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && m(e, function (e) {
            return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
          });
        },
        ATTR: function ATTR(n, r, i) {
          return function (e) {
            var t = se.attr(e, n);
            return null == t ? "!=" === r : !r || (t += "", "=" === r ? t === i : "!=" === r ? t !== i : "^=" === r ? i && 0 === t.indexOf(i) : "*=" === r ? i && -1 < t.indexOf(i) : "$=" === r ? i && t.slice(-i.length) === i : "~=" === r ? -1 < (" " + t.replace($, " ") + " ").indexOf(i) : "|=" === r && (t === i || t.slice(0, i.length + 1) === i + "-"));
          };
        },
        CHILD: function CHILD(h, e, t, g, y) {
          var v = "nth" !== h.slice(0, 3),
              m = "last" !== h.slice(-4),
              x = "of-type" === e;
          return 1 === g && 0 === y ? function (e) {
            return !!e.parentNode;
          } : function (e, t, n) {
            var r,
                i,
                o,
                a,
                s,
                u,
                l = v !== m ? "nextSibling" : "previousSibling",
                c = e.parentNode,
                f = x && e.nodeName.toLowerCase(),
                p = !n && !x,
                d = !1;

            if (c) {
              if (v) {
                while (l) {
                  a = e;

                  while (a = a[l]) {
                    if (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) return !1;
                  }

                  u = l = "only" === h && !u && "nextSibling";
                }

                return !0;
              }

              if (u = [m ? c.firstChild : c.lastChild], m && p) {
                d = (s = (r = (i = (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]) && r[2], a = s && c.childNodes[s];

                while (a = ++s && a && a[l] || (d = s = 0) || u.pop()) {
                  if (1 === a.nodeType && ++d && a === e) {
                    i[h] = [k, s, d];
                    break;
                  }
                }
              } else if (p && (d = s = (r = (i = (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]), !1 === d) while (a = ++s && a && a[l] || (d = s = 0) || u.pop()) {
                if ((x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) && ++d && (p && ((i = (o = a[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] = [k, d]), a === e)) break;
              }

              return (d -= y) === g || d % g == 0 && 0 <= d / g;
            }
          };
        },
        PSEUDO: function PSEUDO(e, o) {
          var t,
              a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
          return a[S] ? a(o) : 1 < a.length ? (t = [e, e, "", o], b.setFilters.hasOwnProperty(e.toLowerCase()) ? le(function (e, t) {
            var n,
                r = a(e, o),
                i = r.length;

            while (i--) {
              e[n = P(e, r[i])] = !(t[n] = r[i]);
            }
          }) : function (e) {
            return a(e, 0, t);
          }) : a;
        }
      },
      pseudos: {
        not: le(function (e) {
          var r = [],
              i = [],
              s = f(e.replace(B, "$1"));
          return s[S] ? le(function (e, t, n, r) {
            var i,
                o = s(e, null, r, []),
                a = e.length;

            while (a--) {
              (i = o[a]) && (e[a] = !(t[a] = i));
            }
          }) : function (e, t, n) {
            return r[0] = e, s(r, null, n, i), r[0] = null, !i.pop();
          };
        }),
        has: le(function (t) {
          return function (e) {
            return 0 < se(t, e).length;
          };
        }),
        contains: le(function (t) {
          return t = t.replace(te, ne), function (e) {
            return -1 < (e.textContent || o(e)).indexOf(t);
          };
        }),
        lang: le(function (n) {
          return V.test(n || "") || se.error("unsupported lang: " + n), n = n.replace(te, ne).toLowerCase(), function (e) {
            var t;

            do {
              if (t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-");
            } while ((e = e.parentNode) && 1 === e.nodeType);

            return !1;
          };
        }),
        target: function target(e) {
          var t = n.location && n.location.hash;
          return t && t.slice(1) === e.id;
        },
        root: function root(e) {
          return e === a;
        },
        focus: function focus(e) {
          return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        },
        enabled: ge(!1),
        disabled: ge(!0),
        checked: function checked(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && !!e.checked || "option" === t && !!e.selected;
        },
        selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        },
        empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeType < 6) return !1;
          }

          return !0;
        },
        parent: function parent(e) {
          return !b.pseudos.empty(e);
        },
        header: function header(e) {
          return J.test(e.nodeName);
        },
        input: function input(e) {
          return Q.test(e.nodeName);
        },
        button: function button(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && "button" === e.type || "button" === t;
        },
        text: function text(e) {
          var t;
          return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
        },
        first: ye(function () {
          return [0];
        }),
        last: ye(function (e, t) {
          return [t - 1];
        }),
        eq: ye(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }),
        even: ye(function (e, t) {
          for (var n = 0; n < t; n += 2) {
            e.push(n);
          }

          return e;
        }),
        odd: ye(function (e, t) {
          for (var n = 1; n < t; n += 2) {
            e.push(n);
          }

          return e;
        }),
        lt: ye(function (e, t, n) {
          for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r;) {
            e.push(r);
          }

          return e;
        }),
        gt: ye(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; ++r < t;) {
            e.push(r);
          }

          return e;
        })
      }
    }).pseudos.nth = b.pseudos.eq, {
      radio: !0,
      checkbox: !0,
      file: !0,
      password: !0,
      image: !0
    }) {
      b.pseudos[e] = de(e);
    }

    for (e in {
      submit: !0,
      reset: !0
    }) {
      b.pseudos[e] = he(e);
    }

    function me() {}

    function xe(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) {
        r += e[t].value;
      }

      return r;
    }

    function be(s, e, t) {
      var u = e.dir,
          l = e.next,
          c = l || u,
          f = t && "parentNode" === c,
          p = r++;
      return e.first ? function (e, t, n) {
        while (e = e[u]) {
          if (1 === e.nodeType || f) return s(e, t, n);
        }

        return !1;
      } : function (e, t, n) {
        var r,
            i,
            o,
            a = [k, p];

        if (n) {
          while (e = e[u]) {
            if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
          }
        } else while (e = e[u]) {
          if (1 === e.nodeType || f) if (i = (o = e[S] || (e[S] = {}))[e.uniqueID] || (o[e.uniqueID] = {}), l && l === e.nodeName.toLowerCase()) e = e[u] || e;else {
            if ((r = i[c]) && r[0] === k && r[1] === p) return a[2] = r[2];
            if ((i[c] = a)[2] = s(e, t, n)) return !0;
          }
        }

        return !1;
      };
    }

    function we(i) {
      return 1 < i.length ? function (e, t, n) {
        var r = i.length;

        while (r--) {
          if (!i[r](e, t, n)) return !1;
        }

        return !0;
      } : i[0];
    }

    function Te(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) {
        (o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s)));
      }

      return a;
    }

    function Ce(d, h, g, y, v, e) {
      return y && !y[S] && (y = Ce(y)), v && !v[S] && (v = Ce(v, e)), le(function (e, t, n, r) {
        var i,
            o,
            a,
            s = [],
            u = [],
            l = t.length,
            c = e || function (e, t, n) {
          for (var r = 0, i = t.length; r < i; r++) {
            se(e, t[r], n);
          }

          return n;
        }(h || "*", n.nodeType ? [n] : n, []),
            f = !d || !e && h ? c : Te(c, s, d, n, r),
            p = g ? v || (e ? d : l || y) ? [] : t : f;

        if (g && g(f, p, n, r), y) {
          i = Te(p, u), y(i, [], n, r), o = i.length;

          while (o--) {
            (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
          }
        }

        if (e) {
          if (v || d) {
            if (v) {
              i = [], o = p.length;

              while (o--) {
                (a = p[o]) && i.push(f[o] = a);
              }

              v(null, p = [], i, r);
            }

            o = p.length;

            while (o--) {
              (a = p[o]) && -1 < (i = v ? P(e, a) : s[o]) && (e[i] = !(t[i] = a));
            }
          }
        } else p = Te(p === t ? p.splice(l, p.length) : p), v ? v(null, t, p, r) : H.apply(t, p);
      });
    }

    function Ee(e) {
      for (var i, t, n, r = e.length, o = b.relative[e[0].type], a = o || b.relative[" "], s = o ? 1 : 0, u = be(function (e) {
        return e === i;
      }, a, !0), l = be(function (e) {
        return -1 < P(i, e);
      }, a, !0), c = [function (e, t, n) {
        var r = !o && (n || t !== w) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
        return i = null, r;
      }]; s < r; s++) {
        if (t = b.relative[e[s].type]) c = [be(we(c), t)];else {
          if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
            for (n = ++s; n < r; n++) {
              if (b.relative[e[n].type]) break;
            }

            return Ce(1 < s && we(c), 1 < s && xe(e.slice(0, s - 1).concat({
              value: " " === e[s - 2].type ? "*" : ""
            })).replace(B, "$1"), t, s < n && Ee(e.slice(s, n)), n < r && Ee(e = e.slice(n)), n < r && xe(e));
          }

          c.push(t);
        }
      }

      return we(c);
    }

    return me.prototype = b.filters = b.pseudos, b.setFilters = new me(), h = se.tokenize = function (e, t) {
      var n,
          r,
          i,
          o,
          a,
          s,
          u,
          l = x[e + " "];
      if (l) return t ? 0 : l.slice(0);
      a = e, s = [], u = b.preFilter;

      while (a) {
        for (o in n && !(r = _.exec(a)) || (r && (a = a.slice(r[0].length) || a), s.push(i = [])), n = !1, (r = z.exec(a)) && (n = r.shift(), i.push({
          value: n,
          type: r[0].replace(B, " ")
        }), a = a.slice(n.length)), b.filter) {
          !(r = G[o].exec(a)) || u[o] && !(r = u[o](r)) || (n = r.shift(), i.push({
            value: n,
            type: o,
            matches: r
          }), a = a.slice(n.length));
        }

        if (!n) break;
      }

      return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
    }, f = se.compile = function (e, t) {
      var n,
          y,
          v,
          m,
          x,
          r,
          i = [],
          o = [],
          a = A[e + " "];

      if (!a) {
        t || (t = h(e)), n = t.length;

        while (n--) {
          (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
        }

        (a = A(e, (y = o, m = 0 < (v = i).length, x = 0 < y.length, r = function r(e, t, n, _r, i) {
          var o,
              a,
              s,
              u = 0,
              l = "0",
              c = e && [],
              f = [],
              p = w,
              d = e || x && b.find.TAG("*", i),
              h = k += null == p ? 1 : Math.random() || .1,
              g = d.length;

          for (i && (w = t == C || t || i); l !== g && null != (o = d[l]); l++) {
            if (x && o) {
              a = 0, t || o.ownerDocument == C || (T(o), n = !E);

              while (s = y[a++]) {
                if (s(o, t || C, n)) {
                  _r.push(o);

                  break;
                }
              }

              i && (k = h);
            }

            m && ((o = !s && o) && u--, e && c.push(o));
          }

          if (u += l, m && l !== u) {
            a = 0;

            while (s = v[a++]) {
              s(c, f, t, n);
            }

            if (e) {
              if (0 < u) while (l--) {
                c[l] || f[l] || (f[l] = q.call(_r));
              }
              f = Te(f);
            }

            H.apply(_r, f), i && !e && 0 < f.length && 1 < u + v.length && se.uniqueSort(_r);
          }

          return i && (k = h, w = p), c;
        }, m ? le(r) : r))).selector = e;
      }

      return a;
    }, g = se.select = function (e, t, n, r) {
      var i,
          o,
          a,
          s,
          u,
          l = "function" == typeof e && e,
          c = !r && h(e = l.selector || e);

      if (n = n || [], 1 === c.length) {
        if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (a = o[0]).type && 9 === t.nodeType && E && b.relative[o[1].type]) {
          if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0])) return n;
          l && (t = t.parentNode), e = e.slice(o.shift().value.length);
        }

        i = G.needsContext.test(e) ? 0 : o.length;

        while (i--) {
          if (a = o[i], b.relative[s = a.type]) break;

          if ((u = b.find[s]) && (r = u(a.matches[0].replace(te, ne), ee.test(o[0].type) && ve(t.parentNode) || t))) {
            if (o.splice(i, 1), !(e = r.length && xe(o))) return H.apply(n, r), n;
            break;
          }
        }
      }

      return (l || f(e, c))(r, t, !E, n, !t || ee.test(e) && ve(t.parentNode) || t), n;
    }, d.sortStable = S.split("").sort(j).join("") === S, d.detectDuplicates = !!l, T(), d.sortDetached = ce(function (e) {
      return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
    }), ce(function (e) {
      return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
    }) || fe("type|href|height|width", function (e, t, n) {
      if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
    }), d.attributes && ce(function (e) {
      return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
    }) || fe("value", function (e, t, n) {
      if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
    }), ce(function (e) {
      return null == e.getAttribute("disabled");
    }) || fe(R, function (e, t, n) {
      var r;
      if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
    }), se;
  }(C);

  S.find = d, S.expr = d.selectors, S.expr[":"] = S.expr.pseudos, S.uniqueSort = S.unique = d.uniqueSort, S.text = d.getText, S.isXMLDoc = d.isXML, S.contains = d.contains, S.escapeSelector = d.escape;

  var h = function h(e, t, n) {
    var r = [],
        i = void 0 !== n;

    while ((e = e[t]) && 9 !== e.nodeType) {
      if (1 === e.nodeType) {
        if (i && S(e).is(n)) break;
        r.push(e);
      }
    }

    return r;
  },
      T = function T(e, t) {
    for (var n = []; e; e = e.nextSibling) {
      1 === e.nodeType && e !== t && n.push(e);
    }

    return n;
  },
      k = S.expr.match.needsContext;

  function A(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }

  var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  function j(e, n, r) {
    return m(n) ? S.grep(e, function (e, t) {
      return !!n.call(e, t, e) !== r;
    }) : n.nodeType ? S.grep(e, function (e) {
      return e === n !== r;
    }) : "string" != typeof n ? S.grep(e, function (e) {
      return -1 < i.call(n, e) !== r;
    }) : S.filter(n, e, r);
  }

  S.filter = function (e, t, n) {
    var r = t[0];
    return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? S.find.matchesSelector(r, e) ? [r] : [] : S.find.matches(e, S.grep(t, function (e) {
      return 1 === e.nodeType;
    }));
  }, S.fn.extend({
    find: function find(e) {
      var t,
          n,
          r = this.length,
          i = this;
      if ("string" != typeof e) return this.pushStack(S(e).filter(function () {
        for (t = 0; t < r; t++) {
          if (S.contains(i[t], this)) return !0;
        }
      }));

      for (n = this.pushStack([]), t = 0; t < r; t++) {
        S.find(e, i[t], n);
      }

      return 1 < r ? S.uniqueSort(n) : n;
    },
    filter: function filter(e) {
      return this.pushStack(j(this, e || [], !1));
    },
    not: function not(e) {
      return this.pushStack(j(this, e || [], !0));
    },
    is: function is(e) {
      return !!j(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1).length;
    }
  });
  var D,
      q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  (S.fn.init = function (e, t, n) {
    var r, i;
    if (!e) return this;

    if (n = n || D, "string" == typeof e) {
      if (!(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : q.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

      if (r[1]) {
        if (t = t instanceof S ? t[0] : t, S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)), N.test(r[1]) && S.isPlainObject(t)) for (r in t) {
          m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
        }
        return this;
      }

      return (i = E.getElementById(r[2])) && (this[0] = i, this.length = 1), this;
    }

    return e.nodeType ? (this[0] = e, this.length = 1, this) : m(e) ? void 0 !== n.ready ? n.ready(e) : e(S) : S.makeArray(e, this);
  }).prototype = S.fn, D = S(E);
  var L = /^(?:parents|prev(?:Until|All))/,
      H = {
    children: !0,
    contents: !0,
    next: !0,
    prev: !0
  };

  function O(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType) {
      ;
    }

    return e;
  }

  S.fn.extend({
    has: function has(e) {
      var t = S(e, this),
          n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) {
          if (S.contains(this, t[e])) return !0;
        }
      });
    },
    closest: function closest(e, t) {
      var n,
          r = 0,
          i = this.length,
          o = [],
          a = "string" != typeof e && S(e);
      if (!k.test(e)) for (; r < i; r++) {
        for (n = this[r]; n && n !== t; n = n.parentNode) {
          if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
            o.push(n);
            break;
          }
        }
      }
      return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
    },
    index: function index(e) {
      return e ? "string" == typeof e ? i.call(S(e), this[0]) : i.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    },
    add: function add(e, t) {
      return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
    },
    addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  }), S.each({
    parent: function parent(e) {
      var t = e.parentNode;
      return t && 11 !== t.nodeType ? t : null;
    },
    parents: function parents(e) {
      return h(e, "parentNode");
    },
    parentsUntil: function parentsUntil(e, t, n) {
      return h(e, "parentNode", n);
    },
    next: function next(e) {
      return O(e, "nextSibling");
    },
    prev: function prev(e) {
      return O(e, "previousSibling");
    },
    nextAll: function nextAll(e) {
      return h(e, "nextSibling");
    },
    prevAll: function prevAll(e) {
      return h(e, "previousSibling");
    },
    nextUntil: function nextUntil(e, t, n) {
      return h(e, "nextSibling", n);
    },
    prevUntil: function prevUntil(e, t, n) {
      return h(e, "previousSibling", n);
    },
    siblings: function siblings(e) {
      return T((e.parentNode || {}).firstChild, e);
    },
    children: function children(e) {
      return T(e.firstChild);
    },
    contents: function contents(e) {
      return null != e.contentDocument && r(e.contentDocument) ? e.contentDocument : (A(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
    }
  }, function (r, i) {
    S.fn[r] = function (e, t) {
      var n = S.map(this, i, e);
      return "Until" !== r.slice(-5) && (t = e), t && "string" == typeof t && (n = S.filter(t, n)), 1 < this.length && (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()), this.pushStack(n);
    };
  });
  var P = /[^\x20\t\r\n\f]+/g;

  function R(e) {
    return e;
  }

  function M(e) {
    throw e;
  }

  function I(e, t, n, r) {
    var i;

    try {
      e && m(i = e.promise) ? i.call(e).done(t).fail(n) : e && m(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }

  S.Callbacks = function (r) {
    var e, n;
    r = "string" == typeof r ? (e = r, n = {}, S.each(e.match(P) || [], function (e, t) {
      n[t] = !0;
    }), n) : S.extend({}, r);

    var i,
        t,
        o,
        a,
        s = [],
        u = [],
        l = -1,
        c = function c() {
      for (a = a || r.once, o = i = !0; u.length; l = -1) {
        t = u.shift();

        while (++l < s.length) {
          !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && (l = s.length, t = !1);
        }
      }

      r.memory || (t = !1), i = !1, a && (s = t ? [] : "");
    },
        f = {
      add: function add() {
        return s && (t && !i && (l = s.length - 1, u.push(t)), function n(e) {
          S.each(e, function (e, t) {
            m(t) ? r.unique && f.has(t) || s.push(t) : t && t.length && "string" !== w(t) && n(t);
          });
        }(arguments), t && !i && c()), this;
      },
      remove: function remove() {
        return S.each(arguments, function (e, t) {
          var n;

          while (-1 < (n = S.inArray(t, s, n))) {
            s.splice(n, 1), n <= l && l--;
          }
        }), this;
      },
      has: function has(e) {
        return e ? -1 < S.inArray(e, s) : 0 < s.length;
      },
      empty: function empty() {
        return s && (s = []), this;
      },
      disable: function disable() {
        return a = u = [], s = t = "", this;
      },
      disabled: function disabled() {
        return !s;
      },
      lock: function lock() {
        return a = u = [], t || i || (s = t = ""), this;
      },
      locked: function locked() {
        return !!a;
      },
      fireWith: function fireWith(e, t) {
        return a || (t = [e, (t = t || []).slice ? t.slice() : t], u.push(t), i || c()), this;
      },
      fire: function fire() {
        return f.fireWith(this, arguments), this;
      },
      fired: function fired() {
        return !!o;
      }
    };

    return f;
  }, S.extend({
    Deferred: function Deferred(e) {
      var o = [["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2], ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"]],
          i = "pending",
          a = {
        state: function state() {
          return i;
        },
        always: function always() {
          return s.done(arguments).fail(arguments), this;
        },
        "catch": function _catch(e) {
          return a.then(null, e);
        },
        pipe: function pipe() {
          var i = arguments;
          return S.Deferred(function (r) {
            S.each(o, function (e, t) {
              var n = m(i[t[4]]) && i[t[4]];
              s[t[1]](function () {
                var e = n && n.apply(this, arguments);
                e && m(e.promise) ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject) : r[t[0] + "With"](this, n ? [e] : arguments);
              });
            }), i = null;
          }).promise();
        },
        then: function then(t, n, r) {
          var u = 0;

          function l(i, o, a, s) {
            return function () {
              var n = this,
                  r = arguments,
                  e = function e() {
                var e, t;

                if (!(i < u)) {
                  if ((e = a.apply(n, r)) === o.promise()) throw new TypeError("Thenable self-resolution");
                  t = e && ("object" == _typeof(e) || "function" == typeof e) && e.then, m(t) ? s ? t.call(e, l(u, o, R, s), l(u, o, M, s)) : (u++, t.call(e, l(u, o, R, s), l(u, o, M, s), l(u, o, R, o.notifyWith))) : (a !== R && (n = void 0, r = [e]), (s || o.resolveWith)(n, r));
                }
              },
                  t = s ? e : function () {
                try {
                  e();
                } catch (e) {
                  S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace), u <= i + 1 && (a !== M && (n = void 0, r = [e]), o.rejectWith(n, r));
                }
              };

              i ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()), C.setTimeout(t));
            };
          }

          return S.Deferred(function (e) {
            o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)), o[1][3].add(l(0, e, m(t) ? t : R)), o[2][3].add(l(0, e, m(n) ? n : M));
          }).promise();
        },
        promise: function promise(e) {
          return null != e ? S.extend(e, a) : a;
        }
      },
          s = {};
      return S.each(o, function (e, t) {
        var n = t[2],
            r = t[5];
        a[t[1]] = n.add, r && n.add(function () {
          i = r;
        }, o[3 - e][2].disable, o[3 - e][3].disable, o[0][2].lock, o[0][3].lock), n.add(t[3].fire), s[t[0]] = function () {
          return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
        }, s[t[0] + "With"] = n.fireWith;
      }), a.promise(s), e && e.call(s, s), s;
    },
    when: function when(e) {
      var n = arguments.length,
          t = n,
          r = Array(t),
          i = s.call(arguments),
          o = S.Deferred(),
          a = function a(t) {
        return function (e) {
          r[t] = this, i[t] = 1 < arguments.length ? s.call(arguments) : e, --n || o.resolveWith(r, i);
        };
      };

      if (n <= 1 && (I(e, o.done(a(t)).resolve, o.reject, !n), "pending" === o.state() || m(i[t] && i[t].then))) return o.then();

      while (t--) {
        I(i[t], a(t), o.reject);
      }

      return o.promise();
    }
  });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  S.Deferred.exceptionHook = function (e, t) {
    C.console && C.console.warn && e && W.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
  }, S.readyException = function (e) {
    C.setTimeout(function () {
      throw e;
    });
  };
  var F = S.Deferred();

  function $() {
    E.removeEventListener("DOMContentLoaded", $), C.removeEventListener("load", $), S.ready();
  }

  S.fn.ready = function (e) {
    return F.then(e)["catch"](function (e) {
      S.readyException(e);
    }), this;
  }, S.extend({
    isReady: !1,
    readyWait: 1,
    ready: function ready(e) {
      (!0 === e ? --S.readyWait : S.isReady) || (S.isReady = !0) !== e && 0 < --S.readyWait || F.resolveWith(E, [S]);
    }
  }), S.ready.then = F.then, "complete" === E.readyState || "loading" !== E.readyState && !E.documentElement.doScroll ? C.setTimeout(S.ready) : (E.addEventListener("DOMContentLoaded", $), C.addEventListener("load", $));

  var B = function B(e, t, n, r, i, o, a) {
    var s = 0,
        u = e.length,
        l = null == n;
    if ("object" === w(n)) for (s in i = !0, n) {
      B(e, t, s, n[s], !0, o, a);
    } else if (void 0 !== r && (i = !0, m(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function t(e, _t2, n) {
      return l.call(S(e), n);
    })), t)) for (; s < u; s++) {
      t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
    }
    return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
  },
      _ = /^-ms-/,
      z = /-([a-z])/g;

  function U(e, t) {
    return t.toUpperCase();
  }

  function X(e) {
    return e.replace(_, "ms-").replace(z, U);
  }

  var V = function V(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };

  function G() {
    this.expando = S.expando + G.uid++;
  }

  G.uid = 1, G.prototype = {
    cache: function cache(e) {
      var t = e[this.expando];
      return t || (t = {}, V(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
        value: t,
        configurable: !0
      }))), t;
    },
    set: function set(e, t, n) {
      var r,
          i = this.cache(e);
      if ("string" == typeof t) i[X(t)] = n;else for (r in t) {
        i[X(r)] = t[r];
      }
      return i;
    },
    get: function get(e, t) {
      return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
    },
    access: function access(e, t, n) {
      return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
    },
    remove: function remove(e, t) {
      var n,
          r = e[this.expando];

      if (void 0 !== r) {
        if (void 0 !== t) {
          n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(P) || []).length;

          while (n--) {
            delete r[t[n]];
          }
        }

        (void 0 === t || S.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
      }
    },
    hasData: function hasData(e) {
      var t = e[this.expando];
      return void 0 !== t && !S.isEmptyObject(t);
    }
  };
  var Y = new G(),
      Q = new G(),
      J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      K = /[A-Z]/g;

  function Z(e, t, n) {
    var r, i;
    if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(K, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
      try {
        n = "true" === (i = n) || "false" !== i && ("null" === i ? null : i === +i + "" ? +i : J.test(i) ? JSON.parse(i) : i);
      } catch (e) {}

      Q.set(e, t, n);
    } else n = void 0;
    return n;
  }

  S.extend({
    hasData: function hasData(e) {
      return Q.hasData(e) || Y.hasData(e);
    },
    data: function data(e, t, n) {
      return Q.access(e, t, n);
    },
    removeData: function removeData(e, t) {
      Q.remove(e, t);
    },
    _data: function _data(e, t, n) {
      return Y.access(e, t, n);
    },
    _removeData: function _removeData(e, t) {
      Y.remove(e, t);
    }
  }), S.fn.extend({
    data: function data(n, e) {
      var t,
          r,
          i,
          o = this[0],
          a = o && o.attributes;

      if (void 0 === n) {
        if (this.length && (i = Q.get(o), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
          t = a.length;

          while (t--) {
            a[t] && 0 === (r = a[t].name).indexOf("data-") && (r = X(r.slice(5)), Z(o, r, i[r]));
          }

          Y.set(o, "hasDataAttrs", !0);
        }

        return i;
      }

      return "object" == _typeof(n) ? this.each(function () {
        Q.set(this, n);
      }) : B(this, function (e) {
        var t;
        if (o && void 0 === e) return void 0 !== (t = Q.get(o, n)) ? t : void 0 !== (t = Z(o, n)) ? t : void 0;
        this.each(function () {
          Q.set(this, n, e);
        });
      }, null, e, 1 < arguments.length, null, !0);
    },
    removeData: function removeData(e) {
      return this.each(function () {
        Q.remove(this, e);
      });
    }
  }), S.extend({
    queue: function queue(e, t, n) {
      var r;
      if (e) return t = (t || "fx") + "queue", r = Y.get(e, t), n && (!r || Array.isArray(n) ? r = Y.access(e, t, S.makeArray(n)) : r.push(n)), r || [];
    },
    dequeue: function dequeue(e, t) {
      t = t || "fx";

      var n = S.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = S._queueHooks(e, t);

      "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () {
        S.dequeue(e, t);
      }, o)), !r && o && o.empty.fire();
    },
    _queueHooks: function _queueHooks(e, t) {
      var n = t + "queueHooks";
      return Y.get(e, n) || Y.access(e, n, {
        empty: S.Callbacks("once memory").add(function () {
          Y.remove(e, [t + "queue", n]);
        })
      });
    }
  }), S.fn.extend({
    queue: function queue(t, n) {
      var e = 2;
      return "string" != typeof t && (n = t, t = "fx", e--), arguments.length < e ? S.queue(this[0], t) : void 0 === n ? this : this.each(function () {
        var e = S.queue(this, t, n);
        S._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
      });
    },
    dequeue: function dequeue(e) {
      return this.each(function () {
        S.dequeue(this, e);
      });
    },
    clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    },
    promise: function promise(e, t) {
      var n,
          r = 1,
          i = S.Deferred(),
          o = this,
          a = this.length,
          s = function s() {
        --r || i.resolveWith(o, [o]);
      };

      "string" != typeof e && (t = e, e = void 0), e = e || "fx";

      while (a--) {
        (n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
      }

      return s(), i.promise(t);
    }
  });

  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
      ne = ["Top", "Right", "Bottom", "Left"],
      re = E.documentElement,
      ie = function ie(e) {
    return S.contains(e.ownerDocument, e);
  },
      oe = {
    composed: !0
  };

  re.getRootNode && (ie = function ie(e) {
    return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument;
  });

  var ae = function ae(e, t) {
    return "none" === (e = t || e).style.display || "" === e.style.display && ie(e) && "none" === S.css(e, "display");
  };

  function se(e, t, n, r) {
    var i,
        o,
        a = 20,
        s = r ? function () {
      return r.cur();
    } : function () {
      return S.css(e, t, "");
    },
        u = s(),
        l = n && n[3] || (S.cssNumber[t] ? "" : "px"),
        c = e.nodeType && (S.cssNumber[t] || "px" !== l && +u) && te.exec(S.css(e, t));

    if (c && c[3] !== l) {
      u /= 2, l = l || c[3], c = +u || 1;

      while (a--) {
        S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o;
      }

      c *= 2, S.style(e, t, c + l), n = n || [];
    }

    return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
  }

  var ue = {};

  function le(e, t) {
    for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++) {
      (r = e[c]).style && (n = r.style.display, t ? ("none" === n && (l[c] = Y.get(r, "display") || null, l[c] || (r.style.display = "")), "" === r.style.display && ae(r) && (l[c] = (u = a = o = void 0, a = (i = r).ownerDocument, s = i.nodeName, (u = ue[s]) || (o = a.body.appendChild(a.createElement(s)), u = S.css(o, "display"), o.parentNode.removeChild(o), "none" === u && (u = "block"), ue[s] = u)))) : "none" !== n && (l[c] = "none", Y.set(r, "display", n)));
    }

    for (c = 0; c < f; c++) {
      null != l[c] && (e[c].style.display = l[c]);
    }

    return e;
  }

  S.fn.extend({
    show: function show() {
      return le(this, !0);
    },
    hide: function hide() {
      return le(this);
    },
    toggle: function toggle(e) {
      return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
        ae(this) ? S(this).show() : S(this).hide();
      });
    }
  });
  var ce,
      fe,
      pe = /^(?:checkbox|radio)$/i,
      de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      he = /^$|^module$|\/(?:java|ecma)script/i;
  ce = E.createDocumentFragment().appendChild(E.createElement("div")), (fe = E.createElement("input")).setAttribute("type", "radio"), fe.setAttribute("checked", "checked"), fe.setAttribute("name", "t"), ce.appendChild(fe), v.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked, ce.innerHTML = "<textarea>x</textarea>", v.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue, ce.innerHTML = "<option></option>", v.option = !!ce.lastChild;
  var ge = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };

  function ye(e, t) {
    var n;
    return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && A(e, t) ? S.merge([e], n) : n;
  }

  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++) {
      Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
    }
  }

  ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td, v.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
  var me = /<|&#?\w+;/;

  function xe(e, t, n, r, i) {
    for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++) {
      if ((o = e[d]) || 0 === o) if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);else if (me.test(o)) {
        a = a || f.appendChild(t.createElement("div")), s = (de.exec(o) || ["", ""])[1].toLowerCase(), u = ge[s] || ge._default, a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2], c = u[0];

        while (c--) {
          a = a.lastChild;
        }

        S.merge(p, a.childNodes), (a = f.firstChild).textContent = "";
      } else p.push(t.createTextNode(o));
    }

    f.textContent = "", d = 0;

    while (o = p[d++]) {
      if (r && -1 < S.inArray(o, r)) i && i.push(o);else if (l = ie(o), a = ye(f.appendChild(o), "script"), l && ve(a), n) {
        c = 0;

        while (o = a[c++]) {
          he.test(o.type || "") && n.push(o);
        }
      }
    }

    return f;
  }

  var be = /^([^.]*)(?:\.(.+)|)/;

  function we() {
    return !0;
  }

  function Te() {
    return !1;
  }

  function Ce(e, t) {
    return e === function () {
      try {
        return E.activeElement;
      } catch (e) {}
    }() == ("focus" === t);
  }

  function Ee(e, t, n, r, i, o) {
    var a, s;

    if ("object" == _typeof(t)) {
      for (s in "string" != typeof n && (r = r || n, n = void 0), t) {
        Ee(e, s, n, r, t[s], o);
      }

      return e;
    }

    if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Te;else if (!i) return e;
    return 1 === o && (a = i, (i = function i(e) {
      return S().off(e), a.apply(this, arguments);
    }).guid = a.guid || (a.guid = S.guid++)), e.each(function () {
      S.event.add(this, t, i, r, n);
    });
  }

  function Se(e, i, o) {
    o ? (Y.set(e, i, !1), S.event.add(e, i, {
      namespace: !1,
      handler: function handler(e) {
        var t,
            n,
            r = Y.get(this, i);

        if (1 & e.isTrigger && this[i]) {
          if (r.length) (S.event.special[i] || {}).delegateType && e.stopPropagation();else if (r = s.call(arguments), Y.set(this, i, r), t = o(this, i), this[i](), r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : n = {}, r !== n) return e.stopImmediatePropagation(), e.preventDefault(), n && n.value;
        } else r.length && (Y.set(this, i, {
          value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this)
        }), e.stopImmediatePropagation());
      }
    })) : void 0 === Y.get(e, i) && S.event.add(e, i, we);
  }

  S.event = {
    global: {},
    add: function add(t, e, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = Y.get(t);

      if (V(t)) {
        n.handler && (n = (o = n).handler, i = o.selector), i && S.find.matchesSelector(re, i), n.guid || (n.guid = S.guid++), (u = y.events) || (u = y.events = Object.create(null)), (a = y.handle) || (a = y.handle = function (e) {
          return "undefined" != typeof S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0;
        }), l = (e = (e || "").match(P) || [""]).length;

        while (l--) {
          d = g = (s = be.exec(e[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = S.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = S.event.special[d] || {}, c = S.extend({
            type: d,
            origType: g,
            data: r,
            handler: n,
            guid: n.guid,
            selector: i,
            needsContext: i && S.expr.match.needsContext.test(i),
            namespace: h.join(".")
          }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(t, r, h, a) || t.addEventListener && t.addEventListener(d, a)), f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), S.event.global[d] = !0);
        }
      }
    },
    remove: function remove(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = Y.hasData(e) && Y.get(e);

      if (y && (u = y.events)) {
        l = (t = (t || "").match(P) || [""]).length;

        while (l--) {
          if (d = g = (s = be.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d) {
            f = S.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length;

            while (o--) {
              c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
            }

            a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, y.handle) || S.removeEvent(e, d, y.handle), delete u[d]);
          } else for (d in u) {
            S.event.remove(e, d + t[l], n, r, !0);
          }
        }

        S.isEmptyObject(u) && Y.remove(e, "handle events");
      }
    },
    dispatch: function dispatch(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          s = new Array(arguments.length),
          u = S.event.fix(e),
          l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
          c = S.event.special[u.type] || {};

      for (s[0] = u, t = 1; t < arguments.length; t++) {
        s[t] = arguments[t];
      }

      if (u.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, u)) {
        a = S.event.handlers.call(this, u, l), t = 0;

        while ((i = a[t++]) && !u.isPropagationStopped()) {
          u.currentTarget = i.elem, n = 0;

          while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped()) {
            u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o, u.data = o.data, void 0 !== (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = r) && (u.preventDefault(), u.stopPropagation()));
          }
        }

        return c.postDispatch && c.postDispatch.call(this, u), u.result;
      }
    },
    handlers: function handlers(e, t) {
      var n,
          r,
          i,
          o,
          a,
          s = [],
          u = t.delegateCount,
          l = e.target;
      if (u && l.nodeType && !("click" === e.type && 1 <= e.button)) for (; l !== this; l = l.parentNode || this) {
        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
          for (o = [], a = {}, n = 0; n < u; n++) {
            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? -1 < S(i, this).index(l) : S.find(i, this, null, [l]).length), a[i] && o.push(r);
          }

          o.length && s.push({
            elem: l,
            handlers: o
          });
        }
      }
      return l = this, u < t.length && s.push({
        elem: l,
        handlers: t.slice(u)
      }), s;
    },
    addProp: function addProp(t, e) {
      Object.defineProperty(S.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: m(e) ? function () {
          if (this.originalEvent) return e(this.originalEvent);
        } : function () {
          if (this.originalEvent) return this.originalEvent[t];
        },
        set: function set(e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
          });
        }
      });
    },
    fix: function fix(e) {
      return e[S.expando] ? e : new S.Event(e);
    },
    special: {
      load: {
        noBubble: !0
      },
      click: {
        setup: function setup(e) {
          var t = this || e;
          return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click", we), !1;
        },
        trigger: function trigger(e) {
          var t = this || e;
          return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click"), !0;
        },
        _default: function _default(e) {
          var t = e.target;
          return pe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click") || A(t, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        }
      }
    }
  }, S.removeEvent = function (e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n);
  }, S.Event = function (e, t) {
    if (!(this instanceof S.Event)) return new S.Event(e, t);
    e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? we : Te, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && S.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[S.expando] = !0;
  }, S.Event.prototype = {
    constructor: S.Event,
    isDefaultPrevented: Te,
    isPropagationStopped: Te,
    isImmediatePropagationStopped: Te,
    isSimulated: !1,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = we, e && !this.isSimulated && e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = we, e && !this.isSimulated && e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = we, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
    }
  }, S.each({
    altKey: !0,
    bubbles: !0,
    cancelable: !0,
    changedTouches: !0,
    ctrlKey: !0,
    detail: !0,
    eventPhase: !0,
    metaKey: !0,
    pageX: !0,
    pageY: !0,
    shiftKey: !0,
    view: !0,
    "char": !0,
    code: !0,
    charCode: !0,
    key: !0,
    keyCode: !0,
    button: !0,
    buttons: !0,
    clientX: !0,
    clientY: !0,
    offsetX: !0,
    offsetY: !0,
    pointerId: !0,
    pointerType: !0,
    screenX: !0,
    screenY: !0,
    targetTouches: !0,
    toElement: !0,
    touches: !0,
    which: !0
  }, S.event.addProp), S.each({
    focus: "focusin",
    blur: "focusout"
  }, function (t, e) {
    S.event.special[t] = {
      setup: function setup() {
        return Se(this, t, Ce), !1;
      },
      trigger: function trigger() {
        return Se(this, t), !0;
      },
      _default: function _default(e) {
        return Y.get(e.target, t);
      },
      delegateType: e
    };
  }), S.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (e, i) {
    S.event.special[e] = {
      delegateType: i,
      bindType: i,
      handle: function handle(e) {
        var t,
            n = e.relatedTarget,
            r = e.handleObj;
        return n && (n === this || S.contains(this, n)) || (e.type = r.origType, t = r.handler.apply(this, arguments), e.type = i), t;
      }
    };
  }), S.fn.extend({
    on: function on(e, t, n, r) {
      return Ee(this, e, t, n, r);
    },
    one: function one(e, t, n, r) {
      return Ee(this, e, t, n, r, 1);
    },
    off: function off(e, t, n) {
      var r, i;
      if (e && e.preventDefault && e.handleObj) return r = e.handleObj, S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;

      if ("object" == _typeof(e)) {
        for (i in e) {
          this.off(i, t, e[i]);
        }

        return this;
      }

      return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Te), this.each(function () {
        S.event.remove(this, e, n, t);
      });
    }
  });
  var ke = /<script|<style|<link/i,
      Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Ne = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

  function je(e, t) {
    return A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0] || e;
  }

  function De(e) {
    return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
  }

  function qe(e) {
    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
  }

  function Le(e, t) {
    var n, r, i, o, a, s;

    if (1 === t.nodeType) {
      if (Y.hasData(e) && (s = Y.get(e).events)) for (i in Y.remove(t, "handle events"), s) {
        for (n = 0, r = s[i].length; n < r; n++) {
          S.event.add(t, i, s[i][n]);
        }
      }
      Q.hasData(e) && (o = Q.access(e), a = S.extend({}, o), Q.set(t, a));
    }
  }

  function He(n, r, i, o) {
    r = g(r);
    var e,
        t,
        a,
        s,
        u,
        l,
        c = 0,
        f = n.length,
        p = f - 1,
        d = r[0],
        h = m(d);
    if (h || 1 < f && "string" == typeof d && !v.checkClone && Ae.test(d)) return n.each(function (e) {
      var t = n.eq(e);
      h && (r[0] = d.call(this, e, t.html())), He(t, r, i, o);
    });

    if (f && (t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild, 1 === e.childNodes.length && (e = t), t || o)) {
      for (s = (a = S.map(ye(e, "script"), De)).length; c < f; c++) {
        u = e, c !== p && (u = S.clone(u, !0, !0), s && S.merge(a, ye(u, "script"))), i.call(n[c], u, c);
      }

      if (s) for (l = a[a.length - 1].ownerDocument, S.map(a, qe), c = 0; c < s; c++) {
        u = a[c], he.test(u.type || "") && !Y.access(u, "globalEval") && S.contains(l, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? S._evalUrl && !u.noModule && S._evalUrl(u.src, {
          nonce: u.nonce || u.getAttribute("nonce")
        }, l) : b(u.textContent.replace(Ne, ""), u, l));
      }
    }

    return n;
  }

  function Oe(e, t, n) {
    for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
      n || 1 !== r.nodeType || S.cleanData(ye(r)), r.parentNode && (n && ie(r) && ve(ye(r, "script")), r.parentNode.removeChild(r));
    }

    return e;
  }

  S.extend({
    htmlPrefilter: function htmlPrefilter(e) {
      return e;
    },
    clone: function clone(e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = e.cloneNode(!0),
          f = ie(e);
      if (!(v.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || S.isXMLDoc(e))) for (a = ye(c), r = 0, i = (o = ye(e)).length; r < i; r++) {
        s = o[r], u = a[r], void 0, "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type) ? u.checked = s.checked : "input" !== l && "textarea" !== l || (u.defaultValue = s.defaultValue);
      }
      if (t) if (n) for (o = o || ye(e), a = a || ye(c), r = 0, i = o.length; r < i; r++) {
        Le(o[r], a[r]);
      } else Le(e, c);
      return 0 < (a = ye(c, "script")).length && ve(a, !f && ye(e, "script")), c;
    },
    cleanData: function cleanData(e) {
      for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++) {
        if (V(n)) {
          if (t = n[Y.expando]) {
            if (t.events) for (r in t.events) {
              i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
            }
            n[Y.expando] = void 0;
          }

          n[Q.expando] && (n[Q.expando] = void 0);
        }
      }
    }
  }), S.fn.extend({
    detach: function detach(e) {
      return Oe(this, e, !0);
    },
    remove: function remove(e) {
      return Oe(this, e);
    },
    text: function text(e) {
      return B(this, function (e) {
        return void 0 === e ? S.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
        });
      }, null, e, arguments.length);
    },
    append: function append() {
      return He(this, arguments, function (e) {
        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || je(this, e).appendChild(e);
      });
    },
    prepend: function prepend() {
      return He(this, arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var t = je(this, e);
          t.insertBefore(e, t.firstChild);
        }
      });
    },
    before: function before() {
      return He(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    },
    after: function after() {
      return He(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    },
    empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        1 === e.nodeType && (S.cleanData(ye(e, !1)), e.textContent = "");
      }

      return this;
    },
    clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return S.clone(this, e, t);
      });
    },
    html: function html(e) {
      return B(this, function (e) {
        var t = this[0] || {},
            n = 0,
            r = this.length;
        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;

        if ("string" == typeof e && !ke.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
          e = S.htmlPrefilter(e);

          try {
            for (; n < r; n++) {
              1 === (t = this[n] || {}).nodeType && (S.cleanData(ye(t, !1)), t.innerHTML = e);
            }

            t = 0;
          } catch (e) {}
        }

        t && this.empty().append(e);
      }, null, e, arguments.length);
    },
    replaceWith: function replaceWith() {
      var n = [];
      return He(this, arguments, function (e) {
        var t = this.parentNode;
        S.inArray(this, n) < 0 && (S.cleanData(ye(this)), t && t.replaceChild(e, this));
      }, n);
    }
  }), S.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (e, a) {
    S.fn[e] = function (e) {
      for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++) {
        t = o === i ? this : this.clone(!0), S(r[o])[a](t), u.apply(n, t.get());
      }

      return this.pushStack(n);
    };
  });

  var Pe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
      Re = /^--/,
      Me = function Me(e) {
    var t = e.ownerDocument.defaultView;
    return t && t.opener || (t = C), t.getComputedStyle(e);
  },
      Ie = function Ie(e, t, n) {
    var r,
        i,
        o = {};

    for (i in t) {
      o[i] = e.style[i], e.style[i] = t[i];
    }

    for (i in r = n.call(e), t) {
      e.style[i] = o[i];
    }

    return r;
  },
      We = new RegExp(ne.join("|"), "i"),
      Fe = "[\\x20\\t\\r\\n\\f]",
      $e = new RegExp("^" + Fe + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Fe + "+$", "g");

  function Be(e, t, n) {
    var r,
        i,
        o,
        a,
        s = Re.test(t),
        u = e.style;
    return (n = n || Me(e)) && (a = n.getPropertyValue(t) || n[t], s && a && (a = a.replace($e, "$1") || void 0), "" !== a || ie(e) || (a = S.style(e, t)), !v.pixelBoxStyles() && Pe.test(a) && We.test(t) && (r = u.width, i = u.minWidth, o = u.maxWidth, u.minWidth = u.maxWidth = u.width = a, a = n.width, u.width = r, u.minWidth = i, u.maxWidth = o)), void 0 !== a ? a + "" : a;
  }

  function _e(e, t) {
    return {
      get: function get() {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      }
    };
  }

  !function () {
    function e() {
      if (l) {
        u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", re.appendChild(u).appendChild(l);
        var e = C.getComputedStyle(l);
        n = "1%" !== e.top, s = 12 === t(e.marginLeft), l.style.right = "60%", o = 36 === t(e.right), r = 36 === t(e.width), l.style.position = "absolute", i = 12 === t(l.offsetWidth / 3), re.removeChild(u), l = null;
      }
    }

    function t(e) {
      return Math.round(parseFloat(e));
    }

    var n,
        r,
        i,
        o,
        a,
        s,
        u = E.createElement("div"),
        l = E.createElement("div");
    l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", v.clearCloneStyle = "content-box" === l.style.backgroundClip, S.extend(v, {
      boxSizingReliable: function boxSizingReliable() {
        return e(), r;
      },
      pixelBoxStyles: function pixelBoxStyles() {
        return e(), o;
      },
      pixelPosition: function pixelPosition() {
        return e(), n;
      },
      reliableMarginLeft: function reliableMarginLeft() {
        return e(), s;
      },
      scrollboxSize: function scrollboxSize() {
        return e(), i;
      },
      reliableTrDimensions: function reliableTrDimensions() {
        var e, t, n, r;
        return null == a && (e = E.createElement("table"), t = E.createElement("tr"), n = E.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", t.style.cssText = "border:1px solid", t.style.height = "1px", n.style.height = "9px", n.style.display = "block", re.appendChild(e).appendChild(t).appendChild(n), r = C.getComputedStyle(t), a = parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) === t.offsetHeight, re.removeChild(e)), a;
      }
    }));
  }();
  var ze = ["Webkit", "Moz", "ms"],
      Ue = E.createElement("div").style,
      Xe = {};

  function Ve(e) {
    var t = S.cssProps[e] || Xe[e];
    return t || (e in Ue ? e : Xe[e] = function (e) {
      var t = e[0].toUpperCase() + e.slice(1),
          n = ze.length;

      while (n--) {
        if ((e = ze[n] + t) in Ue) return e;
      }
    }(e) || e);
  }

  var Ge = /^(none|table(?!-c[ea]).+)/,
      Ye = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  },
      Qe = {
    letterSpacing: "0",
    fontWeight: "400"
  };

  function Je(e, t, n) {
    var r = te.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }

  function Ke(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
        s = 0,
        u = 0;
    if (n === (r ? "border" : "content")) return 0;

    for (; a < 4; a += 2) {
      "margin" === n && (u += S.css(e, n + ne[a], !0, i)), r ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)), "margin" !== n && (u -= S.css(e, "border" + ne[a] + "Width", !0, i))) : (u += S.css(e, "padding" + ne[a], !0, i), "padding" !== n ? u += S.css(e, "border" + ne[a] + "Width", !0, i) : s += S.css(e, "border" + ne[a] + "Width", !0, i));
    }

    return !r && 0 <= o && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u;
  }

  function Ze(e, t, n) {
    var r = Me(e),
        i = (!v.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r),
        o = i,
        a = Be(e, t, r),
        s = "offset" + t[0].toUpperCase() + t.slice(1);

    if (Pe.test(a)) {
      if (!n) return a;
      a = "auto";
    }

    return (!v.boxSizingReliable() && i || !v.reliableTrDimensions() && A(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === S.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === S.css(e, "boxSizing", !1, r), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + Ke(e, t, n || (i ? "border" : "content"), o, r, a) + "px";
  }

  function et(e, t, n, r, i) {
    return new et.prototype.init(e, t, n, r, i);
  }

  S.extend({
    cssHooks: {
      opacity: {
        get: function get(e, t) {
          if (t) {
            var n = Be(e, "opacity");
            return "" === n ? "1" : n;
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function style(e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
            o,
            a,
            s = X(t),
            u = Re.test(t),
            l = e.style;
        if (u || (t = Ve(s)), a = S.cssHooks[t] || S.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" === (o = _typeof(n)) && (i = te.exec(n)) && i[1] && (n = se(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (S.cssNumber[s] ? "" : "px")), v.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n));
      }
    },
    css: function css(e, t, n, r) {
      var i,
          o,
          a,
          s = X(t);
      return Re.test(t) || (t = Ve(s)), (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Be(e, t, r)), "normal" === i && t in Qe && (i = Qe[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
    }
  }), S.each(["height", "width"], function (e, u) {
    S.cssHooks[u] = {
      get: function get(e, t, n) {
        if (t) return !Ge.test(S.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Ze(e, u, n) : Ie(e, Ye, function () {
          return Ze(e, u, n);
        });
      },
      set: function set(e, t, n) {
        var r,
            i = Me(e),
            o = !v.scrollboxSize() && "absolute" === i.position,
            a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
            s = n ? Ke(e, u, n, a, i) : 0;
        return a && o && (s -= Math.ceil(e["offset" + u[0].toUpperCase() + u.slice(1)] - parseFloat(i[u]) - Ke(e, u, "border", !1, i) - .5)), s && (r = te.exec(t)) && "px" !== (r[3] || "px") && (e.style[u] = t, t = S.css(e, u)), Je(0, t, s);
      }
    };
  }), S.cssHooks.marginLeft = _e(v.reliableMarginLeft, function (e, t) {
    if (t) return (parseFloat(Be(e, "marginLeft")) || e.getBoundingClientRect().left - Ie(e, {
      marginLeft: 0
    }, function () {
      return e.getBoundingClientRect().left;
    })) + "px";
  }), S.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (i, o) {
    S.cssHooks[i + o] = {
      expand: function expand(e) {
        for (var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) {
          n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
        }

        return n;
      }
    }, "margin" !== i && (S.cssHooks[i + o].set = Je);
  }), S.fn.extend({
    css: function css(e, t) {
      return B(this, function (e, t, n) {
        var r,
            i,
            o = {},
            a = 0;

        if (Array.isArray(t)) {
          for (r = Me(e), i = t.length; a < i; a++) {
            o[t[a]] = S.css(e, t[a], !1, r);
          }

          return o;
        }

        return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
      }, e, t, 1 < arguments.length);
    }
  }), ((S.Tween = et).prototype = {
    constructor: et,
    init: function init(e, t, n, r, i, o) {
      this.elem = e, this.prop = n, this.easing = i || S.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (S.cssNumber[n] ? "" : "px");
    },
    cur: function cur() {
      var e = et.propHooks[this.prop];
      return e && e.get ? e.get(this) : et.propHooks._default.get(this);
    },
    run: function run(e) {
      var t,
          n = et.propHooks[this.prop];
      return this.options.duration ? this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : et.propHooks._default.set(this), this;
    }
  }).init.prototype = et.prototype, (et.propHooks = {
    _default: {
      get: function get(e) {
        var t;
        return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
      },
      set: function set(e) {
        S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !S.cssHooks[e.prop] && null == e.elem.style[Ve(e.prop)] ? e.elem[e.prop] = e.now : S.style(e.elem, e.prop, e.now + e.unit);
      }
    }
  }).scrollTop = et.propHooks.scrollLeft = {
    set: function set(e) {
      e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
    }
  }, S.easing = {
    linear: function linear(e) {
      return e;
    },
    swing: function swing(e) {
      return .5 - Math.cos(e * Math.PI) / 2;
    },
    _default: "swing"
  }, S.fx = et.prototype.init, S.fx.step = {};
  var tt,
      nt,
      rt,
      it,
      ot = /^(?:toggle|show|hide)$/,
      at = /queueHooks$/;

  function st() {
    nt && (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(st) : C.setTimeout(st, S.fx.interval), S.fx.tick());
  }

  function ut() {
    return C.setTimeout(function () {
      tt = void 0;
    }), tt = Date.now();
  }

  function lt(e, t) {
    var n,
        r = 0,
        i = {
      height: e
    };

    for (t = t ? 1 : 0; r < 4; r += 2 - t) {
      i["margin" + (n = ne[r])] = i["padding" + n] = e;
    }

    return t && (i.opacity = i.width = e), i;
  }

  function ct(e, t, n) {
    for (var r, i = (ft.tweeners[t] || []).concat(ft.tweeners["*"]), o = 0, a = i.length; o < a; o++) {
      if (r = i[o].call(n, t, e)) return r;
    }
  }

  function ft(o, e, t) {
    var n,
        a,
        r = 0,
        i = ft.prefilters.length,
        s = S.Deferred().always(function () {
      delete u.elem;
    }),
        u = function u() {
      if (a) return !1;

      for (var e = tt || ut(), t = Math.max(0, l.startTime + l.duration - e), n = 1 - (t / l.duration || 0), r = 0, i = l.tweens.length; r < i; r++) {
        l.tweens[r].run(n);
      }

      return s.notifyWith(o, [l, n, t]), n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1);
    },
        l = s.promise({
      elem: o,
      props: S.extend({}, e),
      opts: S.extend(!0, {
        specialEasing: {},
        easing: S.easing._default
      }, t),
      originalProperties: e,
      originalOptions: t,
      startTime: tt || ut(),
      duration: t.duration,
      tweens: [],
      createTween: function createTween(e, t) {
        var n = S.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing);
        return l.tweens.push(n), n;
      },
      stop: function stop(e) {
        var t = 0,
            n = e ? l.tweens.length : 0;
        if (a) return this;

        for (a = !0; t < n; t++) {
          l.tweens[t].run(1);
        }

        return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this;
      }
    }),
        c = l.props;

    for (!function (e, t) {
      var n, r, i, o, a;

      for (n in e) {
        if (i = t[r = X(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = S.cssHooks[r]) && ("expand" in a)) for (n in o = a.expand(o), delete e[r], o) {
          (n in e) || (e[n] = o[n], t[n] = i);
        } else t[r] = i;
      }
    }(c, l.opts.specialEasing); r < i; r++) {
      if (n = ft.prefilters[r].call(l, o, c, l.opts)) return m(n.stop) && (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
    }

    return S.map(c, ct, l), m(l.opts.start) && l.opts.start.call(o, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), S.fx.timer(S.extend(u, {
      elem: o,
      anim: l,
      queue: l.opts.queue
    })), l;
  }

  S.Animation = S.extend(ft, {
    tweeners: {
      "*": [function (e, t) {
        var n = this.createTween(e, t);
        return se(n.elem, e, te.exec(t), n), n;
      }]
    },
    tweener: function tweener(e, t) {
      m(e) ? (t = e, e = ["*"]) : e = e.match(P);

      for (var n, r = 0, i = e.length; r < i; r++) {
        n = e[r], ft.tweeners[n] = ft.tweeners[n] || [], ft.tweeners[n].unshift(t);
      }
    },
    prefilters: [function (e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = "width" in t || "height" in t,
          p = this,
          d = {},
          h = e.style,
          g = e.nodeType && ae(e),
          y = Y.get(e, "fxshow");

      for (r in n.queue || (null == (a = S._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
        a.unqueued || s();
      }), a.unqueued++, p.always(function () {
        p.always(function () {
          a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
        });
      })), t) {
        if (i = t[r], ot.test(i)) {
          if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
            if ("show" !== i || !y || void 0 === y[r]) continue;
            g = !0;
          }

          d[r] = y && y[r] || S.style(e, r);
        }
      }

      if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d)) for (r in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (l = y && y.display) && (l = Y.get(e, "display")), "none" === (c = S.css(e, "display")) && (l ? c = l : (le([e], !0), l = e.style.display || l, c = S.css(e, "display"), le([e]))), ("inline" === c || "inline-block" === c && null != l) && "none" === S.css(e, "float") && (u || (p.done(function () {
        h.display = l;
      }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function () {
        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
      })), u = !1, d) {
        u || (y ? "hidden" in y && (g = y.hidden) : y = Y.access(e, "fxshow", {
          display: l
        }), o && (y.hidden = !g), g && le([e], !0), p.done(function () {
          for (r in g || le([e]), Y.remove(e, "fxshow"), d) {
            S.style(e, r, d[r]);
          }
        })), u = ct(g ? y[r] : 0, r, p), r in y || (y[r] = u.start, g && (u.end = u.start, u.start = 0));
      }
    }],
    prefilter: function prefilter(e, t) {
      t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
    }
  }), S.speed = function (e, t, n) {
    var r = e && "object" == _typeof(e) ? S.extend({}, e) : {
      complete: n || !n && t || m(e) && e,
      duration: e,
      easing: n && t || t && !m(t) && t
    };
    return S.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in S.fx.speeds ? r.duration = S.fx.speeds[r.duration] : r.duration = S.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
      m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
    }, r;
  }, S.fn.extend({
    fadeTo: function fadeTo(e, t, n, r) {
      return this.filter(ae).css("opacity", 0).show().end().animate({
        opacity: t
      }, e, n, r);
    },
    animate: function animate(t, e, n, r) {
      var i = S.isEmptyObject(t),
          o = S.speed(e, n, r),
          a = function a() {
        var e = ft(this, S.extend({}, t), o);
        (i || Y.get(this, "finish")) && e.stop(!0);
      };

      return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
    },
    stop: function stop(i, e, o) {
      var a = function a(e) {
        var t = e.stop;
        delete e.stop, t(o);
      };

      return "string" != typeof i && (o = e, e = i, i = void 0), e && this.queue(i || "fx", []), this.each(function () {
        var e = !0,
            t = null != i && i + "queueHooks",
            n = S.timers,
            r = Y.get(this);
        if (t) r[t] && r[t].stop && a(r[t]);else for (t in r) {
          r[t] && r[t].stop && at.test(t) && a(r[t]);
        }

        for (t = n.length; t--;) {
          n[t].elem !== this || null != i && n[t].queue !== i || (n[t].anim.stop(o), e = !1, n.splice(t, 1));
        }

        !e && o || S.dequeue(this, i);
      });
    },
    finish: function finish(a) {
      return !1 !== a && (a = a || "fx"), this.each(function () {
        var e,
            t = Y.get(this),
            n = t[a + "queue"],
            r = t[a + "queueHooks"],
            i = S.timers,
            o = n ? n.length : 0;

        for (t.finish = !0, S.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length; e--;) {
          i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1));
        }

        for (e = 0; e < o; e++) {
          n[e] && n[e].finish && n[e].finish.call(this);
        }

        delete t.finish;
      });
    }
  }), S.each(["toggle", "show", "hide"], function (e, r) {
    var i = S.fn[r];

    S.fn[r] = function (e, t, n) {
      return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(lt(r, !0), e, t, n);
    };
  }), S.each({
    slideDown: lt("show"),
    slideUp: lt("hide"),
    slideToggle: lt("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (e, r) {
    S.fn[e] = function (e, t, n) {
      return this.animate(r, e, t, n);
    };
  }), S.timers = [], S.fx.tick = function () {
    var e,
        t = 0,
        n = S.timers;

    for (tt = Date.now(); t < n.length; t++) {
      (e = n[t])() || n[t] !== e || n.splice(t--, 1);
    }

    n.length || S.fx.stop(), tt = void 0;
  }, S.fx.timer = function (e) {
    S.timers.push(e), S.fx.start();
  }, S.fx.interval = 13, S.fx.start = function () {
    nt || (nt = !0, st());
  }, S.fx.stop = function () {
    nt = null;
  }, S.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  }, S.fn.delay = function (r, e) {
    return r = S.fx && S.fx.speeds[r] || r, e = e || "fx", this.queue(e, function (e, t) {
      var n = C.setTimeout(e, r);

      t.stop = function () {
        C.clearTimeout(n);
      };
    });
  }, rt = E.createElement("input"), it = E.createElement("select").appendChild(E.createElement("option")), rt.type = "checkbox", v.checkOn = "" !== rt.value, v.optSelected = it.selected, (rt = E.createElement("input")).value = "t", rt.type = "radio", v.radioValue = "t" === rt.value;
  var pt,
      dt = S.expr.attrHandle;
  S.fn.extend({
    attr: function attr(e, t) {
      return B(this, S.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function removeAttr(e) {
      return this.each(function () {
        S.removeAttr(this, e);
      });
    }
  }), S.extend({
    attr: function attr(e, t, n) {
      var r,
          i,
          o = e.nodeType;
      if (3 !== o && 8 !== o && 2 !== o) return "undefined" == typeof e.getAttribute ? S.prop(e, t, n) : (1 === o && S.isXMLDoc(e) || (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? pt : void 0)), void 0 !== n ? null === n ? void S.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = S.find.attr(e, t)) ? void 0 : r);
    },
    attrHooks: {
      type: {
        set: function set(e, t) {
          if (!v.radioValue && "radio" === t && A(e, "input")) {
            var n = e.value;
            return e.setAttribute("type", t), n && (e.value = n), t;
          }
        }
      }
    },
    removeAttr: function removeAttr(e, t) {
      var n,
          r = 0,
          i = t && t.match(P);
      if (i && 1 === e.nodeType) while (n = i[r++]) {
        e.removeAttribute(n);
      }
    }
  }), pt = {
    set: function set(e, t, n) {
      return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
    }
  }, S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
    var a = dt[t] || S.find.attr;

    dt[t] = function (e, t, n) {
      var r,
          i,
          o = t.toLowerCase();
      return n || (i = dt[o], dt[o] = r, r = null != a(e, t, n) ? o : null, dt[o] = i), r;
    };
  });
  var ht = /^(?:input|select|textarea|button)$/i,
      gt = /^(?:a|area)$/i;

  function yt(e) {
    return (e.match(P) || []).join(" ");
  }

  function vt(e) {
    return e.getAttribute && e.getAttribute("class") || "";
  }

  function mt(e) {
    return Array.isArray(e) ? e : "string" == typeof e && e.match(P) || [];
  }

  S.fn.extend({
    prop: function prop(e, t) {
      return B(this, S.prop, e, t, 1 < arguments.length);
    },
    removeProp: function removeProp(e) {
      return this.each(function () {
        delete this[S.propFix[e] || e];
      });
    }
  }), S.extend({
    prop: function prop(e, t, n) {
      var r,
          i,
          o = e.nodeType;
      if (3 !== o && 8 !== o && 2 !== o) return 1 === o && S.isXMLDoc(e) || (t = S.propFix[t] || t, i = S.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
    },
    propHooks: {
      tabIndex: {
        get: function get(e) {
          var t = S.find.attr(e, "tabindex");
          return t ? parseInt(t, 10) : ht.test(e.nodeName) || gt.test(e.nodeName) && e.href ? 0 : -1;
        }
      }
    },
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  }), v.optSelected || (S.propHooks.selected = {
    get: function get(e) {
      var t = e.parentNode;
      return t && t.parentNode && t.parentNode.selectedIndex, null;
    },
    set: function set(e) {
      var t = e.parentNode;
      t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
    }
  }), S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    S.propFix[this.toLowerCase()] = this;
  }), S.fn.extend({
    addClass: function addClass(t) {
      var e, n, r, i, o, a;
      return m(t) ? this.each(function (e) {
        S(this).addClass(t.call(this, e, vt(this)));
      }) : (e = mt(t)).length ? this.each(function () {
        if (r = vt(this), n = 1 === this.nodeType && " " + yt(r) + " ") {
          for (o = 0; o < e.length; o++) {
            i = e[o], n.indexOf(" " + i + " ") < 0 && (n += i + " ");
          }

          a = yt(n), r !== a && this.setAttribute("class", a);
        }
      }) : this;
    },
    removeClass: function removeClass(t) {
      var e, n, r, i, o, a;
      return m(t) ? this.each(function (e) {
        S(this).removeClass(t.call(this, e, vt(this)));
      }) : arguments.length ? (e = mt(t)).length ? this.each(function () {
        if (r = vt(this), n = 1 === this.nodeType && " " + yt(r) + " ") {
          for (o = 0; o < e.length; o++) {
            i = e[o];

            while (-1 < n.indexOf(" " + i + " ")) {
              n = n.replace(" " + i + " ", " ");
            }
          }

          a = yt(n), r !== a && this.setAttribute("class", a);
        }
      }) : this : this.attr("class", "");
    },
    toggleClass: function toggleClass(t, n) {
      var e,
          r,
          i,
          o,
          a = _typeof(t),
          s = "string" === a || Array.isArray(t);

      return m(t) ? this.each(function (e) {
        S(this).toggleClass(t.call(this, e, vt(this), n), n);
      }) : "boolean" == typeof n && s ? n ? this.addClass(t) : this.removeClass(t) : (e = mt(t), this.each(function () {
        if (s) for (o = S(this), i = 0; i < e.length; i++) {
          r = e[i], o.hasClass(r) ? o.removeClass(r) : o.addClass(r);
        } else void 0 !== t && "boolean" !== a || ((r = vt(this)) && Y.set(this, "__className__", r), this.setAttribute && this.setAttribute("class", r || !1 === t ? "" : Y.get(this, "__className__") || ""));
      }));
    },
    hasClass: function hasClass(e) {
      var t,
          n,
          r = 0;
      t = " " + e + " ";

      while (n = this[r++]) {
        if (1 === n.nodeType && -1 < (" " + yt(vt(n)) + " ").indexOf(t)) return !0;
      }

      return !1;
    }
  });
  var xt = /\r/g;
  S.fn.extend({
    val: function val(n) {
      var r,
          e,
          i,
          t = this[0];
      return arguments.length ? (i = m(n), this.each(function (e) {
        var t;
        1 === this.nodeType && (null == (t = i ? n.call(this, e, S(this).val()) : n) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = S.map(t, function (e) {
          return null == e ? "" : e + "";
        })), (r = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in r && void 0 !== r.set(this, t, "value") || (this.value = t));
      })) : t ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) && "get" in r && void 0 !== (e = r.get(t, "value")) ? e : "string" == typeof (e = t.value) ? e.replace(xt, "") : null == e ? "" : e : void 0;
    }
  }), S.extend({
    valHooks: {
      option: {
        get: function get(e) {
          var t = S.find.attr(e, "value");
          return null != t ? t : yt(S.text(e));
        }
      },
      select: {
        get: function get(e) {
          var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;

          for (r = o < 0 ? u : a ? o : 0; r < u; r++) {
            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) {
              if (t = S(n).val(), a) return t;
              s.push(t);
            }
          }

          return s;
        },
        set: function set(e, t) {
          var n,
              r,
              i = e.options,
              o = S.makeArray(t),
              a = i.length;

          while (a--) {
            ((r = i[a]).selected = -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
          }

          return n || (e.selectedIndex = -1), o;
        }
      }
    }
  }), S.each(["radio", "checkbox"], function () {
    S.valHooks[this] = {
      set: function set(e, t) {
        if (Array.isArray(t)) return e.checked = -1 < S.inArray(S(e).val(), t);
      }
    }, v.checkOn || (S.valHooks[this].get = function (e) {
      return null === e.getAttribute("value") ? "on" : e.value;
    });
  }), v.focusin = "onfocusin" in C;

  var bt = /^(?:focusinfocus|focusoutblur)$/,
      wt = function wt(e) {
    e.stopPropagation();
  };

  S.extend(S.event, {
    trigger: function trigger(e, t, n, r) {
      var i,
          o,
          a,
          s,
          u,
          l,
          c,
          f,
          p = [n || E],
          d = y.call(e, "type") ? e.type : e,
          h = y.call(e, "namespace") ? e.namespace.split(".") : [];

      if (o = f = a = n = n || E, 3 !== n.nodeType && 8 !== n.nodeType && !bt.test(d + S.event.triggered) && (-1 < d.indexOf(".") && (d = (h = d.split(".")).shift(), h.sort()), u = d.indexOf(":") < 0 && "on" + d, (e = e[S.expando] ? e : new S.Event(d, "object" == _typeof(e) && e)).isTrigger = r ? 2 : 3, e.namespace = h.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : S.makeArray(t, [e]), c = S.event.special[d] || {}, r || !c.trigger || !1 !== c.trigger.apply(n, t))) {
        if (!r && !c.noBubble && !x(n)) {
          for (s = c.delegateType || d, bt.test(s + d) || (o = o.parentNode); o; o = o.parentNode) {
            p.push(o), a = o;
          }

          a === (n.ownerDocument || E) && p.push(a.defaultView || a.parentWindow || C);
        }

        i = 0;

        while ((o = p[i++]) && !e.isPropagationStopped()) {
          f = o, e.type = 1 < i ? s : c.bindType || d, (l = (Y.get(o, "events") || Object.create(null))[e.type] && Y.get(o, "handle")) && l.apply(o, t), (l = u && o[u]) && l.apply && V(o) && (e.result = l.apply(o, t), !1 === e.result && e.preventDefault());
        }

        return e.type = d, r || e.isDefaultPrevented() || c._default && !1 !== c._default.apply(p.pop(), t) || !V(n) || u && m(n[d]) && !x(n) && ((a = n[u]) && (n[u] = null), S.event.triggered = d, e.isPropagationStopped() && f.addEventListener(d, wt), n[d](), e.isPropagationStopped() && f.removeEventListener(d, wt), S.event.triggered = void 0, a && (n[u] = a)), e.result;
      }
    },
    simulate: function simulate(e, t, n) {
      var r = S.extend(new S.Event(), n, {
        type: e,
        isSimulated: !0
      });
      S.event.trigger(r, null, t);
    }
  }), S.fn.extend({
    trigger: function trigger(e, t) {
      return this.each(function () {
        S.event.trigger(e, t, this);
      });
    },
    triggerHandler: function triggerHandler(e, t) {
      var n = this[0];
      if (n) return S.event.trigger(e, t, n, !0);
    }
  }), v.focusin || S.each({
    focus: "focusin",
    blur: "focusout"
  }, function (n, r) {
    var i = function i(e) {
      S.event.simulate(r, e.target, S.event.fix(e));
    };

    S.event.special[r] = {
      setup: function setup() {
        var e = this.ownerDocument || this.document || this,
            t = Y.access(e, r);
        t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
      },
      teardown: function teardown() {
        var e = this.ownerDocument || this.document || this,
            t = Y.access(e, r) - 1;
        t ? Y.access(e, r, t) : (e.removeEventListener(n, i, !0), Y.remove(e, r));
      }
    };
  });
  var Tt = C.location,
      Ct = {
    guid: Date.now()
  },
      Et = /\?/;

  S.parseXML = function (e) {
    var t, n;
    if (!e || "string" != typeof e) return null;

    try {
      t = new C.DOMParser().parseFromString(e, "text/xml");
    } catch (e) {}

    return n = t && t.getElementsByTagName("parsererror")[0], t && !n || S.error("Invalid XML: " + (n ? S.map(n.childNodes, function (e) {
      return e.textContent;
    }).join("\n") : e)), t;
  };

  var St = /\[\]$/,
      kt = /\r?\n/g,
      At = /^(?:submit|button|image|reset|file)$/i,
      Nt = /^(?:input|select|textarea|keygen)/i;

  function jt(n, e, r, i) {
    var t;
    if (Array.isArray(e)) S.each(e, function (e, t) {
      r || St.test(n) ? i(n, t) : jt(n + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]", t, r, i);
    });else if (r || "object" !== w(e)) i(n, e);else for (t in e) {
      jt(n + "[" + t + "]", e[t], r, i);
    }
  }

  S.param = function (e, t) {
    var n,
        r = [],
        i = function i(e, t) {
      var n = m(t) ? t() : t;
      r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
    };

    if (null == e) return "";
    if (Array.isArray(e) || e.jquery && !S.isPlainObject(e)) S.each(e, function () {
      i(this.name, this.value);
    });else for (n in e) {
      jt(n, e[n], t, i);
    }
    return r.join("&");
  }, S.fn.extend({
    serialize: function serialize() {
      return S.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        var e = S.prop(this, "elements");
        return e ? S.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;
        return this.name && !S(this).is(":disabled") && Nt.test(this.nodeName) && !At.test(e) && (this.checked || !pe.test(e));
      }).map(function (e, t) {
        var n = S(this).val();
        return null == n ? null : Array.isArray(n) ? S.map(n, function (e) {
          return {
            name: t.name,
            value: e.replace(kt, "\r\n")
          };
        }) : {
          name: t.name,
          value: n.replace(kt, "\r\n")
        };
      }).get();
    }
  });
  var Dt = /%20/g,
      qt = /#.*$/,
      Lt = /([?&])_=[^&]*/,
      Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Ot = /^(?:GET|HEAD)$/,
      Pt = /^\/\//,
      Rt = {},
      Mt = {},
      It = "*/".concat("*"),
      Wt = E.createElement("a");

  function Ft(o) {
    return function (e, t) {
      "string" != typeof e && (t = e, e = "*");
      var n,
          r = 0,
          i = e.toLowerCase().match(P) || [];
      if (m(t)) while (n = i[r++]) {
        "+" === n[0] ? (n = n.slice(1) || "*", (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t);
      }
    };
  }

  function $t(t, i, o, a) {
    var s = {},
        u = t === Mt;

    function l(e) {
      var r;
      return s[e] = !0, S.each(t[e] || [], function (e, t) {
        var n = t(i, o, a);
        return "string" != typeof n || u || s[n] ? u ? !(r = n) : void 0 : (i.dataTypes.unshift(n), l(n), !1);
      }), r;
    }

    return l(i.dataTypes[0]) || !s["*"] && l("*");
  }

  function Bt(e, t) {
    var n,
        r,
        i = S.ajaxSettings.flatOptions || {};

    for (n in t) {
      void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    }

    return r && S.extend(!0, e, r), e;
  }

  Wt.href = Tt.href, S.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Tt.href,
      type: "GET",
      isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": It,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": S.parseXML
      },
      flatOptions: {
        url: !0,
        context: !0
      }
    },
    ajaxSetup: function ajaxSetup(e, t) {
      return t ? Bt(Bt(e, S.ajaxSettings), t) : Bt(S.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(Rt),
    ajaxTransport: Ft(Mt),
    ajax: function ajax(e, t) {
      "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
      var c,
          f,
          p,
          n,
          d,
          r,
          h,
          g,
          i,
          o,
          y = S.ajaxSetup({}, t),
          v = y.context || y,
          m = y.context && (v.nodeType || v.jquery) ? S(v) : S.event,
          x = S.Deferred(),
          b = S.Callbacks("once memory"),
          w = y.statusCode || {},
          a = {},
          s = {},
          u = "canceled",
          T = {
        readyState: 0,
        getResponseHeader: function getResponseHeader(e) {
          var t;

          if (h) {
            if (!n) {
              n = {};

              while (t = Ht.exec(p)) {
                n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
              }
            }

            t = n[e.toLowerCase() + " "];
          }

          return null == t ? null : t.join(", ");
        },
        getAllResponseHeaders: function getAllResponseHeaders() {
          return h ? p : null;
        },
        setRequestHeader: function setRequestHeader(e, t) {
          return null == h && (e = s[e.toLowerCase()] = s[e.toLowerCase()] || e, a[e] = t), this;
        },
        overrideMimeType: function overrideMimeType(e) {
          return null == h && (y.mimeType = e), this;
        },
        statusCode: function statusCode(e) {
          var t;
          if (e) if (h) T.always(e[T.status]);else for (t in e) {
            w[t] = [w[t], e[t]];
          }
          return this;
        },
        abort: function abort(e) {
          var t = e || u;
          return c && c.abort(t), l(0, t), this;
        }
      };

      if (x.promise(T), y.url = ((e || y.url || Tt.href) + "").replace(Pt, Tt.protocol + "//"), y.type = t.method || t.type || y.method || y.type, y.dataTypes = (y.dataType || "*").toLowerCase().match(P) || [""], null == y.crossDomain) {
        r = E.createElement("a");

        try {
          r.href = y.url, r.href = r.href, y.crossDomain = Wt.protocol + "//" + Wt.host != r.protocol + "//" + r.host;
        } catch (e) {
          y.crossDomain = !0;
        }
      }

      if (y.data && y.processData && "string" != typeof y.data && (y.data = S.param(y.data, y.traditional)), $t(Rt, y, t, T), h) return T;

      for (i in (g = S.event && y.global) && 0 == S.active++ && S.event.trigger("ajaxStart"), y.type = y.type.toUpperCase(), y.hasContent = !Ot.test(y.type), f = y.url.replace(qt, ""), y.hasContent ? y.data && y.processData && 0 === (y.contentType || "").indexOf("application/x-www-form-urlencoded") && (y.data = y.data.replace(Dt, "+")) : (o = y.url.slice(f.length), y.data && (y.processData || "string" == typeof y.data) && (f += (Et.test(f) ? "&" : "?") + y.data, delete y.data), !1 === y.cache && (f = f.replace(Lt, "$1"), o = (Et.test(f) ? "&" : "?") + "_=" + Ct.guid++ + o), y.url = f + o), y.ifModified && (S.lastModified[f] && T.setRequestHeader("If-Modified-Since", S.lastModified[f]), S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])), (y.data && y.hasContent && !1 !== y.contentType || t.contentType) && T.setRequestHeader("Content-Type", y.contentType), T.setRequestHeader("Accept", y.dataTypes[0] && y.accepts[y.dataTypes[0]] ? y.accepts[y.dataTypes[0]] + ("*" !== y.dataTypes[0] ? ", " + It + "; q=0.01" : "") : y.accepts["*"]), y.headers) {
        T.setRequestHeader(i, y.headers[i]);
      }

      if (y.beforeSend && (!1 === y.beforeSend.call(v, T, y) || h)) return T.abort();

      if (u = "abort", b.add(y.complete), T.done(y.success), T.fail(y.error), c = $t(Mt, y, t, T)) {
        if (T.readyState = 1, g && m.trigger("ajaxSend", [T, y]), h) return T;
        y.async && 0 < y.timeout && (d = C.setTimeout(function () {
          T.abort("timeout");
        }, y.timeout));

        try {
          h = !1, c.send(a, l);
        } catch (e) {
          if (h) throw e;
          l(-1, e);
        }
      } else l(-1, "No Transport");

      function l(e, t, n, r) {
        var i,
            o,
            a,
            s,
            u,
            l = t;
        h || (h = !0, d && C.clearTimeout(d), c = void 0, p = r || "", T.readyState = 0 < e ? 4 : 0, i = 200 <= e && e < 300 || 304 === e, n && (s = function (e, t, n) {
          var r,
              i,
              o,
              a,
              s = e.contents,
              u = e.dataTypes;

          while ("*" === u[0]) {
            u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
          }

          if (r) for (i in s) {
            if (s[i] && s[i].test(r)) {
              u.unshift(i);
              break;
            }
          }
          if (u[0] in n) o = u[0];else {
            for (i in n) {
              if (!u[0] || e.converters[i + " " + u[0]]) {
                o = i;
                break;
              }

              a || (a = i);
            }

            o = o || a;
          }
          if (o) return o !== u[0] && u.unshift(o), n[o];
        }(y, T, n)), !i && -1 < S.inArray("script", y.dataTypes) && S.inArray("json", y.dataTypes) < 0 && (y.converters["text script"] = function () {}), s = function (e, t, n, r) {
          var i,
              o,
              a,
              s,
              u,
              l = {},
              c = e.dataTypes.slice();
          if (c[1]) for (a in e.converters) {
            l[a.toLowerCase()] = e.converters[a];
          }
          o = c.shift();

          while (o) {
            if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
              if (!(a = l[u + " " + o] || l["* " + o])) for (i in l) {
                if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                  !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1]));
                  break;
                }
              }
              if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
                t = a(t);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: a ? e : "No conversion from " + u + " to " + o
                };
              }
            }
          }

          return {
            state: "success",
            data: t
          };
        }(y, s, T, i), i ? (y.ifModified && ((u = T.getResponseHeader("Last-Modified")) && (S.lastModified[f] = u), (u = T.getResponseHeader("etag")) && (S.etag[f] = u)), 204 === e || "HEAD" === y.type ? l = "nocontent" : 304 === e ? l = "notmodified" : (l = s.state, o = s.data, i = !(a = s.error))) : (a = l, !e && l || (l = "error", e < 0 && (e = 0))), T.status = e, T.statusText = (t || l) + "", i ? x.resolveWith(v, [o, l, T]) : x.rejectWith(v, [T, l, a]), T.statusCode(w), w = void 0, g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, y, i ? o : a]), b.fireWith(v, [T, l]), g && (m.trigger("ajaxComplete", [T, y]), --S.active || S.event.trigger("ajaxStop")));
      }

      return T;
    },
    getJSON: function getJSON(e, t, n) {
      return S.get(e, t, n, "json");
    },
    getScript: function getScript(e, t) {
      return S.get(e, void 0, t, "script");
    }
  }), S.each(["get", "post"], function (e, i) {
    S[i] = function (e, t, n, r) {
      return m(t) && (r = r || n, n = t, t = void 0), S.ajax(S.extend({
        url: e,
        type: i,
        dataType: r,
        data: t,
        success: n
      }, S.isPlainObject(e) && e));
    };
  }), S.ajaxPrefilter(function (e) {
    var t;

    for (t in e.headers) {
      "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
    }
  }), S._evalUrl = function (e, t, n) {
    return S.ajax({
      url: e,
      type: "GET",
      dataType: "script",
      cache: !0,
      async: !1,
      global: !1,
      converters: {
        "text script": function textScript() {}
      },
      dataFilter: function dataFilter(e) {
        S.globalEval(e, t, n);
      }
    });
  }, S.fn.extend({
    wrapAll: function wrapAll(e) {
      var t;
      return this[0] && (m(e) && (e = e.call(this[0])), t = S(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        var e = this;

        while (e.firstElementChild) {
          e = e.firstElementChild;
        }

        return e;
      }).append(this)), this;
    },
    wrapInner: function wrapInner(n) {
      return m(n) ? this.each(function (e) {
        S(this).wrapInner(n.call(this, e));
      }) : this.each(function () {
        var e = S(this),
            t = e.contents();
        t.length ? t.wrapAll(n) : e.append(n);
      });
    },
    wrap: function wrap(t) {
      var n = m(t);
      return this.each(function (e) {
        S(this).wrapAll(n ? t.call(this, e) : t);
      });
    },
    unwrap: function unwrap(e) {
      return this.parent(e).not("body").each(function () {
        S(this).replaceWith(this.childNodes);
      }), this;
    }
  }), S.expr.pseudos.hidden = function (e) {
    return !S.expr.pseudos.visible(e);
  }, S.expr.pseudos.visible = function (e) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }, S.ajaxSettings.xhr = function () {
    try {
      return new C.XMLHttpRequest();
    } catch (e) {}
  };
  var _t = {
    0: 200,
    1223: 204
  },
      zt = S.ajaxSettings.xhr();
  v.cors = !!zt && "withCredentials" in zt, v.ajax = zt = !!zt, S.ajaxTransport(function (i) {
    var _o, a;

    if (v.cors || zt && !i.crossDomain) return {
      send: function send(e, t) {
        var n,
            r = i.xhr();
        if (r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields) for (n in i.xhrFields) {
          r[n] = i.xhrFields[n];
        }

        for (n in i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType), i.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e) {
          r.setRequestHeader(n, e[n]);
        }

        _o = function o(e) {
          return function () {
            _o && (_o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null, "abort" === e ? r.abort() : "error" === e ? "number" != typeof r.status ? t(0, "error") : t(r.status, r.statusText) : t(_t[r.status] || r.status, r.statusText, "text" !== (r.responseType || "text") || "string" != typeof r.responseText ? {
              binary: r.response
            } : {
              text: r.responseText
            }, r.getAllResponseHeaders()));
          };
        }, r.onload = _o(), a = r.onerror = r.ontimeout = _o("error"), void 0 !== r.onabort ? r.onabort = a : r.onreadystatechange = function () {
          4 === r.readyState && C.setTimeout(function () {
            _o && a();
          });
        }, _o = _o("abort");

        try {
          r.send(i.hasContent && i.data || null);
        } catch (e) {
          if (_o) throw e;
        }
      },
      abort: function abort() {
        _o && _o();
      }
    };
  }), S.ajaxPrefilter(function (e) {
    e.crossDomain && (e.contents.script = !1);
  }), S.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function textScript(e) {
        return S.globalEval(e), e;
      }
    }
  }), S.ajaxPrefilter("script", function (e) {
    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
  }), S.ajaxTransport("script", function (n) {
    var r, _i;

    if (n.crossDomain || n.scriptAttrs) return {
      send: function send(e, t) {
        r = S("<script>").attr(n.scriptAttrs || {}).prop({
          charset: n.scriptCharset,
          src: n.url
        }).on("load error", _i = function i(e) {
          r.remove(), _i = null, e && t("error" === e.type ? 404 : 200, e.type);
        }), E.head.appendChild(r[0]);
      },
      abort: function abort() {
        _i && _i();
      }
    };
  });
  var Ut,
      Xt = [],
      Vt = /(=)\?(?=&|$)|\?\?/;
  S.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var e = Xt.pop() || S.expando + "_" + Ct.guid++;
      return this[e] = !0, e;
    }
  }), S.ajaxPrefilter("json jsonp", function (e, t, n) {
    var r,
        i,
        o,
        a = !1 !== e.jsonp && (Vt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Vt.test(e.data) && "data");
    if (a || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Vt, "$1" + r) : !1 !== e.jsonp && (e.url += (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () {
      return o || S.error(r + " was not called"), o[0];
    }, e.dataTypes[0] = "json", i = C[r], C[r] = function () {
      o = arguments;
    }, n.always(function () {
      void 0 === i ? S(C).removeProp(r) : C[r] = i, e[r] && (e.jsonpCallback = t.jsonpCallback, Xt.push(r)), o && m(i) && i(o[0]), o = i = void 0;
    }), "script";
  }), v.createHTMLDocument = ((Ut = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Ut.childNodes.length), S.parseHTML = function (e, t, n) {
    return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (v.createHTMLDocument ? ((r = (t = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href, t.head.appendChild(r)) : t = E), o = !n && [], (i = N.exec(e)) ? [t.createElement(i[1])] : (i = xe([e], t, o), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
    var r, i, o;
  }, S.fn.load = function (e, t, n) {
    var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
    return -1 < s && (r = yt(e.slice(s)), e = e.slice(0, s)), m(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (i = "POST"), 0 < a.length && S.ajax({
      url: e,
      type: i || "GET",
      dataType: "html",
      data: t
    }).done(function (e) {
      o = arguments, a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
    }).always(n && function (e, t) {
      a.each(function () {
        n.apply(this, o || [e.responseText, t, e]);
      });
    }), this;
  }, S.expr.pseudos.animated = function (t) {
    return S.grep(S.timers, function (e) {
      return t === e.elem;
    }).length;
  }, S.offset = {
    setOffset: function setOffset(e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u,
          l = S.css(e, "position"),
          c = S(e),
          f = {};
      "static" === l && (e.style.position = "relative"), s = c.offset(), o = S.css(e, "top"), u = S.css(e, "left"), ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto") ? (a = (r = c.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), m(t) && (t = t.call(e, n, S.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : c.css(f);
    }
  }, S.fn.extend({
    offset: function offset(t) {
      if (arguments.length) return void 0 === t ? this : this.each(function (e) {
        S.offset.setOffset(this, t, e);
      });
      var e,
          n,
          r = this[0];
      return r ? r.getClientRects().length ? (e = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
        top: e.top + n.pageYOffset,
        left: e.left + n.pageXOffset
      }) : {
        top: 0,
        left: 0
      } : void 0;
    },
    position: function position() {
      if (this[0]) {
        var e,
            t,
            n,
            r = this[0],
            i = {
          top: 0,
          left: 0
        };
        if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();else {
          t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;

          while (e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position")) {
            e = e.parentNode;
          }

          e && e !== r && 1 === e.nodeType && ((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0), i.left += S.css(e, "borderLeftWidth", !0));
        }
        return {
          top: t.top - i.top - S.css(r, "marginTop", !0),
          left: t.left - i.left - S.css(r, "marginLeft", !0)
        };
      }
    },
    offsetParent: function offsetParent() {
      return this.map(function () {
        var e = this.offsetParent;

        while (e && "static" === S.css(e, "position")) {
          e = e.offsetParent;
        }

        return e || re;
      });
    }
  }), S.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (t, i) {
    var o = "pageYOffset" === i;

    S.fn[t] = function (e) {
      return B(this, function (e, t, n) {
        var r;
        if (x(e) ? r = e : 9 === e.nodeType && (r = e.defaultView), void 0 === n) return r ? r[i] : e[t];
        r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : e[t] = n;
      }, t, e, arguments.length);
    };
  }), S.each(["top", "left"], function (e, n) {
    S.cssHooks[n] = _e(v.pixelPosition, function (e, t) {
      if (t) return t = Be(e, n), Pe.test(t) ? S(e).position()[n] + "px" : t;
    });
  }), S.each({
    Height: "height",
    Width: "width"
  }, function (a, s) {
    S.each({
      padding: "inner" + a,
      content: s,
      "": "outer" + a
    }, function (r, o) {
      S.fn[o] = function (e, t) {
        var n = arguments.length && (r || "boolean" != typeof e),
            i = r || (!0 === e || !0 === t ? "margin" : "border");
        return B(this, function (e, t, n) {
          var r;
          return x(e) ? 0 === o.indexOf("outer") ? e["inner" + a] : e.document.documentElement["client" + a] : 9 === e.nodeType ? (r = e.documentElement, Math.max(e.body["scroll" + a], r["scroll" + a], e.body["offset" + a], r["offset" + a], r["client" + a])) : void 0 === n ? S.css(e, t, i) : S.style(e, t, n, i);
        }, s, n ? e : void 0, n);
      };
    });
  }), S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
    S.fn[t] = function (e) {
      return this.on(t, e);
    };
  }), S.fn.extend({
    bind: function bind(e, t, n) {
      return this.on(e, null, t, n);
    },
    unbind: function unbind(e, t) {
      return this.off(e, null, t);
    },
    delegate: function delegate(e, t, n, r) {
      return this.on(t, e, n, r);
    },
    undelegate: function undelegate(e, t, n) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
    },
    hover: function hover(e, t) {
      return this.mouseenter(e).mouseleave(t || e);
    }
  }), S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, n) {
    S.fn[n] = function (e, t) {
      return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
    };
  });
  var Gt = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
  S.proxy = function (e, t) {
    var n, r, i;
    if ("string" == typeof t && (n = e[t], t = e, e = n), m(e)) return r = s.call(arguments, 2), (i = function i() {
      return e.apply(t || this, r.concat(s.call(arguments)));
    }).guid = e.guid = e.guid || S.guid++, i;
  }, S.holdReady = function (e) {
    e ? S.readyWait++ : S.ready(!0);
  }, S.isArray = Array.isArray, S.parseJSON = JSON.parse, S.nodeName = A, S.isFunction = m, S.isWindow = x, S.camelCase = X, S.type = w, S.now = Date.now, S.isNumeric = function (e) {
    var t = S.type(e);
    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
  }, S.trim = function (e) {
    return null == e ? "" : (e + "").replace(Gt, "$1");
  }, "function" == typeof define && define.amd && define("jquery", [], function () {
    return S;
  });
  var Yt = C.jQuery,
      Qt = C.$;
  return S.noConflict = function (e) {
    return C.$ === S && (C.$ = Qt), e && C.jQuery === S && (C.jQuery = Yt), S;
  }, "undefined" == typeof e && (C.jQuery = C.$ = S), S;
});

},{}],227:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * -----------------------------------------------------------------------------
 *                              PasswordStrength
 * -----------------------------------------------------------------------------
 */

/**
 * PasswordStrength method.
 *
 * This acts as an interface for interacting with _PWS instances.
 * Each [data-pws] input has it's own _PWS instance for managing it's password
 * strength information.
 *
 * @param {String, HtmlElement} selector A selector for the data-pws password
 *                                       input (String) or the element itself.
 *
 * @return {_PWS} The target _PWS instance.
 */
function PasswordStrength(selector) {
  // If no selector is provided, warn the user and exit early.
  if (selector == null && selector == undefined) {
    PWS.warn("Did you mean to pass in a selector to PasswordStrength()?");
    return;
  }
  /**
   * A private method which returns the target _PWS instance.
   *
   * 1. If the selector is a String, select all _PWS instances where the
   *    password input matches the selector.
   *
   * 2. If the selector id an HtmlElement, select all _PWS instances where the
   *    password input is the same as the selector HtmlElement.
   *
   * 3. If the selector is neither a String nor HtmlElement, warn the user and
   *    exit early.
   *
   * 4. If there is at least one matching _PWS instance, return the first
   *    match.
   *
   * 5. If there are no _PWS instances matching the selector, see if we need
   *    to instantiate a new _PWS instance and return it.
   */


  function selected_PWS() {
    var target_PWS;

    if (typeof selector == "string") {
      // [1]
      target_PWS = PasswordStrength._PWSArray.filter(function (_PWS) {
        return _PWS.password.elem.matches(selector);
      });
    } else if (selector instanceof HTMLElement) {
      // [2]
      target_PWS = PasswordStrength._PWSArray.filter(function (_PWS) {
        return _PWS.password.elem == selector;
      });
    } else {
      // [3]
      PWS.warn("Selector must be of type String or HtmlElement. " + "Instead found '" + _typeof(selector) + "'.", selector);
      return;
    }

    return target_PWS.length ? // [4]
    target_PWS[0] : // [5]
    createAndSelect_PWS();
  }
  /**
   * A private method which creates a new _PWS instance using the selectoe
   * and returns the it.
   *
   * 1. Try to create the the new _PWS instance based on the type of selector.
   *    (The selector will only be a String or HtmlElement because any other
   *    type would have caused an early exit further up the chain).
   *
   * 2. If the creation of a new _PWS instance was successful, store it.
   *
   * 3. Return the new _PWS instance (or null if no _PWS instance was
   *    created).
   */


  function createAndSelect_PWS() {
    var not_PWSMsg = "PasswordStrength: This is not a [data-pws] element.";
    /**
     * 1. Get all of the elements matching the selector.
     *
     * 2. If there are no DOM elements matching the selector, warn the user
     *    and exit early.
     *
     * 3. Of the matching elements, filter them down to only thise with
     *    [data-pws] attributes.
     *
     * 4. If there are no [data-pws] elements found, warn the user and exit
     *    early.
     *
     * 5. Create the _PWS instance for the first matching [data-pws] element
     *    and return it.
     */

    function create_PWSFromString() {
      // [1]
      var matchingElems = document.querySelectorAll(selector); // [2]

      if (matchingElems.length) {
        console.warn("PasswordStrength: '" + selector + "' was not " + "found.");
        return;
      } // [3]


      var matching_PWSElems = [].slice.call(matchingElems).filter(function (elem) {
        return elem.hasAttribute("[data-pws]");
      }); // [4]

      if (!matching_PWSElems.length) {
        console.warn(not_PWSMsg, selector);
        return;
      } // [5]


      return new _PWS(matching_PWSElems[0]);
    }
    /**
     * 1. If this element does not have a [data-pws] attribute, warn the
     *    user and exit early.
     *
     * 2. Create and return a _PWS instance for the first matching
     *    [data-pws] element.
     */


    function create_PWSfromElem() {
      // [1]
      if (!selector.hasAttribute("[data-pws]")) {
        console.warn(not_PWSMsg, selector);
        return;
      } // [2]


      return new _PWS(selector);
    } // [1]


    var new_PWS = typeof selector == "string" ? create_PWSFromString() : create_PWSfromElem(); // [2]

    if (new_PWS) {
      PWS._PWSArray.push(new_PWS);
    } // [3]


    return new_PWS;
  }

  return selected_PWS();
}

; // Using PWS as an alias for PasswordStrength.

var PWS = PasswordStrength;
/**
* TODO
*/

PWS.availableRules = ["length", "upper", "lower", "number", "special"];
/**
* Creating events to be dispatched after various changes to the data on a _PWS
* object.
*/

PWS.events = {
  scoreChange: new CustomEvent('pwsScoreChange'),
  labelChange: new CustomEvent('pwsLabelChange'),
  ruleMatchChange: new CustomEvent('pwsRuleMatchChange'),
  validityChange: new CustomEvent('pwsValidityChange')
}; // Create an empty array in which to store the _PWS instances.

PWS._PWSArray = [];
/**
* Public setup method to allow users to define the password strength rules and
* labels before creating each of the _PWS instances.
*
* 1. Validate the passed in setup options. If invalid, exit early.
*
* 2. Assign the rules and labels (optional) to the PasswordStrength object.
*
* 3. Create and store the _PWS instances for all of the [data-pws] elements in
*    the DOM.
*
* @param {Object} opts The setup options.
*                      Properties:
*                      labels: { Number (Integer): String } (optional)
*                      rules: { String: Number (Integer) }
*
* @return {PasswordStrength} The instance PasswordStrength method.
*                            Allows for method chaining.
*/

PWS.setup = function (opts) {
  /**
   * Private helper methid to prefix the warning message with a string
   * relating to the current situation.
   */
  function warn(msg, other) {
    msg = "Invalid PasswordStrength.setup() parameter. " + msg;
    other ? PWS.warn(msg, other) : PWS.warn(msg);
  }
  /**
   * Private helper method to validate the opts parameter.
   *
   * 1. Validate the opts object at the top level and return false if invalid.
   *
   * 2. If the opts object is valid at the top level, validate the labels and
   *    rules properties and return the result.
   *
   * @return {Boolean} opts parameter validity.
   */


  function validateOpts() {
    // [1]
    if (!opts) {
      warn("No parameter found.");
      return false;
    }

    if (_typeof(opts) != "object") {
      warn("Parameter must be an object. Instead found '" + _typeof(opts) + "'.", opts);
      return false;
    }

    if (opts.labels && _typeof(opts.labels) != "object") {
      warn("The labels property is not an object. Instead found '" + _typeof(opts.labels) + "'.", opts.labels);
      return false;
    }

    if (!opts.rules) {
      warn("The rules property is required.");
      return false;
    }

    if (_typeof(opts.rules) != "object") {
      warn("The rules property must be an object. Instead found '" + _typeof(opts.rules) + "'.", opts.rules);
      return false;
    } // [2]


    return validateLabelsOpts() && validateRulesOpts();
  }
  /**
   * Private helper method for texting thr validity of the opts.labels
   * property.
   *
   * 1. If there are no labels passed in, assign an empty object and return
   *    true (valid).
   *
   * 2. For each label in opts.labels, if any of the values are not Strings,
   *    assign a warning message and break the loop.
   *
   * 3. If there is a warning message to display, warn the user and return
   *    false (invalid).
   *
   * 4. Check that all of the necessary properties (0, 1, 2,3 and 4) are in
   *    the opts.labels object.
   *
   *    Note: This uses code from xdazz's answer to the following question about
   *    comparing arrays: https://stackoverflow.com/questions/22395357/how-to-compare-two-arrays-are-equal-using-javascript
   *
   * 5. If there are missing properties on the opts.labels object, warn the
   *    user and return false (invalid).
   *
   * 6. If all is well, return true (valid).
   *
   * @return {Boolean} opt.labels validity.
   */


  function validateLabelsOpts() {
    // [1]
    if (!opts.labels) {
      PWS.labels = {};
      return true;
    }

    var labelKeysRequired = ["0", "1", "2", "3", "4"],
        labelKeysFound = [],
        invalidRuleMsg;

    for (var key in opts.labels) {
      labelKeysFound.push(key); // [2]

      if (typeof opts.labels[key] != "string") {
        invalidRuleMsg = "The value '" + opts.labels[key] + "' for the '" + key + "' property on the labels object is not a string.";
        break;
      }
    } // [3]


    if (invalidRuleMsg) {
      warn(invalidRuleMsg);
      return;
    }

    labelKeysFound = labelKeysFound.sort(); // [4]

    var labelKeysMatch = labelKeysRequired.length === labelKeysFound.length && labelKeysRequired.every(function (element, index) {
      return element === labelKeysFound[index];
    }); // [5]

    if (!labelKeysMatch) {
      warn("Missing required properties on the labels object. Properties of 0, 1, 2, 3 and 4 are required, with values of type 'string'.", opts.labels);
      return false;
    } // [6]


    return true;
  }
  /**
   * Private helper method for texting thr validity of the opts.rules
   * property.
   *
   * 1. For each rule in opts.rules, if the value matches one of the available
   *    rules, increment the rule counter.
   *
   * 2. For each rule in opts.rules, if any of the values are not Numbers
   *    (Integers) or the String of a Number (Integer), store a warning
   *    message and break the loop.
   *
   * 3. Cast all values to an integer to allow the use of String values
   *    instead of Number (e.g. "1" instead of 1).
   *
   * 4. If there are no rules found, warn the user and return false (invalid).
   *
   * 5. If there is a warning message, warn the user and return false
   *    (invalid).
   *
   * 6. If all is well, return true (valid).
   */


  function validateRulesOpts() {
    var ruleCount = 0,
        invalidRuleMsg;

    for (var key in opts.rules) {
      if (PWS.availableRules.indexOf(key) > -1) {
        // [1]
        ruleCount++;
        var originalValue = opts.rules[key],
            intValue = parseInt(originalValue); // [2]

        if (isNaN(intValue) || originalValue !== intValue) {
          invalidRuleMsg = "The value '" + opts.rules[key] + "' for the '" + key + "' property on the rules object is not an integer.";
          break;
        } // [3]


        opts.rules[key] = parseInt(opts.rules[key]);
      }
    } // [4]


    if (!ruleCount) {
      warn("There are no valid rules on in the rules object.", opts.rules);
      return false;
    } // [5]


    if (invalidRuleMsg) {
      warn(invalidRuleMsg);
      return false;
    } // [6]


    return true;
  } // [1]


  if (!validateOpts()) {
    return;
  } // [2]


  if (opts.labels) {
    PWS.labels = opts.labels;
  }

  PWS.rules = opts.rules; // [3]

  [].slice.call(document.querySelectorAll("[data-pws]")).forEach(function (_PWSElem) {
    PWS._PWSArray.push(new _PWS(_PWSElem));
  });
};
/**
* @param {String} msg The warning message.
*
* @param {Any} other  Any aditional information we want to include in the
*                     console warning (usually an element or an object).
*/


PWS.warn = function (msg, other) {
  msg = "PasswordStrength: " + msg;
  other ? console.warn(msg, other) : console.warn(msg);
};
/**
* -----------------------------------------------------------------------------
*                              _PWS
* -----------------------------------------------------------------------------
*/

/**
* _PWS constructor.
*
* Only instantiated from within the PasswordStrength.init() method and stored
* in the PasswordStrength._PWSArray.
*
* 1. HtmlElement:      The password input element.
*
* 2. String:           The password input value.
*
* 3. Array[Object]:    The list of rules which need to be applied to the
*                      password.
*
* 4. Number (Integer): The current password strength score (from 0-4).
*
* 5. String:           The current password strength label.
*
* 6. Boolean:          The validity of the password (true if valid, otherwise
*                      false). Validity is defined by the number or rules
*                      passed by the password. (If all rules are met, password
*                      is valid, otherwise invalid).
*
* @param {Element} elem The password strength component.
*/


function _PWS(elem) {
  var _pws = this;

  _pws.password = {
    elem: elem,
    // [1]
    value: elem.value // [2]

  };
  _pws.rules = []; // [3]

  _pws.score = 0; // [4]

  _pws.label = PWS.labels[0]; // [5]

  _pws.isValid = false; // [6]

  _pws.regex = null; // [7]

  _pws.init();
}

;
/**
* Adds the password strength rules.
*
* @return {_PWS} This _PWS instance. Allows for method chaining.
*/

_PWS.prototype.addRules = function () {
  var _pws = this; // Mnimum length.


  if (PWS.rules.length) {
    _pws.rules.push({
      name: "length",
      regex: "^.{" + PWS.rules.length + ",}$"
    });
  } // Minimum numerical characters.


  if (PWS.rules.number) {
    _pws.rules.push({
      name: "number",
      regex: "(.*[0-9]){" + PWS.rules.number + "}"
    });
  } // Minimum upper case characters.


  if (PWS.rules.upper) {
    _pws.rules.push({
      name: "upper",
      regex: "(.*[A-Z]){" + PWS.rules.upper + "}"
    });
  } // Minimum lower case characters.


  if (PWS.rules.lower) {
    _pws.rules.push({
      name: "lower",
      regex: "(.*[a-z]){" + PWS.rules.lower + "}"
    });
  } // Minimum special characters.


  if (PWS.rules.special) {
    _pws.rules.push({
      name: "special",
      regex: "(.*[_\\W]){" + PWS.rules.special + "}"
    });
  }

  _pws.rules.map(function (rule) {
    rule.isPassed = function () {
      return new RegExp(this.regex, "g").test(_pws.password.value);
    };

    return rule;
  });

  return _pws;
};
/**
* Updates all of the information on the _PWS instance based on the value of the
* password input.
*
* @return {_PWS} This _PWS instance. Allows for method chaining.
*/


_PWS.prototype.update = function () {
  var _pws = this;
  /**
   * 1. Filter the rules down to only thise that have changed.
   *
   * 2. If any of the rules have changed pass/fail status, dispatch an event
   *    to notify listeners of the change(s).
   */


  function checkRules() {
    // [1]
    var rulesChanged = _pws.rules.filter(function (rule) {
      var wasPassing = rule.isPassing;
      rule.isPassing = rule.isPassed();
      return wasPassing !== rule.isPassing;
    });

    if (rulesChanged.length) {
      // [2]
      PWS.events.ruleMatchChange.data = rulesChanged;

      _pws.password.elem.dispatchEvent(PWS.events.ruleMatchChange);
    }
  }
  /**
   * 1. If zxcvbn.js is available, use it to get the password strength score.
   *
   * 2. If zxcvbn.js is unavailable, calculate the score based on the number
   *    of rules passed.
   *
   * 3. If the score has changed, update the score property on the _PWS
   *    instance.
   *
   * 4. If the score has changed, dispatch an event to notify listeners of
   *    the change.
   */


  function checkScore() {
    var score;

    try {
      // [1]
      score = window.zxcvbn(_pws.password.value).score;
    } catch (e) {
      // [2]
      score = Math.floor(_pws.rules.filter(function (rule) {
        return rule.isPassing;
      }).length / _pws.rules.length * 4);
    }

    if (score !== _pws.score) {
      // [3]
      _pws.score = score; // [4]

      PWS.events.scoreChange.data = score;

      _pws.password.elem.dispatchEvent(PWS.events.scoreChange);
    }
  }
  /**
   * 1. Get the new label value using the current score on the _PWS instance.
   *
   * 2. If the label has changed, update the validity property on the _PWS
   *    instance.
   *
   * 3. If the label has changed, dispatch an event to notify listeners of
   *    the change.
   */


  function checkLabel() {
    var index = _pws.score - 1; // [1]

    var label = index >= 0 ? PWS.labels[index] : '';

    if (label !== _pws.label) {
      // [2]
      _pws.label = label; // [3]

      PWS.events.labelChange.data = label;

      _pws.password.elem.dispatchEvent(PWS.events.labelChange);
    }
  }
  /**
   * 1. Check to see if the number of rules passed is equal to the total
   *    number of rules. If so, the password is valid.
   *
   * 2. If the validity has changed, update the validity property on the _PWS
   *    instance.
   *
   * 3. If the validity has changed, dispatch an event to notify listeners of
   *    the change.
   */


  function checkValidity() {
    // [1]
    var isValid = new RegExp(_pws.regex, "g").test(_pws.password.value);

    if (isValid != _pws.isValid) {
      // [2]
      _pws.isValid = isValid; // [3]

      PWS.events.validityChange.data = isValid;

      _pws.password.elem.dispatchEvent(PWS.events.validityChange);
    }
  }

  checkRules();
  checkScore();
  checkLabel();
  checkValidity();
  return _pws;
};
/**
* Binds events to the password input element.
*
* @return {_PWS} This _PWS instance. Allows for method chaining.
*/


_PWS.prototype.bindEvents = function () {
  var _pws = this;
  /**
   * Update the _PWS information whenever the "input" event is fired on the
   * password input.
   */


  _pws.password.elem.addEventListener("input", function (event) {
    _pws.password.value = event.target.value;

    _pws.update();
  });

  return _pws;
};
/**
* Generate a regular expression which validates the whole password.
*
* 1. Concatenate the regex strings.
*
* 2. If the rule is for the minimum length, store the regex for that rule for
*    later because it needs to go on the end of the concatenated regex string.
*
* 3. If there is a minimum length rule in place, add it to the end of the regex
*    string.
*
* 4. Add the concatenated regex string to the _PWS instance.
*
* @return {_PWS} This _PWS instance. Allows for method chaining.
*/


_PWS.prototype.generateRegex = function () {
  var _pws = this,
      regex = "",
      lengthRegex;

  _pws.rules.map(function (rule) {
    if (rule.name != "length") {
      // [1]
      regex += "(?=" + rule.regex + ")";
    } else {
      // [2]
      lengthRegex = rule.regex;
    }
  }); // [3]


  if (lengthRegex) {
    regex += lengthRegex.replace("^", "").replace("$", "");
  } // [4]


  _pws.regex = regex;
  return _pws;
};
/**
* Initialise this _PWS instance.
*
* @return {_PWS} This _PWS instance. Allows for method chaining.
*/


_PWS.prototype.init = function () {
  return this.addRules().generateRegex().bindEvents().update();
};

module.exports = {
  PasswordStrength: PasswordStrength
};

},{}],228:[function(require,module,exports){
"use strict";

require("regenerator-runtime/runtime");

},{"regenerator-runtime/runtime":70}],229:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _state = _interopRequireDefault(require("state"));

var _jquery = _interopRequireDefault(require("jquery"));

var _atomBadge = _interopRequireDefault(require("atom-badge"));

var _atomDeliveryTime = _interopRequireDefault(require("atom-delivery-time"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _Promise = require('es6-promise').Promise;

var PriceUrlLoader = {
  init: function init() {
    _atomBadge.default.init();
  },
  getPrices: function getPrices(element) {
    var priceUrl = element.dataset.priceUrl;

    if (priceUrl !== undefined) {
      return this.service(priceUrl);
    } else {
      return _Promise.resolve();
    }
  },
  productPriceUrlUpdater: function productPriceUrlUpdater(rootSelector) {
    this.updater = this.updater || function () {
      var updater = {
        init: function init() {
          this.itemPriceSelector = '.cmscomponent-product__price-price';
          this.itemPreTextSelector = '.cmscomponent-product__price-pretext';
          this.itemStrikePriceSelector = '.cmscomponent-product__price-strikeprice';
          this.itemValueSelector = '.cmscomponent-product__price-value';
          this.itemCurrencySelector = '.cmscomponent-product__price-currency';
          this.badgeSelector = '.cmscomponent-product__badges-wrapper';
          this.deliveryTimeSelector = '.cmscomponent-product__delivery-time';
          this.discountAmount = '.atom-pricetag-discount-amount';
          this.itemElementList = [{
            name: 'price',
            selector: this.itemPriceSelector + ' ' + this.itemValueSelector
          }, {
            name: 'currency',
            selector: this.itemPriceSelector + ' ' + this.itemCurrencySelector
          }, {
            name: 'strikePriceCurrency',
            selector: this.itemStrikePriceSelector + ' ' + this.itemCurrencySelector
          }, {
            name: 'discountAmount',
            selector: this.discountAmount
          }, {
            name: 'preText',
            selector: this.itemPreTextSelector
          }, {
            name: 'strikethroughPrice',
            selector: this.itemStrikePriceSelector + ' ' + this.itemValueSelector,
            parent: this.itemStrikePriceSelector
          }, {
            name: 'badges',
            selector: this.badgeSelector,
            updateAll: true
          }];
        },
        checkPriceUrlLoader: function checkPriceUrlLoader() {
          var _this = this;

          [].forEach.call(document.querySelectorAll(this.rootSelector), function (root) {
            var priceUrl = root.dataset.priceUrl;

            if (priceUrl !== undefined) {
              PriceUrlLoader.getPrices(root).then(function (data) {
                if (data !== undefined) {
                  _this.handlePrices(data, root);
                }
              }).catch(function (error) {
                console.debug(error);
              });
            }
          });
        },
        handlePrices: function handlePrices(prices, root) {
          for (var j = 0; j < prices.length; j++) {
            var productCode = prices[j].productCode;
            var item = root.querySelector('[data-product-code="' + productCode + '"]');
            var currentPrice = prices[j];

            if (item !== null && currentPrice !== undefined) {
              if (currentPrice && currentPrice.cheapestPrice) {
                currentPrice.price = currentPrice.cheapestPrice;
                currentPrice.strikethroughPrice = undefined;
              }

              PriceUrlLoader.handlePrice(currentPrice, item, this.itemElementList);
              this.fixPreText(item);
              this.handleDeliveryTime(currentPrice, item);
            }
          }

          this.disablePriceLoading(root);
        },
        fixPreText: function fixPreText(element) {
          var preText = element.querySelector(this.itemPreTextSelector);

          if (preText !== null && preText.innerText === '') {
            preText.style.display = 'none';
          }
        },
        handleDeliveryTime: function handleDeliveryTime(price, root) {
          var data = price.deliveryTime;
          [].forEach.call(root.querySelectorAll(this.deliveryTimeSelector), function (deliveryTime) {
            _atomDeliveryTime.default.update(deliveryTime, data);
          });
        },
        disablePriceLoading: function disablePriceLoading(root) {
          root.removeAttribute('data-price-url');
        }
      };
      updater.init();
      return updater;
    }();

    this.updater.rootSelector = rootSelector;
    this.updater.checkPriceUrlLoader();
  },
  handlePriceStartingAt: function handlePriceStartingAt(price, element) {
    var startingAtSelector = '.cmscomponent-product__price-starting-at';
    var startingAtAmountSelector = '.cmscomponent-product__price-starting-at-amount';
    var startingAtElement = element.querySelector(startingAtSelector);
    var startingAtAmountElement = element.querySelector(startingAtAmountSelector);
    if (!startingAtElement || !startingAtAmountElement) return;
    price.priceStartingAt && (startingAtElement.innerHTML = price.priceStartingAt);
    price.priceStartingAtAmount && (startingAtAmountElement.innerHTML = price.priceStartingAtAmount);
  },
  handlePrice: function handlePrice(price, root, itemElementList, itemPriceTagSelector) {
    var _this2 = this;

    if (price !== undefined) {
      var _loop = function _loop(i) {
        var element = itemElementList[i];
        var nodes = root.querySelectorAll(element.selector);

        if (!element.updateAll) {
          nodes = _toConsumableArray(nodes).slice(0, 1);
        }

        nodes.forEach(function (node) {
          if (node !== null) {
            var newValue = undefined;
            var isStrikePriceCurrency = element.name === 'strikePriceCurrency';

            if (isStrikePriceCurrency) {
              element.name = 'currency';
            }

            newValue = price[element.name];

            if (isStrikePriceCurrency && !price['strikethroughPrice']) {
              newValue = '';
            }

            var parent = root.querySelector(element.parent);

            if (newValue !== undefined && newValue !== null) {
              if (parent !== null) {
                parent.classList.remove(_state.default.HIDDEN);
              }

              if (element.name === 'badges') {
                setTimeout(function () {
                  _this2.handleBadges(node, newValue);
                }, 300);
              } else {
                if (_typeof(newValue) === 'object') {
                  newValue = newValue.label;
                }

                _this2.handlePriceStartingAt(price, root);

                node.innerHTML = newValue;
              }
            } else {
              if (parent !== null) {
                parent.classList.add(_state.default.HIDDEN);
              }
            }

            if (itemPriceTagSelector && typeof price.isOnSale !== 'undefined' && price.isOnSale) {
              root.querySelector(itemPriceTagSelector).classList.add('isOnSale');
            }
          }
        });
      };

      for (var i = 0; i < itemElementList.length; i++) {
        _loop(i);
      }
    }
  },
  handleBadges: function handleBadges(node, data) {
    if (data && data.length) {
      node.innerHTML = _atomBadge.default.getBadges(data);
    }
  },
  service: function () {
    var _service = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!document.body.classList.contains('sb-show-main')) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return new _Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });

            case 3:
              _context.next = 6;
              break;

            case 5:
              undefined;

            case 6:
              if (!(url === '')) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", _Promise.resolve({}));

            case 10:
              return _context.abrupt("return", _Promise.resolve(_jquery.default.ajax({
                headers: {
                  Accept: 'application/json; charset=utf-8'
                },
                type: 'GET',
                url: url
              })));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function service(_x) {
      return _service.apply(this, arguments);
    }

    return service;
  }()
};
var _default = PriceUrlLoader;
exports.default = _default;

},{"atom-badge":170,"atom-delivery-time":174,"es6-promise":6,"jquery":29,"state":232}],230:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Screens = {
  'mobile': '414px',
  'mobileMax': {
    max: '414px'
  },
  'smMax': {
    max: '576px'
  },
  'sm': '576px',
  'mdMax': {
    max: '768px'
  },
  'md': '768px',
  'lg': '992px',
  'tablet': '1001px',
  'xl': '1270px'
};
var _default = Screens;
exports.default = _default;

},{}],231:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _simpleLightbox = _interopRequireDefault(require("simple-lightbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TmpSimpleLightbox = Object.assign({}, _simpleLightbox.default);
var SimpleLightboxExtension = Object.assign(TmpSimpleLightbox, {
  isLoaded: false,
  checkCloseLightbox: function checkCloseLightbox() {
    document.querySelectorAll(this.dataSimpleLightboxCloseSelector).forEach(function (element) {
      element.addEventListener('click', function () {
        var _window$openSimpleLig;

        (_window$openSimpleLig = window.openSimpleLightbox) === null || _window$openSimpleLig === void 0 ? void 0 : _window$openSimpleLig.close();
      });
    });
  },
  init: function init() {
    var _this = this;

    this.dataSimpleLightboxSelector = '[data-simple-lightbox]';
    this.dataSimpleLightboxCloseSelector = '[data-simple-lightbox-close]';
    this.slbCloseBtnSelector = '.slbCloseBtn';
    this.slbContentSelector = '.slbContent';
    this.slbContentOuterSelector = '.slbContentOuter';
    this.simpleLightboxEventOpen = new Event('simpleLightboxEventOpen');
    document.querySelectorAll(this.dataSimpleLightboxSelector).forEach(function (element) {
      var targetElement = document.querySelector(element.getAttribute('data-src'));
      element.addEventListener('click', function () {
        _this.open({
          element: targetElement
        });
      });
    });
    this.isLoaded = true;
  },
  open: function open() {
    var _window$openSimpleLig2, _obj$, _obj$$element;

    this.isLoaded || this.init();
    (_window$openSimpleLig2 = window.openSimpleLightbox) === null || _window$openSimpleLig2 === void 0 ? void 0 : _window$openSimpleLig2.close();

    for (var _len = arguments.length, obj = new Array(_len), _key = 0; _key < _len; _key++) {
      obj[_key] = arguments[_key];
    }

    (_obj$ = obj[0]) === null || _obj$ === void 0 ? void 0 : (_obj$$element = _obj$.element) === null || _obj$$element === void 0 ? void 0 : _obj$$element.querySelectorAll('input').forEach(function (input) {
      input.setAttribute('value', input.value);
    });
    obj[0].element && (obj[0].content = obj[0].element.outerHTML); // part of removeExistingLighboxTemplateUntilClose

    window.openSimpleLightbox = _simpleLightbox.default.open.apply(_simpleLightbox.default, obj);
    this.removeExistingLighboxTemplateUntilClose(obj);
    var targetElement = window.openSimpleLightbox.$el;
    var slbContent = targetElement.querySelector(this.slbContentSelector);
    var slbContentOuter = targetElement.querySelector(this.slbContentOuterSelector);
    slbContent.children[0] && (slbContent.children[0].style.display = 'table');

    if (targetElement.querySelector(this.dataSimpleLightboxCloseSelector)) {
      targetElement.querySelector(this.slbCloseBtnSelector).style.display = 'none';
      this.checkCloseLightbox();
    } else {
      var slbCloseBtn = targetElement.querySelector(this.slbCloseBtnSelector);
      slbCloseBtn && (slbCloseBtn.innerHTML = this.getCloseIcon()) && slbContent.appendChild(slbCloseBtn);
      slbCloseBtn.addEventListener('click', function () {
        return window.openSimpleLightbox.close();
      });
    }

    if (targetElement) {
      window.dispatchEvent(this.simpleLightboxEventOpen);
    } //slbContent.addEventListener('click', (event) => event.stopImmediatePropagation());
    //slbContentOuter.addEventListener('click', () => window.openSimpleLightbox.close());


    return window.openSimpleLightbox;
  },
  removeExistingLighboxTemplateUntilClose: function removeExistingLighboxTemplateUntilClose(obj) {
    var _obj$2;

    if ((_obj$2 = obj[0]) !== null && _obj$2 !== void 0 && _obj$2.element) {
      window.openSimpleLightbox.innerHTML = obj[0].element.innerHTML;
      obj[0].element.innerHTML = '';
      var tmpClose = window.openSimpleLightbox.close;

      window.openSimpleLightbox.close = function () {
        obj[0].element.innerHTML = window.openSimpleLightbox.innerHTML;
        tmpClose.bind(window.openSimpleLightbox)();
      };
    }
  },
  getCloseIcon: function getCloseIcon() {
    return "\n      <svg class=\"icon-no\" xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\">\n      <polygon points=\"42 4.247 37.753 0 21 16.753 4.247 0 0 4.247 16.753 21 0 37.753 4.247 42 21 25.247 37.753 42 42 37.753 25.247 21 42 4.247\"/>\n      </svg>\n    ";
  }
});
var _default = SimpleLightboxExtension;
exports.default = _default;

},{"simple-lightbox":71}],232:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var State = {
  HIDDEN: 'hidden',
  ERROR: 'error',
  ERROR_NOMESSAGE: 'error-nomessage',
  ACTIVE: 'is-active',
  VISIBLE: 'is-visible',
  LOADING: 'is-loading',
  LOADED: 'is-loaded',
  HIDDEN_FORM: 'hidden-form',
  DISABLED: 'is-disabled',
  OPEN: 'is-open',
  HAS_EXPANDER: 'has-expander',
  EXPANDED: 'is-expanded',
  SELECTED: 'is-selected',
  NO_SCROLLING: 'no-scrolling',
  FOCUS: 'is-focused',
  READY: 'is-ready',
  STICKY: 'is-sticky',
  NO_TRANSITIONS: 'has-no-transitions',
  RIGHT: 'is-right',
  EMPTY: 'is-empty'
};
var _default = State;
exports.default = _default;

},{}],233:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateDependencies = void 0;
var templateDependencies = {
  "atoms-add-to-cart": ["atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "atoms-alert-info": [],
  "atoms-alert-success": [],
  "atoms-alert-warning": [],
  "atoms-alert": [],
  "atoms-amount": [],
  "atoms-attachment": [],
  "atoms-badge": [],
  "atoms-benefit": [],
  "atoms-button": ["atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "atoms-cart-counter": ["atoms-icon-cart-empty", "atoms-icon-cart-filled"],
  "atoms-cart-notification": [],
  "atoms-checkbox": [],
  "atoms-csrf": [],
  "atoms-delivery-item": [],
  "atoms-delivery-time": [],
  "atoms-dialog": [],
  "atoms-discontinued-product-text": [],
  "atoms-dropdown": ["atoms-tooltip"],
  "atoms-dropdown-form": ["atoms-csrf"],
  "atoms-edit-flyout": [],
  "atoms-expander": ["atoms-icon-arrow"],
  "atoms-file-attachment": [],
  "atoms-form-loading": ["atoms-icon-reload"],
  "atoms-headline": [],
  "atoms-icon-product": ["atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-tooltip"],
  "atoms-icon-add": [],
  "atoms-icon-arrow-big-end": [],
  "atoms-icon-arrow-big": [],
  "atoms-icon-arrow-thick": [],
  "atoms-icon-arrow": [],
  "atoms-icon-attachment": [],
  "atoms-icon-bell": [],
  "atoms-icon-cart-empty": [],
  "atoms-icon-cart-filled": [],
  "atoms-icon-clock": [],
  "atoms-icon-contact-form": [],
  "atoms-icon-delete": [],
  "atoms-icon-delivery-point": [],
  "atoms-icon-dummy": [],
  "atoms-icon-edit": [],
  "atoms-icon-facebook": [],
  "atoms-icon-gotit": [],
  "atoms-icon-heart-empty": [],
  "atoms-icon-heart": [],
  "atoms-icon-info": [],
  "atoms-icon-linkedin": [],
  "atoms-icon-logo": [],
  "atoms-icon-logout": [],
  "atoms-icon-mastercard": [],
  "atoms-icon-megaphone": [],
  "atoms-icon-menu": [],
  "atoms-icon-mewa-profile": [],
  "atoms-icon-mewa": [],
  "atoms-icon-no": [],
  "atoms-icon-oil": [],
  "atoms-icon-paypal": [],
  "atoms-icon-pdf": [],
  "atoms-icon-phone": [],
  "atoms-icon-print": [],
  "atoms-icon-printink": [],
  "atoms-icon-referenztraeger": [],
  "atoms-icon-refresh": [],
  "atoms-icon-reload": [],
  "atoms-icon-remove-dark": [],
  "atoms-icon-reply": [],
  "atoms-icon-service": [],
  "atoms-icon-shield": [],
  "atoms-icon-ssl": [],
  "atoms-icon-tauschort": [],
  "atoms-icon-twitter": [],
  "atoms-icon-user-loggedin": [],
  "atoms-icon-user": [],
  "atoms-icon-visa": [],
  "atoms-icon-yes": [],
  "atoms-icon-youtube": [],
  "atoms-icons-editorial": [],
  "atoms-icons": ["atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "atoms-input": ["atoms-tooltip"],
  "atoms-input-datepicker": ["atoms-tag", "atoms-icon-no"],
  "atoms-input-password": [],
  "atoms-order-detail-item": ["atoms-toggle-state", "atoms-csrf", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-add-to-cart", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "atoms-paragraph": [],
  "atoms-placeholder": [],
  "atoms-presscomment": [],
  "atoms-pricetag": [],
  "atoms-print": ["atoms-icon-print"],
  "atoms-productoptiontile": ["atoms-radio", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "atoms-radio": [],
  "atoms-serviceticket-detail-comments-entry": ["atoms-icon-mewa-profile", "atoms-icon-user-loggedin", "atoms-file-attachment"],
  "atoms-summary": [],
  "atoms-tableprocontra": [],
  "atoms-tag": ["atoms-icon-no"],
  "atoms-teaser-category": [],
  "atoms-teaser-section": [],
  "atoms-teaser-text": [],
  "atoms-teaser": [],
  "atoms-textarea": [],
  "atoms-textlink": [],
  "atoms-tile": ["atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow"],
  "atoms-toggle-state": ["atoms-icon-heart", "atoms-icon-heart-empty"],
  "atoms-tooltip": [],
  "atoms-totop": ["atoms-icon-arrow"],
  "atoms-video": [],
  "atoms-wishlist-notification": ["atoms-icon-heart", "atoms-icon-heart-empty"],
  "atoms-your-order-and-contract-noimg": ["atoms-badge", "atoms-pricetag"],
  "atoms-your-order-and-contract": ["atoms-badge", "atoms-icon-reload", "atoms-icon-reload", "atoms-pricetag"],
  "cmscomponents-account": ["atoms-alert", "cmscomponents-form-changepassword", "cmscomponents-address", "cmscomponents-account-payment", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-add", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-account-contact-person": ["cmscomponents-global-account-box-header", "cmscomponents-global-account-box-list"],
  "cmscomponents-account-owner": ["atoms-alert", "cmscomponents-form-changepassword", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-account-payment": ["atoms-icon-add"],
  "cmscomponents-address": ["atoms-badge"],
  "cmscomponents-anchor-nav": ["atoms-headline"],
  "cmscomponents-assisted-service-mode": ["atoms-alert", "atoms-input", "atoms-input-password", "atoms-button", "atoms-alert", "atoms-input", "atoms-button", "atoms-icon-mewa-profile", "atoms-icon-logout", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-availabilitycheck": ["atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-availabilityzone": [],
  "cmscomponents-breadcrumb": [],
  "cmscomponents-button-ghost": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-button-primary": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-button-secondary": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-cart-empty": ["atoms-icon-cart-empty"],
  "cmscomponents-cart-oci": ["atoms-input", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-cart": ["atoms-alert-success", "atoms-alert-warning", "atoms-pricetag", "cmscomponents-cart-oci", "atoms-button", "atoms-dropdown-form", "atoms-dropdown-form", "atoms-csrf", "atoms-csrf", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-icon-reload", "atoms-icon-yes", "atoms-icon-no", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-dropdown-form", "atoms-dropdown-form", "atoms-csrf", "atoms-csrf", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-icon-reload", "atoms-icon-yes", "atoms-icon-no", "atoms-csrf", "atoms-radio", "atoms-csrf", "atoms-input", "atoms-icon-delete", "atoms-button", "atoms-alert-info", "cmscomponents-availabilityzone", "atoms-pricetag", "atoms-button", "cmscomponents-cart-oci", "atoms-button", "atoms-input", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-categories": [],
  "cmscomponents-checkout-aboutyou": ["cmscomponents-progressbar", "cmscomponents-form-aboutyou", "cmscomponents-minibasket", "atoms-csrf", "atoms-alert-warning", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input-password", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-textarea", "atoms-checkbox", "atoms-button", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-confirm": ["atoms-csrf", "cmscomponents-progressbar", "atoms-alert", "cmscomponents-form-confirm", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "cmscomponents-address", "cmscomponents-address", "atoms-pricetag", "atoms-pricetag", "cmscomponents-checkout-submit", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-checkbox", "atoms-button", "atoms-badge", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-payment": ["cmscomponents-progressbar", "atoms-alert", "cmscomponents-form-billing", "cmscomponents-form-payment", "cmscomponents-minibasket", "atoms-csrf", "atoms-csrf", "atoms-checkbox", "cmscomponents-address", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-button", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-submit": ["atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-success": ["atoms-paragraph", "atoms-paragraph", "atoms-print", "atoms-paragraph", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-confirmation-mbw": ["cmscomponents-progressbar-advanced", "atoms-csrf", "atoms-alert", "atoms-headline", "atoms-textlink", "cmscomponents-account-owner", "atoms-headline", "atoms-textlink", "cmscomponents-address", "atoms-headline", "atoms-textlink", "cmscomponents-address", "atoms-headline", "atoms-textlink", "atoms-order-detail-item", "atoms-headline", "atoms-textarea", "atoms-textarea", "atoms-textarea", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "atoms-alert", "cmscomponents-form-changepassword", "atoms-badge", "atoms-toggle-state", "atoms-csrf", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-add-to-cart", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-checkbox", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-checkout-delivery-mbw": ["cmscomponents-progressbar-advanced", "atoms-alert", "atoms-csrf", "atoms-headline", "cmscomponents-choose-address", "atoms-button", "cmscomponents-minibasket", "atoms-radio", "cmscomponents-address", "cmscomponents-temporary-address-form", "atoms-icon-reload", "atoms-icons", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tooltip"],
  "cmscomponents-checkout-payment-mbw": ["cmscomponents-progressbar-advanced", "atoms-alert", "atoms-csrf", "atoms-headline", "cmscomponents-choose-address", "atoms-headline", "atoms-button", "cmscomponents-minibasket", "atoms-radio", "cmscomponents-address", "cmscomponents-temporary-address-form", "atoms-icon-reload", "atoms-icons", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tooltip"],
  "cmscomponents-choose-address-extension": ["atoms-icon-no"],
  "cmscomponents-choose-address": ["atoms-radio", "cmscomponents-address", "cmscomponents-temporary-address-form", "atoms-badge", "atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-tooltip", "atoms-tooltip"],
  "cmscomponents-temporary-address-form": ["atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-tooltip", "atoms-tooltip"],
  "cmscomponents-color-variants": [],
  "cmscomponents-comment": ["atoms-badge", "atoms-icon-reply"],
  "cmscomponents-contact-settings": ["atoms-alert-warning", "atoms-alert-success", "atoms-csrf", "atoms-radio", "atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-context-options": ["atoms-icon-add", "atoms-edit-flyout"],
  "cmscomponents-contractual-quantities-options": ["atoms-pricetag", "atoms-edit-flyout"],
  "cmscomponents-country-selection": ["atoms-icon-logo"],
  "cmscomponents-css-account": ["cmscomponents-form-changepassword", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-css-contracts": ["atoms-file-attachment"],
  "cmscomponents-css-invoices": ["atoms-alert-warning", "atoms-alert-info", "cmscomponents-sort-filter", "atoms-badge", "cmscomponents-address", "atoms-icon-no", "atoms-icon-no", "atoms-dropdown", "atoms-icon-add", "atoms-dropdown", "atoms-badge", "atoms-tooltip"],
  "cmscomponents-customer-opinion": [],
  "cmscomponents-customer-service-contact": ["atoms-icon-mewa"],
  "cmscomponents-customer-service": ["atoms-icon-add", "cmscomponents-customer-service-contact", "cmscomponents-customer-service-contact", "atoms-icon-mewa"],
  "cmscomponents-customerid": [],
  "cmscomponents-deliveries": ["atoms-alert-warning", "atoms-alert-info", "atoms-delivery-item", "cmscomponents-address", "atoms-paragraph", "atoms-badge"],
  "cmscomponents-delivery-point-flyout": ["cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-delivery-quantities-detail": ["atoms-badge", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-textlink"],
  "cmscomponents-dialog-error": ["atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-dialog-success": ["atoms-icon-yes", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-dialog-warning": ["atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-errorpage-fonts": [],
  "cmscomponents-errorpage": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-expander": ["atoms-expander", "atoms-icon-arrow"],
  "cmscomponents-faq": ["cmscomponents-moreinfo", "atoms-headline", "atoms-expander", "atoms-icon-arrow"],
  "cmscomponents-filter": ["atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-icon-add", "atoms-tag", "atoms-icon-add", "atoms-dropdown", "atoms-checkbox", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-no"],
  "cmscomponents-filter-search": ["atoms-icon-referenztraeger", "atoms-icon-tauschort", "atoms-tooltip", "atoms-input", "atoms-tooltip"],
  "cmscomponents-entry": ["atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "cmscomponents-flyout-content": ["cmscomponents-entry", "cmscomponents-image-text-teaser", "cmscomponents-title-image-text", "atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "cmscomponents-flyout": ["atoms-icon-arrow-thick", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-entry", "cmscomponents-image-text-teaser", "cmscomponents-title-image-text", "atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "cmscomponents-image-text-teaser": [],
  "cmscomponents-title-image-text": [],
  "cmscomponents-follow-up-product": ["atoms-badge", "atoms-pricetag"],
  "cmscomponents-form-buttons": ["atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-message": ["atoms-textarea", "atoms-icon-add"],
  "cmscomponents-form-aboutyou": ["atoms-csrf", "atoms-alert-warning", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input-password", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-textarea", "atoms-checkbox", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-billing": ["atoms-csrf", "atoms-checkbox", "cmscomponents-address", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-badge", "atoms-tooltip"],
  "cmscomponents-form-change-article-deregister-wearer": ["atoms-csrf", "cmscomponents-form-header", "atoms-input", "cmscomponents-wearer-products", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-changepassword": ["atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-confirm": ["cmscomponents-address", "cmscomponents-address", "atoms-pricetag", "atoms-pricetag", "cmscomponents-checkout-submit", "atoms-badge", "atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-confirmation": ["cmscomponents-global-account-box-list", "atoms-print", "atoms-paragraph", "atoms-alert", "atoms-button", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-enterprise": ["atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-header": ["atoms-headline", "atoms-paragraph", "atoms-alert"],
  "cmscomponents-form-login": ["atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input", "atoms-input-password", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-lostpassword": ["atoms-csrf", "atoms-alert", "atoms-input", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-new-wearer": ["atoms-csrf", "cmscomponents-form-header", "atoms-input", "atoms-input", "atoms-input", "atoms-form-loading", "cmscomponents-filter-search", "atoms-form-loading", "cmscomponents-filter-search", "atoms-icon-product", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-reload", "atoms-icon-referenztraeger", "atoms-icon-tauschort", "atoms-tooltip", "atoms-input", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-payment": ["atoms-csrf", "atoms-radio", "atoms-radio", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-registration": ["atoms-csrf", "atoms-headline", "atoms-form-loading", "atoms-alert", "atoms-input", "atoms-input", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-button", "atoms-paragraph", "atoms-icon-reload", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-registration-short-step2": ["atoms-alert", "atoms-input-password", "atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-registration-short": ["atoms-alert-warning", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-repair-report": ["atoms-csrf", "cmscomponents-form-header", "atoms-input", "cmscomponents-wearer-products", "atoms-input", "atoms-paragraph", "cmscomponents-patch-selector", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-icon-delete", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-resetpassword": ["atoms-csrf", "atoms-alert-warning", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-serviceticket": ["atoms-csrf", "cmscomponents-dialog-error", "atoms-headline", "atoms-paragraph", "atoms-form-loading", "atoms-input", "atoms-textarea", "atoms-icon-add", "cmscomponents-upload", "atoms-button", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-form-contact": ["atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-footer": ["atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-dropdown", "atoms-icon-facebook", "atoms-icon-twitter", "atoms-icon-youtube", "atoms-icon-linkedin", "atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-icon-arrow", "atoms-tooltip"],
  "cmscomponents-header-css": ["cmscomponents-header-promo", "atoms-icon-logo", "atoms-icon-user", "atoms-icon-user-loggedin", "cmscomponents-customerid", "atoms-icon-phone"],
  "cmscomponents-header": ["cmscomponents-header-promo", "atoms-icon-logo", "atoms-icon-menu", "atoms-icon-no", "atoms-cart-counter", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-arrow-thick", "atoms-icon-phone", "atoms-icon-ssl", "atoms-icon-shield", "cmscomponents-customerid", "cmscomponents-delivery-point-flyout", "atoms-icon-dummy", "atoms-icon-logo", "atoms-icon-phone", "atoms-icon-ssl", "atoms-icon-shield", "atoms-icon-phone", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-global-account-box-header": [],
  "cmscomponents-global-account-box-list": [],
  "cmscomponents-header-cssitems": ["cmscomponents-customerid"],
  "cmscomponents-header-extended": ["cmscomponents-header-promo", "cmscomponents-header-login-flyout", "cmscomponents-header-icons", "cmscomponents-header-navitems", "cmscomponents-header-cssitems", "cmscomponents-delivery-point-flyout", "atoms-icon-phone", "cmscomponents-login-flyout", "atoms-icon-logo", "cmscomponents-search", "atoms-icon-menu", "atoms-icon-no", "atoms-wishlist-notification", "atoms-cart-counter", "atoms-cart-notification", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-arrow-thick", "cmscomponents-flyout", "atoms-icon-phone", "cmscomponents-customerid", "cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-csrf", "atoms-form-loading", "atoms-headline", "atoms-alert", "atoms-input", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-arrow-thick", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "cmscomponents-entry", "cmscomponents-image-text-teaser", "cmscomponents-title-image-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "cmscomponents-header-icons": ["atoms-icon-logo", "cmscomponents-search", "atoms-icon-menu", "atoms-icon-no", "atoms-wishlist-notification", "atoms-cart-counter", "atoms-cart-notification", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-cart-empty", "atoms-icon-cart-filled"],
  "cmscomponents-header-login-flyout": ["cmscomponents-login-flyout", "atoms-csrf", "atoms-form-loading", "atoms-headline", "atoms-alert", "atoms-input", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-header-navitems": ["atoms-icon-arrow-thick", "cmscomponents-flyout", "atoms-icon-phone", "atoms-icon-arrow-thick", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-entry", "cmscomponents-image-text-teaser", "cmscomponents-title-image-text", "atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "cmscomponents-header-minimal-css": ["cmscomponents-header-promo", "atoms-icon-logo", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "cmscomponents-customerid", "cmscomponents-delivery-point-flyout", "atoms-icon-phone", "cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-header-promo": ["atoms-icon-phone"],
  "cmscomponents-headline": ["atoms-headline"],
  "cmscomponents-howitworks": [],
  "cmscomponents-image-header": ["cmscomponents-context-options", "atoms-icon-add", "atoms-edit-flyout"],
  "cmscomponents-invoiceDelivery": ["atoms-pricetag", "atoms-pricetag"],
  "cmscomponents-listbox": ["atoms-benefit"],
  "cmscomponents-listboxteaser": ["cmscomponents-listboxteaser-content", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "cmscomponents-listboxteaser-content": ["atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "cmscomponents-login": ["cmscomponents-form-login", "cmscomponents-paragraph", "cmscomponents-form-registration-short", "cmscomponents-listbox", "atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input", "atoms-input-password", "atoms-button", "atoms-paragraph", "atoms-alert-warning", "atoms-input", "atoms-button", "atoms-csrf", "atoms-benefit", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-login-dialog": ["atoms-paragraph", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-login-flyout": ["atoms-csrf", "atoms-form-loading", "atoms-headline", "atoms-alert", "atoms-input", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-marquee": [],
  "cmscomponents-micro-footer": [],
  "cmscomponents-micro-header": ["atoms-icon-logo"],
  "cmscomponents-minibasket": ["atoms-pricetag", "atoms-pricetag", "atoms-pricetag"],
  "cmscomponents-moreinfo": ["atoms-headline", "atoms-expander", "atoms-icon-arrow"],
  "cmscomponents-needanalyser-contact": ["cmscomponents-progressbar", "cmscomponents-listbox", "cmscomponents-support", "cmscomponents-form-contact", "atoms-button", "atoms-icon-refresh", "atoms-benefit", "atoms-icon-phone", "atoms-button", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-needanalyser-product-contact": ["cmscomponents-progressbar", "cmscomponents-form-contact", "atoms-button", "atoms-icon-refresh", "cmscomponents-availabilitycheck", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button"],
  "cmscomponents-needanalyser-product": ["cmscomponents-progressbar", "cmscomponents-productrate", "atoms-button", "atoms-icon-refresh", "cmscomponents-availabilitycheck", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip"],
  "cmscomponents-needanalyser": ["atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons"],
  "cmscomponents-newsletter": ["atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-orders-detail-mbw": ["atoms-badge", "atoms-headline", "cmscomponents-address", "atoms-headline", "atoms-order-detail-item", "atoms-summary", "cmscomponents-address", "atoms-badge", "atoms-toggle-state", "atoms-csrf", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-add-to-cart", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-ordersdetail": ["atoms-alert-warning", "atoms-alert-success", "atoms-badge", "cmscomponents-ordersdetail-durationchange", "atoms-pricetag", "cmscomponents-css-contracts", "atoms-productoptiontile", "cmscomponents-ordersdetail-upgrade", "cmscomponents-ordersdetail-downgrade", "cmscomponents-support-product", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-pricetag", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-file-attachment", "atoms-radio", "atoms-pricetag", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-ordersdetail-downgrade": ["atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-radio", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-ordersdetail-durationchange": ["atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-pricetag", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-ordersdetail-upgrade": ["atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-radio", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-original-contracts": ["atoms-alert", "atoms-badge", "atoms-file-attachment"],
  "cmscomponents-page-navigation": [],
  "cmscomponents-pageheader-productdetail": ["cmscomponents-stageproduct", "cmscomponents-teaserbox", "cmscomponents-availabilityzone", "cmscomponents-support-product", "cmscomponents-availabilitycheck", "atoms-video", "atoms-pricetag", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-pageheader-productoverview": ["cmscomponents-stagecontent", "cmscomponents-teaserproduct", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-pageheader-support": ["cmscomponents-stagecontent-mhl", "cmscomponents-support-product", "cmscomponents-moreinfo", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-headline", "atoms-expander", "atoms-icon-reload", "atoms-icons", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-pagination": ["atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end"],
  "cmscomponents-paragraph": ["atoms-paragraph"],
  "cmscomponents-patch-selector": ["atoms-icon-delete"],
  "cmscomponents-presscomments": ["atoms-presscomment", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-product-details": ["atoms-delivery-time", "atoms-discontinued-product-text"],
  "cmscomponents-product": ["atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "cmscomponents-product-grid": ["cmscomponents-utility-bar", "atoms-form-loading", "cmscomponents-product", "cmscomponents-teaser-member", "cmscomponents-pagination", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-icon-reload", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-product-header": ["cmscomponents-stageproduct-extended", "cmscomponents-product-specifications", "atoms-video", "atoms-badge", "atoms-csrf", "atoms-toggle-state", "atoms-icon-reload", "atoms-pricetag", "cmscomponents-product-settings", "atoms-dropdown", "atoms-button", "cmscomponents-dialog-error", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-button", "atoms-icon-arrow-thick", "atoms-textlink", "atoms-alert", "atoms-file-attachment", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-product-highlight": ["cmscomponents-textmedia", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-product-settings": [],
  "cmscomponents-product-specifications": ["atoms-textlink", "atoms-alert", "atoms-file-attachment"],
  "cmscomponents-productrate": ["atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-progressbar-advanced": [],
  "cmscomponents-progressbar": [],
  "cmscomponents-promoteaser": ["atoms-button", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-registration-confirmation": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-registration-extended": ["atoms-alert-warning", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-registration": ["atoms-alert-warning", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-search": [],
  "cmscomponents-search-local": ["atoms-input", "atoms-tooltip"],
  "cmscomponents-serviceticket-detail-assignee": [],
  "cmscomponents-serviceticket-detail-comments-placeholder": ["atoms-placeholder"],
  "cmscomponents-serviceticket-detail-comments": ["atoms-icon-add", "cmscomponents-form-serviceticket", "atoms-icon-yes", "cmscomponents-serviceticket-detail-comments-placeholder", "atoms-serviceticket-detail-comments-entry", "cmscomponents-serviceticket-detail-comments-placeholder", "cmscomponents-dialog-success", "atoms-form-loading", "atoms-csrf", "cmscomponents-dialog-error", "atoms-headline", "atoms-paragraph", "atoms-form-loading", "atoms-input", "atoms-textarea", "atoms-icon-add", "cmscomponents-upload", "atoms-button", "atoms-button", "atoms-placeholder", "atoms-icon-mewa-profile", "atoms-icon-user-loggedin", "atoms-file-attachment", "atoms-icon-yes", "atoms-button", "atoms-icon-reload", "atoms-icon-no", "atoms-button", "atoms-tooltip", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-serviceticket-detail-item": ["atoms-badge"],
  "cmscomponents-serviceticket-detail-placeholder": ["atoms-placeholder"],
  "cmscomponents-serviceticket-detail": ["atoms-alert", "cmscomponents-serviceticket-detail-item", "cmscomponents-wearer-products", "atoms-file-attachment", "cmscomponents-serviceticket-detail-placeholder", "cmscomponents-serviceticket-detail-assignee", "cmscomponents-serviceticket-detail-comments", "atoms-badge", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-placeholder", "atoms-icon-add", "cmscomponents-form-serviceticket", "atoms-icon-yes", "cmscomponents-serviceticket-detail-comments-placeholder", "atoms-serviceticket-detail-comments-entry", "cmscomponents-serviceticket-detail-comments-placeholder", "cmscomponents-dialog-success", "atoms-form-loading", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-csrf", "cmscomponents-dialog-error", "atoms-headline", "atoms-paragraph", "atoms-form-loading", "atoms-input", "atoms-textarea", "atoms-icon-add", "cmscomponents-upload", "atoms-button", "atoms-button", "atoms-placeholder", "atoms-icon-mewa-profile", "atoms-icon-user-loggedin", "atoms-file-attachment", "atoms-icon-yes", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-no", "atoms-button", "atoms-tooltip", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-shipping-confirmations": [],
  "cmscomponents-show-more": ["atoms-icon-arrow-big"],
  "cmscomponents-sort-filter": ["atoms-icon-no", "atoms-icon-no", "atoms-dropdown", "atoms-icon-add", "atoms-dropdown", "atoms-tooltip"],
  "cmscomponents-stage": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-stagecontent-mhl": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-stagecontent": [],
  "cmscomponents-stageproduct-extended": ["atoms-video", "atoms-badge", "atoms-csrf", "atoms-toggle-state", "atoms-icon-reload", "atoms-pricetag", "cmscomponents-product-settings", "atoms-dropdown", "atoms-button", "cmscomponents-dialog-error", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-button", "atoms-icon-arrow-thick", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-stageproduct": ["atoms-video", "atoms-pricetag"],
  "cmscomponents-support-product": ["atoms-icon-phone", "atoms-icon-contact-form"],
  "cmscomponents-support": ["atoms-icon-phone", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-tableprocontra": ["atoms-tableprocontra"],
  "cmscomponents-teaser-member": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaser-promo-small": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaserbox": ["cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaserbox-productrate": ["cmscomponents-productrate", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaser-slider": ["atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-reload", "atoms-icons", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaserbox-slider": ["cmscomponents-product-highlight", "cmscomponents-teaser-slider", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-reload", "atoms-icons", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-teaserproduct": ["atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-testbox": ["atoms-radio", "atoms-radio", "atoms-radio", "cmscomponents-form-contact", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-textmedia": ["atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-tile-list": ["atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "cmscomponents-totopbig": [],
  "cmscomponents-unavailable": ["atoms-csrf", "atoms-input", "atoms-button", "atoms-button", "cmscomponents-availabilityzone", "cmscomponents-availabilitycheck", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button"],
  "cmscomponents-upload": ["atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-utility-bar": ["atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-verifyaccount": ["atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-videocomponent": ["atoms-video"],
  "cmscomponents-wearer-products": ["atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-tooltip"],
  "cmscomponents-welcome-header": ["cmscomponents-welcome", "cmscomponents-customerid"],
  "cmscomponents-welcome": [],
  "cmscomponents-wishlist": ["atoms-alert", "atoms-icon-reload", "atoms-pricetag", "atoms-icon-reload", "atoms-pricetag", "atoms-csrf", "atoms-csrf", "atoms-dropdown", "atoms-button", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-csrf", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "cmscomponents-your-request-detail": ["atoms-textarea", "cmscomponents-upload", "atoms-button", "atoms-button", "cmscomponents-comment", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-badge", "atoms-icon-reply", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-contract-quantities-detail": ["cmscomponents-contractual-quantities-options", "cmscomponents-tile-list", "atoms-pricetag", "atoms-edit-flyout", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "templates-filtered-tile-list-ajax": ["cmscomponents-utility-bar", "cmscomponents-tile-list", "cmscomponents-pagination", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-filtered-tile-list": ["cmscomponents-context-options", "cmscomponents-utility-bar", "cmscomponents-tile-list", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-mewashop-teaser": ["cmscomponents-listboxteaser", "atoms-paragraph", "cmscomponents-listboxteaser-content", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-serviceticket-overview-with-image-header": ["cmscomponents-image-header", "templates-filtered-tile-list", "cmscomponents-context-options", "cmscomponents-context-options", "cmscomponents-utility-bar", "cmscomponents-tile-list", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-wearer-details-component": ["cmscomponents-image-header", "cmscomponents-tile-list", "cmscomponents-context-options", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "templates-wearer-overview-component": ["cmscomponents-context-options", "templates-filtered-tile-list", "atoms-icon-add", "atoms-edit-flyout", "cmscomponents-context-options", "cmscomponents-utility-bar", "cmscomponents-tile-list", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-account-owner": ["cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-account-owner", "atoms-alert", "cmscomponents-form-changepassword", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-account-payment": ["cmscomponents-account-payment", "atoms-icon-add"],
  "templates-account": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "atoms-alert", "cmscomponents-customerid", "cmscomponents-account", "atoms-alert", "cmscomponents-form-changepassword", "cmscomponents-address", "cmscomponents-account-payment", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-add", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-addresses": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-address", "cmscomponents-address", "atoms-badge"],
  "templates-contact-settings": ["atoms-headline", "cmscomponents-contact-settings", "atoms-alert-warning", "atoms-alert-success", "atoms-csrf", "atoms-radio", "atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-account-intro": ["atoms-alert-info", "cmscomponents-breadcrumb", "cmscomponents-welcome", "cmscomponents-customerid", "cmscomponents-listboxteaser", "cmscomponents-teaserbox-slider", "cmscomponents-paragraph", "cmscomponents-needanalyser", "cmscomponents-promoteaser", "cmscomponents-listboxteaser-content", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "atoms-paragraph", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "atoms-button", "atoms-button", "atoms-button", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-account-intro-mts": ["cmscomponents-listboxteaser", "cmscomponents-support-product", "cmscomponents-promoteaser", "cmscomponents-listboxteaser-content", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-button", "atoms-button", "atoms-button", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-icon-reload", "atoms-icons", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-branchen": ["cmscomponents-stagecontent-mhl", "cmscomponents-listboxteaser", "cmscomponents-teaserbox-slider", "cmscomponents-teaser-promo-small", "cmscomponents-listboxteaser", "cmscomponents-marquee", "cmscomponents-teaserbox-slider", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "cmscomponents-listboxteaser-content", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-cart-empty": ["cmscomponents-cart-empty", "atoms-icon-cart-empty"],
  "templates-cart": ["cmscomponents-cart", "cmscomponents-availabilitycheck", "atoms-alert-success", "atoms-alert-warning", "atoms-pricetag", "cmscomponents-cart-oci", "atoms-button", "atoms-dropdown-form", "atoms-dropdown-form", "atoms-csrf", "atoms-csrf", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-icon-reload", "atoms-icon-yes", "atoms-icon-no", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-dropdown-form", "atoms-dropdown-form", "atoms-csrf", "atoms-csrf", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-textarea", "atoms-icon-add", "atoms-icon-reload", "atoms-icon-yes", "atoms-icon-no", "atoms-csrf", "atoms-radio", "atoms-csrf", "atoms-input", "atoms-icon-delete", "atoms-button", "atoms-alert-info", "cmscomponents-availabilityzone", "atoms-pricetag", "atoms-button", "cmscomponents-cart-oci", "atoms-button", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-input", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "atoms-tooltip", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-aboutyou": ["cmscomponents-checkout-aboutyou", "cmscomponents-progressbar", "cmscomponents-form-aboutyou", "cmscomponents-minibasket", "atoms-csrf", "atoms-alert-warning", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input-password", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-textarea", "atoms-checkbox", "atoms-button", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-confirm": ["cmscomponents-checkout-confirm", "atoms-csrf", "cmscomponents-progressbar", "atoms-alert", "cmscomponents-form-confirm", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "cmscomponents-address", "cmscomponents-address", "atoms-pricetag", "atoms-pricetag", "cmscomponents-checkout-submit", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-checkbox", "atoms-button", "atoms-badge", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-confirmation-mbw": ["cmscomponents-checkout-confirmation-mbw", "cmscomponents-progressbar-advanced", "atoms-csrf", "atoms-alert", "atoms-headline", "atoms-textlink", "cmscomponents-account-owner", "atoms-headline", "atoms-textlink", "cmscomponents-address", "atoms-headline", "atoms-textlink", "cmscomponents-address", "atoms-headline", "atoms-textlink", "atoms-order-detail-item", "atoms-headline", "atoms-textarea", "atoms-textarea", "atoms-textarea", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "cmscomponents-minibasket", "cmscomponents-checkout-submit", "atoms-alert", "cmscomponents-form-changepassword", "atoms-badge", "atoms-toggle-state", "atoms-csrf", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-add-to-cart", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-checkbox", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-delivery-mbw": ["cmscomponents-checkout-delivery-mbw", "cmscomponents-progressbar-advanced", "atoms-alert", "atoms-csrf", "atoms-headline", "cmscomponents-choose-address", "atoms-button", "cmscomponents-minibasket", "atoms-radio", "cmscomponents-address", "cmscomponents-temporary-address-form", "atoms-icon-reload", "atoms-icons", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tooltip"],
  "templates-checkout-payment-mbw": ["cmscomponents-checkout-payment-mbw", "cmscomponents-progressbar-advanced", "atoms-alert", "atoms-csrf", "atoms-headline", "cmscomponents-choose-address", "atoms-headline", "atoms-button", "cmscomponents-minibasket", "atoms-radio", "cmscomponents-address", "cmscomponents-temporary-address-form", "atoms-icon-reload", "atoms-icons", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-csrf", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tooltip"],
  "templates-checkout-payment-no-changes": ["templates-checkout-payment", "cmscomponents-checkout-payment", "cmscomponents-progressbar", "atoms-alert", "cmscomponents-form-billing", "cmscomponents-form-payment", "cmscomponents-minibasket", "atoms-csrf", "atoms-csrf", "atoms-checkbox", "cmscomponents-address", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-button", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-payment": ["cmscomponents-checkout-payment", "cmscomponents-progressbar", "atoms-alert", "cmscomponents-form-billing", "cmscomponents-form-payment", "cmscomponents-minibasket", "atoms-csrf", "atoms-csrf", "atoms-checkbox", "cmscomponents-address", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-button", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-badge", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-success-mbw": ["cmscomponents-checkout-success", "atoms-paragraph", "atoms-paragraph", "atoms-print", "atoms-paragraph", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-checkout-success": ["cmscomponents-checkout-success", "atoms-paragraph", "atoms-paragraph", "atoms-print", "atoms-paragraph", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-company": ["cmscomponents-breadcrumb", "atoms-headline", "atoms-paragraph", "cmscomponents-address", "cmscomponents-address", "cmscomponents-address", "atoms-badge"],
  "templates-contactform": ["atoms-headline", "cmscomponents-form-contact", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-content": [],
  "templates-contractual-quantities-detail": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-contractual-quantities-options", "cmscomponents-tile-list", "cmscomponents-listboxteaser", "atoms-pricetag", "atoms-edit-flyout", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "cmscomponents-listboxteaser-content", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-contractual-quantities-overview": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-tile-list", "atoms-paragraph", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "templates-country-selection": ["cmscomponents-country-selection", "atoms-icon-logo"],
  "templates-css-invoices-deprecated": ["cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-css-invoices", "atoms-alert-warning", "atoms-alert-info", "cmscomponents-sort-filter", "atoms-badge", "cmscomponents-address", "atoms-icon-no", "atoms-icon-no", "atoms-dropdown", "atoms-icon-add", "atoms-dropdown", "atoms-badge", "atoms-tooltip"],
  "templates-css-invoices": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-utility-bar", "cmscomponents-tile-list", "cmscomponents-moreinfo", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-headline", "atoms-expander", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-orders-detail": ["cmscomponents-ordersdetail", "atoms-alert-warning", "atoms-alert-success", "atoms-badge", "cmscomponents-ordersdetail-durationchange", "atoms-pricetag", "cmscomponents-css-contracts", "atoms-productoptiontile", "cmscomponents-ordersdetail-upgrade", "cmscomponents-ordersdetail-downgrade", "cmscomponents-support-product", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-pricetag", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-file-attachment", "atoms-radio", "atoms-pricetag", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-productoptiontile", "atoms-checkbox", "atoms-button", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-ordersandcontracts": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-tile-list", "cmscomponents-moreinfo", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-headline", "atoms-expander", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-icon-arrow"],
  "templates-requestsdetail": ["cmscomponents-breadcrumb", "cmscomponents-your-request-detail", "atoms-textarea", "cmscomponents-upload", "atoms-button", "atoms-button", "cmscomponents-comment", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-badge", "atoms-icon-reply", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-css-account": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-customerid", "cmscomponents-css-account", "cmscomponents-form-changepassword", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-css-contracts": ["cmscomponents-breadcrumb", "atoms-alert-info", "atoms-alert-warning", "cmscomponents-css-contracts", "atoms-file-attachment"],
  "templates-css-start": ["cmscomponents-breadcrumb", "atoms-headline", "atoms-button", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-customer-base-data": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "atoms-paragraph", "cmscomponents-address", "cmscomponents-support-product", "atoms-badge", "atoms-icon-phone", "atoms-icon-contact-form"],
  "templates-customer-service": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "atoms-paragraph", "cmscomponents-customer-service", "atoms-paragraph", "cmscomponents-moreinfo", "atoms-icon-add", "cmscomponents-customer-service-contact", "cmscomponents-customer-service-contact", "atoms-headline", "atoms-expander", "atoms-icon-mewa", "atoms-icon-arrow"],
  "templates-deliveries": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-tile-list", "atoms-paragraph", "cmscomponents-listboxteaser", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "cmscomponents-listboxteaser-content", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-delivery-quantities": ["cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-tile-list", "atoms-paragraph", "cmscomponents-listboxteaser", "cmscomponents-moreinfo", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "cmscomponents-listboxteaser-content", "atoms-headline", "atoms-expander", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-icon-arrow", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-delivery-quantities-detail": ["cmscomponents-breadcrumb", "cmscomponents-delivery-quantities-detail", "cmscomponents-listboxteaser", "atoms-badge", "atoms-pricetag", "atoms-pricetag", "atoms-pricetag", "atoms-textlink", "cmscomponents-listboxteaser-content", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-enterprise": ["atoms-headline", "cmscomponents-paragraph", "cmscomponents-listbox", "cmscomponents-support", "cmscomponents-form-contact", "atoms-paragraph", "atoms-benefit", "atoms-icon-phone", "atoms-button", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-errorpage": ["cmscomponents-errorpage", "cmscomponents-teaserbox-slider", "atoms-button", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "atoms-icon-reload", "atoms-icons", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-faq": ["cmscomponents-textmedia", "cmscomponents-faq", "cmscomponents-moreinfo", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "cmscomponents-moreinfo", "atoms-headline", "atoms-expander", "atoms-icon-reload", "atoms-icons", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-change-article": ["cmscomponents-breadcrumb", "cmscomponents-form-change-article-deregister-wearer", "atoms-csrf", "cmscomponents-form-header", "atoms-input", "cmscomponents-wearer-products", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-contact-confirmation-whitelabel": ["cmscomponents-form-confirmation", "cmscomponents-global-account-box-list", "atoms-print", "atoms-paragraph", "atoms-alert", "atoms-button", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-contact-confirmation": ["cmscomponents-form-confirmation", "atoms-headline", "cmscomponents-promoteaser", "cmscomponents-global-account-box-list", "atoms-print", "atoms-paragraph", "atoms-alert", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-deregister-wearer": ["cmscomponents-breadcrumb", "cmscomponents-form-change-article-deregister-wearer", "atoms-csrf", "cmscomponents-form-header", "atoms-input", "cmscomponents-wearer-products", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-new-wearer": ["cmscomponents-breadcrumb", "cmscomponents-form-new-wearer", "atoms-csrf", "cmscomponents-form-header", "atoms-input", "atoms-input", "atoms-input", "atoms-form-loading", "cmscomponents-filter-search", "atoms-form-loading", "cmscomponents-filter-search", "atoms-icon-product", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-reload", "atoms-icon-referenztraeger", "atoms-icon-tauschort", "atoms-tooltip", "atoms-input", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-repair-report": ["cmscomponents-breadcrumb", "cmscomponents-form-repair-report", "atoms-csrf", "cmscomponents-form-header", "atoms-input", "cmscomponents-wearer-products", "atoms-input", "atoms-paragraph", "cmscomponents-patch-selector", "cmscomponents-form-message", "cmscomponents-upload", "cmscomponents-form-buttons", "atoms-headline", "atoms-paragraph", "atoms-alert", "atoms-tooltip", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-icon-delete", "atoms-textarea", "atoms-icon-add", "atoms-button", "atoms-button", "atoms-button", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-form-serviceticket": ["cmscomponents-breadcrumb", "cmscomponents-form-serviceticket", "atoms-csrf", "cmscomponents-dialog-error", "atoms-headline", "atoms-paragraph", "atoms-form-loading", "atoms-input", "atoms-textarea", "atoms-icon-add", "cmscomponents-upload", "atoms-button", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-fst-css-account": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-css-account", "cmscomponents-account-contact-person", "cmscomponents-support-product", "cmscomponents-form-changepassword", "cmscomponents-global-account-box-header", "cmscomponents-global-account-box-list", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-csrf", "cmscomponents-dialog-success", "cmscomponents-dialog-error", "atoms-headline", "atoms-input-password", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-header-css": ["cmscomponents-header-css", "cmscomponents-header-promo", "atoms-icon-logo", "atoms-icon-user", "atoms-icon-user-loggedin", "cmscomponents-customerid", "atoms-icon-phone"],
  "templates-header-extended": ["cmscomponents-header-extended", "cmscomponents-header-promo", "cmscomponents-header-login-flyout", "cmscomponents-header-icons", "cmscomponents-header-navitems", "cmscomponents-header-cssitems", "cmscomponents-delivery-point-flyout", "atoms-icon-phone", "cmscomponents-login-flyout", "atoms-icon-logo", "cmscomponents-search", "atoms-icon-menu", "atoms-icon-no", "atoms-wishlist-notification", "atoms-cart-counter", "atoms-cart-notification", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-arrow-thick", "cmscomponents-flyout", "atoms-icon-phone", "cmscomponents-customerid", "cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-csrf", "atoms-form-loading", "atoms-headline", "atoms-alert", "atoms-input", "atoms-input-password", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-arrow-thick", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "cmscomponents-flyout-content", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "cmscomponents-entry", "cmscomponents-image-text-teaser", "cmscomponents-title-image-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-arrow-thick", "atoms-icon-arrow-thick"],
  "templates-header-minimal-css": ["cmscomponents-header-minimal-css", "cmscomponents-header-promo", "atoms-icon-logo", "atoms-icon-delivery-point", "atoms-icon-user", "atoms-icon-user-loggedin", "cmscomponents-customerid", "cmscomponents-delivery-point-flyout", "atoms-icon-phone", "cmscomponents-search-local", "atoms-csrf", "cmscomponents-address", "atoms-csrf", "cmscomponents-address", "cmscomponents-dialog-warning", "atoms-input", "atoms-badge", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-headline": ["atoms-headline"],
  "templates-home-wipe": ["cmscomponents-stagecontent", "cmscomponents-needanalyser", "cmscomponents-howitworks", "cmscomponents-teaserbox", "cmscomponents-promoteaser", "cmscomponents-newsletter", "cmscomponents-presscomments", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-presscomment", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-tooltip"],
  "templates-home": ["cmscomponents-stage", "cmscomponents-needanalyser", "cmscomponents-howitworks", "cmscomponents-teaserbox", "cmscomponents-promoteaser", "cmscomponents-newsletter", "cmscomponents-presscomments", "atoms-button", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-presscomment", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-tooltip"],
  "templates-invoices": ["cmscomponents-breadcrumb", "atoms-headline", "atoms-paragraph", "cmscomponents-css-invoices", "atoms-alert-warning", "atoms-alert-info", "cmscomponents-sort-filter", "atoms-badge", "cmscomponents-address", "atoms-icon-no", "atoms-icon-no", "atoms-dropdown", "atoms-icon-add", "atoms-dropdown", "atoms-badge", "atoms-tooltip"],
  "templates-login-dialog": ["cmscomponents-login-dialog", "atoms-paragraph", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-login": ["cmscomponents-form-login", "atoms-headline", "cmscomponents-paragraph", "cmscomponents-form-registration-short", "cmscomponents-listbox", "atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input", "atoms-input-password", "atoms-button", "atoms-paragraph", "atoms-alert-warning", "atoms-input", "atoms-button", "atoms-csrf", "atoms-benefit", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-verify-account": ["cmscomponents-verifyaccount", "atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-login-css": ["cmscomponents-textmedia", "cmscomponents-form-login", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-csrf", "atoms-alert-warning", "atoms-alert-info", "atoms-input", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-login-flyout": [],
  "templates-logout": ["cmscomponents-form-confirmation", "cmscomponents-listboxteaser", "cmscomponents-global-account-box-list", "atoms-print", "atoms-paragraph", "atoms-alert", "atoms-button", "atoms-button", "cmscomponents-listboxteaser-content", "atoms-icon-print", "atoms-icon-reload", "atoms-icons", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-categorypage-mbw-no-breadcrumb": ["cmscomponents-textmedia", "cmscomponents-categories", "cmscomponents-product-grid", "cmscomponents-textmedia", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "cmscomponents-utility-bar", "atoms-form-loading", "cmscomponents-product", "cmscomponents-teaser-member", "cmscomponents-pagination", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-icon-reload", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-categorypage-mbw-nosidebar": ["cmscomponents-textmedia", "cmscomponents-teaser-promo-small", "cmscomponents-textmedia", "cmscomponents-product-grid", "cmscomponents-textmedia", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-button", "cmscomponents-utility-bar", "atoms-form-loading", "cmscomponents-product", "cmscomponents-teaser-member", "cmscomponents-pagination", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-icon-reload", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-categorypage-mbw": ["cmscomponents-breadcrumb", "cmscomponents-textmedia", "cmscomponents-teaser-promo-small", "cmscomponents-textmedia", "cmscomponents-categories", "cmscomponents-product-grid", "cmscomponents-textmedia", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-button", "cmscomponents-utility-bar", "atoms-form-loading", "cmscomponents-product", "cmscomponents-teaser-member", "cmscomponents-pagination", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-icon-reload", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-button", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-home-mbw": ["atoms-alert", "cmscomponents-stage", "cmscomponents-teaser-member", "cmscomponents-howitworks", "cmscomponents-teaserbox-slider", "cmscomponents-teaserbox-slider", "cmscomponents-marquee", "cmscomponents-listboxteaser", "cmscomponents-promoteaser", "cmscomponents-teaserbox-slider", "cmscomponents-listboxteaser", "cmscomponents-howitworks", "cmscomponents-teaserbox-slider", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "atoms-button", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "cmscomponents-listboxteaser-content", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-orders-detail-mbw": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "cmscomponents-orders-detail-mbw", "atoms-badge", "atoms-headline", "cmscomponents-address", "atoms-headline", "atoms-order-detail-item", "atoms-summary", "cmscomponents-address", "atoms-badge", "atoms-toggle-state", "atoms-csrf", "atoms-pricetag", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-add-to-cart", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-csrf", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-productdetail-mbw": ["cmscomponents-breadcrumb", "cmscomponents-product-header", "cmscomponents-teaserbox-slider", "cmscomponents-promoteaser", "cmscomponents-teaserbox-slider", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "cmscomponents-stageproduct-extended", "cmscomponents-product-specifications", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-video", "atoms-badge", "atoms-csrf", "atoms-toggle-state", "atoms-icon-reload", "atoms-pricetag", "cmscomponents-product-settings", "atoms-dropdown", "atoms-button", "cmscomponents-dialog-error", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-button", "atoms-icon-arrow-thick", "atoms-textlink", "atoms-alert", "atoms-file-attachment", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-tooltip", "atoms-icon-no", "atoms-button", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-service-overview-mbw": ["cmscomponents-stagecontent-mhl", "cmscomponents-listboxteaser", "cmscomponents-promoteaser", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-teaserbox-slider", "cmscomponents-newsletter", "cmscomponents-customer-opinion", "atoms-button", "cmscomponents-listboxteaser-content", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-your-orders-and-contracts-mbw": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline", "atoms-paragraph", "templates-filtered-tile-list", "cmscomponents-moreinfo", "cmscomponents-context-options", "cmscomponents-utility-bar", "cmscomponents-tile-list", "atoms-headline", "atoms-expander", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-no", "atoms-form-loading", "atoms-icon-no", "atoms-dropdown", "atoms-checkbox", "atoms-input-datepicker", "cmscomponents-show-more", "atoms-tag", "atoms-button", "atoms-input", "atoms-icon-remove-dark", "atoms-icon-arrow", "atoms-dropdown", "atoms-tag", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-arrow", "atoms-icon-reload", "atoms-tooltip", "atoms-tag", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-productdetail-mtsuk": ["cmscomponents-pageheader-productdetail", "cmscomponents-howitworks", "cmscomponents-teaserbox", "cmscomponents-promoteaser", "cmscomponents-newsletter", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-totopbig", "cmscomponents-moreinfo", "cmscomponents-stageproduct", "cmscomponents-teaserbox", "cmscomponents-availabilityzone", "cmscomponents-support-product", "cmscomponents-availabilitycheck", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-headline", "atoms-expander", "atoms-video", "atoms-pricetag", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-arrow", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-needanalyser-contact": ["cmscomponents-needanalyser-contact", "cmscomponents-progressbar", "cmscomponents-listbox", "cmscomponents-support", "cmscomponents-form-contact", "atoms-button", "atoms-icon-refresh", "atoms-benefit", "atoms-icon-phone", "atoms-button", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-needanalyser-product-contact": ["cmscomponents-needanalyser-product-contact", "cmscomponents-progressbar", "cmscomponents-form-contact", "atoms-button", "atoms-icon-refresh", "cmscomponents-availabilitycheck", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button"],
  "templates-needanalyser-product": ["cmscomponents-textmedia", "cmscomponents-needanalyser-product", "cmscomponents-textmedia", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "cmscomponents-progressbar", "cmscomponents-productrate", "atoms-button", "atoms-icon-refresh", "cmscomponents-availabilitycheck", "atoms-icon-reload", "atoms-icons", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip"],
  "templates-needanalyser-widget": ["cmscomponents-needanalyser", "cmscomponents-stage", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons"],
  "templates-needanalyser": ["cmscomponents-needanalyser", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons"],
  "templates-order-stop": ["atoms-alert-warning", "cmscomponents-pageheader-support", "cmscomponents-stagecontent-mhl", "cmscomponents-support-product", "cmscomponents-moreinfo", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-headline", "atoms-expander", "atoms-icon-reload", "atoms-icons", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-original-contracts-DEPRECATED": ["cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-original-contracts", "atoms-paragraph", "cmscomponents-moreinfo", "atoms-alert", "atoms-badge", "atoms-file-attachment", "atoms-headline", "atoms-expander", "atoms-icon-arrow"],
  "templates-original-contracts": ["cmscomponents-breadcrumb", "atoms-headline", "cmscomponents-tile-list", "atoms-paragraph", "cmscomponents-moreinfo", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-headline", "atoms-expander", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload", "atoms-icon-arrow"],
  "templates-page-navigation": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "atoms-headline"],
  "templates-popup-contact": ["atoms-icon-phone", "cmscomponents-form-contact", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-tooltip", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-productoverview": ["cmscomponents-pageheader-productoverview", "cmscomponents-howitworks", "cmscomponents-promoteaser", "cmscomponents-newsletter", "cmscomponents-textmedia", "cmscomponents-videocomponent", "cmscomponents-presscomments", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-moreinfo", "cmscomponents-stagecontent", "cmscomponents-teaserproduct", "atoms-button", "atoms-button", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-video", "atoms-presscomment", "atoms-button", "atoms-headline", "atoms-expander", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-productrates": ["cmscomponents-productrate", "cmscomponents-productrate", "cmscomponents-availabilitycheck", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-refinement": ["cmscomponents-textmedia", "cmscomponents-form-contact", "atoms-button", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-registration-confirmation": ["cmscomponents-registration-confirmation", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-registration-extended": ["cmscomponents-registration-extended", "atoms-alert-warning", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-registration-short": ["cmscomponents-form-registration-short-step2", "atoms-alert", "atoms-input-password", "atoms-checkbox", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-registration": ["cmscomponents-registration", "atoms-alert-warning", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-resetpassword-micro-header": ["cmscomponents-micro-header", "templates-resetpassword", "cmscomponents-footer", "atoms-icon-logo", "cmscomponents-form-resetpassword", "atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-dropdown", "atoms-icon-facebook", "atoms-icon-twitter", "atoms-icon-youtube", "atoms-icon-linkedin", "atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-csrf", "atoms-alert-warning", "atoms-input-password", "atoms-button", "atoms-icon-arrow", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-resetpassword-whitelabel": ["templates-resetpassword", "cmscomponents-form-resetpassword", "atoms-csrf", "atoms-alert-warning", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-resetpassword": ["cmscomponents-form-resetpassword", "atoms-csrf", "atoms-alert-warning", "atoms-input-password", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-error-500": ["cmscomponents-errorpage-fonts", "cmscomponents-micro-header", "cmscomponents-errorpage", "atoms-icon-logo", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-error-501": ["cmscomponents-errorpage-fonts", "cmscomponents-micro-header", "cmscomponents-errorpage", "atoms-icon-logo", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-error-503": ["cmscomponents-errorpage-fonts", "cmscomponents-micro-header", "cmscomponents-errorpage", "atoms-icon-logo", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-maintenance": ["cmscomponents-errorpage-fonts", "cmscomponents-micro-header", "cmscomponents-errorpage", "atoms-icon-logo", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-serviceticket-detail": ["cmscomponents-breadcrumb", "cmscomponents-serviceticket-detail", "atoms-alert", "cmscomponents-serviceticket-detail-item", "cmscomponents-wearer-products", "atoms-file-attachment", "cmscomponents-serviceticket-detail-placeholder", "cmscomponents-serviceticket-detail-assignee", "cmscomponents-serviceticket-detail-comments", "atoms-badge", "atoms-icon-product", "atoms-icon-product", "atoms-alert", "atoms-placeholder", "atoms-icon-add", "cmscomponents-form-serviceticket", "atoms-icon-yes", "cmscomponents-serviceticket-detail-comments-placeholder", "atoms-serviceticket-detail-comments-entry", "cmscomponents-serviceticket-detail-comments-placeholder", "cmscomponents-dialog-success", "atoms-form-loading", "atoms-checkbox", "atoms-dropdown", "atoms-alert", "atoms-csrf", "cmscomponents-dialog-error", "atoms-headline", "atoms-paragraph", "atoms-form-loading", "atoms-input", "atoms-textarea", "atoms-icon-add", "cmscomponents-upload", "atoms-button", "atoms-button", "atoms-placeholder", "atoms-icon-mewa-profile", "atoms-icon-user-loggedin", "atoms-file-attachment", "atoms-icon-yes", "atoms-button", "atoms-icon-reload", "atoms-tooltip", "atoms-icon-no", "atoms-button", "atoms-tooltip", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-serviceticket-overview": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "cmscomponents-image-header", "cmscomponents-tile-list", "cmscomponents-context-options", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "templates-stagecontent-mhl": ["cmscomponents-stagecontent-mhl", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-stagecontent": ["cmscomponents-stagecontent"],
  "templates-standardcontent": ["cmscomponents-textmedia", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-support": ["cmscomponents-pageheader-support", "cmscomponents-textmedia", "cmscomponents-howitworks", "cmscomponents-newsletter", "cmscomponents-stagecontent-mhl", "cmscomponents-support-product", "cmscomponents-moreinfo", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-headline", "atoms-expander", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-icon-arrow", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-alert": ["atoms-alert", "atoms-alert", "atoms-alert", "atoms-alert"],
  "templates-test-availabilityzone": ["cmscomponents-availabilityzone", "cmscomponents-availabilitycheck", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-buttons": ["atoms-button", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-customerid": ["cmscomponents-customerid"],
  "templates-test-dropdown-modal": ["atoms-dropdown", "atoms-tooltip"],
  "templates-test-expander": ["cmscomponents-expander", "atoms-expander", "atoms-icon-arrow"],
  "templates-test-follow-up-products": ["cmscomponents-follow-up-product", "atoms-badge", "atoms-pricetag"],
  "templates-test-footer-css": ["atoms-headline"],
  "templates-test-footer": ["cmscomponents-footer", "atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-dropdown", "atoms-icon-facebook", "atoms-icon-twitter", "atoms-icon-youtube", "atoms-icon-linkedin", "atoms-totop", "atoms-icon-ssl", "atoms-icon-shield", "atoms-icon-arrow", "atoms-tooltip"],
  "templates-test-howitworks": ["cmscomponents-howitworks", "cmscomponents-howitworks"],
  "templates-test-moreinfo": ["cmscomponents-moreinfo", "atoms-headline", "atoms-expander", "atoms-icon-arrow"],
  "templates-test-newsletter": ["cmscomponents-newsletter", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-pageheader-productdetail": ["cmscomponents-pageheader-productdetail", "cmscomponents-stageproduct", "cmscomponents-teaserbox", "cmscomponents-availabilityzone", "cmscomponents-support-product", "cmscomponents-availabilitycheck", "atoms-video", "atoms-pricetag", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-icon-phone", "atoms-icon-contact-form", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-paragraph": ["cmscomponents-paragraph", "atoms-paragraph"],
  "templates-test-presscomments": ["cmscomponents-presscomments", "atoms-presscomment", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-product-stage": ["cmscomponents-stageproduct", "atoms-video", "atoms-pricetag"],
  "templates-test-productrate": ["cmscomponents-productrate", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-promoteaser": ["cmscomponents-promoteaser", "cmscomponents-promoteaser", "atoms-button", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-registration": ["cmscomponents-registration", "atoms-alert-warning", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-button", "atoms-csrf", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-stagecontent-mhl": ["cmscomponents-stagecontent-mhl", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-support-product": ["cmscomponents-support-product", "atoms-icon-phone", "atoms-icon-contact-form"],
  "templates-test-teaserbox-slider": ["cmscomponents-teaserbox-slider", "cmscomponents-product-highlight", "cmscomponents-teaser-slider", "cmscomponents-textmedia", "atoms-teaser-category", "atoms-teaser", "cmscomponents-teaserproduct", "cmscomponents-product", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-reload", "atoms-icons", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-teaserbox": ["cmscomponents-teaserbox", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-teaserproduct": ["cmscomponents-teaserproduct", "cmscomponents-teaserproduct", "cmscomponents-teaserproduct", "cmscomponents-teaserproduct", "cmscomponents-teaserproduct", "cmscomponents-teaserproduct", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-teaserproducts": ["cmscomponents-teaserproduct", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-textmedia": ["cmscomponents-textmedia", "cmscomponents-textmedia", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-video": ["cmscomponents-videocomponent", "atoms-video"],
  "templates-test-welcome-header": [],
  "templates-test": [],
  "templates-test-marquee-mhl": ["cmscomponents-marquee"],
  "templates-test-teaser-category": ["atoms-teaser-category"],
  "templates-test-teaser-member": ["cmscomponents-teaser-member", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-test-teaser-promo-small": ["cmscomponents-teaser-promo-small", "atoms-button", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-testbox": ["cmscomponents-stagecontent", "cmscomponents-testbox", "cmscomponents-needanalyser", "cmscomponents-textmedia", "cmscomponents-howitworks", "cmscomponents-newsletter", "cmscomponents-listboxteaser", "atoms-radio", "atoms-radio", "atoms-radio", "cmscomponents-form-contact", "atoms-headline", "cmscomponents-progressbar", "atoms-headline", "atoms-icons", "atoms-button", "atoms-icon-refresh", "atoms-icon-yes", "atoms-icon-no", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "cmscomponents-listboxteaser-content", "atoms-csrf", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-dropdown", "atoms-input", "atoms-input", "atoms-input", "atoms-input", "atoms-textarea", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-reload", "atoms-icons", "atoms-tooltip", "atoms-teaser-text", "atoms-teaser-category", "cmscomponents-product", "atoms-teaser-section", "atoms-tooltip", "atoms-toggle-state", "atoms-csrf", "atoms-badge", "atoms-icon-reload", "cmscomponents-color-variants", "cmscomponents-product-details", "cmscomponents-product-settings", "cmscomponents-product-details", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-delivery-time", "atoms-discontinued-product-text"],
  "templates-twocolumn": [],
  "templates-unavailable": ["cmscomponents-unavailable", "atoms-csrf", "atoms-input", "atoms-button", "atoms-button", "cmscomponents-availabilityzone", "cmscomponents-availabilitycheck", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-csrf", "cmscomponents-dialog-error", "cmscomponents-dialog-success", "atoms-input", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-radio", "atoms-button", "atoms-button", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big", "atoms-icon-no", "atoms-button", "atoms-icon-yes", "atoms-button"],
  "templates-wearer-detail": ["cmscomponents-page-navigation", "cmscomponents-breadcrumb", "cmscomponents-image-header", "cmscomponents-tile-list", "atoms-paragraph", "cmscomponents-context-options", "atoms-headline", "atoms-paragraph", "atoms-tile", "cmscomponents-pagination", "atoms-form-loading", "atoms-icon-add", "atoms-edit-flyout", "atoms-icon-bell", "atoms-badge", "atoms-pricetag", "atoms-edit-flyout", "atoms-file-attachment", "atoms-icon-arrow", "atoms-icon-arrow-big-end", "atoms-icon-arrow-big", "atoms-icon-arrow-big", "atoms-icon-arrow-big-end", "atoms-icon-reload"],
  "templates-welcome-header": ["cmscomponents-welcome-header", "cmscomponents-welcome", "cmscomponents-customerid"],
  "templates-welcome": ["cmscomponents-welcome"],
  "templates-why-mewa-service": ["cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-textmedia", "cmscomponents-tableprocontra", "cmscomponents-videocomponent", "cmscomponents-presscomments", "cmscomponents-teaserbox", "cmscomponents-newsletter", "atoms-button", "cmscomponents-customer-opinion", "atoms-file-attachment", "atoms-button", "atoms-video", "atoms-tableprocontra", "atoms-video", "atoms-presscomment", "atoms-button", "cmscomponents-teaserproduct", "cmscomponents-productrate", "atoms-button", "atoms-badge", "atoms-icon-megaphone", "atoms-csrf", "atoms-input", "atoms-button", "atoms-alert-warning", "atoms-alert-success", "atoms-alert", "atoms-icon-reload", "atoms-icons", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-button", "atoms-badge", "atoms-pricetag", "atoms-button", "atoms-tooltip", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"],
  "templates-wishlist": ["atoms-headline", "cmscomponents-wishlist", "atoms-alert", "atoms-icon-reload", "atoms-pricetag", "atoms-icon-reload", "atoms-pricetag", "atoms-csrf", "atoms-csrf", "atoms-dropdown", "atoms-button", "atoms-delivery-time", "atoms-discontinued-product-text", "atoms-csrf", "atoms-button", "atoms-tooltip", "atoms-icon-reload", "atoms-icons", "atoms-icon-add", "atoms-icon-arrow", "atoms-icon-attachment", "atoms-icon-bell", "atoms-icon-cart-empty", "atoms-icon-cart-filled", "atoms-icon-delete", "atoms-icon-edit", "atoms-icon-facebook", "atoms-icon-gotit", "atoms-icon-info", "atoms-icon-linkedin", "atoms-icon-logo", "atoms-icon-mastercard", "atoms-icon-megaphone", "atoms-icon-oil", "atoms-icon-paypal", "atoms-icon-pdf", "atoms-icon-phone", "atoms-icon-print", "atoms-icon-printink", "atoms-icon-refresh", "atoms-icon-reload", "atoms-icon-reply", "atoms-icon-service", "atoms-icon-shield", "atoms-icon-ssl", "atoms-icon-twitter", "atoms-icon-user", "atoms-icon-user-loggedin", "atoms-icon-visa", "atoms-icon-youtube", "atoms-icon-heart", "atoms-icon-heart-empty", "atoms-icon-delivery-point", "atoms-icon-arrow-big"]
};
exports.templateDependencies = templateDependencies;

},{}],234:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templatePaths = void 0;
var templatePaths = {
  'atoms-add-to-cart': '01-atoms/add-to-cart/add-to-cart',
  'atoms-alert-info': '01-atoms/alert/alert-info',
  'atoms-alert-success': '01-atoms/alert/alert-success',
  'atoms-alert-warning': '01-atoms/alert/alert-warning',
  'atoms-alert': '01-atoms/alert/alert',
  'atoms-amount': '01-atoms/amount',
  'atoms-attachment': '01-atoms/attachment',
  'atoms-badge': '01-atoms/badge/badge',
  'atoms-benefit': '01-atoms/benefit',
  'atoms-button': '01-atoms/button/button',
  'atoms-cart-counter': '01-atoms/cart-counter/cart-counter',
  'atoms-cart-notification': '01-atoms/cart-notification/cart-notification',
  'atoms-checkbox': '01-atoms/checkbox/checkbox',
  'atoms-csrf': '01-atoms/csrf',
  'atoms-delivery-item': '01-atoms/delivery-item',
  'atoms-delivery-time': '01-atoms/delivery-time/delivery-time',
  'atoms-dialog': '01-atoms/dialog',
  'atoms-discontinued-product-text': '01-atoms/discontinued-product-text/discontinued-product-text',
  'atoms-dropdown': '01-atoms/dropdown/dropdown',
  'atoms-dropdown-form': '01-atoms/dropdown-form',
  'atoms-edit-flyout': '01-atoms/edit-flyout/edit-flyout',
  'atoms-expander': '01-atoms/expander/expander',
  'atoms-file-attachment': '01-atoms/file-attachment/file-attachment',
  'atoms-form-loading': '01-atoms/form-loading/form-loading',
  'atoms-headline': '01-atoms/headline/headline',
  'atoms-icon-product': '01-atoms/icon-product/icon-product',
  'atoms-icon-add': '01-atoms/icons/icon-add',
  'atoms-icon-arrow-big-end': '01-atoms/icons/icon-arrow-big-end',
  'atoms-icon-arrow-big': '01-atoms/icons/icon-arrow-big',
  'atoms-icon-arrow-thick': '01-atoms/icons/icon-arrow-thick',
  'atoms-icon-arrow': '01-atoms/icons/icon-arrow',
  'atoms-icon-attachment': '01-atoms/icons/icon-attachment',
  'atoms-icon-bell': '01-atoms/icons/icon-bell',
  'atoms-icon-cart-empty': '01-atoms/icons/icon-cart-empty',
  'atoms-icon-cart-filled': '01-atoms/icons/icon-cart-filled',
  'atoms-icon-clock': '01-atoms/icons/icon-clock',
  'atoms-icon-contact-form': '01-atoms/icons/icon-contact-form',
  'atoms-icon-delete': '01-atoms/icons/icon-delete',
  'atoms-icon-delivery-point': '01-atoms/icons/icon-delivery-point',
  'atoms-icon-dummy': '01-atoms/icons/icon-dummy',
  'atoms-icon-edit': '01-atoms/icons/icon-edit',
  'atoms-icon-facebook': '01-atoms/icons/icon-facebook',
  'atoms-icon-gotit': '01-atoms/icons/icon-gotit',
  'atoms-icon-heart-empty': '01-atoms/icons/icon-heart-empty',
  'atoms-icon-heart': '01-atoms/icons/icon-heart',
  'atoms-icon-info': '01-atoms/icons/icon-info',
  'atoms-icon-linkedin': '01-atoms/icons/icon-linkedin',
  'atoms-icon-logo': '01-atoms/icons/icon-logo',
  'atoms-icon-logout': '01-atoms/icons/icon-logout',
  'atoms-icon-mastercard': '01-atoms/icons/icon-mastercard',
  'atoms-icon-megaphone': '01-atoms/icons/icon-megaphone',
  'atoms-icon-menu': '01-atoms/icons/icon-menu',
  'atoms-icon-mewa-profile': '01-atoms/icons/icon-mewa-profile',
  'atoms-icon-mewa': '01-atoms/icons/icon-mewa',
  'atoms-icon-no': '01-atoms/icons/icon-no',
  'atoms-icon-oil': '01-atoms/icons/icon-oil',
  'atoms-icon-paypal': '01-atoms/icons/icon-paypal',
  'atoms-icon-pdf': '01-atoms/icons/icon-pdf',
  'atoms-icon-phone': '01-atoms/icons/icon-phone',
  'atoms-icon-print': '01-atoms/icons/icon-print',
  'atoms-icon-printink': '01-atoms/icons/icon-printink',
  'atoms-icon-referenztraeger': '01-atoms/icons/icon-referenztraeger',
  'atoms-icon-refresh': '01-atoms/icons/icon-refresh',
  'atoms-icon-reload': '01-atoms/icons/icon-reload',
  'atoms-icon-remove-dark': '01-atoms/icons/icon-remove-dark',
  'atoms-icon-reply': '01-atoms/icons/icon-reply',
  'atoms-icon-service': '01-atoms/icons/icon-service',
  'atoms-icon-shield': '01-atoms/icons/icon-shield',
  'atoms-icon-ssl': '01-atoms/icons/icon-ssl',
  'atoms-icon-tauschort': '01-atoms/icons/icon-tauschort',
  'atoms-icon-twitter': '01-atoms/icons/icon-twitter',
  'atoms-icon-user-loggedin': '01-atoms/icons/icon-user-loggedin',
  'atoms-icon-user': '01-atoms/icons/icon-user',
  'atoms-icon-visa': '01-atoms/icons/icon-visa',
  'atoms-icon-yes': '01-atoms/icons/icon-yes',
  'atoms-icon-youtube': '01-atoms/icons/icon-youtube',
  'atoms-icons-editorial': '01-atoms/icons/icons-editorial',
  'atoms-icons': '01-atoms/icons/icons',
  'atoms-input': '01-atoms/input/input',
  'atoms-input-datepicker': '01-atoms/input-datepicker/input-datepicker',
  'atoms-input-password': '01-atoms/input-password/input-password',
  'atoms-order-detail-item': '01-atoms/order-detail-item/order-detail-item',
  'atoms-paragraph': '01-atoms/paragraph/paragraph',
  'atoms-placeholder': '01-atoms/placeholder/placeholder',
  'atoms-presscomment': '01-atoms/presscomment',
  'atoms-pricetag': '01-atoms/pricetag/pricetag',
  'atoms-print': '01-atoms/print',
  'atoms-productoptiontile': '01-atoms/productoptiontile',
  'atoms-radio': '01-atoms/radio/radio',
  'atoms-serviceticket-detail-comments-entry': '01-atoms/serviceticket-detail-comments-entry/serviceticket-detail-comments-entry',
  'atoms-summary': '01-atoms/summary/summary',
  'atoms-tableprocontra': '01-atoms/tableprocontra',
  'atoms-tag': '01-atoms/tag/tag',
  'atoms-teaser-category': '01-atoms/teaser-category/teaser-category',
  'atoms-teaser-section': '01-atoms/teaser-section/teaser-section',
  'atoms-teaser-text': '01-atoms/teaser-text',
  'atoms-teaser': '01-atoms/teaser',
  'atoms-textarea': '01-atoms/textarea',
  'atoms-textlink': '01-atoms/textlink/textlink',
  'atoms-tile': '01-atoms/tile/tile',
  'atoms-toggle-state': '01-atoms/toggle-state/toggle-state',
  'atoms-tooltip': '01-atoms/tooltip/tooltip',
  'atoms-totop': '01-atoms/totop',
  'atoms-video': '01-atoms/video/video',
  'atoms-wishlist-notification': '01-atoms/wishlist-notification/wishlist-notification',
  'atoms-your-order-and-contract-noimg': '01-atoms/your-order-and-contract/your-order-and-contract-noimg',
  'atoms-your-order-and-contract': '01-atoms/your-order-and-contract/your-order-and-contract',
  'cmscomponents-account': '02-cmscomponents/account/account',
  'cmscomponents-account-contact-person': '02-cmscomponents/account-contact-person/account-contact-person',
  'cmscomponents-account-owner': '02-cmscomponents/account-owner/account-owner',
  'cmscomponents-account-payment': '02-cmscomponents/account-payment/account-payment',
  'cmscomponents-address': '02-cmscomponents/address/address',
  'cmscomponents-anchor-nav': '02-cmscomponents/anchor-nav/anchor-nav',
  'cmscomponents-assisted-service-mode': '02-cmscomponents/assisted-service-mode/assisted-service-mode',
  'cmscomponents-availabilitycheck': '02-cmscomponents/availabilitycheck/availabilitycheck',
  'cmscomponents-availabilityzone': '02-cmscomponents/availabilityzone',
  'cmscomponents-breadcrumb': '02-cmscomponents/breadcrumb/breadcrumb',
  'cmscomponents-button-ghost': '02-cmscomponents/button-ghost',
  'cmscomponents-button-primary': '02-cmscomponents/button-primary',
  'cmscomponents-button-secondary': '02-cmscomponents/button-secondary',
  'cmscomponents-cart-empty': '02-cmscomponents/cart/cart-empty',
  'cmscomponents-cart-oci': '02-cmscomponents/cart/cart-oci',
  'cmscomponents-cart': '02-cmscomponents/cart/cart',
  'cmscomponents-categories': '02-cmscomponents/categories/categories',
  'cmscomponents-checkout-aboutyou': '02-cmscomponents/checkout/checkout-aboutyou',
  'cmscomponents-checkout-confirm': '02-cmscomponents/checkout/checkout-confirm',
  'cmscomponents-checkout-payment': '02-cmscomponents/checkout/checkout-payment',
  'cmscomponents-checkout-submit': '02-cmscomponents/checkout/checkout-submit',
  'cmscomponents-checkout-success': '02-cmscomponents/checkout/checkout-success',
  'cmscomponents-checkout-confirmation-mbw': '02-cmscomponents/checkout-mbw/checkout-confirmation-mbw',
  'cmscomponents-checkout-delivery-mbw': '02-cmscomponents/checkout-mbw/checkout-delivery-mbw',
  'cmscomponents-checkout-payment-mbw': '02-cmscomponents/checkout-mbw/checkout-payment-mbw',
  'cmscomponents-choose-address-extension': '02-cmscomponents/checkout-mbw/choose-address-extension',
  'cmscomponents-choose-address': '02-cmscomponents/checkout-mbw/choose-address',
  'cmscomponents-temporary-address-form': '02-cmscomponents/checkout-mbw/temporary-address-form',
  'cmscomponents-color-variants': '02-cmscomponents/color-variants/color-variants',
  'cmscomponents-comment': '02-cmscomponents/comment',
  'cmscomponents-contact-settings': '02-cmscomponents/contact-settings',
  'cmscomponents-context-options': '02-cmscomponents/context-options/context-options',
  'cmscomponents-contractual-quantities-options': '02-cmscomponents/contractual-quantities-options/contractual-quantities-options',
  'cmscomponents-country-selection': '02-cmscomponents/country-selection/country-selection',
  'cmscomponents-css-account': '02-cmscomponents/css/css-account',
  'cmscomponents-css-contracts': '02-cmscomponents/css/css-contracts',
  'cmscomponents-css-invoices': '02-cmscomponents/css/css-invoices',
  'cmscomponents-customer-opinion': '02-cmscomponents/customer-opinion',
  'cmscomponents-customer-service-contact': '02-cmscomponents/customer-service/customer-service-contact',
  'cmscomponents-customer-service': '02-cmscomponents/customer-service/customer-service',
  'cmscomponents-customerid': '02-cmscomponents/customerid',
  'cmscomponents-deliveries': '02-cmscomponents/deliveries/deliveries',
  'cmscomponents-delivery-point-flyout': '02-cmscomponents/delivery-point-flyout/delivery-point-flyout',
  'cmscomponents-delivery-quantities-detail': '02-cmscomponents/delivery-quantities-detail/delivery-quantities-detail',
  'cmscomponents-dialog-error': '02-cmscomponents/dialog-error',
  'cmscomponents-dialog-success': '02-cmscomponents/dialog-success',
  'cmscomponents-dialog-warning': '02-cmscomponents/dialog-warning/dialog-warning',
  'cmscomponents-errorpage-fonts': '02-cmscomponents/errorpage/errorpage-fonts',
  'cmscomponents-errorpage': '02-cmscomponents/errorpage/errorpage',
  'cmscomponents-expander': '02-cmscomponents/expander',
  'cmscomponents-faq': '02-cmscomponents/faq/faq',
  'cmscomponents-filter': '02-cmscomponents/filter/filter',
  'cmscomponents-filter-search': '02-cmscomponents/filter-search/filter-search',
  'cmscomponents-entry': '02-cmscomponents/flyout/entry',
  'cmscomponents-flyout-content': '02-cmscomponents/flyout/flyout-content',
  'cmscomponents-flyout': '02-cmscomponents/flyout/flyout',
  'cmscomponents-image-text-teaser': '02-cmscomponents/flyout/image-text-teaser',
  'cmscomponents-title-image-text': '02-cmscomponents/flyout/title-image-text',
  'cmscomponents-follow-up-product': '02-cmscomponents/follow-up-product/follow-up-product',
  'cmscomponents-form-buttons': '02-cmscomponents/form/form-buttons',
  'cmscomponents-form-message': '02-cmscomponents/form/form-message',
  'cmscomponents-form-aboutyou': '02-cmscomponents/form-aboutyou',
  'cmscomponents-form-billing': '02-cmscomponents/form-billing',
  'cmscomponents-form-change-article-deregister-wearer': '02-cmscomponents/form-change-article-deregister-wearer/form-change-article-deregister-wearer',
  'cmscomponents-form-changepassword': '02-cmscomponents/form-changepassword/form-changepassword',
  'cmscomponents-form-confirm': '02-cmscomponents/form-confirm/form-confirm',
  'cmscomponents-form-confirmation': '02-cmscomponents/form-confirmation/form-confirmation',
  'cmscomponents-form-enterprise': '02-cmscomponents/form-enterprise',
  'cmscomponents-form-header': '02-cmscomponents/form-header/form-header',
  'cmscomponents-form-login': '02-cmscomponents/form-login/form-login',
  'cmscomponents-form-lostpassword': '02-cmscomponents/form-lostpassword',
  'cmscomponents-form-new-wearer': '02-cmscomponents/form-new-wearer/form-new-wearer',
  'cmscomponents-form-payment': '02-cmscomponents/form-payment',
  'cmscomponents-form-registration': '02-cmscomponents/form-registration/form-registration',
  'cmscomponents-form-registration-short-step2': '02-cmscomponents/form-registration-short-step2',
  'cmscomponents-form-registration-short': '02-cmscomponents/form-registration-short',
  'cmscomponents-form-repair-report': '02-cmscomponents/form-repair-report/form-repair-report',
  'cmscomponents-form-resetpassword': '02-cmscomponents/form-resetpassword',
  'cmscomponents-form-serviceticket': '02-cmscomponents/form-serviceticket/form-serviceticket',
  'cmscomponents-form-contact': '02-cmscomponents/forms/form-contact',
  'cmscomponents-footer': '02-cmscomponents/global/footer',
  'cmscomponents-header-css': '02-cmscomponents/global/header-css',
  'cmscomponents-header': '02-cmscomponents/global/header',
  'cmscomponents-global-account-box-header': '02-cmscomponents/global-account-box-header/global-account-box-header',
  'cmscomponents-global-account-box-list': '02-cmscomponents/global-account-box-list/global-account-box-list',
  'cmscomponents-header-cssitems': '02-cmscomponents/header-extended/header-cssitems',
  'cmscomponents-header-extended': '02-cmscomponents/header-extended/header-extended',
  'cmscomponents-header-icons': '02-cmscomponents/header-extended/header-icons',
  'cmscomponents-header-login-flyout': '02-cmscomponents/header-extended/header-login-flyout',
  'cmscomponents-header-navitems': '02-cmscomponents/header-extended/header-navitems',
  'cmscomponents-header-minimal-css': '02-cmscomponents/header-minimal-css',
  'cmscomponents-header-promo': '02-cmscomponents/header-promo/header-promo',
  'cmscomponents-headline': '02-cmscomponents/headline',
  'cmscomponents-howitworks': '02-cmscomponents/howitworks/howitworks',
  'cmscomponents-image-header': '02-cmscomponents/image-header/image-header',
  'cmscomponents-invoiceDelivery': '02-cmscomponents/invoiceDelivery',
  'cmscomponents-listbox': '02-cmscomponents/listbox',
  'cmscomponents-listboxteaser': '02-cmscomponents/listboxteaser/listboxteaser',
  'cmscomponents-listboxteaser-content': '02-cmscomponents/listboxteaser-content',
  'cmscomponents-login': '02-cmscomponents/login/login',
  'cmscomponents-login-dialog': '02-cmscomponents/login-dialog/login-dialog',
  'cmscomponents-login-flyout': '02-cmscomponents/login-flyout/login-flyout',
  'cmscomponents-marquee': '02-cmscomponents/marquee/marquee',
  'cmscomponents-micro-footer': '02-cmscomponents/micro-footer',
  'cmscomponents-micro-header': '02-cmscomponents/micro-header',
  'cmscomponents-minibasket': '02-cmscomponents/minibasket/minibasket',
  'cmscomponents-moreinfo': '02-cmscomponents/moreinfo/moreinfo',
  'cmscomponents-needanalyser-contact': '02-cmscomponents/needanalyzer/needanalyser-contact',
  'cmscomponents-needanalyser-product-contact': '02-cmscomponents/needanalyzer/needanalyser-product-contact',
  'cmscomponents-needanalyser-product': '02-cmscomponents/needanalyzer/needanalyser-product',
  'cmscomponents-needanalyser': '02-cmscomponents/needanalyzer/needanalyser',
  'cmscomponents-newsletter': '02-cmscomponents/newsletter',
  'cmscomponents-orders-detail-mbw': '02-cmscomponents/orders-detail-mbw/orders-detail-mbw',
  'cmscomponents-ordersdetail': '02-cmscomponents/ordersdetail/ordersdetail',
  'cmscomponents-ordersdetail-downgrade': '02-cmscomponents/ordersdetail-downgrade/ordersdetail-downgrade',
  'cmscomponents-ordersdetail-durationchange': '02-cmscomponents/ordersdetail-durationchange',
  'cmscomponents-ordersdetail-upgrade': '02-cmscomponents/ordersdetail-upgrade/ordersdetail-upgrade',
  'cmscomponents-original-contracts': '02-cmscomponents/original-contracts/original-contracts',
  'cmscomponents-page-navigation': '02-cmscomponents/page-navigation/page-navigation',
  'cmscomponents-pageheader-productdetail': '02-cmscomponents/pageheader-productdetail',
  'cmscomponents-pageheader-productoverview': '02-cmscomponents/pageheader-productoverview',
  'cmscomponents-pageheader-support': '02-cmscomponents/pageheader-support',
  'cmscomponents-pagination': '02-cmscomponents/pagination/pagination',
  'cmscomponents-paragraph': '02-cmscomponents/paragraph',
  'cmscomponents-patch-selector': '02-cmscomponents/patch-selector/patch-selector',
  'cmscomponents-presscomments': '02-cmscomponents/presscomments',
  'cmscomponents-product-details': '02-cmscomponents/product/product-details',
  'cmscomponents-product': '02-cmscomponents/product/product',
  'cmscomponents-product-grid': '02-cmscomponents/product-grid/product-grid',
  'cmscomponents-product-header': '02-cmscomponents/product-header/product-header',
  'cmscomponents-product-highlight': '02-cmscomponents/product-highlight/product-highlight',
  'cmscomponents-product-settings': '02-cmscomponents/product-settings/product-settings',
  'cmscomponents-product-specifications': '02-cmscomponents/product-specifications/product-specifications',
  'cmscomponents-productrate': '02-cmscomponents/productrate',
  'cmscomponents-progressbar-advanced': '02-cmscomponents/progressbar-advanced/progressbar-advanced',
  'cmscomponents-progressbar': '02-cmscomponents/progressbar',
  'cmscomponents-promoteaser': '02-cmscomponents/promoteaser/promoteaser',
  'cmscomponents-registration-confirmation': '02-cmscomponents/registration-confirmation',
  'cmscomponents-registration-extended': '02-cmscomponents/registration-extended/registration-extended',
  'cmscomponents-registration': '02-cmscomponents/registration',
  'cmscomponents-search': '02-cmscomponents/search/search',
  'cmscomponents-search-local': '02-cmscomponents/search-local/search-local',
  'cmscomponents-serviceticket-detail-assignee': '02-cmscomponents/serviceticket-detail/serviceticket-detail-assignee',
  'cmscomponents-serviceticket-detail-comments-placeholder': '02-cmscomponents/serviceticket-detail/serviceticket-detail-comments-placeholder',
  'cmscomponents-serviceticket-detail-comments': '02-cmscomponents/serviceticket-detail/serviceticket-detail-comments',
  'cmscomponents-serviceticket-detail-item': '02-cmscomponents/serviceticket-detail/serviceticket-detail-item',
  'cmscomponents-serviceticket-detail-placeholder': '02-cmscomponents/serviceticket-detail/serviceticket-detail-placeholder',
  'cmscomponents-serviceticket-detail': '02-cmscomponents/serviceticket-detail/serviceticket-detail',
  'cmscomponents-shipping-confirmations': '02-cmscomponents/shipping-confirmations/shipping-confirmations',
  'cmscomponents-show-more': '02-cmscomponents/show-more/show-more',
  'cmscomponents-sort-filter': '02-cmscomponents/sort-filter/sort-filter',
  'cmscomponents-stage': '02-cmscomponents/stage/stage',
  'cmscomponents-stagecontent-mhl': '02-cmscomponents/stagecontent-mhl',
  'cmscomponents-stagecontent': '02-cmscomponents/stagecontent',
  'cmscomponents-stageproduct-extended': '02-cmscomponents/stageproduct/stageproduct-extended',
  'cmscomponents-stageproduct': '02-cmscomponents/stageproduct/stageproduct',
  'cmscomponents-support-product': '02-cmscomponents/support-product/support-product',
  'cmscomponents-support': '02-cmscomponents/support',
  'cmscomponents-tableprocontra': '02-cmscomponents/tableprocontra',
  'cmscomponents-teaser-member': '02-cmscomponents/teaser-member/teaser-member',
  'cmscomponents-teaser-promo-small': '02-cmscomponents/teaser-promo-small/teaser-promo-small',
  'cmscomponents-teaserbox': '02-cmscomponents/teaserbox/teaserbox',
  'cmscomponents-teaserbox-productrate': '02-cmscomponents/teaserbox-productrate',
  'cmscomponents-teaser-slider': '02-cmscomponents/teaserbox-slider/teaser-slider',
  'cmscomponents-teaserbox-slider': '02-cmscomponents/teaserbox-slider/teaserbox-slider',
  'cmscomponents-teaserproduct': '02-cmscomponents/teaserproduct/teaserproduct',
  'cmscomponents-testbox': '02-cmscomponents/testbox',
  'cmscomponents-textmedia': '02-cmscomponents/textmedia/textmedia',
  'cmscomponents-tile-list': '02-cmscomponents/tile-list/tile-list',
  'cmscomponents-totopbig': '02-cmscomponents/totopbig',
  'cmscomponents-unavailable': '02-cmscomponents/unavailable',
  'cmscomponents-upload': '02-cmscomponents/upload',
  'cmscomponents-utility-bar': '02-cmscomponents/utility-bar/utility-bar',
  'cmscomponents-verifyaccount': '02-cmscomponents/verifyaccount',
  'cmscomponents-videocomponent': '02-cmscomponents/videocomponent',
  'cmscomponents-wearer-products': '02-cmscomponents/wearer-products/wearer-products',
  'cmscomponents-welcome-header': '02-cmscomponents/welcome-header/welcome-header',
  'cmscomponents-welcome': '02-cmscomponents/welcome',
  'cmscomponents-wishlist': '02-cmscomponents/wishlist/wishlist',
  'cmscomponents-your-request-detail': '02-cmscomponents/your-request-detail',
  'templates-contract-quantities-detail': '03-templates/_smartedit/contract-quantities-detail',
  'templates-filtered-tile-list-ajax': '03-templates/_smartedit/filtered-tile-list-ajax',
  'templates-filtered-tile-list': '03-templates/_smartedit/filtered-tile-list',
  'templates-mewashop-teaser': '03-templates/_smartedit/mewashop-teaser',
  'templates-serviceticket-overview-with-image-header': '03-templates/_smartedit/serviceticket-overview-with-image-header',
  'templates-wearer-details-component': '03-templates/_smartedit/wearer-details-component',
  'templates-wearer-overview-component': '03-templates/_smartedit/wearer-overview-component',
  'templates-account-owner': '03-templates/account/account-owner',
  'templates-account-payment': '03-templates/account/account-payment',
  'templates-account': '03-templates/account/account',
  'templates-addresses': '03-templates/account/addresses',
  'templates-contact-settings': '03-templates/account/contact-settings',
  'templates-account-intro': '03-templates/account-intro/account-intro',
  'templates-account-intro-mts': '03-templates/account-intro-mts/account-intro-mts',
  'templates-branchen': '03-templates/branchen',
  'templates-cart-empty': '03-templates/cart/cart-empty',
  'templates-cart': '03-templates/cart/cart',
  'templates-checkout-aboutyou': '03-templates/checkout/checkout-aboutyou',
  'templates-checkout-confirm': '03-templates/checkout/checkout-confirm',
  'templates-checkout-confirmation-mbw': '03-templates/checkout/checkout-confirmation-mbw',
  'templates-checkout-delivery-mbw': '03-templates/checkout/checkout-delivery-mbw',
  'templates-checkout-payment-mbw': '03-templates/checkout/checkout-payment-mbw',
  'templates-checkout-payment-no-changes': '03-templates/checkout/checkout-payment-no-changes',
  'templates-checkout-payment': '03-templates/checkout/checkout-payment',
  'templates-checkout-success-mbw': '03-templates/checkout/checkout-success-mbw',
  'templates-checkout-success': '03-templates/checkout/checkout-success',
  'templates-company': '03-templates/company',
  'templates-contactform': '03-templates/contactform',
  'templates-content': '03-templates/content',
  'templates-contractual-quantities-detail': '03-templates/contractual-quantities-detail/contractual-quantities-detail',
  'templates-contractual-quantities-overview': '03-templates/contractual-quantities-overview/contractual-quantities-overview',
  'templates-country-selection': '03-templates/country-selection/country-selection',
  'templates-css-invoices-deprecated': '03-templates/css/css-invoices-deprecated',
  'templates-css-invoices': '03-templates/css/css-invoices',
  'templates-orders-detail': '03-templates/css/orders-detail',
  'templates-ordersandcontracts': '03-templates/css/ordersandcontracts',
  'templates-requestsdetail': '03-templates/css/requestsdetail',
  'templates-css-account': '03-templates/css-account',
  'templates-css-contracts': '03-templates/css-contracts',
  'templates-css-start': '03-templates/css-start',
  'templates-customer-base-data': '03-templates/customer-base-data/customer-base-data',
  'templates-customer-service': '03-templates/customer-service/customer-service',
  'templates-deliveries': '03-templates/deliveries/deliveries',
  'templates-delivery-quantities': '03-templates/delivery-quantities/delivery-quantities',
  'templates-delivery-quantities-detail': '03-templates/delivery-quantities-detail/delivery-quantities-detail',
  'templates-enterprise': '03-templates/enterprise',
  'templates-errorpage': '03-templates/errorpage/errorpage',
  'templates-faq': '03-templates/faq',
  'templates-form-change-article': '03-templates/form-change-article/form-change-article',
  'templates-form-contact-confirmation-whitelabel': '03-templates/form-contact-confirmation-whitelabel',
  'templates-form-contact-confirmation': '03-templates/form-contact-confirmation',
  'templates-form-deregister-wearer': '03-templates/form-deregister-wearer/form-deregister-wearer',
  'templates-form-new-wearer': '03-templates/form-new-wearer/form-new-wearer',
  'templates-form-repair-report': '03-templates/form-repair-report/form-repair-report',
  'templates-form-serviceticket': '03-templates/form-serviceticket/form-serviceticket',
  'templates-fst-css-account': '03-templates/fst/fst-css-account',
  'templates-header-css': '03-templates/header-css',
  'templates-header-extended': '03-templates/header-extended',
  'templates-header-minimal-css': '03-templates/header-minimal-css',
  'templates-headline': '03-templates/headline',
  'templates-home-wipe': '03-templates/home-wipe/home-wipe',
  'templates-home': '03-templates/home',
  'templates-invoices': '03-templates/invoices',
  'templates-login-dialog': '03-templates/login/login-dialog',
  'templates-login': '03-templates/login/login',
  'templates-verify-account': '03-templates/login/verify-account',
  'templates-login-css': '03-templates/login-css',
  'templates-login-flyout': '03-templates/login-flyout/login-flyout',
  'templates-logout': '03-templates/logout/logout',
  'templates-categorypage-mbw-no-breadcrumb': '03-templates/mbw/categorypage-mbw-no-breadcrumb',
  'templates-categorypage-mbw-nosidebar': '03-templates/mbw/categorypage-mbw-nosidebar',
  'templates-categorypage-mbw': '03-templates/mbw/categorypage-mbw',
  'templates-home-mbw': '03-templates/mbw/home-mbw',
  'templates-orders-detail-mbw': '03-templates/mbw/orders-detail-mbw',
  'templates-productdetail-mbw': '03-templates/mbw/productdetail-mbw',
  'templates-service-overview-mbw': '03-templates/mbw/service-overview-mbw',
  'templates-your-orders-and-contracts-mbw': '03-templates/mbw/your-orders-and-contracts-mbw',
  'templates-productdetail-mtsuk': '03-templates/mtsuk/productdetail-mtsuk',
  'templates-needanalyser-contact': '03-templates/needanalyser/needanalyser-contact',
  'templates-needanalyser-product-contact': '03-templates/needanalyser/needanalyser-product-contact',
  'templates-needanalyser-product': '03-templates/needanalyser/needanalyser-product',
  'templates-needanalyser-widget': '03-templates/needanalyser/needanalyser-widget',
  'templates-needanalyser': '03-templates/needanalyser/needanalyser',
  'templates-order-stop': '03-templates/order-stop',
  'templates-original-contracts-DEPRECATED': '03-templates/original-contracts/original-contracts-DEPRECATED',
  'templates-original-contracts': '03-templates/original-contracts/original-contracts',
  'templates-page-navigation': '03-templates/page-navigation/page-navigation',
  'templates-popup-contact': '03-templates/popup-contact',
  'templates-productoverview': '03-templates/productoverview',
  'templates-productrates': '03-templates/productrates',
  'templates-refinement': '03-templates/refinement',
  'templates-registration-confirmation': '03-templates/registration-confirmation',
  'templates-registration-extended': '03-templates/registration-extended',
  'templates-registration-short': '03-templates/registration-short',
  'templates-registration': '03-templates/registration',
  'templates-resetpassword-micro-header': '03-templates/resetpassword-micro-header/resetpassword-micro-header',
  'templates-resetpassword-whitelabel': '03-templates/resetpassword-whitelabel',
  'templates-resetpassword': '03-templates/resetpassword',
  'templates-error-500': '03-templates/servererror/error-500',
  'templates-error-501': '03-templates/servererror/error-501',
  'templates-error-503': '03-templates/servererror/error-503',
  'templates-maintenance': '03-templates/servererror/maintenance',
  'templates-serviceticket-detail': '03-templates/serviceticket-detail/serviceticket-detail',
  'templates-serviceticket-overview': '03-templates/serviceticket-overview/serviceticket-overview',
  'templates-stagecontent-mhl': '03-templates/stagecontent-mhl',
  'templates-stagecontent': '03-templates/stagecontent',
  'templates-standardcontent': '03-templates/standardcontent',
  'templates-support': '03-templates/support',
  'templates-test-alert': '03-templates/test/test-alert',
  'templates-test-availabilityzone': '03-templates/test/test-availabilityzone',
  'templates-test-buttons': '03-templates/test/test-buttons',
  'templates-test-customerid': '03-templates/test/test-customerid',
  'templates-test-dropdown-modal': '03-templates/test/test-dropdown-modal',
  'templates-test-expander': '03-templates/test/test-expander',
  'templates-test-follow-up-products': '03-templates/test/test-follow-up-products',
  'templates-test-footer-css': '03-templates/test/test-footer-css',
  'templates-test-footer': '03-templates/test/test-footer',
  'templates-test-howitworks': '03-templates/test/test-howitworks',
  'templates-test-moreinfo': '03-templates/test/test-moreinfo',
  'templates-test-newsletter': '03-templates/test/test-newsletter',
  'templates-test-pageheader-productdetail': '03-templates/test/test-pageheader-productdetail',
  'templates-test-paragraph': '03-templates/test/test-paragraph',
  'templates-test-presscomments': '03-templates/test/test-presscomments',
  'templates-test-product-stage': '03-templates/test/test-product-stage',
  'templates-test-productrate': '03-templates/test/test-productrate',
  'templates-test-promoteaser': '03-templates/test/test-promoteaser',
  'templates-test-registration': '03-templates/test/test-registration',
  'templates-test-stagecontent-mhl': '03-templates/test/test-stagecontent-mhl',
  'templates-test-support-product': '03-templates/test/test-support-product',
  'templates-test-teaserbox-slider': '03-templates/test/test-teaserbox-slider',
  'templates-test-teaserbox': '03-templates/test/test-teaserbox',
  'templates-test-teaserproduct': '03-templates/test/test-teaserproduct',
  'templates-test-teaserproducts': '03-templates/test/test-teaserproducts',
  'templates-test-textmedia': '03-templates/test/test-textmedia',
  'templates-test-video': '03-templates/test/test-video',
  'templates-test-welcome-header': '03-templates/test/test-welcome-header',
  'templates-test': '03-templates/test/test',
  'templates-test-marquee-mhl': '03-templates/test-marquee-mhl',
  'templates-test-stagecontent-mhl-2': '03-templates/test-stagecontent-mhl',
  'templates-test-teaser-category': '03-templates/test-teaser-category',
  'templates-test-teaser-member': '03-templates/test-teaser-member',
  'templates-test-teaser-promo-small': '03-templates/test-teaser-promo-small',
  'templates-testbox': '03-templates/testbox',
  'templates-twocolumn': '03-templates/twocolumn',
  'templates-unavailable': '03-templates/unavailable',
  'templates-wearer-detail': '03-templates/wearer-detail/wearer-detail',
  'templates-welcome-header': '03-templates/welcome-header/welcome-header',
  'templates-welcome': '03-templates/welcome',
  'templates-why-mewa-service': '03-templates/why-mewa-service',
  'templates-wishlist': '03-templates/wishlist/wishlist'
};
exports.templatePaths = templatePaths;

},{}],235:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hogan = _interopRequireDefault(require("hogan.js"));

var _tools = _interopRequireDefault(require("tools"));

var _templatePathsGenerated = require("./template-paths.generated.js");

var _templateDependenciesGenerated = require("./template-dependencies.generated.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Templates = {
  templateExtension: '.mustache',
  loadedTemplates: {},
  errors: {
    PARTIAL_404: 'Partial could not be loaded',
    PARTIAL_PATH_UNKNOWN: 'Partial path is unknown please define'
  },
  patternTemplatePaths: _templatePathsGenerated.templatePaths,
  // build by running "npm run storybook"
  updateAllSelectors: function updateAllSelectors(root, html, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      this.updateBySelector(root, html, selectors[i]);
    }
  },
  updateDom: function updateDom(element, html) {
    if (element) {
      element.innerHTML = html;
    }
  },
  updateBySelector: function updateBySelector(root, html, selector) {
    var element = root.querySelector(selector);

    if (element) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      var elementNode = tempElement.querySelector(selector);

      if (elementNode) {
        this.updateDom(element, elementNode.innerHTML);
      }
    }
  },
  getPartials: function getPartials(partials, data, index) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var promises = [];

      var updatedPartials = _objectSpread({}, partials);

      partials.forEach(function (partial) {
        if (partial && partial !== 'stackText') {
          promises.push(_this.load(partial, data, true, index, false).then(function (renderedPartial) {
            updatedPartials[partial] = renderedPartial.rendered;
          }));
        }
      });
      Promise.all(promises).then(function () {
        resolve({
          rendered: updatedPartials,
          renderedIndex: index
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loadTemplates: function loadTemplates(resolve, reject, file, loadPartials, data, index, template, noRender) {
    var _templateDependencies;

    if ((_templateDependencies = _templateDependenciesGenerated.templateDependencies[file]) !== null && _templateDependencies !== void 0 && _templateDependencies.length && loadPartials) {
      this.getPartials(_templateDependenciesGenerated.templateDependencies[file], data, index).then(function (renderedPartialsData) {
        resolve({
          rendered: template.render(data, renderedPartialsData.rendered),
          renderedIndex: index
        });
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve({
        rendered: noRender ? template : template.render(data),
        renderedIndex: index
      });
    }
  },
  requestTemplates: function requestTemplates(resolve, reject, file, loadPartials, data, index, noRender, filePath) {
    var _this2 = this;

    _tools.default.service(this.getPath() + filePath + this.templateExtension, 'GET').then(function (response) {
      return response.status === _tools.default.validStatusCode && response.text();
    }).then(function (text) {
      if (text) {
        var template = _hogan.default.compile(text);

        _this2.loadedTemplates[filePath] = template;

        _this2.loadTemplates(resolve, reject, file, loadPartials, data, index, template, noRender);
      } else {
        reject(_this2.errors.PARTIAL_404);
      }
    }).catch(function (error) {
      reject(error);
    });
  },
  load: function load(file, data, noRender, index) {
    var _this3 = this;

    var loadPartials = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    return new Promise(function (resolve, reject) {
      var filePath = _this3.patternTemplatePaths[file];

      if (filePath) {
        if (!_this3.loadedTemplates[filePath]) {
          _this3.requestTemplates(resolve, reject, file, loadPartials, data, index, noRender, filePath);
        } else {
          _this3.loadTemplates(resolve, reject, file, loadPartials, data, index, _this3.loadedTemplates[filePath], noRender);
        }
      } else {
        reject("".concat(_this3.errors.PARTIAL_PATH_UNKNOWN, " filePath: ").concat(filePath, " file: ").concat(file));
      }
    });
  },
  getPath: function getPath() {
    return document.querySelector('body').dataset.templatePath;
  }
};
window.addEventListener('InitComponents', function () {
  /*
   * page header / navigation
   */
  var flyoutOpenClass = 'flyout-open';
  var promoitems = document.querySelector('.navpromoitems');

  if (document.querySelector('.navtoggle') !== null) {
    document.querySelector('.navtoggle').addEventListener('click', function () {
      var body = document.body;
      window.setTimeout(function () {
        body.classList.remove('cssflyout-open');
        body.classList.remove('cssflyout-open--deliveryPoint');
      }, 100);

      if (body.classList.contains(flyoutOpenClass)) {
        window.headerExtendedCloseFlyout();
      }

      body.classList.toggle(flyoutOpenClass);

      if (promoitems) {
        promoitems.classList.toggle('hidden');
      }
    });
  }

  window.lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    // close flyout if window width has changed
    if (window.lastWidth !== window.innerWidth) {
      document.querySelector('body').classList.remove(flyoutOpenClass);
      window.headerExtendedCloseFlyout();
    }
  });
});
var _default = Templates;
exports.default = _default;

},{"./template-dependencies.generated.js":233,"./template-paths.generated.js":234,"hogan.js":26,"tools":236}],236:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

var _cmscomponentAvailabilitycheck = _interopRequireDefault(require("cmscomponent-availabilitycheck"));

var _state = _interopRequireDefault(require("state"));

var _screens = _interopRequireDefault(require("screens"));

var _priceUrlLoader = _interopRequireDefault(require("price-url-loader"));

require("whatwg-fetch");

var _validation = require("./validation");

var _simpleLightbox = _interopRequireDefault(require("./simple-lightbox"));

var _atoms = require("./atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

String.prototype.interpolate = function (params) {
  var templateString = this;

  for (var param in params) {
    if (param) {
      templateString = templateString.replace(new RegExp('{' + param + '}', 'g'), params[param]);
    }
  }

  return templateString;
};

var Tools = {
  tokenKey: 'CSRFToken',
  validStatusCode: 200,
  lastScrollTop: 0,
  bodyHtmlSelector: 'html, body',
  keyCode: {
    ENTER: 13,
    ESC: 27
  },
  lightboxOptions: {
    touch: false
  },
  hasMutation: function hasMutation(element, mutation) {
    return element.classList.contains(mutation) || element.parentNode.classList.contains(mutation);
  },
  loadComplete: function loadComplete(cb) {
    if (document.readyState === 'complete') {
      cb();
    } else {
      window.addEventListener('load', function () {
        cb();
      });
    }
  },
  getClassFromSelector: function getClassFromSelector(selector) {
    return selector.substring(1);
  },
  isVisible: function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  },
  removeRequiredForDisplayNoneElements: function removeRequiredForDisplayNoneElements(root) {
    var _this = this;

    var requiredElements = document.querySelectorAll("".concat(root, " *[required]"));
    var invisibleRequiredElements = Array.apply(void 0, _toConsumableArray(requiredElements)).filter(function (requiredElement) {
      return !_this.isVisible(requiredElement);
    });
    invisibleRequiredElements.forEach(function (el) {
      return el.removeAttribute('required');
    });
    return invisibleRequiredElements;
  },
  giveBackRequiredToFormerDisplayNoneElements: function giveBackRequiredToFormerDisplayNoneElements(displayNoneElements) {
    displayNoneElements.forEach(function (el) {
      return el.setAttribute('required', 'required');
    });
  },
  reload: function reload() {
    var url = window.location.toString();
    window.location.href = url.split('#')[0];
  },
  getQuerySiblings: function getQuerySiblings(query, element) {
    var parent = element.parentNode;

    if (parent) {
      return parent.querySelector(query);
    }

    return null;
  },
  getAllSiblings: function getAllSiblings(element) {
    var result = [];
    var node = element.parentNode.firstChild;

    while (node) {
      if (node !== element && node.nodeType === Node.ELEMENT_NODE) {
        result.push(node);
      }

      node = node.nextElementSibling || node.nextSibling;
    }

    return result;
  },
  getXPathOfElement: function getXPathOfElement(element) {
    var idx = function idx(sib, name) {
      return sib ? idx(sib.previousElementSibling, name || sib.localName) + (sib.localName === name) : 1;
    };

    var segs = function segs(elm) {
      return !elm || elm.nodeType !== 1 ? [''] : elm.id && document.querySelector("#".concat(elm.id)) === elm ? ["id(\"".concat(elm.id, "\")")] : [].concat(_toConsumableArray(segs(elm.parentNode)), ["".concat(elm.localName.toLowerCase(), "[").concat(idx(elm), "]")]);
    };

    return segs(element).join('/');
  },
  changeUrl: function changeUrl(url) {
    history.replaceState(null, null, url);
  },
  sendEvent: function sendEvent(event, data) {
    var customEvent = new CustomEvent(event, {
      detail: data,
      bubbles: false,
      cancelable: true
    });
    document.getElementsByTagName('body')[0].dispatchEvent(customEvent);
  },
  screen: function screen(breakpoint) {
    var below = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var result = false;
    var screenData = _screens.default[breakpoint]; // let screenData = screens[breakpoint];

    var screenSize = window.innerWidth || document.documentElement.clientWidth;

    if (typeof screenData !== 'undefined') {
      screenData = parseInt(screenData, 10);

      if (below === true && screenData > screenSize || below === false && screenData <= screenSize) {
        result = true;
      }
    }

    return result;
  },
  isBelowMediumBreakpoint: function isBelowMediumBreakpoint() {
    return this.screen('md');
  },
  isBelowLargeBreakpoint: function isBelowLargeBreakpoint() {
    return this.screen('lg');
  },
  debounce: function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
          args = arguments;

      var later = function later() {
        timeout = null;

        if (!immediate) {
          func.apply(context, args);
        }
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  getNodeIndex: function getNodeIndex(element) {
    return element !== undefined && element !== null ? _toConsumableArray(element.parentNode.children).indexOf(element) : null;
  },
  service: function () {
    var _service = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, method, body, headers, form, noToken) {
      var useMethod, request, CSRFRequest;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              useMethod = method === undefined ? 'GET' : method;
              request = {
                method: useMethod
              };

              if (body !== undefined) {
                request.body = body;
              }

              if (headers !== undefined) {
                request.headers = headers;
              } else {
                request.headers = {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                  'X-Requested-With': 'XMLHttpRequest'
                };
              }

              if (!(url === '')) {
                _context.next = 9;
                break;
              }

              console.debug('No Url provided to service.');
              return _context.abrupt("return", Promise.resolve({}));

            case 9:
              if (!noToken) {
                CSRFRequest = this.addCSRFToken(request, form);
                CSRFRequest.credentials = 'same-origin';
              }

              if (!document.body.classList.contains('sb-show-main')) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });

            case 13:
              _context.next = 16;
              break;

            case 15:
              undefined;

            case 16:
              return _context.abrupt("return", Promise.resolve(fetch(url, CSRFRequest)));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function service(_x, _x2, _x3, _x4, _x5, _x6) {
      return _service.apply(this, arguments);
    }

    return service;
  }(),
  getCSRFToken: function getCSRFToken(form) {
    var tokenElement = form && form.querySelector('[name="' + this.tokenKey + '"]');
    var token = tokenElement !== null && tokenElement !== undefined ? tokenElement.value : null;

    if (token === null) {
      token = window.ACC !== undefined && window.ACC.config !== undefined ? window.ACC.config.CSRFToken : null;
    }

    return token;
  },
  disableScrolling: function disableScrolling() {
    document.querySelector(this.bodyHtmlSelector).classList.add(_state.default.NO_SCROLLING);
  },
  enableScrolling: function enableScrolling() {
    document.querySelector(this.bodyHtmlSelector).classList.remove(_state.default.NO_SCROLLING);
  },
  addCSRFToken: function addCSRFToken(request, form) {
    var CSRFRequest = request;

    if (CSRFRequest.body && CSRFRequest.body.search && CSRFRequest.body.search(this.tokenKey) === -1) {
      var token = this.getCSRFToken(form);

      if (token !== null) {
        CSRFRequest.body = CSRFRequest.body + '&' + this.tokenKey + '=' + token;
      } else {
        console.log('token not found!');
      }
    } else if (CSRFRequest.body && CSRFRequest.body.toString().indexOf('FormData') !== -1) {// this is a FormData Request
    }

    return CSRFRequest;
  },
  getFormData: function getFormData(form, useFormData) {
    var data = {};

    if (form) {
      if (useFormData !== true) {
        data = $(form).serialize();
      } else {
        data = new FormData(form);
      }
    }

    return data;
  },
  getLoadingContainer: function getLoadingContainer() {
    return document.querySelector('body');
  },
  disableLoading: function disableLoading() {
    var loadingContainer = this.getLoadingContainer();

    if (loadingContainer) {
      loadingContainer.classList.remove(_state.default.LOADING);
    }
  },
  enableLoading: function enableLoading() {
    var loadingContainer = this.getLoadingContainer();

    if (loadingContainer) {
      loadingContainer.classList.add(_state.default.LOADING);
    }
  },
  PriceUrlLoader: _priceUrlLoader.default,
  json: function json(str) {
    return new Promise(function (resolve, reject) {
      try {
        var data = _typeof(str) !== 'object' ? JSON.parse(str) : str;
        return resolve(data);
      } catch (e) {
        return reject();
      }
    });
  },
  redirect: function redirect(url) {
    document.location.href = url;
  },
  inHorizontalViewport: function inHorizontalViewport(element) {
    var bounding = element.getBoundingClientRect();
    var width = window.innerWidth || document.documentElement.clientWidth;
    return bounding.top >= 0 && bounding.left >= 0 && bounding.right <= width;
  },
  show: function show(element, time, callback) {
    if (element) {
      element.style.display = 'block';
      var height = element.scrollHeight;
      element.style.display = '';
      element.classList.add(_state.default.VISIBLE);
      element.style.height = height + 'px';
      setTimeout(function () {
        element.style.height = '';

        if (callback && typeof callback === 'function') {
          callback();
        }
      }, time);
    }
  },
  scrollToInstant: function scrollToInstant(element) {
    var html = document.querySelector('html');
    var instantClass = 'is-instant';
    var delay = 10; // safari hits wrong position

    setTimeout(function () {
      html.classList.add(instantClass);
      window.scrollTo(0, element.getBoundingClientRect().top);
      html.classList.remove(instantClass);
    }, delay);
  },
  scrollTo: function scrollTo(element, delay, forceAnimate) {
    var isSmoothScrollSupported = !forceAnimate && 'scrollBehavior' in document.documentElement.style;

    if (isSmoothScrollSupported) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    } else {
      $('html, body').animate({
        scrollTop: $(element).offset().top
      }, delay);
    }
  },
  clone: function clone(obj) {
    if (_typeof(obj) === 'object') {
      return JSON.parse(JSON.stringify(obj));
    } else {
      return obj;
    }
  },
  inViewportData: function inViewportData(element) {
    var percentage;
    var fullVisible;

    if (document.body.contains(element)) {
      var rect = element.getBoundingClientRect();
      var innerHeight = window.innerHeight || document.documentElement.clientHeight;
      var innerWidth = window.innerWidth || document.documentElement.clientWidth;
      var maxPercentage = 100;
      var minPercentage = 0;
      var bottom = rect.bottom < innerHeight ? rect.bottom : innerHeight;
      var visibleHeight;

      if (rect.top > 0) {
        visibleHeight = bottom - rect.top;
      } else {
        visibleHeight = bottom;
      }

      percentage = visibleHeight * 100 / rect.height;

      if (percentage > maxPercentage) {
        percentage = maxPercentage;
      } else if (percentage < minPercentage) {
        percentage = minPercentage;
      }

      fullVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= innerHeight && rect.right <= innerWidth;
    } else {
      fullVisible = true;
      percentage = 100;
    }

    return {
      fullVisible: fullVisible,
      percentage: percentage
    };
  },
  scrollIntoElement: function scrollIntoElement(element, percentage) {
    var _this2 = this;

    return new Promise(function (resolve) {
      if (_this2.inViewportData(element).percentage >= percentage) {
        resolve();
      } else {
        var scrollListener = function scrollListener() {
          if (_this2.inViewportData(element).percentage >= percentage) {
            document.removeEventListener('scroll', scrollListener);
            resolve();
          }
        };

        document.addEventListener('scroll', scrollListener);
      }
    });
  },
  getScrollTop: function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  },
  scrollElementAnimation: function scrollElementAnimation(element, percentage, callback) {
    var _this3 = this;

    var uniqueScrollFunction = element.className;

    this[uniqueScrollFunction] = function () {
      var scrollTop = _this3.getScrollTop();

      var isDown = true;

      if (_this3.lastScrollTop > scrollTop) {
        isDown = false;
      }

      var distance = _this3.lastScrollTop - scrollTop;
      _this3.lastScrollTop = scrollTop;

      if (_this3.inViewportData(element).percentage >= percentage) {
        callback({
          isDown: isDown,
          distance: distance,
          scrollTop: scrollTop
        });
      }
    };

    document.addEventListener('scroll', this[uniqueScrollFunction]);
  },
  setLoading: function setLoading(mode, element) {
    if (element) {
      if (mode) {
        element.classList.add(_state.default.LOADING);
      } else {
        element.classList.remove(_state.default.LOADING);
      }
    }
  },
  isChildOf: function isChildOf(parent, child) {
    return parent !== child && parent.contains(child);
  },
  disableSimpleLightbox: function disableSimpleLightbox() {
    var simpleLightboxContainer = document.querySelector('.slbElement');

    if (simpleLightboxContainer) {
      simpleLightboxContainer.style.pointerEvents = 'none';
    }
  },
  enableSimpleLightbox: function enableSimpleLightbox() {
    var simpleLightboxContainer = document.querySelector('.slbElement');

    if (simpleLightboxContainer) {
      simpleLightboxContainer.style.pointerEvents = 'all';
    }
  }
};
window.debug = true; // which HTML element is the target of the event

window.mouseTarget = function (e) {
  var targ;
  if (!e) var e = window.event;
  if (e.target) targ = e.target;else if (e.srcElement) targ = e.srcElement;
  if (targ.nodeType == 3) // defeat Safari bug
    targ = targ.parentNode;
  return targ;
}; // Mouse position relative to the document
// From http://www.quirksmode.org/js/events_properties.html


window.mousePositionDocument = function (e) {
  var posx = 0;
  var posy = 0;

  if (!e) {
    var e = window.event;
  }

  if (e.pageX || e.pageY) {
    posx = e.pageX;
    posy = e.pageY;
  } else if (e.clientX || e.clientY) {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }

  return {
    x: posx,
    y: posy
  };
}; // Find out where an element is on the page
// From http://www.quirksmode.org/js/findpos.html


window.findPos = function (obj) {
  var curleft,
      curtop = curleft = 0;

  if (obj.offsetParent) {
    do {
      curleft += obj.offsetLeft;
      curtop += obj.offsetTop;
    } while (obj = obj.offsetParent);
  }

  return {
    left: curleft,
    top: curtop
  };
}; // Mouse position relative to the element
// not working on IE7 and below


window.mousePositionElement = function (e) {
  var mousePosDoc = window.mousePositionDocument(e);
  var target = window.mouseTarget(e);
  var targetPos = window.findPos(target);
  var posx = mousePosDoc.x - targetPos.left;
  var posy = mousePosDoc.y - targetPos.top;
  return {
    x: posx,
    y: posy
  };
};

window.guid = function () {
  var S4 = function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  };

  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
};

window.log = function (log) {
  if (window.debug) {
    console.log(log);
  }
};

var getRadioValue = function getRadioValue(name) {
  var checkedRadio = document.querySelector('input[name="' + name + '"]:checked');
  return checkedRadio !== null ? checkedRadio.value : null;
};

var getRadioButtons = function getRadioButtons(name) {
  return document.querySelectorAll('input[name="' + name + '"]');
};

var changeRadioNoMessage = function changeRadioNoMessage(name, method) {
  var buttons = getRadioButtons(name);

  for (var i = 1; i < buttons.length; i++) {
    var parent = buttons[i].closest('.atom-radio');
    parent.classList[method](_state.default.ERROR_NOMESSAGE);
  }
};

var isHidden = function isHidden(element) {
  var $element = $(element);
  return $element.parents('.hidden').length === 0 ? false : true;
};

var getValidationTypeErrorMessage = function getValidationTypeErrorMessage(validationType) {
  var errorMsg = _validation.errorMessages[validationType];
  return (errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.length) > 0 ? errorMsg : _validation.errorMessages['invalid' + validationType.charAt(0).toUpperCase() + validationType.slice(1)];
};

window.validate = function (element, initial) {
  var errors = [];
  var mainElement = element.closest('.atom-input, .atom-textarea, .atom-dropdown, .atom-checkbox, .atom-radio');

  if (typeof initial === 'undefined') {
    initial = false;
  }

  if (!mainElement) {
    return errors;
  }

  if (initial && element.value === '') {
    return errors;
  }

  if (initial && (element.value === '' || element.getAttribute('type') === 'radio' && getRadioValue(element.name) === null)) {
    return errors;
  }

  if (isHidden(element) === true) {
    return errors;
  }

  mainElement.classList.remove('error');

  if (element.getAttribute('type') === 'checkbox' && element.hasAttribute('required') && !element.checked) {
    errors.push({
      element: element,
      error: _validation.errorMessages.emptyRequired
    });
  }

  if (element.hasAttribute('required') && _validator.default.isEmpty(element.value)) {
    errors.push({
      element: element,
      error: _validation.errorMessages.emptyRequired
    });
  }

  if (element.getAttribute('type') === 'radio' && element.hasAttribute('required')) {
    var radioName = element.name;
    var radioValue = getRadioValue(radioName);
    changeRadioNoMessage(radioName, 'remove');

    if (radioValue === null) {
      changeRadioNoMessage(radioName, 'add');
      errors.push({
        element: element,
        error: _validation.errorMessages.emptyRequired
      });
    }
  }

  if (element.getAttribute('type') === 'email') {
    window.setTrimmedEmail(element);

    if (!(0, _validation.getCustomValidity)('email', element.value)) {
      errors.push({
        element: element,
        error: _validation.errorMessages.invalidEmail
      });
    }
  }

  if (element.getAttribute('type') === 'phone' && !(0, _validation.getCustomValidity)('phone', element.value)) {
    errors.push({
      element: element,
      error: _validation.errorMessages.invalidNumber
    });
  }

  if (element.getAttribute('type') === 'zip' && !_validator.default.isPostalCode(element.value, 'GB')) {
    errors.push({
      element: element,
      error: _validation.errorMessages.invalidZip
    });
  }

  if (element.getAttribute('type') === 'postalcode' && element.hasAttribute('required') && !(0, _validation.getCustomValidity)('postalCode', element.value.replace(/\s+/g, ''))) {
    errors.push({
      element: element,
      error: _validation.errorMessages.invalidPostalCode
    });
  }

  if (element.getAttribute('type') == 'password' && !mainElement.classList.contains('nonotes') && (element.value === '' || mainElement.dataset.isValidPassword != 'true')) {
    errors.push({
      element: element,
      error: _validation.errorMessages.invalidPassword
    });
  }

  if (element.getAttribute('type') == 'vat' && !(0, _validation.getCustomValidity)('vat', element.value)) {
    errors.push({
      element: element,
      error: _validation.errorMessages.invalidVat
    });
  } // generic validation type errors
  // <input type="text" data-validation-type="validationName">...


  var validationType = element.dataset.validationType;

  if (element.dataset.validationType && element.value.length > 0 && !(0, _validation.getCustomValidity)(validationType, element.value)) {
    errors.push({
      element: element,
      error: getValidationTypeErrorMessage(validationType)
    });
  }

  return errors;
};

window.setTrimmedEmail = function (element) {
  var value = element === null || element === void 0 ? void 0 : element.value;

  if (value) {
    element.value = value.trim() + '.';
    element.value = element.value.substring(0, element.value.length - 1);
  }
};

window.handleErrors = function (errors) {
  errors.forEach(function (error) {
    var mainElement = error.element.closest('.atom-input, .atom-textarea, .atom-dropdown, .atom-checkbox, .atom-radio');

    if (mainElement !== null) {
      var errorElement = mainElement.querySelector('.atom-input-error, .atom-textarea-error, .atom-dropdown-error, .atom-checkbox-error, .atom-radio-error');
      mainElement.classList.add('error');

      if (errorElement !== null) {
        errorElement.textContent = error.error;
      }
    }
  });
};
/**
 * Registers a debounce function that can be cancelled by calling clearTimeout(window.nameDebounce])
 * @callback func
 * @param {number} wait
 * @param {string} name
 */


window.debounce = function (func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'custom';
  var timeoutFunction = "".concat(name, "Timeout");
  clearTimeout(window[timeoutFunction]);
  window[timeoutFunction] = setTimeout(function () {
    func.apply();
  }, wait);
};

window.dialogSuccessDispatcher = function (data, el) {
  if (typeof el.dataset.type !== 'undefined') {
    if (el.dataset.type === 'availabilitycheck') {
      availabilitycheck(data, el);
      return false;
    }
  }

  return true;
};

window.availabilityzone = function (productId, productName, period, hideQuestions) {
  var selection = _cmscomponentAvailabilitycheck.default.getSelection();

  var availabilitycheck = document.getElementById('availabilitycheck');
  availabilitycheck.querySelector('input[name="product"]').value = productId;
  availabilitycheck.querySelector('input[name="contractualPeriod"]').value = period;
  availabilitycheck.querySelector('.cmscomponent-availabilitycheck-product').innerHTML = productName;
  var $printingBlock = $(availabilitycheck.querySelector('.radioButtonBox'));
  var $metalBlock = $(availabilitycheck.querySelector('.query'));

  if (selection.ref === 'need' || typeof hideQuestions !== 'undefined') {
    $printingBlock.addClass(_state.default.HIDDEN);
    $metalBlock.addClass(_state.default.HIDDEN);
  }

  _simpleLightbox.default.open({
    element: document.querySelector('#availabilitycheck')
  });
};

window.availabilitycheck = function (data, el) {
  var obj = _typeof(data) !== 'object' ? $.parseJSON(data) : data;

  if (typeof obj.available !== 'undefined' && obj.available == true) {
    window.location.href = el.dataset.urlAvailable;
  } else if (typeof obj.product !== 'undefined') {
    window.location.href = el.dataset.urlUnavailable + obj.product + '/' + obj.contractualPeriod;
  }
};

window.availabilityzonewithcontractualperiod = function (productId, productName, contractualPeriod) {
  var availabilitycheck = document.getElementById('availabilitycheck');
  availabilitycheck.querySelector('input[name="product"]').value = productId;
  availabilitycheck.querySelector('input[name="contractualPeriod"]').value = contractualPeriod;
  availabilitycheck.querySelector('.cmscomponent-availabilitycheck-product').innerHTML = productName;

  _simpleLightbox.default.open({
    element: document.querySelector('#availabilitycheck')
  });
};

window.availabilitycheckwithperiod = function (data, el) {
  var obj = $.parseJSON(data);

  if (typeof obj.available !== 'undefined' && obj.available == true) {
    window.location.href = el.dataset.urlAvailable;
  } else if (typeof obj.product !== 'undefined') {
    window.location.href = el.dataset.urlUnavailable + obj.product + '/' + obj.contractualPeriod;
  }
};

window.composedPath = function (element) {
  var path = [];
  var localElement = element;

  while (localElement) {
    path.push(localElement);

    if (localElement.tagName === 'HTML') {
      path.push(document);
      path.push(window);
      return path;
    }

    localElement = localElement.parentElement;
  }

  return path;
};

window.clickInside = function (e, className) {
  var clickInsideMenu = false;
  var path = e.path || e.composedPath && e.composedPath() || window.composedPath(e.currenTarget);
  [].forEach.call(path, function (el) {
    if (el.classList && el.classList.contains(className)) {
      clickInsideMenu = true;
    }
  });
  return clickInsideMenu;
};

window.fixRadios = function () {
  if (window.location.hostname !== 'localhost') return false;
  Array.prototype.forEach.call(document.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function (el) {
    var newId = guid();

    if (el.getAttribute('id') === 'radio_radio-name-radio-value') {
      el.setAttribute('id', newId);
      $(el).siblings('label').attr('for', newId);
    }

    if (el.getAttribute('name') === 'radio-name') {
      el.setAttribute('name', 'radio-' + newId);
    }

    if (el.getAttribute('value') === 'radio-value') {
      el.setAttribute('value', guid());
    }
  });
};

window.joinObject = function (object) {
  var glue = ': ';
  var separator = ', ';
  return $.map(Object.getOwnPropertyNames(object), function (k) {
    return [k, object[k]].join(glue);
  }).join(separator);
};

window.validateForm = function (form, e, callback) {
  if (form.dataset.isValid === undefined) {
    e.preventDefault();
  }

  var hasErrors = false;
  Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (el) {
    var errors = validate(el);

    if (errors.length > 0) {
      handleErrors(errors);
      hasErrors = true;
    }

    var inputPassword = el.querySelector('input[type="password"]');

    if (inputPassword && inputPassword.value === '') {
      hasErrors = true;
    }
  });

  if (!hasErrors) {
    form.dataset.isValid = 'true';

    if (!form.classList.contains('dialog-ajaxform')) {
      if (!callback) {
        form[e.type]();
      }
    }
  }

  if (callback) {
    callback(hasErrors);
  }
};

window.getUrlParam = function (param) {
  var results = new RegExp('[?&]' + param + '=([^&#]*)').exec(window.location.href);

  if (results === null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};

window.prepareFormForValidation = function (form) {
  form.setAttribute('novalidate', 'novalidate');
};

window.addEventListener('InitComponents', function () {
  _simpleLightbox.default.init(); // fix duplicate radio IDs


  fixRadios(); // stop form submit if form is incomplete or incorrect

  Array.prototype.forEach.call(document.querySelectorAll('form:not(.has-submit-handler):not(.m-form):not(.m-form-wizard):not(.m-form form)'), function (form) {
    window.prepareFormForValidation(form);
    form.addEventListener('submit', function (e) {
      window.validateForm(form, e);
    });
  });
});
Tools.PriceUrlLoader.init();
var _default = Tools;
exports.default = _default;

},{"./atoms":168,"./simple-lightbox":231,"./validation":238,"cmscomponent-availabilitycheck":186,"price-url-loader":229,"screens":230,"state":232,"validator":78,"whatwg-fetch":157}],237:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClickOutsideListener = void 0;

/**
 *
 * @param {HTMLElement} element
 * @callback function function that gets invoked after clicking outside of the html element
 * @param {boolean} [removeEventListener=true]
 */
var addClickOutsideListener = function addClickOutsideListener(element, callback) {
  var removeEventListener = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var outsideClickListener = function outsideClickListener(event) {
    if (!element.contains(event.target)) {
      callback();

      if (removeEventListener) {
        removeClickListener();
      }
    }
  };

  var removeClickListener = function removeClickListener() {
    document.removeEventListener('click', outsideClickListener);
  };

  document.addEventListener('click', outsideClickListener);
};

exports.addClickOutsideListener = addClickOutsideListener;

},{}],238:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomValidity = exports.errorMessages = void 0;

var _jsvat = require("jsvat");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Fallback input validation patterns
 */
var defaultValidations = {
  email: {
    pattern: /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  },
  phone: {
    pattern: /^(?:[+0-9] ?){6,14}[0-9]$/
  },
  postalCode: {
    pattern: /^[a-zA-Z0-9]{5,}$/
  },
  identnumber: {
    pattern: /^\s*-?[0-9]{1,10}\s*$/
  },
  vat: {
    condition: function condition(value) {
      return checkVat(value);
    }
  }
};
/**
 * Fallback error messages
 */

var defaultErrorMessages = {
  emptyRequired: 'This field is required',
  invalidEmail: 'Please enter a valid e-mail address',
  invalidNumber: 'Please enter a valid phone number',
  invalidZip: 'Please enter a valid zip',
  invalidPostalCode: 'Please enter a valid postal code',
  invalidPassword: 'Please enter a strong password',
  invalidVat: 'Please enter a valid VAT identification number',
  identnumber: 'Identnumber has to be only numbers within 10 digits.'
};
/**
 * Get custom validations that have been set in the window object
 * Returns local default validations as a fallback
 * @returns {object}
 */

var getCustomValidations = function getCustomValidations() {
  var _window$customValidat;

  return (_window$customValidat = window.customValidations) !== null && _window$customValidat !== void 0 ? _window$customValidat : defaultValidations;
};
/**
 * Unify default error messages and custom error messages that are set by the backend
 * Messages found in the window object will overwrite those defaults
 * @returns {object}
 */


var errorMessages = _objectSpread(_objectSpread({}, defaultErrorMessages), window.customErrorMessages);
/**
 *
 * @param {string} type Validation name for RegExp pattern or function
 * @param {string} value Input value that needs to get checked
 * @returns true or false depending whether the condition is set / returns true if no validation is found for this type
 */


exports.errorMessages = errorMessages;

var getCustomValidity = function getCustomValidity(type, value) {
  var _ref, _ref2, _ref3, _validations$type$pat, _validations$type, _validations$type2, _defaultValidations$t, _defaultValidations$t2;

  var validations = getCustomValidations(); // Condition can either be a regexp pattern or a custom js function that returns true or false

  var condition = (_ref = (_ref2 = (_ref3 = (_validations$type$pat = (_validations$type = validations[type]) === null || _validations$type === void 0 ? void 0 : _validations$type.pattern) !== null && _validations$type$pat !== void 0 ? _validations$type$pat : (_validations$type2 = validations[type]) === null || _validations$type2 === void 0 ? void 0 : _validations$type2.condition) !== null && _ref3 !== void 0 ? _ref3 : (_defaultValidations$t = defaultValidations[type]) === null || _defaultValidations$t === void 0 ? void 0 : _defaultValidations$t.pattern) !== null && _ref2 !== void 0 ? _ref2 : (_defaultValidations$t2 = defaultValidations[type]) === null || _defaultValidations$t2 === void 0 ? void 0 : _defaultValidations$t2.condition) !== null && _ref !== void 0 ? _ref : null;

  if (condition instanceof RegExp) {
    // Apply regexp pattern
    return condition.test(value);
  } else if (typeof condition === 'function') {
    // Apply custom validation function
    return condition(value);
  } else {
    // No pattern or functions are set for this specific validation type
    console.error("Missing or incorrect validation implementation of '".concat(type, "'"));
    return true;
  }
};
/**
 * Custom VAT validation function
 * @param {string} vat
 * @returns {boolean}
 */


exports.getCustomValidity = getCustomValidity;

var checkVat = function checkVat(vat) {
  var newVATNumber = (0, _jsvat.checkVAT)(vat, _jsvat.countries);

  if (newVATNumber.isValid && !/\s/.test(vat)) {
    return true;
  } else {
    return false;
  }
};

},{"jsvat":30}],239:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var vanillaZoom = {
  init: function init(container) {
    var _this = this;

    if (!container) {
      console.error('No container element. Please make sure you are using the right markup.');
      return undefined;
    }

    var firstSmallImage = container.querySelector('img');
    var zoomedImage = container.querySelector('img').insertAdjacentElement('afterend', document.createElement('div'));
    zoomedImage.classList.add('vanilla-zoom-zoomed-image');

    if (!zoomedImage) {
      console.error('No zoomed image element. Please make sure you are using the right markup.');
      return undefined;
    }

    if (!firstSmallImage) {
      console.error('No preview images on page. Please make sure you are using the right markup.');
      return undefined;
    } else {
      // Set the source of the zoomed image.
      zoomedImage.style.backgroundImage = "url(' ".concat(firstSmallImage.getAttribute('src'), " ')");
    } // Zoom image on mouse enter.


    zoomedImage.addEventListener('mouseenter', function (e) {
      zoomedImage.style.backgroundSize = '250%';
    }, false); // Show different parts of image depending on cursor position.

    zoomedImage.addEventListener('mousemove', function (e) {
      // getBoundingClientReact gives us various information about the position of the element.
      var dimentions = zoomedImage.getBoundingClientRect(); // Calculate the position of the cursor inside the element (in pixels).

      var x = e.clientX - dimentions.left;
      var y = e.clientY - dimentions.top; // Calculate the position of the cursor as a percentage of the total width/height of the element.

      var xpercent = 100 / (dimentions.width / x);
      var ypercent = 100 / (dimentions.height / y); // Update the background position of the image.

      zoomedImage.style.backgroundPosition = xpercent + '% ' + ypercent + '%';
    }, false); // When leaving the container zoom out the image back to normal size.

    zoomedImage.addEventListener('mouseleave', function () {
      _this.reset(zoomedImage);
    }, false);
    this.reset(zoomedImage);
    return zoomedImage;
  },
  reset: function reset(zoomedImage) {
    zoomedImage.style.backgroundSize = 'contain';
    zoomedImage.style.backgroundPosition = 'center';
  }
};
var _default = vanillaZoom;
exports.default = _default;

},{}],240:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tools = _interopRequireDefault(require("tools"));

var _state = _interopRequireDefault(require("state"));

var _panzoom = _interopRequireDefault(require("@panzoom/panzoom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Zoom = /*#__PURE__*/function () {
  function Zoom() {
    _classCallCheck(this, Zoom);

    this.rootClass = 'zoom';
    this.slideClass = 'slide';
    this.closeClass = 'zoom__close';
    this.prevClass = 'zoom__prev';
    this.nextClass = 'zoom__next';
    this.thumbsClass = 'zoom__thumbs';
    this.thumbImgClass = 'zoom__thumbs-img';
    this.thumbsListClass = 'zoom__thumbs-list';
    this.dotClass = 'zoom__dot';
    this.imagesClass = 'zoom__images';
    this.imgClass = 'zoom__image';
    this.imgWrapperClass = 'zoom__image-wrapper';
    this.imgSliderClass = 'zoom__image-slider';
    this.zoomLoaderClass = 'zoom__loader';
    this.zoomLoaderWrapperClass = 'zoom__loader-wrapper';
    this.itemSelector = '[data-zoom]';
    this.closeSelector = ".".concat(this.closeClass);
    this.prevSelector = ".".concat(this.prevClass);
    this.nextSelector = ".".concat(this.nextClass);
    this.thumbImgSelector = ".".concat(this.thumbImgClass);
    this.thumbsListSelector = ".".concat(this.thumbsListClass);
    this.dotSelector = ".".concat(this.dotClass);
    this.imagesSelector = ".".concat(this.imagesClass);
    this.imgSelector = ".".concat(this.imgClass);
    this.imgSliderSelector = ".".concat(this.imgSliderClass);
    this.imgTagSelector = "".concat(this.imgSelector, " img");
    this.imgWrapperSelector = ".".concat(this.imgWrapperClass);
    this.itemPosition = 0;
    this.itemLength = 0;
    this.minItemsForArrows = 1;
    this.panZoomInstances = [];
    this.panZoomOptions = {
      minScale: 1,
      overflow: 'visible'
    };
    this.bindListeners();
  }

  _createClass(Zoom, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.previewClass = options.preview;
      this.previewSelector = ".".concat(this.previewClass);
      this.group = options.group;
    }
  }, {
    key: "bindListeners",
    value: function bindListeners() {
      var _this = this;

      if (this.group) {
        [].forEach.call(this.group.querySelectorAll(this.itemSelector), function (item) {
          _this.bindClick(item);
        });
      }

      window.addEventListener('resize', function () {
        _this.closeLightbox();
      });
    }
  }, {
    key: "bindClick",
    value: function bindClick(item) {
      var zoomItem = this.getZoomItem(item);

      if (zoomItem) {
        zoomItem.addEventListener('click', this.handleClick.bind(this));
      }
    }
  }, {
    key: "getZoomItem",
    value: function getZoomItem(item) {
      var zoomItem;

      if (!this.isPreview(item)) {
        zoomItem = item;
      } else {
        zoomItem = this.getSlideItem(item);
      }

      return zoomItem;
    }
  }, {
    key: "getSlideItem",
    value: function getSlideItem(item) {
      var itemSrc = item.getAttribute('src');
      var selector = "img.".concat(this.slideClass, "[src='").concat(itemSrc, "']");
      return this.group.querySelector(selector);
    }
  }, {
    key: "handleClick",
    value: function handleClick(item) {
      if (this.isZoomable(item)) {
        this.openLightbox(item);
      }
    }
  }, {
    key: "isZoomable",
    value: function isZoomable(item) {
      return this.getZoomUrl(item) !== undefined ? true : false;
    }
  }, {
    key: "getZoomUrl",
    value: function getZoomUrl(item) {
      return item.dataset.zoom;
    }
  }, {
    key: "getGroupPreviews",
    value: function getGroupPreviews() {
      return [].slice.call(this.group.querySelectorAll("".concat(this.previewSelector).concat(this.itemSelector)));
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return document.querySelector('body');
    }
  }, {
    key: "openLightbox",
    value: function openLightbox(item) {
      var lightbox = this.getLightbox(item);
      var lightboxElement = document.createElement('div');
      lightboxElement.innerHTML = lightbox;
      lightboxElement.classList.add(this.rootClass);
      this.lightboxInstance = this.getBody().appendChild(lightboxElement);
      this.bindLightboxListeners();

      if (_tools.default.isBelowLargeBreakpoint()) {
        this.addPanZoom();
      } else {
        this.addClickZoom();
      }

      this.select();

      _tools.default.disableScrolling();
    }
  }, {
    key: "addPanZoom",
    value: function addPanZoom() {
      var _this2 = this;

      if (this.lightboxInstance) {
        this.panZoomInstances = [];
        [].forEach.call(this.lightboxInstance.querySelectorAll(this.imgTagSelector), function (img) {
          _this2.panZoomInstances.push((0, _panzoom.default)(img, _this2.panZoomOptions));
        });
      }
    }
  }, {
    key: "addClickZoom",
    value: function addClickZoom() {
      var _this3 = this;

      if (this.lightboxInstance) {
        [].forEach.call(this.lightboxInstance.querySelectorAll(this.imgTagSelector), function (img) {
          img.addEventListener('click', _this3.handleClickZoom.bind(_this3));
        });
      }
    }
  }, {
    key: "handleClickZoom",
    value: function handleClickZoom(e) {
      if (this.lightboxInstance) {
        var current = e.currentTarget;
        var img = current.closest(this.imgSelector);

        if (img) {
          this.clickZoomInstance = img;
          img.classList.toggle(_state.default.EXPANDED);

          if (img.classList.contains(_state.default.EXPANDED)) {
            this.scrollToCenter(img);
          } else {
            var imgWrapper = img.querySelector(this.imgWrapperSelector);
            imgWrapper.style.top = null;
          }
        }
      }
    }
  }, {
    key: "scrollToCenter",
    value: function scrollToCenter(img) {
      var windowHeight = window.innerHeight;
      var imgTag = img.querySelector(this.imgTagSelector);
      var imgWrapper = img.querySelector(this.imgWrapperSelector);
      var imgHeight = img.clientHeight;
      var imgTagHeight = imgTag.clientHeight;

      if (windowHeight > imgTagHeight) {
        imgWrapper.style.top = (windowHeight - imgTagHeight) / 2 + 'px';
      } else {
        img.scrollTo(0, imgHeight / 2);
      }
    }
  }, {
    key: "resetClickZoom",
    value: function resetClickZoom() {
      if (this.clickZoomInstance) {
        this.clickZoomInstance.classList.remove(_state.default.EXPANDED);
      }
    }
  }, {
    key: "bindLightboxListeners",
    value: function bindLightboxListeners() {
      var _this4 = this;

      if (this.lightboxInstance) {
        var close = this.lightboxInstance.querySelector(this.closeSelector);

        if (close) {
          close.addEventListener('click', this.closeLightbox.bind(this));
        }

        var zoomOverlay = this.lightboxInstance.querySelector(this.imgSelector);

        if (zoomOverlay) {
          zoomOverlay.addEventListener('click', function (event) {
            if (event.target !== event.currentTarget.querySelector('img')) {
              _this4.closeLightbox();
            }
          });
        }

        var prev = this.lightboxInstance.querySelector(this.prevSelector);

        if (prev) {
          prev.addEventListener('click', this.prev.bind(this));
        }

        var next = this.lightboxInstance.querySelector(this.nextSelector);

        if (next) {
          next.addEventListener('click', this.next.bind(this));
        }

        [].forEach.call(this.lightboxInstance.querySelectorAll(this.thumbImgSelector), function (thumbImg) {
          thumbImg.addEventListener('click', _this4.handleThumbImgClick.bind(_this4));
        });
        [].forEach.call(this.lightboxInstance.querySelectorAll(this.imgTagSelector), function (img) {
          _this4.addLoadingListener(img);
        });
      }
    }
  }, {
    key: "addLoadingListener",
    value: function addLoadingListener(img) {
      var _this5 = this;

      if (img.complete) {
        this.removeImgLoading(img);
      }

      img.addEventListener('load', function () {
        _this5.removeImgLoading(img);
      });
    }
  }, {
    key: "removeImgLoading",
    value: function removeImgLoading(img) {
      img.classList.remove(_state.default.LOADING);
    }
  }, {
    key: "handleThumbImgClick",
    value: function handleThumbImgClick(e) {
      var current = e.currentTarget;
      var index = Array.from(current.parentElement.children).indexOf(current);

      if (index !== undefined && index !== -1) {
        this.switchTo(index);
      }
    }
  }, {
    key: "updateZoomImage",
    value: function updateZoomImage() {
      if (this.lightboxInstance) {
        var selectedImg = this.lightboxInstance.querySelector("".concat(this.imgSelector, ".").concat(_state.default.SELECTED));

        if (selectedImg) {
          selectedImg.classList.remove(_state.default.SELECTED);
        }

        var position = this.itemPosition + 1;
        var newImg = this.lightboxInstance.querySelector("".concat(this.imgSelector, ":nth-of-type(").concat(position, ")"));

        if (newImg) {
          newImg.classList.add(_state.default.SELECTED);
        }
      }
    }
  }, {
    key: "updateImageSlider",
    value: function updateImageSlider() {
      if (this.lightboxInstance) {
        var imgSlider = this.lightboxInstance.querySelector(this.imgSliderSelector);

        if (imgSlider) {
          var fullWidth = 100;
          var step = -(this.itemPosition * fullWidth);
          imgSlider.style.transform = "translateX(".concat(step, "%)");
        }
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      this.lastItemPosition = this.itemPosition;
      this.itemPosition--;

      if (this.itemPosition < 0) {
        this.itemPosition = this.itemLength - 1;
      }

      this.resetZoom();
      this.select();
    }
  }, {
    key: "next",
    value: function next() {
      this.lastItemPosition = this.itemPosition;
      this.itemPosition++;

      if (this.itemPosition >= this.itemLength) {
        this.itemPosition = 0;
      }

      this.resetZoom();
      this.select();
    }
  }, {
    key: "resetZoom",
    value: function resetZoom() {
      if (_tools.default.isBelowLargeBreakpoint()) {
        this.resetPanZoom();
      } else {
        this.resetClickZoom();
      }
    }
  }, {
    key: "switchTo",
    value: function switchTo(position) {
      this.itemPosition = position;
      this.resetClickZoom();
      this.select();
    }
  }, {
    key: "select",
    value: function select() {
      this.updateThumbs();
      this.updateDots();
      this.updateImageSlider();
      this.updateZoomImage();
    }
  }, {
    key: "resetPanZoom",
    value: function resetPanZoom() {
      if (this.panZoomInstances.length) {
        var lastPanZoomInstance = this.panZoomInstances[this.lastItemPosition];

        if (lastPanZoomInstance) {
          lastPanZoomInstance.reset();
        }
      }
    }
  }, {
    key: "closeLightbox",
    value: function closeLightbox() {
      if (this.lightboxInstance) {
        this.getBody().removeChild(this.lightboxInstance);
        this.lightboxInstance = null;

        _tools.default.enableScrolling();
      }
    }
  }, {
    key: "updateThumbs",
    value: function updateThumbs() {
      this.updateControlElement(this.thumbImgSelector);
    }
  }, {
    key: "updateDots",
    value: function updateDots() {
      this.updateControlElement(this.dotSelector);
    }
  }, {
    key: "updateControlElement",
    value: function updateControlElement(selector) {
      var _this6 = this;

      if (this.lightboxInstance) {
        [].forEach.call(this.lightboxInstance.querySelectorAll(selector), function (element, index) {
          if (index === _this6.itemPosition) {
            element.classList.add(_state.default.SELECTED);
          } else {
            element.classList.remove(_state.default.SELECTED);
          }
        });
      }
    }
  }, {
    key: "getThumbs",
    value: function getThumbs(item, groupPreviews) {
      var _this7 = this;

      var index = 0;
      return groupPreviews.map(function (groupItem) {
        var groupItemSrc = groupItem.getAttribute('src');
        var activeClass = '';

        if (_this7.isActiveItem(item, groupItem)) {
          activeClass = _state.default.SELECTED;
          _this7.itemPosition = index;
        }

        index++;
        return "\n        <img src=\"".concat(groupItemSrc, "\" class=\"").concat(_this7.thumbImgClass, " ").concat(activeClass, "\" />\n      ");
      }).join('');
    }
  }, {
    key: "getDots",
    value: function getDots(item, groupPreviews) {
      var _this8 = this;

      return groupPreviews.map(function (groupItem) {
        return "\n        <div class=\"".concat(_this8.dotClass, " ").concat(_this8.isActiveItem(item, groupItem) ? _state.default.SELECTED : '', "\"></div>\n      ");
      }).join('');
    }
  }, {
    key: "isActiveItem",
    value: function isActiveItem(item, compareItem) {
      var itemSrc = item.getAttribute('src');
      var compareItemSrc = compareItem.getAttribute('src');
      return itemSrc === compareItemSrc;
    }
  }, {
    key: "getImages",
    value: function getImages(item, groupPreviews) {
      var _this9 = this;

      return groupPreviews.map(function (groupItem) {
        var zoomUrl = _this9.getZoomUrl(groupItem);

        return "\n        <div class=\"".concat(_this9.imgClass, " ").concat(_this9.isActiveItem(item, groupItem) ? _state.default.SELECTED : '', "\">\n          <div class=\"").concat(_this9.imgWrapperClass, "\">\n            <img src=\"").concat(zoomUrl, "\" class=\"").concat(_state.default.LOADING, "\" />\n            ").concat(_this9.getLoader(), "\n          </div>\n        </div>\n      ");
      }).join('');
    }
  }, {
    key: "getLoader",
    value: function getLoader() {
      return "\n      <div class=\"".concat(this.zoomLoaderWrapperClass, "\">\n        <svg class=\"").concat(this.zoomLoaderClass, "\" version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n          viewBox=\"0 0 53 54\" style=\"enable-background:new 0 0 53 54;\" xml:space=\"preserve\" class=\"reload\">\n        <path d=\"M17.9,22.7\"/>\n        <path d=\"M51.2,31.2c-1.3-0.4-2.7,0.4-3.1,1.7C45.6,40.9,38.2,49,27,49C16.4,49,5,40.2,5,27.1C5,16.5,13.8,5.1,27,5.1\n          c7.6,0,13,4.1,15.6,6.6l-5.4-0.1c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5l11,0.2c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.8-1.1,0.7-1.8\n          L50.5,3.3c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5l0.1,4C40.5,2.7,33.8,0.1,27,0C10.9,0,0,14,0,27s10.9,27,27,27\n          c13.8,0,23-9.9,25.9-19.8C53.3,32.9,52.5,31.5,51.2,31.2z\"/>\n        </svg>\n      </div>\n    ");
    }
  }, {
    key: "getLightbox",
    value: function getLightbox(item) {
      var groupPreviews = this.getGroupPreviews();
      var thumbs = this.getThumbs(item, groupPreviews);
      var dots = this.getDots(item, groupPreviews);
      var images = this.getImages(item, groupPreviews);
      this.itemLength = groupPreviews.length;
      var hasArrows = this.itemLength > this.minItemsForArrows;
      return "\n      <div class=\"zoom__bg\">\n      </div>\n      <div class=\"zoom__content\">\n      <div class=\"".concat(this.imagesClass, "\">\n        <div class=\"").concat(this.imgSliderClass, "\">\n          ").concat(images, "\n        </div>\n      </div>\n      <div class=\"zoom__controls\">\n        <div class=\"zoom__controls-content\">\n          <div class=\"").concat(this.closeClass, "\">\n            <!-- from icon-no.mustache -->\n            <svg class=\"icon-no\" xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\">\n              <polygon points=\"42 4.247 37.753 0 21 16.753 4.247 0 0 4.247 16.753 21 0 37.753 4.247 42 21 25.247 37.753 42 42 37.753 25.247 21 42 4.247\"/>\n            </svg>\n          </div>\n          <div class=\"").concat(this.thumbsClass, "\">\n            <div class=\"").concat(this.thumbsListClass, "\">\n              ").concat(thumbs, "\n            </div>\n          </div>\n          <div class=\"zoom__controls-bar\">\n            <div class=\"").concat(this.prevClass, " ").concat(!hasArrows ? _state.default.HIDDEN : '', "\">\n              <!-- from icon-arrow-big.mustache -->\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20.969\" height=\"40\" viewBox=\"0 0 20.969 40\">\n                <path d=\"M599.064,5086.99L616.985,5107l-17.921,20.01-3.046-3.02,15.5-16.99-15.5-16.99Z\" transform=\"translate(-596.031 -5087)\"/>\n              </svg>\n            </div>\n            <div class=\"zoom__dots\">").concat(dots, "</div>\n            <div class=\"").concat(this.nextClass, " ").concat(!hasArrows ? _state.default.HIDDEN : '', "\">\n              <!-- from icon-arrow-big.mustache -->\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20.969\" height=\"40\" viewBox=\"0 0 20.969 40\">\n                <path d=\"M599.064,5086.99L616.985,5107l-17.921,20.01-3.046-3.02,15.5-16.99-15.5-16.99Z\" transform=\"translate(-596.031 -5087)\"/>\n              </svg>\n            </div>\n          </div>\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "isPreview",
    value: function isPreview(item) {
      return item.classList.contains(this.previewClass);
    }
  }]);

  return Zoom;
}();

var _default = Zoom;
exports.default = _default;

},{"@panzoom/panzoom":1,"state":232,"tools":236}]},{},[225]);
